import React, { useState, useEffect,useRef,useMemo} from 'react';
import { doc as firestoreDoc } from "firebase/firestore";
import ugLogo from "../pages/ChatGPT Image Jul 2, 2026, 12_02_37 PM.png";
import { FaChartLine } from "react-icons/fa";
import { FaProjectDiagram } from "react-icons/fa";
import { CalendarCheck, TruckElectric } from "lucide-react";
import { UserCog,} from "lucide-react";
import { FaMoneyCheckAlt,FaLock} from "react-icons/fa";
import {
  FaUserCheck,
  FaClipboardCheck,
} from "react-icons/fa";
import {FaUserShield} from "react-icons/fa";
import {Toaster } from "react-hot-toast";
import { FiCheckCircle } from "react-icons/fi";
// Add this import at the top of your file
import { FaHome} from "react-icons/fa";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import { motion, AnimatePresence } from "framer-motion";
import { FaPlay, FaMinusCircle } from "react-icons/fa";
import YouTube from "react-youtube";
// At the top of your file (where you have other imports)
import {FaRobot } from "react-icons/fa";
import { FiTrash2 } from "react-icons/fi";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import {
  Trash2,
  BarChart2,
  Percent,
  DollarSign,
  RotateCcw,
  HandCoins,star
} from 'lucide-react';
import emailjs from 'emailjs-com';
import { ClipboardList } from "lucide-react";
import { FaReceipt } from "react-icons/fa";
import {PlusCircle, MinusCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import '../report-section.css';
import '../FinancialSection.css';
import { FiEye } from "react-icons/fi";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { initializeApp } from "firebase/app";  // Import to initialize Firebase
import { getFirestore } from "firebase/firestore";  // Import Firestore service
import { 
  collection, query, orderBy, getDocs, doc, deleteDoc, updateDoc, 
  addDoc, setDoc, getDoc, serverTimestamp, Timestamp,onSnapshot,where,limit,arrayUnion,  // <-- add this
  increment // <-- add this if using increment anywherewriteBatch
} from "firebase/firestore"; 
import { db, auth,fetchCollectionData } from "../firebase"; // ✅ Correct import
import Slider from '@mui/material/Slider';
// ✅ Firebase Storage Imports
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage"; 
import logo from "../logo2.png"; // Ensure only one .png extension
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis,Area,AreaChart,CartesianGrid, Tooltip, Legend, ReferenceLine, Brush,BarChart,Bar,PieChart,Pie,Cell} from 'recharts';
// ✅ CSS Imports
import "../setCommission.css";
import "../credit-package.css";
import "../DashBoard.css";
import "../partnerList.css";
import "../card-report.css";
import { jsPDF } from "jspdf";
import { Edit,X } from "lucide-react";
import html2canvas from "html2canvas";
import { FiSend } from "react-icons/fi";
import { UAParser } from "ua-parser-js";
import { Check,Clock } from "lucide-react";
import { collectionGroup } from "firebase/firestore";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// ✅ React Icons (No Duplicates)
import { 
  FaEdit, FaTrash, FaThList, FaTools, FaUser, FaList, FaUsers, 
  FaChevronDown, FaUserFriends, FaMapMarkerAlt, FaChartBar, FaCity, 
  FaPlus, FaClock, FaImage, FaWrench, FaMoneyBill, FaListAlt, 
  FaCreditCard, FaPlusCircle, FaGauge, FaMoneyBillAlt,FaClipboardList, FaUserPlus,FaShare, FaPaperPlane,FaCheckCircle, FaCog,FaBell,FaTimesCircle,FaTags,FaMoneyBillWave, FaTrashAlt, FaReply,FaSave,FaTicketAlt , FaReplyAll,FaTable,FaForward,FaTimes
} from "react-icons/fa";
import { runTransaction } from "firebase/firestore";
import { MdDelete, MdEdit, MdSave,MdRestore} from "react-icons/md"; // Import from Material Icons
// ✅ FontAwesome Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { MdReply, MdReplyAll, MdForward,
} from "react-icons/md"
import { Bell } from 'react-feather';
import {storage } from "../firebase"; // adjust path if needed
import { uploadBytesResumable} from "firebase/storage";
import { FiCalendar } from "react-icons/fi";
import { Edit2, Save, XCircle } from "lucide-react"; // Make sure to install and import properly
// ✅ React Router
import { Link } from "react-router-dom";
import { MdCheckCircle, MdCancel } from "react-icons/md"; // Import icons
// ✅ Firestore Setup
const firestore = db; // ✅ Use Firestore directly
// Make sure allowedUID is declared at the top of your file
const allowedUID = "eBdMwBiLYvZkUQsoQhjIYrpmlSk2";
const customers = [
  { id: 1, Fullname: "Users", email: "us@test.com", mobile: "1234567890", wallet: "£50" },
  { id: 2, Fullname: "Rushita", email: "abc@gmail.com", mobile: "9876543211", wallet: "£100" },
  { id: 3, Fullname: "Ramesh", email: "Ramesh999@gmail.com", mobile: "9654327891", wallet: "£345" },
];
// 🔹 Original flat data (without referredById/referredByName)
const rawCustomerReferralList = [
  {
    id: 1,
    fullName: "Rushita",
    email: "abc@gmail.com",
    mobile: "9876543211",
    walletBalance: 0,
    referralBalance: 0,
    myReferralCode: "REFRUSHITA",
    referredByCode: "",
    referralBonusApplied: false
  },
  {
    id: 2,
    fullName: "Ramesh",
    email: "ramesh999@gmail.com",
    mobile: "9654327891",
    walletBalance: 0,
    referralBalance: 0,
    myReferralCode: "REFRAM345",
    referredByCode: "REFRUSHITA",
    referralBonusApplied: false
  },
  {
    id: 3,
    fullName: "User",
    email: "us@test.com",
    mobile: "1234567890",
    walletBalance: 0,
    referralBalance: 0,
    myReferralCode: "REFUS01",
    referredByCode: "REFRAM345",
    referralBonusApplied: false
  }
];
// 🔁 Enhance data with referredById and referredByName
const customerReferralList = rawCustomerReferralList.map((cust) => {
  if (!cust.referredByCode) return { ...cust, referredById: "", referredByName: "" };

  const referrer = rawCustomerReferralList.find(
    (ref) => ref.myReferralCode === cust.referredByCode
  );
  return {
    ...cust,
    referredById: referrer ? `cust_${referrer.id}` : "",
    referredByName: referrer ? referrer.fullName : ""
  };
});
// 🔼 Upload to Firestore with enhanced fields
const uploadCustomerReferralList = async () => {
  try {
    for (const user of customerReferralList) {
      const docRef = doc(db, "customers", `cust_${user.id}`);
      await setDoc(docRef, user);
    }
    alert("✅ All referral data uploaded to Firestore!");
  } catch (error) {
    console.error("❌ Upload error:", error);
    alert("❌ Failed to upload referral data.");
  }
};
  const FirestoreData = ({ currentAdminUser }) => {
  useEffect(() => {
    if (currentAdminUser) {
      console.log("✅ currentAdminUser:", currentAdminUser);
    }
  }, [currentAdminUser]); // ← Logs only when currentAdminUser becomes available
  const [data, setData] = useState([]);
  const [showManageBookings, setShowManageBookings] = useState(false);
  const [editedData, setEditedData] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [showUserReport, setShowUserReport] = useState(false);
  const [user, setUser] = useState(null);
  // State for tracking the editing package
  const [editingPackageId, setEditingPackageId] = useState(null);
  const [activeSection, setActiveSection] = useState(null);
  const [editedPackage, setEditedPackage] = useState({ camt: "", amt: "", status: "" });
  const [gatewayList, setGatewayList] = useState([]);
  const [showSetCommission, setShowSetCommission] = useState(false);
  const [showPaymentGatewayList, setShowPaymentGatewayList] = useState(false);
  const [showList, setShowList] = useState(false);
  const [commission, setCommission] = useState("");
  const [creditPackages, setCreditPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  // ✅ Add missing state variables
  const [selectedDate, setSelectedDate] = useState("");
  const [showCreditPackageForm, setShowCreditPackageForm] = useState(false);
  const [showCreditPackageList, setShowCreditPackageList] = useState(false);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [showPartnerReport, setShowPartnerReport] = useState(false);
  const [editingId, setEditingId] = useState(null); // Track row being edited
  const [newData, setNewData] = useState({ Active: true, Storageimg_name: "", Name: "" });
  const [docId, setDocId] = useState("");
  const [addData, setAddData] = useState({ id: "", Active: true, Storageimg_name: "", Name: "" });
  const [showAddCategoryForm, setShowAddCategoryForm] = useState(false);
  const [showListCategory, setShowListCategory] = useState(false);
  const [error, setError] = useState("");
  const [formCustomer, setFormCustomer] = useState({
    customerId: '',
    name: '',
    email: '',
    phone: '',
    status: 'active', // default status
  });
  const [customers, setCustomers] = useState([]);
  const [providerProfiles, setProviderProfiles] = useState([])
  const [formProvider, setFormProvider] = useState({ name: '', email: '', phone: '' });
  const [searchTerm, setSearchTerm] = useState(""); // 👈 Add this
  const [image, setImage] = useState(null);
  // ✅ Add this line to track which tab is active
  const [activeTab, setActiveTab] = useState("Overview");
  const [selectedTimeline, setSelectedTimeline] = useState([]);
  const [adminNotes, setAdminNotes] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  // 🔹 Add this with your other states
  const [showAutomatchCustomers, setShowAutomatchCustomers] = useState(false);
  const [addCategoryOpen, setAddCategoryOpen] = useState(false);
  const [listCategoryOpen, setListCategoryOpen] = useState(false);
  const [columnFilters, setColumnFilters] = useState({
  Date: "",
  Time: "",
  User: "",
  Action: "",
  Details: "",
  "Ticket Details": "",
});
const [providerNotifications, setProviderNotifications] = useState([]);
const [logSourceFilter, setLogSourceFilter] = useState("ALL");
const [customerNotifications, setCustomerNotifications] = useState([]);
const [mainCategoryOpen, setMainCategoryOpen] = useState(false);
 const [banners, setBanners] = useState([
    {
      id: 1,
      image: "banner1.jpg",
      mainCategory: "Salon For Men",
      subCategory: "Haircut & Style",
      childCategory: "Style",
      status: "Publish",
    },
    {
      id: 2,
      image: "banner2.jpg",
      mainCategory: "Appliance Repair",
      subCategory: "AC Service and Repair",
      childCategory: "Repair",
      status: "Publish",
    },
  ]);
/* -----------------------------
     UI State Containers
  -------------------------------- */
  const [bookingRegistry, setBookingRegistry] = useState([]);
  const [isRegistryLoading, setRegistryLoading] = useState(true);
  const [registryError, setRegistryError] = useState("");
  const [selectedPartnerForVerification, setSelectedPartnerForVerification] = useState(null);
  const [partnerVerification, setPartnerVerification] = useState({});
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showPartnerList, setShowPartnerList] = useState(false); // State to toggle Partner List visibility
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showAddBannerForm, setShowAddBannerForm] = useState(false); // State to track Add Banner form visibility
  const [addBannerForm, setAddBannerForm] = useState(false);
  const [showCustomers, setShowCustomers] = useState(false);
  const [bannerImage, setBannerImage] = useState(null);
  const [serviceCategory, setServiceCategory] = useState("");
  const [bannerStatus, setBannerStatus] = useState("Publish");
  const [localCustomers, setLocalCustomers] = useState(customers); // Manage local state
  const [showBannerList, setShowBannerList] = useState(false);
  const [bannerList, setBannerList] = useState([]); // ✅ State to store banners
  // State to track which banner is being edited
const [editingBannerId, setEditingBannerId] = useState(null);
const [bannerVideo, setBannerVideo] = useState(null);
const [editedBanner, setEditedBanner] = useState({
  id: null,
  mainCategory: '',
  subCategory: '',
  childCategory: '',
  status: '',
  image: '',
});

  const navigate = useNavigate();
  const auth = getAuth();
  const toggleDropdown = () => {
    setDropdownOpen(prevState => !prevState);
  };
  const toggleCustomersList = () => {
    setShowCustomers((prev) => !prev);
  };
  const handleManagePartnerReport = (partner) => {
    setSelectedPartner(partner); // Set the selected partner
    setShowPartnerReport(true); // Show the report form
    setShowPartnerList(false);
    navigate(`/manage-partner-report/${partner.id}`); // Navigate to the report page
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Commission Set:", commission);
    setCommission(""); // Reset input after submission
  };
  const handleSetCommission = (partner) => {
    setSelectedPartner(partner); // Store partner data
    setShowPartnerList(false);   // Hide Partner List
    setShowSetCommission(true);  // Show Set Commission Form
  };
  const [availablePaymentGateways, setAvailablePaymentGateways] = useState([
    { id: 1, name: "Razorpay", subtitle: "Card, UPI, Net banking", status: "Publish" },
    { id: 2, name: "Cash On Delivery", subtitle: "Pay via Cash at delivery", status: "Publish" },
    { id: 3, name: "Paypal", subtitle: "Credit/Debit card", status: "Unpublish" },
    { id: 4, name: "Stripe", subtitle: "Accept all major debit and credit cards from customers in every country", status: "Publish" },
    { id: 5, name: "PayStack", subtitle: "Credit/Debit card with an easier way to pay – online and on your mobile.", status: "Unpublish" },
    { id: 6, name: "FlutterWave", subtitle: "Card, pay with USSD, pay with bank, pay with barter", status: "Unpublish" },
    { id: 7, name: "Paytm", subtitle: "Credit/Debit card, net banking, Paytm wallet", status: "Unpublish" },
    { id: 8, name: "SenangPay", subtitle: "Accept all major debit and credit cards from all related banks", status: "Unpublish" }
  ]);
  // Handle status change and update UI immediately
const handleStatusChange = (e, id) => {
  const newStatus = e.target.value;
  // If editing, update the local state for editedBanner
  if (editingBannerId === id) {
    setEditedBanner((prev) => ({
      ...prev,
      status: newStatus,
    }));
  }
  // Update main banner list
  const updatedBanners = banners.map((banner) =>
    banner.id === id ? { ...banner, status: newStatus } : banner
  );
  setBanners(updatedBanners);
  localStorage.setItem("banners", JSON.stringify(updatedBanners));
};
  useEffect(() => {
    const fetchData = async () => {
      try {
        const items = await fetchCollectionData("All_categories");
        setData(items);
        setLoading(false);
        toast.success("Data fetched successfully.");
      } catch (err) {
        console.error("Error fetching Firestore data:", err);
        setError("Failed to fetch data.");
        setLoading(false);
        toast.error("Failed to fetch data.");
      }
    };

    fetchData();
  }, []);
useEffect(() => {
  const fetchCreditTransactions = async () => {
    try {
      const allTransactions = [];
      // 1️⃣ Fetch provider entries
      const providerRef = collection(db, "creditTransactions", "providers", "entries");
      const providerSnapshot = await getDocs(providerRef);
      providerSnapshot.forEach((doc) => {
        const data = doc.data();
        allTransactions.push({
          firestoreId: doc.id,                  // ✅ Firestore document ID for deletion
          id: data.id || `TXN-${doc.id}`,       // formatted transaction ID
          entityType: "providers",
          entityId: data.entityId || data.id || doc.id, // provider ID
          name: data.name || "Unknown Provider",  // fetch provider name
          message: data.message || "",
          status: data.status || "",
          amount: Math.abs(data.amount || 0),   // always positive
          type: data.type || "add",
          currency: data.currency || "USD",
          email: data.email || "",
          createdAt: data.createdAt?.toDate?.() || new Date(),
        });
      });
      // 2️⃣ Fetch customer entries
      const customerRef = collection(db, "creditTransactions", "customers", "entries");
      const customerSnapshot = await getDocs(customerRef);
      customerSnapshot.forEach((doc) => {
        const data = doc.data();
        allTransactions.push({
          firestoreId: doc.id,                  // ✅ Firestore document ID for deletion
          id: data.id || `TXN-${doc.id}`,       // formatted transaction ID
          entityType: "customers",
          entityId: data.entityId || data.id || doc.id, // customer ID
          name: data.name || "Unknown Customer", // fetch customer name
          message: data.message || "",
          status: data.status || "",
          amount: Math.abs(data.amount || 0),   // always positive
          type: data.type || "add",
          currency: data.currency || "USD",
          email: data.email || "",
          createdAt: data.createdAt?.toDate?.() || new Date(),
        });
      });
      // Sort newest first
      allTransactions.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      // Update state and localStorage
      setCreditTransactions(allTransactions);
      localStorage.setItem("creditTransactions", JSON.stringify(allTransactions));
    } catch (error) {
      console.error("Error fetching credit transactions:", error);
    }
  };
  fetchCreditTransactions();
}, []);
  const [creditPackage, setCreditPackage] = useState({
    camt: "",
    amt: "",
    status: ""
  });
  // Add default values when initializing edited data:
const handleEditDocument = (id) => {
  setEditingId(id);
  const documentToEdit = data.find((doc) => doc.id === id);
  if (documentToEdit) {
    setEditedData((prev) => ({
      ...prev,
      [id]: {
        Name: documentToEdit.Name || '',
        Storageimg_name: documentToEdit.Storageimg_name || '',
        Active: documentToEdit.Active || false,
      },
    }));
  }
};
const handleSaveDocument = async (id) => {
  try {
    // Fetch the current document from Firestore
    const docRef = doc(db, "All_categories", id);
    const docSnapshot = await getDoc(docRef);

    if (docSnapshot.exists()) {
      const currentDoc = docSnapshot.data();

      // Collect the updated data from the form
      const updatedDoc = editedData[id];

      // Merge the updated data with existing data from Firestore
      const updatedData = {
        ...currentDoc, // Retain current document fields
        Name: updatedDoc.Name || currentDoc.Name, // Update Category Name
        Storageimg_name: updatedDoc.Storageimg_name || currentDoc.Storageimg_name, // Update Category Subtitle
        Active: updatedDoc.Active !== undefined ? updatedDoc.Active : currentDoc.Active, // Update Active status
      };

      // Update the document with merged data
      await updateDoc(docRef, updatedData);

      // Show success message
      toast.success("Document updated successfully.");

      // Optionally, fetch the updated data to update the UI
      const updatedDataList = await fetchCollectionData("All_categories");
      setData(updatedDataList);

      setEditingId(null);
    } else {
      toast.error("Document not found.");
    }
  } catch (err) {
    console.error("Error saving document:", err);
    toast.error("Failed to save document.");
  }
};

// Ensure the editedData state is updated properly in handleUpdateField function
const handleUpdateField = (e, id) => {
  const { name, value } = e.target;

  // Handle the update of Active status as boolean values
  const updatedValue = name === "Active" ? value === "true" : value;

  // Update the relevant field in the editedData state
  setEditedData((prevData) => ({
    ...prevData,
    [id]: {
      ...prevData[id],
      [name]: updatedValue, // Update either Active or other fields
    },
  }));

  // Show a toast message on successful field update
  toast.info(`Field "${name}" updated to "${updatedValue}" for entry ID: ${id}`, {
    position: "top-right",
    autoClose: 1500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    theme: "light",
  });
};
  const handleAddDocument = async () => {
    if (!addData.Name || !addData.Storageimg_name) {
      toast.error("Please fill in all required fields.");
      return;
    }
  
    try {
      let catVideoName = addData.cat_video;
  
      // If a video file is selected, upload it to Firebase Storage
      if (catVideoName instanceof File) {
        const storage = getStorage();
        const storageRef = ref(storage, `category_videos/${catVideoName.name}`);
        const uploadTask = await uploadBytes(storageRef, catVideoName);
  
        const videoURL = await getDownloadURL(uploadTask.ref);  // Get download URL after upload
        catVideoName = videoURL;  // Store the URL (not the file name)
      }
  
      const docRef = doc(db, "All_categories", addData.id);
      await setDoc(docRef, {
        Active: addData.Active,
        Storageimg_name: addData.Storageimg_name,
        Name: addData.Name,
        cat_video: catVideoName,  // Store video URL
      });
  
      toast.success("Document added successfully.");
      const updatedData = await fetchCollectionData("All_categories");
      setData(updatedData);
  
      setAddData({ Active: true, Storageimg_name: "", Name: "", cat_video: null });
      setShowAddCategoryForm(false);
  
    } catch (err) {
      console.error("Error adding document:", err);  // Log the error
      toast.error("Failed to add document. Please check your input and try again.");
    }
  };

  const handleTogglePublish = (bannerId, newStatus) => {
    setBanners(prevBanners =>
      prevBanners.map(banner =>
        banner.id === bannerId ? { ...banner, status: newStatus } : banner
      )
    );
  };
  async function deleteDocument(db, collection, docId) {
    const docRef = doc(db, collection, docId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        await deleteDoc(docRef);
        console.log("Document deleted successfully");
    } else {
        console.log("Document does not exist");
    }
}

const handleDeleteDocument = async (id) => {
  try {
    const categoryDocRef = doc(firestore, "All_categories", id);  // Reference to the document
    await deleteDoc(categoryDocRef);  // Delete the document

    toast.error("🗑️ Category deleted successfully", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      pauseOnHover: true,
      draggable: true,
    });
  } catch (error) {
    console.error("Error deleting category:", error);
    toast.error("❌ Failed to delete category", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      pauseOnHover: true,
      draggable: true,
    });
  }
};

const [documents, setDocuments] = useState([]);
const handleAddCreditPackage = async (e) => {
  e.preventDefault();

  if (!creditPackage.camt || !creditPackage.amt || !creditPackage.status) {
    toast.error("Please fill in all fields.");
    return;
  }

  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      toast.error("You must be logged in to add a credit package.");
      return;
    }

    // Check if user is the allowed UID
    if (user.uid !== "eBdMwBiLYvZkUQsoQhjIYrpmlSk2") {
      toast.error("You do not have permission to add credit packages.");
      return;
    }

    // ✅ Firestore Collection Reference
    const creditPackageRef = collection(db, "Credit_Packages");

    // ✅ Add document with auto-generated ID
    const docRef = await addDoc(creditPackageRef, {
      camt: Number(creditPackage.camt), // Ensure it's a number
      amt: Number(creditPackage.amt),   // Ensure it's a number
      status: creditPackage.status,
      createdAt: serverTimestamp(),     // ✅ Firestore Timestamp
    });

    // ✅ Log the new document ID
    console.log("Document written with ID:", docRef.id);

    // ✅ Update local state
    setData((prevData) => [...prevData, { id: docRef.id, ...creditPackage }]);

    toast.success("Credit Package added successfully.");

    // ✅ Reset form fields
    setCreditPackage({ camt: "", amt: "", status: "" });

  } catch (err) {
    console.error("Error adding credit package:", err.message);
    toast.error(`Failed to add credit package: ${err.message}`);
  }
};


// Handle input changes in the editable row
const handleInputChange1 = (e) => {
  const { name, value } = e.target;
  setEditedBanner((prevBanner) => ({
    ...prevBanner,
    [name]: value, // Update the field being edited
  }));
};
const [subCategoryOpen, setSubCategoryOpen] = useState(false);
const [childCategoryOpen, setChildCategoryOpen] = useState(false);
const [addOnOpen, setAddOnOpen] = useState(false);
const handleSubCategoryClick = () => {
  setSubCategoryOpen(!subCategoryOpen);
};
// Function to handle package input changes during edit
const handlePackageInputChange = (e) => {
  const { name, value } = e.target;
  setEditedPackage((prev) => ({
    ...prev,
    [name]: value
  }));
};

// Function to start editing a package
const handleEditPackage = (pkg) => {
  setEditingPackageId(pkg.id);
  setEditedPackage({
    camt: pkg.camt,
    amt: pkg.amt,
    status: pkg.status
  });
};
const handleSavePackageEdit = async (id) => {
  try {
    const packageRef = doc(db, "Credit_Packages", id);
    
    // Convert numeric values properly
    const updatedPackage = {
      camt: Number(editedPackage.camt), // Ensure it's a number
      amt: Number(editedPackage.amt),   // Ensure it's a number
      status: editedPackage.status.toLowerCase() // Normalize status
    };

    await updateDoc(packageRef, updatedPackage);

    // Update state
    setCreditPackages((prevPackages) =>
      prevPackages.map((pkg) => (pkg.id === id ? { id, ...updatedPackage } : pkg))
    );

    setEditingPackageId(null);
    toast.success("Credit package updated successfully!");
  } catch (error) {
    console.error("Error updating package:", error);
    toast.error("Failed to update credit package.");
  }
};


const handleDeletePackage = async (id) => {
  if (!window.confirm("Are you sure you want to delete this package?")) return;

  try {
    console.log("Deleting package with ID:", id); // Debugging log
    const packageRef = doc(db, "Credit_Packages", id);
    
    await deleteDoc(packageRef);

    // Update state to remove the deleted package from the UI
    setCreditPackages((prevPackages) => prevPackages.filter((pkg) => pkg.id !== id));

    toast.success("Credit package deleted successfully!");
  } catch (error) {
    console.error("Error deleting package:", error);
    toast.error("Failed to delete credit package.");
  }
};
useEffect(() => {
    const unsubscribe = onAuthStateChanged(getAuth(), (firebaseUser) => {
      setUser(firebaseUser);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const fetchCreditPackages = async () => {
      try {
        const snapshot = await getDocs(collection(db, "Credit_Packages"));
        const packages = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setCreditPackages(packages);
      } catch (error) {
        console.error("❌ Error fetching credit packages:", error);
      }
    };

    if (user?.uid === allowedUID) {
      console.log("✅ User authorized, fetching data");
      fetchCreditPackages();
    }
  }, [user]);

const handleSaveClick = async (id) => {
  try {
    await updateCreditPackage(id, editedPackage); // Update in database
    setCreditPackages((prevPackages) =>
      prevPackages.map((pkg) =>
        pkg.id === id ? { ...pkg, ...editedPackage } : pkg
      )
    );
    setEditingId(null); // Exit edit mode
  } catch (error) {
    console.error("Error updating package:", error);
  }
};
const updateCreditPackage = (id, field, value) => {
  setCreditPackages(prevPackages =>
    prevPackages.map(pkg =>
      pkg.id === id ? { ...pkg, [field]: value } : pkg
    )
  );
};

/* Fetch Data from Firestore on Component Mount */
useEffect(() => {
  const fetchPackages = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "creditPackages"));
      const packages = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setCreditPackages(packages);
      localStorage.setItem("creditPackages", JSON.stringify(packages)); // Store in localStorage
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  fetchPackages();
}, []);
  const [totalOrders, setTotalOrders] = useState(0);
  const [creditBalance, setCreditBalance] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [creditAmount, setCreditAmount] = useState(0);
  const [creditTransactions, setCreditTransactions] = useState([]);

// Handle credit input change
const handleCreditChange = (e) => {
  setCreditAmount(e.target.value);
};

// Handle credit updates
const handleCreditUpdate = (type) => {
  if (!creditAmount || isNaN(creditAmount)) {
    alert("Please enter a valid credit amount.");
    return;
  }

  const amount = parseFloat(creditAmount);

  if (type === "add") {
    setCreditBalance((prev) => prev + amount);
  } else if (type === "subtract") {
    if (creditBalance - amount < 0) {
      alert("Insufficient balance.");
      return;
    }
    setCreditBalance((prev) => prev - amount);
  }

  setTransactions([
    ...transactions,
    { id: transactions.length + 1, message: `Credit ${type}ed`, status: "Success", credit: amount },
  ]);

  setCreditAmount(""); // Reset input
};

const handleFieldUpdate = (event) => {
  if (!event || !event.target) {
    console.error("handleFieldUpdate: Event or target is undefined", event);
    return;
  }

  const { name, value } = event.target;
  setEditableData((prevData) => ({
    ...prevData,
    [name]: value,
  }));
};


const modifyCredit = async (type) => {
  try {
    if (!creditAmount || creditAmount <= 0) {
      alert("Please enter a valid credit amount greater than 0.");
      return;
    }

    const transaction = {
      message: type === "add" ? "Credit Added" : "Credit Deducted",
      status: "Completed",
      amount: type === "add" ? creditAmount : -creditAmount,
      currency: selectedCurrency,
      timestamp: Timestamp.now(), // Firestore timestamp
    };

    // Add transaction to Firestore (this triggers real-time UI updates via onSnapshot)
    await addDoc(collection(db, "creditTransactions"), transaction);

    // Update local credit balance
    setCreditBalance((prev) => (type === "add" ? prev + creditAmount : prev - creditAmount));

    // Reset credit amount input after operation
    setCreditAmount(0);

    console.log(`Credit ${type} successful!`);
  } catch (error) {
    console.error("Error modifying credit:", error);
  }
};

// Fetch Credit Transactions from Firestore
const fetchCreditTransactions = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "creditTransactions"));
    const transactions = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));
    setCreditTransactions(transactions);
  } catch (error) {
    console.error("Error fetching credit transactions:", error);
  }
};

useEffect(() => {
  fetchCreditTransactions(); // Fetch transactions when the component mounts
}, []);
useEffect(() => {
  const fetchTransactions = async () => {
    try {
      const querySnapshot = await getDocs(collection(firestore, "transactions"));
      const transactionsList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setTransactions(transactionsList);
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  };

  fetchTransactions();
}, []);


const [editableRow, setEditableRow] = useState(null);
  const [editableData, setEditableData] = useState({ name: "", subtitle: "", status: "" });

  // Enable edit mode for a specific row
  const enableEdit = (gateway) => {
    setEditableRow(gateway.id);
    setEditableData({
      name: gateway.name,
      subtitle: gateway.subtitle,
      status: gateway.status,
    });
  };

  // Handle changes in input fields
  const handleEditChange = (field, value) => {
    setEditableData((prev) => ({ ...prev, [field]: value }));
  };

  
  // Ensure data persists after refresh or login
useEffect(() => {
  const storedGateways = JSON.parse(localStorage.getItem("paymentGateways"));
  if (storedGateways) {
    setAvailablePaymentGateways(storedGateways);
  } else {
    const defaultGateways = [
      { id: 1, name: "Razorpay", subtitle: "Card, UPI, Net banking", status: "Publish" },
      { id: 2, name: "Cash On Delivery", subtitle: "Pay via Cash at delivery", status: "Publish" },
      { id: 3, name: "Paypal", subtitle: "Credit/Debit card", status: "Publish" },
      { id: 4, name: "Stripe", subtitle: "Major debit and credit cards", status: "Publish" },
      { id: 5, name: "PayStack", subtitle: "Credit/Debit card - online & mobile", status: "Unpublish" },
      { id: 6, name: "FlutterWave", subtitle: "Card, USSD, bank transfer", status: "Unpublish" },
      { id: 7, name: "Paytm", subtitle: "Net banking, Paytm wallet", status: "Unpublish" },
      { id: 8, name: "SenangPay", subtitle: "Major debit and credit cards", status: "Unpublish" }
    ];
    setAvailablePaymentGateways(defaultGateways);
    localStorage.setItem("paymentGateways", JSON.stringify(defaultGateways));
  }
}, []);

const saveEdit = (id) => {
  const updatedGateways = availablePaymentGateways.map((gateway) =>
    gateway.id === id ? { ...gateway, ...editableData } : gateway
  );

  setAvailablePaymentGateways(updatedGateways);
  localStorage.setItem("paymentGateways", JSON.stringify(updatedGateways));
  setEditableRow(null);

  // ✅ Toast notification
  toast.success("✅ Payment gateway updated!", {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    pauseOnHover: true,
    draggable: true,
  });
};

// Ensure banner data persists after refresh or login
useEffect(() => {
  const storedBanners = JSON.parse(localStorage.getItem("banners"));
  if (storedBanners) {
    setBanners(storedBanners);
  } else {
    const defaultBanners = [
      {
        id: 1,
        image: "https://via.placeholder.com/100x50",
        mainCategory: "Electronics",
        subCategory: "Laptops",
        childCategory: "Gaming Laptops",
        status: "Published",
      },
      {
        id: 2,
        image: "https://via.placeholder.com/100x50",
        mainCategory: "Fashion",
        subCategory: "Men's Clothing",
        childCategory: "T-Shirts",
        status: "Published",
      },
      {
        id: 3,
        image: "https://via.placeholder.com/100x50",
        mainCategory: "Home Appliances",
        subCategory: "Kitchen",
        childCategory: "Microwaves",
        status: "Unpublished",
      },
    ];
    setBanners(defaultBanners);
    localStorage.setItem("banners", JSON.stringify(defaultBanners));
  }
}, []);

// Save edited banner and update localStorage
const handleSaveEdit = () => {
  const updatedBanners = banners.map((banner) =>
    banner.id === editingBannerId ? { ...banner, ...editedBanner } : banner
  );
  setBanners(updatedBanners);
  localStorage.setItem("banners", JSON.stringify(updatedBanners));
  setEditingBannerId(null);

  toast.success("✅ Banner saved successfully!", {
    position: "top-right",
    autoClose: 2000,
  });
};

const handleDeleteBanner = (id) => {
  setBanners((prevBanners) =>
    prevBanners.map((banner) =>
      banner.id === id ? { ...banner, isHidden: true } : banner
    )
  );

  toast.error("🗑️ Banner deleted (will reappear on refresh)", {
    position: "top-right",
    autoClose: 2000,
  });
};


// Handle input change for editing
const handleInputChange = (e) => {
  setEditedBanner({ ...editedBanner, [e.target.name]: e.target.value });
};

// Enable edit mode
const handleEdit = (id) => {
  const bannerToEdit = banners.find((banner) => banner.id === id);
  setEditingBannerId(id);
  setEditedBanner({ ...bannerToEdit });

  toast.info("✏️ Editing banner", {
    position: "top-right",
    autoClose: 1500,
  });
};

// Save commission to Firestore
const handleCommissionSave = async (e) => {
  e.preventDefault();
  try {
    console.log("Submitting commission:", commission); // Debugging
    await setDoc(doc(db, "settings", "commission"), {
      value: Number(commission),
    });

    toast.success("💰 Commission set successfully!", {
      position: "top-right",
      autoClose: 2000,
    });
  } catch (error) {
    console.error("Error setting commission: ", error);
    toast.error("❌ Failed to save commission", {
      position: "top-right",
      autoClose: 2000,
    });
  }
};

const handleManageUserReport = (customer) => {
  setShowCustomers(false); // Hide customer list
  setSelectedCustomer(customer); // Store selected customer data
  setShowUserReport(true); // Show user report form
};
const [selectedCustomer, setSelectedCustomer] = useState(null);
const [selectedCurrency, setSelectedCurrency] = useState("USD"); // Default currency

// State variables
const [userId, setUserId] = useState(null);
const [walletBalance, setWalletBalance] = useState(0);
const [transactionAmount, setTransactionAmount] = useState(0);
const [currency, setCurrency] = useState("USD"); // Default currency USD
const [removedTransactions, setRemovedTransactions] = useState([]);
const [lastFetchedTime, setLastFetchedTime] = useState(null);

// Fetch authenticated user
useEffect(() => {
  const unsubscribe = auth.onAuthStateChanged((user) => {
    if (user) {
      setUserId(user.uid);
    } else {
      setUserId(null);
    }
  });
  return () => unsubscribe(); // Cleanup on unmount
}, []);


  useEffect(() => {
    if (!userId) return;
    
    // Fetch Wallet Balance
    const fetchWalletBalance = async () => {
      const userDoc = await getDoc(doc(db, "users", userId));
      if (userDoc.exists()) {
        setWalletBalance(userDoc.data().walletBalance || 0);
      }
    };

    // Fetch Transactions in Real-time
    const q = query(collection(db, "walletTransactions"), where("userId", "==", userId));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setWalletTransactions(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    fetchWalletBalance();
    return () => unsubscribe();
  }, [userId]);

  const modifyWallet = async (type) => {
    if (transactionAmount <= 0) return;
    const userRef = doc(db, "users", userId);
    const userSnap = await getDoc(userRef);
    if (!userSnap.exists()) return;
    
    let newBalance = walletBalance;
    if (type === "add") {
      newBalance += transactionAmount;
    } else if (type === "subtract" && walletBalance >= transactionAmount) {
      newBalance -= transactionAmount;
    } else {
      alert("Insufficient Balance");
      return;
    }

    await updateDoc(userRef, { walletBalance: newBalance });
    setWalletBalance(newBalance);

    // Add transaction to Firestore
    await addDoc(collection(db, "walletTransactions"), {
      userId,
      amount: transactionAmount,
      currency,
      status: type === "add" ? "Credited" : "Debited",
      message: `Wallet ${type} transaction`,
      timestamp: new Date()
    });
  };

const [showPendingOrders, setShowPendingOrders] = useState(false);
const [orders, setOrders] = useState([]); // ✅ Ensure orders is defined
const [creditPackageOpen, setCreditPackageOpen] = useState(false);
useEffect(() => {
  const orderData = [
    { id: 6033, date: "12-03-2025", partner: "-", status: "Pending", type: "Random", credit: "O" },
    { id: 6032, date: "08-03-2025", partner: "-", status: "Pending", type: "Random", credit: "O" },
    { id: 6031, date: "06-03-2025", partner: "-", status: "Pending", type: "Random", credit: "O" },
    { id: 6030, date: "28-02-2025", partner: "Partner", status: "Pending", type: "Direct", credit: "O" },
    { id: 6029, date: "28-02-2025", partner: "-", status: "Pending", type: "Random", credit: "O" },
    { id: 6034, date: "16-03-2025", partner: "-", status: "Pending", type: "Random", credit: "O" },
  ];
  setOrders(orderData);
}, []); // Empty dependency array ensures this runs only once
const [showOnlyPendingOrders, setShowOnlyPendingOrders] = useState(false);
const [rowsPerPage, setRowsPerPage] = useState(10);
const [selectedOrder, setSelectedOrder] = useState(null);
const [status, setStatus] = useState("");
const [comment, setComment] = useState("");
const [credit, setCredit] = useState("");
const [showDecisionForm, setShowDecisionForm] = useState(false);
const toggleDecisionForm = () => {
  setShowDecisionForm(!showDecisionForm);
};
const [selectedOrderId, setSelectedOrderId] = useState(null);
const handleMakeDecision = (orderId) => {
  setSelectedOrderId(orderId); // Store selected order ID
  setShowPendingOrders(false); // Hide pending orders list
  setShowDecisionForm(true); // Show decision form
};

const [providerId, setProviderId] = useState("");
const OrderDecisionForm = ({ selectedOrder, setShowDecisionForm, setShowPendingOrders }) => {
  const [status, setStatus] = useState("");
  const [providerId, setProviderId] = useState(auth.currentUser?.uid || ""); // Default to logged-in user
  const [comment, setComment] = useState("");
  const [credit, setCredit] = useState(""); 
}
  const [authUser, setAuthUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setAuthUser(user);
    });
    
    return () => unsubscribe();
  }, []);

  const handleDecisionSubmit = async (e) => {
  e.preventDefault();
  if (!orderId) {
    alert("Error: Order ID is missing. Please select an order.");
    return;
  }
  try {
    const decisionRef = doc(firestore, "orderDecisions", orderId); 
    await setDoc(decisionRef, {
      status,
      providerId,
      comment,
      credit: auth.currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" ? credit : null,
      timestamp: serverTimestamp(),
    });
    alert("Decision submitted successfully!");
    // ✅ Reset all form fields
    setOrderId("");
    setStatus("");
    setProviderId("");
    setComment("");
    setCredit("");
  } catch (error) {
    console.error("Error submitting decision:", error);
    alert("Failed to submit decision. Please try again.");
  }
};
const [orderId, setOrderId] = useState(""); // Ensure it's defined 
const [showCompletedOrders, setShowCompletedOrders] = useState(false);
const [completedOrders, setCompletedOrders] = useState(() => {
  const savedOrders = localStorage.getItem("completedOrders");
    return savedOrders ? JSON.parse(savedOrders) : [];
  });
  // 1️⃣ On component mount, load completedOrders from localStorage (if exists)
useEffect(() => {
  const storedOrders = localStorage.getItem("completedOrders");
  if (storedOrders) {
    setCompletedOrders(JSON.parse(storedOrders));
  }
}, []);
const deleteOrder = async (transactionId) => {
  try {
    // Delete from Firestore
    await deleteDoc(doc(db, "walletTransactions", transactionId));
    // Update UI immediately
    setCompletedOrders((prev) =>
      prev.filter((order) => order.transactionId !== transactionId)
    );
    toast.success("Transaction deleted successfully!");
  } catch (err) {
    console.error("Error deleting transaction:", err);
    toast.error("Failed to delete transaction");
  }
};
  const [walletTransactions, setWalletTransactions] = useState(() => {
    const savedTransactions = localStorage.getItem("walletTransactions");
    return savedTransactions ? JSON.parse(savedTransactions) : [];
  });
    useEffect(() => {
      localStorage.setItem("walletTransactions", JSON.stringify(walletTransactions));
    }, [walletTransactions]);
  // State to track deleted transactions
const [deletedTransactionIds, setDeletedTransactionIds] = useState(
  JSON.parse(localStorage.getItem("deletedTransactionIds")) || []
);
const removeTransaction = (transactionId) => {
  // Add transactionId to deleted list
  const updatedDeleted = [...deletedTransactionIds, transactionId];
  setDeletedTransactionIds(updatedDeleted);
  // Persist in localStorage to survive re-renders
  localStorage.setItem("deletedTransactionIds", JSON.stringify(updatedDeleted));
  // Update UI
  setWalletTransactions((prev) =>
    prev.filter((txn) => txn.transactionId !== transactionId)
  );
  toast.success("Transaction removed from UI!");
};
// When displaying transactions, filter out deleted ones
const displayedTransactions = walletTransactions.filter(
  (txn) => !deletedTransactionIds.includes(txn.transactionId)
);
const generateCreditId = () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  const h = String(now.getHours()).padStart(2, "0");
  const min = String(now.getMinutes()).padStart(2, "0");
  const s = String(now.getSeconds()).padStart(2, "0");
  const rand = Math.floor(Math.random() * 900 + 100); // 3-digit random
  return `CR-${y}${m}${d}-${h}${min}${s}-${rand}`;
};
const handleModifyCredit = async (type) => {
  try {
    if (!creditAmount || creditAmount <= 0) {
      toast.error("Enter a valid credit amount");
      return;
    }
    let collectionPath = "";
    let entityData = null;
    if (creditProviderId) {
      collectionPath = "creditTransactions/providers/entries"; // hardcoded
      entityData = {
        id: creditProviderId,
        name: creditProviderName,
        email: creditProviderEmail,
      };
    } else if (creditCustomerId) {
      collectionPath = "creditTransactions/customers/entries"; // hardcoded
      entityData = {
        id: creditCustomerId,
        name: creditCustomerName,
        email: creditCustomerEmail,
      };
    } else {
      toast.error("Please fill either Provider or Customer details");
      return;
    }
    const newTransaction = {
      id: generateCreditId(),
      message:
        type === "add"
          ? `Added credit of ${creditAmount} ${selectedCurrency}`
          : `Subtracted credit of ${creditAmount} ${selectedCurrency}`,
      status: type === "add" ? "Added" : "Subtracted",
      amount: creditAmount, 
      type, 
      currency: selectedCurrency,
      createdAt: new Date().toISOString(),
      entityType: collectionPath.includes("providers") ? "providers" : "customers",
      entityId: entityData.id,
      name: entityData.name,
      email: entityData.email,
    };
    // Save to Firestore (fixed path)
    const ref = collection(db, ...collectionPath.split("/"));
    await addDoc(ref, newTransaction);
    // Update local state
    setCreditTransactions((prev) => [newTransaction, ...prev]);
    localStorage.setItem(
      "creditTransactions",
      JSON.stringify([newTransaction, ...creditTransactions])
    );
    // Reset inputs
    setCreditAmount(0);
    if (creditProviderId) {
      setCreditProviderId("");
      setCreditProviderName("");
      setCreditProviderEmail("");
    }
    if (creditCustomerId) {
      setCreditCustomerId("");
      setCreditCustomerName("");
      setCreditCustomerEmail("");
    }
    toast.success(
      `${type === "add" ? "Credit added" : "Credit subtracted"} successfully!`,
      { theme: "light" }
    );
  } catch (error) {
    console.error("Error in handleModifyCredit:", error);
    toast.error("Error updating credit");
  }
};
// Load persisted data on component mount
useEffect(() => {
  const storedBalance = parseFloat(localStorage.getItem("creditBalance")) || 0;
  const storedTransactions = JSON.parse(localStorage.getItem("creditTransactions")) || [];
  setCreditBalance(storedBalance);
  setCreditTransactions(storedTransactions);
}, []);
// Function to delete a transaction
const handleDeleteTransaction = (id) => {
  const filteredTransactions = creditTransactions.filter(
    (transaction) => transaction.id !== id
  );
  // Save to localStorage
  localStorage.setItem("creditTransactions", JSON.stringify(filteredTransactions));
  // Update UI state
  setCreditTransactions(filteredTransactions);
  // Show toast notification with white background
  toast("🗑️ Transaction deleted successfully!", {
    position: "top-right",
    autoClose: 1500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    style: {
      background: "#ffffff", // white background
      color: "#000000",      // black text
      boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
      border: "1px solid #E5E7EB", // optional border
    },
  });
};
const [showCancelledOrders, setShowCancelledOrders] = useState(false);
// ✅ Define `cancelledOrders` inside the component
const cancelledOrders = [
  { id: 5808, date: "04-09-2024" },
  { id: 5806, date: "02-09-2024" },
  { id: 5776, date: "18-07-2024" },
  { id: 5762, date: "28-06-2024" },
  { id: 5742, date: "19-06-2024" },
];
const [selectedCancelledOrder, setSelectedCancelledOrder] = useState(null);
const [discountCouponsOpen, setDiscountCouponsOpen] = useState(false);const startDiscountEdit = (index) => {
  setDiscountList((prevList) =>
    prevList.map((item, i) =>
      i === index ? { ...item, isEditing: true } : item
    )
  );
};
// Handle form data change for the discount coupon
const handleFormDataChange = (e) => {
  const { name, value } = e.target;
  setFormData((prevFormData) => ({
    ...prevFormData,
    [name]: value,
  }));
};
// Add a discount coupon to Firestore with the discountName as the document ID
const addDiscountCoupon = async (formData) => {
  try {
    const { discountName, discountStatus, discountAmount } = formData;
    // Use the discountName as the document ID in Firestore
    const couponRef = doc(firestore, "discountCoupons", discountName); 
    // Create or update the discount coupon document
    await setDoc(couponRef, {
      discountName,
      discountStatus,
      discountAmount,
    });
    console.log(`Discount coupon added with ID ${discountName}`);
  } catch (error) {
    console.error("Error adding discount coupon: ", error);
  }
};
// Fetch the discount coupons from Firestore on component mount
useEffect(() => {
  const fetchCoupons = async () => {
    try {
      // Fetch all coupons from Firestore
      const snapshot = await getDocs(collection(firestore, "discountCoupons"));
      const coupons = snapshot.docs.map(doc => ({
        id: doc.id, // Use Firestore document ID
        ...doc.data(),
        isEditing: false // Flag to handle editing mode
      }));

      // Set the fetched coupons into state
      setDiscountCoupons(coupons);
    } catch (error) {
      console.error("Error fetching coupons:", error);
    }
  };

  fetchCoupons();
}, []); // Empty dependency array to run on mount
// Save the updated coupon to Firestore
const saveCouponToFirestore = async (coupon) => {
  try {
    const couponRef = doc(firestore, "discountCoupons", coupon.id); // Use the Firestore document ID
    await setDoc(couponRef, {
      discountName: coupon.discountName,
      discountStatus: coupon.discountStatus,
      discountAmount: coupon.discountAmount,
    });
    console.log("Coupon updated in Firestore");
  } catch (error) {
    console.error("Error updating coupon:", error);
  }
};
  const [showDiscountCouponForm, setShowDiscountCouponForm] = useState(false);
  const [discountCoupons, setDiscountCoupons] = useState([]);
  const [showDiscountForm, setShowDiscountForm] = useState(false);
  const [showDiscountList, setShowDiscountList] = useState(false);
  const [discountList, setDiscountList] = useState([]);
  const CompletedOrderList = ({ userId }) => {
    const [transactions, setTransactions] = useState([]);
    useEffect(() => {
      const getTransactions = async () => {
        const data = await fetchWalletTransactions(userId);
        setTransactions(data);
      };
      getTransactions();
    }, [userId]);
  }
  const fetchUserWalletTransactions = async (uid) => {
    const walletTxnRef = collection(db, "walletTransactions");
    const q = query(walletTxnRef, where("userId", "==", uid));
    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  };
const [discountName, setDiscountName] = useState("");
const [discountStatus, setDiscountStatus] = useState(true);
const [discountAmount, setDiscountAmount] = useState("");
const [currentUser, setCurrentUser] = useState(null);
  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log("User logged in:", user.uid);
        setCurrentUser(user);
      } else {
        console.warn("No user logged in!");
        setCurrentUser(null);
      }
    });
  }, []);
  const handleDiscountSubmit = async (e) => {
  e.preventDefault();
  if (!currentUser) {
    console.error("User not authenticated! Redirecting to login...");
    return;
  }
  if (currentUser.uid !== "eBdMwBiLYvZkUQsoQhjIYrpmlSk2") {
    console.error("Unauthorized: Only admin can add discount coupons!");
    return;
  }
  if (!applyTo || !selectedId || !selectedName || !selectedEmail) {
    alert("Please fill all required Provider/Customer details before submitting.");
    return;
  }
  const newDiscount = {
    discountCode,
    status: discountStatus,
    amount: parseFloat(discountAmount),
    appliedTo: applyTo,
    targetId: selectedId,
    targetName: selectedName,
    targetEmail: selectedEmail,
    createdAt: new Date(),
  };
  try {
    console.log(`Adding discount for ${applyTo}: ${discountCode}...`);
    const mainCollection = "discountCoupons";
    const subCollection = applyTo === "provider" ? "providers" : "customers";
    // Add to Firestore
    const docRef = await addDoc(collection(db, mainCollection, subCollection, "entries"), newDiscount);
    console.log(`Discount '${discountCode}' added successfully! ID: ${docRef.id}`);
    // ⚡ Optimistically update UI with correct Firestore ID
    setDiscountList((prev) => [
      ...prev,
      {
        ...newDiscount,
        id: docRef.id, // Use Firestore auto-ID
      },
    ]);
    alert("Discount coupon added successfully!");
    // Reset form
    setDiscountAmount("");
    setApplyTo("");
    setSelectedId("");
    setSelectedName("");
    setSelectedEmail("");
    const newCode = "DISC-" + Math.random().toString(36).substring(2, 8).toUpperCase();
    setDiscountCode(newCode);
  } catch (error) {
    console.error("Error adding discount:", error);
    alert("Failed to add discount. Check console for details.");
  }
};
useEffect(() => {
  const fetchDiscounts = async () => {
    const mainCollection = "discountCoupons";
    const allDiscounts = [];
    try {
      const providersSnap = await getDocs(collection(db, mainCollection, "providers", "entries"));
      providersSnap.forEach((doc) => {
        allDiscounts.push({ id: doc.id, appliedTo: "provider", ...doc.data() });
      });
      const customersSnap = await getDocs(collection(db, mainCollection, "customers", "entries"));
      customersSnap.forEach((doc) => {
        allDiscounts.push({ id: doc.id, appliedTo: "customer", ...doc.data() });
      });
      setDiscountList(allDiscounts);
    } catch (error) {
      console.error("Error fetching discount coupons:", error);
    }
  };
  fetchDiscounts();
}, []);
const [formData, setFormData] = useState({});
const handleSave = (id) => {
  // Find the index of the item in the discountList
  const updatedList = discountList.map((item) =>
    item.id === id
      ? {
          ...item,
          name: editedValues[id]?.name || item.name,
          amount: editedValues[id]?.amount || item.amount,
          status: editedValues[id]?.status ?? item.status,
        }
      : item
  );
  // Update the state with the modified list
  setDiscountList(updatedList);
  // Optionally log it
  console.log("Saved:", updatedList.find((item) => item.id === id));
  // ✅ Show toast after saving
  toast.success("✅ Discount changes saved!", {
    position: "top-right",
    autoClose: 1500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    theme: "colored",
  });
};
  const [editedValues, setEditedValues] = useState({});
  const [tempEdits, setTempEdits] = useState({});
  const handleFieldChange = (id, field, value) => {
    setTempEdits((prev) => ({
      ...prev,
      [id]: { ...prev[id], [field]: value },
    }));
  };
  const handleSaveChanges = (id) => {
  setDiscountList((prevList) =>
    prevList.map((item) =>
      item.id === id ? { ...item, ...tempEdits[id] } : item
    )
  );
  setTempEdits((prev) => ({ ...prev, [id]: {} })); // Reset edits after saving
  console.log("Saved:", tempEdits[id]);  
};
const [newCoupon, setNewCoupon] = useState({
  name: "",
  amount: "",
  status: "Published",
});
const newDiscount = {
  name: discountName,
  status: discountStatus,
  amount: parseFloat(discountAmount),
  createdAt: new Date(),
};
// Begin editing a discount by its Firestore ID
const beginDiscountEdit = (id) => {
  setDiscountList((prevList) =>
    prevList.map((item) =>
      item.id === id ? { ...item, isEditing: true } : item
    )
  );
  toast.info("Editing started"); // Will default to top-right from <ToastContainer />
};
// Handle field changes while editing
const updateDiscountField = (id, field, value) => {
  setDiscountList((prevList) =>
    prevList.map((item) =>
      item.id === id ? { ...item, [field]: value } : item
    )
  );
  // ✅ Show toast for the field update
  toast.info(`✏️ Updating "${field}" to "${value}"`, {
    position: "top-right",
    autoClose: 1200,
    hideProgressBar: true,
    pauseOnHover: false,
    draggable: false,
  });
};
// Save the edited discount
const commitDiscountEdit = (id) => {
  setDiscountList((prevList) =>
    prevList.map((item) =>
      item.id === id ? { ...item, isEditing: false } : item
    )
  );
  const savedItem = discountList.find((item) => item.id === id);
  if (savedItem) {
    const name = savedItem.discountCode;
    const status = savedItem.status;
    localStorage.setItem(`discountStatus_${name}`, status);
    toast.success(`Changes saved for "${name}"`, {
      autoClose: 2500,
    });
  }
};
const hideDiscountTemporarily = (id) => {
  const discount = discountList.find((item) => item.id === id);
  if (!discount) {
    toast.error("Discount not found!");
    return;
  }
  // Temporarily hide the discount in the UI
  setDiscountList((prevList) =>
    prevList.map((item) =>
      item.id === id ? { ...item, isTemporarilyDeleted: true } : item
    )
  );
  toast.success(`Discount "${discount.discountCode}" deleted successfully (UI only)`);
};
const handleModifyWallet = async (type) => {
  try {
    if (!transactionAmount || transactionAmount <= 0) {
      toast.error("Enter a valid transaction amount", { theme: "light" });
      return;
    }
    if (!participantType || !participantId || !participantName || !participantEmail) {
      toast.error("Please fill all participant details", { theme: "light" });
      return;
    }
    // ✅ Use separate top-level collections (no linking to providers/customers)
    const collectionName = participantType === "provider" ? "Provider_Wallet" : "Customer_Wallet";
    // 🔹 Fetch last known wallet balance (optional: from recent state or DB)
    let lastBalance = 0;
    if (walletTransactions.length > 0) {
      // take last transaction of same participant if available
      const lastTxn = walletTransactions.find(
        (txn) => txn.id === participantId && txn.participantType === participantType
      );
      if (lastTxn) lastBalance = lastTxn.walletBalanceAfter || 0;
    }
    // 🔹 Calculate new balance
    const newBalance =
      type === "add"
        ? lastBalance + transactionAmount
        : Math.max(0, lastBalance - transactionAmount);
    // 🔹 Build transaction record
    const transactionData = {
      transactionId: `txn-${Date.now()}`,
      id: participantId,
      name: participantName,
      email: participantEmail,
      amount: transactionAmount,
      currency,
      message: `Wallet ${type} transaction`,
      status: type === "add" ? "Credited" : "Debited",
      walletBalanceAfter: newBalance,
      participantType,
      timestamp: new Date(),
    };
    // 🔹 Save to Firestore under Provider_Wallet / Customer_Wallet
    await addDoc(collection(db, collectionName), transactionData);
    // 🔹 Update local state only (no Firestore update to provider/customer doc)
    setWalletBalance(newBalance);
    setCompletedOrders((prev) => [...prev, transactionData]);
    setWalletTransactions((prev) => [...prev, transactionData]);
    setTransactionAmount("");
    // ✅ Toast Notification
    toast.success(
      `${type === "add" ? "Wallet credited" : "Wallet debited"} successfully!`,
      {
        style: {
          background: "#ffffff",
          color: "#000000",
          border: "1px solid #e5e7eb",
          fontFamily: "'Inter', sans-serif",
          fontSize: "14px",
          borderRadius: "8px",
        },
      }
    );
  } catch (error) {
    console.error("Error in handleModifyWallet:", error);
    toast.error("Error updating wallet", {
      style: {
        background: "#ffffff",
        color: "#000000",
        border: "1px solid #e5e7eb",
        fontFamily: "'Inter', sans-serif",
        fontSize: "14px",
        borderRadius: "8px",
      },
    });
  }
};
const [searchWalletTerm, setSearchWalletTerm] = useState(""); // new search term
useEffect(() => {
  fetchWalletTransactions();
}, []);
// 🔹 Load cached data first + fetch new data
useEffect(() => {
  const cached = localStorage.getItem("walletTransactions");
  if (cached) {
    setWalletTransactions(JSON.parse(cached));
  }
  fetchWalletTransactions();
}, []);
// 🔹 Save to cache when data changes
useEffect(() => {
  if (walletTransactions.length > 0) {
    localStorage.setItem("walletTransactions", JSON.stringify(walletTransactions));
  }
}, [walletTransactions]);
// Filter transactions by search term (case-insensitive)
const filteredTransactions = walletTransactions.filter((txn) => {
  const term = searchWalletTerm.toLowerCase();
  return (
    (txn.id?.toLowerCase().includes(term)) ||
    (txn.participantType?.toLowerCase().includes(term)) ||
    (txn.name?.toLowerCase().includes(term)) ||
    (txn.email?.toLowerCase().includes(term)) ||
    (txn.message?.toLowerCase().includes(term)) ||
    (txn.status?.toLowerCase().includes(term)) ||
    (txn.currency?.toLowerCase().includes(term)) ||
    (txn.amount?.toString().includes(term)) ||
    (txn.walletBalanceAfter?.toString().includes(term))
  );
});
const fetchWalletBalance = async () => {
  const userRef = doc(db, "users", userId);
  const userSnap = await getDoc(userRef);
  if (userSnap.exists()) {
    setWalletBalance(userSnap.data().walletBalance ?? 0);
  }
};
const fetchOrderData = async () => {
  const q = query(
    collection(db, "orders"),
    where("userId", "==", userId),
    where("status", "==", "Completed"),
    orderBy("timestamp", "desc")
  );
  const snapshot = await getDocs(q);
  const orders = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  setCompletedOrders(orders); // assuming you have a setCompletedOrders state
};
useEffect(() => {
  const unsubscribe = onSnapshot(collection(db, "walletTransactions"), (snapshot) => {
    const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setWalletTransactions(data);
  });

  return () => unsubscribe();
}, []);

const [removedPartnerIds, setRemovedPartnerIds] = useState([]);
const [isRemoving, setIsRemoving] = useState(false);
useEffect(() => {
  // Load the removed partner IDs from localStorage when the app is loaded
  const storedRemovedPartnerIds = JSON.parse(localStorage.getItem('removedPartnerIds')) || [];
  setRemovedPartnerIds(storedRemovedPartnerIds);
  // Optionally, you can filter the partners based on removedPartnerIds (to prevent showing deleted rows)
}, []);
const handlePartnerRemoval = (partnerId) => {
  setIsRemoving(true);
  setRemovedPartnerIds(prev => {
    const updatedRemovedPartnerIds = [...prev, partnerId];
    localStorage.setItem('removedPartnerIds', JSON.stringify(updatedRemovedPartnerIds));
    return updatedRemovedPartnerIds;
  });
  // Remove from UI immediately
  setPartners(prev => prev.filter(partner => partner.id !== partnerId));
  setTimeout(() => setIsRemoving(false), 500);
};
useEffect(() => {
  const fetchPartners = async () => {
    const removedIds = JSON.parse(localStorage.getItem('removedPartnerIds')) || [];
    setRemovedPartnerIds(removedIds);

    try {
      const snapshot = await getDocs(collection(db, "partners"));
      const allPartners = snapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(partner =>
          partner.fullName &&
          partner.email &&
          partner.mobile &&
          partner.userType &&
          partner.status &&
          typeof partner.walletBalance === 'number'
        ); // ✅ Only include valid entries

      const visiblePartners = allPartners.filter(p => !removedIds.includes(p.id));
      setPartners(visiblePartners);
    } catch (error) {
      console.error("Error fetching partners:", error);
    }
  };

  fetchPartners();
}, []);
useEffect(() => {
  const savedDiscountList = localStorage.getItem('discountList');
  if (savedDiscountList) {
    setDiscountList(JSON.parse(savedDiscountList));
  }
}, []);
const handleDiscountStatusChange = (index, status) => {
  const updatedList = [...discountList];
  updatedList[index].status = status;
  setDiscountList(updatedList);
  localStorage.setItem("discountList", JSON.stringify(updatedList));
};
const saveDiscount = (index) => {
  // Save the updated discount (e.g., make API call or update state)
  const updatedList = [...discountList];
  updatedList[index].isEditing = false;
  setDiscountList(updatedList);
};

const editDiscount = (index) => {
  const updatedList = [...discountList];
  updatedList[index].isEditing = true;
  setDiscountList(updatedList);
};

const deleteDiscount = (index) => {
  const deletedItem = discountList[index];
  const updatedList = discountList.filter((_, i) => i !== index);
  setDiscountList(updatedList);

  toast.error(`Deleted "${deletedItem.name}"`, {
    position: "top-right",
    autoClose: 2000,
  });
};
const [invoiceList, setInvoiceList] = useState([
  {
    id: "in_1REVqQQvoACPyOLkWaP9Fyic",
    customer: "cus_S8nRbx0z1WoPrY",
    amount: "$0.00",
    status: "paid",
  },
  {
    id: "in_1RET8bQvoACPyOLkI5tEUMKK",
    customer: "cus_S8kdYW7ih4BsEy",
    amount: "$0.00",
    status: "paid",
  },
  {
    id: "in_1RERHbQvoACPyOLk5oyMRBtH",
    customer: "cus_S8ijig7i1W4BwP",
    amount: "$0.00",
    status: "paid",
  },
  {
    id: "in_1RER8rQvoACPyOLk9YAVL7fd",
    customer: "cus_S8iajA4gjCIEvR",
    amount: "$0.00",
    status: "paid",
  },
  {
    id: "in_1RER6cQvoACPyOLkZjcwXXre",
    customer: "cus_S8iXNDRusa1K5B",
    amount: "$0.00",
    status: "paid",
  },
]);



const [visibleSection, setVisibleSection] = useState(""); // Correct initialization of state

const handleFinancialSectionToggle = () => {
  setVisibleSection(visibleSection === "financialSection" ? "" : "financialSection");
};

const [editingIndex, setEditingIndex] = useState(null);
const [editedId, setEditedId] = useState('');
const [editedCustomer, setEditedCustomer] = useState('');
const [editedAmount, setEditedAmount] = useState('');
const [editedStatus, setEditedStatus] = useState('');
const [showFinancialSection, setShowFinancialSection] = useState(false);
const [invoices, setInvoices] = useState([]); // Initialize invoices state
const [financialData, setFinancialData] = useState([]);

const handleStartEdit = (index, id, customer, amount, status) => {
  setEditingIndex(index);
  setEditedId(id);
  setEditedCustomer(customer);
  setEditedAmount(amount);
  setEditedStatus(status);

  toast.info(`Editing invoice "${id}"`, {
    position: "top-right",
    autoClose: 2000,
  });
};

const handleConfirmSave = () => {
  const updated = invoiceList.map((invoice, index) => {
    if (index === editingIndex) {
      return {
        ...invoice,
        id: editedId,
        customer: editedCustomer,
        amount: editedAmount,
        status: editedStatus,
      };
    }
    return invoice;
  });

  setInvoiceList(updated);
  setEditingIndex(null);

  toast.success(`Changes saved for invoice "${editedId}"`, {
    position: "top-right",
    autoClose: 2000,
  });
};

const handleRemove = (invoiceId) => {
  const updatedInvoices = invoices.filter((invoice) => invoice.id !== invoiceId);
  setInvoices(updatedInvoices);

  console.log("Deleted invoice:", invoiceId); // Debug
  toast.error(`Invoice "${invoiceId}" deleted`, {
    position: "top-right",
    autoClose: 2000,
  });
};

useEffect(() => {
  // Set the status from localStorage if it exists
  const updatedInvoiceList = invoiceList.map((invoice) => {
    const storedStatus = localStorage.getItem(`invoiceStatus_${invoice.id}`);
    if (storedStatus) {
      return { ...invoice, status: storedStatus };
    }
    return invoice;
  });
  
  setInvoiceList(updatedInvoiceList);
}, []);

useEffect(() => {
  const updated = discountList.map((item) => {
    const saved = localStorage.getItem(`discountStatus_${item.name}`);
    if (saved !== null) {
      return {
        ...item,
        status: saved === "true", // convert string to boolean
      };
    }
    return item;
  });
  setDiscountList(updated);
}, []);

useEffect(() => {
  const storedTransactions = localStorage.getItem("creditTransactions");
  if (storedTransactions) {
    setCreditTransactions(JSON.parse(storedTransactions));
  }
}, []);


const [previewInvoice, setPreviewInvoice] = useState(null);
const [showPreviewModal, setShowPreviewModal] = useState(false);

const handlePreview = (invoice) => {
  setPreviewInvoice(invoice);
  setShowPreviewModal(true);
};

const CompletedOrdersSection = ({ showCompletedOrders, walletTransactions, deleteOrder }) => {
  const [completedOrders, setCompletedOrders] = useState([]);

  // Load from sessionStorage on mount
  useEffect(() => {
    const storedOrders = sessionStorage.getItem("completedOrders");
    if (storedOrders) {
      setCompletedOrders(JSON.parse(storedOrders));
    }
  }, []);

  // Save to sessionStorage whenever completedOrders update
  useEffect(() => {
    if (completedOrders?.length > 0) {
      sessionStorage.setItem("completedOrders", JSON.stringify(completedOrders));
    }
  }, [completedOrders]);
}
const PartnerReport = ({
  showPartnerReport,
  totalOrders,
  creditBalance,
  handleModifyCredit,
  handleDeleteTransaction,
  creditAmount,
  setCreditAmount,
  selectedCurrency,
  setSelectedCurrency,
}) => {
  const [creditTransactions, setCreditTransactions] = useState([]);

  // Load from sessionStorage on mount
  useEffect(() => {
    const storedTransactions = sessionStorage.getItem("creditTransactions");
    if (storedTransactions) {
      setCreditTransactions(JSON.parse(storedTransactions));
    }
  }, []);

  // Save to sessionStorage whenever transactions update
  useEffect(() => {
    if (creditTransactions?.length > 0) {
      sessionStorage.setItem("creditTransactions", JSON.stringify(creditTransactions));
    }
  }, [creditTransactions]);
}


const handleZohoTicketClick = () => {
  // logic to show Zoho ticket section or open modal
  showOnlySection("zohoTickets");
};

const [ticketData, setTicketData] = useState({
  statusUpdates: [
    { time: "09:47 PM", update: "Ticket overshot its Resolution Due time" },
    { time: "03:47 PM", update: "Service-level agreement has been activated" },
    {
      time: "03:47 PM",
      update: "Due Date changed from 25 Nov 12:00 PM to 23 Apr 09:47 PM",
    },
  ],
  currentTicketDetails: {
    submittedAt: "03:47 PM",
    name: "Nithin Popuri",
    department: "homeservice-nithin",
    accountName: "NithinVamsi",
    contactName: "NithinVamsi",
    email: "Popuri.nitin.apexdreamstudio@gmail.com",
    phone: "9346382870",
    subject: "This is a deskticket for YouTube Demo",
    description: "This Is a Description for Your DeskTicket",
    status: "Open",
    ticketOwner: "Nithin Popuri",
    dueDate: "25 Nov 12:00 PM",
    priority: "High",
    channel: "Phone",
    timeToRespond: "25 Nov 12:00 PM",
    layout: "homeservice-nithin",
    language: "English",
    relationshipType: "None",
  },
});
const { statusUpdates, ticketDetails } = ticketData;
const [showZohoTicket, setShowZohoTicket] = useState(false);
const handleDeleteTicket = (ticketKey) => {
  setTicketData(prevState => {
    const updatedTicketDetails = { ...prevState.currentTicketDetails };
    delete updatedTicketDetails[ticketKey];  // Remove the ticket detail property
    return { ...prevState, currentTicketDetails: updatedTicketDetails };
  });
};
const [editingRowKey, setEditingRowKey] = useState(null);
const [editedFields, setEditedFields] = useState({});
const handleRowSave = (originalKey) => {
  const { newKey, value, status } = editedFields;
  if (!newKey || !value || !status) {
    alert("Please fill out all fields before saving.");
    return;
  }
  const updatedTicketDetails = { ...ticketData.currentTicketDetails };
  // If the key has changed, delete the old key and insert the new one
  if (originalKey !== newKey) {
    delete updatedTicketDetails[originalKey];
  }
  // Assign updated value and status
  updatedTicketDetails[newKey] = {
    value: value,
    status: status
  };
  // Update the ticketData state with the new ticket details, ensuring the row position is maintained
  setTicketData((prev) => ({
    ...prev,
    currentTicketDetails: updatedTicketDetails,
  }));
  // Reset the editing state after saving
  setEditingRowKey(null);
  setEditedFields({});
};
const handlePrintOrder = () => {
  const printWindow = window.open("", "_blank");
  const content = document.getElementById("orderPreviewContent").innerHTML;
  printWindow.document.write(content);
  printWindow.document.close();
  printWindow.print();
};
// Declare printRef here
const printRef = useRef(); // Add this line
const printOrder = () => {
  const content = printRef.current;
  const printWindow = window.open('', '', 'height=800,width=600');
  printWindow.document.write(content.innerHTML);
  printWindow.document.close();
  printWindow.print();
};
// Initial state for ticket logs
const [ticketLogs, setTicketLogs] = useState([
    {
      date: '31 Jan 10:49 AM',
      event: 'Ticket was reopened on receipt of customer reply',
      statusChange: 'Closed to Open',
    },
    {
      date: '31 Jan 10:49 AM',
      event: 'Mail received from mailer-daemon',
    },
    {
      date: '31 Jan 10:07 AM',
      event: 'Vaibhav Sharma added a time entry',
      timeSpent: '2 minutes 58 seconds',
      description: 'Time spent on chat.',
    },
    {
      date: '31 Jan 10:05 AM',
      event: 'Vaibhav Sharma added a time entry',
      timeSpent: '1 minute 19 seconds',
      description: 'Updated ticket fields',
    },
    {
      date: '31 Jan 10:05 AM',
      event: 'Vaibhav Sharma updated the ticket',
      statusChange: 'Open to Closed',
    },
    {
      date: '31 Jan 10:04 AM',
      event: 'Vaibhav Sharma added a time entry',
      timeSpent: '16 seconds',
      description: 'Sent a new reply',
    },
    {
      date: '31 Jan 10:04 AM',
      event: 'Vaibhav Sharma sent an email reply',
    },
    {
      date: '31 Jan 10:03 AM',
      event: 'New chat ticket received',
      department: 'Unlimited Gig',
      contactName: 'Hello',
      email: 'hello@123.com',
      subject: 'Hello test',
      status: 'Open',
      ticketOwner: 'Vaibhav Sharma',
      channel: 'Chat',
      layout: 'Unlimited Gig',
      relationshipType: 'None',
    },
]);
  const handleReferredByChange = (customerId, newReferrer) => {
    setLocalCustomers((prevCustomers) =>
      prevCustomers.map((cust) =>
        cust.id === customerId ? { ...cust, referredBy: newReferrer } : cust
      )
    );
  
    // 🔄 Optional: Persist this change to Firestore or backend here
    // updateCustomerReferredBy(customerId, newReferrer);
  };
  const handleReferralChange = (customerId, newReferral) => {
    setLocalCustomers(prevCustomers =>
      prevCustomers.map(customer =>
        customer.id === customerId
          ? { ...customer, referredBy: newReferral }
          : customer
      )
    );
  
    // Optional: update in Firestore
    // await updateDoc(doc(firestore, 'customers', customerId), { referredBy: newReferral });
  };
    
  const [users, setUsers] = useState([
    {
      id: 1,
      fullName: 'Users',
      email: 'us@test.com',
      mobile: '1234567890',
      wallet: '50£',
      referredBy: 'none',
      status: 'Active'
    },
    {
      id: 2,
      fullName: 'Rushita',
      email: 'abc@gmail.com',
      mobile: '9876543211',
      wallet: '100£',
      referredBy: 'Users',
      status: 'Active'
    },
    {
      id: 3,
      fullName: 'Ramesh',
      email: 'Ramesh999@gmail.com',
      mobile: '9654327891',
      wallet: '345£',
      referredBy: 'Users',
      status: 'Active'
    }
  ]);

  // Update function for handling input changes
  const updateUserField = (e, userId, field) => {
    const updatedUsers = users.map((user) => {
      if (user.id === userId) {
        return { ...user, [field]: e.target.value };
      }
      return user;
    });
    setUsers(updatedUsers);
  };

  // Handling status update
  const updateUserStatus = (e, userId) => {
    updateUserField(e, userId, 'status');
  };


  const handleUserProfileStatusChange = (e, userId) => {
    const updatedUserList = users.map((user) => {
      if (user.id === userId) {
        return { ...user, status: e.target.value };
      }
      return user;
    });
    setUsers(updatedUserList);
  };
  
  const [selectedUserProfile, setSelectedUserProfile] = useState(null);
  const [showZohoTicket2, setShowZohoTicket2] = useState(false);


    const [entries, setEntries] = useState([
      {
        dateTime: '31 Jan 10:24 AM',
        action: 'Vaibhav Sharma received a happiness rating',
        rating: 'Good',
        description: 'Great service',
      },
      {
        dateTime: '31 Jan 10:09 AM',
        action: 'Vaibhav Sharma added a time entry',
        timeSpent: '1 minute 42 seconds',
        description: 'Time spent on chat.',
      },
      {
        dateTime: '31 Jan 10:06 AM',
        action: 'New chat ticket received',
        department: 'Unlimited Gig',
        contactName: 'Hello',
        email: 'hello@123.com',
        subject: 'test new',
        status: 'Open',
        ticketOwner: 'Vaibhav Sharma',
        channel: 'Chat',
        layout: 'Unlimited Gig',
        relationshipType: 'None',
      },
    ]);
  
    const handleDeleteEntry = (index) => {
      const updatedEntries = entries.filter((_, i) => i !== index);
      setEntries(updatedEntries);
    };

    const [ticketEntries, setTicketEntries] = useState([
      {
        dateTime: "30 Jan, 11:35 PM",
        action: "Ticket overshot its Resolution Due time",
        sla: "Priority-based SLAs",
        dueDate: "30 Jan 11:35 PM",
        submittedBy: "sdfdsf",
        department: "Unlimited Gig",
        contactName: "sdfdsf",
        email: "sharma.vaibhav18@gmail.com",
        subject: "erewr",
        description: "test",
        status: "Open",
        priority: "High",
        channel: "Web",
        layout: "Unlimited Gig",
        relationshipType: "None",
      },
    ]);
  
    const handleDeleteLog = (index) => {
      const updatedEntries = [...ticketEntries];
      updatedEntries.splice(index, 1);
      setTicketEntries(updatedEntries);
    };
  


const [showZohoTicket3, setShowZohoTicket3] = useState(false);
const [ticket4, setTicket4] = useState([
  {
    id: 1,
    date: "30 Jan 05:18 PM",
    action: "New chat ticket received",
    details: {
      language: "English",
      layout: "Unlimited Gig",
      department: "Unlimited Gig",
      contactName: "Hello",
      email: "hello@123.com",
      subject: "hello",
      status: "Open",
      channel: "Chat",
      relationshipType: "None"
    }
  }
]);
const handleDeleteTicket4 = (index) => {
  const updatedTickets = ticket4.filter((_, i) => i !== index); // Remove ticket by index
  setTicket4(updatedTickets); // Update the state with the new list
};

const [ticket5, setTicket5] = useState([
  {
    date: "30 Jan 12:24 PM",
    action: "Added a time entry",
    details: {
      timeSpent: "15 seconds",
      executedOn: "30 Jan 12:24 PM",
      description: "Updated Ticket fields",
      rating: "",
      department: "",
      contactName: "",
      email: "",
      subject: "",
      status: "",
      ticketOwner: "",
      channel: "",
      layout: "",
      relationshipType: ""
    }
  },
  {
    date: "30 Jan 11:52 AM",
    action: "Received a happiness rating",
    details: {
      timeSpent: "",
      executedOn: "30 Jan 11:52 AM",
      description: "",
      rating: "Good",
      department: "",
      contactName: "",
      email: "",
      subject: "",
      status: "",
      ticketOwner: "",
      channel: "",
      layout: "",
      relationshipType: ""
    }
  },
  {
    date: "30 Jan 11:29 AM",
    action: "Added a time entry",
    details: {
      timeSpent: "1 minute 45 seconds",
      executedOn: "30 Jan 11:29 AM",
      description: "Time spent on chat.",
      rating: "",
      department: "",
      contactName: "",
      email: "",
      subject: "",
      status: "",
      ticketOwner: "",
      channel: "",
      layout: "",
      relationshipType: ""
    }
  },
  {
    date: "30 Jan 11:26 AM",
    action: "New chat ticket received",
    details: {
      timeSpent: "",
      executedOn: "30 Jan 11:26 AM",
      description: "",
      rating: "",
      department: "Unlimited Gig",
      contactName: "Hello",
      email: "k@j.com",
      subject: "Hii",
      status: "Open",
      ticketOwner: "Vaibhav Sharma",
      channel: "Chat",
      layout: "Unlimited Gig",
      relationshipType: "None"
    }
  }
]);


// Define the state for showZohoTicket5
const [showZohoTicket5, setShowZohoTicket5] = useState(false); // You can set this to true or false based on your condition
const [replyIndex, setReplyIndex] = useState(null);
  const [replyAllIndex, setReplyAllIndex] = useState(null);
  const [forwardIndex, setForwardIndex] = useState(null);
  const [messageText, setMessageText] = useState("");

  const handleSendMessage = (index, type) => {
    const ticket = ticket5[index];
    const sender = "Support";
    const content =
      type === "forward"
        ? `Forwarded to Manager: ${messageText}`
        : messageText;

    const newMessage = { sender, content };

    // Update messages in the selected ticket
    const updatedTickets = [...ticket5];
    const ticketMessages = updatedTickets[index].messages || [];
    updatedTickets[index].messages = [...ticketMessages, newMessage];
    setTicket5(updatedTickets);

    toast.success(`${type.toUpperCase()} sent successfully to ticket #${ticket.id}`, {
      position: "top-right",
      autoClose: 2000,
    });

    // Clear state
    setReplyIndex(null);
    setReplyAllIndex(null);
    setForwardIndex(null);
    setMessageText("");
  };

  const handleCancel = () => {
    toast.info("Action canceled", { autoClose: 1500 });
    setReplyIndex(null);
    setReplyAllIndex(null);
    setForwardIndex(null);
    setMessageText("");
  };

  const handleDeleteMessage = (messageIndex, ticketIndex) => {
    setTicket5((prevTickets) => {
      const updatedTickets = [...prevTickets];
      const ticket = updatedTickets[ticketIndex];
  
      if (ticket.messages && ticket.messages.length > messageIndex) {
        ticket.messages.splice(messageIndex, 1);  // Delete the message at the specified index
      }
  
      return updatedTickets;
    });
  
    toast.success("Message deleted successfully!");
  };

  
  const [replies, setReplies] = useState({});
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'reply', 'replyAll', 'forward'
  const [notification, setNotification] = useState(null);
  const [openTicketId, setOpenTicketId] = useState(null); // Track which ticket's chat is open

  // Handle real-time message updates (Reply, Reply All, Forward)
  const handleReply = (ticketId) => {
    setMessageType('reply');
    setMessage('');
    setOpenTicketId(ticketId); // Open the corresponding chat
  };

  const handleReplyAll = (ticketId) => {
    setMessageType('replyAll');
    setMessage('');
    setOpenTicketId(ticketId); // Open the corresponding chat
  };

  const handleForward = (ticketId) => {
    setMessageType('forward');
    setMessage('');
    setOpenTicketId(ticketId); // Open the corresponding chat
  };

  const handleMessageSend = (ticketId) => {
    if (message.trim()) {
      setReplies((prev) => ({
        ...prev,
        [ticketId]: [
          ...(prev[ticketId] || []),
          { type: messageType, message: message, id: Date.now() }, // Add unique ID for each message
        ],
      }));

      // Clear the message input
      setMessage('');

      // Set notification
      setNotification('Successfully Delivered');

      // Close notification after 3 seconds
      setTimeout(() => setNotification(null), 3000);

      // Simulate message sending to backend
      // Here, integrate your API or WebSocket call to send the message to the backend
      // sendToBackend(ticketId, message, messageType);
    }
  };

  const removeMessage = (ticketId, messageId) => {
    setReplies((prev) => ({
      ...prev,
      [ticketId]: prev[ticketId]?.filter((msg) => msg.id !== messageId), // Using filter for deletion
    }));

    // Simulate deletion from backend (optional API call)
    // deleteMessageFromBackend(ticketId, messageId);
  };
  
  const removeTicketLog = (index) => {
    const updatedTicketLogs = ticketLogs.filter((_, i) => i !== index);
    setTicketLogs(updatedTicketLogs);
  };

  
  const [activeZoho1ActionIndex, setActiveZoho1ActionIndex] = useState(null);
  const [zoho1ActionType, setZoho1ActionType] = useState('');
  const [zoho1Message, setZoho1Message] = useState('');
  const [sentMessages, setSentMessages] = useState([]); // ✅ must be an array

  const handleZoho1ReplyAction = (index, type) => {
    setActiveZoho1ActionIndex(index);
    setZoho1ActionType(type);
    setZoho1Message('');
  };

  const handleZoho1SendMessage = (index) => {
    if (!zoho1Message.trim()) return;
  
    // Update the sent messages state
    setSentMessages((prev) => ({
      ...prev,
      [index]: {
        type: zoho1ActionType,
        message: zoho1Message,
      },
    }));
  
    // Trigger a success toast notification
    toast.success('Message Delivered Successfully');
  
    // Clear the input fields and reset the action
    setZoho1Message('');
    setZoho1ActionType('');
    setActiveZoho1ActionIndex(null);
  };
  
  
  const handleDeleteSentMessage = (index) => {
    setSentMessages((prev) => {
      const updated = { ...prev };
      delete updated[index];
      return updated;
    });
  };
  const [replyType, setReplyType] = useState(null);



  const [activeZohoField, setActiveZohoField] = useState(null);
  const [currentZohoAction, setCurrentZohoAction] = useState('');
  const [zohoMessage, setZohoMessage] = useState('');
  const [zohoResponses, setZohoResponses] = useState({});
  

  // Zoho inline actions
  const openZohoAction = (fieldKey, actionType) => {
    setActiveZohoField(fieldKey);
    setCurrentZohoAction(actionType);
    setZohoMessage('');
  };

  const cancelZohoAction = () => {
    setActiveZohoField(null);
    setCurrentZohoAction('');
    setZohoMessage('');
  };

  const submitZohoResponse = (fieldKey) => {
    if (!zohoMessage.trim()) return;
    setZohoResponses(prev => ({
      ...prev,
      [fieldKey]: [
        ...(prev[fieldKey] || []),
        { type: currentZohoAction, message: zohoMessage }
      ]
    }));
    toast.success('Message Delivered Successfully');
    cancelZohoAction();
  };

  // Edit / Delete field handlers
  const startFieldEdit = (fieldKey) => {
    const obj = ticketData.currentTicketDetails[fieldKey];
    const val = obj && typeof obj === 'object' ? obj.value : obj;
    const stat = obj && typeof obj === 'object' ? obj.status : 'Open';
    setEditingRowKey(fieldKey);
    setEditedFields({ newKey: fieldKey, value: val, status: stat });
  };

  const handleFieldDelete = (fieldKey) => {
    handleDeleteTicket(fieldKey);
    if (activeZohoField === fieldKey) cancelZohoAction();
    if (editingRowKey === fieldKey) {
      setEditingRowKey(null);
      setEditedFields({});
    }
  };

  const handleDeleteTicketItem = (ticketIndex) => {
    // Assuming `ticket5` is the array of tickets
    const updatedTickets = ticket5.filter((_, i) => i !== ticketIndex);
    setTicket5(updatedTickets); // Update the state with the modified ticket list
  };

  
  const handleZoho1DeleteTicket = (index) => {
    if (window.confirm('Are you sure you want to delete this ticket?')) {
      const updatedTicketLogs = ticketLogs.filter((log, i) => i !== index);
      setTicketLogs(updatedTicketLogs);
      toast.success('Ticket deleted successfully');
    }
  };


  // Load from localStorage on mount
  useEffect(() => {
    const savedOrders = JSON.parse(localStorage.getItem("completedOrders")) || [];
    const savedTransactions = JSON.parse(localStorage.getItem("walletTransactions")) || [];
    setCompletedOrders(savedOrders);
    setWalletTransactions(savedTransactions);
  }, []);

  // Save to localStorage whenever completedOrders or walletTransactions change
  useEffect(() => {
    localStorage.setItem("completedOrders", JSON.stringify(completedOrders));
    localStorage.setItem("walletTransactions", JSON.stringify(walletTransactions));
  }, [completedOrders, walletTransactions]);

  useEffect(() => {
  const savedOrders = localStorage.getItem("totalOrders");
  const savedBalance = localStorage.getItem("creditBalance");
  const savedTransactions = localStorage.getItem("creditTransactions");

  if (savedOrders) setTotalOrders(Number(savedOrders));
  if (savedBalance) setCreditBalance(Number(savedBalance));
  if (savedTransactions) setCreditTransactions(JSON.parse(savedTransactions));
}, []);

function formatSelectedPages(permissions) {
  if (!permissions || typeof permissions !== 'object') return '';
  return Object.entries(permissions)
    .flatMap(([category, pages]) =>
      Object.entries(pages)
        .filter(([page, allowed]) => allowed)
        .map(([page]) => page)
    )
    .join(', ');
}

const [userList, setUserList] = useState([]);



useEffect(() => {
  async function fetchUsers() {
    try {
      const usersCol = collection(db, 'users');
      const userSnapshot = await getDocs(usersCol);
      const users = userSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setUserList(users);
    } catch (error) {
      console.error('Failed to fetch users:', error);
    }
  }
  fetchUsers();
}, []);

const PAGE_HIERARCHY = {
  "Operations": ["Completed Orders", "Credit Package Form", "Send Notification Form"],
  // other categories...
};
  const [newUserData, setNewUserData] = useState({
    name: "",
    email: "",
    mobile: "",
    password: "",
    isAdmin: false,
    canAccessCallRecording: false,
    canMonitorLiveCalls: false,
    permissions: {}, // structure: { category: { page: boolean } }
  });


  // Handle form input changes (text & checkbox)
  const handleUserFieldChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setNewUserData((prev) => ({
        ...prev,
        [name]: checked,
      }));
    } else {
      setNewUserData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // Toggle page permission checkbox
  const handlePermissionToggle = (category, page) => {
    setNewUserData((prev) => {
      const categoryPermissions = prev.permissions[category] || {};
      return {
        ...prev,
        permissions: {
          ...prev.permissions,
          [category]: {
            ...categoryPermissions,
            [page]: !categoryPermissions[page],
          },
        },
      };
    });
  };

  // Fetch user list from Firestore on mount
  useEffect(() => {
    async function fetchUsers() {
      const q = query(collection(db, "users"), orderBy("name"));
      const querySnapshot = await getDocs(q);
      const users = [];
      querySnapshot.forEach((doc) => {
        users.push({ id: doc.id, ...doc.data() });
      });
      setUserList(users);
    }

    fetchUsers();
  }, []);

  // Handle adding a new user/admin
  const handleAddNewUser = async () => {
    try {
      // Create Firebase Auth user
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        newUserData.email,
        newUserData.password
      );

      const user = userCredential.user;

      // Update user profile display name
      await updateProfile(user, { displayName: newUserData.name });

      // Save additional user info and permissions to Firestore
      await addDoc(collection(db, "users"), {
        uid: user.uid,
        name: newUserData.name,
        email: newUserData.email,
        mobile: newUserData.mobile,
        isAdmin: newUserData.isAdmin,
        canAccessCallRecording: newUserData.canAccessCallRecording,
        canMonitorLiveCalls: newUserData.canMonitorLiveCalls,
        permissions: newUserData.permissions,
        status: "Active",
        lastLogin: null, // you can update this on login
      });

      alert("User added successfully!");

      // Clear form
      setNewUserData({
        name: "",
        email: "",
        mobile: "",
        password: "",
        isAdmin: false,
        canAccessCallRecording: false,
        canMonitorLiveCalls: false,
        permissions: {},
      });

      // Refresh user list
      const q = query(collection(db, "users"), orderBy("name"));
      const querySnapshot = await getDocs(q);
      const users = [];
      querySnapshot.forEach((doc) => {
        users.push({ id: doc.id, ...doc.data() });
      });
      setUserList(users);
    } catch (error) {
      console.error("Error adding user:", error);
      alert("Failed to add user: " + error.message);
    }
  };

const [isTicketDropdownOpen, setTicketDropdownOpen] = useState(false);

const toggleTicketDropdown = () => {
  setTicketDropdownOpen((prev) => !prev);
};

 const [showSendNotification, setShowSendNotification] = useState(false);
 const [notificationForm, setNotificationForm] = useState({
    notifTitle: '',
    notifMessage: '',
    notifImageUrl: '',
    userCategory: '',
  });

  const onFieldUpdate = (e) => {
    const { name, value } = e.target;
    setNotificationForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

 const onNotificationSubmit = async (e) => {
  e.preventDefault();
  try {
    await addDoc(collection(db, 'notifications'), {
      notifTitle: notificationForm.notifTitle,
      notifMessage: notificationForm.notifMessage,
      notifImageUrl: notificationForm.notifImageUrl,
      userCategory: notificationForm.userCategory,
      createdAt: Timestamp.now()
    });

    alert('Notification data sent to Firestore!');
    setNotificationForm({ notifTitle: '', notifMessage: '', notifImageUrl: '', userCategory: '' });
    setShowSendNotification(false);
  } catch (error) {
    console.error('Error sending notification:', error);
    alert('Failed to send notification');
  }
};

const [showCombinedTickets, setShowCombinedTickets] = useState(false);
const toggleCombinedTickets = () => {
  setShowCombinedTickets(!showCombinedTickets);
};

const [panelTitle, setPanelTitle] = useState('');
const [panelAlias, setPanelAlias] = useState('');
const [userAppKey, setUserAppKey] = useState('');
const [userAppSecret, setUserAppSecret] = useState('');
const [partnerAppKey, setPartnerAppKey] = useState('');
const [partnerAppSecret, setPartnerAppSecret] = useState('');
const [currencySymbol, setCurrencySymbol] = useState('');
const [logoFile, setLogoFile] = useState(null);
const [selectedZone, setSelectedZone] = useState('');
const [signupBonus, setSignupBonus] = useState('');
const [referralBonus, setReferralBonus] = useState('');
const [partnerWithdrawalThreshold, setPartnerWithdrawalThreshold] = useState('');
const [twilioSID, setTwilioSID] = useState('');
const [twilioAuthToken, setTwilioAuthToken] = useState('');
const [twilioPhone, setTwilioPhone] = useState('');
const [messageServiceType, setMessageServiceType] = useState('');
const [msg91Auth, setMsg91Auth] = useState('');
const [msg91Template, setMsg91Template] = useState('');
const [twilioAccountId, setTwilioAccountId] = useState('');
const [twilioToken, setTwilioToken] = useState('');
const [twilioNumberConfig, setTwilioNumberConfig] = useState('');
const [otpVerification, setOtpVerification] = useState('');

const handleSubmitConfig = async (e) => {
  e.preventDefault();

  try {
    const data = {
      panelTitle,
      panelAlias,
      userAppKey,
      userAppSecret,
      partnerAppKey,
      partnerAppSecret,
      currencySymbol,
      selectedZone,
      signupBonus: Number(signupBonus),
      referralBonus: Number(referralBonus),
      partnerWithdrawalThreshold: Number(partnerWithdrawalThreshold),
      twilioSID,
      twilioAuthToken,
      twilioPhone,
      messageServiceType,
      msg91Auth,
      msg91Template,
      twilioAccountId,
      twilioToken,
      twilioNumberConfig,
      otpVerification,
      updatedAt: new Date().toISOString(),
    };

    // Save to Firestore
    await setDoc(doc(db, "configurations", "config"), data);

    alert("Configuration saved successfully!");

    // Clear form fields
    setPanelTitle("");
    setPanelAlias("");
    setUserAppKey("");
    setUserAppSecret("");
    setPartnerAppKey("");
    setPartnerAppSecret("");
    setCurrencySymbol("");
    setSelectedZone("");
    setSignupBonus("");
    setReferralBonus("");
    setPartnerWithdrawalThreshold("");
    setTwilioSID("");
    setTwilioAuthToken("");
    setTwilioPhone("");
    setMessageServiceType("");
    setMsg91Auth("");
    setMsg91Template("");
    setTwilioAccountId("");
    setTwilioToken("");
    setTwilioNumberConfig("");
    setOtpVerification("");
    setLogoFile(null); // if you're handling logo upload

    // Hide settings panel
    setShowSettings(false);

  } catch (error) {
    alert("Error saving configuration: " + error.message);
  }
};

const currentUserUid = auth.currentUser?.uid;
// State to store notes keyed by customerId: { id: noteDocId, text: noteText }
const [notesMap, setNotesMap] = useState({});
// Fetch notes for each customer when showCustomers, localCustomers, or currentUserUid changes
useEffect(() => {
  if (!showCustomers || !currentUserUid) return;
  const fetchNotes = async () => {
    const newNotesMap = {};
    for (const customer of localCustomers) {
      try {
        const notesRef = collection(db, "users", currentUserUid, "notes");
        const q = query(notesRef, where("customerId", "==", customer.id));
        const snapshot = await getDocs(q);
        if (!snapshot.empty) {
          const noteDoc = snapshot.docs[0];
          newNotesMap[customer.id] = {
            id: noteDoc.id,
            text: noteDoc.data().text,
          };
        } else {
          newNotesMap[customer.id] = { id: null, text: "" };
        }
      } catch (error) {
        console.error(`Error fetching notes for customer ${customer.id}:`, error);
        newNotesMap[customer.id] = { id: null, text: "" };
      }
    }
    setNotesMap(newNotesMap);
  };
  fetchNotes();
}, [showCustomers, localCustomers, currentUserUid]);

// Update note text locally on input change
const handleNoteChange = (customerId, newText) => {
  setNotesMap((prevNotes) => ({
    ...prevNotes,
    [customerId]: {
      ...prevNotes[customerId],
      text: newText,
    },
  }));
};

const handleSendNote = async (customerId, customerName, noteText) => {
  if (!customerId || !customerName?.trim() || !noteText?.trim()) {
    toast.warn("❌ Customer name and note text are required.");
    return;
  }

  try {
    // Reference to existing customer doc by ID (not name-based path)
    const customerRef = doc(db, "customers", customerId);
    const docSnap = await getDoc(customerRef);

    // Optionally ensure the customer doc exists
    if (!docSnap.exists()) {
      toast.error("Customer record does not exist in Firestore.");
      return;
    }

    // Reference to subcollection: customers/{customerId}/notes
    const notesRef = collection(customerRef, "notes");

    const newNote = {
      customerId,
      customerName: customerName.trim(),
      text: noteText.trim(),
      createdAt: serverTimestamp(),
    };

    const docRef = await addDoc(notesRef, newNote);
    console.log("✅ Note saved to:", docRef.path);

    // Update local state: clear textarea & store saved note
    setNotesMap((prev) => ({
      ...prev,
      [customerId]: {
        id: docRef.id,
        text: "",
        savedNote: noteText.trim(),
      },
    }));

    toast.success("✅ Note saved successfully!");
  } catch (error) {
    console.error("🔥 Firestore error:", error.message);
    toast.error("❌ Failed to save note.");
  }
};

useEffect(() => {
  const initializeNotes = async () => {
    const map = {};

    for (const customer of localCustomers) {
      const customerId = String(customer.id);
      const customerName = String(customer.Fullname).replace(/\s+/g, "_");

      try {
        const notesRef = collection(db, "customers", customerName, "notes");
        const notesSnapshot = await getDocs(notesRef);

        if (!notesSnapshot.empty) {
          const firstDoc = notesSnapshot.docs[0];
          map[customerId] = {
            id: firstDoc.id, // ✅ doc ID needed for delete
            text: "", // leave text input blank
            savedNote: firstDoc.data().text,
          };
        }
      } catch (error) {
        console.error("❌ Error loading notes for", customerId, error);
      }
    }

    setNotesMap(map);
  };

  if (localCustomers.length > 0) {
    initializeNotes();
  }
}, [localCustomers]);
const handleDeleteNote = async (customerId, customerName, noteId) => {
  if (!noteId || !customerId) {
    toast.error("❌ Missing customer or note ID.");
    return;
  }

  try {
    // 🔥 Correct Firestore path: customers/{customerId}/notes/{noteId}
    const noteRef = doc(db, "customers", customerId, "notes", noteId);
    await deleteDoc(noteRef); // ✅ Delete from Firestore

    // ✅ Update UI state
    setNotesMap((prev) => {
      const updated = { ...prev };
      delete updated[customerId];
      return updated;
    });

    toast.success("✅ Note deleted successfully");
  } catch (error) {
    console.error("🔥 Failed to delete note:", error.message || error);
    toast.error("❌ Failed to delete note.");
  }
};

const buttonStyle = (bgColor) => ({
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "6px 10px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  });


const [currentUserId, setCurrentUserId] = useState(null); 
const ticketActivities = [
  {
    date: "08 May",
    time: "01:39 PM",
    user: "Vaibhav Sharma",
    action: "updated the ticket",
    details: [
      "Status changed from Open to Closed",
      "Mail received from mailer-daemon",
      "Vaibhav Sharma sent an email reply",
    ],
  },
  {
    date: "30 Jan",
    time: "12:24 PM",
    user: "Vaibhav Sharma",
    action: "added a time entry",
    details: ["Time Spent 15 seconds", "Executed on 30 Jan 12:24 PM", "updated Ticket fields"],
  },
  {
    date: "30 Jan",
    time: "11:52 AM",
    user: "Vaibhav Sharma",
    action: "received a happiness rating",
    details: ["Rating Good"],
  },
  {
    date: "30 Jan",
    time: "11:29 AM",
    user: "Vaibhav Sharma",
    action: "added a time entry",
    details: ["Time Spent 1 minute 45 seconds", "Executed on 30 Jan 11:29 AM", "Time spent on chat."],
  },
  {
    date: "30 Jan",
    time: "11:26 AM",
    action: "New chat ticket Received",
    ticketDetails: {
      department: "Unlimited Gig",
      contactName: "Hello",
      email: "k@j.com",
      subject: "Hii",
      status: "Open",
      ticketOwner: "Vaibhav Sharma",
      channel: "Chat",
      layout: "Unlimited Gig",
      relationshipType: "None",
    },
  },
  {
    date: "11 Feb",
    time: "07:50 PM",
    action: "Ticket overshot its Resolution Due time",
  },
  {
    date: "11 Feb",
    time: "01:50 PM",
    action: "Service-level agreement activated",
    details: ["SLA Name Priority-based SLAs", "Due Date changed from None to 11 Feb 07:50 PM"],
  },
  {
    date: "11 Feb",
    time: "01:50 PM",
    user: "Vaibhav",
    action: "submitted a new ticket from Help Center",
    ticketDetails: {
      department: "Unlimited Gig",
      contactName: "vaibhav",
      email: "shajha@gmail.com",
      subject: "test",
      description: "test ticket",
      status: "Open",
      priority: "High",
      channel: "Web",
      layout: "Unlimited Gig",
      relationshipType: "None",
    },
  },
  {
    date: "04 Feb",
    time: "09:50 AM",
    action: "Mail received from mailer-daemon",
  },
  {
    date: "31 Jan",
    time: "10:49 AM",
    action: "Ticket was reopened on receipt of customer reply",
    details: ["Status changed from Closed to Open", "Mail received from mailer-daemon"],
  },
  {
    date: "31 Jan",
    time: "10:07 AM",
    user: "Vaibhav Sharma",
    action: "added a time entry",
    details: ["Time Spent 2 minutes 58 seconds", "Executed on 31 Jan 10:07 AM", "Time spent on chat."],
  },
  {
    date: "31 Jan",
    time: "10:05 AM",
    user: "Vaibhav Sharma",
    action: "added a time entry",
    details: ["Time Spent 1 minute 19 seconds", "Executed on 31 Jan 10:05 AM", "updated Ticket fields"],
  },
  {
    date: "31 Jan",
    time: "10:05 AM",
    user: "Vaibhav Sharma",
    action: "updated the ticket",
    details: ["Status changed from Open to Closed"],
  },
  {
    date: "31 Jan",
    time: "10:04 AM",
    user: "Vaibhav Sharma",
    action: "added a time entry",
    details: ["Time Spent 16 seconds", "Executed on 31 Jan 10:04 AM", "sent a new reply"],
  },
  {
    date: "31 Jan",
    time: "10:04 AM",
    user: "Vaibhav Sharma",
    action: "sent an email reply",
  },
  {
    date: "31 Jan",
    time: "10:03 AM",
    action: "New chat ticket Received",
    ticketDetails: {
      department: "Unlimited Gig",
      contactName: "Hello",
      email: "hello@123.com",
      subject: "Hello test",
      status: "Open",
      ticketOwner: "Vaibhav Sharma",
      channel: "Chat",
      layout: "Unlimited Gig",
      relationshipType: "None",
    },
  },
  {
    date: "31 Jan",
    time: "10:24 AM",
    user: "Vaibhav Sharma",
    action: "received a happiness rating",
    details: ["Rating Good", "Description Great service"],
  },
  {
    date: "31 Jan",
    time: "10:09 AM",
    user: "Vaibhav Sharma",
    action: "added a time entry",
    details: ["Time Spent 1 minute 42 seconds", "Executed on 31 Jan 10:09 AM", "Time spent on chat."],
  },
  {
    date: "31 Jan",
    time: "10:06 AM",
    action: "New chat ticket Received",
    ticketDetails: {
      department: "Unlimited Gig",
      contactName: "Hello",
      email: "hello@123.com",
      subject: "test new",
      status: "Open",
      ticketOwner: "Vaibhav Sharma",
      channel: "Chat",
      layout: "Unlimited Gig",
      relationshipType: "None",
    },
  },
  {
    date: "30 Jan",
    time: "11:35 PM",
    action: "Ticket overshot its Resolution Due time",
  },
  {
    date: "30 Jan",
    time: "05:35 PM",
    action: "Service-level agreement activated",
    details: ["SLA Name Priority-based SLAs", "Due Date changed from None to 30 Jan 11:35 PM"],
  },
  {
    date: "30 Jan",
    time: "05:35 PM",
    user: "sdfdsf",
    action: "submitted a new ticket from Help Center",
    ticketDetails: {
      department: "Unlimited Gig",
      contactName: "sdfdsf",
      email: "sharma.vaibhav18@gmail.com",
      subject: "erewr",
      description: "test",
      status: "Open",
      priority: "High",
      channel: "Web",
      layout: "Unlimited Gig",
      relationshipType: "None",
    },
  },
  {
    date: "30 Jan",
    time: "05:18 PM",
    action: "Ticket language was detected",
    details: ["Layout Unlimited Gig", "Language English"],
  },
  {
    date: "30 Jan",
    time: "05:18 PM",
    action: "New chat ticket Received",
    ticketDetails: {
      department: "Unlimited Gig",
      contactName: "Hello",
      email: "hello@123.com",
      subject: "hello",
      status: "Open",
      channel: "Chat",
      layout: "Unlimited Gig",
      language: "English",
      relationshipType: "None",
    },
  },
];
const [showAllTickets, setShowAllTickets] = useState(false);
const [editableEntryIndex, setEditableEntryIndex] = useState(null);
const [mutableEntryData, setMutableEntryData] = useState({});
const [visibleTicketEntries, setVisibleTicketEntries] = useState(ticketActivities || []);
// Start editing
const initiateFieldModification = (idx, activity) => {
  setEditableEntryIndex(idx);
  setMutableEntryData({ ...activity });
  toast.info("📝 Editing started", {
    position: "top-right",
    autoClose: 2000,
  });
};
  const handleFieldValueAdjust = (key, newValue) => {
    setMutableEntryData((prev) => ({ ...prev, [key]: newValue }));
  };
  // Confirm and save changes
const confirmEntryChanges = (idx) => {
  const updatedEntries = [...visibleTicketEntries];
  updatedEntries[idx] = mutableEntryData;
  setVisibleTicketEntries(updatedEntries);
  setEditableEntryIndex(null);

  toast.success("✅ Changes saved successfully", {
    position: "top-right",
    autoClose: 2000,
  });
};
// Cancel editing
const discardFieldChanges = () => {
  setEditableEntryIndex(null);
  setMutableEntryData({});
  toast.warning("❌ Changes discarded", {
    position: "top-right",
    autoClose: 2000,
  });
};
// Delete an entry
const eraseTicketEntry = (idx) => {
  const updatedEntries = [...visibleTicketEntries];
  updatedEntries.splice(idx, 1);
  setVisibleTicketEntries(updatedEntries);
  toast.error("🗑️ Ticket entry deleted", {
    position: "top-right",
    autoClose: 2000,
  });
};
const [userUID, setUserUID] = useState(null);
const [uploadedFileURL, setUploadedFileURL] = useState(null);
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserUID(user.uid);
      } else {
        setUserUID(null);
      }
    });
    return () => unsubscribe();
  }, []);
 const handleFileUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) {
    toast.error('No file selected');
    return;
  }
  try {
    const storageRef = ref(storage, `partners/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);
    uploadTask.on(
      'state_changed',
      null,
      (error) => {
        console.error('Upload failed:', error);
        toast.error('File upload failed!');
      },
      async () => {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        console.log('File available at', downloadURL);
        setUploadedFileURL(downloadURL); // ✅ this sets the file URL to show the View File button
        toast.success('File uploaded successfully!');
      }
    );
  } catch (err) {
    console.error('Unexpected upload error:', err);
    toast.error('Unexpected error during file upload.');
  }
};

const actionButtonStyle = (bgColor) => ({
  padding: "6px 10px",
  borderRadius: "6px",
  border: "none",
  backgroundColor: bgColor,
  color: "#fff",
  cursor: "pointer",
  fontSize: "13px",
  fontWeight: "600",
});

const wrapperStyle = {
  maxWidth: "1230px",
  width: "100%",
  marginLeft: "100px",
  padding: "20px",
};
const headerStyle = {
  backgroundColor: "#fff",
  padding: "20px 25px",
  borderRadius: "12px 12px 0 0",
  borderBottom: "1px solid #e0e0e0",
};
const headerTextStyle = {
  margin: 0,
  fontSize: "22px",
  fontWeight: "600",
  color: "#333",
};
const tableContainerStyle = {
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "0 0 12px 12px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
  overflowX: "auto",
};
const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  minWidth: "1100px",
};
const tableHeadRowStyle = {
  backgroundColor: "#f9fafb",
  color: "#003366",
  textAlign: "left",
};
const tableHeaderCellStyle = {
  padding: "12px 10px",
  fontSize: "14px",
  fontWeight: "600",
  borderBottom: "1px solid #e5e7eb",
};
const tableRowStyle = {
  borderBottom: "1px solid #f0f0f0",
  color: "#003366",
};
const td = { padding: "10px" };
const tdCenter = { ...td, textAlign: "center" };
const dropdownStyle = {
  padding: "6px 10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "14px",
  width: "100%",
  backgroundColor: "#fff",
};
const statusBadgeStyle = {
  backgroundColor: "#ffcccc",
  color: "#cc0000",
  padding: "4px 8px",
  borderRadius: "8px",
  fontSize: "13px",
  fontWeight: "600",
};
const textAreaStyle = {
  width: "100%",
  resize: "vertical",
  borderRadius: "6px",
  border: "1px solid #ccc",
  padding: "6px 10px",
  fontSize: "14px",
};
const noteButtonGroupStyle = {
  marginTop: "6px",
  display: "flex",
  justifyContent: "flex-end",
  gap: "8px",
};
const noteButtonStyle = (bg) => ({
  padding: "4px 12px",
  borderRadius: "6px",
  border: "none",
  backgroundColor: bg,
  color: "#fff",
  fontSize: "13px",
  fontWeight: "600",
  cursor: "pointer",
});

const actionButtonContainer = {
  display: "flex",
  flexWrap: "wrap",
  gap: "6px",
  justifyContent: "center",
};
const [availability, setAvailability] = useState({
  Monday: { open: true, slots: [{ from: 9, to: 13 }, { from: 14, to: 17 }] },
  Tuesday: { open: true, slots: [{ from: 9, to: 13 }, { from: 14, to: 17 }] },
  Wednesday: { open: true, slots: [{ from: 9, to: 13 }, { from: 14, to: 17 }] },
  Thursday: { open: true, slots: [{ from: 9, to: 13 }, { from: 14, to: 17 }] },
  Friday: { open: true, slots: [{ from: 9, to: 13 }, { from: 14, to: 17 }] },
  Saturday: { open: true, slots: [{ from: 9, to: 13 }, { from: 14, to: 17 }] }
});
const [editingSlots, setEditingSlots] = useState({});
const addTimeSlot = (day) => {
  setAvailability(prev => ({
    ...prev,
    [day]: {
      ...prev[day],
      slots: [...prev[day].slots, [9, 17]],
    }
  }));
};
const handleToggleOpen = (day) => {
  setAvailability(prev => ({
    ...prev,
    [day]: { ...prev[day], open: !prev[day].open }
  }));
};
const handleSlotChange = (day, index, value) => {
  const updatedSlots = [...availability[day].slots];
  updatedSlots[index] = value;
  setAvailability(prev => ({
    ...prev,
    [day]: {
      ...prev[day],
      slots: updatedSlots
    }
  }));
};
const applyMondayToAll = () => {
  const mondaySlots = availability["Monday"];
  const updated = {};
  for (const day in availability) {
    updated[day] = { ...mondaySlots };
  }
  setAvailability(updated);
};
const [timezone, setTimezone] = useState("Asia/Kolkata"); // Or any default timezone
const handleSaveNote = async () => {
  if (!currentUser?.uid || !selectedPartner?.username) {
    return alert("User or partner info is missing");
  }
  try {
    const noteId = `note-${Date.now()}`;
    const noteRef = doc(db, "partners", selectedPartner.username, "notes", noteId);
    await setDoc(noteRef, {
      note: noteText,
      createdAt: new Date().toISOString(),
      addedBy: currentUser.uid, // optional for tracking who added it
    });
    alert("Note saved successfully!");
    setShowNoteModal(false);
    setNoteText("");
  } catch (error) {
    console.error("Error saving note:", error);
    alert("Failed to save note.");
  }
};
const handleSendEmail = async () => {
  if (!currentUser?.uid || !selectedPartner?.username) {
    return alert("User or partner info is missing");
  }
  try {
    const emailId = `email-${Date.now()}`;
    const emailRef = doc(db, "partners", selectedPartner.username, "emails", emailId);
    await setDoc(emailRef, {
      email: emailAddress,
      sentAt: new Date().toISOString(),
      addedBy: currentUser.uid, // optional
    });
    alert("Email saved!");
    setShowEmailModal(false);
    setEmailAddress("");
  } catch (error) {
    console.error("Error sending email:", error);
    alert("Failed to send email");
  }
};
const [showNoteModal, setShowNoteModal] = useState(false);
const [showEmailModal, setShowEmailModal] = useState(false);
const [noteText, setNoteText] = useState('');
const [emailText, setEmailText] = useState('');
const [emailAddress, setEmailAddress] = useState("");
const [showSchedulerFor, setShowSchedulerFor] = useState(null);
const handleSaveAvailability = async (partnerId, scheduleType = "weekly") => {
  if (!partnerId) {
    toast.error("❌ Partner ID is missing. Cannot save availability.");
    return;
  }
  try {
    const cleanedAvailability = {};

    Object.entries(availability).forEach(([day, { open, slots }]) => {
      cleanedAvailability[day] = {
        open,
        slots: open ? slots.map(slot => ({ from: slot.from, to: slot.to })) : [],
      };
    });
    const ref = doc(db, `partners/${partnerId}/availability/${scheduleType}`);
    const dataToSave = {
      timezone,
      availability: cleanedAvailability,
      updatedAt: Timestamp.now(),
    };
    await setDoc(ref, dataToSave);
    toast.success(`✅ ${scheduleType} schedule saved successfully!`);
  } catch (error) {
    console.error("❌ Error saving availability to Firestore:", error);
    toast.error("❌ Failed to save schedule.");
  }
};

 const applyWeeklySchedule = () => {
  setViewingScheduleType("weekly");
  const updatedAvailability = {};
  Object.keys(availability).forEach(day => {
    updatedAvailability[day] = {
      open: true,
      slots: [],
      range: [9, 17], // Default time range
    };
  });

  setAvailability(updatedAvailability);
};
const applyMonthlySchedule = () => {
  setViewingScheduleType("monthly");
  const updatedAvailability = {};
  Object.keys(availability).forEach(day => {
    updatedAvailability[day] = {
      open: true,
      slots: [],
      range: [9, 17], // Default time range
    };
  });
  setAvailability(updatedAvailability);
};
const applyYearlySchedule = () => {
  setViewingScheduleType("yearly");
  const updatedAvailability = {};
  Object.keys(availability).forEach(day => {
    updatedAvailability[day] = {
      open: true,
      slots: [],
      range: [9, 17], // Default time range
    };
  });

  setAvailability(updatedAvailability);
};

const [activeSlider, setActiveSlider] = useState(null); // 'from' or 'to'
const [viewingScheduleType, setViewingScheduleType] = useState("weekly");
const handleRangeChange = (day, newRange) => {
  setAvailability(prev => ({
    ...prev,
    [day]: {
      ...prev[day],
      range: newRange,
    },
  }));
};
const updateSlotRange = (day, index, newRange) => {
  setAvailability(prev => ({
    ...prev,
    [day]: {
      ...prev[day],
      slots: prev[day].slots.map((slot, i) => i === index ? newRange : slot)
    }
  }));
};
const removeTimeSlot = (day, index) => {
  setAvailability(prev => ({
    ...prev,
    [day]: {
      ...prev[day],
      slots: prev[day].slots.filter((_, i) => i !== index)
    }
  }));
};
const [notifications, setNotifications] = useState([]);
const [selectedProviderId, setSelectedProviderId] = useState(null);
const [profiles, setProfiles] = useState(providerProfiles);
  // Handler: Select notification to load provider profile
  function handleSelectNotification(notification) {
    setSelectedProviderId(notification.providerId);
  }
  // Mark all notifications as read
  function markAllAsRead() {
    setNotifications((prev) => prev.map((n) => ({ ...n, read: true })));
  }

  // Handle provider panel notification click
  function handleNotificationClick(notif) {
    alert(`Notification clicked:\nTitle: ${notif.title || notif.type}\nMessage: ${notif.message || ""}`);
    setNotifications((prev) =>
      prev.map((n) => (n.id === notif.id ? { ...n, read: true } : n))
    );
  }
 // ✅ Mark notification as read (local only)
const markNotificationAsRead = (id) => {
  setNotifications((prev) =>
    prev.map((n) => (n.id === id ? { ...n, read: true } : n))
  );
  console.log(`Notification ${id} marked as read (UI only).`);
};

// 🔄 Mark notification as unread (local only)
const markNotificationAsUnread = (id) => {
  setNotifications((prev) =>
    prev.map((n) => (n.id === id ? { ...n, read: false } : n))
  );
  console.log(`Notification ${id} marked as unread (UI only).`);
};
 const sendNotification = (type) => {
  const bookingTypes = {
    new: {
      title: "New Booking",
      body: "A new booking has been made.",
    },
    confirmed: {
      title: "Booking Confirmed",
      body: "A booking has been confirmed.",
    },
    cancelled: {
      title: "Booking Cancelled",
      body: "A booking has been cancelled.",
    },
    amended: {
      title: "Booking Amended",
      body: "A booking has been amended.",
    },
  };

  const { title, body } = bookingTypes[type] || {};
  if (!title || !body) {
    console.error("❌ Invalid booking type:", type);
    return;
  }
  fetch("http://localhost:4000/notify/booking-event", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      type,
      title,
      body,
      provider: {
        name: formProvider.name || "Demo Provider",
        email: formProvider.email || "demo@example.com",
      },
    }),
  })
    .then((res) => {
      if (!res.ok) {
        return res.text().then((text) => {
          throw new Error(`HTTP ${res.status} - ${text}`);
        });
      }
      return res.json();
    })
    .then((data) => {
      console.log(`✅ ${type} Notification Sent:`, data);

      // ⬇️ Immediately update notification UI
      const newNotif = {
        id: data.firestoreDocId,
        title,
        body,
        type,
        provider: {
          name: formProvider.name || "Demo Provider",
          email: formProvider.email || "demo@example.com",
        },
        timestamp: new Date(),
        read: false,
      };
      setNotifications((prev) => [newNotif, ...prev]);
    })
    .catch((err) => {
      console.error("❌ Error sending notification:", err.message);
    });
};
const formatDate = (date) => {
  if (!date) return 'N/A';
  const d = new Date(date);
  return d.toLocaleString(); // You can customize this format
};
const selectedProile = selectedProviderId ? profiles[selectedProviderId] : null;
const [showNotificationCustomers, setShowNotificationCustomers] = useState(false);
const [selectedCustomerProfile, setSelectedCustomerProfile] = useState(null);
const [selectedProfile, setSelectedProfile] = useState(null);
const [selectedDocs, setSelectedDocs] = useState([]);
 const [providerList, setProviderList] = useState([]);
// 🔁 Load existing provider notifications from Firestore on mount/login
  useEffect(() => {
    const loadProviderNotifications = async () => {
      try {
        const q = query(collection(db, "notifications"), orderBy("timestamp", "desc"));
        const querySnapshot = await getDocs(q);
        const providers = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          if (data.provider) {
            providers.push(data.provider);
          }
        });
        setProviderList(providers);
        setNotifications(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      } catch (error) {
        console.error("❌ Failed to fetch provider list:", error);
        toast.error("Error loading provider list.");
      }
    };

    loadProviderNotifications();
  }, []);
  const handleAddProvider = async () => {
  const {
    providerId = '',
    name = '',
    email = '',
    phone = '',
  } = formProvider || {};

  // ✅ Validate required fields
  if (!name.trim() || !email.trim() || !phone.trim()) {
    toast.error("Please fill in all fields.");
    return;
  }
  const newProviderId = providerId || `provider-${Date.now()}`;
  const newProvider = {
    providerId: newProviderId,
    name: name.trim(),
    email: email.trim(),
    phone: phone.trim(),
    status: "Pending",
  };
  const newNotif = {
    title: "🆕 New Provider Added",
    body: "Documentation waiting for authorization",
    timestamp: new Date().toISOString(),
    read: false,
    provider: newProvider,
  };
  try {
    // ✅ Save to Firestore
    const docRef = await addDoc(collection(db, "notifications"), newNotif);
    // ✅ Update state
    const savedNotif = { id: docRef.id, ...newNotif };
    setNotifications((prev) => [savedNotif, ...prev]);
    setProviderList((prev) => [newProvider, ...prev]);
    setSelectedProfile(newProvider);
    localStorage.setItem("selectedProfile", JSON.stringify(newProvider));
    // ✅ Reset form
    setFormProvider({ providerId: "", name: "", email: "", phone: "" });
    toast.success("✅ Provider added and saved.");
  } catch (err) {
    console.error("❌ Error adding provider:", err);
    toast.error("Failed to save provider.");
  }
};
useEffect(() => {
  const unsubscribe = onSnapshot(collection(db, "notifications"), (snapshot) => {
    const filteredProviders = snapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(doc => doc.type === "new_provider_added");
    setProviderList(filteredProviders.map(p => ({
      bookingId: p.id,
      providerId: p.provider.providerId,
      name: p.provider.name,
      email: p.provider.email,
      status: p.status || "Pending",
    })));
  });
  return () => unsubscribe(); // Cleanup listener on unmount
}, []);
 const [bookingList, setBookingList] = useState([]);
  useEffect(() => {
  const fetchBookings = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "notifications"));
      const validBookings = [];

      querySnapshot.forEach((doc) => {
        const data = doc.data();

        // ✅ Validate all required fields
        const isValid =
          data.bookingId &&
          data.type &&
          data.timestamp &&
          data.provider &&
          data.provider.name &&
          data.provider.email &&
          data.provider.phone &&
          data.provider.providerId;
        if (isValid) {
          validBookings.push({ id: doc.id, ...data });
        }
      });

      setBookingList(validBookings);
    } catch (error) {
      console.error("❌ Error fetching bookings:", error);
    }
  };
  fetchBookings();
}, []);
  const handleBookingClick = async (type) => {
    const bookingId = `BOOK-${Date.now()}`;
    const timestamp = Date.now();
    const bookingData = {
      bookingId,
      type,
      title: "Booking Event",
      timestamp,
      read: false,
      provider: {
        name: formProvider.name,
        email: formProvider.email,
        phone: formProvider.phone,
        providerId: formProvider.providerId,
      },
    };
    try {
      const docRef = await addDoc(collection(db, "notifications"), bookingData);
      console.log(`📩 ${type} Notification Sent`, docRef.id);
      // Update UI list
      setBookingList((prevList) => [
        ...prevList,
        { ...bookingData, id: docRef.id },
      ]);
    } catch (err) {
      console.error("❌ Error:", err);
    }
  };
  const fetchProviders = async () => {
  try {
    const snapshot = await getDocs(collection(db, "notifications"));
    const providerData = snapshot.docs.map((doc) => ({
      ...doc.data(),
      docId: doc.id, // ✅ add docId to each provider
    }));
    setProviderList(providerData); // assuming you use state like this
  } catch (error) {
    console.error("Failed to fetch providers:", error);
  }
};
const markAllCustomerNotificationsRead = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "Notification_Customers"));
    const updatePromises = querySnapshot.docs.map((docSnap) => {
      const notifRef = doc(db, "Notification_Customers", docSnap.id);
      return updateDoc(notifRef, { read: true });
    });
    await Promise.all(updatePromises);
    console.log("✅ All customer notifications marked as read");
  } catch (error) {
    console.error("❌ Error marking notifications as read:", error);
  }
};
const handleMainCategoryClick = () => {
    setMainCategoryOpen(prevState => !prevState);
}
const [showTechnicalDetails, setShowTechnicalDetails] = useState(false);//Service Approvals//
const [isCustomerListUnlocked, setIsCustomerListUnlocked] = useState(false);
const [showCustPasswordModal, setShowCustPasswordModal] = useState(false);
const humanizeLabel = (value) => {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  return String(value)
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};
// Fires the inspect handler + an optional audit-log callback together.
const handleInspectRecord = (record) => {
  if (!record) return;
  onCommitServiceInspection(record);
  if (typeof onLogAccess === "function") {
    onLogAccess({
      recordId: record.service_id || record.id,
      accessedBy: currentUserName || "Unknown user",
      accessedAt: new Date().toISOString(),
      action: "viewed",
    });
  }
};//Service Approvals
const [serviceActionConfirmModal, setServiceActionConfirmModal] = useState(false);
const [isServiceUpdating, setIsServiceUpdating] = useState(false);//providers list//
const [dashboardSize, setDashboardSize] = React.useState(100); // 25, 50, 75, 100
const [statusModalFilter, setStatusModalFilter] = React.useState(null); // 'total' | 'new' | 'pending' | 'approved' | 'rejected' | null//Dashboard for Services approval//
const [isDashboardCollapsed, setIsDashboardCollapsed] = React.useState(false);
const [isListRevealed, setIsListRevealed] = useState(false);
const [syncingApproval, setSyncingApproval] = useState(false);//Verification Documents//
const [verificationApprovalRegistry, setVerificationApprovalRegistry] = useState(() => {
  try {
    const saved = localStorage.getItem("verificationApprovalRegistry");
    return saved ? JSON.parse(saved) : {};
  } catch (e) {
    console.error("Failed to load verificationApprovalRegistry from localStorage:", e);
    return {};
  }
});//Verification Documents//
const [providerNotesRegistry, setProviderNotesRegistry] = useState({});
const [providerSearchField, setProviderSearchField] = useState("");
const [isListPasswordModalOpen, setIsListPasswordModalOpen] = useState(false);
const [listPasswordInput, setListPasswordInput] = useState("");
const [listPasswordError, setListPasswordError] = useState("");
const [inspectedNotesProvider, setInspectedNotesProvider] = useState(null);
const [isAuditLogsModalOpen, setIsAuditLogsModalOpen] = useState(false);
const [adminAuditLogs, setAdminAuditLogs] = useState([]);
// Central audit log: array of { id, action, actionLabel, providerId, providerName,
// reason, justificationNote, accessedByUid, accessedByEmail, timestamp, timestampDisplay }
const [accessAuditLog, setAccessAuditLog] = useState(() => {
  // Optional: rehydrate from localStorage cache on load
  try {
    const cached = localStorage.getItem("provider_access_audit_log");
    return cached ? JSON.parse(cached) : [];
  } catch (e) {
    return [];
  }
});
// Toggles the central "Audit Logs" modal panel
   const [showAuditLogsPanel, setShowAuditLogsPanel] = useState(false);//Providerlist//
   const [customerSearchQuery, setCustomerSearchQuery] = useState("");
   const [inspectedKycProvider, setInspectedKycProvider] = useState(null);
   const [kycFetchStatus, setKycFetchStatus] = useState("idle");
   const [kycRegistry, setKycRegistry] = useState({});
   // --- Security Gate (reason + PIN), scoped to the Customer List ---
   const [customerShieldPhase, setCustomerShieldPhase] = useState(null); // null | "prompt_reason" | "prompt_passcode"
   const [customerShieldTargetEntity, setCustomerShieldTargetEntity] = useState(null);
   const [customerShieldIntentScope, setCustomerShieldIntentScope] = useState(""); // "profile_view" | "transactions" | "promotions" | "wallet" | "transaction_pii"
   const [customerShieldAccessReason, setCustomerShieldAccessReason] = useState("");
   const [customerShieldJustificationNote, setCustomerShieldJustificationNote] = useState("");
   const [customerShieldPasscodeSecret, setCustomerShieldPasscodeSecret] = useState("");
   const [customerShieldValidationAlert, setCustomerShieldValidationAlert] = useState("");
   const [customerShieldPendingAction, setCustomerShieldPendingAction] = useState(null);
   const [unlockedCustomerPII, setUnlockedCustomerPII] = useState({}); // { "<key>_<scope>": true }
   // --- Audit Trail ---
   const [customerAuditLog, setCustomerAuditLog] = useState([]);
   // --- Role & tiered credit workflow ---
   const [currentStaffRole, setCurrentStaffRole] = useState("support"); // "support" | "senior" | "manager"
   const [creditRequestQueue, setCreditRequestQueue] = useState([]);
   const [creditRequestDraft, setCreditRequestDraft] = useState({});
   const [topUpReasonDraft, setTopUpReasonDraft] = useState("");
   const [topUpRelatedBookingAmount, setTopUpRelatedBookingAmount] = useState("");//Customer List//
// Add these with your other useState declarations
const [showServicePasswordModal, setShowServicePasswordModal] = useState(false);
const [servicePassword, setServicePassword] = useState("");
const [servicePasswordError, setServicePasswordError] = useState("");///Service Approval Button Section//
// 1. State for modal and toast
const [confirmationModal, setConfirmationModal] = useState({
  isOpen: false,
  type: "", // 'approve_service' | 'reject_service' | 'approve_provider' | 'reject_provider'
  target: null,
  reason: "",
});
const [toastNotification, setToastNotification] = useState(null);
const triggerToast = (message, type = "success") => {
  setToastNotification({ message, type });
  setTimeout(() => setToastNotification(null), 4000);
};
// 2. Execution Handler for approving/rejecting services and providers
const handleExecuteModalDecision = async () => {
  const { type, target, reason } = confirmationModal;
  if (!target) return;
  try {
    if (type === "approve_service") {
      const serviceId = target.service_id || target.id;
      const payload = {
        approval_status: "approved",
        status: "active",
        is_approved: true,
        is_active: true,
        reviewed_by: currentUser?.email || "Admin",
        reviewed_at: new Date().toISOString(),
      };
      // Persistent sync to admin_pending_approvals/services/pending/{serviceId}
      const pendingDocRef = doc(db, "admin_pending_approvals", "services", "pending", serviceId);
      await updateDoc(pendingDocRef, payload);
      // Sync active state to public services collection
      const publicDocRef = doc(db, "services", serviceId);
      await setDoc(publicDocRef, payload, { merge: true });
      triggerToast(`Service "${target.service_name || serviceId}" approved & active.`);
      onRetryQueueSync && onRetryQueueSync();
    } else if (type === "reject_service") {
      const serviceId = target.service_id || target.id;
      const payload = {
        approval_status: "rejected",
        status: "rejected",
        is_approved: false,
        is_active: false,
        rejection_reason: reason || "Does not meet platform guidelines.",
        reviewed_by: currentUser?.email || "Admin",
        reviewed_at: new Date().toISOString(),
      };
      const pendingDocRef = doc(db, "admin_pending_approvals", "services", "pending", serviceId);
      await updateDoc(pendingDocRef, payload);
      const publicDocRef = doc(db, "services", serviceId);
      await setDoc(publicDocRef, payload, { merge: true });
      triggerToast(`Service rejected: ${payload.rejection_reason}`, "error");
      onRetryQueueSync && onRetryQueueSync();
    } else if (type === "approve_provider") {
      await updateProviderVerificationStatus("approved", target?.name, notes);
      triggerToast("Provider application successfully approved.");
    } else if (type === "reject_provider") {
      await updateProviderVerificationStatus("rejected", target?.name, reason || notes);
      triggerToast("Provider application rejected.", "error");
    }
  } catch (err) {
    console.error("Operation failed:", err);
    triggerToast("Action failed: " + (err.message || "Unknown error"), "error");
  } finally {
    setConfirmationModal({ isOpen: false, type: "", target: null, reason: "" });
  }
};//service approval//
// ============================================================
  // COMPONENT STATE REGISTRY
  // ============================================================
  const [submissionQueue, setSubmissionQueue] = useState([]);
  const [isSynchronizing, setIsSynchronizing] = useState(true);
  const [syncFaultMessage, setSyncFaultMessage] = useState("");
  const [filterQueryToken, setFilterQueryToken] = useState("");
  // Inspection Dossier Modal State
  const [inspectedServiceDossier, setInspectedServiceDossier] = useState(null);
  const [isDossierActive, setIsDossierActive] = useState(false);
  // Media Lightbox State
  const [previewMediaTargetUrl, setPreviewMediaTargetUrl] = useState(null);
  // ============================================================
  // FIRESTORE REFERENCE
  // ============================================================
  const pendingApprovalsCollectionRef = collection(
    db,
    "admin_pending_approvals",
    "services",
    "pending"
  );
  // ============================================================
  // SYNCHRONIZATION DISPATCHER
  // ============================================================
  const synchronizeApprovalQueue = async () => {
    setIsSynchronizing(true);
    setSyncFaultMessage("");
    try {
      let querySnapshot;
      try {
        const prioritizedQuery = query(
          pendingApprovalsCollectionRef,
          orderBy("submitted_at", "desc")
        );
        querySnapshot = await getDocs(prioritizedQuery);
      } catch (orderingError) {
        console.warn(
          "Descending query order unindexed. Falling back to unconstrained scan.",
          orderingError
        );
        querySnapshot = await getDocs(pendingApprovalsCollectionRef);
      }
      const normalizedRecords = querySnapshot.docs.map((documentSnapshot) => ({
        id: documentSnapshot.id,
        ...documentSnapshot.data(),
      }));
      setSubmissionQueue(normalizedRecords);
    } catch (fault) {
      console.error("Firestore synchronizer failure:", fault);
      setSyncFaultMessage(
        fault?.message || "Failed to synchronize remote pending approvals."
      );
    } finally {
      setIsSynchronizing(false);
    }
  };
  useEffect(() => {
    synchronizeApprovalQueue();
  }, []);
  // ============================================================
  // EVENT HANDLERS & DISPATCHERS
  // ============================================================
  const onFilterQueryChange = (event) => {
    setFilterQueryToken(event.target.value);
  };
  const onCommitServiceInspection = (serviceRecord) => {
    setInspectedServiceDossier(serviceRecord);
    setIsDossierActive(true);
  };
  const onDismissServiceInspection = () => {
    setInspectedServiceDossier(null);
    setIsDossierActive(false);
  };
  const onActivateMediaPreview = (mediaResourceUrl) => {
    if (mediaResourceUrl) {
      setPreviewMediaTargetUrl(mediaResourceUrl);
    }
  };
  const onDismissMediaPreview = () => {
    setPreviewMediaTargetUrl(null);
  };
  const onRetryQueueSync = () => {
    synchronizeApprovalQueue();
  };
  // ============================================================
  // SAFE SANITIZATION AND FORMATTING UTILITY
  // ============================================================
  const sanitizeDisplayToken = (targetValue) => {
    if (targetValue === null || targetValue === undefined || targetValue === "") {
      return "—";
    }
    if (targetValue?.toDate && typeof targetValue.toDate === "function") {
      return targetValue.toDate().toLocaleString();
    }
    if (targetValue?.seconds) {
      return new Date(targetValue.seconds * 1000).toLocaleString();
    }
    if (Array.isArray(targetValue)) {
      if (targetValue.length === 0) return "—";
      return targetValue
        .map((element) => {
          if (typeof element === "object" && element !== null) {
            if (element.name && element.quantity !== undefined) {
              return `${element.name} (x${element.quantity})`;
            }
            if (element.name) return element.name;
            if (element.url) return element.url;
            return JSON.stringify(element);
          }
          return String(element);
        })
        .join(", ");
    }
    if (typeof targetValue === "object") {
      return JSON.stringify(targetValue, null, 2);
    }
    if (typeof targetValue === "boolean") {
      return targetValue ? "Yes" : "No";
    }
    return String(targetValue);
  };
  // ============================================================
  // DERIVED METRICS & FILTERED RECORDSETS
  // ============================================================
  const filteredSubmissions = useMemo(() => {
    const sanitizedSearch = filterQueryToken.trim().toLowerCase();
    if (!sanitizedSearch) return submissionQueue;
    return submissionQueue.filter((record) => {
      const consolidatedSearchPayload = [
        record.service_name,
        record.service_id,
        record.category,
        record.category_type,
        record.sub_category,
        record.provider_name,
        record.provider_email,
        record.provider_id,
        record.approval_status,
        record.status,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return consolidatedSearchPayload.includes(sanitizedSearch);
    });
  }, [submissionQueue, filterQueryToken]);
  const aggregateMetrics = useMemo(() => {
    const totalSubmissions = submissionQueue.length;
    const pendingReview = submissionQueue.filter(
      (item) =>
        String(item.approval_status || item.status || "").toLowerCase() === "pending"
    ).length;
    const approvedSubmissions = submissionQueue.filter(
      (item) => String(item.approval_status || "").toLowerCase() === "approved"
    ).length;
    const rejectedSubmissions = submissionQueue.filter(
      (item) => String(item.approval_status || "").toLowerCase() === "rejected"
    ).length;
    return { totalSubmissions, pendingReview, approvedSubmissions, rejectedSubmissions };
  }, [submissionQueue]);
  // ============================================================
  // BADGE VARIANT RESOLUTION
  // ============================================================
  const resolveStatusBadgeVariant = (statusDescriptor) => {
    const normalizedKey = String(statusDescriptor || "pending").toLowerCase();
    if (normalizedKey === "approved") return styles.statusBadgeVerified;
    if (normalizedKey === "rejected") return styles.statusBadgeDismissed;
    return styles.statusBadgePending;
  };
  // ============================================================
  // SUB-COMPONENT: ATTRIBUTE FIELD DISPLAY
  // ============================================================
  const AttributeFieldBlock = ({ label, value, spansFullWidth = false }) => (
    <div
      style={{
        ...styles.attributeFieldPanel,
        gridColumn: spansFullWidth ? "1 / -1" : "auto",
      }}
    >
      <span style={styles.attributeDescriptorTag}>{label}</span>
      <span style={styles.attributeValueDisplay}>{sanitizeDisplayToken(value)}</span>
    </div>
  );
// ============================================================
// STYLES DESIGN TOKENS
// ============================================================
const styles = {
  viewportCanvas: {
    minHeight: "100vh",
    padding: "32px",
    background: "#f4f6fb",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    color: "#0f172a",
  },
  activityIndicatorOverlay: {
    minHeight: "65vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#64748b",
  },
  loadingActivitySpinner: {
    width: "40px",
    height: "40px",
    border: "4px solid #e2e8f0",
    borderTop: "4px solid #0284c7",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
    marginBottom: "14px",
  },
  faultNotificationBanner: {
    maxWidth: "580px",
    margin: "80px auto",
    padding: "26px",
    background: "#ffffff",
    borderRadius: "12px",
    border: "1px solid #fecaca",
    textAlign: "center",
    boxShadow: "0 10px 25px -5px rgba(0,0,0,0.05)",
  },
  actionMasthead: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "28px",
  },
  mastheadHeading: {
    margin: 0,
    fontSize: "26px",
    fontWeight: "700",
    letterSpacing: "-0.02em",
  },
  mastheadDescription: {
    margin: "6px 0 0",
    color: "#64748b",
    fontSize: "14px",
  },
  actionTriggerPrimary: {
    padding: "10px 20px",
    background: "#0284c7",
    color: "#ffffff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "14px",
  },
  metricDashboardGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
    marginBottom: "24px",
  },
  metricIndicatorTile: {
    background: "#ffffff",
    padding: "18px 20px",
    borderRadius: "12px",
    border: "1px solid #e2e8f0",
  },
  metricCaptionLabel: {
    display: "block",
    color: "#64748b",
    fontSize: "13px",
    fontWeight: "500",
    marginBottom: "6px",
  },
  metricDataMagnitude: {
    fontSize: "26px",
    fontWeight: "700",
  },
  filterCommandToolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    marginBottom: "20px",
  },
  searchQueryTextField: {
    width: "100%",
    maxWidth: "500px",
    padding: "12px 18px",
    border: "1px solid #cbd5e1",
    borderRadius: "8px",
    outline: "none",
    fontSize: "14px",
    background: "#ffffff",
  },
  aggregateCountIndicator: {
    color: "#64748b",
    fontSize: "14px",
  },
  zeroStatePresenter: {
    padding: "80px 20px",
    textAlign: "center",
    background: "#ffffff",
    borderRadius: "12px",
    border: "1px solid #e2e8f0",
    color: "#64748b",
  },
  tabularDataCanvas: {
    background: "#ffffff",
    borderRadius: "12px",
    border: "1px solid #e2e8f0",
    overflowX: "auto",
    boxShadow: "0 1px 3px rgba(0,0,0,0.02)",
  },
  tabularGridElement: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "1000px",
  },
  tabularHeaderCell: {
    padding: "14px 18px",
    textAlign: "left",
    background: "#f8fafc",
    borderBottom: "1px solid #e2e8f0",
    fontSize: "12px",
    fontWeight: "700",
    color: "#475569",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
  },
  tabularDataRow: {
    borderBottom: "1px solid #f1f5f9",
  },
  tabularDataCell: {
    padding: "14px 18px",
    fontSize: "14px",
    verticalAlign: "middle",
  },
  primaryTextToken: {
    fontWeight: "600",
  },
  subduedTextToken: {
    color: "#94a3b8",
    fontSize: "12px",
  },
  secondaryTriggerButton: {
    padding: "7px 15px",
    background: "#0f172a",
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "600",
  },
  statusBadgePending: {
    display: "inline-block",
    padding: "4px 10px",
    borderRadius: "20px",
    background: "#fef3c7",
    color: "#92400e",
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "capitalize",
  },
  statusBadgeVerified: {
    display: "inline-block",
    padding: "4px 10px",
    borderRadius: "20px",
    background: "#dcfce7",
    color: "#166534",
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "capitalize",
  },
  statusBadgeDismissed: {
    display: "inline-block",
    padding: "4px 10px",
    borderRadius: "20px",
    background: "#fee2e2",
    color: "#991b1b",
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "capitalize",
  },
  dossierBackdropSurface: {
    position: "fixed",
    inset: 0,
    background: "rgba(15, 23, 42, 0.65)",
    backdropFilter: "blur(4px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
    zIndex: 999,
  },
  dossierModalShell: {
    width: "100%",
    maxWidth: "1050px",
    maxHeight: "90vh",
    background: "#ffffff",
    borderRadius: "16px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
  },
  dossierSectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px 28px",
    borderBottom: "1px solid #e2e8f0",
  },
  dossierPrimaryTitle: {
    margin: 0,
    fontSize: "20px",
    fontWeight: "700",
  },
  dossierContextSubtitle: {
    margin: "4px 0 0",
    fontSize: "13px",
    color: "#64748b",
  },
  circularDismissAction: {
    width: "36px",
    height: "36px",
    border: "none",
    borderRadius: "50%",
    background: "#f1f5f9",
    fontSize: "22px",
    cursor: "pointer",
    lineHeight: "1",
  },
  dossierScrollableContent: {
    overflowY: "auto",
    padding: "24px 28px",
  },
  sectionHeaderSeparator: {
    fontSize: "13px",
    fontWeight: "700",
    color: "#0284c7",
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    marginTop: "20px",
    marginBottom: "12px",
    borderBottom: "1px solid #e2e8f0",
    paddingBottom: "6px",
  },
  attributeMatrixGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "12px",
  },
  attributeFieldPanel: {
    background: "#f8fafc",
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
    display: "flex",
    flexDirection: "column",
  },
  attributeDescriptorTag: {
    fontSize: "11px",
    fontWeight: "700",
    color: "#64748b",
    textTransform: "uppercase",
    marginBottom: "4px",
  },
  attributeValueDisplay: {
    fontSize: "13px",
    color: "#0f172a",
    wordBreak: "break-word",
  },
  tokenClusterWrapper: {
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
    marginTop: "4px",
  },
  metadataTagBadge: {
    background: "#e0f2fe",
    color: "#0369a1",
    fontSize: "12px",
    padding: "3px 10px",
    borderRadius: "14px",
    fontWeight: "500",
  },
  mediaAssetGrid: {
    display: "flex",
    gap: "12px",
    flexWrap: "wrap",
    marginTop: "8px",
  },
  mediaThumbnailFrame: {
    position: "relative",
    width: "110px",
    height: "110px",
    borderRadius: "8px",
    overflow: "hidden",
    border: "1px solid #cbd5e1",
    cursor: "pointer",
    background: "#000",
  },
  mediaElementBitmap: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
  mediaHoverInteractionLayer: {
    position: "absolute",
    inset: 0,
    background: "rgba(0, 0, 0, 0.45)",
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: "600",
  },
  unstructuredMediaDisplay: {
    padding: "6px",
    fontSize: "10px",
    color: "#ffffff",
  },
  dossierActionDock: {
    padding: "16px 28px",
    borderTop: "1px solid #e2e8f0",
    display: "flex",
    justifyContent: "flex-end",
  },
  neutralDismissTrigger: {
    padding: "9px 22px",
    background: "#0f172a",
    color: "#ffffff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "14px",
  },
  lightboxPortalBackdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0, 0, 0, 0.88)",
    backdropFilter: "blur(6px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10000,
    padding: "20px",
  },
  lightboxViewportFrame: {
    position: "relative",
    maxWidth: "90vw",
    maxHeight: "90vh",
  },
  lightboxExitTrigger: {
    position: "absolute",
    top: "-45px",
    right: "-10px",
    background: "transparent",
    border: "none",
    color: "#ffffff",
    fontSize: "36px",
    cursor: "pointer",
  },
  lightboxMediaRenderer: {
    maxWidth: "100%",
    maxHeight: "85vh",
    borderRadius: "8px",
    display: "block",
    boxShadow: "0 25px 50px -12px rgba(0,0,0,0.6)",
  },
};
//Service Approvals//
const [providerSearchQuery, setProviderSearchQuery] = useState("");
const [shieldAccessReason, setShieldAccessReason] = useState("");
const [unlockedTransactionPII, setUnlockedTransactionPII] = useState([]);
/* ================= 1. SAFE CHRONOLOGY FORMATTER ================= */
const stringifyFirestoreTemporal = (temporalVal) => {
  if (!temporalVal) return "—";
  if (typeof temporalVal === "object") {
    if (typeof temporalVal.toDate === "function") return temporalVal.toDate().toLocaleString();
    if (temporalVal.seconds) return new Date(temporalVal.seconds * 1000).toLocaleString();
    return JSON.stringify(temporalVal);
  }
  return String(temporalVal);
};
/* ================= 2. SECURE ACCESS PROTOCOL (SHIELD GATE) ================= */
const [shieldProtocolPhase, setShieldProtocolPhase] = useState(null); // null | "prompt_reason" | "prompt_passcode"
const [shieldTargetEntity, setShieldTargetEntity] = useState(null); // Selected provider row record
const [shieldIntentScope, setShieldIntentScope] = useState(null); // "profile_view" | "catalog_approval" | "ledger_bookings"
const [shieldJustificationNote, setShieldJustificationNote] = useState("");
const [shieldPasscodeSecret, setShieldPasscodeSecret] = useState("");
const [shieldValidationAlert, setShieldValidationAlert] = useState("");
const SHIELD_SECURITY_PIN = "8972";
/* ================= 3. ACTIVE MODAL DIALOG CONTROLLERS ================= */
const [inspectedCatalogProvider, setInspectedCatalogProvider] = useState(null); // Services modal target
const [inspectedLedgerProvider, setInspectedLedgerProvider] = useState(null); // Bookings modal target
/* ================= 4. DATA REGISTRIES & NETWORK STATUS ================= */
const [providerCatalogRegistry, setProviderCatalogRegistry] = useState({}); // { [providerUid]: Array<ServiceItem> }
const [providerLedgerRegistry, setProviderLedgerRegistry] = useState({}); // { [providerUid]: Array<BookingItem> }
const [subcollectionFetchStatus, setSubcollectionFetchStatus] = useState({}); // { [cacheKey]: boolean }
/* ================= 5. TELEMETRY & AUDIT TRAIL DISPATCHER ================= */
const dispatchShieldAuditTelemetry = (entityRecord, scopeKey, justification, resolution) => {
  try {
    const auditRecord = {
      timestamp: new Date().toISOString(),
      actionScope: scopeKey || "profile_view",
      targetEntityId: entityRecord?.id || entityRecord?.uid || "unknown",
      targetEntityName: entityRecord?.name || entityRecord?.displayName || "unknown",
      operatorUid: currentUser?.uid || "unknown",
      justification,
      resolution, // "granted" | "denied" | "dismissed"
    };
    const historicLogs = JSON.parse(localStorage.getItem("provider_view_audit_log") || "[]");
    historicLogs.push(auditRecord);
    localStorage.setItem("provider_view_audit_log", JSON.stringify(historicLogs));
  } catch (err) {
    console.warn("Shield telemetry audit warning:", err);
  }
};
/* ================= 6. SHIELD PROTOCOL ROUTING & GATING ================= */
const initiateShieldProtocol = (entityRecord, scopeKey) => {
  setShieldTargetEntity(entityRecord);
  setShieldIntentScope(scopeKey);
  setShieldJustificationNote("");
  setShieldPasscodeSecret("");
  setShieldValidationAlert("");
  setShieldProtocolPhase("prompt_reason");
};
const advanceShieldToPinValidation = () => {
  if (!shieldJustificationNote.trim()) {
    setShieldValidationAlert("Please articulate a business justification before advancing.");
    return;
  }
  setShieldValidationAlert("");
  setShieldProtocolPhase("prompt_passcode");
};
const terminateShieldProtocol = () => {
  setShieldProtocolPhase(null);
  setShieldTargetEntity(null);
  setShieldIntentScope(null);
  setShieldJustificationNote("");
  setShieldPasscodeSecret("");
  setShieldValidationAlert("");
};
/* ================= 7. SUBCOLLECTION INGESTION HANDLERS ================= */
/**
 * Ingests and aggregates service documentation from `favorites` AND `Notification` subcollections
 */
const syncProviderCatalogAndAlerts = async (providerUid) => {
  if (!providerUid) return [];
  if (providerCatalogRegistry[providerUid]) return providerCatalogRegistry[providerUid];
  setSubcollectionFetchStatus((prev) => ({ ...prev, [`${providerUid}_catalog`]: true }));
  try {
    const aggregateIndex = new Map();
    if (typeof db !== "undefined" && typeof collection === "function" && typeof getDocs === "function") {
      // Branch A: Query `favorites` subcollection
      try {
        const favSnap = await getDocs(collection(db, "users", providerUid, "favorites"));
        favSnap.docs.forEach((docRef) => {
          const raw = docRef.data() || {};
          const serviceKey = raw.service_id || raw.serviceId || docRef.id;
          aggregateIndex.set(serviceKey, {
            id: docRef.id || raw.id || serviceKey,
            service_id: serviceKey,
            service_name: raw.service_name ?? raw.serviceName ?? raw.title ?? "Untitled Service",
            address: raw.address ?? "",
            approval_status: raw.approval_status ?? raw.approvalStatus ?? "pending",
            category: raw.category ?? "",
            category_type: raw.category_type ?? raw.categoryType ?? "",
            created_at: raw.created_at ?? raw.createdAt ?? null,
            description: raw.description ?? "",
            discount: Number(raw.discount ?? 0),
            discount_amount: Number(raw.discount_amount ?? raw.discountAmount ?? 0),
            discounted_price: Number(raw.discounted_price ?? raw.final_price ?? raw.finalPrice ?? 0),
            duration_hour: Number(raw.duration_hour ?? raw.durationHour ?? 0),
            duration_mins: Number(raw.duration_mins ?? raw.durationMins ?? 0),
            edited_by_provider: Boolean(raw.edited_by_provider ?? raw.editedByProvider),
            final_price: Number(raw.final_price ?? raw.finalPrice ?? raw.discounted_price ?? 0),
            gallery_images: Array.isArray(raw.gallery_images) ? raw.gallery_images : [],
            gallery_media: Array.isArray(raw.gallery_media) ? raw.gallery_media : [],
            has_videos: Boolean(raw.has_videos ?? raw.hasVideos),
            image: raw.image ?? "",
            is_active: Boolean(raw.is_active ?? raw.isActive),
            is_approved: Boolean(raw.is_approved ?? raw.isApproved),
            latitude: Number(raw.latitude ?? 0),
            longitude: Number(raw.longitude ?? 0),
            media: Array.isArray(raw.media) ? raw.media : [],
            original_price: Number(raw.original_price ?? raw.price ?? 0),
            price: Number(raw.price ?? 0),
            provider_id: raw.provider_id ?? raw.providerId ?? providerUid,
            providerId: raw.providerId ?? raw.provider_id ?? providerUid,
            rejection_reason: raw.rejection_reason ?? raw.rejectionReason ?? null,
            reviewed_at: raw.reviewed_at ?? raw.reviewedAt ?? null,
            reviewed_by: raw.reviewed_by ?? raw.reviewedBy ?? "",
            search_keywords: Array.isArray(raw.search_keywords) ? raw.search_keywords : [],
            set_as_feature: Boolean(raw.set_as_feature ?? raw.setAsFeature),
            status: raw.status ?? "inactive",
            storage_img_name: raw.storage_img_name ?? "",
            sub_category: raw.sub_category ?? raw.subCategory ?? "",
            submitted_for_review_at: raw.submitted_for_review_at ?? raw.submittedForReviewAt ?? null,
            suggest_category: raw.suggest_category ?? raw.suggestCategory ?? "",
            timestamp: raw.timestamp ?? null,
            tools: Array.isArray(raw.tools) ? raw.tools : [],
            total_media_count: Number(raw.total_media_count ?? (raw.gallery_images?.length || 0)),
            updated_at: raw.updated_at ?? raw.updatedAt ?? null,
            version: Number(raw.version ?? 1),
            _discoveredSubcollection: "favorites",
          });
        });
      } catch (favErr) {
        console.warn("Favorites subcollection read warning:", favErr);
      }
      // Branch B: Query `Notification` subcollection
      try {
        const notifSnap = await getDocs(collection(db, "users", providerUid, "Notification"));
        notifSnap.docs.forEach((docRef) => {
          const raw = docRef.data() || {};
          const serviceKey = raw.service_id || raw.serviceId || docRef.id;
          const preExisting = aggregateIndex.get(serviceKey) || {};
          aggregateIndex.set(serviceKey, {
            ...preExisting,
            id: docRef.id || raw.id || serviceKey,
            service_id: serviceKey,
            service_name: raw.service_name ?? raw.serviceName ?? preExisting.service_name ?? "Untitled Service",
            address: raw.address ?? preExisting.address ?? "",
            approval_status: raw.approval_status ?? raw.approvalStatus ?? preExisting.approval_status ?? "pending",
            category: raw.category ?? preExisting.category ?? "",
            category_type: raw.category_type ?? raw.categoryType ?? preExisting.category_type ?? "",
            created_at: raw.created_at ?? raw.createdAt ?? preExisting.created_at ?? null,
            description: raw.description ?? preExisting.description ?? "",
            discount: Number(raw.discount ?? preExisting.discount ?? 0),
            discount_amount: Number(raw.discount_amount ?? raw.discountAmount ?? preExisting.discount_amount ?? 0),
            discounted_price: Number(raw.discounted_price ?? raw.final_price ?? preExisting.discounted_price ?? 0),
            duration_hour: Number(raw.duration_hour ?? raw.durationHour ?? preExisting.duration_hour ?? 0),
            duration_mins: Number(raw.duration_mins ?? raw.durationMins ?? preExisting.duration_mins ?? 0),
            edited_by_provider: Boolean(raw.edited_by_provider ?? raw.editedByProvider ?? preExisting.edited_by_provider),
            gallery_images: Array.isArray(raw.gallery_images) ? raw.gallery_images : preExisting.gallery_images || [],
            gallery_media: Array.isArray(raw.gallery_media) ? raw.gallery_media : preExisting.gallery_media || [],
            has_videos: Boolean(raw.has_videos ?? raw.hasVideos ?? preExisting.has_videos),
            image: raw.image ?? preExisting.image ?? "",
            is_active: Boolean(raw.is_active ?? raw.isActive ?? preExisting.is_active),
            is_approved: Boolean(raw.is_approved ?? raw.isApproved ?? preExisting.is_approved),
            latitude: Number(raw.latitude ?? preExisting.latitude ?? 0),
            longitude: Number(raw.longitude ?? preExisting.longitude ?? 0),
            media: Array.isArray(raw.media) ? raw.media : preExisting.media || [],
            original_price: Number(raw.original_price ?? raw.price ?? preExisting.original_price ?? 0),
            price: Number(raw.price ?? preExisting.price ?? 0),
            final_price: Number(raw.final_price ?? raw.finalPrice ?? raw.discounted_price ?? preExisting.final_price ?? 0),
            provider_id: raw.provider_id ?? raw.providerId ?? preExisting.provider_id ?? providerUid,
            providerId: raw.providerId ?? raw.provider_id ?? preExisting.providerId ?? providerUid,
            rejection_reason: raw.rejection_reason ?? raw.rejectionReason ?? preExisting.rejection_reason ?? null,
            reviewed_at: raw.reviewed_at ?? raw.reviewedAt ?? preExisting.reviewed_at ?? null,
            reviewed_by: raw.reviewed_by ?? raw.reviewedBy ?? preExisting.reviewed_by ?? "",
            search_keywords: Array.isArray(raw.search_keywords) ? raw.search_keywords : preExisting.search_keywords || [],
            set_as_feature: Boolean(raw.set_as_feature ?? raw.setAsFeature ?? preExisting.set_as_feature),
            status: raw.status ?? preExisting.status ?? "inactive",
            storage_img_name: raw.storage_img_name ?? preExisting.storage_img_name ?? "",
            sub_category: raw.sub_category ?? raw.subCategory ?? preExisting.sub_category ?? "",
            submitted_for_review_at: raw.submitted_for_review_at ?? raw.submittedForReviewAt ?? preExisting.submitted_for_review_at ?? null,
            suggest_category: raw.suggest_category ?? raw.suggestCategory ?? preExisting.suggest_category ?? "",
            timestamp: raw.timestamp ?? preExisting.timestamp ?? null,
            tools: Array.isArray(raw.tools) ? raw.tools : preExisting.tools || [],
            total_media_count: Number(raw.total_media_count ?? preExisting.total_media_count ?? 0),
            updated_at: raw.updated_at ?? raw.updatedAt ?? preExisting.updated_at ?? null,
            version: Number(raw.version ?? preExisting.version ?? 1),
            _discoveredSubcollection: preExisting._discoveredSubcollection ? "favorites & Notification" : "Notification",
          });
        });
      } catch (notifErr) {
        console.warn("Notification subcollection read warning:", notifErr);
      }
    }
    const compiledServices = Array.from(aggregateIndex.values());
    setProviderCatalogRegistry((prev) => ({ ...prev, [providerUid]: compiledServices }));
    return compiledServices;
  } catch (err) {
    console.error("Critical failure compiling provider catalog registry:", err);
    return [];
  } finally {
    setSubcollectionFetchStatus((prev) => ({ ...prev, [`${providerUid}_catalog`]: false }));
  }
};
/**
 * Ingests all booking records from `MyBooking` subcollection
 */
const retrieveProviderBookingLedger = async (providerUid) => {
  if (!providerUid) return [];
  if (providerLedgerRegistry[providerUid]) return providerLedgerRegistry[providerUid];
  setSubcollectionFetchStatus((prev) => ({ ...prev, [`${providerUid}_ledger`]: true }));
  try {
    if (typeof db !== "undefined" && typeof collection === "function" && typeof getDocs === "function") {
      const snap = await getDocs(collection(db, "users", providerUid, "MyBooking"));
      const ledgerItems = snap.docs.map((docRef) => {
        const raw = docRef.data() || {};
        return {
          address: raw.address ?? "",
          arrivalOtp: raw.arrivalOtp ?? "",
          arrivalOtpExpiry: raw.arrivalOtpExpiry ?? null,
          arrivalVerified: Boolean(raw.arrivalVerified),
          bookingDate: raw.bookingDate ?? "",
          bookingDateTimestamp: raw.bookingDateTimestamp ?? null,
          bookingId: raw.bookingId ?? docRef.id ?? "",
          bookingStatus: raw.bookingStatus ?? raw.status ?? "pending",
          bookingTime: raw.bookingTime ?? "",
          bookingTimeStamp: raw.bookingTimeStamp ?? null,
          createdAt: raw.createdAt ?? null,
          customerName: raw.customerName ?? raw.customer?.name ?? raw.user?.name ?? "—",
          customerToken: raw.customerToken ?? "",
          customer_total_amount: Number(raw.customer_total_amount ?? raw.totalAmount ?? raw.totalCharge ?? 0),
          duration: raw.duration ?? "",
          hasPets: Boolean(raw.hasPets),
          id: docRef.id || raw.id || "",
          idempotencyKey: raw.idempotencyKey ?? "",
          invoiceGeneratedAt: raw.invoiceGeneratedAt ?? null,
          invoiceReady: Boolean(raw.invoiceReady),
          isInvoiceGenerated: Boolean(raw.isInvoiceGenerated),
          isPaid: Boolean(raw.isPaid),
          jobDescription: raw.jobDescription ?? "",
          latitude: Number(raw.latitude ?? 0),
          longitude: Number(raw.longitude ?? 0),
          paymentMethod: raw.paymentMethod ?? "",
          paymentMethodDisplay: raw.paymentMethodDisplay ?? raw.paymentMethod ?? "—",
          paymentStatus: raw.paymentStatus ?? "unpaid",
          petType: raw.petType ?? "",
          providerId: raw.providerId ?? raw.provider_id ?? providerUid,
          providerName: raw.providerName ?? raw.provider?.name ?? "—",
          serviceId: raw.serviceId ?? raw.service_id ?? "",
          serviceImage: raw.serviceImage ?? raw.service_image ?? "",
          serviceName: raw.serviceName ?? raw.service_name ?? "General Service",
          serviceStartedAt: raw.serviceStartedAt ?? null,
          status: raw.status ?? raw.bookingStatus ?? "pending",
          totalAmount: Number(raw.totalAmount ?? raw.customer_total_amount ?? 0),
          totalCharge: Number(raw.totalCharge ?? raw.totalAmount ?? 0),
          updatedAt: raw.updatedAt ?? null,
          // Financial Priority Top-Line Fields
          providerPayout: Number(raw.providerPayout ?? raw.provider_payout ?? raw.payout ?? 0),
          platformFee: Number(raw.platformFee ?? raw.platform_fee ?? raw.commission ?? 0),
          ugRevenue: Number(raw.ugRevenue ?? raw.ug_revenue ?? raw.companyRevenue ?? 0),
          discount: Number(raw.discount ?? raw.discountAmount ?? 0),
          tax: Number(raw.tax ?? raw.taxAmount ?? 0),
          customerEmail: raw.customerEmail ?? raw.customer_email ?? raw.user?.email ?? "—",
          customerPhone: raw.customerPhone ?? raw.customer_phone ?? raw.user?.phone ?? "—",
          providerEmail: raw.providerEmail ?? raw.provider_email ?? "—",
          providerPhone: raw.providerPhone ?? raw.provider_phone ?? "—",
          _rawRecord: raw,
        };
      });
      setProviderLedgerRegistry((prev) => ({ ...prev, [providerUid]: ledgerItems }));
      return ledgerItems;
    }
    return [];
  } catch (err) {
    console.error("Critical failure reading provider booking ledger:", err);
    return [];
  } finally {
    setSubcollectionFetchStatus((prev) => ({ ...prev, [`${providerUid}_ledger`]: false }));
  }
};
/* ================= 8. AUTHORIZE PIN & UNLOCK DESTINATION ================= */
const authorizeShieldAccessRequest = async () => {
  if (shieldPasscodeSecret === SHIELD_SECURITY_PIN) {
    dispatchShieldAuditTelemetry(shieldTargetEntity, shieldIntentScope, shieldJustificationNote, "granted");
    const targetEntity = shieldTargetEntity;
    const activeScope = shieldIntentScope;
    terminateShieldProtocol();
    if (activeScope === "profile_view") {
      setActiveProviderRecord(targetEntity);
      try {
        localStorage.setItem("activeProviderRecord", JSON.stringify(targetEntity));
      } catch (e) {
        console.error("Storage sync failure", e);
      }
      setCurrentView("providerProfile");
      setShowProviderList(false);
      showOnlySection("providerProfile");
    } else if (activeScope === "catalog_approval") {
      setInspectedCatalogProvider(targetEntity);
      await syncProviderCatalogAndAlerts(targetEntity?.id || targetEntity?.uid);
    } else if (activeScope === "ledger_bookings") {
      setInspectedLedgerProvider(targetEntity);
      await retrieveProviderBookingLedger(targetEntity?.id || targetEntity?.uid);
    }
  } else {
    dispatchShieldAuditTelemetry(shieldTargetEntity, shieldIntentScope, shieldJustificationNote, "denied");
    setShieldValidationAlert("Incorrect access code. Verification rejected.");
  }
};
const formatSafeDateTime = (val) => {
  if (!val) return "—";
  if (typeof val === "object") {
    if (typeof val.toDate === "function") return val.toDate().toLocaleString();
    if (val.seconds) return new Date(val.seconds * 1000).toLocaleString();
    return JSON.stringify(val);
  }
  return String(val);
};//Providers list//
// Subcollections state: keyed by providerId/userId
const [expandedServiceRow, setExpandedServiceRow] = useState(null);
const [expandedBookingRow, setExpandedBookingRow] = useState(null);
const [servicesCache, setServicesCache] = useState({}); // { [id]: Array<ServiceDoc> }
const [bookingsCache, setBookingsCache] = useState({}); // { [id]: Array<BookingDoc> }
const [subDataLoading, setSubDataLoading] = useState({}); // { [id_type]: boolean }
// Fetch `MyBooking` subcollection
const fetchProviderBookings = async (userId) => {
  if (!userId || bookingsCache[userId]) return;
  setSubDataLoading((prev) => ({ ...prev, [`${userId}_bookings`]: true }));
  try {
    if (typeof db !== "undefined" && typeof collection === "function" && typeof getDocs === "function") {
      const snap = await getDocs(collection(db, "users", userId, "MyBooking"));
      const items = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setBookingsCache((prev) => ({ ...prev, [userId]: items }));
    }
  } catch (err) {
    console.error("Error fetching MyBooking subcollection:", err);
  } finally {
    setSubDataLoading((prev) => ({ ...prev, [`${userId}_bookings`]: false }));
  }
};
const [viewGateStep, setViewGateStep] = useState(null); // null | "reason" | "password"
const [viewGateTarget, setViewGateTarget] = useState(null); // the `prov` record pending view
const [viewGateReason, setViewGateReason] = useState("");
const [viewGatePassword, setViewGatePassword] = useState("");
const [viewGateError, setViewGateError] = useState("");
 const PROVIDER_VIEW_ACCESS_CODE = "8972";
    const logProviderViewAttempt = (prov, reason, outcome) => {
          try {
            const entry = {
              timestamp: new Date().toISOString(),
              providerId: prov?.id || prov?.uid || "unknown",
              providerName: prov?.name || prov?.displayName || "unknown",
              requestedBy: currentUser?.uid || "unknown",
              reason,
              outcome, // "granted" | "denied" | "cancelled"
            };
            const existing = JSON.parse(localStorage.getItem("provider_view_audit_log") || "[]");
            existing.push(entry);
            localStorage.setItem("provider_view_audit_log", JSON.stringify(existing));
          } catch (e) {
            console.warn("Audit log error:", e);
          }
        };
        const startProviderViewRequest = (prov) => {
          setViewGateTarget(prov);
          setViewGateReason("");
          setViewGatePassword("");
          setViewGateError("");
          setViewGateStep("reason");
        };
        const proceedToPasswordStep = () => {
          if (!viewGateReason.trim()) {
            setViewGateError("Please provide a reason before continuing.");
            return;
          }
          setViewGateError("");
          setViewGateStep("password");
        };
        const confirmProviderViewAccess = () => {
          if (viewGatePassword === PROVIDER_VIEW_ACCESS_CODE) {
            logProviderViewAttempt(viewGateTarget, viewGateReason, "granted");
            const prov = viewGateTarget;
            setActiveProviderRecord(prov);
            try {
              localStorage.setItem("activeProviderRecord", JSON.stringify(prov));
            } catch (e) {
              console.error("Storage error", e);
            }
            setCurrentView("providerProfile");
            setShowProviderList(false);
            showOnlySection("providerProfile");
            closeViewGate();
          } else {
            logProviderViewAttempt(viewGateTarget, viewGateReason, "denied");
            setViewGateError("Incorrect access code.");
          }
        };
        const closeViewGate = () => {
          setViewGateStep(null);
          setViewGateTarget(null);
          setViewGateReason("");
          setViewGatePassword("");
          setViewGateError("");
        };//providers profile//
 const [listZoomLevel, setListZoomLevel] = useState(100); // 👈 add this
 const [isRefreshSpinning, setIsRefreshSpinning] = useState(false);
const updateProviderVerificationStatus = async (newStatus, providerDisplayName, adminNotes) => {
  if (!activeProviderRecord?.id) {
    console.error("Cannot update status: activeProviderRecord is missing an id.");
    alert("⚠️ No provider selected.");
    return;
  }
  const resolvedName =
    providerDisplayName ||
    activeProviderRecord?.username ||
    activeProviderRecord?.name ||
    "";
  if (!resolvedName) {
    alert("⚠️ Provider name is required.");
    return;
  }

  try {
    const providerRef = doc(db, "users", activeProviderRecord.id);
    await updateDoc(providerRef, {
      status: newStatus,
      lastStatusNote: adminNotes || "",
      lastStatusUpdatedBy: currentUser?.uid || "unknown",
      lastStatusUpdatedAt: serverTimestamp(),
    });

    // keep local state + cache in sync so UI reflects the change immediately
    const updatedRecord = { ...activeProviderRecord, status: newStatus };
    setActiveProviderRecord(updatedRecord);
    localStorage.setItem("activeProviderRecord", JSON.stringify(updatedRecord));

    toast?.success
      ? toast.success(`Provider ${resolvedName} marked as "${newStatus}" ✅`)
      : console.log(`Provider ${resolvedName} marked as "${newStatus}"`);
  } catch (error) {
    console.error("Failed to update provider status in Firestore:", error);
    alert("❌ Failed to update provider status. Check console for details.");
  }
};
const handleProviderApprovalDecision = async () => {
  if (!activeProviderRecord?.id) {
    console.error("Cannot approve/reject: activeProviderRecord is missing an id.");
    alert("⚠️ No provider selected.");
    return;
  }
  const resolvedName =
    activeProviderRecord?.username || activeProviderRecord?.name || "";
  if (!resolvedName) {
    alert("⚠️ Provider name is required.");
    return;
  }
  const decision = window.confirm(
    `Approve ${resolvedName}? Click Cancel to reject instead.`
  );
  const newStatus = decision ? "approved" : "rejected";
  try {
    const providerRef = doc(db, "users", activeProviderRecord.id);
    await updateDoc(providerRef, {
      status: newStatus,
      lastStatusUpdatedBy: currentUser?.uid || "unknown",
      lastStatusUpdatedAt: serverTimestamp(),
    });
    const updatedRecord = { ...activeProviderRecord, status: newStatus };
    setActiveProviderRecord(updatedRecord);
    localStorage.setItem("activeProviderRecord", JSON.stringify(updatedRecord));
    toast?.success
      ? toast.success(`Provider ${resolvedName} ${newStatus} ✅`)
      : console.log(`Provider ${resolvedName} ${newStatus}`);
  } catch (error) {
    console.error("Failed to approve/reject provider in Firestore:", error);
    alert("❌ Failed to update provider status. Check console for details.");
  }
};//Providers List//
const [activeProviderRecord, setActiveProviderRecord] = useState(() => {
  try {
    const cached = localStorage.getItem("activeProviderRecord");
    return cached ? JSON.parse(cached) : null;
  } catch {
    return null;
  }
});//Providers List//
useEffect(() => {
  // real-time listener on "users" where role == "provider"
  const q = query(collection(db, "users"), where("role", "==", "provider"));
  const unsubscribe = onSnapshot(
    q,
    (snapshot) => {
      console.log("provider docs found:", snapshot.docs.length);
      snapshot.docs.forEach((doc) => console.log(doc.id, doc.data()));
      const providers = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setProviderList(providers);
      setProvidersLoading(false);
      try {
        localStorage.setItem("providersListCache", JSON.stringify(providers));
      } catch (e) {
        console.error("Failed to cache providers list:", e);
      }
    },
    (error) => {
      console.error("Error fetching providers:", error.code, error.message);
      setProvidersLoading(false);
      // keep whatever is already cached in providerList on error
    }
  );
  return () => unsubscribe();
}, []);//Providers List//
const fetchProvidersFromUsersCollection = async () => {
  setProvidersLoading(true);
  try {
    const q = query(collection(db, "users"), where("role", "==", "provider"));
    const snapshot = await getDocs(q);
    const providers = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    console.log("Refreshed provider docs:", providers.length);
    setProviderList(providers);
    localStorage.setItem("providersListCache", JSON.stringify(providers));
  } catch (error) {
    console.error("Manual refresh failed:", error.code, error.message);
  } finally {
    setProvidersLoading(false);
  }
};
/* ================= NEW UNIQUE SUBCOLLECTION HANDLERS ================= */
/**
 * 1. Fetch `favorites` subcollection with all 39 service approval fields
 */
const handleFetchProviderServicesApproval = async (userId) => {
  if (!userId || servicesCache[userId]) return;
  setSubDataLoading((prev) => ({ ...prev, [`${userId}_services`]: true }));
  try {
    if (typeof db !== "undefined" && typeof collection === "function" && typeof getDocs === "function") {
      const snap = await getDocs(collection(db, "users", userId, "favorites"));
      const items = snap.docs.map((doc) => {
        const d = doc.data() || {};
        return {
          address: d.address ?? "",
          approval_status: d.approval_status ?? d.approvalStatus ?? "pending",
          category: d.category ?? "",
          category_type: d.category_type ?? d.categoryType ?? "",
          created_at: d.created_at ?? d.createdAt ?? null,
          description: d.description ?? "",
          discount: d.discount ?? 0,
          duration_hour: d.duration_hour ?? d.durationHour ?? 0,
          duration_mins: d.duration_mins ?? d.durationMins ?? 0,
          edited_by_provider: Boolean(d.edited_by_provider ?? d.editedByProvider),
          final_price: d.final_price ?? d.finalPrice ?? 0,
          gallery_images: Array.isArray(d.gallery_images) ? d.gallery_images : [],
          gallery_media: Array.isArray(d.gallery_media) ? d.gallery_media : [],
          has_videos: Boolean(d.has_videos ?? d.hasVideos),
          id: doc.id || d.id || "",
          image: d.image ?? "",
          is_active: Boolean(d.is_active ?? d.isActive),
          is_approved: Boolean(d.is_approved ?? d.isApproved),
          latitude: d.latitude ?? 0,
          longitude: d.longitude ?? 0,
          price: d.price ?? 0,
          providerId: d.providerId ?? d.provider_id ?? userId,
          provider_id: d.provider_id ?? d.providerId ?? userId,
          rejection_reason: d.rejection_reason ?? d.rejectionReason ?? null,
          reviewed_at: d.reviewed_at ?? d.reviewedAt ?? null,
          reviewed_by: d.reviewed_by ?? d.reviewedBy ?? "",
          search_keywords: Array.isArray(d.search_keywords) ? d.search_keywords : [],
          service_id: d.service_id ?? d.serviceId ?? doc.id,
          service_name: d.service_name ?? d.serviceName ?? d.title ?? "Untitled Service",
          set_as_feature: Boolean(d.set_as_feature ?? d.setAsFeature),
          status: d.status ?? "inactive",
          sub_category: d.sub_category ?? d.subCategory ?? "",
          submitted_for_review_at: d.submitted_for_review_at ?? d.submittedForReviewAt ?? null,
          suggest_category: d.suggest_category ?? d.suggestCategory ?? "",
          timestamp: d.timestamp ?? null,
          tools: Array.isArray(d.tools) ? d.tools : [],
          total_media_count: d.total_media_count ?? (d.gallery_images?.length || 0),
          updated_at: d.updated_at ?? d.updatedAt ?? null,
          version: d.version ?? 1,
        };
      });
      setServicesCache((prev) => ({ ...prev, [userId]: items }));
    }
  } catch (err) {
    console.error("Error fetching favorites services approval:", err);
  } finally {
    setSubDataLoading((prev) => ({ ...prev, [`${userId}_services`]: false }));
  }
};
/**
 * 2. Fetch `MyBooking` subcollection with all exact requested booking fields
 */
const handleFetchProviderBookingsSubcollection = async (userId) => {
  if (!userId || bookingsCache[userId]) return;
  setSubDataLoading((prev) => ({ ...prev, [`${userId}_bookings`]: true }));
  try {
    if (typeof db !== "undefined" && typeof collection === "function" && typeof getDocs === "function") {
      const snap = await getDocs(collection(db, "users", userId, "MyBooking"));
      const items = snap.docs.map((doc) => {
        const d = doc.data() || {};
        return {
          address: d.address ?? "",
          arrivalOtp: d.arrivalOtp ?? "",
          arrivalOtpExpiry: d.arrivalOtpExpiry ?? null,
          arrivalVerified: Boolean(d.arrivalVerified),
          bookingDate: d.bookingDate ?? "",
          bookingDateTimestamp: d.bookingDateTimestamp ?? null,
          bookingId: d.bookingId ?? doc.id ?? "",
          bookingStatus: d.bookingStatus ?? d.status ?? "pending",
          bookingTime: d.bookingTime ?? "",
          bookingTimeStamp: d.bookingTimeStamp ?? null,
          createdAt: d.createdAt ?? null,
          customerName: d.customerName ?? d.customer?.name ?? d.user?.name ?? "—",
          customerToken: d.customerToken ?? "",
          customer_total_amount: Number(d.customer_total_amount ?? d.totalAmount ?? d.totalCharge ?? 0),
          duration: d.duration ?? "",
          hasPets: Boolean(d.hasPets),
          id: doc.id || d.id || "",
          idempotencyKey: d.idempotencyKey ?? "",
          invoiceGeneratedAt: d.invoiceGeneratedAt ?? null,
          invoiceReady: Boolean(d.invoiceReady),
          isInvoiceGenerated: Boolean(d.isInvoiceGenerated),
          isPaid: Boolean(d.isPaid),
          jobDescription: d.jobDescription ?? "",
          latitude: d.latitude ?? 0,
          longitude: d.longitude ?? 0,
          paymentMethod: d.paymentMethod ?? "",
          paymentMethodDisplay: d.paymentMethodDisplay ?? d.paymentMethod ?? "—",
          paymentStatus: d.paymentStatus ?? "unpaid",
          petType: d.petType ?? "",
          providerId: d.providerId ?? d.provider_id ?? userId,
          providerName: d.providerName ?? d.provider?.name ?? "—",
          serviceId: d.serviceId ?? d.service_id ?? "",
          serviceImage: d.serviceImage ?? d.service_image ?? "",
          serviceName: d.serviceName ?? d.service_name ?? "General Service",
          serviceStartedAt: d.serviceStartedAt ?? null,
          status: d.status ?? d.bookingStatus ?? "pending",
          totalAmount: Number(d.totalAmount ?? d.customer_total_amount ?? 0),
          totalCharge: Number(d.totalCharge ?? d.totalAmount ?? 0),
          updatedAt: d.updatedAt ?? null,
          // Financial priorities
          providerPayout: Number(d.providerPayout ?? d.provider_payout ?? d.payout ?? 0),
          platformFee: Number(d.platformFee ?? d.platform_fee ?? d.commission ?? 0),
          ugRevenue: Number(d.ugRevenue ?? d.ug_revenue ?? d.companyRevenue ?? 0),
          discount: Number(d.discount ?? d.discountAmount ?? 0),
          tax: Number(d.tax ?? d.taxAmount ?? 0),
          // Contact info if present
          customerEmail: d.customerEmail ?? d.customer_email ?? d.user?.email ?? "—",
          customerPhone: d.customerPhone ?? d.customer_phone ?? d.user?.phone ?? "—",
          providerEmail: d.providerEmail ?? d.provider_email ?? "—",
          providerPhone: d.providerPhone ?? d.provider_phone ?? "—",
          _raw: d,
        };
      });
      setBookingsCache((prev) => ({ ...prev, [userId]: items }));
    }
  } catch (err) {
    console.error("Error fetching MyBooking subcollection:", err);
  } finally {
    setSubDataLoading((prev) => ({ ...prev, [`${userId}_bookings`]: false }));
  }
  };//providers list//
const [expandedCustomerTxnRow, setExpandedCustomerTxnRow] = useState(null);
const [documentPreviewModal, setDocumentPreviewModal] = useState({ open: false, doc: null, url: null });//Verification PipeLine//
const [walletUnsub, setWalletUnsub] = useState(null);
const [isIssuingCredit, setIsIssuingCredit] = useState(false);
const [isRecordingReversal, setIsRecordingReversal] = useState(false);
// --- Voucher & Wallet State Hooks ---
const [voucherDraft, setVoucherDraft] = useState({});
const [isIssuingVoucher, setIsIssuingVoucher] = useState(false);
// ---------- ADD CREDIT (TopUp Issue) — FIRESTORE SYNCED ----------
async function handleIssueTopUpCredit() {
  const customerId = String(topUpDraft.customerId || "").trim();
  const customerName = String(topUpDraft.customerName || "").trim();
  const amount = Number(topUpDraft.amount);
  const reasonCode = topUpDraft.reasonCode || "Goodwill Compensation";
  const staffHandle = String(topUpDraft.staffHandle || "").trim();
  const remarks = topUpDraft.remarks || "";
  if (!customerId) return alert("Please enter a Customer ID");
  if (!amount || amount <= 0) return alert("Please enter a valid credit amount");
  if (!staffHandle) return alert("Please enter the staff name issuing this credit");
  setIsIssuingCredit(true); // ✅ was missing — this flag drives the button/inputs disabled state
  const localId = `topup_${Date.now()}`;
  const nowIso = new Date().toISOString();
  const newEntry = {
    id: localId,
    customerId,
    customerName,
    entryType: "issue",
    amount,
    reasonCode,
    remarks,
    bookingId: "",
    staffHandle,
    transactionDate: nowIso
  };
  // Optimistic local update so the admin UI feels instant even before Firestore confirms
  const updatedLedger = [newEntry, ...walletLedger];
  setWalletLedger(updatedLedger);
  try {
    const ledgerRef = collection(db, "users", customerId, "walletLedger");
    await addDoc(ledgerRef, {
      customerId,
      customerName,
      entryType: "issue",
      amount,
      reasonCode,
      remarks,
      bookingId: "",
      staffHandle,
      transactionDate: serverTimestamp(),
      transactionDateClient: nowIso
    });
    const userRef = doc(db, "users", customerId);
    await setDoc(
      userRef,
      {
        walletBalance: increment(amount),
        walletLastUpdated: serverTimestamp()
      },
      { merge: true }
    );
    logActivityTrailEntry({
      customerId,
      customerName,
      activityCategory: "TopUp",
      summary: `Credit of £${amount.toFixed(2)} issued. Reason: ${reasonCode}.${remarks ? " Notes: " + remarks : ""}`,
      staffHandle
    });
    setTopUpDraft((prev) => ({ ...prev, amount: "", remarks: "" }));
    alert("Credit issued and synced to customer's wallet.");
  } catch (err) {
    console.error("Issue TopUp credit error:", err);
    setWalletLedger(walletLedger); // roll back optimistic update
    alert("Failed to issue credit — NOT synced to customer app: " + err.message);
  } finally {
    setIsIssuingCredit(false); // ✅ always reset, success or failure
  }
}
// ---------- REFUND (Reversal) TRACKING — FIRESTORE SYNCED ----------
async function handleRecordReversal() {
  const customerId = String(reversalDraft.customerId || "").trim();
  const customerName = String(reversalDraft.customerName || "").trim();
  const refundAmount = Number(reversalDraft.refundAmount);
  const refundReason = reversalDraft.refundReason || "";
  const bookingId = reversalDraft.bookingId || "";
  const approvedByAdmin = String(reversalDraft.approvedByAdmin || "").trim();
  if (!customerId) return alert("Please enter a Customer ID");
  if (!refundAmount || refundAmount <= 0) return alert("Please enter a valid refund amount");
  if (!refundReason) return alert("Please enter a refund reason");
  if (!approvedByAdmin) return alert("Please enter the approving administrator's name");
  setIsRecordingReversal(true); // ✅ drives the "Recording..." button state / disabled inputs
  const localId = `reversal_${Date.now()}`;
  const nowIso = new Date().toISOString();
  const newEntry = {
    id: localId,
    customerId,
    customerName,
    refundAmount,
    refundReason,
    bookingId,
    approvedByAdmin,
    reversalDate: nowIso
  };
  const updated = [newEntry, ...reversalLedger];
  setReversalLedger(updated);
  try {
    const reversalRef = collection(db, "users", customerId, "reversalLedger");
    await addDoc(reversalRef, {
      customerId,
      customerName,
      refundAmount,
      refundReason,
      bookingId,
      approvedByAdmin,
      reversalDate: serverTimestamp(),
      reversalDateClient: nowIso
    });
    const userRef = doc(db, "users", customerId);
    await setDoc(
      userRef,
      {
        walletBalance: increment(refundAmount),
        walletLastUpdated: serverTimestamp()
      },
      { merge: true }
    );
    logActivityTrailEntry({
      customerId,
      customerName,
      activityCategory: "Reversal",
      summary: `Refund of £${refundAmount.toFixed(2)} approved by ${approvedByAdmin}. Reason: ${refundReason}. Booking: ${bookingId || "-"}.`,
      staffHandle: approvedByAdmin
    });

    setReversalDraft({});
    alert("Refund recorded and synced to customer's wallet.");
  } catch (err) {
    console.error("Record reversal error:", err);
    setReversalLedger(reversalLedger);
    alert("Failed to record refund — NOT synced to customer app: " + err.message);
  } finally {
    setIsRecordingReversal(false); // ✅ always reset
  }
}
// ---------- OPEN WALLET DRAWER — NOW ATTACHES A LIVE FIRESTORE LISTENER ----------
function openWalletDrawerForCustomer(customer, targetId) {
  const customerId = customer.customerId || customer.id || targetId || "";
  const customerName = customer.name || "";
  setWalletActiveCustomer(customer);
  setWalletActiveTab("overview");
  setTopUpDraft({ customerId, customerName });
  setReversalDraft({ customerId, customerName });
  setShowWalletModule(true);
  if (!customerId) return;
  // Tear down any previous listener before starting a new one — otherwise switching
  // between customers leaves stale listeners running and can leak data across customers.
  // ✅ walletUnsub now exists as state, declared at the top of the component.
  if (walletUnsub) walletUnsub();
  const ledgerQuery = query(
    collection(db, "users", customerId, "walletLedger"),
    orderBy("transactionDate", "desc")
  );
  const unsubscribe = onSnapshot(
    ledgerQuery,
    (snapshot) => {
      const liveEntries = snapshot.docs.map((d) => {
        const data = d.data();
        return {
          id: d.id,
          ...data,
          transactionDate: data.transactionDate?.toDate
            ? data.transactionDate.toDate().toISOString()
            : data.transactionDateClient || new Date().toISOString()
        };
      });
      setWalletLedger((prev) => {
        const others = prev.filter(
          (e) => normalizeWalletId(e.customerId) !== normalizeWalletId(customerId)
        );
        return [...liveEntries, ...others];
      });
    },
    (err) => console.error("Wallet ledger subscription error:", err)
  );
  setWalletUnsub(() => unsubscribe); // storing a function in state requires the functional form
}
// ---------- CLOSE WALLET MODULE — tears down listener, clears drafts ----------
function handleCloseWalletModule() {
  if (walletUnsub) {
    walletUnsub();
    setWalletUnsub(null);
  }
  setShowWalletModule(false);
  setWalletActiveCustomer(null);
  setTopUpDraft({});
  setReversalDraft({});
}//Customer List//
// Sort order state, defaulting to "oldest"
if (!window.__providerSortOrder) {
  window.__providerSortOrder = "oldest";
}
window.__providersRefreshing = window.__providersRefreshing || false;
// Toggles sort order and forces a re-render via the existing pendingStageOverrides setter
window.__toggleProviderSort = () => {
  window.__providerSortOrder =
    window.__providerSortOrder === "oldest" ? "newest" : "oldest";
  // Force a re-render without changing real data — reuse existing state setter
  if (typeof setPendingStageOverrides === "function") {
    setPendingStageOverrides((prev) => ({ ...prev }));
  }
};
// Forces an immediate Firestore re-fetch via fetchAllProviders (see providerPipelineHandlers.js)
window.__refreshProviders = async () => {
  if (window.__providersRefreshing) return;
  window.__providersRefreshing = true;
  if (typeof setPendingStageOverrides === "function") {
    setPendingStageOverrides((prev) => ({ ...prev })); // trigger spinner render
  }
  try {
    if (typeof fetchAllProviders === "function") {
      const { newProviders, existingProviders } = await fetchAllProviders();
      if (typeof setPipelineBoardRecords === "function") setPipelineBoardRecords(newProviders);
      if (typeof setProviderPipelineCards === "function") setProviderPipelineCards(existingProviders);
    }
  } catch (error) {
    console.error("Failed to refresh providers:", error);
  } finally {
    window.__providersRefreshing = false;
    if (typeof setPendingStageOverrides === "function") {
      setPendingStageOverrides((prev) => ({ ...prev }));
    }
  }
};
const [isSavingReport, setIsSavingReport] = useState(false);//Job Reports
// ✅ NEW: Promotions per-customer target state
const [promoTargetCustomer, setPromoTargetCustomer] = useState(null);
function openPromotionsForCustomer(customer) {
  setPromoTargetCustomer(customer || null);
  setShowPromotionsModule(true);
}
function handleClosePromotionsModule() {
  setShowPromotionsModule(false);
  setPromoTargetCustomer(null);
}
function handleCloseWalletModule() {
  setShowWalletModule(false);
  setWalletActiveCustomer(null);
  setTopUpDraft({});
  setReversalDraft({});
}
//Customer List
const [inviteUsersList, setInviteUsersList] = useState([]);
const [loadingInvites, setLoadingInvites] = useState(true);
// Fetch Invite Users collection live from Firestore
useEffect(() => {
  setLoadingInvites(true);
  // Note: Replace "Invite Users" with your exact Firestore collection name if different (e.g. "inviteUsers" or "invited_users")
  const inviteUsersCollectionRef = collection(db, "Invite Users");
  const q = query(inviteUsersCollectionRef, orderBy("createdAt", "desc"));
  const unsubscribe = onSnapshot(
    q,
    (snapshot) => {
      const users = snapshot.docs.map((doc) => {
        const data = doc.data();
        // Safe helper function to format Firestore Timestamps or Date objects
        const formatTimestamp = (timestamp) => {
          if (!timestamp) return null;
          if (typeof timestamp.toDate === "function") {
            return timestamp.toDate().toLocaleString();
          }
          if (timestamp instanceof Date) {
            return timestamp.toLocaleString();
          }
          return String(timestamp);
        };
        // Determine the best formatted creation timestamp for display
        const createdAtFormatted =
          formatTimestamp(data.createdAt) ||
          formatTimestamp(data.invitedAt) ||
          "—";
        return {
          id: doc.id,
          uid: data.uid || doc.id,
          // Map form input names to table expectations with safe fallbacks
          displayName: data.displayName || data.fullName || "—",
          email: data.email || data.emailAddress || "—",
          role: data.role || data.accessLevel || "employee",
          accountType: data.accountType || "Employee",
          status: data.status || "invited",
          disabled: Boolean(data.disabled),
          emailVerified: Boolean(data.emailVerified),
          invitationLink: data.invitationLink || data.inviteUrl || null,
          ...data,
          createdAtFormatted,
        };
      });
      setInviteUsersList(users);
      setLoadingInvites(false);
    },
    (error) => {
      console.error("Error fetching Invite Users:", error);
      setLoadingInvites(false);
    }
  );
  return () => unsubscribe();
}, []);
const formControlStyle = {
  width: "100%",
  padding: "12px 14px",
  border: "1px solid #d1d5db",
  borderRadius: "8px",
  fontSize: "14px",
  background: "#ffffff",
  color: "#111827",
  outline: "none",
  boxSizing: "border-box",
  transition: "all 0.2s ease"
};
const EMPLOYEE_INVITATION_ENDPOINT =
  "https://invitenewusers-mc4pzotprq-uc.a.run.app";
  const [employeeDetails, setEmployeeDetails] = useState({
    emailAddress: "",
    fullName: "",
    accessLevel: "employee"
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successNotice, setSuccessNotice] = useState("");
  const [errorNotice, setErrorNotice] = useState("");
  const [generatedInviteUrl, setGeneratedInviteUrl] = useState("");
  // Stores all invitations created during the current page session
  const [employeeDirectory, setEmployeeDirectory] = useState([]);
  const updateEmployeeField = (event) => {
    const { name, value } = event.target;
    setEmployeeDetails((currentDetails) => ({
     ...currentDetails,
      [name]: value
    }));
  };
  const submitEmployeeInvitation = async (event) => {
    event.preventDefault();
    setSuccessNotice("");
    setErrorNotice("");
    setGeneratedInviteUrl("");
    const cleanedEmail = employeeDetails.emailAddress.trim();
    const cleanedName = employeeDetails.fullName.trim();
    if (!cleanedEmail) {
      setErrorNotice("Please enter the employee email address.");
      return;
    }
    if (!cleanedName) {
      setErrorNotice("Please enter the employee name.");
      return;
    }
    try {
      setIsSubmitting(true);
      const serverResponse = await fetch(EMPLOYEE_INVITATION_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: cleanedEmail,
          displayName: cleanedName,
          role: employeeDetails.accessLevel
        })
      });
      let serverData = {};
      try {
        serverData = await serverResponse.json();
      } catch (jsonError) {
        console.error("Invalid server response:", jsonError);
        throw new Error("The server returned an invalid response.");
      }
      if (!serverResponse.ok || serverData.success!== true) {
        const backendMessage =
          typeof serverData.message === "string"
           ? serverData.message
            : typeof serverData.error === "string"
           ? serverData.error
            : "Unable to create employee invitation.";

        throw new Error(backendMessage);
      }
      const returnedEmail =
        typeof serverData.user?.email === "string"
         ? serverData.user.email
          : cleanedEmail;
      const returnedInvitationUrl =
        typeof serverData.invitationLink === "string"
         ? serverData.invitationLink
          : "";
      const newEmployeeRecord = {
        id: `${Date.now()}-${Math.random()}`,
        fullName: cleanedName,
        emailAddress: returnedEmail,
        accessLevel: employeeDetails.accessLevel,
        invitationUrl: returnedInvitationUrl,
        invitationStatus: "Invitation Created",
        createdAt: new Date().toLocaleString()
      };
      setEmployeeDirectory((currentDirectory) => [
        newEmployeeRecord,
       ...currentDirectory
      ]);
      setSuccessNotice(
        `Invitation created successfully for ${returnedEmail}.`
      );
      setGeneratedInviteUrl(returnedInvitationUrl);
      setEmployeeDetails({
        emailAddress: "",
        fullName: "",
        accessLevel: "employee"
      });
    } catch (submissionError) {
      console.error("Employee invitation request failed:", submissionError);
      const readableError =
        submissionError instanceof Error &&
        typeof submissionError.message === "string"
         ? submissionError.message
          : "Unable to create employee invitation.";
      setErrorNotice(readableError);
    } finally {
      setIsSubmitting(false);
    }
  };
  const copyGeneratedInviteUrl = async (url) => {
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
      setSuccessNotice("Invitation link copied to clipboard.");
      setErrorNotice("");
    } catch (copyError) {
      console.error("Invitation link copy failed:", copyError);
      setErrorNotice("Unable to copy the invitation link.");
      setSuccessNotice("");
    }
  };
  const pageStyle = {
    minHeight: "100vh",
    padding: "32px",
    background: "#f5f7fb",
    boxSizing: "border-box"
  };
  const headingStyle = {
    marginBottom: "24px"
  };
  const subtitleStyle = {
    margin: 0,
    color: "#6b7280",
    fontSize: "15px"
  };
  const fieldStyle = {
    marginBottom: "20px"
  };
  const labelStyle = {
    display: "block",
    marginBottom: "8px",
    color: "#111827",
    fontSize: "14px",
    fontWeight: 700
  };
  const selectStyle = {
  ...formControlStyle,
  cursor: isSubmitting ? "not-allowed" : "pointer"
};
  const submitButtonStyle = {
    width: "100%",
    minHeight: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "9px",
    border: "none",
    borderRadius: "9px",
    background: isSubmitting? "#6b8fc5" : "#0747A6",
    color: "#ffffff",
    fontSize: "15px",
    fontWeight: 700,
    cursor: isSubmitting? "not-allowed" : "pointer",
    opacity: isSubmitting? 0.75 : 1
  };
  const alertStyle = {
    marginBottom: "18px",
    padding: "13px 15px",
    borderRadius: "9px",
    fontSize: "14px",
    lineHeight: 1.5,
    boxSizing: "border-box"
  };
  const errorStyle = {
   ...alertStyle,
    background: "#fef2f2",
    color: "#b91c1c",
    border: "1px solid #fecaca"
  };
  const successStyle = {
   ...alertStyle,
    background: "#ecfdf5",
    color: "#047857",
    border: "1px solid #a7f3d0"
  };
  const resultStyle = {
    marginTop: "28px",
    paddingTop: "26px",
    borderTop: "1px solid #e5e7eb"
  };
  const resultTitleStyle = {
    color: "#111827",
    fontSize: "18px",
    fontWeight: 800,
    marginBottom: "7px"
  };
  const resultTextStyle = {
    margin: "0 0 15px",
    color: "#6b7280",
    fontSize: "14px"
  };
  const linkRowStyle = {
    display: "flex",
    gap: "10px",
    marginBottom: "14px"
  };
  const linkInputStyle = {
    flex: 1,
    minWidth: 0,
    height: "44px",
    padding: "0 12px",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    color: "#374151",
    background: "#ffffff",
    fontSize: "13px",
    outline: "none",
    boxSizing: "border-box"
  };
  const copyButtonStyle = {
    minWidth: "82px",
    minHeight: "44px",
    padding: "0 18px",
    border: "none",
    borderRadius: "8px",
    background: "#111827",
    color: "#ffffff",
    fontWeight: 700,
    cursor: "pointer"
  };
  const openButtonStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "44px",
    padding: "0 18px",
    borderRadius: "8px",
    background: "#0747A6",
    color: "#ffffff",
    textDecoration: "none",
    fontSize: "14px",
    fontWeight: 700
  };
  const spinnerStyle = {
    width: "17px",
    height: "17px",
    border: "2px solid rgba(255,255,255,0.35)",
    borderTopColor: "#ffffff",
    borderRadius: "50%",
    display: "inline-block"
  };
  const directoryCardStyle = {
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "16px",
    padding: "24px",
    boxShadow: "0 8px 30px rgba(15, 23, 42, 0.07)",
    boxSizing: "border-box"
  };
  const directoryHeaderStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "15px",
    marginBottom: "20px"
  };
  const directoryTitleStyle = {
    margin: 0,
    color: "#111827",
    fontSize: "20px",
    fontWeight: 800
  };
  const directoryCountStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "30px",
    height: "30px",
    padding: "0 9px",
    borderRadius: "20px",
    background: "#e8f0ff",
    color: "#0747A6",
    fontSize: "13px",
    fontWeight: 800
  };
  const tableWrapperStyle = {
    width: "100%",
    overflowX: "auto",
    border: "1px solid #e5e7eb",
    borderRadius: "12px"
  };
  const employeeNameStyle = {
    color: "#111827",
    fontWeight: 700
  };
  const employeeEmailStyle = {
    color: "#6b7280",
    fontSize: "13px",
    marginTop: "3px"
  };
  const roleBadgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    padding: "5px 10px",
    borderRadius: "20px",
    background: "#f3f4f6",
    color: "#374151",
    fontSize: "12px",
    fontWeight: 700,
    textTransform: "capitalize"
  };
  const rowActionStyle = {
    display: "flex",
    alignItems: "center",
    gap: "7px",
    flexWrap: "wrap"
  };
  const rowCopyButtonStyle = {
    minHeight: "34px",
    padding: "0 11px",
    border: "1px solid #d1d5db",
    borderRadius: "7px",
    background: "#ffffff",
    color: "#374151",
    fontSize: "12px",
    fontWeight: 700,
    cursor: "pointer"
  };
  const rowOpenButtonStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "34px",
    padding: "0 11px",
    borderRadius: "7px",
    background: "#0747A6",
    color: "#ffffff",
    textDecoration: "none",
    fontSize: "12px",
    fontWeight: 700
  };
  const emptyDirectoryStyle = {
    padding: "45px 20px",
    textAlign: "center",
    color: "#6b7280",
    fontSize: "14px",
    border: "1px dashed #d1d5db",
    borderRadius: "12px",
    background: "#fafafa"
  };
// ✅ Column filter state for Customer List table
const [customerColumnFilters, setCustomerColumnFilters] = useState({});
// ✅ Column filter state for Booking Records table
const [bookingColumnFilters, setBookingColumnFilters] = useState({});
const [providersLoading, setProvidersLoading] = useState(true);
const [providerNotesDraft, setProviderNotesDraft] = useState("");
const [notesSavedMessage, setNotesSavedMessage] = useState("");
const [pendingStageOverrides, setPendingStageOverrides] = useState({});
useEffect(() => {
  const unsubscribe = subscribeToProviders(({ newProviders, existingProviders }) => {
    setPipelineBoardRecords(newProviders);
    setProviderPipelineCards(existingProviders);
    setProvidersLoading(false);
  });
  return () => unsubscribe();
}, []);
/* ────────────────────────────────────────────────────────
   1. FIELD ALIAS MAP
   Every possible field name we might see in a "users" doc,
   mapped to the canonical name the JSX expects. Add more
   aliases here as you discover real field names in your data.
──────────────────────────────────────────────────────── */
const FIELD_ALIASES = {
  providerDisplayName: ["providerDisplayName", "name", "fullName", "displayName", "providerName"],
  providerEmailAddress: ["providerEmailAddress", "email", "emailAddress"],
  providerContactNumber: ["providerContactNumber", "phone", "phoneNumber", "contactNumber", "mobile"],
  serviceLocation: ["serviceLocation", "location", "city", "address"],
  serviceCategory: ["serviceCategory", "category", "categories", "service", "profession"],
  serviceReference: ["serviceReference", "providerId", "id", "uid"],
  device: ["device", "deviceType", "platform"],
  approvalStage: ["approvalStage", "status", "verificationStage", "stage", "pipelineStatus"],
  role: ["role", "userType", "accountType", "providerType", "userRole"],
  createdAt: ["createdAt", "created_at", "signUpDate", "registeredAt", "timestamp"],
  documentUploaded: ["documentUploaded", "hasDocuments", "docsUploaded"],
  verificationCompleted: ["verificationCompleted", "isVerified", "verified"],
  documents: ["documents", "docs", "uploadedDocuments"],
};
/* Pull the first matching alias value out of a raw doc */
const pickField = (raw, canonicalKey) => {
  const aliases = FIELD_ALIASES[canonicalKey] || [canonicalKey];
  for (const alias of aliases) {
    if (raw[alias] !== undefined && raw[alias] !== null && raw[alias] !== "") {
      return raw[alias];
    }
  }
  return undefined;
};
/* ────────────────────────────────────────────────────────
   2. NORMALIZE a raw Firestore doc into the shape the JSX
      (both the board cards and kanban cards) expects.
──────────────────────────────────────────────────────── */
const normalizeProviderDoc = (docSnap) => {
  const raw = docSnap.data();
  const id = docSnap.id;
  return {
    id,
    rowId: id,
    providerDisplayName: pickField(raw, "providerDisplayName") || "Unnamed Provider",
    providerEmailAddress: pickField(raw, "providerEmailAddress") || "—",
    providerContactNumber: pickField(raw, "providerContactNumber") || "—",
    serviceLocation: pickField(raw, "serviceLocation") || "—",
    serviceCategory: pickField(raw, "serviceCategory") || "—",
    serviceReference: pickField(raw, "serviceReference") || id,
    device: pickField(raw, "device") || "—",
    approvalStage: pickField(raw, "approvalStage") || "New Provider",
    status: pickField(raw, "approvalStage") || "verification_pending",
    role: pickField(raw, "role"),
    createdAt: pickField(raw, "createdAt"),
    documentUploaded: !!pickField(raw, "documentUploaded"),
    verificationCompleted: !!pickField(raw, "verificationCompleted"),
    documents: pickField(raw, "documents") || [],
    _raw: raw, // keep raw doc around for debugging / future field mapping
  };
}

/* ────────────────────────────────────────────────────────
   3. NEW vs EXISTING CLASSIFICATION
   Auto-detect logic, in priority order:
   a) Explicit role/type field, if present, wins first.
      Values containing "new" -> New Provider tab.
      Values containing "existing", "active", "approved",
      "verified" -> Existing Provider tab.
   b) Explicit approvalStage/status field, if present:
      "new provider" / "pending verification" / "verification
      pending" -> New tab.
      "verification started" / "approved" / "rejected" /
      "verification completed" -> Existing tab.
   c) Fallback: createdAt within the last NEW_PROVIDER_WINDOW_DAYS
      -> New tab, otherwise Existing tab.
   d) Final fallback: no usable signal at all -> New tab
      (safer default so nothing silently disappears; you'll
      see it and can tune the rules above once you inspect
      console output).
   Adjust NEW_PROVIDER_WINDOW_DAYS and the keyword lists below
   once you've seen your real field values in the console log.
──────────────────────────────────────────────────────── */
const NEW_PROVIDER_WINDOW_DAYS = 7;
const NEW_KEYWORDS = ["new", "pending", "unverified", "started", "verification_pending", "verification pending"];
const EXISTING_KEYWORDS = ["existing", "active", "approved", "verified", "completed", "verification_completed", "rejected"]
const matchesAny = (value, keywords) => {
  if (!value) return false;
  const v = String(value).toLowerCase();
  return keywords.some((k) => v.includes(k));
};
const classifyProvider = (provider) => {
  // (a) explicit role field
  if (provider.role) {
    if (matchesAny(provider.role, NEW_KEYWORDS)) return "new";
    if (matchesAny(provider.role, EXISTING_KEYWORDS)) return "existing";
  }
  // (b) approvalStage / status field
  if (provider.approvalStage) {
    if (matchesAny(provider.approvalStage, NEW_KEYWORDS)) return "new";
    if (matchesAny(provider.approvalStage, EXISTING_KEYWORDS)) return "existing";
  }
  // (c) createdAt recency fallback
  const created = provider.createdAt;
  if (created) {
    const createdDate = created.toDate ? created.toDate() : new Date(created);
    if (!isNaN(createdDate.getTime())) {
      const ageDays = (Date.now() - createdDate.getTime()) / (1000 * 60 * 60 * 24);
      return ageDays <= NEW_PROVIDER_WINDOW_DAYS ? "new" : "existing";
    }
  }
  // (d) final fallback
  return "new";
};
/* ────────────────────────────────────────────────────────
   4. SCAN + SPLIT the whole users collection
──────────────────────────────────────────────────────── */
const splitProviders = (snapshot) => {
  const newProviders = [];
  const existingProviders = [];
  snapshot.forEach((docSnap) => {
    const provider = normalizeProviderDoc(docSnap);
    const bucket = classifyProvider(provider);
    // Debug visibility — remove once field mapping is confirmed
    console.log(
      `[providerPipeline] doc=${provider.id} role=${provider.role} stage=${provider.approvalStage} -> ${bucket}`
    );
    if (bucket === "new") {
      newProviders.push(provider);
    } else {
      existingProviders.push(provider);
    }
  });
  return { newProviders, existingProviders };
};
/* ────────────────────────────────────────────────────────
   5. ONE-TIME FETCH — call on tab switch / mount
──────────────────────────────────────────────────────── */
 const fetchAllProviders = async () => {
  try {
    const usersRef = collection(db, "users");
    const snapshot = await getDocs(query(usersRef));
    return splitProviders(snapshot);
  } catch (error) {
    console.error("[providerPipeline] fetchAllProviders failed:", error);
    return { newProviders: [], existingProviders: [] };
  }
};
/* ────────────────────────────────────────────────────────
   6. LIVE LISTENER — call once on mount, keep it subscribed
      for real-time updates across both tabs.
      Returns the unsubscribe function.
──────────────────────────────────────────────────────── */
 const subscribeToProviders = (onUpdate) => {
  const usersRef = collection(db, "users");
  const unsubscribe = onSnapshot(
    query(usersRef),
    (snapshot) => {
      const { newProviders, existingProviders } = splitProviders(snapshot);
      onUpdate({ newProviders, existingProviders });
    },
    (error) => {
      console.error("[providerPipeline] subscribeToProviders failed:", error);
      onUpdate({ newProviders: [], existingProviders: [] });
    }
  );
  return unsubscribe;
};
const [isLoadingCustomerList, setIsLoadingCustomerList] = useState(false);
const [isLoadingBookingRecords, setIsLoadingBookingRecords] = useState(false);
const [subBookingRecords, setSubBookingRecords] = useState({}); // ✅ ADD THIS
const [subBookingCounts, setSubBookingCounts] = useState({}); // ✅ NEW: { [userId]: count } from users/{id}/MyBooking
const handleRefreshCustomerList = async () => {
  setIsLoadingCustomerList(true);
  try {
    const snapshot = await getDocs(collection(db, "users"));
    const users = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setCustomerList(users);
    // ✅ Fetch MyBooking subcollection count + records for each user
    const counts = {};
    const records = {}; // ✅ ADDED
    await Promise.all(
      users.map(async (u) => {
        const normalizedId = String(u.id).trim().toLowerCase();
        try {
          const subSnap = await getDocs(collection(db, "users", u.id, "MyBooking"));
          counts[normalizedId] = subSnap.size;
          // ✅ ADDED: store actual booking docs, not just the count
          records[normalizedId] = subSnap.docs.map((d) => ({
            docId: d.id,
            customerId: u.id, // ensure customerId is present for downstream matching/merging
            ...d.data(),
          }));
        } catch (subErr) {
          console.error(`Failed to fetch MyBooking for user ${u.id}:`, subErr);
          counts[normalizedId] = 0;
          records[normalizedId] = []; // ✅ ADDED
        }
      })
    );
    setSubBookingCounts(counts);
    setSubBookingRecords(records); // ✅ ADDED — this was missing entirely before
  } catch (err) {
    console.error("Failed to refresh customer list:", err);
    alert("Failed to refresh customer list: " + err.message);
  } finally {
    setIsLoadingCustomerList(false);
  }
};
// ============================================
// ✅ FIXED: handleRefreshBookingRecords — allFields is derived via
// useMemo from workOrders, so it recalculates automatically.
// No need to manually build fieldSet or call setAllFields here.
// ============================================
const handleRefreshBookingRecords = async () => {
  setIsLoadingBookingRecords(true);
  try {
    const snapshot = await getDocs(collection(db, "Booking")); // adjust collection name if different
    const bookings = snapshot.docs.map(doc => ({ docId: doc.id, ...doc.data() }));
    setWorkOrders(bookings); // allFields useMemo recalculates automatically from this
  } catch (err) {
    console.error("Failed to refresh booking records:", err);
    alert("Failed to refresh booking records: " + err.message);
  } finally {
    setIsLoadingBookingRecords(false);
  }
};
// ============================================
// ✅ Fetch booking records automatically on mount
// (previously only ran when the Refresh button was manually clicked,
// so the table was empty until a user clicked Refresh)
// ============================================
useEffect(() => {
  handleRefreshBookingRecords();
}, []);

// ---------- BALANCE READ (unchanged — still useful for local array sums) ----------
function getWalletBalanceForCustomer(ledger, targetId) {
  const normalizedTarget = normalizeWalletId(targetId);
  return (ledger || [])
    .filter((entry) => normalizeWalletId(entry.customerId) === normalizedTarget)
    .reduce((balance, entry) => {
      if (entry.entryType === "issue") return balance + Number(entry.amount || 0);
      if (entry.entryType === "redeem") return balance - Number(entry.amount || 0);
      return balance;
    }, 0);
}//Customer List//
// For Customer List (already existed, kept as is)
const [customerListExpanded, setCustomerListExpanded] = useState(false);
const [customerListPageSize, setCustomerListPageSize] = useState(25);
// For Booking Records (NEW - add these)
const [bookingRecordsExpanded, setBookingRecordsExpanded] = useState(false);
const [bookingRecordsPageSize, setBookingRecordsPageSize] = useState(25);
// Voucher and Credit Handles in Customer List
/* ============================================================
   ✅ WALLET MODULE — STATE + HANDLERS (FIXED)
   Paste these hooks + functions directly INSIDE your component body,
   at the same level as your other state (customerList, workOrders, etc).
   ROOT CAUSE OF THE PREVIOUS CRASH:
   Handlers were written to accept a `deps` object: handleIssueTopUpCredit(deps).
   But JSX called it as onClick={handleIssueTopUpCredit} — React auto-passes
   the click SyntheticEvent as the first argument, so `deps` was actually the
   event, `deps.topUpDraft` was undefined, and `.customerId` on undefined threw.
   FIX: every handler below is now a plain function that closes over
   component state directly (like handleCommitChanges / handleDraftMutation
   already do elsewhere in this file). None of them take a deps argument,
   so onClick={handleIssueTopUpCredit} works safely even though React passes
   an event object — the function simply ignores it.
   ============================================================ */

// ---------- STORAGE KEYS ----------
const WALLET_LEDGER_KEY = "walletTopUpLedger";        // credit transaction history (issue + redeem)
const VOUCHER_REGISTRY_KEY = "walletVoucherRegistry"; // vouchers issued/used/expired
const REVERSAL_LEDGER_KEY = "walletReversalLedger";   // refund history
const ACTIVITY_TRAIL_KEY = "walletActivityTrail";     // unified notes/support/refund/credit/booking log
const [showWalletModule, setShowWalletModule] = useState(false);
const [walletActiveCustomer, setWalletActiveCustomer] = useState(null);
const [walletActiveTab, setWalletActiveTab] = useState("overview");
const [walletLedger, setWalletLedger] = useState(() => {
  try { return JSON.parse(localStorage.getItem(WALLET_LEDGER_KEY) || "[]"); } catch { return []; }
});
const [voucherRegistry, setVoucherRegistry] = useState(() => {
  try { return JSON.parse(localStorage.getItem(VOUCHER_REGISTRY_KEY) || "[]"); } catch { return []; }
});
const [reversalLedger, setReversalLedger] = useState(() => {
  try { return JSON.parse(localStorage.getItem(REVERSAL_LEDGER_KEY) || "[]"); } catch { return []; }
});
const [activityTrail, setActivityTrail] = useState(() => {
  try { return JSON.parse(localStorage.getItem(ACTIVITY_TRAIL_KEY) || "[]"); } catch { return []; }
});
const [topUpDraft, setTopUpDraft] = useState({});
const [reversalDraft, setReversalDraft] = useState({});
// ---------- PURE HELPERS (no state access — safe as free functions) ----------
function normalizeWalletId(value) {
  return String(value ?? "").trim().toLowerCase();
}
function getTotalWalletBalanceAcrossAllCustomers(ledger) {
  return (ledger || []).reduce((balance, entry) => {
    if (entry.entryType === "issue") return balance + Number(entry.amount || 0);
    if (entry.entryType === "redeem") return balance - Number(entry.amount || 0);
    return balance;
  }, 0);
}
function getTotalTopUpsIssued(ledger) {
  return (ledger || [])
    .filter((entry) => entry.entryType === "issue")
    .reduce((sum, entry) => sum + Number(entry.amount || 0), 0)
    .toFixed(2);
}
function getReversalCountsByCustomer(ledger) {
  return (ledger || []).reduce((counts, entry) => {
    const key = normalizeWalletId(entry.customerId);
    counts[key] = (counts[key] || 0) + 1;
    return counts;
  }, {});
}
/* ============================================================
   Everything below assumes it is defined INSIDE your component
   (same scope as walletLedger, setWalletLedger, topUpDraft,
   setTopUpDraft, walletActiveCustomer, etc — exactly like
   handleCommitChanges / handlePurgeClient already do in this file).
   Copy these in as-is. Do NOT pass a deps argument at the call site.
   ============================================================ */
// ---------- ActivityTrail logger ----------
function logActivityTrailEntry({ customerId, customerName, activityCategory, summary, staffHandle }) {
  try {
    const stored = JSON.parse(localStorage.getItem(ACTIVITY_TRAIL_KEY) || "[]");
    const entry = {
      id: `trail_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
      customerId: String(customerId || "").trim(),
      customerName: customerName || "",
      activityCategory,
      summary,
      staffHandle: staffHandle || "Unknown",
      occurredAt: new Date().toISOString()
    };
    stored.unshift(entry);
    localStorage.setItem(ACTIVITY_TRAIL_KEY, JSON.stringify(stored));
    setActivityTrail(stored);
    return entry;
  } catch (err) {
    console.error("ActivityTrail log error:", err);
    return null;
  }
}
// ---------- REDEEM CREDIT AT CHECKOUT ----------
// Wired as: onClick={() => handleRedeemTopUpCreditAtCheckout({ customerId, customerName, amount, bookingId, staffHandle })}
function handleRedeemTopUpCreditAtCheckout({ customerId, customerName, amount, bookingId, staffHandle }) {
  const normalizedId = normalizeWalletId(customerId);
  const currentBalance = getWalletBalanceForCustomer(walletLedger, normalizedId);
  if (Number(amount) > currentBalance) {
    alert("Redemption amount exceeds available wallet balance.");
    return false;
  }
  const newEntry = {
    id: `topup_${Date.now()}`,
    customerId: String(customerId || "").trim(),
    customerName,
    entryType: "redeem",
    amount: Number(amount),
    reasonCode: "Checkout Redemption",
    bookingId: bookingId || "",
    staffHandle: staffHandle || "System",
    transactionDate: new Date().toISOString()
  };
  const updatedLedger = [newEntry, ...walletLedger];
  setWalletLedger(updatedLedger);
  localStorage.setItem(WALLET_LEDGER_KEY, JSON.stringify(updatedLedger));
  logActivityTrailEntry({
    customerId,
    customerName,
    activityCategory: "TopUp",
    summary: `₹${Number(amount).toFixed(2)} redeemed at checkout against booking ${bookingId || "-"}.`,
    staffHandle: staffHandle || "System"
  });

  return true;
}
// ---------- VOUCHER (PromoCode) REGISTRY ----------
function handleIssueVoucher({ customerId, customerName, discountAmount, expiryDate }) {
  const newVoucher = {
    id: `voucher_${Date.now()}`,
    voucherCode: `PROMO-${Math.random().toString(36).slice(2, 8).toUpperCase()}`,
    customerId: String(customerId || "").trim(),
    customerName,
    voucherStatus: "Unused",           // Used / Unused / Expired
    dateIssued: new Date().toISOString(),
    expiryDate: expiryDate || "",
    discountAmount: discountAmount || "",
    redeemedBookingId: ""
  };
  const updated = [newVoucher, ...voucherRegistry];
  setVoucherRegistry(updated);
  localStorage.setItem(VOUCHER_REGISTRY_KEY, JSON.stringify(updated));
  return newVoucher;
}
function handleRedeemVoucherAgainstBooking(voucherId, bookingId) {
  const updated = voucherRegistry.map((v) =>
    v.id === voucherId ? { ...v, voucherStatus: "Used", redeemedBookingId: bookingId } : v
  );
  setVoucherRegistry(updated);
  localStorage.setItem(VOUCHER_REGISTRY_KEY, JSON.stringify(updated));
}
function markExpiredVouchers() {
  const now = new Date();
  const updated = voucherRegistry.map((v) => {
    if (v.voucherStatus === "Unused" && v.expiryDate && new Date(v.expiryDate) < now) {
      return { ...v, voucherStatus: "Expired" };
    }
    return v;
  });
  setVoucherRegistry(updated);
  localStorage.setItem(VOUCHER_REGISTRY_KEY, JSON.stringify(updated));
}
// ---------- BOOKING / SUPPORT ACTIVITY LOGGING ----------
function logBookingActionToActivityTrail({ customerId, customerName, actionSummary, staffHandle }) {
  return logActivityTrailEntry({ customerId, customerName, activityCategory: "BookingAction", summary: actionSummary, staffHandle });
}
function logSupportConversationToActivityTrail({ customerId, customerName, conversationSummary, staffHandle }) {
  return logActivityTrailEntry({ customerId, customerName, activityCategory: "SupportConversation", summary: conversationSummary, staffHandle });
}
const [noteAuthors, setNoteAuthors] = useState({});
const [expandedTxnRow, setExpandedTxnRow] = useState(null);
// Promotions module state
const [showPromotionsModule, setShowPromotionsModule] = useState(false);
const [showNewCampaignForm, setShowNewCampaignForm] = useState(false);
const [campaignDraft, setCampaignDraft] = useState({ type: "birthday", status: "Draft" });
const [campaigns, setCampaigns] = useState(() => {
  try { return JSON.parse(localStorage.getItem("promoCampaigns") || "[]"); }
  catch { return []; }
});
const [promoNotifications, setPromoNotifications] = useState(() => {
  try { return JSON.parse(localStorage.getItem("promoNotifications") || "[]"); }
  catch { return []; }
});
const tableHeaderStyleLight = {
  padding: "8px 10px",
  fontSize: "11px",
  fontWeight: "700",
  color: "#6B7280",
  textAlign: "left",
  textTransform: "uppercase",
  borderBottom: "1px solid #E5E7EB",
  whiteSpace: "nowrap"
};
function formatDobDisplay(dob) {
  if (!dob) return "-";
  try {
    const d = new Date(dob);
    if (isNaN(d.getTime())) return "-";
    return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch { return "-"; }
}
function getDaysUntilNextBirthday(dob) {
  if (!dob) return null;
  const birth = new Date(dob);
  if (isNaN(birth.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  let next = new Date(today.getFullYear(), birth.getMonth(), birth.getDate());
  if (next < today) next = new Date(today.getFullYear() + 1, birth.getMonth(), birth.getDate());
  const diffMs = next - today;
  return Math.round(diffMs / (1000 * 60 * 60 * 24));
}
function getUpcomingBirthdays(customerList, withinDays = 30) {
  return customerList
    .filter(c => c.dob)
    .map(c => ({ ...c, daysUntil: getDaysUntilNextBirthday(c.dob) }))
    .filter(c => c.daysUntil !== null && c.daysUntil <= withinDays)
    .sort((a, b) => a.daysUntil - b.daysUntil);
}
const scheduleBirthdayNotification = (customer) => {
  const targetId = String(customer.customerId || customer.id || "").trim().toLowerCase();
  const birth = new Date(customer.dob);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  let nextBirthday = new Date(today.getFullYear(), birth.getMonth(), birth.getDate());
  if (nextBirthday < today) nextBirthday = new Date(today.getFullYear() + 1, birth.getMonth(), birth.getDate());
  // Schedule ~1 month (30 days) before the birthday
  const notifyDate = new Date(nextBirthday);
  notifyDate.setDate(notifyDate.getDate() - 30);
  if (notifyDate < today) notifyDate.setTime(today.getTime()); // don't schedule in the past
  const newNotification = {
    id: Date.now(),
    customerId: targetId,
    customerName: customer.name || customer.customerId,
    dob: customer.dob,
    type: "birthday_reminder",
    notifyDate: notifyDate.toISOString(),
    birthdayDate: nextBirthday.toISOString(),
    message: "🎉 10% OFF on Birthday Booking — reminder scheduled",
    status: "scheduled",
    createdAt: new Date().toISOString()
  };
  try {
    const updated = [newNotification, ...promoNotifications];
    setPromoNotifications(updated);
    localStorage.setItem("promoNotifications", JSON.stringify(updated));
    alert(`Birthday reminder scheduled for ${customer.name || customer.customerId} on ${notifyDate.toLocaleDateString()}`);
  } catch (err) {
    console.error("Schedule notification error:", err);
    alert("Failed to schedule notification: " + err.message);
  }
};
const cancelPromoNotification = (id) => {
  try {
    const updated = promoNotifications.filter(n => n.id !== id);
    setPromoNotifications(updated);
    localStorage.setItem("promoNotifications", JSON.stringify(updated));
  } catch (err) {
    console.error("Cancel notification error:", err);
  }
};
const handleSaveCampaign = () => {
  if (!campaignDraft.title || !campaignDraft.title.trim()) {
    return alert("Please enter a campaign title");
  }
  const newCampaign = {
    id: Date.now(),
    title: campaignDraft.title.trim(),
    discount: campaignDraft.discount || "",
    type: campaignDraft.type || "birthday",
    status: campaignDraft.status || "Draft",
    startDate: campaignDraft.startDate || "",
    endDate: campaignDraft.endDate || "",
    description: campaignDraft.description || "",
    createdAt: new Date().toISOString()
  };
  try {
    const updated = [newCampaign, ...campaigns];
    setCampaigns(updated);
    localStorage.setItem("promoCampaigns", JSON.stringify(updated));
    setCampaignDraft({ type: "birthday", status: "Draft" });
    setShowNewCampaignForm(false);
  } catch (err) {
    console.error("Save campaign error:", err);
    alert("Failed to save campaign: " + err.message);
  }
};
const handleDeleteCampaign = (id) => {
  if (!window.confirm("Delete this campaign?")) return;
  try {
    const updated = campaigns.filter(c => c.id !== id);
    setCampaigns(updated);
    localStorage.setItem("promoCampaigns", JSON.stringify(updated));
  } catch (err) {
    console.error("Delete campaign error:", err);
  }
};
const isTestProviderCheck = (item) => {
  if (!item) return false;
  if (item.isTestProvider === true) return true;
  if (typeof item.mode === "string" && item.mode.toLowerCase() === "test") return true;
  if (typeof item.environment === "string" && item.environment.toLowerCase() === "test") return true;
  const name = `${item.firstName || ""} ${item.lastName || ""}`.toLowerCase();
  const email = (item.email || "").toLowerCase();
  if (name.includes("test") || email.includes("test")) return true;
  return false;
}
const [noteInputs, setNoteInputs] = useState({});
const [noteLogs, setNoteLogs] = useState([]);
const [isSavingNote, setIsSavingNote] = useState(false);
const [selectedNoteCustomer, setSelectedNoteCustomer] = useState(null);
useEffect(() => {
try {
const storedNotes = JSON.parse(localStorage.getItem("customerNotes") || "{}");
if (Object.keys(storedNotes).length && typeof setCustomerList === 'function') {
setCustomerList(prev => prev.map(c => {
const key = String(c.customerId || c.id || "").trim().toLowerCase();
return storedNotes[key] ? {...c, notes: storedNotes[key]} : c;
}));
}
} catch (err) {
console.error("Failed to hydrate notes from localStorage:", err);
}
}, []);//Customer List Notes//
const [selectedTransactionCustomer, setSelectedTransactionCustomer] = useState(null);
const [selectedTransactionBookings, setSelectedTransactionBookings] = useState([]);
const tableDataStyle = { border: "1px solid #ddd", padding: "10px", verticalAlign: "top", whiteSpace: "nowrap", fontSize: "13px" };
const [workOrders, setWorkOrders] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  useEffect(() => {
    fetchWorkOrders();
  }, []);
  const fetchWorkOrders = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "Booking"));
      const jobs = querySnapshot.docs.map((doc) => ({
        docId: doc.id,
        ...doc.data(),
      }));
      console.log("Work Orders:", jobs);
      setWorkOrders(jobs); // allFields useMemo recalculates automatically from this
    } catch (error) {
      console.error("Error loading work orders:", error);
    } finally {
      setIsFetching(false);
    }
  };
  const formatCellValue = (value) => {
    if (value instanceof Timestamp) {
      return value.toDate().toLocaleString();
    }
    if (Array.isArray(value)) {
      return value.length? JSON.stringify(value) : "[]";
    }
    if (value && typeof value === "object") {
      return JSON.stringify(value);
    }
    if (value === null) return "null";
    if (value === undefined) return "-";
    return String(value);
  };
  const allFields = useMemo(() => {
    if (!workOrders.length) return [];
    return [...new Set(workOrders.flatMap((job) => Object.keys(job)))];
  }, [workOrders]);
  const customerProfiles = useMemo(() => {
    const customerMap = new Map();
    workOrders.forEach((job) => {
      if (!job.customerId) return;
      if (!customerMap.has(job.customerId)) {
        customerMap.set(job.customerId, {
          clientId: job.customerId,
          clientName: job.customerName,
          displayName: job.fullName,
          emailAddress: job.customerEmail,
          location: job.address,
          totalJobs: 1,
        });
      } else {
        customerMap.get(job.customerId).totalJobs += 1;
      }
    });
    return [...customerMap.values()];
  }, [workOrders]);//Booking
const [purgedVault, setPurgedVault] = useState([]);
const [editableRowId, setEditableRowId] = useState(null);
const [draftClient, setDraftClient] = useState({});
const handleInitiateEdit = (row) => {
  setEditableRowId(row.id || row.customerId);
  setDraftClient({ ...row });
};
const handleDraftMutation = (key, val) => setDraftClient(p => ({ ...p, [key]: val }));
const handleCommitChanges = () => {
  setCustomerList(prev => prev.map(c => (c.id || c.customerId) === editableRowId ? { ...c, ...draftClient } : c));
  setEditableRowId(null);
};
const handleCancelEdit = () => { setEditableRowId(null); setDraftClient({}); };
const handlePurgeClient = (row) => {
  if (!window.confirm(`Delete ${row.name}?`)) return;
  setPurgedVault(p => [...p, row]);
  setCustomerList(prev => prev.filter(c => (c.id || c.customerId) !== (row.id || row.customerId)));
};
const handleRestoreArchive = () => {
  setCustomerList(prev => [...prev, ...purgedVault]);
  setPurgedVault([]);
};
const [dashboardZoom, setDashboardZoom] = useState(1.00);
// ================= CONFIG =================
const EXCLUDED_COLUMNS = ["recordId", "id", "object", "currency", "docType", "_internalId", "totalAmountPaid", "application_fee"];
const IMPORTANT_COLUMNS = ["customerId","bookingId","providerPayout","amount_captured","platformFee","paymentMethod","providerPayoutId"];
// Display name mapping
const COLUMN_DISPLAY_NAMES = {
  amount_captured: "Customer Total Amount",
  providerPayout: "Provider Payout",
};
const getColumnDisplayName = (col) => COLUMN_DISPLAY_NAMES[col] || col;
const isEmptyValue = (v) => {
  if (v === null || v === undefined) return true;
  const s = String(v).trim();
  return s === "" || s === "-" || s.toLowerCase() === "null" || s.toLowerCase() === "undefined";
};
// ================= STATE =================
const [ledgerEntries, setLedgerEntries] = useState([]);
const [gridColumns, setGridColumns] = useState([]);
const [isLoadingLedger, setIsLoadingLedger] = useState(false);
const [loadingError, setLoadingError] = useState("");
const [ledgerTextFilter, setLedgerTextFilter] = useState("");
const [columnFilterValues, setColumnFilterValues] = useState({});
const updateColumnFilterValue = (column, value) => setColumnFilterValues(prev => ({...prev, [column]: value}));
const clearAllColumnFilters = () => { setColumnFilterValues({}); setLedgerTextFilter(""); };
const stringifyForFilterMatch = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "object") { try { return JSON.stringify(value).toLowerCase(); } catch { return ""; } }
  return String(value).toLowerCase();
};
// ================= PRIORITY ORDER =================
// Order: Booking -> Customer -> Payment -> Amounts -> Payouts
const frontPriorityColumnOrder = [
  "bookingId",
  "customerId",
  "customer", // customer Name
  "paymentMethod",
  "payment_method_details",
  "paymentStatus",
  "payment_intent",
  "amount_captured",
  "serviceAmount",
  "platformFee",
  "application_fee_amount",
  "stripeProcessingFee",
  "totalRevenue",
  "totalApplicationFees",
  "totalRefunded",
  "balance",
  "providerPayout",
  "providerPayoutId",
  "payoutsProcessed"
];
const backPriorityColumnOrder = ["chargesCount","amount"];
const orderedGridColumns = useMemo(() => {
  const filteredGrid = gridColumns.filter(col =>!EXCLUDED_COLUMNS.includes(col));
  const front = frontPriorityColumnOrder.filter(c => filteredGrid.includes(c));
  const back = backPriorityColumnOrder.filter(c => filteredGrid.includes(c));
  const placed = new Set([...front,...back]);
  const remaining = filteredGrid.filter(c =>!placed.has(c));
  return [...front,...remaining,...back];
}, [gridColumns]);
const filteredLedgerEntries = useMemo(() => {
  let result = ledgerEntries;
  if (ledgerTextFilter.trim()!== "") {
    const q = ledgerTextFilter.trim().toLowerCase();
    result = result.filter(entry => orderedGridColumns.some(col => stringifyForFilterMatch(entry[col]).includes(q)));
  }
  const active = Object.keys(columnFilterValues).filter(c => columnFilterValues[c]?.trim()!== "");
  if (active.length > 0) {
    result = result.filter(entry => active.every(col => stringifyForFilterMatch(entry[col]).includes(columnFilterValues[col].trim().toLowerCase())));
  }
  return result;
}, [ledgerEntries, ledgerTextFilter, columnFilterValues, orderedGridColumns]);
// ================= REMOVE BLANK + SPARSE ROWS =================
const cleanedLedgerEntries = useMemo(() => {
  const list = filteredLedgerEntries || [];
  return list.filter((entry) => {
    if (!entry || typeof entry!== 'object') return false;
    if (isEmptyValue(entry.bookingId)) return false;
    if (isEmptyValue(entry.customerId)) return false;
    const meaningfulFields = Object.entries(entry).filter(([k, v]) => {
      if (EXCLUDED_COLUMNS.includes(k)) return false;
      if (k === '_internalId') return false;
      return!isEmptyValue(v);
    });
    if (meaningfulFields.length < 3) return false;
    return true;
  });
}, [filteredLedgerEntries]);
const visibleGridColumns = useMemo(() => {
  if (cleanedLedgerEntries.length === 0) return orderedGridColumns;
  return orderedGridColumns.filter(col => cleanedLedgerEntries.some(e =>!isEmptyValue(e[col])));
}, [cleanedLedgerEntries, orderedGridColumns]);
// ================= CURRENCY =================
const currencyFieldNames = ["amount","amount_captured","amount_refunded","application_fee_amount","balance","platformFee","serviceAmount","stripeProcessingFee","totalRevenue","totalApplicationFees","totalRefunded","providerPayout"];
const alreadyConvertedFieldNames = ["Customer Payout","platformFee","stripeProcessingFee","serviceAmount","totalRevenue","totalRefunded","totalApplicationFees","providerPayout"];
const formatCurrencyValue = (rawValue, column) => {
  const n = Number(rawValue);
  if (Number.isNaN(n)) return String(rawValue);
  const isRaw =!alreadyConvertedFieldNames.includes(column);
  const val = isRaw? n / 100 : n;
  return val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
useEffect(() => { fetchTransactionLedger(); }, []);
// ================= FETCH - FILTER AT SOURCE =================
const fetchTransactionLedger = async () => {
  try {
    setIsLoadingLedger(true);
    setLoadingError("");
    const snap = await getDocs(collection(db, "Stripe_Payment_Transcations"));
    const data = [];
    const cols = new Set();
    snap.forEach(docSnap => {
      const doc = docSnap.data();
      if (!doc || Object.keys(doc).length === 0) return;
      const metadata = doc.metadata || {};
      const normalized = {...doc };
      if (metadata.provider_payout) normalized.providerPayout = metadata.provider_payout;
      if (metadata.provider_id) normalized.providerPayoutId = metadata.provider_id;
      if (doc.docType === "payout") delete normalized.amount;
      if (isEmptyValue(normalized.bookingId)) {
        console.log("Skipping blank doc (no bookingId):", docSnap.id);
        return;
      }
      if (isEmptyValue(normalized.customerId)) {
        console.log("Skipping blank doc (no customerId):", docSnap.id);
        return;
      }
      const hasImportantData = IMPORTANT_COLUMNS.some(col =>!isEmptyValue(normalized[col]));
      if (!hasImportantData) {
        console.log("Skipping blank doc:", docSnap.id);
        return;
      }
      data.push({ _internalId: docSnap.id,...normalized });
      Object.keys(normalized).forEach(f => {
        if (!EXCLUDED_COLUMNS.includes(f) &&!isEmptyValue(f)) cols.add(f);
      });
    });
    console.log("Loaded valid records:", data.length, "Filtered:", snap.size - data.length);
    setLedgerEntries(data);
    setGridColumns([...Array.from(cols)]);
  } catch (e) {
    console.error(e);
    setLoadingError(e.message);
  } finally {
    setIsLoadingLedger(false);
  }
};
const formatLedgerCellDisplay = (value, column) => {
  if (isEmptyValue(value)) return "-";
  if (currencyFieldNames.includes(column) &&!isNaN(parseFloat(value))) return formatCurrencyValue(value, column);
  if (typeof value === "boolean") return value? "Yes" : "No";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
};
const getLedgerCellStyle = (column) => ({
  padding: "12px 16px", fontSize: "13px",
  color: column === "bookingId"? "#0747A6" : "#374151",
  fontWeight: column === "bookingId"? "700" : "400",
  background: column === "bookingId"? "#EEF2FF" : "transparent",
  whiteSpace: "nowrap", maxWidth: "220px", overflow: "hidden", textOverflow: "ellipsis"
});
const [boardZoomLevel, setBoardZoomLevel] = useState(100);
const cycleBoardZoom = (level) => {
  setBoardZoomLevel(level);
};
// Only column WIDTH changes — card content always full size
const getBoardColumnWidth = (zoom) => {
  if (zoom === 25) return 120;
  if (zoom === 50) return 200;
  if (zoom === 75) return 248;
  return 290; // 100%
};//Board View for Provider Pipeline
const [draggedProvider, setDraggedProvider] = useState(null);
const [providerDrawerVisible, setProviderDrawerVisible] = useState(false);
{/* =========================================
   DRAG STATE
========================================= */}
const [draggingProvider, setDraggingProvider] = useState(null);//Kanban//
const [pipelineDraggingCard, setPipelineDraggingCard] =
  useState(null);
const [pipelineHoveredStage, setPipelineHoveredStage] =
  useState(null);
  {/* ============================================================
    PIPELINE STAGE TRANSITION ENGINE
============================================================ */}
const executeProviderStagePromotion = async (
  transitionDirection
) => {
  try {
    if (!providerInspectionRecord) return;
    const currentStageIndex = PIPELINE_STAGES.findIndex(
      (stage) =>
        stage.id.toLowerCase() ===
        (
          providerInspectionRecord.approvalStage ||
          "New Provider"
        ).toLowerCase()
    );
    let destinationStage = null;
    /* ============================================================
        ADVANCE TO NEXT STAGE
    ============================================================ */
    if (transitionDirection === "forward") {
      const nextStage =
        PIPELINE_STAGES[currentStageIndex + 1];
      if (nextStage) {
        destinationStage = nextStage.id;
      }
    }
    /* ============================================================
        MOVE TO REJECTED STAGE
    ============================================================ */
    if (transitionDirection === "rejected") {
      destinationStage = "Rejected";
    }
    if (!destinationStage) return;
    /* ============================================================
        UPDATE LOCAL BOARD DATA
    ============================================================ */
    const refreshedPipelineRecords =
      pipelineBoardRecords.map((record) => {
        if (record.id === providerInspectionRecord.id) {
          return {
            ...record,
            approvalStage: destinationStage,
          };
        }
        return record;
      });
    setPipelineBoardRecords(refreshedPipelineRecords);
    /* ============================================================
        UPDATE ACTIVE DRAWER RECORD
    ============================================================ */
    setProviderInspectionRecord((previousRecord) => ({
      ...previousRecord,
      approvalStage: destinationStage,
    }));
    /* ============================================================
        OPTIONAL FIREBASE UPDATE
    ============================================================ */
    // await updateDoc(
    //   doc(db, "providers", providerInspectionRecord.id),
    //   {
    //     approvalStage: destinationStage,
    //     updatedAt: serverTimestamp(),
    //   }
    // );
    console.log(
      `Provider moved to ${destinationStage}`
    );
  } catch (error) {
    console.log(
      "Provider stage transition failed:",
      error
    );
  }
};//Board //
const [providerInspectionRecord, setProviderInspectionRecord] = useState(null);
const [providerDetailTab, setProviderDetailTab] = useState("overview");
const [kanbanZoom, setKanbanZoom] = useState(100);
const [providerPipelineCards, setProviderPipelineCards] = useState([
  {
    id: "UG001",
    providerDisplayName: "Rahul Kumar",
    serviceCategory: "Electrician",
    serviceLocation: "Hyderabad",
    device: "Android",
    status: "verification_pending",
    // Added according to upload/verification handle logic
    documentUploaded: true,
    verificationCompleted: false,
    documents: [],
  },
  {
    id: "UG002",
    providerDisplayName: "Sarah Johnson",
    serviceCategory: "Cleaning",
    serviceLocation: "Manchester",
    device: "Android",
    status: "verification_started",
    documentUploaded: true,
    verificationCompleted: false,
    documents: [],
  },
  {
    id: "UG003",
    providerDisplayName: "Michael Brown",
    serviceCategory: "Electrical",
    serviceLocation: "Birmingham",
    device: "Web",
    status: "approved",
    documentUploaded: true,
    verificationCompleted: true,
    documents: [],
  },
  {
    id: "UG004",
    providerDisplayName: "Emma Wilson",
    serviceCategory: "Painting",
    serviceLocation: "Liverpool",
    device: "Android",
    status: "rejected",
    documentUploaded: true,
    verificationCompleted: false,
    documents: [],
  },
  {
    id: "UG005",
    providerDisplayName: "David Lee",
    serviceCategory: "HVAC",
    serviceLocation: "Leeds",
    device: "iOS",
    status: "verification_completed",
    documentUploaded: true,
    verificationCompleted: true,
    documents: [],
  },
]);
const INITIAL_PARTNERS = [
  {
    id: "1",
    rowId: "1",
    providerDisplayName: "Sarah Johnson",
    serviceCategory: "Cleaning",
    serviceLocation: "London",
    approvalStage: "New Provider",
    status: "New Provider",
    device: "iOS",
  },
  {
    id: "2",
    rowId: "2",
    providerDisplayName: "Michael Brown",
    serviceCategory: "Plumbing",
    serviceLocation: "Manchester",
    approvalStage: "Pending Verification",
    status: "Pending Verification",
    device: "Android",
  },
  {
    id: "3",
    rowId: "3",
    providerDisplayName: "Emma Wilson",
    serviceCategory: "Electrical",
    serviceLocation: "Liverpool",
    approvalStage: "Verification Started",
    status: "Verification Started",
    device: "Web",
  },
  {
    id: "4",
    rowId: "4",
    providerDisplayName: "James Smith",
    serviceCategory: "Painting",
    serviceLocation: "Birmingham",
    approvalStage: "Verification Completed",
    status: "Verification Completed",
    device: "iOS",
  },
  {
    id: "5",
    rowId: "5",
    providerDisplayName: "Sophia Taylor",
    serviceCategory: "Handyman",
    serviceLocation: "Leeds",
    approvalStage: "Approved",
    status: "Approved",
    device: "Android",
  },
];
const PIPELINE_STAGES = [
  {
    id: "New Provider",
    label: "New Provider",
  },
  {
    id: "Pending Verification",
    label: "Pending Verification",
  },
  {
    id: "Verification Started",
    label: "Verification Started",
  },
  {
    id: "Verification Completed",
    label: "Verification Completed",
  },
  {
    id: "Internal Review",
    label: "Internal Review",
  },
  {
    id: "Approved",
    label: "Approved",
  },
  {
    id: "Rejected",
    label: "Rejected",
  },
];
const [profileDrawerOpen, setProfileDrawerOpen] = useState(false);
const [providerSnapshot, setProviderSnapshot] = useState(null);
// ─────────────────────────────────────────────
//  PROVIDER VERIFICATION PIPELINE — HANDLERS
//  New terminology; drop these into your component
// ─────────────────────────────────────────────
const [pipelineViewMode, setPipelineViewMode] = useState("kanban"); // "kanban" | "table"
const [providerViewMode, setProviderViewMode] = useState("board");
const [providerPanelTab, setProviderPanelTab] = useState("profile");
const [pipelineBoardRecords, setPipelineBoardRecords] = useState([]);
const [toastMessage, setToastMessage] = useState("");
const [dragPipelineCard, setDragPipelineCard] = useState(null);
const [draggingRecord, setDraggingRecord] = useState(null);
const [focusedProvider, setFocusedProvider] = useState(null);
const [drawerActiveTab, setDrawerActiveTab] = useState("Profile");
const [columnSizeMap, setColumnSizeMap] = useState({});
const [providerSearchTerm, setProviderSearchTerm] = useState("");
 
// ── 1. Switch between Board View and Table View ──
const switchPipelineView = (mode) => {
  setPipelineViewMode(mode);
};
 
// ── 2. Open provider detail drawer ──────────────
const openProviderDrawer = (providerRefOrId) => {
  const match = pipelineBoardRecords.find(
    (r) =>
      (r.serviceReference || r.id) === providerRefOrId
  );
  if (match) {
    setFocusedProvider(match);
    setDrawerActiveTab("Profile");
  }
};
 
// ── 3. Open drawer from table row click ─────────
const selectTableRow = (rowData) => {
  setFocusedProvider(rowData);
  setDrawerActiveTab("Profile");
};
 
// ── 4. Close the detail drawer ──────────────────
const closeProviderDrawer = () => {
  setFocusedProvider(null);
};
 
// ── 5. Switch tabs inside the drawer ────────────
const switchDrawerTab = (tabName) => {
  setDrawerActiveTab(tabName);
};
 
// ── 6. Drag-start on a kanban card ──────────────
const beginCardDrag = (record) => {
  setDraggingRecord(record);
};
 
// ── 7. Drop card into a new pipeline stage ──────
const dropCardOnStage = (targetStageId) => {
  if (!draggingRecord) return;
  setPipelineBoardRecords((prev) =>
    prev.map((r) =>
      (r.rowId || r.id) === (draggingRecord.rowId || draggingRecord.id)
        ? { ...r, approvalStage: targetStageId, status: targetStageId }
        : r
    )
  );
  setDraggingRecord(null);
};
 
// ── 8. Toggle kanban column width ───────────────
const toggleColumnSize = (stageId) => {
  setColumnSizeMap((prev) => ({
    ...prev,
    [stageId]: prev[stageId] === "expanded" ? "default" : "expanded",
  }));
};
 
// ── 9. Resolve column width string from state ───
const resolveColumnWidth = (stageId) => {
  return columnSizeMap[stageId] === "expanded" ? "340px" : "240px";
};
 
// ── 10. Update provider search term ─────────────
const updateProviderSearch = (e) => {
  setProviderSearchTerm(e.target.value);
};
 
// ── 11. Move provider to next pipeline stage ────
const advanceProviderStage = (providerId) => {
  const ORDERED_STAGES = [
    "New Provider",
    "Pending Verification",
    "Verification Started",
    "Verification Completed",
    "Internal Review",
    "Approved",
  ];
  setPipelineBoardRecords((prev) =>
    prev.map((r) => {
      if ((r.serviceReference || r.id) !== providerId) return r;
      const currentIdx = ORDERED_STAGES.indexOf(
        r.approvalStage || r.status
      );
      const nextStage =
        ORDERED_STAGES[Math.min(currentIdx + 1, ORDERED_STAGES.length - 1)];
      return { ...r, approvalStage: nextStage, status: nextStage };
    })
  );
};
 
// ── 12. Reject a provider ───────────────────────
const rejectProvider = (providerId) => {
  setPipelineBoardRecords((prev) =>
    prev.map((r) =>
      (r.serviceReference || r.id) === providerId
        ? { ...r, approvalStage: "Rejected", status: "Rejected" }
        : r
    )
  );
};
//kanban//
// --- UTILITY HANDLES ---
const handleModeSwitch = (mode) => setVisualMode(mode);

const handleSearchChange = (e) => {
  setSearchKeywords(e.target.value);
  // Implement actual filtering logic here based on `e.target.value`
};

const handleEntitySelect = (record) => {
  setInspectorEntity(record);
};

const handleInspectorAction = (actionType) => {
  if (!inspectorEntity) return;
  // Logic for 'advance', 'revoke', etc.
  console.log(`Triggering ${actionType} for`, inspectorEntity.id);
};

// --- MOCK DATA HELPERS (Replace with real API calls) ---
const getEntityAvatar = (name) => ({
  initials: name ? name.substring(0, 2).toUpperCase() : "??",
  hue: (name?.charCodeAt(0) || 0) % 360,
});

const getPhaseStyling = (phaseId) => {
  const phase = WORKFLOW_PHASES.find(p => p.id === phaseId) || WORKFLOW_PHASES[0];
  return { bg: phase.colors.bg, text: phase.colors.text, label: phase.label };
};

// --- MAIN COMPONENT ---
  const [concurrentPartners, setConcurrentPartners] = useState(INITIAL_PARTNERS);
  const [presentView, setPresentView] = useState('kanban');
  const [searchQuery, setSearchQuery] = useState('');
  const [activePartnerId, setActivePartnerId] = useState(null);
  const [workflowMenu, setWorkflowMenu] = useState(null); // { x, y, partnerId }
  const [internalMemo, setInternalMemo] = useState('');
  const drawerRef = useRef(null);
  // Close context menu on click outside
  useEffect(() => {
    const handleGlobalClick = (e) => {
      if (workflowMenu) setWorkflowMenu(null);
    };
    document.addEventListener('click', handleGlobalClick);
    return () => document.removeEventListener('click', handleGlobalClick);
  }, [workflowMenu]);

  // --- HANDLERS ---

  const handleSearchUpdate = (e) => setSearchQuery(e.target.value);

  const handleViewModeSwitch = (targetView) => setPresentView(targetView);

  const handlePartnerSelection = (id) => setActivePartnerId(id);

  const handleRowSelection = (id) => setActivePartnerId(id);

  const handleCloseDetailsPanel = () => setActivePartnerId(null);

  const handleWorkflowMenuTrigger = (e, id) => {
    e.stopPropagation();
    setWorkflowMenu({ x: e.clientX, y: e.clientY, partnerId: id });
  };

  const handleWorkflowTransition = (id, newStage) => {
    setConcurrentPartners(prevList => prevList.map(entity => 
      entity.id === id ? { ...entity, status: newStage } : entity
    ));
    setWorkflowMenu(null);
  };

  const handleMemoDrafting = (e) => setInternalMemo(e.target.value);

  const handleMemoSubmission = () => {
    if (!internalMemo.trim() || !activePartnerId) return;
    setConcurrentPartners(prevList => prevList.map(entity => {
      if (entity.id === activePartnerId) {
        return {
          ...entity,
          notes: [...entity.notes, { text: internalMemo, date: new Date().toLocaleString(), author: "Super Admin" }]
        };
      }
      return entity;
    }));
    setInternalMemo('');
  };

  // --- DERIVED STATE ---

  const analytics = {
    total: concurrentPartners.length,
    new: concurrentPartners.filter(p => p.status === 'New Provider').length,
    pending: concurrentPartners.filter(p => p.status === 'Pending Verification').length,
    approved: concurrentPartners.filter(p => p.status === 'Approved').length,
    rejected: concurrentPartners.filter(p => p.status === 'Rejected').length,
  };

  const visiblePartners = concurrentPartners.filter(p => {
    const lowerQuery = searchQuery.toLowerCase();
    return !searchQuery || 
           p.name.toLowerCase().includes(lowerQuery) ||
           p.email.toLowerCase().includes(lowerQuery) ||
           p.id.toLowerCase().includes(lowerQuery) ||
           p.city.toLowerCase().includes(lowerQuery);
  });

  const activePartner = concurrentPartners.find(p => p.id === activePartnerId);
  const InfoSection = ({ title, children }) => (
  <div style={{ marginBottom: 28 }}>
    <div
      style={{
        fontSize: 15,
        fontWeight: 700,
        color: "#111827",
        marginBottom: 18,
      }}
    >
      {title}
    </div>

    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 14,
      }}
    >
      {children}
    </div>
  </div>
);
const InfoRow = ({ label, value }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "120px 1fr",
      gap: 18,
      alignItems: "start",
    }}
  >
    <div
      style={{
        fontSize: 13,
        color: "#6b7280",
      }}
    >
      {label}
    </div>

    <div
      style={{
        fontSize: 13,
        fontWeight: 500,
        color: "#111827",
        lineHeight: 1.5,
      }}
    >
      {value}
    </div>
  </div>
);
const [providerDashboardModal, setProviderDashboardModal] =
  useState(false);
const [providerDashboardModalData, setProviderDashboardModalData] =
  useState(null);
const openProviderDashboardModal = (type, data) => {
  setProviderDashboardModalData({
    type,
    data,
  });
  setProviderDashboardModal(true);
};
const closeProviderDashboardModal = () => {
  setProviderDashboardModal(false);
  setProviderDashboardModalData(null);
};
const [bookingWidth, setBookingWidth] =
  useState(100);
/* ===================================================== */
/* ✅ TALENT HUB CONTROL CENTER STATES */
/* ===================================================== */
const [
  providerIntelligenceScale,
  updateProviderIntelligenceScale,
] = useState(100);
/* ===================================================== */
/* ✅ MASTER PROVIDER REGISTRY */
/* ===================================================== */
const [
  masterProviderRegistry,
  updateMasterProviderRegistry,
] = useState([]);
/* ===================================================== */
/* ✅ FILTERED PROVIDER STREAM */
/* ===================================================== */
const [
  providerRealtimeFeed,
  updateProviderRealtimeFeed,
] = useState([]);
/* ===================================================== */
/* ✅ PROVIDER REPORT COUNTERS */
/* ===================================================== */
const [
  providerRegisteredCount,
  updateProviderRegisteredCount,
] = useState(0);
const [
  providerVerifiedCount,
  updateProviderVerifiedCount,
] = useState(0);
const [
  providerAwaitingCount,
  updateProviderAwaitingCount,
] = useState(0);
const [
  providerRestrictedCount,
  updateProviderRestrictedCount,
] = useState(0);
const [
  providerActiveCount,
  updateProviderActiveCount,
] = useState(0);
const [
  providerFreshEnrollmentCount,
  updateProviderFreshEnrollmentCount,
] = useState(0);
/* ===================================================== */
/* ✅ PROVIDER REPORT MODAL STATES */
/* ===================================================== */
const [
  providerReportModalVisible,
  updateProviderReportModalVisible,
] = useState(false);
const [
  providerReportTitle,
  updateProviderReportTitle,
] = useState("");
const [
  providerReportCollection,
  updateProviderReportCollection,
] = useState([]);
/* ===================================================== */
/* ✅ DATE FILTER STATES */
/* ===================================================== */
const [
  providerFilterStartDate,
  updateProviderFilterStartDate,
] = useState("");
const [
  providerFilterEndDate,
  updateProviderFilterEndDate,
] = useState("");
/* ===================================================== */
/* ✅ TALENT BOARD RESIZE CONTROLS */
/* ===================================================== */
const amplifyProviderIntelligenceView =
  () => {
    updateProviderIntelligenceScale(
      (currentScale) =>
        Math.min(
          currentScale + 10,
          100
        )
    );
  };
const compressProviderIntelligenceView =
  () => {
    updateProviderIntelligenceScale(
      (currentScale) =>
        Math.max(
          currentScale - 10,
          50
        )
    );
  };
/* ===================================================== */
/* ✅ LIVE PROVIDER INTELLIGENCE ENGINE */
/* ===================================================== */
useEffect(() => {
  const detachProviderObserver =
    onSnapshot(
      collection(db, "providers"),
      (snapshotPayload) => {
        const providerRegistry = [];
        let verifiedCounter = 0;
        let awaitingCounter = 0;
        let restrictedCounter = 0;
        let activeCounter = 0;
        snapshotPayload.forEach(
          (providerDocument) => {
            const providerPayload =
              providerDocument.data();
            const structuredProviderPayload =
              {
                id: providerDocument.id,
                ...providerPayload,
              };
            providerRegistry.push(
              structuredProviderPayload
            );
            /* ========================================= */
            /* ✅ PROVIDER STATUS CLASSIFICATION */
            /* ========================================= */
            if (
              providerPayload?.status?.toLowerCase() ===
              "approved"
            ) {
              verifiedCounter++;
            }
            if (
              providerPayload?.status?.toLowerCase() ===
              "pending"
            ) {
              awaitingCounter++;
            }
            if (
              providerPayload?.status?.toLowerCase() ===
              "blocked"
            ) {
              restrictedCounter++;
            }
            /* ========================================= */
            /* ✅ ACTIVE PROVIDER DETECTION */
            /* ========================================= */
            if (
              providerPayload?.online ===
                true ||
              providerPayload?.isOnline ===
                true
            ) {
              activeCounter++;
            }
          }
        );
        /* ========================================= */
        /* ✅ MASTER REGISTRY SYNCHRONIZATION */
        /* ========================================= */
        updateMasterProviderRegistry(
          providerRegistry
        );
        /* ========================================= */
        /* ✅ FILTERED FEED SYNCHRONIZATION */
        /* ========================================= */
        updateProviderRealtimeFeed(
          providerRegistry
        );
        /* ========================================= */
        /* ✅ DASHBOARD METRICS */
        /* ========================================= */
        updateProviderRegisteredCount(
          providerRegistry.length
        );
        updateProviderVerifiedCount(
          verifiedCounter
        );
        updateProviderAwaitingCount(
          awaitingCounter
        );
        updateProviderRestrictedCount(
          restrictedCounter
        );
        updateProviderActiveCount(
          activeCounter
        );
        /* ========================================= */
        /* ✅ FRESH ENROLLMENT DETECTION */
        /* ========================================= */
        const freshProviderCounter =
          providerRegistry.filter(
            (providerItem) => {
              const providerCreatedDate =
                providerItem?.createdAt
                  ?.toDate
                  ? providerItem.createdAt.toDate()
                  : new Date(
                      providerItem?.createdAt
                    );
              const currentDate =
                new Date();
              const dateDifference =
                currentDate -
                providerCreatedDate;
              const dayDifference =
                dateDifference /
                (1000 *
                  60 *
                  60 *
                  24);
              return (
                dayDifference <= 7
              );
            }
          ).length;
        updateProviderFreshEnrollmentCount(
          freshProviderCounter
        );
      }
    );
  return () =>
    detachProviderObserver();
}, []);
/* ===================================================== */
/* ✅ APPLY PROVIDER DATE FILTER */
/* ===================================================== */
const activateProviderDateFilter =
  () => {
    if (
      !providerFilterStartDate ||
      !providerFilterEndDate
    ) {
      return;
    }
    const securedStartDate =
      new Date(
        providerFilterStartDate
      );
    const securedEndDate =
      new Date(providerFilterEndDate);
    securedEndDate.setHours(
      23,
      59,
      59,
      999
    );
    const filteredProviderRegistry =
      (
        masterProviderRegistry || []
      ).filter((providerItem) => {
        const providerCreatedDate =
          providerItem?.createdAt
            ?.toDate
            ? providerItem.createdAt.toDate()
            : new Date(
                providerItem?.createdAt
              );
        return (
          providerCreatedDate >=
            securedStartDate &&
          providerCreatedDate <=
            securedEndDate
        );
      });
    updateProviderRealtimeFeed(
      filteredProviderRegistry
    );
    updateProviderRegisteredCount(
      filteredProviderRegistry.length
    );
    updateProviderVerifiedCount(
      filteredProviderRegistry.filter(
        (providerItem) =>
          providerItem?.status?.toLowerCase() ===
          "approved"
      ).length
    );
    updateProviderAwaitingCount(
      filteredProviderRegistry.filter(
        (providerItem) =>
          providerItem?.status?.toLowerCase() ===
          "pending"
      ).length
    );
    updateProviderRestrictedCount(
      filteredProviderRegistry.filter(
        (providerItem) =>
          providerItem?.status?.toLowerCase() ===
          "blocked"
      ).length
    );
    updateProviderActiveCount(
      filteredProviderRegistry.filter(
        (providerItem) =>
          providerItem?.online ===
            true ||
          providerItem?.isOnline ===
            true
      ).length
    );
    updateProviderFreshEnrollmentCount(
      filteredProviderRegistry.filter(
        (providerItem) => {
          const providerCreatedDate =
            providerItem?.createdAt
              ?.toDate
              ? providerItem.createdAt.toDate()
              : new Date(
                  providerItem?.createdAt
                );
          const currentDate =
            new Date();
          const dateDifference =
            currentDate -
            providerCreatedDate;
          const dayDifference =
            dateDifference /
            (1000 *
              60 *
              60 *
              24);

          return (
            dayDifference <= 7
          );
        }
      ).length
    );
  };
/* ===================================================== */
/* ✅ RESET PROVIDER DATE FILTER */
/* ===================================================== */
const resetProviderDateFilter =
  () => {
    updateProviderFilterStartDate(
      ""
    );
    updateProviderFilterEndDate("");
    updateProviderRealtimeFeed(
      masterProviderRegistry
    );
    updateProviderRegisteredCount(
      masterProviderRegistry.length
    );
    updateProviderVerifiedCount(
      masterProviderRegistry.filter(
        (providerItem) =>
          providerItem?.status?.toLowerCase() ===
          "approved"
      ).length
    );
    updateProviderAwaitingCount(
      masterProviderRegistry.filter(
        (providerItem) =>
          providerItem?.status?.toLowerCase() ===
          "pending"
      ).length
    );
    updateProviderRestrictedCount(
      masterProviderRegistry.filter(
        (providerItem) =>
          providerItem?.status?.toLowerCase() ===
          "blocked"
      ).length
    );
    updateProviderActiveCount(
      masterProviderRegistry.filter(
        (providerItem) =>
          providerItem?.online ===
            true ||
          providerItem?.isOnline ===
            true
      ).length
    );
    updateProviderFreshEnrollmentCount(
      masterProviderRegistry.filter(
        (providerItem) => {
          const providerCreatedDate =
            providerItem?.createdAt
              ?.toDate
              ? providerItem.createdAt.toDate()
              : new Date(
                  providerItem?.createdAt
                );
          const currentDate =
            new Date();
          const dateDifference =
            currentDate -
            providerCreatedDate;
          const dayDifference =
            dateDifference /
            (1000 *
              60 *
              60 *
              24);
          return (
            dayDifference <= 7
          );
        }
      ).length
    );
  };
/* ===================================================== */
/* ✅ UNIVERSAL REPORT OPEN ENGINE */
/* ===================================================== */
const launchProviderReportCenter = (
  reportTitle,
  reportCollection
) => {
  updateProviderReportTitle(
    reportTitle
  );
  updateProviderReportCollection(
    reportCollection
  );
  updateProviderReportModalVisible(
    true
  );
};
/* ===================================================== */
/* ✅ CLICKABLE PROVIDER REPORT HANDLERS */
/* ===================================================== */
/* ============================================== */
/* ✅ REGISTERED PROVIDERS */
/* ============================================= */
const openRegisteredProviderInsights =
  () => {
    const registeredProviders =
      providerRealtimeFeed || [];
    launchProviderReportCenter(
      "REGISTERED PROVIDERS REPORT",
      registeredProviders
    );
  };
/* ============================================== */
/* ✅ VERIFIED PROVIDERS */
/* ============================================== */
const openVerifiedProviderInsights =
  () => {
    const verifiedProviders =
      (
        providerRealtimeFeed || []
      ).filter(
        (providerItem) =>
          providerItem?.status?.toLowerCase() ===
          "approved"
      );
    launchProviderReportCenter(
      "VERIFIED PROVIDERS REPORT",
      verifiedProviders
    );
  };
/* ============================================== */
/* ✅ AWAITING PROVIDERS */
/* ============================================== */
const openAwaitingProviderInsights =
  () => {
    const awaitingProviders =
      (
        providerRealtimeFeed || []
      ).filter(
        (providerItem) =>
          providerItem?.status?.toLowerCase() ===
          "pending"
      );
    launchProviderReportCenter(
      "AWAITING PROVIDERS REPORT",
      awaitingProviders
    );
  };
/* ============================================== */
/* ✅ RESTRICTED PROVIDERS */
/* ============================================== */
const openRestrictedProviderInsights =
  () => {
    const restrictedProviders =
      (
        providerRealtimeFeed || []
      ).filter(
        (providerItem) =>
          providerItem?.status?.toLowerCase() ===
          "blocked"
      );
    launchProviderReportCenter(
      "RESTRICTED PROVIDERS REPORT",
      restrictedProviders
    );
  };
/* ============================================== */
/* ✅ ACTIVE PROVIDERS */
/* ============================================== */
const openActiveProviderInsights =
  () => {
    const activeProviders =
      (
        providerRealtimeFeed || []
      ).filter(
        (providerItem) =>
          providerItem?.online ===
            true ||
          providerItem?.isOnline ===
            true
      );
    launchProviderReportCenter(
      "ACTIVE PROVIDERS REPORT",
      activeProviders
    );
  };
/* ============================================== */
/* ✅ FRESH PROVIDERS */
/* ============================================== */
const openFreshProviderInsights =
  () => {
    const freshProviders =
      (
        providerRealtimeFeed || []
      ).filter(
        (providerItem) => {
          const providerCreatedDate =
            providerItem?.createdAt
              ?.toDate
              ? providerItem.createdAt.toDate()
              : new Date(
                  providerItem?.createdAt
                );
          const currentDate =
            new Date();
          const dateDifference =
            currentDate -
            providerCreatedDate;
          const dayDifference =
            dateDifference /
            (1000 *
              60 *
              60 *
              24);
          return (
            dayDifference <= 7
          );
        }
      );
    launchProviderReportCenter(
      "FRESH PROVIDERS REPORT",
      freshProviders
    );
  };

/* ============================================== */
/* ✅ ANALYTICS BREAKDOWN */
/* ============================================== */
const openProviderMetricBreakdown =
  (metricPayload) => {
    launchProviderReportCenter(
      `${metricPayload?.title} ANALYTICS REPORT`,
      providerRealtimeFeed
    );
  };
/* ============================================== */
/* ✅ PROVIDER PROFILE REPORT */
/* ============================================== */
const openProviderProfileReport =
  (providerPayload) => {
    launchProviderReportCenter(
      "PROVIDER PROFILE REPORT",
      [providerPayload]
    );
  };
/* ===================================================== */
/* ✅ PROVIDER ANALYTICS MATRIX */
/* ===================================================== */
const providerAnalyticsMatrix = [
  {
    title: "Registered",
    count:
      providerRegisteredCount ||
      0,
    color:
      "linear-gradient(135deg,#3b82f6,#2563eb)",
    glow:
      "rgba(59,130,246,0.45)",
  },
  {
    title: "Verified",
    count:
      providerVerifiedCount ||
      0,
    color:
      "linear-gradient(135deg,#22c55e,#15803d)",
    glow:
      "rgba(34,197,94,0.45)",
  },
  {
    title: "Awaiting",
    count:
      providerAwaitingCount ||
      0,
    color:
      "linear-gradient(135deg,#f59e0b,#d97706)",
    glow:
      "rgba(245,158,11,0.45)",
  },
  {
    title: "Restricted",
    count:
      providerRestrictedCount ||
      0,
    color:
      "linear-gradient(135deg,#ef4444,#dc2626)",
    glow:
      "rgba(239,68,68,0.45)",
  },
  {
    title: "Active",
    count:
      providerActiveCount ||
      0,
    color:
      "linear-gradient(135deg,#06b6d4,#0891b2)",
    glow:
      "rgba(6,182,212,0.45)",
  },
  {
    title: "Fresh",
    count:
      providerFreshEnrollmentCount ||
      0,
    color:
      "linear-gradient(135deg,#8b5cf6,#7c3aed)",
    glow:
      "rgba(139,92,246,0.45)",
  },
];
/* ===================================================== */
/* ✅ PROVIDER PEAK METRIC CALCULATOR */
/* ===================================================== */
const providerHighestMetric =
  Math.max(
    ...providerAnalyticsMatrix.map(
      (analyticsCard) =>
        analyticsCard.count || 0
    ),
    1
  );
/* ========================================================= */
/* ✅ EXPAND STATES */
/* ========================================================= */
const [providerExpanded, setProviderExpanded] =
  useState(false);
const [bookingExpanded, setBookingExpanded] =
  useState(false);
/* ========================================================= */
/* ✅ WIDTH STATES */
/* ========================================================= */
const [providerWidth, setProviderWidth] =
  useState(50);
/* ========================================================= */
/* ✅ EXPAND FUNCTION */
/* ========================================================= */
const expandProviderDashboard = () => {
  setProviderWidth((prev) => {
    if (prev < 25) return 25;
    if (prev < 50) return 50;
    if (prev < 75) return 75;
    if (prev < 100) return 100;
    return 100;
  });
};
const collapseProviderDashboard = () => {
  setProviderWidth((prev) => {
    if (prev > 75) return 75;
    if (prev > 50) return 50;
    if (prev > 25) return 25;
    return 25;
  });
};
// ==========================================================
// ✅ BOOKING INSIGHT VIEWPORT STATE
// ==========================================================
const [bookingInsightViewport, setBookingInsightViewport] = useState(50);
// ==========================================================
// ✅ VIEWPORT CONTROLS
// ==========================================================
const expandBookingInsightViewport = () => {
  setBookingInsightViewport((prev) => (prev < 75 ? 75 : 100));
};
const collapseBookingInsightViewport = () => {
  setBookingInsightViewport((prev) => (prev > 75 ? 75 : 50));
};
// ==========================================================
// ✅ BOOKING DATE FILTER STATES
// ==========================================================
const [bookingRangeStartDate, setBookingRangeStartDate] = useState("");
const [bookingRangeEndDate, setBookingRangeEndDate] = useState("");
const [bookingDateFilterActivated, setBookingDateFilterActivated] = useState(false);
// ==========================================================
// ✅ MASTER + FILTERED BOOKINGS
// ==========================================================
const [masterBookingInsightRecords, setMasterBookingInsightRecords] = useState([]);
const [filteredBookingInsightRecords, setFilteredBookingInsightRecords] = useState([]);
const [filteredBookingRealtimeFeed, setFilteredBookingRealtimeFeed] = useState([]);
// ==========================================================
// ✅ ACTIVE REPORT STATE
// ==========================================================
const [activeBookingInsightReport, setActiveBookingInsightReport] = useState(null);
const [bookingInsightReportRecords, setBookingInsightReportRecords] = useState([]);
// ==========================================================
// ✅ FIRESTORE LIVE STREAM
// ==========================================================
useEffect(() => {
  const bookingCollectionReference = collection(db, "Booking");
  const unsubscribe = onSnapshot(
    bookingCollectionReference,
    (snapshot) => {
      const realtimeBookingPayload = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setMasterBookingInsightRecords(realtimeBookingPayload);
      setFilteredBookingInsightRecords(realtimeBookingPayload);
      setFilteredBookingRealtimeFeed(realtimeBookingPayload);
    },
    (error) => console.error("BOOKING SNAPSHOT ERROR:", error)
  );
  return () => unsubscribe();
}, []);
// ==========================================================
// ✅ APPLY DATE FILTER
// ==========================================================
const applyBookingDateInsightsFilter = () => {
  if (!bookingRangeStartDate || !bookingRangeEndDate) {
    setFilteredBookingInsightRecords(masterBookingInsightRecords);
    setFilteredBookingRealtimeFeed(masterBookingInsightRecords);
    setBookingDateFilterActivated(false);
    return;
  }
  const fromDate = new Date(bookingRangeStartDate);
  const toDate = new Date(bookingRangeEndDate);
  toDate.setHours(23, 59, 59, 999);
  const filtered = masterBookingInsightRecords.filter((item) => {
    const rawDate = item?.createdAt?.seconds
      ? new Date(item.createdAt.seconds * 1000)
      : item?.createdAt
      ? new Date(item.createdAt)
      : item?.date
      ? new Date(item.date)
      : null;

    if (!rawDate) return false;
    return rawDate >= fromDate && rawDate <= toDate;
  });
  setFilteredBookingInsightRecords(filtered);
  setFilteredBookingRealtimeFeed(filtered);
  setBookingDateFilterActivated(true);
};
// ==========================================================
// ✅ RESET DATE FILTER
// ==========================================================
const resetBookingDateInsightsFilter = () => {
  setBookingRangeStartDate("");
  setBookingRangeEndDate("");
  setFilteredBookingInsightRecords(masterBookingInsightRecords);
  setFilteredBookingRealtimeFeed(masterBookingInsightRecords);
  setBookingDateFilterActivated(false);
};
// ==========================================================
// ✅ STATUS COUNTS (LIVE FILTERED)
// ==========================================================
const bookingStatusInsightCounts = useMemo(() => {
  const counts = {
    new: 0,
    pending: 0,
    confirmed: 0,
    accepted: 0,
    onTheWay: 0,
    arrived: 0,
    completed: 0,
    cancelled: 0,
    refunded: 0,
    rated: 0,
    paid: 0,
    paymentFailed: 0,
    paymentPending: 0,
  };
  filteredBookingInsightRecords.forEach((item) => {
    const status = (item?.bookingStatus || item?.status || "")
      .toLowerCase()
      .trim();
    const payment = (item?.paymentStatus || "").toLowerCase().trim();
    switch (status) {
      case "new": counts.new++; break;
      case "pending": counts.pending++; break;
      case "confirmed": counts.confirmed++; break;
      case "accepted": counts.accepted++; break;
      case "on the way":
      case "ontheway": counts.onTheWay++; break;
      case "arrived": counts.arrived++; break;
      case "completed": counts.completed++; break;
      case "cancelled":
      case "canceled": counts.cancelled++; break;
      case "refunded": counts.refunded++; break;
      case "rated": counts.rated++; break;
    }
    switch (payment) {
      case "paid": counts.paid++; break;
      case "payment_failed": counts.paymentFailed++; break;
      case "payment_pending": counts.paymentPending++; break;
    }
  });
  return counts;
}, [filteredBookingInsightRecords]);
// ==========================================================
// ✅ METRICS
// ==========================================================
const bookingStatusInsightMetrics = [
  { title: "New", count: bookingStatusInsightCounts.new, color: "linear-gradient(135deg,#3b82f6,#2563eb)", glow: "rgba(59,130,246,0.45)" },
  { title: "Pending", count: bookingStatusInsightCounts.pending, color: "linear-gradient(135deg,#f59e0b,#d97706)", glow: "rgba(245,158,11,0.45)" },
  { title: "Confirmed", count: bookingStatusInsightCounts.confirmed, color: "linear-gradient(135deg,#10b981,#059669)", glow: "rgba(16,185,129,0.45)" },
  { title: "Accepted", count: bookingStatusInsightCounts.accepted, color: "linear-gradient(135deg,#6366f1,#4f46e5)", glow: "rgba(99,102,241,0.45)" },
  { title: "On The Way", count: bookingStatusInsightCounts.onTheWay, color: "linear-gradient(135deg,#0ea5e9,#0284c7)", glow: "rgba(14,165,233,0.45)" },
  { title: "Arrived", count: bookingStatusInsightCounts.arrived, color: "linear-gradient(135deg,#14b8a6,#0f766e)", glow: "rgba(20,184,166,0.45)" },
  { title: "Completed", count: bookingStatusInsightCounts.completed, color: "linear-gradient(135deg,#22c55e,#16a34a)", glow: "rgba(34,197,94,0.45)" },
  { title: "Cancelled", count: bookingStatusInsightCounts.cancelled, color: "linear-gradient(135deg,#ef4444,#dc2626)", glow: "rgba(239,68,68,0.45)" },
  { title: "Refunded", count: bookingStatusInsightCounts.refunded, color: "linear-gradient(135deg,#f97316,#ea580c)", glow: "rgba(249,115,22,0.45)" },
  { title: "Rated", count: bookingStatusInsightCounts.rated, color: "linear-gradient(135deg,#8b5cf6,#7c3aed)", glow: "rgba(139,92,246,0.45)" },
  { title: "Paid", count: bookingStatusInsightCounts.paid, color: "linear-gradient(135deg,#22c55e,#15803d)", glow: "rgba(34,197,94,0.45)" },
  { title: "Payment Failed", count: bookingStatusInsightCounts.paymentFailed, color: "linear-gradient(135deg,#ef4444,#b91c1c)", glow: "rgba(239,68,68,0.45)" },
  { title: "Payment Pending", count: bookingStatusInsightCounts.paymentPending, color: "linear-gradient(135deg,#eab308,#ca8a04)", glow: "rgba(234,179,8,0.45)" },
];
// ==========================================================
// ✅ ANALYTICS VALUES
// ==========================================================
const bookingAnalyticsVisualizationValues = bookingStatusInsightMetrics.map(m => Number(m.count) || 0);
const bookingAnalyticsMaximumMetric = Math.max(...bookingAnalyticsVisualizationValues, 1);
// ==========================================================
// ✅ CLICK HANDLERS (CONNECTED TO REPORT SYSTEM)
// ==========================================================
const handleBookingStatusDrilldown = (status) => {
  setActiveBookingInsightReport(status);
  const filtered = filteredBookingInsightRecords.filter((item) => {
    const st = (item?.bookingStatus || item?.status || "").toLowerCase().trim();
    const pay = (item?.paymentStatus || "").toLowerCase().trim();
    if (status.toLowerCase() === "payment failed") return pay === "payment_failed";
    if (status.toLowerCase() === "payment pending") return pay === "payment_pending";
    if (status.toLowerCase() === "paid") return pay === "paid";
    return st === status.toLowerCase();
  });
  setBookingInsightReportRecords(filtered);
};
const handleBookingAnalyticsDrilldown = handleBookingStatusDrilldown;
const handleBookingFeedInspection = (booking) => {
  setActiveBookingInsightReport("BOOKING DETAILS");
  setBookingInsightReportRecords([booking]);
};
const bookingAnalyticsVisualizationData =
  bookingStatusInsightMetrics;
 // ==========================================================
// ✅ PROVIDER DASHBOARD DEFAULT METRICS
// ==========================================================
const totalProviders = 1250;
const pendingProviders = 86;
const approvedProviders = 1104;
const citiesCovered = 42;
const topCategory =
  "Home Cleaning";
// ==========================================================
// ✅ PROVIDER DATE FILTER STATES
// ==========================================================
const [
  providerAnalyticsFromDate,
  setProviderAnalyticsFromDate,
] = useState("");
const [
  providerAnalyticsToDate,
  setProviderAnalyticsToDate,
] = useState("");
const [
  providerAnalyticsFilterActive,
  setProviderAnalyticsFilterActive,
] = useState(false);

// ==========================================================
// ✅ FILTER TRIGGER STATE
// ==========================================================
const [
  providerFilterTrigger,
  setProviderFilterTrigger,
] = useState(0);
// ==========================================================
// ✅ SERVICE PARTNER DASHBOARD ENGINE
// ==========================================================
const [
  servicePartners,
  setServicePartners,
] = useState([]);
// ==========================================================
// ✅ LIVE PROVIDER QUEUE STATE
// ==========================================================
const [
  providerQueue,
  setProviderQueue,
] = useState([]);
// ==========================================================
// ✅ APPLIED FILTER STATES
// ==========================================================
const [
  appliedProviderFromDate,
  setAppliedProviderFromDate,
] = useState("");
const [
  appliedProviderToDate,
  setAppliedProviderToDate,
] = useState("");
// ==========================================================
// ✅ REALTIME ONBOARDING PIPELINE
// ==========================================================
const [
  partnerPipeline,
  setPartnerPipeline,
] = useState([]);
// ==========================================================
// ✅ SAFE PARTNER REGISTRY
// ==========================================================
const partnerRegistry =
  Array.isArray(
    servicePartners
  )
    ? servicePartners
    : [];
// ==========================================================
// ✅ DEFAULT CATEGORY FALLBACK
// ==========================================================
const defaultServiceCategory =
  topCategory ||
  "General Services";
// ==========================================================
// ✅ CORE DASHBOARD TOTALS
// ==========================================================
const registeredPartners =
  Number(totalProviders) +
  Number(
    partnerRegistry.length || 0
  );
const screeningPartners =
  Number(pendingProviders) +
  Number(
    partnerRegistry.filter(
      (partner) =>
        (
          partner?.status || ""
        ).toLowerCase() ===
        "pending"
    ).length || 0
  );
const verifiedPartners =
  Number(approvedProviders) +
  Number(
    partnerRegistry.filter(
      (partner) =>
        (
          partner?.status || ""
        ).toLowerCase() ===
        "approved"
    ).length || 0
  );
const activeCoverage =
  Number(citiesCovered) +
  Number(
    new Set(
      partnerRegistry
        .map(
          (partner) =>
            partner?.city
        )
        .filter(Boolean)
    ).size || 0
  );
// ==========================================================
// ✅ REALTIME FIRESTORE STREAM
// ==========================================================
useEffect(() => {
  const onboardingStream = query(
    collection(
      db,
      "waitingTickets"
    ),
    orderBy(
      "createdAt",
      "desc"
    )
  );
  const unsubscribe =
    onSnapshot(
      onboardingStream,
      (snapshot) => {
        const realtimePartners =
          snapshot.docs.map(
            (doc) => ({
              id: doc.id,
              ...doc.data(),
            })
          );
        // ==================================================
        // ✅ MAIN PIPELINE
        // ==================================================
        setPartnerPipeline(
          realtimePartners
        );
        // ==================================================
        // ✅ OPTIONAL LEGACY QUEUE
        // ==================================================
        setProviderQueue(
          realtimePartners
        );
      },
      (error) => {
        console.error(
          "Realtime Queue Error:",
          error
        );
        setPartnerPipeline([]);
        setProviderQueue([]);
      }
    );
  return () => unsubscribe();
}, []);
// ==========================================================
// ✅ FILTERED PROVIDER PIPELINE
// ==========================================================
const providerAnalyticsPipeline =
  useMemo(() => {
    // ======================================================
    // ✅ NO APPLIED FILTER
    // ======================================================
    if (
      !appliedProviderFromDate &&
      !appliedProviderToDate
    ) {
      return partnerPipeline;
    }
    return (
      partnerPipeline || []
    ).filter((partner) => {
      let createdDate = null;
      // ====================================================
      // ✅ FIRESTORE TIMESTAMP
      // ====================================================
      if (
        partner?.createdAt
          ?.seconds
      ) {
        createdDate =
          new Date(
            partner.createdAt.seconds *
              1000
          );
      }
      // ====================================================
      // ✅ NORMAL DATE
      // ====================================================
      else if (
        partner?.createdAt
      ) {
        createdDate =
          new Date(
            partner.createdAt
          );
      }
      // ====================================================
      // ✅ FALLBACK DATE
      // ====================================================
      else if (
        partner?.date
      ) {
        createdDate =
          new Date(
            partner.date
          );
      }
      if (!createdDate)
        return false;
      // ====================================================
      // ✅ FROM FILTER
      // ====================================================
      if (
        appliedProviderFromDate
      ) {
        const fromDate =
          new Date(
            appliedProviderFromDate
          );
        fromDate.setHours(
          0,
          0,
          0,
          0
        );

        if (
          createdDate < fromDate
        ) {
          return false;
        }
      }
      // ====================================================
      // ✅ TO FILTER
      // ====================================================
      if (
        appliedProviderToDate
      ) {
        const toDate =
          new Date(
            appliedProviderToDate
          );
        toDate.setHours(
          23,
          59,
          59,
          999
        );
        if (
          createdDate > toDate
        ) {
          return false;
        }
      }
      return true;
    });
  }, [
    partnerPipeline,
    appliedProviderFromDate,
    appliedProviderToDate,
  ]);
  // ==========================================================
// ✅ APPLY FILTER
// ==========================================================
const applyProviderAnalyticsDateFilter =
  () => {
    setAppliedProviderFromDate(
      providerAnalyticsFromDate
    );
    setAppliedProviderToDate(
      providerAnalyticsToDate
    );
    setProviderAnalyticsFilterActive(
      true
    );
  };
  // ==========================================================
// ✅ RESET FILTER
// ==========================================================
const clearProviderAnalyticsDateFilter =
  () => {
    setProviderAnalyticsFromDate(
      ""
    );
    setProviderAnalyticsToDate(
      ""
    );
    setAppliedProviderFromDate(
      ""
    );
    setAppliedProviderToDate(
      ""
    );
    setProviderAnalyticsFilterActive(
      false
    );
  };
// ==========================================================
// ✅ LIVE DASHBOARD INSIGHTS
// ==========================================================
const dashboardInsights =
  useMemo(() => {
    const analyticsSource =
      providerAnalyticsPipeline ||
      [];
    // ======================================================
    // ✅ PENDING REVIEW COUNT
    // ======================================================
    const onboardingReviewCount =
      analyticsSource.filter(
        (partner) =>
          !partner?.status ||
          (
            partner?.status || ""
          ).toLowerCase() ===
            "pending"
      ).length || 0;
    // ======================================================
    // ✅ VERIFIED COUNT
    // ======================================================
    const verifiedQueueCount =
      analyticsSource.filter(
        (partner) =>
          (
            partner?.status || ""
          ).toLowerCase() ===
          "approved"
      ).length || 0;
    // ======================================================
    // ✅ REGIONAL EXPANSION
    // ======================================================
    const regionalExpansion =
      new Set(
        analyticsSource
          .map(
            (partner) =>
              partner?.city
          )
          .filter(Boolean)
      ).size || 0;
    // ======================================================
    // ✅ FINAL DASHBOARD VALUES
    // ======================================================
    return {
      partners:
        Number(
          registeredPartners
        ) +
        Number(
          analyticsSource.length ||
            0
        ),
      screening:
        Number(
          screeningPartners
        ) +
        Number(
          onboardingReviewCount
        ),
      verified:
        Number(
          verifiedPartners
        ) +
        Number(
          verifiedQueueCount
        ),
      coverage:
        Number(
          activeCoverage
        ) +
        Number(
          regionalExpansion
        ),
    };
  }, [
    providerAnalyticsPipeline,
    registeredPartners,
    screeningPartners,
    verifiedPartners,
    activeCoverage,
    providerFilterTrigger,
  ]);
  // ==========================================================
// ✅ DASHBOARD PERFORMANCE WIDGETS
// ==========================================================
const dashboardWidgets = [
  {
    title: "Partners",
    count:
      dashboardInsights
        .partners,
    color:
      "linear-gradient(135deg,#06b6d4,#2563eb)",
    glow:
      "rgba(59,130,246,0.45)",
  },
  {
    title: "Screening",
    count:
      dashboardInsights
        .screening,
    color:
      "linear-gradient(135deg,#f59e0b,#facc15)",
    glow:
      "rgba(250,204,21,0.40)",
  },
  {
    title: "Verified",
    count:
      dashboardInsights
        .verified,
    color:
      "linear-gradient(135deg,#10b981,#4ade80)",
    glow:
      "rgba(74,222,128,0.40)",
  },
  {
    title: "Coverage",
    count:
      dashboardInsights
        .coverage,
    color:
      "linear-gradient(135deg,#8b5cf6,#6366f1)",
    glow:
      "rgba(129,140,248,0.40)",
  },
];
// ==========================================================
// ✅ GRAPH VALUES
// ==========================================================
const analyticsValues =
  dashboardWidgets.map(
    (widget) =>
      Number(
        widget.count
      ) || 0
  );
  // ==========================================================
// ✅ MAX ANALYTICS SCALE
// ==========================================================
const maxMetric = Math.max(
  ...analyticsValues,
  1
);
// ✅ STATES
const [notesViewerOpen, setNotesViewerOpen] =
  useState(false);
const [logsViewerOpen, setLogsViewerOpen] =
  useState(false);
const [focusedTicket, setFocusedTicket] =
  useState(null);
const [selectedLogs, setSelectedLogs] =
  useState([]);
const [dashboardFilters, setDashboardFilters] =
  useState({
    ticketId: "",
    fullName: "",
    business: "",
    category: "",
    city: "",
    experience: "",
    email: "",
    phone: "",
    status: "",
  });
// ✅ FILTER HANDLER
const alterDashboardFilter = (field, value) => {
  setDashboardFilters((prev) => ({
    ...prev,
    [field]: value,
  }));
  setCurrentTicketPage(1);
};
// ✅ STATUS UPDATE HANDLER
const modifyTicketStage = async (
  ticketDocId,
  latestStage
) => {
  try {
    await handleTicketStatusUpdate(
      ticketDocId,
      latestStage
    );
  } catch (error) {
    console.error(error);
  }
};
// ✅ NOTES UPDATE HANDLER WITH LOGS
const persistTicketNotes = async (
  ticketDocId,
  updatedNotes
) => {
  try {
    await handleTicketNotesUpdate(
      ticketDocId,
      updatedNotes
    );
    // OPTIONAL LOCAL LOG APPEND
    setTicketRecords((prev) =>
      prev.map((item) => {
        if (item.id === ticketDocId) {
          return {
            ...item,
            notes: updatedNotes,
            notesLogs: [
              ...(item.notesLogs || []),
              {
                message: updatedNotes,
                createdAt: new Date().toISOString(),
              },
            ],
          };
        }
        return item;
      })
    );
  } catch (error) {
    console.error(error);
  }
};
// ✅ STATES
const [openedLogIndexes, setOpenedLogIndexes] =
  useState([]);
// ✅ OPEN SINGLE LOG
const expandSingleLog = (logIndex) => {
  setOpenedLogIndexes((prev) => {
    if (prev.includes(logIndex)) {
      return prev;
    }
    return [...prev, logIndex];
  });
};
// ✅ CLOSE SINGLE LOG
const collapseSingleLog = (logIndex) => {
  setOpenedLogIndexes((prev) =>
    prev.filter((item) => item !== logIndex)
  );
};
const [ticketNotesModal, setTicketNotesModal] =
  useState(false);
const [selectedTicket, setSelectedTicket] =
  useState(null);
  // ✅ Add this state near your other useState hooks
const [currentTicketPage, setCurrentTicketPage] = useState(1);
// ✅ NOTES UPDATE FUNCTION
const handleTicketNotesUpdate = async (
  ticketDocId,
  latestNotes
) => {
  try {
    // ✅ FIRESTORE UPDATE
    await updateDoc(doc(db, "waitingTickets", ticketDocId), {
      notes: latestNotes,
    });
    // ✅ UI UPDATE
    setTicketRecords((previousTickets) =>
      previousTickets.map((singleTicket) =>
        singleTicket.id === ticketDocId
          ? {
              ...singleTicket,
              notes: latestNotes,
            }
          : singleTicket
      )
    );
    // ✅ SUCCESS TOAST
    toast.success("Ticket Notes Updated Successfully");
    console.log("Notes Updated Successfully");
  } catch (notesError) {
    console.error("Error Updating Notes:", notesError);
    // ❌ ERROR TOAST
    toast.error("Failed To Update Ticket Notes");
  }
};
// ✅ STATUS UPDATE FUNCTION
const handleTicketStatusUpdate = async (
  ticketDocId,
  latestStatus
) => {
  try {
    // ✅ FIRESTORE UPDATE
    await updateDoc(doc(db, "waitingTickets", ticketDocId), {
      status: latestStatus,
    });
    // ✅ UI UPDATE
    setTicketRecords((previousTickets) =>
      previousTickets.map((singleTicket) =>
        singleTicket.id === ticketDocId
          ? {
              ...singleTicket,
              status: latestStatus,
            }
          : singleTicket
      )
    );
    // ✅ SUCCESS TOAST
    toast.success(
      `Ticket Status Updated To ${latestStatus}`
    );
    console.log("Status Updated Successfully");
  } catch (statusError) {
    console.error("Error Updating Status:", statusError);
    // ❌ ERROR TOAST
    toast.error("Failed To Update Ticket Status");
  }
};
const [ticketRecords, setTicketRecords] = useState([]);
const [isFetchingTickets, setIsFetchingTickets] = useState(false);
const [ticketFetchError, setTicketFetchError] = useState(null);
useEffect(() => {
  initiateTicketLoad();
}, []);
const initiateTicketLoad = async () => {
  try {
    setIsFetchingTickets(true);
    const snapshotBundle = await getDocs(collection(db, "waitingTickets"));
    const formattedTickets = snapshotBundle.docs.map((docItem) => {
      const raw = docItem.data();
      return {
        id: docItem.id,
        ticketId: raw.ticketId || "-",
        firstName: raw.firstName || "",
        lastName: raw.lastName || "",
        business: raw.business || "-",
        category: raw.category || "-",
        city: raw.city || "-",
        experience: raw.experience || "-",
        email: raw.email || "-",
        phone: raw.phone || "-",
        status: raw.status || "Pending",
        createdAt: raw.createdAt || null,
      };
    });
    setTicketRecords(formattedTickets);
    // ⏳ FORCE 10 SECOND LOADER
    await new Promise((resolve) => setTimeout(resolve, 10000));
  } catch (err) {
    console.error(err);
  } finally {
    setIsFetchingTickets(false);
  }
};
 const headerCell = {
  padding: "10px",
  textAlign: "left",
  fontSize: "12px",
  textTransform: "uppercase",
  color: "#555"
};
const bodyCell = {
  padding: "10px",
  fontSize: "14px"
};
const [showCustomerProfile, setShowCustomerProfile] = useState(false);
const [showSidebarAuth, setShowSidebarAuth] = useState(true);
const [sidebarPassword, setSidebarPassword] = useState("");
const [sidebarAccessGranted, setSidebarAccessGranted] = useState(false);
const [sidebarError, setSidebarError] = useState("");//DashBoard//
const [showScanModal, setShowScanModal] = useState(false);//Provider Logs//
const [showActivateChat, setShowActivateChat] = useState(false);//DashBoard Part//
const [showProviderList, setShowProviderList] = useState(false);//DashBoard Part//
const [showVerificationModal, setShowVerificationModal] = useState(false);//DashBoard Part//
const [ordersOpen, setOrdersOpen] = useState(false);//DashBoard Part//
const [manageOpen, setManageOpen] = useState(false);//DashBoard Part//
const [showMakeDecision, setShowMakeDecision] = useState(false);//DashBoard Part//
const [showListBanner, setShowListBanner] = useState(false);//DashBoard Part//
const [showManagePartnerReport, setShowManagePartnerReport] = useState(false);//DashBoard Part//
const titleStyle = {
  margin: 0,
  fontFamily: "'Poppins', sans-serif",
  fontSize: "24px",
  fontWeight: "700",
  color: "#111827",
};//DashBoard part//
const [currentView, setCurrentView] = useState("");
const modalOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 2000,
};
const modalBox = {
  background: "#fff",
  padding: "20px",
  borderRadius: "10px",
  width: "420px",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};
const btnRow = {
  display: "flex",
  justifyContent: "space-between",
  marginTop: "10px",
};
const APPROVAL_STATUSES = [
  "Accepted",
  "Rejected",
  "Approved",
  "Valid",
  "Under Review",
  "In Progress"
];
const ADMIN_LIST = ["Aashish", "Vaibhav", "Vijay", "Ravi"];
const [approvalRequests, setApprovalRequests] = useState([]);
// Request modal
const [isRequestModalOpen, setIsRequestModalOpen] = useState(false);
const [activeRequestPayload, setActiveRequestPayload] = useState(null);
// Final approval modal
const [isFinalApprovalOpen, setIsFinalApprovalOpen] = useState(false);
const [activeApprovalPacket, setActiveApprovalPacket] = useState(null);
// Request form
const [reqReasonText, setReqReasonText] = useState("");
const [reqStatusPick, setReqStatusPick] = useState("");
const [reqAdminPick, setReqAdminPick] = useState("");
const initiateApprovalRequestFlow = (doc) => {
  const generatedReqId = "REQ-" + Math.floor(100000 + Math.random() * 900000);
  setActiveRequestPayload({
    requestId: generatedReqId,
    doc,
  });
  setReqReasonText("");
  setReqStatusPick("");
  setReqAdminPick("");
  setIsRequestModalOpen(true);
};
const submitApprovalRequestPacket = () => {
  const packet = {
    requestId: activeRequestPayload.requestId,
    doc: activeRequestPayload.doc,
    reason: reqReasonText,
    status: reqStatusPick,
    assignedAdmin: reqAdminPick,
    createdAt: new Date().toLocaleString(),
    stage: "REQUESTED",
  };
  setApprovalRequests((prev) => [...prev, packet]);
  setIsRequestModalOpen(false);
};
const triggerFinalApprovalModal = (request) => {
  setActiveApprovalPacket(request);
  setIsFinalApprovalOpen(true);
};
const handleFetchProviders = async () => {
  try {
    setIsGlobalLoading(true);
    const snapshot = await getDocs(
      collection(db, "stripe market place", "providers", "list")
    );
    const providers = snapshot.docs.map((doc) => ({
      uid: doc.id,
      ...doc.data(),
    }));
    setFilteredProviders(providers);
  } catch (error) {
    console.error("Error fetching providers:", error);
  } finally {
    setIsGlobalLoading(false);
  }
};//Provider Onboarding Part//
// Table Styles
const tableHeaderStyle = { padding: "12px", textAlign: "left" };//Payment Gateway//
const tableCellStyle = { padding: "12px" };
// Input Field Style
const formInputStyle = {
  padding: "6px",
  border: "1px solid #D1D5DB",
  borderRadius: "6px",
  width: "100%",
};
// Action Buttons
const primaryActionButton = {
  backgroundColor: "#2563EB",
  color: "#fff",
  padding: "6px 12px",
  borderRadius: "6px",
  border: "none",
  cursor: "pointer",
};
const successActionButton = {
  backgroundColor: "#10B981",
  color: "#fff",
  padding: "6px 12px",
  borderRadius: "6px",
  border: "none",
  cursor: "pointer",
};
const [providerNames, setProviderNames] = useState([]);
const ADMIN_USERS = ["Aashish", "Vaibhav", "Vijay","Ravi"];
const [adminUsers, setAdminUsers] = useState([]);
const [selectedAdmin, setSelectedAdmin] = useState("");
/* ================= SAFE HELPERS ================= */
const complexFields = [
  "source",
  "system",
  "layoutDetails",
  "entitySkills",
  "sharedDepartments",
  "customFields",
];
const formatFieldValue = (value) => {
  if (typeof value === "object" && value !== null) {
    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return "";
    }
  }
  return value || "";
};
const parseFieldValue = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};
const [editingTicketId, setEditingTicketId] = useState(null);
const [editingRowData, setEditingRowData] = useState({});
const [hiddenTicketIds, setHiddenTicketIds] = useState([]);
// ------------------ State ------------------
const [ticketsArchive, setTicketsArchive] = useState([]);
const [ticketFilterHandles, setTicketFilterHandles] = useState({});
const filteredTicketArchive = Array.isArray(ticketsArchive)
  ? ticketsArchive
      .filter((ticket) => !hiddenTicketIds.includes(ticket.id))
      .filter((ticket) => {
        return Object.keys(ticketFilterHandles).every((fieldKey) => {
          const filterValue = ticketFilterHandles[fieldKey];
          if (!filterValue) return true;
          const ticketValue = ticket[fieldKey];
          if (ticketValue === undefined || ticketValue === null) return false;
          // SOURCE OBJECT
          if (fieldKey === "source" && typeof ticketValue === "object") {
            return JSON.stringify(ticketValue)
              .toLowerCase()
              .includes(filterValue.toLowerCase());
          }
          // SHARED DEPARTMENTS ARRAY
          if (fieldKey === "sharedDepartments" && Array.isArray(ticketValue)) {
            return JSON.stringify(ticketValue)
              .toLowerCase()
              .includes(filterValue.toLowerCase());
          }
          // ENTITY SKILLS ARRAY
          if (fieldKey === "entitySkills" && Array.isArray(ticketValue)) {
            return JSON.stringify(ticketValue)
              .toLowerCase()
              .includes(filterValue.toLowerCase());
          }
          // LAYOUT DETAILS OBJECT
          if (fieldKey === "layoutDetails" && typeof ticketValue === "object") {
            return JSON.stringify(ticketValue)
              .toLowerCase()
              .includes(filterValue.toLowerCase());
          }
          // CUSTOM FIELDS OBJECT
          if (fieldKey === "customFields" && typeof ticketValue === "object") {
            return JSON.stringify(ticketValue)
              .toLowerCase()
              .includes(filterValue.toLowerCase());
          }
          return String(ticketValue)
            .toLowerCase()
            .includes(filterValue.toLowerCase());
        });
      })
  : [];
  // At the top of your component (with other useState declarations)
  const [showTicketDashboard, setShowTicketDashboard] = useState(false);
  const [isLoadingTickets, setIsLoadingTickets] = useState(false);
  const [ticketsError, setTicketsError] = useState(null);//Macros//
  // ------------------ Format Values ------------------
  const safeRender = (val) => {
    if (val === null || val === undefined || val === "") return "N/A";
    if (typeof val === "object") return JSON.stringify(val, null, 2);
    return val.toString();
  };//Macros//
  // ------------------ Determine Columns ------------------
  const tableColumns =
    ticketsArchive.length > 0
      ? Array.from(
          new Set([...Object.keys(ticketsArchive[0]), "description"])
        )
      : [];//Macros//
// ================= TIMESTAMP FORMATTER =================
const formatTimestampDisplay = (timestamp) => {
  if (!timestamp) return "-";
  try {
    const date = timestamp?.toDate
      ? timestamp.toDate()
      : new Date(timestamp);
    return date.toLocaleString();
  } catch {
    return "-";
  }
};
const [partnerLedger, setPartnerLedger] = useState([]);//Provider Onboarding Part//
// ================= FILTER HANDLES STATE =================
const [filterHandles, setFilterHandles] = useState({});//Provider Onboarding//
// ================= FILTER INPUT HANDLER =================
const onFilterUpdate = (fieldKey, inputValue) => {
  setFilterHandles((prev) => ({
    ...prev,
    [fieldKey]: inputValue.toLowerCase(),
  }));
};
// ================= FILTERED PROVIDER DATA =================
const filteredProviders = Array.isArray(partnerLedger)
  ? partnerLedger.filter((record) => {
      return Object.keys(filterHandles).every((fieldKey) => {
        const searchValue = filterHandles[fieldKey];
        if (!searchValue) return true;
        let targetValue = "";
        switch (fieldKey) {
          case "uid":
            targetValue = record.uid;
            break;
          case "name":
            targetValue = record.displayName;
            break;
          case "email":
            targetValue = record.emailAddress;
            break;
          case "kyc":
            targetValue = record.kycState;
            break;
          case "stripe":
            targetValue = record.stripePhase;
            break;
          case "charges":
            targetValue =
              record.paymentStatus === null
                ? "-"
                : record.paymentStatus
                ? "enabled"
                : "disabled";
            break;
          case "payouts":
            targetValue =
              record.payoutStatus === null
                ? "-"
                : record.payoutStatus
                ? "enabled"
                : "disabled";
            break;
          case "account":
            targetValue = record.stripeAccountCode;
            break;
          case "onboarding":
            targetValue = record.onboardingStage;
            break;
          case "providerId":
            targetValue = record.externalProviderId;
            break;
          case "verification":
            targetValue = record.verificationMode;
            break;
          case "created":
            targetValue = formatTimestampDisplay(record.initiatedOn);
            break;
          case "updated":
            targetValue = formatTimestampDisplay(record.modifiedOn);
            break;
          case "completed":
            targetValue = formatTimestampDisplay(record.onboardingClosedAt);
            break;
          default:
            targetValue = "";
        }
        return targetValue
          ?.toString()
          .toLowerCase()
          .includes(searchValue);
      });
    })
  : [];//Provider Onboarding//{Filter Part}//
// ================= GLOBAL LOADER STATE =================
const [isGlobalLoading, setIsGlobalLoading] = useState(false);//Provider Onboarding//
// ================= LOAD PROVIDERS WITH 5s SPINNER =================
const handleLoadProvidersWithSpinner = async () => {
  try {
    setIsGlobalLoading(true);
    const minDelay = new Promise((res) => setTimeout(res, 5000));
    const dataFetch = fetchProviders(); // your existing function
    await Promise.all([minDelay, dataFetch]);
  } catch (error) {
    console.error("Error loading providers:", error);
  } finally {
    setIsGlobalLoading(false);
  }
};//Provider Onboarding//
// ================= HANDLE STATE =================
const [handles, setHandles] = useState({});//Verfication Documents//
// ================= HANDLE TABLE FILTER CHANGE =================
const handleTableFilterChange = (key, value) => {
  setHandles((prev) => ({
    ...prev,
    [key]: value.toLowerCase(),
  }));
};
// ================= HANDLE FILTER LOGIC =================
const getFilteredDocs = () => {
  return docs.filter((doc) => {
    const approvalData = approvalRegistry[doc.id] || {};
    const history = approvalData.history || [];
    const latest = history[history.length - 1];
    const handleData = {
      userId: doc.userId || "",
      dateOfBirth: doc.dateOfBirth || "",
      status: doc.status || "",
      verificationType: doc.verificationType || "",
      visaType: doc.visaType || "",
      shareCode: doc.shareCode || "",
      isBritishOrIrish: String(doc.isBritishOrIrish ?? ""),
      isStudent: String(doc.isStudent ?? ""),
      hasConfirmed: String(doc.hasConfirmed ?? ""),
      passportValidFrom: doc.passportValidFrom || "",
      passportValidUntil: doc.passportValidUntil || "",
      visaValidFrom: doc.visaValidFrom || "",
      visaValidUntil: doc.visaValidUntil || "",
      submittedAt: convertFirestoreTime(doc.submittedAt) || "",
      updatedAt: convertFirestoreTime(doc.updatedAt) || "",
      documentRequirements: Array.isArray(doc.documentRequirements)
        ? doc.documentRequirements.join(", ")
        : "",
      birth_certificate: doc.documents?.birth_certificate ? "yes" : "",
      driving_licence: doc.documents?.driving_licence ? "yes" : "",
      passport: doc.documents?.passport ? "yes" : "",
      studentRestriction: String(doc.workingHoursRestrictions?.isStudent ?? ""),
      allStudents: String(
        doc.workingHoursRestrictions?.restrictions?.appliesToAllStudents ?? ""
      ),
      fullTimeAllowed:
        doc.workingHoursRestrictions?.restrictions?.fullTimeAllowed || "",
      maxHoursPerWeek:
        doc.workingHoursRestrictions?.restrictions?.maxHoursPerWeek || "",
      requiresTermDates: String(
        doc.workingHoursRestrictions?.restrictions?.requiresTermDates ?? ""
      ),
      restrictionType:
        doc.workingHoursRestrictions?.restrictions?.type || "",
      approval: latest?.status || "",
      adminUser: latest?.adminUser || "",
      note: latest?.note || "",
      time: latest?.time || "",
    };
    return Object.keys(handles).every((key) =>
      handleData[key]
        ?.toString()
        .toLowerCase()
        .includes(handles[key])
    );
  });
};//Verfication Documents//
const tableHeadCell = {
  padding: "12px",
  border: "1px solid #E5E7EB",
  textAlign: "left",
  fontWeight: "600",
  color: "#111827",
  whiteSpace: "nowrap",
};
const tableBodyCell = {
  padding: "12px",
  border: "1px solid #E5E7EB",
  textAlign: "left",
  color: "#374151",
  whiteSpace: "nowrap",
};//Verifcation Documents//
// ✅ STATE
const [docs, setDocs] = useState([]);
const [fetchingDocs, setFetchingDocs] = useState(false);
const docsRefreshRef = useRef(null);
  const isDocsFetchingRef = useRef(false);
  const handleFetchVerificationDocs = async () => {
    if (isDocsFetchingRef.current) return;
    isDocsFetchingRef.current = true;
    setFetchingDocs(true);
    try {
      const snapshot = await getDocs(collection(db, "VerificationDocuments"));
      const verificationList = snapshot.docs.map((singleItem) => ({
        id: singleItem.id,
        ...singleItem.data(),
      }));
      setDocs(verificationList);
    } catch (fetchErr) {
      console.error("Error fetching docs:", fetchErr);
    } finally {
      isDocsFetchingRef.current = false;
      setFetchingDocs(false);
    }
  };
  useEffect(() => {
    handleFetchVerificationDocs();
    docsRefreshRef.current = setInterval(() => {
      handleFetchVerificationDocs();
    }, 10000);
    return () => {
      if (docsRefreshRef.current) {
        clearInterval(docsRefreshRef.current);
      }
    };
  }, []);//Verification Documents//
const [approvalRegistry, setApprovalRegistry] = useState({});
const [verificationDocsBusy, setVerificationDocsBusy] = useState(false);
const convertFirestoreTime = (timeValue) => {
    if (!timeValue) return "—";
    return new Date(timeValue.seconds * 1000).toLocaleString();
  };
// ================= FETCH NOTIFICATIONS =================
const handleFetchNotifications = async () => {
  setIsNotificationLoading(true); // 🔥 start spinner
  const startTime = Date.now(); // ⏱ track start
  try {
    const snapshot = await getDocs(collection(db, "notifications"));
    const list = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setNotificationRegistry(list);
  } catch (error) {
    console.error("Error fetching notifications:", error);
  } finally {
    const elapsed = Date.now() - startTime;
    // ⏳ ensure minimum 10 seconds spinner
    const remainingTime = 10000 - elapsed;
    setTimeout(() => {
      setIsNotificationLoading(false); // 🔥 stop after 10 sec
    }, remainingTime > 0 ? remainingTime : 0);
  }
};
useEffect(() => {
  handleFetchNotifications();
  const interval = setInterval(() => {
    handleFetchNotifications();
  }, 10000); // 🔁 every 10 sec
  return () => clearInterval(interval);
}, []);
const [notificationRegistry, setNotificationRegistry] = useState([]);//Provider Notifications//
const [isNotificationLoading, setIsNotificationLoading] = useState(false);//Provider Notifications//
  const [queryMap, setQueryMap] = useState({
  id: "",
  userId: "",
  title: "",
  description: "",
  type: "",
  isRead: "",
  time: "",
  image: "",
  createdAt: "",
  timestamp: "",
  badge: "",
  service: "",
  bookingDate: "",
  bookingTime: "",
  duration: "",
  totalAmount: "",
  customerName: "",
  customerAddress: "",
  petType: "",
  hasPets: ""
});
const updateQueryValue = (key, value) => {
  setQueryMap((prev) => ({
    ...prev,
    [key]: value.toLowerCase()
  }));
};//Provider Notifications//
const refinedNotifications = notificationRegistry.filter((entry) => {
  const payload = entry?.data || {};
  const matcher = (key, value) => {
    if (!queryMap[key]) return true;
    return (value || "")
      .toString()
      .toLowerCase()
      .includes(queryMap[key]);
  };
  return (
    matcher("id", entry?.id) &&
    matcher("userId", entry?.userId) &&
    matcher("title", entry?.title) &&
    matcher("description", entry?.description) &&
    matcher("type", entry?.type) &&
    matcher("isRead", entry?.isRead ? "true" : "false") &&
    matcher("time", entry?.time) &&
    matcher("image", entry?.image) &&
    matcher("createdAt", entry?.createdAt) &&
    matcher("timestamp", payload?.timestamp) &&
    matcher("badge", payload?.badgeName) &&
    matcher("service", payload?.serviceName) &&
    matcher("bookingDate", payload?.bookingDate) &&
    matcher("bookingTime", payload?.bookingTime) &&
    matcher("duration", payload?.duration) &&
    matcher("totalAmount", payload?.totalAmount) &&
    matcher("customerName", payload?.customerName) &&
    matcher("customerAddress", payload?.customerAddress) &&
    matcher("petType", payload?.petType) &&
    matcher("hasPets", payload?.hasPets?.toString())
  );
});//provider Notifications//
/* ================= VISUAL DEFINITIONS ================= */
const tableFrame = {
  width: "100%",
  borderCollapse: "collapse",
  backgroundColor: "#ffffff",
};
const columnHeader = {
  border: "1px solid #d1d5db",
  padding: "10px",
  backgroundColor: "#eef2f7",
  fontWeight: "600",
  fontSize: "12px",
};
const columnData = {
  border: "1px solid #e5e7eb",
  padding: "10px",
  fontSize: "12px",
};
const [isDataLoading, setIsDataLoading] = useState(true);//Provider Onboarding Part//
  useEffect(() => {
    retrievePartnerLedger();
  }, []);
  const retrievePartnerLedger = async () => {
  try {
    const ledgerRef = collection(
      db,
      "stripe market place",
      "providers",
      "list"
    );
    const ledgerSnapshot = await getDocs(ledgerRef);
    // 🔥 DEBUG
    console.log("🔥 Snapshot Size:", ledgerSnapshot.size);
    console.log("🔥 Raw Docs:", ledgerSnapshot.docs);
    const structuredData = ledgerSnapshot.docs.map((item) => {
      const source = item.data();
      console.log("📄 Each Doc:", item.id, source); // 🔥 DEBUG
      return {
        uid: item.id,
        paymentStatus: source.chargesEnabled ?? null,
        payoutStatus: source.payoutsEnabled ?? null,
        initiatedOn: source.created_at ?? null,
        modifiedOn: source.updated_at ?? null,
        onboardingClosedAt: source.onboardingCompletedAt ?? null,
        displayName: source.name ?? "",
        emailAddress: source.email ?? "",
        kycState: source.kyc_status ?? "",
        stripePhase: source.stripeStatus ?? "",
        onboardingStage: source.stripe_onboarding_status ?? "",
        stripeAccountCode: source.stripe_account_id ?? "",
        externalProviderId: source.providerId ?? item.id,
        verificationMode: source.verification_source ?? "",
      };
    });
    console.log("✅ Final Structured Data:", structuredData);
    setPartnerLedger(structuredData);
  } catch (err) {
    console.error("❌ Data Retrieval Failed:", err);
  } finally {
    setIsDataLoading(false);
  }
};
  const renderDateTime = (val) => {
    return val?.toDate?.().toLocaleString() || "-";//Provider Onboarding Part//
  };
  const formatFirestoreDate = (timestamp) => {
  if (!timestamp) return "-";
  try {
    // ✅ Firestore Timestamp
    if (typeof timestamp === "object" && timestamp.seconds) {
      return new Date(timestamp.seconds * 1000).toLocaleString("en-IN", {
        dateStyle: "medium",
        timeStyle: "short",
      });
    }
    // ✅ If it's already a JS Date / string
    return new Date(timestamp).toLocaleString("en-IN", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  } catch (err) {
    return "-";
  }
};
const [providersList, setProvidersList] = useState([]); // ✅ FIX
const [showProviderOnboarding, setShowProviderOnboarding] = useState(false);//Provider Onboarding part//
const [noteModalOpen, setNoteModalOpen] = useState(false);
const [selectedDoc, setSelectedDoc] = useState(null);
const [approvalAction, setApprovalAction] = useState(null);
const [adminUserName, setAdminUserName] = useState("");
const [adminNote, setAdminNote] = useState("");//Provider Notifications Part//

const [showProviderNotifications, setShowProviderNotifications] = useState(false);
const NOT_APPLICABLE = "Not Applicable";
  // ================= FIELD FORMAT HANDLER =================
  const handleFieldFormatting = (value) => {
    if (value === undefined || value === null || value === "") {
      return NOT_APPLICABLE;
    }
    if (typeof value === "boolean") {
      return value ? "True" : "False";
    }
    // Firestore Timestamp conversion
    if (typeof value === "object" && value.seconds !== undefined) {
      return new Date(value.seconds * 1000).toLocaleString();
    }
    return value;
  };
  // ================= FETCH NOTIFICATIONS =================
  const handleNotificationRegistryFetch = async () => {
    try {
      const snapshot = await getDocs(collection(db, "notifications"));
      const notificationList = snapshot.docs.map((docNode) => ({
        id: docNode.id,
        ...docNode.data()
      }));
      setNotificationRegistry(notificationList);
    } catch (error) {
      console.error("Notification Fetch Error:", error);
    }
    setIsNotificationLoading(false);
  };
  useEffect(() => {
    handleNotificationRegistryFetch();
  }, []);
  // ================= TABLE STYLE =================
  const tableStyleRegistry = {
    width: "100%",
    borderCollapse: "collapse"
  };
  const cellStyleRegistry = {
    padding: "8px 6px",
    textAlign: "left",
    verticalAlign: "top"
  };
const summaryCardStyle = () => ({
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "8px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
});
const [showVerificationDocuments, setShowVerificationDocuments] = useState(false);
  useEffect(() => {
    fetchVerificationDocs();
  }, []);
  const fetchVerificationDocs = async () => {
    try {
      const snapshot = await getDocs(collection(db, "VerificationDocuments"));
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));
      setDocs(data);
      setFetchingDocs(false);
    } catch (error) {
      console.error("Error fetching verification docs:", error);
      setFetchingDocs(false);
    }
  };
// ✅ ALWAYS declare state first
const [bookingFilters, setBookingFilters] = useState({
  fromDate: "",
  toDate: "",
});
const bodyCellStyle = { padding: "10px" };
/* ================= FILTER STATE ================= */
const [filterInputs, setFilterInputs] = useState({
  bookingId: "",
  Date: "",
  Time: "",
  address: "",
  basePrice: "",
  bookingDate: "",
  bookingDateTimestamp: "",
  bookingStatus: "",
  bookingTimeStamp: "",
  createdAt: "",
  customerId: "",
  userId: "",
  date: "",
  time: "",
  discount: "",
  duration: "",
  durationHours: "",
  durationMinutes: "",
  totalDurationHours: "",
  fullName: "",
  phoneNumber: "",
  hasPets: "",
  petType: "",
  petDetails: "",
  paymentStatus: "",
  platFormFee: "",
  platformFee: "",
  providerId: "",
  providerName: "",
  quantity: "",
  selectedDate: "",
  selectedTime: "",
  serviceDuration: "",
  serviceId: "",
  serviceImagePath: "",
  serviceName: "",
  subtotal: "",
  totalCharge: "",
  vat: "",
  booking_id: "",
  booking_status: "",
  captured_at: "",
  created_at: "",
  currency: "",
  customer_id: "",
  customer_total_amount: "",
  markup_rate: "",
  paid: "",
  payment_intent_id: "",
  platform_fee_rate: "",
  platform_revenue_amount: "",
  provider_id: "",
  provider_payout_amount: "",
  refunded_at: "",
  service_price: "",
  status: "",
  stripe_checkout_session_id: "",
  stripe_connected_account_id: "",
  stripe_payment_intent_id: "",
  stripe_status: "",
  updated_at: "",
});

/* ================= FILTER HANDLER ================= */
const onFilterChange = (fieldKey, value) => {
  setFilterInputs((prev) => ({
    ...prev,
    [fieldKey]: value,
  }));
};

const updateBookingFilter = (fieldKey, value) => {
  setBookingFilters((prev) => ({
    ...prev,
    [fieldKey]: value,
  }));
};

const resetBookingFilters = () => {
  setBookingFilters({
    fromDate: "",
    toDate: "",
  });

  setFilterInputs({
    bookingId: "",
    Date: "",
    Time: "",
    address: "",
    basePrice: "",
    bookingDate: "",
    bookingDateTimestamp: "",
    bookingStatus: "",
    bookingTimeStamp: "",
    createdAt: "",
    customerId: "",
    userId: "",
    date: "",
    time: "",
    discount: "",
    duration: "",
    durationHours: "",
    durationMinutes: "",
    totalDurationHours: "",
    fullName: "",
    phoneNumber: "",
    hasPets: "",
    petType: "",
    petDetails: "",
    paymentStatus: "",
    platFormFee: "",
    platformFee: "",
    providerId: "",
    providerName: "",
    quantity: "",
    selectedDate: "",
    selectedTime: "",
    serviceDuration: "",
    serviceId: "",
    serviceImagePath: "",
    serviceName: "",
    subtotal: "",
    totalCharge: "",
    vat: "",
    booking_id: "",
    booking_status: "",
    captured_at: "",
    created_at: "",
    currency: "",
    customer_id: "",
    customer_total_amount: "",
    markup_rate: "",
    paid: "",
    payment_intent_id: "",
    platform_fee_rate: "",
    platform_revenue_amount: "",
    provider_id: "",
    provider_payout_amount: "",
    refunded_at: "",
    service_price: "",
    status: "",
    stripe_checkout_session_id: "",
    stripe_connected_account_id: "",
    stripe_payment_intent_id: "",
    stripe_status: "",
    updated_at: "",
  });
};

/* ================= BOOKING DATE PARSER ================= */
const getActualBookingDate = (booking) => {
  const rawBookingDate =
    booking.selectedDate ||
    booking.bookingDate ||
    booking.date ||
    booking.Date ||
    null;

  if (!rawBookingDate) return null;

  if (rawBookingDate?.seconds) {
    const parsed = new Date(rawBookingDate.seconds * 1000);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  if (typeof rawBookingDate === "number") {
    const parsed = new Date(
      rawBookingDate < 1e12 ? rawBookingDate * 1000 : rawBookingDate
    );
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  if (typeof rawBookingDate === "string") {
    const trimmed = rawBookingDate.trim();

    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      const parsed = new Date(`${trimmed}T00:00:00`);
      return isNaN(parsed.getTime()) ? null : parsed;
    }

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(trimmed)) {
      const [dd, mm, yyyy] = trimmed.split("/");
      const parsed = new Date(`${yyyy}-${mm}-${dd}T00:00:00`);
      return isNaN(parsed.getTime()) ? null : parsed;
    }

    const parsed = new Date(trimmed);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  return null;
};

/* ================= DATE RANGE FILTER ================= */
const dateRangeFilteredBookings = useMemo(() => {
  if (!Array.isArray(bookingRegistry)) return [];

  if (!bookingFilters.fromDate || !bookingFilters.toDate) {
    return bookingRegistry;
  }

  const fromBoundary = new Date(`${bookingFilters.fromDate}T00:00:00`);
  const toBoundary = new Date(`${bookingFilters.toDate}T23:59:59.999`);

  return bookingRegistry.filter((booking) => {
    const bookingDate = getActualBookingDate(booking);
    if (!bookingDate) return false;
    return bookingDate >= fromBoundary && bookingDate <= toBoundary;
  });
}, [bookingRegistry, bookingFilters.fromDate, bookingFilters.toDate]);

/* ================= TABLE FILTER ONLY ================= */
const visibleBookingRegistry = useMemo(() => {
  if (!Array.isArray(dateRangeFilteredBookings)) return [];

  return dateRangeFilteredBookings.filter((record) => {
    return Object.entries(filterInputs).every(([fieldKey, rawFilter]) => {
      const isEmpty =
        rawFilter === undefined ||
        rawFilter === null ||
        (typeof rawFilter === "string" && rawFilter.trim() === "");

      if (isEmpty) return true;

      const cellValue = record[fieldKey];
      if (cellValue === undefined || cellValue === null) return false;

      const filterValue = String(rawFilter).toLowerCase();

      if (typeof cellValue === "string") {
        return cellValue.toLowerCase().includes(filterValue);
      }

      if (typeof cellValue === "number") {
        return String(cellValue).includes(filterValue);
      }

      if (typeof cellValue === "boolean") {
        return cellValue.toString().toLowerCase() === filterValue;
      }

      return String(cellValue).toLowerCase().includes(filterValue);
    });
  });
}, [dateRangeFilteredBookings, filterInputs]);

/* ================= ANALYTICS BOOKINGS ================= */
/* only date range should affect graph */
const analyticsBookings = useMemo(() => {
  if (!Array.isArray(dateRangeFilteredBookings)) return [];
  return dateRangeFilteredBookings;
}, [dateRangeFilteredBookings]);

/* ================= STATUS COUNTS ================= */
const statusCounts = useMemo(() => {
  const statuses = [
    "New",
    "Pending",
    "Confirmed",
    "Accepted",
    "On the way",
    "Rated",
    "Arrived",
    "Cancelled",
    "Completed",
    "Refunded",
    "paid",
    "payment_failed",
    "payment_Pending",
  ];

  const counts = {};
  statuses.forEach((status) => {
    counts[status] = 0;
  });

  analyticsBookings.forEach((booking) => {
    const rawStatus =
      booking.bookingStatus ||
      booking.booking_status ||
      booking.status ||
      booking.stripe_status;

    if (!rawStatus) return;

    const normalized = rawStatus.toString().trim().toLowerCase();

    statuses.forEach((status) => {
      if (normalized === status.toLowerCase()) {
        counts[status]++;
      }
    });
  });

  return counts;
}, [analyticsBookings]);

/* ================= STATUS COLORS ================= */
const statusColors = {
  New: "#3b82f6",
  Pending: "#f59e0b",
  Confirmed: "#10b981",
  Accepted: "#6366f1",
  "On the way": "#0ea5e9",
  Rated: "#8b5cf6",
  Arrived: "#14b8a6",
  Cancelled: "#ef4444",
  Completed: "#22c55e",
  Refunded: "#f97316",
  paid: "#22c55e",
  payment_failed: "#ef4444",
  payment_Pending: "#eab308",
};
const BOOKINGS_SERVICE_ENDPOINT =
  "https://getbookings-mc4pzotprq-uc.a.run.app";
/* -----------------------------
   Data Normalizer / Presenter
-------------------------------- */
const presentCellValue = (rawValue) => {
  if (rawValue === null || rawValue === undefined) return "";
  if (typeof rawValue === "object" && rawValue._seconds) {
    return new Date(rawValue._seconds * 1000).toLocaleString();
  }
  if (typeof rawValue === "object") {
    return JSON.stringify(rawValue);
  }
  if (typeof rawValue === "boolean") {
    return rawValue ? "true" : "false";
  }
  return rawValue;
};
  /* -----------------------------
     Data Loader
  -------------------------------- */
  useEffect(() => {
    loadBookingRegistry();
  }, []);
  const loadBookingRegistry = async () => {
  try {
    setRegistryLoading(true); // 🔥 REQUIRED
    setRegistryError("");
    const apiResponse = await fetch(BOOKINGS_SERVICE_ENDPOINT);
    const payload = await apiResponse.json();
    if (!payload.success) {
      throw new Error("Booking registry fetch failed");
    }
    setBookingRegistry(payload.bookings || []);
  } catch (err) {
    setRegistryError(err.message);
  } finally {
    setRegistryLoading(false);
  }
};
const GlobalLoader = ({ show }) => {
  if (!show) return null;
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(255,255,255,0.75)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: 60,
          height: 60,
          border: "6px solid #E5E7EB",
          borderTop: "6px solid #2563EB",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}
      />
      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};
const SummaryCard = ({ title, value, bg }) => (
  <div
    style={{
      backgroundColor: bg,
      padding: 16,
      borderRadius: 12,
      textAlign: "center",
    }}
  >
    <h4>{title}</h4>
    <p>{value}</p>
  </div>
);
const TableHead = ({ children }) => (
  <th style={{ padding: 12, textAlign: "left", fontWeight: 600, color: "#111827" }}>
    {children}
  </th>
);
const TableCell = ({ children, style }) => (
  <td style={{ padding: 12, ...style }}>{children}</td>
);
// ================= HELPER COMPONENT =================
const SectionTable = ({ title, headers, rows }) => (
  <div style={{ marginTop: "24px" }}>
    <h4 style={{ marginBottom: "12px", fontWeight: 600 }}>{title}</h4>
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead style={{ background: "#F3F4F6" }}>
        <tr>
          {headers.map((h, idx) => (
            <th key={idx} style={{ padding: "10px", textAlign: "left" }}>{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((r, idx) => (
          <tr key={idx}>
            {Object.values(r).map((v, i) => (
              <td key={i} style={{ padding: "10px" }}>{v}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
  // ================= STATE =================
  const [providerLogs, setProviderLogs] = useState([]);
  const [customerLogs, setCustomerLogs] = useState([]);
  // ================= EXECUTE BACKEND TRIGGER =================
  const executePushTrigger = async () => {
    setIsProcessing(true);
    try {
      const response = await fetch(
        "https://sendpushfrombackend-mc4pzotprq-uc.a.run.app",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({}),
        }
      );
      const data = await response.json();
      // ================= UPDATE STATE =================
      setProviderLogs(data.providerNotifications || []);
      setCustomerLogs(data.customerNotifications || []);
      const combinedLogs = (data.logs || []).map((msg) => ({
        message: msg,
        system: true,
      }));
      setActivityLogs(combinedLogs);
    } catch (err) {
      console.error("Error triggering backend:", err);
      setActivityLogs((prev) => [
        ...prev,
        { message: "🔥 Backend trigger failed", system: true },
      ]);
    } finally {
      setIsProcessing(false);
    }
  };
const showProviders = logSourceFilter === "ALL" || logSourceFilter === "PROVIDER";
const showUsers = logSourceFilter === "ALL" || logSourceFilter === "USER";
const allNotifications = [
  ...providerNotifications,
  ...customerNotifications,
];
const totalCount = allNotifications.length;
const sentCount = allNotifications.filter(n => n.sent).length;
const failedCount = allNotifications.filter(n => !n.sent).length;
const [logs, setLogs] = useState([]);
const [isProcessing, setIsProcessing] = useState(false);
const [showCustomerList, setShowCustomerList] = useState(false);
const [showCustomerBookingList, setShowCustomerBookingList] = useState(false);
const [showProvidersList, setShowProvidersList] = useState(false);
const [showProviderBookingList, setShowProviderBookingList] = useState(false);
const [selectedRefundFilter, setSelectedRefundFilter] = useState("");
const [providerFilterId, setProviderFilterId] = React.useState("");
const [userFilterId, setUserFilterId] = React.useState("");
const [isProviderModalOpen, setIsProviderModalOpen] = useState(false);
const [filterText, setFilterText] = useState("");
const [isUserModalOpen, setIsUserModalOpen] = useState(false);
// Table / Grid styles
const gridStyle = {
  width: "100%",
  borderCollapse: "collapse",
  fontFamily: "'Inter', sans-serif",
  fontSize: "14px",
  color: "#374151",
};
const headerCellStyle = {
  padding: "12px",
  textAlign: "left",
  backgroundColor: "#F9FAFB",
  borderBottom: "1px solid #E5E7EB",
};
const cellStyle = {
  padding: "12px",
  borderBottom: "1px solid #E5E7EB",
};
const preformattedStyle = {
  backgroundColor: "#F3F4F6",
  padding: "8px",
  borderRadius: "6px",
  overflowX: "auto",
};
  const [scanResult, setScanResult] = useState(null);
  const [isLoadingScan, setIsLoadingScan] = useState(false);
  const [scanError, setScanError] = useState("");
  const [selectedDomain, setSelectedDomain] = useState("users");
  const loadDeepScanData = async () => {
    setIsLoadingScan(true);
    setScanError("");
    try {
      const response = await fetch(
        "https://deepscanusersandproviders-mc4pzotprq-uc.a.run.app"
      );
      const data = await response.json();
      if (data.success) {
        setScanResult(data.data);
      } else {
        setScanError("Failed to load data from server");
      }
    } catch (err) {
      setScanError(err.message || "Unknown error");
    }
    setIsLoadingScan(false);
  };
  // Render object as grid
  const renderDataGrid = (data) => (
    <table style={gridStyle}>
      <thead>
        <tr>
          <th style={headerCellStyle}>Field</th>
          <th style={headerCellStyle}>Value</th>
        </tr>
      </thead>
      <tbody>
        {Object.entries(data || {}).map(([key, value]) => (
          <tr key={key}>
            <td style={cellStyle}>{key}</td>
            <td style={cellStyle}>
              {typeof value === "object" ? (
                <pre style={preformattedStyle}>
                  {JSON.stringify(value, null, 2)}
                </pre>
              ) : (
                String(value)
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
  // Render each document in a collection
  const renderCollection = (collectionData) =>
    collectionData.map((doc, index) => (
      <div
        key={index}
        style={{
          marginBottom: "16px",
          background: "#F9FAFB",
          padding: "12px",
          borderRadius: "8px",
        }}
      >
        {renderDataGrid(doc)}
        {doc.subcollections &&
          Object.entries(doc.subcollections).map(([subName, subDocs]) => (
            <div key={subName} style={{ marginTop: "12px" }}>
              <h5 style={{ fontWeight: "600" }}>📦 {subName} Subcollection</h5>
              {subDocs.map((subDoc, subIndex) => (
                <div
                  key={subIndex}
                  style={{
                    marginTop: "8px",
                    background: "#fff",
                    padding: "8px",
                    borderRadius: "6px",
                  }}
                >
                  {renderDataGrid(subDoc)}
                </div>
              ))}
            </div>
          ))}
      </div>
    ));
const [showProviderLogs, setShowProviderLogs] = useState(false);
const [activeNotificationTab, setActiveNotificationTab] = useState(""); // Unique state
const [showNotificationLogs, setShowNotificationLogs] = useState(false);
const [responsePayload, setResponsePayload] = useState(null);
const [activityLogs, setActivityLogs] = useState([]);
const [showSidebar, setShowSidebar] = useState(true);
const [showPasswordModal, setShowPasswordModal] = useState(true);
const [passwordInput, setPasswordInput] = useState("");
const handlePasswordSubmit = () => {
    if (passwordInput === "1234") {
      setShowPasswordModal(false);
      toast.success("Access Granted!");
    } else {
      toast.error("Incorrect Password");
      setPasswordInput(""); // Clear input
    }
  };
const getRefundStatusBadge = (status) => {
  switch (status) {
    case "Refund New":
      return "bg-yellow-100 text-yellow-700 px-2 py-1 rounded-full text-xs";
    case "Refund Pending":
      return "bg-orange-100 text-orange-700 px-2 py-1 rounded-full text-xs";
    case "Refund Issued":
      return "bg-blue-100 text-blue-700 px-2 py-1 rounded-full text-xs";
    case "Refund Confirmed":
      return "bg-purple-100 text-purple-700 px-2 py-1 rounded-full text-xs";
    case "Refund Completed":
      return "bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs";
    default:
      return "bg-gray-100 text-gray-700 px-2 py-1 rounded-full text-xs";
  }
};
const [refundReason, setRefundReason] = useState("");
const [approveStatus, setApproveStatus] = useState("");
// Inside your component at the top with other useState declarations
const [refundStatus, setRefundStatus] = useState(""); // Add this
const [approvePassword, setApprovePassword] = useState(""); // <-- new state
const [approverName, setApproverName] = useState("");
const [approveModal, setApproveModal] = useState(false);
const [approveEvent, setApproveEvent] = useState(null);
const [selectedAdminForRequest, setSelectedAdminForRequest] = useState("");
const [refundRequestAmount, setRefundRequestAmount] = useState("");
const [refundRequestReason, setRefundRequestReason] = useState("");
// At the top of your FirestoreData component
const [logsModal, setLogsModal] = useState({
  show: false,
  consumer: null,
});
const [response, setResponse] = useState(null); // <-- add this state
const [consumerDateFilter, setConsumerDateFilter] = useState("");
const [currentFinancialTab, setCurrentFinancialTab] = useState("invoices");
const [refundModal, setRefundModal] = useState({ show: false, customerId: "", logIndex: null });
const [refundAmount, setRefundAmount] = useState("");
const handleRefund = async (customerId, eventIndex, refundAmount) => {
  try {
    const customerRef = doc(db, "Payment_Logs", customerId);
    const customerSnap = await getDoc(customerRef);
    if (!customerSnap.exists()) return;
    const data = customerSnap.data();
    const events = data.events || [];
    // Update amount in the specific event
    events[eventIndex] = {
      ...events[eventIndex],
      amount: Number(refundAmount),
      eventType: "refund", // optional: mark as refund
      status: "refunded",  // optional
      timestamp: Date.now(),
    };
    // Update Firestore
    await updateDoc(customerRef, { events });
    // Update UI immediately
    setConsumers((prev) =>
      prev.map((c) =>
        c.id === customerId ? { ...c, events: events } : c
      )
    );
    setRefundModal({ show: false });
    setRefundAmount("");
  } catch (err) {
    console.error("Refund error:", err);
  }
};
const [consumers, setConsumers] = useState([]); // each consumer will include events
  /* ================= REFUND COUNTS ================= */
  const refundCounts = React.useMemo(() => {
    const counts = {
      "Refund New": 0,
      "Refund Pending": 0,
      "Refund Issued": 0,
      "Refund Confirmed": 0,
      "Refund Completed": 0,
    };
    (consumers || []).forEach((c) => {
      (c.events || []).forEach((ev) => {
        const status = ev.refundApproval?.refundStatus;
        if (status && counts[status] !== undefined) {
          counts[status]++;
        }
      });
    });
    return counts;
  }, [consumers]);
const [consumerSearch, setConsumerSearch] = useState("");
const [rowFilters, setRowFilters] = useState({});
const [fetching, setFetching] = useState(false);
const [fetchError, setFetchError] = useState(null);
const prettyTime = (ts) => new Date(ts).toLocaleString();
const fetchConsumersWithLogs = async () => {
  setFetching(true);
  setFetchError(null);
  try {
    const snapshot = await getDocs(collection(db, "Payment_Logs"));
    const data = snapshot.docs.map((doc) => {
      const d = doc.data();
      const mappedEvents = (d.events || [])
        .slice()
        .reverse()
        .map((ev) => {
          // 🎨 Payment Status Badge
          const statusBadge =
            ev.status === "success"
              ? "bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs"
              : ev.status === "failed"
              ? "bg-red-100 text-red-700 px-2 py-1 rounded-full text-xs"
              : ev.status === "pending"
              ? "bg-yellow-100 text-yellow-700 px-2 py-1 rounded-full text-xs"
              : "bg-gray-100 text-gray-700 px-2 py-1 rounded-full text-xs";
          // 📌 Refund Status & Badge
          const refundStatus = ev.refundApproval?.refundStatus || null;
          const refundStatusBadge = refundStatus
            ? refundStatus === "Refund New"
              ? "bg-yellow-100 text-yellow-700 px-2 py-1 rounded-full text-xs"
              : refundStatus === "Refund Pending"
              ? "bg-orange-100 text-orange-700 px-2 py-1 rounded-full text-xs"
              : refundStatus === "Refund Issued"
              ? "bg-blue-100 text-blue-700 px-2 py-1 rounded-full text-xs"
              : refundStatus === "Refund Confirmed"
              ? "bg-purple-100 text-purple-700 px-2 py-1 rounded-full text-xs"
              : refundStatus === "Refund Completed"
              ? "bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs"
              : "bg-gray-100 text-gray-700 px-2 py-1 rounded-full text-xs"
            : "bg-gray-100 text-gray-700 px-2 py-1 rounded-full text-xs";
          // Request Reason (from Firestore)
          const requestReason = ev.refundApproval?.requestReason || "-";
          return {
            eventId: ev.eventId || "-",
            eventType: ev.eventType || "-",
            customerId: ev.customerId || "-",
            customerName: ev.name || d.name || "-",
            amount: ev.amount ?? "-",
            status: ev.status || "-",
            statusBadge,
            paymentIntentId: ev.paymentIntentId || "-",
            stripeId: ev.stripeId || "-",
            walletBalance: ev.walletBalance ?? "-",
            refundApproval: {
              adminToApprove: ev.refundApproval?.adminToApprove || "-",
              approved: ev.refundApproval?.approved ?? false,
              approvedAt: ev.refundApproval?.approvedAt || null,
              approvedBy: ev.refundApproval?.approvedBy || "-",
              requestAmount: ev.refundApproval?.requestAmount ?? "-",
              requestReason,
              requested: ev.refundApproval?.requested ?? false,
              requestedBy: ev.refundApproval?.requestedBy || "-",
              refundStatus, // dynamic from Firestore
            },
            refundStatus,
            refundStatusBadge, // badge class for UI
            requestReason,
            timestamp: ev.timestamp || Date.now(),
          };
        });
      return {
        id: doc.id,
        name: d.name || "-",
        email: d.email || "-",
        events: mappedEvents,
      };
    });
    setConsumers(data);
  } catch (err) {
    console.error("Error fetching consumers:", err);
    setFetchError(err.message);
  } finally {
    setFetching(false);
  }
};
// Track overall timeline document upload completion %
const [timelineCompletion, setTimelineCompletion] = useState(0);
const [showPaymentLogs, setShowPaymentLogs] = useState(false);
const [showAutomatedProviderFlow, setShowAutomatedProviderFlow] = useState(false);
// State to track which tab is active inside Selected Agent Management
const [currentSection, setCurrentSection] = useState("Profile Info");
/* ================== Helpers & Data ================== */
// 🧮 Profile Completion Calculator
const calcCompletion = (data) => {
  let score = 0;
  if (data.displayName) score += 20;
  if (data.bio) score += 20;
  if (data.skills?.length) score += 20;
  if (data.photos?.length) score += 20;
  if (data.docsUploaded) score += 20;
  return score;
};
// 🛠️ Real Services List
const allServices = [
  "Plumbing", "Cleaning", "Cooking", "Electrical Repair", "Gardening",
  "Painting", "Babysitting", "Car Wash", "Tutoring", "Moving Help",
  "AC Repair", "Pest Control", "Appliance Installation", "Haircut",
  "Laundry Service",
];
// 📋 Document Types for Verification
const docTypes = [
  { key: "identityCheck", label: "Identity Check", desc: "Government-issued ID or passport" },
  { key: "addressProof", label: "Address Proof", desc: "Recent utility bill or bank statement" },
  { key: "dbsCheck", label: "Background / DBS Check", desc: "Criminal record verification document" },
  { key: "insurance", label: "Insurance Certificate", desc: "Liability or professional insurance proof" },
];
// 🧩 Expiry Status Logic
const expiryStatus = (expiry) => {
  if (!expiry) return { label: "No expiry", color: "green" };
  const now = new Date();
  const exp = new Date(expiry);
  const diffDays = Math.ceil((exp - now) / (1000 * 60 * 60 * 24));
  if (diffDays < 0) return { label: "Expired", color: "red" };
  if (diffDays <= 30) return { label: "Expiring soon", color: "orange" };
  return { label: "Valid", color: "green" };
};
/* ================== React States ================== */
const [email, setEmail] = useState("");
const [password, setPassword] = useState("");
const [serviceAgents, setServiceAgents] = useState([]);
const [currentAgent, setCurrentAgent] = useState(null);
const [selectedService, setSelectedService] = useState("");
const [profileForm, setProfileForm] = useState({ displayName: "", bio: "", skills: "" });
const [creditForm, setCreditForm] = useState({ engageCredits: "", referralWins: "" });
const [referralForm, setReferralForm] = useState({ referredEmail: "" });
const [docFiles, setDocFiles] = useState({});
const [docDates, setDocDates] = useState({});
const [agentDocs, setAgentDocs] = useState({});
const [overallCompletion, setOverallCompletion] = useState(0);
/* ================== Handlers ================== */
// 🔹 Signup (Firestore Only)
const handleSignup = async (e) => {
  e.preventDefault();
  if (!email || !password) return toast.error("Email & password required");
  try {
    // Create new provider record
    const providerRef = await addDoc(collection(db, "Provider_Signup"), {
      email,
      password, // ⚠️ For demo use only — remove in production
      providerStatus: "created",
      onboardingScore: 0,
      engageCredits: 0,
      referralWins: 0,
      profileCompletionScore: 0,
      referralCount: 0,
      tokenBalance: 0,
      createdAt: serverTimestamp(),
    });
    // Trigger analytics / logging
    await addDoc(collection(db, "journeyTriggers"), {
      providerId: providerRef.id,
      eventType: "provider.signup",
      createdAt: serverTimestamp(),
    });
    // Clear form
    setEmail("");
    setPassword("");
    toast.success("Service agent registered successfully!");
  } catch (error) {
    console.error("Signup failed:", error);
    toast.error("Signup failed: " + error.message);
  }
};
/* ===================================================
   🔸 Profile Update Handler
   =================================================== */
const handleProfileUpdate = async (e) => {
  e.preventDefault();
  if (!currentAgent) return toast.error("Select service agent first");
  const { displayName, bio, skills } = profileForm;
  const skillsArr = skills
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  try {
    const ref = doc(db, "Provider_Signup", currentAgent.id);
    const snap = await getDoc(ref);
    const oldData = snap.data() || {};
    const updatedData = {
      ...oldData,
      displayName,
      bio,
      skills: skillsArr,
    };
    const completionScore = calcCompletion(updatedData);
    await updateDoc(ref, {
      displayName,
      bio,
      skills: skillsArr,
      profileCompletionScore: completionScore,
      onboardingScore: completionScore,
      providerStatus:
        completionScore === 100 ? "ready_for_review" : oldData.providerStatus,
      updatedAt: serverTimestamp(),
    });
    toast.success("Profile updated successfully!");
  } catch (err) {
    console.error("Profile update failed:", err);
    toast.error("Profile update failed: " + err.message);
  }
};
/* ===================================================
   🔸 Document Upload Timeline Handler
   =================================================== */
const handleTimelineUpload = async (docKey) => {
  if (!currentAgent) {
    toast.error("Please select a service agent first");
    return;
  }
  const file = docFiles[docKey];
  if (!file) {
    toast.error(`Please choose a file for ${docKey} before uploading`);
    return;
  }
  try {
    // 🔹 Reference path in Firebase Storage
    const fileRef = ref(storage, `timelineDocs/${currentAgent.id}/${docKey}/${file.name}`);
    // 🔹 Start the resumable upload
    const uploadTask = uploadBytesResumable(fileRef, file);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // 🔸 Track upload progress
        const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        setUploadProgress((prev) => {
          const updated = { ...prev, [docKey]: progress };
          // 🔸 Calculate timeline completion percentage (for vertical slider)
          const completed = docTypes.filter(
            (d) => updated[d.key] === 100 || agentDocs[d.key]?.url
          ).length;
          const timelinePercent = Math.round((completed / docTypes.length) * 100);
          setTimelineCompletion(timelinePercent);
          return updated;
        });
      },
      (error) => {
        console.error("Upload failed:", error);
        toast.error(`Upload failed: ${error.message}`);
      },
      async () => {
        // ✅ Upload complete → get download URL
        const fileUrl = await getDownloadURL(uploadTask.snapshot.ref);
        // ✅ Prepare Firestore document
        const expiryDate = docDates[docKey] || null;
        const docData = {
          providerId: currentAgent.id,
          docType: docKey,
          url: fileUrl,
          expiryDate,
          uploadedAt: serverTimestamp(),
        };
        // ✅ Save uploaded document metadata
        await setDoc(
          doc(db, "gigProviderDocsTimeline", `${currentAgent.id}_${docKey}`),
          docData
        );
        // ✅ Log upload event for audit / triggers
        await addDoc(collection(db, "journeyTriggers"), {
          providerId: currentAgent.id,
          eventType: `provider.docs.${docKey}.uploaded`,
          createdAt: serverTimestamp(),
        });
        // ✅ Update local state so UI instantly turns green
        setAgentDocs((prev) => ({
          ...prev,
          [docKey]: docData,
        }));
        // ✅ Update progress and timeline state
        setUploadProgress((prev) => {
          const updated = { ...prev, [docKey]: 100 };
          const completed = docTypes.filter(
            (d) => updated[d.key] === 100 || agentDocs[d.key]?.url
          ).length;
          const timelinePercent = Math.round((completed / docTypes.length) * 100);
          setTimelineCompletion(timelinePercent);
          return updated;
        });

        toast.success(`${docKey} uploaded successfully!`);
      }
    );
  } catch (err) {
    console.error("Upload error:", err);
    toast.error("Upload failed: " + err.message);
  }
};
// 🔹 Shortcut Upload Handlers
const handleUploadIdentity = () => handleTimelineUpload("identityCheck");
const handleUploadAddress = () => handleTimelineUpload("addressProof");
const handleUploadDBS = () => handleTimelineUpload("dbsCheck");
const handleUploadInsurance = () => handleTimelineUpload("insurance");
/* ===================================================
   🔸 Verify Agent Handler
   =================================================== */
const handleVerify = async (agentId) => {
  try {
    await updateDoc(doc(db, "Provider_Signup", agentId), {
      providerStatus: "verified",
      updatedAt: serverTimestamp(),
    });
    await addDoc(collection(db, "journeyTriggers"), {
      providerId: agentId,
      eventType: "provider.docs.verified",
      createdAt: serverTimestamp(),
    });
    toast.success("Service agent verified!");
  } catch (err) {
    console.error("Verification failed:", err);
    toast.error("Verification failed: " + err.message);
  }
};

/* ===================================================
   🔸 Referral Count & Token Balance Update
   =================================================== */
const handleSaveManualChanges = async (e) => {
  e.preventDefault();
  if (!currentAgent) {
    return toast.error("Select service agent first");
  }
  const { referralCount, tokenBalance } = manualForm;
  try {
    const referralToAdd = Number(referralCount);
    const tokensToAdd = Number(tokenBalance);
    if (isNaN(referralToAdd) || isNaN(tokensToAdd)) {
      return toast.error("Please enter valid numbers");
    }
    await updateDoc(doc(db, "Provider_Signup", currentAgent.id), {
      referralCount: increment(referralToAdd),
      tokenBalance: increment(tokensToAdd),
      updatedAt: serverTimestamp(),
    });
    toast.success("Referral count & token balance updated!");
    setManualForm({
      referralCount: "",
      tokenBalance: "",
    });
  } catch (err) {
    console.error("Manual update failed:", err);
    toast.error("Update failed: " + err.message);
  }
};
/* ===================================================
   🔸 Job Assignment Handler
   =================================================== */
const handleAssignJob = async (agentId) => {
  if (!selectedService) return toast.error("Select service first");
  try {
    await addDoc(collection(db, "gigJobs"), {
      providerId: agentId,
      serviceName: selectedService,
      jobStatus: "assigned",
      createdAt: serverTimestamp(),
    });
    await addDoc(collection(db, "journeyTriggers"), {
      providerId: agentId,
      eventType: "provider.job.assigned",
      payload: { serviceName: selectedService },
      createdAt: serverTimestamp(),
    });
    toast.success(`Assigned job: ${selectedService}`);
  } catch (err) {
    console.error("Job assignment failed:", err);
    toast.error("Job assignment failed: " + err.message);
  }
};
/* ===================================================
   🔸 Manual Referral + Token Update Handler
   =================================================== */
const handleManualReferralSubmit = async (e) => {
  e.preventDefault();
  if (!currentAgent) {
    return toast.error("Select service agent first");
  }
  const { referralCount, tokenBalance } = manualForm;
  try {
    const referralToAdd = Number(referralCount);
    const tokensToAdd = Number(tokenBalance);
    if (isNaN(referralToAdd) || isNaN(tokensToAdd)) {
      return toast.error("Enter valid numbers");
    }
    // ✅ 1. Update Provider Counts
    await updateDoc(doc(db, "Provider_Signup", currentAgent.id), {
      referralCount: increment(referralToAdd),
      tokenBalance: increment(tokensToAdd),
      updatedAt: serverTimestamp(),
    });
    // ✅ 2. (Optional) Create referral logs
    for (let i = 0; i < referralToAdd; i++) {
      await addDoc(collection(db, "gigReferrals"), {
        providerId: currentAgent.id,
        status: "manual",
        createdAt: serverTimestamp(),
      });
    }
    // ✅ 3. Trigger event
    await addDoc(collection(db, "journeyTriggers"), {
      providerId: currentAgent.id,
      eventType: "provider.manual.referral",
      payload: {
        referralCount: referralToAdd,
        tokenBalance: tokensToAdd,
      },
      createdAt: serverTimestamp(),
    });
    toast.success("Manual referral & tokens updated!");
    setManualForm({
      referralCount: "",
      tokenBalance: "",
    });
  } catch (err) {
    console.error("Manual referral failed:", err);
    toast.error("Update failed: " + err.message);
  }
};
/* ================== Fetch Data ================== */
// 🔹 Fetch All Service Agents (from Firestore Only)
useEffect(() => {
  const q = query(collection(db, "Provider_Signup"), orderBy("createdAt", "desc"));
  const unsub = onSnapshot(
    q,
    (snap) => {
      const dataArr = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setServiceAgents(dataArr);
    },
    (error) => {
      console.error("Error fetching providers:", error);
      toast.error("Failed to fetch service agents");
    }
  );
  return () => unsub();
}, []);
// 🔹 Fetch Agent Document Timeline (for selected provider)
useEffect(() => {
  if (!currentAgent) return;
  const q = query(collection(db, "gigProviderDocsTimeline"));
  const unsub = onSnapshot(
    q,
    (snap) => {
      const docs = {};
      snap.forEach((d) => {
        const data = d.data();
        if (data.providerId === currentAgent.id) {
          docs[data.docType] = data;
        }
      });
      setAgentDocs(docs);
      // ✅ Calculate overall completion progress
      const uploadedCount = Object.keys(docs).length;
      setOverallCompletion(
        docTypes.length > 0 ? (uploadedCount / docTypes.length) * 100 : 0
      );
    },
    (error) => {
      console.error("Error fetching timeline docs:", error);
      toast.error("Failed to load document timeline");
    }
  );
  return () => unsub();
}, [currentAgent]);
// -------------------- STATE SETUP --------------------
const [fromDate, setFromDate] = useState(""); // selected start date
const [toDate, setToDate] = useState("");     // selected end date
const [showCalendar, setShowCalendar] = useState(false); // calendar modal visibility
const [chartMetric, setChartMetric] = useState("count"); // status chart metric
const [selectedFilter, setSelectedFilter] = useState("revenue"); // current chart filter
const [appliedDateRange, setAppliedDateRange] = useState({ from: null, to: null }); // active date range
// -------------------- DATA STATES --------------------
const [monthlyTypeRevenueData, setMonthlyTypeRevenueData] = useState([]); // monthly booking data
const [servicePlatformData, setServicePlatformData] = useState([]);       // service platform revenue data
// -------------------- APPLY BUTTON HANDLER --------------------
const handleApplyDateRange = () => {
  if (fromDate && toDate) {
    const from = new Date(fromDate);
    const to = new Date(toDate);
    setAppliedDateRange({
      from: from.toISOString().split("T")[0],
      to: to.toISOString().split("T")[0],
    });
  }
  setShowCalendar(false);
};
// -------------------- GENERATE MONTHLY REVENUE --------------------
useEffect(() => {
  const generateMonthlyBookings = (from, to) => {
    const bookings = [];
    const bookingTypes = ["confirmed", "pending", "new", "cancelled"];
    let current = new Date(from.getFullYear(), from.getMonth(), 1);
    while (current <= to) {
      const monthName = current.toLocaleString("default", { month: "short" });
      const totals = {};
      bookingTypes.forEach((type) => {
        switch (type) {
          case "confirmed":
            totals[type] = Math.floor(Math.random() * 7000 + 3000);
            break;
          case "pending":
            totals[type] = Math.floor(Math.random() * 2000 + 500);
            break;
          case "new":
            totals[type] = Math.floor(Math.random() * 4000 + 1000);
            break;
          case "cancelled":
            totals[type] = Math.floor(Math.random() * 1500 + 300);
            break;
          default:
            totals[type] = 0;
        }
      });
      bookings.push({
        date: `${current.getFullYear()}-${(current.getMonth() + 1).toString().padStart(2, "0")}-01`,
        month: monthName,
        ...totals,
        total: totals.confirmed + totals.pending + totals.new + totals.cancelled,
      });
      current.setMonth(current.getMonth() + 1);
    }
    return bookings;
  };
  if (appliedDateRange.from && appliedDateRange.to) {
    const from = new Date(appliedDateRange.from);
    const to = new Date(appliedDateRange.to);
    setMonthlyTypeRevenueData(generateMonthlyBookings(from, to));
  } else {
    const now = new Date();
    const defaultFrom = new Date(now.getFullYear(), 0, 1);
    const defaultTo = new Date(now.getFullYear(), 11, 31);
    setMonthlyTypeRevenueData(generateMonthlyBookings(defaultFrom, defaultTo));
  }
}, [appliedDateRange]);
// -------------------- GENERATE SERVICE PLATFORM DATA --------------------
useEffect(() => {
  const generateServicePlatformData = (monthlyData) => {
    const platforms = ["Web", "Mobile App", "Admin Portal"];
    return platforms.map((platform) => {
      // Sum random amounts over months
      const amount = monthlyData.reduce((sum) => sum + Math.floor(Math.random() * 8000 + 2000), 0);
      return { platform, amount };
    });
  };
  if (monthlyTypeRevenueData.length) {
    setServicePlatformData(generateServicePlatformData(monthlyTypeRevenueData));
  } else {
    setServicePlatformData([
      { platform: "Web", amount: 50000 },
      { platform: "Mobile App", amount: 60000 },
      { platform: "Admin Portal", amount: 30000 },
    ]);
  }
}, [monthlyTypeRevenueData]);
const getFilteredData = () => {
  const from = appliedDateRange.from ? new Date(appliedDateRange.from) : null;
  const to = appliedDateRange.to ? new Date(appliedDateRange.to) : null;
  // Helper: check if a month overlaps the selected range
  const isMonthInRange = (monthStr) => {
    if (!from || !to) return true;
    const monthDate = new Date(monthStr); // e.g., "2025-09-01"
    const monthStart = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1);
    const monthEnd = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0); // last day of month
    return monthEnd >= from && monthStart <= to;
  };
  if (selectedFilter === "revenue") {
    return monthlyTypeRevenueData
      .filter((item) => isMonthInRange(item.date));
  }
  if (selectedFilter === "totalAmount") {
    return monthlyTypeRevenueData
      .filter((item) => isMonthInRange(item.date));
  }
  if (selectedFilter === "servicePlatform") {
    return servicePlatformData;
  }
  return monthlyTypeRevenueData.filter((item) => isMonthInRange(item.date));
};
// -------------------- FILTERED STATUS DATA --------------------
const getFilteredStatusData = () => {
  return chartBookings.map((b) => {
    if (chartMetric === "totalRevenue") {
      return { ...b, amount: b.count * (Math.random() * 800 + 200) };
    } else if (chartMetric === "grossRevenue") {
      return { ...b, amount: b.count * (Math.random() * 1000 + 300) };
    } else {
      return b;
    }
  });
};
const [selectedMonth, setSelectedMonth] = useState("All");
const [revenueChartData, setRevenueChartData] = useState([
  { label: "Confirmed Bookings", revenue: 0 },
  { label: "Pending Bookings", revenue: 0 },
  { label: "New Bookings", revenue: 0 },
  { label: "Cancelled Bookings", revenue: 0 },
]);
useEffect(() => {
  const fetchRevenueData = async () => {
    try {
      // ✅ Fetch data from both Firestore collections
      const customerDocs = await getDocs(collection(db, "Booking_Customers"));
      const providerDocs = await getDocs(collection(db, "Booking_Providers"));
      // ✅ Combine both
      const allBookings = [
        ...customerDocs.docs.map((d) => d.data()),
        ...providerDocs.docs.map((d) => d.data()),
      ];
      // ✅ Initialize revenue accumulator
      const revenueTotals = {
        confirmed: 0,
        pending: 0,
        new: 0,
        cancelled: 0,
      };
      // ✅ Sum up amounts by booking type
      allBookings.forEach((entry) => {
        const type = entry.type?.toLowerCase();
        const amount = Number(entry.amount || 0);
        if (revenueTotals.hasOwnProperty(type)) {
          revenueTotals[type] += amount;
        }
      });
      // ✅ Update chart data dynamically
      setRevenueChartData([
        { label: "Confirmed Bookings", revenue: revenueTotals.confirmed },
        { label: "Pending Bookings", revenue: revenueTotals.pending },
        { label: "New Bookings", revenue: revenueTotals.new },
        { label: "Cancelled Bookings", revenue: revenueTotals.cancelled },
      ]);
    } catch (err) {
      console.error("Error fetching booking revenue data:", err);
    }
  };
  fetchRevenueData();
}, []);
  const [chartBookings, updateChartBookings] = useState([
    { label: "Confirmed Bookings", count: 0 },
    { label: "Pending Bookings", count: 0 },
    { label: "New Bookings", count: 0 },
    { label: "Cancelled Bookings", count: 0 },
  ]);
const colorScheme = ["#2ECC71", "#F1C40F", "#3498DB", "#E74C3C"]; // green, yellow, blue, red
const [showFinancialOverview, setShowFinancialOverview] = useState(false);
const [showFinancialBookings, setShowFinancialBookings] = useState(false);
const [financeOpen, setFinanceOpen] = useState(false);
const [activeButton, setActiveButton] = useState(null);
const [notifierSearchTitle, setNotifierSearchTitle] = useState("");
const [notifierSearchCustomerId, setNotifierSearchCustomerId] = useState("");
const [notifierSearchName, setNotifierSearchName] = useState("");
const [notifierSearchEmail, setNotifierSearchEmail] = useState("");
const [notifierSearchPhone, setNotifierSearchPhone] = useState("");
const [notifierSearchStatus, setNotifierSearchStatus] = useState("");
const [notifierSearchTime, setNotifierSearchTime] = useState("");
const [pgSearchName, setPgSearchName] = useState("");
const [pgSearchSubtitle, setPgSearchSubtitle] = useState("");
const [pgSearchStatus, setPgSearchStatus] = useState("");
// Handler for column-specific filter changes
const handleServiceHistoryColumnFilterChange = (column, value) => {
  setColumnFilters((prev) => ({
    ...prev,
    [column]: value,
  }));
};
  const [deletedEntries, setDeletedEntries] = useState([]);
  const handleColumnFilterChange = (column, value) => {
  setColumnFilters((prev) => ({ ...prev, [column]: value }));
};
const filteredTicketEntries = useMemo(() => {
  if (!Array.isArray(visibleTicketEntries)) return [];
  return visibleTicketEntries.filter((entry) => {
    return Object.entries(columnFilters).every(([column, value]) => {
      if (!value || value.trim() === "") return true;
      const needle = value.toString().toLowerCase();
      // pick the field from entry depending on column
      let hay = "";
      switch (column) {
        case "Date":
          hay = entry?.date ?? "";
          break;
        case "Time":
          hay = entry?.time ?? "";
          break;
        case "User":
          hay = entry?.user ?? "";
          break;
        case "Action":
          hay = entry?.action ?? "";
          break;
        case "Details":
          hay = Array.isArray(entry?.details) ? entry.details.join(" ") : entry?.details ?? "";
          break;
        case "Ticket Details":
          if (entry?.ticketDetails && typeof entry.ticketDetails === "object") {
            hay = Object.entries(entry.ticketDetails)
              .map(([k, v]) => `${k}:${v}`)
              .join(" ");
          } else hay = "";
          break;
        default:
          hay = JSON.stringify(entry ?? "");
      }
      // Safe: ensure hay is string before calling toLowerCase
      return (hay || "").toString().toLowerCase().includes(needle);
    });
  });
}, [visibleTicketEntries, columnFilters]);
  const [deletedOrders, setDeletedOrders] = useState(
    JSON.parse(localStorage.getItem("deletedOrders")) || []
  );
  // Update localStorage whenever deletedOrders changes
  useEffect(() => {
    localStorage.setItem("deletedOrders", JSON.stringify(deletedOrders));
  }, [deletedOrders]);
  const handleDeleteOrder = (transactionId) => {
    setDeletedOrders((prev) => [...prev, transactionId]);
    toast.success("Transaction deleted from UI");
  };
  const deleteWalletTxn = async (transactionId, participantType) => {
  if (!transactionId || !participantType) return;
  try {
    // 1️⃣ Determine correct Firestore collection
    const collectionName =
      participantType.toLowerCase() === "provider"
        ? "Provider_Wallet"
        : "Customer_Wallet";
    // 2️⃣ Reference the document
    const txnDocRef = doc(db, collectionName, transactionId);
    // 3️⃣ Delete from Firestore
    await deleteDoc(txnDocRef);
    // 4️⃣ Remove from UI immediately
    setWalletTransactions((prev) =>
      prev.filter((txn) => txn.transactionId !== transactionId)
    );
    // 5️⃣ Show toast message
    toast.success("Transaction deleted successfully!");
  } catch (error) {
    console.error("Delete failed:", error);
    toast.error("Failed to delete transaction. Please try again.");
  }
};
const [searchWalletId, setSearchWalletId] = useState("");
const [searchWalletType, setSearchWalletType] = useState("");
const [searchWalletName, setSearchWalletName] = useState("");
const [searchWalletEmail, setSearchWalletEmail] = useState("");
const [searchWalletMessage, setSearchWalletMessage] = useState("");
const [searchWalletTxnStatus, setSearchWalletTxnStatus] = useState("");
const [searchWalletAmount, setSearchWalletAmount] = useState("");
const [searchWalletCurrency, setSearchWalletCurrency] = useState("");
const [searchWalletBalance, setSearchWalletBalance] = useState("");
const [walletIdFilter, setWalletIdFilter] = useState("");
const [entityIdFilter, setEntityIdFilter] = useState("");
const [nameFilter, setNameFilter] = useState("");
const [messageFilter, setMessageFilter] = useState("");
const [statusFilter, setStatusFilter] = useState("");
const [amountFilter, setAmountFilter] = useState("");
const [currencyFilter, setCurrencyFilter] = useState("");
  // Inside your component function (e.g., FirestoreData)
const [rowsPerPageOrders, setRowsPerPageOrders] = useState(10); // default rows per page
const [currentOrdersPage, setCurrentOrdersPage] = useState(1);
// For column-specific search
const [completedOrdersSearch, setCompletedOrdersSearch] = useState({
  transactionId: "",
  participantType: "",
  name: "",
  email: "",
  message: "",
  status: "",
});
const [searchCode, setSearchCode] = useState("");
const [searchId, setSearchId] = useState("");
const [searchName, setSearchName] = useState("");
const [searchEmail, setSearchEmail] = useState("");
  const saveAddressEditUI = (userId, data) => {
  setTempUserList((prev) =>
    prev.map((usr) =>
      usr.id === userId ? { ...usr, address: data.address, postcode: data.postcode } : usr
    )
  );
  toast.success("Address updated successfully!", { position: "top-right", autoClose: 3000 });
};
const [editableAddressData, setEditableAddressData] = useState({ address: "", postcode: "" });
  const [showAddressModal, setShowAddressModal] = useState({
  visible: false,
  userId: null,
});
const [showDeleteModal, setShowDeleteModal] = useState({
  visible: false,
  userId: null,
  userName: ""
});
useEffect(() => {
  if (selectedPartnerForVerification) {
    const docRef = doc(db, "Partners_VerficationCompliance", selectedPartnerForVerification.id);
    getDoc(docRef).then((docSnap) => {
      if (docSnap.exists()) {
        setPartnerVerification((prev) => ({
          ...prev,
          [selectedPartnerForVerification.id]: docSnap.data(),
        }));
      } else {
        setPartnerVerification((prev) => ({
          ...prev,
          [selectedPartnerForVerification.id]: {},
        }));
      }
    });
  }
}, [selectedPartnerForVerification]);8
  const openVerificationTab = (partner) => {
  setSelectedPartnerForVerification(partner);
  setShowVerificationTab(true);
  setShowPartnerList(false);
};
 const [uploadProgress, setUploadProgress] = useState(0);
 const [overallProgress, setOverallProgress] = useState(0); // overall top progress
const [toasts, setToasts] = useState([]);
const showToast = (message, color = "Blue") => {
  const id = Date.now();
  setToasts((prev) => [...prev, { id, message, color }]);
  // Remove toast after 3 seconds
  setTimeout(() => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, 3000);
};
  const [showVerificationTab, setShowVerificationTab] = useState(false);
  const fetchWalletTransactions = async () => {
  try {
    const allTxns = [];
    // 1️⃣ Fetch provider wallet transactions
    const providerRef = collection(db, "Provider_Wallet");
    const providerSnap = await getDocs(providerRef);
    providerSnap.forEach((doc) => {
      const data = doc.data();
      allTxns.push({
        transactionId: doc.id, // Firestore document ID
        participantType: "provider",
        id: data.id || doc.id, // optional wallet ID
        name: data.name || "Unknown Provider",
        email: data.email || "",
        message: data.message || "",
        status: data.status || "",
        amount: Math.abs(data.amount || 0),
        currency: data.currency || "USD",
        walletBalanceAfter: data.walletBalanceAfter || 0,
        createdAt: data.createdAt?.toDate?.() || new Date(),
      });
    });
    // 2️⃣ Fetch customer wallet transactions
    const customerRef = collection(db, "Customer_Wallet");
    const customerSnap = await getDocs(customerRef);
    customerSnap.forEach((doc) => {
      const data = doc.data();
      allTxns.push({
        transactionId: doc.id,
        participantType: "customer",
        id: data.id || doc.id,
        name: data.name || "Unknown Customer",
        email: data.email || "",
        message: data.message || "",
        status: data.status || "",
        amount: Math.abs(data.amount || 0),
        currency: data.currency || "USD",
        walletBalanceAfter: data.walletBalanceAfter || 0,
        createdAt: data.createdAt?.toDate?.() || new Date(),
      });
    });
    // 3️⃣ Sort newest first
    allTxns.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    // 4️⃣ Update state
    setWalletTransactions(allTxns);
  } catch (error) {
    console.error("Error fetching wallet transactions:", error);
  }
};
// At the top of your component
const [searchServiceHistoryTerm, setSearchServiceHistoryTerm] = useState("");
const [searchCompletedOrdersTerm, setSearchCompletedOrdersTerm] = useState("");
const [walletSearchTerm, setWalletSearchTerm] = useState("");
const [participantType, setParticipantType] = useState("provider"); // default value
const [participantId, setParticipantId] = useState("");
const [participantName, setParticipantName] = useState("");
const [participantEmail, setParticipantEmail] = useState("");
// ---------------- STATE VARIABLES (NEW TERMINOLOGY) ----------------
const [creditProviderId, setCreditProviderId] = useState("");
const [creditSearchTerm, setCreditSearchTerm] = useState("");
const [creditProviderName, setCreditProviderName] = useState("");
const [creditProviderEmail, setCreditProviderEmail] = useState("");
const [creditCustomerId, setCreditCustomerId] = useState("");
const [creditCustomerName, setCreditCustomerName] = useState("");
const [creditCustomerEmail, setCreditCustomerEmail] = useState("");
  // --- Place these at the TOP of your component function (after imports, before return) ---
const [questionSearch, setQuestionSearch] = useState(""); // renamed search state (unique)
const [currentPage, setCurrentPage] = useState(1);       // pagination current page
// helper (non-hook) functions - safe to place here
const formatDateForDisplay = (createdAt) => {
  try {
    if (createdAt instanceof Date) return createdAt.toLocaleString();
    if (createdAt?.seconds) return new Date(createdAt.seconds * 1000).toLocaleString();
    if (typeof createdAt === "number") return new Date(createdAt).toLocaleString();
    return "-";
  } catch {
    return "-";
  }
};
const formatDateForInput = (createdAt) => {
  try {
    let date;
    if (createdAt instanceof Date) date = createdAt;
    else if (createdAt?.seconds) date = new Date(createdAt.seconds * 1000);
    else if (typeof createdAt === "number") date = new Date(createdAt);
    else date = new Date();
    return date.toISOString().slice(0, 16);
  } catch {
    return "";
  }
};
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  // -------------------- State Setup --------------------
const [discountCode, setDiscountCode] = useState("");
const [applyTo, setApplyTo] = useState("");
const [selectedId, setSelectedId] = useState("");
const [selectedName, setSelectedName] = useState("");
const [selectedEmail, setSelectedEmail] = useState("");
// -------------------- Auto-generate Discount Code --------------------
useEffect(() => {
  const generateCode = () => {
    const code = "DISC-" + Math.random().toString(36).substring(2, 8).toUpperCase();
    setDiscountCode(code);
  };
  generateCode();
}, []);
  const handleRestoreAllPartners = () => {
  localStorage.removeItem("removedPartnerIds");
  setRemovedPartnerIds([]);
};
// On component mount, load from localStorage
useEffect(() => {
  const storedIds = localStorage.getItem("removedPartnerIds");
  if (storedIds) {
    setRemovedPartnerIds(JSON.parse(storedIds));
  }
}, []);
  // ------------------------ Styles ------------------------
const tdStyle = {
  padding: "12px 16px",
  fontSize: "14px",
  color: "#374151",
};
  // ---------------- Quick Book a Job ----------------
const quickBookJob = async (providerId, jobId, workerName, setJobPosts) => {
  try {
    const jobRef = doc(db, "Provider_AutoMatching", providerId, "JobPortal", jobId);
    // If workerName is null or empty, set default value
    const finalWorkerName = workerName || "Job Booking completed";
    await updateDoc(jobRef, {
      quickBookedBy: finalWorkerName,
    });
    // Update local state to reflect in UI immediately
    setJobPosts(prev =>
      prev.map(job =>
        job.id === jobId ? { ...job, quickBookedBy: finalWorkerName } : job
      )
    );
    // ✅ Always show success message
    toast.success("Job Booking completed");
  } catch (error) {
    console.error("Error quick booking job:", error);
    // ❌ Removed toast.error (only log internally)
  }
};
// ---------------- Add Tokens Function ----------------
const addTokensToUser = async (providerId, jobId, userId, amount, setTokenWallet) => {
  try {
    let docRef;
    if (jobId && providerId) {
      // Tokens earned from a job
      docRef = doc(db, "Provider_AutoMatching", providerId, "JobPortal", jobId);
      await setDoc(
        docRef,
        {
          tokensEarnedByUser: {
            [userId]: increment(amount),
          },
        },
        { merge: true } // merge ensures existing data isn't overwritten
      );
    } else {
      // Tokens earned from watching ads
      docRef = doc(db, "Provider_AutoMatching", "AdTokensRoot");
      await setDoc(
        docRef,
        {
          tokensEarnedByUser: {
            [userId]: increment(amount),
          },
          updatedAt: new Date(),
        },
        { merge: true }
      );
    }
    // Update UI tokens immediately
    setTokenWallet(prev => {
      const updated = prev + amount;
      // Store tokens in localStorage for persistence
      localStorage.setItem("walletTokens", updated);
      return updated;
    });
    toast.success(`+${amount} tokens added!`);
  } catch (error) {
    console.error("Error adding tokens:", error);
    toast.error("Failed to add tokens.");
  }
};
useEffect(() => {
  const storedTokens = localStorage.getItem("walletTokens");
  if (storedTokens) {
    setTokenWallet(Number(storedTokens));
  }
}, []);
// ---------------- Apply to a Job ----------------
const applyToJob = async (providerId, jobId, userId, jobCost, setTokenWallet) => {
  try {
    // 1️⃣ Add user to appliedUsers list in the job
    const jobRef = doc(db, "Provider_AutoMatching", providerId, "JobPortal", jobId);
    await updateDoc(jobRef, {
      appliedUsers: arrayUnion(userId),
    });
    // 2️⃣ Deduct tokens from Firestore (AdTokensRoot) correctly
    const tokensRef = doc(db, "Provider_AutoMatching", "AdTokensRoot");
    const tokensSnap = await getDoc(tokensRef);
    let currentTokens = 0;
    if (tokensSnap.exists() && tokensSnap.data().tokensEarnedByUser?.[userId]) {
      currentTokens = tokensSnap.data().tokensEarnedByUser[userId];
    }
    const updatedTokens = Math.max(currentTokens - Number(jobCost), 0); // avoid negative
    await setDoc(
      tokensRef,
      {
        tokensEarnedByUser: {
          [userId]: updatedTokens,
        },
        updatedAt: new Date(),
      },
      { merge: true }
    );
    // 3️⃣ Update UI tokens immediately + persist in localStorage
    setTokenWallet(prev => {
      const newUI = Math.max(prev - Number(jobCost), 0);
      localStorage.setItem("walletTokens", newUI);
      return newUI;
    });
    toast.success(`Job applied successfully! -${jobCost} tokens deducted.`);
  } catch (error) {
    console.error("Error applying to job:", error);
    toast.error("Failed to apply to job.");
  }
};
// Add a new job post in JobPortal subcollection
const addJobPost = async (job, userId) => {
  try {
    const rootRef = doc(db, "Provider_AutoMatching", "JobPortalRoot"); 
    // Ensure root doc exists (only needed once)
    await setDoc(rootRef, { createdAt: new Date() }, { merge: true });
    // Use job title + timestamp as ID or generate your own predictable ID
    const jobId = `${job.category}-${Date.now()}`;
    const jobRef = doc(db, "Provider_AutoMatching", "JobPortalRoot", "JobPortal", jobId);
    await setDoc(jobRef, {
      ...job,
      createdBy: userId,
      appliedUsers: [],
      quickBookedBy: null,
      timestamp: new Date(),
    });
    toast.success("Job posted successfully!");
    return { providerId: "JobPortalRoot", jobId };
  } catch (error) {
    console.error("Error adding job post:", error);
    toast.error("Failed to post job.");
  }
};
const YT_ADS = [
  // Existing entries...
  "dQw4w9WgXcQ", "3JZ_D3ELwOQ", "L_jWHffIx5E", "kJQP7kiw5Fk", "fRh_vgS2dFE",
  "CevxZvSJLk8", "09R8_2nJtjg", "hTWKbfoikeg", "RgKAFK5djSk", "YQHsXMglC9A",
  "uelHwf8o7_U", "OPf0YbXqDm0", "kOkQ4T5WO9E", "2Vv-BfVoq4g", "IcrbM1l_BoI",
  "dvgZkm1xWPE", "fJ9rUzIMcZQ", "kXYiU_JCYtU", "C0DPdy98e4c", "e-ORhEE9VVg",
  "9bZkp7q19f0", "JGwWNGJdvx8", "6Dh-RL__uN4", "VbfpW0pbvaU", "uelHwf8o7_U",
  "YlUKcNNmywk", "hT_nvWreIhg", "SlPhMPnQ58k", "04854XqcfCY", "CevxZvSJLk8",
  // New Telugu Movie Clips and Teasers
  "ggJg6CcKtZE", // Mirai Trailer Telugu
  "7D6plzDj66o", // Pushpa 2 Dialogue Clip
  "5IDwzBo3SKo", // RajaSaab Trailer Telugu
  "cHd-vTYZ87A", // GHAATI Trailer Telugu
  "3-3zN1ldeJA", // New Telugu Movie Scene
  "EtdHtQd_Cew", // New Telugu Movie Scene
  "zHiKFSBO_JE", // New Telugu Movie Scene
  "VKjZitFcxPk", // New Telugu Movie Scene
  "WVG6cnskbRg", // New Telugu Movie Scene
  "OM6Sgf-Q4Ow", // New Telugu Movie Scene
  "NgBoMJy386M", // New Telugu Movie Scene
  "iGGDbhjgWUU", // Best Court Scenes in Tollywood
  "lACOPlX5oZA", // 100% Love Telugu Movie Comedy Scenes
  "ggJg6CcKtZE", // Mirai Trailer Telugu
  "7D6plzDj66o", // Pushpa 2 Dialogue Clip
  "5IDwzBo3SKo", // RajaSaab Trailer Telugu
  "cHd-vTYZ87A", // GHAATI Trailer Telugu
  "3-3zN1ldeJA", // New Telugu Movie Scene
  "EtdHtQd_Cew", // New Telugu Movie Scene
  "zHiKFSBO_JE", // New Telugu Movie Scene
  "VKjZitFcxPk", // New Telugu Movie Scene
  "WVG6cnskbRg", // New Telugu Movie Scene
  "OM6Sgf-Q4Ow", // New Telugu Movie Scene
  "NgBoMJy386M", // New Telugu Movie Scene
  "iGGDbhjgWUU", // Best Court Scenes in Tollywood
  "lACOPlX5oZA", // 100% Love Telugu Movie Comedy Scenes
];
// ---------------- Helper Function ----------------
const getRandomAd = (currentAd) => {
  if (YT_ADS.length <= 1) return YT_ADS[0]; // fallback
  let randomAd;
  do {
    const randomIndex = Math.floor(Math.random() * YT_ADS.length);
    randomAd = YT_ADS[randomIndex];
  } while (randomAd === currentAd); // ensure different from current
  return randomAd;
};
// ---------------- Usage Example ----------------
// When user clicks "Watch Ad"
const handleWatchAd = () => {
  const randomAd = getRandomAd(currentAdVideo); // pass currently playing ad
  setCurrentAdVideo(randomAd);
  setIsAdPlaying(true);
};
// Function to play a random YouTube ad and earn tokens when finished
const playRandomYTAd = (tokensEarned) => {
  if (isAdPlaying) return;
  const randomIndex = Math.floor(Math.random() * YT_ADS.length);
  setCurrentAdVideo(YT_ADS[randomIndex]);
  setIsAdPlaying(true);
  setAdTokensEarned(tokensEarned); // store how many tokens to give after ad ends
};
// Optional: track tokens to give after ad ends
const [adTokensEarned, setAdTokensEarned] = useState(0);
// Handle ad ending manually
const handleAdEnd = () => {
  setIsAdPlaying(false);
  setCurrentAdVideo(null);
  setTokenWallet((prev) => prev + adTokensEarned);
  toast.success(`+${adTokensEarned} Tokens earned!`);
};
 const [techListPortal, setTechListPortal] = useState([]); // for Job Portal matching
 // --- Work Categories ---
const WORK_CATEGORIES = [
  "Water System Repair", "Housekeeping", "Power Technician", "Woodwork",
  "Wall Finishing", "Garden Care", "Insect Treatment", "Furniture Moving",
  "General Repairs", "Machine Fixing", "Heating & Cooling Service",
  "Roof Maintenance", "Tile Installation", "Key & Lock Service",
  "Pool Maintenance", "Glass & Window Wash", "Outdoor Design",
  "Brickwork", "Concrete Services", "Floor Installation", "Gate & Fence Work",
  "Rain Gutter Service", "Aerial Drone Survey", "Smart Device Setup",
  "TV Installation", "Home Furniture Setup"
];
// --- Dynamic YouTube Ad Fetch ---
const retrieveVideoAds = async () => {
  try {
    // Demo: random sample IDs. Replace with YouTube API or Adserver API in production
    const demoVideos = ["dQw4w9WgXcQ", "kxopViU98Xo", "9bZkp7q19f0", "3JZ_D3ELwOQ", "fJ9rUzIMcZQ"];
    return demoVideos.sort(() => 0.5 - Math.random()).slice(0, 5);
  } catch (error) {
    console.error("Error fetching ads:", error);
    return [];
  }
};
// --- State ---
const [jobPosts, setJobPosts] = useState(() => JSON.parse(localStorage.getItem("jobPosts")) || []);
const [newJob, setNewJob] = useState({ category: "", location: "", distance: "", cost: "", description: "" });
const [tokenWallet, setTokenWallet] = useState(() => Number(localStorage.getItem(`wallet_${user?.id}`)) || 0);
const [appliedJobIds, setAppliedJobIds] = useState(() => JSON.parse(localStorage.getItem(`applied_${user?.id}`)) || []);
const [visibleProfile, setVisibleProfile] = useState(true);
const [notificationRadius, setNotificationRadius] = useState(() => Number(localStorage.getItem("notificationRadius")) || 25);
// --- Ads ---
const [isAdPlaying, setIsAdPlaying] = useState(false);
const [currentAdVideo, setCurrentAdVideo] = useState(null);
const [adVideoPool, setAdVideoPool] = useState([]);
const [lastAd, setLastAd] = useState(-1);
const adRef = useRef(null);
// --- Storage Persistence ---
useEffect(() => {
  localStorage.setItem("jobPosts", JSON.stringify(jobPosts));
}, [jobPosts]);
useEffect(() => {
  if (user?.id) {
    localStorage.setItem(`wallet_${user.id}`, tokenWallet.toString());
  }
}, [tokenWallet, user?.id]);
useEffect(() => {
  if (user?.id) {
    localStorage.setItem(`applied_${user.id}`, JSON.stringify(appliedJobIds));
  }
}, [appliedJobIds, user?.id]);
useEffect(() => {
  localStorage.setItem("notificationRadius", notificationRadius.toString());
}, [notificationRadius]);
// --- Load Ads ---
useEffect(() => {
  const loadAds = async () => {
    const videos = await retrieveVideoAds();
    setAdVideoPool(videos);
  };
  loadAds();
}, []);
// --- Ad Handlers ---
const triggerAd = (reward = 10) => {
  if (!adVideoPool.length) return toast.error("No ads available at the moment.");
  let randomIndex;
  do {
    randomIndex = Math.floor(Math.random() * adVideoPool.length);
  } while (randomIndex === lastAd && adVideoPool.length > 1);
  setCurrentAdVideo(adVideoPool[randomIndex]);
  setLastAd(randomIndex);
  setIsAdPlaying(true);
};
const completeAd = (reward = 10) => {
  setTokenWallet(prev => prev + reward);
  toast.success(`+${reward} Tokens added!`);
  setIsAdPlaying(false);
  setCurrentAdVideo(null);
};
// --- Job Handlers ---
const postJob = (e) => {
  e.preventDefault();
  const { category, location, distance, cost } = newJob;
  if (!category || !location || !distance || !cost) {
    return toast.error("Fill all required fields.");
  }
  const jobEntry = {
    id: `job_${Date.now()}`,
    ...newJob,
    distance: Number(distance),
    cost: Number(cost),
    createdAt: Date.now(),
  };
  setJobPosts(prev => [jobEntry, ...prev]);
  setNewJob({ category: "", location: "", distance: "", cost: "", description: "" });
  toast.success("Job posted successfully!");
};
const enrollJob = (job) => {
  const requiredTokens = Number(job.cost);
  if (appliedJobIds.includes(job.id)) return toast.info("Already applied.");
  if (tokenWallet >= requiredTokens) {
    setTokenWallet(prev => prev - requiredTokens);
    setAppliedJobIds(prev => [...prev, job.id]);
    toast.success(`Applied for ${job.category}. ${requiredTokens} Tokens deducted.`);
  } else {
    toast.warning("Insufficient tokens. Watch ads to earn more.");
  }
};
const quickBook = (tech, job) => {
  toast.info(`Booking ${tech.name || "No tech"} for ${job.category}...`);
};
const saveRadius = () => {
  localStorage.setItem("notificationRadius", notificationRadius.toString());
  toast.success("Notification radius saved!");
};
const findMatchingTechs = (job) => {
  if (!techListPortal || techListPortal.length === 0) return [];
  return techListPortal.filter(
    (t) =>
      t.active &&
      t.specialty.toLowerCase() === job.category.toLowerCase() &&
      t.radius >= Number(job.distance)
  );
};
  const [messages, setMessages] = useState([]); // chat messages
  const [selectedBookingId, setSelectedBookingId] = useState(null);
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");       // search input
  // ✅ Define bookings state here
  const [bookings, setBookings] = useState([]);
  const [newBooking, setNewBooking] = useState({
    id: "",
    customer: "",
    provider: "",
    status: "active",
    triggerStatus: "Safe",
  });
  const [notifList, setNotifList] = useState([]);
  const [notifFilter, setNotifFilter] = useState("all"); // ✅ Add this
  const [showModal, setShowModal] = useState(false); 
  // ✅ Helper to get booking by ID
const getSelectedBooking = (id) => {
  if (!id) return null;
  return bookings.find((b) => b.id === id) || null;
};
  // ✅ Only define chatId after receiving selectedBookingId
  const chatId = selectedBookingId; // safe assignment
  useEffect(() => {
    // guard clause: exit if chatId is undefined/null
    if (!chatId) return;
    const chatRef = collection(db, "chats", chatId, "messages");
    const unsubscribe = onSnapshot(chatRef, (snapshot) => {
      const messagesData = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setMessages(messagesData);
    });
    return () => unsubscribe();
  }, [chatId]);
  const [input, setInput] = useState(""); // current user input
  const chatContainerRef = useRef(null);
  // Scroll to bottom whenever messages update
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [messages]);
  // Load existing messages & subscribe to new ones from Firestore
  useEffect(() => {
    if (!chatId) return;
    const messagesColRef = collection(db, "Chat_Activation", chatId, "Messages");
    const unsubscribe = onSnapshot(messagesColRef, (snapshot) => {
      const msgs = snapshot.docs.map((doc) => doc.data());
      setMessages(msgs);
    });
    return () => unsubscribe();
  }, [chatId]);
  // Handle sending message
  const handleSend = async () => {
    if (!input.trim()) return;
    const userMessage = input;
    setInput(""); // Clear input
    try {
      // Show toast for sending
      toast.info("Sending message...", { autoClose: 1000 });
      const messagesColRef = collection(db, "Chat_Activation", chatId, "Messages");
      // Add user message to Firestore
      const userDoc = await addDoc(messagesColRef, {
        sender: "user",
        text: userMessage,
        timestamp: new Date(),
      });
      // Add locally for instant UI update
      setMessages((prev) => [...prev, { sender: "user", text: userMessage }]);
      // Connect to streaming API
      const response = await fetch("http://127.0.0.1:5050/chat-stream", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: userMessage }),
      });
      if (!response.body) return;
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let botMessage = "";
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        botMessage += decoder.decode(value, { stream: true });
        // Update messages locally
        setMessages((prev) => {
          const lastMessage = prev[prev.length - 1];
          if (lastMessage && lastMessage.sender === "bot") {
            return [...prev.slice(0, -1), { sender: "bot", text: botMessage }];
          } else {
            return [...prev, { sender: "bot", text: botMessage }];
          }
        });
        // Update bot message in Firestore (overwrite or add first message)
        const botDocRef = doc(db, "Chat_Activation", chatId, "Messages", "botMessage");
        await setDoc(botDocRef, {
          sender: "bot",
          text: botMessage,
          timestamp: new Date(),
        });
      }
      toast.success("Message sent successfully!", { autoClose: 1500 });
    } catch (err) {
      console.error("Error streaming response:", err);
      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: "⚠️ Error: Could not get response." },
      ]);
      toast.error("Failed to send message.", { autoClose: 3000 });
    }
  };
  // Send message on Enter
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };
  function getButtonStyle(isActive, color) {
    return {
      backgroundColor: isActive ? color : "#e5e7eb", // gray if inactive
      color: isActive ? "white" : "#111827", // text color changes too
      border: "none",
      padding: "8px 16px",
      borderRadius: "8px",
      cursor: "pointer",
      marginRight: "8px",
      transition: "background-color 0.3s",
    };
  }
  const filteredBookings = bookings.filter((b) => {
  const q = search.trim().toLowerCase();
  const matchesSearch =
    !q ||
    b.id.toLowerCase().includes(q) ||
    b.customer.toLowerCase().includes(q) ||
    b.provider.toLowerCase().includes(q);
  const matchesFilter =
    filter === "all" ||
    (filter === "warnings" && b.triggerStatus.toLowerCase() === "warning") ||
    (filter === "escalated" && b.triggerStatus.toLowerCase() === "escalated") ||
    (filter === "blocked" && b.triggerStatus.toLowerCase() === "blocked") ||
    (filter === "completed" && b.status.toLowerCase() === "completed") ||
    (filter === "active" && b.status.toLowerCase() === "active") ||
    (filter === "confirmed" && b.status.toLowerCase() === "confirmed");
  return matchesSearch && matchesFilter;
});
  useEffect(() => {
  const savedRange = localStorage.getItem("jobRange");
  if (savedRange) {
    setJobRange(Number(savedRange));
  }
}, []);
const [jobs, setJobs] = useState([]); // all jobs
const [jobForm, setJobForm] = useState({
  service: "",
  location: "",
  distance: "",
  cost: "",
  description: "",
});
const [bookedProviders, setBookedProviders] = useState([]);
const [requestForm, setRequestForm] = useState({
  name: "",
  contact: "",
  service: "",
  notes: "",
});
const [matchedTechnicians, setMatchedTechnicians] = useState([]);
const handleSeeMatches = () => {
  const matches = technicians.filter(
    (t) =>
      t.active &&
      t.specialty.toLowerCase() === requestForm.service.toLowerCase()
  );
  setMatchedTechnicians(matches);
  setShowMatches(true);
};
const handleBookNow = async (tech, item) => {
  const booking = {
    technician: tech.fullname,
    service: item.service,
    location: item.location || item.site,
    timestamp: Date.now(),
  };
  try {
    await addDoc(collection(db, "Provider_AutoMatching", "data", "bookings"), booking);
    toast.success(`✅ You booked ${tech.fullname} for ${booking.service} at ${booking.location}`);
  } catch (err) {
    console.error("Error saving booking:", err);
    toast.error("❌ Failed to save booking.");
  }
};
// inside useEffect
useEffect(() => {
  const unsubTechs = onSnapshot(
    collection(db, "Provider_AutoMatching", "data", "technicians"),
    (snapshot) => {
      setTechnicians(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    }
  );
  const unsubTasks = onSnapshot(
    collection(db, "Provider_AutoMatching", "data", "tasks"),
    (snapshot) => {
      setTasks(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    }
  );
  const unsubJobs = onSnapshot(
    collection(db, "Provider_AutoMatching", "data", "jobs"),
    (snapshot) => {
      setJobs(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    }
  );
  const unsubRequests = onSnapshot(
    collection(db, "Provider_AutoMatching", "data", "requests"),
    (snapshot) => {
      setRequests(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    }
  );
  return () => {
    unsubTechs();
    unsubTasks();
    unsubJobs();
    unsubRequests();
  };
}, []);
const [requests, setRequests] = useState([]);
const [requestSaved, setRequestSaved] = useState(false);
const [showMatches, setShowMatches] = useState(false);
const [profileVisible, setProfileVisible] = useState(false);
const [jobRange, setJobRange] = useState(10);
const formStyle = { display: "flex", flexDirection: "column", gap: "20px" };
const inputStyle = { width: "100%", padding: "12px", borderRadius: "8px", border: "1px solid #D1D5DB" };
const submitBtn = (bg) => ({ backgroundColor: bg, color: "#fff", padding: "12px", borderRadius: "8px", fontWeight: "600", cursor: "pointer" });
const emptyBox = { padding: "20px", backgroundColor: "#F3F4F6", textAlign: "center", borderRadius: "8px" };
const cardStyle = { backgroundColor: "#fff", borderRadius: "12px", padding: "20px", boxShadow: "0 4px 12px rgba(0,0,0,0.05)" };
const matchItem = { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px", border: "1px solid #D1D5DB", borderRadius: "8px", marginBottom: "10px" };
// ✅ Escalate booking & add log
const handleEscalate = async (id) => {
const bookingDocRef = doc(db, "Chat_Activation", id);
  try {
    // Optimistically update local state
    setBookings((prev) =>
      prev.map((b) =>
        b.id === id
          ? {
              ...b,
              triggerStatus: "Escalated",
              logs: [
                ...(b.logs || []),
                `Booking escalated at ${new Date().toLocaleString()}`,
              ],
            }
          : b
      )
    );
    // Firestore update
    const bookingSnapshot = await getDoc(bookingDocRef);
    if (bookingSnapshot.exists()) {
      await updateDoc(bookingDocRef, {
        triggerStatus: "Escalated",
        logs: [
          ...(bookingSnapshot.data().logs || []),
          `Booking escalated at ${new Date().toISOString()}`,
        ],
      });
    }
    toast.success("Booking escalated successfully!");
  } catch (err) {
    console.error("Error escalating booking:", err);
    toast.error("Failed to escalate booking.");
  }
};
// ✅ Close logs modal
const handleCloseLogs = () => {
  setSelectedBooking(null);
  setShowLogsModal(false);
  toast.info("Logs modal closed.");
};
// ✅ View logs
const handleViewLogs = (booking) => {
  console.log("Opening logs for:", booking); // 🔍 Debug
  setSelectedBooking(booking);
  setShowLogsModal(true);
  toast.info("Viewing booking logs.");
};
const [showLogsModal, setShowLogsModal] = useState(false);
// ✅ Add this state for Availability
const [showAvailability, setShowAvailability] = useState(false);
const [logModalContent, setLogModalContent] = useState("");
const [showSuspendModal, setShowSuspendModal] = useState(false);
const [suspendModalContent, setSuspendModalContent] = useState("");
const [showEscalateModal, setShowEscalateModal] = useState(false);
const [escalationNotificationId, setEscalationNotificationId] = useState("");
const [escalationReason, setEscalationReason] = useState("");
// Moderation keywords
const flaggedKeywords = ["payment", "bank", "ssn", "credit"];
const [showChatModal, setShowChatModal] = useState(false);
// ----------------- Triggers / Chat Handling -----------------
// Evaluate trigger status based on flagged messages
const evaluateTriggers = (chat = []) => {
  const flaggedCount = chat.filter((m) => m.status === "flagged").length;
  if (flaggedCount >= 5) return "Blocked";
  if (flaggedCount >= 3) return "Escalated";
  if (flaggedCount >= 1) return "Warning";
  return "Safe";
};
// Badge color helper
const badgeColor = (status) => {
  switch (status) {
    case "Safe":
      return "#d4edda";
    case "Warning":
      return "#fff3cd";
    case "Escalated":
      return "#ffe5b4";
    case "Blocked":
      return "#f8d7da";
    default:
      return "#eee";
  }
};
// Moderate messages for flagged content
const moderateMessage = (msg) => {
  const lowered = (msg || "").toLowerCase();
  return flaggedKeywords.some((kw) => lowered.includes(kw)) ? "flagged" : "safe";
};
// ----------------- Add new booking -----------------
const handleAddBooking = async (bookingData) => {
  const { id, customer, provider, status, triggerStatus } = bookingData;
  if (!id.trim() || !customer.trim() || !provider.trim()) {
    toast.error("Please fill all booking fields");
    return;
  }
  if (getSelectedBooking(id.trim())) {
    toast.warning("Booking ID already exists");
    return;
  }
  const bookingObj = {
    id: id.trim(),
    customer: customer.trim(),
    provider: provider.trim(),
    status,
    chat: [],
    metadataLogs: [
      {
        action: "Booking created",
        status: triggerStatus,
        timestamp: new Date().toISOString(),
      },
    ],
    triggerStatus,
  };
  setBookings((prev) => [...prev, bookingObj]);
  setSelectedBookingId(bookingObj.id);
  // Firestore: create main document
  const bookingDocRef = doc(db, "Chat_Activation", bookingObj.id);
  await setDoc(bookingDocRef, bookingObj);
  // Notification
  const typeMap = {
    Safe: "safe",
    Warning: "warning",
    Escalated: "escalated",
    Blocked: "blocked",
  };
  const notifType = typeMap[triggerStatus] || "new";
  const newNotif = {
    id: `${bookingObj.id}-${notifType}`,
    bookingId: bookingObj.id,
    user: bookingObj.customer,
    trigger: "Booking created",
    status: triggerStatus,
    type: notifType,
    time: new Date().toISOString(),
  };
  setNotifList((prev) => [newNotif, ...prev]);
  setNewBooking({
    id: "",
    customer: "",
    provider: "",
    status: "active",
    triggerStatus: "Safe",
  });
  // Auto-open chatbot modal
  setShowModal(true);
  setMessages([
    {
      sender: "bot",
      text: `💬 Chat started for Booking #${bookingObj.id} between ${bookingObj.customer} (Customer) and ${bookingObj.provider} (Provider).`,
    },
  ]);
  toast.success(`Booking #${bookingObj.id} created and chat started!`);
};
// ----------------- Update trigger status -----------------
const handleUpdateStatus = async (id, newTriggerStatus) => {
  setBookings((prev) =>
    prev.map((b) =>
      b.id === id ? { ...b, triggerStatus: newTriggerStatus } : b
    )
  );
  const bookingDocRef = doc(db, "Chat_Activation", id);
  await updateDoc(bookingDocRef, { triggerStatus: newTriggerStatus });
  toast.info(`Booking #${id} trigger status updated to ${newTriggerStatus}`);
};
// ----------------- Send chat message -----------------
const sendMessageFromModal = async () => {
  if (!modalMessage.trim() || !currentBooking) return;
  if (currentBooking.status === "completed") {
    toast.warning("This chat has been closed. Contact support for issues.");
    return;
  }
  if (currentBooking.triggerStatus === "Blocked") {
    toast.error("This booking is blocked due to repeated violations.");
    return;
  }
  const status = moderateMessage(modalMessage);
  const chatItem = { text: modalMessage.trim(), status, timestamp: new Date().toISOString() };
  setBookings((prev) =>
    prev.map((b) => {
      if (b.id !== currentBooking.id) return b;
      const updatedChat = [...(b.chat || []), chatItem];
      const triggerStatus = evaluateTriggers(updatedChat);
      // Firestore update
      const bookingDocRef = doc(db, "Chat_Activation", b.id);
      setDoc(bookingDocRef, { chat: updatedChat, triggerStatus }, { merge: true });
      return { ...b, chat: updatedChat, triggerStatus };
    })
  );
  setModalMessage("");
  if (status === "flagged") {
    toast.warning("⚠️ Flagged message detected — CRM admin notified.");
  } else {
    toast.success("Message sent successfully!");
  }
};
// ----------------- Notifications update -----------------
useEffect(() => {
  const newNotifs = bookings.flatMap((b) => {
    if (!b.chat || b.chat.length === 0) return [];
    const lastMsg = b.chat[b.chat.length - 1];
    const createdAt = lastMsg.timestamp;
    switch (b.triggerStatus) {
      case "Warning":
        return [
          {
            id: b.id + "-warning",
            bookingId: b.id,
            user: b.customer || b.provider,
            trigger: lastMsg.text,
            status: "Warning issued",
            type: "warning",
            time: createdAt,
          },
        ];
      case "Escalated":
        return [
          {
            id: b.id + "-escalated",
            bookingId: b.id,
            user: b.customer || b.provider,
            trigger: lastMsg.text,
            status: "Escalated to Compliance",
            type: "escalated",
            time: createdAt,
          },
        ];
      case "Blocked":
        return [
          {
            id: b.id + "-blocked",
            bookingId: b.id,
            user: b.customer || b.provider,
            trigger: lastMsg.text,
            status: "Chat Disabled",
            type: "blocked",
            time: createdAt,
          },
        ];
      default:
        return [
          {
            id: b.id + "-safe",
            bookingId: b.id,
            user: b.customer || b.provider,
            trigger: "No issues detected",
            status: "Safe",
            type: "safe",
            time: new Date().toISOString(),
          },
        ];
    }
  });
  setNotifList((prev) => {
    const chatNotifIds = newNotifs.map((n) => n.id);
    const updated = prev.filter((n) => !chatNotifIds.includes(n.id));
    return [...newNotifs, ...updated];
  });
}, [bookings]);
// Filter notifications by type
const displayedNotifList = notifList.filter(
  (n) => notifFilter === "all" || n.type.toLowerCase() === notifFilter
);
const [showChatActivation, setShowChatActivation] = useState(false);
 const handleSendNotification = async (type) => {
  const payload = {
    token: "f_ZrkvfiegvswEGHmwKFHl:APA91bGb0G-uqV57sLa-t7jVtaaqe6fhqrkX2uQo9yXnlHD9tXfYizo9KqoRz7JkoA7n0gVLw1uJPHe_ZYXl_3Ee0hHZB5f9JI5Qa9nfAEqoRu3kZA4pkEA",
    type: type, // 'cancelled', 'confirmed', 'new', or 'amended'
    message: `Your booking has been ${type} ${getEmoji(type)}`,
  };
  const urls = [
    "https://customerjourneynotifications-mc4pzotprq-uc.a.run.app/send-notification",
    "http://localhost:8080/send-notification",
  ];
  try {
    let data = null;
    for (const url of urls) {
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        data = await response.json();
        if (data.success) break;
      } catch (err) {
        console.error(`Failed on ${url}`, err);
      }
    }
    console.log("Push Notification Response:", data);
    if (data && data.success) {
      alert(`Notification (${type}) sent successfully!`);
    } else {
      alert("Failed to send notification: " + (data?.error || "Unknown error"));
    }
  } catch (error) {
    console.error("Error:", error);
    alert("Something went wrong while sending the notification.");
  }
};
const getEmoji = (type) => {
  switch (type) {
    case 'new':
      return '📦';
    case 'confirmed':
      return '✅';
    case 'cancelled':
      return '❌';
    case 'amended':
      return '🔁';
    default:
      return '';
  }
};
  const triggerPushNotice = (type) => {
  console.log(`Push notification triggered for ${type} booking.`);
};
  // --- Common Styles ---
const buttonBase = {
  padding: "10px 20px",
  border: "none",
  borderRadius: "6px",
  color: "#fff",
  fontWeight: 600,
  cursor: "pointer",
  transition: "background 0.2s ease",
};8
const panelStyle = {
  backgroundColor: "#fff",
  borderRadius: "10px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  padding: "10px",
};
  // Sample jobs
  const [taskQueue] = useState([
    { id: "job201", type: "cleaning", location: "CityX", time: "9:00 AM" },
    { id: "job202", type: "plumbing", location: "CityY", time: "10:30 AM" },
    { id: "job203", type: "electrical", location: "CityX", time: "2:00 PM" },
  ]);
  // Sample customers
  const [customerPool, setCustomerPool] = useState([
    { id: "c1", name: "Michael Scott", needs: ["cleaning"], location: "CityX", loyalty: 5, assignedCount: 0 },
    { id: "c2", name: "Pam Beesly", needs: ["plumbing"], location: "CityY", loyalty: 4, assignedCount: 1 },
    { id: "c3", name: "Jim Halpert", needs: ["electrical", "cleaning"], location: "CityX", loyalty: 3, assignedCount: 0 },
    { id: "c4", name: "Dwight Schrute", needs: ["plumbing"], location: "CityY", loyalty: 5, assignedCount: 2 },
    { id: "c5", name: "Stanley Hudson", needs: ["electrical"], location: "CityX", loyalty: 2, assignedCount: 0 },
  ]);
  const [allocationMap, setAllocationMap] = useState({});
  const [taskStates, setTaskStates] = useState({});
  // Scoring logic
  const calculateCompatibility = (customer, task) => {
    let points = 0;
    if (customer.needs.includes(task.type)) points += 50;
    if (customer.location === task.location) points += 30;
    points += customer.loyalty * 5;
    points += 10 - (customer.assignedCount || 0);
    return points;
  };
  // Assign customer to job
  const assignCustomerToTask = (task, skipIds = []) => {
    const pool = customerPool.filter(c => !skipIds.includes(c.id));
    if (!pool.length) {
      setTaskStates(prev => ({ ...prev, [task.id]: "unmatched" }));
      toast.warning(`⚠️ No customers left for ${task.id}`);
      return;
    }
    const scoredPool = pool.map(c => ({ ...c, score: calculateCompatibility(c, task) }));
    scoredPool.sort((a, b) => b.score - a.score);
    const candidate = scoredPool[0];
    if (!candidate || candidate.score <= 0) {
      setTaskStates(prev => ({ ...prev, [task.id]: "unmatched" }));
      toast.warning(`⚠️ No suitable customer for ${task.id}`);
      return;
    }
    setAllocationMap(prev => ({
      ...prev,
      [task.id]: { ...candidate, rejectedIds: [] }
    }));
    setTaskStates(prev => ({ ...prev, [task.id]: "assigned" }));
    toast.success(`✅ ${task.id} assigned to ${candidate.name}`);
  };
  // Reject current assignment
  const triggerReassignment = (taskId) => {
    const current = allocationMap[taskId];
    if (!current) return;
    const updatedRejected = [...(current.rejectedIds || []), current.id];
    setAllocationMap(prev => ({
      ...prev,
      [taskId]: { ...current, rejectedIds: updatedRejected }
    }));
    setTaskStates(prev => ({ ...prev, [taskId]: "pending" }));
    toast.info(`🔄 ${current.name} rejected ${taskId}. Reassigning...`);
    const task = taskQueue.find(t => t.id === taskId);
    assignCustomerToTask(task, updatedRejected);
  };
  // Initial auto-assign
  useEffect(() => {
    taskQueue.forEach(task => assignCustomerToTask(task));
    // eslint-disable-next-line
  }, []);
  // Add this at the top with your other useState hooks
const [showAutomatchProviders, setShowAutomatchProviders] = useState(false);
// Constants
const SERVICE_CATEGORIES = ["Plumbing", "Electrician", "Cleaning", "Carpentry"];
  // -------------------- State --------------------
  const [technicians, setTechnicians] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [currentTab, setCurrentTab] = useState("technician");
  const [techForm, setTechForm] = useState({
    fullname: "",
    specialty: "",
    radius: 15,
    active: true,
  });
  const [taskForm, setTaskForm] = useState({
    service: "",
    site: "",
    cost: "",
    coverage: 0,
  });
  const [isRequestModal, setIsRequestModal] = useState(false);
  const [requestPhase, setRequestPhase] = useState(0);
  const [requestInfo, setRequestInfo] = useState({
    fullname: "",
    contact: "",
    category: "",
    remarks: "",
    allowAlerts: true,
  });
  const [isRadiusModal, setIsRadiusModal] = useState(false);
  const [radiusValue, setRadiusValue] = useState(15);
 // ================== Technician ==================
const addTechnician = async (e) => {
  e.preventDefault();
  try {
    await addDoc(
      collection(db, "Provider_AutoMatching", "data", "technicians"),
      techForm
    );
    setTechnicians([...technicians, { id: Date.now(), ...techForm }]);
    setTechForm({ fullname: "", specialty: "", radius: 10, active: true });
    toast.success("✅ Technician added successfully!");
  } catch (err) {
    console.error("Error adding technician:", err);
    toast.error("❌ Failed to add technician.");
  }
};
// ================== Task ==================
const addTask = async (e) => {
  e.preventDefault();
  try {
    await addDoc(collection(db, "Provider_AutoMatching", "data", "tasks"), taskForm);
    setTasks([...tasks, { id: Date.now(), ...taskForm }]);
    setTaskForm({ service: "", site: "", cost: "", coverage: "" });
    toast.success("✅ Task posted successfully!");
  } catch (err) {
    console.error("Error adding task:", err);
    toast.error("❌ Failed to post task.");
  }
};
// ================== Job ==================
const addJob = async (e) => {
  e.preventDefault();
  const newJob = {
    service: jobForm.service,
    location: jobForm.location,
    distance: Number(jobForm.distance),
    cost: Number(jobForm.cost),
    description: jobForm.description,
  };
  try {
    await addDoc(collection(db, "Provider_AutoMatching", "data", "jobs"), newJob);
    setJobs([...jobs, { id: Date.now(), ...newJob }]);
    setJobForm({ service: "", location: "", distance: "", cost: "", description: "" });
    toast.success("✅ Job added successfully!");
  } catch (err) {
    console.error("Error adding job:", err);
    toast.error("❌ Failed to add job.");
  }
};
// ================== Request ==================
const saveRequest = async (request) => {
  try {
    await addDoc(collection(db, "Provider_AutoMatching", "data", "requests"), request);
    setRequestSaved(true);
    toast.success("✅ Request submitted successfully!");
  } catch (err) {
    console.error("Error saving request:", err);
    toast.error("❌ Failed to submit request.");
  }
};
  const markAlertSeen = (techId, alertId) => {
    setTechnicians((prev) =>
      prev.map((t) =>
        t.id === techId
          ? {
              ...t,
              alerts: t.alerts.map((a) =>
                a.id === alertId ? { ...a, seen: true } : a
              ),
            }
          : t
      )
    );
  };
  const submitRequest = (e) => {
    e.preventDefault();
    setRequestPhase(2);
  };
  const latestTask = tasks[0];
  const compatibleTechs = latestTask
    ? technicians.filter(
        (t) =>
          t.active &&
          t.specialty === latestTask.service &&
          t.radius >= latestTask.coverage
      )
    : [];
  // Add state for Customer Panel
const [showCustomerPanel, setShowCustomerPanel] = useState(false);
const [showAddCustomer, setShowAddCustomer] = useState(false);
const [showProviderBonus, setShowProviderBonus] = useState(false);
const [showCustomerBonus, setShowCustomerBonus] = useState(false);
  // Store expiry date in Firestore (or local state until save)
const handleExpiryChange = (docKey, date) => {
  setVerification((prev) => ({
    ...prev,
    [docKey]: {
      ...prev[docKey],
      expiryDate: date, // YYYY-MM-DD
    },
  }));
};
// Send reminder + Save reminder in Firestore
const sendReminder = async (docKey, expiryDate) => {
  try {
    if (!selectedProfile?.id) {
      console.error("❌ Provider ID missing");
      toast.error("Provider ID missing!");
      return;
    }
    /* ================= CALL FIREBASE HTTP FUNCTION ================= */
    const response = await fetch(
      "http://127.0.0.1:5994/urbanclapclone-8dc68/asia-south1/expiryReminderHTTP",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          providerId: selectedProfile.id,
          providerName: selectedProfile?.name || "",
          providerEmail: selectedProfile?.email || "",
          documentKey: docKey,
          expiryDate: expiryDate,
        }),
      }
    );
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result?.message || "HTTP Reminder failed");
    }
    /* ================= SAVE REMINDER IN FIRESTORE ================= */
    const remindersRef = collection(db, "documentReminders");
    await addDoc(remindersRef, {
      providerId: selectedProfile.id,
      providerName: selectedProfile?.name || "",
      providerEmail: selectedProfile?.email || "",
      documentKey: docKey,
      expiryDate: expiryDate,
      status: "sent",
      createdAt: serverTimestamp(),
    });
    console.log(`✅ Reminder sent & saved for ${docKey}`);
    toast.success(`Reminder sent for ${docKey}`);
  } catch (error) {
    console.error("🔥 Reminder error:", error);
    toast.error("Failed to send reminder!");
  }
};
const [selectedBooking, setSelectedBooking] = useState(null);
const [showProviderProfile, setShowProviderProfile] = useState(false);
// Add this with your other state hooks
const [showEscalationPanel, setShowEscalationPanel] = useState(false);
const [showAddProvider, setShowAddProvider] = useState(false);
  // Function to save booking data
const handleSaveBookingServices = async () => {
  try {
    await addDoc(collection(db, "Booking_Services"), {
      bookingCode: bookingData.bookingCode,
      invoice: bookingData.invoice,
      customerName: bookingData.customerName,
      customerEmail: bookingData.customerEmail,
      service: bookingData.service,
      onsite: bookingData.onsite,
      expenses: bookingData.expenses,
      estimatedCost: calculateCost(),
      createdAt: new Date(),
    });
    alert("✅ Booking Service saved successfully!");
    // 🔄 Reset form data after save
    setBookingData({
      bookingCode: "",
      invoice: "",
      customerName: "",
      customerEmail: "",
      service: "",
      onsite: "",
      expenses: "",
    });
  } catch (error) {
    console.error("Error saving booking service: ", error);
    alert("❌ Failed to save booking service.");
  }
};
// ---------------- State ----------------
const [statusMessage, setStatusMessage] = useState("Idle");
const services = [
  { id: "ac", name: "AC Repair", rate: 50 },
  { id: "plumbing", name: "Plumbing", rate: 40 },
  { id: "electrical", name: "Electrical", rate: 50 },
  { id: "carpentry", name: "Carpentry", rate: 45 },
  { id: "painting", name: "Painting", rate: 35 },
  { id: "pest", name: "Pest Control", rate: 30 },
  { id: "cleaning", name: "Home Cleaning", rate: 25 },
  { id: "appliance", name: "Appliance Repair", rate: 40 },
  { id: "tech", name: "Mobile/Laptop Repair", rate: 45 },
  { id: "cctv", name: "CCTV Installation", rate: 50 },
  { id: "salon", name: "Salon at Home", rate: 60 },
  { id: "driver", name: "Driver Service", rate: 55 },
];
const [bookingData, setBookingData] = useState({
  bookingCode: "",
  invoice: "",
  customerName: "",
  customerEmail: "",
  service: services[0].id,
  onsite: "Yes",
  expenses: 0,
});
const [timer, setTimer] = useState(0);
const [isRunning, setIsRunning] = useState(false);
const [isPaused, setIsPaused] = useState(false);
const [isOnBreak, setIsOnBreak] = useState(false);
const [history, setHistory] = useState([]);
const timerRef = useRef(null);
// ---------------- Lifecycle ----------------
useEffect(() => {
  return () => clearInterval(timerRef.current);
}, []);
// ---------------- Handlers ----------------
const handleChange = (e) => {
  const { name, value } = e.target;
  setBookingData((prev) => ({ ...prev, [name]: value }));
};
const handleServiceChange = (e) => {
  setBookingData((prev) => ({ ...prev, service: e.target.value }));
};
const addHistoryEvent = (action) => {
  const timestamp = new Date().toLocaleString();
  setHistory((prev) => [{ action, timestamp }, ...prev]);
};
const handleGenerateBookingCode = () => {
  const code = `BKG-${Math.floor(Math.random() * 100000)}`;
  setBookingData((prev) => ({ ...prev, bookingCode: code }));
  addHistoryEvent(`Generated booking code: ${code}`);
  setStatusMessage("Booking code generated");
};
const handleGenerateInvoice = () => {
  const invoice = `INV-${Math.floor(Math.random() * 100000)}`;
  setBookingData((prev) => ({ ...prev, invoice }));
  addHistoryEvent(`Generated invoice: ${invoice}`);
  setStatusMessage("Invoice generated");
};
// ---------------- Timer Functions ----------------
const startTimer = () => {
  if (timerRef.current) return;
  timerRef.current = setInterval(() => setTimer((prev) => prev + 1), 1000);
  setIsRunning(true);
  setIsPaused(false);
  setStatusMessage("Working");
};
const pauseTimer = () => {
  clearInterval(timerRef.current);
  timerRef.current = null;
  setIsPaused(true);
  setIsRunning(false);
  setStatusMessage("Paused");
  addHistoryEvent("Paused work");
};
const handleClockIn = () => {
  if (isRunning && !isPaused) return;
  startTimer();
  addHistoryEvent("Clocked In");
};
const handlePause = () => {
  if (!isRunning || isPaused || isOnBreak) return;
  pauseTimer();
};
const handleTakeBreakToggle = () => {
  if (!isRunning && !isOnBreak) {
    setStatusMessage("Start booking before taking a break");
    return;
  }
  if (!isOnBreak) {
    pauseTimer();
    setIsOnBreak(true);
    addHistoryEvent("Took a break");
    setStatusMessage("On Break");
  } else {
    setIsOnBreak(false);
    setIsPaused(false);
    addHistoryEvent("Back from break");
    setStatusMessage("Working");
    startTimer();
  }
};
const handleClockOut = () => {
  // stop timer
  clearInterval(timerRef.current);
  timerRef.current = null;
  // reset all states
  setIsRunning(false);
  setIsPaused(false);
  setIsOnBreak(false);
  setTimer(0); // this alone resets display to 0:00:00
  // log and update status
  addHistoryEvent("Clocked Out");
  setStatusMessage("Idle");
};
// ---------------- Cost & Time ----------------
const calculateCost = () => {
  const serviceObj = services.find((s) => s.id === bookingData.service);
  const rate = serviceObj?.rate || 0;
  const hours = timer / 3600;
  const expenses = parseFloat(bookingData.expenses || 0);
  return (rate * hours + expenses).toFixed(2);
};
const formatTime = (seconds) => {
  const h = String(Math.floor(seconds / 3600)).padStart(2, "0");
  const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
  const s = String(seconds % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
};
// ---------------- PDF & History ----------------
const handleSavePDF = () => {
  const doc = new jsPDF();
  let y = 10;
  const left = 10;
  doc.setFontSize(14);
  doc.text("📄 Customer Booking Receipt", left, y);
  doc.setFontSize(10);
  y += 10;
  const fields = [
    ["Booking Code", bookingData.bookingCode],
    ["Invoice", bookingData.invoice],
    ["Customer Name", bookingData.customerName],
    ["Email", bookingData.customerEmail],
    ["Service", services.find((s) => s.id === bookingData.service)?.name || "-"],
    ["Onsite", bookingData.onsite],
    ["Additional Expenses", bookingData.expenses || "0"],
    ["Total Time", formatTime(timer)],
    ["Total Cost", `$${calculateCost()}`],
  ];
  fields.forEach(([label, value]) => {
    doc.text(`${label}: ${value}`, left, y);
    y += 7;
  });
  y += 5;
  doc.text("Booking History:", left, y);
  y += 7;
  if (history.length === 0) {
    doc.text("- No history recorded -", left, y);
  } else {
    history.forEach((h, idx) => {
      doc.text(`${idx + 1}. ${h.action} - ${h.timestamp}`, left, y);
      y += 7;
      if (y > 280) {
        doc.addPage();
        y = 10;
      }
    });
  }
  doc.save(`CustomerBooking_${bookingData.bookingCode || "UNSET"}.pdf`);
  setStatusMessage("Receipt saved as PDF");
};
const handleClearHistory = () => {
  if (!window.confirm("Clear booking history? This cannot be undone.")) return;
  setHistory([]);
  setStatusMessage("History cleared");
};
const [showBookingServices, setShowBookingServices] = useState(false); // ✅ must exist
// ✅ Define pushBookingNotification in scope
const pushBookingNotification = async (type) => {
  const { name, email, phone, providerId } = formProvider || {};
  if (!providerReady || !name || !email || !phone || !providerId) {
    return alert("Please fill all provider details before sending a notification.");
  }
  setPushingType(type);
  try {
    const res = await fetch("http://localhost:7678/notify/booking-event", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        type,
        provider: { name, email, phone, providerId },
      }),
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.error || "Push failed");
    alert(`✅ Push notification sent for "${type}" with provider: ${name}`);
  } catch (e) {
    console.error(e);
    alert(`❌ Failed to send push: ${e.message}`);
  } finally {
    // Reset pushing state
    setPushingType(null);
    // ✅ Clear the form after performing the booking action
    setFormProvider({ name: "", email: "", phone: "", providerId: "" });
  }
};
const [savingType, setSavingType] = useState(null);
const [pushingType, setPushingType] = useState(null);
const providerReady = !!formProvider?.providerId;
const types = ["new", "confirmed", "cancelled", "amended"];
const saveAvailabilityToFirestore = async (username, period) => {
  if (!username) {
    console.error("Cannot save: username is undefined!");
    toast.error("Cannot save: provider ID is missing!");
    return;
  }
  try {
    // Map all days, keep closed days with open: false
    const formattedAvailability = {};
    Object.entries(profileAvailability).forEach(([day, data]) => {
      formattedAvailability[day] = {
        open: data.open,
        slots: data.open ? data.slots : [], // keep slots only if open
      };
    });
    const docRef = doc(db, "ProviderProfile_Availability", `${username}_${period}`);
    await setDoc(docRef, {
      username: username,
      period: period,
      availability: formattedAvailability,
      updatedAt: new Date(),
    });
    console.log("Availability saved successfully!");
    toast.success(`✅ Availability (${period}) saved successfully!`);
  } catch (error) {
    console.error("Error saving availability:", error);
    toast.error(`❌ Error saving availability: ${error.message}`);
  }
};
  const modifyDayTimeSlot = (dayName, slotIndex, updatedTimeRange) => {
  setProfileAvailability((currentAvailability) => ({
    ...currentAvailability,
    [dayName]: {
      ...currentAvailability[dayName],
      slots: currentAvailability[dayName].slots.map((slot, i) =>
        i === slotIndex ? updatedTimeRange : slot
      ),
    },
  }));
};
  // Inside your component
const [selectedTimezone, setSelectedTimezone] = useState("Asia/Kolkata");
const [successMessage, setSuccessMessage] = useState(""); // ✅ must be inside component
// ---------------- New Availability State for Profile Card ----------------
const [profileAvailability, setProfileAvailability] = useState({
  Monday: { open: true, slots: [{ from: 9, to: 13 }, { from: 14, to: 17 }] },
  Tuesday: { open: true, slots: [{ from: 9, to: 13 }, { from: 14, to: 17 }] },
  Wednesday: { open: true, slots: [{ from: 9, to: 13 }, { from: 14, to: 17 }] },
  Thursday: { open: true, slots: [{ from: 9, to: 13 }, { from: 14, to: 17 }] },
  Friday: { open: true, slots: [{ from: 9, to: 13 }, { from: 14, to: 17 }] },
  Saturday: { open: true, slots: [{ from: 9, to: 13 }, { from: 14, to: 17 }] }
});
// ---------------- Slot Editing State ----------------
const [profileSlotEditingState, setProfileSlotEditingState] = useState({});
// ---------------- Handlers ----------------
const toggleProfileDayStatus = (day) => {
  setProfileAvailability((prev) => ({
    ...prev,
    [day]: { ...prev[day], open: !prev[day].open },
  }));
};
const modifyProfileSlot = (day, index, updatedSlot) => {
  setProfileAvailability((prev) => {
    const updatedSlots = [...prev[day].slots];
    updatedSlots[index] = updatedSlot;
    return { ...prev, [day]: { ...prev[day], slots: updatedSlots } };
  });
};
const appendProfileSlot = (day) => {
  setProfileAvailability((prev) => ({
    ...prev,
    [day]: { ...prev[day], slots: [...prev[day].slots, { from: 9, to: 10 }] },
  }));
};
const deleteProfileSlot = (day, index) => {
  setProfileAvailability((prev) => {
    const updatedSlots = prev[day].slots.filter((_, i) => i !== index);
    return { ...prev, [day]: { ...prev[day], slots: updatedSlots } };
  });
};
 // ---------------- Persist Availability with UI feedback ----------------
  const persistAvailability = (username, type) => {
    // Replace this with your API / Firestore call
    console.log("Saving availability for", username, "as", type);
    console.log(availability);

    // Show temporary UI message
    setSuccessMessage(`✅ Availability saved for ${username} (${type})`);

    // Auto-hide message after 3 seconds
    setTimeout(() => setSuccessMessage(""), 3000);
  };
  // ---------------- State for Section Visibility ----------------
const [showProviderNotifier, setShowProviderNotifier] = useState(false); // ✅ NEW
const [showCustomerNotifier, setShowCustomerNotifier] = useState(false);
const [allAdminNotes, setAllAdminNotes] = React.useState(() => {
  try {
    const saved = localStorage.getItem("allAdminNotes");
    return saved ? JSON.parse(saved) : [];
  } catch (err) {
    console.error("Failed to load notes:", err);
    return [];
  }
});
const [newNote, setNewNote] = React.useState("");
  const reviews = [
    { id: 1, rating: 5, feedback: "Excellent service, very professional!" },
    { id: 2, rating: 4, feedback: "Great job, but arrived slightly late." },
    { id: 3, rating: 5, feedback: "Quick and efficient, highly recommend!" },
  ];
  const [isEditing, setIsEditing] = useState(false);
  const [editableProfile, setEditableProfile] = useState({ ...selectedProfile });
  // ---------------- Handler Functions ----------------
  // Contact Provider
  const handleContactProvider = () => {
    if (selectedProfile?.phone) {
      alert(`Contacting ${selectedProfile.name} at ${selectedProfile.phone}`);
    } else {
      alert("Phone number not available");
    }
  };
  const handleApproveReject = () => {
  const action = window.prompt("Type 'approve' or 'reject' for this provider:");

  if (action === "approve") {
    updateStatus("approved", selectedProfile.name, notes);
    setSelectedProfile({ ...selectedProfile, status: "approved" }); // 👈 update state
  } else if (action === "reject") {
    updateStatus("rejected", selectedProfile.name, notes);
    setSelectedProfile({ ...selectedProfile, status: "rejected" }); // 👈 update state
  } else {
    alert("Invalid action");
  }
};
  // Export Profile as JSON
  const handleExportProfile = () => {
    if (!selectedProfile) return;
    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(selectedProfile, null, 2));
    const downloadAnchorNode = document.createElement("a");
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", `${selectedProfile.name}_profile.json`);
    document.body.appendChild(downloadAnchorNode);
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  };
// ✅ Define all your values properly
const performanceChartData = [
  { month: "May", value: 20 },
  { month: "Jun", value: 70 },
  { month: "Jul", value: 140 },
  { month: "Aug", value: 300 },
  { month: "Sep", value: 480 },
  { month: "Oct", value: 920 },
];
const totalJobs = 38;
const averageRating = 4.8;
const earningsThisMonth = 1250.5;
const earningsLastMonth = 980;
const responseRate = 92;
// ✅ Utility function
const formatCurrency = (v) =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
  }).format(v);

 function FirestoreData({ profile = {}, activeTab = "Performance & Earnings" }) {
  // Derived data must be inside the component
  const performanceChartData =
    Array.isArray(profile.performanceData) && profile.performanceData.length
      ? profile.performanceData
      : sampleData;

  const totalJobs = profile.totalJobs ?? profile.jobs ?? 38;
  const averageRating = profile.rating ?? 4.8;
  const earningsThisMonth =
    typeof profile.earnings === "number" ? profile.earnings : 1250.5;
  const responseRate = profile.response ?? 92;
}
  // Step definitions for verification workflow
const [verificationSteps, setVerificationSteps] = useState([
  { key: "identityCheck", label: "Identity Verification", instructions: "Upload ID document" },
  { key: "dbsScreening", label: "DBS Screening", instructions: "Upload DBS certificate" },
  { key: "insuranceValidation", label: "Insurance Validation", instructions: "Upload insurance document" },
]);

// State to track uploaded files and verification status
const [verificationStatus, setVerificationStatus] = useState({
  identityCheck: { status: "", fileName: "" },
  dbsScreening: { status: "", fileName: "" },
  insuranceValidation: { status: "", fileName: "" },
});
// Handle file uploads for both Verification & Compliance and Trust Indicators
const handleDocumentUpload = (stepKey, e) => {
  const file = e.target.files[0];
  if (!file) return;

  // Mark the step as pending with the uploaded file
  setVerificationStatus((prev) => ({
    ...prev,
    [stepKey]: { ...prev[stepKey], fileName: file.name, status: "pending" },
  }));

  // Simulate server verification (e.g., upload + approve)
  setTimeout(() => {
    setVerificationStatus((prev) => ({
      ...prev,
      [stepKey]: { ...prev[stepKey], status: "verified" },
    }));
  }, 2000); // 2 seconds delay for demo purposes
};
  const [profileDetails, setProfileDetails] = useState({
  name: "",
  serviceCategory: "",
  services: [], // Default empty array
  rate: "",
  location: "",
  serviceRadius: "",
  nextAvailable: "",
  bio: "",
});
  const [isEditingNotes, setIsEditingNotes] = useState(false);
  const steps = [
    { title: "Identity Check", description: "Passport / Driver’s Licence uploaded", key: "identity", initialStatus: "pending" },
    { title: "Address Proof", description: "Utility Bill, Bank Statement", key: "address", initialStatus: "pending" },
    { title: "DBS Check", description: "Background check", key: "dbs", initialStatus: "in-progress" },
    { title: "Insurance", description: "Liability insurance document", key: "insurance", initialStatus: "pending" },
    { title: "Bank Details", description: "For payouts", key: "bank", initialStatus: "pending" },
  ];

  const [verification, setVerification] = useState(
    steps.reduce((acc, step) => {
      acc[step.key] = { status: step.initialStatus, file: null };
      return acc;
    }, {})
  );

  const [timeline, setTimeline] = useState([]);

  const completionPercent =
    (Object.values(verification).filter((v) => v.status === "completed").length / steps.length) * 100;

  const handleUpload = (key, e) => {
    const file = e.target.files[0];
    if (file) {
      setVerification((prev) => ({
        ...prev,
        [key]: { ...prev[key], file, status: "completed" },
      }));

      setTimeline((prev) => [
        {
          text: `${steps.find((s) => s.key === key).title} document uploaded`,
          time: new Date().toLocaleString(),
          status: "completed",
        },
        ...prev,
      ]);
    }
  };

  const getStatusIcon = (status) => {
    const baseStyle = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 22,
      height: 22,
      borderRadius: "50%",
      color: "#fff",
      fontSize: 14,
      zIndex: 2,
    };
    if (status === "completed") return <span style={{ ...baseStyle, backgroundColor: "#4CAF50" }}>✓</span>;
    if (status === "in-progress") return <span style={{ ...baseStyle, backgroundColor: "#ccc" }}>→</span>;
    return <span style={{ ...baseStyle, backgroundColor: "#f44336" }}>→</span>;
  };

  const stepGap = 48;
  const dotSize = 12;

const [filterStatus, setFilterStatus] = useState("all");
const filteredNotifications = notifications.filter((notif) => {
  if (filterStatus === "read") return notif.read;
  if (filterStatus === "unread") return !notif.read;
  return true; // all
});

const updateStatus = async (newStatus, providerName, notes = "") => {
  if (!providerName || !providerName.trim()) {
    toast.error("⚠️ Provider name is required.");
    return;
  }

  try {
    // Query Notification_Providers by provider.name
    const q = query(
      collection(db, "Notification_Providers"),
      where("provider.name", "==", providerName.trim())
    );
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      toast.error("❌ Provider not found.");
      return;
    }

    // Assuming unique provider name, update first matched doc
    const docRef = querySnapshot.docs[0].ref;

    // Build status message dynamically
    let messageText = "";
    switch (newStatus) {
      case "authorized":
        messageText = "Provider has been authorized.";
        break;
      case "activated":
        messageText = "Provider account activated.";
        break;
      case "rejected":
        messageText = notes ? `Rejected: ${notes}` : "Provider has been rejected.";
        break;
      case "authorization_complete":
        messageText = "Authorization process completed.";
        break;
      default:
        messageText = `Status updated to ${newStatus}.`;
    }

    // Update Firestore document with new status and message
    await setDoc(
      docRef,
      {
        status: newStatus,
        message: messageText,
        updatedAt: serverTimestamp(),
        read: true,
      },
      { merge: true }
    );

    // Update provider list state in UI
    setProviderList((prevList) =>
      prevList.map((provider) =>
        provider.provider?.name === providerName
          ? { ...provider, status: newStatus }
          : provider
      )
    );

    // Update selectedProfile if matches provider
    setSelectedProfile((prev) => {
      if (!prev) return prev;

      // If your selectedProfile has provider nested:
      if (prev.provider?.name === providerName) {
        return {
          ...prev,
          status: newStatus,
          provider: { ...prev.provider, status: newStatus }, // Also update nested provider status if exists
        };
      }

      // Or if your selectedProfile is directly provider object:
      if (prev.name === providerName) {
        return {
          ...prev,
          status: newStatus,
        };
      }

      return prev;
    });

    toast.success("✅ Status updated successfully.");
  } catch (error) {
    console.error("❌ Firestore Update Error:", error);
    toast.error("❌ Failed to update status.");
  }
};

const fetchNotifications = async () => {
  try {
    const q = query(collection(db, "Notification_Providers"), orderBy("timestamp", "desc"));
    const snapshot = await getDocs(q);

    const notifList = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));

    setNotifications(notifList);
  } catch (error) {
    console.error("Error fetching notifications:", error);
    toast.error("Failed to load notifications.");
  }
};

// In your component:
useEffect(() => {
  fetchNotifications();
}, []);
const [selectedCustomerId, setSelectedCustomerId] = useState("");
  const [providerFormData, setProviderFormData] = useState({
  providerId: '',
  name: '',
  email: '',
  phone: '',
});

const [customerBookingList, setCustomerBookingList] = useState([]);
useEffect(() => {
  const fetchBookings = async () => {
    try {
      const q = query(collection(db, "Notification_Customers"), orderBy("createdAt", "desc"));
      const querySnapshot = await getDocs(q);

      const bookings = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setCustomerBookingList(bookings);
    } catch (error) {
      console.error("Error fetching customer bookings:", error);
    }
  };

  fetchBookings();
}, []);

  const [customerList, setCustomerList] = useState([]);
  const [customerNotes, setCustomerNotes] = useState('');
  const customersRef = collection(db, "Notification_Customers");

  // 🚀 Realtime fetch of customer list
  useEffect(() => {
    const unsubscribe = onSnapshot(customersRef, (snapshot) => {
      const updatedList = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCustomerList(updatedList);
    });

    return () => unsubscribe(); // cleanup listener
  }, []);

  // ❌ Delete customer
  const deleteCustomer = async (docId) => {
    try {
      await deleteDoc(doc(db, "Notification_Customers", docId));
    } catch (error) {
      console.error("Error deleting customer:", error);
    }
  };
    const deleteBooking = async (bookingId) => {
    if (!bookingId) return;

    try {
      const q = query(
        collection(db, "notifications"),
        where("bookingId", "==", bookingId)
      );

      const snapshot = await getDocs(q);

      if (snapshot.empty) {
        console.warn(`❌ No document found with bookingId: ${bookingId}`);
        return;
      }

      snapshot.forEach(async (docSnap) => {
        await deleteDoc(doc(db, "notifications", docSnap.id));
        console.log(`✅ Deleted booking with ID: ${bookingId}`);
      });

      // Remove from local state
      setBookingList((prev) =>
        prev.filter((booking) => booking.bookingId !== bookingId)
      );
    } catch (error) {
      console.error("🔥 Error deleting booking:", error);
    }
  };

const handleCustomerBookingClick = async (bookingType) => {
const { customerId, name, email, phone } = formCustomer; // 🔹 Removed deviceType (not in form)
  if (!customerId || !name || !email || !phone) {
    toast.warn("Please fill in all customer fields before adding booking.", { position: "top-center" });
    return;
  }
  try {
    const bookingTitles = {
      new: "📦 New Booking",
      confirmed: "✅ Booking Confirmed",
      cancelled: "❌ Booking Cancelled",
      amended: "🔁 Booking Amended",
    };
    const bookingData = {
      bookingId: uuidv4(),
      type: bookingType,
      title: bookingTitles[bookingType] || "📦 Booking Update",
      timestamp: serverTimestamp(),
      customer: {
        customerId,
        name,
        email,
        phone,
      },
    };
    // Save booking data
    await addDoc(collection(db, "Booking_Customers"), bookingData);
    // Save booking notification to "Notification_Feed"
    await addDoc(collection(db, "Notification_Feed"), {
      id: uuidv4(),
      title: bookingData.title,
      type: `booking_${bookingType}`,
      timestamp: serverTimestamp(),
      read: false,
      body: `Booking status: ${bookingData.title}`,
      customerId,
      name,
      email,
      phone,
      status: "Pending",
    });
    toast.success(`Booking of type "${bookingType}" added successfully!`, { position: "top-center" });
    // Reset form
    setFormCustomer({ customerId: "", name: "", email: "", phone: "" });
    fetchNotificationFeed();
  } catch (error) {
    console.error("Error adding booking:", error);
    toast.error("Failed to add booking.", { position: "top-center" });
  }
};
  // 🆕 Using new variable terminology
  const [bookingRecords, setBookingRecords] = useState([]);
  const [activeBooking, setActiveBooking] = useState(null);
  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, "Booking_Customers"),
      (querySnapshot) => {
        console.log("🔥 Snapshot triggered. Total docs:", querySnapshot.size);
        if (querySnapshot.empty) {
          console.log("⚠️ No documents found in Firestore.");
          setBookingRecords([]);
          return;
        }
        const extractedBookings = querySnapshot.docs.map((doc) => {
          const data = doc.data();
          const customer = data.customer || {};
          return {
            recordId: doc.id,
            bookingCode: data.bookingId || "N/A",
            bookingType: data.type || "Unknown",
            bookingTitle: data.title || "Booking",
            bookingTime: data.timestamp?.toDate ? data.timestamp.toDate() : null,
            customerCode: customer.id || customer.customerId || "N/A",
            customerName: customer.name || "Unnamed",
            customerEmail: customer.email || "N/A",
            customerPhone: customer.phone || "N/A",
            userAgentData: data.userAgent || navigator.userAgent,
          };
        });
        console.log("✅ Bookings Parsed:", extractedBookings);
        setBookingRecords(extractedBookings);
      },
      (error) => {
        console.error("❌ Firestore fetch error:", error);
      }
    );
    return () => unsubscribe();
  }, []);
const [notificationFeed, setNotificationFeed] = useState([]);
const fetchNotificationFeed = async () => {
  try {
    const q = query(
      collection(db, "Notification_Feed"),
      orderBy("timestamp", "desc")
    );
    const snapshot = await getDocs(q);
    setCustomerNotifications(prevNotifications => {
      const fetchedNotifications = snapshot.docs.map(docSnap => ({
        id: docSnap.id,       // Firestore document ID
        ...docSnap.data()
      }));
      // Preserve local read/unread state for smoother UX
      return fetchedNotifications.map(newNotif => {
        const existingNotif = prevNotifications.find(p => p.id === newNotif.id);
        return existingNotif
          ? { ...newNotif, read: existingNotif.read }
          : newNotif;
      });
    });
  } catch (error) {
    console.error("Error fetching notification feed:", error);
  }
};
useEffect(() => {
  fetchNotificationFeed();
}, []);

// ✅ Submit new customer + update Notification_Feed UI
const submitNewCustomer = async () => {
const { customerId, name, email, phone, deviceType } = formCustomer;
  // ✅ Validate all fields (deviceType optional)
  if (
    !customerId?.trim() ||
    !name?.trim() ||
    !email?.trim() ||
    !phone?.trim()
  ) {
    toast.warn("⚠️ Please fill in all required fields properly.", {
      position: "top-center",
    });
    return;
  }
  try {
    // ✅ Add to Notification_Feed collection
    await addDoc(collection(db, "Notification_Feed"), {
      customerId: customerId.trim(),
      name: name.trim(),
      email: email.trim(),
      phone: phone.trim(),
      status: "Pending",
      timestamp: serverTimestamp(),
    });
    // ✅ Add notification for new customer
    await addDoc(collection(db, "Notification_Customers"), {
      id: uuidv4(),
      title: "🆕 New Customer Added",
      type: "new_customer_added",
      timestamp: serverTimestamp(),
      read: false,
      status: "Pending",
      body: "Documentation waiting for authorization.",
      customer: {
        customerId: customerId.trim(),
        name: name.trim(),
        email: email.trim(),
        phone: phone.trim(),
      },
    });
    toast.success("✅ Customer added successfully!", { position: "top-center" });
    // ✅ Reset form fields
    setFormCustomer({
      customerId: "",
      name: "",
      email: "",
      phone: "",
      deviceType: "",
    });
    // ✅ Refresh Notification_Feed UI
    await fetchNotificationFeed();
  } catch (error) {
    console.error("❌ Error adding customer:", error);
    toast.error("Failed to add customer.", { position: "top-center" });
  }
};

useEffect(() => {
  const unsubscribe = onSnapshot(collection(db, "Notification_Customers"), (snapshot) => {
    const customerList = snapshot.docs.map((doc) => {
      const notif = doc.data();
      return {
        id: doc.id,
        customerId: notif.customer?.customerId || "N/A",
        name: notif.customer?.name || "N/A",
        email: notif.customer?.email || "N/A",
        phone: notif.customer?.phone || "N/A",
        deviceType: notif.customer?.deviceType || "Unknown",
        status: notif.status || "Pending",
      };
    });
    setCustomerList(customerList); // ✅ Keep consistent with table
  });
  return () => unsubscribe();
}, []);

const fetchCustomersFromNotifications = async () => {
  try {
    const q = query(collection(db, "Notification_Customers"), orderBy("timestamp", "desc"));
    const snapshot = await getDocs(q);

    const customersFromNotifications = snapshot.docs.map(doc => {
      const data = doc.data();
      const customer = data.customer || {}; // nested customer object
      return {
        id: doc.id,
        customerId: customer.customerId || "N/A",
        name: customer.name || "N/A",
        email: customer.email || "N/A",
        phone: customer.phone || "N/A",
        deviceType: customer.deviceType || "Unknown", // ✅ Added deviceType from nested object
        status: data.status || "Pending",
        timestamp: data.timestamp,
        title: data.title,
      };
    });

    setCustomerList(customersFromNotifications);
  } catch (error) {
    console.error("Error fetching customers from notifications:", error);
  }
};


const toggleReadStatusByName = async (notifName, currentReadStatus) => {
  try {
    // 🔹 Instant local UI update
    setCustomerNotifications((prev) =>
      prev.map((notif) =>
        notif.name === notifName
          ? { ...notif, read: !currentReadStatus }
          : notif
      )
    );

    const q = query(
      collection(db, "Notification_Feed"),
      where("name", "==", notifName)
    );
    const snapshot = await getDocs(q);

    if (snapshot.empty) {
      toast.error(`No notification found for name: ${notifName}`);
      return;
    }

    // 🔹 Firestore update
    for (const docSnap of snapshot.docs) {
      await updateDoc(docSnap.ref, { read: !currentReadStatus });
    }

    toast.success(`Marked as ${!currentReadStatus ? "Read" : "Unread"} successfully!`);

    // Optional: Re-fetch to ensure full sync with server
    await fetchNotificationFeed();
  } catch (error) {
    console.error("Error toggling read status by name:", error);
    toast.error("Failed to update read status. Please try again.");
  }
};

const toggleReadStatus = async (notifId, providerId, newStatus) => {
  try {
    let updated = false;

    // ✅ 1. Update Notification_Providers
    if (notifId && !notifId.startsWith("BK_")) {
      const notifRef = doc(db, "Notification_Providers", notifId);
      await updateDoc(notifRef, { read: newStatus });
      updated = true;
      console.log(`✅ Notification_Providers updated for ${notifId}`);
    } else {
      // Fallback to updating by "id" field if doc ID isn't directly usable
      const notifQuery = query(
        collection(db, "Notification_Providers"),
        where("id", "==", notifId)
      );
      const notifSnap = await getDocs(notifQuery);

      if (!notifSnap.empty) {
        for (let notifDoc of notifSnap.docs) {
          await updateDoc(notifDoc.ref, { read: newStatus });
        }
        updated = true;
        console.log(`✅ Notification_Providers updated for ${notifId}`);
      } else {
        console.warn(`⚠️ No Notification_Providers doc found for id: ${notifId}`);
      }
    }

    // ✅ 2. Find and Update Booking_Providers by "id" field
    const bookingQuery = query(
      collection(db, "Booking_Providers"),
      where("id", "==", notifId)
    );
    const bookingSnap = await getDocs(bookingQuery);

    if (!bookingSnap.empty) {
      for (let bookingDoc of bookingSnap.docs) {
        await updateDoc(bookingDoc.ref, { read: newStatus });
      }
      updated = true;
      console.log(`✅ Booking_Providers updated for ${notifId}`);
    } else {
      console.warn(`⚠️ No Booking_Providers doc found for id: ${notifId}`);
    }

    // ✅ 3. Update UI locally
    setNotifications((prev) =>
      prev.map((n) => (n.id === notifId ? { ...n, read: newStatus } : n))
    );

    // ✅ Toast notifications
    if (updated) {
      toast.success(
        `Notification marked as ${newStatus ? "Read" : "Unread"} successfully.`,
        { position: "top-right", autoClose: 2000 }
      );
    } else {
      toast.info("No matching document found to update.", {
        position: "top-right",
        autoClose: 2000,
      });
    }
  } catch (error) {
    console.error("❌ Error updating read status:", error);
    toast.error("Failed to update notification status.", {
      position: "top-right",
      autoClose: 3000,
    });
  }
};

const submitNewProvider = async () => {
const { name = "", email = "", phone = "", providerId = "" } = formProvider || {};
  // Validation
  if (!name.trim() || !email.trim() || !phone.trim()) {
    toast.error("❌ Please fill in all fields.");
    return;
  }
  const finalProviderId = providerId.trim() || `PV_${Date.now()}`;
  const newProviderDoc = {
    title: "🆕 New Provider Added",
    body: "Documentation waiting for authorization.",
    type: "new_provider_added",
    read: false,
    status: "Pending",
    timestamp: serverTimestamp(),
    provider: {
      providerId: finalProviderId,
      name: name.trim(),
      email: email.trim(),
      phone: phone.trim(),
    },
  };

  try {
    // Save in Firestore
    const docRef = await addDoc(collection(db, "Notification_Providers"), newProviderDoc);

    // Update Provider List UI instantly
    setProviderList((prev) => [{ id: docRef.id, ...newProviderDoc }, ...prev]);

    // Update Notification Feed UI instantly
    setNotifications((prev) => [
      {
        id: docRef.id,
        title: newProviderDoc.title,
        body: newProviderDoc.body,
        type: newProviderDoc.type,
        read: newProviderDoc.read,
        status: newProviderDoc.status,
        timestamp: new Date(), // or serverTimestamp() if you want server time
        provider: newProviderDoc.provider,
      },
      ...prev,
    ]);

    // Reset form
    setFormProvider({ providerId: "", name: "", email: "", phone: "" });

    toast.success("✅ Provider added successfully!");
  } catch (error) {
    console.error("❌ Error adding provider:", error);
    toast.error("❌ Failed to add provider. Please try again.");
  }
};

const addBooking = async (type) => {
  if (!formProvider?.providerId) {
    alert("⚠️ Please fill provider details first.");
    return;
  }
  const newBooking = {
    id: `BK_${Date.now()}`,
    type,
    title:
      type === "new"
        ? "📦 New Booking"
        : type === "confirmed"
        ? "✅ Confirmed"
        : type === "cancelled"
        ? "❌ Cancelled"
        : "🔁 Amended",
    provider: {
      providerId: formProvider.providerId,
      name: formProvider.name,
      email: formProvider.email,
      phone: formProvider.phone,
    },
    read: false,
    timestamp: serverTimestamp(),
  };

  try {
    const docRef = await addDoc(collection(db, "Booking_Providers"), newBooking);
    alert(`Booking added with ID: ${docRef.id}`);

    const bookingWithId = {
      ...newBooking,
      id: docRef.id,
      timestamp: new Date(),
    };

    // Update Booking List UI
    setBookingList((prev) => [bookingWithId, ...prev]);

    // Also update Notifications feed UI
    setNotifications((prev) => [bookingWithId, ...prev]);  // assuming setNotifications is your state setter for notifications

    // Clear provider form
    setFormProvider({
      providerId: "",
      name: "",
      email: "",
      phone: "",
    });
  } catch (err) {
    alert("Failed to add booking");
    console.error(err);
  }
};
useEffect(() => {
  const bookingsQuery = query(
    collection(db, "Booking_Providers"),
    orderBy("timestamp", "desc")
  );

  const providersQuery = query(
    collection(db, "Notification_Providers"),
    orderBy("timestamp", "desc")
  );

  // Temporary local state holders
  let latestBookings = [];
  let latestProviders = [];

  const mergeAndSetNotifications = () => {
    const combined = [...latestBookings, ...latestProviders];

    // Deduplicate by 'id'
    const uniqueMap = new Map();
    combined.forEach((item) => {
      uniqueMap.set(item.id, item);
    });

    // Convert Map values to array and sort by timestamp desc
    const merged = Array.from(uniqueMap.values()).sort(
      (a, b) => b.timestamp - a.timestamp
    );

    setNotifications(merged);
  };

  const unsubscribeBookings = onSnapshot(bookingsQuery, (snapshot) => {
    latestBookings = snapshot.docs.map((doc) => ({
      id: doc.id,
      type: "booking",
      ...doc.data(),
      timestamp: doc.data().timestamp?.toDate() || new Date(),
    }));

    setBookingList(latestBookings); // update booking list UI

    mergeAndSetNotifications();
  });

  const unsubscribeProviders = onSnapshot(providersQuery, (snapshot) => {
    latestProviders = snapshot.docs.map((doc) => ({
      id: doc.id,
      type: "provider",
      ...doc.data(),
      timestamp: doc.data().timestamp?.toDate() || new Date(),
    }));

    mergeAndSetNotifications();
  });

  return () => {
    unsubscribeBookings();
    unsubscribeProviders();
  };
}, []);

const listenToProviders = () => {
  try {
    const q = query(
      collection(db, "Notification_Providers"),
      orderBy("timestamp", "desc")
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const providers = snapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            id: doc.id,
            name: data?.provider?.name || data?.name || "No Name",
            email: data?.provider?.email || data?.email || "No Email",
            phone: data?.provider?.phone || data?.phone || "Phone not available", // Flatten phone here
            status: data?.status || "Unknown",
            timestamp: data?.timestamp?.toDate ? data.timestamp.toDate() : new Date(),
          };
        });
        setProviderList(providers);
      },
      (error) => {
        console.error("❌ Error listening to providers:", error);
        toast.error("❌ Failed to load provider list.");
      }
    );

    return unsubscribe; // return unsubscribe for cleanup
  } catch (error) {
    console.error("❌ Error setting up listener:", error);
    toast.error("❌ Failed to initialize provider listener.");
    return () => {}; // no-op cleanup function
  }
};
useEffect(() => {
  const unsubscribe = listenToProviders();
  return () => unsubscribe && unsubscribe();
}, []);
 useEffect(() => {
  const fetchCustomers = async () => {
    try {
      const snapshot = await getDocs(collection(db, "customers"));

      const customers = snapshot.docs
        .map((doc) => {
          const data = doc.data();
          const fullName = (data.fullName || "").trim();
          const email = (data.email || "").trim();
          const mobile = (data.mobile || "").trim();

          // ✅ Skip entries with no essential identity info
          if (!fullName && !email && !mobile) return null;

          return {
            id: doc.id,
            fullName,
            email,
            mobile,
            walletBalance:
              typeof data.walletBalance === "number" ? data.walletBalance : 0,
            referralBalance:
              typeof data.referralBalance === "number" ? data.referralBalance : 0,
            referredBy: (data.referredBy || "").trim(),
            referredById: (data.referredById || "").trim(), // ✅ correctly added
            referralBonusApplied: !!data.referralBonusApplied,
            myReferralCode: data.myReferralCode || "",
            referredByCode: data.referredByCode || "",
            tags: Array.isArray(data.tags) ? data.tags : [], // ✅ fallback to empty array
          };
        })
        .filter((cust) => cust !== null); // ✅ remove skipped entries

      setLocalCustomers(customers);
    } catch (error) {
      console.error("❌ Failed to fetch customers:", error);
      toast.error("Failed to load customers.");
    }
  };

  fetchCustomers();
}, []);

 const [enteredCustomerReferralCode, setEnteredCustomerReferralCode] = useState("");
 const [referralCode, setReferralCode] = useState("");

const applyReferralBonusFor = async (targetDocId) => {
  const userBonus = 100;
  const refBonus = 50;

  try {
    const targetSnap = await getDoc(doc(db, "customers", targetDocId));
    if (!targetSnap.exists()) {
      toast.error("❌ Customer not found.");
      return;
    }

    const customer = { docId: targetSnap.id, ...targetSnap.data() };

    // ⛔ Prevent invalid or self-referral
    if (
      !customer.referredById ||
      customer.referredById === customer.docId
    ) {
      toast.info("❌ Invalid referral ID.");
      return;
    }

    // ✅ Prevent re-application
    if (customer.referralBonusApplied) {
      toast.info("✅ Referral bonus already applied.");
      return;
    }

    // 🔍 Fetch referrer directly using referredById
    const referrerSnap = await getDoc(doc(db, "customers", customer.referredById));
    if (!referrerSnap.exists()) {
      toast.error("❌ Referrer not found.");
      return;
    }

    const referrer = {
      docId: referrerSnap.id,
      ...referrerSnap.data(),
    };

    // 🔁 Apply bonus transaction
    await runTransaction(db, async (tx) => {
      tx.update(doc(db, "customers", customer.docId), {
        walletBalance: (customer.walletBalance || 0) + userBonus,
        referralBalance: (customer.referralBalance || 0) + userBonus,
        referralBonusApplied: true,
        referredBy: customer.referredByName || referrer.fullName || referrer.docId,
      });

      tx.update(doc(db, "customers", referrer.docId), {
        walletBalance: (referrer.walletBalance || 0) + refBonus,
        referralBalance: (referrer.referralBalance || 0) + refBonus,
      });
    });

    // 🔄 Fetch updated data
    const [updatedCustomerSnap, updatedReferrerSnap] = await Promise.all([
      getDoc(doc(db, "customers", customer.docId)),
      getDoc(doc(db, "customers", referrer.docId)),
    ]);

    const updatedCustomer = { docId: updatedCustomerSnap.id, ...updatedCustomerSnap.data() };
    const updatedReferrer = { docId: updatedReferrerSnap.id, ...updatedReferrerSnap.data() };

    // 🟢 Update state for immediate UI sync
    setLocalCustomers((prev) =>
      prev.map((c) => {
        if (c.docId === updatedCustomer.docId || c.id === updatedCustomer.docId) return updatedCustomer;
        if (c.docId === updatedReferrer.docId || c.id === updatedReferrer.docId) return updatedReferrer;
        return c;
      })
    );

    toast.success(`🎁 ₹${userBonus} → ${updatedCustomer.fullName}, ₹${refBonus} → ${updatedReferrer.fullName}`);
  } catch (err) {
    console.error("❌ Referral Bonus Error:", err);
    toast.error("❌ Error applying referral bonus.");
  }
};

// ✅ Reset one customer's wallet/referral data
const resetWalletAndReferralByDocId = async (docId, setLocalCustomers) => {
  const userRef = doc(db, "customers", docId);
  const userSnap = await getDoc(userRef);

  if (!userSnap.exists()) {
    throw new Error(`Customer with ID ${docId} not found.`);
  }

  const updates = {
    walletBalance: 0,
    referralBalance: 0,
    referralBonusApplied: false,
  };

  await updateDoc(userRef, updates);

  // ✅ Update local UI state
  setLocalCustomers((prev) =>
    prev.map((cust) =>
      cust.docId === docId || cust.id === docId ? { ...cust, ...updates } : cust
    )
  );
};

// ✅ Loop through all customers and reset eligible ones
const resetAllCustomerWalletsAndReferrals = async (setLocalCustomers) => {
  const failedResets = [];
  const skipped = [];

  try {
    const querySnapshot = await getDocs(collection(db, "customers"));

    if (querySnapshot.empty) {
      toast.info("ℹ️ No customers found.");
      return;
    }

    for (const docSnap of querySnapshot.docs) {
      const docId = docSnap.id;
      const data = docSnap.data();

      const hasAllFields =
        data.hasOwnProperty("walletBalance") &&
        data.hasOwnProperty("referralBalance") &&
        data.hasOwnProperty("referralBonusApplied");

      if (hasAllFields) {
        try {
          await resetWalletAndReferralByDocId(docId, setLocalCustomers);
          console.log(`✅ Reset successful for: ${docId}`);
        } catch (err) {
          console.error(`❌ Failed to reset customer ${docId}:`, err);
          failedResets.push(docId);
        }
      } else {
        console.log(`⏭️ Skipped ${docId} (missing one or more required fields)`);
        skipped.push(docId);
      }
    }

    if (failedResets.length > 0) {
      toast.error(`❌ Failed to reset ${failedResets.length} customer(s). Check console.`);
      console.log("Failed Resets:", failedResets);
    } else {
      toast.success("✅ All eligible customer wallets/referrals reset.");
    }

    if (skipped.length > 0) {
      console.info(`ℹ️ Skipped ${skipped.length} customer(s) with missing fields:`, skipped);
    }
  } catch (err) {
    console.error("❌ Error during bulk reset:", err);
    toast.error("❌ Unexpected error during reset.");
  }
};
 useEffect(() => {
  const unsubscribe = onSnapshot(collection(db, "partners"), (snapshot) => {
    const data = snapshot.docs
      .map((doc) => {
        const d = doc.data();

        if (!d.fullName && !d.email && !d.mobile) return null;

        return {
          id: doc.id,
          fullName: d.fullName?.trim() || "Unnamed",
          email: d.email?.trim() || "No Email",
          mobile: d.mobile?.trim() || "No Mobile",
          user_type: d.role || "N/A",
          username: d.UserId || doc.id,
          status: d.status || "Inactive",
          approval_status: d.approvalStatus || "Pending",
          walletBalance: typeof d.walletBalance === "number" ? d.walletBalance : 0,
          referralBalance: typeof d.referralBalance === "number" ? d.referralBalance : 0,
          storageImage: d.userStorageImage || "https://via.placeholder.com/100",
          referredByCode: d.referredBy || "Not Referred",
          referredById: d.referredById?.trim() || "",
          myReferralCode: d.myReferralCode || "",
          referralCode: d.referralCode || "",
          referralBonusApplied: !!d.referralBonusApplied,
          tags: d.tags || [],
        };
      })
      .filter((item) => item !== null);

    setPartners(data);
  });

  return () => unsubscribe();
}, []);


const addTestPartner = async () => {
  const partnerUsers = {
    id: 1,
    uid: "user_01",
    UserId: "user_01",
    password: "123456",
    fullName: "Users",
    email: "us@test.com",
    mobile: "1234567890",
    role: "provider",
    myReferralCode: "USERS123",
    referredByCode: "",
    referredBy: "",
    referredById: null,
    referralBonusApplied: false,
    walletBalance: 50,
    status: "Active",
    approvalStatus: "Approved",
    userStorageImage: "/images/user.png"
  };

  const partnerRushita = {
    id: 2,
    uid: "rushi@123",
    UserId: "rushi@123",
    password: "987654",
    fullName: "Rushita",
    email: "abc@gmail.com",
    mobile: "9876543211",
    role: "partner",
    myReferralCode: "RUSHITA456",
    referredByCode: "USERS123",
    referredBy: "",
    referredById: null,
    referralBonusApplied: false,
    walletBalance: 100,
    status: "Active",
    approvalStatus: "Approved",
    userStorageImage: "/images/rushita.png"
  };

  const partnerJohn = {
    id: 3,
    uid: "john_99",
    UserId: "john_99",
    password: "password123",
    fullName: "John Doe",
    email: "john123Katarapu@gmail.com",
    mobile: "9998887770",
    role: "provider",
    myReferralCode: "JOHN999",
    referredByCode: "RUSHITA456",
    referredBy: "",
    referredById: null,
    referralBonusApplied: false,
    walletBalance: 80,
    status: "Active",
    approvalStatus: "Pending",
    userStorageImage: "/images/john.png"
  };

  const allPartners = [partnerUsers, partnerRushita, partnerJohn];
  const userBonus = 100;
  const refBonus = 100;

  try {
    // Step 1: Upload all partners to Firestore
    for (const partner of allPartners) {
      await setDoc(doc(db, "partners", partner.uid), partner);
      console.log(`✅ Partner ${partner.fullName} added`);
    }

    // Step 2: Apply referral bonuses
    for (const referred of allPartners) {
      if (!referred.referredByCode || referred.referralBonusApplied) continue;

      // Prevent self-referral
      if (referred.referredByCode === referred.myReferralCode) {
        console.warn(`⚠️ Skipping self-referral for ${referred.fullName}`);
        continue;
      }

      // Find the referrer by referral code
      const refQuery = query(
        collection(db, "partners"),
        where("myReferralCode", "==", referred.referredByCode)
      );
      const refSnap = await getDocs(refQuery);

      if (refSnap.empty) {
        console.warn(`ℹ️ No referrer found for ${referred.fullName}`);
        continue;
      }

      const referrerDoc = refSnap.docs[0];
      const referrerData = referrerDoc.data();
      const referrerId = referrerDoc.id;

      await runTransaction(db, async (tx) => {
        // Update referred user
        tx.update(doc(db, "partners", referred.uid), {
          referredById: referrerId,
          referredBy: referrerData.fullName || referrerId,
          referralBonusApplied: true,
          walletBalance: (referred.walletBalance || 0) + userBonus,
        });

        // Update referrer wallet
        tx.update(doc(db, "partners", referrerId), {
          walletBalance: (referrerData.walletBalance || 0) + refBonus,
        });
      });

      console.log(`🎉 Referral bonus applied: ${referred.fullName} referred by ${referrerData.fullName}`);
      toast.success(`🎉 ₹${userBonus} → ${referred.fullName}, ₹${refBonus} → ${referrerData.fullName}`);
    }

    toast.success("✅ All test partners added and referral bonuses applied");
  } catch (error) {
    console.error("🔥 Error in addTestPartner:", error);
    toast.error("❌ Failed to complete partner setup.");
  }
};

const resetWalletAndReferralForPartners = async () => {
  try {
    const snapshot = await getDocs(collection(db, "partners"));

    for (const docSnap of snapshot.docs) {
      const partner = docSnap.data();
      const partnerRef = doc(db, "partners", docSnap.id);

      // ❌ Skip partners with missing fullName or walletBalance
      if (
        !partner.fullName ||
        partner.walletBalance === undefined ||
        partner.referralBonusApplied === undefined
      ) {
        console.warn(`⏭️ Skipping incomplete partner: ${docSnap.id}`);
        continue;
      }

      await updateDoc(partnerRef, {
        walletBalance: 0,
        referralBonusApplied: false,
        referredBy: "",
      });
    }

    toast.success("✅ Wallet and referral data reset for all valid partners!");
  } catch (err) {
    console.error("❌ Error during partner reset:", err);
    toast.error("❌ Error during partner reset: " + err.message);
  }
};

const applyReferralBonusForPartner = async (referralCode) => {
  const userBonus = 100;
  const refBonus = 100;

  try {
    // 🔍 Lookup referred partner (who entered the code)
    const referredQuery = query(
      collection(db, "partners"),
      where("myReferralCode", "==", referralCode)
    );
    const referredSnap = await getDocs(referredQuery);

    if (referredSnap.empty) {
      toast.error("❌ Partner not found.");
      return;
    }

    const referredDoc = referredSnap.docs[0];
    const referredPartner = {
      docId: referredDoc.id,
      ...referredDoc.data(),
    };

    // ✅ Prevent invalid or self-referral
    if (
      !referredPartner.referredByCode ||
      referredPartner.referredByCode === referredPartner.myReferralCode
    ) {
      toast.info("❌ Invalid referral code.");
      return;
    }

    // ✅ Prevent re-application
    if (referredPartner.referralBonusApplied) {
      toast.info("✅ Referral bonus already applied.");
      return;
    }

    // 🔍 Lookup referrer using referredByCode
    const referrerQuery = query(
      collection(db, "partners"),
      where("myReferralCode", "==", referredPartner.referredByCode)
    );
    const referrerSnap = await getDocs(referrerQuery);

    if (referrerSnap.empty) {
      toast.error("❌ Referrer not found.");
      return;
    }

    const referrerDoc = referrerSnap.docs[0];
    const referrerPartner = {
      docId: referrerDoc.id,
      ...referrerDoc.data(),
    };

    // 🔁 Apply bonus (wallet only) and update referredById
    await runTransaction(db, async (tx) => {
      tx.update(doc(db, "partners", referredPartner.docId), {
        walletBalance: (referredPartner.walletBalance || 0) + userBonus,
        referralBonusApplied: true,
        referredBy: referrerPartner.fullName || referredPartner.referredByCode,
        referredById: referrerPartner.docId || "", // ✅ Add this line
      });

      tx.update(doc(db, "partners", referrerPartner.docId), {
        walletBalance: (referrerPartner.walletBalance || 0) + refBonus,
      });
    });

    toast.success(
      `🎁 ₹${userBonus} → ${referredPartner.fullName}, ₹${refBonus} → ${referrerPartner.fullName}`
    );
  } catch (err) {
    console.error("❌ Referral Bonus Error:", err);
    toast.error("❌ Error applying referral bonus.");
  }
};

const [serviceType, setServiceType] = useState('');
const [enteredReferralCode, setEnteredReferralCode] = useState("");
const [generatedBookingId, setGeneratedBookingId] = useState('');
const [generatedCustomerUID, setGeneratedCustomerUID] = useState('');
useEffect(() => {
  if (!serviceType) return;

  const shortCode = serviceType
    .replace(/\s+/g, '')       // Remove spaces
    .slice(0, 3)               // First 3 letters
    .toUpperCase();            // Capitalize

  const timeCode = Date.now().toString().slice(-6); // last 6 digits of timestamp
  const randomCode = Math.floor(100 + Math.random() * 900); // 3-digit random

  const bookingId = `BK-${shortCode}-${timeCode}-${randomCode}`;
  const customerUID = `CUST-${shortCode}-${randomCode}`;

  setGeneratedBookingId(bookingId);
  setGeneratedCustomerUID(customerUID);
}, [serviceType]);

  useEffect(() => {
  const fetchServiceHistory = async () => {
    try {
      const snapshot = await getDocs(collection(db, "jobReports"));
      const reports = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setServiceHistory(reports); // ✅ Load into state
    } catch (error) {
      console.error("❌ Failed to load service history:", error);
    }
  };

  fetchServiceHistory();
}, []);

 const handleDeleteServiceEntry = async (index) => {
  const reportToDelete = serviceHistory[index];

  if (!reportToDelete?.id) {
    console.warn("⚠️ No report ID found for deletion.");
    return;
  }

  try {
    // Delete from Firestore
    await deleteDoc(doc(db, "jobReports", reportToDelete.id));

    // Remove from local UI
    const updatedHistory = serviceHistory.filter((_, i) => i !== index);
    setServiceHistory(updatedHistory);

    console.log(`🗑 Deleted report (Booking ID: ${reportToDelete.bookingId || 'N/A'})`);
  } catch (err) {
    console.error("❌ Error deleting report:", err);
  }
};

  const handleSaveToServiceHistory = () => {
  const completedTasks = taskList.filter((t) => t.completed).map((t) => t.task);
  const newEntry = {
    customerEmail,
    serviceType,
    completedTasks,
    notes,
    rating,
    feedback,
    images: {
      before: beforeImagePreview || null,
      after: afterImagePreview || null,
    },
    timestamp: new Date().toISOString(), // or Date.now()
  };

  setServiceHistory((prev) => [...prev, newEntry]);

  alert("✅ Saved to Service History!");

  // Optionally reset form
  setCustomerEmail('');
  setServiceType('');
  setTaskList((prev) => prev.map((t) => ({ ...t, completed: false })));
  setBeforeImagePreview(null);
  setAfterImagePreview(null);
  setNotes('');
  setRating(0);
  setGeneratedCustomerUID('');     // ✅ clear generated customer UID
  setGeneratedBookingId('');       // ✅ clear generated booking ID
  setFeedback('');
};

  const [showRefundOptions, setShowRefundOptions] = useState({});
  const [jobId, setJobId] = useState('');
  const [showRefundDropdown, setShowRefundDropdown] = useState({});
  const [showServiceHistory, setShowServiceHistory] = useState(false);
  const [serviceHistory, setServiceHistory] = useState([]); // optional local fallback
  const [saveToServiceHistory, setSaveToServiceHistory] = useState(false);
  const [tempUserList, setTempUserList] = useState([
  {
    id: "U001",
    fullName: "John Doe",
    email: "john@example.com",
    mobile: "9876543210",
    extension: "101",
    isAdmin: false,
    lastLogin: "2025-07-07 09:00 AM",
    status: "Active",
    wallet: "£0"
  },
  {
    id: "U002",
    fullName: "Ravi Sharma",
    email: "ravi@domain",
    mobile: "98765432",
    extension: "",
    isAdmin: false,
    lastLogin: "2025-07-06 10:14 PM",
    status: "",
    wallet: "£0"
  },
  {
    id: "U003",
    fullName: "Anjali Mehra",
    email: "anjali@example.com",
    mobile: "9876543210",
    extension: "104",
    isAdmin: true,
    lastLogin: "2025-07-03 11:30 AM",
    status: "Suspended",
    wallet: "£0"
  },
  {
    id: "U004",
    fullName: "Users",
    email: "us@test.com",
    mobile: "1234567890",
    extension: "105",
    isAdmin: false,
    lastLogin: "2025-07-02 12:00 PM",
    status: "Active",
    wallet: "£50"
  },
  {
    id: "U005",
    fullName: "Rushita",
    email: "abc@gmail.com",
    mobile: "9876543211",
    extension: "106",
    isAdmin: false,
    lastLogin: "2025-07-01 02:45 PM",
    status: "Active",
    wallet: "£100"
  },
  {
    id: "U006",
    fullName: "Ramesh",
    email: "Ramesh999@gmail.com",
    mobile: "9654327891",
    extension: "107",
    isAdmin: false,
    lastLogin: "2025-06-30 03:10 PM",
    status: "Active",
    wallet: "£345"
  }
]);

// On component mount/load (inside useEffect)
useEffect(() => {
  const savedUsers = localStorage.getItem("userList");
  if (savedUsers) {
    setTempUserList(JSON.parse(savedUsers));
  } else {
    // Load default data (your hardcoded users)
    setTempUserList(defaultUserData);
  }
}, []);

const saveRowEditUI = (id) => {
  // 1. Update tempUserList state with edited data
  const updatedList = tempUserList.map((usr) =>
    usr.id === id ? { ...usr, ...editableRowData } : usr
  );
  setTempUserList(updatedList);

  // 2. Save to localStorage
  localStorage.setItem("userList", JSON.stringify(updatedList));

  // 3. Clear editing states
  setActiveEditRow(null);
  setEditableRowData({});

  // 4. Show success toast
  toast.success("✅ User changes saved successfully!", {
    position: "top-right",
    autoClose: 2000,
  });
};

const defaultUserData = [
  {
    id: "U001",
    fullName: "John Doe",
    email: "john@example.com",
    mobile: "9876543210",
    extension: "101",
    isAdmin: false,
    lastLogin: "2025-07-07 09:00 AM",
    status: "Active",
    wallet: "£0"
  },
  {
    id: "U002",
    fullName: "Ravi Sharma",
    email: "ravi@domain",
    mobile: "98765432",
    extension: "",
    isAdmin: false,
    lastLogin: "2025-07-06 10:14 PM",
    status: "",
    wallet: "£0"
  },
  {
    id: "U003",
    fullName: "Anjali Mehra",
    email: "anjali@example.com",
    mobile: "9876543210",
    extension: "104",
    isAdmin: true,
    lastLogin: "2025-07-03 11:30 AM",
    status: "Suspended",
    wallet: "£0"
  },
  {
    id: "U004",
    fullName: "Users",
    email: "us@test.com",
    mobile: "1234567890",
    extension: "105",
    isAdmin: false,
    lastLogin: "2025-07-02 12:00 PM",
    status: "Active",
    wallet: "£50"
  },
  {
    id: "U005",
    fullName: "Rushita",
    email: "abc@gmail.com",
    mobile: "9876543211",
    extension: "106",
    isAdmin: false,
    lastLogin: "2025-07-01 02:45 PM",
    status: "Active",
    wallet: "£100"
  },
  {
    id: "U006",
    fullName: "Ramesh",
    email: "Ramesh999@gmail.com",
    mobile: "9654327891",
    extension: "107",
    isAdmin: false,
    lastLogin: "2025-06-30 03:10 PM",
    status: "Active",
    wallet: "£345"
  }
];

 
 // Status change handler
const handleLocalStatusChange = (e, userId) => {
  const newStatus = e.target.value;

  setUsers((prevUsers) =>
    prevUsers.map((user) =>
      user.id === userId ? { ...user, status: newStatus } : user
    )
  );

  toast.info(`Status updated to "${newStatus}"`, { autoClose: 2000 });
};

// Begin editing a specific user row
const beginRowEditUI = (user) => {
  setActiveEditRow(user.id);
  setEditableRowData({ ...user });
  toast.info(`Editing ${user.fullName || user.id}`, { autoClose: 1500 });
};

// Cancel editing
const cancelRowEditUI = () => {
  setActiveEditRow(null);
  setEditableRowData({});
  toast.warn("Edit cancelled", { autoClose: 1500 });
};

// Update a specific field
const updateRowField = (field, value) => {
  setEditableRowData((prev) => ({ ...prev, [field]: value }));
};

// UI-only delete user
const deleteFromUIOnly = (id) => {
  const user = tempUserList.find((u) => u.id === id);
  setTempUserList((prevList) => prevList.filter((user) => user.id !== id));
  toast.error(`🗑️ ${user?.fullName || id} deleted (UI only)`, { autoClose: 2000 });
};

// Activate user
const triggerActivateUI = (id) => {
  setTempUserList((prevList) =>
    prevList.map((user) =>
      user.id === id ? { ...user, status: "Active" } : user
    )
  );
  toast.success("✅ User activated", { autoClose: 1500 });
};

// Suspend user
const triggerSuspendUI = (id) => {
  setTempUserList((prevList) =>
    prevList.map((user) =>
      user.id === id ? { ...user, status: "Suspended" } : user
    )
  );
  toast.warn("⏸️ User suspended", { autoClose: 1500 });
};

// Show login info
const showLoginInfo = (id) => {
  const user = tempUserList.find((u) => u.id === id);
  if (user) {
    toast.info(`🔐 Last login: ${user.lastLogin || "N/A"}`, {
      autoClose: 3000,
    });
  } else {
    toast.error("User not found", { autoClose: 2000 });
  }
};

// Ghost mode simulation
const runGhostMode = (id) => {
  const user = tempUserList.find((u) => u.id === id);
  if (user) {
    toast.dark(`👻 Ghost Mode: ${user.fullName} (${user.email})`, {
      autoClose: 3000,
    });
  } else {
    toast.error("User not found", { autoClose: 2000 });
  }
};

// Validate user fields
const runCheckStatus = (id) => {
  const user = tempUserList.find((u) => u.id === id);
  if (!user) {
    toast.error("User not found", { autoClose: 2000 });
    return;
  }

  const issues = [];
  if (!user.email?.includes("@")) issues.push("Invalid email");
  if (!user.mobile || user.mobile.length < 10) issues.push("Invalid mobile");
  if (!user.status) issues.push("Missing status");

  if (issues.length > 0) {
    toast.warn(`⚠️ Issues:\n${issues.join(", ")}`, {
      autoClose: 3000,
    });
  } else {
    toast.success(`✅ All checks passed for ${user.fullName}`, {
      autoClose: 2000,
    });
  }
};

  // 📌 State to show/hide modal
const [showReceiptModal, setShowReceiptModal] = useState(false);

   const handleBeforeImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setBeforeImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleAfterImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setAfterImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
  };


  const handleExportPDF = () => {
  const doc = new jsPDF("landscape", "mm", "a5"); // 👈 Landscape A5
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 10;
  const lineHeight = 6;
  let y = 20;

  // Header
  const headerHeight = 12;
  doc.setFillColor(40, 44, 52);
  doc.rect(0, 0, pageWidth, headerHeight + 3, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("🧾 Job Receipt Preview", margin, headerHeight);
  doc.setTextColor(0, 0, 0);
  y = headerHeight + 8;

  // Customer Email
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.text("Customer Email:", margin, y);
  doc.setFont("helvetica", "normal");
  doc.text(customerEmail || "-", margin + 40, y);
  y += lineHeight;

  // Service Type
  doc.setFont("helvetica", "bold");
  doc.text("Service Type:", margin, y);
  doc.setFont("helvetica", "normal");
  doc.text(serviceType || "-", margin + 40, y);
  y += lineHeight * 2;

  // Completed Tasks
  doc.setFont("helvetica", "bold");
  doc.text("Completed Tasks:", margin, y);
  y += lineHeight;
  const tasks = taskList?.filter(t => t.completed) || [];
  doc.setFont("helvetica", "normal");
  tasks.forEach(t => {
    doc.text(`• ${t.task}`, margin + 5, y);
    y += lineHeight;
  });
  y += lineHeight;

  // Notes, Rating, Feedback
  doc.setFont("helvetica", "bold");
  doc.text("Notes:", margin, y);
  doc.setFont("helvetica", "normal");
  doc.text(notes || "-", margin + 20, y);
  y += lineHeight;

  doc.setFont("helvetica", "bold");
  doc.text("Rating:", margin, y);
  doc.setFont("helvetica", "normal");
  doc.text(`${rating} / 5`, margin + 20, y);
  y += lineHeight;

  doc.setFont("helvetica", "bold");
  doc.text("Feedback:", margin, y);
  doc.setFont("helvetica", "normal");
  doc.text(feedback || "-", margin + 25, y);
  y += lineHeight * 2;

  // Image thumbnails side-by-side
  const thumbWidth = 50;
  const thumbHeight = 35;

  if (beforeImagePreview) {
    doc.setFont("helvetica", "bold");
    doc.text("Before Image:", margin, y);
    doc.addImage(beforeImagePreview, "JPEG", margin, y + lineHeight, thumbWidth, thumbHeight);
    doc.setTextColor(0, 0, 255);
    doc.textWithLink("View", margin, y + thumbHeight + lineHeight + 2, { url: beforeImagePreview });
    doc.setTextColor(0, 0, 0);
  }

  if (afterImagePreview) {
    const x = margin + thumbWidth + 20;
    doc.setFont("helvetica", "bold");
    doc.text("After Image:", x, y);
    doc.addImage(afterImagePreview, "JPEG", x, y + lineHeight, thumbWidth, thumbHeight);
    doc.setTextColor(0, 0, 255);
    doc.textWithLink("View", x, y + thumbHeight + lineHeight + 2, { url: afterImagePreview });
    doc.setTextColor(0, 0, 0);
  }

  doc.save("job_receipt.pdf");
};

const [blockedFromCustomers, setBlockedFromCustomers] = useState([]);
const [blockedFromPartners, setBlockedFromPartners] = useState([]);
const [editableCustomerBlocks, setEditableCustomerBlocks] = useState([]);
const [deletedCustomerRows, setDeletedCustomerRows] = useState([]);
const [editingRowId, setEditingRowId] = useState(null);
const [tempEditState, setTempEditState] = useState(null);
useEffect(() => {
  setEditableCustomerBlocks(blockedFromCustomers); // keep original state clean
}, [blockedFromCustomers]);

// Start editing a row
const beginEditCustomerRow = (row) => {
  setEditingRowId(row.id);
  setTempEditState({ ...row }); // create a temp copy
};

// On input change
const updateTempField = (field, value) => {
  setTempEditState((prev) => ({
    ...prev,
    [field]: value,
  }));
};

const commitCustomerEdit = () => {
  const updated = editableCustomerBlocks.map((row) => {
    if (row.id === editingRowId) {
      const updatedRow = { ...tempEditState };

      // 🔁 Convert back to Timestamp if it's a string date
      if (typeof updatedRow.blockedAt === "string") {
        const dateObj = new Date(updatedRow.blockedAt);
        if (!isNaN(dateObj.getTime())) {
          updatedRow.blockedAt = Timestamp.fromDate(dateObj);
        }
      }

      return updatedRow;
    }
    return row;
  });

  setEditableCustomerBlocks(updated);
  setEditingRowId(null);
  setTempEditState(null);
};


// Delete from UI only
const hideCustomerUIRow = (id) => {
  setDeletedCustomerRows((prev) => [...prev, id]);
};

// Filter hidden rows
const isHidden = (id) => deletedCustomerRows.includes(id);


const [editablePartnerBlocks, setEditablePartnerBlocks] = useState([]);
const [deletedPartnerRows, setDeletedPartnerRows] = useState([]);
const [activeEditRow, setActiveEditRow] = useState(null); // ✅ Add this
const [editingPartnerRowId, setEditingPartnerRowId] = useState(null);
const [editableRowData, setEditableRowData] = useState({}); // ✅ Add this line
const [tempPartnerEditState, setTempPartnerEditState] = useState(null);

useEffect(() => {
  setEditablePartnerBlocks(blockedFromPartners); // your Firestore listener array
}, [blockedFromPartners]);

const startEditPartnerRow = (row) => {
  setEditingPartnerRowId(row.id);
  setTempPartnerEditState({ ...row });
};

const updatePartnerField = (field, value) => {
  setTempPartnerEditState((prev) => ({
    ...prev,
    [field]: value,
  }));
};

const commitPartnerRowChanges = () => {
  const updated = editablePartnerBlocks.map((row) => {
    if (row.id === editingPartnerRowId) {
      const updatedRow = { ...tempPartnerEditState };

      if (typeof updatedRow.blockedAt === "string") {
        const dateObj = new Date(updatedRow.blockedAt);
        if (!isNaN(dateObj.getTime())) {
          updatedRow.blockedAt = Timestamp.fromDate(dateObj);
        }
      }

      return updatedRow;
    }
    return row;
  });

  setEditablePartnerBlocks(updated);
  setEditingPartnerRowId(null);
  setTempPartnerEditState(null);
};

const hidePartnerRowUI = (id) => {
  setDeletedPartnerRows((prev) => [...prev, id]);
};

const isPartnerRowHidden = (id) => deletedPartnerRows.includes(id);



useEffect(() => {
  const unsubscribe = onSnapshot(
    collectionGroup(db, "blocked_partners"),
    (snapshot) => {
      const updated = snapshot.docs
        .filter((doc) => doc.data().blocked === true)
        .map((doc) => {
          const data = doc.data();
          const path = doc.ref.path.split("/");
          const partnerIdIndex = path.findIndex((seg) => seg === "partners");
          const partnerId = partnerIdIndex !== -1 ? path[partnerIdIndex + 1] : "unknown";

          return {
            id: partnerId,
            name: data.name || "",
            blockReason: data.reason || "", // ✅ important
            status: data.status || "Blocked",
            blockedAt: data.blockedAt || null,
          };
        });

      setBlockedFromPartners(updated); // or setEditablePartnerBlocks(updated)
    }
  );

  return () => unsubscribe();
}, []);



  const sampleJobs = [
  {
    number: "001",
    customerName: "John Doe",
    rating: 2.5,
    status: "Completed",
    flagged: true,
  },
  {
    number: "002",
    customerName: "Jane Smith",
    rating: 1.8,
    status: "Complaint Raised",
    flagged: true,
  },
  {
    number: "003",
    customerName: "Mark Johnson",
    rating: 4.5,
    status: "Completed",
    flagged: false,
  },
  {
    number: "004",
    customerName: "Emma Watson",
    rating: 1.9,
    status: "Completed",
    flagged: true,
  },
  {
    number: "005",
    customerName: "Daniel Craig",
    rating: 2.2,
    status: "Missed",
    flagged: true,
  },
  {
    number: "006",
    customerName: "Olivia Wilde",
    rating: 2.4,
    status: "Completed",
    flagged: true,
  },
  {
    number: "007",
    customerName: "Chris Evans",
    rating: 1.0,
    status: "Complaint Raised",
    flagged: true,
  },
  {
    number: "008",
    customerName: "Scarlett Johansson",
    rating: 1.5,
    status: "Missed",
    flagged: true,
  },
];

// ✅ Wrap in async function
const seedSampleJobs = async () => {
  for (const job of sampleJobs) {
    const jobId = `JOB${job.number}`;
    const customerId = `CUST${job.number}`;
    const providerId = `PROV${job.number}`;
    const partnerId = providerId;

    const jobData = {
      id: jobId,
      customerId,
      customerName: job.customerName,
      providerId,
      partnerId,
      rating: job.rating,
      status: job.status,
      flagged: job.flagged,
    };

    try {
      const jobRef = doc(db, "partners", partnerId, "jobs", jobId);
      await setDoc(jobRef, jobData);
      console.log(`✅ Created ${jobId} under partners/${partnerId}/jobs`);
    } catch (error) {
      console.error(`❌ Failed to create ${jobId}:`, error);
    }
  }
};


const jobList = [
  {
    number: "001",
    jobId: "JOB001",
    customerId: "CUST001",
    providerId: "PROV001",
    partnerId: "PROV001",
    customerName: "John Doe",
    rating: 2.5,
    status: "Completed",
    flagged: true,
  },
  {
    number: "002",
    jobId: "JOB002",
    customerId: "CUST002",
    providerId: "PROV002",
    partnerId: "PROV002",
    customerName: "Jane Smith",
    rating: 1.8,
    status: "Complaint Raised",
    flagged: true,
  },
  {
    number: "003",
    jobId: "JOB003",
    customerId: "CUST003",
    providerId: "PROV003",
    partnerId: "PROV003",
    customerName: "Mark Johnson",
    rating: 4.5,
    status: "Completed",
    flagged: false,
  },
  {
    number: "004",
    jobId: "JOB004",
    customerId: "CUST004",
    providerId: "PROV004",
    partnerId: "PROV004",
    customerName: "Emma Watson",
    rating: 1.9,
    status: "Completed",
    flagged: true,
  },
  {
    number: "005",
    jobId: "JOB005",
    customerId: "CUST005",
    providerId: "PROV005",
    partnerId: "PROV005",
    customerName: "Daniel Craig",
    rating: 2.2,
    status: "Missed",
    flagged: true,
  },
  {
    number: "006",
    jobId: "JOB006",
    customerId: "CUST006",
    providerId: "PROV006",
    partnerId: "PROV006",
    customerName: "Olivia Wilde",
    rating: 2.4,
    status: "Completed",
    flagged: true,
  },
  {
    number: "007",
    jobId: "JOB007",
    customerId: "CUST007",
    providerId: "PROV007",
    partnerId: "PROV007",
    customerName: "Chris Evans",
    rating: 1.0,
    status: "Complaint Raised",
    flagged: true,
  },
  {
    number: "008",
    jobId: "JOB008",
    customerId: "CUST008",
    providerId: "PROV008",
    partnerId: "PROV008",
    customerName: "Scarlett Johansson",
    rating: 1.5,
    status: "Missed",
    flagged: true,
  },
];

const escalatedJobs = [...jobList]; // reuse data under a new name to avoid collision
   
const [blockedMap, setBlockedMap] = useState({});


const handleMoveToRefund = async (jobId, partnerId) => {
  if (!partnerId || !jobId) {
    console.error("❌ Missing jobId or partnerId");
    return;
  }

  try {
    // ✅ Step 1: Mark job as pending refund
    await setDoc(
      doc(db, "partners", partnerId, "jobs", jobId),
      {
        status: "pending_refund",
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );

    // ✅ Step 2: Create refund record
    await setDoc(
      doc(db, "partners", partnerId, "refunds", jobId),
      {
        jobId,
        status: "pending",
        createdAt: serverTimestamp(),
      },
      { merge: true }
    );

    alert(`💸 Refund initiated for Job ID: ${jobId}`);
  } catch (err) {
    console.error("❌ Error initiating refund:", err);
    alert("❌ Failed to process refund.");
  }
};

// ✅ Approve Refund
const handleApproveRefund = async (jobId, partnerId) => {
  try {
    await setDoc(
      doc(db, "partners", partnerId, "refunds", jobId),
      {
        status: "approved",
        approvedAt: serverTimestamp(),
      },
      { merge: true }
    );

    await setDoc(
      doc(db, "partners", partnerId, "jobs", jobId),
      {
        status: "refund_approved",
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );

    toast.success(`✅ Refund approved for Job ID: ${jobId}`);
  } catch (error) {
    console.error("Error approving refund:", error);
    toast.error("❌ Failed to approve refund");
  }
};
const handleDeclineRefund = async (jobId, partnerId) => {
  // 🔍 Debug: Log input values
  console.log("🛑 Decline Refund triggered:", { jobId, partnerId });

  if (!jobId?.trim() || !partnerId?.trim()) {
    toast.error("❌ Missing jobId or partnerId");
    return;
  }

  try {
    // 📌 Step 1: Set refund status
    await setDoc(
      doc(db, "partners", partnerId, "refunds", jobId),
      {
        status: "declined",
        declinedAt: serverTimestamp(),
      },
      { merge: true }
    );

    // 📌 Step 2: Update job status
    await setDoc(
      doc(db, "partners", partnerId, "jobs", jobId),
      {
        status: "refund_declined",
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );

    // ✅ Final success message (styled as success but with ❌ text)
    toast.success("❌ Refund Declined");
  } catch (error) {
    console.error("❌ Firestore write failed:", error);
    toast.error("❌ Failed to decline refund");
  }
};


const handleReviewMark = async (jobId, partnerId) => {
  if (!partnerId || !jobId) {
    console.error("❌ Missing partnerId or jobId");
    return;
  }

  try {
    // ✅ Step 1: Only update reviewStatus, not status
    await setDoc(
      doc(db, "partners", partnerId, "jobs", jobId),
      {
        reviewStatus: "under_review",
        updatedAt: serverTimestamp(),
      },
      { merge: true } // Don't overwrite existing fields like status
    );

    // ✅ Step 2: Add to reviews collection (if desired)
    await setDoc(
      doc(db, "partners", partnerId, "reviews", jobId),
      {
        jobId,
        reviewStatus: "under_review",
        createdAt: serverTimestamp(),
      },
      { merge: true }
    );

    alert(`📝 Job ${jobId} flagged for review under partner ${partnerId}`);
  } catch (err) {
    console.error("❌ Error marking job for review:", err);
    alert("❌ Failed to mark job for review.");
  }
};

const handleAutoBlockOrUnblock = async (partnerId, action = "block") => {
  if (!partnerId) {
    toast.error("❌ Missing partnerId");
    return;
  }

  try {
    const blockRef = doc(db, "partners", partnerId, "blocked_partners", "status");

    if (action === "unblock") {
      await setDoc(
        blockRef,
        {
          blocked: false,
          reason: "Unblocked manually",
          updatedAt: serverTimestamp(),
        },
        { merge: true }
      );

      toast.success("🔓 Partner Unblocked");
      return;
    }

    // Default action: "block"
    const jobsRef = collection(db, "partners", partnerId, "jobs");
    const jobsSnap = await getDocs(jobsRef);

    let flaggedJobsCount = 0;
    const reasonSet = new Set();
    const reasonPerJob = [];

    for (const docSnap of jobsSnap.docs) {
      const job = docSnap.data();
      const jobId = docSnap.id;

      const jobReasons = [];

      if (job.rating !== undefined && job.rating < 3) {
        jobReasons.push("Low rating");
        reasonSet.add("Low rating");
      }

      if (job.status === "Complaint Raised") {
        jobReasons.push("Complaint raised");
        reasonSet.add("Complaint raised");
      }

      if (job.status === "Missed") {
        jobReasons.push("Missed job");
        reasonSet.add("Missed job");
      }

      if (job.flagged === true) {
        jobReasons.push("Manually flagged");
        reasonSet.add("Manually flagged");
      }

      if (jobReasons.length > 0) {
        flaggedJobsCount++;
        reasonPerJob.push(`Job ${jobId}: ${jobReasons.join(", ")}`);
      }
    }

    if (flaggedJobsCount > 0) {
      const blockReason = Array.from(reasonSet).join(", ");

      await setDoc(
        blockRef,
        {
          blocked: true,
          reason: blockReason,
          flaggedJobs: flaggedJobsCount,
          details: reasonPerJob,
          blockedAt: serverTimestamp(),
        },
        { merge: true }
      );

      toast.error(`🚫 Partner Blocked due to: ${blockReason}`);
    } else {
      toast.info("ℹ️ No flagged jobs found. Auto-block skipped.");
    }
  } catch (error) {
    console.error("❌ Error in handleAutoBlockOrUnblock:", error);
    toast.error("❌ Operation failed");
  }
};

const [flaggedJobs, setFlaggedJobs] = useState([]);
const [providers, setProviders] = useState({});
const seedJobsToFirestore = async () => {
  try {
    for (const job of jobData) {
      const jobRef = doc(db, "customers", job.customerId, "jobs", job.jobId);
      await setDoc(jobRef, {
        providerId: job.providerId,
        partnerId: job.partnerId,
        customerName: job.customerName,
        rating: job.rating,
        status: job.status,
        flagged: job.flagged,
        createdAt: new Date()
      });
    }

    toast.success("✅ Jobs successfully seeded to Firestore!");
    console.log("✅ Job data successfully seeded to Firestore");
  } catch (error) {
    toast.error("❌ Failed to seed job data!");
    console.error("❌ Failed to seed job data:", error);
  }
};



// Fetch flagged jobs & providers
useEffect(() => {
  const fetchFlaggedJobs = async () => {
    const q = query(collection(db, 'jobs'), where('flagged', '==', true));
    const snapshot = await getDocs(q);
    const jobs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setFlaggedJobs(jobs);
  };

  const fetchProviders = async () => {
    const snap = await getDocs(collection(db, 'providers'));
    const map = {};
    snap.forEach(doc => map[doc.id] = doc.data());
    setProviders(map);
  };

  fetchFlaggedJobs();
  fetchProviders();
}, []);


// ✅ Job data declared at top-level
const jobData = [
  {
    number: "001",
    jobId: "JOB001",
    customerId: "CUST001",
    providerId: "PROV001",
    partnerId: "PROV001",
    customerName: "John Doe",
    rating: 2.5,
    status: "Completed",
    flagged: true,
  },
  {
    number: "002",
    jobId: "JOB002",
    customerId: "CUST002",
    providerId: "PROV002",
    partnerId: "PROV002",
    customerName: "Jane Smith",
    rating: 1.8,
    status: "Complaint Raised",
    flagged: true,
  },
  {
    number: "003",
    jobId: "JOB003",
    customerId: "CUST003",
    providerId: "PROV003",
    partnerId: "PROV003",
    customerName: "Mark Johnson",
    rating: 4.5,
    status: "Completed",
    flagged: false,
  },
  {
    number: "004",
    jobId: "JOB004",
    customerId: "CUST004",
    providerId: "PROV004",
    partnerId: "PROV004",
    customerName: "Emma Watson",
    rating: 1.9,
    status: "Completed",
    flagged: true,
  },
  {
    number: "005",
    jobId: "JOB005",
    customerId: "CUST005",
    providerId: "PROV005",
    partnerId: "PROV005",
    customerName: "Daniel Craig",
    rating: 2.2,
    status: "Missed",
    flagged: true,
  },
  {
    number: "006",
    jobId: "JOB006",
    customerId: "CUST006",
    providerId: "PROV006",
    partnerId: "PROV006",
    customerName: "Olivia Wilde",
    rating: 2.4,
    status: "Completed",
    flagged: true,
  },
  {
    number: "007",
    jobId: "JOB007",
    customerId: "CUST007",
    providerId: "PROV007",
    partnerId: "PROV007",
    customerName: "Chris Evans",
    rating: 1.0,
    status: "Complaint Raised",
    flagged: true,
  },
  {
    number: "008",
    jobId: "JOB008",
    customerId: "CUST008",
    providerId: "PROV008",
    partnerId: "PROV008",
    customerName: "Scarlett Johansson",
    rating: 1.5,
    status: "Missed",
    flagged: true,
  },
];

const escalatedJobList = jobData.map(job => ({
  escalationJobId: job.jobId,
  escalationCustomerId: job.customerId,
  escalationProviderId: job.providerId,
  customerName: job.customerName,
  rating: job.rating,
  flagged: job.flagged,
  status: job.status,
}));


const moveToRefundQueue = async (customerId, jobId) => {
  try {
    // ✅ Step 1: Update job's status in jobs collection
    await setDoc(
      doc(db, "customers", customerId, "jobs", jobId),
      {
        status: "pending_refund",
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );

    // ✅ Step 2: Add entry in refunds collection
    await setDoc(
      doc(db, "customers", customerId, "refunds", jobId),
      {
        jobId,
        status: "pending",
        createdAt: serverTimestamp(),
      },
      { merge: true }
    );

    alert(`✅ Refund initiated for Job ${jobId} under Customer ${customerId}`);
  } catch (err) {
    console.error("❌ Error initiating refund:", err);
    alert("❌ Refund failed: " + err.message);
  }
};

const markUnderReview = async (customerId, jobId) => {
  try {
    // ✅ Step 1: Only update reviewStatus, not status
    await setDoc(
      doc(db, "customers", customerId, "jobs", jobId),
      {
        reviewStatus: "under_review",
        updatedAt: serverTimestamp(),
      },
      { merge: true } // Don't overwrite existing fields like status
    );

    // ✅ Step 2: Add to reviews collection (if desired)
    await setDoc(
      doc(db, "customers", customerId, "internal_reviews", jobId),
      {
        jobId,
        reviewStatus: "under_review",
        createdAt: serverTimestamp(),
      },
      { merge: true }
    );

    alert(`📝 Job ${jobId} marked under review for customer ${customerId}`);
  } catch (err) {
    console.error("❌ Error marking review:", err);
    alert("❌ Failed to mark under review: " + err.message);
  }
};

const handleFlagEscalation = (escalationCustomerId, escalationJobId, escalationProviderId) => {
  flagJob(escalationCustomerId, escalationJobId, escalationProviderId);
};

const autoBlockViolators = async (task) => {
  try {
    const { customerId, providerId, rating, status, flagged, jobId } = task;

    if (!customerId || !providerId || !jobId) {
      alert("Missing customer, provider, or job ID.");
      return;
    }

    // ✅ Check for violation reason
    let blockReason = null;
    if (rating < 3) blockReason = "Low rating";
    else if (status === "Complaint Raised") blockReason = "Complaint raised";
    else if (status === "Missed") blockReason = "Missed job";
    else if (flagged === true) blockReason = "Flagged by system";

    if (!blockReason) {
      alert("No valid reason found for blocking.");
      return;
    }

    // ✅ Block provider under customer
    await setDoc(
      doc(db, "customers", customerId, "blocked_providers", providerId),
      {
        providerId,
        jobId,
        reason: blockReason,
        status: "blocked",
        blockedAt: serverTimestamp(),
      },
      { merge: true }
    );

    // ✅ Optional: Update customer doc
    await setDoc(
      doc(db, "customers", customerId),
      {
        hasBlockedProviders: true,
        lastBlockedAt: serverTimestamp(),
      },
      { merge: true }
    );

    console.log(`🚫 Blocked provider ${providerId} for customer ${customerId} — Reason: ${blockReason}`);
    alert(`🚫 Auto-blocked provider ${providerId} — Reason: ${blockReason}`);

  } catch (err) {
    console.error("❌ Error during auto-blocking:", err);
    alert("❌ Failed to auto-block: " + err.message);
  }
};

const handleRefundAction = async (customerId, jobId, status) => {
  try {
    if (!customerId || !jobId) {
      toast.error("Missing customerId or jobId");
      return;
    }

    // 1. Refund document
    const refundDocRef = doc(db, "customers", customerId, "refunds", jobId);
    await setDoc(refundDocRef, { status }, { merge: true });

    // 2. Update job's refundStatus field
    const jobDocRef = doc(db, "customers", customerId, "jobs", jobId);
    await updateDoc(jobDocRef, { refundStatus: status });

    toast.success(`Refund ${status.toUpperCase()} updated in both records`);
  } catch (err) {
    console.error("Error updating refund status in Firestore:", err);
    toast.error("Error updating refund status");
  }
};
const handleUnblock = async (customerId, providerId) => {
  await deleteDoc(doc(db, "customers", customerId, "blocked_providers", providerId));
  setEditableCustomerBlocks((prev) =>
    prev.filter((b) => b.customerId !== customerId || b.id !== providerId)
  );
};


const [blockedProviders, setBlockedProviders] = useState([]);
useEffect(() => {
  const fetchBlockedProviders = async () => {
    try {
      const customersSnapshot = await getDocs(collection(db, "customers"));
      const allBlocked = [];

      for (const customerDoc of customersSnapshot.docs) {
        const blockedRef = collection(db, "customers", customerDoc.id, "blocked_providers");
        const blockedSnap = await getDocs(blockedRef);

        blockedSnap.forEach((doc) => {
          allBlocked.push({
            ...doc.data(),
            providerId: doc.id,
            customerId: customerDoc.id,
            customerName: customerDoc.data().name || "N/A",
          });
        });
      }

      setBlockedProviders(allBlocked);
    } catch (err) {
      console.error("Failed to fetch blocked providers:", err);
    }
  };

  fetchBlockedProviders();
}, []);


// ⛔ Use this if you need job info for matching customer name
const referenceJobs = jobData; // from UI

useEffect(() => {
  const unsubscribe = onSnapshot(
    collectionGroup(db, "blocked_providers"),
    (snapshot) => {
      const blocked = snapshot.docs.map((doc) => {
        const path = doc.ref.path.split("/");
        const customerId = path[1];
        const providerId = path[3];

        const job = escalatedJobs.find(
          (j) => j.customerId === customerId && j.providerId === providerId
        );

        return {
          id: providerId,
          type: "customer",
          customerId,
          customerName: job?.customerName || "—",
          reason: doc.data().reason || "—",
          blockedAt: doc.data().blockedAt || null,
        };
      });

      setBlockedFromCustomers(blocked);
    }
  );

  return () => unsubscribe();
}, []);


const customerId = auth.currentUser.uid;

const [availableTags] = useState(["High-value", "Inactive > 60 days", "Property manager"]);
const [tagFilter, setTagFilter] = useState("");
const [selectedTags, setSelectedTags] = useState({});
const [tagSelections, setTagSelections] = useState({}); // per-customer dropdown state
const [selectedCampaignTag, setSelectedCampaignTag] = useState("");
const [campaignMessage, setCampaignMessage] = useState("");


const removeTagFromUI = (customerId, tagToRemove) => {
  setLocalCustomers((prevCustomers) =>
    prevCustomers.map((customer) => {
      if (customer.id === customerId) {
        const updatedTags = (customer.tags || []).filter((t) => t !== tagToRemove);
        return { ...customer, tags: updatedTags };
      }
      return customer;
    })
  );

  toast.success("✅ Tag removed from UI");
};


const handleSendCampaign = async () => {
  if (!selectedCampaignTag) {
    toast.error("❌ Please select a tag.");
    return;
  }

  if (!campaignMessage.trim()) {
    toast.error("❌ Please enter a campaign message.");
    return;
  }

  try {
    const tag = selectedCampaignTag.trim();
    const message = campaignMessage.trim();

    const targetCustomers = localCustomers.filter((customer) =>
      (customer.tags || []).includes(tag)
    );

    if (targetCustomers.length === 0) {
      toast.warning("⚠️ No customers found with the selected tag.");
      return;
    }

    for (const customer of targetCustomers) {
      const customerId = customer?.id || customer?.docId;
      if (!customerId) {
        console.warn("⚠️ Skipping customer without valid ID");
        continue;
      }

      const campaignRef = collection(db, "customers", customerId, "campaigns");

      const campaignPayload = {
        tag,
        message,
        fullName: customer.fullName?.trim() || "",
        email: customer.email?.trim() || "",
        mobile: customer.mobile?.trim() || "",
        sentAt: serverTimestamp(),
      };

      await addDoc(campaignRef, campaignPayload);
    }

    toast.success(`✅ Campaign sent to ${targetCustomers.length} customer(s).`);
    setCampaignMessage("");
    setSelectedCampaignTag("");
  } catch (error) {
    console.error("❌ Error sending campaign:", error);
    toast.error("❌ Failed to send campaign.");
  }
};


const addTagAndSaveCustomerInfo = async (customer, tag) => {
  try {
    const customerId = customer?.id || customer?.docId;
    const fullName = customer?.fullName?.trim();
    const trimmedTag = tag?.trim();

    if (!customerId || !fullName || !trimmedTag) {
      toast.error("❌ Missing customer ID, name, or tag.");
      return;
    }

    const customerDocRef = doc(db, "customers", customerId);
    const tagsCollectionRef = collection(customerDocRef, "tags");

    // Prevent duplicate tag
    const existingTagQuery = query(tagsCollectionRef, where("tag", "==", trimmedTag));
    const snapshot = await getDocs(existingTagQuery);
    if (!snapshot.empty) {
      toast.warning("⚠️ Tag already exists for this customer.");
      return;
    }

    const tagData = {
      tag: trimmedTag,
      fullName,
      email: customer.email?.trim() || "",
      mobile: customer.mobile?.trim() || "",
      walletBalance: typeof customer.walletBalance === "number" ? customer.walletBalance : 0,
      referredBy: customer.referredBy?.trim() || "",
      status: customer.status || "Active",
      addedAt: serverTimestamp(),
    };

    await addDoc(tagsCollectionRef, tagData);
    toast.success("✅ Tag saved successfully!");

    // Update UI
    setLocalCustomers((prev) =>
      prev.map((c) =>
        c.id === customerId || c.docId === customerId
          ? {
              ...c,
              tags: c.tags && !c.tags.includes(trimmedTag)
                ? [...c.tags, trimmedTag]
                : c.tags || [trimmedTag],
            }
          : c
      )
    );

    // Reset selected tag input
    setSelectedTags((prev) => ({
      ...prev,
      [customerId]: "",
    }));
  } catch (error) {
    console.error("❌ Error saving tag:", error);
    toast.error("❌ Failed to save tag.");
  }
};

  const serviceImageMap = {
  "AC Repair": "https://cdn-icons-png.flaticon.com/512/2933/2933206.png",
  "Plumbing": "https://cdn-icons-png.flaticon.com/512/2965/2965567.png",
  "Electrical": "https://cdn-icons-png.flaticon.com/512/2950/2950712.png",
  "Carpentry": "https://cdn-icons-png.flaticon.com/512/865/865393.png",
  "Painting": "https://cdn-icons-png.flaticon.com/512/810/810535.png",
  "Pest Control": "https://cdn-icons-png.flaticon.com/512/3016/3016781.png",
  "Home Cleaning": "https://cdn-icons-png.flaticon.com/512/3772/3772921.png",
  "Appliance Repair": "https://cdn-icons-png.flaticon.com/512/1046/1046784.png",
  "Mobile/Laptop Repair": "https://cdn-icons-png.flaticon.com/512/1814/1814343.png",
  "CCTV Installation": "https://cdn-icons-png.flaticon.com/512/1086/1086933.png",
  "Salon at Home": "https://cdn-icons-png.flaticon.com/512/2903/2903558.png",
  "Driver Service": "https://cdn-icons-png.flaticon.com/512/3068/3068183.png",
};

const [taskList, setTaskList] = useState([]);
const [rating, setRating] = useState(0);
const [feedback, setFeedback] = useState("");

// Called when service type is selected
const handleServiceTypeChange = (value) => {
  setServiceType(value);
  const shortCode = value.replace(/\s+/g, '').slice(0, 3).toUpperCase();
  const timeCode = Date.now().toString().slice(-6);
  const randomCode = Math.floor(100 + Math.random() * 900);

  setGeneratedBookingId(`BK-${shortCode}-${timeCode}-${randomCode}`);
  setGeneratedCustomerUID(`CUST-${shortCode}-${randomCode}`);

  const serviceTasks = {
    'AC Repair': [
      'Check gas level',
      'Clean filters',
      'Test cooling',
      'Inspect compressor',
      'Tighten connections'
    ],
    'Plumbing': [
      'Inspect leak',
      'Replace washer',
      'Test water flow',
      'Seal joints',
      'Check water pressure'
    ],
    'Electrical': [
      'Check voltage',
      'Test connections',
      'Replace fuse',
      'Inspect wiring',
      'Ensure grounding'
    ],
    'Carpentry': [
      'Measure wood pieces',
      'Cut to size',
      'Assemble structure',
      'Polish surfaces',
      'Clean work area'
    ],
    'Painting': [
      'Cover floors/furniture',
      'Apply primer',
      'Paint first coat',
      'Paint second coat',
      'Touch up edges'
    ],
    'Pest Control': [
      'Inspect affected area',
      'Spray chemicals',
      'Seal entry points',
      'Install traps if needed',
      'Provide safety instructions'
    ],
    'Home Cleaning': [
      'Dust furniture',
      'Vacuum carpets',
      'Mop floors',
      'Clean kitchen & bathroom',
      'Dispose of trash'
    ],
    'Appliance Repair': [
      'Diagnose issue',
      'Replace faulty parts',
      'Test functionality',
      'Clean appliance',
      'Provide usage tips'
    ],
    'Mobile/Laptop Repair': [
      'Run diagnostic tests',
      'Replace damaged parts',
      'Install updates',
      'Check battery health',
      'Test device performance'
    ],
    'CCTV Installation': [
      'Survey installation area',
      'Drill and mount cameras',
      'Connect wiring',
      'Configure recording settings',
      'Test camera angles'
    ],
    'Salon at Home': [
      'Sanitize tools',
      'Consult customer needs',
      'Perform service (cut/facial etc.)',
      'Clean up area',
      'Suggest aftercare'
    ],
    'Driver Service': [
      'Confirm destination',
      'Inspect vehicle before use',
      'Follow route instructions',
      'Drive safely',
      'Report any issues'
    ]
  };

  const selectedTasks = serviceTasks[value] || [];
  const formattedTasks = selectedTasks.map((task) => ({ task, completed: false }));
  setTaskList(formattedTasks);
};

const addNoteToCustomer = async (customer, noteText) => {
  try {
    const fullName = customer?.fullName?.trim() || customer?.Fullname?.trim() || "";
    const note = noteText?.trim();

    if (!fullName || !note) {
      toast.error("❌ Customer name and note text are required.");
      return;
    }

    const customerRef = doc(db, "customers", customer.id);
    const notesRef = collection(customerRef, "notes");

    const noteData = {
      fullName,
      note,
      addedAt: serverTimestamp(),
    };

    await addDoc(notesRef, noteData);

    toast.success("✅ Note saved successfully!");

    // Optional local state update
    setLocalCustomers((prev) =>
      prev.map((c) =>
        c.id === customer.id
          ? { ...c, notes: [...(c.notes || []), note] }
          : c
      )
    );

    // Clear input field
    setNoteInputs((prev) => ({
      ...prev,
      [customer.id]: "",
    }));
  } catch (error) {
    console.error("❌ Error saving note:", error);
    toast.error("Failed to save note.");
  }
};

// Called when a checklist item is toggled
const handleTaskToggle = (index) => {
  const updated = [...taskList];
  updated[index].completed = !updated[index].completed;
  setTaskList(updated);
};

// Called when job is marked as completed
const markJobCompleted = async () => {
  try {
    // Validate required fields
    if (!jobId) {
      alert("❌ Job ID is missing.");
      return;
    }

    if (!providerId) {
      alert("❌ Provider ID is missing.");
      return;
    }

    if (!customerEmail) {
      alert("❌ Customer email is missing.");
      return;
    }

    // Get completed tasks
    const completedTasks = taskList
      .filter((t) => t.completed)
      .map((t) => t.task);

    // Prepare job report
    const jobData = {
      jobId,
      providerId,
      customerEmail,
      serviceType: serviceType || "",
      completedTasks,
      notes: notes || "",
      photos: {
        before: beforeImageUrl || "",
        after: afterImageUrl || ""
      },
      rating: rating || null,
      feedback: feedback || "",
      timestamp: new Date().toISOString()
    };

    console.log("📦 Saving job report:", jobData);

    // Save to Firestore
    const result = await saveJobReportToDatabase(jobData);

    console.log("🔥 Firestore save result:", result);

    // Only show success if save succeeded
    if (result?.success !== false) {
      alert("✅ Job completed and saved successfully!");
      return;
    }

    // If function explicitly returns success:false
    throw new Error(
      result?.message || "Unable to save the job report."
    );

  } catch (error) {
    console.error("❌ Failed to save the report:", error);

    alert(
      `❌ Failed to save the report.\n\n${
        error?.message || "Unknown error occurred."
      }`
    );
  }
};

const [beforeImagePreview, setBeforeImagePreview] = useState(null);
const [afterImagePreview, setAfterImagePreview] = useState(null);

const handleImageUpload = async (e, type) => {
  const file = e.target.files[0];
  if (!file) return;

  try {
    const uniqueName = `${type}-${Date.now()}-${file.name}`;
    const imageRef = ref(storage, `jobImages/${uniqueName}`);

    // Upload file
    await uploadBytes(imageRef, file);

    // Get download URL
    const url = await getDownloadURL(imageRef);

    // Set preview and store URL
    if (type === "before") {
      setBeforeImagePreview(url); // Not blob, actual link
    } else {
      setAfterImagePreview(url);
    }
  } catch (error) {
    console.error("❌ Error uploading image:", error);
    alert("Failed to upload image.");
  }
};
const generateReport = async () => {
  try {
    // Format checklist (selected true values)
    const checklistText = Object.entries(checklist)
      .filter(([_, value]) => value)
      .map(([key]) => `✔ ${key}`)
      .join("\n");

    // Format task list (from serviceType)
    const formattedTasks = taskList
      .map((item, index) => `${index + 1}. ${item.task} - ${item.completed ? "✅ Done" : "❌ Pending"}`)
      .join("\n");

    // EmailJS template parameters
    const templateParams = {
      to_email: customerEmail,
      checklist: checklistText || 'No checklist items selected',
      tasks: formattedTasks || 'No tasks available for this service type',
      notes: notes || 'No notes provided',
      service_type: serviceType || 'Not selected'
    };

    await emailjs.send(
      'service_gerl87b',       // ✅ Your EmailJS Service ID
      'template_m1chido',      // ✅ Your EmailJS Template ID
      templateParams,
      'OA26VH-_s7R4ls_Ke'      // ✅ Your Public Key
    );

    alert('✅ Report sent successfully!');
  } catch (error) {
    console.error('❌ Error sending report:', error);
    alert('❌ Failed to send report. Check console for more info.');
  }
};
const [checklist, setChecklist] = useState({
  "AC Repair": false,
  "Plumbing": false,
  "Electrical": false,
  "Carpentry": false,
  "Painting": false,
  "Pest Control": false,
  "Home Cleaning": false,
  "Appliance Repair": false,
  "Mobile/Laptop Repair": false,
  "CCTV Installation": false,
  "Salon at Home": false,
  "Driver Service": false,
});

  const [beforeImage, setBeforeImage] = useState(null);
  const [afterImage, setAfterImage] = useState(null);
  const [notes, setNotes] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');

  const handleChecklistChange = (e) => {
    const { name, checked } = e.target;
    setChecklist((prev) => ({ ...prev, [name]: checked }));
  };

  const BannerImage = ({ src }) => {
  const [imgSrc, setImgSrc] = React.useState(
    src?.includes("via.placeholder.com") || !src ? "/default-banner.png" : src
  );

  return (
    <img
      src={imgSrc}
      alt="Banner"
      onError={() => setImgSrc("/default-banner.png")}
      style={{ width: "80px", height: "auto", borderRadius: "6px" }}
    />
  );
};
const [showCRUDTable, setShowCRUDTable] = useState(false);
// Defining showEntries state variable
const [showEntries, setShowEntries] = useState(true); // Default state is true, showing the entries table
// Add the state at the top of your component
const [showZohoTicket1, setShowZohoTicket1] = useState(false); // ✅ New state for Ticket1
const [showZohoTicket4, setShowZohoTicket4] = useState(false);
// Section visibility states
const [showUserProfile, setShowUserProfile] = useState(false);
const [messageDeliveryStatus, setMessageDeliveryStatus] = useState(null);
const [showSendNotificationForm, setShowSendNotificationForm] = useState(false);
const showOnlySection = (section) => {
  // Reset all sections to false
  setShowCustomers(false);
  setShowAddCategoryForm(false);
  setShowListCategory(false);
  setShowPartnerList(false);
  setShowAddBannerForm(false);
  setShowBannerList(false);
  setShowCreditPackageForm(false);
  setShowCreditPackageList(false);
  setShowPartnerReport(false);
  setShowSetCommission(false);
  setShowPaymentGatewayList(false);
  setShowUserReport(false);
  setShowPendingOrders(false);
  setShowDecisionForm(false);
  setShowCompletedOrders(false);
  setShowCancelledOrders(false);
  setShowDiscountForm(false);
  setShowDiscountList(false);
  setShowFinancialSection(false);
  setShowUserProfile(false);
  setShowAddUser(false);
  setShowSendNotification(false);
  setShowSettings(false);
  setShowAllTickets(false); // <-- NEW
  setShowServiceHistory(false); // ✅ ADD THIS
  setShowProviderNotifier(false); // ✅ NEW
  setShowCustomerNotifier(false); // ✅ NEW
  setShowBookingServices(false); // ✅ NEW Booking Services section
  setShowProviderProfile(false);
  setShowAddProvider(false); // ✅ NEW
  setShowEscalationPanel(false); // ✅ NEW
  setShowCustomerPanel(false); // ✅ reset Customer Panel
  setShowAddCustomer(false); // ✅ NEW
  setShowProviderBonus(false); // ✅ NEW reset state
  setShowCustomerBonus(false); // ✅ NEW reset state
  setShowAutomatchProviders(false); // ✅ NEW for Auto-Assign Providers
  setShowAutomatchCustomers(false); // ✅ NEW for Auto-Assign Customers
  setShowChatActivation(false); // ✅ NEW for Chat Activation Section
  setShowFinancialOverview(false); // ✅ NEW — reset Financial Overview state
  setShowFinancialBookings(false); // 📘 Bookings
  setShowAutomatedProviderFlow(false); // ✅ NEW — reset this too
  setShowPaymentLogs(false); // ✅ NEW — reset Payment Logs
  setShowNotificationLogs(false); // ✅ reset Notification Logs
  setShowProviderLogs(false); // ✅ NEW — reset Provider Logs
  setShowProviderBookingList(false); // ✅ NEW — reset Provider Booking List
  setShowProvidersList(false); // ✅ NEW — reset Providers List
  setShowCustomerBookingList(false); // ✅ NEW — reset Customer Booking List
  setShowCustomerList(false);
  setShowVerificationDocuments(false); // ✅ NEW — reset Verification Documents
  setShowProviderNotifications(false); // ✅ NEW — reset Provider Notifications
  setShowProviderOnboarding(false); // ✅ NEW
  setShowTicketDashboard(false); // <-- NEW Ticket Dashboard
// ✅ NEW — Manage Bookings
  setShowManageBookings(false);
 // Highlight the button only if it's Notification Logs
  if (section === "notificationLogs") {
    setActiveNotificationTab("notificationLogs");
  } else {
    setActiveNotificationTab(""); // reset highlight for other sections
  }
  // Enable the selected section only
  const sectionMap = {
    pendingOrders: () => setShowPendingOrders(true),
    completedOrders: () => setShowCompletedOrders(true),
    cancelledOrders: () => setShowCancelledOrders(true),
    addCreditPackage: () => setShowCreditPackageForm(true),
    listCreditPackage: () => setShowCreditPackageList(true),
    customers: () => setShowCustomers(true),
    addCategory: () => setShowAddCategoryForm(true),
    listCategory: () => setShowListCategory(true),
    partnerList: () => setShowPartnerList(true),
    addBanner: () => setShowAddBannerForm(true),
    listBanner: () => setShowBannerList(true),
    partnerReport: () => setShowPartnerReport(true),
    setCommission: () => setShowSetCommission(true),
    listPaymentGateway: () => setShowPaymentGatewayList(true),
    userReport: () => setShowUserReport(true),
    manageDecisionForm: () => setShowDecisionForm(true),
    addDiscountCoupon: () => setShowDiscountForm(true),
    listDiscountCoupons: () => setShowDiscountList(true),
    financialSection: () => setShowFinancialSection(true),
    userProfile: () => setShowUserProfile(true),
    addUser: () => setShowAddUser(true),
    sendNotification: () => setShowSendNotification(true),
    settings: () => setShowSettings(true),
    allTickets: () => setShowAllTickets(true), // <-- NEW
    serviceHistory: () => setShowServiceHistory(true), // ✅ ADD THIS
    providerNotifier: () => setShowProviderNotifier(true), // ✅ NEW
    customerNotifier: () => setShowCustomerNotifier(true), // ✅ NEW  
    bookingServices: () => setShowBookingServices(true), // ✅ NEW
    providerProfile: () => setShowProviderProfile(true), // ✅ FIXED
    addProvider: () => setShowAddProvider(true), // ✅ NEW
    escalationPanel: () => setShowEscalationPanel(true), // ✅ NEW
    customerPanel: () => setShowCustomerPanel(true), // ✅ NEW
    addCustomer: () => setShowAddCustomer(true), // ✅ NEW
    providerBonus: () => setShowProviderBonus(true), // ✅ NEW
    customerBonus: () => setShowCustomerBonus(true), // ✅ NEW
    automatchProviders: () => setShowAutomatchProviders(true), // ✅ NEW
    automatchCustomers: () => setShowAutomatchCustomers(true), // ✅ NEW
    chatActivation: () => setShowChatActivation(true), // ✅ NEW entry
    financialOverview: () => setShowFinancialOverview(true), // ✅ NEW ENTRY
    financialBookings: () => setShowFinancialBookings(true),
    automatedProviderFlow: () => setShowAutomatedProviderFlow(true), // ✅ NEW ENTRY
    paymentLogs: () => setShowPaymentLogs(true), // ✅ NEW
    notificationLogs: () => setShowNotificationLogs(true), // ✅ NEW
     // ✅ NEW ENTRY
  providerLogs: () => setShowProviderLogs(true),
  providerBookingList: () => setShowProviderBookingList(true), // ✅ NEW
  providersList: () => setShowProvidersList(true), // ✅ NEW
  customerBookingList: () => setShowCustomerBookingList(true), // ✅ NEW
  customerList: () => setShowCustomerList(true),
  verificationDocuments: () => setShowVerificationDocuments(true), // ✅ NEW
  providerNotifications: () => setShowProviderNotifications(true), // ✅ NEW
  providerOnboarding: () => setShowProviderOnboarding(true), // ✅ NEW
  ticketDashboard: () => setShowTicketDashboard(true), // <-- NEW entry
  // ✅ NEW ENTRY
    manageBookings: () => setShowManageBookings(true),
  };
  if (sectionMap[section]) {
    sectionMap[section]();
  }
};
// Toggle functions
const togglePendingOrders = () => showOnlySection("pendingOrders");
const toggleCompletedOrders = () => showOnlySection("completedOrders");
const toggleCancelledOrders = () => showOnlySection("cancelledOrders");
const toggleCreditPackageForm = () => showOnlySection("addCreditPackage");
const toggleListCreditPackage = () => showOnlySection("listCreditPackage");
const toggleSetCommission = () => showOnlySection("setCommission");
const togglePaymentGatewayList = () => showOnlySection("listPaymentGateway");
const toggleUserReport = () => showOnlySection("userReport");
const toggleManageDecisionForm = () => showOnlySection("manageDecisionForm");
const toggleDiscountForm = () => showOnlySection("addDiscountCoupon");
const toggleDiscountList = () => showOnlySection("listDiscountCoupons");
const toggleFinancialSection = () => showOnlySection("financialSection");
const toggleUserProfile = () => showOnlySection("userProfile");
const toggleAddUser = () => showOnlySection("addUser");
const toggleSendNotification = () => showOnlySection("sendNotification");
const toggleSettings = () => showOnlySection("settings");
const toggleAllTickets = () => showOnlySection("allTickets"); // <-- NEW
const toggleServiceHistory = () => showOnlySection("serviceHistory");
const toggleProviderNotifier = () => showOnlySection("providerNotifier"); // ✅ NEW
const toggleCustomerNotifier = () => showOnlySection("customerNotifier"); // ✅ NEW
const toggleBookingServices = () => showOnlySection("bookingServices"); // ✅ NEW
const toggleProviderProfile = () => showOnlySection("providerProfile");
const toggleAddProvider = () => showOnlySection("addProvider"); // ✅ NEW
const toggleEscalationPanel = () => showOnlySection("escalationPanel"); // ✅ NEW
const toggleCustomerPanel = () => showOnlySection("customerPanel"); // ✅ NEW
const toggleAddCustomer = () => showOnlySection("addCustomer"); // ✅ NEW
const toggleProviderBonus = () => showOnlySection("providerBonus"); // ✅ NEW
const toggleCustomerBonus = () => showOnlySection("customerBonus"); // ✅ NEW
const toggleCustomers = () => showOnlySection("customers");
const toggleAutomatchProviders = () => showOnlySection("automatchProviders"); // ✅ NEW
const toggleAutomatchCustomers = () => showOnlySection("automatchCustomers"); // ✅ NEW
const toggleChatActivation = () => showOnlySection("chatActivation");
// ✅ Add a new toggle function for Financial Overview
const toggleFinancialOverview = () => showOnlySection("financialOverview");
const toggleFinancialBookings = () => showOnlySection("financialBookings");
const toggleAutomatedProviderFlow = () => showOnlySection("automatedProviderFlow"); // ✅ NEW
const togglePaymentLogs = () => showOnlySection("paymentLogs"); // ✅ NEW
const toggleNotificationLogs = () => showOnlySection("notificationLogs");
const toggleProviderLogs = () => showOnlySection("providerLogs");
const toggleVerificationDocuments = () =>
  showOnlySection("verificationDocuments");
const toggleProviderBookingList = () =>
  showOnlySection("providerBookingList"); // ✅ NEW
const toggleProvidersList = () => showOnlySection("providersList"); // ✅ NEW
const toggleCustomerBookingList = () =>
  showOnlySection("customerBookingList"); // ✅ NEW
// Customer List
const toggleCustomerList = () =>
  showOnlySection("customerList");
const toggleManageBookings = () =>
  showOnlySection("manageBookings");
const toggleProviderNotifications = () =>
  showOnlySection("providerNotifications");
const toggleProviderOnboarding = () =>
  showOnlySection("providerOnboarding");
const toggleTicketDashboard = () => showOnlySection("ticketDashboard");

const [showAddUser, setShowAddUser] = useState(false);
const [showSettings, setShowSettings] = useState(false); // <-- NEW
const [showNotificationProviders, setShowNotificationProviders] = useState(false); // ✅ NEW
const handleDelete = (id) => {
  if (window.confirm("Are you sure you want to delete this customer?")) {
    const updatedCustomers = localCustomers.filter(customer => customer.id !== id);
    setLocalCustomers(updatedCustomers); // Update the local customers state
    toast.success("Customer deleted successfully!");
  }
};
//  Show Address Alert
const handleLocationClick = (customer) => {
  alert(`Address for ${customer.Fullname}: ${customer.address || "No address available"}`);
};
// Manage Report - Log Report Details (Replace with modal if needed)
const handleAnalyticsClick = (customer) => {
  console.log(`Managing report for: ${customer.Fullname}`);
  alert(`Managing report for: ${customer.Fullname}`);
};
const toggleSidebar = () => {
  setSidebarOpen(prevState => !prevState);
};
// Toggle the visibility of the payment gateway list
const handleToggleList = () => {
  setShowList(!showList);
};
const [partners, setPartners] = useState([   
    {

      name: "Users",
      email: "us@test.com",
      mobile: "1234567890",
      user_type: "provider", // standardized key to 'user_type'
      username: "user_01", // standardized key to 'username'
      user_storage_img: "F1.png", // standardized key to 'user_storage_img'
      status: "Deactivated",
      approval_status: "Approved", // standardized key to 'approval_status'
      created_at: "December 18, 2024, 03:46:28 PM UTC+5:30" // standardized key to 'created_at'

    },
    {

      name: "Rushita",
      email: "abc@gmail.com",
      mobile: "9876543211",
      user_type: "provider", // standardized key to 'user_type'
      username: "rushi@123", // standardized key to 'username'
      user_storage_img: "  ", // standardized key to 'user_storage_img'
      status: "Deactivated",
      approval_status: "Approved", // standardized key to 'approval_status'
      created_at: "January 21, 2025, 05:56:19PM UTC+5:30" // standardized key to 'created_at'

    },
    
])
return (
  <div style={{ display: "flex", height: "100vh", overflow: "hidden" }}>
{/* ================= SIDEBAR STYLES ================= */}
<style>{`
  .custom-sidebar-scroll::-webkit-scrollbar {
    width: 5px;
  }
  .custom-sidebar-scroll::-webkit-scrollbar-track {
    background: transparent;
  }
  .custom-sidebar-scroll::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.12);
    border-radius: 10px;
  }
  .custom-sidebar-scroll::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.25);
  }
  .sidebar-menu-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 11px 14px;
    cursor: pointer;
    border-radius: 12px;
    margin-bottom: 6px;
    transition: all 0.2s ease;
    color: #94a3b8;
    background: transparent;
    font-size: 13.5px;
    box-sizing: border-box;
  }
  .sidebar-menu-item:hover:not(.active) {
    background: rgba(255, 255, 255, 0.05);
    color: #ffffff;
  }
  .sidebar-menu-item.active {
    background: linear-gradient(90deg, #1d68f2 0%, #3b82f6 100%);
    color: #ffffff;
    box-shadow: 0 4px 14px rgba(29, 104, 242, 0.4);
  }
  .sidebar-menu-item .menu-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    flex-shrink: 0;
  }
  .sidebar-menu-item .menu-label {
    font-weight: 500;
    font-size: 13.5px;
  }
  .sidebar-menu-item .menu-arrow {
    font-size: 14px;
    opacity: 0.6;
    margin-left: 8px;
  }
  .sidebar-section-title {
    padding: 18px 14px 8px;
    font-size: 10.5px;
    color: #64748b;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    list-style: none;
  }
`}</style>

{/* ================= SIDEBAR ================= */}
<aside
  style={{
    width: "275px",
    minWidth: "275px",
    maxWidth: "275px",
    height: "100vh",
    background: "linear-gradient(180deg, #030a1a 0%, #081735 100%)",
    color: "#ffffff",
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    borderRight: "1px solid rgba(255, 255, 255, 0.08)",
    boxShadow: "4px 0 24px rgba(0, 0, 0, 0.35)",
    flexShrink: 0,
    zIndex: 50,
  }}
>

  {/* ================= LOGO HEADER ================= */}
  <div
    style={{
      padding: "24px 20px 20px",
      display: "flex",
      alignItems: "center",
      gap: "12px",
      borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
      flexShrink: 0,
    }}
  >
    <img
      src={ugLogo}
      alt="UnlimitedGig Logo"
      style={{
        width: "42px",
        height: "42px",
        objectFit: "contain",
        display: "block",
        flexShrink: 0,
      }}
    />

    <div style={{ display: "flex", alignItems: "baseline", gap: "2px" }}>
      <span
        style={{
          fontSize: "20px",
          fontWeight: 800,
          color: "#ffffff",
          letterSpacing: "-0.5px",
        }}
      >
        Unlimited
      </span>

      <span
        style={{
          fontSize: "20px",
          fontWeight: 800,
          color: "#38bdf8",
          letterSpacing: "-0.5px",
        }}
      >
        Gig
      </span>
    </div>
  </div>

  {/* ================= NAVIGATION ================= */}
  <div
    className="custom-sidebar-scroll"
    style={{
      flex: 1,
      minHeight: 0,
      overflowY: "auto",
      overflowX: "hidden",
      padding: "16px 14px",
    }}
  >
    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>

      {/*
        Reusable navigation item.
        All existing navigation states are preserved.
      */}

      {(() => {
        const navigateTo = (view, useSection = false) => {
          if (typeof setCurrentView === "function") {
            setCurrentView(view);
          }

          if (typeof setActiveButton === "function") {
            setActiveButton(view);
          }

          if (useSection && typeof showOnlySection === "function") {
            showOnlySection(view);
          }
        };

        const toggleView = (view, useSection = false) => {
          const isSelected =
            currentView === view || activeButton === view;

          if (isSelected) {
            if (typeof setCurrentView === "function") {
              setCurrentView("");
            }

            if (typeof setActiveButton === "function") {
              setActiveButton("");
            }
          } else {
            navigateTo(view, useSection);
          }
        };

        const isActive = (view) =>
          currentView === view || activeButton === view;

        const menuItem = (label, icon, view, options = {}) => (
          <li
            key={view}
            className={`sidebar-menu-item ${
              isActive(view) ? "active" : ""
            }`}
            onClick={() =>
              options.toggle === false
                ? navigateTo(view, options.section)
                : toggleView(view, options.section)
            }
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                minWidth: 0,
              }}
            >
              <span className="menu-icon">{icon}</span>

              <span className="menu-label">
                {label}
              </span>
            </div>

            <span className="menu-arrow">›</span>
          </li>
        );

        const sectionTitle = (title) => (
          <li className="sidebar-section-title" key={title}>
            {title}
          </li>
        );

        const providerProfileItem = () => {
          const selected = isActive("providerProfile");

          return (
            <li
              key="providerProfile"
              className={`sidebar-menu-item ${
                selected ? "active" : ""
              }`}
              onClick={() => {
                if (selected) {
                  if (typeof setCurrentView === "function") {
                    setCurrentView("");
                  }

                  if (typeof setActiveButton === "function") {
                    setActiveButton("");
                  }

                  return;
                }

                const entered = window.prompt(
                  "Enter Admin Password to Access Provider Profile:"
                );

                if (entered === null) return;

                try {
                  const ENCRYPTED_KEY = "ODk3Mg==";
                  const encryptedInput = btoa(entered.trim());

                  if (encryptedInput === ENCRYPTED_KEY) {
                    navigateTo("providerProfile", true);
                  } else {
                    window.alert(
                      "Access Denied: Incorrect Password."
                    );
                  }
                } catch (error) {
                  console.error(
                    "Provider Profile authentication error:",
                    error
                  );

                  window.alert(
                    "Access Denied: Incorrect Password."
                  );
                }
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <span className="menu-icon">👤</span>

                <span className="menu-label">
                  Provider Profile
                </span>
              </div>

              <span className="menu-arrow">›</span>
            </li>
          );
        };

        return (
          <>
            {/* MAIN DASHBOARD */}
            {menuItem(
              "Dashboard",
              <FaHome />,
              "dashboard"
            )}

            {menuItem(
              "Provider Verification Pipeline",
              <FaUserShield />,
              "providerVerificationPipeline"
            )}

            {menuItem(
              "New Provider Service Pipeline",
              <FaProjectDiagram />,
              "servicePipeline"
            )}

            {menuItem(
              "Transactions",
              <FaMoneyCheckAlt />,
              "transactions",
              { toggle: false }
            )}

            {/* CUSTOMERS SECTION */}
            {sectionTitle("Customers Section")}

            {menuItem(
              "Customer List",
              "👥",
              "customerList",
              { section: true }
            )}

            {menuItem(
              "Booking Invoices",
              "📘",
              "financialBookings",
              { section: true }
            )}

            {menuItem(
              "Manage Bookings",
              "📅",
              "manageBookings",
              { section: true }
            )}

            {/* PROVIDERS SECTION */}
            {sectionTitle("Providers Section")}

            {menuItem(
              "Providers List",
              "🧑‍🔧",
              "providersList",
              { section: true }
            )}

            {/* VERIFICATION SECTION */}
            {sectionTitle("Verification Section")}

            {menuItem(
              "Verification Docs",
              "📄",
              "verificationDocuments",
              { section: true }
            )}

            {/* SERVICE MANAGEMENT */}
            {sectionTitle("Service Management")}

            {providerProfileItem()}

            {menuItem(
              "Invite Users",
              <FaUserPlus />,
              "inviteUsers",
              { toggle: false }
            )}

            {menuItem(
              "Marketing Ledger",
              <FaChartLine />,
              "marketingLedger",
              { toggle: false }
            )}

            {/* TICKETS SECTION */}
            {sectionTitle("Tickets Section")}

            {menuItem(
              "Waiting List",
              <FaChartBar />,
              "ticketDashboard",
              { section: true }
            )}
          </>
        );
      })()}

    </ul>
  </div>

  {/* ================= ADMIN PROFILE FOOTER ================= */}
  <div
    style={{
      padding: "16px 18px",
      borderTop: "1px solid rgba(255, 255, 255, 0.08)",
      background: "rgba(3, 11, 26, 0.4)",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexShrink: 0,
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
      }}
    >
      <div
        style={{
          width: "38px",
          height: "38px",
          borderRadius: "10px",
          background:
            "linear-gradient(135deg, #1d68f2 0%, #3b82f6 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#ffffff",
          fontWeight: 700,
          fontSize: "13px",
          boxShadow: "0 2px 8px rgba(29, 104, 242, 0.4)",
        }}
      >
        AD
      </div>

      <div>
        <div
          style={{
            fontSize: "13.5px",
            fontWeight: "600",
            color: "#ffffff",
          }}
        >
          Admin
        </div>

        <div
          style={{
            fontSize: "11px",
            color: "#64748b",
          }}
        >
          Super Admin
        </div>
      </div>
    </div>

    <span
      title="Logout"
      style={{
        cursor: "pointer",
        color: "#94a3b8",
        fontSize: "18px",
        transition: "all 0.2s ease",
        padding: "4px 8px",
        borderRadius: "8px",
      }}
      onClick={() => {
        // Connect your existing logout function here.
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = "#ffffff";
        e.currentTarget.style.background =
          "rgba(255, 255, 255, 0.08)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = "#94a3b8";
        e.currentTarget.style.background = "transparent";
      }}
    >
      ⮲
    </span>
  </div>
</aside>


<div
  style={{
    display: "flex",
    width: "100%",
    maxWidth: "100%",
    gap: "20px",
    padding: "20px",
    boxSizing: "border-box",
    overflowX: "hidden", // ADD THIS
    minWidth: 0, // ADD THIS
  }}
>
  {/* 🔹 RIGHT CONTENT AREA */}
  <div
    style={{
      flex: "1 1 0%",
      minWidth: 0, // MOST IMPORTANT FIX
      maxWidth: "100%",
      backgroundColor: "#f3f4f6",
      minHeight: "100vh",
      overflowY: "auto",
      overflowX: "hidden", // FIX - not auto
      borderRadius: "12px",
      padding: "20px",
      boxSizing: "border-box",
    }}
  >

{/* ========================================================= */}
{/* ✅ MAIN DASHBOARD WRAPPER */}
{/* ========================================================= */}
{currentView === "dashboard" && (
<div
  style={{
    width: "100%",
    maxWidth: "100%", // CHANGE FROM 100vw to 100%
    minWidth: 0,
    overflowX: "hidden",
    padding: "10px",
    boxSizing: "border-box",
  }}
>
  {/* ======================================================= */}
  {/* ✅ BOTH DASHBOARDS CONTAINER */}
  {/* ======================================================= */}
  <div
    style={{
      display: "flex",
      gap: "20px",
      width: "100%",
      alignItems: "stretch",
      justifyContent: "space-between",
      transition: "all 0.4s ease",
      overflow: "hidden",
      flexWrap:
        providerWidth >= 95 ||
        bookingWidth >= 95
          ? "nowrap"
          : "wrap",
    }}
  >
 {/* ===================================================== */}
{/* ✅ PROVIDER DASHBOARD WRAPPER */}
{/* ===================================================== */}
<div
  style={{
    flex: providerWidth >= 95 ? "1 1 100%" : "1 1 420px",
    width: providerWidth >= 95 ? "100%" : `${providerWidth}%`,
    minWidth: 0,
    maxWidth: "100%",
    transition: "all 0.4s ease",
    boxSizing: "border-box",
  }}
>
  {/* ===================================================== */}
  {/* ✅ MAIN WHITE CONTAINER */}
  {/* ===================================================== */}
  <div
    style={{
      width: "100%",
      padding: "24px",
      borderRadius: "32px",
      background: "#f8fafc",
      border: "1px solid #e5e7eb",
      boxShadow: "0 10px 40px rgba(15,23,42,0.06)",
      position: "relative",
      overflow: "hidden",
      boxSizing: "border-box",
    }}
  >
    {/* ===================================================== */}
    {/* ✅ HEADER */}
    {/* ===================================================== */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        flexWrap: "wrap",
        gap: "20px",
        padding: "28px",
        borderRadius: "28px",
        background: "#ffffff",
        border: "1px solid #e5e7eb",
        marginBottom: "28px",
      }}
    >
{/* ✅ TITLE + TICKET DASHBOARD BUTTON */}
{/* ===================================================== */}
<div
  style={{
    flex: "1 1 260px",
    minWidth: 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "16px",
  }}
>
  {/* LEFT SIDE */}
  <div>
    <h1
      style={{
        margin: 0,
        fontSize: "clamp(30px,4vw,42px)",
        fontWeight: 900,
        color: "#111827",
        lineHeight: 1.1,
      }}
    >
      PROVIDER WAITING TICKETS
    </h1>
    <p
      style={{
        marginTop: 10,
        color: "#6b7280",
        fontSize: "15px",
        fontWeight: 500,
      }}
    >
      Real-time onboarding intelligence
    </p>
  </div>
  {/* RIGHT SIDE BUTTON */}
  <button
    onClick={() => {
      if (activeButton === "ticketDashboard") {
        setActiveButton("");
        setCurrentView("");
      } else {
        setActiveButton("ticketDashboard");
        setCurrentView("ticketDashboard");

        if (typeof showOnlySection === "function") {
          showOnlySection("ticketDashboard");
        }
      }
    }}
    style={{
      background:
        activeButton === "ticketDashboard"
          ? "#2563eb"
          : "#111827",
      color: "#fff",
      border: "none",
      borderRadius: "12px",
      padding: "14px 24px",
      fontSize: "14px",
      fontWeight: 700,
      cursor: "pointer",
      whiteSpace: "nowrap",
      boxShadow: "0 8px 20px rgba(37,99,235,0.25)",
      transition: "all .25s ease",
    }}
  >
    🎫 Ticket Dashboard
  </button>
</div>
      {/* ===================================================== */}
      {/* ✅ CONTROLS */}
      {/* ===================================================== */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "12px",
          alignItems: "center",
          justifyContent: "flex-end",
          flex: "1 1 650px",
        }}
      >
        {/* DATE INPUT */}
        <input
          type="date"
          value={providerAnalyticsFromDate}
          onChange={(e) =>
            setProviderAnalyticsFromDate(e.target.value)
          }
          style={{
            ...inputStyle,
            minWidth: "180px",
            flex: "1 1 180px",
            background: "#ffffff",
            border: "1px solid #d1d5db",
            borderRadius: "16px",
            padding: "14px",
          }}
        />
        {/* DATE INPUT */}
        <input
          type="date"
          value={providerAnalyticsToDate}
          onChange={(e) =>
            setProviderAnalyticsToDate(e.target.value)
          }
          style={{
            ...inputStyle,
            minWidth: "180px",
            flex: "1 1 180px",
            background: "#ffffff",
            border: "1px solid #d1d5db",
            borderRadius: "16px",
            padding: "14px",
          }}
        />
        {/* APPLY */}
        <button
          onClick={applyProviderAnalyticsDateFilter}
          style={{
            padding: "14px 20px",
            borderRadius: "16px",
            border: "none",
            background:
              "linear-gradient(135deg,#8b5cf6,#7c3aed)",
            color: "#fff",
            fontWeight: 800,
            cursor: "pointer",
            minWidth: "120px",
            whiteSpace: "nowrap",
            boxShadow:
              "0 8px 20px rgba(139,92,246,0.18)",
          }}
        >
          APPLY
        </button>
        {/* RESET */}
        <button
          onClick={clearProviderAnalyticsDateFilter}
          style={{
            padding: "14px 20px",
            borderRadius: "16px",
            border: "1px solid #d1d5db",
            background: "#ffffff",
            color: "#374151",
            fontWeight: 800,
            cursor: "pointer",
            minWidth: "120px",
            whiteSpace: "nowrap",
          }}
        >
          RESET
        </button>
        {/* EXPAND */}
        <button
          onClick={expandProviderDashboard}
          style={{
            padding: "14px 20px",
            borderRadius: "16px",
            border: "none",
            background:
              "linear-gradient(135deg,#22c55e,#16a34a)",
            color: "#fff",
            fontWeight: 800,
            cursor: "pointer",
            minWidth: "120px",
            whiteSpace: "nowrap",
            boxShadow:
              "0 8px 20px rgba(34,197,94,0.18)",
          }}
        >
          EXPAND
        </button>
        {/* COLLAPSE */}
        <button
          onClick={collapseProviderDashboard}
          style={{
            padding: "14px 20px",
            borderRadius: "16px",
            border: "none",
            background:
              "linear-gradient(135deg,#ef4444,#dc2626)",
            color: "#fff",
            fontWeight: 800,
            cursor: "pointer",
            minWidth: "120px",
            whiteSpace: "nowrap",
            boxShadow:
              "0 8px 20px rgba(239,68,68,0.18)",
          }}
        >
          COLLAPSE
        </button>
        {/* LIVE */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "12px 16px",
            borderRadius: "999px",
            background: "#ffffff",
            border: "1px solid #e5e7eb",
            flexShrink: 0,
          }}
        >
          <div
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              background: "#22c55e",
              boxShadow:
                "0 0 10px rgba(34,197,94,0.5)",
            }}
          />
          <span
            style={{
              color: "#111827",
              fontWeight: 800,
              fontSize: "12px",
              letterSpacing: "1px",
              whiteSpace: "nowrap",
            }}
          >
            LIVE STREAM
          </span>
        </div>
      </div>
    </div>
    {/* ===================================================== */}
    {/* ✅ KPI GRID */}
    {/* ===================================================== */}
    <div
      style={{
        display: "grid",
        gridTemplateColumns:
          "repeat(auto-fit,minmax(240px,1fr))",
        gap: "22px",
        width: "100%",
        marginBottom: "28px",
      }}
    >
      {(dashboardWidgets || []).map((widget, index) => (
        <div
          key={index}
          onClick={() =>
            openProviderDashboardModal(
              "widget",
              widget
            )
          }
          style={{
            background: "#ffffff",
            border: "1px solid #e5e7eb",
            borderRadius: "28px",
            padding: "26px",
            minWidth: 0,
            overflow: "hidden",
            position: "relative",
            boxShadow:
              "0 8px 30px rgba(15,23,42,0.04)",
            cursor: "pointer",
            transition: "all 0.3s ease",
          }}
        >
          {/* ICON */}
          <div
            style={{
              width: 58,
              height: 58,
              borderRadius: 20,
              background: widget.color,
              marginBottom: 22,
            }}
          />
          {/* TITLE */}
          <p
            style={{
              color: "#6b7280",
              fontSize: 15,
              fontWeight: 700,
              marginBottom: 10,
            }}
          >
            {widget.title}
          </p>
          {/* VALUE */}
          <h2
            style={{
              fontSize: "clamp(34px,5vw,48px)",
              fontWeight: 900,
              margin: 0,
              color: "#111827",
              lineHeight: 1,
            }}
          >
            {Number(widget.count || 0).toLocaleString()}
          </h2>
          {/* TREND */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              marginTop: 18,
              flexWrap: "wrap",
            }}
          >
            <span
              style={{
                color: "#10b981",
                fontWeight: 800,
                fontSize: 14,
              }}
            >
              ↑ 12%
            </span>
            <span
              style={{
                color: "#9ca3af",
                fontSize: 13,
                fontWeight: 600,
              }}
            >
              to last month
            </span>
          </div>
        </div>
      ))}
    </div>
    {/* ===================================================== */}
    {/* ✅ ANALYTICS PANEL */}
    {/* ===================================================== */}
    <div
      style={{
        background: "#ffffff",
        borderRadius: "32px",
        padding: "30px",
        border: "1px solid #e5e7eb",
        boxShadow: "0 8px 30px rgba(15,23,42,0.04)",
        marginBottom: "28px",
      }}
    >
      {/* ===================================================== */}
      {/* ✅ TOP HEADER */}
      {/* ===================================================== */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
          gap: "14px",
        }}
      >
        <div>
          <h3
            style={{
              margin: 0,
              fontSize: 30,
              fontWeight: 900,
              color: "#111827",
            }}
          >
            Growth Analytics
          </h3>
          <p
            style={{
              marginTop: 6,
              color: "#6b7280",
            }}
          >
            Real-time provider trends
          </p>
        </div>
        {/* STATUS */}
        <div
          style={{
            padding: "12px 18px",
            borderRadius: "16px",
            background: providerAnalyticsFilterActive
              ? "#ecfdf5"
              : "#f3f4f6",
            border: providerAnalyticsFilterActive
              ? "1px solid #bbf7d0"
              : "1px solid #e5e7eb",
            color: providerAnalyticsFilterActive
              ? "#10b981"
              : "#6b7280",
            fontWeight: 800,
            fontSize: 13,
            whiteSpace: "nowrap",
          }}
        >
          {providerAnalyticsFilterActive
            ? "FILTER ACTIVE"
            : "LIVE DATA"}
        </div>
      </div>
      {/* ===================================================== */}
      {/* ✅ FILTER INFO */}
      {/* ===================================================== */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "12px",
          marginTop: "18px",
        }}
      >
        <div
          style={{
            padding: "12px 16px",
            borderRadius: "14px",
            background: "#f9fafb",
            border: "1px solid #e5e7eb",
            fontSize: "13px",
            fontWeight: 700,
            color: "#374151",
          }}
        >
          FROM: {providerAnalyticsFromDate || "--"}
        </div>
        <div
          style={{
            padding: "12px 16px",
            borderRadius: "14px",
            background: "#f9fafb",
            border: "1px solid #e5e7eb",
            fontSize: "13px",
            fontWeight: 700,
            color: "#374151",
          }}
        >
          TO: {providerAnalyticsToDate || "--"}
        </div>
      </div>
      {/* ===================================================== */}
      {/* ✅ BARS */}
      {/* ===================================================== */}
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-around",
          gap: "18px",
          overflowX: "auto",
          padding: "34px 10px 10px",
        }}
      >
        {(dashboardWidgets || []).map((metric, index) => {
          const safeCount = Number(metric.count) || 0;
          const barHeight =
            maxMetric > 0
              ? (safeCount / maxMetric) * 220
              : 20;
          return (
            <div
              key={index}
              onClick={() =>
                openProviderDashboardModal(
                  "analytics",
                  metric
                )
              }
              style={{
                textAlign: "center",
                minWidth: "85px",
                cursor: "pointer",
              }}
            >
              {/* VALUE */}
              <div
                style={{
                  marginBottom: 12,
                  padding: "8px 12px",
                  borderRadius: "999px",
                  background: "#ffffff",
                  border: "1px solid #e5e7eb",
                  fontWeight: 800,
                  fontSize: 13,
                  color: "#111827",
                }}
              >
                {safeCount}
              </div>
              {/* BAR WRAPPER */}
              <div
                style={{
                  width: "54px",
                  height: "240px",
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "center",
                  borderRadius: "20px",
                  background: "#f3f4f6",
                  padding: "5px",
                  border: "1px solid #e5e7eb",
                }}
              >
                {/* BAR */}
                <div
                  style={{
                    width: "100%",
                    height: `${barHeight}px`,
                    borderRadius:
                      "14px 14px 10px 10px",
                    background: metric.color,
                    transition: "height 0.5s ease",
                  }}
                />
              </div>
              {/* LABEL */}
              <span
                style={{
                  display: "block",
                  marginTop: 12,
                  fontSize: 11,
                  color: "#6b7280",
                  fontWeight: 700,
                  lineHeight: 1.4,
                }}
              >
                {metric.title}
              </span>
            </div>
          );
        })}
      </div>
    </div>
    {/* ===================================================== */}
    {/* ✅ LIVE FEED */}
    {/* ===================================================== */}
    <div
      style={{
        background: "#ffffff",
        borderRadius: "32px",
        padding: "28px",
        border: "1px solid #e5e7eb",
        boxShadow: "0 8px 30px rgba(15,23,42,0.04)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "14px",
          marginBottom: "20px",
        }}
      >
        <div>
          <h3
            style={{
              margin: 0,
              color: "#111827",
              fontSize: 28,
              fontWeight: 900,
            }}
          >
            Live Applications
          </h3>
          <p
            style={{
              marginTop: 6,
              color: "#6b7280",
            }}
          >
            Real-time onboarding activity
          </p>
        </div>
        <div
          style={{
            padding: "12px 18px",
            borderRadius: "999px",
            background: "#ecfdf5",
            border: "1px solid #bbf7d0",
            color: "#10b981",
            fontWeight: 800,
            fontSize: 13,
          }}
        >
          LIVE QUEUE
        </div>
      </div>
      {/* ===================================================== */}
      {/* ✅ FEED LIST */}
      {/* ===================================================== */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "14px",
        }}
      >
        {(providerQueue || []).map((item, index) => {
          const isTestProvider =
            item?.isTest === true ||
            item?.type === "test" ||
            /test/i.test(item?.category || "") ||
            /test/i.test(item?.firstName || "") ||
            /test/i.test(item?.lastName || "");

          return (
            <div
              key={index}
              onClick={() =>
                openProviderDashboardModal(
                  "provider",
                  item
                )
              }
              style={{
                padding: "18px",
                borderRadius: "22px",
                background: "#f9fafb",
                border: "1px solid #e5e7eb",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "14px",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
            >
              {/* LEFT */}
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  <div
                    style={{
                      color: "#111827",
                      fontWeight: 800,
                      fontSize: 16,
                    }}
                  >
                    {item?.firstName} {item?.lastName}
                  </div>
                  {/* ✅ ACTUAL / TEST PROVIDER BADGE */}
                  <span
                    style={{
                      padding: "4px 10px",
                      borderRadius: "999px",
                      fontSize: "10px",
                      fontWeight: 800,
                      letterSpacing: "0.5px",
                      whiteSpace: "nowrap",
                      background: isTestProvider
                        ? "#fee2e2"
                        : "#dbeafe",
                      color: isTestProvider
                        ? "#dc2626"
                        : "#2563eb",
                      border: isTestProvider
                        ? "1px solid #fecaca"
                        : "1px solid #bfdbfe",
                    }}
                  >
                    {isTestProvider
                      ? "TEST PROVIDER"
                      : "ACTUAL PROVIDER"}
                  </span>
                </div>
                <div
                  style={{
                    color: "#6b7280",
                    fontSize: 13,
                    marginTop: 4,
                  }}
                >
                  {item?.category}
                </div>
              </div>
              {/* STATUS */}
              <div
                style={{
                  padding: "8px 14px",
                  borderRadius: "999px",
                  background: "#fef3c7",
                  color: "#d97706",
                  fontSize: "12px",
                  fontWeight: "800",
                  whiteSpace: "nowrap",
                }}
              >
                {item?.status || "Pending"}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </div>
  {/* ===================================================== */}
  {/* ✅ GLOBAL REPORT MODAL */}
  {/* ===================================================== */}
  {providerDashboardModal && (
    <div
      onClick={closeProviderDashboardModal}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(15,23,42,0.72)",
        zIndex: 999999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "24px",
        overflowY: "auto",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: "980px",
          background: "#ffffff",
          borderRadius: "34px",
          border: "1px solid #e5e7eb",
          padding: "34px",
          maxHeight: "92vh",
          overflowY: "auto",
          boxShadow:
            "0 30px 90px rgba(15,23,42,0.25)",
        }}
      >
        {/* HEADER */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px",
            marginBottom: "30px",
            flexWrap: "wrap",
          }}
        >
          <div>
            <h2
              style={{
                margin: 0,
                color: "#111827",
                fontSize: "34px",
                fontWeight: 900,
              }}
            >
              Detailed Report
            </h2>
            <p
              style={{
                marginTop: "8px",
                color: "#6b7280",
                fontWeight: 600,
              }}
            >
              Complete dashboard analytics information
            </p>
          </div>
          <button
            onClick={closeProviderDashboardModal}
            style={{
              border: "none",
              background: "#ef4444",
              color: "#fff",
              width: "50px",
              height: "50px",
              borderRadius: "16px",
              cursor: "pointer",
              fontWeight: 900,
              fontSize: "18px",
            }}
          >
            ✕
          </button>
        </div>
        {/* REPORT BODY */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(260px,1fr))",
            gap: "20px",
          }}
        >
          {Object.entries(
            providerDashboardModalData?.data || {}
          ).map(([key, value], index) => (
            <div
              key={index}
              style={{
                padding: "22px",
                borderRadius: "24px",
                background: "#f9fafb",
                border: "1px solid #e5e7eb",
              }}
            >
              <div
                style={{
                  color: "#6b7280",
                  fontSize: "13px",
                  fontWeight: 800,
                  marginBottom: "10px",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                }}
              >
                {key}
              </div>
              <div
                style={{
                  color: "#111827",
                  fontSize: "17px",
                  fontWeight: 800,
                  wordBreak: "break-word",
                  lineHeight: 1.6,
                }}
              >
                {typeof value === "object"
                  ? JSON.stringify(value, null, 2)
                  : String(value || "--")}
              </div>
            </div>
          ))}
        </div>
        {/* FOOTER */}
        <div
          style={{
            marginTop: "30px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "14px",
            flexWrap: "wrap",
          }}
        >
          <button
            onClick={closeProviderDashboardModal}
            style={{
              padding: "14px 24px",
              borderRadius: "16px",
              border: "1px solid #d1d5db",
              background: "#ffffff",
              color: "#374151",
              fontWeight: 800,
              cursor: "pointer",
            }}
          >
            CLOSE
          </button>
          <button
            style={{
              padding: "14px 24px",
              borderRadius: "16px",
              border: "none",
              background:
                "linear-gradient(135deg,#8b5cf6,#7c3aed)",
              color: "#ffffff",
              fontWeight: 800,
              cursor: "pointer",
              boxShadow:
                "0 8px 20px rgba(139,92,246,0.25)",
            }}
          >
            EXPORT REPORT
          </button>
        </div>
      </div>
      </div>
  )}
    {/* ===================================================== */}
    {/* ✅ ANIMATIONS */}
    {/* ===================================================== */}
    <style>{`
      @keyframes shimmer {
        0% { left: -50%; }
        100% { left: 140%; }
      }
    `}</style>
  </div>
{/* ===================================================== */}
{/* ✅ FILTER + SCREEN FIT BOOKING DASHBOARD */}
{/* ===================================================== */}
<div
  style={{
    flex:
      bookingInsightViewport >= 95
        ? "1 1 100%"
        : `${bookingInsightViewport} 1 0%`,
    width:
      bookingInsightViewport >= 95
        ? "100%"
        : `${bookingInsightViewport}%`,

    minWidth: 0,
    maxWidth: "100%",
    transition: "all 0.35s ease",
    overflow: "hidden",
    boxSizing: "border-box",
  }}
>
  {/* ===================================================== */}
{/* ✅ BOOKING MAIN CONTAINER */}
{/* ===================================================== */}
<div
  style={{
    width: "100%",
    maxWidth: "100%",
    borderRadius: "34px",
    background: "#f8fafc",
    padding: "26px",
    border: "1px solid #e2e8f0",
    boxShadow:
      "0 20px 60px rgba(15,23,42,0.08)",
    boxSizing: "border-box",
    overflow: "hidden",
    position: "relative",
  }}
>
  {/* ===================================================== */}
  {/* ✅ HEADER */}
  {/* ===================================================== */}
  <div
    style={{
      display: "flex",
      justifyContent:
        "space-between",
      alignItems: "center",
      marginBottom: "26px",
      flexWrap: "wrap",
      gap: "20px",
      width: "100%",
    }}
  >
    {/* ================================================= */}
    {/* ✅ TITLE */}
    {/* ================================================= */}
    <div
      style={{
        minWidth: 0,
        flex: 1,
      }}
    >
      <h2
        style={{
          color: "#0f172a",
          fontSize:
            bookingInsightViewport >=
            95
              ? "34px"
              : "28px",

          fontWeight: "900",
          margin: 0,
          letterSpacing: "-0.5px",
          wordBreak: "break-word",
        }}
      >
        BOOKING CONTROL CENTER
      </h2>
      <p
        style={{
          color: "#64748b",
          fontSize: "13px",
          marginTop: "8px",
          marginBottom: 0,
          fontWeight: "600",
        }}
      >
        Real-time booking intelligence
      </p>
    </div>
    <button
      onClick={() => {
        setCurrentView("manageBookings");
      }}
      style={{
        background:
          "linear-gradient(135deg, #2563eb, #1d4ed8)",
        color: "#fff",
        border: "none",
        padding: "12px 22px",
        borderRadius: "12px",
        fontSize: "14px",
        fontWeight: "800",
        cursor: "pointer",
        boxShadow:
          "0 10px 25px rgba(37,99,235,0.25)",
        transition: "0.3s ease",
        whiteSpace: "nowrap",
      }}
    >
      Manage Bookings
    </button>
    {/* ================================================= */}
    {/* ✅ RIGHT ACTIONS */}
    {/* ================================================= */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "14px",
        flexWrap: "wrap",
      }}
    >
      {/* ============================================= */}
      {/* ✅ FROM DATE */}
      {/* ============================================= */}
      <input
        type="date"
        value={bookingRangeStartDate}
        onChange={(e) =>
          setBookingRangeStartDate(
            e.target.value
          )
        }
        style={{
          padding: "13px 16px",
          borderRadius: "16px",
          border:
            "1px solid #e2e8f0",
          background: "#ffffff",
          color: "#0f172a",
          fontWeight: "700",
          fontSize: "13px",
          outline: "none",
          minWidth: "160px",
          boxShadow:
            "0 4px 14px rgba(15,23,42,0.04)",
        }}
      />
      {/* ============================================= */}
      {/* ✅ TO DATE */}
      {/* ============================================= */}
      <input
        type="date"
        value={bookingRangeEndDate}
        onChange={(e) =>
          setBookingRangeEndDate(
            e.target.value
          )
        }
        style={{
          padding: "13px 16px",
          borderRadius: "16px",
          border:
            "1px solid #e2e8f0",
          background: "#ffffff",
          color: "#0f172a",
          fontWeight: "700",
          fontSize: "13px",
          outline: "none",
          minWidth: "160px",
          boxShadow:
            "0 4px 14px rgba(15,23,42,0.04)",
        }}
      />
      {/* ============================================= */}
      {/* ✅ APPLY FILTER */}
      {/* ============================================= */}
      <button
        onClick={
          applyBookingDateInsightsFilter
        }
        style={{
          padding: "13px 18px",
          borderRadius: "16px",
          border: "none",
          background:
            "linear-gradient(135deg,#6366f1,#8b5cf6)",
          color: "#ffffff",
          fontWeight: "800",
          fontSize: "12px",
          cursor: "pointer",
          whiteSpace: "nowrap",
          boxShadow:
            "0 12px 24px rgba(99,102,241,0.25)",
          transition: "0.3s ease",
        }}
      >
        APPLY FILTER
      </button>
      {/* ============================================= */}
      {/* ✅ RESET FILTER */}
      {/* ============================================= */}
      <button
        onClick={
          resetBookingDateInsightsFilter
        }
        style={{
          padding: "13px 18px",
          borderRadius: "16px",
          border: "none",
          background:
            "linear-gradient(135deg,#64748b,#475569)",
          color: "#ffffff",
          fontWeight: "800",
          fontSize: "12px",
          cursor: "pointer",
          whiteSpace: "nowrap",
          boxShadow:
            "0 12px 24px rgba(100,116,139,0.25)",
          transition: "0.3s ease",
        }}
      >
        RESET
      </button>
      {/* ============================================= */}
      {/* ✅ EXPAND BUTTON */}
      {/* ============================================= */}
      <button
        onClick={
          expandBookingInsightViewport
        }
        style={{
          padding: "13px 18px",
          borderRadius: "16px",
          border: "none",
          background:
            "linear-gradient(135deg,#22c55e,#16a34a)",
          color: "#ffffff",
          fontWeight: "800",
          fontSize: "12px",
          cursor: "pointer",
          whiteSpace: "nowrap",
          boxShadow:
            "0 12px 24px rgba(34,197,94,0.25)",
          transition: "0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform =
            "translateY(-2px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform =
            "translateY(0px)";
        }}
      >
        EXPAND +10%
      </button>
      {/* ============================================= */}
      {/* ✅ COLLAPSE BUTTON */}
      {/* ============================================= */}
      <button
        onClick={
          collapseBookingInsightViewport
        }
        style={{
          padding: "13px 18px",
          borderRadius: "16px",
          border: "none",
          background:
            "linear-gradient(135deg,#ef4444,#dc2626)",
          color: "#ffffff",
          fontWeight: "800",
          fontSize: "12px",
          cursor: "pointer",
          whiteSpace: "nowrap",
          boxShadow:
            "0 12px 24px rgba(239,68,68,0.25)",
          transition: "0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform =
            "translateY(-2px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform =
            "translateY(0px)";
        }}
      >
        COLLAPSE -10%
      </button>
      {/* ============================================= */}
      {/* ✅ LIVE CHIP */}
      {/* ============================================= */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "11px 16px",
          borderRadius: "999px",
          background: "#ffffff",
          border:
            "1px solid #e2e8f0",
          flexShrink: 0,
          boxShadow:
            "0 6px 18px rgba(15,23,42,0.05)",
        }}
      >
        <div
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            background: "#22c55e",
            boxShadow:
              "0 0 12px rgba(34,197,94,0.9)",
            animation:
              "pulse 1.5s infinite",
          }}
        />
        <span
          style={{
            color: "#0f172a",
            fontWeight: "800",
            fontSize: "12px",
            letterSpacing: "0.6px",
            whiteSpace: "nowrap",
          }}
        >
          LIVE BOOKINGS
        </span>
      </div>
    </div>
  </div>
  {/* ===================================================== */}
  {/* ✅ FILTER REPORT */}
  {/* ===================================================== */}
  <div
    style={{
      background: "#ffffff",
      borderRadius: "24px",
      padding: "20px",
      marginBottom: "28px",
      border: "1px solid #e2e8f0",
      display: "flex",
      justifyContent:
        "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "16px",
      boxShadow:
        "0 8px 24px rgba(15,23,42,0.05)",
    }}
  >
    <div>
      <h3
        style={{
          color: "#0f172a",
          margin: 0,
          fontSize: "20px",
          fontWeight: "800",
        }}
      >
        BOOKING REPORT SUMMARY
      </h3>
      <p
        style={{
          color: "#64748b",
          marginTop: "8px",
          fontSize: "12px",
          fontWeight: "600",
        }}
      >
        Filtered Date Range :
        {" "}
        {bookingRangeStartDate ||
          "--"}{" "}
        →{" "}
        {bookingRangeEndDate ||
          "--"}
      </p>
    </div>
    <div
      style={{
        display: "flex",
        gap: "12px",
        flexWrap: "wrap",
      }}
    >
      <div
        style={{
          padding: "11px 16px",
          borderRadius: "14px",
          background: "#eef2ff",
          color: "#4f46e5",
          fontWeight: "800",
          fontSize: "12px",
          border:
            "1px solid #c7d2fe",
        }}
      >
        FILTERED BOOKINGS :
        {" "}
        {filteredBookingInsightRecords?.length ||
          0}
      </div>
      <div
        style={{
          padding: "11px 16px",
          borderRadius: "14px",
          background:
            bookingDateFilterActivated
              ? "#dcfce7"
              : "#fee2e2",
          color:
            bookingDateFilterActivated
              ? "#15803d"
              : "#dc2626",
          fontWeight: "800",
          fontSize: "12px",
          border:
            bookingDateFilterActivated
              ? "1px solid #bbf7d0"
              : "1px solid #fecaca",
        }}
      >
        FILTER STATUS :
        {" "}
        {bookingDateFilterActivated
          ? "ACTIVE"
          : "INACTIVE"}
      </div>
    </div>
  </div>
  {/* ===================================================== */}
  {/* ✅ BOOKING STATUS CARDS */}
  {/* ===================================================== */}
  <div
    style={{
      display: "grid",
      gridTemplateColumns:
        bookingInsightViewport >=
        95
          ? "repeat(auto-fit,minmax(190px,1fr))"
          : "repeat(auto-fit,minmax(160px,1fr))",

      gap: "18px",
      marginBottom: "30px",
      width: "100%",
    }}
  >
    {(
      bookingStatusInsightMetrics ||
      []
    ).map((metric, index) => (
      <div
        key={index}
        onClick={() =>
          handleBookingStatusDrilldown(
            metric.title
          )
        }
        style={{
          background: "#ffffff",
          borderRadius: "22px",
          padding: "22px",
          textAlign: "center",
          border:
            "1px solid #e2e8f0",
          boxShadow:
            "0 10px 28px rgba(15,23,42,0.05)",
          transition: "0.3s ease",
          minWidth: 0,
          overflow: "hidden",
          cursor: "pointer",
        }}
      >
        <div
          style={{
            width: "52px",
            height: "52px",
            borderRadius: "18px",
            background:
              metric.lightColor ||
              "#eef2ff",
            margin:
              "0 auto 18px auto",
            display: "flex",
            alignItems: "center",
            justifyContent:
              "center",
          }}
        >
          <div
            style={{
              width: "14px",
              height: "14px",
              borderRadius:
                "999px",
              background:
                metric.dotColor ||
                "#6366f1",
            }}
          />
        </div>
        <h4
          style={{
            color: "#64748b",
            fontSize: "13px",
            fontWeight: "800",
            marginBottom: "12px",
            letterSpacing: "0.3px",
            wordBreak: "break-word",
          }}
        >
          {metric.title}
        </h4>
        <h2
          style={{
            color: "#0f172a",
            fontSize:
              bookingInsightViewport >=
              95
                ? "34px"
                : "28px",

            fontWeight: "900",
            margin: 0,
            wordBreak: "break-word",
          }}
        >
          {metric.count}
        </h2>
      </div>
    ))}
  </div>
  {/* ===================================================== */}
  {/* ✅ BOOKING CONTENT */}
  {/* ===================================================== */}
  <div
    style={{
      display: "grid",
      gridTemplateColumns:
        bookingInsightViewport >=
        85
          ? "minmax(0,1fr) 340px"
          : "1fr",

      gap: "22px",
      width: "100%",
      overflow: "hidden",
    }}
  >
    {/* ================================================= */}
    {/* ✅ ANALYTICS */}
    {/* ================================================= */}
    <div
      style={{
        background: "#ffffff",
        borderRadius: "28px",
        padding: "26px",
        minWidth: 0,
        overflow: "hidden",
        border:
          "1px solid #e2e8f0",
        boxShadow:
          "0 10px 30px rgba(15,23,42,0.05)",
      }}
    >
      <h3
        style={{
          color: "#0f172a",
          fontSize: "24px",
          fontWeight: "800",
          marginBottom: "8px",
        }}
      >
        Booking Analytics
      </h3>
      <p
        style={{
          color: "#64748b",
          fontSize: "12px",
          marginBottom: "26px",
          fontWeight: "600",
        }}
      >
        Dynamic booking insights
      </p>
      <div
        style={{
          height: "250px",
          display: "flex",
          alignItems: "flex-end",
          justifyContent:
            "space-around",
          gap: "12px",
          overflowX: "auto",
          paddingBottom: "10px",
        }}
      >
        {(
          bookingAnalyticsVisualizationData ||
          []
        ).map(
          (metric, index) => {
            const safeCount =
              Number(
                metric.count
              ) || 0;
            const barHeight =
              bookingAnalyticsMaximumMetric >
              0
                ? (safeCount /
                    bookingAnalyticsMaximumMetric) *
                  180
                : 12;
            return (
              <div
                key={index}
                onClick={() =>
                  handleBookingAnalyticsDrilldown(
                    metric.title
                  )
                }
                style={{
                  display: "flex",
                  flexDirection:
                    "column",
                  alignItems:
                    "center",
                  minWidth: "58px",
                  flexShrink: 0,
                  cursor:
                    "pointer",
                }}
              >
                <span
                  style={{
                    color:
                      "#0f172a",
                    marginBottom:
                      "10px",
                    fontSize:
                      "12px",
                    fontWeight:
                      "700",
                  }}
                >
                  {safeCount}
                </span>
                <div
                  style={{
                    width: "42px",
                    height: `${barHeight}px`,
                    borderRadius:
                      "16px 16px 8px 8px",
                    background:
                      metric.color,

                    boxShadow: `0 12px 26px ${metric.glow}`,
                  }}
                />
                <span
                  style={{
                    color:
                      "#64748b",
                    fontSize:
                      "10px",
                    marginTop:
                      "12px",
                    textAlign:
                      "center",
                    fontWeight:
                      "700",
                  }}
                >
                  {metric.title}
                </span>
              </div>
            );
          }
        )}
      </div>
    </div>
    {/* ================================================= */}
    {/* ✅ LIVE FEED */}
    {/* ================================================= */}
    <div
      style={{
        background: "#ffffff",
        borderRadius: "28px",
        padding: "24px",
        minWidth: 0,
        overflow: "hidden",
        border:
          "1px solid #e2e8f0",
        boxShadow:
          "0 10px 30px rgba(15,23,42,0.05)",
      }}
    >
      <h3
        style={{
          color: "#0f172a",
          fontSize: "22px",
          fontWeight: "800",
          marginBottom: "6px",
        }}
      >
        Live Booking Feed
      </h3>
      <p
        style={{
          color: "#64748b",
          fontSize: "12px",
          marginBottom: "20px",
          fontWeight: "600",
        }}
      >
        Latest booking activity
      </p>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "14px",
          maxHeight: "380px",
          overflowY: "auto",
        }}
      >
        {(
          filteredBookingRealtimeFeed ||
          []
        ).length > 0 ? (
          filteredBookingRealtimeFeed.map(
            (
              item,
              index
            ) => (
              <div
                key={index}
                onClick={() =>
                  handleBookingFeedInspection(
                    item
                  )
                }
                style={{
                  background:
                    "#f8fafc",
                  border:
                    "1px solid #e2e8f0",
                  borderRadius:
                    "20px",
                  padding:
                    "16px",
                  display:
                    "flex",
                  justifyContent:
                    "space-between",
                  alignItems:
                    "center",
                  gap: "14px",
                  flexWrap:
                    "wrap",
                  cursor:
                    "pointer",
                  transition:
                    "0.3s ease",
                }}
              >
                <div
                  style={{
                    minWidth: 0,
                    flex: 1,
                  }}
                >
                  <h4
                    style={{
                      color:
                        "#0f172a",
                      fontSize:
                        "14px",
                      fontWeight:
                        "800",
                      marginBottom:
                        "5px",
                    }}
                  >
                    {item?.customerName ||
                      item?.name ||
                      "New Booking"}
                  </h4>
                  <p
                    style={{
                      color:
                        "#64748b",
                      fontSize:
                        "11px",
                      margin: 0,
                      fontWeight:
                        "600",
                    }}
                  >
                    {item?.service ||
                      item?.category ||
                      "General Service"}
                  </p>
                </div>
                <div
                  style={{
                    padding:
                      "7px 14px",
                    borderRadius:
                      "999px",
                    background:
                      item?.status?.toLowerCase() ===
                      "completed"
                        ? "#dcfce7"
                        : item?.status?.toLowerCase() ===
                          "cancelled"
                        ? "#fee2e2"
                        : "#fef9c3",
                    color:
                      item?.status?.toLowerCase() ===
                      "completed"
                        ? "#15803d"
                        : item?.status?.toLowerCase() ===
                          "cancelled"
                        ? "#dc2626"
                        : "#ca8a04",
                    fontSize:
                      "10px",
                    fontWeight:
                      "800",
                    textTransform:
                      "uppercase",
                    whiteSpace:
                      "nowrap",
                    border:
                      item?.status?.toLowerCase() ===
                      "completed"
                        ? "1px solid #bbf7d0"
                        : item?.status?.toLowerCase() ===
                          "cancelled"
                        ? "1px solid #fecaca"
                        : "1px solid #fde68a",
                  }}
                >
                  {item?.status ||
                    "Pending"}
                </div>
              </div>
            )
          )
        ) : (
          <div
            style={{
              background:
                "#f8fafc",
              border:
                "1px solid #e2e8f0",
              borderRadius:
                "20px",
              padding:
                "18px",
              color:
                "#64748b",
              fontSize:
                "13px",
              fontWeight:
                "600",
            }}
          >
            No booking activity
            detected.
          </div>
        )}
      </div>
    </div>
  </div>
  {/* ===================================================== */}
  {/* ✅ GLOBAL PULSE */}
  {/* ===================================================== */}
  <style>
    {`
      @keyframes pulse {
        0% {
          transform: scale(1);
          opacity: 1;
        }
        50% {
          transform: scale(1.3);
          opacity: 0.7;
        }
        100% {
          transform: scale(1);
          opacity: 1;
        }
      }
    `}
  </style>
</div>
{/* ===================================================== */}
{/* ✅ BOOKING REPORT MODAL VIEWER */}
{/* ===================================================== */}
{activeBookingInsightReport && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      width: "100%",
      height: "100%",
      background: "rgba(15,23,42,0.55)",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 999999,
      padding: "24px",
      overflowY: "auto",
      boxSizing: "border-box",
    }}
  >
    {/* ================================================= */}
    {/* ✅ MODAL BOX */}
    {/* ================================================= */}
    <div
      style={{
        width: "100%",
        maxWidth: "1380px",
        maxHeight: "92vh",
        overflow: "hidden",
        background: "#f8fafc",
        borderRadius: "34px",
        border: "1px solid #e2e8f0",
        boxShadow:
          "0 25px 70px rgba(15,23,42,0.18)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* ================================================= */}
      {/* ✅ HEADER */}
      {/* ================================================= */}
      <div
        style={{
          padding: "28px",
          borderBottom:
            "1px solid #e2e8f0",
          display: "flex",
          justifyContent:
            "space-between",
          alignItems: "center",
          gap: "20px",
          flexWrap: "wrap",
          background: "#ffffff",
        }}
      >
        <div
          style={{
            minWidth: 0,
            flex: 1,
          }}
        >
          <h2
            style={{
              color: "#0f172a",
              margin: 0,
              fontSize: "32px",
              fontWeight: "900",
              letterSpacing: "-0.5px",
              wordBreak: "break-word",
            }}
          >
            {activeBookingInsightReport} REPORT
          </h2>
          <p
            style={{
              color: "#64748b",
              marginTop: "10px",
              fontSize: "13px",
              fontWeight: "600",
              marginBottom: 0,
            }}
          >
            Total Records :
            {" "}
            {bookingInsightReportRecords?.length || 0}
          </p>
        </div>
        {/* ============================================= */}
        {/* ✅ HEADER ACTIONS */}
        {/* ============================================= */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            flexWrap: "wrap",
          }}
        >
          <button
            onClick={() =>
              window.print()
            }
            style={{
              border: "none",
              padding: "13px 18px",
              borderRadius: "16px",
              background:
                "linear-gradient(135deg,#22c55e,#16a34a)",
              color: "#ffffff",
              fontWeight: "800",
              fontSize: "12px",
              cursor: "pointer",
              boxShadow:
                "0 12px 24px rgba(34,197,94,0.25)",
              transition: "0.3s ease",
              whiteSpace: "nowrap",
            }}
          >
            PRINT REPORT
          </button>
          <button
            onClick={() => {
              setActiveBookingInsightReport(
                null
              );

              setBookingInsightReportRecords(
                []
              );
            }}
            style={{
              border: "none",
              padding: "13px 18px",
              borderRadius: "16px",
              background:
                "linear-gradient(135deg,#ef4444,#dc2626)",
              color: "#ffffff",
              fontWeight: "800",
              fontSize: "12px",
              cursor: "pointer",
              boxShadow:
                "0 12px 24px rgba(239,68,68,0.25)",
              transition: "0.3s ease",
              whiteSpace: "nowrap",
            }}
          >
            CLOSE REPORT
          </button>
        </div>
      </div>
      {/* ================================================= */}
      {/* ✅ SUMMARY STRIP */}
      {/* ================================================= */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(180px,1fr))",
          gap: "16px",
          padding: "24px 28px",
          background: "#f8fafc",
          borderBottom:
            "1px solid #e2e8f0",
        }}
      >
        {[
          {
            title:
              "Total Bookings",
            value:
              bookingInsightReportRecords?.length ||
              0,
            background:
              "#eef2ff",
            color:
              "#4f46e5",
            border:
              "#c7d2fe",
          },
          {
            title:
              "Completed",
            value:
              (
                bookingInsightReportRecords ||
                []
              ).filter(
                (
                  bookingItem
                ) =>
                  bookingItem?.status?.toLowerCase() ===
                    "completed" ||
                  bookingItem?.bookingStatus?.toLowerCase() ===
                    "completed"
              ).length,
            background:
              "#dcfce7",
            color:
              "#15803d",
            border:
              "#bbf7d0",
          },
          {
            title:
              "Pending",
            value:
              (
                bookingInsightReportRecords ||
                []
              ).filter(
                (
                  bookingItem
                ) =>
                  bookingItem?.status?.toLowerCase() ===
                    "pending" ||
                  bookingItem?.bookingStatus?.toLowerCase() ===
                    "pending"
              ).length,
            background:
              "#fef9c3",
            color:
              "#ca8a04",
            border:
              "#fde68a",
          },
          {
            title:
              "Cancelled",
            value:
              (
                bookingInsightReportRecords ||
                []
              ).filter(
                (
                  bookingItem
                ) =>
                  bookingItem?.status?.toLowerCase() ===
                    "cancelled" ||
                  bookingItem?.bookingStatus?.toLowerCase() ===
                    "cancelled"
              ).length,

            background:
              "#fee2e2",
            color:
              "#dc2626",
            border:
              "#fecaca",
          },
        ].map(
          (
            reportMetric,
            reportMetricIndex
          ) => (
            <div
              key={
                reportMetricIndex
              }
              style={{
                background:
                  "#ffffff",
                borderRadius:
                  "22px",
                padding:
                  "20px",
                border: `1px solid ${reportMetric.border}`,
                boxShadow:
                  "0 8px 24px rgba(15,23,42,0.05)",
              }}
            >
              <p
                style={{
                  color:
                    "#64748b",
                  fontSize:
                    "12px",
                  fontWeight:
                    "700",
                  marginBottom:
                    "12px",
                }}
              >
                {
                  reportMetric.title
                }
              </p>

              <h2
                style={{
                  color:
                    reportMetric.color,
                  fontSize:
                    "30px",
                  fontWeight:
                    "900",
                  margin: 0,
                }}
              >
                {
                  reportMetric.value
                }
              </h2>
            </div>
          )
        )}
      </div>
      {/* ================================================= */}
      {/* ✅ TABLE */}
      {/* ================================================= */}
      <div
        style={{
          flex: 1,
          overflow: "auto",
          padding: "28px",
          background: "#f8fafc",
        }}
      >
        <table
          style={{
            width: "100%",
            minWidth: "1250px",
            borderCollapse:
              "separate",
            borderSpacing: 0,
            background:
              "#ffffff",
            borderRadius:
              "24px",
            overflow: "hidden",
            border:
              "1px solid #e2e8f0",
          }}
        >
          <thead>
            <tr
              style={{
                background:
                  "#f8fafc",
              }}
            >
              {[
                "Booking ID",
                "Customer",
                "Service",
                "Booking Status",
                "Payment Status",
                "Provider",
                "Amount",
                "Date",
              ].map(
                (
                  headerTitle,
                  headerIndex
                ) => (
                  <th
                    key={
                      headerIndex
                    }
                    style={{
                      padding:
                        "18px 16px",
                      textAlign:
                        "left",
                      color:
                        "#0f172a",
                      fontSize:
                        "12px",
                      fontWeight:
                        "800",
                      letterSpacing:
                        "0.5px",
                      borderBottom:
                        "1px solid #e2e8f0",
                      whiteSpace:
                        "nowrap",
                      position:
                        "sticky",
                      top: 0,
                      background:
                        "#f8fafc",
                      zIndex: 2,
                    }}
                  >
                    {
                      headerTitle
                    }
                  </th>
                )
              )}
            </tr>
          </thead>
          <tbody>
            {(
              bookingInsightReportRecords ||
              []
            ).map(
              (
                item,
                index
              ) => (
                <tr
                  key={index}
                  onClick={() =>
                    handleBookingFeedInspection?.(
                      item
                    )
                  }
                  style={{
                    borderBottom:
                      "1px solid #f1f5f9",
                    cursor:
                      "pointer",
                    transition:
                      "0.3s ease",
                  }}
                >
                  {/* ========================================= */}
                  {/* ✅ BOOKING ID */}
                  {/* ========================================= */}
                  <td
                    style={{
                      padding:
                        "18px 16px",
                    }}
                  >
                    <div
                      style={{
                        display:
                          "inline-flex",
                        alignItems:
                          "center",
                        padding:
                          "7px 14px",
                        borderRadius:
                          "999px",
                        background:
                          "#eef2ff",
                        color:
                          "#4f46e5",
                        fontWeight:
                          "800",
                        fontSize:
                          "11px",
                        border:
                          "1px solid #c7d2fe",
                        whiteSpace:
                          "nowrap",
                      }}
                    >
                      {item?.bookingId ||
                        item?.id ||
                        "--"}
                    </div>
                  </td>
                  {/* ========================================= */}
                  {/* ✅ CUSTOMER */}
                  {/* ========================================= */}
                  <td
                    style={{
                      padding:
                        "18px 16px",
                    }}
                  >
                    <div>
                      <h4
                        style={{
                          color:
                            "#0f172a",
                          fontSize:
                            "14px",
                          fontWeight:
                            "800",
                          margin: 0,
                          marginBottom:
                            "4px",
                        }}
                      >
                        {item?.customerName ||
                          item?.name ||
                          "Customer"}
                      </h4>
                      <p
                        style={{
                          color:
                            "#64748b",
                          fontSize:
                            "11px",
                          margin: 0,
                          fontWeight:
                            "600",
                        }}
                      >
                        {item?.phone ||
                          item?.mobile ||
                          "No Contact"}
                      </p>
                    </div>
                  </td>
                  {/* ========================================= */}
                  {/* ✅ SERVICE */}
                  {/* ========================================= */}
                  <td
                    style={{
                      padding:
                        "18px 16px",
                      color:
                        "#475569",
                      fontSize:
                        "13px",
                      fontWeight:
                        "700",
                    }}
                  >
                    {item?.service ||
                      item?.category ||
                      "--"}
                  </td>
                  {/* ========================================= */}
                  {/* ✅ BOOKING STATUS */}
                  {/* ========================================= */}
                  <td
                    style={{
                      padding:
                        "18px 16px",
                    }}
                  >
                    <div
                      style={{
                        display:
                          "inline-flex",
                        alignItems:
                          "center",
                        padding:
                          "7px 14px",
                        borderRadius:
                          "999px",
                        background:
                          item?.bookingStatus?.toLowerCase() ===
                            "completed" ||
                          item?.status?.toLowerCase() ===
                            "completed"
                            ? "#dcfce7"
                            : item?.bookingStatus?.toLowerCase() ===
                                "cancelled" ||
                              item?.status?.toLowerCase() ===
                                "cancelled"
                            ? "#fee2e2"
                            : "#fef9c3",
                        color:
                          item?.bookingStatus?.toLowerCase() ===
                            "completed" ||
                          item?.status?.toLowerCase() ===
                            "completed"
                            ? "#15803d"
                            : item?.bookingStatus?.toLowerCase() ===
                                "cancelled" ||
                              item?.status?.toLowerCase() ===
                                "cancelled"
                            ? "#dc2626"
                            : "#ca8a04",
                        border:
                          item?.bookingStatus?.toLowerCase() ===
                            "completed" ||
                          item?.status?.toLowerCase() ===
                            "completed"
                            ? "1px solid #bbf7d0"
                            : item?.bookingStatus?.toLowerCase() ===
                                "cancelled" ||
                              item?.status?.toLowerCase() ===
                                "cancelled"
                            ? "1px solid #fecaca"
                            : "1px solid #fde68a",

                        fontSize:
                          "11px",
                        fontWeight:
                          "800",
                        textTransform:
                          "uppercase",
                        whiteSpace:
                          "nowrap",
                      }}
                    >
                      {item?.bookingStatus ||
                        item?.status ||
                        "--"}
                    </div>
                  </td>
                  {/* ========================================= */}
                  {/* ✅ PAYMENT STATUS */}
                  {/* ========================================= */}
                  <td
                    style={{
                      padding:
                        "18px 16px",
                    }}
                  >
                    <div
                      style={{
                        display:
                          "inline-flex",
                        alignItems:
                          "center",
                        padding:
                          "7px 14px",
                        borderRadius:
                          "999px",
                        background:
                          "#ecfeff",
                        color:
                          "#0f766e",
                        border:
                          "1px solid #a5f3fc",
                        fontSize:
                          "11px",
                        fontWeight:
                          "800",
                        textTransform:
                          "uppercase",
                        whiteSpace:
                          "nowrap",
                      }}
                    >
                      {item?.paymentStatus ||
                        "--"}
                    </div>
                  </td>
                  {/* ========================================= */}
                  {/* ✅ PROVIDER */}
                  {/* ========================================= */}
                  <td
                    style={{
                      padding:
                        "18px 16px",
                      color:
                        "#0f172a",
                      fontSize:
                        "13px",
                      fontWeight:
                        "700",
                    }}
                  >
                    {item?.providerName ||
                      "--"}
                  </td>
                  {/* ========================================= */}
                  {/* ✅ AMOUNT */}
                  {/* ========================================= */}
                  <td
                    style={{
                      padding:
                        "18px 16px",
                      color:
                        "#ca8a04",
                      fontSize:
                        "13px",
                      fontWeight:
                        "900",
                      whiteSpace:
                        "nowrap",
                    }}
                  >
                    £
                    {item?.amount ||
                      item?.price ||
                      0}
                  </td>
                  {/* ========================================= */}
                  {/* ✅ DATE */}
                  {/* ========================================= */}
                  <td
                    style={{
                      padding:
                        "18px 16px",
                      color:
                        "#64748b",
                      fontSize:
                        "12px",
                      fontWeight:
                        "700",
                      whiteSpace:
                        "nowrap",
                    }}
                  >
                    {item?.createdAt
                      ?.seconds
                      ? new Date(
                          item.createdAt.seconds *
                            1000
                        ).toLocaleDateString()
                      : item?.date
                      ? new Date(
                          item.date
                        ).toLocaleDateString()
                      : "--"}
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
        {/* =============================================== */}
        {/* ✅ EMPTY STATE */}
        {/* =============================================== */}
        {(!bookingInsightReportRecords ||
          bookingInsightReportRecords.length ===
            0) && (
          <div
            style={{
              marginTop:
                "24px",
              padding:
                "24px",
              borderRadius:
                "22px",
              background:
                "#ffffff",
              border:
                "1px solid #fecaca",
              color:
                "#dc2626",
              fontWeight:
                "700",
              fontSize:
                "13px",
              textAlign:
                "center",
              boxShadow:
                "0 8px 24px rgba(15,23,42,0.04)",
            }}
          >
            No records found for this
            report.
          </div>
        )}
      </div>
    </div>
  </div>
)}
  </div>
  </div>
  
 {/*New Provider List */}
<div
  style={{
    width: "100%",
    display: "block",
    clear: "both",
    marginTop: "40px",
    marginBottom: "40px",
    position: "relative",
    zIndex: 1,
    background: "#eef2ff",
    borderRadius: "32px",
    padding: "20px",
    boxSizing: "border-box",
  }}
>
  <div
    style={{
      width:
        providerIntelligenceScale >= 95
          ? "100%"
          : `${providerIntelligenceScale}%`,
      minWidth: 0,
      maxWidth: "100%",
      margin: "0 auto",
      transition: "all 0.4s ease",
      boxSizing: "border-box",
    }}
  >
    <div
      style={{
        width: "100%",
        background: "#ffffff",
        borderRadius: "28px",
        padding: "32px",
        border: "1px solid #dbe3f0",
        boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      {/* ============================================= */}
      {/* HEADER */}
      {/* ============================================= */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
          gap: "24px",
          marginBottom: "32px",
        }}
      >
        <div
          style={{
            flex: 1,
            minWidth: 0,
          }}
        >
          <h2
            style={{
              margin: 0,
              color: "#111827",
              fontSize:
                providerIntelligenceScale >= 95
                  ? "36px"
                  : "30px",
              fontWeight: "800",
              letterSpacing: "0.5px",
              lineHeight: "1.2",
              wordBreak: "break-word",
            }}
          >
            NEW PROVIDERS
          </h2>
          <p
            style={{
              color: "#374151",
              fontSize: "15px",
              fontWeight: "500",
              marginTop: "10px",
              marginBottom: 0,
            }}
          >
            Real-time provider intelligence dashboard
          </p>
          {/* ============================================= */}
          {/* FILTER PANEL */}
          {/* ============================================= */}
          <div
            style={{
              marginTop: "24px",
              display: "flex",
              alignItems: "flex-end",
              gap: "14px",
              flexWrap: "wrap",
              background: "#f8fafc",
              border: "1px solid #dbe3f0",
              borderRadius: "18px",
              padding: "20px",
            }}
          >
            {/* FROM DATE */}
            <div>
              <label
                style={{
                  display: "block",
                  color: "#1f2937",
                  fontSize: "12px",
                  fontWeight: "700",
                  marginBottom: "8px",
                }}
              >
                FROM DATE
              </label>
              <input
                type="date"
                value={providerFilterStartDate}
                onChange={(event) =>
                  updateProviderFilterStartDate(
                    event.target.value
                  )
                }
                style={{
                  minWidth: "180px",
                  padding: "12px 14px",
                  borderRadius: "12px",
                  border: "1px solid #cbd5e1",
                  background: "#ffffff",
                  color: "#111827",
                  fontSize: "14px",
                  fontWeight: "600",
                  outline: "none",
                }}
              />
            </div>
            {/* TO DATE */}
            <div>
              <label
                style={{
                  display: "block",
                  color: "#1f2937",
                  fontSize: "12px",
                  fontWeight: "700",
                  marginBottom: "8px",
                }}
              >
                TO DATE
              </label>
              <input
                type="date"
                value={providerFilterEndDate}
                onChange={(event) =>
                  updateProviderFilterEndDate(
                    event.target.value
                  )
                }
                style={{
                  minWidth: "180px",
                  padding: "12px 14px",
                  borderRadius: "12px",
                  border: "1px solid #cbd5e1",
                  background: "#ffffff",
                  color: "#111827",
                  fontSize: "14px",
                  fontWeight: "600",
                  outline: "none",
                }}
              />
            </div>
            <button
              onClick={activateProviderDateFilter}
              style={{
                padding: "12px 22px",
                border: "none",
                borderRadius: "12px",
                background: "#4f46e5",
                color: "#ffffff",
                fontSize: "14px",
                fontWeight: "700",
                cursor: "pointer",
              }}
            >
              APPLY FILTER
            </button>
            <button
              onClick={resetProviderDateFilter}
              style={{
                padding: "12px 22px",
                borderRadius: "12px",
                border: "1px solid #cbd5e1",
                background: "#ffffff",
                color: "#111827",
                fontSize: "14px",
                fontWeight: "700",
                cursor: "pointer",
              }}
            >
              RESET
            </button>
          </div>
        </div>
        {/* ============================================= */}
        {/* ACTION BUTTONS */}
        {/* ============================================= */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "12px",
          }}
        >
          <button
            onClick={
              amplifyProviderIntelligenceView
            }
            style={{
              padding: "12px 18px",
              borderRadius: "12px",
              border: "none",
              background: "#4f46e5",
              color: "#ffffff",
              fontWeight: "700",
              fontSize: "14px",
              cursor: "pointer",
            }}
          >
            EXPAND +10%
          </button>
          <button
            onClick={
              compressProviderIntelligenceView
            }
            style={{
              padding: "12px 18px",
              borderRadius: "12px",
              border: "1px solid #cbd5e1",
              background: "#ffffff",
              color: "#111827",
              fontWeight: "700",
              fontSize: "14px",
              cursor: "pointer",
            }}
          >
            COLLAPSE -10%
          </button>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              padding: "10px 16px",
              borderRadius: "999px",
              background: "#ffffff",
              border: "1px solid #dbe3f0",
            }}
          >
            <div
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                background: "#4f46e5",
              }}
            />
            <span
              style={{
                color: "#111827",
                fontSize: "13px",
                fontWeight: "700",
                letterSpacing: "0.4px",
              }}
            >
              LIVE TALENT
            </span>
          </div>
        </div>
      </div>
      {/* ============================================= */}
      {/* STATUS MATRIX */}
      {/* ============================================= */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(220px,1fr))",
          gap: "20px",
          marginBottom: "30px",
        }}
      >
        {[
          {
            title: "Registered",
            count:
              providerRegisteredCount,
            clickHandler:
              openRegisteredProviderInsights,
          },
          {
            title: "Verified",
            count:
              providerVerifiedCount,
            clickHandler:
              openVerifiedProviderInsights,
          },
          {
            title: "Awaiting",
            count:
              providerAwaitingCount,
            clickHandler:
              openAwaitingProviderInsights,
          },
          {
            title: "Restricted",
            count:
              providerRestrictedCount,
            clickHandler:
              openRestrictedProviderInsights,
          },
          {
            title: "Active",
            count:
              providerActiveCount,
            clickHandler:
              openActiveProviderInsights,
          },
          {
            title: "Fresh",
            count:
              providerFreshEnrollmentCount,
            clickHandler:
              openFreshProviderInsights,
          },
        ].map(
          (
            providerMetricCard,
            providerMetricIndex
          ) => (
            <div
              key={providerMetricIndex}
              onClick={
                providerMetricCard.clickHandler
              }
              style={{
                background: "#ffffff",
                borderRadius: "22px",
                padding: "24px",
                border:
                  "1px solid #dbe3f0",
                boxShadow:
                  "0 10px 25px rgba(0,0,0,0.06)",
                cursor: "pointer",
                transition:
                  "all 0.3s ease",
              }}
            >
              <h4
                style={{
                  margin: 0,
                  marginBottom: "12px",
                  color: "#374151",
                  fontSize: "15px",
                  fontWeight: "700",
                }}
              >
                {
                  providerMetricCard.title
                }
              </h4>
              <h2
                style={{
                  margin: 0,
                  color: "#111827",
                  fontSize: "42px",
                  fontWeight: "800",
                  lineHeight: "1",
                }}
              >
                {
                  providerMetricCard.count
                }
              </h2>
            </div>
          )
        )}
      </div>
     {/* ============================================= */}
{/* ANALYTICS + LIVE TALENT FEED */}
{/* ============================================= */}
<div
  style={{
    display: "grid",
    gridTemplateColumns:
      providerIntelligenceScale >= 85
        ? "minmax(0,1fr) 340px"
        : "1fr",
    gap: "24px",
    marginTop: "10px",
  }}
>
  {/* ============================================= */}
  {/* TALENT ANALYTICS */}
  {/* ============================================= */}
  <div
    style={{
      background: "#ffffff",
      borderRadius: "24px",
      padding: "28px",
      border: "1px solid #dbe3f0",
      boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
      overflow: "hidden",
    }}
  >
    <h3
      style={{
        margin: 0,
        color: "#111827",
        fontSize: "24px",
        fontWeight: "800",
      }}
    >
      Talent Analytics
    </h3>
    <p
      style={{
        color: "#64748b",
        fontSize: "13px",
        marginTop: "8px",
        marginBottom: "24px",
      }}
    >
      Live talent growth metrics
    </p>
    <div
      style={{
        height: "260px",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-around",
        gap: "14px",
      }}
    >
      {(providerAnalyticsMatrix || []).map(
        (
          providerInsightMetric,
          providerInsightIndex
        ) => {
          const protectedMetricValue =
            Number(
              providerInsightMetric.count
            ) || 0;
          const providerMetricHeight =
            providerHighestMetric > 0
              ? (protectedMetricValue /
                  providerHighestMetric) *
                190
              : 15;
          return (
            <div
              key={providerInsightIndex}
              onClick={() =>
                openProviderMetricBreakdown(
                  providerInsightMetric
                )
              }
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                minWidth: "60px",
                cursor: "pointer",
              }}
            >
              <span
                style={{
                  color: "#111827",
                  fontWeight: "700",
                  fontSize: "13px",
                  marginBottom: "10px",
                }}
              >
                {protectedMetricValue}
              </span>
              <div
                style={{
                  width: "46px",
                  height: `${providerMetricHeight}px`,
                  borderRadius:
                    "16px 16px 8px 8px",
                  background:
                    providerInsightMetric.color,
                  boxShadow: `0 10px 25px ${providerInsightMetric.glow}`,
                  transition: "0.3s ease",
                }}
              />
              <span
                style={{
                  color: "#64748b",
                  fontSize: "11px",
                  fontWeight: "600",
                  textAlign: "center",
                  marginTop: "12px",
                }}
              >
                {
                  providerInsightMetric.title
                }
              </span>
            </div>
          );
        }
      )}
    </div>
  </div>
  {/* ============================================= */}
  {/* LIVE TALENT FEED */}
  {/* ============================================= */}
  <div
    style={{
      background: "#ffffff",
      borderRadius: "24px",
      padding: "24px",
      border: "1px solid #dbe3f0",
      boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
      overflow: "hidden",
    }}
  >
    <h3
      style={{
        margin: 0,
        color: "#111827",
        fontSize: "22px",
        fontWeight: "800",
      }}
    >
      Live Talent Feed
    </h3>
    <p
      style={{
        color: "#64748b",
        fontSize: "13px",
        marginTop: "8px",
        marginBottom: "20px",
      }}
    >
      Latest talent enrollments
    </p>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "14px",
        maxHeight: "420px",
        overflowY: "auto",
      }}
    >
      {(providerRealtimeFeed || []).map(
        (
          providerProfile,
          providerProfileIndex
        ) => (
          <div
            key={providerProfileIndex}
            onClick={() =>
              openProviderProfileReport(
                providerProfile
              )
            }
            style={{
              background: "#f8fafc",
              border: "1px solid #e2e8f0",
              borderRadius: "18px",
              padding: "16px",
              display: "flex",
              justifyContent:
                "space-between",
              alignItems: "center",
              gap: "12px",
              cursor: "pointer",
              transition: "0.3s ease",
            }}
          >
            <div>
              <h4
                style={{
                  margin: 0,
                  color: "#111827",
                  fontSize: "14px",
                  fontWeight: "800",
                }}
              >
                {providerProfile?.name ||
                  "Talent"}
              </h4>
              <p
                style={{
                  marginTop: "5px",
                  marginBottom: 0,
                  color: "#64748b",
                  fontSize: "12px",
                }}
              >
                {providerProfile?.service ||
                  "General Service"}
              </p>
            </div>
            <div
              style={{
                padding: "7px 14px",
                borderRadius: "999px",
                background:
                  "rgba(34,197,94,0.12)",
                color: "#16a34a",
                fontSize: "11px",
                fontWeight: "800",
                letterSpacing: "0.3px",
              }}
            >
              ACTIVE
            </div>
          </div>
        )
      )}
    </div>
  </div>
      </div>
      {/* ================================================= */}
      {/* ✅ PULSE */}
      {/* ================================================= */}
      <style>
        {`
          @keyframes pulse {
            0% {
              transform: scale(1);
              opacity: 1;
            }
            50% {
              transform: scale(1.3);
              opacity: 0.7;
            }
            100% {
              transform: scale(1);
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  </div>
</div>
{/* ===================================================== */}
{/* ✅ PROVIDER REPORT CENTER MODAL */}
{/* ===================================================== */}
{providerReportModalVisible && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(15,23,42,0.35)",
      backdropFilter: "blur(10px)",
      zIndex: 999999,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "24px",
      overflowY: "auto",
    }}
  >
    <div
      style={{
        width: "100%",
        maxWidth: "1480px",
        maxHeight: "94vh",
        overflow: "hidden",
        background: "#f8fafc",
        borderRadius: "34px",
        boxShadow:
          "0 25px 80px rgba(15,23,42,0.18)",
        display: "flex",
        flexDirection: "column",
        border: "1px solid #e2e8f0",
      }}
    >
      {/* ================================================= */}
      {/* ✅ MODAL HEADER */}
      {/* ================================================= */}
      <div
        style={{
          padding: "28px 34px",
          background: "#ffffff",
          borderBottom:
            "1px solid #e2e8f0",
          display: "flex",
          justifyContent:
            "space-between",
          alignItems: "center",
          gap: "20px",
          flexWrap: "wrap",
        }}
      >
        <div>
          <h2
            style={{
              margin: 0,
              color: "#0f172a",
              fontSize: "34px",
              fontWeight: "900",
              letterSpacing: "-0.5px",
            }}
          >
            {providerReportTitle ||
              "Provider Report Center"}
          </h2>
          <p
            style={{
              marginTop: "8px",
              marginBottom: 0,
              color: "#64748b",
              fontSize: "13px",
              fontWeight: "600",
            }}
          >
            Total Providers :
            {" "}
            {
              providerReportCollection.length
            }
          </p>
        </div>
        {/* ============================================= */}
        {/* ✅ ACTION BUTTONS */}
        {/* ============================================= */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            flexWrap: "wrap",
          }}
        >
          <button
            onClick={() =>
              window.print()
            }
            style={{
              border: "none",
              padding: "13px 20px",
              borderRadius: "16px",
              background:
                "linear-gradient(135deg,#6366f1,#8b5cf6)",
              color: "#ffffff",
              fontWeight: "800",
              fontSize: "12px",
              cursor: "pointer",
              boxShadow:
                "0 12px 24px rgba(99,102,241,0.25)",
            }}
          >
            PRINT REPORT
          </button>
          <button
            onClick={() =>
              updateProviderReportModalVisible(
                false
              )
            }
            style={{
              border: "none",
              padding: "13px 20px",
              borderRadius: "16px",
              background:
                "linear-gradient(135deg,#ef4444,#dc2626)",
              color: "#ffffff",
              fontWeight: "800",
              fontSize: "12px",
              cursor: "pointer",
              boxShadow:
                "0 12px 24px rgba(239,68,68,0.25)",
            }}
          >
            CLOSE REPORT
          </button>
        </div>
      </div>
      {/* ================================================= */}
      {/* ✅ SUMMARY STRIP */}
      {/* ================================================= */}
      <div
        style={{
          padding: "24px 34px",
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(220px,1fr))",
          gap: "18px",
          background: "#f8fafc",
          borderBottom:
            "1px solid #e2e8f0",
        }}
      >
        {[
          {
            title:
              "Total Providers",
            value:
              providerReportCollection.length,
            color: "#6366f1",
            bg: "#eef2ff",
          },
          {
            title:
              "Approved",
            value:
              providerReportCollection.filter(
                (providerItem) =>
                  providerItem?.status?.toLowerCase() ===
                  "approved"
              ).length,
            color: "#16a34a",
            bg: "#dcfce7",
          },
          {
            title:
              "Pending",
            value:
              providerReportCollection.filter(
                (providerItem) =>
                  providerItem?.status?.toLowerCase() ===
                  "pending"
              ).length,
            color: "#d97706",
            bg: "#fef3c7",
          },
          {
            title:
              "Blocked",
            value:
              providerReportCollection.filter(
                (providerItem) =>
                  providerItem?.status?.toLowerCase() ===
                  "blocked"
              ).length,
            color: "#dc2626",
            bg: "#fee2e2",
          },
          {
            title: "Online",
            value:
              providerReportCollection.filter(
                (providerItem) =>
                  providerItem?.online ===
                    true ||
                  providerItem?.isOnline ===
                    true
              ).length,
            color: "#0891b2",
            bg: "#cffafe",
          },
        ].map(
          (
            summaryCard,
            summaryIndex
          ) => (
            <div
              key={summaryIndex}
              style={{
                background: "#ffffff",
                borderRadius: "24px",
                padding: "22px",
                border:
                  "1px solid #e2e8f0",
                boxShadow:
                  "0 10px 30px rgba(15,23,42,0.05)",
              }}
            >
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "16px",
                  background:
                    summaryCard.bg,
                  display: "flex",
                  alignItems: "center",
                  justifyContent:
                    "center",
                  marginBottom: "16px",
                }}
              >
                <div
                  style={{
                    width: "14px",
                    height: "14px",
                    borderRadius:
                      "999px",
                    background:
                      summaryCard.color,
                  }}
                />
              </div>
              <p
                style={{
                  margin: 0,
                  color: "#64748b",
                  fontSize: "12px",
                  fontWeight: "700",
                }}
              >
                {
                  summaryCard.title
                }
              </p>
              <h2
                style={{
                  marginTop: "12px",
                  marginBottom: 0,
                  color: "#0f172a",
                  fontSize: "34px",
                  fontWeight: "900",
                }}
              >
                {
                  summaryCard.value
                }
              </h2>
            </div>
          )
        )}
      </div>
      {/* ================================================= */}
      {/* ✅ TABLE SECTION */}
      {/* ================================================= */}
      <div
        style={{
          flex: 1,
          overflow: "auto",
          padding: "30px 34px",
          background: "#f8fafc",
        }}
      >
        <div
          style={{
            overflowX: "auto",
            borderRadius: "28px",
            background: "#ffffff",
            border: "1px solid #e2e8f0",
            boxShadow:
              "0 10px 35px rgba(15,23,42,0.05)",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse:
                "separate",
              borderSpacing: 0,
              minWidth: "1600px",
            }}
          >
            {/* ========================================= */}
            {/* ✅ TABLE HEADER */}
            {/* ========================================= */}
            <thead>
              <tr
                style={{
                  background: "#ffffff",
                }}
              >
                {[
                  "Provider Name",
                  "Provider ID",
                  "Service",
                  "Phone Number",
                  "Email Address",
                  "Status",
                  "Availability",
                  "Created Date",
                  "City",
                  "Rating",
                ].map(
                  (
                    headerTitle,
                    headerIndex
                  ) => (
                    <th
                      key={headerIndex}
                      style={{
                        padding:
                          "22px 20px",
                        textAlign:
                          "left",
                        whiteSpace:
                          "nowrap",
                        color:
                          "#0f172a",
                        fontSize:
                          "12px",
                        fontWeight:
                          "900",
                        letterSpacing:
                          "0.5px",
                        borderBottom:
                          "1px solid #e2e8f0",
                        position:
                          "sticky",
                        top: 0,
                        background:
                          "#ffffff",
                        zIndex: 20,
                      }}
                    >
                      {headerTitle}
                    </th>
                  )
                )}
              </tr>
            </thead>
            {/* ========================================= */}
            {/* ✅ TABLE BODY */}
            {/* ========================================= */}
            <tbody>
              {(providerReportCollection ||
                []).map(
                (
                  providerItem,
                  providerIndex
                ) => {
                  const providerCreatedDate =
                    providerItem?.createdAt
                      ?.toDate
                      ? providerItem.createdAt.toDate()
                      : providerItem?.createdAt
                      ? new Date(
                          providerItem.createdAt
                        )
                      : null;
                  const fetchedProviderName =
                    providerItem?.name ||
                    providerItem?.providerName ||
                    providerItem?.fullName ||
                    providerItem?.displayName ||
                    providerItem?.providername ||
                    "Provider";
                  const fetchedProviderId =
                    providerItem?.providerId ||
                    providerItem?.providerID ||
                    providerItem?.id ||
                    providerItem?.uid ||
                    providerItem?.provider_id ||
                    "N/A";
                  return (
                    <tr
                      key={
                        providerIndex
                      }
                      onClick={() =>
                        openProviderProfileReport(
                          providerItem
                        )
                      }
                      style={{
                        cursor:
                          "pointer",
                        transition:
                          "0.25s ease",
                        background:
                          providerIndex %
                            2 ===
                          0
                            ? "#ffffff"
                            : "#f8fafc",
                      }}
                    >
                      {/* ================================= */}
                      {/* PROVIDER NAME */}
                      {/* ================================= */}
                      <td
                        style={{
                          padding:
                            "22px 20px",
                          borderBottom:
                            "1px solid #f1f5f9",
                          minWidth:
                            "220px",
                        }}
                      >
                        <div
                          style={{
                            display:
                              "flex",
                            alignItems:
                              "center",
                            gap: "14px",
                          }}
                        >
                          <div
                            style={{
                              width: "48px",
                              height: "48px",
                              borderRadius:
                                "16px",
                              background:
                                "linear-gradient(135deg,#6366f1,#8b5cf6)",
                              display:
                                "flex",
                              alignItems:
                                "center",
                              justifyContent:
                                "center",
                              color:
                                "#ffffff",
                              fontWeight:
                                "900",
                              fontSize:
                                "16px",
                            }}
                          >
                            {String(
                              fetchedProviderName
                            )
                              .charAt(0)
                              .toUpperCase()}
                          </div>
                          <div>
                            <h4
                              style={{
                                margin: 0,
                                color:
                                  "#0f172a",
                                fontSize:
                                  "14px",
                                fontWeight:
                                  "800",
                              }}
                            >
                              {
                                fetchedProviderName
                              }
                            </h4>
                            <p
                              style={{
                                marginTop:
                                  "5px",
                                marginBottom: 0,
                                color:
                                  "#64748b",
                                fontSize:
                                  "11px",
                                fontWeight:
                                  "600",
                              }}
                            >
                              Registered Provider
                            </p>
                          </div>
                        </div>
                      </td>
                      {/* ================================= */}
                      {/* PROVIDER ID */}
                      {/* ================================= */}
                      <td
                        style={{
                          padding:
                            "22px 20px",
                          borderBottom:
                            "1px solid #f1f5f9",
                          color:
                            "#6366f1",
                          fontWeight:
                            "800",
                          fontSize:
                            "12px",
                          whiteSpace:
                            "nowrap",
                          minWidth:
                            "170px",
                        }}
                      >
                        {
                          fetchedProviderId
                        }
                      </td>
                      {/* ================================= */}
                      {/* SERVICE */}
                      {/* ================================= */}
                      <td
                        style={{
                          padding:
                            "22px 20px",
                          borderBottom:
                            "1px solid #f1f5f9",
                          color:
                            "#334155",
                          fontSize:
                            "13px",
                          fontWeight:
                            "600",
                          minWidth:
                            "180px",
                        }}
                      >
                        {providerItem?.service ||
                          providerItem?.category ||
                          "General Service"}
                      </td>
                      {/* ================================= */}
                      {/* PHONE */}
                      {/* ================================= */}
                      <td
                        style={{
                          padding:
                            "22px 20px",
                          borderBottom:
                            "1px solid #f1f5f9",
                          color:
                            "#334155",
                          fontSize:
                            "13px",
                          minWidth:
                            "160px",
                        }}
                      >
                        {providerItem?.phone ||
                          providerItem?.mobile ||
                          "N/A"}
                      </td>
                      {/* ================================= */}
                      {/* EMAIL */}
                      {/* ================================= */}
                      <td
                        style={{
                          padding:
                            "22px 20px",
                          borderBottom:
                            "1px solid #f1f5f9",
                          color:
                            "#334155",
                          fontSize:
                            "13px",
                          minWidth:
                            "260px",
                          wordBreak:
                            "break-word",
                        }}
                      >
                        {providerItem?.email ||
                          "N/A"}
                      </td>
                      {/* ================================= */}
                      {/* STATUS */}
                      {/* ================================= */}
                      <td
                        style={{
                          padding:
                            "22px 20px",
                          borderBottom:
                            "1px solid #f1f5f9",
                          minWidth:
                            "140px",
                        }}
                      >
                        <div
                          style={{
                            display:
                              "inline-flex",
                            alignItems:
                              "center",
                            justifyContent:
                              "center",
                            padding:
                              "8px 16px",
                            borderRadius:
                              "999px",
                            fontSize:
                              "11px",
                            fontWeight:
                              "800",
                            textTransform:
                              "uppercase",
                            background:
                              providerItem?.status?.toLowerCase() ===
                              "approved"
                                ? "#dcfce7"
                                : providerItem?.status?.toLowerCase() ===
                                  "pending"
                                ? "#fef3c7"
                                : "#fee2e2",
                            color:
                              providerItem?.status?.toLowerCase() ===
                              "approved"
                                ? "#15803d"
                                : providerItem?.status?.toLowerCase() ===
                                  "pending"
                                ? "#b45309"
                                : "#dc2626",
                          }}
                        >
                          {providerItem?.status ||
                            "Unknown"}
                        </div>
                      </td>
                      {/* ================================= */}
                      {/* AVAILABILITY */}
                      {/* ================================= */}
                      <td
                        style={{
                          padding:
                            "22px 20px",
                          borderBottom:
                            "1px solid #f1f5f9",
                          fontWeight:
                            "800",
                          fontSize:
                            "12px",
                          minWidth:
                            "130px",
                          color:
                            providerItem?.online ||
                            providerItem?.isOnline
                              ? "#16a34a"
                              : "#dc2626",
                        }}
                      >
                        {providerItem?.online ||
                        providerItem?.isOnline
                          ? "ONLINE"
                          : "OFFLINE"}
                      </td>
                      {/* ================================= */}
                      {/* CREATED DATE */}
                      {/* ================================= */}
                      <td
                        style={{
                          padding:
                            "22px 20px",
                          borderBottom:
                            "1px solid #f1f5f9",
                          color:
                            "#334155",
                          fontSize:
                            "13px",
                          minWidth:
                            "160px",
                        }}
                      >
                        {providerCreatedDate
                          ? providerCreatedDate.toLocaleDateString()
                          : "N/A"}
                      </td>
                      {/* ================================= */}
                      {/* CITY */}
                      {/* ================================= */}
                      <td
                        style={{
                          padding:
                            "22px 20px",
                          borderBottom:
                            "1px solid #f1f5f9",
                          color:
                            "#334155",
                          fontSize:
                            "13px",
                          minWidth:
                            "140px",
                        }}
                      >
                        {providerItem?.city ||
                          providerItem?.location ||
                          "N/A"}
                      </td>
                      {/* ================================= */}
                      {/* RATING */}
                      {/* ================================= */}
                      <td
                        style={{
                          padding:
                            "22px 20px",
                          borderBottom:
                            "1px solid #f1f5f9",
                          color:
                            "#f59e0b",
                          fontSize:
                            "13px",
                          fontWeight:
                            "800",
                          minWidth:
                            "100px",
                        }}
                      >
                        ⭐
                        {" "}
                        {providerItem?.rating ||
                          "0"}
                      </td>
                    </tr>
                  );
                }
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
)}

{/*
  ============================================================================
  NOTES ON THIS UPDATE (read before pasting in)
  ============================================================================
  1. Row click: every <tr> (main table + modal table) now calls the same
     inspect handler on click. The "Inspect" button still works too, but it
     stops the click from bubbling twice.
  2. Underscore removal: a new `humanizeLabel()` helper turns things like
     "Home_D_Cleaning" -> "Home D Cleaning". It's applied to Category,
     Sub Category, Category Type, Suggested Category and Service Name for
     DISPLAY ONLY — the underlying record data is untouched.
  3. Audit log: the dossier now has an "Access & Audit Log" section that
     reads `record.audit_log` (expected shape: [{ user, action, timestamp }]).
     Opening a dossier also fires an optional `onLogAccess({ recordId,
     accessedBy, accessedAt, action })` callback so your backend can persist
     a real audit trail. If you don't pass `onLogAccess` / `currentUserName`
     as props yet, wire them up in the parent component — this file only
     calls them if they exist, so nothing breaks in the meantime.
  4. Approval view is now split into "Essentials" (always visible — what a
     reviewer actually needs) and "Technical / internal details" (Firebase
     IDs, lat/long, version, storage keys, etc.), hidden by default behind a
     "Show technical details" toggle. Latitude/longitude only render in the
     Essentials view if `record.requires_location_review` is truthy.
  5. Compacted padding/margins across the metric cards, toolbar and tables
     so the CRM view is denser and easier to scan. The dossier modal's own
     styling lives in your external `styles.*` object (not included in the
     snippet you sent), so trim padding there too if you want it tighter.
  6. Nothing was removed: all original sections, image/gallery handling,
     lightbox preview, search/filter, size controls, collapse/expand, and
     status modal logic are preserved as-is, just edited in place.
  7. IMPORTANT — data disappearing on refresh/login: this fragment only
     *renders* `filteredSubmissions` / `aggregateMetrics` that are handed to
     it as props. It has no fetch/query logic of its own, so I can't fix a
     disappearing-data bug from this file alone. That almost always means
     one of: (a) the Firestore query in the parent component is scoped to
     the logged-in user/provider instead of all pending services, (b) the
     listener unsubscribes or resets state before the new snapshot arrives,
     or (c) a loading/auth race condition clears `filteredSubmissions` to []
     on mount before data loads. Check the function that populates
     `filteredSubmissions` and `aggregateMetrics` (likely a useEffect +
     Firestore onSnapshot/getDocs call) and make sure it isn't filtered by
     the current user or reset on every re-render.
  ============================================================================
*/}
{/* Small display-only helper — strips underscores and title-cases text.
    Put this near the top of your component (above the return) if it isn't
    already available as a shared util. */}
{/*
const humanizeLabel = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  return String(value)
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};
// Local UI state for the dossier's technical-details toggle.
// (Assumes `useState` is already imported in the parent file.)
const [showTechnicalDetails, setShowTechnicalDetails] = useState(false);
// Fires the inspect handler + an optional audit-log callback together.
const handleInspectRecord = (record) => {
  onCommitServiceInspection(record);
  if (typeof onLogAccess === "function") {
    onLogAccess({
      recordId: record.service_id || record.id,
      accessedBy: currentUserName || "Unknown user",
      accessedAt: new Date().toISOString(),
      action: "viewed",
    });
  }
};
*/}
{/* ========================================================= */}
{/* ✅ SERVICE APPROVALS DASHBOARD (NEW SEPARATE DASHBOARD) */}
{/* ========================================================= */}
<div
  style={{
    width: "100%",
    display: "block",
    clear: "both",
    marginTop: "40px",
    marginBottom: "40px",
    position: "relative",
    zIndex: 1,
    background: "#f0f4ff",
    borderRadius: "32px",
    padding: "20px",
    boxSizing: "border-box",
  }}
>
  <div
    style={{
      width: "100%",
      minWidth: 0,
      maxWidth: `${dashboardSize ?? 100}%`,
      margin: "0 auto",
      transition: "all 0.4s ease",
      boxSizing: "border-box",
    }}
  >
    <div
      style={{
        width: "100%",
        background: "#ffffff",
        borderRadius: "28px",
        padding: "24px",
        border: "1px solid #dbe3f0",
        boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      {/* ============================================= */}
      {/* HEADER */}
      {/* ============================================= */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
          gap: "18px",
          marginBottom: isDashboardCollapsed ? "0px" : "20px",
          transition: "margin 0.3s ease",
        }}
      >
        <div style={{ flex: "1 1 260px", minWidth: 0 }}>
          <h2
            style={{
              margin: 0,
              color: "#111827",
              fontSize: "28px",
              fontWeight: "900",
              letterSpacing: "0.5px",
              lineHeight: "1.2",
              wordBreak: "break-word",
            }}
          >
            📑 SERVICE APPROVAL REGISTRY
          </h2>
          <p
            style={{
              color: "#6b7280",
              fontSize: "13px",
              fontWeight: "500",
              marginTop: "6px",
              marginBottom: 0,
            }}
          >
            Path: <code>admin_pending_approvals / services / pending</code>
          </p>
        </div>
        {/* Live Indicator, Size Selectors & Expand / Collapse Controls */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          {/* Sizing & Expand/Collapse Toolbar */}
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              background: "#F1F5F9",
              border: "1px solid #CBD5E1",
              borderRadius: "14px",
              padding: "4px",
              gap: "4px",
            }}
          >
            {/* Collapse Toggle Button */}
            <button
              type="button"
              onClick={() => setIsDashboardCollapsed(true)}
              title="Collapse entire list and contents"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
                padding: "8px 12px",
                borderRadius: "10px",
                border: "none",
                background: isDashboardCollapsed ? "#DC2626" : "transparent",
                color: isDashboardCollapsed ? "#ffffff" : "#475569",
                fontWeight: "800",
                fontSize: "12px",
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
            >
              ▲ Collapse
            </button>
            {/* Expand Toggle Button */}
            <button
              type="button"
              onClick={() => setIsDashboardCollapsed(false)}
              title="Expand entire list and contents"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
                padding: "8px 12px",
                borderRadius: "10px",
                border: "none",
                background: !isDashboardCollapsed ? "#2563EB" : "transparent",
                color: !isDashboardCollapsed ? "#ffffff" : "#475569",
                fontWeight: "800",
                fontSize: "12px",
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
            >
              ▼ Expand
            </button>
            <div style={{ width: "1px", height: "20px", background: "#CBD5E1", margin: "0 2px" }} />
            {/* Size Buttons: 25%, 50%, 75%, 100% */}
            {[25, 50, 75, 100].map((size) => {
              const isActive = !isDashboardCollapsed && (dashboardSize ?? 100) === size;
              return (
                <button
                  key={size}
                  type="button"
                  onClick={() => {
                    setDashboardSize(size);
                    setIsDashboardCollapsed(false);
                  }}
                  title={`Resize dashboard to ${size}%`}
                  style={{
                    padding: "8px 12px",
                    borderRadius: "10px",
                    border: "none",
                    background: isActive ? "#1E293B" : "transparent",
                    color: isActive ? "#ffffff" : "#475569",
                    fontWeight: "800",
                    fontSize: "12px",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                >
                  {size}%
                </button>
              );
            })}
          </div>
          <button
            type="button"
            onClick={onRetryQueueSync}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              padding: "10px 18px",
              borderRadius: "14px",
              border: "none",
              background: "linear-gradient(135deg,#2563eb,#1d4ed8)",
              color: "#ffffff",
              fontWeight: "800",
              fontSize: "13px",
              cursor: "pointer",
              boxShadow: "0 8px 20px rgba(37,99,235,0.25)",
            }}
          >
            🔄 Refresh Data
          </button>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "8px 14px",
              borderRadius: "999px",
              background: "#ffffff",
              border: "1px solid #dbe3f0",
              boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
            }}
          >
            <div
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                background: "#22c55e",
                boxShadow: "0 0 10px rgba(34,197,94,0.6)",
              }}
            />
            <span
              style={{
                color: "#111827",
                fontSize: "13px",
                fontWeight: "800",
                letterSpacing: "0.4px",
              }}
            >
              LIVE APPROVALS
            </span>
          </div>
        </div>
      </div>
      {/* ============================================= */}
      {/* COLLAPSIBLE WRAPPER (THE WHOLE LIST & CONTENTS) */}
      {/* ============================================= */}
      {isDashboardCollapsed ? (
        <div
          onClick={() => setIsDashboardCollapsed(false)}
          style={{
            padding: "20px",
            textAlign: "center",
            background: "#F8FAFC",
            borderRadius: "18px",
            border: "2px dashed #CBD5E1",
            color: "#64748B",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            marginTop: "10px",
            transition: "all 0.3s ease",
          }}
        >
          📁 Dashboard list and contents are collapsed. Click here or click <strong>▼ Expand</strong> / <strong>[25%, 50%, 75%, 100%]</strong> to view.
        </div>
      ) : (
        <div style={{ width: "100%", transition: "all 0.4s ease" }}>
          {/* ============================================= */}
          {/* STATUS METRICS / COUNTERS MATRIX */}
          {/* ============================================= */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
              gap: "12px",
              marginBottom: "18px",
            }}
          >
            {/* TOTAL SERVICES */}
            <div
              onClick={() => setStatusModalFilter("total")}
              title="Click to view all submitted services"
              style={{
                background: "#EEF2FF",
                border: "1px solid #C7D2FE",
                borderRadius: "18px",
                padding: "14px 16px",
                boxShadow: "0 8px 20px rgba(79,70,229,0.06)",
                cursor: "pointer",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow = "0 12px 26px rgba(79,70,229,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "none";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(79,70,229,0.06)";
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <p style={{ margin: 0, color: "#4338CA", fontSize: "12px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                  Total Services
                </p>
                <span style={{ fontSize: "11px" }}>👁️</span>
              </div>
              <h2 style={{ margin: "6px 0 0 0", color: "#1E1B4B", fontSize: "30px", fontWeight: "900", lineHeight: 1 }}>
                {aggregateMetrics?.totalSubmissions ?? filteredSubmissions?.length ?? 0}
              </h2>
              <span style={{ fontSize: "10px", color: "#6366F1", fontWeight: "600", display: "block", marginTop: "6px" }}>
                All submitted entries
              </span>
            </div>
            {/* NEW SERVICES */}
            <div
              onClick={() => setStatusModalFilter("new")}
              title="Click to view new services"
              style={{
                background: "#E0F2FE",
                border: "1px solid #BAE6FD",
                borderRadius: "18px",
                padding: "14px 16px",
                boxShadow: "0 8px 20px rgba(2,132,199,0.06)",
                cursor: "pointer",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow = "0 12px 26px rgba(2,132,199,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "none";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(2,132,199,0.06)";
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <p style={{ margin: 0, color: "#0369A1", fontSize: "12px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                  New Services
                </p>
                <span style={{ fontSize: "11px" }}>👁️</span>
              </div>
              <h2 style={{ margin: "6px 0 0 0", color: "#0C4A6E", fontSize: "30px", fontWeight: "900", lineHeight: 1 }}>
                {aggregateMetrics?.newSubmissions ??
                  (filteredSubmissions || []).filter(
                    (r) =>
                      (r.approval_status || r.status || "").toLowerCase() === "new" ||
                      r.is_new === true ||
                      r.isNew === true
                  ).length}
              </h2>
              <span style={{ fontSize: "10px", color: "#0284C7", fontWeight: "600", display: "block", marginTop: "6px" }}>
                Fresh submissions
              </span>
            </div>
            {/* PENDING SERVICES */}
            <div
              onClick={() => setStatusModalFilter("pending")}
              title="Click to view pending services"
              style={{
                background: "#FEF3C7",
                border: "1px solid #FDE68A",
                borderRadius: "18px",
                padding: "14px 16px",
                boxShadow: "0 8px 20px rgba(217,119,6,0.06)",
                cursor: "pointer",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow = "0 12px 26px rgba(217,119,6,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "none";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(217,119,6,0.06)";
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <p style={{ margin: 0, color: "#B45309", fontSize: "12px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                  Pending Review
                </p>
                <span style={{ fontSize: "11px" }}>👁️</span>
              </div>
              <h2 style={{ margin: "6px 0 0 0", color: "#78350F", fontSize: "30px", fontWeight: "900", lineHeight: 1 }}>
                {aggregateMetrics?.pendingReview ??
                  (filteredSubmissions || []).filter(
                    (r) => (r.approval_status || r.status || "pending").toLowerCase() === "pending"
                  ).length}
              </h2>
              <span style={{ fontSize: "10px", color: "#D97706", fontWeight: "600", display: "block", marginTop: "6px" }}>
                Awaiting decision
              </span>
            </div>
            {/* APPROVED SERVICES */}
            <div
              onClick={() => setStatusModalFilter("approved")}
              title="Click to view approved services"
              style={{
                background: "#DCFCE7",
                border: "1px solid #BBF7D0",
                borderRadius: "18px",
                padding: "14px 16px",
                boxShadow: "0 8px 20px rgba(22,163,74,0.06)",
                cursor: "pointer",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow = "0 12px 26px rgba(22,163,74,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "none";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(22,163,74,0.06)";
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <p style={{ margin: 0, color: "#15803D", fontSize: "12px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                  Approved
                </p>
                <span style={{ fontSize: "11px" }}>👁️</span>
              </div>
              <h2 style={{ margin: "6px 0 0 0", color: "#14532D", fontSize: "30px", fontWeight: "900", lineHeight: 1 }}>
                {aggregateMetrics?.approvedSubmissions ??
                  (filteredSubmissions || []).filter(
                    (r) =>
                      (r.approval_status || r.status || "").toLowerCase() === "approved" ||
                      r.is_approved === true
                  ).length}
              </h2>
              <span style={{ fontSize: "10px", color: "#16A34A", fontWeight: "600", display: "block", marginTop: "6px" }}>
                Verified & live
              </span>
            </div>
            {/* REJECTED SERVICES */}
            <div
              onClick={() => setStatusModalFilter("rejected")}
              title="Click to view rejected services"
              style={{
                background: "#FEE2E2",
                border: "1px solid #FECACA",
                borderRadius: "18px",
                padding: "14px 16px",
                boxShadow: "0 8px 20px rgba(220,38,38,0.06)",
                cursor: "pointer",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow = "0 12px 26px rgba(220,38,38,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "none";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(220,38,38,0.06)";
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <p style={{ margin: 0, color: "#B91C1C", fontSize: "12px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                  Rejected
                </p>
                <span style={{ fontSize: "11px" }}>👁️</span>
              </div>
              <h2 style={{ margin: "6px 0 0 0", color: "#7F1D1D", fontSize: "30px", fontWeight: "900", lineHeight: 1 }}>
                {aggregateMetrics?.rejectedSubmissions ??
                  (filteredSubmissions || []).filter(
                    (r) => (r.approval_status || r.status || "").toLowerCase() === "rejected"
                  ).length}
              </h2>
              <span style={{ fontSize: "10px", color: "#DC2626", fontWeight: "600", display: "block", marginTop: "6px" }}>
                Denied or declined
              </span>
            </div>
          </div>
          {/* ============================================= */}
          {/* SEARCH & FILTER TOOLBAR */}
          {/* ============================================= */}
          <div
            style={{
              background: "#F9FAFB",
              padding: "12px 16px",
              borderRadius: "16px",
              marginBottom: "16px",
              border: "1px solid #E5E7EB",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "12px",
            }}
          >
            <input
              type="text"
              placeholder="🔍 Search services, providers, categories, or identifiers..."
              value={filterQueryToken}
              onChange={onFilterQueryChange}
              style={{
                flex: "1 1 300px",
                minWidth: "240px",
                maxWidth: "500px",
                padding: "10px 14px",
                borderRadius: "12px",
                border: "1px solid #D1D5DB",
                outline: "none",
                fontSize: "14px",
                background: "#ffffff",
                boxShadow: "0 2px 6px rgba(0,0,0,0.02)",
              }}
            />
            <div style={{ display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>
              <span
                style={{
                  fontSize: "13px",
                  color: "#374151",
                  fontWeight: "700",
                  background: "#ffffff",
                  padding: "6px 14px",
                  borderRadius: "10px",
                  border: "1px solid #E5E7EB",
                }}
              >
                Showing <strong>{filteredSubmissions?.length || 0}</strong> records
              </span>
            </div>
          </div>
          {/* ============================================= */}
          {/* TABULAR REGISTRY LOGS SECTION */}
          {/* ============================================= */}
          <div
            style={{
              width: "100%",
              overflowX: "auto",
              background: "#ffffff",
              borderRadius: "18px",
              border: "1px solid #E5E7EB",
              boxShadow: "0 4px 20px rgba(0,0,0,0.02)",
            }}
          >
            {isSynchronizing ? (
              <div style={{ padding: "60px 20px", textAlign: "center", fontWeight: "700", color: "#6B7280", fontSize: "16px" }}>
                ⏳ Synchronizing approvals from Firestore database...
              </div>
            ) : syncFaultMessage ? (
              <div
                style={{
                  background: "#FEE2E2",
                  color: "#DC2626",
                  padding: "20px",
                  borderRadius: "16px",
                  margin: "16px",
                  textAlign: "center",
                }}
              >
                <p style={{ margin: "0 0 10px 0", fontWeight: "700" }}>{syncFaultMessage}</p>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={onRetryQueueSync}
                  style={{
                    padding: "10px 20px",
                    borderRadius: "10px",
                    border: "none",
                    background: "#DC2626",
                    color: "#fff",
                    fontWeight: "700",
                    cursor: "pointer",
                  }}
                >
                  Retry Synchronization
                </button>
              </div>
            ) : (
              <table style={{ width: "100%", minWidth: "1050px", borderCollapse: "collapse", tableLayout: "auto" }}>
                <thead style={{ background: "#F8FAFC", position: "sticky", top: 0, zIndex: 1 }}>
                  <tr>
                    <th
                      style={{
                        padding: "10px 14px",
                        fontSize: "12px",
                        fontWeight: "800",
                        color: "#0747A6",
                        background: "#EEF2FF",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                        textTransform: "uppercase",
                        borderBottom: "1px solid #E5E7EB",
                      }}
                    >
                      Service
                    </th>
                    <th
                      style={{
                        padding: "10px 14px",
                        fontSize: "12px",
                        fontWeight: "800",
                        color: "#4B5563",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                        textTransform: "uppercase",
                        borderBottom: "1px solid #E5E7EB",
                      }}
                    >
                      Category
                    </th>
                    <th
                      style={{
                        padding: "10px 14px",
                        fontSize: "12px",
                        fontWeight: "800",
                        color: "#4B5563",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                        textTransform: "uppercase",
                        borderBottom: "1px solid #E5E7EB",
                      }}
                    >
                      Provider
                    </th>
                    <th
                      style={{
                        padding: "10px 14px",
                        fontSize: "12px",
                        fontWeight: "800",
                        color: "#4B5563",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                        textTransform: "uppercase",
                        borderBottom: "1px solid #E5E7EB",
                      }}
                    >
                      Price
                    </th>
                    <th
                      style={{
                        padding: "10px 14px",
                        fontSize: "12px",
                        fontWeight: "800",
                        color: "#4B5563",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                        textTransform: "uppercase",
                        borderBottom: "1px solid #E5E7EB",
                      }}
                    >
                      Status
                    </th>
                    <th
                      style={{
                        padding: "10px 14px",
                        fontSize: "12px",
                        fontWeight: "800",
                        color: "#4B5563",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                        textTransform: "uppercase",
                        borderBottom: "1px solid #E5E7EB",
                      }}
                    >
                      Approval
                    </th>
                    <th
                      style={{
                        padding: "10px 14px",
                        fontSize: "12px",
                        fontWeight: "800",
                        color: "#4B5563",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                        textTransform: "uppercase",
                        borderBottom: "1px solid #E5E7EB",
                      }}
                    >
                      Submitted At
                    </th>
                    <th
                      style={{
                        padding: "10px 14px",
                        fontSize: "12px",
                        fontWeight: "800",
                        color: "#4B5563",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        textTransform: "uppercase",
                        borderBottom: "1px solid #E5E7EB",
                      }}
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredSubmissions && filteredSubmissions.length > 0 ? (
                    filteredSubmissions.map((record, index) => {
                      const statusVal = record.approval_status || record.status || "pending";
                      const isApproved = statusVal.toLowerCase() === "approved";
                      const isRejected = statusVal.toLowerCase() === "rejected";
                      return (
                        <tr
                          key={record.id || record.service_id || index}
                          onClick={() => handleInspectRecord(record)}
                          style={{
                            background: index % 2 === 0 ? "#ffffff" : "#F9FAFB",
                            borderBottom: "1px solid #E5E7EB",
                            transition: "background 0.15s ease",
                            cursor: "pointer",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#EEF2FF";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = index % 2 === 0 ? "#ffffff" : "#F9FAFB";
                          }}
                        >
                          {/* Service Name & ID */}
                          <td style={{ padding: "10px 14px", fontSize: "14px" }}>
                            <div style={{ fontWeight: "800", color: "#111827" }}>
                              {humanizeLabel(record.service_name) || "Unnamed Service"}
                            </div>
                            <div style={{ fontSize: "12px", color: "#6B7280", marginTop: "2px" }}>
                              ID: {record.service_id || record.id || "—"}
                            </div>
                          </td>
                          {/* Category */}
                          <td style={{ padding: "10px 14px", fontSize: "13px", color: "#374151" }}>
                            <div style={{ fontWeight: "700" }}>{humanizeLabel(record.category)}</div>
                            {record.sub_category && (
                              <div style={{ fontSize: "12px", color: "#6B7280", marginTop: "2px" }}>
                                {humanizeLabel(record.sub_category)}
                              </div>
                            )}
                          </td>
                          {/* Provider */}
                          <td style={{ padding: "10px 14px", fontSize: "13px" }}>
                            <div style={{ fontWeight: "800", color: "#111827" }}>
                              {record.provider_name || "—"}
                            </div>
                            <div style={{ fontSize: "12px", color: "#6B7280" }}>
                              {record.provider_email || "—"}
                            </div>
                          </td>
                          {/* Price */}
                          <td style={{ padding: "10px 14px", fontSize: "14px", color: "#111827", whiteSpace: "nowrap" }}>
                            <strong>£{record.price ?? 0}</strong>
                          </td>
                          {/* Lifecycle Status */}
                          <td style={{ padding: "10px 14px" }}>
                            <span
                              style={{
                                background: record.status === "active" ? "#DCFCE7" : "#F3F4F6",
                                color: record.status === "active" ? "#166534" : "#4B5563",
                                padding: "5px 11px",
                                borderRadius: "999px",
                                fontSize: "11px",
                                fontWeight: "800",
                                textTransform: "capitalize",
                                display: "inline-block",
                              }}
                            >
                              {humanizeLabel(record.status || "pending")}
                            </span>
                          </td>
                          {/* Approval Status */}
                          <td style={{ padding: "10px 14px" }}>
                            <span
                              style={{
                                background: isApproved
                                  ? "#DCFCE7"
                                  : isRejected
                                  ? "#FEE2E2"
                                  : "#FEF3C7",
                                color: isApproved
                                  ? "#166534"
                                  : isRejected
                                  ? "#991B1B"
                                  : "#92400E",
                                padding: "5px 11px",
                                borderRadius: "999px",
                                fontSize: "11px",
                                fontWeight: "800",
                                textTransform: "capitalize",
                                display: "inline-block",
                              }}
                            >
                              {humanizeLabel(statusVal)}
                            </span>
                          </td>
                          {/* Submitted At */}
                          <td style={{ padding: "10px 14px", fontSize: "13px", color: "#374151", whiteSpace: "nowrap" }}>
                            {sanitizeDisplayToken(record.submitted_at)}
                          </td>
                          {/* Inspect Action */}
                          <td style={{ padding: "10px 14px", textAlign: "center" }}>
                            <button
                              type="button"
                              style={{
                                padding: "7px 14px",
                                fontSize: "12px",
                                borderRadius: "10px",
                                background: "#EEF2FF",
                                color: "#4338CA",
                                border: "1px solid #C7D2FE",
                                fontWeight: "800",
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleInspectRecord(record);
                              }}
                            >
                              🔍 Inspect
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan={8}
                        style={{ textAlign: "center", padding: "60px 20px", fontWeight: "700", color: "#6B7280" }}
                      >
                        No service approvals found matching your search.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </div>
  </div>
</div>
{/* ========================================================= */}
{/* ✅ DEDICATED STATUS GROUP SERVICES MODAL WINDOW */}
{/* ========================================================= */}
{statusModalFilter && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(15, 23, 42, 0.7)",
      backdropFilter: "blur(6px)",
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "20px",
      boxSizing: "border-box",
    }}
    onClick={() => setStatusModalFilter(null)}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        background: "#ffffff",
        borderRadius: "24px",
        width: "100%",
        maxWidth: "1150px",
        maxHeight: "90vh",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 25px 60px rgba(0,0,0,0.28)",
        overflow: "hidden",
        border: "1px solid #E2E8F0",
      }}
    >
      {/* MODAL HEADER */}
      {(() => {
        const configMap = {
          total: { title: "Total Submitted Services", color: "#4338CA", bg: "#EEF2FF", border: "#C7D2FE" },
          new: { title: "New Services Queue", color: "#0369A1", bg: "#E0F2FE", border: "#BAE6FD" },
          pending: { title: "Pending Review Services", color: "#B45309", bg: "#FEF3C7", border: "#FDE68A" },
          approved: { title: "Approved Services Registry", color: "#15803D", bg: "#DCFCE7", border: "#BBF7D0" },
          rejected: { title: "Rejected Services Log", color: "#B91C1C", bg: "#FEE2E2", border: "#FECACA" },
        };
        const currentConfig = configMap[statusModalFilter] || configMap.total;
        const modalRecords = (filteredSubmissions || []).filter((r) => {
          const statusVal = (r.approval_status || r.status || "pending").toLowerCase();
          if (statusModalFilter === "new") {
            return statusVal === "new" || r.is_new === true || r.isNew === true;
          }
          if (statusModalFilter === "pending") {
            return statusVal === "pending";
          }
          if (statusModalFilter === "approved") {
            return statusVal === "approved" || r.is_approved === true;
          }
          if (statusModalFilter === "rejected") {
            return statusVal === "rejected";
          }
          return true; // 'total'
        });
        return (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "18px 24px",
                borderBottom: "1px solid #E2E8F0",
                background: currentConfig.bg,
              }}
            >
              <div>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "900", color: currentConfig.color }}>
                    {currentConfig.title}
                  </h2>
                  <span
                    style={{
                      background: currentConfig.color,
                      color: "#ffffff",
                      fontSize: "12px",
                      fontWeight: "800",
                      padding: "4px 12px",
                      borderRadius: "999px",
                    }}
                  >
                    {modalRecords.length} Services
                  </span>
                </div>
                <p style={{ margin: "4px 0 0 0", fontSize: "13px", color: "#475569", fontWeight: "600" }}>
                  Showing all matching items categorized under status: <strong>{statusModalFilter.toUpperCase()}</strong>
                </p>
              </div>
              <button
                type="button"
                onClick={() => setStatusModalFilter(null)}
                style={{
                  width: "34px",
                  height: "34px",
                  borderRadius: "50%",
                  border: "none",
                  background: "#ffffff",
                  color: "#1E293B",
                  fontSize: "18px",
                  fontWeight: "900",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                }}
              >
                ✕
              </button>
            </div>
            {/* SCROLLABLE LIST TABLE */}
            <div style={{ padding: "16px 24px", overflowY: "auto", flex: "1 1 auto" }}>
              {modalRecords.length === 0 ? (
                <div style={{ padding: "50px 20px", textAlign: "center", color: "#64748B", fontWeight: "700" }}>
                  No services found for status: <strong>{statusModalFilter}</strong>.
                </div>
              ) : (
                <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
                  <thead>
                    <tr style={{ borderBottom: "2px solid #E2E8F0", color: "#475569", fontSize: "12px", textTransform: "uppercase" }}>
                      <th style={{ padding: "10px 12px" }}>Service</th>
                      <th style={{ padding: "10px 12px" }}>Category</th>
                      <th style={{ padding: "10px 12px" }}>Provider</th>
                      <th style={{ padding: "10px 12px" }}>Price</th>
                      <th style={{ padding: "10px 12px" }}>Status</th>
                      <th style={{ padding: "10px 12px" }}>Submitted</th>
                      <th style={{ padding: "10px 12px", textAlign: "center" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modalRecords.map((record, index) => {
                      const stat = record.approval_status || record.status || "pending";
                      return (
                        <tr
                          key={record.id || record.service_id || index}
                          onClick={() => {
                            setStatusModalFilter(null);
                            handleInspectRecord(record);
                          }}
                          style={{
                            borderBottom: "1px solid #F1F5F9",
                            background: index % 2 === 0 ? "#ffffff" : "#F8FAFC",
                            cursor: "pointer",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#EEF2FF";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = index % 2 === 0 ? "#ffffff" : "#F8FAFC";
                          }}
                        >
                          <td style={{ padding: "12px", fontSize: "13px" }}>
                            <div style={{ fontWeight: "800", color: "#1E293B" }}>
                              {humanizeLabel(record.service_name) || "Unnamed Service"}
                            </div>
                            <div style={{ fontSize: "11px", color: "#64748B", marginTop: "2px" }}>
                              ID: {record.service_id || record.id || "—"}
                            </div>
                          </td>
                          <td style={{ padding: "12px", fontSize: "13px", color: "#334155" }}>
                            <div style={{ fontWeight: "700" }}>{humanizeLabel(record.category)}</div>
                            {record.sub_category && (
                              <div style={{ fontSize: "11px", color: "#64748B" }}>{humanizeLabel(record.sub_category)}</div>
                            )}
                          </td>
                          <td style={{ padding: "12px", fontSize: "13px" }}>
                            <div style={{ fontWeight: "700", color: "#1E293B" }}>{record.provider_name || "—"}</div>
                            <div style={{ fontSize: "11px", color: "#64748B" }}>{record.provider_email || "—"}</div>
                          </td>
                          <td style={{ padding: "12px", fontSize: "13px", fontWeight: "800", color: "#1E293B" }}>
                            £{record.price ?? 0}
                          </td>
                          <td style={{ padding: "12px" }}>
                            <span
                              style={{
                                padding: "4px 10px",
                                borderRadius: "999px",
                                fontSize: "11px",
                                fontWeight: "800",
                                textTransform: "capitalize",
                                background:
                                  stat.toLowerCase() === "approved"
                                    ? "#DCFCE7"
                                    : stat.toLowerCase() === "rejected"
                                    ? "#FEE2E2"
                                    : "#FEF3C7",
                                color:
                                  stat.toLowerCase() === "approved"
                                    ? "#166534"
                                    : stat.toLowerCase() === "rejected"
                                    ? "#991B1B"
                                    : "#92400E",
                              }}
                            >
                              {humanizeLabel(stat)}
                            </span>
                          </td>
                          <td style={{ padding: "12px", fontSize: "12px", color: "#475569" }}>
                            {sanitizeDisplayToken(record.submitted_at)}
                          </td>
                          <td style={{ padding: "12px", textAlign: "center" }}>
                            <button
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                setStatusModalFilter(null);
                                handleInspectRecord(record);
                              }}
                              style={{
                                padding: "6px 14px",
                                borderRadius: "8px",
                                background: "#EEF2FF",
                                border: "1px solid #C7D2FE",
                                color: "#4338CA",
                                fontSize: "12px",
                                fontWeight: "800",
                                cursor: "pointer",
                              }}
                            >
                              🔍 Inspect
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
            {/* MODAL FOOTER */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "12px 24px",
                borderTop: "1px solid #E2E8F0",
                background: "#F8FAFC",
              }}
            >
              <button
                type="button"
                onClick={() => setStatusModalFilter(null)}
                style={{
                  padding: "9px 20px",
                  borderRadius: "12px",
                  background: "#1E293B",
                  color: "#ffffff",
                  border: "none",
                  fontWeight: "800",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
              >
                Close Window
              </button>
            </div>
          </>
        );
      })()}
    </div>
  </div>
)}
{/* ========================================================= */}
{/* ✅ DETAILED INSPECTION DOSSIER MODAL — "Approval View" */}
{/* Shows only what's needed to make an approval decision by   */}
{/* default. Technical/internal fields are hidden behind a     */}
{/* toggle so a new CRM user isn't overwhelmed.                */}
{/* ========================================================= */}
{isDossierActive && inspectedServiceDossier && (
  <div style={styles.dossierBackdropSurface} onClick={onDismissServiceInspection}>
    <div style={styles.dossierModalShell} onClick={(e) => e.stopPropagation()}>
      {/* MODAL HEADER */}
      <div style={styles.dossierSectionHeader}>
        <div>
          <h2 style={styles.dossierPrimaryTitle}>
            {humanizeLabel(inspectedServiceDossier.service_name) || "Service Dossier"}
          </h2>
          <p style={styles.dossierContextSubtitle}>
            Service ID: {inspectedServiceDossier.service_id || inspectedServiceDossier.id}
          </p>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <button
            type="button"
            onClick={() => setShowTechnicalDetails((prev) => !prev)}
            style={{
              padding: "8px 14px",
              borderRadius: "10px",
              border: "1px solid #CBD5E1",
              background: showTechnicalDetails ? "#1E293B" : "#F1F5F9",
              color: showTechnicalDetails ? "#ffffff" : "#475569",
              fontWeight: "800",
              fontSize: "12px",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            {showTechnicalDetails ? "🔧 Hide technical details" : "🔧 Show technical details"}
          </button>
          <button
            type="button"
            style={styles.circularDismissAction}
            onClick={onDismissServiceInspection}
          >
            ×
          </button>
        </div>
      </div>
      {/* SCROLLABLE DOSSIER BODY */}
      <div style={styles.dossierScrollableContent}>
        {/* ---------- ESSENTIALS: what a reviewer needs to decide ---------- */}
        <div style={styles.sectionHeaderSeparator}>Service Details</div>
        <div style={styles.attributeMatrixGrid}>
          <AttributeFieldBlock label="Service ID" value={inspectedServiceDossier.service_id} />
          <AttributeFieldBlock label="Service Name" value={humanizeLabel(inspectedServiceDossier.service_name)} />
          <AttributeFieldBlock label="Category" value={humanizeLabel(inspectedServiceDossier.category)} />
          <AttributeFieldBlock label="Sub Category" value={humanizeLabel(inspectedServiceDossier.sub_category)} />
          <AttributeFieldBlock label="Description" value={inspectedServiceDossier.description} spansFullWidth />
        </div>
        <div style={styles.sectionHeaderSeparator}>Provider Details</div>
        <div style={styles.attributeMatrixGrid}>
          <AttributeFieldBlock label="Provider Name" value={inspectedServiceDossier.provider_name} />
          <AttributeFieldBlock label="Provider Email" value={inspectedServiceDossier.provider_email} />
          {/* Address / lat-long only shown here if an actual approval rule requires it */}
          {inspectedServiceDossier.requires_location_review && (
            <>
              <AttributeFieldBlock label="Physical Address" value={inspectedServiceDossier.address} spansFullWidth />
              <AttributeFieldBlock label="Latitude" value={inspectedServiceDossier.latitude} />
              <AttributeFieldBlock label="Longitude" value={inspectedServiceDossier.longitude} />
            </>
          )}
        </div>
        <div style={styles.sectionHeaderSeparator}>Pricing</div>
        <div style={styles.attributeMatrixGrid}>
          <AttributeFieldBlock label="Base Price" value={`£${inspectedServiceDossier.price ?? 0}`} />
          <AttributeFieldBlock label="Discount" value={`${inspectedServiceDossier.discount ?? 0}%`} />
          <AttributeFieldBlock label="Duration (Hours)" value={inspectedServiceDossier.duration_hour} />
          <AttributeFieldBlock label="Duration (Minutes)" value={inspectedServiceDossier.duration_mins} />
        </div>
        <div style={styles.sectionHeaderSeparator}>Approval Decision</div>
        <div style={styles.attributeMatrixGrid}>
          <AttributeFieldBlock label="Approval Status" value={humanizeLabel(inspectedServiceDossier.approval_status)} />
          <AttributeFieldBlock label="Rejection Reason" value={inspectedServiceDossier.rejection_reason} />
          <AttributeFieldBlock label="Reviewed By" value={inspectedServiceDossier.reviewed_by} />
          <AttributeFieldBlock label="Reviewed At" value={inspectedServiceDossier.reviewed_at} />
        </div>
        {/* ---------- GALLERY & MEDIA (always visible — never hidden) ---------- */}
        <div style={styles.sectionHeaderSeparator}>Service Images / Media</div>
        <div style={{ marginTop: "8px" }}>
          <div style={styles.mediaAssetGrid}>
            {Array.isArray(inspectedServiceDossier.gallery_images) &&
            inspectedServiceDossier.gallery_images.length > 0 ? (
              inspectedServiceDossier.gallery_images.map((imgUrl, index) => {
                const validSrc = typeof imgUrl === "string" ? imgUrl : imgUrl?.url;
                if (!validSrc) return null;
                return (
                  <div
                    key={index}
                    style={styles.mediaThumbnailFrame}
                    onClick={() => onActivateMediaPreview(validSrc)}
                  >
                    <img src={validSrc} alt={`Gallery asset ${index + 1}`} style={styles.mediaElementBitmap} />
                    <div style={styles.mediaHoverInteractionLayer}>🔍 View</div>
                  </div>
                );
              })
            ) : (
              <p style={styles.subduedTextToken}>No gallery images provided.</p>
            )}
          </div>
        </div>
        {/* ---------- ACCESS & AUDIT LOG (always visible) ---------- */}
        <div style={styles.sectionHeaderSeparator}>Access & Audit Log</div>
        <div style={{ marginTop: "8px", overflowX: "auto" }}>
          {Array.isArray(inspectedServiceDossier.audit_log) && inspectedServiceDossier.audit_log.length > 0 ? (
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
              <thead>
                <tr style={{ borderBottom: "1px solid #E2E8F0", color: "#64748B", textTransform: "uppercase" }}>
                  <th style={{ textAlign: "left", padding: "8px 10px" }}>User</th>
                  <th style={{ textAlign: "left", padding: "8px 10px" }}>Action</th>
                  <th style={{ textAlign: "left", padding: "8px 10px" }}>Timestamp</th>
                </tr>
              </thead>
              <tbody>
                {inspectedServiceDossier.audit_log
                  .slice()
                  .sort((a, b) => new Date(b.timestamp || 0) - new Date(a.timestamp || 0))
                  .map((entry, idx) => (
                    <tr key={idx} style={{ borderBottom: "1px solid #F1F5F9" }}>
                      <td style={{ padding: "8px 10px", fontWeight: "700", color: "#1E293B" }}>
                        {entry.user || entry.accessedBy || "Unknown user"}
                      </td>
                      <td style={{ padding: "8px 10px", color: "#374151" }}>
                        {humanizeLabel(entry.action || "viewed")}
                      </td>
                      <td style={{ padding: "8px 10px", color: "#475569" }}>
                        {sanitizeDisplayToken(entry.timestamp || entry.accessedAt)}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          ) : (
            <p style={styles.subduedTextToken}>No audit history recorded yet for this service.</p>
          )}
        </div>
        {/* ---------- TECHNICAL / INTERNAL DETAILS (hidden by default) ---------- */}
        {showTechnicalDetails && (
          <>
            <div style={styles.sectionHeaderSeparator}>Technical & Internal Details</div>
            <div style={styles.attributeMatrixGrid}>
              <AttributeFieldBlock label="Category Type" value={humanizeLabel(inspectedServiceDossier.category_type)} />
              <AttributeFieldBlock label="Suggested Category" value={humanizeLabel(inspectedServiceDossier.suggest_category)} />
              <AttributeFieldBlock label="Provider ID" value={inspectedServiceDossier.provider_id} />
              {!inspectedServiceDossier.requires_location_review && (
                <>
                  <AttributeFieldBlock label="Latitude" value={inspectedServiceDossier.latitude} />
                  <AttributeFieldBlock label="Longitude" value={inspectedServiceDossier.longitude} />
                  <AttributeFieldBlock label="Physical Address" value={inspectedServiceDossier.address} spansFullWidth />
                </>
              )}
              <AttributeFieldBlock label="Lifecycle Status" value={humanizeLabel(inspectedServiceDossier.status)} />
              <AttributeFieldBlock label="Is Approved" value={inspectedServiceDossier.is_approved ? "true" : "false"} />
              <AttributeFieldBlock label="Is Active" value={inspectedServiceDossier.is_active ? "true" : "false"} />
              <AttributeFieldBlock label="Featured Item" value={inspectedServiceDossier.set_as_feature} />
              <AttributeFieldBlock label="Edited By Provider" value={inspectedServiceDossier.edited_by_provider} />
              <AttributeFieldBlock label="Contains Videos" value={inspectedServiceDossier.has_videos} />
              <AttributeFieldBlock label="Total Media Count" value={inspectedServiceDossier.total_media_count} />
              <AttributeFieldBlock label="Document Version" value={inspectedServiceDossier.version} />
              <AttributeFieldBlock label="Storage Image Name" value={inspectedServiceDossier.storage_img_name} />
              <AttributeFieldBlock label="Created At" value={inspectedServiceDossier.created_at} />
              <AttributeFieldBlock label="Updated At" value={inspectedServiceDossier.updated_at} />
              <AttributeFieldBlock label="Submitted At" value={inspectedServiceDossier.submitted_at} />
              <AttributeFieldBlock label="Submitted For Review At" value={inspectedServiceDossier.submitted_for_review_at} />
            </div>
            <div style={styles.sectionHeaderSeparator}>Search Indexing & Tools</div>
            <div style={styles.attributeMatrixGrid}>
              <div style={{ ...styles.attributeFieldPanel, gridColumn: "1 / -1" }}>
                <span style={styles.attributeDescriptorTag}>Search Keywords</span>
                <div style={styles.tokenClusterWrapper}>
                  {Array.isArray(inspectedServiceDossier.search_keywords) &&
                  inspectedServiceDossier.search_keywords.length > 0 ? (
                    inspectedServiceDossier.search_keywords.map((kwItem, index) => {
                      const keywordText =
                        typeof kwItem === "object" && kwItem !== null
                          ? kwItem.name || kwItem.keyword || JSON.stringify(kwItem)
                          : String(kwItem);
                      return (
                        <span key={index} style={styles.metadataTagBadge}>
                          {humanizeLabel(keywordText)}
                        </span>
                      );
                    })
                  ) : (
                    <span style={styles.subduedTextToken}>No keywords indexed</span>
                  )}
                </div>
              </div>
              <div style={{ ...styles.attributeFieldPanel, gridColumn: "1 / -1" }}>
                <span style={styles.attributeDescriptorTag}>Tools Catalog</span>
                <div style={styles.tokenClusterWrapper}>
                  {Array.isArray(inspectedServiceDossier.tools) &&
                  inspectedServiceDossier.tools.length > 0 ? (
                    inspectedServiceDossier.tools.map((toolItem, index) => {
                      let toolRepresentation = "";
                      if (typeof toolItem === "string") {
                        toolRepresentation = humanizeLabel(toolItem);
                      } else if (typeof toolItem === "object" && toolItem !== null) {
                        toolRepresentation = toolItem.name
                          ? `${humanizeLabel(toolItem.name)}${toolItem.quantity !== undefined ? ` (x${toolItem.quantity})` : ""}`
                          : JSON.stringify(toolItem);
                      } else {
                        toolRepresentation = String(toolItem);
                      }
                      return (
                        <span key={index} style={styles.metadataTagBadge}>
                          {toolRepresentation}
                        </span>
                      );
                    })
                  ) : (
                    <span style={styles.subduedTextToken}>No tools recorded</span>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      {/* MODAL FOOTER */}
      <div style={styles.dossierActionDock}>
        <button
          type="button"
          style={styles.neutralDismissTrigger}
          onClick={onDismissServiceInspection}
        >
          Close Dossier
        </button>
      </div>
    </div>
  </div>
)}
{/* ========================================================= */}
{/* ✅ LIGHTBOX PREVIEW PORTAL */}
{/* ========================================================= */}
{previewMediaTargetUrl && (
  <div style={styles.lightboxPortalBackdrop} onClick={onDismissMediaPreview}>
    <div style={styles.lightboxViewportFrame} onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        style={styles.lightboxExitTrigger}
        onClick={onDismissMediaPreview}
      >
        &times;
      </button>
      <img
        src={previewMediaTargetUrl}
        alt="High-resolution preview"
        style={styles.lightboxMediaRenderer}
      />
    </div>
  </div>
)}
</div>
)}

{currentView === "transactions" && (
  <div style={{ width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box", overflowX: "hidden", padding: 0 }}>
    <div style={headerStyle}>
      <h3 style={titleStyle}>Stripe Transactions</h3>
    </div>
    <div style={{...cardStyle, width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box", background: "#ffffff", borderRadius: "16px", padding: "16px", boxShadow: "0 4px 20px rgba(0,0,0,0.06)", border: "1px solid #E5E7EB", overflow: "hidden" }}>
      <div style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.06)", marginBottom: "16px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "15px" }}>
        <div style={{ flex: "1 1 200px", minWidth: 0 }}>
          <h3 style={{ margin: 0, fontFamily: "'Poppins', sans-serif", fontSize: "20px", fontWeight: "700", color: "#111827" }}>
            💳 Stripe Financial Transaction Ledger
          </h3>
          <p style={{ marginTop: "6px", color: "#6B7280", fontSize: "13px", marginBottom: 0 }}>Complete payment, payout and settlement records.</p>
        </div>
        <div style={{ background: "#EEF2FF", color: "#0747A6", padding: "10px 18px", borderRadius: "10px", fontWeight: "700", fontSize: "14px" }}>
          Total Records : {cleanedLedgerEntries.length}
        </div>
      </div>
      <div style={{ background: "#fff", padding: "16px", borderRadius: "12px", marginBottom: "16px", boxShadow: "0 4px 12px rgba(0,0,0,.05)", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "12px", border: "1px solid #F3F4F6" }}>
        <input placeholder="🔍 Search Transaction..." value={ledgerTextFilter} onChange={(e) => setLedgerTextFilter(e.target.value)} style={{ flex: "1 1 200px", minWidth: "200px", maxWidth: "320px", padding: "10px 14px", borderRadius: "8px", border: "1px solid #D1D5DB", outline: "none", fontSize: "14px" }} />
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
          <button className="btn btn-primary" onClick={fetchTransactionLedger}>🔄 Refresh</button>
          <button className="btn btn-secondary" onClick={clearAllColumnFilters}>✖ Clear Filters</button>
          <button className="btn btn-success">📄 Export CSV</button>
        </div>
      </div>
      <div style={{ width: "100%", overflowX: "auto", background: "#fff", borderRadius: "12px", border: "1px solid #E5E7EB" }}>
        {isLoadingLedger? (
          <div style={{ padding: "80px 20px", textAlign: "center", fontWeight: "600", color: "#6B7280" }}>Retrieving Financial Transaction Records...</div>
        ) : loadingError? (
          <div style={{ background: "#FEE2E2", color: "#DC2626", padding: "20px", borderRadius: "10px", margin: "16px" }}>{loadingError}</div>
        ) : (
          <table style={{ width: "100%", minWidth: "850px", borderCollapse: "collapse", tableLayout: "auto" }}>
            <thead style={{ background: "#F9FAFB", position: "sticky", top: 0, zIndex: 1 }}>
              <tr>
                {visibleGridColumns.map((column) => (
                  <th key={column} style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: column === "bookingId"? "#0747A6" : "#6B7280", background: column === "bookingId"? "#EEF2FF" : "transparent", textAlign: "left", whiteSpace: "nowrap", textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>
                    {getColumnDisplayName(column)}
                  </th>
                ))}
              </tr>
              <tr style={{ background: "#FFFFFF" }}>
                {visibleGridColumns.map((column) => (
                  <th key={`filter-${column}`} style={{ padding: "6px 8px", borderBottom: "1px solid #E5E7EB", background: column === "bookingId"? "#EEF2FF" : "transparent" }}>
                    <input value={columnFilterValues[column] || ""} onChange={(e) => updateColumnFilterValue(column, e.target.value)} placeholder={`Filter ${getColumnDisplayName(column)}`} style={{ width: "100%", minWidth: "90px", boxSizing: "border-box", padding: "6px 8px", fontSize: "12px", borderRadius: "6px", border: "1px solid #D1D5DB", outline: "none", background: "#FAFAFA" }} />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {cleanedLedgerEntries.length > 0? (
                cleanedLedgerEntries.map((entry, index) => (
                  <tr key={entry._internalId || entry.recordId || index} style={{ background: index % 2 === 0? "#ffffff" : "#F9FAFB", borderBottom: "1px solid #E5E7EB" }}>
                    {visibleGridColumns.map((column) => (
                      <td key={column} style={getLedgerCellStyle(column)}>
                        {formatLedgerCellDisplay(entry[column], column)}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={visibleGridColumns.length} style={{ textAlign: "center", padding: "80px 20px", fontWeight: "600", color: "#6B7280" }}>No Financial Transactions Available</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  </div>
)}

{currentView === "inviteUsers" && (
  <div style={{ width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box", overflowX: "hidden", padding: 0 }}>
    <div style={headerStyle}>
      <h3 style={titleStyle}>Invite New Users</h3>
    </div>
    
    <div style={{ 
      ...cardStyle, 
      width: "100%", 
      maxWidth: "100%", 
      minWidth: 0, 
      boxSizing: "border-box", 
      background: "#ffffff", 
      borderRadius: "16px", 
      padding: "16px", 
      boxShadow: "0 4px 20px rgba(0,0,0,0.06)", 
      border: "1px solid #E5E7EB", 
      overflow: "hidden" 
    }}>
      {/* Top Info Header */}
      <div style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.06)", marginBottom: "16px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "15px" }}>
        <div style={{ flex: "1 1 200px", minWidth: 0 }}>
          <h3 style={{ margin: 0, fontFamily: "'Poppins', sans-serif", fontSize: "20px", fontWeight: "700", color: "#111827" }}>
            ✉ Employee Invitation Manager
          </h3>
          <p style={{ marginTop: "6px", color: "#6B7280", fontSize: "13px", marginBottom: 0 }}>
            Create an employee account and generate an invitation link.
          </p>
        </div>
        <div style={{ background: "#EEF2FF", color: "#0747A6", padding: "10px 18px", borderRadius: "10px", fontWeight: "700", fontSize: "14px" }}>
          Total Invited : {inviteUsersList?.length || 0}
        </div>
      </div>

      {/* Form Card */}
      <div style={{ background: "#fff", padding: "20px", borderRadius: "12px", marginBottom: "16px", boxShadow: "0 4px 12px rgba(0,0,0,.05)", border: "1px solid #F3F4F6" }}>
        <form onSubmit={submitEmployeeInvitation} style={{ width: "100%" }}>
          <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", width: "100%" }}>
            <div style={{ flex: "1 1 220px", minWidth: "200px" }}>
              <label style={{ display: "block", marginBottom: "6px", fontSize: "12px", fontWeight: "600", color: "#6B7280", textTransform: "uppercase" }}>
                Employee Name
              </label>
              <input
                id="fullName"
                name="fullName"
                type="text"
                value={employeeDetails.fullName}
                onChange={updateEmployeeField}
                placeholder="Enter employee name"
                disabled={isSubmitting}
                autoComplete="name"
                style={{ width: "100%", boxSizing: "border-box", padding: "10px 14px", borderRadius: "8px", border: "1px solid #D1D5DB", outline: "none", fontSize: "14px", background: "#FAFAFA" }}
              />
            </div>

            <div style={{ flex: "1 1 220px", minWidth: "200px" }}>
              <label style={{ display: "block", marginBottom: "6px", fontSize: "12px", fontWeight: "600", color: "#6B7280", textTransform: "uppercase" }}>
                Email Address
              </label>
              <input
                id="emailAddress"
                name="emailAddress"
                type="email"
                value={employeeDetails.emailAddress}
                onChange={updateEmployeeField}
                placeholder="employee@example.com"
                disabled={isSubmitting}
                autoComplete="email"
                style={{ width: "100%", boxSizing: "border-box", padding: "10px 14px", borderRadius: "8px", border: "1px solid #D1D5DB", outline: "none", fontSize: "14px", background: "#FAFAFA" }}
              />
            </div>

            <div style={{ flex: "1 1 160px", minWidth: "150px" }}>
              <label style={{ display: "block", marginBottom: "6px", fontSize: "12px", fontWeight: "600", color: "#6B7280", textTransform: "uppercase" }}>
                Role
              </label>
              <select
                id="accessLevel"
                name="accessLevel"
                value={employeeDetails.accessLevel}
                onChange={updateEmployeeField}
                disabled={isSubmitting}
                style={{ width: "100%", boxSizing: "border-box", padding: "10px 14px", borderRadius: "8px", border: "1px solid #D1D5DB", outline: "none", fontSize: "14px", background: "#FAFAFA" }}
              >
                <option value="employee">Employee</option>
                <option value="admin">Admin</option>
                <option value="manager">Manager</option>
              </select>
            </div>
          </div>

          {errorNotice && (
            <div style={{ background: "#FEE2E2", color: "#DC2626", padding: "12px 16px", borderRadius: "10px", marginTop: "16px", fontSize: "13px", fontWeight: "600" }}>
              {errorNotice}
            </div>
          )}

          {successNotice && (
            <div style={{ background: "#DCFCE7", color: "#166534", padding: "12px 16px", borderRadius: "10px", marginTop: "16px", fontSize: "13px", fontWeight: "600" }}>
              {successNotice}
            </div>
          )}

          <div style={{ marginTop: "16px", display: "flex", gap: "10px" }}>
            <button type="submit" disabled={isSubmitting} className="btn btn-primary">
              {isSubmitting ? "Creating Invitation..." : "✉ Send Invitation"}
            </button>
            {generatedInviteUrl && (
              <button type="button" className="btn btn-secondary" onClick={() => copyGeneratedInviteUrl(generatedInviteUrl)}>
                Copy Link
              </button>
            )}
          </div>
        </form>

        {/* Generated Invite Link Section */}
        {generatedInviteUrl && (
          <div style={{ marginTop: "16px", background: "#F9FAFB", border: "1px solid #E5E7EB", borderRadius: "10px", padding: "14px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "12px" }}>
            <div style={{ flex: "1 1 200px", minWidth: 0 }}>
              <div style={{ fontSize: "12px", fontWeight: "700", color: "#111827", textTransform: "uppercase", marginBottom: "4px" }}>
                Invitation Link Generated
              </div>
              <div style={{ fontSize: "13px", color: "#6B7280", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {generatedInviteUrl}
              </div>
            </div>
            <div style={{ display: "flex", gap: "8px" }}>
              <button type="button" className="btn btn-secondary" onClick={() => copyGeneratedInviteUrl(generatedInviteUrl)}>
                Copy
              </button>
              <a href={generatedInviteUrl} target="_blank" rel="noopener noreferrer" className="btn btn-success" style={{ textDecoration: "none" }}>
                Open
              </a>
            </div>
          </div>
        )}
      </div>

      {/* Firestore Directory Table */}
      <div style={{ width: "100%", overflowX: "auto", background: "#fff", borderRadius: "12px", border: "1px solid #E5E7EB" }}>
        <table style={{ width: "100%", minWidth: "1100px", borderCollapse: "collapse", tableLayout: "auto" }}>
          <thead style={{ background: "#F9FAFB", position: "sticky", top: 0, zIndex: 1 }}>
            <tr>
              <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#0747A6", background: "#EEF2FF", textAlign: "left", whiteSpace: "nowrap", textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>Employee</th>
              <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#6B7280", textAlign: "left", whiteSpace: "nowrap", textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>Role / Type</th>
              <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#6B7280", textAlign: "left", whiteSpace: "nowrap", textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>Status</th>
              <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#6B7280", textAlign: "left", whiteSpace: "nowrap", textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>Verified</th>
              <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#6B7280", textAlign: "left", whiteSpace: "nowrap", textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>Created</th>
              <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#6B7280", textAlign: "left", whiteSpace: "nowrap", textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>Invited At</th>
              <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#6B7280", textAlign: "left", whiteSpace: "nowrap", textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>Updated At</th>
              <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#6B7280", textAlign: "left", whiteSpace: "nowrap", textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>Invitation</th>
            </tr>
          </thead>
          <tbody>
            {loadingInvites ? (
              <tr>
                <td colSpan={8} style={{ textAlign: "center", padding: "40px", color: "#6B7280" }}>
                  Loading invites...
                </td>
              </tr>
            ) : inviteUsersList && inviteUsersList.length > 0 ? (
              inviteUsersList.map((user, index) => (
                <tr key={user.id || user.uid || index} style={{ background: index % 2 === 0 ? "#ffffff" : "#F9FAFB", borderBottom: "1px solid #E5E7EB" }}>
                  <td style={{ padding: "12px 16px", fontSize: "13px" }}>
                    <div style={{ fontWeight: "600", color: "#111827" }}>{user.displayName || "—"}</div>
                    <div style={{ fontSize: "12px", color: "#6B7280" }}>{user.email}</div>
                    <div style={{ fontSize: "10px", color: "#9CA3AF", marginTop: "2px" }}>UID: {user.uid}</div>
                  </td>

                  <td style={{ padding: "12px 16px" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <span style={{ background: "#EEF2FF", color: "#0747A6", padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "700", textTransform: "capitalize", width: "fit-content" }}>
                        {user.role}
                      </span>
                      <span style={{ fontSize: "11px", color: "#6B7280" }}>{user.accountType}</span>
                    </div>
                  </td>

                  <td style={{ padding: "12px 16px" }}>
                    <span
                      style={{
                        background: user.status === "invited" ? "#FEF3C7" : user.disabled ? "#FEE2E2" : "#DCFCE7",
                        color: user.status === "invited" ? "#92400E" : user.disabled ? "#991B1B" : "#166534",
                        padding: "4px 10px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: "700",
                        textTransform: "capitalize",
                      }}
                    >
                      {user.disabled ? "Disabled" : user.status}
                    </span>
                  </td>

                  <td style={{ padding: "12px 16px", fontSize: "13px" }}>
                    <span
                      style={{
                        background: user.emailVerified ? "#DCFCE7" : "#FEE2E2",
                        color: user.emailVerified ? "#166534" : "#991B1B",
                        padding: "4px 10px",
                        borderRadius: "20px",
                        fontSize: "11px",
                        fontWeight: "700",
                      }}
                    >
                      {user.emailVerified ? "✓ Verified" : "✗ Not Verified"}
                    </span>
                  </td>

                  <td style={{ padding: "12px 16px", fontSize: "13px", color: "#374151", whiteSpace: "nowrap" }}>
                    {user.createdAtFormatted || (user.createdAt?.toDate ? user.createdAt.toDate().toLocaleString() : "—")}
                  </td>

                  <td style={{ padding: "12px 16px", fontSize: "13px", color: "#374151", whiteSpace: "nowrap" }}>
                    {user.invitedAt?.toDate ? user.invitedAt.toDate().toLocaleString() : "—"}
                  </td>

                  <td style={{ padding: "12px 16px", fontSize: "13px", color: "#374151", whiteSpace: "nowrap" }}>
                    {user.updatedAt?.toDate ? user.updatedAt.toDate().toLocaleString() : "—"}
                  </td>

                  <td style={{ padding: "12px 16px" }}>
                    {user.invitationLink ? (
                      <div style={{ display: "flex", gap: "8px" }}>
                        <button
                          type="button"
                          className="btn btn-secondary"
                          style={{ padding: "6px 12px", fontSize: "12px" }}
                          onClick={() => copyGeneratedInviteUrl(user.invitationLink)}
                        >
                          Copy
                        </button>
                        <a
                          href={user.invitationLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-primary"
                          style={{ padding: "6px 12px", fontSize: "12px", textDecoration: "none" }}
                        >
                          Open
                        </a>
                      </div>
                    ) : (
                      <span style={{ color: "#9ca3af", fontSize: "12px" }}>Link unavailable</span>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8} style={{ textAlign: "center", padding: "80px 20px", fontWeight: "600", color: "#6B7280" }}>
                  No employee invitations found in Firestore.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  </div>
)}


{/*
  ═══════════════════════════════════════════════════════════════════════
  SERVICE PIPELINE & VERIFICATION ENGINE (COMPREHENSIVELY HARDENED)
  PART 1 OF 2
  ═══════════════════════════════════════════════════════════════════════
  STRICT ARCHITECTURAL GUARANTEES & NOTIFICATION SPECIFICATIONS:
  1. FCM TOKEN GATED PUSH NOTIFICATION ENGINE VIA CLOUD RUN:
     - Endpoint: https://unlimitedgigproviderservicenotifications-mc4pzotprq-el.a.run.app
     - Triggered automatically on "Approve All", "Reject Service", individual
       decision modals, and drag-and-drop transitions into Approved or Rejected.
     - STRICT GATE & TOAST FEEDBACK: Evaluates if service card or associated provider has
       a valid FCM token ("provider_fcm_token", "fcm_token", etc.).
     - Dispatches live push notification and immediately displays real-time toast feedback
       indicating "Notification sent successfully for [serviceTitle]!" or error/skip reasons.
     - 30-second deduplication lock with user feedback.
  2. INSTANT ZERO-LATENCY OPTIMISTIC RENDERING:
     - Dragging to Approved across ALL three boards immediately renders the card in Approved.
     - Background sync handles Firestore writes & Cloud Run notifications asynchronously.
  3. REAL-TIME MULTI-BOARD FILTER & SORT ENGINE:
     - Immediate updates across "New Services", "Image Changes Only", and "Deletion Requests".
     - Real-time sort orders: "Newest First", "Oldest First", and "Recently Updated".
  4. STAGE PERSISTENCE & IMMUTABILITY:
     - When moved from "Pending Verification" to "New Request", it persists strictly in New Request
       on the "Image Changes Only" board with all metadata and flags preserved.
  ═══════════════════════════════════════════════════════════════════════
*/}
{currentView === "servicePipeline" && (
  <>
    {/* ── SECURITY WATERMARK & SCREENSHOT / PRINT SHIELD STYLES ───────────── */}
    <style>{`
      @media print {
        body * { display: none !important; }
        body::before {
          content: "CONFIDENTIAL AUDIT DATA — PRINTING AND SCREEN CAPTURE IS STRICTLY PROHIBITED";
          display: block !important;
          font-size: 24px;
          font-weight: 800;
          color: #dc2626;
          text-align: center;
          padding-top: 100px;
        }
      }
      .no-screen-capture {
        -webkit-touch-callout: none !important;
        -webkit-user-select: none !important;
        -khtml-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        user-select: none !important;
      }
      .svc-media-shield {
        pointer-events: none;
        position: absolute;
        inset: 0;
        background: repeating-linear-gradient(
          45deg,
          rgba(15, 23, 42, 0.02),
          rgba(15, 23, 42, 0.02) 40px,
          rgba(239, 68, 68, 0.04) 40px,
          rgba(239, 68, 68, 0.04) 80px
        );
        z-index: 20;
      }
      .svc-filter-input::placeholder {
        color: #94a3b8;
      }
      @keyframes svcShieldPulse {
        0% { box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.7); }
        70% { box-shadow: 0 0 0 14px rgba(220, 38, 38, 0); }
        100% { box-shadow: 0 0 0 0 rgba(220, 38, 38, 0); }
      }
      .svc-security-alert-box {
        animation: svcShieldPulse 1.8s infinite;
      }
      @keyframes svcSpin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      .svc-spin {
        animation: svcSpin 0.85s linear infinite;
        display: inline-block;
      }
      .svc-badge-pulse {
        animation: svcBadgeGlow 2s infinite ease-in-out;
      }
      @keyframes svcBadgeGlow {
        0% { opacity: 0.9; transform: scale(1); }
        50% { opacity: 1; transform: scale(1.04); }
        100% { opacity: 0.9; transform: scale(1); }
      }
      @keyframes svcToastSlideIn {
        from { transform: translateX(120%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
      .svc-toast-animate {
        animation: svcToastSlideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
      }
      .svc-thumb-strip::-webkit-scrollbar { height: 6px; }
      .svc-thumb-strip::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
    `}</style>

    {/* ── CORE ENGINE, PERSISTENCE, TOAST MANAGER & FIRESTORE INITIALIZATION ── */}
    {(() => {
      if (typeof window !== "undefined") {
        /* Storage Cache Keys */
        window.__LS_SVC_BOARD_KEY = "service_pipeline_board_records_cache";
        window.__LS_SVC_AUDIT_KEY = "service_stage_transition_logs";
        window.__LS_SVC_MEDIA_ACCESS_KEY = "service_sensitive_media_access_logs";
        window.__LS_SVC_RECYCLE_BIN_KEY = "service_images_recycle_bin_7day_store";
        window.__LS_SVC_IMAGE_ACTIVITY_KEY = "service_images_activity_logs_store";
        window.__SERVICE_PIPELINE_PASSCODE = "8972";

        /* Push Notification Endpoint */
        window.__SVC_PUSH_NOTIFICATION_ENDPOINT = "https://unlimitedgigproviderservicenotifications-mc4pzotprq-el.a.run.app";
        if (!window.__sentNotificationDedupeMap) {
          window.__sentNotificationDedupeMap = new Map();
        }

        /* Master in-memory registries ensuring zero data loss across transitions */
        if (!window.__serviceMasterRegistry) {
          window.__serviceMasterRegistry = new Map();
        }
        if (!window.__unlockedImageUrls) {
          window.__unlockedImageUrls = new Set();
        }
        if (!window.__serviceRealtimeUnsubs) {
          window.__serviceRealtimeUnsubs = [];
        }
        if (!window.__providerNameCache) {
          window.__providerNameCache = new Map();
        }
        if (!window.__pendingProviderNameLookups) {
          window.__pendingProviderNameLookups = new Set();
        }
        if (!window.__svcToastsList) {
          window.__svcToastsList = [];
        }
        if (!window.__svcFirstSnapDone) {
          window.__svcFirstSnapDone = {};
        }
        if (!window.__knownDeletionRequests) {
          window.__knownDeletionRequests = new Set();
        }
        if (typeof window.__svcInitialLoadDone === "undefined") window.__svcInitialLoadDone = false;

        /* SAFE TEXT RENDERER */
        window.__safeText = (v, fallback = "") => {
          if (v === undefined || v === null) return fallback;
          if (typeof v === "string") return v;
          if (typeof v === "number" || typeof v === "boolean") return String(v);
          try {
            if (v instanceof Date) {
              return isNaN(v.getTime()) ? fallback : v.toLocaleString();
            }
            if (typeof v?.toDate === "function") {
              const d = v.toDate();
              return d && !isNaN(d.getTime()) ? d.toLocaleString() : fallback;
            }
            if (typeof v === "object" && (typeof v.seconds === "number" || typeof v._seconds === "number")) {
              const secs = typeof v.seconds === "number" ? v.seconds : v._seconds;
              const d = new Date(secs * 1000);
              return isNaN(d.getTime()) ? fallback : d.toLocaleString();
            }
            if (Array.isArray(v)) {
              return v.map((x) => window.__safeText(x, "")).filter(Boolean).join(", ") || fallback;
            }
            if (typeof v === "object") {
              return JSON.stringify(v);
            }
          } catch (e) {
            return fallback;
          }
          return String(v);
        };

        /* Active Toast Trigger System */
        window.__showServiceToast = (message, type = "info", duration = 4500) => {
          const id = `svc_toast_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`;
          const toast = { id, message: window.__safeText(message), type, duration };
          window.__svcToastsList.push(toast);
          window.__triggerServicePipelineReRender();
          setTimeout(() => {
            window.__svcToastsList = window.__svcToastsList.filter((t) => t.id !== id);
            window.__triggerServicePipelineReRender();
          }, duration);
        };

        /* Filter, Sort, Scale & Sync States */
        if (typeof window.__serviceSearchQuery === "undefined") window.__serviceSearchQuery = "";
        if (typeof window.__serviceSortOrder === "undefined") window.__serviceSortOrder = "newest";
        if (typeof window.__serviceQuickFilter === "undefined") window.__serviceQuickFilter = "all";
        if (typeof window.__serviceZoomScale === "undefined") window.__serviceZoomScale = 100;
        if (typeof window.__serviceActiveTab === "undefined") window.__serviceActiveTab = "overview";
        if (typeof window.__svcSecurityOverrideActiveUntil === "undefined") window.__svcSecurityOverrideActiveUntil = 0;
        if (typeof window.__isServicePipelineSyncing === "undefined") window.__isServicePipelineSyncing = false;
        if (typeof window.__serviceActiveImageIndex === "undefined") window.__serviceActiveImageIndex = 0;
        if (typeof window.__serviceShowTechnicalDetails === "undefined") window.__serviceShowTechnicalDetails = false;

        /* Firestore path blocklist */
        window.__BLOCKED_FIRESTORE_PATH_FRAGMENTS = ["service_audit_logs", "audit_logs", "image_activity_logs", "recycle_bin"];
        window.__isBlockedFirestorePath = (pathString) => {
          if (!pathString) return false;
          const p = String(pathString).toLowerCase();
          return window.__BLOCKED_FIRESTORE_PATH_FRAGMENTS.some((frag) => p.includes(frag));
        };

        /* Cryptographic Digest / Encryption Signature Generator */
        window.__generateEncryptedAuditToken = async (serviceId, fromStage, toStage, reason) => {
          const raw = `${serviceId}|${fromStage}|${toStage}|${reason}|${window.__SERVICE_PIPELINE_PASSCODE}|${Date.now()}`;
          try {
            if (typeof crypto !== "undefined" && crypto.subtle && typeof TextEncoder !== "undefined") {
              const enc = new TextEncoder();
              const hashBuf = await crypto.subtle.digest("SHA-256", enc.encode(raw));
              const hashArr = Array.from(new Uint8Array(hashBuf));
              const hashHex = hashArr.map((b) => b.toString(16).padStart(2, "0")).join("");
              return {
                signature: `ENC-SIG-${hashHex.slice(0, 32).toUpperCase()}`,
                securityHash: hashHex,
                timestamp: new Date().toISOString(),
              };
            }
          } catch (e) {}
          const fallbackSig = btoa(`ENC:${serviceId}:${Date.now()}`).replace(/=/g, "");
          return {
            signature: `ENC-SIG-${fallbackSig}`,
            securityHash: fallbackSig,
            timestamp: new Date().toISOString(),
          };
        };

        /* Universal DocRef Resolver */
        window.__getFirestoreDocRefUniversal = (pathString) => {
          if (typeof db === "undefined" || !pathString) return null;
          if (window.__isBlockedFirestorePath(pathString)) return null;
          const segs = pathString.split("/").filter(Boolean);
          if (segs.length % 2 !== 0) return null;
          if (typeof doc === "function") {
            try { return doc(db, ...segs); } catch (e) {}
          }
          if (typeof window.doc === "function") {
            try { return window.doc(db, ...segs); } catch (e) {}
          }
          if (typeof db.doc === "function") {
            try { return db.doc(pathString); } catch (e) {}
          }
          if (typeof db.collection === "function") {
            try {
              let cur = db;
              for (let i = 0; i < segs.length; i += 2) {
                cur = cur.collection(segs[i]).doc(segs[i + 1]);
              }
              return cur;
            } catch (e) {}
          }
          return null;
        };

        /* Universal Document Exists Checker */
        window.__checkFirestoreDocExistsUniversal = async (docRef) => {
          if (!docRef) return false;
          try {
            if (typeof getDoc === "function") {
              const snap = await getDoc(docRef);
              return Boolean(snap && (typeof snap.exists === "function" ? snap.exists() : snap.exists));
            }
            if (typeof docRef.get === "function") {
              const snap = await docRef.get();
              return Boolean(snap && (typeof snap.exists === "function" ? snap.exists() : snap.exists));
            }
          } catch (e) {}
          return false;
        };

        /* Force UI Refresh Trigger */
        window.__triggerServicePipelineReRender = () => {
          if (typeof setServicePreviewModal === "function") {
            setServicePreviewModal((p) => ({ ...(p || {}), _t: Date.now() }));
          }
          if (typeof setServiceInspectionRecord === "function") {
            setServiceInspectionRecord((p) => (p ? { ...p, _t: Date.now() } : null));
          }
          if (typeof setServicePipelineCards === "function") {
            setServicePipelineCards((prev) => (Array.isArray(prev) ? [...prev] : []));
          }
          if (typeof setDocumentPreviewModal === "function") {
            setDocumentPreviewModal((p) => ({ ...(p || {}), _t: Date.now() }));
          }
        };

        /* Helper: Check if protected surface is open */
        window.__isServiceProtectedSurfaceOpen = () => {
          const isDrawerOpen = Boolean(window.__serviceDrawerOpen || (typeof serviceDrawerVisible !== "undefined" && serviceDrawerVisible));
          const isPreviewOpen = Boolean(window.__servicePreviewModalState?.open || window.__isServiceMediaPreviewActive || (typeof servicePreviewModal !== "undefined" && servicePreviewModal?.open));
          const isSectionModalOpen = Boolean(window.__serviceActiveSectionModal?.open);
          const isRecycleModalOpen = Boolean(window.__recycleBinModalState?.open);
          const isDeletionProcessOpen = Boolean(window.__imageDeletionProcessModalState?.open);
          return Boolean(isDrawerOpen || isPreviewOpen || isSectionModalOpen || isRecycleModalOpen || isDeletionProcessOpen);
        };

        /* Anti-Screenshot, Multi-Touch & Screen Recording Security Trap */
        window.__showServiceSecurityAlert = (actionType = "Screenshot / Screen Recording / Download", onAuthorizeCallback = null) => {
          if (Date.now() < window.__svcSecurityOverrideActiveUntil) {
            if (typeof onAuthorizeCallback === "function") onAuthorizeCallback();
            return;
          }
          window.__serviceSecurityViolationModalState = {
            open: true,
            action: actionType,
            timestamp: new Date().toLocaleTimeString(),
            showOverrideGate: false,
            overrideError: null,
            onAuthorizeCallback,
          };
          window.__logServiceAudit({
            action: "SECURITY_VIOLATION_TRAP",
            serviceId: "SYSTEM_SHIELD",
            serviceTitle: "Capture Gate",
            reason: actionType,
          });
          window.__showServiceToast(`Security Alert: ${actionType} detected!`, "error", 5000);
          window.__triggerServicePipelineReRender();
        };

        /* Intercept getDisplayMedia for desktop/browser screen capture */
        if (typeof navigator !== "undefined" && navigator.mediaDevices && !window.__svcScreenCaptureProxySet) {
          window.__svcScreenCaptureProxySet = true;
          try {
            const originalGetDisplayMedia = navigator.mediaDevices.getDisplayMedia
              ? navigator.mediaDevices.getDisplayMedia.bind(navigator.mediaDevices)
              : null;
            if (originalGetDisplayMedia) {
              navigator.mediaDevices.getDisplayMedia = async function(...args) {
                if (window.__isServiceProtectedSurfaceOpen() && Date.now() >= window.__svcSecurityOverrideActiveUntil) {
                  window.__showServiceSecurityAlert("Screen Recording Stream Attempt");
                  throw new Error("Screen recording of confidential service records is prohibited.");
                }
                return originalGetDisplayMedia(...args);
              };
            }
          } catch (err) {}
        }

        /* Keyboard, Gesture, Visibility & Context Menu Traps */
        if (!window.__svcSecurityListenersBound) {
          window.__svcSecurityListenersBound = true;
          window.addEventListener("keydown", (e) => {
            if (Date.now() < window.__svcSecurityOverrideActiveUntil) return;
            const isOpen = window.__isServiceProtectedSurfaceOpen();
            const key = String(e.key || "").toLowerCase();
            const code = String(e.code || "").toLowerCase();
            const isPrintScreen = e.key === "PrintScreen" || code === "printscreen";
            const isPrintOrSave = (e.ctrlKey || e.metaKey) && (key === "p" || key === "s" || key === "u");
            const isMacScreenshot = e.metaKey && e.shiftKey && (key === "3" || key === "4" || key === "5" || key === "6");
            const isWindowsSnipping = (e.metaKey || e.ctrlKey) && e.shiftKey && key === "s";
            const isWindowsGameBar = (e.metaKey || e.ctrlKey) && (key === "g" || (e.altKey && key === "r"));
            const isDevTools = key === "f12" || ((e.ctrlKey || e.metaKey) && e.shiftKey && (key === "i" || key === "c" || key === "j"));
            if (isPrintScreen || isPrintOrSave || isMacScreenshot || isWindowsSnipping || isWindowsGameBar || (isOpen && isDevTools)) {
              e.preventDefault();
              e.stopPropagation();
              if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText("").catch(() => {});
              }
              const reason = isWindowsGameBar
                ? "Windows Screen Recording Tool Attempt (Win+G / Win+Alt+R)"
                : isMacScreenshot
                ? "Mac Screen Capture Shortcut (Cmd+Shift+3/4/5)"
                : isWindowsSnipping
                ? "Windows Snipping Tool (Win+Shift+S)"
                : isPrintScreen
                ? "PrintScreen Capture Attempt"
                : "Screen Recording / Screen Capture Attempt";
              window.__showServiceSecurityAlert(reason);
            }
          }, true);
          window.addEventListener("touchstart", (e) => {
            if (Date.now() < window.__svcSecurityOverrideActiveUntil) return;
            if (window.__isServiceProtectedSurfaceOpen() && e.touches && e.touches.length >= 3) {
              e.preventDefault();
              e.stopPropagation();
              window.__showServiceSecurityAlert("Mobile Multi-Finger Screenshot Gesture Detected");
            }
          }, { passive: false });
          window.addEventListener("visibilitychange", () => {
            if (Date.now() < window.__svcSecurityOverrideActiveUntil) return;
            if (document.hidden && window.__isServiceProtectedSurfaceOpen()) {
              window.__showServiceSecurityAlert("System Capture / App Backgrounding Activity Detected");
            }
          });
          window.addEventListener("contextmenu", (e) => {
            if (Date.now() < window.__svcSecurityOverrideActiveUntil) return;
            if (window.__isServiceProtectedSurfaceOpen()) {
              e.preventDefault();
              window.__showServiceSecurityAlert("Right-Click Context Menu Prevented");
            }
          });
        }

        /* Identity Resolvers */
        window.__getServiceCanonId = (item) => {
          if (!item) return "";
          return String(item.serviceId || item.id || item.uid || "").trim();
        };
        window.__getServiceProviderId = (item) => {
          if (!item) return "N/A";
          return String(item.providerId || item.userId || item.provider_id || item.vendorId || item.uid || "N/A").trim();
        };
        window.__getServiceTitle = (item) => {
          if (!item) return "Untitled Service";
          return window.__safeText(item.serviceTitle || item.serviceName || item.title || item.name || "Service Request", "Service Request");
        };

        /* Humanize label helper */
        window.__humanizeLabel = (raw) => {
          if (raw === undefined || raw === null) return "";
          const s = window.__safeText(raw).trim();
          if (!s) return "";
          return s.replace(/_+/g, " ").replace(/\s+/g, " ").trim();
        };

        /* Disallowed fields for Firestore writes */
        window.__SERVICE_PIPELINE_DISALLOWED_WRITE_FIELDS = [
          "cancellation_reason",
          "cancellation_requested",
          "cancelled_at",
          "cancelled_by",
        ];

        /* Plain client-side ISO timestamp generator */
        window.__getClientIsoTimestamp = () => new Date().toISOString();

        /* Structured serverTimestamp Map Generator with exact date and time */
        window.__getServerTimestampObject = () => {
          const now = new Date();
          let nativeServerTs = null;
          try {
            if (typeof serverTimestamp === "function") {
              nativeServerTs = serverTimestamp();
            } else if (typeof window.serverTimestamp === "function") {
              nativeServerTs = window.serverTimestamp();
            } else if (typeof firebase !== "undefined" && firebase.firestore?.FieldValue?.serverTimestamp) {
              nativeServerTs = firebase.firestore.FieldValue.serverTimestamp();
            }
          } catch (e) {}
          return {
            _methodName: "serverTimestamp",
            date: now.toLocaleDateString(),
            time: now.toLocaleTimeString(),
            iso: now.toISOString(),
            timestamp: now.getTime(),
            formatted: now.toLocaleString(),
            ...(nativeServerTs && typeof nativeServerTs === "object" ? nativeServerTs : {}),
          };
        };

        /* Deep recursive sanitizer removing undefined values and disallowed fields */
        window.__stripDisallowedFieldsForFirestore = (payload) => {
          if (payload === undefined) return null;
          if (payload === null || typeof payload !== "object") return payload;
          if (payload instanceof Date) return payload;
          if (typeof payload?.toDate === "function") return payload;
          if (payload?._methodName === "serverTimestamp") return payload;
          const disallowed = new Set(window.__SERVICE_PIPELINE_DISALLOWED_WRITE_FIELDS || []);
          if (Array.isArray(payload)) {
            return payload
              .filter((v) => v !== undefined)
              .map((v) => window.__stripDisallowedFieldsForFirestore(v));
          }
          const clean = {};
          Object.keys(payload).forEach((k) => {
            if (disallowed.has(k)) return;
            const val = payload[k];
            if (val !== undefined) {
              clean[k] = window.__stripDisallowedFieldsForFirestore(val);
            }
          });
          return clean;
        };

        /* Epoch converter */
        window.__toEpochMs = (raw) => {
          if (!raw) return 0;
          try {
            if (typeof raw?.toDate === "function") return raw.toDate().getTime();
            if (typeof raw === "object" && typeof raw.seconds === "number") return raw.seconds * 1000;
            if (typeof raw === "object" && typeof raw._seconds === "number") return raw._seconds * 1000;
            if (typeof raw === "object" && typeof raw.timestamp === "number") return raw.timestamp;
            if (typeof raw === "object" && raw.iso) {
              const p = new Date(raw.iso).getTime();
              if (!isNaN(p)) return p;
            }
            const parsed = new Date(raw).getTime();
            return isNaN(parsed) ? 0 : parsed;
          } catch (e) {
            return 0;
          }
        };

        window.__getStageTimestampMs = (data) => {
          if (!data) return 0;
          return Math.max(
            window.__toEpochMs(data.updatedAt),
            window.__toEpochMs(data.updated_at),
            window.__toEpochMs(data.stage_updated_at),
            window.__toEpochMs(data.reviewed_at),
            window.__toEpochMs(data.reviewedAt)
          );
        };

        window.__getServiceTimestamp = (item) => {
          if (!item) return 0;
          const raw = item.reviewed_at || item.reviewedAt || item.createdAt || item.uploaded_at || item.uploadedAt || item.upload_date || item._detectedAt;
          if (!raw) return 0;
          return window.__toEpochMs(raw);
        };

        window.__formatServiceDateDisplay = (item) => {
          const ts = window.__getServiceTimestamp(item);
          if (!ts) return "Recently logged";
          const d = new Date(ts);
          return d.toLocaleDateString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
        };

        window.__formatPreciseTimestamp = (raw) => {
          if (!raw) return "Not available";
          try {
            const ms = window.__toEpochMs(raw);
            if (!ms) return "Not available";
            const ts = new Date(ms);
            if (isNaN(ts.getTime())) return "Not available";
            return ts.toLocaleString(undefined, { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" });
          } catch (e) {
            return "Not available";
          }
        };

        window.__formatReviewedAtDisplay = (item) => {
          if (!item) return "Not Reviewed";
          const raw = item.reviewed_at || item.reviewedAt;
          if (!raw) return "Not Reviewed";
          const formatted = window.__formatPreciseTimestamp(raw);
          return formatted === "Not available" ? "Not Reviewed" : formatted;
        };

        window.__getServiceReviewedByDisplay = (svcOrImg, parentSvc) => {
          if (!svcOrImg) return "Not Reviewed";
          const raw = svcOrImg.reviewedBy || svcOrImg.reviewed_by;
          if (!raw || !window.__safeText(raw).trim()) return "Not Reviewed";
          const rawTrim = window.__safeText(raw).trim();
          const contextRecord = parentSvc || svcOrImg;
          const pId = window.__getServiceProviderId(contextRecord);
          const uId = String(contextRecord.userId || "").trim();
          const looksLikeRawId = pId !== "N/A" && rawTrim === pId;
          const looksLikeUserId = uId && rawTrim === uId;
          if (looksLikeRawId || looksLikeUserId) return "Not Reviewed";
          return rawTrim;
        };

        window.__getSafeLocationDisplay = (svc) => {
          const raw = svc?.location || svc?.serviceLocation || svc?.address || null;
          if (!raw) return "—";
          const str = window.__safeText(raw).trim();
          const looksLikeCoords = /^-?\d{1,3}(\.\d+)?\s*,\s*-?\d{1,3}(\.\d+)?$/.test(str);
          if (looksLikeCoords) return "Address on file (coordinates hidden)";
          return str;
        };

        window.__isLocationApprovalRuleActive = (svc) => {
          if (!svc) return false;
          return Boolean(svc.locationApprovalRequired || svc.requiresLocationVerification || svc.serviceRadius || svc.radius_km || svc.radiusKm);
        };

        window.__toggleServiceTechnicalDetails = () => {
          window.__serviceShowTechnicalDetails = !window.__serviceShowTechnicalDetails;
          window.__triggerServicePipelineReRender();
        };

        window.__getServiceCreatedTimestamp = (item) => {
          if (!item) return 0;
          const raw = item.createdAt || item.uploaded_at || item.uploadedAt || item.upload_date || item._detectedAt;
          if (!raw) return 0;
          return window.__toEpochMs(raw);
        };

        window.__isServiceRecentlyCreated = (item) => {
          if (!item) return false;
          if (item.is_new === true || item.isNew === true) return true;
          if (item._detectedFresh && item._detectedAt && (Date.now() - Number(item._detectedAt)) / (1000 * 60 * 60) <= 48) return true;
          const raw = item.createdAt || item.uploaded_at || item.uploadedAt;
          if (!raw) return false;
          const ts = window.__toEpochMs(raw);
          if (isNaN(ts) || ts <= 0) return false;
          const diffHours = (Date.now() - ts) / (1000 * 60 * 60);
          return diffHours <= 48;
        };

        window.__isNewlyUploadedImage = (imgItem, parentSvc) => {
          if (!imgItem) return false;
          if (imgItem.isNew || imgItem.is_new || imgItem.isFresh || imgItem._detectedFresh) return true;
          const upRaw = imgItem.uploadedAt || imgItem.uploaded_at || imgItem.created_at || imgItem.createdAt;
          if (upRaw) {
            const ms = window.__toEpochMs(upRaw);
            if (ms > 0 && (Date.now() - ms) / (1000 * 60 * 60) <= 48) {
              return true;
            }
          }
          if (parentSvc && (parentSvc.had_image_changes || parentSvc.has_image_changes || parentSvc.images_edited || parentSvc.pending_image_review)) {
            if (imgItem.status === "pending" || imgItem.approval_status === "pending") {
              return true;
            }
          }
          return false;
        };

        window.__urlsMatchCanonical = (u1, u2) => {
          if (!u1 || !u2) return false;
          const s1 = String(u1).trim();
          const s2 = String(u2).trim();
          if (s1 === s2) return true;
          const base1 = s1.split("?")[0].split("#")[0];
          const base2 = s2.split("?")[0].split("#")[0];
          return Boolean(base1 && base2 && base1 === base2);
        };

        window.__normalizeImageStatus = (raw) => {
          if (raw === undefined || raw === null || String(raw).trim() === "") return null;
          const s = String(raw).toLowerCase().replace(/[^a-z0-9]/g, "");
          if (s === "approved" || s === "verified" || s === "active") return "approved";
          if (s === "rejected" || s === "reject" || s === "declined") return "rejected";
          return "pending";
        };

        window.__getPendingImageCount = (record) => {
          if (!record) return 0;
          return window.__extractServiceImages(record).filter((im) => im.status === "pending").length;
        };

        window.__isImageChangesOnlyService = (item) => {
          if (!item) return false;
          if (
            item.had_image_changes === true ||
            item.image_changes_only === true ||
            item.has_image_changes === true ||
            item.pending_image_review === true ||
            item.images_edited === true ||
            item._from_image_changes === true
          ) {
            return true;
          }
          const wasApproved = item.is_approved === true || item.previous_status === "approved" || item.was_approved === true;
          const images = window.__extractServiceImages(item);
          const hasPendingImg = images.some((img) => img.status === "pending" || img.status === "new_request" || img.approval_status === "pending");
          return wasApproved && hasPendingImg;
        };

        window.__areAllServiceImagesApproved = (record) => {
          if (!record) return true;
          const images = window.__extractServiceImages(record);
          if (images.length === 0) return true;
          return images.every((img) => img.status === "approved" || img.approval_status === "approved");
        };

        /* ── FEATURE 5: IMAGE ACTIVITY LOGGING ENGINE ── */
        window.__logImageActivity = ({ action, serviceId, providerId, imageId, imageUrl, imageCaption, details, reason }) => {
          try {
            const currentUser =
              (typeof auth !== "undefined" && auth?.currentUser?.email) ||
              (typeof currentAdminUser !== "undefined" && currentAdminUser?.email) ||
              "Compliance Officer";
            const storageKey = window.__LS_SVC_IMAGE_ACTIVITY_KEY;
            const existingRaw = localStorage.getItem(storageKey);
            const logs = existingRaw ? JSON.parse(existingRaw) : [];
            const newEntry = {
              id: `img_act_${Date.now()}_${Math.random().toString(36).substring(2, 7)}`,
              action: action || "IMAGE_ACTIVITY",
              serviceId: String(serviceId || "N/A"),
              providerId: String(providerId || "N/A"),
              imageId: String(imageId || imageUrl || "N/A"),
              imageUrl: imageUrl || null,
              imageCaption: imageCaption || "Service Image",
              details: details || "",
              reason: reason || "",
              performedBy: currentUser,
              timestamp: new Date().toISOString(),
              formattedTime: new Date().toLocaleString(),
            };
            logs.unshift(newEntry);
            if (logs.length > 1000) logs.pop();
            localStorage.setItem(storageKey, JSON.stringify(logs));
          } catch (e) {}
        };

        window.__getImageActivityLogs = (filterServiceId = null, filterProviderId = null) => {
          try {
            const raw = localStorage.getItem(window.__LS_SVC_IMAGE_ACTIVITY_KEY);
            if (!raw) return [];
            const logs = JSON.parse(raw);
            return logs.filter((l) => {
              if (filterServiceId && String(l.serviceId).trim() !== String(filterServiceId).trim()) return false;
              if (filterProviderId && String(l.providerId).trim() !== String(filterProviderId).trim()) return false;
              return true;
            });
          } catch (e) {
            return [];
          }
        };

        /* ── FEATURE 4: SEVEN-DAY RECYCLE BIN ENGINE ── */
        window.__RECYCLE_BIN_RETENTION_MS = 7 * 24 * 60 * 60 * 1000;
        window.__getRecycleBinItems = (filterServiceId = null) => {
          try {
            const raw = localStorage.getItem(window.__LS_SVC_RECYCLE_BIN_KEY);
            if (!raw) return [];
            let items = JSON.parse(raw);
            const now = Date.now();
            items = items.map((it) => {
              const deletedMs = window.__toEpochMs(it.deletedAt);
              const expiresAtMs = deletedMs + window.__RECYCLE_BIN_RETENTION_MS;
              const remainingMs = Math.max(0, expiresAtMs - now);
              const daysLeft = Math.ceil(remainingMs / (1000 * 60 * 60 * 24));
              const hoursLeft = Math.ceil(remainingMs / (1000 * 60 * 60));
              return {
                ...it,
                remainingMs,
                daysLeft,
                hoursLeft,
                isExpired: remainingMs <= 0,
              };
            });
            if (filterServiceId) {
              return items.filter((x) => String(x.serviceId).trim() === String(filterServiceId).trim());
            }
            return items;
          } catch (e) {
            return [];
          }
        };

        window.__saveRecycleBinItems = (items) => {
          try {
            localStorage.setItem(window.__LS_SVC_RECYCLE_BIN_KEY, JSON.stringify(items));
          } catch (e) {}
        };

        window.__moveToRecycleBin = ({ serviceId, providerId, imgItem, reason = "Deleted by compliance officer" }) => {
          const items = window.__getRecycleBinItems();
          const targetUrl = imgItem.url || imgItem.file;
          const cleanExisting = items.filter((x) => !(String(x.serviceId) === String(serviceId) && window.__urlsMatchCanonical(x.url, targetUrl)));
          const recycleRecord = {
            id: `rc_${Date.now()}_${Math.random().toString(36).substring(2, 6)}`,
            serviceId: String(serviceId),
            providerId: String(providerId || "N/A"),
            url: targetUrl,
            caption: imgItem.caption || "Service Image",
            previousStatus: imgItem.status || "pending",
            deletionReason: reason,
            deletedAt: new Date().toISOString(),
            originalUploadedAt: imgItem.uploadedAt || null,
            originalUploadedBy: imgItem.uploadedBy || null,
            meta: { ...imgItem },
          };
          cleanExisting.unshift(recycleRecord);
          window.__saveRecycleBinItems(cleanExisting);
          window.__logImageActivity({
            action: "IMAGE_MOVED_TO_RECYCLE_BIN",
            serviceId,
            providerId,
            imageId: targetUrl,
            imageUrl: targetUrl,
            imageCaption: imgItem.caption,
            details: "Soft-deleted to 7-day recycle bin",
            reason,
          });
        };

        window.__restoreImageFromRecycleBin = async (recycleId) => {
          const items = window.__getRecycleBinItems();
          const target = items.find((x) => x.id === recycleId);
          if (!target) return false;
          const sId = target.serviceId;
          const registry = window.__serviceMasterRegistry;
          const existing = registry.get(sId);
          const stageUpdatedAtValue = window.__getServerTimestampObject();
          if (existing) {
            const restoredImg = {
              id: target.meta?.id || target.url,
              url: target.url,
              file: target.url,
              caption: target.caption,
              status: target.previousStatus || "pending",
              approval_status: target.previousStatus || "pending",
              uploadedAt: target.originalUploadedAt || new Date().toISOString(),
              uploadedBy: target.originalUploadedBy || "Provider",
              restoredAt: new Date().toISOString(),
            };
            const currentImgs = Array.isArray(existing.images) ? [...existing.images] : [];
            const alreadyHas = currentImgs.some((im) => window.__urlsMatchCanonical(im.url || im.file, target.url));
            if (!alreadyHas) {
              currentImgs.push(restoredImg);
            }
            const updatedRecord = {
              ...existing,
              images: currentImgs,
              stage_updated_at: stageUpdatedAtValue,
              updatedAt: new Date().toISOString(),
              updated_at: new Date().toISOString(),
            };
            registry.set(sId, updatedRecord);
            if (typeof setServicePipelineCards === "function") {
              setServicePipelineCards(Array.from(registry.values()));
            }
            try {
              if (typeof db !== "undefined") {
                const targets = window.__collectServiceWriteTargets(updatedRecord, sId);
                const rawPayload = {
                  images: updatedRecord.images,
                  stage_updated_at: stageUpdatedAtValue,
                  updatedAt: updatedRecord.updatedAt,
                  updated_at: updatedRecord.updated_at,
                };
                const cleanPayload = window.__stripDisallowedFieldsForFirestore(rawPayload);
                await Promise.allSettled(Array.from(targets.values()).map((t) => window.__safeWriteFirestoreDoc(t, cleanPayload)));
              }
            } catch (err) {}
          }
          const filtered = items.filter((x) => x.id !== recycleId);
          window.__saveRecycleBinItems(filtered);
          window.__logImageActivity({
            action: "IMAGE_RESTORED_FROM_RECYCLE_BIN",
            serviceId: target.serviceId,
            providerId: target.providerId,
            imageId: target.url,
            imageUrl: target.url,
            imageCaption: target.caption,
            details: "Restored from 7-day recycle bin back to service gallery",
          });
          window.__showServiceToast(`Image "${target.caption}" successfully restored!`, "success");
          window.__triggerServicePipelineReRender();
          return true;
        };

        window.__permanentlyPurgeRecycleItem = (recycleId) => {
          const items = window.__getRecycleBinItems();
          const target = items.find((x) => x.id === recycleId);
          if (!target) return;
          const filtered = items.filter((x) => x.id !== recycleId);
          window.__saveRecycleBinItems(filtered);
          window.__logImageActivity({
            action: "IMAGE_PERMANENTLY_PURGED",
            serviceId: target.serviceId,
            providerId: target.providerId,
            imageId: target.url,
            imageUrl: target.url,
            imageCaption: target.caption,
            details: "Permanently purged from 7-day recycle bin",
          });
          window.__showServiceToast("Image permanently removed from recycle bin.", "info");
          window.__triggerServicePipelineReRender();
        };

        /* Async Provider Name Resolver */
        window.__resolveProviderNameAsync = async (pId, uId) => {
          const targetId = (pId && pId !== "N/A") ? pId : ((uId && uId !== "N/A") ? uId : null);
          if (!targetId || typeof db === "undefined") return;
          if (window.__providerNameCache.has(targetId)) return;
          if (window.__pendingProviderNameLookups.has(targetId)) return;
          window.__pendingProviderNameLookups.add(targetId);
          try {
            let foundName = null;
            try {
              const pRef = window.__getFirestoreDocRefUniversal(`providers/${targetId}`);
              if (pRef) {
                let pSnap = null;
                if (typeof getDoc === "function") {
                  pSnap = await getDoc(pRef);
                } else if (typeof pRef.get === "function") {
                  pSnap = await pRef.get();
                }
                if (pSnap && (typeof pSnap.exists === "function" ? pSnap.exists() : pSnap.exists)) {
                  const pData = typeof pSnap.data === "function" ? pSnap.data() : pSnap.data;
                  if (pData && (pData.name || pData.fullName || pData.providerName)) {
                    foundName = window.__safeText(pData.name || pData.fullName || pData.providerName);
                  }
                }
              }
            } catch (err) {}
            if (!foundName) {
              try {
                const uRef = window.__getFirestoreDocRefUniversal(`users/${targetId}`);
                if (uRef) {
                  let uSnap = null;
                  if (typeof getDoc === "function") {
                    uSnap = await getDoc(uRef);
                  } else if (typeof uRef.get === "function") {
                    uSnap = await uRef.get();
                  }
                  if (uSnap && (typeof uSnap.exists === "function" ? uSnap.exists() : uSnap.exists)) {
                    const uData = typeof uSnap.data === "function" ? uSnap.data() : uSnap.data;
                    if (uData && (uData.fullName || uData.name || uData.displayName)) {
                      foundName = window.__safeText(uData.fullName || uData.name || uData.displayName);
                    }
                  }
                }
              } catch (err) {}
            }
            if (foundName) {
              window.__providerNameCache.set(targetId, foundName);
              let modified = false;
              window.__serviceMasterRegistry.forEach((val) => {
                const curPid = window.__getServiceProviderId(val);
                const curUid = String(val.userId || "").trim();
                if (curPid === targetId || curUid === targetId) {
                  val.resolvedProviderName = foundName;
                  modified = true;
                }
              });
              if (modified) {
                if (typeof setServicePipelineCards === "function") {
                  setServicePipelineCards(Array.from(window.__serviceMasterRegistry.values()));
                }
                window.__triggerServicePipelineReRender();
              }
            }
          } catch (e) {
          } finally {
            window.__pendingProviderNameLookups.delete(targetId);
          }
        };

        window.__getServiceProviderName = (item) => {
          if (!item) return "Verified Provider";
          const pId = window.__getServiceProviderId(item);
          const uId = String(item.userId || "").trim();
          if (item.resolvedProviderName) return window.__safeText(item.resolvedProviderName);
          if (pId !== "N/A" && window.__providerNameCache.has(pId)) {
            return window.__providerNameCache.get(pId);
          }
          if (uId && window.__providerNameCache.has(uId)) {
            return window.__providerNameCache.get(uId);
          }
          if ((pId !== "N/A" && !window.__pendingProviderNameLookups.has(pId)) || (uId && !window.__pendingProviderNameLookups.has(uId))) {
            window.__resolveProviderNameAsync(pId, uId);
          }
          const direct = window.__safeText(item.fullName || item.name || item.providerName || item.providerDisplayName || item.userName || "");
          if (direct && !/^unnamed/i.test(direct)) return direct;
          if (item.username) return `@${window.__safeText(item.username)}`;
          return "Verified Provider";
        };

        window.__normalizeServiceStage = (stageStr) => {
          if (!stageStr) return "new_request";
          const s = String(stageStr).toLowerCase().replace(/[^a-z0-9]/g, "");
          if (s === "approved" || s === "verified" || s === "active") return "approved";
          if (s === "rejected" || s === "reject" || s === "declined") return "rejected";
          if (s === "pendingverification" || s === "pending" || s === "underreview" || s === "inreview") return "pending_verification";
          if (s === "newrequest" || s === "new" || s === "draft") return "new_request";
          return "new_request";
        };

        /* ── DIRECT STAGE RESOLUTION (INSTANT APPROVAL & REJECTION GUARANTEED) ── */
        window.__getEffectiveServiceStage = (record) => {
          if (!record) return "new_request";
          return window.__normalizeServiceStage(record.approval_status || record.status);
        };

        window.__getNextServiceStage = (stageStr) => {
          const s = window.__normalizeServiceStage(stageStr);
          if (s === "new_request") return "pending_verification";
          if (s === "pending_verification") return "approved";
          if (s === "rejected") return "pending_verification";
          return null;
        };

        window.__getServiceStageMeta = (stageStr) => {
          const cat = window.__normalizeServiceStage(stageStr);
          switch (cat) {
            case "new_request":
              return { label: "New Request", shortLabel: "New", color: "#4f46e5", bg: "#e0e7ff" };
            case "pending_verification":
              return { label: "Pending Verification", shortLabel: "Pending", color: "#d97706", bg: "#fef3c7" };
            case "approved":
              return { label: "Approved", shortLabel: "Approved", color: "#16a34a", bg: "#dcfce7" };
            case "rejected":
              return { label: "Rejected", shortLabel: "Rejected", color: "#dc2626", bg: "#fee2e2" };
            default:
              return { label: "New Request", shortLabel: "New", color: "#4f46e5", bg: "#e0e7ff" };
          }
        };

        window.__hasReviewMarkers = (data) => {
          if (!data) return false;
          return Boolean(
            data.reviewed_at || data.reviewedAt || data.reviewed_by || data.reviewedBy ||
            data.stageTransition || data.stage_transition ||
            data.was_approved || data.is_approved === true || data.previous_status === "approved"
          );
        };

        window.__isProviderSubmittedUnreviewed = (data) => {
          if (!data || window.__hasReviewMarkers(data)) return false;
          const raw = data.approval_status !== undefined && data.approval_status !== null && String(data.approval_status).trim() !== ""
            ? data.approval_status
            : data.status;
          const norm = String(raw || "").toLowerCase().replace(/[^a-z0-9]/g, "");
          return norm === "pending" || norm === "new" || norm === "newrequest" || norm === "draft" || norm === "submitted" || norm === "created";
        };

        /* ── ROBUST IMAGE EXTRACTOR ── */
        window.__extractServiceImages = (record) => {
          if (!record) return [];
          const list = [];
          const seen = new Set();
          const recordStageForImages = window.__normalizeServiceStage(record.approval_status || record.status);
          const recordFallbackStatus = recordStageForImages === "approved" ? "approved" : recordStageForImages === "rejected" ? "rejected" : "pending";
          const addImg = (url, caption = "", source = "gallery", meta = {}) => {
            if (!url || typeof url !== "string") return;
            const cleanUrl = url.trim();
            if (!cleanUrl.startsWith("http") && !cleanUrl.startsWith("data:image") && !cleanUrl.startsWith("blob:")) return;
            if (seen.has(cleanUrl)) return;
            seen.add(cleanUrl);
            const isCrmUploaded = meta?.uploaded_from === "crm" || meta?.source === "crm" || source === "crm";
            const explicitStatus = window.__normalizeImageStatus(
              meta?.status || meta?.approval_status || meta?.media_status || (meta?.is_approved === true ? "approved" : null)
            );
            let currentImgStatus;
            if (recordStageForImages === "approved") {
              currentImgStatus = "approved";
            } else if (recordStageForImages === "rejected") {
              currentImgStatus = "rejected";
            } else if (recordStageForImages === "pending_verification") {
              if (meta?.individual_review === true && explicitStatus) {
                currentImgStatus = explicitStatus;
              } else {
                currentImgStatus = "pending";
              }
            } else if (recordStageForImages === "new_request") {
              currentImgStatus = "pending";
            } else {
              currentImgStatus = isCrmUploaded ? "approved" : (explicitStatus || recordFallbackStatus);
            }
            const rawUploader = meta?.uploadedBy || meta?.uploaded_by || meta?.uploaderName || meta?.uploader_name || null;
            const hasDeletionRequest = Boolean(
              meta?.deletion_requested || meta?.deletionRequested ||
              meta?.delete_requested || meta?.requested_deletion ||
              meta?.removal_requested || meta?.delete_requested_at ||
              meta?.is_deletion_requested || meta?.deletion_status === "pending" ||
              (record.image_deletion_requested && (meta?.isMainImage || list.length === 0))
            );
            const deletionRequestedAt = meta?.deletion_requested_at || meta?.delete_requested_at || meta?.deletionRequestedAt || record.deletion_requested_at || null;
            const deletionReason = meta?.deletion_reason || meta?.delete_reason || meta?.removal_reason || record.image_deletion_reason || "Provider requested image removal";
            const isFreshImg = window.__isNewlyUploadedImage({ ...meta, url: cleanUrl }, record);
            list.push({
              id: meta?.id || cleanUrl,
              url: cleanUrl,
              caption: window.__safeText(caption) || `Service Media #${list.length + 1}`,
              source,
              uploaded_from: meta?.uploaded_from || (isCrmUploaded ? "crm" : "provider"),
              status: currentImgStatus,
              approval_status: currentImgStatus,
              uploadedAt: meta?.uploadedAt || meta?.uploaded_at || null,
              uploadedBy: rawUploader ? window.__safeText(rawUploader) : null,
              reviewedBy: meta?.reviewedBy || meta?.reviewed_by || null,
              reviewedAt: meta?.reviewedAt || meta?.reviewed_at || null,
              rejection_reason: meta?.rejection_reason || null,
              isEdited: Boolean(meta?.isEdited || meta?.is_edited || meta?.modified),
              isMainImage: Boolean(meta?.isMainImage || meta?.is_cover || meta?.is_main),
              isNew: isFreshImg,
              deletionRequested: hasDeletionRequest,
              deletionRequestedAt,
              deletionReason,
            });
          };
          const parseMediaStructure = (container, sourceLabel) => {
            if (!container) return;
            if (typeof container === "string") {
              addImg(container, sourceLabel, sourceLabel);
              return;
            }
            if (Array.isArray(container)) {
              container.forEach((item, idx) => {
                if (typeof item === "string") {
                  addImg(item, `${sourceLabel} #${idx + 1}`, sourceLabel);
                } else if (item && typeof item === "object") {
                  const u = item.url || item.file || item.image || item.fileUrl || item.downloadURL || item.src || item.link;
                  addImg(u, item.caption || item.title || `${sourceLabel} #${idx + 1}`, sourceLabel, item);
                }
              });
              return;
            }
            if (typeof container === "object") {
              if (Array.isArray(container.items)) parseMediaStructure(container.items, `${sourceLabel}_items`);
              if (Array.isArray(container.urls)) parseMediaStructure(container.urls, `${sourceLabel}_urls`);
              if (Array.isArray(container.images)) parseMediaStructure(container.images, `${sourceLabel}_images`);
              if (Array.isArray(container.media)) parseMediaStructure(container.media, `${sourceLabel}_media`);
              if (container.url || container.file || container.image || container.fileUrl || container.downloadURL) {
                addImg(container.url || container.file || container.image || container.fileUrl || container.downloadURL, container.caption || container.title || sourceLabel, sourceLabel, container);
              }
              Object.keys(container).forEach((k) => {
                if (["status", "approval_status", "items", "urls", "images", "media", "updatedAt", "updated_at", "createdAt", "stage_updated_at"].includes(k)) return;
                const val = container[k];
                if (typeof val === "string") {
                  addImg(val, k, sourceLabel);
                } else if (val && typeof val === "object") {
                  if (Array.isArray(val)) {
                    parseMediaStructure(val, k);
                  } else {
                    const u = val.url || val.file || val.image || val.fileUrl || val.downloadURL || val.src;
                    addImg(u, val.caption || val.title || k, sourceLabel, val);
                  }
                }
              });
            }
          };
          if (record.gallery_media && typeof record.gallery_media === "object" && !Array.isArray(record.gallery_media)) {
            const gm = record.gallery_media;
            const mainCandidate = gm.mainImage || gm.main_image || gm.mainImageUrl || gm.coverUrl || gm.cover_url;
            if (mainCandidate) {
              const mainStatus = recordStageForImages === "approved" ? "approved" : (recordStageForImages === "rejected" ? "rejected" : (gm.mainImage_status || gm.main_image_status || gm.status || gm.approval_status));
              const hasMainDelReq = Boolean(gm.mainImage_deletion_requested || gm.main_image_deletion_requested || gm.deletion_requested);
              const mainDelTime = gm.mainImage_delete_requested_at || gm.main_image_delete_requested_at || gm.deletion_requested_at;
              const mainDelReason = gm.mainImage_delete_reason || gm.main_image_deletion_reason || gm.deletion_reason;
              if (typeof mainCandidate === "string") {
                addImg(mainCandidate, "Main Gallery Image", "gallery_media_main", {
                  isMainImage: true,
                  status: mainStatus,
                  approval_status: mainStatus,
                  reviewedBy: gm.mainImage_reviewed_by || gm.reviewed_by,
                  reviewedAt: gm.mainImage_reviewed_at || gm.reviewed_at,
                  deletion_requested: hasMainDelReq,
                  deletion_requested_at: mainDelTime,
                  deletion_reason: mainDelReason,
                });
              } else if (typeof mainCandidate === "object") {
                const u = mainCandidate.url || mainCandidate.file || mainCandidate.image || mainCandidate.downloadURL;
                addImg(u, mainCandidate.caption || "Main Gallery Image", "gallery_media_main", {
                  ...mainCandidate,
                  isMainImage: true,
                  status: mainCandidate.status || mainStatus,
                  approval_status: mainCandidate.approval_status || mainStatus,
                  deletion_requested: mainCandidate.deletion_requested !== undefined ? mainCandidate.deletion_requested : hasMainDelReq,
                  deletion_requested_at: mainCandidate.deletion_requested_at || mainDelTime,
                  deletion_reason: mainCandidate.deletion_reason || mainDelReason,
                });
              }
            }
          }
          parseMediaStructure(record.gallery_media, "gallery_media");
          parseMediaStructure(record.media, "media");
          parseMediaStructure(record.images, "images");
          parseMediaStructure(record.photos, "photos");
          parseMediaStructure(record.pictures, "pictures");
          if (record.coverImage) addImg(record.coverImage, "Cover Photo", "coverImage", { isMainImage: true });
          if (record.serviceImage) addImg(record.serviceImage, "Featured Photo", "serviceImage", { isMainImage: true });
          if (record.thumbnail) addImg(record.thumbnail, "Thumbnail", "thumbnail");
          if (record.image) addImg(record.image, "Main Image", "image", { isMainImage: true });
          list.sort((a, b) => Number(b.isMainImage) - Number(a.isMainImage));
          return list;
        };

        /* Audit Logs Engine — LOCAL STORAGE ONLY */
        window.__logServiceAudit = ({ action, serviceId, serviceTitle, fromStage, toStage, reason, note, imageId, imageCaption, signature }) => {
          try {
            const currentUser =
              (typeof auth !== "undefined" && auth?.currentUser?.email) ||
              (typeof currentAdminUser !== "undefined" && currentAdminUser?.email) ||
              "Admin Compliance Officer";
            const storageKey = window.__LS_SVC_AUDIT_KEY;
            const existingRaw = localStorage.getItem(storageKey);
            const logs = existingRaw ? JSON.parse(existingRaw) : [];
            const entry = {
              id: `svc_audit_${Date.now()}_${Math.random().toString(36).substring(2, 6)}`,
              action: action || "STAGE_CHANGE",
              serviceId: String(serviceId || ""),
              serviceTitle: serviceTitle || "Service",
              fromStage: fromStage || "—",
              toStage: toStage || "—",
              reason: reason || "Compliance Authorized",
              note: note || "",
              imageId: imageId || null,
              imageCaption: imageCaption || null,
              signature: signature || null,
              performedBy: currentUser,
              timestamp: new Date().toISOString(),
              formattedTime: new Date().toLocaleString(),
            };
            logs.unshift(entry);
            if (logs.length > 500) logs.pop();
            localStorage.setItem(storageKey, JSON.stringify(logs));
          } catch (e) {}
        };

        window.__getServiceAuditLogs = (serviceId) => {
          try {
            const raw = localStorage.getItem(window.__LS_SVC_AUDIT_KEY);
            if (!raw) return [];
            const parsed = JSON.parse(raw);
            const sId = String(serviceId || "").trim();
            return sId ? parsed.filter((l) => l && String(l.serviceId).trim() === sId) : parsed;
          } catch (e) {
            return [];
          }
        };

        /* ── SHARED FIRESTORE WRITE TARGET COLLECTOR ── */
        window.__collectServiceWriteTargets = (record, sId) => {
          const targets = new Map();
          const registerPathTarget = (pathStr, requiresExistingCheck = true) => {
            if (!pathStr || targets.has(pathStr)) return;
            if (window.__isBlockedFirestorePath(pathStr)) return;
            const docRef = window.__getFirestoreDocRefUniversal(pathStr);
            if (docRef) targets.set(pathStr, { docRef, requiresExistingCheck, path: pathStr });
          };
          registerPathTarget(`admin_pending_approvals/services/pending/${sId}`, false);
          const recordedDocPaths = Array.isArray(record.docPaths) ? record.docPaths : [];
          recordedDocPaths.forEach((pStr) => {
            if (pStr && !pStr.includes("/services/")) {
              registerPathTarget(pStr, false);
            }
          });
          const candidateProviderIds = new Set();
          if (record.providerId && record.providerId !== "N/A") candidateProviderIds.add(String(record.providerId).trim());
          if (record.userId && record.userId !== "N/A") candidateProviderIds.add(String(record.userId).trim());
          if (record.provider_id && record.provider_id !== "N/A") candidateProviderIds.add(String(record.provider_id).trim());
          candidateProviderIds.forEach((pIdVal) => {
            if (pIdVal) registerPathTarget(`users/${pIdVal}/Notification/${sId}`, true);
          });
          const candidateCategories = new Set();
          if (record.category) candidateCategories.add(String(record.category).trim());
          if (record.serviceCategory) candidateCategories.add(String(record.serviceCategory).trim());
          const candidateSubCategories = new Set();
          if (record.subCategory) candidateSubCategories.add(String(record.subCategory).trim());
          if (record.subcategory) candidateSubCategories.add(String(record.subcategory).trim());
          if (candidateSubCategories.size === 0) candidateSubCategories.add("general");
          candidateCategories.forEach((catVal) => {
            candidateSubCategories.forEach((subCatVal) => {
              if (catVal) {
                registerPathTarget(`All_categories/${catVal}/subCategories/${subCatVal}/Notification/${sId}`, true);
              }
            });
          });
          return targets;
        };

        window.__safeWriteFirestoreDoc = async ({ docRef, requiresExistingCheck, path }, updatePayload) => {
          if (!docRef) return;
          if (window.__isBlockedFirestorePath(path || docRef?.path)) return;
          try {
            if (requiresExistingCheck) {
              const exists = await window.__checkFirestoreDocExistsUniversal(docRef);
              if (!exists) return;
            }
            if (typeof setDoc === "function") {
              try {
                await setDoc(docRef, updatePayload, { merge: true });
                return;
              } catch (e) {
                if (typeof updateDoc === "function") {
                  await updateDoc(docRef, updatePayload);
                  return;
                }
              }
            }
            if (typeof docRef.set === "function") {
              try {
                await docRef.set(updatePayload, { merge: true });
                return;
              } catch (compatErr) {
                if (typeof docRef.update === "function") {
                  await docRef.update(updatePayload);
                  return;
                }
              }
            }
            if (typeof docRef.update === "function") {
              await docRef.update(updatePayload);
            }
          } catch (err) {
            console.warn(`Write safe-skip on ${docRef?.path || path || docRef}:`, err);
          }
        };

        /* ── SCANNER & DISPATCHER: PUSH NOTIFICATIONS TO CLOUD RUN (STRICT FCM TOKEN GATED & FEEDBACK TOASTS) ── */
        window.__sendServicePushNotification = async ({ serviceId, providerId, targetStatus, justificationText, serviceRecord }) => {
          if (!serviceId) return;
          const sId = String(serviceId).trim();
          const pId = String(providerId || (serviceRecord && window.__getServiceProviderId(serviceRecord)) || "N/A").trim();
          const normalizedTargetStatus = window.__normalizeServiceStage(targetStatus);
          const serviceTitle = window.__getServiceTitle(serviceRecord);

          /* Deduplication Lock (30-second window) */
          const dedupeKey = `${sId}::${normalizedTargetStatus}`;
          const lastSentTime = window.__sentNotificationDedupeMap.get(dedupeKey) || 0;
          if (Date.now() - lastSentTime < 30000) {
            window.__showServiceToast(`Notification for "${serviceTitle}" was recently sent (deduplicated).`, "info", 3000);
            return;
          }

          /* Check initial token candidates directly from service record */
          let scannedFcmToken =
            (serviceRecord && (
              serviceRecord.provider_fcm_token ||
              serviceRecord.fcm_token ||
              serviceRecord.fcmToken ||
              serviceRecord.providerFcmToken ||
              serviceRecord.token ||
              serviceRecord.pushToken
            )) || null;

          let scannedStatus = normalizedTargetStatus;
          let scannedCategory = (serviceRecord && (serviceRecord.category || serviceRecord.serviceCategory)) || null;
          let scannedCategoryType = (serviceRecord && (serviceRecord.category_type || serviceRecord.categoryType || serviceRecord.service_type || serviceRecord.serviceType)) || null;

          const extractDocFields = (data) => {
            if (!data || typeof data !== "object") return;
            if (!scannedFcmToken) {
              scannedFcmToken = data.provider_fcm_token || data.fcm_token || data.fcmToken || data.providerFcmToken || data.token || data.pushToken || null;
            }
            if (!scannedCategory && (data.category || data.serviceCategory)) {
              scannedCategory = data.category || data.serviceCategory;
            }
            if (!scannedCategoryType && (data.category_type || data.categoryType || data.service_type || data.serviceType)) {
              scannedCategoryType = data.category_type || data.categoryType || data.service_type || data.serviceType;
            }
            if (data.status || data.approval_status) {
              scannedStatus = window.__normalizeServiceStage(data.approval_status || data.status);
            }
          };

          try {
            /* 1. Scan primary approval collection */
            const ref1 = window.__getFirestoreDocRefUniversal(`admin_pending_approvals/services/pending/${sId}`);
            if (ref1) {
              let snap1 = null;
              if (typeof getDoc === "function") snap1 = await getDoc(ref1);
              else if (typeof ref1.get === "function") snap1 = await ref1.get();
              if (snap1 && (typeof snap1.exists === "function" ? snap1.exists() : snap1.exists)) {
                extractDocFields(typeof snap1.data === "function" ? snap1.data() : snap1.data);
              }
            }

            /* 2. Scan user notification subcollection */
            if (!scannedFcmToken && pId && pId !== "N/A") {
              const ref2 = window.__getFirestoreDocRefUniversal(`users/${pId}/Notification/${sId}`);
              if (ref2) {
                let snap2 = null;
                if (typeof getDoc === "function") snap2 = await getDoc(ref2);
                else if (typeof ref2.get === "function") snap2 = await ref2.get();
                if (snap2 && (typeof snap2.exists === "function" ? snap2.exists() : snap2.exists)) {
                  extractDocFields(typeof snap2.data === "function" ? snap2.data() : snap2.data);
                }
              }
            }

            /* 3. Scan category subcollection */
            const cat = scannedCategory || (serviceRecord && (serviceRecord.category || serviceRecord.serviceCategory)) || null;
            const subCat = (serviceRecord && (serviceRecord.subCategory || serviceRecord.subcategory)) || "general";
            if (!scannedFcmToken && cat) {
              const ref3 = window.__getFirestoreDocRefUniversal(`All_categories/${cat}/subCategories/${subCat}/Notification/${sId}`);
              if (ref3) {
                let snap3 = null;
                if (typeof getDoc === "function") snap3 = await getDoc(ref3);
                else if (typeof ref3.get === "function") snap3 = await ref3.get();
                if (snap3 && (typeof snap3.exists === "function" ? snap3.exists() : snap3.exists)) {
                  extractDocFields(typeof snap3.data === "function" ? snap3.data() : snap3.data);
                }
              }
            }

            /* 4. Scan root user and provider documents */
            if (!scannedFcmToken && pId && pId !== "N/A") {
              const userRef = window.__getFirestoreDocRefUniversal(`users/${pId}`);
              if (userRef) {
                let uSnap = null;
                if (typeof getDoc === "function") uSnap = await getDoc(userRef);
                else if (typeof userRef.get === "function") uSnap = await userRef.get();
                if (uSnap && (typeof uSnap.exists === "function" ? uSnap.exists() : uSnap.exists)) {
                  const uData = typeof uSnap.data === "function" ? uSnap.data() : uSnap.data;
                  scannedFcmToken = uData?.provider_fcm_token || uData?.fcm_token || uData?.fcmToken || uData?.providerFcmToken || uData?.token || null;
                }
              }
              if (!scannedFcmToken) {
                const provRef = window.__getFirestoreDocRefUniversal(`providers/${pId}`);
                if (provRef) {
                  let prSnap = null;
                  if (typeof getDoc === "function") prSnap = await getDoc(provRef);
                  else if (typeof provRef.get === "function") prSnap = await provRef.get();
                  if (prSnap && (typeof prSnap.exists === "function" ? prSnap.exists() : prSnap.exists)) {
                    const prData = typeof prSnap.data === "function" ? prSnap.data() : prSnap.data;
                    scannedFcmToken = prData?.provider_fcm_token || prData?.fcm_token || prData?.fcmToken || prData?.providerFcmToken || prData?.token || null;
                  }
                }
              }
            }
          } catch (scanErr) {
            console.warn("Notice scanning collections for push notification metadata:", scanErr);
          }

          /* STRICT FCM TOKEN GATE: DO NOT SEND NOTIFICATION IF NO FCM TOKEN IS STORED */
          if (!scannedFcmToken || !String(scannedFcmToken).trim()) {
            window.__showServiceToast(`Notice: Push notification skipped (No verified FCM token found for "${serviceTitle}").`, "info", 4000);
            return;
          }

          if (!scannedCategory) scannedCategory = "General";
          if (!scannedCategoryType) scannedCategoryType = "standard";

          const isApproved = normalizedTargetStatus === "approved";
          const isRejected = normalizedTargetStatus === "rejected";

          const notifTitle = isApproved
            ? `Service Approved: "${serviceTitle}"`
            : isRejected
            ? `Service Update: "${serviceTitle}"`
            : `Service Status Updated: "${serviceTitle}"`;

          const notifBody = isApproved
            ? `Congratulations! Your service "${serviceTitle}" in category ${scannedCategory} has been approved and is now active.`
            : isRejected
            ? `Your service "${serviceTitle}" was reviewed. Note: ${justificationText || "Review required"}`
            : `Your service "${serviceTitle}" is now marked as ${window.__getServiceStageMeta(normalizedTargetStatus).label}.`;

          const payload = {
            serviceId: sId,
            service_id: sId,
            providerId: pId,
            provider_id: pId,
            provider_fcm_token: String(scannedFcmToken).trim(),
            fcm_token: String(scannedFcmToken).trim(),
            status: normalizedTargetStatus,
            approval_status: normalizedTargetStatus,
            category: scannedCategory,
            category_type: scannedCategoryType,
            serviceTitle,
            title: notifTitle,
            body: notifBody,
            reason: justificationText || "",
            timestamp: new Date().toISOString(),
          };

          try {
            window.__sentNotificationDedupeMap.set(dedupeKey, Date.now());
            const response = await fetch(window.__SVC_PUSH_NOTIFICATION_ENDPOINT, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(payload),
            });
            if (response.ok || response.status === 200) {
              window.__showServiceToast(`Notification sent successfully for "${serviceTitle}"!`, "success", 4500);
            } else {
              window.__showServiceToast(`Notification dispatch returned status ${response.status} for "${serviceTitle}".`, "warning", 4500);
            }
          } catch (dispatchErr) {
            console.warn("Notice sending service push notification via Cloud Run:", dispatchErr);
            window.__showServiceToast(`Notice: Failed to connect to notification gateway for "${serviceTitle}".`, "error", 4500);
          }
        };

        /* ── MULTI-COLLECTION WRITEBACK ENGINE WITH INSTANT OPTIMISTIC RENDERING ── */
        window.__executeServiceStageTransition = async (serviceId, nextStageId, justificationText = "", encryptionMetadata = null) => {
          if (!serviceId) return;
          const sId = String(serviceId).trim();
          const registry = window.__serviceMasterRegistry;
          const cachedCards = Array.isArray(window.__servicePipelineCards) ? window.__servicePipelineCards : [];
          const existing =
            registry.get(sId) ||
            cachedCards.find((c) => window.__getServiceCanonId(c) === sId) ||
            (window.__selectedInspectionService && window.__getServiceCanonId(window.__selectedInspectionService) === sId ? window.__selectedInspectionService : null) ||
            window.__draggingServiceCard ||
            {};
          const fromStage = window.__getEffectiveServiceStage(existing);
          const normNextStage = window.__normalizeServiceStage(nextStageId);
          const isApproved = normNextStage === "approved";
          const isRejected = normNextStage === "rejected";
          const isNewRequest = normNextStage === "new_request";
          const isPendingVerification = normNextStage === "pending_verification";

          /* STAGE PERSISTENCE GUARANTEE IN IMAGE CHANGES ONLY BOARD:
             When moving from Pending Verification to New Request, retain image change markers strictly */
          const isFromPendingToNewInImageChanges =
            (fromStage === "pending_verification" && isNewRequest) ||
            (window.__serviceQuickFilter === "image_changes_only" && isNewRequest) ||
            Boolean(existing.had_image_changes || existing.image_changes_only || existing.has_image_changes || existing._from_image_changes);

          let targetStatus = normNextStage;
          if (isApproved) {
            targetStatus = "approved";
          } else if (isRejected) {
            targetStatus = "rejected";
          } else if (isNewRequest) {
            targetStatus = "new_request";
          } else if (isPendingVerification) {
            targetStatus = "pending_verification";
          }
          const targetImageStatus = isApproved ? "approved" : isRejected ? "rejected" : "pending";
          const preserveExistingImageReviews =
            !isPendingVerification && (isNewRequest) && (fromStage === "new_request" || fromStage === "pending_verification");
          const currentAdminAuth =
            (typeof auth !== "undefined" && auth?.currentUser?.email) ||
            (typeof currentAdminUser !== "undefined" && currentAdminUser?.email) ||
            "Authorized Compliance Officer";
          const currentTimestamp = new Date().toISOString();
          const stageUpdatedAtValue = window.__getServerTimestampObject();

          const combinedSource = {
            ...existing,
            discount: existing.discount,
            discount_amount: existing.discount_amount,
            discounted_price: existing.discounted_price,
            provider_fcm_token: existing.provider_fcm_token || existing.fcm_token || existing.fcmToken || null,
            fcm_token: existing.fcm_token || existing.provider_fcm_token || null,
            media: existing.media || null,
            gallery_media: existing.gallery_media || null,
            images: existing.images || [],
            photos: existing.photos || [],
            pictures: existing.pictures || [],
            coverImage: existing.coverImage || null,
            serviceImage: existing.serviceImage || null,
            thumbnail: existing.thumbnail || null,
            image: existing.image || null,
            duration_seconds: existing.duration_seconds,
            uploaded_at: existing.uploaded_at || existing.uploadedAt,
          };

          const stampItemStatus = (base, itemStatus) => {
            if (isPendingVerification || isNewRequest) {
              return {
                ...base,
                status: "pending",
                approval_status: "pending",
                media_status: "pending",
                is_approved: false,
                individual_review: false,
                reviewedBy: null,
                reviewedAt: null,
                rejection_reason: null,
              };
            }
            const cur = String(base.status || base.approval_status || "").toLowerCase();
            const keep = preserveExistingImageReviews && (cur === "approved" || cur === "rejected");
            const st = isApproved ? "approved" : (keep ? cur : itemStatus);
            return {
              ...base,
              status: st,
              approval_status: st,
              media_status: st,
              is_approved: st === "approved",
              reviewedBy: keep ? (base.reviewedBy || currentAdminAuth) : currentAdminAuth,
              reviewedAt: keep ? (base.reviewedAt || currentTimestamp) : currentTimestamp,
            };
          };

          const syncMediaStructureWithItemStatuses = (rawContainer, fallbackContainer, statusValue) => {
            const itemStatus = isPendingVerification || isNewRequest ? "pending" : (statusValue === "approved" ? "approved" : statusValue === "rejected" ? "rejected" : "pending");
            let containerObj = {};
            if (typeof rawContainer === "object" && rawContainer !== null && !Array.isArray(rawContainer)) {
              containerObj = { ...rawContainer };
            } else if (Array.isArray(rawContainer)) {
              containerObj = { items: [...rawContainer] };
            } else if (typeof rawContainer === "string" && rawContainer.trim()) {
              containerObj = { items: [{ url: rawContainer.trim(), file: rawContainer.trim(), status: itemStatus, approval_status: itemStatus }] };
            } else if (typeof fallbackContainer === "object" && fallbackContainer !== null && !Array.isArray(fallbackContainer)) {
              containerObj = { ...fallbackContainer };
            } else if (Array.isArray(fallbackContainer)) {
              containerObj = { items: [...fallbackContainer] };
            } else {
              containerObj = { items: [] };
            }
            const existingMainSt = String(containerObj.mainImage_status || containerObj.main_image_status || "").toLowerCase();
            const mainKeep = !isPendingVerification && !isNewRequest && preserveExistingImageReviews && (existingMainSt === "approved" || existingMainSt === "rejected");
            const mainSt = (isPendingVerification || isNewRequest) ? "pending" : (isApproved ? "approved" : (mainKeep ? existingMainSt : itemStatus));
            containerObj.status = isPendingVerification ? "pending_verification" : (isNewRequest ? "new_request" : statusValue);
            containerObj.approval_status = isPendingVerification ? "pending_verification" : (isNewRequest ? "new_request" : statusValue);
            containerObj.media_status = isPendingVerification ? "pending_verification" : (isNewRequest ? "new_request" : statusValue);
            containerObj.mainImage_status = mainSt;
            containerObj.main_image_status = mainSt;
            containerObj.mainImage_approved = mainSt === "approved";
            containerObj.reviewed_by = (isPendingVerification || isNewRequest) ? null : currentAdminAuth;
            containerObj.reviewed_at = (isPendingVerification || isNewRequest) ? null : currentTimestamp;
            ["mainImage", "main_image", "mainImageUrl", "coverUrl", "cover_url"].forEach((mk) => {
              if (containerObj[mk] && typeof containerObj[mk] === "object" && !Array.isArray(containerObj[mk])) {
                containerObj[mk] = stampItemStatus(containerObj[mk], itemStatus);
              }
            });
            if (Array.isArray(containerObj.items) && containerObj.items.length > 0) {
              containerObj.items = containerObj.items.map((item) => {
                if (typeof item === "object" && item !== null) {
                  return stampItemStatus(item, itemStatus);
                } else if (typeof item === "string") {
                  return stampItemStatus({ url: item, file: item }, itemStatus);
                }
                return item;
              });
            } else {
              const reconstructed = [];
              if (Array.isArray(containerObj.images)) {
                containerObj.images.forEach((im) => {
                  reconstructed.push(typeof im === "object" && im !== null ? stampItemStatus(im, itemStatus) : stampItemStatus({ url: im, file: im }, itemStatus));
                });
              }
              if (Array.isArray(containerObj.urls)) {
                containerObj.urls.forEach((u) => {
                  reconstructed.push(typeof u === "object" && u !== null ? stampItemStatus(u, itemStatus) : stampItemStatus({ url: u, file: u }, itemStatus));
                });
              }
              if (containerObj.url || containerObj.file) {
                reconstructed.push(stampItemStatus({ url: containerObj.url || containerObj.file, file: containerObj.file || containerObj.url }, itemStatus));
              }
              if (reconstructed.length > 0) {
                containerObj.items = reconstructed;
              } else if (!Array.isArray(containerObj.items)) {
                containerObj.items = [];
              }
            }
            return containerObj;
          };

          const resolvedGalleryMedia = syncMediaStructureWithItemStatuses(combinedSource.gallery_media, combinedSource.media, targetStatus);
          const resolvedMedia = syncMediaStructureWithItemStatuses(combinedSource.media, combinedSource.gallery_media, targetStatus);
          if ((!resolvedGalleryMedia.items || resolvedGalleryMedia.items.length === 0) && resolvedMedia.items && resolvedMedia.items.length > 0) {
            resolvedGalleryMedia.items = [...resolvedMedia.items];
          }
          if ((!resolvedMedia.items || resolvedMedia.items.length === 0) && resolvedGalleryMedia.items && resolvedGalleryMedia.items.length > 0) {
            resolvedMedia.items = [...resolvedGalleryMedia.items];
          }
          const updatedImages = Array.isArray(combinedSource.images) && combinedSource.images.length > 0
            ? combinedSource.images.map((im) => {
                if (typeof im === "object" && im !== null) {
                  return stampItemStatus(im, targetImageStatus);
                }
                return im;
              })
            : (resolvedGalleryMedia.items || []);

          const stampObjectArray = (arr) =>
            Array.isArray(arr) && arr.length > 0
              ? arr.map((im) => (typeof im === "object" && im !== null ? stampItemStatus(im, targetImageStatus) : im))
              : arr;

          const resolvedPhotos = stampObjectArray(combinedSource.photos);
          const resolvedPictures = stampObjectArray(combinedSource.pictures);

          /* STRICT PRESERVATION OF IMAGE CHANGES FLAGS */
          const hadImageChangesIdentity = isFromPendingToNewInImageChanges ? true : Boolean(
            combinedSource.had_image_changes ||
            combinedSource.image_changes_only ||
            combinedSource.has_image_changes ||
            combinedSource.images_edited ||
            combinedSource.pending_image_review
          );
          const resolvedHasImageChanges = isApproved ? false : (isFromPendingToNewInImageChanges ? true : Boolean(combinedSource.has_image_changes));

          const updatedRecord = {
            ...combinedSource,
            serviceId: sId,
            id: sId,
            discount: combinedSource.discount !== undefined ? combinedSource.discount : null,
            discount_amount: combinedSource.discount_amount !== undefined ? combinedSource.discount_amount : null,
            discounted_price: combinedSource.discounted_price !== undefined ? combinedSource.discounted_price : null,
            provider_fcm_token: combinedSource.provider_fcm_token || combinedSource.fcm_token || null,
            fcm_token: combinedSource.fcm_token || combinedSource.provider_fcm_token || null,
            status: targetStatus,
            approval_status: targetStatus,
            description_status: targetStatus,
            description_is_approved: isApproved,
            media_status: targetStatus,
            is_approved: isApproved,
            is_active: isApproved,
            was_approved: isNewRequest ? false : (isApproved ? true : Boolean(combinedSource.was_approved)),
            had_stage_reset_to_new: isNewRequest,
            had_image_changes: hadImageChangesIdentity,
            image_changes_only: hadImageChangesIdentity,
            has_image_changes: resolvedHasImageChanges,
            pending_image_review: isApproved ? false : (isFromPendingToNewInImageChanges ? true : Boolean(combinedSource.pending_image_review)),
            images_edited: isApproved ? false : (isFromPendingToNewInImageChanges ? true : Boolean(combinedSource.images_edited)),
            _from_image_changes: isFromPendingToNewInImageChanges ? true : Boolean(combinedSource._from_image_changes),
            gallery_media: resolvedGalleryMedia,
            media: resolvedMedia,
            images: updatedImages,
            photos: resolvedPhotos,
            pictures: resolvedPictures,
            duration_seconds: combinedSource.duration_seconds !== undefined ? combinedSource.duration_seconds : null,
            uploaded_at: combinedSource.uploaded_at || combinedSource.uploadedAt || null,
            _localTransitionTime: Date.now(),
            _stageTs: Date.now(),
            _stageSource: "local",
            _stagePath: null,
            rejection_reason: isRejected ? (justificationText || "Service rejected during audit.") : null,
            approval_reason: isApproved ? (justificationText || "Service approved by compliance.") : null,
            reviewed_at: (isPendingVerification || isNewRequest) ? null : currentTimestamp,
            reviewed_by: (isPendingVerification || isNewRequest) ? null : currentAdminAuth,
            reviewedAt: (isPendingVerification || isNewRequest) ? null : currentTimestamp,
            reviewedBy: (isPendingVerification || isNewRequest) ? null : currentAdminAuth,
            stage_updated_at: stageUpdatedAtValue,
            updatedAt: currentTimestamp,
            updated_at: currentTimestamp,
            stageTransition: true,
            stage_transition: true,
            encryption_signature: encryptionMetadata?.signature || combinedSource.encryption_signature || null,
            security_verification_hash: encryptionMetadata?.securityHash || combinedSource.security_verification_hash || null,
          };

          /* ── INSTANT ZERO-LATENCY OPTIMISTIC COMMIT (LOCAL & STATE) ── */
          registry.set(sId, updatedRecord);

          if (typeof setServicePipelineCards === "function") {
            setServicePipelineCards((prev) => {
              const cardMap = new Map();
              if (Array.isArray(prev)) {
                prev.forEach((item) => {
                  const id = window.__getServiceCanonId(item);
                  if (id) cardMap.set(id, item);
                });
              }
              cardMap.set(sId, updatedRecord);
              return Array.from(cardMap.values());
            });
          }
          if (typeof setServiceInspectionRecord === "function") {
            setServiceInspectionRecord((prev) => {
              if (!prev || window.__getServiceCanonId(prev) !== sId) return prev;
              return { ...prev, ...updatedRecord };
            });
          }
          if (window.__selectedInspectionService && window.__getServiceCanonId(window.__selectedInspectionService) === sId) {
            window.__selectedInspectionService = updatedRecord;
          }
          try {
            localStorage.setItem(window.__LS_SVC_BOARD_KEY, JSON.stringify(Array.from(registry.values())));
          } catch (e) {}

          window.__logServiceAudit({
            action: isApproved ? "SERVICE_APPROVED" : isRejected ? "SERVICE_REJECTED" : isNewRequest ? "STAGE_RESET_TO_NEW_REQUEST" : "STAGE_TRANSITION",
            serviceId: sId,
            serviceTitle: window.__getServiceTitle(updatedRecord),
            fromStage,
            toStage: nextStageId,
            reason: justificationText || `Service advanced to ${nextStageId}`,
            signature: encryptionMetadata?.signature || null,
          });

          const extractedMedia = window.__extractServiceImages(updatedRecord);
          extractedMedia.forEach((im) => {
            window.__logImageActivity({
              action: isApproved ? "BULK_IMAGE_APPROVED" : isRejected ? "BULK_IMAGE_REJECTED" : "STAGE_TRANSITION_SYNC",
              serviceId: sId,
              providerId: window.__getServiceProviderId(updatedRecord),
              imageId: im.id,
              imageUrl: im.url,
              imageCaption: im.caption,
              details: `Image synchronized with service status -> ${targetStatus}`,
              reason: justificationText,
            });
          });

          window.__triggerServicePipelineReRender();

          /* ── ASYNC BACKGROUND FIRESTORE WRITEBACK ── */
          (async () => {
            try {
              if (typeof db !== "undefined") {
                const rawUpdatePayload = {
                  serviceId: sId,
                  approval_status: targetStatus,
                  status: targetStatus,
                  discount: updatedRecord.discount,
                  discount_amount: updatedRecord.discount_amount,
                  discounted_price: updatedRecord.discounted_price,
                  description_status: targetStatus,
                  description_is_approved: isApproved,
                  media_status: targetStatus,
                  is_approved: isApproved,
                  is_active: isApproved,
                  was_approved: isNewRequest ? false : (isApproved ? true : Boolean(combinedSource.was_approved)),
                  had_stage_reset_to_new: isNewRequest,
                  had_image_changes: hadImageChangesIdentity,
                  image_changes_only: hadImageChangesIdentity,
                  has_image_changes: resolvedHasImageChanges,
                  pending_image_review: isApproved ? false : (isFromPendingToNewInImageChanges ? true : Boolean(combinedSource.pending_image_review)),
                  images_edited: isApproved ? false : (isFromPendingToNewInImageChanges ? true : Boolean(combinedSource.images_edited)),
                  _from_image_changes: isFromPendingToNewInImageChanges ? true : Boolean(combinedSource._from_image_changes),
                  gallery_media: resolvedGalleryMedia,
                  media: resolvedMedia,
                  images: updatedImages,
                  photos: resolvedPhotos,
                  pictures: resolvedPictures,
                  rejection_reason: isRejected ? (justificationText || "Service rejected during audit.") : null,
                  approval_reason: isApproved ? (justificationText || "Service approved by compliance.") : null,
                  reviewed_at: (isPendingVerification || isNewRequest) ? null : currentTimestamp,
                  reviewed_by: (isPendingVerification || isNewRequest) ? null : currentAdminAuth,
                  stage_updated_at: stageUpdatedAtValue,
                  updatedAt: currentTimestamp,
                  updated_at: currentTimestamp,
                  stageTransition: true,
                  stage_transition: true,
                  encryption_signature: encryptionMetadata?.signature || null,
                  security_verification_hash: encryptionMetadata?.securityHash || null,
                };
                const updatePayload = window.__stripDisallowedFieldsForFirestore(rawUpdatePayload);
                const registeredTargets = window.__collectServiceWriteTargets(updatedRecord, sId);
                const writePromises = Array.from(registeredTargets.values()).map((t) => window.__safeWriteFirestoreDoc(t, updatePayload));
                await Promise.allSettled(writePromises);
              }
            } catch (err) {
              console.error("Critical error updating Firestore across collections:", err);
            }
          })();

          /* ── ASYNC CLOUD RUN PUSH NOTIFICATION (STRICT FCM TOKEN CHECK & FEEDBACK) ── */
          if (isApproved || isRejected) {
            window.__sendServicePushNotification({
              serviceId: sId,
              providerId: window.__getServiceProviderId(updatedRecord),
              targetStatus: targetStatus,
              justificationText: justificationText,
              serviceRecord: updatedRecord,
            });
          }

          const toastMsg = isApproved
            ? `Service & all images approved for "${window.__getServiceTitle(updatedRecord)}"!`
            : isRejected
            ? `Service rejected for "${window.__getServiceTitle(updatedRecord)}".`
            : isNewRequest
            ? `Service moved to New Request stage in Image Changes board.`
            : `Service transitioned to ${window.__getServiceStageMeta(nextStageId).label}.`;
          window.__showServiceToast(toastMsg, isApproved ? "success" : isRejected ? "error" : "info");
        };

        /* ── GENERIC RECURSIVE IMAGE-BY-URL STATUS STAMPER ── */
        window.__stampImageStatusByUrl = (node, targetUrl, statusValue, meta) => {
          let matched = false;
          const getUrl = (o) => {
            if (typeof o === "string") return o.trim();
            if (o && typeof o === "object") {
              const u = o.url || o.file || o.image || o.fileUrl || o.downloadURL || o.src;
              return u ? String(u).trim() : null;
            }
            return null;
          };
          const stampObj = (obj, urlVal) => ({
            ...obj,
            url: obj.url || urlVal,
            file: obj.file || obj.url || urlVal,
            status: statusValue,
            approval_status: statusValue,
            media_status: statusValue,
            is_approved: statusValue === "approved",
            individual_review: true,
            reviewedBy: meta.reviewedBy,
            reviewedAt: meta.reviewedAt,
            rejection_reason: statusValue === "rejected" ? (meta.reason || obj.rejection_reason || "Rejected by reviewer") : (obj.rejection_reason || null),
          });
          const NESTED_KEYS = ["items", "urls", "images", "media", "mainImage", "main_image", "mainImageUrl", "coverUrl", "cover_url"];
          const SKIP_KEYS = new Set([
            "status", "approval_status", "media_status", "items", "urls", "images", "media",
            "updatedAt", "updated_at", "stage_updated_at", "createdAt", "mainImage", "main_image", "mainImageUrl", "coverUrl", "cover_url",
            "url", "file", "image", "fileUrl", "downloadURL", "src", "is_approved",
            "reviewedBy", "reviewedAt", "rejection_reason", "individual_review"
          ]);
          const walk = (n) => {
            if (n === null || n === undefined) return n;
            if (typeof n === "string") {
              if (window.__urlsMatchCanonical(n, targetUrl)) {
                matched = true;
                return stampObj({}, n.trim());
              }
              return n;
            }
            if (Array.isArray(n)) {
              return n.map((it) => {
                if (typeof it === "string" && window.__urlsMatchCanonical(it, targetUrl)) {
                  matched = true;
                  return stampObj({}, it.trim());
                }
                return walk(it);
              });
            }
            if (typeof n === "object") {
              let out = { ...n };
              const u = getUrl(n);
              if (u && window.__urlsMatchCanonical(u, targetUrl)) {
                matched = true;
                out = stampObj(out, u);
              }
              if (typeof out.mainImage === "string" && window.__urlsMatchCanonical(out.mainImage, targetUrl)) {
                matched = true;
                out.mainImage_status = statusValue;
                out.mainImage_approval_status = statusValue;
                out.mainImage_is_approved = statusValue === "approved";
                out.mainImage_reviewed_by = meta.reviewedBy;
                out.mainImage_reviewed_at = meta.reviewedAt;
                out.mainImage_individual_review = true;
              }
              if (typeof out.main_image === "string" && window.__urlsMatchCanonical(out.main_image, targetUrl)) {
                matched = true;
                out.main_image_status = statusValue;
                out.main_image_approval_status = statusValue;
                out.main_image_is_approved = statusValue === "approved";
                out.main_image_individual_review = true;
              }
              NESTED_KEYS.forEach((k) => {
                if (out[k] !== undefined) out[k] = walk(out[k]);
              });
              Object.keys(out).forEach((k) => {
                if (SKIP_KEYS.has(k)) return;
                const val = out[k];
                if (val && typeof val === "object") {
                  out[k] = walk(val);
                }
              });
              return out;
            }
            return n;
          };
          const result = walk(node);
          return { result, matched };
        };

        /* ── PER-IMAGE APPROVE / REJECT ENGINE WITH STAGE_UPDATED_AT MAP ── */
        window.__setSingleImageReviewStatus = async (serviceId, imageIdentifier, newStatus, reasonText = "") => {
          const sId = String(serviceId || "").trim();
          if (!sId || !imageIdentifier) return;
          const registry = window.__serviceMasterRegistry;
          const cachedCards = Array.isArray(window.__servicePipelineCards) ? window.__servicePipelineCards : [];
          const existing =
            registry.get(sId) ||
            cachedCards.find((c) => window.__getServiceCanonId(c) === sId) ||
            (window.__selectedInspectionService && window.__getServiceCanonId(window.__selectedInspectionService) === sId ? window.__selectedInspectionService : null);
          if (!existing) return;
          const allExtractedNow = window.__extractServiceImages(existing);
          const targetImgMeta = allExtractedNow.find(
            (im) => im.id === imageIdentifier || window.__urlsMatchCanonical(im.url, imageIdentifier)
          );
          const targetUrl = targetImgMeta ? targetImgMeta.url : String(imageIdentifier).trim();
          if (!targetUrl) return;
          const currentAdminAuth =
            (typeof auth !== "undefined" && auth?.currentUser?.email) ||
            (typeof currentAdminUser !== "undefined" && currentAdminUser?.email) ||
            "Authorized Compliance Officer";
          const nowIso = new Date().toISOString();
          const stageUpdatedAtValue = window.__getServerTimestampObject();
          const stampMeta = { reviewedBy: currentAdminAuth, reviewedAt: nowIso, reason: reasonText };
          let anyMatched = false;
          const stampField = (fieldVal) => {
            if (fieldVal === undefined || fieldVal === null) return fieldVal;
            const { result, matched } = window.__stampImageStatusByUrl(fieldVal, targetUrl, newStatus, stampMeta);
            if (matched) anyMatched = true;
            return result;
          };
          const updatedGalleryMedia = stampField(existing.gallery_media);
          const updatedMedia = stampField(existing.media);
          const updatedImagesArrRaw = stampField(existing.images);
          const updatedPhotos = stampField(existing.photos);
          const updatedPictures = stampField(existing.pictures);
          let matchedCaption = targetImgMeta?.caption || "";
          let finalImagesArr = updatedImagesArrRaw !== undefined ? updatedImagesArrRaw : existing.images;
          if (!anyMatched) {
            if (!targetImgMeta) return;
            anyMatched = true;
            matchedCaption = targetImgMeta.caption;
            finalImagesArr = [
              ...(Array.isArray(existing.images) ? existing.images : []),
              {
                id: targetImgMeta.id,
                url: targetImgMeta.url,
                file: targetImgMeta.url,
                caption: targetImgMeta.caption,
                status: newStatus,
                approval_status: newStatus,
                media_status: newStatus,
                is_approved: newStatus === "approved",
                individual_review: true,
                uploadedAt: targetImgMeta.uploadedAt,
                uploadedBy: targetImgMeta.uploadedBy,
                reviewedBy: currentAdminAuth,
                reviewedAt: nowIso,
                isMainImage: targetImgMeta.isMainImage,
                rejection_reason: newStatus === "rejected" ? (reasonText || "Rejected by reviewer") : null,
              },
            ];
          }
          const updatedRecord = {
            ...existing,
            gallery_media: updatedGalleryMedia !== undefined ? updatedGalleryMedia : existing.gallery_media,
            media: updatedMedia !== undefined ? updatedMedia : existing.media,
            images: finalImagesArr,
            photos: updatedPhotos !== undefined ? updatedPhotos : existing.photos,
            pictures: updatedPictures !== undefined ? updatedPictures : existing.pictures,
            reviewed_at: nowIso,
            reviewed_by: currentAdminAuth,
            reviewedAt: nowIso,
            reviewedBy: currentAdminAuth,
            stage_updated_at: stageUpdatedAtValue,
            updatedAt: nowIso,
            updated_at: nowIso,
            _stageTs: Date.now(),
            _stageSource: "local",
            _stagePath: null,
            _localTransitionTime: Date.now(),
          };
          registry.set(sId, updatedRecord);
          if (typeof setServicePipelineCards === "function") {
            setServicePipelineCards((prev) => {
              const cardMap = new Map();
              if (Array.isArray(prev)) prev.forEach((it) => { const id = window.__getServiceCanonId(it); if (id) cardMap.set(id, it); });
              cardMap.set(sId, updatedRecord);
              return Array.from(cardMap.values());
            });
          }
          if (typeof setServiceInspectionRecord === "function") {
            setServiceInspectionRecord((prev) => (prev && window.__getServiceCanonId(prev) === sId ? { ...prev, ...updatedRecord } : prev));
          }
          if (window.__selectedInspectionService && window.__getServiceCanonId(window.__selectedInspectionService) === sId) {
            window.__selectedInspectionService = updatedRecord;
          }
          try { localStorage.setItem(window.__LS_SVC_BOARD_KEY, JSON.stringify(Array.from(registry.values()))); } catch (e) {}
          window.__logServiceAudit({
            action: newStatus === "approved" ? "IMAGE_APPROVED" : "IMAGE_REJECTED",
            serviceId: sId,
            serviceTitle: window.__getServiceTitle(updatedRecord),
            fromStage: "image_review",
            toStage: newStatus,
            reason: reasonText || `Image marked ${newStatus}`,
            imageId: targetUrl,
            imageCaption: matchedCaption,
          });
          window.__logImageActivity({
            action: newStatus === "approved" ? "IMAGE_APPROVED" : "IMAGE_REJECTED",
            serviceId: sId,
            providerId: window.__getServiceProviderId(updatedRecord),
            imageId: targetUrl,
            imageUrl: targetUrl,
            imageCaption: matchedCaption,
            details: `Single image marked ${newStatus}`,
            reason: reasonText,
          });
          (async () => {
            try {
              if (typeof db !== "undefined") {
                const targetDocMap = window.__collectServiceWriteTargets(updatedRecord, sId);
                const rawUpdatePayload = {
                  gallery_media: updatedRecord.gallery_media,
                  media: updatedRecord.media,
                  images: updatedRecord.images,
                  photos: updatedRecord.photos,
                  pictures: updatedRecord.pictures,
                  reviewed_at: nowIso,
                  reviewed_by: currentAdminAuth,
                  stage_updated_at: stageUpdatedAtValue,
                  updatedAt: nowIso,
                  updated_at: nowIso,
                };
                const updatePayload = window.__stripDisallowedFieldsForFirestore(rawUpdatePayload);
                await Promise.allSettled(Array.from(targetDocMap.values()).map((t) => window.__safeWriteFirestoreDoc(t, updatePayload)));
              }
            } catch (err) {
              console.error("Error writing per-image status across collections:", err);
            }
          })();

          if (newStatus === "approved") {
            const allApproved = window.__areAllServiceImagesApproved(updatedRecord);
            if (allApproved && window.__isImageChangesOnlyService(updatedRecord)) {
              await window.__executeServiceStageTransition(sId, "approved", "All individually reviewed images approved.");
              return;
            }
          }
          window.__showServiceToast(`Image ${newStatus === "approved" ? "approved" : "rejected"} successfully!`, newStatus === "approved" ? "success" : "error");
          window.__triggerServicePipelineReRender();
        };

        /* ── FEATURE 3: PROCESS PROVIDER IMAGE DELETION REQUESTS (APPROVE OR REJECT) ── */
        window.__processImageDeletionRequest = async (serviceId, imageIdentifier, decision, adminReason = "") => {
          const sId = String(serviceId || "").trim();
          if (!sId || !imageIdentifier) return;
          const registry = window.__serviceMasterRegistry;
          const existing = registry.get(sId);
          if (!existing) return;
          const images = window.__extractServiceImages(existing);
          const targetImg = images.find((im) => im.id === imageIdentifier || window.__urlsMatchCanonical(im.url, imageIdentifier));
          if (!targetImg) return;
          const targetUrl = targetImg.url;
          const pId = window.__getServiceProviderId(existing);
          const nowIso = new Date().toISOString();
          const stageUpdatedAtValue = window.__getServerTimestampObject();
          if (decision === "approve") {
            window.__moveToRecycleBin({
              serviceId: sId,
              providerId: pId,
              imgItem: targetImg,
              reason: adminReason || `Deletion request approved: ${targetImg.deletionReason || "Removed by provider"}`,
            });
            const filterArray = (arr) => {
              if (!Array.isArray(arr)) return arr;
              return arr.filter((x) => {
                const u = typeof x === "string" ? x : (x?.url || x?.file || x?.image);
                return !window.__urlsMatchCanonical(u, targetUrl);
              });
            };
            const updatedImages = filterArray(existing.images);
            const updatedPhotos = filterArray(existing.photos);
            const updatedPictures = filterArray(existing.pictures);
            let updatedGalleryMedia = existing.gallery_media;
            if (updatedGalleryMedia && typeof updatedGalleryMedia === "object") {
              const gmCopy = JSON.parse(JSON.stringify(updatedGalleryMedia));
              if (Array.isArray(gmCopy.items)) gmCopy.items = filterArray(gmCopy.items);
              if (Array.isArray(gmCopy.images)) gmCopy.images = filterArray(gmCopy.images);
              if (Array.isArray(gmCopy.urls)) gmCopy.urls = filterArray(gmCopy.urls);
              if (window.__urlsMatchCanonical(gmCopy.mainImage, targetUrl)) gmCopy.mainImage = null;
              if (window.__urlsMatchCanonical(gmCopy.main_image, targetUrl)) gmCopy.main_image = null;
              updatedGalleryMedia = gmCopy;
            }
            const updatedRecord = {
              ...existing,
              images: updatedImages,
              photos: updatedPhotos,
              pictures: updatedPictures,
              gallery_media: updatedGalleryMedia,
              stage_updated_at: stageUpdatedAtValue,
              updatedAt: nowIso,
              updated_at: nowIso,
            };

            registry.set(sId, updatedRecord);
            if (typeof setServicePipelineCards === "function") {
              setServicePipelineCards(Array.from(registry.values()));
            }
            if (typeof setServiceInspectionRecord === "function") {
              setServiceInspectionRecord((prev) => (prev && window.__getServiceCanonId(prev) === sId ? { ...prev, ...updatedRecord } : prev));
            }
            window.__logImageActivity({
              action: "IMAGE_DELETION_REQUEST_APPROVED",
              serviceId: sId,
              providerId: pId,
              imageId: targetUrl,
              imageUrl: targetUrl,
              imageCaption: targetImg.caption,
              details: "Admin approved deletion request; image moved to 7-Day Recycle Bin",
              reason: adminReason,
            });
            (async () => {
              try {
                if (typeof db !== "undefined") {
                  const targets = window.__collectServiceWriteTargets(updatedRecord, sId);
                  const rawPayload = {
                    images: updatedImages,
                    photos: updatedPhotos,
                    pictures: updatedPictures,
                    gallery_media: updatedGalleryMedia,
                    stage_updated_at: stageUpdatedAtValue,
                    updatedAt: nowIso,
                    updated_at: nowIso,
                  };
                  const cleanPayload = window.__stripDisallowedFieldsForFirestore(rawPayload);
                  await Promise.allSettled(Array.from(targets.values()).map((t) => window.__safeWriteFirestoreDoc(t, cleanPayload)));
                }
              } catch (err) {}
            })();
            window.__showServiceToast("Deletion request approved. Image moved to 7-Day Recycle Bin.", "success");
          } else {
            const clearFlagsInArray = (arr) => {
              if (!Array.isArray(arr)) return arr;
              return arr.map((item) => {
                if (typeof item === "object" && item !== null) {
                  const u = item.url || item.file || item.image;
                  if (window.__urlsMatchCanonical(u, targetUrl)) {
                    return {
                      ...item,
                      deletion_requested: false,
                      deletionRequested: false,
                      delete_requested: false,
                      deletion_reason: null,
                      deletion_rejected_reason: adminReason || "Admin declined deletion request",
                      deletion_reviewed_at: nowIso,
                    };
                  }
                }
                return item;
              });
            };
            const updatedImages = clearFlagsInArray(existing.images);
            const updatedRecord = {
              ...existing,
              images: updatedImages,
              stage_updated_at: stageUpdatedAtValue,
              updatedAt: nowIso,
              updated_at: nowIso,
            };
            registry.set(sId, updatedRecord);
            if (typeof setServicePipelineCards === "function") {
              setServicePipelineCards(Array.from(registry.values()));
            }
            if (typeof setServiceInspectionRecord === "function") {
              setServiceInspectionRecord((prev) => (prev && window.__getServiceCanonId(prev) === sId ? { ...prev, ...updatedRecord } : prev));
            }
            window.__logImageActivity({
              action: "IMAGE_DELETION_REQUEST_REJECTED",
              serviceId: sId,
              providerId: pId,
              imageId: targetUrl,
              imageUrl: targetUrl,
              imageCaption: targetImg.caption,
              details: "Admin declined provider's image deletion request",
              reason: adminReason,
            });
            (async () => {
              try {
                if (typeof db !== "undefined") {
                  const targets = window.__collectServiceWriteTargets(updatedRecord, sId);
                  const rawPayload = {
                    images: updatedImages,
                    stage_updated_at: stageUpdatedAtValue,
                    updatedAt: nowIso,
                    updated_at: nowIso,
                  };
                  const cleanPayload = window.__stripDisallowedFieldsForFirestore(rawPayload);
                  await Promise.allSettled(Array.from(targets.values()).map((t) => window.__safeWriteFirestoreDoc(t, cleanPayload)));
                }
              } catch (err) {}
            })();
            window.__showServiceToast("Deletion request rejected. Image preserved in active service.", "info");
          }
          window.__triggerServicePipelineReRender();
        };

        /* ── INCOMING FIRESTORE DOCUMENT PROCESSOR ── */
        window.__processSingleIncomingServiceDoc = (d, originLabel, isLive = false) => {
          if (!d) return null;
          const rawData = typeof d.data === "function" ? d.data() : d;
          const data = window.__stripDisallowedFieldsForFirestore(rawData) || {};
          const pathStr = d.ref?.path || (typeof d.path === "string" ? d.path : "");
          if (window.__isBlockedFirestorePath(pathStr)) return null;
          let sId = String(data.serviceId || data.id || data.uid || "").trim();
          if (!sId && d.id) {
            sId = String(d.id).trim();
          }
          if (!sId) return null;
          const isLikelyService = Boolean(
            data.serviceTitle || data.serviceName || data.title || data.name ||
            data.category || data.serviceCategory || data.pricing || data.price ||
            data.discount_amount !== undefined || data.discounted_price !== undefined || data.discount !== undefined ||
            data.gallery_media || data.images || data.photos || data.media ||
            data.serviceId || (pathStr && (pathStr.includes("services") || pathStr.includes("admin_pending_approvals")))
          );
          if (!isLikelyService && !window.__serviceMasterRegistry.has(sId)) {
            return null;
          }
          const existing = window.__serviceMasterRegistry.get(sId) || {};
          const isBrandNewRecord = !window.__serviceMasterRegistry.has(sId);
          const segments = pathStr.split("/").filter(Boolean);
          let pathProviderId = null;
          let pathCategory = null;
          let pathSubCategory = null;
          if (segments.length >= 4 && segments[0] === "users" && segments[2] === "Notification") {
            pathProviderId = segments[1];
          }
          if (segments.length >= 6 && segments[0] === "All_categories" && segments[2] === "subCategories" && segments[4] === "Notification") {
            pathCategory = segments[1];
            pathSubCategory = segments[3];
          }
          const incomingTs = window.__getStageTimestampMs(data);
          const incomingIsPrimary = pathStr.startsWith("admin_pending_approvals/");
          const existingTs = Number(existing._stageTs || 0);
          const hasExistingStage = Boolean(existing.approval_status);
          let acceptIncomingStage = true;
          if (hasExistingStage && !isBrandNewRecord) {
            const sameSource = Boolean(pathStr && existing._stagePath && existing._stagePath === pathStr);
            if (sameSource) {
              acceptIncomingStage = incomingTs === 0 || incomingTs >= existingTs;
            } else if (incomingTs > existingTs) {
              acceptIncomingStage = true;
            } else if (incomingTs === existingTs) {
              acceptIncomingStage = incomingIsPrimary || (existing._stageSource !== "primary" && existing._stageSource !== "local");
            } else {
              acceptIncomingStage = false;
            }
          }
          const isRecentlyTransitionedLocally = existing._localTransitionTime && (Date.now() - existing._localTransitionTime < 15000);
          const keepExistingStageMeta = Boolean(hasExistingStage && !isBrandNewRecord && (isRecentlyTransitionedLocally || !acceptIncomingStage));
          const forceNewRequest = isBrandNewRecord && isLive && !window.__hasReviewMarkers(data);
          const incomingSubmitted = window.__isProviderSubmittedUnreviewed(data);
          let currentStage;
          if (forceNewRequest) {
            currentStage = "new_request";
          } else if (isRecentlyTransitionedLocally && existing.approval_status) {
            currentStage = window.__normalizeServiceStage(existing.approval_status);
          } else if (!acceptIncomingStage && existing.approval_status) {
            currentStage = window.__normalizeServiceStage(existing.approval_status);
          } else {
            const incomingExplicitStage = incomingSubmitted
              ? "new_request"
              : (data.approval_status !== undefined && data.approval_status !== null && String(data.approval_status).trim() !== ""
                ? window.__normalizeServiceStage(data.approval_status)
                : (data.status !== undefined && data.status !== null && String(data.status).trim() !== "" ? window.__normalizeServiceStage(data.status) : null));
            if (incomingExplicitStage) {
              currentStage = incomingExplicitStage;
            } else if (existing.approval_status) {
              currentStage = window.__normalizeServiceStage(existing.approval_status);
            } else {
              currentStage = "new_request";
            }
          }
          const wasPreviouslyApproved = Boolean(
            (currentStage !== "new_request" && (existing.is_approved || existing.approval_status === "approved" || data.was_approved || data.previous_status === "approved"))
          );
          const hadImageChanges = Boolean(
            existing.had_image_changes ||
            existing.image_changes_only ||
            existing._from_image_changes ||
            data.had_image_changes ||
            data.image_changes_only ||
            data.has_image_changes ||
            data.images_edited ||
            data.pending_image_review
          );
          const hasImageEditFlag = Boolean(
            data.images_edited ||
            data.pending_image_review ||
            data.has_image_changes
          );
          const existingPaths = Array.isArray(existing.docPaths) ? [...existing.docPaths] : [];
          if (pathStr && !existingPaths.includes(pathStr)) {
            existingPaths.push(pathStr);
          }
          const existingImagesList = window.__extractServiceImages(existing);
          const existingImgStatusMap = new Map();
          if (currentStage !== "pending_verification" || !isRecentlyTransitionedLocally) {
            existingImagesList.forEach((im) => {
              if (im && im.url) {
                const base = im.url.split("?")[0];
                existingImgStatusMap.set(base, im);
              }
            });
          }
          const preserveImgStatusInContainer = (container) => {
            if (!container || existingImgStatusMap.size === 0) return container;
            if (typeof container !== "object") return container;
            const stamped = JSON.parse(JSON.stringify(container));
            const visit = (node) => {
              if (!node || typeof node !== "object") return;
              if (Array.isArray(node)) {
                node.forEach((item) => {
                  if (typeof item === "object" && item !== null) {
                    const u = item.url || item.file || item.image;
                    if (u) {
                      const ex = existingImgStatusMap.get(String(u).split("?")[0]);
                      if (ex && (ex.status === "approved" || ex.status === "rejected") && (!item.status || item.status === "pending")) {
                        item.status = ex.status;
                        item.approval_status = ex.approval_status;
                        item.is_approved = ex.status === "approved";
                        item.reviewedBy = ex.reviewedBy || item.reviewedBy;
                        item.reviewedAt = ex.reviewedAt || item.reviewedAt;
                      }
                    }
                  }
                  visit(item);
                });
                return;
              }
              const u = node.url || node.file || node.image;
              if (u) {
                const ex = existingImgStatusMap.get(String(u).split("?")[0]);
                if (ex && (ex.status === "approved" || ex.status === "rejected") && (!node.status || node.status === "pending")) {
                  node.status = ex.status;
                  node.approval_status = ex.approval_status;
                  node.is_approved = ex.status === "approved";
                  node.reviewedBy = ex.reviewedBy || node.reviewedBy;
                  node.reviewedAt = ex.reviewedAt || node.reviewedAt;
                }
              }
              if (typeof node.mainImage === "string") {
                const ex = existingImgStatusMap.get(String(node.mainImage).split("?")[0]);
                if (ex && (ex.status === "approved" || ex.status === "rejected")) {
                  node.mainImage_status = ex.status;
                  node.mainImage_approval_status = ex.approval_status;
                  node.mainImage_is_approved = ex.status === "approved";
                }
              }
              Object.keys(node).forEach((k) => {
                if (typeof node[k] === "object" && node[k] !== null) visit(node[k]);
              });
            };
            visit(stamped);
            return stamped;
          };
          const resolvedGallery = preserveImgStatusInContainer(data.gallery_media || existing.gallery_media || null);
          const resolvedMed = preserveImgStatusInContainer(data.media || existing.media || null);
          let resolvedImgs = (Array.isArray(data.images) && data.images.length > 0) ? data.images : (existing.images || []);
          if (Array.isArray(resolvedImgs)) {
            resolvedImgs = resolvedImgs.map((im) => {
              if (typeof im === "object" && im !== null) {
                const u = im.url || im.file || im.id;
                if (u) {
                  const ex = existingImgStatusMap.get(String(u).split("?")[0]);
                  if (ex && (ex.status === "approved" || ex.status === "rejected") && (!im.status || im.status === "pending")) {
                    return {
                      ...im,
                      status: ex.status,
                      approval_status: ex.approval_status,
                      is_approved: ex.status === "approved",
                      reviewedBy: ex.reviewedBy || im.reviewedBy,
                      reviewedAt: ex.reviewedAt || im.reviewedAt,
                    };
                  }
                }
              }
              return im;
            });
          }
          const rawDuration = data.duration_seconds !== undefined ? data.duration_seconds : (data.durationSeconds !== undefined ? data.durationSeconds : existing.duration_seconds);
          const rawUploadedAt = data.uploaded_at || data.uploadedAt || data.upload_date || data.createdAt || existing.uploaded_at;
          const resolvedPid = data.providerId || existing.providerId || pathProviderId || data.userId || null;
          const resolvedUid = data.userId || existing.userId || pathProviderId || data.providerId || null;
          const rawReviewedAt = data.reviewed_at || data.reviewedAt || existing.reviewed_at || existing.reviewedAt || null;

          const resolvedDiscount = data.discount !== undefined ? data.discount : (existing.discount !== undefined ? existing.discount : null);
          const resolvedDiscountAmount = data.discount_amount !== undefined ? data.discount_amount : (data.discountAmount !== undefined ? data.discountAmount : (existing.discount_amount !== undefined ? existing.discount_amount : null));
          const resolvedDiscountedPrice = data.discounted_price !== undefined ? data.discounted_price : (data.discountedPrice !== undefined ? data.discountedPrice : (existing.discounted_price !== undefined ? existing.discounted_price : null));

          const resolvedFcmToken = data.provider_fcm_token || data.fcm_token || data.fcmToken || data.providerFcmToken || existing.provider_fcm_token || null;
          const resolvedCategoryType = data.category_type || data.categoryType || data.service_type || data.serviceType || existing.category_type || null;

          const merged = {
            ...existing,
            ...data,
            serviceId: sId,
            id: sId,
            origin: originLabel || existing.origin,
            providerId: resolvedPid,
            userId: resolvedUid,
            category: data.category || existing.category || pathCategory || data.serviceCategory || null,
            subCategory: data.subCategory || existing.subCategory || pathSubCategory || data.subcategory || null,
            category_type: resolvedCategoryType,
            categoryType: resolvedCategoryType,
            provider_fcm_token: resolvedFcmToken,
            discount: resolvedDiscount,
            discount_amount: resolvedDiscountAmount,
            discounted_price: resolvedDiscountedPrice,
            approval_status: currentStage,
            status: currentStage,
            description_status: data.description_status || existing.description_status || currentStage,
            description_is_approved: data.description_is_approved !== undefined ? Boolean(data.description_is_approved) : (currentStage === "approved"),
            media_status: data.media_status || existing.media_status || currentStage,
            was_approved: wasPreviouslyApproved,
            had_stage_reset_to_new: Boolean(data.had_stage_reset_to_new || existing.had_stage_reset_to_new || currentStage === "new_request"),
            had_image_changes: hadImageChanges,
            image_changes_only: hadImageChanges,
            _from_image_changes: Boolean(existing._from_image_changes || data._from_image_changes),
            images_edited: hasImageEditFlag || (currentStage !== "approved" && Boolean(existing.images_edited)),
            pending_image_review: hasImageEditFlag || (currentStage !== "approved" && Boolean(existing.pending_image_review)),
            is_active: currentStage === "approved",
            is_approved: currentStage === "approved",
            duration_seconds: rawDuration !== undefined ? rawDuration : "N/A",
            uploaded_at: rawUploadedAt ? (typeof rawUploadedAt?.toDate === "function" ? rawUploadedAt.toDate().toISOString() : rawUploadedAt) : null,
            createdAt: data.createdAt || existing.createdAt || rawUploadedAt || null,
            rejection_reason: data.rejection_reason || existing.rejection_reason || null,
            approval_reason: data.approval_reason || existing.approval_reason || null,
            reviewed_at: rawReviewedAt,
            reviewedAt: rawReviewedAt,
            reviewed_by: data.reviewed_by || data.reviewedBy || existing.reviewed_by || existing.reviewedBy || null,
            stageTransition: Boolean(data.stageTransition || existing.stageTransition),
            stage_transition: Boolean(data.stage_transition || data.stageTransition || existing.stage_transition || existing.stageTransition),
            encryption_signature: data.encryption_signature || existing.encryption_signature || null,
            security_verification_hash: data.security_verification_hash || existing.security_verification_hash || null,
            _localTransitionTime: existing._localTransitionTime || null,
            _stageTs: keepExistingStageMeta ? existingTs : incomingTs,
            _stageSource: keepExistingStageMeta ? (existing._stageSource || null) : (incomingIsPrimary ? "primary" : "notification"),
            _stagePath: keepExistingStageMeta ? (existing._stagePath || null) : (pathStr || null),
            _detectedAt: existing._detectedAt || (isBrandNewRecord ? Date.now() : null),
            _detectedFresh: Boolean(existing._detectedFresh || (isBrandNewRecord && isLive)),
            gallery_media: resolvedGallery,
            media: resolvedMed,
            images: resolvedImgs,
            photos: data.photos || existing.photos || [],
            coverImage: data.coverImage || existing.coverImage || null,
            serviceImage: data.serviceImage || existing.serviceImage || null,
            thumbnail: data.thumbnail || existing.thumbnail || null,
            image: data.image || existing.image || null,
            docPaths: existingPaths,
          };

          const extractedImages = window.__extractServiceImages(merged);
          const currentDeletionReqs = extractedImages.filter((im) => im.deletionRequested);
          if (currentDeletionReqs.length > 0 || data.image_deletion_requested || data.deletion_requested) {
            merged.has_deletion_requests = true;
            merged.deletion_requests_count = Math.max(currentDeletionReqs.length, 1);
          } else {
            merged.has_deletion_requests = false;
            merged.deletion_requests_count = 0;
          }
          window.__resolveProviderNameAsync(resolvedPid, resolvedUid);
          window.__serviceMasterRegistry.set(sId, merged);
          if (typeof setServicePipelineCards === "function") {
            setServicePipelineCards(Array.from(window.__serviceMasterRegistry.values()));
          }
          if (window.__selectedInspectionService && window.__getServiceCanonId(window.__selectedInspectionService) === sId) {
            window.__selectedInspectionService = merged;
          }
          return { sId, isNew: isBrandNewRecord };
        };

        /* ── REAL-TIME SNAPSHOT LISTENERS ── */
        window.__attachRealtimeServiceListeners = () => {
          if (typeof db === "undefined" || window.__serviceRealtimeListenersActive) return;
          window.__serviceRealtimeListenersActive = true;
          const handleSnapshot = (snap, label) => {
            const isLive = Boolean(window.__svcFirstSnapDone[label]);
            const freshIds = [];
            snap.forEach((d) => {
              const res = window.__processSingleIncomingServiceDoc(d, label, isLive);
              if (res && res.isNew && isLive) freshIds.push(res.sId);
            });
            window.__svcFirstSnapDone[label] = true;
            try {
              localStorage.setItem(window.__LS_SVC_BOARD_KEY, JSON.stringify(Array.from(window.__serviceMasterRegistry.values())));
            } catch (e) {}
            if (freshIds.length > 0) {
              const first = window.__serviceMasterRegistry.get(freshIds[0]);
              window.__showServiceToast(
                freshIds.length === 1
                  ? `New service received: "${window.__getServiceTitle(first)}" → New Request`
                  : `${freshIds.length} new services received → New Request`,
                "success",
                5000
              );
            }
            window.__triggerServicePipelineReRender();
          };
          const bindSnapshot = (queryTarget, label) => {
            try {
              if (typeof onSnapshot === "function") {
                const unsub = onSnapshot(queryTarget, (snap) => handleSnapshot(snap, label), (err) => console.warn(`Notice in realtime ${label} listener:`, err));
                window.__serviceRealtimeUnsubs.push(unsub);
              } else if (queryTarget && typeof queryTarget.onSnapshot === "function") {
                const unsub = queryTarget.onSnapshot((snap) => handleSnapshot(snap, label), (err) => console.warn(`Notice in realtime ${label} compat listener:`, err));
                window.__serviceRealtimeUnsubs.push(unsub);
              }
            } catch (err) {
              console.warn(`Could not bind live snapshot for ${label}:`, err);
            }
          };
          try {
            if (typeof collection === "function") {
              bindSnapshot(collection(db, "admin_pending_approvals", "services", "pending"), "admin_pending_approvals");
            } else if (typeof db.collection === "function") {
              bindSnapshot(db.collection("admin_pending_approvals").doc("services").collection("pending"), "admin_pending_approvals");
            }
          } catch (e) {}
          try {
            if (typeof collectionGroup === "function") {
              bindSnapshot(collectionGroup(db, "Notification"), "collectionGroup_Notification");
            } else if (typeof db.collectionGroup === "function") {
              bindSnapshot(db.collectionGroup("Notification"), "collectionGroup_Notification");
            }
          } catch (e) {}
        };

        /* ── FETCH & MERGE ALL SERVICES FROM ALL FIREBASE PATHS ── */
        window.__refreshAllServicesFromFirestore = async () => {
          window.__isServicePipelineSyncing = true;
          window.__showServiceToast("Syncing services from Firestore...", "info", 2000);
          window.__triggerServicePipelineReRender();
          try {
            if (typeof db === "undefined") {
              window.__isServicePipelineSyncing = false;
              window.__triggerServicePipelineReRender();
              return;
            }
            const isLiveRefresh = Boolean(window.__svcInitialLoadDone);
            try {
              if (typeof collection === "function" && typeof getDocs === "function") {
                const sSnap = await getDocs(collection(db, "admin_pending_approvals", "services", "pending"));
                sSnap.forEach((d) => window.__processSingleIncomingServiceDoc(d, "admin_pending_approvals", isLiveRefresh));
              } else if (typeof db.collection === "function") {
                const sSnap = await db.collection("admin_pending_approvals").doc("services").collection("pending").get();
                sSnap.forEach((d) => window.__processSingleIncomingServiceDoc(d, "admin_pending_approvals", isLiveRefresh));
              }
            } catch (e) {}
            try {
              if (typeof collectionGroup === "function" && typeof getDocs === "function") {
                const notifSnap = await getDocs(collectionGroup(db, "Notification"));
                notifSnap.forEach((d) => window.__processSingleIncomingServiceDoc(d, "collectionGroup_Notification", isLiveRefresh));
              } else if (typeof db.collectionGroup === "function") {
                const notifSnap = await db.collectionGroup("Notification").get();
                notifSnap.forEach((d) => window.__processSingleIncomingServiceDoc(d, "collectionGroup_Notification", isLiveRefresh));
              }
            } catch (e) {}
            window.__svcInitialLoadDone = true;
            const completeArray = Array.from(window.__serviceMasterRegistry.values());
            if (typeof setServicePipelineCards === "function") {
              setServicePipelineCards(completeArray);
            }
            try {
              localStorage.setItem(window.__LS_SVC_BOARD_KEY, JSON.stringify(completeArray));
            } catch (e) {}
            window.__showServiceToast(`Synced ${completeArray.length} service records successfully!`, "success");
          } catch (err) {
            console.error("Critical error reading service collections:", err);
            window.__showServiceToast("Error refreshing services from Firestore.", "error");
          } finally {
            window.__isServicePipelineSyncing = false;
            window.__triggerServicePipelineReRender();
          }
        };

        if (!window.__servicePipelineAutoLoaded) {
          window.__servicePipelineAutoLoaded = true;
          try {
            const rawCached = localStorage.getItem(window.__LS_SVC_BOARD_KEY);
            if (rawCached) {
              const parsed = JSON.parse(rawCached);
              if (Array.isArray(parsed) && parsed.length > 0) {
                parsed.forEach((s) => {
                  const sid = window.__getServiceCanonId(s);
                  if (sid) window.__serviceMasterRegistry.set(sid, s);
                });
                if (typeof setServicePipelineCards === "function") {
                  setServicePipelineCards(parsed);
                }
              }
            }
          } catch (e) {}
          setTimeout(() => {
            if (typeof window.__attachRealtimeServiceListeners === "function") {
              window.__attachRealtimeServiceListeners();
            }
            if (typeof window.__refreshAllServicesFromFirestore === "function") {
              window.__refreshAllServicesFromFirestore();
            }
          }, 60);
        }

        /* Section Modal Controller */
        window.__openServiceSectionModal = (tab, record) => {
          if (tab === "images") {
            window.__serviceActiveImageIndex = 0;
            window.__serviceImagesAuthModalState = {
              open: true,
              record,
              error: null,
              onSuccess: () => {
                window.__serviceActiveSectionModal = { open: true, tab: "images", record };
                window.__showServiceToast("Media Depository unlocked successfully!", "success");
                window.__triggerServicePipelineReRender();
              },
            };
            window.__triggerServicePipelineReRender();
            return;
          }
          window.__serviceActiveSectionModal = { open: true, tab, record };
          window.__triggerServicePipelineReRender();
        };

        window.__closeServiceSectionModal = () => {
          window.__serviceActiveSectionModal = null;
          window.__triggerServicePipelineReRender();
        };

        window.__openRecycleBinModal = (serviceRecord = null) => {
          window.__recycleBinModalState = {
            open: true,
            serviceRecord,
            selectedServiceId: serviceRecord ? window.__getServiceCanonId(serviceRecord) : "all",
          };
          window.__triggerServicePipelineReRender();
        };

        window.__openImageDeletionProcessModal = (serviceRecord, imgItem) => {
          window.__imageDeletionProcessModalState = {
            open: true,
            serviceRecord,
            imgItem,
            error: null,
          };
          window.__triggerServicePipelineReRender();
        };

        window.__promptServiceImageAccessPasscode = ({ imgItem, serviceRecord }) => {
          if (window.__unlockedImageUrls && window.__unlockedImageUrls.has(imgItem.url)) {
            window.__servicePreviewModalState = { open: true, img: imgItem, service: serviceRecord };
            window.__isServiceMediaPreviewActive = true;
            if (typeof setServicePreviewModal === "function") {
              setServicePreviewModal({ open: true, img: imgItem, service: serviceRecord });
            }
            window.__triggerServicePipelineReRender();
            return;
          }
          window.__serviceImageItemAuthModalState = {
            open: true,
            imgItem,
            serviceRecord,
            error: null,
            onConfirm: (enteredPasscode) => {
              if (String(enteredPasscode || "").trim() === window.__SERVICE_PIPELINE_PASSCODE) {
                if (!window.__unlockedImageUrls) window.__unlockedImageUrls = new Set();
                window.__unlockedImageUrls.add(imgItem.url);
                window.__serviceImageItemAuthModalState = null;
                window.__isServiceMediaPreviewActive = true;
                window.__servicePreviewModalState = { open: true, img: imgItem, service: serviceRecord };
                if (typeof setServicePreviewModal === "function") {
                  setServicePreviewModal({ open: true, img: imgItem, service: serviceRecord });
                }
                window.__showServiceToast("High-resolution preview unlocked!", "success");
                window.__triggerServicePipelineReRender();
              } else {
                window.__serviceImageItemAuthModalState.error = "Incorrect Security Passcode. Access denied.";
                window.__showServiceToast("Invalid passcode for image access.", "error");
                window.__triggerServicePipelineReRender();
              }
            },
          };
          window.__triggerServicePipelineReRender();
        };

        window.__openServiceCriticalTransitionModal = (params) => {
          window.__serviceCriticalModalState = {
            open: true,
            error: null,
            service: params.service,
            serviceId: window.__getServiceCanonId(params.service),
            fromStage: params.fromStage,
            toStage: params.toStage,
            isApprovedToNew: params.fromStage === "approved" && params.toStage === "new_request",
            onConfirm: params.onConfirm,
          };
          window.__triggerServicePipelineReRender();
        };

        window.__openDrawerDecisionModal = (service, actionType) => {
          window.__drawerDecisionModalState = {
            open: true,
            service,
            actionType,
            error: null,
          };
          window.__triggerServicePipelineReRender();
        };

        window.__openMainImageDecisionModal = (service, imgItem, actionType) => {
          if (!service || !imgItem) return;
          window.__mainImageDecisionModalState = {
            open: true,
            service,
            imgItem,
            actionType,
            error: null,
          };
          window.__triggerServicePipelineReRender();
        };
      }
      return null;
    })()}

    {/* ── ACTIVE TOAST NOTIFICATION CONTAINER ──────────────────────── */}
    <div
      style={{
        position: "fixed",
        top: 20,
        right: 20,
        zIndex: 9999999,
        display: "flex",
        flexDirection: "column",
        gap: 10,
        pointerEvents: "none",
      }}
    >
      {(window.__svcToastsList || []).map((t) => {
        const isSuccess = t.type === "success";
        const isError = t.type === "error";
        const isWarning = t.type === "warning";
        const bg = isSuccess ? "#15803d" : isError ? "#b91c1c" : isWarning ? "#b45309" : "#1e293b";
        const icon = isSuccess ? "✓" : isError ? "✕" : isWarning ? "⚠️" : "ℹ️";
        return (
          <div
            key={t.id}
            className="svc-toast-animate"
            style={{
              pointerEvents: "auto",
              background: bg,
              color: "#ffffff",
              padding: "10px 18px",
              borderRadius: 10,
              boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
              display: "flex",
              alignItems: "center",
              gap: 10,
              fontSize: 13,
              fontWeight: 700,
              maxWidth: 380,
              border: "1px solid rgba(255,255,255,0.15)",
            }}
          >
            <span style={{ fontSize: 16 }}>{icon}</span>
            <span style={{ flex: 1, lineHeight: 1.35 }}>{window.__safeText(t.message)}</span>
            <button
              onClick={() => {
                window.__svcToastsList = window.__svcToastsList.filter((x) => x.id !== t.id);
                window.__triggerServicePipelineReRender();
              }}
              style={{
                background: "transparent",
                border: "none",
                color: "#ffffff",
                cursor: "pointer",
                fontSize: 14,
                opacity: 0.8,
                padding: "0 0 0 6px",
              }}
            >
              ✕
            </button>
          </div>
        );
      })}
    </div>

    {/* ── UNIFIED SERVICE PIPELINE STAGE DEFINITIONS ───────────────── */}
    {(() => {
      window.__ALL_SERVICE_STAGES = [
        { id: "new_request", label: "New Request", shortLabel: "New", color: "#4f46e5", bg: "#e0e7ff" },
        { id: "pending_verification", label: "Pending Verification", shortLabel: "Pending", color: "#d97706", bg: "#fef3c7" },
        { id: "approved", label: "Approved", shortLabel: "Approved", color: "#16a34a", bg: "#dcfce7" },
        { id: "rejected", label: "Rejected", shortLabel: "Rejected", color: "#dc2626", bg: "#fee2e2" },
      ];
      return null;
    })()}

    {/* ── TOP PIPELINE TOOLBAR WITH FILTERS, RECYCLE BIN & REFRESH ─── */}
    <header
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "14px 22px",
        background: "#0f172a",
        borderBottom: "1px solid #334155",
        flexWrap: "wrap",
        gap: 12,
        color: "#ffffff",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{ fontSize: 24, background: "#1e293b", padding: "6px 10px", borderRadius: 10, border: "1px solid #334155" }}>
          📦
        </div>
        <div>
          <h2 style={{ margin: 0, fontSize: "18px", fontWeight: 800, color: "#ffffff", letterSpacing: "-0.02em" }}>
            Service Verification Pipeline
          </h2>
          <span style={{ fontSize: "12px", color: "#94a3b8" }}>
            Real-Time Push Notifications · Instant Stage Updates · 7-Day Recycle Bin · Pricing Concessions
          </span>
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        {/* Quick Filter Buttons across all 3 Boards */}
        <div style={{ display: "flex", background: "#1e293b", padding: "3px", borderRadius: 8, border: "1px solid #475569" }}>
          {[
            { id: "all", label: "New Services" },
            { id: "image_changes_only", label: "🖼️ Image Changes Only" },
            { id: "deletion_requests_only", label: "🗑️ Deletion Requests" },
          ].map((flt) => {
            const isSelected = (window.__serviceQuickFilter || "all") === flt.id;
            let delCountBadge = null;
            if (flt.id === "deletion_requests_only") {
              let count = 0;
              window.__serviceMasterRegistry.forEach((svc) => {
                const imgs = window.__extractServiceImages(svc);
                if (imgs.some((im) => im.deletionRequested) || svc.has_deletion_requests) count++;
              });
              if (count > 0) {
                delCountBadge = (
                  <span style={{ background: "#ef4444", color: "#fff", fontSize: 9.5, padding: "1px 5px", borderRadius: 10, marginLeft: 4 }}>
                    {count}
                  </span>
                );
              }
            }
            return (
              <button
                key={flt.id}
                type="button"
                onClick={() => {
                  window.__serviceQuickFilter = flt.id;
                  window.__showServiceToast(`Filter applied: ${flt.label}`, "info", 2000);
                  window.__triggerServicePipelineReRender();
                }}
                style={{
                  padding: "4px 10px",
                  borderRadius: 6,
                  border: "none",
                  background: isSelected ? (flt.id === "deletion_requests_only" ? "#dc2626" : "#3b82f6") : "transparent",
                  color: isSelected ? "#ffffff" : "#cbd5e1",
                  fontSize: 11,
                  fontWeight: 700,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  transition: "all 0.15s ease",
                }}
              >
                <span>{flt.label}</span>
                {delCountBadge}
              </button>
            );
          })}
        </div>

        {/* 7-Day Recycle Bin Launcher Button */}
        <button
          type="button"
          onClick={() => window.__openRecycleBinModal(null)}
          style={{
            padding: "5px 12px",
            borderRadius: 8,
            border: "1px solid #e11d48",
            background: "#881337",
            color: "#ffffff",
            fontSize: 11.5,
            fontWeight: 800,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
          title="Open 7-Day Media Recycle Bin & Restoration Console"
        >
          <span>♻️</span>
          <span>7-Day Recycle Bin</span>
          {(() => {
            const count = window.__getRecycleBinItems().length;
            if (count > 0) {
              return (
                <span style={{ background: "#f43f5e", color: "#fff", fontSize: 10, padding: "1px 5px", borderRadius: 8 }}>
                  {count}
                </span>
              );
            }
            return null;
          })()}
        </button>

        {/* Search Input */}
        <div style={{ display: "flex", alignItems: "center", background: "#1e293b", border: "1px solid #475569", borderRadius: 8, padding: "4px 10px", gap: 6 }}>
          <span style={{ fontSize: 13, color: "#94a3b8" }}>🔍</span>
          <input
            type="text"
            className="svc-filter-input"
            placeholder="Search Service / Provider / Discount / Price..."
            value={window.__serviceSearchQuery || ""}
            onChange={(e) => {
              window.__serviceSearchQuery = e.target.value;
              window.__triggerServicePipelineReRender();
            }}
            style={{
              background: "transparent",
              border: "none",
              color: "#ffffff",
              fontSize: 12,
              outline: "none",
              width: 200,
            }}
          />
          {window.__serviceSearchQuery && (
            <button
              onClick={() => {
                window.__serviceSearchQuery = "";
                window.__showServiceToast("Search filter cleared.", "info", 1500);
                window.__triggerServicePipelineReRender();
              }}
              style={{ background: "none", border: "none", color: "#94a3b8", cursor: "pointer", fontSize: 11, padding: 0 }}
            >
              ✕
            </button>
          )}
        </div>

        {/* Sort Filter: Real-time update for Newest First, Oldest First, Recently Updated */}
        <div style={{ display: "flex", alignItems: "center", gap: 6, background: "#1e293b", padding: "4px 8px", borderRadius: 8, border: "1px solid #475569" }}>
          <span style={{ fontSize: 11, fontWeight: 700, color: "#cbd5e1" }}>Sort:</span>
          <select
            value={window.__serviceSortOrder || "newest"}
            onChange={(e) => {
              window.__serviceSortOrder = e.target.value;
              window.__showServiceToast(`Sorted by: ${e.target.value.replace("_", " ")}`, "info", 1500);
              window.__triggerServicePipelineReRender();
            }}
            style={{
              background: "#0f172a",
              color: "#f8fafc",
              border: "1px solid #334155",
              borderRadius: 6,
              padding: "4px 8px",
              fontSize: 11,
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            <option value="newest">Newest First</option>
            <option value="oldest">Oldest First</option>
            <option value="recently_updated">Recently Updated</option>
          </select>
        </div>

        {/* Scale Switcher */}
        <div style={{ display: "flex", alignItems: "center", gap: 4, background: "#1e293b", padding: "3px 6px", borderRadius: 8, border: "1px solid #475569" }}>
          {[25, 50, 75, 100].map((scale) => (
            <button
              key={scale}
              onClick={() => {
                window.__serviceZoomScale = scale;
                window.__triggerServicePipelineReRender();
              }}
              style={{
                padding: "3px 8px",
                borderRadius: 6,
                border: "none",
                background: (window.__serviceZoomScale || 100) === scale ? "#2563eb" : "transparent",
                color: "#ffffff",
                fontWeight: 700,
                fontSize: 11,
                cursor: "pointer",
              }}
            >
              {scale}%
            </button>
          ))}
        </div>

        {/* Sync Button */}
        <button
          type="button"
          disabled={Boolean(window.__isServicePipelineSyncing)}
          onClick={async () => {
            if (typeof window.__refreshAllServicesFromFirestore === "function") {
              await window.__refreshAllServicesFromFirestore();
            }
          }}
          style={{
            padding: "6px 16px",
            borderRadius: 8,
            border: "1px solid #3b82f6",
            background: window.__isServicePipelineSyncing ? "#1d4ed8" : "#2563eb",
            color: "#ffffff",
            fontWeight: 800,
            fontSize: 12,
            cursor: window.__isServicePipelineSyncing ? "wait" : "pointer",
            display: "flex",
            alignItems: "center",
            gap: 7,
            boxShadow: "0 2px 8px rgba(37,99,235,0.3)",
            transition: "all 0.2s ease",
          }}
          title="Fetch latest services from Firebase immediately"
        >
          <span className={window.__isServicePipelineSyncing ? "svc-spin" : ""} style={{ fontSize: 14 }}>↻</span>
          <span>{window.__isServicePipelineSyncing ? "Syncing..." : "Refresh Services"}</span>
        </button>
      </div>
    </header>

    {/* ── KANBAN WORKSPACE CANVAS ──────────────────────────────────── */}
    <div style={{ display: "flex", flex: 1, overflow: "hidden", position: "relative", background: "#f8fafc" }}>
      <main style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", position: "relative" }}>
        {(() => {
          const currentScale = window.__serviceZoomScale || 100;
          const is25Scale = currentScale === 25;
          const colWidth = is25Scale ? 210 : currentScale === 50 ? 260 : currentScale === 75 ? 310 : 360;
          const svcMap = new Map();
          if (typeof servicePipelineCards !== "undefined" && Array.isArray(servicePipelineCards)) {
            servicePipelineCards.forEach((s) => {
              const sid = window.__getServiceCanonId(s);
              if (sid) svcMap.set(sid, { ...s });
            });
          }
          if (window.__serviceMasterRegistry) {
            window.__serviceMasterRegistry.forEach((val, sid) => {
              if (sid) {
                const ex = svcMap.get(sid) || {};
                svcMap.set(sid, { ...ex, ...val });
              }
            });
          }
          let serviceList = Array.from(svcMap.values());
          if (window.__serviceSearchQuery && window.__serviceSearchQuery.trim()) {
            const q = window.__serviceSearchQuery.trim().toLowerCase();
            serviceList = serviceList.filter((s) => {
              const sid = window.__getServiceCanonId(s).toLowerCase();
              const pid = window.__getServiceProviderId(s).toLowerCase();
              const title = window.__getServiceTitle(s).toLowerCase();
              const pName = window.__getServiceProviderName(s).toLowerCase();
              const cat = window.__humanizeLabel(s.category || s.serviceCategory || "").toLowerCase();
              const subCat = window.__humanizeLabel(s.subCategory || s.subcategory || "").toLowerCase();
              const price = window.__safeText(s.pricing || s.price || s.rate || "").toLowerCase();
              const disc = window.__safeText(s.discount || "").toLowerCase();
              const discAmt = window.__safeText(s.discount_amount || s.discountAmount || "").toLowerCase();
              const discPrice = window.__safeText(s.discounted_price || s.discountedPrice || "").toLowerCase();
              return sid.includes(q) || pid.includes(q) || title.includes(q) || pName.includes(q) || cat.includes(q) || subCat.includes(q) || price.includes(q) || disc.includes(q) || discAmt.includes(q) || discPrice.includes(q);
            });
          }
          const qf = window.__serviceQuickFilter || "all";
          if (qf === "image_changes_only") {
            serviceList = serviceList.filter((s) => window.__isImageChangesOnlyService(s));
          } else if (qf === "deletion_requests_only") {
            serviceList = serviceList.filter((s) => {
              const imgs = window.__extractServiceImages(s);
              return imgs.some((im) => im.deletionRequested) || Boolean(s.has_deletion_requests);
            });
          }

          /* ── ACCURATE SORTING ACROSS ALL 3 BOARDS (NEWEST FIRST, OLDEST FIRST, RECENTLY UPDATED) ── */
          const sortMode = window.__serviceSortOrder || "newest";
          serviceList.sort((a, b) => {
            if (sortMode === "recently_updated") {
              const aUp = Math.max(
                window.__toEpochMs(a.updatedAt),
                window.__toEpochMs(a.updated_at),
                window.__toEpochMs(a.stage_updated_at),
                window.__toEpochMs(a._stageTs),
                Number(a._localTransitionTime || 0)
              );
              const bUp = Math.max(
                window.__toEpochMs(b.updatedAt),
                window.__toEpochMs(b.updated_at),
                window.__toEpochMs(b.stage_updated_at),
                window.__toEpochMs(b._stageTs),
                Number(b._localTransitionTime || 0)
              );
              return bUp - aUp;
            }
            if (sortMode === "oldest") {
              const aTs = window.__getServiceCreatedTimestamp(a) || window.__getServiceTimestamp(a);
              const bTs = window.__getServiceCreatedTimestamp(b) || window.__getServiceTimestamp(b);
              return aTs - bTs;
            }
            /* "newest" First */
            const aTs = window.__getServiceCreatedTimestamp(a) || window.__getServiceTimestamp(a);
            const bTs = window.__getServiceCreatedTimestamp(b) || window.__getServiceTimestamp(b);
            return bTs - aTs;
          });

          const stages = window.__ALL_SERVICE_STAGES || [];
          const isDrawerOpen = Boolean(window.__serviceDrawerOpen || (typeof serviceDrawerVisible !== "undefined" && serviceDrawerVisible));
          return (
            <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>
              {/* Columns Canvas */}
              <div style={{ flex: isDrawerOpen ? "0 0 calc(100% - 520px)" : 1, overflow: "hidden", transition: "all 0.2s ease" }}>
                <div style={{ overflowX: "auto", overflowY: "hidden", padding: 16, height: "100%", boxSizing: "border-box" }}>
                  <div style={{ display: "flex", gap: 14, minWidth: "fit-content", height: "100%" }}>
                    {stages.map((stage) => {
                      const stageCards = serviceList.filter((s) => {
                        const act = window.__getEffectiveServiceStage(s);
                        return act === stage.id;
                      });
                      if (stage.id === "new_request" && sortMode === "newest") {
                        stageCards.sort(
                          (a, b) => window.__getServiceCreatedTimestamp(b) - window.__getServiceCreatedTimestamp(a)
                        );
                      }
                      return (
                        <div
                          key={stage.id}
                          onDragOver={(e) => {
                            e.preventDefault();
                            e.dataTransfer.dropEffect = "move";
                          }}
                          onDrop={async (e) => {
                            e.preventDefault();
                            const draggedId = e.dataTransfer?.getData("text/plain") || window.__getServiceCanonId(window.__draggingServiceCard);
                            window.__draggingServiceCard = null;
                            if (!draggedId) return;
                            const sRecord = window.__serviceMasterRegistry.get(draggedId) || svcMap.get(draggedId);
                            if (!sRecord) return;
                            const curStage = window.__getEffectiveServiceStage(sRecord);
                            const targetStage = stage.id;
                            if (curStage === targetStage) return;

                            /* PERSISTENCE: If moved from Pending Verification to New Request in Image changes board */
                            if (curStage === "pending_verification" && targetStage === "new_request") {
                              sRecord.had_image_changes = true;
                              sRecord.image_changes_only = true;
                              sRecord.has_image_changes = true;
                              sRecord.images_edited = true;
                              sRecord._from_image_changes = true;
                            }

                            /* ── INSTANT DRAG TO APPROVED GUARANTEE ACROSS ALL THREE BOARDS ── */
                            if (targetStage === "approved") {
                              await window.__executeServiceStageTransition(
                                draggedId,
                                "approved",
                                `Service card advanced directly to Approved stage from ${curStage}.`
                              );
                              return;
                            }

                            /* Approved to New Request Critical Demotion Gate */
                            const isApprovedToNewRequest = curStage === "approved" && targetStage === "new_request";
                            if (isApprovedToNewRequest) {
                              window.__openServiceCriticalTransitionModal({
                                service: sRecord,
                                fromStage: curStage,
                                toStage: targetStage,
                                onConfirm: async (reason) => {
                                  const encryptionMeta = await window.__generateEncryptedAuditToken(draggedId, curStage, targetStage, reason);
                                  await window.__executeServiceStageTransition(draggedId, targetStage, reason, encryptionMeta);
                                },
                              });
                            } else {
                              await window.__executeServiceStageTransition(draggedId, targetStage, `Service card moved from ${curStage} to ${targetStage}.`);
                            }
                          }}
                          style={{
                            width: colWidth,
                            flexShrink: 0,
                            background: "#ffffff",
                            border: "1px solid #e2e8f0",
                            borderRadius: 12,
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.03)",
                          }}
                        >
                          {/* Column Header */}
                          <div
                            style={{
                              padding: is25Scale ? "8px 10px" : "12px 14px",
                              borderBottom: "1px solid #e2e8f0",
                              background: "#f8fafc",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <strong style={{ fontSize: is25Scale ? 11 : 13, color: "#0f172a" }}>
                              {stage.label}
                            </strong>
                            <span style={{ background: stage.bg, color: stage.color, padding: is25Scale ? "1px 6px" : "2px 8px", borderRadius: 12, fontSize: is25Scale ? 10 : 11, fontWeight: 700 }}>
                              {stageCards.length}
                            </span>
                          </div>
                          {/* Column Cards */}
                          <div style={{ padding: is25Scale ? 6 : 10, display: "flex", flexDirection: "column", gap: is25Scale ? 6 : 10, overflowY: "auto", flex: 1 }}>
                            {stageCards.length === 0 && (
                              <div style={{ textAlign: "center", color: "#94a3b8", fontSize: is25Scale ? 10 : 12, padding: 24 }}>
                                No services in stage
                              </div>
                            )}
                            {stageCards.map((service) => {
                              const sId = window.__getServiceCanonId(service);
                              const pId = window.__getServiceProviderId(service);
                              const title = window.__getServiceTitle(service);
                              const pName = window.__getServiceProviderName(service);
                              const category = window.__humanizeLabel(service.category || service.serviceCategory) || "General";
                              const cardImages = window.__extractServiceImages(service);
                              const mediaCount = cardImages.length;
                              const pendingImgCount = cardImages.filter((im) => im.status === "pending").length;
                              const newImagesCount = cardImages.filter((im) => im.isNew).length;
                              const deletionRequestsCount = cardImages.filter((im) => im.deletionRequested).length;
                              const mainCardImg = cardImages[0] || null;
                              const curStageId = window.__getEffectiveServiceStage(service);
                              const meta = window.__getServiceStageMeta(curStageId);
                              const nextStageId = window.__getNextServiceStage(curStageId);
                              const nextStageMeta = nextStageId ? window.__getServiceStageMeta(nextStageId) : null;
                              const isRecentlyCreated = window.__isServiceRecentlyCreated(service);
                              const isImageChangesOnly = window.__isImageChangesOnlyService(service);
                              const isServicePendingApproval = curStageId === "new_request" || curStageId === "pending_verification";
                              const awaitingApproval = isServicePendingApproval || pendingImgCount > 0;
                              const reviewedAtDisplay = window.__formatReviewedAtDisplay(service);
                              const isMainThumbUnlocked = Boolean(mainCardImg && window.__unlockedImageUrls && window.__unlockedImageUrls.has(mainCardImg.url));
                              const isMainImgApproved = mainCardImg && (mainCardImg.status === "approved" || mainCardImg.approval_status === "approved");
                              const isMainImgRejected = mainCardImg && (mainCardImg.status === "rejected" || mainCardImg.approval_status === "rejected");
                              const isMainImgNew = Boolean(mainCardImg && mainCardImg.isNew);
                              const isMainImgDeletionRequested = Boolean(mainCardImg && mainCardImg.deletionRequested);

                              return (
                                <div
                                  key={`svc_card_${sId}`}
                                  draggable
                                  onDragStart={(e) => {
                                    window.__draggingServiceCard = service;
                                    e.dataTransfer.setData("text/plain", sId);
                                    e.dataTransfer.effectAllowed = "move";
                                  }}
                                  onDragEnd={() => { window.__draggingServiceCard = null; }}
                                  onClick={() => {
                                    window.__selectedInspectionService = service;
                                    window.__serviceDrawerOpen = true;
                                    if (typeof setServiceInspectionRecord === "function") setServiceInspectionRecord(service);
                                    if (typeof setServiceDrawerVisible === "function") setServiceDrawerVisible(true);
                                    window.__triggerServicePipelineReRender();
                                  }}
                                  style={{
                                    background: "#ffffff",
                                    border: deletionRequestsCount > 0 ? "1.5px solid #ef4444" : isImageChangesOnly ? "1.5px solid #f59e0b" : isRecentlyCreated ? "1.5px solid #6366f1" : awaitingApproval ? "1.5px solid #fbbf24" : "1px solid #cbd5e1",
                                    borderRadius: is25Scale ? 8 : 10,
                                    padding: is25Scale ? "7px 8px" : 12,
                                    cursor: "grab",
                                    boxShadow: isRecentlyCreated ? "0 2px 10px rgba(99,102,241,0.12)" : "0 1px 3px rgba(0,0,0,0.05)",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: is25Scale ? 4 : 6,
                                    position: "relative",
                                  }}
                                >
                                  {/* Main Gallery Thumbnail with NEW Tag & Deletion Request Overlay */}
                                  {mainCardImg && (
                                    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                      <div
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          window.__promptServiceImageAccessPasscode({ imgItem: mainCardImg, serviceRecord: service });
                                        }}
                                        style={{
                                          position: "relative",
                                          width: "100%",
                                          height: is25Scale ? 46 : 84,
                                          borderRadius: 8,
                                          overflow: "hidden",
                                          background: "#0f172a",
                                          cursor: "pointer",
                                          flexShrink: 0,
                                        }}
                                        title={isMainThumbUnlocked ? "View main service image" : "Locked — click to unlock preview"}
                                      >
                                        <img
                                          src={mainCardImg.url}
                                          alt=""
                                          onContextMenu={(e) => e.preventDefault()}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            filter: isMainThumbUnlocked ? "none" : "blur(6px)",
                                          }}
                                        />
                                        {!isMainThumbUnlocked && (
                                          <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(15,23,42,0.35)", color: "#fff", fontSize: is25Scale ? 13 : 17 }}>
                                            🔒
                                          </div>
                                        )}
                                        {/* NEW TAG ON NEWLY UPLOADED PROVIDER SERVICE IMAGE */}
                                        {isMainImgNew && (
                                          <span
                                            className="svc-badge-pulse"
                                            style={{
                                              position: "absolute",
                                              top: 4,
                                              left: 4,
                                              background: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)",
                                              color: "#ffffff",
                                              fontSize: is25Scale ? 7.5 : 8.5,
                                              fontWeight: 900,
                                              padding: "1px 5px",
                                              borderRadius: 4,
                                              boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
                                            }}
                                          >
                                            ✨ NEW IMAGE
                                          </span>
                                        )}
                                        {mainCardImg.isMainImage && !isMainImgNew && (
                                          <span style={{ position: "absolute", top: 4, left: 4, background: "#7c3aed", color: "#fff", fontSize: 8.5, fontWeight: 800, padding: "1px 5px", borderRadius: 4 }}>
                                            MAIN
                                          </span>
                                        )}
                                        {/* Main Image Live Status Badge */}
                                        <span
                                          style={{
                                            position: "absolute",
                                            top: 4,
                                            right: 4,
                                            background: isMainImgApproved ? "#16a34a" : isMainImgRejected ? "#dc2626" : "#d97706",
                                            color: "#ffffff",
                                            fontSize: 8,
                                            fontWeight: 800,
                                            padding: "1px 5px",
                                            borderRadius: 4,
                                            boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                                          }}
                                        >
                                          {isMainImgApproved ? "✓ Approved" : isMainImgRejected ? "✕ Rejected" : "⏳ Pending"}
                                        </span>
                                        {/* PROVIDER IMAGE DELETION REQUEST OVERLAY ON CARD */}
                                        {isMainImgDeletionRequested && (
                                          <div
                                            style={{
                                              position: "absolute",
                                              bottom: 0,
                                              left: 0,
                                              right: 0,
                                              background: "rgba(185, 28, 28, 0.92)",
                                              color: "#ffffff",
                                              padding: "3px 6px",
                                              fontSize: is25Scale ? 7.5 : 9,
                                              fontWeight: 800,
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <span>🗑️ Deletion Requested</span>
                                            <span style={{ fontSize: 8, opacity: 0.9 }}>
                                              {mainCardImg.deletionRequestedAt ? new Date(mainCardImg.deletionRequestedAt).toLocaleDateString() : "Pending"}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                      {/* Main Image Action Buttons */}
                                      <div style={{ display: "flex", gap: 4, width: "100%" }}>
                                        {isMainImgDeletionRequested ? (
                                          <button
                                            type="button"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              window.__openImageDeletionProcessModal(service, mainCardImg);
                                            }}
                                            style={{
                                              flex: 1,
                                              padding: is25Scale ? "2px 4px" : "3px 6px",
                                              borderRadius: 4,
                                              border: "1px solid #ef4444",
                                              background: "#fee2e2",
                                              color: "#b91c1c",
                                              fontSize: is25Scale ? 8 : 9.5,
                                              fontWeight: 800,
                                              cursor: "pointer",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              gap: 3,
                                            }}
                                          >
                                            <span>🗑️</span>
                                            <span>Process Deletion Request</span>
                                          </button>
                                        ) : (
                                          <>
                                            <button
                                              type="button"
                                              disabled={isMainImgApproved}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                window.__openMainImageDecisionModal(service, mainCardImg, "approve");
                                              }}
                                              style={{
                                                flex: 1,
                                                padding: is25Scale ? "2px 4px" : "3px 6px",
                                                borderRadius: 4,
                                                border: "none",
                                                background: isMainImgApproved ? "#dcfce7" : "#16a34a",
                                                color: isMainImgApproved ? "#15803d" : "#ffffff",
                                                fontSize: is25Scale ? 8 : 9.5,
                                                fontWeight: 800,
                                                cursor: isMainImgApproved ? "default" : "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: 3,
                                              }}
                                              title="Approve Main Gallery Image"
                                            >
                                              <span>✓</span>
                                              <span>{isMainImgApproved ? "Approved" : "Approve Main"}</span>
                                            </button>
                                            <button
                                              type="button"
                                              disabled={isMainImgRejected}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                window.__openMainImageDecisionModal(service, mainCardImg, "reject");
                                              }}
                                              style={{
                                                flex: 1,
                                                padding: is25Scale ? "2px 4px" : "3px 6px",
                                                borderRadius: 4,
                                                border: "none",
                                                background: isMainImgRejected ? "#fee2e2" : "#dc2626",
                                                color: isMainImgRejected ? "#b91c1c" : "#ffffff",
                                                fontSize: is25Scale ? 8 : 9.5,
                                                fontWeight: 800,
                                                cursor: isMainImgRejected ? "default" : "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: 3,
                                              }}
                                              title="Reject Main Gallery Image"
                                            >
                                              <span>✕</span>
                                              <span>{isMainImgRejected ? "Rejected" : "Reject Main"}</span>
                                            </button>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  {/* TAG ROW */}
                                  <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                                    {isRecentlyCreated && (
                                      <span
                                        className="svc-badge-pulse"
                                        style={{
                                          fontSize: is25Scale ? 8 : 9.5,
                                          fontWeight: 900,
                                          background: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)",
                                          color: "#ffffff",
                                          padding: "2px 7px",
                                          borderRadius: 4,
                                          letterSpacing: "0.04em",
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: 3,
                                        }}
                                      >
                                        ✨ NEW
                                      </span>
                                    )}
                                    {newImagesCount > 0 && (
                                      <span
                                        style={{
                                          fontSize: is25Scale ? 8 : 9.5,
                                          fontWeight: 900,
                                          background: "#e0e7ff",
                                          color: "#3730a3",
                                          border: "1px solid #c7d2fe",
                                          padding: "2px 7px",
                                          borderRadius: 4,
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: 3,
                                        }}
                                        title={`${newImagesCount} image(s) newly uploaded by provider`}
                                      >
                                        ✨ {newImagesCount} New Image{newImagesCount === 1 ? "" : "s"}
                                      </span>
                                    )}
                                    {deletionRequestsCount > 0 && (
                                      <span
                                        style={{
                                          fontSize: is25Scale ? 8 : 9.5,
                                          fontWeight: 900,
                                          background: "#fee2e2",
                                          color: "#991b1b",
                                          border: "1px solid #fca5a5",
                                          padding: "2px 7px",
                                          borderRadius: 4,
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: 3,
                                          cursor: "pointer",
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          window.__openServiceSectionModal("images", service);
                                        }}
                                        title="Provider requested image deletion"
                                      >
                                        🗑️ {deletionRequestsCount} Deletion Req.
                                      </span>
                                    )}
                                    {awaitingApproval && (
                                      <span
                                        style={{
                                          fontSize: is25Scale ? 8 : 9.5,
                                          fontWeight: 800,
                                          background: "#fef3c7",
                                          color: "#b45309",
                                          border: "1px solid #fcd34d",
                                          padding: "2px 7px",
                                          borderRadius: 4,
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: 3,
                                        }}
                                      >
                                        {isServicePendingApproval ? "⏳ Service Awaiting Approval" : "⏳ Images Awaiting Approval"}
                                      </span>
                                    )}
                                    {pendingImgCount > 0 && (
                                      <span
                                        style={{
                                          fontSize: is25Scale ? 8 : 9.5,
                                          fontWeight: 800,
                                          background: "#ffedd5",
                                          color: "#c2410c",
                                          border: "1px solid #fdba74",
                                          padding: "2px 7px",
                                          borderRadius: 4,
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: 3,
                                        }}
                                      >
                                        🖼️ {pendingImgCount} Pending
                                      </span>
                                    )}
                                    {isImageChangesOnly && (
                                      <span
                                        style={{
                                          fontSize: is25Scale ? 8 : 9.5,
                                          fontWeight: 800,
                                          background: curStageId === "approved" ? "#dcfce7" : "#fef3c7",
                                          color: curStageId === "approved" ? "#15803d" : "#b45309",
                                          border: curStageId === "approved" ? "1px solid #bbf7d0" : "1px solid #fde68a",
                                          padding: "2px 7px",
                                          borderRadius: 4,
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: 3,
                                        }}
                                      >
                                        {curStageId === "approved" ? "🖼️ Image Changes Approved" : "🖼️ Image Changes Only"}
                                      </span>
                                    )}
                                  </div>
                                  {/* PROVIDER NAME ROW */}
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 6,
                                      padding: is25Scale ? "2px 5px" : "4px 8px",
                                      background: "#f0fdf4",
                                      border: "1px solid #bbf7d0",
                                      borderRadius: 6,
                                    }}
                                  >
                                    <span style={{ fontSize: is25Scale ? 9 : 11 }}>👤</span>
                                    <span style={{ fontWeight: 800, fontSize: is25Scale ? 10 : 12, color: "#166534", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                      {window.__safeText(pName)}
                                    </span>
                                  </div>
                                  {/* Card Meta Row */}
                                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 4 }}>
                                    <span style={{ fontSize: is25Scale ? 8.5 : 10, fontWeight: 700, background: "#ede9fe", color: "#6d28d9", padding: "1px 5px", borderRadius: 4 }}>
                                      ID: {sId.slice(-8)}
                                    </span>
                                    <span style={{ fontSize: is25Scale ? 8.5 : 9.5, fontWeight: 800, background: meta.bg, color: meta.color, padding: "1px 6px", borderRadius: 4 }}>
                                      ● {is25Scale ? meta.shortLabel : meta.label}
                                    </span>
                                  </div>
                                  {/* REVIEWED AT ROW */}
                                  <div
                                    style={{
                                      fontSize: is25Scale ? 8 : 10,
                                      fontWeight: 700,
                                      background: "#f1f5f9",
                                      border: "1px solid #e2e8f0",
                                      borderRadius: 5,
                                      padding: is25Scale ? "2px 4px" : "3px 6px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      color: "#475569",
                                    }}
                                  >
                                    <span style={{ display: "flex", alignItems: "center", gap: 3 }}>
                                      <span>🕒</span>
                                      <span>Reviewed At:</span>
                                    </span>
                                    <strong style={{ color: reviewedAtDisplay !== "Not Reviewed" ? "#166534" : "#94a3b8" }}>
                                      {reviewedAtDisplay}
                                    </strong>
                                  </div>
                                  {/* Provider ID Row */}
                                  <div
                                    style={{
                                      fontSize: is25Scale ? 8 : 10,
                                      fontWeight: 700,
                                      background: "#f8fafc",
                                      border: "1px solid #e2e8f0",
                                      borderRadius: 5,
                                      padding: is25Scale ? "2px 4px" : "3px 6px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      color: "#475569",
                                    }}
                                  >
                                    <span>Provider ID:</span>
                                    <code style={{ color: "#0f172a", fontWeight: 800 }}>
                                      {pId !== "N/A" ? (pId.length > 14 ? `${pId.slice(0, 12)}…` : pId) : "On File"}
                                    </code>
                                  </div>
                                  {/* Service Title */}
                                  <div>
                                    <div style={{ fontWeight: 800, fontSize: is25Scale ? 11 : 13.5, color: "#0f172a", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} title={title}>
                                      {title}
                                    </div>
                                  </div>
                                  {/* Details / Category / Pricing Badge */}
                                  <div style={{ fontSize: is25Scale ? 8.5 : 11, color: "#475569", background: "#f8fafc", padding: "4px 6px", borderRadius: 6, border: "1px solid #f1f5f9" }}>
                                    <span>Cat: <strong>{category}</strong></span>
                                    {service.pricing && <span> · {window.__safeText(service.pricing)}</span>}
                                  </div>
                                  {/* Bottom Media Counter & Direct Fast Actions */}
                                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 2 }}>
                                    <span style={{ fontSize: is25Scale ? 8.5 : 10, fontWeight: 700, background: "#eff6ff", color: "#1d4ed8", padding: "1px 6px", borderRadius: 4 }}>
                                      🖼️ {mediaCount} Image(s)
                                    </span>
                                    <div style={{ display: "flex", gap: 4 }}>
                                      {stage.id !== "approved" && (
                                        <button
                                          type="button"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            window.__openDrawerDecisionModal(service, "approve");
                                          }}
                                          style={{ border: "none", background: "#16a34a", color: "#fff", padding: "2px 6px", borderRadius: 4, fontSize: 10, fontWeight: 700, cursor: "pointer" }}
                                          title="Approve Service & All Images"
                                        >
                                          ✓
                                        </button>
                                      )}
                                      {stage.id !== "rejected" && (
                                        <button
                                          type="button"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            window.__openDrawerDecisionModal(service, "reject");
                                          }}
                                          style={{ border: "none", background: "#dc2626", color: "#fff", padding: "2px 6px", borderRadius: 4, fontSize: 10, fontWeight: 700, cursor: "pointer" }}
                                          title="Reject Service"
                                        >
                                          ✕
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                  {/* ADVANCE STAGE ACTION BUTTON */}
                                  {nextStageId && nextStageMeta && (
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        window.__executeServiceStageTransition(sId, nextStageId);
                                      }}
                                      style={{
                                        width: "100%",
                                        marginTop: 4,
                                        padding: is25Scale ? "3px 6px" : "5px 8px",
                                        borderRadius: 6,
                                        border: "1px solid #3b82f6",
                                        background: "#eff6ff",
                                        color: "#1d4ed8",
                                        fontSize: is25Scale ? 9 : 11,
                                        fontWeight: 800,
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: 5,
                                      }}
                                      title={`Advance to ${nextStageMeta.label}`}
                                    >
                                      <span>Advance Stage ➔</span>
                                      <span style={{ fontSize: is25Scale ? 8.5 : 10, opacity: 0.85 }}>({nextStageMeta.shortLabel})</span>
                                    </button>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
			 
              {/* ── PART 2 OF 2: CONTINUED FROM WORKSPACE BOARD ────────── */}

              {/* ── RIGHT DETAIL INSPECTION DRAWER ─────────────────────── */}
              {isDrawerOpen && (() => {
                const svcRaw = window.__selectedInspectionService || (typeof serviceInspectionRecord !== "undefined" && serviceInspectionRecord);
                if (!svcRaw) return null;
                const svc = window.__serviceMasterRegistry.get(window.__getServiceCanonId(svcRaw)) || svcRaw;
                const sId = window.__getServiceCanonId(svc);
                const pId = window.__getServiceProviderId(svc);
                const title = window.__getServiceTitle(svc);
                const pName = window.__getServiceProviderName(svc);
                const curStage = window.__getEffectiveServiceStage(svc);
                const meta = window.__getServiceStageMeta(curStage);
                const nextStageId = window.__getNextServiceStage(curStage);
                const nextStageMeta = nextStageId ? window.__getServiceStageMeta(nextStageId) : null;
                const images = window.__extractServiceImages(svc);
                const drawerPendingImgCount = images.filter((im) => im.status === "pending").length;
                const drawerNewImagesCount = images.filter((im) => im.isNew).length;
                const drawerDeletionReqCount = images.filter((im) => im.deletionRequested).length;
                const drawerServicePending = curStage === "new_request" || curStage === "pending_verification";
                const drawerAwaitingApproval = drawerServicePending || drawerPendingImgCount > 0;
                const isRecentlyCreated = window.__isServiceRecentlyCreated(svc);
                const isImageChangesOnly = window.__isImageChangesOnlyService(svc);
                const reviewedByDisplay = window.__getServiceReviewedByDisplay(svc);
                const showTech = Boolean(window.__serviceShowTechnicalDetails);
                const reviewedAtDisplay = window.__formatReviewedAtDisplay(svc);
                const rawDiscount = svc.discount;
                const rawDiscountAmount = svc.discount_amount !== undefined ? svc.discount_amount : svc.discountAmount;
                const rawDiscountedPrice = svc.discounted_price !== undefined ? svc.discounted_price : svc.discountedPrice;
                return (
                  <aside
                    style={{
                      width: 520,
                      background: "#ffffff",
                      borderLeft: "1px solid #cbd5e1",
                      display: "flex",
                      flexDirection: "column",
                      flexShrink: 0,
                      boxShadow: "-8px 0 25px rgba(0,0,0,0.06)",
                      zIndex: 10,
                    }}
                  >
                    {/* Header */}
                    <div style={{ padding: 18, borderBottom: "1px solid #e2e8f0", background: "#0f172a", color: "#ffffff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div>
                        <div style={{ display: "flex", gap: 6, alignItems: "center", marginBottom: 4, flexWrap: "wrap" }}>
                          {isRecentlyCreated && (
                            <span style={{ fontSize: 9.5, fontWeight: 900, background: "#6366f1", color: "#fff", padding: "1px 6px", borderRadius: 4 }}>
                              ✨ NEW
                            </span>
                          )}
                          {drawerNewImagesCount > 0 && (
                            <span style={{ fontSize: 9.5, fontWeight: 900, background: "#4338ca", color: "#fff", padding: "1px 6px", borderRadius: 4 }}>
                              ✨ {drawerNewImagesCount} NEW IMAGE(S)
                            </span>
                          )}
                          {drawerDeletionReqCount > 0 && (
                            <span style={{ fontSize: 9.5, fontWeight: 900, background: "#dc2626", color: "#fff", padding: "1px 6px", borderRadius: 4 }}>
                              🗑️ {drawerDeletionReqCount} DELETION REQ.
                            </span>
                          )}
                          {drawerAwaitingApproval && (
                            <span style={{ fontSize: 9.5, fontWeight: 800, background: "#f59e0b", color: "#fff", padding: "1px 6px", borderRadius: 4 }}>
                              {drawerServicePending ? "⏳ Service Awaiting Approval" : "⏳ Images Awaiting Approval"}
                            </span>
                          )}
                          {drawerPendingImgCount > 0 && (
                            <span style={{ fontSize: 9.5, fontWeight: 800, background: "#ea580c", color: "#fff", padding: "1px 6px", borderRadius: 4 }}>
                              🖼️ {drawerPendingImgCount} Image{drawerPendingImgCount === 1 ? "" : "s"} Pending
                            </span>
                          )}
                          <div style={{ fontSize: 13, color: "#4ade80", fontWeight: 800 }}>
                            👤 Provider: {window.__safeText(pName)}
                          </div>
                        </div>
                        <div style={{ fontWeight: 800, fontSize: 15 }}>{title}</div>
                        <div style={{ fontSize: 11, color: "#38bdf8", fontWeight: 700 }}>Service ID: {sId}</div>
                      </div>
                      <button
                        onClick={() => {
                          window.__serviceDrawerOpen = false;
                          if (typeof setServiceDrawerVisible === "function") setServiceDrawerVisible(false);
                          window.__triggerServicePipelineReRender();
                        }}
                        style={{ border: "1px solid #475569", background: "#1e293b", color: "#fff", padding: "6px 12px", borderRadius: 6, cursor: "pointer", fontWeight: 700 }}
                      >
                        ✕ Close
                      </button>
                    </div>

                    {/* Stage Transition Action Bar */}
                    <div style={{ padding: "12px 18px", borderBottom: "1px solid #e2e8f0", display: "flex", gap: 8, flexWrap: "wrap", background: "#f8fafc" }}>
                      {nextStageId && nextStageMeta && (
                        <button
                          onClick={() => {
                            window.__executeServiceStageTransition(sId, nextStageId);
                          }}
                          style={{
                            flex: "1 0 100%",
                            padding: "9px 14px",
                            borderRadius: 8,
                            background: "#2563eb",
                            color: "#ffffff",
                            border: "none",
                            fontWeight: 800,
                            fontSize: 12,
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 6,
                          }}
                        >
                          <span>Advance Stage ➔</span>
                          <span>Move to {nextStageMeta.label}</span>
                        </button>
                      )}
                      {curStage !== "approved" && (
                        <button
                          onClick={() => window.__openDrawerDecisionModal(svc, "approve")}
                          style={{ flex: 1, padding: "8px 12px", borderRadius: 8, background: "#16a34a", color: "#fff", border: "none", fontWeight: 700, fontSize: 11, cursor: "pointer" }}
                        >
                          ✓ Approve All
                        </button>
                      )}
                      {curStage !== "rejected" && (
                        <button
                          onClick={() => window.__openDrawerDecisionModal(svc, "reject")}
                          style={{ flex: 1, padding: "8px 12px", borderRadius: 8, background: "#dc2626", color: "#fff", border: "none", fontWeight: 700, fontSize: 11, cursor: "pointer" }}
                        >
                          ✕ Reject Service
                        </button>
                      )}
                      {curStage !== "pending_verification" && (
                        <button
                          onClick={() => window.__executeServiceStageTransition(sId, "pending_verification")}
                          style={{ flex: 1, padding: "8px 12px", borderRadius: 8, background: "#d97706", color: "#fff", border: "none", fontWeight: 700, fontSize: 11, cursor: "pointer" }}
                        >
                          ⏳ Mark Pending
                        </button>
                      )}
                    </div>

                    {/* Section Switcher Tabs */}
                    <div style={{ padding: "10px 14px", background: "#0b1329", borderBottom: "1px solid #1e293b", display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 6 }}>
                      {[
                        { key: "overview", label: "Overview", icon: "📋" },
                        { key: "images", label: "Images Tab", icon: "🖼️", count: images.length },
                        { key: "activity", label: "Img Logs", icon: "📊" },
                        { key: "audit", label: "Stage Audit", icon: "🕒" },
                      ].map((btn) => (
                        <button
                          key={btn.key}
                          onClick={() => window.__openServiceSectionModal(btn.key, svc)}
                          style={{
                            padding: "8px 6px",
                            borderRadius: 8,
                            border: "1px solid #334155",
                            background: btn.key === "images" ? "#1e40af" : "#0f172a",
                            color: "#ffffff",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 4,
                          }}
                        >
                          <span style={{ fontSize: 10, fontWeight: 700 }}>{btn.icon} {btn.label}</span>
                          {btn.count !== undefined && (
                            <span style={{ fontSize: 9, background: "#38bdf8", color: "#0f172a", padding: "1px 4px", borderRadius: 6, fontWeight: 800 }}>
                              {btn.count}
                            </span>
                          )}
                        </button>
                      ))}
                    </div>

                    {/* Attributes Summary Card with Discount Fields */}
                    <div style={{ padding: 18, overflowY: "auto", flex: 1 }}>
                      <div style={{ background: "#f8fafc", padding: 14, borderRadius: 10, border: "1px solid #e2e8f0" }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: "#0f172a", marginBottom: 8 }}>Service Attributes Snapshot</div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>Provider: <strong style={{ color: "#166534" }}>{window.__safeText(pName)}</strong></div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>Category: <strong>{window.__humanizeLabel(svc.category || svc.serviceCategory) || "General"}</strong></div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>Sub-Category: <strong>{window.__humanizeLabel(svc.subCategory || svc.subcategory) || "—"}</strong></div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>Regular Price / Pricing: <strong>{window.__safeText(svc.pricing || svc.price, "—")}</strong></div>
                        {/* RENDER DISCOUNT FIELDS */}
                        <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 8, padding: "8px 10px", margin: "8px 0" }}>
                          <div style={{ fontSize: 11, fontWeight: 800, color: "#166534", marginBottom: 4 }}>💰 Pricing & Discount Concessions:</div>
                          <div style={{ fontSize: 12, color: "#14532d", marginBottom: 2 }}>
                            Discount Rate: <strong>{rawDiscount !== null && rawDiscount !== undefined ? `${window.__safeText(rawDiscount)}` : "None"}</strong>
                          </div>
                          <div style={{ fontSize: 12, color: "#14532d", marginBottom: 2 }}>
                            Discount Amount: <strong>{rawDiscountAmount !== null && rawDiscountAmount !== undefined ? window.__safeText(rawDiscountAmount) : "—"}</strong>
                          </div>
                          <div style={{ fontSize: 12, color: "#14532d" }}>
                            Discounted Price: <strong style={{ color: "#15803d" }}>{rawDiscountedPrice !== null && rawDiscountedPrice !== undefined ? window.__safeText(rawDiscountedPrice) : "—"}</strong>
                          </div>
                        </div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>Duration: <strong style={{ color: "#2563eb" }}>{window.__safeText(svc.duration) || (svc.duration_seconds !== undefined ? `${window.__safeText(svc.duration_seconds)}s` : "N/A")}</strong></div>
                        {window.__isLocationApprovalRuleActive(svc) && (
                          <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>Location: <strong>{window.__getSafeLocationDisplay(svc)}</strong></div>
                        )}
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>Status: <strong style={{ color: meta.color }}>{meta.label}</strong></div>
                        {drawerDeletionReqCount > 0 && (
                          <div style={{ fontSize: 12, color: "#991b1b", background: "#fee2e2", padding: "6px 10px", borderRadius: 6, marginBottom: 6, fontWeight: 700, border: "1px solid #fecaca" }}>
                            ⚠️ Alert: Provider requested deletion of {drawerDeletionReqCount} image(s). Open Images tab to process.
                          </div>
                        )}
                        {isImageChangesOnly && (
                          <div style={{ fontSize: 12, color: curStage === "approved" ? "#15803d" : "#b45309", background: curStage === "approved" ? "#dcfce7" : "#fef3c7", padding: "4px 8px", borderRadius: 6, marginBottom: 4, fontWeight: 700 }}>
                            {curStage === "approved" ? "✓ Service media modifications verified & approved." : "⚠️ Alert: Only media modifications require audit review."}
                          </div>
                        )}
                        {svc.approval_reason && (
                          <div style={{ fontSize: 12, color: "#16a34a", marginBottom: 4 }}>Approval Reason: <strong>{window.__safeText(svc.approval_reason)}</strong></div>
                        )}
                        {svc.rejection_reason && (
                          <div style={{ fontSize: 12, color: "#dc2626", marginBottom: 4 }}>Rejection Reason: <strong>{window.__safeText(svc.rejection_reason)}</strong></div>
                        )}
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          Reviewed By: <strong>{reviewedByDisplay}</strong>
                        </div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          Reviewed At: <strong>{reviewedAtDisplay}</strong>
                        </div>
                        {/* Open Recycle Bin for this Service */}
                        <div style={{ marginTop: 12, paddingTop: 10, borderTop: "1px dashed #cbd5e1" }}>
                          <button
                            type="button"
                            onClick={() => window.__openRecycleBinModal(svc)}
                            style={{
                              width: "100%",
                              padding: "7px 10px",
                              borderRadius: 6,
                              border: "1px solid #f43f5e",
                              background: "#fff1f2",
                              color: "#be123c",
                              fontWeight: 800,
                              fontSize: 11.5,
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 6,
                            }}
                          >
                            <span>♻️</span>
                            <span>View 7-Day Recycle Bin for this Service</span>
                          </button>
                        </div>
                        <button
                          type="button"
                          onClick={() => window.__toggleServiceTechnicalDetails()}
                          style={{ marginTop: 10, background: "transparent", border: "1px dashed #cbd5e1", color: "#64748b", fontSize: 10.5, fontWeight: 700, padding: "5px 9px", borderRadius: 6, cursor: "pointer", width: "100%" }}
                        >
                          {showTech ? "▾ Hide Technical Details" : "▸ Show Technical Details"}
                        </button>
                        {showTech && (
                          <div style={{ marginTop: 8, paddingTop: 8, borderTop: "1px dashed #cbd5e1", display: "flex", flexDirection: "column", gap: 4 }}>
                            <div style={{ fontSize: 10.5, color: "#94a3b8", fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.03em" }}>Technical / Debug Info (Internal Use Only)</div>
                            <div style={{ fontSize: 11, color: "#64748b" }}>Provider ID: <code>{pId}</code></div>
                            <div style={{ fontSize: 11, color: "#64748b" }}>Origin Path: <code>{window.__safeText(svc.origin, "Firestore Synced")}</code></div>
                            <div style={{ fontSize: 11, color: "#64748b" }}>Description Status (raw): <code>{window.__safeText(svc.description_status, "—")}</code></div>
                            <div style={{ fontSize: 11, color: "#64748b" }}>Media Status (raw): <code>{window.__safeText(svc.media_status, "—")}</code></div>
                            <div style={{ fontSize: 11, color: "#64748b" }}>Is Active / Is Approved: <code>{String(Boolean(svc.is_active))} / {String(Boolean(svc.is_approved))}</code></div>
                            <div style={{ fontSize: 11, color: "#64748b" }}>updatedAt: <code>{window.__safeText(svc.updatedAt, "—")}</code></div>
                            <div style={{ fontSize: 11, color: "#64748b" }}>updated_at: <code>{window.__safeText(svc.updated_at, "—")}</code></div>
                            <div style={{ fontSize: 11, color: "#64748b" }}>stage_updated_at: <code>{window.__safeText(svc.stage_updated_at?.formatted || svc.stage_updated_at, "—")}</code></div>
                          </div>
                        )}
                      </div>
                    </div>
                  </aside>
                );
              })()}
            </div>
          );
        })()}
      </main>
    </div>

    {/* ============================================================
        SECTION POPUP MODAL (IMAGES TAB, IMAGE ACTIVITY LOGS, AUDIT, OVERVIEW)
    ============================================================ */}
    {window.__serviceActiveSectionModal?.open && (() => {
      const modal = window.__serviceActiveSectionModal;
      const tab = modal.tab;
      const svcRaw = modal.record;
      if (!svcRaw) return null;
      const svc = window.__serviceMasterRegistry.get(window.__getServiceCanonId(svcRaw)) || svcRaw;
      const sId = window.__getServiceCanonId(svc);
      const pId = window.__getServiceProviderId(svc);
      const title = window.__getServiceTitle(svc);
      const pName = window.__getServiceProviderName(svc);
      const images = window.__extractServiceImages(svc);
      const allApproved = window.__areAllServiceImagesApproved(svc);
      const effectiveStageId = window.__getEffectiveServiceStage(svc);
      const close = () => window.__closeServiceSectionModal();
      const activeIdx = Math.max(0, Math.min(window.__serviceActiveImageIndex || 0, Math.max(0, images.length - 1)));
      const activeImg = images[activeIdx] || null;
      const showTechOverview = Boolean(window.__serviceShowTechnicalDetails);
      const reviewedAtDisplay = window.__formatReviewedAtDisplay(svc);
      const rawDiscount = svc.discount;
      const rawDiscountAmount = svc.discount_amount !== undefined ? svc.discount_amount : svc.discountAmount;
      const rawDiscountedPrice = svc.discounted_price !== undefined ? svc.discounted_price : svc.discountedPrice;
      return (
        <div
          onClick={close}
          className="no-screen-capture"
          onContextMenu={(e) => {
            e.preventDefault();
            window.__showServiceSecurityAlert("Right-Click Action Prevented");
          }}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.8)",
            zIndex: 14000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px 16px",
            backdropFilter: "blur(8px)",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#ffffff",
              borderRadius: 20,
              width: "min(1000px, 100%)",
              maxHeight: "88vh",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 25px 50px rgba(0,0,0,0.35)",
              overflow: "hidden",
              position: "relative",
            }}
          >
            {/* Security Top Banner */}
            <div
              style={{
                background: "linear-gradient(90deg, #991b1b 0%, #b91c1c 50%, #991b1b 100%)",
                color: "#fee2e2",
                padding: "6px 20px",
                fontSize: 10.5,
                fontWeight: 800,
                textAlign: "center",
                letterSpacing: "0.05em",
                textTransform: "uppercase",
              }}
            >
              🔒 Confidential Verification Depository — Screen Recording, Screenshots & Downloads Strictly Prohibited
            </div>

            {/* Modal Header */}
            <div style={{ padding: "16px 24px", background: "#0f172a", color: "#ffffff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ fontSize: 13, color: "#4ade80", fontWeight: 800 }}>👤 Provider: {window.__safeText(pName)}</div>
                <h3 style={{ margin: 0, fontWeight: 800, fontSize: 17 }}>{title}</h3>
                <span style={{ fontSize: 11, color: "#94a3b8" }}>
                  Service ID: {sId} · Provider ID: {pId}
                </span>
              </div>
              <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                <button
                  type="button"
                  onClick={() => window.__openRecycleBinModal(svc)}
                  style={{ border: "1px solid #f43f5e", background: "#881337", color: "#fff", borderRadius: 8, padding: "6px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}
                >
                  ♻️ 7-Day Recycle Bin
                </button>
                <button
                  onClick={close}
                  style={{ border: "1px solid #334155", background: "#1e293b", color: "#fff", borderRadius: 8, padding: "6px 14px", fontWeight: 700, cursor: "pointer" }}
                >
                  ✕ Close
                </button>
              </div>
            </div>

            {/* Modal Navigation Tabs */}
            <div style={{ display: "flex", padding: "10px 18px", gap: 8, background: "#0b1329", borderBottom: "1px solid #1e293b", overflowX: "auto" }}>
              {[
                { key: "overview", label: "Service Details (Overview)", icon: "📋" },
                { key: "images", label: "Images Tab & Media Review", icon: "🖼️", count: images.length },
                { key: "activity", label: "Image Activity Logs", icon: "📊" },
                { key: "audit", label: "Stage & Audit Trail", icon: "🕒" },
              ].map((t) => (
                <button
                  key={t.key}
                  onClick={() => window.__openServiceSectionModal(t.key, svc)}
                  style={{
                    padding: "8px 14px",
                    borderRadius: 8,
                    border: tab === t.key ? "1px solid #38bdf8" : "1px solid transparent",
                    background: tab === t.key ? "#1e40af" : "#1e293b",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: 12,
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    whiteSpace: "nowrap",
                  }}
                >
                  <span>{t.icon}</span>
                  <span>{t.label}</span>
                  {t.count !== undefined && (
                    <span style={{ fontSize: 10, background: "rgba(255,255,255,0.2)", padding: "1px 5px", borderRadius: 6 }}>
                      {t.count}
                    </span>
                  )}
                </button>
              ))}
            </div>

            {/* Modal Body */}
            <div style={{ flex: 1, overflowY: "auto", padding: 22, background: "#f8fafc" }}>
              {/* ════ TAB: OVERVIEW (WITH DISCOUNT FIELDS) ════ */}
              {tab === "overview" && (
                <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(360px, 1fr))", gap: 16 }}>
                    <div style={{ background: "#ffffff", padding: 18, borderRadius: 14, border: "1px solid #e2e8f0" }}>
                      <h4 style={{ margin: "0 0 12px 0", fontSize: 14, fontWeight: 800, color: "#0f172a" }}>Service Specifications</h4>
                      <div style={{ display: "flex", flexDirection: "column", gap: 8, fontSize: 12.5 }}>
                        <div>Service ID: <strong>{sId}</strong></div>
                        <div>Provider: <strong style={{ color: "#166534" }}>{window.__safeText(pName)}</strong></div>
                        <div>Title: <strong>{title}</strong></div>
                        <div>Description: <span style={{ color: "#475569" }}>{window.__safeText(svc.description || svc.details, "No description provided.")}</span></div>
                        <div>Category: <strong>{window.__humanizeLabel(svc.category || svc.serviceCategory) || "General"}</strong></div>
                        <div>Sub-Category: <strong>{window.__humanizeLabel(svc.subCategory || svc.subcategory) || "—"}</strong></div>
                        <div>Regular Price / Pricing: <strong>{window.__safeText(svc.pricing || svc.price, "—")}</strong></div>
                        {/* DISCOUNT FIELDS CARD */}
                        <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", padding: "10px 12px", borderRadius: 8, marginTop: 4 }}>
                          <div style={{ fontWeight: 800, color: "#166534", marginBottom: 6 }}>💰 Concessions & Promotional Pricing</div>
                          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                            <div>Discount Rate / Tier: <strong>{rawDiscount !== null && rawDiscount !== undefined ? window.__safeText(rawDiscount) : "None"}</strong></div>
                            <div>Discount Amount: <strong>{rawDiscountAmount !== null && rawDiscountAmount !== undefined ? window.__safeText(rawDiscountAmount) : "—"}</strong></div>
                            <div>Discounted Price: <strong style={{ color: "#15803d", fontSize: 13 }}>{rawDiscountedPrice !== null && rawDiscountedPrice !== undefined ? window.__safeText(rawDiscountedPrice) : "—"}</strong></div>
                          </div>
                        </div>

                        <div>Duration: <strong>{window.__safeText(svc.duration) || (svc.duration_seconds !== undefined ? `${window.__safeText(svc.duration_seconds)} sec` : "—")}</strong></div>
                        {window.__isLocationApprovalRuleActive(svc) && (
                          <div>Location: <strong>{window.__getSafeLocationDisplay(svc)}</strong></div>
                        )}
                      </div>
                    </div>
                    <div style={{ background: "#ffffff", padding: 18, borderRadius: 14, border: "1px solid #e2e8f0" }}>
                      <h4 style={{ margin: "0 0 12px 0", fontSize: 14, fontWeight: 800, color: "#0f172a" }}>Review Status</h4>
                      <div style={{ display: "flex", flexDirection: "column", gap: 8, fontSize: 12.5 }}>
                        <div>Status: <strong style={{ color: effectiveStageId === "approved" ? "#16a34a" : effectiveStageId === "rejected" ? "#dc2626" : "#d97706" }}>{window.__getServiceStageMeta(effectiveStageId).label}</strong></div>
                        <div>Reviewed By: <strong>{window.__getServiceReviewedByDisplay(svc)}</strong></div>
                        <div>Reviewed At: <strong>{reviewedAtDisplay}</strong></div>
                        <div>Approval Reason: <span style={{ color: "#16a34a" }}>{window.__safeText(svc.approval_reason, "None recorded")}</span></div>
                        <div>Rejection Reason: <span style={{ color: "#dc2626" }}>{window.__safeText(svc.rejection_reason, "None recorded")}</span></div>
                      </div>
                    </div>
                  </div>
                  <div style={{ background: "#ffffff", padding: 14, borderRadius: 12, border: "1px dashed #cbd5e1" }}>
                    <button
                      type="button"
                      onClick={() => window.__toggleServiceTechnicalDetails()}
                      style={{ background: "transparent", border: "1px dashed #cbd5e1", color: "#64748b", fontSize: 11, fontWeight: 700, padding: "6px 10px", borderRadius: 6, cursor: "pointer" }}
                    >
                      {showTechOverview ? "▾ Hide Technical / Debug Info" : "▸ Show Technical / Debug Info (Internal Use Only)"}
                    </button>
                    {showTechOverview && (
                      <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 6, fontSize: 12 }}>
                        <div>Origin Path: <strong style={{ color: "#7c3aed" }}>{window.__safeText(svc.origin, "Firestore Synced")}</strong></div>
                        <div>Provider ID (raw): <code>{pId}</code></div>
                        <div>Description Status (raw): <strong>{window.__safeText(svc.description_status, "pending")}</strong></div>
                        <div>Media Status (raw): <strong>{window.__safeText(svc.media_status, "pending")}</strong></div>
                        <div>Is Active / Is Approved: <strong>{String(Boolean(svc.is_active))} / {String(Boolean(svc.is_approved))}</strong></div>
                        <div>updatedAt: <strong>{window.__safeText(svc.updatedAt, "—")}</strong></div>
                        <div>updated_at: <strong>{window.__safeText(svc.updated_at, "—")}</strong></div>
                        <div>stage_updated_at: <strong>{window.__safeText(svc.stage_updated_at?.formatted || svc.stage_updated_at, "—")}</strong></div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* ════ TAB: IMAGES TAB ════ */}
              {tab === "images" && (
                <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                  {/* Status Indicators & BULK APPROVE */}
                  <div style={{ background: "#ffffff", border: "1px solid #cbd5e1", borderRadius: 14, padding: 18, boxShadow: "0 1px 3px rgba(0,0,0,0.04)" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12, flexWrap: "wrap", gap: 10 }}>
                      <h4 style={{ margin: 0, fontSize: 14, fontWeight: 800, color: "#0f172a" }}>
                        📸 Media & Verification Status
                      </h4>
                      <div style={{ display: "flex", gap: 10 }}>
                        {!allApproved ? (
                          <button
                            type="button"
                            onClick={async () => {
                              await window.__executeServiceStageTransition(sId, "approved", "Bulk Approved all service media & specifications.");
                              window.__showServiceToast("All service images approved successfully!", "success");
                            }}
                            style={{
                              background: "#16a34a",
                              color: "#ffffff",
                              border: "none",
                              padding: "8px 18px",
                              borderRadius: 8,
                              fontSize: 12.5,
                              fontWeight: 800,
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              boxShadow: "0 2px 8px rgba(22,163,74,0.3)",
                            }}
                          >
                            <span>✓</span>
                            <span>Approve All Images</span>
                          </button>
                        ) : (
                          <div
                            style={{
                              background: "#dcfce7",
                              color: "#15803d",
                              border: "1px solid #bbf7d0",
                              padding: "6px 14px",
                              borderRadius: 8,
                              fontSize: 12,
                              fontWeight: 800,
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                            }}
                          >
                            <span>✓</span>
                            <span>All Images Approved</span>
                          </div>
                        )}
                      </div>
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
                      <div style={{ background: "#f8fafc", padding: "8px 12px", borderRadius: 8, border: "1px solid #e2e8f0" }}>
                        <span style={{ fontSize: 11, color: "#64748b" }}>Overall Status:</span>
                        <div style={{ fontWeight: 800, fontSize: 13, color: effectiveStageId === "approved" ? "#16a34a" : effectiveStageId === "rejected" ? "#dc2626" : "#d97706" }}>
                          {window.__getServiceStageMeta(effectiveStageId).label}
                        </div>
                      </div>
                      <div style={{ background: "#f8fafc", padding: "8px 12px", borderRadius: 8, border: "1px solid #e2e8f0" }}>
                        <span style={{ fontSize: 11, color: "#64748b" }}>Images Approved:</span>
                        <div style={{ fontWeight: 800, fontSize: 13, color: "#2563eb" }}>
                          {images.filter((im) => im.status === "approved").length} / {images.length}
                        </div>
                      </div>
                      <div style={{ background: "#f8fafc", padding: "8px 12px", borderRadius: 8, border: "1px solid #e2e8f0" }}>
                        <span style={{ fontSize: 11, color: "#64748b" }}>Newly Uploaded:</span>
                        <div style={{ fontWeight: 800, fontSize: 13, color: "#4f46e5" }}>
                          {images.filter((im) => im.isNew).length} Images
                        </div>
                      </div>
                      <div style={{ background: "#f8fafc", padding: "8px 12px", borderRadius: 8, border: "1px solid #e2e8f0" }}>
                        <span style={{ fontSize: 11, color: "#64748b" }}>Deletion Requests:</span>
                        <div style={{ fontWeight: 800, fontSize: 13, color: "#dc2626" }}>
                          {images.filter((im) => im.deletionRequested).length} Pending
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Thumbnail Strip with NEW and DELETION Badges */}
                  {images.length > 0 && (
                    <div className="svc-thumb-strip" style={{ display: "flex", gap: 8, overflowX: "auto", padding: "4px 2px" }}>
                      {images.map((im, idx) => {
                        const isActive = idx === activeIdx;
                        const isUnlockedThumb = window.__unlockedImageUrls && window.__unlockedImageUrls.has(im.url);
                        const dotColor = im.status === "approved" ? "#16a34a" : im.status === "rejected" ? "#dc2626" : "#d97706";
                        return (
                          <div
                            key={im.id}
                            onClick={() => {
                              window.__serviceActiveImageIndex = idx;
                              window.__triggerServicePipelineReRender();
                            }}
                            style={{
                              position: "relative",
                              flexShrink: 0,
                              width: 80,
                              height: 66,
                              borderRadius: 8,
                              overflow: "hidden",
                              cursor: "pointer",
                              border: isActive ? "2.5px solid #2563eb" : im.deletionRequested ? "2px solid #ef4444" : "1px solid #cbd5e1",
                              background: "#0f172a",
                            }}
                            title={im.caption}
                          >
                            <img
                              src={im.url}
                              alt=""
                              onContextMenu={(e) => e.preventDefault()}
                              style={{ width: "100%", height: "100%", objectFit: "cover", filter: isUnlockedThumb ? "none" : "blur(5px)" }}
                            />
                            <span style={{ position: "absolute", bottom: 3, right: 3, width: 8, height: 8, borderRadius: "50%", background: dotColor, border: "1px solid #fff" }} />
                            {im.isNew && (
                              <span style={{ position: "absolute", top: 2, left: 2, fontSize: 7, fontWeight: 900, background: "#4f46e5", color: "#fff", padding: "0 3px", borderRadius: 3 }}>
                                NEW
                              </span>
                            )}
                            {im.deletionRequested && (
                              <span style={{ position: "absolute", top: 2, right: 2, fontSize: 8, background: "#dc2626", color: "#fff", borderRadius: "50%", width: 14, height: 14, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                🗑️
                              </span>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {/* Image-by-Image Slider / Viewer */}
                  <div style={{ background: "#ffffff", borderRadius: 14, border: "1px solid #cbd5e1", padding: 18 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14, flexWrap: "wrap", gap: 8 }}>
                      <h4 style={{ margin: 0, fontSize: 14, fontWeight: 800, color: "#0f172a" }}>
                        Image By Image Inspection ({images.length > 0 ? `${activeIdx + 1} of ${images.length}` : "0"} Images)
                      </h4>
                      <div style={{ display: "flex", gap: 8 }}>
                        <button
                          type="button"
                          disabled={images.length <= 1 || activeIdx === 0}
                          onClick={() => {
                            window.__serviceActiveImageIndex = Math.max(0, activeIdx - 1);
                            window.__triggerServicePipelineReRender();
                          }}
                          style={{
                            padding: "6px 14px",
                            borderRadius: 8,
                            border: "1px solid #cbd5e1",
                            background: activeIdx === 0 ? "#f1f5f9" : "#ffffff",
                            color: activeIdx === 0 ? "#94a3b8" : "#0f172a",
                            fontWeight: 800,
                            cursor: activeIdx === 0 ? "not-allowed" : "pointer",
                          }}
                        >
                          ◀ Previous Image
                        </button>
                        <button
                          type="button"
                          disabled={images.length <= 1 || activeIdx >= images.length - 1}
                          onClick={() => {
                            window.__serviceActiveImageIndex = Math.min(images.length - 1, activeIdx + 1);
                            window.__triggerServicePipelineReRender();
                          }}
                          style={{
                            padding: "6px 16px",
                            borderRadius: 8,
                            border: "none",
                            background: activeIdx >= images.length - 1 ? "#94a3b8" : "#2563eb",
                            color: "#ffffff",
                            fontWeight: 800,
                            cursor: activeIdx >= images.length - 1 ? "not-allowed" : "pointer",
                          }}
                        >
                          Next Image ▶
                        </button>
                      </div>
                    </div>
                    {images.length === 0 ? (
                      <div style={{ textAlign: "center", padding: "40px 20px", background: "#f8fafc", borderRadius: 12, border: "1.5px dashed #cbd5e1", color: "#64748b" }}>
                        No gallery media or service images found across the collections.
                      </div>
                    ) : (
                      activeImg && (() => {
                        const isUnlocked = window.__unlockedImageUrls && window.__unlockedImageUrls.has(activeImg.url);
                        const isImgApproved = activeImg.status === "approved" || activeImg.approval_status === "approved";
                        const isImgRejected = activeImg.status === "rejected" || activeImg.approval_status === "rejected";
                        const isCrmOrigin = activeImg.uploaded_from === "crm" || activeImg.source === "crm";
                        const imgReviewedByDisplay = window.__getServiceReviewedByDisplay(activeImg, svc);
                        return (
                          <div style={{ display: "flex", flexDirection: "column", gap: 12, background: "#f8fafc", padding: 16, borderRadius: 12, border: "1px solid #e2e8f0" }}>
                            {/* PROVIDER IMAGE DELETION REQUEST BANNER WITH TIMESTAMP */}
                            {activeImg.deletionRequested && (
                              <div
                                style={{
                                  background: "#fee2e2",
                                  border: "1.5px solid #ef4444",
                                  borderRadius: 10,
                                  padding: "12px 16px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  flexWrap: "wrap",
                                  gap: 10,
                                }}
                              >
                                <div>
                                  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                    <span style={{ fontSize: 18 }}>🗑️</span>
                                    <strong style={{ color: "#991b1b", fontSize: 13.5 }}>
                                      Provider Image Deletion Request
                                    </strong>
                                  </div>
                                  <div style={{ fontSize: 12, color: "#7f1d1d", marginTop: 3 }}>
                                    Requested Timestamp: <strong>{window.__formatPreciseTimestamp(activeImg.deletionRequestedAt)}</strong>
                                  </div>
                                  <div style={{ fontSize: 12, color: "#7f1d1d", marginTop: 2 }}>
                                    Provider Reason: <em>"{activeImg.deletionReason || "Removal requested"}"</em>
                                  </div>
                                </div>
                                <button
                                  type="button"
                                  onClick={() => window.__openImageDeletionProcessModal(svc, activeImg)}
                                  style={{
                                    padding: "8px 16px",
                                    borderRadius: 8,
                                    border: "none",
                                    background: "#b91c1c",
                                    color: "#ffffff",
                                    fontWeight: 800,
                                    fontSize: 12,
                                    cursor: "pointer",
                                    boxShadow: "0 2px 6px rgba(185,28,28,0.3)",
                                  }}
                                >
                                  Process Request ➔
                                </button>
                              </div>
                            )}
                            {/* Main Inspection Canvas */}
                            <div style={{ position: "relative", height: 360, background: "#0f172a", borderRadius: 10, overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <div className="svc-media-shield" />
                              <img
                                src={activeImg.url}
                                alt=""
                                onContextMenu={(e) => e.preventDefault()}
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "100%",
                                  objectFit: "contain",
                                  filter: isUnlocked ? "none" : "blur(2px)",
                                }}
                              />
                              <div style={{ position: "absolute", top: 10, right: 10, display: "flex", gap: 6, flexWrap: "wrap" }}>
                                {activeImg.isNew && (
                                  <span style={{ background: "#4f46e5", color: "#fff", fontSize: 11, padding: "4px 9px", borderRadius: 6, fontWeight: 900, boxShadow: "0 2px 4px rgba(0,0,0,0.25)" }}>
                                    ✨ NEW IMAGE
                                  </span>
                                )}
                                <span
                                  style={{
                                    background: isImgApproved ? "#16a34a" : isImgRejected ? "#dc2626" : "#d97706",
                                    color: "#ffffff",
                                    fontSize: 11,
                                    padding: "4px 9px",
                                    borderRadius: 6,
                                    fontWeight: 800,
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.25)",
                                  }}
                                >
                                  {isImgApproved ? "✓ Approved" : isImgRejected ? "✕ Rejected" : "⏳ Pending Verification"}
                                </span>
                                {activeImg.isMainImage && (
                                  <span style={{ background: "#7c3aed", color: "#fff", fontSize: 11, padding: "4px 8px", borderRadius: 6, fontWeight: 700 }}>
                                    Main Gallery Image
                                  </span>
                                )}
                                {isCrmOrigin && (
                                  <span style={{ background: "#2563eb", color: "#fff", fontSize: 11, padding: "4px 8px", borderRadius: 6, fontWeight: 700 }}>
                                    CRM Auto-Approved
                                  </span>
                                )}
                              </div>
                            </div>
                            {/* Details and Unlock Action */}
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 10 }}>
                              <div>
                                <strong style={{ fontSize: 13, color: "#0f172a" }}>{window.__safeText(activeImg.caption)}</strong>
                                <div style={{ fontSize: 11, color: "#64748b", marginTop: 4 }}>
                                  Image uploadedAt: <strong style={{ color: "#334155" }}>{window.__formatPreciseTimestamp(activeImg.uploadedAt)}</strong>
                                </div>
                                <div style={{ fontSize: 11, color: "#64748b" }}>
                                  Uploaded By: <strong style={{ color: "#334155" }}>{window.__safeText(activeImg.uploadedBy || (isCrmOrigin ? "CRM Team" : pName) || "Unknown")}</strong>
                                </div>
                                <div style={{ fontSize: 11, color: "#64748b" }}>
                                  Reviewed By: <strong style={{ color: "#334155" }}>{imgReviewedByDisplay}</strong>
                                  {imgReviewedByDisplay !== "Not Reviewed" && activeImg.reviewedAt ? ` · ${window.__formatPreciseTimestamp(activeImg.reviewedAt)}` : ""}
                                </div>
                              </div>
                              <div style={{ display: "flex", gap: 8 }}>
                                <button
                                  type="button"
                                  onClick={() => window.__promptServiceImageAccessPasscode({ imgItem: activeImg, serviceRecord: svc })}
                                  style={{
                                    padding: "8px 16px",
                                    borderRadius: 8,
                                    border: isUnlocked ? "1px solid #16a34a" : "1px solid #2563eb",
                                    background: isUnlocked ? "#dcfce7" : "#2563eb",
                                    color: isUnlocked ? "#16a34a" : "#ffffff",
                                    fontWeight: 800,
                                    fontSize: 12,
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 6,
                                  }}
                                >
                                  <span>{isUnlocked ? "🔓" : "🔒"}</span>
                                  <span>{isUnlocked ? "View High-Res Full Screen" : "Unlock High-Res Image"}</span>
                                </button>
                                <button
                                  type="button"
                                  onClick={() => {
                                    window.__moveToRecycleBin({
                                      serviceId: sId,
                                      providerId: pId,
                                      imgItem: activeImg,
                                      reason: "Removed directly to 7-day recycle bin by compliance admin",
                                    });
                                    window.__showServiceToast("Image sent to 7-Day Recycle Bin.", "info");
                                    window.__triggerServicePipelineReRender();
                                  }}
                                  style={{
                                    padding: "8px 12px",
                                    borderRadius: 8,
                                    border: "1px solid #f43f5e",
                                    background: "#fff1f2",
                                    color: "#be123c",
                                    fontWeight: 800,
                                    fontSize: 12,
                                    cursor: "pointer",
                                  }}
                                  title="Soft-delete image to 7-Day Recycle Bin"
                                >
                                  ♻️ Move to Bin
                                </button>
                              </div>
                            </div>

                            {/* Per-Image Approve / Reject Row */}
                            <div style={{ display: "flex", gap: 8, paddingTop: 8, borderTop: "1px dashed #e2e8f0" }}>
                              <button
                                type="button"
                                disabled={isImgApproved}
                                onClick={() => window.__setSingleImageReviewStatus(sId, activeImg.id, "approved")}
                                style={{
                                  flex: 1,
                                  padding: "8px 12px",
                                  borderRadius: 8,
                                  border: "none",
                                  background: isImgApproved ? "#dcfce7" : "#16a34a",
                                  color: isImgApproved ? "#15803d" : "#ffffff",
                                  fontWeight: 800,
                                  fontSize: 12,
                                  cursor: isImgApproved ? "default" : "pointer",
                                }}
                              >
                                ✓ {isImgApproved ? "Image Approved" : "Approve This Image"}
                              </button>
                              <button
                                type="button"
                                disabled={isImgRejected}
                                onClick={() => window.__setSingleImageReviewStatus(sId, activeImg.id, "rejected", "Rejected during individual image review.")}
                                style={{
                                  flex: 1,
                                  padding: "8px 12px",
                                  borderRadius: 8,
                                  border: "none",
                                  background: isImgRejected ? "#fee2e2" : "#dc2626",
                                  color: isImgRejected ? "#b91c1c" : "#ffffff",
                                  fontWeight: 800,
                                  fontSize: 12,
                                  cursor: isImgRejected ? "default" : "pointer",
                                }}
                              >
                                ✕ {isImgRejected ? "Image Rejected" : "Reject This Image"}
                              </button>
                            </div>
                          </div>
                        );
                      })()
                    )}
                  </div>
                </div>
              )}

              {/* ════ TAB: IMAGE ACTIVITY LOGS ════ */}
              {tab === "activity" && (
                <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                  <div style={{ background: "#ffffff", padding: 14, borderRadius: 12, border: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
                    <div>
                      <strong style={{ fontSize: 13, color: "#0f172a" }}>Image Activity Audit Records</strong>
                      <div style={{ fontSize: 11, color: "#64748b" }}>
                        Tracking all uploads, reviews, deletion requests, and restorations for Service: <code>{sId}</code> · Provider: <code>{pId}</code>
                      </div>
                    </div>
                    <span style={{ fontSize: 11, background: "#eff6ff", color: "#1d4ed8", padding: "4px 8px", borderRadius: 6, fontWeight: 800 }}>
                      Logged Locally (Zero Firestore Clutter)
                    </span>
                  </div>
                  {(() => {
                    const activityLogs = window.__getImageActivityLogs(sId, pId);
                    if (activityLogs.length === 0) {
                      return (
                        <div style={{ textAlign: "center", padding: 40, background: "#ffffff", borderRadius: 12, border: "1px dashed #cbd5e1", color: "#64748b" }}>
                          No image activities recorded for this service and provider yet.
                        </div>
                      );
                    }
                    return (
                      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                        {activityLogs.map((log) => {
                          const isApprove = log.action.includes("APPROVED");
                          const isReject = log.action.includes("REJECTED");
                          const isDelete = log.action.includes("DELETION") || log.action.includes("RECYCLE");
                          const isRestore = log.action.includes("RESTORE");
                          const badgeBg = isApprove ? "#dcfce7" : isReject ? "#fee2e2" : isDelete ? "#ffedd5" : isRestore ? "#e0e7ff" : "#f1f5f9";
                          const badgeColor = isApprove ? "#15803d" : isReject ? "#b91c1c" : isDelete ? "#c2410c" : isRestore ? "#3730a3" : "#334155";
                          return (
                            <div key={log.id} style={{ background: "#ffffff", border: "1px solid #e2e8f0", padding: "12px 14px", borderRadius: 10, display: "flex", flexDirection: "column", gap: 4 }}>
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <span style={{ background: badgeBg, color: badgeColor, padding: "2px 8px", borderRadius: 6, fontSize: 11, fontWeight: 800 }}>
                                  {log.action.replace(/_/g, " ")}
                                </span>
                                <span style={{ fontSize: 11, color: "#64748b" }}>{window.__safeText(log.formattedTime)}</span>
                              </div>
                              <div style={{ fontSize: 12.5, fontWeight: 700, color: "#0f172a", marginTop: 2 }}>
                                Image: {window.__safeText(log.imageCaption)}
                              </div>
                              {log.details && (
                                <div style={{ fontSize: 12, color: "#334155" }}>{window.__safeText(log.details)}</div>
                              )}
                              {log.reason && (
                                <div style={{ fontSize: 11.5, color: "#475569", background: "#f8fafc", padding: "4px 8px", borderRadius: 4 }}>
                                  Reason: <em>"{window.__safeText(log.reason)}"</em>
                                </div>
                              )}
                              <div style={{ fontSize: 10.5, color: "#94a3b8", display: "flex", justifyContent: "space-between", marginTop: 2 }}>
                                <span>Performed By: {window.__safeText(log.performedBy)}</span>
                                <span>Provider ID: {window.__safeText(log.providerId)}</span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })()}
                </div>
              )}

              {/* ════ TAB: AUDIT ════ */}
              {tab === "audit" && (
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  {(() => {
                    const logs = window.__getServiceAuditLogs(sId);
                    if (logs.length === 0) {
                      return (
                        <div style={{ textAlign: "center", padding: 40, background: "#ffffff", borderRadius: 12, border: "1px dashed #cbd5e1", color: "#64748b" }}>
                          No stage transitions or audit logs recorded for this service yet.
                        </div>
                      );
                    }
                    return logs.map((l) => (
                      <div key={l.id} style={{ background: "#ffffff", border: "1px solid #e2e8f0", padding: "10px 14px", borderRadius: 8, fontSize: 12 }}>
                        <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700 }}>
                          <span style={{ color: "#2563eb" }}>{window.__safeText(l.action)} ({window.__safeText(l.fromStage)} ➔ {window.__safeText(l.toStage)})</span>
                          <span style={{ color: "#64748b" }}>{window.__safeText(l.formattedTime)}</span>
                        </div>
                        <div style={{ marginTop: 4, color: "#334155" }}>{window.__safeText(l.reason)}</div>
                        {l.signature && (
                          <div style={{ marginTop: 2, fontSize: 11, color: "#166534", fontFamily: "monospace" }}>
                            🔒 Encrypted Signature: {window.__safeText(l.signature)}
                          </div>
                        )}
                        {l.imageId && (
                          <div style={{ marginTop: 2, fontSize: 11, color: "#7c3aed" }}>Image: {window.__safeText(l.imageCaption || l.imageId)}</div>
                        )}
                        <div style={{ marginTop: 2, fontSize: 11, color: "#94a3b8" }}>By: {window.__safeText(l.performedBy)}</div>
                      </div>
                    ));
                  })()}
                </div>
              )}
            </div>
          </div>
        </div>
      );
    })()}

    {/* ============================================================
        FEATURE 4: SEVEN-DAY RECYCLE BIN & RESTORATION CONSOLE MODAL
    ============================================================ */}
    {window.__recycleBinModalState?.open && (() => {
      const state = window.__recycleBinModalState;
      const targetServiceId = state.selectedServiceId === "all" ? null : state.selectedServiceId;
      const items = window.__getRecycleBinItems(targetServiceId);
      const close = () => {
        window.__recycleBinModalState = null;
        window.__triggerServicePipelineReRender();
      };
      return (
        <div
          onClick={close}
          className="no-screen-capture"
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.85)",
            zIndex: 16000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
            backdropFilter: "blur(8px)",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#ffffff",
              borderRadius: 20,
              width: "min(920px, 100%)",
              maxHeight: "85vh",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 25px 60px rgba(0,0,0,0.35)",
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <div style={{ padding: "16px 22px", background: "#881337", color: "#ffffff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 24 }}>♻️</span>
                <div>
                  <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800 }}>
                    7-Day Media Recycle Bin & Restoration Desk
                  </h3>
                  <span style={{ fontSize: 11.5, opacity: 0.9 }}>
                    All deleted images are safely retained for 7 calendar days before permanent purge
                  </span>
                </div>
              </div>
              <button
                onClick={close}
                style={{ background: "rgba(0,0,0,0.2)", border: "none", color: "#fff", borderRadius: 8, padding: "6px 12px", cursor: "pointer", fontWeight: 700 }}
              >
                ✕ Close
              </button>
            </div>
            {/* Filter Sub-bar */}
            <div style={{ padding: "10px 18px", background: "#f8fafc", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ fontSize: 12, color: "#475569" }}>
                Total Retained Images: <strong>{items.length}</strong>
              </div>
              {state.serviceRecord && (
                <div style={{ display: "flex", gap: 8 }}>
                  <button
                    type="button"
                    onClick={() => {
                      state.selectedServiceId = state.selectedServiceId === "all" ? window.__getServiceCanonId(state.serviceRecord) : "all";
                      window.__triggerServicePipelineReRender();
                    }}
                    style={{
                      padding: "4px 10px",
                      borderRadius: 6,
                      border: "1px solid #cbd5e1",
                      background: state.selectedServiceId === "all" ? "#e0e7ff" : "#ffffff",
                      fontSize: 11,
                      fontWeight: 700,
                      cursor: "pointer",
                    }}
                  >
                    {state.selectedServiceId === "all" ? "Showing All Services" : "Filter: This Service Only"}
                  </button>
                </div>
              )}
            </div>
            {/* Body */}
            <div style={{ flex: 1, overflowY: "auto", padding: 20, background: "#f1f5f9" }}>
              {items.length === 0 ? (
                <div style={{ textAlign: "center", padding: "60px 20px", background: "#ffffff", borderRadius: 14, border: "1.5px dashed #cbd5e1" }}>
                  <div style={{ fontSize: 36, marginBottom: 8 }}>♻️</div>
                  <h4 style={{ margin: "0 0 6px 0", color: "#0f172a", fontSize: 16 }}>Recycle Bin is Empty</h4>
                  <p style={{ margin: 0, color: "#64748b", fontSize: 12.5 }}>
                    No service images are currently in the 7-day retention period.
                  </p>
                </div>
              ) : (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(270px, 1fr))", gap: 14 }}>
                  {items.map((it) => (
                    <div
                      key={it.id}
                      style={{
                        background: "#ffffff",
                        borderRadius: 12,
                        border: "1px solid #e2e8f0",
                        padding: 12,
                        display: "flex",
                        flexDirection: "column",
                        gap: 8,
                        boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
                      }}
                    >
                      {/* Image Thumbnail with Countdown Badge */}
                      <div style={{ position: "relative", height: 140, background: "#0f172a", borderRadius: 8, overflow: "hidden" }}>
                        <img
                          src={it.url}
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                        <span
                          style={{
                            position: "absolute",
                            top: 6,
                            right: 6,
                            background: it.daysLeft <= 1 ? "#dc2626" : "#e11d48",
                            color: "#ffffff",
                            fontSize: 10,
                            fontWeight: 800,
                            padding: "2px 7px",
                            borderRadius: 6,
                            boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
                          }}
                        >
                          ⏳ {it.daysLeft > 0 ? `${it.daysLeft} day(s) left` : "Expires today"}
                        </span>
                      </div>
                      {/* Info */}
                      <div>
                        <strong style={{ fontSize: 13, color: "#0f172a" }}>{window.__safeText(it.caption)}</strong>
                        <div style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}>
                          Service ID: <code>{it.serviceId}</code>
                        </div>
                        <div style={{ fontSize: 11, color: "#64748b" }}>
                          Deleted At: <strong>{window.__formatPreciseTimestamp(it.deletedAt)}</strong>
                        </div>
                        <div style={{ fontSize: 11, color: "#b91c1c", marginTop: 2 }}>
                          Reason: <em>"{it.deletionReason}"</em>
                        </div>
                      </div>
                      {/* Actions */}
                      <div style={{ display: "flex", gap: 6, marginTop: "auto" }}>
                        <button
                          type="button"
                          onClick={async () => {
                            await window.__restoreImageFromRecycleBin(it.id);
                          }}
                          style={{
                            flex: 1,
                            padding: "7px 10px",
                            borderRadius: 6,
                            border: "none",
                            background: "#16a34a",
                            color: "#ffffff",
                            fontSize: 11.5,
                            fontWeight: 800,
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 4,
                          }}
                        >
                          <span>↩️</span>
                          <span>Restore Image</span>
                        </button>
                        <button
                          type="button"
                          onClick={() => window.__permanentlyPurgeRecycleItem(it.id)}
                          style={{
                            padding: "7px 10px",
                            borderRadius: 6,
                            border: "1px solid #cbd5e1",
                            background: "#ffffff",
                            color: "#dc2626",
                            fontSize: 11,
                            fontWeight: 700,
                            cursor: "pointer",
                          }}
                          title="Purge immediately without waiting 7 days"
                        >
                          Purge
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      );
    })()}

    {/* ============================================================
        PROCESS IMAGE DELETION REQUEST MODAL
    ============================================================ */}
    {window.__imageDeletionProcessModalState?.open && (() => {
      const state = window.__imageDeletionProcessModalState;
      const svc = state.serviceRecord;
      const img = state.imgItem;
      const sId = window.__getServiceCanonId(svc);
      const close = () => {
        window.__imageDeletionProcessModalState = null;
        window.__triggerServicePipelineReRender();
      };
      return (
        <div
          onClick={close}
          className="no-screen-capture"
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.85)",
            zIndex: 16500,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
            backdropFilter: "blur(6px)",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#ffffff",
              borderRadius: 16,
              width: "min(500px, 100%)",
              overflow: "hidden",
              boxShadow: "0 25px 60px rgba(0,0,0,0.35)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div style={{ background: "linear-gradient(135deg, #b91c1c 0%, #991b1b 100%)", padding: "16px 20px", color: "#ffffff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: 22 }}>🗑️</span>
                <h3 style={{ margin: 0, fontSize: 16, fontWeight: 800 }}>
                  Review Provider Image Deletion Request
                </h3>
              </div>
              <button onClick={close} style={{ background: "rgba(0,0,0,0.2)", border: "none", color: "#fff", borderRadius: "50%", width: 28, height: 28, cursor: "pointer" }}>✕</button>
            </div>
            <div style={{ padding: "20px 22px", display: "flex", flexDirection: "column", gap: 12 }}>
              <div style={{ fontSize: 13, color: "#334155" }}>
                Service: <strong>{window.__getServiceTitle(svc)}</strong> (<code>{sId}</code>)
              </div>
              {/* Preview Thumbnail */}
              <div style={{ height: 140, background: "#0f172a", borderRadius: 10, overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <img src={img.url} alt="" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
              </div>
              {/* Timestamp and reason from provider */}
              <div style={{ background: "#fee2e2", border: "1px solid #fecaca", padding: "10px 14px", borderRadius: 8, fontSize: 12 }}>
                <div style={{ color: "#991b1b", fontWeight: 800 }}>
                  Deletion Requested Timestamp: {window.__formatPreciseTimestamp(img.deletionRequestedAt)}
                </div>
                <div style={{ color: "#7f1d1d", marginTop: 4 }}>
                  Provider's Reason: <em>"{img.deletionReason || "Image removal requested"}"</em>
                </div>
              </div>
              <div>
                <label style={{ fontSize: 12, fontWeight: 700, color: "#1e293b", display: "block", marginBottom: 6 }}>
                  Compliance Admin Decision Note / Reason:
                </label>
                <textarea
                  id="svc-deletion-admin-reason"
                  rows={2}
                  placeholder="Enter reason for approving or declining deletion request..."
                  style={{ width: "100%", padding: 10, borderRadius: 8, border: "1.5px solid #cbd5e1", fontSize: 12.5, boxSizing: "border-box" }}
                />
              </div>
              {state.error && (
                <div style={{ fontSize: 12, color: "#dc2626", fontWeight: 700, background: "#fee2e2", padding: "8px 12px", borderRadius: 8 }}>
                  ⚠️ {state.error}
                </div>
              )}
            </div>
            <div style={{ padding: "14px 22px", background: "#f8fafc", borderTop: "1px solid #e2e8f0", display: "flex", justifyContent: "flex-end", gap: 10 }}>
              <button
                type="button"
                onClick={async () => {
                  const note = document.getElementById("svc-deletion-admin-reason")?.value?.trim();
                  close();
                  await window.__processImageDeletionRequest(sId, img.id, "reject", note);
                }}
                style={{ padding: "8px 16px", borderRadius: 8, border: "1px solid #cbd5e1", background: "#ffffff", color: "#334155", fontWeight: 700, fontSize: 12, cursor: "pointer" }}
              >
                Reject Request (Keep Image)
              </button>
              <button
                type="button"
                onClick={async () => {
                  const note = document.getElementById("svc-deletion-admin-reason")?.value?.trim();
                  close();
                  await window.__processImageDeletionRequest(sId, img.id, "approve", note);
                }}
                style={{
                  padding: "8px 18px",
                  borderRadius: 8,
                  border: "none",
                  background: "#b91c1c",
                  color: "#ffffff",
                  fontWeight: 800,
                  fontSize: 12,
                  cursor: "pointer",
                }}
              >
                Approve (Move to 7-Day Bin)
              </button>
            </div>
          </div>
        </div>
      );
    })()}

    {/* ============================================================
        SECURITY MODAL: IMAGES TAB AUTHENTICATION GATE
    ============================================================ */}
    {window.__serviceImagesAuthModalState?.open && (() => {
      const state = window.__serviceImagesAuthModalState;
      const close = () => { window.__serviceImagesAuthModalState = null; window.__triggerServicePipelineReRender(); };
      return (
        <div
          onClick={close}
          style={{ position: "fixed", inset: 0, background: "rgba(15, 23, 42, 0.85)", zIndex: 15000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, backdropFilter: "blur(6px)" }}
        >
          <div onClick={(e) => e.stopPropagation()} style={{ background: "#ffffff", borderRadius: 16, width: "min(430px, 100%)", padding: 24, boxShadow: "0 25px 60px rgba(0,0,0,0.35)" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
              <span style={{ fontSize: 24 }}>🖼️</span>
              <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: "#1e40af" }}>
                Service Media Security Gate
              </h3>
            </div>
            <p style={{ fontSize: 13, color: "#475569", margin: "0 0 16px 0", lineHeight: 1.45 }}>
              Access to gallery media and compliance images is strictly restricted. Enter compliance authorization passcode to proceed.
            </p>
            <input
              type="password"
              id="service-images-passcode-input"
              placeholder="Enter authorization key..."
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  const val = document.getElementById("service-images-passcode-input")?.value?.trim();
                  if (val === window.__SERVICE_PIPELINE_PASSCODE) {
                    const cb = state.onSuccess;
                    window.__serviceImagesAuthModalState = null;
                    if (cb) cb();
                  } else {
                    state.error = "Incorrect Security Passcode. Access denied.";
                    window.__showServiceToast("Incorrect Security Passcode.", "error");
                    window.__triggerServicePipelineReRender();
                  }
                }
              }}
              style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1.5px solid #cbd5e1", fontSize: 14, boxSizing: "border-box", marginBottom: 10 }}
            />
            {state.error && (
              <div style={{ fontSize: 12, color: "#dc2626", fontWeight: 700, marginBottom: 12 }}>
                ⚠️ {state.error}
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
              <button onClick={close} style={{ padding: "8px 16px", borderRadius: 8, border: "1px solid #cbd5e1", background: "#ffffff", color: "#334155", fontWeight: 700, cursor: "pointer" }}>
                Cancel
              </button>
              <button
                onClick={() => {
                  const val = document.getElementById("service-images-passcode-input")?.value?.trim();
                  if (val === window.__SERVICE_PIPELINE_PASSCODE) {
                    const cb = state.onSuccess;
                    window.__serviceImagesAuthModalState = null;
                    if (cb) cb();
                  } else {
                    state.error = "Incorrect Security Passcode. Access denied.";
                    window.__showServiceToast("Incorrect Security Passcode.", "error");
                    window.__triggerServicePipelineReRender();
                  }
                }}
                style={{ padding: "8px 18px", borderRadius: 8, border: "none", background: "#1e40af", color: "#ffffff", fontWeight: 800, cursor: "pointer" }}
              >
                Authorize Access
              </button>
            </div>
          </div>
        </div>
      );
    })()}

    {/* ============================================================
        SECURITY MODAL: INDIVIDUAL IMAGE PASSCODE GATE
    ============================================================ */}
    {window.__serviceImageItemAuthModalState?.open && (() => {
      const state = window.__serviceImageItemAuthModalState;
      const close = () => { window.__serviceImageItemAuthModalState = null; window.__triggerServicePipelineReRender(); };
      return (
        <div onClick={close} style={{ position: "fixed", inset: 0, background: "rgba(15, 23, 42, 0.85)", zIndex: 15500, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, backdropFilter: "blur(6px)" }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: "#ffffff", borderRadius: 16, width: "min(430px, 100%)", padding: 24, boxShadow: "0 25px 60px rgba(0,0,0,0.35)" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
              <span style={{ fontSize: 24 }}>🔓</span>
              <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: "#1e40af" }}>
                Unlock Image Preview
              </h3>
            </div>
            <p style={{ fontSize: 13, color: "#475569", margin: "0 0 16px 0", lineHeight: 1.45 }}>
              Enter authorization key to unlock and preview <strong>{window.__safeText(state.imgItem?.caption, "this image")}</strong>.
            </p>
            <input
              type="password"
              id="svc-single-img-passcode"
              placeholder="Enter authorization key..."
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  const val = document.getElementById("svc-single-img-passcode")?.value?.trim();
                  state.onConfirm(val);
                }
              }}
              style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1.5px solid #cbd5e1", fontSize: 14, boxSizing: "border-box", marginBottom: 10 }}
            />
            {state.error && (
              <div style={{ fontSize: 12, color: "#dc2626", fontWeight: 700, marginBottom: 12 }}>
                ⚠️ {state.error}
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
              <button onClick={close} style={{ padding: "8px 16px", borderRadius: 8, border: "1px solid #cbd5e1", background: "#ffffff", color: "#334155", fontWeight: 700, cursor: "pointer" }}>
                Cancel
              </button>
              <button
                onClick={() => {
                  const val = document.getElementById("svc-single-img-passcode")?.value?.trim();
                  state.onConfirm(val);
                }}
                style={{ padding: "8px 18px", borderRadius: 8, border: "none", background: "#2563eb", color: "#ffffff", fontWeight: 800, cursor: "pointer" }}
              >
                Unlock Image
              </button>
            </div>
          </div>
        </div>
      );
    })()}

    {/* ============================================================
        DRAWER DECISION MODAL (APPROVE ALL / REJECT SERVICE)
    ============================================================ */}
    {window.__drawerDecisionModalState?.open && (() => {
      const state = window.__drawerDecisionModalState;
      const svc = state.service;
      const isApprove = state.actionType === "approve";
      const sId = window.__getServiceCanonId(svc);
      const title = window.__getServiceTitle(svc);
      const close = () => { window.__drawerDecisionModalState = null; window.__triggerServicePipelineReRender(); };
      return (
        <div
          onClick={close}
          className="no-screen-capture"
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.85)",
            zIndex: 16500,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
            backdropFilter: "blur(6px)",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#ffffff",
              borderRadius: 16,
              width: "min(480px, 100%)",
              overflow: "hidden",
              boxShadow: "0 25px 60px rgba(0,0,0,0.35)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                background: isApprove ? "linear-gradient(135deg, #16a34a 0%, #15803d 100%)" : "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
                padding: "16px 20px",
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 800 }}>
                {isApprove ? "✓ Confirm Service & Image Approval" : "✕ Confirm Service Rejection"}
              </h3>
              <button onClick={close} style={{ background: "rgba(0,0,0,0.2)", border: "none", color: "#fff", borderRadius: "50%", width: 28, height: 28, cursor: "pointer" }}>✕</button>
            </div>
            <div style={{ padding: "20px 22px", display: "flex", flexDirection: "column", gap: 14 }}>
              <div style={{ fontSize: 13.5, color: "#1e293b", fontWeight: 700 }}>
                Are you sure you really want to {isApprove ? "APPROVE" : "REJECT"} this service?
              </div>
              <div style={{ fontSize: 12.5, color: "#475569" }}>
                Target Service: <strong>{title}</strong> (ID: <code>{sId}</code>)
              </div>
              {isApprove && (
                <div style={{ fontSize: 12, color: "#166534", background: "#f0fdf4", border: "1px solid #bbf7d0", padding: "8px 10px", borderRadius: 6 }}>
                  ✓ Notice: All service specifications, descriptions, and uploaded images will be marked <strong>Approved & Active</strong> across all provider screens and databases immediately. An instant push notification will also be dispatched if an FCM token is present.
                </div>
              )}
              <div>
                <label style={{ fontSize: 12, fontWeight: 700, color: "#1e293b", display: "block", marginBottom: 6 }}>
                  Why do you want to {isApprove ? "approve" : "reject"}? (Mandatory Reason) <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <textarea
                  id="svc-decision-reason-input"
                  rows={3}
                  placeholder={isApprove ? "State why you are approving this service..." : "State the reason for rejecting this service..."}
                  style={{ width: "100%", padding: 10, borderRadius: 8, border: "1.5px solid #cbd5e1", fontSize: 13, boxSizing: "border-box" }}
                />
              </div>
              {state.error && (
                <div style={{ fontSize: 12, color: "#dc2626", fontWeight: 700, background: "#fee2e2", padding: "8px 12px", borderRadius: 8 }}>
                  ⚠️ {state.error}
                </div>
              )}
            </div>
            <div style={{ padding: "14px 22px", background: "#f8fafc", borderTop: "1px solid #e2e8f0", display: "flex", justifyContent: "flex-end", gap: 10 }}>
              <button
                type="button"
                onClick={close}
                style={{ padding: "8px 18px", borderRadius: 8, border: "1px solid #cbd5e1", background: "#ffffff", color: "#334155", fontWeight: 700, fontSize: 12, cursor: "pointer" }}
              >
                No, Cancel
              </button>
              <button
                type="button"
                onClick={async () => {
                  const reason = document.getElementById("svc-decision-reason-input")?.value?.trim();
                  if (!reason || reason.length < 3) {
                    state.error = "Please provide a valid reason.";
                    window.__showServiceToast("Reason required for audit trail.", "warning");
                    window.__triggerServicePipelineReRender();
                    return;
                  }
                  const targetStage = isApprove ? "approved" : "rejected";
                  close();
                  await window.__executeServiceStageTransition(sId, targetStage, reason);
                }}
                style={{
                  padding: "8px 20px",
                  borderRadius: 8,
                  border: "none",
                  background: isApprove ? "#16a34a" : "#dc2626",
                  color: "#ffffff",
                  fontWeight: 800,
                  fontSize: 12,
                  cursor: "pointer",
                }}
              >
                Yes, {isApprove ? "Approve Service & Images" : "Reject Service"}
              </button>
            </div>
          </div>
        </div>
      );
    })()}

    {/* ============================================================
        MAIN GALLERY IMAGE DECISION MODAL
    ============================================================ */}
    {window.__mainImageDecisionModalState?.open && (() => {
      const state = window.__mainImageDecisionModalState;
      const svc = state.service;
      const imgItem = state.imgItem;
      const isApprove = state.actionType === "approve";
      const sId = window.__getServiceCanonId(svc);
      const title = window.__getServiceTitle(svc);
      const close = () => { window.__mainImageDecisionModalState = null; window.__triggerServicePipelineReRender(); };
      const isUnlockedPreview = Boolean(imgItem && window.__unlockedImageUrls && window.__unlockedImageUrls.has(imgItem.url));
      const submitDecision = async () => {
        const reason = document.getElementById("svc-main-img-reason-input")?.value?.trim();
        if (!reason || reason.length < 3) {
          state.error = `Please provide a valid reason for ${isApprove ? "approving" : "rejecting"} the main gallery image.`;
          window.__showServiceToast("Reason required for audit trail.", "warning");
          window.__triggerServicePipelineReRender();
          return;
        }
        const targetStatus = isApprove ? "approved" : "rejected";
        const imageIdentifier = imgItem.id || imgItem.url;
        close();
        await window.__setSingleImageReviewStatus(sId, imageIdentifier, targetStatus, reason);
      };
      return (
        <div
          onClick={close}
          className="no-screen-capture"
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.85)",
            zIndex: 16600,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
            backdropFilter: "blur(6px)",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#ffffff",
              borderRadius: 16,
              width: "min(480px, 100%)",
              overflow: "hidden",
              boxShadow: "0 25px 60px rgba(0,0,0,0.35)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                background: isApprove ? "linear-gradient(135deg, #16a34a 0%, #15803d 100%)" : "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
                padding: "16px 20px",
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 800 }}>
                {isApprove ? "✓ Confirm Main Gallery Image Approval" : "✕ Confirm Main Gallery Image Rejection"}
              </h3>
              <button onClick={close} style={{ background: "rgba(0,0,0,0.2)", border: "none", color: "#fff", borderRadius: "50%", width: 28, height: 28, cursor: "pointer" }}>✕</button>
            </div>
            <div style={{ padding: "20px 22px", display: "flex", flexDirection: "column", gap: 14 }}>
              <div style={{ fontSize: 13.5, color: "#1e293b", fontWeight: 700 }}>
                Are you sure you really want to {isApprove ? "APPROVE" : "REJECT"} the main gallery image?
              </div>
              <div style={{ fontSize: 12.5, color: "#475569" }}>
                Target Service: <strong>{title}</strong> (ID: <code>{sId}</code>)
              </div>
              {imgItem && (
                <div style={{ position: "relative", height: 110, borderRadius: 10, overflow: "hidden", background: "#0f172a" }}>
                  <img
                    src={imgItem.url}
                    alt=""
                    onContextMenu={(e) => e.preventDefault()}
                    style={{ width: "100%", height: "100%", objectFit: "cover", filter: isUnlockedPreview ? "none" : "blur(8px)" }}
                  />
                  {!isUnlockedPreview && (
                    <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(15,23,42,0.4)", color: "#fff", fontSize: 20 }}>
                      🔒
                    </div>
                  )}
                </div>
              )}
              <div>
                <label style={{ fontSize: 12, fontWeight: 700, color: "#1e293b", display: "block", marginBottom: 6 }}>
                  Why do you want to {isApprove ? "approve" : "reject"} this image? (Mandatory Reason) <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <textarea
                  id="svc-main-img-reason-input"
                  rows={3}
                  placeholder={isApprove ? "State why you are approving the main gallery image..." : "State the reason for rejecting the main gallery image..."}
                  style={{ width: "100%", padding: 10, borderRadius: 8, border: "1.5px solid #cbd5e1", fontSize: 13, boxSizing: "border-box" }}
                />
              </div>
              {state.error && (
                <div style={{ fontSize: 12, color: "#dc2626", fontWeight: 700, background: "#fee2e2", padding: "8px 12px", borderRadius: 8 }}>
                  ⚠️ {state.error}
                </div>
              )}
            </div>
            <div style={{ padding: "14px 22px", background: "#f8fafc", borderTop: "1px solid #e2e8f0", display: "flex", justifyContent: "flex-end", gap: 10 }}>
              <button
                type="button"
                onClick={close}
                style={{ padding: "8px 18px", borderRadius: 8, border: "1px solid #cbd5e1", background: "#ffffff", color: "#334155", fontWeight: 700, fontSize: 12, cursor: "pointer" }}
              >
                No, Cancel
              </button>
              <button
                type="button"
                onClick={submitDecision}
                style={{
                  padding: "8px 20px",
                  borderRadius: 8,
                  border: "none",
                  background: isApprove ? "#16a34a" : "#dc2626",
                  color: "#ffffff",
                  fontWeight: 800,
                  fontSize: 12,
                  cursor: "pointer",
                }}
              >
                Yes, {isApprove ? "Approve Main Image" : "Reject Main Image"}
              </button>
            </div>
          </div>
        </div>
      );
    })()}

    {/* ============================================================
        CRITICAL DRAG-AND-DROP TRANSITION CONFIRMATION MODAL
    ============================================================ */}
    {window.__serviceCriticalModalState?.open && (() => {
      const state = window.__serviceCriticalModalState;
      const svc = state.service;
      const title = window.__getServiceTitle(svc);
      const fromStage = state.fromStage;
      const toStage = state.toStage;
      const isApprovedToNew = state.isApprovedToNew;
      const close = () => { window.__serviceCriticalModalState = null; window.__triggerServicePipelineReRender(); };
      return (
        <div onClick={close} className="no-screen-capture" style={{ position: "fixed", inset: 0, background: "rgba(15, 23, 42, 0.85)", zIndex: 16000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, backdropFilter: "blur(6px)" }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: "#ffffff", borderRadius: 16, width: "min(520px, 100%)", overflow: "hidden", boxShadow: "0 25px 60px rgba(0,0,0,0.35)", display: "flex", flexDirection: "column" }}>
            <div style={{ background: isApprovedToNew ? "linear-gradient(135deg, #4338ca 0%, #312e81 100%)" : "linear-gradient(135deg, #d97706 0%, #b45309 100%)", padding: "16px 22px", color: "#ffffff", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 24 }}>{isApprovedToNew ? "🔐" : "⚠️"}</span>
                <h3 style={{ margin: 0, fontSize: 16, fontWeight: 800 }}>
                  {isApprovedToNew ? "Encrypted State Transition: Approved ➔ New Request" : "Do you really want to move service card?"}
                </h3>
              </div>
              <button onClick={close} style={{ background: "rgba(0,0,0,0.2)", border: "none", color: "#fff", borderRadius: "50%", width: 28, height: 28, cursor: "pointer" }}>✕</button>
            </div>
            <div style={{ padding: "18px 22px", display: "flex", flexDirection: "column", gap: 14 }}>
              <p style={{ fontSize: 13, color: "#334155", margin: 0 }}>
                You are transitioning <strong>{title}</strong> directly from <strong style={{ color: "#16a34a" }}>{fromStage}</strong> to <strong style={{ color: "#4f46e5" }}>{toStage}</strong>.
              </p>
              {isApprovedToNew && (
                <div style={{ fontSize: 12, color: "#1e1b4b", background: "#e0e7ff", border: "1px solid #c7d2fe", padding: "10px 12px", borderRadius: 8 }}>
                  🔒 <strong>Encrypted State Demotion Mechanism:</strong> This operation revokes verified service status, de-activates live public visibility across provider accounts, and stamps a tamper-evident cryptographic hash in the compliance audit trail. Mandatory compliance authorization passcode is required.
                </div>
              )}
              <div>
                <label style={{ fontSize: 12, fontWeight: 700, color: "#1e293b", display: "block", marginBottom: 6 }}>
                  Mandatory Audit Reason / Justification <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <textarea
                  id="svc-critical-reason"
                  rows={3}
                  placeholder={isApprovedToNew ? "State why you are demoting this approved service back to New Request..." : "State the compliance justification for this transition..."}
                  style={{ width: "100%", padding: 10, borderRadius: 8, border: "1.5px solid #cbd5e1", fontSize: 12.5, boxSizing: "border-box" }}
                />
              </div>
              <label style={{ display: "flex", alignItems: "flex-start", gap: 8, cursor: "pointer", fontSize: 12, color: "#334155" }}>
                <input type="checkbox" id="svc-critical-checkbox" style={{ marginTop: 2 }} />
                <span>I confirm that I have reviewed the media and attributes of this service request.</span>
              </label>
              <div>
                <label style={{ fontSize: 12, fontWeight: 700, color: "#1e293b", display: "block", marginBottom: 4 }}>
                  Authorization Passcode <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <input
                  type="password"
                  id="svc-critical-passcode"
                  placeholder="Enter compliance authorization key..."
                  style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: "1.5px solid #cbd5e1", fontSize: 13, boxSizing: "border-box" }}
                />
              </div>
              {state.error && (
                <div style={{ fontSize: 12, color: "#dc2626", fontWeight: 700, background: "#fee2e2", padding: "8px 12px", borderRadius: 8 }}>
                  ⚠️ {state.error}
                </div>
              )}
            </div>
            <div style={{ padding: "14px 22px", background: "#f8fafc", borderTop: "1px solid #e2e8f0", display: "flex", justifyContent: "flex-end", gap: 10 }}>
              <button onClick={close} style={{ padding: "8px 18px", borderRadius: 8, border: "1px solid #cbd5e1", background: "#ffffff", color: "#334155", fontWeight: 700, fontSize: 12, cursor: "pointer" }}>
                Cancel
              </button>
              <button
                onClick={async () => {
                  const reason = document.getElementById("svc-critical-reason")?.value?.trim();
                  const isChecked = document.getElementById("svc-critical-checkbox")?.checked;
                  const pass = document.getElementById("svc-critical-passcode")?.value?.trim();
                  if (!reason || reason.length < 5) {
                    state.error = "Please provide an audit justification (at least 5 characters).";
                    window.__showServiceToast("Audit justification is required.", "warning");
                    window.__triggerServicePipelineReRender();
                    return;
                  }
                  if (!isChecked) {
                    state.error = "You must confirm the review acknowledgment checkbox.";
                    window.__showServiceToast("Please check the confirmation acknowledgment.", "warning");
                    window.__triggerServicePipelineReRender();
                    return;
                  }
                  if (pass !== window.__SERVICE_PIPELINE_PASSCODE) {
                    state.error = "Incorrect Security Passcode. Access denied.";
                    window.__showServiceToast("Incorrect Security Passcode.", "error");
                    window.__triggerServicePipelineReRender();
                    return;
                  }
                  close();
                  if (typeof state.onConfirm === "function") {
                    await state.onConfirm(reason);
                  }
                }}
                style={{ padding: "8px 20px", borderRadius: 8, border: "none", background: isApprovedToNew ? "#4338ca" : "#16a34a", color: "#ffffff", fontWeight: 800, fontSize: 12, cursor: "pointer" }}
              >
                {isApprovedToNew ? "Authorize & Move to New Request" : "Yes, Confirm & Move Service"}
              </button>
            </div>
          </div>
        </div>
      );
    })()}

    {/* ============================================================
        SECURITY MODAL: ACTIONS PROHIBITED POPUP & OVERRIDE
    ============================================================ */}
    {window.__serviceSecurityViolationModalState?.open && (() => {
      const state = window.__serviceSecurityViolationModalState;
      const close = () => { window.__serviceSecurityViolationModalState = null; window.__triggerServicePipelineReRender(); };
      return (
        <div
          onClick={close}
          style={{ position: "fixed", inset: 0, background: "rgba(15, 23, 42, 0.94)", zIndex: 999999, display: "flex", alignItems: "center", justifyContent: "center", padding: 16, backdropFilter: "blur(12px)" }}
        >
          <div onClick={(e) => e.stopPropagation()} className="svc-security-alert-box" style={{ background: "#ffffff", borderRadius: 22, width: "min(500px, 94vw)", padding: "24px 22px", border: "2.5px solid #ef4444", textAlign: "center", boxSizing: "border-box" }}>
            <div style={{ fontSize: 44, marginBottom: 8 }}>🚫</div>
            <h3 style={{ margin: "0 0 10px 0", fontSize: 19, fontWeight: 900, color: "#b91c1c" }}>
              The actions are strictly prohibited
            </h3>
            <p style={{ fontSize: 13, color: "#334155", margin: "0 0 12px 0", lineHeight: 1.5 }}>
              Downloading images, capturing screenshots, printing, and executing screen recordings of sensitive service compliance records are strictly prohibited by statutory security audit policy.
            </p>
            <div style={{ background: "#fee2e2", border: "1px solid #fecaca", padding: "10px 12px", borderRadius: 8, fontSize: 12, color: "#991b1b", marginBottom: 16, fontWeight: 700 }}>
              ⚠️ Incident logged: <strong>{window.__safeText(state.action)}</strong> at {window.__safeText(state.timestamp)}
            </div>
            {!state.showOverrideGate ? (
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                <button
                  type="button"
                  onClick={close}
                  style={{ width: "100%", padding: "12px 20px", borderRadius: 12, border: "none", background: "#dc2626", color: "#ffffff", fontWeight: 800, fontSize: 13.5, cursor: "pointer" }}
                >
                  I Acknowledge & Understand
                </button>
                <button
                  type="button"
                  onClick={() => {
                    state.showOverrideGate = true;
                    window.__triggerServicePipelineReRender();
                  }}
                  style={{ background: "transparent", border: "1px dashed #cbd5e1", color: "#475569", padding: "8px 12px", borderRadius: 8, fontSize: 11.5, fontWeight: 700, cursor: "pointer" }}
                >
                  🔐 Compliance Officer Override (Authenticate with Passcode)
                </button>
              </div>
            ) : (
              <div style={{ background: "#f8fafc", padding: 14, borderRadius: 12, border: "1px solid #cbd5e1", textAlign: "left", marginTop: 10 }}>
                <div style={{ fontSize: 12.5, fontWeight: 700, color: "#0f172a", marginBottom: 6 }}>
                  Screen Recording & Screenshot Authorization Gate
                </div>
                <input
                  type="password"
                  id="svc-override-passcode-input"
                  placeholder="Enter compliance authorization passcode..."
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      const entered = document.getElementById("svc-override-passcode-input")?.value?.trim();
                      if (entered === window.__SERVICE_PIPELINE_PASSCODE) {
                        window.__svcSecurityOverrideActiveUntil = Date.now() + 60000;
                        const cb = state.onAuthorizeCallback;
                        window.__serviceSecurityViolationModalState = null;
                        if (typeof cb === "function") cb();
                        window.__showServiceToast("Compliance override granted for 60 seconds.", "success");
                        window.__triggerServicePipelineReRender();
                      } else {
                        state.overrideError = "Invalid Authorization Passcode. Access denied.";
                        window.__showServiceToast("Invalid compliance override passcode.", "error");
                        window.__triggerServicePipelineReRender();
                      }
                    }
                  }}
                  style={{ width: "100%", padding: "9px 12px", borderRadius: 8, border: "1.5px solid #cbd5e1", fontSize: 13, boxSizing: "border-box", marginBottom: 8 }}
                />
                {state.overrideError && (
                  <div style={{ fontSize: 11.5, color: "#dc2626", fontWeight: 700, marginBottom: 8 }}>
                    ⚠️ {state.overrideError}
                  </div>
                )}
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                  <button onClick={() => { state.showOverrideGate = false; window.__triggerServicePipelineReRender(); }} style={{ padding: "6px 12px", borderRadius: 6, border: "1px solid #cbd5e1", background: "#fff", cursor: "pointer" }}>Back</button>
                  <button
                    onClick={() => {
                      const entered = document.getElementById("svc-override-passcode-input")?.value?.trim();
                      if (entered === window.__SERVICE_PIPELINE_PASSCODE) {
                        window.__svcSecurityOverrideActiveUntil = Date.now() + 60000;
                        const cb = state.onAuthorizeCallback;
                        window.__serviceSecurityViolationModalState = null;
                        if (typeof cb === "function") cb();
                        window.__showServiceToast("Compliance override granted for 60 seconds.", "success");
                        window.__triggerServicePipelineReRender();
                      } else {
                        state.overrideError = "Invalid Authorization Passcode. Access denied.";
                        window.__showServiceToast("Invalid compliance override passcode.", "error");
                        window.__triggerServicePipelineReRender();
                      }
                    }}
                    style={{ padding: "6px 16px", borderRadius: 6, border: "none", background: "#1e40af", color: "#fff", fontWeight: 800, cursor: "pointer" }}
                  >
                    Authorize Action
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    })()}

    {/* ============================================================
        IMAGE PREVIEW MODAL: ZERO DOWNLOAD & WATERMARK SHIELD
    ============================================================ */}
    {Boolean(window.__servicePreviewModalState?.open || (typeof servicePreviewModal !== "undefined" && servicePreviewModal?.open)) && (() => {
      window.__isServiceMediaPreviewActive = true;
      const activeModal = window.__servicePreviewModalState?.open ? window.__servicePreviewModalState : servicePreviewModal;
      const imgItem = activeModal?.img;
      const parentSvc = activeModal?.service;
      const close = () => {
        window.__isServiceMediaPreviewActive = false;
        window.__servicePreviewModalState = null;
        if (typeof setServicePreviewModal === "function") {
          setServicePreviewModal({ open: false, img: null, service: null });
        }
        window.__triggerServicePipelineReRender();
      };
      return (
        <div
          onClick={close}
          className="no-screen-capture"
          onContextMenu={(e) => {
            e.preventDefault();
            window.__showServiceSecurityAlert("Preview Canvas Context Menu Prevented");
          }}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15,23,42,0.85)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 17000,
            padding: 24,
            backdropFilter: "blur(4px)",
          }}
        >
          <div onClick={(e) => e.stopPropagation()} style={{ background: "#ffffff", borderRadius: 16, width: "min(860px, 100%)", maxHeight: "88vh", display: "flex", flexDirection: "column", overflow: "hidden", position: "relative" }}>
            <div style={{ padding: "12px 20px", background: "#0f172a", color: "#ffffff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 18 }}>🔒</span>
                <strong style={{ fontSize: 14 }}>{window.__safeText(imgItem?.caption, "Protected Image Preview")}</strong>
              </div>
              <button onClick={close} style={{ background: "none", border: "none", color: "#ffffff", fontSize: 18, cursor: "pointer" }}>✕</button>
            </div>
            <div style={{ flex: 1, minHeight: 380, background: "#f1f5f9", position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <div className="svc-media-shield" />
              <img
                src={imgItem?.url || imgItem?.file}
                alt=""
                onContextMenu={(e) => e.preventDefault()}
                style={{ maxWidth: "100%", maxHeight: "65vh", objectFit: "contain", userSelect: "none" }}
              />
            </div>
            {imgItem && (
              <div style={{ padding: "10px 20px", background: "#ffffff", borderTop: "1px solid #e2e8f0", display: "flex", flexWrap: "wrap", gap: 14, fontSize: 11.5, color: "#334155" }}>
                <span>Image uploadedAt: <strong>{window.__formatPreciseTimestamp(imgItem.uploadedAt)}</strong></span>
                <span>Uploaded By: <strong>{window.__safeText(imgItem.uploadedBy || (parentSvc ? window.__getServiceProviderName(parentSvc) : "Unknown"))}</strong></span>
                <span>Reviewed By: <strong>{window.__getServiceReviewedByDisplay(imgItem, parentSvc)}</strong></span>
              </div>
            )}
            <div style={{ padding: "10px 20px", background: "#f8fafc", borderTop: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: 11, color: "#dc2626", fontWeight: 700 }}>
                ⚠️ Right-click, downloads, and screen recordings are strictly monitored and prohibited
              </span>
              <button onClick={close} style={{ padding: "6px 16px", borderRadius: 6, background: "#0f172a", color: "#ffffff", border: "none", fontWeight: 700, cursor: "pointer" }}>
                Close Preview
              </button>
            </div>
          </div>
        </div>
      );
    })()}
  </>
)}


{currentView === "marketingLedger" && (() => {
  /* ---------- Stable, cached-once component bundle ----------
     V19 Upgrade: Comprehensive multidimensional filtering across all views,
     dashboards, sub-tables, and modals (Customers, Bookings, Ledger, Audit,
     and Distribution). Preserves all Firestore, Stripe balance, and
     auto-settlement calculation logic with a modern fintech UI theme.
     V20: Settlement tiles (Service Price, Credit Used, Stripe Payment,
     Provider Payout, UG Revenue, Pending Ledger Impact) open focused views
     that show only data relevant to the clicked tile.
     V21: Credit redemption date + calendar filters, available/redeemed/expired
     credit visibility, provider payout vs Stripe reconciliation (extra payout
     deducted from Stripe balance), Stripe settlement endpoint, pending Stripe
     receipts / provider payouts, and a persistent Stripe settlement log.
     V22: Live Stripe balance now updates after every settlement (live balance
     is re-read from Stripe, with a safe projected fallback that is cleared as
     soon as Stripe reflects the movement). The original balance
     (£1,223,201.28) is preserved and persisted as the fixed reference, and the
     pending balance is shown consistently in the UI and the Stripe modal.
     V23: The Stripe balance shown in the UI is now the REMAINING balance
     (original balance + every settled movement from the persistent settlement
     log), and the headline figure additionally reserves pending provider
     payouts / receipts. Pending Stripe receipts, pending provider payouts and
     Pending Ledger Impact are computed from unsettled bookings (the
     "unsettled" status bug and the stored-credit-of-zero bug are fixed), and
     every settlement is pushed to the Stripe account via the settlement
     endpoint with the full remaining-balance payload.
     V23.1: postStripeSettlement now reports the REAL failure reason (HTTP
     status, Stripe's own message, or "route not found") and the failure note
     no longer blames "is the server running?". No other logic changed.
     V23.2 (FIX "Projected (Stripe not updated)"):
       - postStripeSettlement now also returns the backend's error `code`,
         `hint` and full body (insufficient balance, bad destination, etc.).
       - On `balance_insufficient` in TEST mode the dashboard asks the backend
         (POST /api/stripe/test-topup) to add exactly the missing funds to the
         Stripe AVAILABLE balance and retries the settlement once.
       - A backend reply of success with `stripeUpdated:false` (no provider
         Stripe account, so no transfer happened) is no longer shown as a
         Stripe success; the log/receipt says so explicitly.
       - The provider Stripe account id is now also looked up in the master
         "Booking" collection and under more field names.
       - Bundle cache key bumped (V23_2) so this code is picked up without a
         hard refresh. No other logic changed.
     V23.3 (FIX "Pending Ledger Impact = £0.00"):
       - Pending Ledger Impact = SUM of Credit Used (MIN(Service Price,
         Available Credit)) over all UNSETTLED bookings. It showed £0.00 when
         the customer's marketingAvailableCredits was 0 / missing (credit
         already deducted at checkout, or only marketingExistingCredits set)
         and the booking carried no positive stored creditUsed field.
       - Unsettled bookings now resolve their credit in this order:
           1) positive stored credit field on the booking (more key names read),
           2) credit IMPLIED by the booking itself = Service Price − stored
              Stripe/customer payment (when a payment amount is stored),
           3) formula MIN(Service Price, running customer available credit),
              where the available credit falls back to marketingExistingCredits
              when marketingAvailableCredits is 0.
       - Bundle cache key bumped (V23_3). No other logic changed.
     V23.4 (Credit Redeemed in reconciliation + UI-only Stripe shortfall):
       - "Credit Redeemed" is now part of the settlement calculation and
         reconciliation: Credit Redeemed (this settlement = Credit Used),
         previously redeemed total, and the new cumulative redeemed total.
         It is shown in the simulation card, the receipt, the booking audit,
         the Stripe settlement log, the Live Settlement Matrix (new tile with
         a focused view) and is sent in the Stripe settlement payload.
       - Every calculation is pushed to the REAL Stripe account (customer
         payment in, provider payout out, net movement, credit redeemed)
         EXCEPT the shortfall scenario. Example: £100 service + £30 credit =
         £70 customer Stripe payment; if the provider payout is £80, the extra
         £10 is deducted ONLY in the UI Stripe balance and is NOT sent to the
         Stripe account. The Stripe payload therefore carries the payout that
         the customer payment covers (MIN(payout, Stripe payment)) and the
         Stripe-only net; the extra amount is sent as `uiOnlyShortfall` for
         information only and is tracked separately in the settlement log.
       - Stripe sync checks compare the Stripe account against the Stripe-only
         expected balance (live balance + pushed net), not the UI balance, so a
         UI-only deduction never shows as a false sync gap.
       - Bundle cache key bumped (V23_4). Nothing else changed.
     V23.5 (Credit Used + Credit Redeemed in the Stripe Balance Engine):
       - The Stripe Balance Engine modal now shows "Credit Used" and
         "Credit Redeemed" next to the existing fields: two new balance cards
         (settled totals), new rows in the Settlement Reconciliation block
         (settled credit used / redeemed, pending credit on unsettled
         bookings, customer-record redeemed total), and a new "Credit Used"
         column in the Stripe Settlement Log (Credit Redeemed was already there).
       - Every settlement pushed to the Stripe account now also carries the
         cumulative Credit Used / Credit Redeemed totals (after this
         settlement), an `engineSnapshot` of the Stripe Balance Engine figures
         and a string-only `stripeMetadata` object (Stripe metadata values must
         be strings) so the backend can write the calculations onto the Stripe
         transfer / balance transaction. The settlement log stores the same
         cumulative totals. The UI-only shortfall rule from V23.4 is unchanged.
       - Bundle cache key bumped (V23_5). Nothing else changed.
     V23.6 (FIX Credit Used / Credit Redeemed accuracy on every board):
       - Credit Used = MIN(Service Price, Available Credit) over ALL bookings
         (settled + pending). Credit Redeemed = the credit that has actually
         been redeemed, i.e. Credit Used of SETTLED bookings only. Pending
         bookings now show Credit Redeemed £0.00 (their credit is only
         "pending ledger impact" until the booking is settled). Previously
         Credit Redeemed simply mirrored Credit Used for every booking.
       - A booking settled in this session keeps the exact credit that was
         used at settlement (session credit map). Before, right after
         settling, the board re-ran the formula against the customer's
         already-reduced balance and Credit Used / Redeemed dropped.
       - The settlement form now uses the SAME credit the boards use for the
         selected pending booking (stored / implied booking credit or the
         running available credit), so Credit Used on the form, receipt, log,
         Stripe payload and every board always match. Customer available
         credit falls back to marketingExistingCredits when it is 0.
       - "Redeemed On" dates are only set for settled bookings (pending
         bookings show "—"), so the customer "Last Redeemed" date and the
         redemption date filters are no longer polluted by pending bookings.
         The Credit Redeemed focused view lists settled bookings only.
       - Formula Integrity hint now reads Service Price = Credit Used +
         Stripe payment (the identity that is actually checked). The bookings
         badge row shows Credit Used / Redeemed side by side.
       - Bundle cache key bumped (V23_6). Nothing else changed. */
  if (!window.__MLD_BUNDLE_V23_6__) {
    window.__MLD_BUNDLE_V23_6__ = (function build() {
      const _useState = typeof useState !== "undefined" ? useState : React.useState;
      const _useEffect = typeof useEffect !== "undefined" ? useEffect : React.useEffect;
      const _useRef = typeof useRef !== "undefined" ? useRef : React.useRef;
      const _useMemo = typeof useMemo !== "undefined" ? useMemo : React.useMemo;
      /* ---------- Firebase handles (from parent scope) ---------- */
      const _db = typeof db !== "undefined" ? db : window.db;
      const _collection = typeof collection !== "undefined" ? collection : null;
      const _getDocs = typeof getDocs !== "undefined" ? getDocs : null;
      const _onSnapshot = typeof onSnapshot !== "undefined" ? onSnapshot : null;
      const _doc = typeof doc !== "undefined" ? doc : null;
      const _updateDoc = typeof updateDoc !== "undefined" ? updateDoc : null;
      const _increment = typeof increment !== "undefined" ? increment : null;
      const _addDoc = typeof addDoc !== "undefined" ? addDoc : null;
      /* ---------- Firestore locations ---------- */
      const CUSTOMERS_COLLECTION = "users";
      const BOOKINGS_SUBCOLLECTION = "MyBooking";
      const BOOKING_COLLECTION = "Booking";
      const SETTLEMENT_LOG_COLLECTION = "SettlementLogs";
      const PAYOUT_KEYS = [
        "provider_payout_amount", "providerPayoutAmount", "providerPayout", "provider_payout",
        "providerAmount", "providerEarning", "providerEarnings", "providerShare", "providerPayoutObligation",
        "provider_payout_obligation", "provider_amount", "payoutAmount", "payout_amount", "provider_earning",
        "providerNetAmount", "vendorPayout", "vendor_payout", "providerFee",
      ];
      const BOOKING_CUSTOMER_KEYS = [
        "customerId", "customer_id", "userId", "user_id", "uid", "customerUid", "customer_uid", "customerDocId",
      ];
      /* FIX V23.2: provider Stripe connected-account id may live under several field names */
      const PROVIDER_ACCOUNT_KEYS = [
        "providerStripeAccountId", "stripeAccountId", "providerAccountId",
        "provider_stripe_account_id", "stripe_account_id", "connectedAccountId",
        "providerConnectAccountId", "stripeConnectId",
      ];
      /* ---------- Stripe Backend API Endpoints ---------- */
      const STRIPE_BALANCE_ENDPOINT =
        window.__STRIPE_BALANCE_URL__ || "http://localhost:5000/api/stripe/balance";
      const STRIPE_SETTLEMENT_ENDPOINT =
        window.__STRIPE_SETTLEMENT_URL__ || "http://localhost:5000/api/stripe/settlement";
      /* FIX V23.2: test-mode top-up route (adds real test funds to the Stripe AVAILABLE balance) */
      const STRIPE_TOPUP_ENDPOINT =
        window.__STRIPE_TOPUP_URL__ ||
        STRIPE_SETTLEMENT_ENDPOINT.replace(/\/settlement\/?$/, "/test-topup");
      /* ---------- Original Stripe balance (fixed reference, never overwritten by live updates) ---------- */
      const STRIPE_ORIGINAL_BALANCE_DEFAULT = 1223201.28;
      const STRIPE_ORIGINAL_STORAGE_KEY = "__MLD_STRIPE_ORIGINAL_BALANCE__";
      const readOriginalStripeBalance = () => {
        try {
          const s = window.localStorage.getItem(STRIPE_ORIGINAL_STORAGE_KEY);
          const n = parseFloat(s);
          if (s !== null && !isNaN(n)) return n;
        } catch (e) {}
        const w = parseFloat(window.__STRIPE_ORIGINAL_BALANCE__);
        return !isNaN(w) ? w : STRIPE_ORIGINAL_BALANCE_DEFAULT;
      };
      const persistOriginalStripeBalance = (n) => {
        try {
          if (window.localStorage.getItem(STRIPE_ORIGINAL_STORAGE_KEY) === null) {
            window.localStorage.setItem(STRIPE_ORIGINAL_STORAGE_KEY, String(n));
          }
        } catch (e) {}
      };
      /* ---------- Helpers & Formatters ---------- */
      const gbp = (n) => {
        const v = Number(n || 0);
        return (
          (v < 0 ? "-" : "") +
          "£" +
          Math.abs(v).toLocaleString("en-GB", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
      };
      const nowLabel = () =>
        new Date()
          .toLocaleString("en-US", {
            month: "short",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })
          .replace(/,([^,]*)$/, "$1")
          .replace(" at ", " ");
      const parseNum = (val) => {
        if (typeof val === "number") return isNaN(val) ? 0 : val;
        if (typeof val === "string") {
          const clean = val.replace(/[^0-9.-]/g, "");
          const n = parseFloat(clean);
          return isNaN(n) ? 0 : n;
        }
        return 0;
      };
      const pick = (obj, keys) => {
        for (const k of keys) {
          if (obj && obj[k] !== undefined && obj[k] !== null && obj[k] !== "") return obj[k];
        }
        return undefined;
      };
      const toMillis = (v) => {
        if (!v) return 0;
        if (typeof v.toMillis === "function") return v.toMillis();
        if (typeof v.toDate === "function") return v.toDate().getTime();
        if (typeof v === "object" && typeof v.seconds === "number") return v.seconds * 1000;
        const t = new Date(v).getTime();
        return isNaN(t) ? 0 : t;
      };
      const dateLabelOf = (ms, fallback) =>
        ms
          ? new Date(ms).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
          : fallback
          ? String(fallback)
          : "—";
      const dateInputToMs = (s, endOfDay) => {
        if (!s) return null;
        const t = new Date(s + (endOfDay ? "T23:59:59.999" : "T00:00:00")).getTime();
        return isNaN(t) ? null : t;
      };
      /* ---------- Settlement formula ---------- */
      function calcSettlement({ servicePrice, availableCredit, providerObligation, prevLedgerBalance, prevCreditRedeemed }) {
        const sp = Math.max(0, parseNum(servicePrice));
        const avail = Math.max(0, parseNum(availableCredit));
        const creditUsed = Math.min(sp, avail);
        const customerPayment = Math.max(0, sp - creditUsed);
        const providerPayout = Math.max(0, parseNum(providerObligation));
        const prev = parseNum(prevLedgerBalance);
        const prevRedeemed = Math.max(0, parseNum(prevCreditRedeemed));
        const stripePayment = customerPayment;
        /* V23.4: the part of the provider payout that the customer's Stripe payment covers.
           Only this part is a real movement in the Stripe account. */
        const stripePayoutPushed = Math.min(providerPayout, stripePayment);
        /* V23.4: extra payout beyond the customer payment is deducted in the UI Stripe balance ONLY */
        const stripeUiOnly = Math.max(0, providerPayout - stripePayment);
        return {
          servicePrice: sp,
          availableCredit: avail,
          creditUsed,
          /* V23.4: Credit Redeemed in this settlement = credit used on the booking */
          creditRedeemed: creditUsed,
          prevCreditRedeemed: prevRedeemed,
          finalCreditRedeemed: prevRedeemed + creditUsed,
          customerPayment,
          stripePayment,
          providerPayout,
          ledgerDeduction: creditUsed,
          prevLedgerBalance: prev,
          finalLedgerBalance: prev - creditUsed,
          ugRevenue: Math.max(0, sp - providerPayout),
          ugRevenueRaw: sp - providerPayout,
          /* Stripe in (customer card) minus Stripe out (provider payout) — UI balance movement */
          stripeNet: stripePayment - providerPayout,
          /* Extra amount the provider payout takes from existing Stripe balance (UI balance only) */
          stripeShortfall: Math.max(0, providerPayout - stripePayment),
          /* V23.4: movement that is really pushed to the Stripe account */
          stripePayoutPushed,
          stripeNetPushed: stripePayment - stripePayoutPushed,
          stripeUiOnly,
        };
      }
      /* ---------- Booking normaliser ---------- */
      function normalizeBooking(docId, data, masterData) {
        const d = data || {};
        const customerTotalAmount = parseNum(
          pick(d, [
            "customerTotalAmount", "customer_total_amount", "totalAmount", "total_amount",
            "total", "servicePrice", "service_price", "grandTotal", "price", "amount",
          ])
        );
        const masterPayoutRaw = masterData ? pick(masterData, PAYOUT_KEYS) : undefined;
        const ownPayoutRaw = pick(d, PAYOUT_KEYS);
        let providerPayout = parseNum(masterPayoutRaw !== undefined ? masterPayoutRaw : ownPayoutRaw);
        let payoutSource =
          masterPayoutRaw !== undefined ? "Booking collection" : ownPayoutRaw !== undefined ? "MyBooking" : "Not found";
        /* FIX V23.3: read more possible field names for the credit applied on the booking */
        const creditRaw = pick(d, [
          "creditUsed", "marketingCreditUsed", "creditApplied", "creditsUsed",
          "marketingCreditsUsed", "credit_used", "marketingCreditApplied",
          "marketing_credit_used", "creditRedeemed", "redeemedCredit", "marketingCreditDeducted",
        ]);
        const creditUsed = parseNum(creditRaw);
        const ugRaw = pick(d, [
          "ugRevenue", "ug_revenue", "UGRevenue", "platformRevenue", "platformFee",
          "commission", "adminCommission",
        ]);
        /* Payout missing but platform revenue known -> payout = price - UG revenue */
        if (providerPayout <= 0 && ugRaw !== undefined && customerTotalAmount > 0) {
          const derived = Math.max(0, customerTotalAmount - parseNum(ugRaw));
          if (derived > 0) {
            providerPayout = derived;
            payoutSource = "Derived (price − UG revenue)";
          }
        }
        const ugRevenue = ugRaw !== undefined ? parseNum(ugRaw) : Math.max(0, customerTotalAmount - providerPayout);
        const stripeRaw = pick(d, ["stripePayment", "stripeAmount", "amountPaid", "paidAmount", "customerPayment"]);
        const stripePayment = stripeRaw !== undefined ? parseNum(stripeRaw) : Math.max(0, customerTotalAmount - creditUsed);
        /* FIX V23.3: credit implied by the booking itself (Service Price − what the customer actually paid).
           Only meaningful when a payment amount is really stored on the booking. */
        const hasStripeData = stripeRaw !== undefined;
        const impliedCredit = hasStripeData ? Math.max(0, customerTotalAmount - stripePayment) : 0;
        const dateRaw = pick(d, ["bookingDate", "date", "scheduledAt", "createdAt", "created_at", "timestamp"]);
        const dateMs = toMillis(dateRaw);
        /* FIX V23.6: settled flag is resolved first, because a "redeemed on" date only exists for SETTLED bookings */
        const settled =
          d.settled === true ||
          d.marketingSettled === true ||
          /^\s*(?!un|not|pending)(settled|reconciled|completed settlement)/i.test(String(d.settlementStatus || ""));
        const redeemedRaw = pick(d, ["creditRedeemedAt", "redeemedAt", "creditRedeemedDate", "settledAt"]);
        const redeemedMs = toMillis(redeemedRaw) || (settled && creditUsed > 0 ? dateMs : 0);
        /* FIX V23.2: look in MyBooking first, then in the master Booking collection, under more field names */
        const providerAccountId =
          pick(d, PROVIDER_ACCOUNT_KEYS) ?? (masterData ? pick(masterData, PROVIDER_ACCOUNT_KEYS) : undefined);
        return {
          docId: String(docId),
          bookingId: String(pick(d, ["bookingId", "booking_id", "bookingID"]) ?? docId),
          customerTotalAmount,
          providerPayout,
          payoutSource,
          ugRevenue,
          creditUsed,
          hasCreditData: creditRaw !== undefined,
          stripePayment,
          hasStripeData,
          impliedCredit,
          serviceName: String(pick(d, ["serviceName", "service", "serviceTitle", "category", "serviceCategory"]) ?? "—"),
          providerName: String(pick(d, ["providerName", "provider", "providerDisplayName", "providerFullName"]) ?? "—"),
          status: String(pick(d, ["status", "bookingStatus", "booking_status"]) ?? "Pending"),
          dateMs,
          dateLabel: dateLabelOf(dateMs, typeof dateRaw === "string" ? dateRaw : ""),
          redeemedMs,
          redeemedLabel: dateLabelOf(redeemedMs, ""),
          providerAccountId: providerAccountId ? String(providerAccountId) : "",
          settled,
        };
      }
      /* ---------- Master "Booking" collection scanner ---------- */
      async function fetchBookingMaster() {
        const byKey = {};
        const add = (key, data) => {
          const k = String(key ?? "").trim();
          if (!k) return;
          (byKey[k] = byKey[k] || []).push(data);
        };
        const ingest = (snap) => {
          snap.forEach((d) => {
            const data = d.data() || {};
            add(d.id, data);
            const fieldId = pick(data, ["bookingId", "booking_id", "bookingID"]);
            if (fieldId !== undefined && String(fieldId) !== d.id) add(fieldId, data);
          });
        };
        try {
          if (_db && _collection && _getDocs) {
            ingest(await _getDocs(_collection(_db, BOOKING_COLLECTION)));
          } else if (window.firebase && window.firebase.firestore) {
            ingest(await window.firebase.firestore().collection(BOOKING_COLLECTION).get());
          }
        } catch (e) {
          console.warn(`Could not read "${BOOKING_COLLECTION}" collection:`, e);
        }
        return { byKey };
      }
      function resolveMasterBooking(master, customerId, bookingDocId, bookingFieldId) {
        if (!master || !master.byKey) return null;
        const cands = [...(master.byKey[bookingDocId] || []), ...(master.byKey[bookingFieldId] || [])];
        const cid = String(customerId || "").trim();
        for (const c of cands) {
          const owner = pick(c, BOOKING_CUSTOMER_KEYS);
          if (owner !== undefined && String(owner).trim() === cid) return c;
        }
        for (const c of cands) {
          if (pick(c, BOOKING_CUSTOMER_KEYS) === undefined) return c;
        }
        return null;
      }
      /* ---------- Subcollection Scanner: users/{docId}/MyBooking ---------- */
      async function scanCustomerBookingDetails(userId, master) {
        if (!userId) return [];
        const toList = (snap) => {
          const list = [];
          snap.forEach((d) => {
            const data = d.data() || {};
            const fieldId = pick(data, ["bookingId", "booking_id", "bookingID"]);
            const masterData = resolveMasterBooking(master, userId, d.id, fieldId !== undefined ? String(fieldId) : d.id);
            list.push(normalizeBooking(d.id, data, masterData));
          });
          list.sort((a, b) => (a.dateMs || 0) - (b.dateMs || 0));
          return list;
        };
        try {
          if (_db && _collection && _getDocs) {
            const snap = await _getDocs(_collection(_db, CUSTOMERS_COLLECTION, userId, BOOKINGS_SUBCOLLECTION));
            return toList(snap);
          }
          if (window.firebase && window.firebase.firestore) {
            const snap = await window.firebase.firestore()
              .collection(CUSTOMERS_COLLECTION)
              .doc(userId)
              .collection(BOOKINGS_SUBCOLLECTION)
              .get();
            return toList(snap);
          }
        } catch (e) {
          console.warn(`Could not read MyBooking subcollection for customer ${userId}:`, e);
        }
        return [];
      }
      function buildCustomerPayload(docs, bookingsMap = {}) {
        const customers = [];
        let otherRoles = 0;
        let totalAvailableCredits = 0;
        let totalExistingCredits = 0;
        let totalLifetimeIssued = 0;
        let totalSpentCredits = 0;
        let totalCreditAllocated = 0;
        let totalCreditExpired = 0;
        let totalCreditRedeemed = 0;
        let totalCreditsRedeemedCount = 0;
        let totalBookingsCount = 0;
        const allBookings = [];
        docs.forEach((u) => {
          const docId = String(u.id || "").trim();
          let rawRole = String(u.role ?? "").trim().toLowerCase();
          if (rawRole === "user") rawRole = "customer";
          const customerName =
            String(
              u.User_name ?? u.user_name ?? u.userName ?? u.customerName ??
                u.fullName ?? u.name ?? u.displayName ?? ""
            ).trim() ||
            String(u.customerEmail || u.email || "").trim() ||
            docId;
          const phone = String(u.phone ?? u.phoneNumber ?? u.mobile ?? u.contactNumber ?? "").trim();
          const location = String(u.city ?? u.location ?? u.address ?? "").trim();
          const createdAt = u.createdAt
            ? u.createdAt.toDate
              ? u.createdAt.toDate().toLocaleDateString("en-GB")
              : String(u.createdAt)
            : u.created_at || u.joinedAt || "—";
          const marketingAvailableCredits = parseNum(
            u.marketingAvailableCredits ?? u.marketing_available_credits ?? u.availableCredits ?? u.marketingExistingCredits
          );
          const marketingExistingCredits = parseNum(
            u.marketingExistingCredits ?? u.marketing_existing_credits ?? u.existingCredits ?? u.marketingAvailableCredits
          );
          const marketingLifetimeIssued = parseNum(
            u.marketingLifetimeIssued ?? u.marketing_lifetime_issued ?? u.lifetimeIssued
          );
          const rawTotalSpent = parseNum(
            u.marketingTotalSpent ?? u.marketing_total_spent ?? u.totalSpent
          );
          const marketingTotalSpent =
            rawTotalSpent > 0
              ? rawTotalSpent
              : Math.max(0, marketingLifetimeIssued - (marketingAvailableCredits || marketingExistingCredits));

          const marketingCreditAllocated = parseNum(
            u.marketingCreditAllocated ?? u.marketing_credit_allocated ?? u.creditAllocated ?? u.allocatedCredits
          );
          const marketingCreditExpired = parseNum(
            u.marketingCreditExpired ?? u.marketing_credit_expired ?? u.creditExpired ?? u.expiredCredits
          );
          const marketingCreditRedeemed = parseNum(
            u.marketingCreditRedeemed ?? u.marketing_credit_redeemed ?? u.creditRedeemed ?? u.redeemedCredits
          );
          const marketingCreditsRedeemedCount = parseNum(
            u.marketingCreditsRedeemedCount ?? u.marketing_credits_redeemed_count ?? u.creditsRedeemedCount ?? u.redeemedCount
          );
          const rawBookingList = Array.isArray(bookingsMap[docId]) ? bookingsMap[docId] : null;
          const bookingList = (rawBookingList || []).map((b) => ({
            ...b,
            customerId: docId,
            customerName,
            customerEmail: u.customerEmail || u.email || "—",
            key: docId + "::" + b.docId,
          }));
          const bookingsCount =
            rawBookingList && rawBookingList.length > 0
              ? rawBookingList.length
              : parseNum(u.myBookingsCount || u.bookingsCount || 0);
          const isCustomer = rawRole === "" || rawRole === "customer";
          const hasCredits =
            marketingAvailableCredits > 0 ||
            marketingExistingCredits > 0 ||
            marketingLifetimeIssued > 0 ||
            marketingTotalSpent > 0 ||
            marketingCreditAllocated > 0 ||
            marketingCreditExpired > 0 ||
            marketingCreditRedeemed > 0 ||
            marketingCreditsRedeemedCount > 0 ||
            bookingsCount > 0;
          if (!isCustomer && !hasCredits) {
            otherRoles++;
            return;
          }
          totalAvailableCredits += marketingAvailableCredits;
          totalExistingCredits += marketingExistingCredits;
          totalLifetimeIssued += marketingLifetimeIssued;
          totalSpentCredits += marketingTotalSpent;
          totalCreditAllocated += marketingCreditAllocated;
          totalCreditExpired += marketingCreditExpired;
          totalCreditRedeemed += marketingCreditRedeemed;
          totalCreditsRedeemedCount += marketingCreditsRedeemedCount;
          totalBookingsCount += bookingsCount;
          allBookings.push(...bookingList);
          const lastRedeemedMs = Math.max(
            toMillis(u.marketingLastRedeemedAt ?? u.lastRedeemedAt),
            ...bookingList.map((b) => b.redeemedMs || 0),
            0
          );
          customers.push({
            id: docId,
            customerName,
            email: u.customerEmail || u.email || "—",
            phone: phone || "—",
            location: location || "—",
            role: rawRole || "customer",
            createdAt,
            marketingAvailableCredits,
            marketingExistingCredits,
            marketingLifetimeIssued,
            marketingTotalSpent,
            marketingSpent: marketingTotalSpent,
            marketingCreditAllocated,
            marketingCreditExpired,
            marketingCreditRedeemed,
            marketingCreditsRedeemedCount,
            lastRedeemedMs,
            lastRedeemedLabel: dateLabelOf(lastRedeemedMs, ""),
            bookingsCount,
            bookings: bookingList,
          });
        });
        customers.sort((a, b) => a.customerName.localeCompare(b.customerName));
        allBookings.sort((a, b) => (b.dateMs || 0) - (a.dateMs || 0));
        const totalCredits = Math.max(
          totalLifetimeIssued,
          totalCreditAllocated > 0 ? totalCreditAllocated : totalAvailableCredits + totalSpentCredits
        );
        const totalSpent = totalSpentCredits;
        const totalAvailable = totalAvailableCredits > 0 ? totalAvailableCredits : totalExistingCredits;
        return {
          count: customers.length,
          totalDocs: docs.length,
          otherRoles,
          totalAvailableCredits: totalAvailable,
          totalExistingCredits,
          totalLifetimeIssued,
          totalCredits,
          totalSpent,
          totalCreditAllocated,
          totalCreditExpired,
          totalCreditRedeemed,
          totalCreditsRedeemedCount,
          totalBookingsCount,
          allBookings,
          customers,
        };
      }
      async function scanAllUserBookings(docs) {
        const bookingsMap = {};
        const master = await fetchBookingMaster();
        const promises = docs.map(async (d) => {
          const docId = String(d.id || "").trim();
          if (docId) {
            bookingsMap[docId] = await scanCustomerBookingDetails(docId, master);
          }
        });
        await Promise.all(promises);
        return bookingsMap;
      }
      async function fetchCustomers() {
        const docs = [];
        if (_db && _collection && _getDocs) {
          const snap = await _getDocs(_collection(_db, CUSTOMERS_COLLECTION));
          snap.forEach((d) => docs.push({ id: d.id, ...d.data() }));
        } else if (window.firebase && window.firebase.firestore) {
          const snap = await window.firebase.firestore().collection(CUSTOMERS_COLLECTION).get();
          snap.forEach((d) => docs.push({ id: d.id, ...d.data() }));
        } else {
          throw new Error("Firebase db / collection / getDocs not found in scope");
        }
        const bookingsMap = await scanAllUserBookings(docs);
        return buildCustomerPayload(docs, bookingsMap);
      }
      function subscribeCustomers(onData, onError) {
        let cachedBookings = {};
        const handle = async (snap) => {
          const docs = [];
          snap.forEach((d) => docs.push({ id: d.id, ...d.data() }));
          onData(buildCustomerPayload(docs, cachedBookings));
          try {
            const bookingsMap = await scanAllUserBookings(docs);
            cachedBookings = bookingsMap;
            onData(buildCustomerPayload(docs, bookingsMap));
          } catch (e) {
            console.warn("Error refreshing MyBooking subcollections:", e);
          }
        };
        if (_db && _collection && _onSnapshot) {
          return _onSnapshot(_collection(_db, CUSTOMERS_COLLECTION), handle, onError);
        }
        if (window.firebase && window.firebase.firestore) {
          return window.firebase.firestore().collection(CUSTOMERS_COLLECTION).onSnapshot(handle, onError);
        }
        onError(new Error("Firebase db / collection / onSnapshot not found in scope"));
        return () => {};
      }
      async function addCreditToCustomer(id, amt) {
        if (_db && _doc && _updateDoc && _increment) {
          return _updateDoc(_doc(_db, CUSTOMERS_COLLECTION, id), {
            marketingAvailableCredits: _increment(amt),
            marketingExistingCredits: _increment(amt),
            marketingLifetimeIssued: _increment(amt),
            marketingCreditAllocated: _increment(amt),
          });
        }
        if (window.firebase && window.firebase.firestore) {
          const F = window.firebase.firestore;
          return F().collection(CUSTOMERS_COLLECTION).doc(id).update({
            marketingAvailableCredits: F.FieldValue.increment(amt),
            marketingExistingCredits: F.FieldValue.increment(amt),
            marketingLifetimeIssued: F.FieldValue.increment(amt),
            marketingCreditAllocated: F.FieldValue.increment(amt),
          });
        }
        throw new Error("Firebase doc / updateDoc / increment not found in scope");
      }
      async function recordBookingSettlement(id, creditUsed) {
        if (creditUsed <= 0) return;
        if (_db && _doc && _updateDoc && _increment) {
          return _updateDoc(_doc(_db, CUSTOMERS_COLLECTION, id), {
            marketingAvailableCredits: _increment(-creditUsed),
            marketingExistingCredits: _increment(-creditUsed),
            marketingTotalSpent: _increment(creditUsed),
            marketingCreditRedeemed: _increment(creditUsed),
            marketingCreditsRedeemedCount: _increment(1),
            marketingLastRedeemedAt: new Date(),
          });
        }
        if (window.firebase && window.firebase.firestore) {
          const F = window.firebase.firestore;
          return F().collection(CUSTOMERS_COLLECTION).doc(id).update({
            marketingAvailableCredits: F.FieldValue.increment(-creditUsed),
            marketingExistingCredits: F.FieldValue.increment(-creditUsed),
            marketingTotalSpent: F.FieldValue.increment(creditUsed),
            marketingCreditRedeemed: F.FieldValue.increment(creditUsed),
            marketingCreditsRedeemedCount: F.FieldValue.increment(1),
            marketingLastRedeemedAt: new Date(),
          });
        }
        throw new Error("Firebase doc / updateDoc / increment not found in scope");
      }
      async function markBookingSettled(customerId, bookingDocId, s) {
        if (!customerId || !bookingDocId) return;
        const payload = {
          settled: true,
          settlementStatus: "settled",
          creditUsed: s.creditUsed,
          creditRedeemed: s.creditRedeemed !== undefined ? s.creditRedeemed : s.creditUsed,
          stripePayment: s.stripePayment,
          providerPayout: s.providerPayout,
          ugRevenue: s.ugRevenue,
          marketingLedgerDeduction: s.ledgerDeduction,
          creditRedeemedAt: new Date(),
          stripeNet: s.stripeNet,
          stripeShortfall: s.stripeShortfall,
          providerPaidFromStripe: s.providerPayoutPushed !== undefined ? s.providerPayoutPushed : s.providerPayout,
        };
        if (_db && _doc && _updateDoc) {
          return _updateDoc(_doc(_db, CUSTOMERS_COLLECTION, customerId, BOOKINGS_SUBCOLLECTION, bookingDocId), payload);
        }
        if (window.firebase && window.firebase.firestore) {
          return window.firebase.firestore()
            .collection(CUSTOMERS_COLLECTION)
            .doc(customerId)
            .collection(BOOKINGS_SUBCOLLECTION)
            .doc(bookingDocId)
            .update(payload);
        }
      }
      async function fetchStripeBalancePayload() {
        let balanceResponse;
        try {
          /* cache-bust so the live balance is always re-read from Stripe after a settlement */
          const sep = STRIPE_BALANCE_ENDPOINT.includes("?") ? "&" : "?";
          balanceResponse = await fetch(STRIPE_BALANCE_ENDPOINT + sep + "_ts=" + Date.now(), { cache: "no-store" });
        } catch (netErr) {
          throw new Error("Cannot connect to backend server at http://localhost:5000");
        }
        const balancePayload = await balanceResponse.json();
        if (!balanceResponse.ok || !balancePayload.success) {
          throw new Error(balancePayload.message || "Unable to retrieve Stripe account balance");
        }
        return balancePayload;
      }
      /* Ask the backend to move the provider payout out of the Stripe balance.
         V23.1: returns the REAL failure reason (Stripe's message, HTTP status, or route-not-found).
         V23.2: also returns the backend `code`, `hint` (appended to the message) and the full body. */
      async function postStripeSettlement(payload) {
        let res;
        try {
          res = await fetch(STRIPE_SETTLEMENT_ENDPOINT, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          });
        } catch (e) {
          return { ok: false, message: "Cannot reach Stripe settlement endpoint (server down or CORS blocked)" };
        }
        let body = {};
        let raw = "";
        try {
          raw = await res.text();
          body = raw ? JSON.parse(raw) : {};
        } catch (e) {
          body = {};
        }
        if (!res.ok || body.success === false) {
          const base =
            body.message ||
            (res.status === 404
              ? "Route POST /api/stripe/settlement was not found on the backend (restart server.js with the new route)"
              : `Backend returned HTTP ${res.status}${raw && !raw.trim().startsWith("<") ? ": " + raw.slice(0, 160) : ""}`);
          const reason = body.hint ? `${base} — ${body.hint}` : base;
          return { ok: false, message: reason, code: body.code || null, body };
        }
        return { ok: true, body };
      }
      /* V23.2: TEST-MODE ONLY. Ask the backend to add funds (minor units) to the Stripe AVAILABLE balance. */
      async function topUpStripeTestBalance(amountMinor) {
        try {
          const res = await fetch(STRIPE_TOPUP_ENDPOINT, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ amount: Math.round(amountMinor) }),
          });
          const body = await res.json().catch(() => ({}));
          return res.ok && body.success !== false;
        } catch (e) {
          return false;
        }
      }
      async function writeSettlementLog(entry) {
        try {
          if (_db && _collection && _addDoc) return await _addDoc(_collection(_db, SETTLEMENT_LOG_COLLECTION), entry);
          if (window.firebase && window.firebase.firestore) {
            return await window.firebase.firestore().collection(SETTLEMENT_LOG_COLLECTION).add(entry);
          }
        } catch (e) {
          console.warn("Could not write settlement log:", e);
        }
      }
      async function fetchSettlementLogs() {
        try {
          let snap;
          if (_db && _collection && _getDocs) snap = await _getDocs(_collection(_db, SETTLEMENT_LOG_COLLECTION));
          else if (window.firebase && window.firebase.firestore) {
            snap = await window.firebase.firestore().collection(SETTLEMENT_LOG_COLLECTION).get();
          } else return [];
          const list = [];
          snap.forEach((d) => list.push({ id: d.id, ...d.data() }));
          list.sort((a, b) => (b.tsMs || 0) - (a.tsMs || 0));
          return list.slice(0, 5000);
        } catch (e) {
          console.warn("Could not read settlement logs:", e);
          return [];
        }
      }
      /* ---------- Datasets & Initial State ---------- */
      const RANGES = {
        "7D": {
          label: "Last 7 days",
          sub: "Sep 24 – Sep 30",
          x: ["Sep 24", "Sep 25", "Sep 26", "Sep 27", "Sep 28", "Sep 29", "Sep 30"],
          d: [
            [7600, 7900, 8100, 8300, 8600, 8800, 9000],
            [4300, 4500, 4700, 4900, 5100, 5300, 5400],
            [2500, 2600, 2700, 2800, 2900, 3000, 3100],
          ],
        },
        "30D": {
          label: "Last 30 days",
          sub: "Sep 1 – Sep 30",
          x: ["Sep 1", "Sep 5", "Sep 10", "Sep 15", "Sep 20", "Sep 25", "Sep 30"],
          d: [
            [3300, 4700, 5900, 6300, 7200, 7600, 9000],
            [1400, 2600, 3200, 3700, 4600, 4600, 5400],
            [600, 1500, 1900, 2100, 2300, 2600, 3100],
          ],
        },
        "90D": {
          label: "Last 90 days",
          sub: "Jul 3 – Sep 30",
          x: ["Jul 3", "Jul 22", "Aug 10", "Aug 29", "Sep 10", "Sep 20", "Sep 30"],
          d: [
            [1200, 2600, 4100, 5600, 7000, 8100, 9000],
            [500, 1400, 2300, 3200, 4200, 4900, 5400],
            [300, 800, 1200, 1700, 2200, 2700, 3100],
          ],
        },
      };
      const LINES = [
        ["Earned Credits", "#10b981"],
        ["Spent Credits", "#3b82f6"],
        ["Balance Credits", "#8b5cf6"],
      ];
      const DIST0 = [
        { n: "Provider Promotions", v: 2000, c: "#2563eb" },
        { n: "Customer Referrals", v: 1200, c: "#10b981" },
        { n: "Campaign Rewards", v: 800, c: "#f59e0b" },
        { n: "Refunds", v: 600, c: "#8b5cf6" },
        { n: "Others", v: 400, c: "#64748b" },
      ];
      const ENTRIES0 = [
        { id: 5, d: "Sep 28, 2025 10:24 AM", t: "Credit", desc: "Campaign bonus", rel: "Summer Campaign", a: 100, b: 3150, title: "Campaign Credit", sub: "Marketing campaign bonus", i: "🎁" },
        { id: 4, d: "Sep 27, 2025 04:12 PM", t: "Debit", desc: "Provider payout", rel: "Rahul Kumar (Plumber)", a: -80, b: 3050, title: "Provider Payout", sub: "Provider incentive", i: "👥" },
        { id: 3, d: "Sep 26, 2025 11:34 AM", t: "Credit", desc: "Referral reward", rel: "Customer Referral", a: 50, b: 3130, title: "Customer Referral", sub: "Referral reward", i: "➜" },
        { id: 2, d: "Sep 25, 2025 02:20 PM", t: "Debit", desc: "Ad campaign cost", rel: "Google Ads", a: -150, b: 3080, title: "Campaign Spend", sub: "Ad campaign cost", i: "📣" },
        { id: 1, d: "Sep 24, 2025 09:15 AM", t: "Credit", desc: "Refund adjustment", rel: "Booking #UG12345", a: 40, b: 3230, title: "Refund Adjustment", sub: "Customer refund credit", i: "↻" },
      ];
      const QUICK = [
        { k: "credit", t: "Add Credit", s: "Top up customer credits", i: "+", c: "#10b981", bg: "#ecfdf5", hover: "#d1fae5" },
        { k: "reconcile", t: "Booking Settlement", s: "Run settlement formula", i: "⚙️", c: "#0891b2", bg: "#ecfeff", hover: "#cffafe" },
        { k: "campaign", t: "Create Campaign", s: "Launch advertising drive", i: "🚀", c: "#2563eb", bg: "#eff6ff", hover: "#dbeafe" },
        { k: "ledger", t: "View Ledger", s: "Inspect audit transactions", i: "📄", c: "#7c3aed", bg: "#f5f3ff", hover: "#ede9fe" },
        { k: "report", t: "Generate Report", s: "Export snapshot insights", i: "📊", c: "#f59e0b", bg: "#fffbeb", hover: "#fef3c7" },
      ];
      /* ---------- Visual SVGs ---------- */
      function Spark({ color, id }) {
        return (
          <svg className="spark-svg" viewBox="0 0 140 60" preserveAspectRatio="none" aria-hidden>
            <defs>
              <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stopColor={color} stopOpacity=".3" />
                <stop offset="1" stopColor={color} stopOpacity="0" />
              </linearGradient>
            </defs>
            <path
              d="M0 58 C25 50 40 54 60 42 C80 32 95 38 110 20 C122 12 132 10 140 6 L140 60 L0 60Z"
              fill={`url(#${id})`}
            />
          </svg>
        );
      }
      function OverviewChart({ range, hidden }) {
        const { x: labels, d } = RANGES[range];
        const W = 700, H = 240, L = 42, R = 18, T = 15, B = 30, MAX = 10000;
        const px = (i) => L + (i * (W - L - R)) / (labels.length - 1);
        const py = (v) => T + (1 - v / MAX) * (H - T - B);
        return (
          <svg viewBox={`0 0 ${W} ${H}`} width="100%" height="auto" role="img" aria-label="Overview chart" style={{ overflow: "visible" }}>
            <defs>
              {LINES.map(([n, c]) => (
                <linearGradient key={n} id={"grad_" + n[0]} x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor={c} stopOpacity="0.25" />
                  <stop offset="100%" stopColor={c} stopOpacity="0.0" />
                </linearGradient>
              ))}
            </defs>
            {[0, 2500, 5000, 7500, 10000].map((v) => (
              <g key={v}>
                <line x1={L} x2={W - R} y1={py(v)} y2={py(v)} stroke="#f1f5f9" strokeDasharray="3 3" />
                <text x={L - 8} y={py(v) + 3} textAnchor="end" fontSize="10.5" fill="#94a3b8" fontWeight="500">
                  {v === 0 ? "0" : v >= 1000 ? v / 1000 + "k" : v}
                </text>
              </g>
            ))}
            {labels.map((l, i) => (
              <text key={l} x={px(i)} y={H - 6} textAnchor="middle" fontSize="11" fill="#64748b" fontWeight="500">
                {l}
              </text>
            ))}
            {d.map((s, k) => {
              if (hidden.includes(k)) return null;
              const pts = s.map((v, i) => `${px(i)},${py(v)}`).join(" ");
              return (
                <g key={k}>
                  <polygon
                    points={`${px(0)},${py(0)} ${pts} ${px(s.length - 1)},${py(0)}`}
                    fill={`url(#grad_${LINES[k][0][0]})`}
                  />
                  <polyline points={pts} fill="none" stroke={LINES[k][1]} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                  {s.map((v, i) => (
                    <circle key={i} cx={px(i)} cy={py(v)} r="3.5" fill={LINES[k][1]} stroke="#ffffff" strokeWidth="2">
                      <title>{`${LINES[k][0]} • ${labels[i]}: ${gbp(v)}`}</title>
                    </circle>
                  ))}
                </g>
              );
            })}
          </svg>
        );
      }
      function Donut({ dist, active, onPick }) {
        const total = dist.reduce((a, s) => a + s.v, 0);
        const r = 54, c = 2 * Math.PI * r;
        let off = 0;
        const sel = dist.find((s) => s.n === active);
        return (
          <svg viewBox="0 0 150 150" width="140" height="140" role="img">
            <g transform="rotate(-90 75 75)">
              {dist.map((s) => {
                const len = (s.v / total) * c;
                const isPicked = active === s.n;
                const el = (
                  <circle
                    key={s.n}
                    cx="75"
                    cy="75"
                    r={r}
                    fill="none"
                    stroke={s.c}
                    strokeWidth={isPicked ? 22 : 16}
                    strokeDasharray={`${len - 1.5} ${c - len + 1.5}`}
                    strokeDashoffset={-off}
                    style={{ cursor: "pointer", transition: "all .2s ease" }}
                    onClick={() => onPick(isPicked ? null : s.n)}
                  />
                );
                off += len;
                return el;
              })}
            </g>
            <text x="75" y="72" textAnchor="middle" fontSize="16" fontWeight="700" fill="#0f172a">
              £{(sel ? sel.v : total).toLocaleString()}
            </text>
            <text x="75" y="88" textAnchor="middle" fontSize="10.5" fill="#64748b" fontWeight="500">
              {sel ? sel.n.split(" ")[0] : "Total"}
            </text>
          </svg>
        );
      }
      /* ---------- Modal Wrapper ---------- */
      function ModalDialog({ title, subtitle, icon, onClose, wide, children }) {
        const onCloseRef = _useRef(onClose);
        _useEffect(() => {
          onCloseRef.current = onClose;
        });
        _useEffect(() => {
          const handleKeyDown = (e) => {
            if (e.key === "Escape" && onCloseRef.current) onCloseRef.current();
          };
          const prevOverflow = document.body.style.overflow;
          document.body.style.overflow = "hidden";
          window.addEventListener("keydown", handleKeyDown);
          return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener("keydown", handleKeyDown);
          };
        }, []);
        return (
          <div className="ml-modal-backdrop" onClick={(e) => e.stopPropagation()}>
            <div
              className={`ml-modal-card ${wide ? "ml-modal-wide" : ""}`}
              role="dialog"
              aria-modal="true"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="ml-modal-header">
                <div className="ml-modal-title-group">
                  {icon && <span className="ml-modal-badge-icon">{icon}</span>}
                  <div>
                    <h3 className="ml-modal-title">{title}</h3>
                    {subtitle && <p className="ml-modal-subtitle">{subtitle}</p>}
                  </div>
                </div>
                <button type="button" className="ml-btn-close" onClick={onClose} aria-label="Close modal">
                  ✕
                </button>
              </div>
              <div className="ml-modal-body">{children}</div>
            </div>
          </div>
        );
      }
      /* ---------- Filter Components ---------- */
      function FilterClearButton({ onClear, count }) {
        if (!count) return null;
        return (
          <button type="button" className="btn-filter-clear" onClick={onClear} title="Reset active filters">
            ✕ Clear Filters ({count})
          </button>
        );
      }
      /* ---------- Reusable Ledger Table with Sorting ---------- */
      function LedgerTable({ rows, onRowClick }) {
        return (
          <div className="table-wrap">
            <table className="ledger-tbl">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Description</th>
                  <th>Related Entity</th>
                  <th className="tar">Amount</th>
                  <th className="tar">Balance</th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="tbl-empty">
                      No matching transaction records found.
                    </td>
                  </tr>
                ) : (
                  rows.map((e) => (
                    <tr key={e.id} className={onRowClick ? "row-click" : ""} onClick={() => onRowClick && onRowClick(e)}>
                      <td className="cell-date">{e.d}</td>
                      <td>
                        <span className={`status-pill ${e.t.toLowerCase()}`}>
                          <span className="dot" /> {e.t}
                        </span>
                      </td>
                      <td className="cell-desc">{e.desc}</td>
                      <td className="cell-rel">{e.rel}</td>
                      <td className={`tar font-numeric font-semibold ${e.t === "Credit" ? "col-pos" : "col-neg"}`}>
                        {e.a > 0 ? "+" : "-"} {gbp(Math.abs(e.a))}
                      </td>
                      <td className="tar font-numeric font-semibold col-bal">{gbp(e.b)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        );
      }
      /* ---------- Stripe Helpers ---------- */
      const labelStyle = {
        display: "block",
        color: "#8791a2",
        fontSize: "11px",
        textTransform: "uppercase",
        letterSpacing: "0.6px",
        marginBottom: "5px",
      };
      function StripeBalanceCard({ label, icon, value, hint, valueColor }) {
        return (
          <div
            style={{
              background: "#ffffff",
              borderRadius: "14px",
              padding: "20px",
              border: "1px solid #edf0f5",
              boxShadow: "0 2px 8px rgba(20, 40, 80, 0.04)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                color: "#6c7687",
                fontSize: "13px",
                fontWeight: 600,
              }}
            >
              <span>{label}</span>
              <div
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#eef4ff",
                  color: "#0747A6",
                  fontWeight: "bold",
                }}
              >
                {icon}
              </div>
            </div>
            <h2 style={{ margin: "18px 0 6px", fontSize: "28px", letterSpacing: "-0.5px", color: valueColor || "#0f172a" }}>
              {value}
            </h2>
            <p style={{ margin: 0, color: "#8993a4", fontSize: "12px" }}>{hint}</p>
          </div>
        );
      }
      function SummaryRow({ label, value, last }) {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: last ? "14px 0 0" : "10px 0",
              fontSize: last ? "14px" : "13px",
              borderBottom: last ? "none" : "1px solid #f1f5f9",
            }}
          >
            {last ? <strong>{label}</strong> : <span style={{ color: "#687386" }}>{label}</span>}
            <strong style={last ? { fontSize: "18px", color: "#0747A6" } : undefined}>{value}</strong>
          </div>
        );
      }
      /* ---------- Main Dashboard Component ---------- */
      function MarketingLedgerDashboard() {
        const [range, setRange] = _useState("30D");
        const [dateOpen, setDateOpen] = _useState(false);
        const [modal, setModal] = _useState(null);
        const [entries, setEntries] = _useState(ENTRIES0);
        const [dist, setDist] = _useState(DIST0);
        const [localSpent, setLocalSpent] = _useState(0);
        const [saving, setSaving] = _useState(false);
        const [hidden, setHidden] = _useState([]);
        const [activeSlice, setActiveSlice] = _useState(null);
        const [toast, setToast] = _useState("");
        const [err, setErr] = _useState("");
        const [receipt, setReceipt] = _useState(null);
        const [filter, setFilter] = _useState("All");
        const [q, setQ] = _useState("");
        const [selected, setSelected] = _useState(null);
        const [refreshing, setRefreshing] = _useState(false);
        /* Main Ledger advanced filters */
        const [ledgerMinAmt, setLedgerMinAmt] = _useState("");
        const [ledgerMaxAmt, setLedgerMaxAmt] = _useState("");
        const [ledgerSort, setLedgerSort] = _useState("date-desc");
        /* Stream search & filter */
        const [streamFilter, setStreamFilter] = _useState("All");
        const [streamQ, setStreamQ] = _useState("");
        /* Bookings modal comprehensive filter state */
        const [bookingQ, setBookingQ] = _useState("");
        const [bookingCustFilter, setBookingCustFilter] = _useState("");
        const [bookingView, setBookingView] = _useState("all");
        const [bookingStatusFilter, setBookingStatusFilter] = _useState("all");
        const [bookingSettlementFilter, setBookingSettlementFilter] = _useState("all");
        const [bookingServiceFilter, setBookingServiceFilter] = _useState("all");
        const [bookingProviderFilter, setBookingProviderFilter] = _useState("all");
        const [bookingMinAmount, setBookingMinAmount] = _useState("");
        const [bookingMaxAmount, setBookingMaxAmount] = _useState("");
        const [bookingSortBy, setBookingSortBy] = _useState("date-desc");
        const [bookingDateFrom, setBookingDateFrom] = _useState("");
        const [bookingDateTo, setBookingDateTo] = _useState("");
        /* Settlement persistent keys */
        const [settledKeys, setSettledKeys] = _useState([]);
        const [settleBookingKey, setSettleBookingKey] = _useState("");
        const [redeemedAtMap, setRedeemedAtMap] = _useState({});
        /* V23.6: exact Credit Used recorded when a booking was settled in this session (key -> amount) */
        const [settledCreditMap, setSettledCreditMap] = _useState({});
        /* Customers modal comprehensive filter state */
        const [custData, setCustData] = _useState(null);
        const [custLoading, setCustLoading] = _useState(true);
        const [customerErr, setCustomerErr] = _useState("");
        const [custQ, setCustQ] = _useState("");
        const [custLocationFilter, setCustLocationFilter] = _useState("all");
        const [custRoleFilter, setCustRoleFilter] = _useState("all");
        const [custBookingFilter, setCustBookingFilter] = _useState("all");
        const [custMinCredit, setCustMinCredit] = _useState("");
        const [custMaxCredit, setCustMaxCredit] = _useState("");
        const [custSortBy, setCustSortBy] = _useState("name-asc");
        const [custDateFrom, setCustDateFrom] = _useState("");
        const [custDateTo, setCustDateTo] = _useState("");
        /* Distribution modal filters */
        const [distQ, setDistQ] = _useState("");
        const [distSort, setDistSort] = _useState("v-desc");
        /* Stripe balance state */
        const [stripeBalanceData, setStripeBalanceData] = _useState(null);
        const [isBalanceLoading, setIsBalanceLoading] = _useState(false);
        const [balanceFetchError, setBalanceFetchError] = _useState("");
        const [stripeLogs, setStripeLogs] = _useState([]);
        const [stripeSyncNote, setStripeSyncNote] = _useState("");
        /* Forms state */
        const [cf, setCf] = _useState({ customerId: "", amount: "", source: DIST0[0].n, desc: "" });
        const [gf, setGf] = _useState({ name: "", budget: "", channel: "Google Ads" });
        /* Settlement Calculation Form State */
        const [settleCustId, setSettleCustId] = _useState("");
        const [servicePriceInput, setServicePriceInput] = _useState("100.00");
        const [providerObligationInput, setProviderObligationInput] = _useState("75.00");
        const [bookingRefInput, setBookingRefInput] = _useState("");
        const dateRef = _useRef(null);
        const toastTimer = _useRef(null);
        /* ORIGINAL balance: fixed reference (default £1,223,201.28), persisted, never overwritten by live updates */
        const stripeOriginalRef = _useRef(readOriginalStripeBalance());
        _useEffect(() => {
          persistOriginalStripeBalance(stripeOriginalRef.current);
        }, []);
        /* Cumulative net Stripe movement of every settlement ever recorded (persistent log) — UI balance */
        const stripeLoggedNet = _useMemo(
          () => stripeLogs.reduce((a, l) => a + parseNum(l.stripeNet), 0),
          [stripeLogs]
        );
        /* V23.4: cumulative amount deducted in the UI balance ONLY (never pushed to the Stripe account) */
        const stripeLoggedUiOnly = _useMemo(
          () => stripeLogs.reduce((a, l) => a + parseNum(l.stripeUiOnly), 0),
          [stripeLogs]
        );
        /* V23.5: cumulative Credit Used of every recorded settlement (persistent log) */
        const stripeLoggedCreditUsed = _useMemo(
          () => stripeLogs.reduce((a, l) => a + parseNum(l.creditUsed), 0),
          [stripeLogs]
        );
        /* V23.5: cumulative Credit Redeemed of every recorded settlement (falls back to Credit Used for old logs) */
        const stripeLoggedCreditRedeemed = _useMemo(
          () =>
            stripeLogs.reduce(
              (a, l) => a + parseNum(l.creditRedeemed !== undefined ? l.creditRedeemed : l.creditUsed),
              0
            ),
          [stripeLogs]
        );
        /* Dynamic totals */
        const totals = _useMemo(
          () => ({
            credits: custData?.totalCredits ?? custData?.totalLifetimeIssued ?? 0,
            spent: (custData?.totalSpent ?? 0) + localSpent,
            available: Math.max(0, (custData?.totalAvailableCredits ?? custData?.totalExistingCredits ?? 0) - localSpent),
            allocated: custData?.totalCreditAllocated ?? 0,
            expired: custData?.totalCreditExpired ?? 0,
            redeemed: custData?.totalCreditRedeemed ?? 0,
            redeemedCount: custData?.totalCreditsRedeemedCount ?? 0,
            bookingsCount: custData?.totalBookingsCount ?? 0,
          }),
          [custData, localSpent]
        );
        const available = totals.available;
        const distTotal = dist.reduce((a, s) => a + s.v, 0);
        const balance = entries.length ? entries[0].b : 0;
        /* Automatic settlement engine */
        const autoSettle = _useMemo(() => {
          const rows = [];
          (custData?.customers || []).forEach((c) => {
            /* FIX V23.3: if marketingAvailableCredits is 0 / missing, fall back to marketingExistingCredits
               so unsettled bookings are not silently valued at £0 credit. */
            let runningAvail =
              c.marketingAvailableCredits > 0 ? c.marketingAvailableCredits : c.marketingExistingCredits || 0;
            (c.bookings || []).forEach((b) => {
              const isSettled = b.settled || settledKeys.includes(b.key);
              /* Settled bookings keep their stored credit.
                 UNSETTLED bookings resolve their credit as:
                   1) a positive stored credit on the booking,
                   2) else the credit IMPLIED by the booking (Service Price − stored customer payment),
                   3) else the formula MIN(Service Price, customer's running available credit).
                 (a stored 0 on an unsettled booking must not hide the pending ledger impact). */
              const storedPositive =
                b.hasCreditData && b.creditUsed > 0 ? b.creditUsed : b.impliedCredit > 0 ? b.impliedCredit : 0;
              /* FIX V23.6: a booking settled in this session keeps the exact credit used at settlement
                 (the customer's balance has already been reduced, so re-running the formula would be wrong). */
              const mappedCredit = settledCreditMap[b.key];
              const useStoredCredit = isSettled ? mappedCredit !== undefined || b.hasCreditData : storedPositive > 0;
              const storedCreditValue = isSettled ? (mappedCredit !== undefined ? mappedCredit : b.creditUsed) : storedPositive;
              /* FIX V23.6: credit available to THIS booking (what the settlement form must use too) */
              const creditAvailable = useStoredCredit ? storedCreditValue : runningAvail;
              const calc0 = calcSettlement({
                servicePrice: b.customerTotalAmount,
                availableCredit: creditAvailable,
                providerObligation: b.providerPayout,
                prevLedgerBalance: 0,
                prevCreditRedeemed: 0,
              });
              /* FIX V23.6: Credit Redeemed = credit of SETTLED bookings only; pending credit is only a pending ledger impact */
              const calc = {
                ...calc0,
                creditRedeemed: isSettled ? calc0.creditUsed : 0,
                finalCreditRedeemed: isSettled ? calc0.creditUsed : 0,
              };
              if (!useStoredCredit && !isSettled) runningAvail = Math.max(0, runningAvail - calc.creditUsed);
              /* FIX V23.6: a redemption date only exists for settled bookings */
              const redeemedMs = isSettled
                ? redeemedAtMap[b.key] || b.redeemedMs || (calc.creditUsed > 0 ? b.dateMs : 0)
                : 0;
              rows.push({ ...b, settled: isSettled, redeemedMs, calc, creditAvailable, creditFromBooking: useStoredCredit });
            });
          });
          const sum = (f) => rows.reduce((a, r) => a + f(r), 0);
          const pending = rows.filter((r) => !r.settled);
          const psum = (f) => pending.reduce((a, r) => a + f(r), 0);
          const t = {
            count: rows.length,
            pendingCount: pending.length,
            settledCount: rows.length - pending.length,
            servicePrice: sum((r) => r.calc.servicePrice),
            creditUsed: sum((r) => r.calc.creditUsed),
            creditRedeemed: sum((r) => r.calc.creditRedeemed),
            stripePayment: sum((r) => r.calc.stripePayment),
            providerPayout: sum((r) => r.calc.providerPayout),
            ugRevenue: sum((r) => r.ugRevenue),
            ledgerDeduction: sum((r) => r.calc.ledgerDeduction),
            pendingDeduction: psum((r) => r.calc.ledgerDeduction),
            stripeNet: sum((r) => r.calc.stripeNet),
            stripeShortfall: sum((r) => r.calc.stripeShortfall),
            pendingStripeIn: psum((r) => r.calc.stripePayment),
            pendingProviderOut: psum((r) => r.calc.providerPayout),
            pendingStripeNet: psum((r) => r.calc.stripeNet),
          };
          t.prevLedgerBalance = balance;
          t.finalLedgerBalance = balance - t.pendingDeduction;
          t.reconciled = Math.abs(t.servicePrice - (t.creditUsed + t.stripePayment)) < 0.005;
          /* Stripe <-> Marketing ledger: (Price - Provider Payout) must equal (Stripe net + Credit used) */
          t.reconciledStripe =
            Math.abs(sum((r) => r.calc.ugRevenueRaw) - (t.stripeNet + t.creditUsed)) < 0.005;
          const byKey = {};
          rows.forEach((r) => {
            byKey[r.key] = r;
          });
          return { rows, totals: t, byKey };
        }, [custData, settledKeys, balance, redeemedAtMap, settledCreditMap]);
        const at = autoSettle.totals;
        const showToast = (m) => {
          setToast(m);
          clearTimeout(toastTimer.current);
          toastTimer.current = setTimeout(() => setToast(""), 2800);
        };
        _useEffect(() => () => clearTimeout(toastTimer.current), []);
        _useEffect(() => {
          const h = (e) => dateRef.current && !dateRef.current.contains(e.target) && setDateOpen(false);
          document.addEventListener("mousedown", h);
          return () => document.removeEventListener("mousedown", h);
        }, []);
        const permissionMsg = (e, fallback, action) =>
          e && e.code === "permission-denied"
            ? `Firestore rules deny ${action} customer records`
            : (e && e.message) || fallback;
        const loadCustomers = () => {
          setCustLoading(true);
          setCustomerErr("");
          return fetchCustomers()
            .then((data) => setCustData(data))
            .catch((e) => {
              console.error("Firebase customer error:", e);
              setCustomerErr(permissionMsg(e, "Failed to query customers", "reading"));
            })
            .finally(() => setCustLoading(false));
        };
        const loadStripeBalance = async () => {
          try {
            setIsBalanceLoading(true);
            setBalanceFetchError("");
            const payload = await fetchStripeBalancePayload();
            setStripeBalanceData(payload);
            return payload;
          } catch (balanceError) {
            console.error("Stripe Balance Retrieval Error:", balanceError);
            setBalanceFetchError(
              balanceError.message || "An unexpected error occurred while retrieving the balance."
            );
            return null;
          } finally {
            setIsBalanceLoading(false);
          }
        };
        const refreshAll = async () => {
          setRefreshing(true);
          await Promise.allSettled([loadCustomers(), loadStripeBalance()]);
          setRefreshing(false);
          showToast("Dashboard synchronized");
        };
        _useEffect(() => {
          setCustLoading(true);
          const unsub = subscribeCustomers(
            (data) => {
              setCustData(data);
              setCustomerErr("");
              setCustLoading(false);
            },
            (e) => {
              console.error("Firebase snapshot error:", e);
              setCustomerErr(permissionMsg(e, "Failed to listen to customers", "reading"));
              setCustLoading(false);
            }
          );
          loadStripeBalance();
          fetchSettlementLogs().then(setStripeLogs);
          return () => unsub && unsub();
        }, []);
        /* Stripe balance figures: LIVE balance (Stripe) + any not-yet-confirmed projected movement.
           The ORIGINAL balance stays fixed as the reference. */
        const stripeApiAvailable =
          stripeBalanceData?.available?.amount !== undefined ? stripeBalanceData.available.amount / 100 : null;
        const stripeApiPending =
          stripeBalanceData?.pending?.amount !== undefined ? stripeBalanceData.pending.amount / 100 : 0;
        /* REMAINING live balance (UI) = original + all settled movements (provider payouts out, customer receipts in) */
        const stripeEffective = stripeOriginalRef.current + stripeLoggedNet;
        /* V23.4: balance the Stripe ACCOUNT itself is expected to show = UI balance + UI-only deductions (not pushed) */
        const stripeExpectedAccount = stripeEffective + stripeLoggedUiOnly;
        /* Difference between what the Stripe account reports and what it is expected to report (0 once Stripe is in sync) */
        const stripeSyncGap = stripeApiAvailable !== null ? stripeExpectedAccount - stripeApiAvailable : 0;
        const stripeProjected = stripeEffective + at.pendingStripeNet;
        const stripeOriginal = stripeOriginalRef.current;
        /* Pending: Stripe's own pending balance + customer receipts still waiting on unsettled bookings */
        const stripePendingProjected = stripeApiPending + at.pendingStripeIn;
        const stripeAvailableDisplay = isBalanceLoading
          ? "Refreshing..."
          : stripeApiAvailable !== null
          ? gbp(stripeProjected)
          : balanceFetchError
          ? "Unavailable"
          : "£0.00";
        const customerDisplay = custLoading
          ? "Scanning…"
          : custData
          ? custData.count.toLocaleString()
          : "Unavailable";
        const STATS = [
          {
            k: "credits",
            label: "Total Credits",
            value: totals.credits,
            trend: custData ? "Live" : "—",
            color: "#10b981",
            icon: "💎",
            subtext: custData ? `${gbp(custData.totalLifetimeIssued)} lifetime issued` : "",
          },
          {
            k: "allocated",
            label: "Credit Allocated",
            value: totals.allocated,
            trend: "Firestore",
            color: "#0284c7",
            icon: "📥",
            subtext: `${gbp(totals.allocated)} assigned to customers`,
          },
          {
            k: "redeemed",
            label: "Credit Redeemed",
            value: totals.redeemed,
            trend: `${totals.redeemedCount} redemptions`,
            color: "#f59e0b",
            icon: "🏷️",
            subtext: `${totals.redeemedCount} total times redeemed`,
          },
          {
            k: "expired",
            label: "Credit Expired",
            value: totals.expired,
            trend: "Archived",
            color: "#ef4444",
            icon: "⏳",
            subtext: `${gbp(totals.expired)} expired unused`,
          },
          {
            k: "available",
            label: "Available Credits",
            value: totals.available,
            trend: custData ? "Live" : "—",
            color: "#8b5cf6",
            icon: "✨",
            subtext: custData ? `${gbp(totals.available)} available active` : "",
          },
          {
            k: "customers",
            label: "Active Customers",
            display: customerDisplay,
            trend: "Live (customer)",
            color: "#059669",
            icon: "👥",
            subtext: custData ? `${custData.count} named customers` : "",
            note: customerErr,
          },
          {
            k: "bookings",
            label: "Customer Bookings",
            display: custLoading ? "Scanning…" : totals.bookingsCount.toLocaleString(),
            trend: "customers/MyBooking",
            color: "#0891b2",
            icon: "📅",
            subtext: `${totals.bookingsCount} bookings · ${gbp(at.servicePrice)} service value`,
          },
          {
            k: "stripe",
            label: "Stripe Remaining Balance (GBP)",
            display: stripeAvailableDisplay,
            trend: stripeBalanceData ? "● Connected" : "Stripe API",
            color: "#0747A6",
            icon: "🏦",
            subtext: stripeBalanceData?.accountId || "acct_1QqxpnJzsfOM5Wqn",
            note:
              balanceFetchError ||
              `Live (settled): ${gbp(stripeEffective)} · Pending receipts: +${gbp(at.pendingStripeIn)} · Provider payouts due: -${gbp(at.pendingProviderOut)} · Stripe pending: ${gbp(stripeApiPending)}`,
          },
        ];
        const fillSettleFromBooking = (b) => {
          if (!b) {
            setSettleBookingKey("");
            return;
          }
          setSettleBookingKey(b.key);
          setServicePriceInput(Number(b.customerTotalAmount || 0).toFixed(2));
          setProviderObligationInput(Number(b.providerPayout || 0).toFixed(2));
          setBookingRefInput(b.bookingId);
        };
        const prepareSettle = (customerId, bookingKey) => {
          const custs = custData?.customers || [];
          const cust =
            custs.find((c) => c.id === customerId) ||
            (bookingKey ? custs.find((c) => (c.bookings || []).some((b) => b.key === bookingKey)) : null) ||
            custs[0] ||
            null;
          setSettleCustId(cust?.id || "");
          const list = cust?.bookings || [];
          const bk =
            list.find((b) => b.key === bookingKey) ||
            list.find((b) => !(b.settled || settledKeys.includes(b.key))) ||
            list[0] ||
            null;
          fillSettleFromBooking(bk);
        };
        const closeModal = () => {
          setModal(null);
          setErr("");
        };
        const openModal = (k, sel = null) => {
          setErr("");
          setFilter("All");
          setQ("");
          setSelected(sel);
          if (k === "reconcile") prepareSettle(null, null);
          setModal(k);
        };
        const openBookings = (customerId, view = "all") => {
          openModal("stat:bookings");
          setBookingCustFilter(customerId || "");
          setBookingView(view);
        };
        const openCreditFor = (customerId) => {
          setErr("");
          setCf((p) => ({ ...p, customerId }));
          setModal("credit");
        };
        const openSettleFor = (customerId, bookingKey = null) => {
          setErr("");
          prepareSettle(customerId, bookingKey);
          setModal("reconcile");
        };
        const addEntry = (e) => {
          setEntries((prev) => [{ id: Date.now(), d: nowLabel(), b: (prev[0]?.b || 0) + e.a, ...e }, ...prev]);
        };
        const submitCredit = async (ev) => {
          ev.preventDefault();
          const amt = parseFloat(cf.amount);
          const cust = custData?.customers.find((c) => c.id === cf.customerId);
          if (!cust) return setErr("Please select a customer.");
          if (!amt || amt <= 0) return setErr("Please specify an amount higher than £0.00.");
          try {
            setSaving(true);
            await addCreditToCustomer(cust.id, amt);
          } catch (e) {
            console.error(e);
            setSaving(false);
            return setErr(permissionMsg(e, "Failed to update credits", "updating"));
          }
          setSaving(false);
          addEntry({
            t: "Credit",
            a: amt,
            desc: cf.desc.trim() || "Manual credit injection",
            rel: `${cust.customerName} (${cf.source})`,
            title: "Credit Added",
            sub: cf.desc.trim() || `Top up for ${cust.customerName}`,
            i: "🎁",
          });
          setDist((d) => d.map((s) => (s.n === cf.source ? { ...s, v: s.v + amt } : s)));
          setReceipt({
            title: "Credits Deposited Successfully",
            subtitle: `Saved to customer record ${cust.id}`,
            tone: "ok",
            icon: "✓",
            rows: [
              ["Doc ID", cust.id],
              ["Customer", cust.customerName],
              ["Amount Deposited", "+ " + gbp(amt)],
              ["Destination Source", cf.source],
              ["Description / Memo", cf.desc.trim() || "Manual credit injection"],
              ["Recorded Timestamp", nowLabel()],
              ["New Available Credits", gbp(cust.marketingAvailableCredits + amt)],
            ],
          });
          setCf({ customerId: "", amount: "", source: DIST0[0].n, desc: "" });
          setErr("");
          setModal("receipt");
        };
        const selectedSettleCust = (custData?.customers || []).find((c) => c.id === settleCustId) || custData?.customers?.[0] || null;
        const selectedSettleBooking = (selectedSettleCust?.bookings || []).find((b) => b.key === settleBookingKey) || null;
        const numServicePrice = Math.max(0, parseFloat(servicePriceInput) || 0);
        /* FIX V23.6: the credit available to the settlement is the SAME credit the boards use for the selected
           pending booking (stored / implied booking credit, or the running available credit). For a manual entry
           it is the customer's available credit (falling back to existing credits when it is 0). */
        const settleRow = selectedSettleBooking ? autoSettle.byKey[selectedSettleBooking.key] : null;
        const settleBaseAvail = selectedSettleCust
          ? selectedSettleCust.marketingAvailableCredits > 0
            ? selectedSettleCust.marketingAvailableCredits
            : selectedSettleCust.marketingExistingCredits || 0
          : available;
        const numCustAvailableCredit = Math.max(
          0,
          settleRow && !settleRow.settled ? settleRow.creditAvailable : settleBaseAvail
        );
        const calcCreditUsed = Math.min(numServicePrice, numCustAvailableCredit);
        /* V23.4: Credit Redeemed is part of the reconciliation (this settlement + customer's cumulative redeemed) */
        const calcCreditRedeemed = calcCreditUsed;
        const prevCreditRedeemed = Math.max(0, selectedSettleCust?.marketingCreditRedeemed ?? 0);
        const calcFinalCreditRedeemed = prevCreditRedeemed + calcCreditRedeemed;
        const calcCustomerPayment = Math.max(0, numServicePrice - calcCreditUsed);
        const calcStripePayment = calcCustomerPayment;
        const numProviderPayoutObligation = Math.max(0, parseFloat(providerObligationInput) || 0);
        const calcProviderPayout = numProviderPayoutObligation;
        const calcUgRevenue = Math.max(0, numServicePrice - calcProviderPayout);
        const calcMarketingLedgerDeduction = calcCreditUsed;
        const prevLedgerBalance = balance;
        const calcMarketingLedgerBalance = prevLedgerBalance - calcCreditUsed;
        /* Stripe impact: customer payment in, provider payout out (UI balance) */
        const calcStripeNet = calcStripePayment - calcProviderPayout;
        const calcStripeShortfall = Math.max(0, calcProviderPayout - calcStripePayment);
        /* V23.4: what is REALLY pushed to the Stripe account. The shortfall (extra payout beyond the
           customer's Stripe payment) is deducted in the UI Stripe balance only. */
        const calcStripePayoutPushed = Math.min(calcProviderPayout, calcStripePayment);
        const calcStripeNetPushed = calcStripePayment - calcStripePayoutPushed;
        const calcStripeUiOnly = calcStripeShortfall;
        const simRow = { display: "flex", justifyContent: "space-between", borderBottom: "1px solid #edf2f7", paddingBottom: "6px" };
        const applyBookingSettlement = async (ev) => {
          ev.preventDefault();
          if (!selectedSettleCust) return setErr("Please choose a valid customer.");
          if (numServicePrice <= 0) return setErr("Service price must be greater than £0.00.");
          if (selectedSettleBooking && (selectedSettleBooking.settled || settledKeys.includes(selectedSettleBooking.key))) {
            return setErr("This booking has already been settled.");
          }
          const nowMs = Date.now();
          const bk = selectedSettleBooking;
          const refLabel = bookingRefInput.trim() || bk?.bookingId || "Direct Settlement";
          try {
            setSaving(true);
            if (calcCreditUsed > 0) {
              await recordBookingSettlement(selectedSettleCust.id, calcCreditUsed);
            }
          } catch (e) {
            console.error(e);
            setSaving(false);
            return setErr(permissionMsg(e, "Failed to apply settlement to Firestore", "updating"));
          }
          /* ---- Stripe: read the live balance first, pay provider out of it, then re-read the live balance ---- */
          const preFresh = await loadStripeBalance();
          const liveBeforeApi =
            preFresh?.available?.amount !== undefined ? preFresh.available.amount / 100 : stripeApiAvailable ?? 0;
          const pendingBefore =
            preFresh?.pending?.amount !== undefined ? preFresh.pending.amount / 100 : stripeApiPending;
          /* Remaining balance BEFORE this settlement (original + every earlier settled movement) */
          const stripeBefore = stripeEffective;
          /* V23.4: balance the Stripe ACCOUNT should show after the pushed movement only */
          const expectedApiAfter = liveBeforeApi + calcStripeNetPushed;
          /* V23.5: cumulative Credit Used / Credit Redeemed AFTER this settlement (Stripe Balance Engine totals) */
          const creditUsedTotalAfter = stripeLoggedCreditUsed + calcCreditUsed;
          const creditRedeemedTotalAfter = stripeLoggedCreditRedeemed + calcCreditRedeemed;
          /* V23.5: Stripe Balance Engine snapshot + string-only metadata so the backend can write
             every calculation onto the Stripe transfer / balance transaction. */
          const engineSnapshot = {
            originalBalance: stripeOriginalRef.current,
            balanceBefore: stripeBefore,
            balanceAfter: stripeBefore + calcStripeNet,
            creditUsed: calcCreditUsed,
            creditRedeemed: calcCreditRedeemed,
            creditUsedTotalAfter,
            creditRedeemedTotalAfter,
            customerPayment: calcCustomerPayment,
            stripePayment: calcStripePayment,
            providerPayoutTotal: calcProviderPayout,
            providerPayoutPushed: calcStripePayoutPushed,
            netPushed: calcStripeNetPushed,
            ugRevenue: calcUgRevenue,
            uiOnlyShortfall: calcStripeUiOnly,
          };
          const stripeMetadata = {};
          Object.keys(engineSnapshot).forEach((k) => {
            stripeMetadata[k] = String(Math.round(engineSnapshot[k] * 100) / 100);
          });
          stripeMetadata.bookingId = String(refLabel);
          stripeMetadata.customerId = String(selectedSettleCust.id);
          /* FIX V23.2: payload built once so it can be re-sent after a test-mode top-up.
             V23.4: payload carries ONLY the movement that must reach the Stripe account
             (providerPayout = payout covered by the customer payment, stripeNet = pushed net).
             The extra payout is sent as `uiOnlyShortfall` for information; it must NOT be transferred. */
          const settlementPayload = {
            idempotencyKey: `${selectedSettleCust.id}_${bk ? bk.docId : "manual_" + nowMs}`,
            bookingId: refLabel,
            customerId: selectedSettleCust.id,
            providerAccountId: bk?.providerAccountId || null,
            currency: "gbp",
            servicePrice: numServicePrice,
            creditUsed: calcCreditUsed,
            creditRedeemed: calcCreditRedeemed,
            prevCreditRedeemed: prevCreditRedeemed,
            finalCreditRedeemed: calcFinalCreditRedeemed,
            /* V23.5: Stripe Balance Engine credit totals after this settlement */
            creditUsedTotalAfter,
            creditRedeemedTotalAfter,
            stripePayment: calcStripePayment,
            providerPayout: calcStripePayoutPushed,
            providerPayoutTotal: calcProviderPayout,
            stripeNet: calcStripeNetPushed,
            stripeShortfall: 0,
            uiOnlyShortfall: calcStripeUiOnly,
            originalBalance: stripeOriginalRef.current,
            balanceBefore: stripeBefore,
            expectedBalanceAfter: stripeBefore + calcStripeNet,
            expectedStripeAccountAfter: expectedApiAfter,
            engineSnapshot,
            stripeMetadata,
          };
          let sres = await postStripeSettlement(settlementPayload);
          /* FIX V23.2: Stripe can only pay out money that is really in its AVAILABLE balance.
             In TEST mode, add exactly the missing funds via /api/stripe/test-topup and retry ONCE
             (with a fresh idempotency key, because the rejected attempt never reached Stripe). */
          let toppedUp = false;
          if (!sres.ok && sres.code === "balance_insufficient" && sres.body?.requiredAmount !== undefined) {
            const gapMinor = Math.max(0, sres.body.requiredAmount - (sres.body.availableAmount || 0));
            if (gapMinor > 0 && (await topUpStripeTestBalance(gapMinor + 100))) {
              toppedUp = true;
              sres = await postStripeSettlement({
                ...settlementPayload,
                idempotencyKey: settlementPayload.idempotencyKey + "_topup",
              });
            }
          }
          /* Remaining balance AFTER this settlement (UI): provider payout leaves (incl. the UI-only extra), customer payment arrives */
          const stripeAfter = stripeBefore + calcStripeNet;
          let pendingAfter = pendingBefore;
          let syncMode;
          if (sres.ok) {
            const fresh = await loadStripeBalance();
            const apiAfter =
              fresh?.available?.amount !== undefined
                ? fresh.available.amount / 100
                : sres.body?.balance?.available?.amount !== undefined
                ? sres.body.balance.available.amount / 100
                : null;
            pendingAfter =
              fresh?.pending?.amount !== undefined ? fresh.pending.amount / 100 : pendingBefore;
            if (sres.body?.stripeUpdated === false) {
              /* FIX V23.2: backend answered OK but moved no money (no provider Stripe account on the booking) */
              syncMode = "Recorded only (no Stripe transfer)";
              setStripeSyncNote(`The backend recorded this settlement but did NOT move any money in Stripe, because the booking has no provider Stripe account id (acct_...). Add providerStripeAccountId to the booking (or the "${BOOKING_COLLECTION}" document) to push the provider payout to Stripe. The remaining balance ${gbp(stripeAfter)} is recorded in the settlement log.`);
            } else if (apiAfter !== null && Math.abs(apiAfter - expectedApiAfter) < 0.01) {
              syncMode = "Stripe (live)";
              setStripeSyncNote("");
            } else if (apiAfter !== null && Math.abs(apiAfter - liveBeforeApi) >= 0.004) {
              syncMode = "Stripe (partially synced)";
              setStripeSyncNote(`Stripe reports ${gbp(apiAfter)} while the Stripe account is expected to show ${gbp(expectedApiAfter)} after the pushed movement. The dashboard shows the remaining balance ${gbp(stripeAfter)}; press Refresh once Stripe finishes processing.`);
            } else {
              syncMode = "Stripe accepted (awaiting live sync)";
              setStripeSyncNote(`Stripe accepted the settlement but its reported balance (${apiAfter !== null ? gbp(apiAfter) : "unavailable"}) has not changed yet (expected ${gbp(expectedApiAfter)}). The dashboard shows the remaining balance ${gbp(stripeAfter)} and will match Stripe once the payout / receipt is processed.`);
            }
            if (toppedUp) syncMode += " + test top-up";
            if (calcStripeUiOnly > 0) syncMode += " + UI-only extra payout";
          } else {
            syncMode = "Projected (Stripe not updated)";
            setStripeSyncNote(`Stripe settlement failed: ${sres.message}. The remaining balance ${gbp(stripeAfter)} is recorded in the settlement log, but the Stripe account itself has NOT been updated.`);
          }
          setSaving(false);
          if (calcCreditUsed > 0) {
            addEntry({
              t: "Debit",
              a: -calcCreditUsed,
              desc: `Settlement: ${refLabel} (Credit used)`,
              rel: `${selectedSettleCust.customerName} (${selectedSettleCust.id})`,
              title: "Marketing Credit Settlement",
              sub: `Credit deduction against £${numServicePrice.toFixed(2)} service`,
              i: "⚙️",
            });
            setLocalSpent((s) => s + calcCreditUsed);
          }
          const logEntry = {
            tsMs: nowMs,
            bookingId: refLabel,
            customerId: selectedSettleCust.id,
            customerName: selectedSettleCust.customerName,
            servicePrice: numServicePrice,
            creditUsed: calcCreditUsed,
            creditRedeemed: calcCreditRedeemed,
            finalCreditRedeemed: calcFinalCreditRedeemed,
            /* V23.5: Stripe Balance Engine cumulative credit totals after this settlement */
            creditUsedTotalAfter,
            creditRedeemedTotalAfter,
            stripeIn: calcStripePayment,
            providerOut: calcProviderPayout,
            stripeNet: calcStripeNet,
            stripeShortfall: calcStripeShortfall,
            stripePayoutPushed: calcStripePayoutPushed,
            stripePushedNet: calcStripeNetPushed,
            /* V23.4: deducted in the UI balance only, never pushed to the Stripe account */
            stripeUiOnly: calcStripeUiOnly,
            balanceBefore: stripeBefore,
            balanceAfter: stripeAfter,
            originalBalance: stripeOriginalRef.current,
            pendingAfter,
            mode: syncMode,
          };
          setStripeLogs((l) => [{ id: "local_" + nowMs, ...logEntry }, ...l]);
          writeSettlementLog(logEntry);
          if (bk) {
            setSettledKeys((ks) => (ks.includes(bk.key) ? ks : [...ks, bk.key]));
            /* FIX V23.6: remember the exact credit used for this booking so every board keeps showing it */
            setSettledCreditMap((m) => ({ ...m, [bk.key]: calcCreditUsed }));
            if (calcCreditUsed > 0) setRedeemedAtMap((m) => ({ ...m, [bk.key]: nowMs }));
            markBookingSettled(selectedSettleCust.id, bk.docId, {
              creditUsed: calcCreditUsed,
              creditRedeemed: calcCreditRedeemed,
              stripePayment: calcStripePayment,
              providerPayout: calcProviderPayout,
              providerPayoutPushed: calcStripePayoutPushed,
              ugRevenue: calcUgRevenue,
              ledgerDeduction: calcMarketingLedgerDeduction,
              stripeNet: calcStripeNet,
              stripeShortfall: calcStripeShortfall,
            }).catch((e) => console.warn("Could not flag booking as settled in Firestore:", e));
          }
          setReceipt({
            title: "Booking Settlement Final Reconciled",
            subtitle: `Calculated according to standard marketing ledger formula`,
            tone: "ok",
            icon: "✓",
            rows: [
              ["Customer", `${selectedSettleCust.customerName} (${selectedSettleCust.id})`],
              ["Booking Reference", refLabel],
              ["Credit Redeemed On", calcCreditUsed > 0 ? dateLabelOf(nowMs, "") : "—"],
              ["Service Price", gbp(numServicePrice)],
              ["Credit Used (MIN)", "- " + gbp(calcCreditUsed)],
              ["Credit Redeemed (this settlement)", gbp(calcCreditRedeemed)],
              ["Previously Redeemed Credit", gbp(prevCreditRedeemed)],
              ["Total Credit Redeemed (cumulative)", gbp(calcFinalCreditRedeemed)],
              ["Customer Payment (Price - Credit)", gbp(calcCustomerPayment)],
              ["Stripe Payment (Received)", gbp(calcStripePayment)],
              ["Provider Payout (total obligation)", "- " + gbp(calcProviderPayout)],
              ["Provider Payout pushed to Stripe account", "- " + gbp(calcStripePayoutPushed)],
              ["Extra Deducted from Stripe Balance (UI only, not in Stripe)", "- " + gbp(calcStripeShortfall)],
              ["Net Stripe Impact (UI balance)", gbp(calcStripeNet)],
              ["Net Pushed to Stripe Account", gbp(calcStripeNetPushed)],
              ["Original Stripe Balance", gbp(stripeOriginalRef.current)],
              ["Stripe Balance Before", gbp(stripeBefore)],
              ["Stripe Balance After (" + syncMode + ")", gbp(stripeAfter)],
              ["Stripe Pending Balance", gbp(pendingAfter)],
              ["UG Revenue (Price - Provider Payout)", gbp(calcUgRevenue)],
              ["Marketing Ledger Deduction", "- " + gbp(calcMarketingLedgerDeduction)],
              ["Previous Ledger Balance", gbp(prevLedgerBalance)],
              ["Final Marketing Ledger Balance", gbp(calcMarketingLedgerBalance)],
            ],
          });
          setBookingRefInput("");
          setErr("");
          setModal("receipt");
        };
        const submitCampaign = (ev) => {
          ev.preventDefault();
          const amt = parseFloat(gf.budget);
          if (!gf.name.trim()) return setErr("Campaign identifier name is required.");
          if (!amt || amt <= 0) return setErr("Please provide a budget greater than 0.");
          if (amt > available) return setErr(`Budget exceeds available balance of ${gbp(available)}.`);
          addEntry({
            t: "Debit",
            a: -amt,
            desc: "Campaign budget allocation",
            rel: `${gf.name.trim()} (${gf.channel})`,
            title: "Campaign Spend",
            sub: gf.name.trim(),
            i: "📣",
          });
          setLocalSpent((s) => s + amt);
          setGf({ name: "", budget: "", channel: "Google Ads" });
          setReceipt({
            title: "Promotional Campaign Deployed",
            subtitle: "Budget has been reserved and credited to marketing channel",
            tone: "info",
            icon: "🚀",
            rows: [
              ["Campaign Name", gf.name.trim()],
              ["Target Marketing Channel", gf.channel],
              ["Reserved Budget Cap", "- " + gbp(amt)],
              ["Timestamp", nowLabel()],
              ["Remaining Available", gbp(available - amt)],
            ],
          });
          setErr("");
          setModal("receipt");
        };
        const exportCsv = (customRows = null, filename = null) => {
          const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
          const rowsToExport = customRows || entries;
          const head = ["Date", "Type", "Description", "Related To", "Amount", "Balance"];
          const body = rowsToExport.map((e) => [e.d, e.t, e.desc, e.rel, e.a, e.b]);
          const csv = [head, ...body].map((r) => r.map(esc).join(",")).join("\n");
          const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8;" }));
          const a = document.createElement("a");
          a.href = url;
          a.download = filename || `marketing-ledger-${new Date().toISOString().slice(0, 10)}.csv`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
          showToast("CSV report exported successfully");
        };
        /* Filtered Main Ledger */
        const filteredEntries = _useMemo(() => {
          const s = q.trim().toLowerCase();
          const minA = ledgerMinAmt !== "" ? parseFloat(ledgerMinAmt) : null;
          const maxA = ledgerMaxAmt !== "" ? parseFloat(ledgerMaxAmt) : null;
          return entries
            .filter((e) => {
              if (filter !== "All" && e.t !== filter) return false;
              if (s && ![e.desc, e.rel, e.d, e.t].some((f) => String(f).toLowerCase().includes(s))) return false;
              const absVal = Math.abs(e.a);
              if (minA !== null && !isNaN(minA) && absVal < minA) return false;
              if (maxA !== null && !isNaN(maxA) && absVal > maxA) return false;
              return true;
            })
            .sort((a, b) => {
              if (ledgerSort === "amount-desc") return Math.abs(b.a) - Math.abs(a.a);
              if (ledgerSort === "amount-asc") return Math.abs(a.a) - Math.abs(b.a);
              if (ledgerSort === "date-asc") return a.id - b.id;
              return b.id - a.id;
            });
        }, [entries, filter, q, ledgerMinAmt, ledgerMaxAmt, ledgerSort]);
        /* Filtered Stream entries on sidebar */
        const filteredStream = _useMemo(() => {
          const s = streamQ.trim().toLowerCase();
          return entries
            .filter((e) => {
              if (streamFilter !== "All" && e.t !== streamFilter) return false;
              if (s && ![e.desc, e.rel, e.title, e.sub].some((f) => String(f).toLowerCase().includes(s))) return false;
              return true;
            })
            .slice(0, 5);
        }, [entries, streamFilter, streamQ]);
        const toggleLine = (k) => setHidden((h) => (h.includes(k) ? h.filter((x) => x !== k) : [...h, k]));
        const R = RANGES[range];
        const parsedCreditAmt = parseFloat(cf.amount) || 0;
        const previewNewAvailable = available + parsedCreditAmt;
        const parsedCampaignAmt = parseFloat(gf.budget) || 0;
        const previewRemainingAfterCampaign = available - parsedCampaignAmt;
        const creditTarget = custData?.customers.find((c) => c.id === cf.customerId);
        /* ---------- Stat Modals with High-Powered Filters ---------- */
        const renderStatModal = () => {
          if (!modal || !modal.startsWith("stat:")) return null;
          const k = modal.slice(5);
          /* BOOKINGS VIEW MODAL */
          if (k === "bookings") {
            const needle = bookingQ.trim().toLowerCase();
            const view = bookingView || "all";
            // Extract unique metadata for filter dropdowns
            const allServices = Array.from(new Set(autoSettle.rows.map((r) => r.serviceName).filter((v) => v && v !== "—")));
            const allProviders = Array.from(new Set(autoSettle.rows.map((r) => r.providerName).filter((v) => v && v !== "—")));
            const allStatuses = Array.from(new Set(autoSettle.rows.map((r) => r.status).filter(Boolean)));
            const money = (h, get, o = {}) => ({
              h,
              tar: true,
              key: !!o.key,
              cls: "font-numeric " + (o.cls || ""),
              style: o.style,
              sum: get,
              minus: !!o.minus,
              r: o.r || ((r) => (o.minus ? "- " : "") + gbp(get(r))),
            });
            const colDefs = {
              bookingId: { h: "Booking ID", key: true, cls: "cell-doc-id", r: (r) => <span className="doc-pill" title={r.docId}>{r.bookingId}</span> },
              providerPayout: money("Provider Payout", (r) => r.providerPayout, {
                key: true,
                cls: "font-semibold",
                r: (r) => <span title={`provider_payout_amount source: ${r.payoutSource}`}>{gbp(r.providerPayout)}</span>,
              }),
              customerTotal: money("Customer Total Amount", (r) => r.customerTotalAmount, { key: true, cls: "font-semibold" }),
              servicePrice: money("Service Price", (r) => r.calc.servicePrice, { key: true, cls: "font-semibold" }),
              ugRevenue: money("UG Revenue", (r) => r.ugRevenue, { key: true, cls: "font-semibold col-pos" }),
              customer: {
                h: "Customer",
                cls: "cell-desc",
                r: (r) => (
                  <div>
                    <span className="cust-avatar-pill">👤</span> <strong>{r.customerName}</strong>
                    <small style={{ display: "block", color: "#64748b", fontSize: "11px" }}>{r.customerId}</small>
                  </div>
                ),
              },
              service: { h: "Service", r: (r) => r.serviceName },
              provider: { h: "Provider", r: (r) => r.providerName },
              date: { h: "Date", cls: "cell-date", r: (r) => r.dateLabel },
              redeemedOn: { h: "Redeemed On", cls: "cell-date", r: (r) => (r.redeemedMs ? dateLabelOf(r.redeemedMs, "") : "—") },
              status: { h: "Status", r: (r) => <span className="booking-pill">{r.status}</span> },
              source: { h: "Payout Source", r: (r) => <span className="booking-pill source">{r.payoutSource}</span> },
              creditUsed: money("Credit Used", (r) => r.calc.creditUsed, { cls: "col-neg" }),
              creditRedeemed: money("Credit Redeemed", (r) => r.calc.creditRedeemed, { cls: "col-neg" }),
              stripe: money("Stripe Payment", (r) => r.calc.stripePayment, { style: { color: "#0747A6" } }),
              stripeNet: money("Net Stripe Impact", (r) => r.calc.stripeNet, {
                key: true,
                cls: "font-semibold",
                r: (r) => <span className={r.calc.stripeNet < 0 ? "col-neg" : "col-pos"}>{gbp(r.calc.stripeNet)}</span>,
              }),
              stripeShort: money("Extra From Stripe (UI only)", (r) => r.calc.stripeShortfall, { cls: "col-neg" }),
              deduction: money("Ledger Deduction", (r) => r.calc.ledgerDeduction, { cls: "col-neg", minus: true }),
              settlement: {
                h: "Settlement",
                r: (r) => (
                  <span className={`status-pill ${r.settled ? "credit" : "pending"}`}>
                    <span className="dot" /> {r.settled ? "Settled" : "Pending"}
                  </span>
                ),
              },
              action: {
                h: "Action",
                r: (r) => (
                  <button
                    type="button"
                    className="btn-action-settle"
                    disabled={r.settled}
                    onClick={(e) => {
                      e.stopPropagation();
                      openSettleFor(r.customerId, r.key);
                    }}
                  >
                    {r.settled ? "Reconciled" : "Settle"}
                  </button>
                ),
              },
            };
            /* Focused views (opened from the Live Settlement Matrix tiles) show ONLY the data
               relevant to the clicked tile: its own column, its own total, and its own amount filter. */
            const viewDefs = {
              all: {
                title: "Customer Bookings — Comprehensive Audit",
                cols: ["bookingId", "providerPayout", "customerTotal", "ugRevenue", "customer", "service", "provider", "date", "redeemedOn", "status", "creditUsed", "creditRedeemed", "stripe", "stripeNet", "deduction", "settlement", "action"],
                focused: false,
                metricLabel: "Customer Total",
                metric: (r) => r.customerTotalAmount,
              },
              servicePrice: {
                title: "Service Price — Booking Stream",
                cols: ["bookingId", "customer", "servicePrice"],
                focused: true,
                metricLabel: "Service Price",
                metric: (r) => r.calc.servicePrice,
              },
              creditUsed: {
                title: "Credit Used — By Booking",
                cols: ["bookingId", "customer", "redeemedOn", "creditUsed"],
                focused: true,
                metricLabel: "Credit Used",
                metric: (r) => r.calc.creditUsed,
                badgeCls: "col-neg",
              },
              creditRedeemed: {
                title: "Credit Redeemed — Settled Bookings",
                cols: ["bookingId", "customer", "redeemedOn", "creditRedeemed"],
                settledOnly: true,
                focused: true,
                metricLabel: "Credit Redeemed",
                metric: (r) => r.calc.creditRedeemed,
                badgeCls: "col-neg",
              },
              stripePayment: {
                title: "Stripe Payment — By Booking",
                cols: ["bookingId", "customer", "stripe"],
                focused: true,
                metricLabel: "Stripe Payment",
                metric: (r) => r.calc.stripePayment,
                badgeStyle: { color: "#0747A6" },
              },
              providerPayout: {
                title: "Provider Payout Liabilities",
                cols: ["bookingId", "customer", "provider", "providerPayout"],
                focused: true,
                metricLabel: "Provider Payout",
                metric: (r) => r.providerPayout,
              },
              ugRevenue: {
                title: "UG Platform Revenue Share",
                cols: ["bookingId", "customer", "ugRevenue"],
                focused: true,
                metricLabel: "UG Revenue",
                metric: (r) => r.ugRevenue,
                badgeCls: "col-pos",
              },
              ledger: {
                title: "Pending Ledger Impact — Unsettled Bookings",
                cols: ["bookingId", "customer", "deduction", "action"],
                pendingOnly: true,
                focused: true,
                metricLabel: "Pending Ledger Deduction",
                metric: (r) => r.calc.ledgerDeduction,
                badgeCls: "col-neg",
              },
              stripeNet: {
                title: "Net Stripe Impact — Customer Payment vs Provider Payout",
                cols: ["bookingId", "customer", "stripe", "providerPayout", "stripeShort", "stripeNet"],
                focused: true,
                metricLabel: "Net Stripe Impact",
                metric: (r) => r.calc.stripeNet,
              },
              pendingStripe: {
                title: "Pending Stripe Receipts — Unsettled Bookings",
                cols: ["bookingId", "customer", "stripe", "action"],
                pendingOnly: true,
                focused: true,
                metricLabel: "Pending Stripe Receipt",
                metric: (r) => r.calc.stripePayment,
                badgeStyle: { color: "#0747A6" },
              },
              pendingProvider: {
                title: "Pending Provider Payouts (from Stripe Balance)",
                cols: ["bookingId", "customer", "provider", "providerPayout", "action"],
                pendingOnly: true,
                focused: true,
                metricLabel: "Pending Provider Payout",
                metric: (r) => r.providerPayout,
                badgeCls: "col-neg",
              },
            };
            const vd = viewDefs[view] || viewDefs.all;
            const focused = !!vd.focused;
            const cols = vd.cols.map((id) => ({ id, ...colDefs[id] }));
            // Multi-criteria filtering
            const minAmt = bookingMinAmount !== "" ? parseFloat(bookingMinAmount) : null;
            const maxAmt = bookingMaxAmount !== "" ? parseFloat(bookingMaxAmount) : null;
            const dFrom = dateInputToMs(bookingDateFrom, false);
            const dTo = dateInputToMs(bookingDateTo, true);
            /* FIX V23.6: Credit Redeemed filters/sorts by its real redemption date (settled only);
               Credit Used falls back to the booking date for pending bookings. */
            const dateKey = (r) =>
              (view === "creditRedeemed" ? r.redeemedMs : view === "creditUsed" ? r.redeemedMs || r.dateMs : r.dateMs) || 0;
            const rows = autoSettle.rows
              .filter((r) => !bookingCustFilter || r.customerId === bookingCustFilter)
              .filter((r) => !vd.pendingOnly || !r.settled)
              .filter((r) => !vd.settledOnly || r.settled)
              .filter((r) => {
                if (!focused) {
                  if (bookingStatusFilter !== "all" && r.status.toLowerCase() !== bookingStatusFilter.toLowerCase()) return false;
                  if (bookingSettlementFilter === "settled" && !r.settled) return false;
                  if (bookingSettlementFilter === "pending" && r.settled) return false;
                  if (bookingServiceFilter !== "all" && r.serviceName !== bookingServiceFilter) return false;
                  if (bookingProviderFilter !== "all" && r.providerName !== bookingProviderFilter) return false;
                }
                if (dFrom !== null || dTo !== null) {
                  const t = dateKey(r);
                  if (!t) return false;
                  if (dFrom !== null && t < dFrom) return false;
                  if (dTo !== null && t > dTo) return false;
                }
                const mv = vd.metric(r);
                if (minAmt !== null && !isNaN(minAmt) && mv < minAmt) return false;
                if (maxAmt !== null && !isNaN(maxAmt) && mv > maxAmt) return false;
                if (
                  needle &&
                  ![r.bookingId, r.docId, r.customerName, r.customerEmail, r.customerId, r.serviceName, r.providerName, r.status, r.dateLabel]
                    .join(" ")
                    .toLowerCase()
                    .includes(needle)
                ) {
                  return false;
                }
                return true;
              })
              .sort((a, b) => {
                const da = dateKey(a), db2 = dateKey(b);
                if (bookingSortBy === "date-asc") return da - db2;
                if (bookingSortBy === "amount-desc") return vd.metric(b) - vd.metric(a);
                if (bookingSortBy === "amount-asc") return vd.metric(a) - vd.metric(b);
                if (bookingSortBy === "credit-desc") {
                  return focused ? vd.metric(b) - vd.metric(a) : b.calc.creditUsed - a.calc.creditUsed;
                }
                return db2 - da;
              });
            const sum = (f) => rows.reduce((a, r) => a + f(r), 0);
            const tot = {
              customerTotal: sum((r) => r.customerTotalAmount),
              servicePrice: sum((r) => r.calc.servicePrice),
              providerPayout: sum((r) => r.providerPayout),
              ugRevenue: sum((r) => r.ugRevenue),
              creditUsed: sum((r) => r.calc.creditUsed),
              creditRedeemed: sum((r) => r.calc.creditRedeemed),
              stripe: sum((r) => r.calc.stripePayment),
              deduction: sum((r) => r.calc.ledgerDeduction),
              metric: sum((r) => vd.metric(r)),
            };
            const filterCust = (custData?.customers || []).find((c) => c.id === bookingCustFilter);
            const activeFilterCount = focused
              ? [
                  bookingCustFilter ? 1 : 0,
                  bookingMinAmount !== "" ? 1 : 0,
                  bookingMaxAmount !== "" ? 1 : 0,
                  bookingDateFrom ? 1 : 0,
                  bookingDateTo ? 1 : 0,
                  bookingQ ? 1 : 0,
                ].reduce((a, b) => a + b, 0)
              : [
                  bookingCustFilter ? 1 : 0,
                  bookingStatusFilter !== "all" ? 1 : 0,
                  bookingSettlementFilter !== "all" ? 1 : 0,
                  bookingServiceFilter !== "all" ? 1 : 0,
                  bookingProviderFilter !== "all" ? 1 : 0,
                  bookingMinAmount !== "" ? 1 : 0,
                  bookingMaxAmount !== "" ? 1 : 0,
                  bookingDateFrom ? 1 : 0,
                  bookingDateTo ? 1 : 0,
                  bookingQ ? 1 : 0,
                ].reduce((a, b) => a + b, 0);
            const clearBookingFilters = () => {
              setBookingQ("");
              setBookingCustFilter("");
              setBookingStatusFilter("all");
              setBookingSettlementFilter("all");
              setBookingServiceFilter("all");
              setBookingProviderFilter("all");
              setBookingMinAmount("");
              setBookingMaxAmount("");
              setBookingDateFrom("");
              setBookingDateTo("");
              setBookingSortBy("date-desc");
            };
            return (
              <ModalDialog
                title={vd.title}
                subtitle={
                  filterCust
                    ? `Filtered for ${filterCust.customerName} (${filterCust.id}) · users/MyBooking`
                    : focused
                    ? `Showing only ${vd.metricLabel} data per booking`
                    : "Real-time query engine across all customer bookings"
                }
                icon="📅"
                onClose={closeModal}
                wide
              >
                {customerErr && <div className="ml-err-banner mb-4">⚠️ {customerErr}</div>}
                {/* Filter Control Console */}
                <div className="ml-filter-panel">
                  <div className="filter-row primary">
                    <div className="ml-search-input-wrap">
                      <span className="ml-search-ico">🔍</span>
                      <input
                        className="input-search"
                        type="search"
                        placeholder={
                          focused
                            ? "Search booking ID, customer name, email..."
                            : "Search booking ID, customer name, email, service, provider..."
                        }
                        value={bookingQ}
                        onChange={(e) => setBookingQ(e.target.value)}
                      />
                    </div>
                    <div className="filter-select-group">
                      {!focused && (
                        <select value={bookingSettlementFilter} onChange={(e) => setBookingSettlementFilter(e.target.value)}>
                          <option value="all">Settlement: All</option>
                          <option value="pending">Pending Only</option>
                          <option value="settled">Settled Only</option>
                        </select>
                      )}
                      {!focused && (
                        <select value={bookingStatusFilter} onChange={(e) => setBookingStatusFilter(e.target.value)}>
                          <option value="all">Status: All</option>
                          {allStatuses.map((s) => (
                            <option key={s} value={s}>{s}</option>
                          ))}
                        </select>
                      )}
                      <select value={bookingSortBy} onChange={(e) => setBookingSortBy(e.target.value)}>
                        <option value="date-desc">Newest First</option>
                        <option value="date-asc">Oldest First</option>
                        <option value="amount-desc">{focused ? `${vd.metricLabel}: High to Low` : "Total: High to Low"}</option>
                        <option value="amount-asc">{focused ? `${vd.metricLabel}: Low to High` : "Total: Low to High"}</option>
                        {!focused && <option value="credit-desc">Credit Used: High to Low</option>}
                      </select>
                    </div>
                  </div>
                  <div className="filter-row secondary">
                    {!focused && (
                      <div className="filter-field-inline">
                        <label>Service:</label>
                        <select value={bookingServiceFilter} onChange={(e) => setBookingServiceFilter(e.target.value)}>
                          <option value="all">All Services</option>
                          {allServices.map((s) => (
                            <option key={s} value={s}>{s}</option>
                          ))}
                        </select>
                      </div>
                    )}
                    {!focused && (
                      <div className="filter-field-inline">
                        <label>Provider:</label>
                        <select value={bookingProviderFilter} onChange={(e) => setBookingProviderFilter(e.target.value)}>
                          <option value="all">All Providers</option>
                          {allProviders.map((p) => (
                            <option key={p} value={p}>{p}</option>
                          ))}
                        </select>
                      </div>
                    )}
                    <div className="filter-field-inline">
                      <label>{focused ? `${vd.metricLabel} (£):` : "Amount (£):"}</label>
                      <input
                        type="number"
                        placeholder="Min"
                        className="input-mini"
                        value={bookingMinAmount}
                        onChange={(e) => setBookingMinAmount(e.target.value)}
                      />
                      <span>–</span>
                      <input
                        type="number"
                        placeholder="Max"
                        className="input-mini"
                        value={bookingMaxAmount}
                        onChange={(e) => setBookingMaxAmount(e.target.value)}
                      />
                    </div>
                    <div className="filter-field-inline">
                      <label>{(view === "creditUsed" || view === "creditRedeemed") ? "Redeemed on:" : "Date:"}</label>
                      <input
                        type="date"
                        className="input-mini"
                        style={{ width: 140 }}
                        value={bookingDateFrom}
                        onChange={(e) => setBookingDateFrom(e.target.value)}
                      />
                      <span>–</span>
                      <input
                        type="date"
                        className="input-mini"
                        style={{ width: 140 }}
                        value={bookingDateTo}
                        onChange={(e) => setBookingDateTo(e.target.value)}
                      />
                    </div>
                    <FilterClearButton onClear={clearBookingFilters} count={activeFilterCount} />
                    <button type="button" className="btn-secondary ml-auto-btn" onClick={loadCustomers} disabled={custLoading}>
                      {custLoading ? "Scanning…" : "↻ Rescan Data"}
                    </button>
                  </div>
                </div>
                {/* Filter Badges summary */}
                {focused ? (
                  <div className="ml-stat-badge-row" style={{ gridTemplateColumns: "repeat(2, 1fr)" }}>
                    <div className="ml-stat-badge">
                      <span className="badge-lbl">Matching Bookings</span>
                      <span className="badge-val col-highlight">{rows.length}</span>
                    </div>
                    <div className="ml-stat-badge">
                      <span className="badge-lbl">Total {vd.metricLabel}</span>
                      <span className={`badge-val ${vd.badgeCls || ""}`} style={vd.badgeStyle}>
                        {gbp(tot.metric)}
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="ml-stat-badge-row quad">
                    <div className="ml-stat-badge">
                      <span className="badge-lbl">Matching Bookings</span>
                      <span className="badge-val col-highlight">{rows.length}</span>
                    </div>
                    <div className="ml-stat-badge">
                      <span className="badge-lbl">Customer Total</span>
                      <span className="badge-val">{gbp(tot.customerTotal)}</span>
                    </div>
                    <div className="ml-stat-badge">
                      <span className="badge-lbl">Credit Used / Redeemed</span>
                      <span className="badge-val col-neg">{gbp(tot.creditUsed)} / {gbp(tot.creditRedeemed)}</span>
                    </div>
                    <div className="ml-stat-badge">
                      <span className="badge-lbl">Net Stripe Payment</span>
                      <span className="badge-val" style={{ color: "#0747A6" }}>{gbp(tot.stripe)}</span>
                    </div>
                  </div>
                )}
                <div className="ml-modal-table-scroll">
                  <table className="ledger-tbl">
                    <thead>
                      <tr>
                        {cols.map((c) => (
                          <th key={c.id} className={`${c.key ? "th-key" : ""} ${c.tar ? "tar" : ""}`}>
                            {c.h}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {rows.length === 0 ? (
                        <tr>
                          <td colSpan={cols.length} className="tbl-empty">
                            {custLoading ? "Scanning records…" : "No matching bookings match your active filters."}
                          </td>
                        </tr>
                      ) : (
                        rows.map((r) => (
                          <tr key={r.key} className="row-click" onClick={() => openModal("booking", r)}>
                            {cols.map((c) => (
                              <td key={c.id} className={`${c.key ? "td-key" : ""} ${c.tar ? "tar" : ""} ${c.cls || ""}`} style={c.style}>
                                {c.r(r)}
                              </td>
                            ))}
                          </tr>
                        ))
                      )}
                    </tbody>
                    {rows.length > 0 && (
                      <tfoot>
                        <tr>
                          {cols.map((c, i) => (
                            <td key={c.id} className={`${c.tar ? "tar" : ""} ${c.cls || ""}`} style={c.style}>
                              {i === 0 ? `Totals (${rows.length})` : c.sum ? `${c.minus ? "- " : ""}${gbp(sum(c.sum))}` : ""}
                            </td>
                          ))}
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div>
                <div className="ml-modal-footer">
                  <span className="text-muted" style={{ marginRight: "auto", fontSize: "12px" }}>
                    Filtered {rows.length} of {autoSettle.rows.length} total booking documents
                  </span>
                  <button type="button" className="btn-secondary" onClick={closeModal}>
                    Close
                  </button>
                </div>
              </ModalDialog>
            );
          }
          /* CUSTOMER DOMAIN MODALS (Allocated, Redeemed, Expired, Available, Spent, Customers) */
          if (["customers", "allocated", "redeemed", "expired", "credits", "spent", "available"].includes(k)) {
            const needle = custQ.toLowerCase();
            const cl = custData?.customers || [];
            // Unique filters
            const allLocations = Array.from(new Set(cl.map((c) => c.location).filter((l) => l && l !== "—")));
            const allRoles = Array.from(new Set(cl.map((c) => c.role).filter(Boolean)));
            const m = (h, get, cls = "") => ({
              h,
              tar: true,
              cls: `font-numeric font-semibold ${cls}`,
              r: (c) => gbp(get(c)),
            });
            const cc = {
              docId: { h: "Doc ID", cls: "cell-doc-id", r: (c) => <span className="doc-pill" title={c.id}>{c.id}</span> },
              customer: {
                h: "Customer",
                cls: "cell-desc",
                r: (c) => (
                  <div>
                    <span className="cust-avatar-pill">👤</span> <strong>{c.customerName}</strong>
                    <small style={{ display: "block", color: "#64748b", fontSize: "11px" }}>{c.email}</small>
                  </div>
                ),
              },
              phone: { h: "Phone", r: (c) => c.phone },
              location: { h: "Location", r: (c) => c.location },
              role: {
                h: "Role",
                r: (c) => (
                  <span className="status-pill credit">
                    <span className="dot" /> {c.role}
                  </span>
                ),
              },
              joined: { h: "Joined", cls: "cell-date", r: (c) => c.createdAt },
              lastRedeemed: { h: "Last Redeemed", cls: "cell-date", r: (c) => (c.lastRedeemedMs ? c.lastRedeemedLabel : "—") },
              bookings: {
                h: "Bookings",
                tar: true,
                cls: "font-numeric font-semibold",
                r: (c) => (
                  <button
                    type="button"
                    className="booking-btn"
                    title="Open detailed MyBooking records for this customer"
                    onClick={() => openBookings(c.id)}
                  >
                    📅 {c.bookingsCount}
                  </button>
                ),
              },
              allocated: m("Allocated", (c) => c.marketingCreditAllocated, "col-pos"),
              lifetime: m("Lifetime Issued", (c) => c.marketingLifetimeIssued),
              available: m("Available", (c) => c.marketingAvailableCredits, "col-bal"),
              existing: m("Existing Credits", (c) => c.marketingExistingCredits),
              redeemed: m("Redeemed", (c) => c.marketingCreditRedeemed, "col-neg"),
              redeemedCount: { h: "Redeemed Count", tar: true, cls: "font-numeric font-semibold", r: (c) => c.marketingCreditsRedeemedCount },
              expired: m("Expired", (c) => c.marketingCreditExpired, "text-muted"),
              spent: m("Total Spent", (c) => c.marketingTotalSpent, "text-muted"),
              actions: {
                h: "Actions",
                r: (c) => (
                  <div style={{ display: "flex", gap: "6px" }}>
                    <button type="button" className="btn-secondary" style={{ padding: "4px 8px", fontSize: "11.5px" }} onClick={() => openCreditFor(c.id)}>
                      + Credit
                    </button>
                    <button type="button" className="btn-secondary" style={{ padding: "4px 8px", fontSize: "11.5px", background: "#ecfeff" }} onClick={() => openSettleFor(c.id)}>
                      Settle
                    </button>
                  </div>
                ),
              },
            };
            const cv = {
              customers: {
                title: "Active Customer Registry",
                subtitle: "Profiles, locations, credit portfolios and booking frequency",
                icon: "👥",
                empty: "No matching customers found.",
                cols: ["docId", "customer", "phone", "location", "role", "joined", "bookings", "available", "redeemed", "expired", "lastRedeemed", "actions"],
                rel: () => true,
                metric: (c) => c.marketingAvailableCredits,
              },
              allocated: {
                title: "Allocated Promotional Credits",
                subtitle: "Explicit marketing credits granted to customer accounts",
                icon: "📥",
                empty: "No customers have allocated credit.",
                cols: ["docId", "customer", "allocated", "lifetime", "actions"],
                rel: (c) => c.marketingCreditAllocated > 0,
                metric: (c) => c.marketingCreditAllocated,
              },
              redeemed: {
                title: "Redeemed Promotional Credits",
                subtitle: "Credit volume claimed during service booking checkout",
                icon: "🏷️",
                empty: "No customers have redeemed credit.",
                cols: ["docId", "customer", "redeemed", "redeemedCount", "lastRedeemed", "bookings"],
                rel: (c) => c.marketingCreditRedeemed > 0 || c.marketingCreditsRedeemedCount > 0,
                metric: (c) => c.marketingCreditRedeemed,
              },
              expired: {
                title: "Expired Marketing Credits",
                subtitle: "Unused promotional balances past their validity timestamp",
                icon: "⏳",
                empty: "No customers have expired credit.",
                cols: ["docId", "customer", "expired", "lifetime"],
                rel: (c) => c.marketingCreditExpired > 0,
                metric: (c) => c.marketingCreditExpired,
              },
              available: {
                title: "Spendable Available Balances",
                subtitle: "Active customer credits ready for direct booking redemption",
                icon: "✨",
                empty: "No customers have available credit.",
                cols: ["docId", "customer", "available", "redeemed", "expired", "existing", "actions"],
                rel: (c) => c.marketingAvailableCredits > 0 || c.marketingExistingCredits > 0,
                metric: (c) => c.marketingAvailableCredits,
              },
              credits: {
                title: "Total Lifetime Issued Volume",
                subtitle: "Cumulative credit history recorded per customer entity",
                icon: "💎",
                empty: "No customers found with issued credit.",
                cols: ["docId", "customer", "lifetime", "allocated", "available", "actions"],
                rel: (c) => c.marketingLifetimeIssued > 0 || c.marketingCreditAllocated > 0 || c.marketingAvailableCredits > 0,
                metric: (c) => c.marketingLifetimeIssued,
              },
              spent: {
                title: "Total Spent & Deducted Ledger",
                subtitle: "Gross deductions recorded against customer balance sheets",
                icon: "💳",
                empty: "No customers have recorded deductions.",
                cols: ["docId", "customer", "spent", "redeemed", "lastRedeemed", "bookings"],
                rel: (c) => c.marketingTotalSpent > 0 || c.marketingCreditRedeemed > 0,
                metric: (c) => c.marketingTotalSpent,
              },
            }[k];
            const cols = cv.cols.map((id) => ({ id, ...cc[id] }));
            // Advanced filtering logic for customers
            const minC = custMinCredit !== "" ? parseFloat(custMinCredit) : null;
            const maxC = custMaxCredit !== "" ? parseFloat(custMaxCredit) : null;
            const cDFrom = dateInputToMs(custDateFrom, false);
            const cDTo = dateInputToMs(custDateTo, true);
            const list = cl
              .filter(cv.rel)
              .filter((c) => {
                if (custLocationFilter !== "all" && c.location !== custLocationFilter) return false;
                if (custRoleFilter !== "all" && c.role.toLowerCase() !== custRoleFilter.toLowerCase()) return false;
                if (custBookingFilter === "has" && c.bookingsCount === 0) return false;
                if (custBookingFilter === "none" && c.bookingsCount > 0) return false;
                if (cDFrom !== null || cDTo !== null) {
                  const t = c.lastRedeemedMs || 0;
                  if (!t) return false;
                  if (cDFrom !== null && t < cDFrom) return false;
                  if (cDTo !== null && t > cDTo) return false;
                }
                const mVal = cv.metric ? cv.metric(c) : c.marketingAvailableCredits;
                if (minC !== null && !isNaN(minC) && mVal < minC) return false;
                if (maxC !== null && !isNaN(maxC) && mVal > maxC) return false;
                if (
                  needle &&
                  ![c.id, c.customerName, c.email, c.phone, c.location].join(" ").toLowerCase().includes(needle)
                ) {
                  return false;
                }
                return true;
              })
              .sort((a, b) => {
                if (custSortBy === "name-asc") return a.customerName.localeCompare(b.customerName);
                if (custSortBy === "name-desc") return b.customerName.localeCompare(a.customerName);
                if (custSortBy === "bookings-desc") return b.bookingsCount - a.bookingsCount;
                if (custSortBy === "credit-desc") {
                  const ma = cv.metric ? cv.metric(a) : a.marketingAvailableCredits;
                  const mb = cv.metric ? cv.metric(b) : b.marketingAvailableCredits;
                  return mb - ma;
                }
                if (custSortBy === "credit-asc") {
                  const ma = cv.metric ? cv.metric(a) : a.marketingAvailableCredits;
                  const mb = cv.metric ? cv.metric(b) : b.marketingAvailableCredits;
                  return ma - mb;
                }
                return 0;
              });
            const activeCustFilters = [
              custQ ? 1 : 0,
              custLocationFilter !== "all" ? 1 : 0,
              custRoleFilter !== "all" ? 1 : 0,
              custBookingFilter !== "all" ? 1 : 0,
              custMinCredit !== "" ? 1 : 0,
              custMaxCredit !== "" ? 1 : 0,
              custDateFrom ? 1 : 0,
              custDateTo ? 1 : 0,
            ].reduce((a, b) => a + b, 0);
            const clearCustFilters = () => {
              setCustQ("");
              setCustLocationFilter("all");
              setCustRoleFilter("all");
              setCustBookingFilter("all");
              setCustMinCredit("");
              setCustMaxCredit("");
              setCustDateFrom("");
              setCustDateTo("");
              setCustSortBy("name-asc");
            };
            return (
              <ModalDialog title={cv.title} subtitle={cv.subtitle} icon={cv.icon} onClose={closeModal} wide>
                {customerErr && <div className="ml-err-banner mb-4">⚠️ {customerErr}</div>}
                {/* Filter Controls Panel */}
                <div className="ml-filter-panel">
                  <div className="filter-row primary">
                    <div className="ml-search-input-wrap">
                      <span className="ml-search-ico">🔍</span>
                      <input
                        className="input-search"
                        type="search"
                        placeholder="Search by doc ID, name, email, phone, location..."
                        value={custQ}
                        onChange={(e) => setCustQ(e.target.value)}
                      />
                    </div>
                    <div className="filter-select-group">
                      <select value={custLocationFilter} onChange={(e) => setCustLocationFilter(e.target.value)}>
                        <option value="all">Location: All</option>
                        {allLocations.map((l) => (
                          <option key={l} value={l}>{l}</option>
                        ))}
                      </select>
                      <select value={custBookingFilter} onChange={(e) => setCustBookingFilter(e.target.value)}>
                        <option value="all">Bookings: All</option>
                        <option value="has">With Bookings</option>
                        <option value="none">Zero Bookings</option>
                      </select>
                      <select value={custSortBy} onChange={(e) => setCustSortBy(e.target.value)}>
                        <option value="name-asc">Name (A–Z)</option>
                        <option value="name-desc">Name (Z–A)</option>
                        <option value="credit-desc">Credit: Highest</option>
                        <option value="credit-asc">Credit: Lowest</option>
                        <option value="bookings-desc">Most Bookings</option>
                      </select>
                    </div>
                  </div>
                  <div className="filter-row secondary">
                    <div className="filter-field-inline">
                      <label>Role:</label>
                      <select value={custRoleFilter} onChange={(e) => setCustRoleFilter(e.target.value)}>
                        <option value="all">All Roles</option>
                        {allRoles.map((r) => (
                          <option key={r} value={r}>{r}</option>
                        ))}
                      </select>
                    </div>
                    <div className="filter-field-inline">
                      <label>Credit Range (£):</label>
                      <input
                        type="number"
                        placeholder="Min"
                        className="input-mini"
                        value={custMinCredit}
                        onChange={(e) => setCustMinCredit(e.target.value)}
                      />
                      <span>–</span>
                      <input
                        type="number"
                        placeholder="Max"
                        className="input-mini"
                        value={custMaxCredit}
                        onChange={(e) => setCustMaxCredit(e.target.value)}
                      />
                    </div>
                    <div className="filter-field-inline">
                      <label>Redeemed on:</label>
                      <input
                        type="date"
                        className="input-mini"
                        style={{ width: 140 }}
                        value={custDateFrom}
                        onChange={(e) => setCustDateFrom(e.target.value)}
                      />
                      <span>–</span>
                      <input
                        type="date"
                        className="input-mini"
                        style={{ width: 140 }}
                        value={custDateTo}
                        onChange={(e) => setCustDateTo(e.target.value)}
                      />
                    </div>
                    <FilterClearButton onClear={clearCustFilters} count={activeCustFilters} />
                    <button type="button" className="btn-secondary ml-auto-btn" onClick={loadCustomers} disabled={custLoading}>
                      {custLoading ? "Scanning…" : "↻ Rescan Firebase"}
                    </button>
                  </div>
                </div>
                {/* Available / Redeemed / Expired summary for the filtered list */}
                <div className="ml-stat-badge-row">
                  <div className="ml-stat-badge">
                    <span className="badge-lbl">Available</span>
                    <span className="badge-val col-pos">{gbp(list.reduce((a, c) => a + c.marketingAvailableCredits, 0))}</span>
                  </div>
                  <div className="ml-stat-badge">
                    <span className="badge-lbl">Redeemed</span>
                    <span className="badge-val col-neg">{gbp(list.reduce((a, c) => a + c.marketingCreditRedeemed, 0))}</span>
                  </div>
                  <div className="ml-stat-badge">
                    <span className="badge-lbl">Expired</span>
                    <span className="badge-val">{gbp(list.reduce((a, c) => a + c.marketingCreditExpired, 0))}</span>
                  </div>
                </div>
                <div className="ml-modal-table-scroll">
                  <table className="ledger-tbl">
                    <thead>
                      <tr>
                        {cols.map((c) => (
                          <th key={c.id} className={c.tar ? "tar" : ""}>
                            {c.h}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {list.length === 0 ? (
                        <tr>
                          <td colSpan={cols.length} className="tbl-empty">
                            {custLoading ? "Scanning customers…" : cv.empty}
                          </td>
                        </tr>
                      ) : (
                        list.map((c, idx) => (
                          <tr key={c.id || idx}>
                            {cols.map((col) => (
                              <td key={col.id} className={`${col.tar ? "tar" : ""} ${col.cls || ""}`}>
                                {col.r(c)}
                              </td>
                            ))}
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="ml-modal-footer">
                  <span className="text-muted" style={{ marginRight: "auto", fontSize: "12px" }}>
                    Showing {list.length} of {cl.filter(cv.rel).length} qualified customer accounts
                  </span>
                  <button type="button" className="btn-secondary" onClick={closeModal}>
                    Close
                  </button>
                </div>
              </ModalDialog>
            );
          }
          /* STRIPE MODAL */
          if (k === "stripe") {
            return (
              <ModalDialog title="Stripe Balance Engine" subtitle="Connected Merchant Balance & Reconciliation" icon="🏦" onClose={closeModal} wide>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
                  <span style={{ fontSize: 13, color: "#687386" }}>
                    API Endpoint: <code>{STRIPE_BALANCE_ENDPOINT}</code>
                  </span>
                  <button
                    type="button"
                    className="btn-primary"
                    onClick={loadStripeBalance}
                    disabled={isBalanceLoading}
                    style={{ background: "#0747A6" }}
                  >
                    {isBalanceLoading ? "Refreshing..." : "↻ Refresh Balance"}
                  </button>
                </div>

                {balanceFetchError && (
                  <div className="ml-err-banner mb-4">
                    <strong style={{ fontSize: "15px" }}>Unable to Retrieve Balance</strong>
                    <p style={{ margin: "6px 0", fontSize: "13px" }}>{balanceFetchError}</p>
                    <div style={{ marginTop: "10px", color: "#7d4646", fontSize: "12px" }}>
                      Ensure backend daemon is operating at: <code>http://localhost:5000</code>
                    </div>
                  </div>
                )}
                {isBalanceLoading && !stripeBalanceData && (
                  <div style={{ padding: "40px 20px", textAlign: "center" }}>
                    <div className="spin" style={{ width: 32, height: 32, border: "3px solid #cbd5e1", borderTopColor: "#0747A6", borderRadius: "50%", margin: "0 auto 12px" }} />
                    <p style={{ color: "#687386", fontSize: "14px" }}>Querying live Stripe balance endpoints...</p>
                  </div>
                )}
                {stripeBalanceData && (
                  <>
                    <div
                      className="account-grid"
                      style={{
                        background: "#ffffff",
                        border: "1px solid #edf0f5",
                        borderRadius: "14px",
                        padding: "16px 20px",
                        display: "grid",
                        gridTemplateColumns: "2fr 1fr 1fr",
                        gap: "16px",
                        marginBottom: "20px",
                      }}
                    >
                      <div>
                        <span style={labelStyle}>Connected Account</span>
                        <strong style={{ fontSize: "14px" }}>{stripeBalanceData.accountId}</strong>
                      </div>
                      <div>
                        <span style={labelStyle}>Currency</span>
                        <strong>{stripeBalanceData.currency}</strong>
                      </div>
                      <div>
                        <span style={labelStyle}>Status</span>
                        <strong style={{ color: "#16834a" }}>● Connected</strong>
                      </div>
                    </div>
                    <div
                      className="balance-grid"
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                        gap: "16px",
                        marginBottom: "20px",
                      }}
                    >
                      <StripeBalanceCard
                        label="Remaining Balance (settled)"
                        icon="£"
                        value={gbp(stripeEffective)}
                        hint={`After all settled payouts & receipts · Stripe reports ${stripeApiAvailable !== null ? gbp(stripeApiAvailable) : "—"}`}
                      />
                      <StripeBalanceCard
                        label="Pending Balance"
                        icon="◷"
                        value={gbp(stripePendingProjected)}
                        hint={`Stripe pending ${gbp(stripeApiPending)} + ${gbp(at.pendingStripeIn)} receipts from ${at.pendingCount} unsettled bookings · provider payouts due ${gbp(at.pendingProviderOut)}`}
                      />
                      <StripeBalanceCard
                        label="Remaining After All Deductions"
                        icon="£"
                        value={gbp(stripeProjected)}
                        hint="Settled balance + pending receipts − pending provider payouts"
                        valueColor="#0747A6"
                      />
                    </div>
                    {/* V23.5: Credit Used + Credit Redeemed in the Stripe Balance Engine */}
                    <div
                      className="balance-grid"
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                        gap: "16px",
                        marginBottom: "20px",
                      }}
                    >
                      <StripeBalanceCard
                        label="Credit Used (settled)"
                        icon="🏷"
                        value={gbp(stripeLoggedCreditUsed)}
                        hint={`Credit applied across ${stripeLogs.length} recorded settlements · pending on ${at.pendingCount} unsettled bookings: ${gbp(at.pendingDeduction)}`}
                        valueColor="#dc2626"
                      />
                      <StripeBalanceCard
                        label="Credit Redeemed (settled)"
                        icon="✓"
                        value={gbp(stripeLoggedCreditRedeemed)}
                        hint={`Redeemed through settlements · customer records show ${gbp(totals.redeemed)} (${totals.redeemedCount} redemptions)`}
                        valueColor="#dc2626"
                      />
                    </div>
                    <div
                      style={{
                        background: "#ffffff",
                        borderRadius: "14px",
                        padding: "20px",
                        border: "1px solid #edf0f5",
                        marginBottom: "20px",
                      }}
                    >
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                        <div>
                          <h4 style={{ margin: 0, fontSize: "16px", color: "#0f172a" }}>Balance Summary</h4>
                          <p style={{ margin: "4px 0 0", color: "#8993a4", fontSize: "12px" }}>
                            Stripe connected account real-time snapshot
                          </p>
                        </div>
                        <span
                          style={{
                            padding: "4px 10px",
                            borderRadius: "6px",
                            background: "#eef4ff",
                            color: "#0747A6",
                            fontSize: "11px",
                            fontWeight: 700,
                          }}
                        >
                          GBP
                        </span>
                      </div>
                      <SummaryRow label="Remaining (settled) GBP" value={gbp(stripeEffective)} />
                      <SummaryRow label="Pending GBP (Stripe + unsettled receipts)" value={gbp(stripePendingProjected)} />
                      <SummaryRow label="Total GBP" value={gbp(stripeEffective + stripePendingProjected)} last />
                    </div>
                    {/* Settlement reconciliation (ORIGINAL balance is the fixed reference; live balance moves with each settlement) */}
                    <div
                      style={{
                        background: "#ffffff",
                        borderRadius: "14px",
                        padding: "20px",
                        border: "1px solid #edf0f5",
                        marginBottom: "20px",
                      }}
                    >
                      <h4 style={{ margin: "0 0 12px", fontSize: "16px", color: "#0f172a" }}>Settlement Reconciliation</h4>
                      {stripeSyncNote && <div className="ml-err-banner mb-4">⚠️ {stripeSyncNote}</div>}
                      <SummaryRow label="Original Stripe balance (fixed reference, not the live balance)" value={gbp(stripeOriginal)} />
                      <SummaryRow label="Net movement since original (settled)" value={gbp(stripeLoggedNet)} />
                      <SummaryRow label="Remaining balance after settled deductions" value={gbp(stripeEffective)} />
                      <SummaryRow label="Credit Used (settled settlements, cumulative)" value={"- " + gbp(stripeLoggedCreditUsed)} />
                      <SummaryRow label="Credit Redeemed (settled settlements, cumulative)" value={gbp(stripeLoggedCreditRedeemed)} />
                      <SummaryRow label="Credit Used pending (unsettled bookings)" value={"- " + gbp(at.pendingDeduction)} />
                      <SummaryRow label="Credit Redeemed in customer records (Firestore)" value={gbp(totals.redeemed)} />
                      <SummaryRow label="UI-only deductions (extra provider payout, not pushed to Stripe)" value={"- " + gbp(stripeLoggedUiOnly)} />
                      <SummaryRow label="Stripe account balance expected (after pushed movements only)" value={gbp(stripeExpectedAccount)} />
                      <SummaryRow label="Balance reported by Stripe account" value={stripeApiAvailable !== null ? gbp(stripeApiAvailable) : "—"} />
                      <SummaryRow label="Not yet reflected in Stripe account" value={gbp(stripeSyncGap)} />
                      <SummaryRow label="Pending (Stripe API)" value={gbp(stripeApiPending)} />
                      <SummaryRow label="Pending customer receipts (unsettled bookings)" value={"+ " + gbp(at.pendingStripeIn)} />
                      <SummaryRow label="Pending provider payouts from Stripe" value={"- " + gbp(at.pendingProviderOut)} />
                      <SummaryRow label="Projected pending balance (Stripe + unsettled receipts)" value={gbp(stripePendingProjected)} />
                      <SummaryRow label="Projected Stripe balance" value={gbp(stripeProjected)} last />
                    </div>
                    <h4 className="ml-section-subhead">Stripe Settlement Log</h4>
                    <div className="ml-modal-table-scroll" style={{ marginBottom: 20 }}>
                      <table className="ledger-tbl">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Booking</th>
                            <th>Customer</th>
                            <th className="tar">Credit Used</th>
                            <th className="tar">Credit Redeemed</th>
                            <th className="tar">Stripe In</th>
                            <th className="tar">Provider Out</th>
                            <th className="tar">Extra From Stripe (UI only)</th>
                            <th className="tar">Net</th>
                            <th className="tar">Balance Before</th>
                            <th className="tar">Balance After</th>
                            <th>Mode</th>
                          </tr>
                        </thead>
                        <tbody>
                          {stripeLogs.length === 0 ? (
                            <tr>
                              <td colSpan="12" className="tbl-empty">No settlement logs yet.</td>
                            </tr>
                          ) : (
                            stripeLogs.map((l) => (
                              <tr key={l.id}>
                                <td className="cell-date">{dateLabelOf(l.tsMs, "")}</td>
                                <td>{l.bookingId}</td>
                                <td>{l.customerName}</td>
                                <td className="tar font-numeric col-neg">{gbp(l.creditUsed)}</td>
                                <td className="tar font-numeric col-neg">{gbp(l.creditRedeemed !== undefined ? l.creditRedeemed : l.creditUsed)}</td>
                                <td className="tar font-numeric">{gbp(l.stripeIn)}</td>
                                <td className="tar font-numeric col-neg">- {gbp(l.providerOut)}</td>
                                <td className="tar font-numeric col-neg">{gbp(l.stripeShortfall)}</td>
                                <td className={`tar font-numeric font-semibold ${l.stripeNet < 0 ? "col-neg" : "col-pos"}`}>{gbp(l.stripeNet)}</td>
                                <td className="tar font-numeric">{gbp(l.balanceBefore)}</td>
                                <td className="tar font-numeric">{gbp(l.balanceAfter)}</td>
                                <td><span className="booking-pill">{l.mode}</span></td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                    <details style={{ background: "#161b22", borderRadius: "12px", overflow: "hidden", marginBottom: "15px" }}>
                      <summary
                        style={{
                          color: "#ffffff",
                          padding: "12px 16px",
                          cursor: "pointer",
                          fontWeight: 600,
                          fontSize: "13px",
                        }}
                      >
                        Inspect Complete Raw Stripe Payload
                      </summary>
                      <pre
                        style={{
                          margin: 0,
                          padding: "16px",
                          color: "#d7dee9",
                          overflowX: "auto",
                          fontSize: "11.5px",
                          lineHeight: 1.5,
                        }}
                      >
                        {JSON.stringify(stripeBalanceData.rawStripeBalance, null, 2)}
                      </pre>
                    </details>
                  </>
                )}
                <div className="ml-modal-footer">
                  <button type="button" className="btn-secondary" onClick={closeModal}>
                    Close
                  </button>
                </div>
              </ModalDialog>
            );
          }
          return null;
        };
        return (
          <div className="ml-scope">
            <style>{css}</style>
            <div className="dashboard-wrapper">
              <div className="dash-main">
                {/* Header Top-Bar */}
                <div className="top-bar">
                  <div>
                    <div className="badge-pill">Enterprise Fintech Ledger</div>
                    <h1 className="page-heading">Marketing Credit Ledger</h1>
                    <p className="page-sub">Omnichannel promotional allocations, dynamic customer settlements & balance auditing</p>
                  </div>
                  <div className="top-actions">
                    <button
                      type="button"
                      className="btn-secondary btn-refresh-all"
                      onClick={refreshAll}
                      disabled={refreshing || isBalanceLoading || custLoading}
                    >
                      <span className={refreshing || isBalanceLoading || custLoading ? "spin" : ""}>↻</span>{" "}
                      {refreshing || isBalanceLoading || custLoading ? "Syncing Nodes…" : "Sync All"}
                    </button>
                    <div className="dt-container" ref={dateRef}>
                      <button
                        className="btn-date"
                        onClick={() => setDateOpen((o) => !o)}
                        aria-haspopup="listbox"
                        aria-expanded={dateOpen}
                      >
                        <span className="cal-ico">📅</span>
                        <div className="date-labels">
                          <span className="dl-main">{R.label}</span>
                          <span className="dl-sub">{R.sub}</span>
                        </div>
                        <span className="arrow-down">▾</span>
                      </button>
                      {dateOpen && (
                        <ul className="dropdown-popover" role="listbox">
                          {Object.entries(RANGES).map(([k, v]) => (
                            <li key={k}>
                              <button
                                type="button"
                                role="option"
                                aria-selected={range === k}
                                className={`dp-opt ${range === k ? "active" : ""}`}
                                onClick={() => {
                                  setRange(k);
                                  setDateOpen(false);
                                }}
                              >
                                <b>{v.sub}</b>
                                <small>{v.label}</small>
                              </button>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
                {/* KPI Stat Cards */}
                <section className="stats-row">
                  {STATS.map((s, i) => (
                    <div
                      className="dash-card stat-tile clickable"
                      key={s.label}
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        if (s.k === "bookings") openBookings("");
                        else openModal("stat:" + s.k);
                      }}
                      onKeyDown={(e) => {
                        if (e.key !== "Enter") return;
                        if (s.k === "bookings") openBookings("");
                        else openModal("stat:" + s.k);
                      }}
                    >
                      <div className="stat-top">
                        <span className="stat-icon-wrapper">{s.icon}</span>
                        <span className="trend-badge">{s.trend}</span>
                      </div>
                      <div className="stat-body">
                        <span className="stat-label">{s.label}</span>
                        <h2 className="stat-val">{s.display !== undefined ? s.display : gbp(s.value)}</h2>
                        {s.subtext && <span className="stat-subtext font-mono">{s.subtext}</span>}
                        {s.note ? <span className="stat-note">{s.note}</span> : null}
                      </div>
                      <Spark color={s.color} id={"sp_" + i} />
                    </div>
                  ))}
                </section>
                {/* Booking Settlement Reconciler Banner */}
                <div
                  className="dash-card settle-hero-banner"
                  style={{
                    background: "linear-gradient(135deg, #064e3b 0%, #042f2e 100%)",
                    color: "#ffffff",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "22px 28px",
                    flexWrap: "wrap",
                    gap: "16px",
                  }}
                >
                  <div>
                    <span className="hero-pill-tag">
                      Settlement Engine
                    </span>
                    <h3 style={{ margin: "8px 0 4px", fontSize: "19px", color: "#fff", fontWeight: 700 }}>
                      Service Price ➔ Credit Used / Redeemed ➔ Customer Payment ➔ Ledger Deduction
                    </h3>
                    <p style={{ margin: 0, fontSize: "13.5px", color: "#a7f3d0", lineHeight: 1.4 }}>
                      Formula: Credit Used = MIN(Service Price, Available Credit) · Credit Redeemed = Credit Used of settled bookings · Stripe Charge = Service Price − Credit Used · Net Stripe Impact = Stripe Charge − Provider Payout (extra payout is deducted in the UI balance only)
                    </p>
                  </div>
                  <button
                    type="button"
                    className="btn-primary"
                    style={{ background: "#10b981", color: "#064e3b", fontWeight: 700, padding: "11px 22px" }}
                    onClick={() => openModal("reconcile")}
                  >
                    Open Settlement Reconciler →
                  </button>
                </div>
                {/* Live Settlement Summary Table */}
                <section className="dash-card">
                  <div className="table-card-head">
                    <div>
                      <h3>Live Settlement Matrix</h3>
                      <p className="text-muted">
                        Continuous aggregation from all customer bookings · {at.count} bookings ({at.pendingCount} pending, {at.settledCount} settled)
                      </p>
                    </div>
                    <button type="button" className="btn-link" onClick={() => openBookings("")}>
                      Explore All Bookings &rarr;
                    </button>
                  </div>
                  <div className="ml-settle-grid">
                    <div className="ml-settle-tile" onClick={() => openBookings("", "servicePrice")}>
                      <span className="lbl">Service Price</span>
                      <span className="val">{gbp(at.servicePrice)}</span>
                      <span className="hint">Gross transaction volume</span>
                    </div>
                    <div className="ml-settle-tile" onClick={() => openBookings("", "creditUsed")}>
                      <span className="lbl">Credit Used</span>
                      <span className="val col-neg">{gbp(at.creditUsed)}</span>
                      <span className="hint">MIN(Service Price, Available Credit) · settled + pending</span>
                    </div>
                    <div className="ml-settle-tile" onClick={() => openBookings("", "creditRedeemed")}>
                      <span className="lbl">Credit Redeemed</span>
                      <span className="val col-neg">{gbp(at.creditRedeemed)}</span>
                      <span className="hint">Credit redeemed on {at.settledCount} settled bookings</span>
                    </div>
                    <div className="ml-settle-tile" onClick={() => openBookings("", "stripePayment")}>
                      <span className="lbl">Stripe Payment</span>
                      <span className="val" style={{ color: "#0747A6" }}>{gbp(at.stripePayment)}</span>
                      <span className="hint">Net customer card charge</span>
                    </div>
                    <div className="ml-settle-tile" onClick={() => openBookings("", "providerPayout")}>
                      <span className="lbl">Provider Payout</span>
                      <span className="val">{gbp(at.providerPayout)}</span>
                      <span className="hint">Provider obligation share</span>
                    </div>
                    <div className="ml-settle-tile" onClick={() => openBookings("", "ugRevenue")}>
                      <span className="lbl">UG Revenue</span>
                      <span className="val col-pos">{gbp(at.ugRevenue)}</span>
                      <span className="hint">Platform commission</span>
                    </div>
                    <div className="ml-settle-tile" onClick={() => openBookings("", "ledger")}>
                      <span className="lbl">Pending Ledger Impact</span>
                      <span className="val col-neg">- {gbp(at.pendingDeduction)}</span>
                      <span className="hint">From {at.pendingCount} unsettled bookings</span>
                    </div>
                    <div className="ml-settle-tile" onClick={() => openBookings("", "stripeNet")}>
                      <span className="lbl">Net Stripe Impact</span>
                      <span className={`val ${at.stripeNet < 0 ? "col-neg" : "col-pos"}`}>{gbp(at.stripeNet)}</span>
                      <span className="hint">Stripe payment − provider payout (extra from Stripe, UI only: {gbp(at.stripeShortfall)})</span>
                    </div>
                    <div className="ml-settle-tile" onClick={() => openBookings("", "pendingStripe")}>
                      <span className="lbl">Pending Stripe Receipts</span>
                      <span className="val" style={{ color: "#0747A6" }}>{gbp(at.pendingStripeIn)}</span>
                      <span className="hint">From {at.pendingCount} unsettled bookings</span>
                    </div>
                    <div className="ml-settle-tile" onClick={() => openBookings("", "pendingProvider")}>
                      <span className="lbl">Pending Provider Payout</span>
                      <span className="val col-neg">- {gbp(at.pendingProviderOut)}</span>
                      <span className="hint">To be paid from Stripe balance</span>
                    </div>
                  </div>
                  <div className="ml-settle-final">
                    <div>
                      <span className="lbl">Opening Balance</span>
                      <span className="val">{gbp(at.prevLedgerBalance)}</span>
                    </div>
                    <div>
                      <span className="lbl">Projected Ledger Balance</span>
                      <span className="val">{gbp(at.finalLedgerBalance)}</span>
                    </div>
                    <div className={at.reconciled ? "ok" : ""}>
                      <span className="lbl">Formula Integrity</span>
                      <span className="val" style={{ color: at.reconciled ? "#059669" : "#dc2626" }}>
                        {at.reconciled ? "✓ Reconciled Exact" : "⚠ Variance Detected"}
                      </span>
                      <span className="hint">
                        {gbp(at.servicePrice)} = {gbp(at.creditUsed)} credits used + {gbp(at.stripePayment)} Stripe
                      </span>
                    </div>
                    <div>
                      <span className="lbl">Stripe Remaining Balance (settled)</span>
                      <span className="val">{gbp(stripeEffective)}</span>
                      <span className="hint">Original {gbp(stripeOriginal)} · Net settled {gbp(stripeLoggedNet)} · UI-only {gbp(stripeLoggedUiOnly)} · Stripe pending {gbp(stripeApiPending)}</span>
                    </div>
                    <div>
                      <span className="lbl">Remaining After All Deductions</span>
                      <span className="val">{gbp(stripeProjected)}</span>
                      <span className="hint">+{gbp(at.pendingStripeIn)} pending receipts · -{gbp(at.pendingProviderOut)} provider payouts due · pending {gbp(stripePendingProjected)}</span>
                    </div>
                    <div className={at.reconciledStripe ? "ok" : ""}>
                      <span className="lbl">Stripe ↔ Ledger Integrity</span>
                      <span className="val" style={{ color: at.reconciledStripe ? "#059669" : "#dc2626" }}>
                        {at.reconciledStripe ? "✓ Reconciled Exact" : "⚠ Variance Detected"}
                      </span>
                      <span className="hint">UG revenue = Stripe net + credit used</span>
                    </div>
                  </div>
                </section>
                {/* Charts Grid */}
                <section className="charts-grid">
                  <div className="dash-card chart-card clickable" onClick={() => openModal("chart")}>
                    <div className="chart-header">
                      <div>
                        <h3>Cashflow & Balance Trajectory</h3>
                        <p className="text-muted">Net growth across promotional deposits & campaign spend</p>
                      </div>
                      <div className="pill-group" role="tablist" onClick={(e) => e.stopPropagation()}>
                        {Object.keys(RANGES).map((r) => (
                          <button
                            key={r}
                            role="tab"
                            aria-selected={range === r}
                            className={`pill-btn ${range === r ? "active" : ""}`}
                            onClick={() => setRange(r)}
                          >
                            {r}
                          </button>
                        ))}
                      </div>
                    </div>
                    <div className="chart-svg-container">
                      <OverviewChart range={range} hidden={hidden} />
                    </div>
                    <div className="chart-legend" onClick={(e) => e.stopPropagation()}>
                      {LINES.map(([n, c], k) => (
                        <button
                          key={n}
                          type="button"
                          className={`legend-pill ${hidden.includes(k) ? "disabled" : ""}`}
                          onClick={() => toggleLine(k)}
                        >
                          <span className="color-dot" style={{ backgroundColor: c }} />
                          <span>{n}</span>
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="dash-card donut-card">
                    <div className="table-card-head">
                      <div className="card-heading-simple">
                        <h3>Credit Distribution</h3>
                        <p className="text-muted">Originating acquisition channels</p>
                      </div>
                      <button type="button" className="btn-link" onClick={() => openModal("distribution")}>
                        Breakdown &rarr;
                      </button>
                    </div>
                    <div className="donut-content">
                      <Donut dist={dist} active={activeSlice} onPick={setActiveSlice} />
                      <ul className="donut-legend-list">
                        {dist.map((s) => (
                          <li key={s.n} className={activeSlice === s.n ? "item-highlight" : ""}>
                            <button
                              type="button"
                              className="btn-slice-select"
                              onClick={() => setActiveSlice(activeSlice === s.n ? null : s.n)}
                            >
                              <span className="color-dot" style={{ backgroundColor: s.c }} />
                              <span className="slice-name">{s.n}</span>
                            </button>
                            <span className="slice-val font-numeric">{gbp(s.v).replace(".00", "")}</span>
                            <span className="slice-pct">{((s.v / distTotal) * 100).toFixed(0)}%</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </section>
                {/* Latest Entries with Inline Filtering */}
                <section className="dash-card">
                  <div className="table-card-head">
                    <div>
                      <h3>Ledger Activity & Audit Stream</h3>
                      <p className="text-muted">Real-time ledger audit log of debit deductions and credit injections</p>
                    </div>
                    <button type="button" className="btn-link" onClick={() => openModal("ledger")}>
                      Open Full Audit Ledger &rarr;
                    </button>
                  </div>
                  {/* Inline filter bar for the main view */}
                  <div className="ml-filter-bar mb-4">
                    <div className="pill-group">
                      {["All", "Credit", "Debit"].map((f) => (
                        <button
                          key={f}
                          type="button"
                          className={`pill-btn ${filter === f ? "active" : ""}`}
                          onClick={() => setFilter(f)}
                        >
                          {f}
                        </button>
                      ))}
                    </div>
                    <div className="ml-search-input-wrap">
                      <span className="ml-search-ico">🔍</span>
                      <input
                        className="input-search"
                        type="search"
                        placeholder="Search memo, related entity, or date..."
                        value={q}
                        onChange={(e) => setQ(e.target.value)}
                      />
                    </div>
                    <div className="filter-field-inline">
                      <label>Sort:</label>
                      <select value={ledgerSort} onChange={(e) => setLedgerSort(e.target.value)}>
                        <option value="date-desc">Newest First</option>
                        <option value="date-asc">Oldest First</option>
                        <option value="amount-desc">Amount: High to Low</option>
                        <option value="amount-asc">Amount: Low to High</option>
                      </select>
                    </div>
                  </div>
                  <LedgerTable rows={filteredEntries.slice(0, 8)} onRowClick={(e) => openModal("entry", e)} />
                </section>
              </div>
              {/* Side Column */}
              <aside className="dash-side">
                <div className="promo-banner">
                  <div className="promo-text">
                    <span className="promo-tag">STRIPE GATEWAY</span>
                    <h2 className="promo-title">Marketing Hub</h2>
                    <p className="promo-desc">
                      Connected to merchant node <code>{stripeBalanceData?.accountId || "acct_1QqxpnJzsfOM5Wqn"}</code>{" "}
                      via endpoint <code>{STRIPE_BALANCE_ENDPOINT}</code>.
                    </p>
                  </div>
                </div>
                {/* Quick Operational Tools */}
                <div className="dash-card">
                  <div className="card-heading-simple">
                    <h3>Quick Actions</h3>
                    <p className="text-muted">Operations, injections & reconciliations</p>
                  </div>
                  <div className="quick-grid">
                    {QUICK.map((q2) => (
                      <button
                        key={q2.k}
                        type="button"
                        className="quick-card-btn"
                        style={{ "--btn-bg": q2.bg, "--btn-hover": q2.hover, "--btn-col": q2.c }}
                        onClick={() => openModal(q2.k)}
                      >
                        <span className="q-icon">{q2.i}</span>
                        <div className="q-labels">
                          <strong>{q2.t}</strong>
                          <small>{q2.s}</small>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
                {/* Recent Stream with its own quick-filter */}
                <div className="dash-card">
                  <div className="table-card-head" style={{ marginBottom: 8 }}>
                    <h3>Recent Stream</h3>
                    <button type="button" className="btn-link" onClick={() => openModal("ledger")}>
                      View all
                    </button>
                  </div>
                  <div className="stream-filter-row">
                    <input
                      type="search"
                      className="input-search stream-search"
                      placeholder="Filter stream…"
                      value={streamQ}
                      onChange={(e) => setStreamQ(e.target.value)}
                    />
                    <select
                      className="stream-type-select"
                      value={streamFilter}
                      onChange={(e) => setStreamFilter(e.target.value)}
                    >
                      <option value="All">All</option>
                      <option value="Credit">Credit</option>
                      <option value="Debit">Debit</option>
                    </select>
                  </div>
                  <ul className="activity-list">
                    {filteredStream.length === 0 ? (
                      <li className="tbl-empty" style={{ padding: "16px 0", fontSize: "12px" }}>
                        No activity found.
                      </li>
                    ) : (
                      filteredStream.map((r) => {
                        const isPos = r.a > 0;
                        return (
                          <li key={r.id} className="activity-item row-click" onClick={() => openModal("entry", r)}>
                            <div className={`activity-avatar ${isPos ? "bg-pos" : "bg-neg"}`}>{r.i}</div>
                            <div className="activity-info">
                              <p className="act-title">{r.title}</p>
                              <p className="act-sub">{r.sub}</p>
                              <span className="act-time">{r.d}</span>
                            </div>
                            <div className="activity-amt">
                              <strong className={`font-numeric ${isPos ? "col-pos" : "col-neg"}`}>
                                {isPos ? "+" : "-"} {gbp(Math.abs(r.a))}
                              </strong>
                            </div>
                          </li>
                        );
                      })
                    )}
                  </ul>
                </div>
              </aside>
            </div>
            {/* Modal Dialogs */}
            {renderStatModal()}
            {/* RECONCILIATION MODAL WITH FORMULA ENGINE */}
            {modal === "reconcile" && (
              <ModalDialog
                title="Booking Settlement & Final Reconciliation"
                subtitle="Calculate Credit Used / Redeemed, Customer Payment, Stripe Payment, Provider Payout & Ledger Deduction"
                icon="⚙️"
                onClose={closeModal}
                wide
              >
                <div className="ml-flow-guide">
                  <div className="flow-step">Service Price</div>
                  <div className="flow-arrow">↓</div>
                  <div className="flow-step">Credit Used = MIN(Service Price, Available Credit)</div>
                  <div className="flow-arrow">↓</div>
                  <div className="flow-step">Credit Redeemed = Credit Used (added to customer's redeemed total)</div>
                  <div className="flow-arrow">↓</div>
                  <div className="flow-step">Customer Payment = Service Price − Credit Used</div>
                  <div className="flow-arrow">↓</div>
                  <div className="flow-step">Stripe Payment = Customer Payment</div>
                  <div className="flow-arrow">↓</div>
                  <div className="flow-step">Provider Payout = Provider Payout Obligation</div>
                  <div className="flow-arrow">↓</div>
                  <div className="flow-step">Net Stripe Impact = Stripe Payment − Provider Payout</div>
                  <div className="flow-arrow">↓</div>
                  <div className="flow-step">Extra payout beyond Stripe Payment = deducted in UI Stripe balance only</div>
                  <div className="flow-arrow">↓</div>
                  <div className="flow-step">Marketing Ledger Deduction = Credit Used</div>
                  <div className="flow-arrow">↓</div>
                  <div className="flow-step">Marketing Ledger Balance = Previous Ledger Balance − Credit Used</div>
                  <div className="flow-arrow">↓</div>
                  <div className="flow-step highlight">Final Reconciliation</div>
                </div>
                <form className="ml-form-stack" onSubmit={applyBookingSettlement} style={{ marginTop: "20px" }}>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                    <div className="ml-form-field">
                      <label htmlFor="s-cust">Select Customer</label>
                      <select
                        id="s-cust"
                        value={settleCustId}
                        onChange={(e) => prepareSettle(e.target.value, null)}
                        required
                      >
                        <option value="">Select customer…</option>
                        {(custData?.customers || []).map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.customerName} ({c.id}) — Avail: {gbp(c.marketingAvailableCredits)} | Bookings: {c.bookingsCount}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="ml-form-field">
                      <label htmlFor="s-ref">Booking Ref / Subcollection ID</label>
                      <input
                        id="s-ref"
                        type="text"
                        value={bookingRefInput}
                        onChange={(e) => setBookingRefInput(e.target.value)}
                        placeholder="e.g. BK-90210"
                      />
                    </div>
                  </div>
                  <div className="ml-form-field">
                    <label htmlFor="s-booking">Select Booking (auto-fills Service Price & Provider Payout)</label>
                    <select
                      id="s-booking"
                      value={settleBookingKey}
                      onChange={(e) =>
                        fillSettleFromBooking((selectedSettleCust?.bookings || []).find((b) => b.key === e.target.value) || null)
                      }
                    >
                      <option value="">Manual entry (no booking selected)</option>
                      {(selectedSettleCust?.bookings || []).map((b) => (
                        <option key={b.key} value={b.key}>
                          {b.bookingId} — {gbp(b.customerTotalAmount)} — Provider {gbp(b.providerPayout)} — {b.settled || settledKeys.includes(b.key) ? "Settled" : "Pending"}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                    <div className="ml-form-field">
                      <label htmlFor="s-price">Service Price (£)</label>
                      <div className="ml-input-affix-wrap">
                        <span className="ml-input-affix">£</span>
                        <input
                          id="s-price"
                          type="number"
                          min="0.01"
                          step="0.01"
                          value={servicePriceInput}
                          onChange={(e) => setServicePriceInput(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="ml-form-field">
                      <label htmlFor="s-provider">Provider Payout Obligation (£)</label>
                      <div className="ml-input-affix-wrap">
                        <span className="ml-input-affix">£</span>
                        <input
                          id="s-provider"
                          type="number"
                          min="0.00"
                          step="0.01"
                          value={providerObligationInput}
                          onChange={(e) => setProviderObligationInput(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  {/* Real-time Calculation Simulation Card */}
                  <div
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                      borderRadius: "14px",
                      padding: "16px 20px",
                    }}
                  >
                    <h4 style={{ margin: "0 0 12px", fontSize: "14px", color: "#0f172a" }}>Reconciliation Simulation</h4>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", fontSize: "13px" }}>
                      <div style={simRow}>
                        <span>Service Price:</span>
                        <strong>{gbp(numServicePrice)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Customer Available Credit:</span>
                        <strong className="col-pos">{gbp(numCustAvailableCredit)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Credit Used = MIN(Price, Avail):</span>
                        <strong className="col-neg">{gbp(calcCreditUsed)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Credit Redeemed (this settlement):</span>
                        <strong className="col-neg">{gbp(calcCreditRedeemed)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Previously Redeemed Credit:</span>
                        <strong>{gbp(prevCreditRedeemed)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Total Credit Redeemed (after):</span>
                        <strong className="col-neg">{gbp(calcFinalCreditRedeemed)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Customer Payment (Price - Credit):</span>
                        <strong>{gbp(calcCustomerPayment)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Stripe Payment = Customer Payment:</span>
                        <strong style={{ color: "#0747A6" }}>{gbp(calcStripePayment)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Provider Payout = Obligation:</span>
                        <strong>{gbp(calcProviderPayout)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Ledger Deduction:</span>
                        <strong className="col-neg">- {gbp(calcMarketingLedgerDeduction)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Previous Ledger Balance:</span>
                        <strong>{gbp(prevLedgerBalance)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>UG Revenue = Price − Provider Payout:</span>
                        <strong className="col-pos">{gbp(calcUgRevenue)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Booking Status:</span>
                        <strong>
                          {selectedSettleBooking
                            ? selectedSettleBooking.settled || settledKeys.includes(selectedSettleBooking.key)
                              ? "Settled"
                              : "Pending"
                            : "Manual entry"}
                        </strong>
                      </div>
                      <div style={simRow}>
                        <span>Original Stripe Balance:</span>
                        <strong>{gbp(stripeOriginal)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Stripe Balance (current live):</span>
                        <strong>{gbp(stripeEffective)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Stripe Received (Customer Payment):</span>
                        <strong style={{ color: "#0747A6" }}>+ {gbp(calcStripePayment)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Provider Payout from Stripe:</span>
                        <strong className="col-neg">- {gbp(calcProviderPayout)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Provider Payout pushed to Stripe account:</span>
                        <strong className="col-neg">- {gbp(calcStripePayoutPushed)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Extra Deducted from Stripe Balance (UI only):</span>
                        <strong className="col-neg">- {gbp(calcStripeShortfall)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Net Stripe Impact (UI balance):</span>
                        <strong className={calcStripeNet < 0 ? "col-neg" : "col-pos"}>{gbp(calcStripeNet)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Net Pushed to Stripe Account:</span>
                        <strong className={calcStripeNetPushed < 0 ? "col-neg" : "col-pos"}>{gbp(calcStripeNetPushed)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Stripe Balance After:</span>
                        <strong>{gbp(stripeEffective + calcStripeNet)}</strong>
                      </div>
                      <div style={simRow}>
                        <span>Stripe Pending Balance:</span>
                        <strong>{gbp(stripeApiPending)}</strong>
                      </div>
                    </div>
                    <div
                      style={{
                        marginTop: "14px",
                        padding: "12px 14px",
                        background: "#eff6ff",
                        borderRadius: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <strong style={{ color: "#1e3a8a", fontSize: "14px" }}>
                        Marketing Ledger Balance = Previous Balance − Credit Used:
                      </strong>
                      <span style={{ fontSize: "18px", fontWeight: 800, color: "#1d4ed8" }}>
                        {gbp(calcMarketingLedgerBalance)}
                      </span>
                    </div>
                  </div>
                  {err && <div className="ml-err-banner">⚠️ {err}</div>}
                  <div className="ml-modal-footer">
                    <button type="button" className="btn-secondary" onClick={closeModal}>
                      Cancel
                    </button>
                    <button type="submit" className="btn-primary" disabled={saving}>
                      {saving ? "Recording..." : `Confirm Settlement (${gbp(calcCreditUsed)} credit deduction)`}
                    </button>
                  </div>
                </form>
              </ModalDialog>
            )}
            {/* CHART DATA TABLE MODAL */}
            {modal === "chart" && (
              <ModalDialog title="Cashflow & Balance Data Matrix" subtitle={R.label} icon="📈" onClose={closeModal} wide>
                <div className="ml-modal-table-scroll">
                  <table className="ledger-tbl">
                    <thead>
                      <tr>
                        <th>Date</th>
                        {LINES.map(([n]) => (
                          <th key={n} className="tar">
                            {n}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {R.x.map((label, i) => (
                        <tr key={label}>
                          <td>{label}</td>
                          {R.d.map((s, k) => (
                            <td key={k} className="tar font-numeric">
                              {gbp(s[i])}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </ModalDialog>
            )}
            {/* SINGLE ENTRY DETAIL RECEIPT MODAL */}
            {modal === "entry" && selected && (
              <ModalDialog title={selected.title || "Transaction"} subtitle={selected.sub} icon={selected.i} onClose={closeModal}>
                <div className="ml-receipt-sheet">
                  <dl className="ml-receipt-dl">
                    {[
                      ["Date", selected.d],
                      ["Type", selected.t],
                      ["Description", selected.desc],
                      ["Related entity", selected.rel],
                      ["Amount", (selected.a > 0 ? "+ " : "- ") + gbp(Math.abs(selected.a))],
                      ["Balance after", gbp(selected.b)],
                    ].map(([l, v]) => (
                      <div key={l} className="ml-receipt-row">
                        <dt>{l}</dt>
                        <dd className="font-numeric">{v}</dd>
                      </div>
                    ))}
                  </dl>
                </div>
              </ModalDialog>
            )}
            {/* BOOKING DETAIL WITH AUTO-SETTLEMENT BREAKDOWN */}
            {modal === "booking" && selected && (() => {
              const r = autoSettle.byKey[selected.key] || selected;
              const c = r.calc || calcSettlement({
                servicePrice: r.customerTotalAmount,
                availableCredit: r.creditUsed,
                providerObligation: r.providerPayout,
                prevLedgerBalance: balance,
                prevCreditRedeemed: 0,
              });
              return (
                <ModalDialog
                  title={`Booking Audit: ${r.bookingId}`}
                  subtitle={`${r.customerName} (${r.customerId}) · users/${r.customerId}/MyBooking/${r.docId}`}
                  icon="📅"
                  onClose={closeModal}
                >
                  <div className="ml-receipt-sheet">
                    <dl className="ml-receipt-dl">
                      {[
                        ["Booking ID", r.bookingId],
                        ["Provider Payout", gbp(r.providerPayout)],
                        ["Customer Total Amount", gbp(r.customerTotalAmount)],
                        ["UG Revenue", gbp(r.ugRevenue)],
                        ["Customer", `${r.customerName} (${r.customerId})`],
                        ["Service", r.serviceName],
                        ["Provider", r.providerName],
                        ["Booking Date", r.dateLabel],
                        ["Booking Status", r.status],
                        ["Provider Payout Source", r.payoutSource],
                        ["Service Price", gbp(c.servicePrice)],
                        ["Credit Used = MIN(Price, Credit)", "- " + gbp(c.creditUsed)],
                        ["Credit Redeemed", gbp(c.creditRedeemed)],
                        ["Customer Payment (Price - Credit)", gbp(c.customerPayment)],
                        ["Stripe Payment", gbp(c.stripePayment)],
                        ["Provider Payout (Obligation)", gbp(c.providerPayout)],
                        ["Marketing Ledger Deduction", "- " + gbp(c.ledgerDeduction)],
                        ["Credit Redeemed On", r.redeemedMs ? dateLabelOf(r.redeemedMs, "") : "—"],
                        ["Net Stripe Impact (Stripe − Provider Payout)", gbp(c.stripeNet)],
                        ["Extra Deducted from Stripe (UI only)", gbp(c.stripeShortfall)],
                        ["Settlement Status", r.settled ? "Settled" : "Pending"],
                      ].map(([l, v]) => (
                        <div key={l} className="ml-receipt-row">
                          <dt>{l}</dt>
                          <dd className="font-numeric">{v}</dd>
                        </div>
                      ))}
                    </dl>
                  </div>
                  <div className="ml-modal-footer mt-4">
                    <button type="button" className="btn-secondary" onClick={() => openBookings(r.customerId)}>
                      Back to Bookings
                    </button>
                    {!r.settled && (
                      <button type="button" className="btn-primary" onClick={() => openSettleFor(r.customerId, r.key)}>
                        Settle This Booking
                      </button>
                    )}
                  </div>
                </ModalDialog>
              );
            })()}
            {/* DEPOSIT CREDIT MODAL */}
            {modal === "credit" && (
              <ModalDialog
                title="Deposit Marketing Credits"
                subtitle="Allocate promotional balance to customer (synced to Firestore)"
                icon="🎁"
                onClose={closeModal}
              >
                <div className="ml-stat-badge-row">
                  <div className="ml-stat-badge">
                    <span className="badge-lbl">Total Credits</span>
                    <span className="badge-val">{gbp(totals.credits)}</span>
                  </div>
                  <div className="ml-stat-badge">
                    <span className="badge-lbl">Available Now</span>
                    <span className="badge-val col-pos">{gbp(available)}</span>
                  </div>
                  <div className="ml-stat-badge">
                    <span className="badge-lbl">Forecasted Total</span>
                    <span className="badge-val col-highlight">
                      {gbp(totals.credits + (parsedCreditAmt > 0 ? parsedCreditAmt : 0))}
                    </span>
                  </div>
                </div>
                <form className="ml-form-stack" onSubmit={submitCredit}>
                  <div className="ml-form-field">
                    <label htmlFor="c-cust">Customer</label>
                    <select
                      id="c-cust"
                      value={cf.customerId}
                      onChange={(e) => setCf((p) => ({ ...p, customerId: e.target.value }))}
                      required
                    >
                      <option value="">Select customer…</option>
                      {(custData?.customers || []).map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.customerName} ({c.id}) — {gbp(c.marketingAvailableCredits || c.marketingExistingCredits)} available | {c.bookingsCount} bookings
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="ml-form-field">
                    <label htmlFor="c-amt">Credit Amount</label>
                    <div className="ml-input-affix-wrap">
                      <span className="ml-input-affix">£</span>
                      <input
                        id="c-amt"
                        type="number"
                        min="0.01"
                        step="0.01"
                        value={cf.amount}
                        onChange={(e) => setCf((p) => ({ ...p, amount: e.target.value }))}
                        placeholder="250.00"
                        autoFocus
                        required
                      />
                    </div>
                  </div>
                  <div className="ml-form-field">
                    <label htmlFor="c-source">Destination Bucket</label>
                    <select
                      id="c-source"
                      value={cf.source}
                      onChange={(e) => setCf((p) => ({ ...p, source: e.target.value }))}
                    >
                      {DIST0.map((s) => (
                        <option key={s.n} value={s.n}>
                          {s.n}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="ml-form-field">
                    <label htmlFor="c-desc">Memo / Internal Reference</label>
                    <input
                      id="c-desc"
                      type="text"
                      value={cf.desc}
                      onChange={(e) => setCf((p) => ({ ...p, desc: e.target.value }))}
                      placeholder="e.g. Customer loyalty bonus"
                    />
                  </div>
                  {parsedCreditAmt > 0 && (
                    <div className="ml-preview-banner">
                      {creditTarget && (
                        <div className="ml-preview-line">
                          <span>{creditTarget.customerName} ({creditTarget.id}): new balance</span>
                          <strong className="col-pos">
                            {gbp(creditTarget.marketingAvailableCredits + parsedCreditAmt)}
                          </strong>
                        </div>
                      )}
                      <div className="ml-preview-line">
                        <span>New Aggregate Available Balance</span>
                        <strong className="col-pos">{gbp(previewNewAvailable)}</strong>
                      </div>
                    </div>
                  )}
                  {err && <div className="ml-err-banner">⚠️ {err}</div>}
                  <div className="ml-modal-footer">
                    <button type="button" className="btn-secondary" onClick={closeModal}>
                      Cancel
                    </button>
                    <button type="submit" className="btn-primary" disabled={saving}>
                      {saving ? "Saving…" : `Deposit ${parsedCreditAmt > 0 ? gbp(parsedCreditAmt) : "Credits"}`}
                    </button>
                  </div>
                </form>
              </ModalDialog>
            )}
            {/* CREATE CAMPAIGN MODAL */}
            {modal === "campaign" && (
              <ModalDialog
                title="Create Promotional Campaign"
                subtitle="Allocate dedicated marketing spend limit for user acquisition"
                icon="🚀"
                onClose={closeModal}
              >
                <div className="ml-stat-badge-row">
                  <div className="ml-stat-badge">
                    <span className="badge-lbl">Current Available</span>
                    <span className="badge-val col-pos">{gbp(available)}</span>
                  </div>
                  <div className="ml-stat-badge">
                    <span className="badge-lbl">Reserved Spend</span>
                    <span className="badge-val">{gbp(totals.spent)}</span>
                  </div>
                </div>
                <form className="ml-form-stack" onSubmit={submitCampaign}>
                  <div className="ml-form-field">
                    <label htmlFor="g-name">Campaign Label</label>
                    <input
                      id="g-name"
                      type="text"
                      value={gf.name}
                      onChange={(e) => setGf((p) => ({ ...p, name: e.target.value }))}
                      placeholder="e.g. Q4 Festive Referral Drive"
                      autoFocus
                      required
                    />
                  </div>
                  <div className="ml-form-field">
                    <label htmlFor="g-chan">Marketing Channel</label>
                    <select
                      id="g-chan"
                      value={gf.channel}
                      onChange={(e) => setGf((p) => ({ ...p, channel: e.target.value }))}
                    >
                      {["Google Ads", "Meta Ads", "Email Marketing", "SMS Notification", "Influencer Promo"].map((c) => (
                        <option key={c} value={c}>
                          {c}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="ml-form-field">
                    <label htmlFor="g-bud">Budget Allocation</label>
                    <div className="ml-input-affix-wrap">
                      <span className="ml-input-affix">£</span>
                      <input
                        id="g-bud"
                        type="number"
                        min="1"
                        max={available}
                        step="0.01"
                        value={gf.budget}
                        onChange={(e) => setGf((p) => ({ ...p, budget: e.target.value }))}
                        placeholder="150.00"
                        required
                      />
                    </div>
                  </div>
                  {parsedCampaignAmt > 0 && (
                    <div className="ml-preview-banner">
                      <div className="ml-preview-line">
                        <span>Remaining Balance Post-Campaign</span>
                        <strong className={previewRemainingAfterCampaign < 0 ? "col-neg" : "col-pos"}>
                          {gbp(previewRemainingAfterCampaign)}
                        </strong>
                      </div>
                    </div>
                  )}
                  {err && <div className="ml-err-banner">⚠️ {err}</div>}
                  <div className="ml-modal-footer">
                    <button type="button" className="btn-secondary" onClick={closeModal}>
                      Cancel
                    </button>
                    <button type="submit" className="btn-primary">
                      Deploy Campaign
                    </button>
                  </div>
                </form>
              </ModalDialog>
            )}
            {/* FULL AUDIT LEDGER MODAL WITH COMPREHENSIVE FILTERING */}
            {modal === "ledger" && (
              <ModalDialog
                title="Complete Ledger Audit Matrix"
                subtitle="Double-entry transaction records with dynamic query filters"
                icon="📄"
                onClose={closeModal}
                wide
              >
                {/* Advanced Filter Header */}
                <div className="ml-filter-panel">
                  <div className="filter-row primary">
                    <div className="pill-group">
                      {["All", "Credit", "Debit"].map((f) => (
                        <button
                          key={f}
                          type="button"
                          className={`pill-btn ${filter === f ? "active" : ""}`}
                          onClick={() => setFilter(f)}
                        >
                          {f}
                        </button>
                      ))}
                    </div>
                    <div className="ml-search-input-wrap">
                      <span className="ml-search-ico">🔍</span>
                      <input
                        className="input-search"
                        type="search"
                        placeholder="Filter by description, entity name, or date timestamp..."
                        value={q}
                        onChange={(e) => setQ(e.target.value)}
                      />
                    </div>
                    <button type="button" className="btn-secondary" onClick={() => exportCsv(filteredEntries)}>
                      ⬇ Export Filtered CSV
                    </button>
                  </div>
                  <div className="filter-row secondary">
                    <div className="filter-field-inline">
                      <label>Sort By:</label>
                      <select value={ledgerSort} onChange={(e) => setLedgerSort(e.target.value)}>
                        <option value="date-desc">Newest First</option>
                        <option value="date-asc">Oldest First</option>
                        <option value="amount-desc">Amount: High to Low</option>
                        <option value="amount-asc">Amount: Low to High</option>
                      </select>
                    </div>
                    <div className="filter-field-inline">
                      <label>Amount Range (£):</label>
                      <input
                        type="number"
                        placeholder="Min"
                        className="input-mini"
                        value={ledgerMinAmt}
                        onChange={(e) => setLedgerMinAmt(e.target.value)}
                      />
                      <span>–</span>
                      <input
                        type="number"
                        placeholder="Max"
                        className="input-mini"
                        value={ledgerMaxAmt}
                        onChange={(e) => setLedgerMaxAmt(e.target.value)}
                      />
                    </div>
                    <FilterClearButton
                      count={(filter !== "All" ? 1 : 0) + (q ? 1 : 0) + (ledgerMinAmt ? 1 : 0) + (ledgerMaxAmt ? 1 : 0)}
                      onClear={() => {
                        setFilter("All");
                        setQ("");
                        setLedgerMinAmt("");
                        setLedgerMaxAmt("");
                        setLedgerSort("date-desc");
                      }}
                    />
                  </div>
                </div>
                <div className="ml-modal-table-scroll">
                  <LedgerTable rows={filteredEntries} onRowClick={(e) => openModal("entry", e)} />
                </div>
                <div className="ml-modal-table-foot">
                  <span>
                    Displaying <b>{filteredEntries.length}</b> of {entries.length} audited entries
                  </span>
                  <span>
                    Current Running Balance: <strong className="font-numeric">{gbp(balance)}</strong>
                  </span>
                </div>
                <div className="ml-modal-footer mt-4">
                  <button type="button" className="btn-secondary" onClick={closeModal}>
                    Close View
                  </button>
                </div>
              </ModalDialog>
            )}
            {/* DISTRIBUTION BREAKDOWN MODAL WITH SEARCH & SORT */}
            {modal === "distribution" && (() => {
              const needle = distQ.trim().toLowerCase();
              const distList = dist
                .filter((s) => !needle || s.n.toLowerCase().includes(needle))
                .sort((a, b) => (distSort === "v-asc" ? a.v - b.v : b.v - a.v));
              return (
                <ModalDialog
                  title="Promotional Credit Distribution"
                  subtitle="Allocations segregated by marketing acquisition channels"
                  icon="🥧"
                  onClose={closeModal}
                  wide
                >
                  <div className="ml-stat-badge-row">
                    <div className="ml-stat-badge">
                      <span className="badge-lbl">Total Distributed</span>
                      <span className="badge-val">{gbp(distTotal)}</span>
                    </div>
                    <div className="ml-stat-badge">
                      <span className="badge-lbl">Active Channels</span>
                      <span className="badge-val col-highlight">{dist.length}</span>
                    </div>
                  </div>
                  <div className="ml-filter-bar">
                    <div className="ml-search-input-wrap">
                      <span className="ml-search-ico">🔍</span>
                      <input
                        className="input-search"
                        type="search"
                        placeholder="Search channel bucket name..."
                        value={distQ}
                        onChange={(e) => setDistQ(e.target.value)}
                      />
                    </div>
                    <div className="filter-field-inline">
                      <label>Sort:</label>
                      <select value={distSort} onChange={(e) => setDistSort(e.target.value)}>
                        <option value="v-desc">Volume: High to Low</option>
                        <option value="v-asc">Volume: Low to High</option>
                      </select>
                    </div>
                  </div>
                  <div className="table-wrap mb-4">
                    <table className="ledger-tbl">
                      <thead>
                        <tr>
                          <th>Allocation Bucket</th>
                          <th className="tar">Volume</th>
                          <th className="tar">Share</th>
                        </tr>
                      </thead>
                      <tbody>
                        {distList.length === 0 ? (
                          <tr>
                            <td colSpan="3" className="tbl-empty">No channels match query.</td>
                          </tr>
                        ) : (
                          distList.map((s) => (
                            <tr key={s.n}>
                              <td>
                                <span
                                  className="color-dot"
                                  style={{ backgroundColor: s.c, display: "inline-block", marginRight: "8px" }}
                                />
                                <strong>{s.n}</strong>
                              </td>
                              <td className="tar font-numeric font-semibold">{gbp(s.v)}</td>
                              <td className="tar font-numeric text-muted">{((s.v / distTotal) * 100).toFixed(1)}%</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="ml-modal-footer">
                    <button type="button" className="btn-secondary" onClick={closeModal}>
                      Close
                    </button>
                  </div>
                </ModalDialog>
              );
            })()}
            {/* AUDIT SUMMARY REPORT MODAL */}
            {modal === "report" && (
              <ModalDialog
                title="Consolidated Performance & Credit Audit Summary"
                subtitle="Unified analytical snapshot of platform promotional liabilities"
                icon="📊"
                onClose={closeModal}
                wide
              >
                <div className="ml-stat-badge-row quad">
                  <div className="ml-stat-badge">
                    <span className="badge-lbl">Total Credits</span>
                    <span className="badge-val">{gbp(totals.credits)}</span>
                  </div>
                  <div className="ml-stat-badge">
                    <span className="badge-lbl">Total Spent</span>
                    <span className="badge-val col-neg">{gbp(totals.spent)}</span>
                  </div>
                  <div className="ml-stat-badge">
                    <span className="badge-lbl">Available Credits</span>
                    <span className="badge-val col-pos">{gbp(available)}</span>
                  </div>
                  <div className="ml-stat-badge">
                    <span className="badge-lbl">Total Bookings</span>
                    <span className="badge-val col-highlight">{totals.bookingsCount}</span>
                  </div>
                </div>
                <h4 className="ml-section-subhead">Volume by Allocation Channel</h4>
                <div className="table-wrap mb-4">
                  <table className="ledger-tbl">
                    <thead>
                      <tr>
                        <th>Allocation Bucket</th>
                        <th className="tar">Volume</th>
                        <th className="tar">Share</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dist.map((s) => (
                        <tr key={s.n}>
                          <td>
                            <span
                              className="color-dot"
                              style={{ backgroundColor: s.c, display: "inline-block", marginRight: "8px" }}
                            />
                            <strong>{s.n}</strong>
                          </td>
                          <td className="tar font-numeric font-semibold">{gbp(s.v)}</td>
                          <td className="tar font-numeric text-muted">{((s.v / distTotal) * 100).toFixed(1)}%</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="ml-modal-footer">
                  <button type="button" className="btn-secondary" onClick={closeModal}>
                    Close
                  </button>
                  <button type="button" className="btn-primary" onClick={() => exportCsv()}>
                    Download Full CSV Audit Report
                  </button>
                </div>
              </ModalDialog>
            )}
            {/* CONFIRMATION / ACTION RECEIPT MODAL */}
            {modal === "receipt" && receipt && (
              <ModalDialog title={receipt.title} subtitle={receipt.subtitle} icon={receipt.icon} onClose={closeModal}>
                <div className="ml-receipt-sheet">
                  <dl className="ml-receipt-dl">
                    {receipt.rows.map(([label, val]) => (
                      <div key={label} className="ml-receipt-row">
                        <dt>{label}</dt>
                        <dd className="font-numeric">{val}</dd>
                      </div>
                    ))}
                  </dl>
                </div>
                <div className="ml-modal-footer mt-4">
                  <button type="button" className="btn-secondary" onClick={() => openModal("ledger")}>
                    Inspect Ledger
                  </button>
                  <button type="button" className="btn-primary" onClick={closeModal}>
                    Acknowledge & Close
                  </button>
                </div>
              </ModalDialog>
            )}
            {/* Live Floating Notification */}
            {toast && (
              <div className="toast-float" role="status" aria-live="polite">
                <span className="toast-dot" /> {toast}
              </div>
            )}
          </div>
        );
      }
      /* ---------- Comprehensive Modern Fintech UI Styling ---------- */
      const css = `
      .ml-scope {
        --bg-page: #f8fafc;
        --surface: #ffffff;
        --text-primary: #0f172a;
        --text-secondary: #64748b;
        --border-color: #e2e8f0;
        --border-subtle: #f1f5f9;
        --primary: #2563eb;
        --primary-hover: #1d4ed8;
        --success: #10b981;
        --danger: #ef4444;
        --stripe: #0747A6;
        --radius-sm: 8px;
        --radius-md: 12px;
        --radius-lg: 16px;
        --shadow-sm: 0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.02);
        --shadow-md: 0 4px 6px -1px rgba(15,23,42,0.06), 0 2px 4px -2px rgba(15,23,42,0.04);
        --shadow-modal: 0 25px 50px -12px rgba(15, 23, 42, 0.28);
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
        color: var(--text-primary);
        background-color: var(--bg-page);
        min-height: 100vh;
        box-sizing: border-box;
      }
      .ml-scope * { box-sizing: border-box; margin: 0; padding: 0; }
      .font-numeric { font-variant-numeric: tabular-nums; }
      .font-semibold { font-weight: 600; }
      .font-mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace; font-size: 11.5px; }
      .tar { text-align: right; }
      .text-muted { color: var(--text-secondary); font-size: 13px; }
      .col-pos { color: #059669 !important; }
      .col-neg { color: #dc2626 !important; }
      .col-highlight { color: #2563eb !important; }
      .col-bal { color: #1e293b; }
      .mt-4 { margin-top: 16px !important; }
      .mb-4 { margin-bottom: 16px !important; }
      .dashboard-wrapper {
        display: grid;
        grid-template-columns: minmax(0, 1fr) 390px;
        gap: 24px;
        max-width: 1560px;
        margin: 0 auto;
        padding: 24px 32px 64px;
      }
      @media(max-width: 1220px) { .dashboard-wrapper { grid-template-columns: 1fr; padding: 16px; } }
      .dash-main { display: flex; flex-direction: column; gap: 24px; min-width: 0; }
      .dash-side { display: flex; flex-direction: column; gap: 24px; min-width: 0; }
      .dash-card {
        background: var(--surface);
        border: 1px solid var(--border-color);
        border-radius: var(--radius-lg);
        padding: 22px;
        box-shadow: var(--shadow-sm);
        transition: box-shadow 0.2s ease, border-color 0.2s ease;
      }
      .clickable, .row-click { cursor: pointer; }
      .stat-tile.clickable:hover, .chart-card.clickable:hover { border-color: #93c5fd; box-shadow: var(--shadow-md); }
      .row-click:hover td, .activity-item.row-click:hover { background: #f8fafc; }
      .top-bar { display: flex; justify-content: space-between; align-items: flex-end; gap: 16px; flex-wrap: wrap; }
      .top-actions { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }
      .btn-refresh-all { display: inline-flex; align-items: center; gap: 6px; padding: 10px 14px; border-radius: var(--radius-md); }
      .spin { display: inline-block; animation: spin .8s linear infinite; }
      @keyframes spin { to { transform: rotate(360deg); } }
      .badge-pill {
        display: inline-block; font-size: 11px; font-weight: 700; text-transform: uppercase;
        letter-spacing: 0.05em; color: var(--primary); background: #eff6ff; padding: 3px 10px; border-radius: 99px; margin-bottom: 6px;
      }
      .page-heading { font-size: 27px; font-weight: 800; letter-spacing: -0.02em; color: #0f172a; }
      .page-sub { color: var(--text-secondary); font-size: 14px; margin-top: 2px; }
      .dt-container { position: relative; }
      .btn-date {
        display: flex; align-items: center; gap: 10px; background: #fff; border: 1px solid var(--border-color);
        border-radius: var(--radius-md); padding: 8px 14px; cursor: pointer; text-align: left; box-shadow: var(--shadow-sm);
      }
      .date-labels { display: flex; flex-direction: column; }
      .dl-main { font-size: 13px; font-weight: 700; color: #1e293b; }
      .dl-sub { font-size: 11px; color: var(--text-secondary); }
      .cal-ico { font-size: 16px; }
      .arrow-down { color: var(--text-secondary); font-size: 12px; }
      .dropdown-popover {
        position: absolute; top: calc(100% + 6px); right: 0; z-index: 50;
        background: #fff; border: 1px solid var(--border-color); border-radius: var(--radius-md);
        padding: 6px; box-shadow: var(--shadow-md); list-style: none; min-width: 220px;
      }
      .dp-opt {
        width: 100%; border: 0; background: transparent; padding: 8px 12px; border-radius: 6px;
        text-align: left; cursor: pointer; display: flex; flex-direction: column; gap: 2px;
      }
      .dp-opt:hover, .dp-opt.active { background: #eff6ff; }
      .dp-opt b { font-size: 13px; color: #1e293b; }
      .dp-opt small { font-size: 11px; color: var(--text-secondary); }
      /* Stat Cards */
      .stats-row { display: grid; grid-template-columns: repeat(auto-fit, minmax(215px, 1fr)); gap: 16px; }
      .stat-tile { position: relative; overflow: hidden; display: flex; flex-direction: column; justify-content: space-between; min-height: 125px; }
      .stat-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
      .stat-icon-wrapper { font-size: 20px; }
      .trend-badge { font-size: 11px; font-weight: 700; color: #059669; background: #ecfdf5; padding: 2px 8px; border-radius: 99px; }
      .stat-label { font-size: 12.5px; color: var(--text-secondary); font-weight: 600; text-transform: uppercase; letter-spacing: 0.03em; }
      .stat-val { font-size: 23px; font-weight: 800; letter-spacing: -0.02em; margin-top: 4px; color: #0f172a; }
      .stat-subtext { font-size: 11px; color: #64748b; margin-top: 3px; display: block; }
      .stat-note { display: block; font-size: 11.5px; color: #d97706; margin-top: 3px; }
      .spark-svg { position: absolute; bottom: 0; right: 0; width: 45%; height: 50px; pointer-events: none; }
      /* Settlement Hero */
      .hero-pill-tag {
        background: rgba(255,255,255,0.18);
        color: #6ee7b7;
        padding: 3px 10px;
        border-radius: 99px;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        display: inline-block;
      }
      /* Charts */
      .charts-grid { display: grid; grid-template-columns: minmax(0, 1.8fr) minmax(0, 1.1fr); gap: 20px; }
      @media(max-width: 980px) { .charts-grid { grid-template-columns: 1fr; } }
      .chart-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; margin-bottom: 18px; flex-wrap: wrap; }
      .chart-header h3 { font-size: 16px; font-weight: 700; color: #0f172a; }
      .chart-svg-container { width: 100%; margin: 10px 0; }
      .chart-legend { display: flex; gap: 16px; flex-wrap: wrap; margin-top: 12px; }
      .legend-pill { background: transparent; border: 0; display: inline-flex; align-items: center; gap: 6px; font-size: 12.5px; font-weight: 600; color: #475569; cursor: pointer; }
      .legend-pill.disabled { opacity: 0.35; text-decoration: line-through; }
      .color-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
      .card-heading-simple h3 { font-size: 16px; font-weight: 700; }
      .donut-content { display: flex; flex-direction: column; align-items: center; gap: 16px; margin-top: 14px; }
      .donut-legend-list { list-style: none; width: 100%; display: flex; flex-direction: column; gap: 6px; }
      .donut-legend-list li { display: grid; grid-template-columns: 1fr auto 44px; align-items: center; gap: 8px; padding: 6px 8px; border-radius: 6px; font-size: 12.5px; }
      .donut-legend-list li.item-highlight { background: #f1f5f9; font-weight: 700; }
      .btn-slice-select { background: 0; border: 0; display: flex; align-items: center; gap: 8px; cursor: pointer; text-align: left; font-size: inherit; color: inherit; }
      .slice-pct { text-align: right; color: var(--text-secondary); font-size: 11px; }
      /* Table Styles */
      .table-card-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px; gap: 12px; }
      .table-card-head h3 { font-size: 16px; font-weight: 700; }
      .btn-link { background: 0; border: 0; color: var(--primary); font-size: 13px; font-weight: 600; cursor: pointer; text-decoration: none; }
      .btn-link:hover { text-decoration: underline; }
      .table-wrap { width: 100%; overflow-x: auto; }
      .ledger-tbl { width: 100%; border-collapse: collapse; font-size: 13px; text-align: left; }
      .ledger-tbl th { background: #f8fafc; color: #475569; font-weight: 600; padding: 11px 14px; border-bottom: 1px solid var(--border-color); font-size: 12px; text-transform: uppercase; letter-spacing: 0.03em; white-space: nowrap; }
      .ledger-tbl td { padding: 12px 14px; border-bottom: 1px solid var(--border-subtle); color: #334155; }
      .ledger-tbl tr:last-child td { border-bottom: none; }
      .cell-date { white-space: nowrap; font-size: 12px; color: var(--text-secondary); }
      .cell-desc { font-weight: 600; color: #0f172a; }
      .cell-rel { color: var(--text-secondary); }
      .cell-doc-id { white-space: nowrap; }
      .doc-pill {
        display: inline-block;
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 11px;
        background: #f1f5f9;
        color: #475569;
        border: 1px solid #cbd5e1;
        border-radius: 6px;
        padding: 2px 7px;
        max-width: 140px;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
      }
      .booking-pill {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        background: #e0f2fe;
        color: #0369a1;
        padding: 3px 8px;
        border-radius: 6px;
        font-size: 11.5px;
        font-weight: 600;
      }
      .booking-pill.source { background: #f1f5f9; color: #475569; }
      .cust-avatar-pill { margin-right: 6px; opacity: 0.8; }
      .tbl-empty { text-align: center; color: var(--text-secondary); padding: 36px 16px; font-size: 13.5px; }
      .status-pill { display: inline-flex; align-items: center; gap: 5px; padding: 3px 10px; border-radius: 99px; font-size: 11.5px; font-weight: 700; }
      .status-pill .dot { width: 6px; height: 6px; border-radius: 50%; display: inline-block; }
      .status-pill.credit { background: #dcfce7; color: #15803d; }
      .status-pill.credit .dot { background: #15803d; }
      .status-pill.debit { background: #fee2e2; color: #b91c1c; }
      .status-pill.debit .dot { background: #b91c1c; }
      .status-pill.pending { background: #fef3c7; color: #b45309; }
      .status-pill.pending .dot { background: #b45309; }
      /* Sidebar Promo & Quick Buttons */
      .promo-banner {
        background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
        color: #ffffff !important; padding: 24px; border-radius: var(--radius-lg);
        position: relative; overflow: hidden;
      }
      .promo-tag { font-size: 10px; text-transform: uppercase; font-weight: 800; letter-spacing: 0.06em; background: rgba(255,255,255,0.22); color: #fff; padding: 4px 8px; border-radius: 6px; display: inline-block; }
      .promo-title { font-size: 20px; font-weight: 800; margin: 10px 0 6px; color: #fff; }
      .promo-desc { font-size: 13px; color: #fff; opacity: 0.95; line-height: 1.5; }
      .promo-desc code { background: rgba(255,255,255,0.25); padding: 2px 5px; border-radius: 4px; }
      .quick-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-top: 12px; }
      .quick-card-btn {
        background-color: var(--btn-bg); border: 1px solid transparent; border-radius: var(--radius-md);
        padding: 14px 12px; display: flex; flex-direction: column; gap: 8px; text-align: left; cursor: pointer;
        transition: transform 0.15s ease, background-color 0.15s ease;
      }
      .quick-card-btn:hover { background-color: var(--btn-hover); transform: translateY(-1px); }
      .q-icon { font-size: 18px; }
      .q-labels strong { display: block; font-size: 12.5px; color: #0f172a; }
      .q-labels small { font-size: 11px; color: var(--text-secondary); margin-top: 2px; }
      /* Activity List & Mini Stream Filter */
      .stream-filter-row { display: flex; gap: 8px; margin-bottom: 12px; }
      .stream-search { font-size: 12px; padding: 6px 10px 6px 30px; }
      .stream-type-select { padding: 6px 8px; border-radius: var(--radius-md); border: 1px solid var(--border-color); font-size: 12px; background: #fff; }
      .activity-list { list-style: none; display: flex; flex-direction: column; }
      .activity-item { display: flex; align-items: center; gap: 12px; padding: 12px 0; border-bottom: 1px solid var(--border-subtle); }
      .activity-avatar { width: 36px; height: 36px; border-radius: 10px; display: grid; place-items: center; font-size: 16px; flex-shrink: 0; }
      .bg-pos { background: #ecfdf5; color: #10b981; }
      .bg-neg { background: #fef2f2; color: #ef4444; }
      .activity-info { flex: 1; min-width: 0; }
      .act-title { font-size: 13px; font-weight: 600; color: #0f172a; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
      .act-sub { font-size: 11.5px; color: var(--text-secondary); }
      .act-time { font-size: 10.5px; color: #94a3b8; }
      /* Modals */
      .ml-modal-backdrop {
        position: fixed; inset: 0; width: 100vw; height: 100vh;
        background: rgba(15, 23, 42, 0.68); backdrop-filter: blur(6px);
        display: flex; align-items: center; justify-content: center; z-index: 99999; padding: 20px;
      }
      .ml-modal-card {
        background: #ffffff; width: 100%; max-width: 540px; max-height: calc(100vh - 48px);
        border-radius: 20px; box-shadow: var(--shadow-modal); display: flex; flex-direction: column; overflow: hidden;
      }
      .ml-modal-wide { max-width: 1260px; }
      .ml-modal-header { padding: 20px 24px; border-bottom: 1px solid var(--border-color); display: flex; justify-content: space-between; align-items: center; }
      .ml-modal-title-group { display: flex; align-items: center; gap: 12px; }
      .ml-modal-badge-icon { width: 38px; height: 38px; border-radius: 10px; background: #f1f5f9; display: grid; place-items: center; font-size: 18px; }
      .ml-modal-title { font-size: 18px; font-weight: 700; color: #0f172a; }
      .ml-modal-subtitle { font-size: 12.5px; color: var(--text-secondary); margin-top: 1px; }
      .ml-btn-close { background: #f1f5f9; border: 0; width: 32px; height: 32px; border-radius: 50%; display: grid; place-items: center; cursor: pointer; color: #475569; }
      .ml-btn-close:hover { background: #e2e8f0; }
      .ml-modal-body { padding: 24px; overflow-y: auto; }
      /* Advanced Filter Panel in Modals */
      .ml-filter-panel {
        background: #f8fafc;
        border: 1px solid var(--border-color);
        border-radius: var(--radius-md);
        padding: 12px 14px;
        margin-bottom: 16px;
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
      .filter-row { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }
      .filter-row.primary { justify-content: space-between; }
      .filter-row.secondary { font-size: 12.5px; color: #475569; padding-top: 4px; border-top: 1px dashed #e2e8f0; }
      .filter-select-group { display: flex; gap: 8px; flex-wrap: wrap; }
      .filter-select-group select, .filter-field-inline select {
        padding: 8px 12px;
        border: 1px solid var(--border-color);
        border-radius: var(--radius-md);
        font-size: 12.5px;
        background: #ffffff;
        color: #1e293b;
      }
      .filter-field-inline { display: flex; align-items: center; gap: 6px; }
      .filter-field-inline label { font-weight: 600; color: #475569; }
      .input-mini {
        width: 72px;
        padding: 6px 8px;
        border: 1px solid var(--border-color);
        border-radius: 6px;
        font-size: 12px;
        background: #fff;
      }
      .btn-filter-clear {
        background: #fee2e2;
        color: #b91c1c;
        border: 1px solid #fca5a5;
        border-radius: 99px;
        padding: 4px 10px;
        font-size: 11.5px;
        font-weight: 700;
        cursor: pointer;
      }
      .btn-filter-clear:hover { background: #fecaca; }
      .ml-auto-btn { margin-left: auto; }
      .ml-stat-badge-row { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; margin-bottom: 20px; }
      .ml-stat-badge-row.quad { grid-template-columns: repeat(4, 1fr); }
      @media(max-width: 768px) {
        .ml-stat-badge-row, .ml-stat-badge-row.quad { grid-template-columns: 1fr 1fr; }
        .balance-grid { grid-template-columns: 1fr !important; }
        .account-grid { grid-template-columns: 1fr !important; }
      }
      .ml-stat-badge { background: #f8fafc; border: 1px solid var(--border-color); border-radius: 10px; padding: 10px 12px; display: flex; flex-direction: column; gap: 2px; }
      .ml-stat-badge .badge-lbl { font-size: 11px; color: var(--text-secondary); font-weight: 600; text-transform: uppercase; }
      .ml-stat-badge .badge-val { font-size: 15px; font-weight: 700; }
      .ml-form-stack { display: flex; flex-direction: column; gap: 16px; }
      .ml-form-field { display: flex; flex-direction: column; gap: 6px; }
      .ml-form-field label { font-size: 13px; font-weight: 600; color: #334155; }
      .ml-form-field input, .ml-form-field select {
        padding: 11px 14px; border: 1px solid var(--border-color); border-radius: var(--radius-md); font-size: 14px; background: #fff;
      }
      .ml-input-affix-wrap { position: relative; display: flex; align-items: center; }
      .ml-input-affix { position: absolute; left: 14px; color: var(--text-secondary); font-weight: 700; }
      .ml-input-affix-wrap input { width: 100%; padding-left: 28px !important; }
      .ml-preview-banner { background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; padding: 12px 16px; display: flex; flex-direction: column; gap: 6px; }
      .ml-preview-line { display: flex; justify-content: space-between; font-size: 13px; color: #166534; }
      .ml-err-banner { background: #fef2f2; border: 1px solid #fecaca; color: #b91c1c; padding: 11px 14px; border-radius: 10px; font-size: 13px; }
      .ml-modal-footer { display: flex; justify-content: flex-end; align-items: center; gap: 10px; margin-top: 10px; padding-top: 12px; }
      .btn-primary { background: #0747A6; color: #fff; border: 0; padding: 10px 20px; border-radius: var(--radius-md); font-size: 13px; font-weight: 600; cursor: pointer; transition: all .15s ease; }
      .btn-primary:hover { opacity: 0.92; transform: translateY(-0.5px); }
      .btn-primary:disabled, .btn-secondary:disabled { opacity: 0.6; cursor: not-allowed; }
      .btn-secondary { background: #f1f5f9; color: #334155; border: 1px solid var(--border-color); padding: 9px 16px; border-radius: var(--radius-md); font-size: 13px; font-weight: 600; cursor: pointer; white-space: nowrap; }
      .btn-secondary:hover { background: #e2e8f0; }
      .btn-action-settle {
        background: #ecfeff;
        color: #0891b2;
        border: 1px solid #a5f3fc;
        padding: 4px 10px;
        border-radius: 6px;
        font-size: 11.5px;
        font-weight: 700;
        cursor: pointer;
      }
      .btn-action-settle:hover:not(:disabled) { background: #cffafe; }
      .btn-action-settle:disabled { opacity: 0.55; cursor: default; border-color: transparent; background: #f1f5f9; color: #94a3b8; }
      .ml-filter-bar { display: flex; gap: 12px; align-items: center; flex-wrap: wrap; }
      .ml-search-input-wrap { flex: 1; min-width: 220px; position: relative; display: flex; align-items: center; }
      .ml-search-ico { position: absolute; left: 12px; font-size: 13px; color: #94a3b8; pointer-events: none; }
      .input-search { width: 100%; padding: 9px 12px 9px 34px; border: 1px solid var(--border-color); border-radius: var(--radius-md); font-size: 13px; }
      .pill-group { display: inline-flex; background: #f1f5f9; padding: 3px; border-radius: 99px; }
      .pill-btn { border: 0; background: transparent; padding: 6px 14px; border-radius: 99px; font-size: 12px; font-weight: 600; color: #475569; cursor: pointer; }
      .pill-btn.active { background: #fff; color: #0f172a; box-shadow: 0 1px 2px rgba(0,0,0,0.06); }
      .ml-modal-table-scroll { max-height: 440px; overflow-y: auto; overflow-x: auto; border: 1px solid var(--border-color); border-radius: 10px; }
      .ml-modal-table-foot { display: flex; justify-content: space-between; margin-top: 14px; font-size: 12.5px; color: var(--text-secondary); }
      .ml-section-subhead { font-size: 14px; font-weight: 700; margin: 16px 0 10px; color: #1e293b; }
      .ml-receipt-sheet { background: #f8fafc; border: 1px solid var(--border-color); border-radius: 12px; overflow: hidden; }
      .ml-receipt-dl { display: flex; flex-direction: column; }
      .ml-receipt-row { display: flex; justify-content: space-between; gap: 16px; padding: 12px 18px; border-bottom: 1px solid #edf2f7; font-size: 13px; }
      .ml-receipt-row:last-child { border-bottom: 0; background: #f1f5f9; font-weight: 700; font-size: 13.5px; }
      .ml-receipt-row dt { color: var(--text-secondary); }
      .ml-receipt-row dd { font-weight: 600; color: #0f172a; text-align: right; }
      .toast-float {
        position: fixed; bottom: 28px; left: 50%; transform: translateX(-50%);
        background: #0f172a; color: #fff; padding: 11px 22px; border-radius: 99px;
        font-size: 13px; font-weight: 600; box-shadow: var(--shadow-modal); z-index: 100000;
        display: flex; align-items: center; gap: 8px; animation: fadeInToast .2s ease-out;
      }
      .toast-dot { width: 8px; height: 8px; background: #10b981; border-radius: 50%; }
      @keyframes fadeInToast { from { opacity: 0; transform: translate(-50%, 8px); } to { opacity: 1; transform: translate(-50%, 0); } }
      /* Key Column highlighting */
      .th-key { background: #fef9c3 !important; color: #854d0e !important; }
      .td-key { background: #fefce8; }
      .booking-btn { background: #e0f2fe; color: #0369a1; border: 0; cursor: pointer; font-weight: 700; padding: 3px 10px; border-radius: 6px; font-size: 11.5px; }
      .booking-btn:hover { background: #bae6fd; }
      .ledger-tbl tfoot td { background: #f8fafc; font-weight: 700; border-top: 2px solid var(--border-color); border-bottom: none; }
      /* Live Settlement Grid */
      .ml-settle-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(170px, 1fr)); gap: 12px; margin-top: 6px; }
      .ml-settle-tile { background: #f8fafc; border: 1px solid var(--border-color); border-radius: 12px; padding: 12px 14px; cursor: pointer; display: flex; flex-direction: column; gap: 3px; transition: all .15s ease; }
      .ml-settle-tile:hover { border-color: #93c5fd; background: #fff; transform: translateY(-1px); }
      .ml-settle-tile .lbl, .ml-settle-final .lbl { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; color: var(--text-secondary); }
      .ml-settle-tile .val { font-size: 18px; font-weight: 800; color: #0f172a; font-variant-numeric: tabular-nums; }
      .ml-settle-tile .hint, .ml-settle-final .hint { font-size: 11px; color: #94a3b8; }
      .ml-settle-final { margin-top: 14px; display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 12px; }
      .ml-settle-final > div { border-radius: 12px; padding: 12px 14px; background: #eff6ff; display: flex; flex-direction: column; gap: 3px; }
      .ml-settle-final > div.ok { background: #ecfdf5; }
      .ml-settle-final .val { font-size: 20px; font-weight: 800; color: #1d4ed8; font-variant-numeric: tabular-nums; }
      /* Flow Guide */
      .ml-flow-guide {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        background: #f0fdf4;
        border: 1px dashed #86efac;
        padding: 14px;
        border-radius: 12px;
      }
      .flow-step {
        background: #ffffff;
        border: 1px solid #bbf7d0;
        color: #166534;
        font-weight: 600;
        font-size: 12px;
        padding: 5px 14px;
        border-radius: 6px;
        text-align: center;
        width: 100%;
        max-width: 440px;
      }
      .flow-step.highlight {
        background: #166534;
        color: #ffffff;
        font-weight: 700;
      }
      .flow-arrow {
        color: #15803d;
        font-size: 13px;
        font-weight: 800;
        line-height: 1;
      }
      `;
      return { MarketingLedgerDashboard };
    })();
  }
  const { MarketingLedgerDashboard } = window.__MLD_BUNDLE_V23_6__;
  return <MarketingLedgerDashboard />;
})()}


{/* ═══════════════════════════════════════════════════════
    PROVIDER VERIFICATION PIPELINE — COMPREHENSIVE JSX (PART 1)
    Data source: "users", "providers" & "VerificationDocuments" Firestore collections
    Includes:
      - REAL-TIME FIRESTORE LISTENERS (onSnapshot) on users / providers / VerificationDocuments.
        No localStorage record cache, no cached-snapshot data: only fresh server data is displayed.
      - DOCUMENT UPLOAD ENGINE: "Select & Upload" stores the file (Firebase Storage) and writes
        it into the matching VerificationDocuments/{providerUid} document; the listener then
        pushes it to the provider card + All Docs tab automatically.
      - AUTOMATED FRONT-END EXPIRED DOCUMENT BLOCKING: Automatically updates stage
        to "blocked" both in-memory and Firestore when any document is detected expired.
      - AUTOMATED DETECT & RELOCATE TO BLOCKED COLUMN ON EXISTING PROVIDERS (KANBAN)
      - AUTOMATED DATE SANITIZER: Replaces "Invalid Date" with valid timestamps
      - ACTIVE SPINNER ON SYNC BUTTON DURING REFRESH
      - DE-DUPLICATION ENGINE: Cleans duplicate documents and provider records
      - Passcode Security Gates (Passcode: 8972 strictly hidden)
      - Shield Protocol Security Gate, PII Protection, Screenshot/Capture Prevention
      - Thumbnail preview engine and per-document passcode gates
      - NEW: SELFIE CLICK-TO-ZOOM PREVIEW (modal, +/- buttons, mouse-wheel zoom, drag-to-pan,
        X / outside-click / Esc close, animated open & close, responsive). It only re-uses the
        existing selfieUrl already loaded from Firebase — no new upload feature.
    REQUIRED IMPORTS IN THE HOST FILE (used through typeof-guards, same style as before):
      import { collection, doc, getDoc, getDocs, setDoc, updateDoc, query, where,
               onSnapshot, serverTimestamp } from "firebase/firestore";
      import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
      const storage = getStorage();   // optional but strongly recommended for uploads
═══════════════════════════════════════════════════════ */}
{currentView === "providerVerificationPipeline" && (
  <>
    {/* ── SECURITY WATERMARK, CAPTURE SHIELD & SPINNER STYLES ───────────── */}
    <style>{`
      @media print {
        body * { display: none !important; }
        body::before {
          content: "CONFIDENTIAL AUDIT DATA — PRINTING AND SCREEN CAPTURE IS STRICTLY PROHIBITED";
          display: block !important;
          font-size: 24px;
          font-weight: 800;
          color: #dc2626;
          text-align: center;
          padding-top: 100px;
        }
      }
      .no-screen-capture {
        -webkit-touch-callout: none !important;
        -webkit-user-select: none !important;
        -khtml-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        user-select: none !important;
      }
      .doc-preview-shield {
        pointer-events: none;
        position: absolute;
        inset: 0;
        background: repeating-linear-gradient(
          45deg,
          rgba(15, 23, 42, 0.02),
          rgba(15, 23, 42, 0.02) 40px,
          rgba(239, 68, 68, 0.04) 40px,
          rgba(239, 68, 68, 0.04) 80px
        );
        z-index: 1;
      }
      .pipeline-filter-input::placeholder {
        color: #94a3b8;
      }
      @keyframes shieldPulse {
        0% { box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.7); }
        70% { box-shadow: 0 0 0 14px rgba(220, 38, 38, 0); }
        100% { box-shadow: 0 0 0 0 rgba(220, 38, 38, 0); }
      }
      .security-alert-box {
        animation: shieldPulse 1.8s infinite;
      }
      @keyframes pipelineSpin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      .pipeline-spin-icon {
        display: inline-block;
        animation: pipelineSpin 0.9s linear infinite;
      }

      /* ── SELFIE CLICK-TO-ZOOM PREVIEW: ANIMATIONS + RESPONSIVE LAYOUT ── */
      @keyframes selfieBackdropIn  { from { opacity: 0; } to { opacity: 1; } }
      @keyframes selfieBackdropOut { from { opacity: 1; } to { opacity: 0; } }
      @keyframes selfiePanelIn {
        from { opacity: 0; transform: scale(0.92) translateY(14px); }
        to   { opacity: 1; transform: scale(1) translateY(0); }
      }
      @keyframes selfiePanelOut {
        from { opacity: 1; transform: scale(1) translateY(0); }
        to   { opacity: 0; transform: scale(0.94) translateY(10px); }
      }
      .selfie-backdrop-open  { animation: selfieBackdropIn 0.24s ease-out forwards; }
      .selfie-backdrop-close { animation: selfieBackdropOut 0.22s ease-in forwards; }
      .selfie-panel-open     { animation: selfiePanelIn 0.28s cubic-bezier(0.2, 0.9, 0.3, 1) forwards; }
      .selfie-panel-close    { animation: selfiePanelOut 0.22s ease-in forwards; }
      .selfie-preview-panel {
        width: min(1100px, 96vw);
        height: min(90vh, 900px);
        max-height: 90vh;
      }
      .selfie-zoom-trigger { cursor: zoom-in; transition: transform 0.18s ease, box-shadow 0.18s ease; }
      .selfie-zoom-trigger:hover { transform: scale(1.03); box-shadow: 0 4px 14px rgba(37, 99, 235, 0.25); }
      .selfie-zoom-btn:hover:not(:disabled) { background: #334155 !important; }
      .selfie-zoom-btn:disabled { opacity: 0.4; cursor: not-allowed !important; }
      @media (max-width: 1024px) {
        .selfie-preview-panel { width: min(94vw, 860px); height: min(88vh, 820px); }
      }
      @media (max-width: 640px) {
        .selfie-preview-panel {
          width: 100vw;
          height: 100vh;
          height: 100dvh;
          max-height: 100dvh;
          border-radius: 0 !important;
        }
        .selfie-preview-label { display: none !important; }
        .selfie-preview-toolbar { padding: 8px 10px !important; gap: 6px !important; }
        .selfie-preview-title { font-size: 12px !important; }
      }
    `}</style>

    {/* ── CORE ENGINE, RE-RENDER TRIGGER, HELPERS, AUDIT & PERSISTENCE ────── */}
    {(() => {
      if (typeof window !== "undefined") {
        /* Storage Keys (record caches are LEGACY and are purged — only audit logs persist locally) */
        window.__LS_BOARD_KEY = "pipeline_board_records_cache";
        window.__LS_KANBAN_KEY = "pipeline_kanban_records_cache";
        window.__LS_AUDIT_KEY = "provider_stage_transition_logs";
        window.__LS_DOC_ACCESS_KEY = "pipeline_sensitive_doc_access_logs";
        window.__DOCUMENT_EXPIRY_MONTHS = 6;
        window.__PIPELINE_PASSCODE = "8972";

        /* When true, snapshots served from the local Firestore cache are ignored so that
           ONLY fresh server data is ever displayed. */
        if (typeof window.__IGNORE_CACHED_SNAPSHOTS === "undefined") {
          window.__IGNORE_CACHED_SNAPSHOTS = true;
        }

        /* Sync Spinner Active State */
        if (typeof window.__isPipelineSyncing === "undefined") {
          window.__isPipelineSyncing = false;
        }

        /* Master in-memory registry ensuring zero data loss and no duplicates */
        if (!window.__pipelineMasterRegistry) {
          window.__pipelineMasterRegistry = new Map();
        }
        if (!window.__kanbanProviderIdSet) {
          window.__kanbanProviderIdSet = new Set();
        }
        if (!window.__firestoreExistingDocIds) {
          window.__firestoreExistingDocIds = {
            providers: new Map(),
            users: new Map(),
            VerificationDocuments: new Map(),
          };
        }

        /* Real-time engine state */
        if (!window.__pendingStageOverrides) window.__pendingStageOverrides = new Map();
        if (!window.__autoBlockPersisted) window.__autoBlockPersisted = new Set();
        if (!window.__autoUnblockPersisted) window.__autoUnblockPersisted = new Set();
        if (typeof window.__pipelineListenersActive === "undefined") window.__pipelineListenersActive = false;
        if (!window.__pipelineUnsubs) window.__pipelineUnsubs = [];
        if (typeof window.__docUploadState === "undefined") window.__docUploadState = null;

        /* Image failures mapping */
        if (!window.__docThumbFailedMap) window.__docThumbFailedMap = {};
        if (!window.__docPreviewForceIframeMap) window.__docPreviewForceIframeMap = {};

        /* Active Filter & Sorting States */
        if (typeof window.__pipelineUidSearchQuery === "undefined") window.__pipelineUidSearchQuery = "";
        if (typeof window.__pipelineSortOrder === "undefined") window.__pipelineSortOrder = "default";
        if (typeof window.__pipelineExpiredOnly === "undefined") window.__pipelineExpiredOnly = false;

        /* Force UI Refresh Trigger */
        window.__triggerPipelineReRender = () => {
          if (typeof setDocumentPreviewModal === "function") {
            setDocumentPreviewModal((p) => ({ ...(p || {}), _t: Date.now() }));
          }
        };

        /* ══════════════════════════════════════════════════════════════
           SELFIE CLICK-TO-ZOOM PREVIEW ENGINE
           - Uses ONLY the selfieUrl that is already loaded from Firebase (no upload logic).
           - State lives in window.__selfiePreviewState (same pattern as the other gates).
           - Zoom / pan are applied straight to the <img> DOM node for smooth, lag-free
             interaction; the state object is the single source of truth, so any React
             re-render simply re-applies the same transform.
        ══════════════════════════════════════════════════════════════ */
        window.__SELFIE_MIN_SCALE = 1;
        window.__SELFIE_MAX_SCALE = 6;
        window.__SELFIE_BUTTON_STEP = 0.5;
        if (typeof window.__selfiePreviewState === "undefined") window.__selfiePreviewState = null;

        window.__openSelfiePreview = (url, name) => {
          const cleanUrl = String(url || "").trim();
          if (!cleanUrl) return;
          window.__selfiePreviewState = {
            open: true,
            closing: false,
            url: cleanUrl,
            name: name || "Selfie Verification",
            scale: 1,
            x: 0,
            y: 0,
            dragging: false,
            startX: 0,
            startY: 0,
            loaded: false,
            error: false,
          };
          window.__triggerPipelineReRender();
        };

        window.__closeSelfiePreview = () => {
          const s = window.__selfiePreviewState;
          if (!s || s.closing) return;
          s.closing = true;
          s.dragging = false;
          window.__triggerPipelineReRender();
          setTimeout(() => {
            /* Only clear if the same preview is still the one that was closing */
            if (window.__selfiePreviewState === s) {
              window.__selfiePreviewState = null;
              window.__triggerPipelineReRender();
            }
          }, 230);
        };

        /* Keep the zoomed image from being dragged completely out of view */
        window.__clampSelfiePan = (s) => {
          if (!s) return;
          if (s.scale <= 1) {
            s.x = 0;
            s.y = 0;
            return;
          }
          const stage = document.getElementById("selfie-preview-stage");
          const img = document.getElementById("selfie-preview-img");
          if (!stage || !img) return;
          const scaledW = img.offsetWidth * s.scale;
          const scaledH = img.offsetHeight * s.scale;
          const maxX = Math.max(0, (scaledW - stage.clientWidth) / 2) + 60;
          const maxY = Math.max(0, (scaledH - stage.clientHeight) / 2) + 60;
          s.x = Math.min(maxX, Math.max(-maxX, s.x));
          s.y = Math.min(maxY, Math.max(-maxY, s.y));
        };

        /* Push the current state straight into the DOM (no React re-render needed) */
        window.__applySelfieTransform = () => {
          const s = window.__selfiePreviewState;
          if (!s) return;
          const img = document.getElementById("selfie-preview-img");
          if (img) {
            img.style.transition = s.dragging ? "none" : "transform 0.18s ease-out";
            img.style.transform = `translate(${s.x}px, ${s.y}px) scale(${s.scale})`;
            img.style.cursor = s.scale > 1 ? (s.dragging ? "grabbing" : "grab") : "zoom-in";
          }
          const label = document.getElementById("selfie-zoom-level-label");
          if (label) label.textContent = `${Math.round(s.scale * 100)}%`;
          const inBtn = document.getElementById("selfie-zoom-in-btn");
          if (inBtn) inBtn.disabled = s.scale >= window.__SELFIE_MAX_SCALE - 0.001;
          const outBtn = document.getElementById("selfie-zoom-out-btn");
          if (outBtn) outBtn.disabled = s.scale <= window.__SELFIE_MIN_SCALE + 0.001;
        };

        window.__setSelfieZoom = (nextScale) => {
          const s = window.__selfiePreviewState;
          if (!s || s.closing) return;
          const clamped = Math.min(window.__SELFIE_MAX_SCALE, Math.max(window.__SELFIE_MIN_SCALE, nextScale));
          if (clamped === s.scale) return;
          const ratio = clamped / s.scale;
          s.x *= ratio;
          s.y *= ratio;
          s.scale = clamped;
          window.__clampSelfiePan(s);
          window.__applySelfieTransform();
        };

        window.__selfieZoomIn = () => {
          const s = window.__selfiePreviewState;
          if (s) window.__setSelfieZoom(s.scale + window.__SELFIE_BUTTON_STEP);
        };
        window.__selfieZoomOut = () => {
          const s = window.__selfiePreviewState;
          if (s) window.__setSelfieZoom(s.scale - window.__SELFIE_BUTTON_STEP);
        };
        window.__selfieZoomReset = () => {
          const s = window.__selfiePreviewState;
          if (!s) return;
          s.scale = 1;
          s.x = 0;
          s.y = 0;
          window.__applySelfieTransform();
        };

        /* Mouse wheel zoom (bound as a NON-passive native listener so preventDefault works) */
        window.__selfieWheelHandler = (e) => {
          const s = window.__selfiePreviewState;
          if (!s || s.closing) return;
          e.preventDefault();
          e.stopPropagation();
          const factor = e.deltaY < 0 ? 1.15 : 1 / 1.15;
          window.__setSelfieZoom(s.scale * factor);
        };

        /* Drag-to-pan (Pointer Events: mouse, pen and touch) */
        window.__selfiePointerDown = (e) => {
          const s = window.__selfiePreviewState;
          if (!s || s.closing || s.scale <= 1) return;
          e.preventDefault();
          s.dragging = true;
          s.startX = e.clientX - s.x;
          s.startY = e.clientY - s.y;
          try { e.currentTarget.setPointerCapture(e.pointerId); } catch (err) {}
          window.__applySelfieTransform();
        };
        window.__selfiePointerMove = (e) => {
          const s = window.__selfiePreviewState;
          if (!s || !s.dragging) return;
          s.x = e.clientX - s.startX;
          s.y = e.clientY - s.startY;
          window.__clampSelfiePan(s);
          window.__applySelfieTransform();
        };
        window.__selfiePointerUp = (e) => {
          const s = window.__selfiePreviewState;
          if (!s || !s.dragging) return;
          s.dragging = false;
          try { e.currentTarget.releasePointerCapture(e.pointerId); } catch (err) {}
          window.__applySelfieTransform();
        };
        /* Double-click / double-tap toggles between fit and 2.5x */
        window.__selfieDoubleClick = () => {
          const s = window.__selfiePreviewState;
          if (!s) return;
          window.__setSelfieZoom(s.scale > 1 ? 1 : 2.5);
        };

        /* Keyboard: Esc closes, + / - zoom, 0 resets (bound once) */
        if (!window.__selfieKeyboardBound) {
          window.__selfieKeyboardBound = true;
          window.addEventListener("keydown", (e) => {
            const s = window.__selfiePreviewState;
            if (!s || s.closing) return;
            if (e.key === "Escape") {
              e.preventDefault();
              window.__closeSelfiePreview();
            } else if (e.key === "+" || e.key === "=") {
              e.preventDefault();
              window.__selfieZoomIn();
            } else if (e.key === "-" || e.key === "_") {
              e.preventDefault();
              window.__selfieZoomOut();
            } else if (e.key === "0") {
              e.preventDefault();
              window.__selfieZoomReset();
            }
          });
        }

        /* Helper to check if any protected document surface is currently active */
        window.__isProtectedDocSurfaceOpen = () => {
          const isDocSectionOpen = window.__activeSectionModal?.open &&
            (window.__activeSectionModal.tab === "documents" || window.__activeSectionModal.tab === "docTypes");
          const isPreviewOpen = Boolean(window.__isDocPreviewActive || (typeof documentPreviewModal !== "undefined" && documentPreviewModal?.open));
          const isDrawerOpen = Boolean(
            (typeof providerDrawerVisible !== "undefined" && providerDrawerVisible) ||
            (typeof profileDrawerOpen !== "undefined" && profileDrawerOpen)
          );
          return Boolean(isDocSectionOpen || isPreviewOpen || isDrawerOpen);
        };

        /* Temporary override timestamp allowing capture after valid passcode entry */
        window.__securityOverrideActiveUntil = window.__securityOverrideActiveUntil || 0;

        /* ── SECURITY TRAP: SCREEN CAPTURE, SCREEN RECORDING & DOWNLOAD MONITOR ── */
        window.__showSecurityViolationAlert = (actionType = "Screenshot / Screen Recording / Download", onAuthorizeCallback = null) => {
          if (Date.now() < window.__securityOverrideActiveUntil) {
            if (typeof onAuthorizeCallback === "function") onAuthorizeCallback();
            return;
          }
          window.__securityViolationModalState = {
            open: true,
            action: actionType,
            timestamp: new Date().toLocaleTimeString(),
            showOverrideGate: false,
            overrideError: null,
            onAuthorizeCallback,
          };
          window.__logSensitiveDocAccess({
            action: "SECURITY_VIOLATION_ATTEMPT",
            resource: actionType,
            providerId: "SYSTEM_SHIELD",
            providerName: "Security Gate",
          });
          window.__triggerPipelineReRender();
        };

        /* Monkey-patch navigator.mediaDevices.getDisplayMedia */
        if (typeof navigator !== "undefined" && navigator.mediaDevices && !window.__screenCaptureProxySet) {
          window.__screenCaptureProxySet = true;
          try {
            const originalGetDisplayMedia = navigator.mediaDevices.getDisplayMedia ? navigator.mediaDevices.getDisplayMedia.bind(navigator.mediaDevices) : null;
            if (originalGetDisplayMedia) {
              navigator.mediaDevices.getDisplayMedia = async function(...args) {
                if (window.__isProtectedDocSurfaceOpen() && Date.now() >= window.__securityOverrideActiveUntil) {
                  window.__showSecurityViolationAlert("Desktop/Browser Screen Recording Stream Attempt");
                  throw new Error("Screen recording of confidential verification records is strictly prohibited.");
                }
                return originalGetDisplayMedia(...args);
              };
            }
          } catch (err) {
            console.warn("Could not patch getDisplayMedia:", err);
          }
        }

        if (!window.__securityListenersBound) {
          window.__securityListenersBound = true;
          window.addEventListener("keydown", (e) => {
            if (Date.now() < window.__securityOverrideActiveUntil) return;
            const isDocOpen = window.__isProtectedDocSurfaceOpen();
            const key = String(e.key || "").toLowerCase();
            const code = String(e.code || "").toLowerCase();
            const isPrintScreen = e.key === "PrintScreen" || code === "printscreen";
            const isPrintOrSave = (e.ctrlKey || e.metaKey) && (key === "p" || key === "s" || key === "u");
            const isMacScreenshot = e.metaKey && e.shiftKey && (key === "3" || key === "4" || key === "5" || key === "6");
            const isWindowsSnipping = (e.metaKey || e.ctrlKey) && e.shiftKey && key === "s";
            const isWindowsGameBarRecord = (e.metaKey || e.ctrlKey) && e.altKey && key === "r";
            const isWindowsGameBar = (e.metaKey || e.ctrlKey) && key === "g";
            const isGenericScreenRecordShortcut = (e.ctrlKey || e.metaKey) && (e.altKey || e.shiftKey) && (key === "r" || key === "c" || key === "x" || key === "e");
            const isNvidiaRecord = e.altKey && (key === "f9" || key === "f10");
            const isDevTools = key === "f12" || ((e.ctrlKey || e.metaKey) && e.shiftKey && (key === "i" || key === "c" || key === "j"));
            if (
              isPrintScreen ||
              isPrintOrSave ||
              isMacScreenshot ||
              isWindowsSnipping ||
              isWindowsGameBarRecord ||
              isWindowsGameBar ||
              isNvidiaRecord ||
              (isDocOpen && (isGenericScreenRecordShortcut || isDevTools))
            ) {
              e.preventDefault();
              e.stopPropagation();
              if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText("").catch(() => {});
              }
              const reason = isWindowsGameBarRecord || isWindowsGameBar
                ? "Windows Screen Recording Tool Attempt (Win+Alt+R / Win+G)"
                : isMacScreenshot
                ? "Mac Screen Recording / Capture Shortcut (Cmd+Shift+3/4/5)"
                : isWindowsSnipping
                ? "Windows Snipping Screen Capture Attempt (Win+Shift+S)"
                : isNvidiaRecord
                ? "Hardware Screen Recording Tool (Alt+F9/F10)"
                : isPrintScreen
                ? "PrintScreen Capture Attempt"
                : "Screen Recording / Capture Shortcut Attempt";
              window.__showSecurityViolationAlert(reason);
            }
          }, true);

          window.addEventListener("keyup", (e) => {
            if (Date.now() < window.__securityOverrideActiveUntil) return;
            if (e.key === "PrintScreen" || String(e.code || "").toLowerCase() === "printscreen") {
              if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText("").catch(() => {});
              }
              window.__showSecurityViolationAlert("PrintScreen Screen Capture Attempt");
            }
          }, true);

          window.addEventListener("touchstart", (e) => {
            if (Date.now() < window.__securityOverrideActiveUntil) return;
            if (window.__isProtectedDocSurfaceOpen() && e.touches && e.touches.length >= 3) {
              e.preventDefault();
              e.stopPropagation();
              window.__showSecurityViolationAlert("Mobile Multi-Finger Screenshot Gesture Detected (iPhone / Android)");
            }
          }, { passive: false });

          window.addEventListener("visibilitychange", () => {
            if (Date.now() < window.__securityOverrideActiveUntil) return;
            if (document.hidden && window.__isProtectedDocSurfaceOpen()) {
              window.__showSecurityViolationAlert("Mobile Hardware Screenshot (Power + Volume) / Screen Recording Activity Detected");
            }
          });

          window.addEventListener("blur", () => {
            if (Date.now() < window.__securityOverrideActiveUntil) return;
            if (window.__isProtectedDocSurfaceOpen()) {
              window.__showSecurityViolationAlert("Screen Recording / Mobile Hardware Capture / System Overlay Detected");
            }
          });

          window.addEventListener("pagehide", () => {
            if (Date.now() < window.__securityOverrideActiveUntil) return;
            if (window.__isProtectedDocSurfaceOpen()) {
              window.__showSecurityViolationAlert("Screen Capture / App Backgrounding Detected (iOS / Android)");
            }
          });

          window.addEventListener("contextmenu", (e) => {
            if (Date.now() < window.__securityOverrideActiveUntil) return;
            if (window.__isProtectedDocSurfaceOpen()) {
              e.preventDefault();
              window.__showSecurityViolationAlert("Right-Click / Context Menu Action Prevented");
            }
          });
        }

        /* Identity Resolver */
        window.__getProviderCanonId = (record) => {
          if (!record) return "";
          return String(record.uid || record.userId || record.providerId || record.id || "").trim();
        };

        /* Check if Provider is Unnamed */
        window.__isUnnamedProvider = (record) => {
          if (!record) return false;
          const raw = String(record.providerDisplayName || record.name || record.displayName || "").trim().toLowerCase();
          return !raw || raw === "unnamed provider" || raw === "unnamed" || raw === "unnamedprovider";
        };

        /* Canonical Display Name Resolver */
        window.__getProviderDisplayName = (record) => {
          if (!record) return "Provider";
          const raw = String(record.providerDisplayName || record.name || record.displayName || "").trim();
          const isUnnamed = !raw || /^unnamed(\s*provider)?$/i.test(raw);
          if (isUnnamed) {
            if (record.username && String(record.username).trim() && !/^unnamed/i.test(String(record.username).trim())) {
              return String(record.username).trim();
            }
            if (record.fullName && String(record.fullName).trim() && !/^unnamed/i.test(String(record.fullName).trim())) {
              return String(record.fullName).trim();
            }
          }
          return raw || record.username || record.fullName || "Provider";
        };

        /* Selfie Resolvers */
        window.__getProviderSelfieUrl = (record) => {
          if (!record) return "";
          return String(record.selfieUrl || "").trim();
        };
        window.__isProviderSelfieCaptured = (record) => {
          if (!record) return false;
          if (typeof record.selfieCaptured === "boolean") return record.selfieCaptured;
          return Boolean(window.__getProviderSelfieUrl(record));
        };

        /* Document URL Resolver */
        window.__getDocumentFileUrl = (docItem) => {
          if (!docItem) return "";
          return String(docItem.fileUrl || docItem.downloadURL || docItem.url || "").trim();
        };
        window.__isKnownNonImageDocUrl = (url) => {
          if (!url) return false;
          return /\.(pdf|docx?|xlsx?|csv|zip|rar|7z)(\?|#|$)/i.test(String(url));
        };
        window.__looksLikeImageDocUrl = (url) => {
          if (!url) return false;
          if (/^data:application\/pdf/i.test(String(url))) return false;
          if (/\.(png|jpe?g|webp|gif|bmp|heic|heif|svg)(\?|#|$)/i.test(String(url))) return true;
          return !window.__isKnownNonImageDocUrl(url);
        };

        /* ── SENSITIVE DATA ACCESS LOGGING ── */
        window.__logSensitiveDocAccess = ({ providerId, providerName, docName, docType, action, resource }) => {
          try {
            const currentUser =
              (typeof auth !== "undefined" && auth?.currentUser?.email) ||
              (typeof currentAdminUser !== "undefined" && currentAdminUser?.email) ||
              "Admin Verified Authority";
            const targetResource = resource || docName || docType || "Sensitive Verification Record";
            const storageKey = window.__LS_DOC_ACCESS_KEY;
            const existingRaw = localStorage.getItem(storageKey);
            const logs = existingRaw ? JSON.parse(existingRaw) : [];
            const previousAccesses = logs.filter(
              (l) => l && l.providerId === String(providerId) && l.accessedBy === currentUser && l.targetResource === targetResource
            );
            const accessCount = previousAccesses.length + 1;
            const accessEntry = {
              id: `doc_access_${Date.now()}_${Math.random().toString(36).substring(2, 6)}`,
              accessedBy: currentUser,
              providerId: String(providerId || ""),
              providerName: providerName || "Provider",
              targetResource,
              docType: docType || "Document",
              action: action || "ACCESS_VIEW",
              accessCount,
              timestamp: new Date().toISOString(),
              formattedTime: new Date().toLocaleString(),
            };
            logs.unshift(accessEntry);
            if (logs.length > 600) logs.pop();
            localStorage.setItem(storageKey, JSON.stringify(logs));
          } catch (err) {
            console.warn("Sensitive access logging error:", err);
          }
        };

        window.__getSensitiveDocAccessLogs = (providerId) => {
          try {
            const raw = localStorage.getItem(window.__LS_DOC_ACCESS_KEY);
            if (!raw) return [];
            const parsed = JSON.parse(raw);
            if (!Array.isArray(parsed)) return [];
            const pIdStr = String(providerId || "").trim();
            return pIdStr
              ? parsed.filter((l) => l && String(l.providerId).trim() === pIdStr)
              : parsed.filter(Boolean);
          } catch (e) {
            return [];
          }
        };

        /* Section Modal Controller with Passcode Gates */
        window.__openPipelineSectionModal = (tab, record) => {
          if (tab === "documents") {
            window.__allDocsAuthModalState = {
              open: true,
              record,
              error: null,
              onSuccess: () => {
                window.__activeSectionModal = { open: true, tab: "documents", record };
                window.__logSensitiveDocAccess({
                  providerId: window.__getProviderCanonId(record),
                  providerName: window.__getProviderDisplayName(record),
                  docType: "All Documents Tab Access",
                  action: "AUTHORIZED_ALL_DOCS_UNLOCK",
                });
                window.__triggerPipelineReRender();
              },
            };
            window.__triggerPipelineReRender();
            return;
          }
          if (tab === "docTypes") {
            window.__docTypesAuthModalState = {
              open: true,
              record,
              error: null,
              onSuccess: () => {
                window.__activeSectionModal = { open: true, tab: "docTypes", record };
                window.__logSensitiveDocAccess({
                  providerId: window.__getProviderCanonId(record),
                  providerName: window.__getProviderDisplayName(record),
                  docType: "Categorized Doc Types Access",
                  action: "AUTHORIZED_DOC_TYPES_UNLOCK",
                });
                window.__triggerPipelineReRender();
              },
            };
            window.__triggerPipelineReRender();
            return;
          }
          window.__activeSectionModal = { open: true, tab, record };
          window.__triggerPipelineReRender();
        };

        window.__closePipelineSectionModal = () => {
          window.__activeSectionModal = null;
          window.__triggerPipelineReRender();
        };

        /* Document Access Passcode Gate */
        window.__promptDocAccessPasscode = ({ docItem, url, providerRecord, categoryTitle }) => {
          window.__docItemAuthModalState = {
            open: true,
            docItem,
            url,
            providerRecord,
            categoryTitle,
            error: null,
            onConfirm: (enteredPasscode) => {
              if (String(enteredPasscode || "").trim() === window.__PIPELINE_PASSCODE) {
                window.__docItemAuthModalState = null;
                window.__isDocPreviewActive = true;
                window.__logSensitiveDocAccess({
                  providerId: window.__getProviderCanonId(providerRecord),
                  providerName: window.__getProviderDisplayName(providerRecord),
                  docName: docItem.name || "Document File",
                  docType: categoryTitle || docItem.docType || "Document",
                  action: "AUTHENTICATED_DOCUMENT_PREVIEW",
                });
                if (typeof setDocumentPreviewModal === "function") {
                  setDocumentPreviewModal({
                    open: true,
                    doc: docItem,
                    url: url,
                  });
                }
                window.__triggerPipelineReRender();
              } else {
                window.__docItemAuthModalState.error = "Incorrect Security Passcode. Access denied.";
                window.__triggerPipelineReRender();
              }
            },
          };
          window.__triggerPipelineReRender();
        };

        /* Board Access Passcode Modal Handler */
        window.__promptBoardAccessPassword = (targetMode, onSuccess) => {
          window.__boardPasscodeModalState = {
            open: true,
            targetMode,
            error: null,
            onConfirm: (enteredKey) => {
              if (String(enteredKey || "").trim() === window.__PIPELINE_PASSCODE) {
                window.__boardPasscodeModalState = null;
                if (typeof onSuccess === "function") onSuccess();
                window.__triggerPipelineReRender();
              } else {
                window.__boardPasscodeModalState.error = "Incorrect Security Passcode. Access denied.";
                window.__triggerPipelineReRender();
              }
            },
          };
          window.__triggerPipelineReRender();
        };

        /* Stage Transition Encrypted Gates */
        window.__openEncryptedStageGateModal = (params) => {
          window.__encryptedStageGateState = {
            open: true,
            error: null,
            ...params,
          };
          window.__triggerPipelineReRender();
        };

        window.__openApprovalReasonModal = (params) => {
          window.__openEncryptedStageGateModal({
            ...params,
            fromStage: params.fromStage || params.provider?.approvalStage || "verification_completed",
            toStage: "approved",
            title: "🔐 Authorization & Approval Gate",
            description: `Authorizing approval for ${window.__getProviderDisplayName(params.provider)}. Security authorization key and justification required.`,
          });
        };

        /* Critical Transition Confirmation Modal */
        window.__openCriticalTransitionModal = (params) => {
          window.__criticalTransitionModalState = {
            open: true,
            error: null,
            provider: params.provider,
            providerId: window.__getProviderCanonId(params.provider),
            fromStage: params.fromStage,
            toStage: params.toStage,
            targetStageId: params.targetStageId || params.toStage,
            onConfirm: params.onConfirm,
          };
          window.__triggerPipelineReRender();
        };

        /* Strict Role Filter */
        window.__isRecordInvalidOrCustomer = (record) => {
          if (!record) return true;
          if (record.customerName || record.customer_name || record.customerId || record.customerToken) {
            return true;
          }
          const role = String(record.role || "").toLowerCase().trim();
          if (role !== "provider") return true;
          const userType = String(record.userType || "").toLowerCase().trim();
          if (userType === "user" || userType === "customer") return true;
          const id = record.id || record.uid || record.serviceReference;
          const name = record.providerDisplayName || record.name || record.displayName || record.fullName || record.username;
          if (!id || !name || String(name).trim().length < 2) return true;
          return false;
        };

        window.__normalizeStageStr = (str) => {
          if (!str) return "";
          return String(str).toLowerCase().trim().replace(/[^a-z0-9]/g, "");
        };

        window.__getStageCategory = (stageStr) => {
          if (!stageStr) return "pending";
          const s = window.__normalizeStageStr(stageStr);
          if (s === "blocked" || s === "restricted" || s === "docsexpired" || s === "expired") return "blocked";
          if (s === "rejected" || s === "reject") return "rejected";
          if (s === "verificationcompleted" || s === "completed") return "completed";
          if (s === "approved" || s === "verified" || s === "active") return "approved";
          if (s === "internalreview" || s === "underreview" || s === "inreview" || s === "review") return "review";
          if (s === "verificationstarted" || s === "inverification" || s === "started" || s === "verifying" || s === "inprogress") return "started";
          if (s === "newprovider" || s === "new" || s === "newuser" || s === "newregistration") return "new";
          if (s === "verificationpending" || s === "pendingverification" || s === "pending" || s === "unassigned") return "pending";
          return s;
        };

        window.__isStageMatch = (stageA, stageB) => {
          if (!stageA || !stageB) return false;
          return window.__getStageCategory(stageA) === window.__getStageCategory(stageB);
        };

        window.__getStageMeta = (stageStr) => {
          const cat = window.__getStageCategory(stageStr);
          switch (cat) {
            case "new":
              return { label: "New Provider", shortLabel: "New", color: "#4f46e5", bg: "#e0e7ff" };
            case "pending":
              return { label: "Verification Pending", shortLabel: "Pending", color: "#2563eb", bg: "#dbeafe" };
            case "started":
              return { label: "Verification Started", shortLabel: "Started", color: "#d97706", bg: "#fef3c7" };
            case "review":
              return { label: "Under Review", shortLabel: "Review", color: "#7c3aed", bg: "#ede9fe" };
            case "completed":
              return { label: "Verification Completed", shortLabel: "Completed", color: "#059669", bg: "#d1fae5" };
            case "approved":
              return { label: "Approved", shortLabel: "Approved", color: "#16a34a", bg: "#dcfce7" };
            case "rejected":
              return { label: "Rejected", shortLabel: "Rejected", color: "#dc2626", bg: "#fee2e2" };
            case "blocked":
              return { label: "Blocked — Expired Docs", shortLabel: "Blocked", color: "#b91c1c", bg: "#fee2e2" };
            default:
              return { label: String(stageStr || "Pending").replace(/_/g, " "), shortLabel: "Pending", color: "#475569", bg: "#f1f5f9" };
          }
        };

        /* ── AUTOMATED DATE SANITIZER: ELIMINATES "Invalid Date" ── */
        window.__toDocDate = (value) => {
          if (!value) return null;
          try {
            if (typeof value?.toDate === "function") return value.toDate();
            if (typeof value?.seconds === "number") return new Date(value.seconds * 1000);
            if (typeof value === "number") return new Date(value);
            const parsed = new Date(value);
            return Number.isNaN(parsed.getTime()) ? null : parsed;
          } catch (e) {
            return null;
          }
        };

        window.__formatCleanDate = (value, fallback = "—") => {
          const d = window.__toDocDate(value);
          if (!d) return fallback;
          try {
            return d.toLocaleString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            });
          } catch (e) {
            return fallback;
          }
        };

        /* Compute Days Since Provider Signed Up */
        window.__getDaysSinceSignup = (record) => {
          if (!record) return 0;
          const raw =
            record.createdAt ||
            record.createdDate ||
            record.registeredAt ||
            record.joinedAt ||
            record.registrationDate ||
            record.submittedAt ||
            record.timestamp;
          const d = window.__toDocDate(raw);
          if (!d) return 0;
          const diffMs = Date.now() - d.getTime();
          if (diffMs < 0) return 0;
          return Math.floor(diffMs / (1000 * 60 * 60 * 24));
        };

        window.__getSignupDateTimestamp = (record) => {
          if (!record) return 0;
          const raw =
            record.createdAt ||
            record.createdDate ||
            record.registeredAt ||
            record.joinedAt ||
            record.registrationDate ||
            record.submittedAt ||
            record.timestamp;
          const d = window.__toDocDate(raw);
          return d ? d.getTime() : 0;
        };

        /* ── DOCUMENT EXPIRY CHECKING & AUTOMATED FRONT-END BLOCKING ── */
        window.__getDocumentExpiryDate = (docItem) => {
          if (!docItem) return null;
          const explicit =
            window.__toDocDate(docItem.expiryDate) ||
            window.__toDocDate(docItem.validUntil) ||
            window.__toDocDate(docItem.passportValidUntil) ||
            window.__toDocDate(docItem.visaValidUntil);
          if (explicit) return explicit;
          return null;
        };

        window.__isDocumentExpired = (docItem) => {
          if (!docItem) return false;
          if (docItem.isExpired === true || docItem.status === "expired" || docItem.verificationStatus === "expired") return true;
          const expiry = window.__getDocumentExpiryDate(docItem);
          if (!expiry) return false;
          return expiry.getTime() < Date.now();
        };

        window.__isDocumentExpiringSoon = (docItem, daysThreshold = 60) => {
          if (!docItem) return false;
          if (window.__isDocumentExpired(docItem)) return true;
          const expiry = window.__getDocumentExpiryDate(docItem);
          if (!expiry) return false;
          const diffDays = (expiry.getTime() - Date.now()) / (1000 * 60 * 60 * 24);
          return diffDays >= 0 && diffDays <= daysThreshold;
        };

        window.__hasAnyDocumentExpired = (record) => {
          if (!record) return false;
          const docs = record?.documents || [];
          if (Array.isArray(docs) && docs.some((d) => window.__isDocumentExpired(d))) return true;
          const vMeta = record.verificationMeta || {};
          const candidateDates = [
            record.visaValidUntil,
            vMeta.visaValidUntil,
            record.passportValidUntil,
            vMeta.passportValidUntil,
            record.expiryDate,
            vMeta.expiryDate,
          ];
          for (const rawDate of candidateDates) {
            const parsed = window.__toDocDate(rawDate);
            if (parsed && parsed.getTime() < Date.now()) {
              return true;
            }
          }
          return false;
        };

        window.__hasDocumentGoingToExpire = (record) => {
          if (!record) return false;
          const cId = window.__getProviderCanonId(record);
          if (cId && window.__kanbanProviderIdSet.has(cId)) return true;
          if (window.__isProviderBlocked(record)) return true;
          const docs = record?.documents || [];
          if (Array.isArray(docs) && docs.some((d) => window.__isDocumentExpiringSoon(d, 60))) return true;
          const vMeta = record.verificationMeta || {};
          const candidateDates = [
            record.visaValidUntil,
            vMeta.visaValidUntil,
            record.passportValidUntil,
            vMeta.passportValidUntil,
            record.expiryDate,
            vMeta.expiryDate,
          ];
          for (const rawDate of candidateDates) {
            const parsed = window.__toDocDate(rawDate);
            if (parsed) {
              const diffDays = (parsed.getTime() - Date.now()) / (1000 * 60 * 60 * 24);
              if (diffDays <= 60) return true;
            }
          }
          return false;
        };

        /* Provider Is Blocked Logic */
        window.__isProviderBlocked = (record) => {
          if (!record) return false;
          const cur = String(record.approvalStage || record.status || "").toLowerCase();
          if (cur === "rejected") return false;
          return window.__hasAnyDocumentExpired(record);
        };

        /* ── AUTOMATED EXPIRED ENGINE: GET EFFECTIVE STAGE & AUTO BLOCK ── */
        window.__getEffectiveProviderStage = (record) => {
          if (!record) return "verification_pending";
          if (window.__isProviderBlocked(record)) {
            const pId = window.__getProviderCanonId(record);
            if (pId && record.approvalStage !== "blocked") {
              record.approvalStage = "blocked";
              record.status = "blocked";
              record.eligibilityStatus = "Ineligible (Expired Docs)";
              if (window.__pipelineMasterRegistry) {
                window.__pipelineMasterRegistry.set(pId, { ...record });
              }
              if (window.__kanbanProviderIdSet) {
                window.__kanbanProviderIdSet.add(pId);
              }
              /* Loop guard: persist the automatic block to Firestore only once per provider */
              if (
                typeof window.__executePipelineStageTransition === "function" &&
                !record.__autoBlockedTriggered &&
                !window.__autoBlockPersisted.has(pId)
              ) {
                record.__autoBlockedTriggered = true;
                window.__autoBlockPersisted.add(pId);
                setTimeout(() => {
                  window.__executePipelineStageTransition(pId, "blocked", "Automatic Stage Enforcement: Document Expired");
                }, 10);
              }
            }
            return "blocked";
          }
          return record.approvalStage || record.status || "verification_pending";
        };

        /* Dynamic Eligibility Status */
        window.__computeEligibilityStatus = (record) => {
          if (!record) return "Pending";
          if (window.__isProviderBlocked(record)) return "Ineligible (Expired Docs)";
          const currentStageCat = window.__getStageCategory(record.approvalStage || record.status);
          if (currentStageCat === "approved") return "approved";
          if (currentStageCat === "completed") return "Eligible";
          if (record.eligibilityStatus && record.eligibilityStatus !== "pending" && record.eligibilityStatus !== "Pending") {
            return record.eligibilityStatus;
          }
          const docs = record.documents || [];
          if (docs.length === 0) return "Pending Documents";
          const allVerified = docs.length > 0 && docs.every((d) => d.verificationStatus === "verified" || d.status === "verified");
          if (allVerified) return "Eligible";
          if (docs.length >= 1) return "Eligible (Under Review)";
          return "Pending";
        };

        /* Formatters */
        window.__formatServiceLocation = (value) => {
          if (!value) return "—";
          if (typeof value === "string") return value.trim() || "—";
          if (typeof value === "object") {
            if (value.address) return String(value.address);
            const lat = value.latitude ?? value.lat ?? value._lat;
            const lng = value.longitude ?? value.lng ?? value._long;
            if (lat !== undefined && lng !== undefined) return `${Number(lat).toFixed(3)}, ${Number(lng).toFixed(3)}`;
          }
          return String(value);
        };

        window.__getProviderProfileImage = (record) => {
          if (!record) return "";
          return (
            record.profileImage ||
            record.profileImageUrl ||
            record.photoURL ||
            record.avatar ||
            record.avatarUrl ||
            record.image ||
            `https://ui-avatars.com/api/?name=${encodeURIComponent(
              window.__getProviderDisplayName(record) || "Provider"
            )}&background=0F172A&color=FFFFFF&size=128`
          );
        };

        window.__getProviderShareCode = (record) => {
          if (!record) return "";
          if (record.shareCode) return String(record.shareCode);
          const id = String(record.id || record.uid || record.serviceReference || "000000");
          const cleaned = id.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
          return `PROV-${cleaned.slice(-6) || "VERIFIED"}`;
        };

        window.__isTargetShieldedProvider = (record) => {
          if (!record) return false;
          const pId = String(record.uid || record.userId || record.providerId || record.id || "").trim();
          const email = String(record.providerEmailAddress || record.email || "").trim().toLowerCase();
          return pId === "4YaxZSA92fAUQoYrNnGT" || email === "dpyekbi703@gmail.com";
        };

        /* Audit Logging */
        window.__logPipelineAudit = ({ action, providerId, providerName, reason, note, fromStage, toStage, approvedBy, approvedAt }) => {
          try {
            const currentUser =
              (typeof auth !== "undefined" && auth?.currentUser?.email) ||
              (typeof currentAdminUser !== "undefined" && currentAdminUser?.email) ||
              "Admin Verified Authority";
            const newLog = {
              id: `audit_${Date.now()}_${Math.random().toString(36).substr(2, 4)}`,
              action: String(action || "stage_change"),
              providerId: providerId ? String(providerId) : "",
              providerName: providerName || "Provider",
              fromStage: fromStage || "—",
              toStage: toStage || "—",
              reason: reason || "Stage Transition Authorized",
              note: note || "",
              movedBy: currentUser,
              approvedBy: approvedBy || (toStage === "approved" ? currentUser : null),
              approvedAt: approvedAt || (toStage === "approved" ? new Date().toISOString() : null),
              timestamp: new Date().toISOString(),
              formattedTime: new Date().toLocaleString(),
            };
            const stored = localStorage.getItem(window.__LS_AUDIT_KEY);
            const list = stored ? JSON.parse(stored) : [];
            list.unshift(newLog);
            if (list.length > 500) list.pop();
            localStorage.setItem(window.__LS_AUDIT_KEY, JSON.stringify(list));
          } catch (e) {
            console.warn("Could not write audit entry:", e);
          }
        };

        window.__getProviderAuditLogs = (providerId) => {
          try {
            const raw = localStorage.getItem(window.__LS_AUDIT_KEY);
            if (!raw) return [];
            const parsed = JSON.parse(raw);
            if (!Array.isArray(parsed)) return [];
            const pIdStr = String(providerId || "").trim();
            const filtered = pIdStr
              ? parsed.filter((l) => l && (String(l.providerId).trim() === pIdStr || String(l.userId).trim() === pIdStr))
              : parsed.filter(Boolean);
            return filtered.map((l, index) => ({
              id: l?.id || `log_${index}`,
              action: String(l?.action || "stage_change"),
              providerId: l?.providerId || "",
              providerName: l?.providerName || "Provider",
              fromStage: l?.fromStage || "—",
              toStage: l?.toStage || "—",
              reason: l?.reason || l?.note || "Compliance Logged",
              note: l?.note || "",
              movedBy: l?.movedBy || "Admin Authority",
              approvedBy: l?.approvedBy || null,
              approvedAt: l?.approvedAt ? window.__formatCleanDate(l.approvedAt) : null,
              timestamp: l?.timestamp || new Date().toISOString(),
              formattedTime: l?.formattedTime || window.__formatCleanDate(l?.timestamp, new Date().toLocaleString()),
            }));
          } catch (e) {
            return [];
          }
        };

        window.__getMergedNotesLogs = (record) => {
          if (!record) return [];
          const pId = window.__getProviderCanonId(record);
          const recordNotes = Array.isArray(record.notes) ? record.notes : [];
          const auditNotes = window.__getProviderAuditLogs(pId).filter((l) => l && (l.action === "note" || l.note));
          const list = [];
          const seen = new Set();
          auditNotes.forEach((a) => {
            const txt = a.note || a.reason;
            if (txt && !seen.has(txt)) {
              seen.add(txt);
              list.push({
                id: a.id,
                text: txt,
                author: a.movedBy,
                formattedTime: a.formattedTime,
                timestamp: new Date(a.timestamp).getTime(),
              });
            }
          });
          recordNotes.forEach((n) => {
            if (n && n.text && !seen.has(n.text)) {
              seen.add(n.text);
              list.push({
                id: n.id || Date.now(),
                text: n.text,
                author: n.author || "Admin",
                formattedTime: window.__formatCleanDate(n.createdAt, new Date().toLocaleString()),
                timestamp: Date.now(),
              });
            }
          });
          return list.sort((a, b) => b.timestamp - a.timestamp);
        };

        /* ── DEDUPLICATION ENGINE: DOCUMENTS & PROVIDER ARRAYS ── */
        window.__extractBestDocuments = (...candidates) => {
          const docMap = new Map();
          for (const cand of candidates) {
            let list = [];
            if (cand && Array.isArray(cand.documents) && cand.documents.length > 0) {
              list = cand.documents;
            } else if (Array.isArray(cand) && cand.length > 0) {
              list = cand;
            }
            for (const doc of list) {
              if (doc) {
                const uniqueKey = String(doc.id || doc.name || doc.fileUrl || doc.downloadURL || Math.random()).trim().toLowerCase();
                if (!docMap.has(uniqueKey)) {
                  docMap.set(uniqueKey, { ...doc });
                }
              }
            }
          }
          return Array.from(docMap.values());
        };

        /* ── INTERACTIVE DOCUMENT UPLOADER ENGINE → FIREBASE (VerificationDocuments) ──
           1. File goes to Firebase Storage (falls back to an inline data-URL only for small files
              when Storage is not configured).
           2. The download URL + metadata are merged into VerificationDocuments/{providerUid}
              under  documents.{docKey}  and  documentMeta.{docKey}.
           3. The real-time listener picks the change up and updates the provider card, All Docs
              tab and Doc Types tab automatically — nothing is stored only in memory. */
        window.__handleDocumentFileUpload = async (file, record, customDocType = "General Document") => {
          if (!file || !record) return;
          const pId = window.__getProviderCanonId(record);
          if (!pId) return;
          if (window.__docUploadState && window.__docUploadState.uploading) return;

          const setUploadState = (patch) => {
            window.__docUploadState = { providerId: pId, ...patch };
            window.__triggerPipelineReRender();
          };

          try {
            const MAX_BYTES = 10 * 1024 * 1024;
            if (file.size > MAX_BYTES) {
              throw new Error("File is larger than 10 MB. Please upload a smaller file.");
            }
            if (typeof db === "undefined" || typeof doc !== "function" || typeof setDoc !== "function") {
              throw new Error("Firestore functions (db, doc, setDoc) are not available in this scope.");
            }

            setUploadState({ uploading: true, success: false, error: null, fileName: file.name });

            const slug =
              String(customDocType || "document")
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "_")
                .replace(/^_+|_+$/g, "") || "document";
            const docKey = `${slug}_${Date.now()}`;
            const safeFileName = String(file.name || "file").replace(/[^a-zA-Z0-9._-]/g, "_");
            const currentAdmin =
              (typeof auth !== "undefined" && auth?.currentUser?.email) ||
              (typeof currentAdminUser !== "undefined" && currentAdminUser?.email) ||
              "Admin Verified Authority";

            let fileUrl = "";
            let storagePath = "";
            const storageReady =
              typeof storage !== "undefined" &&
              typeof ref === "function" &&
              typeof uploadBytes === "function" &&
              typeof getDownloadURL === "function";

            if (storageReady) {
              storagePath = `VerificationDocuments/${pId}/${docKey}_${safeFileName}`;
              const sRef = ref(storage, storagePath);
              await uploadBytes(sRef, file, { contentType: file.type || "application/octet-stream" });
              fileUrl = await getDownloadURL(sRef);
            } else {
              if (file.size > 700 * 1024) {
                throw new Error(
                  "Firebase Storage is not configured (storage, ref, uploadBytes, getDownloadURL) and the file exceeds the ~700 KB Firestore inline limit."
                );
              }
              fileUrl = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = () => reject(new Error("Could not read the selected file."));
                reader.readAsDataURL(file);
              });
            }

            /* Pick the existing VerificationDocuments doc for this provider, else use the UID */
            const knownIds = window.__firestoreExistingDocIds?.VerificationDocuments?.get(pId);
            let vdocId = pId;
            if (knownIds && knownIds.size > 0 && !knownIds.has(pId)) {
              vdocId = Array.from(knownIds)[0];
            }

            const ts = typeof serverTimestamp === "function" ? serverTimestamp() : new Date();
            await setDoc(
              doc(db, "VerificationDocuments", String(vdocId)),
              {
                userId: pId,
                uid: pId,
                providerId: pId,
                documents: { [docKey]: fileUrl },
                documentMeta: {
                  [docKey]: {
                    name: file.name,
                    docType: customDocType,
                    fileName: file.name,
                    contentType: file.type || "",
                    size: file.size || 0,
                    storagePath,
                    uploadedAt: new Date().toISOString(),
                    uploadedBy: currentAdmin,
                    expiryDate: null,
                  },
                },
                updatedAt: ts,
              },
              { merge: true }
            );

            window.__logSensitiveDocAccess({
              providerId: pId,
              providerName: window.__getProviderDisplayName(record),
              docName: file.name,
              docType: customDocType,
              action: "DOCUMENT_UPLOAD_SYNCED_TO_FIRESTORE",
            });

            setUploadState({ uploading: false, success: true, error: null, fileName: file.name });
            setTimeout(() => {
              if (window.__docUploadState && window.__docUploadState.success) {
                window.__docUploadState = null;
                window.__triggerPipelineReRender();
              }
            }, 4000);
          } catch (err) {
            console.error("Document upload failed:", err);
            setUploadState({
              uploading: false,
              success: false,
              error: String(err?.message || err || "Upload failed"),
              fileName: file?.name || "",
            });
          }
        };

        /* ── IMMUTABLE STAGE TRANSITION & FIRESTORE SYNC ── */
        window.__executePipelineStageTransition = async (providerId, nextStageId, reasonText = "") => {
          if (!providerId) return;
          const pIdStr = String(providerId).trim();
          const registry = window.__pipelineMasterRegistry;
          const existingMaster = registry.get(pIdStr) || {};
          let fallbackSource = {};
          if (typeof pipelineBoardRecords !== "undefined" && Array.isArray(pipelineBoardRecords)) {
            fallbackSource = pipelineBoardRecords.find((b) => window.__getProviderCanonId(b) === pIdStr) || fallbackSource;
          }
          if (typeof providerPipelineCards !== "undefined" && Array.isArray(providerPipelineCards)) {
            fallbackSource = providerPipelineCards.find((b) => window.__getProviderCanonId(b) === pIdStr) || fallbackSource;
          }
          const inspRec = typeof providerInspectionRecord !== "undefined" && window.__getProviderCanonId(providerInspectionRecord) === pIdStr ? providerInspectionRecord : {};
          const snapRec = typeof providerSnapshot !== "undefined" && window.__getProviderCanonId(providerSnapshot) === pIdStr ? providerSnapshot : {};
          const baseRecord = {
            ...fallbackSource,
            ...existingMaster,
            ...inspRec,
            ...snapRec,
          };
          const fromStage = baseRecord.approvalStage || baseRecord.status || "New";
          const isTargetApproved = window.__getStageCategory(nextStageId) === "approved";
          const currentAdminAuth =
            (typeof auth !== "undefined" && auth?.currentUser?.email) ||
            (typeof currentAdminUser !== "undefined" && currentAdminUser?.email) ||
            "Authorized Compliance Officer";
          const currentTimestamp = new Date().toISOString();
          const resolvedDocs = window.__extractBestDocuments(
            existingMaster,
            baseRecord,
            fallbackSource,
            inspRec,
            snapRec
          );
          const resolvedVerificationMeta = {
            ...(fallbackSource.verificationMeta || {}),
            ...(existingMaster.verificationMeta || {}),
            ...(inspRec.verificationMeta || {}),
            ...(snapRec.verificationMeta || {}),
          };
          const rawCandidateName = baseRecord.providerDisplayName || baseRecord.name || fallbackSource.providerDisplayName || fallbackSource.name || existingMaster.providerDisplayName || existingMaster.name || "";
          const resolvedUsername = baseRecord.username || fallbackSource.username || existingMaster.username || "";
          const resolvedFullName = baseRecord.fullName || fallbackSource.fullName || existingMaster.fullName || "";
          const isUnnamed = !rawCandidateName || /^unnamed(\s*provider)?$/i.test(rawCandidateName);
          const computedDisplayName = isUnnamed
            ? (resolvedUsername || resolvedFullName || "Provider")
            : rawCandidateName;

          const resolvedSelfieUrl =
            baseRecord.selfieUrl || fallbackSource.selfieUrl || existingMaster.selfieUrl || inspRec.selfieUrl || snapRec.selfieUrl || "";
          const resolvedSelfieCaptured = Boolean(
            baseRecord.selfieCaptured ??
            fallbackSource.selfieCaptured ??
            existingMaster.selfieCaptured ??
            inspRec.selfieCaptured ??
            snapRec.selfieCaptured ??
            Boolean(resolvedSelfieUrl)
          );

          const updatedRecord = {
            ...fallbackSource,
            ...baseRecord,
            ...existingMaster,
            id: baseRecord.id || fallbackSource.id || pIdStr,
            uid: pIdStr,
            userId: pIdStr,
            role: "provider",
            approvalStage: nextStageId,
            status: isTargetApproved ? "approved" : nextStageId,
            verificationStatus: isTargetApproved ? "approved" : (baseRecord.verificationStatus || nextStageId),
            approvedBy: isTargetApproved ? currentAdminAuth : (baseRecord.approvedBy || null),
            approvedAt: isTargetApproved ? currentTimestamp : (baseRecord.approvedAt || null),
            documents: resolvedDocs,
            verificationMeta: resolvedVerificationMeta,
            providerDisplayName: computedDisplayName,
            username: resolvedUsername,
            fullName: resolvedFullName,
            serviceCategory: baseRecord.serviceCategory || fallbackSource.serviceCategory || "General Services",
            serviceLocation: baseRecord.serviceLocation || fallbackSource.serviceLocation || "—",
            providerEmailAddress: baseRecord.providerEmailAddress || baseRecord.email || fallbackSource.providerEmailAddress || fallbackSource.email || existingMaster.email || "—",
            email: baseRecord.email || baseRecord.providerEmailAddress || fallbackSource.email || fallbackSource.providerEmailAddress || existingMaster.email || "—",
            providerContactNumber: baseRecord.providerContactNumber || baseRecord.phoneNumber || baseRecord.phone || fallbackSource.providerContactNumber || fallbackSource.phoneNumber || fallbackSource.phone || existingMaster.phoneNumber || "—",
            phoneNumber: baseRecord.phoneNumber || baseRecord.providerContactNumber || baseRecord.phone || fallbackSource.phoneNumber || fallbackSource.providerContactNumber || fallbackSource.phone || existingMaster.phoneNumber || "—",
            profileImage: baseRecord.profileImage || fallbackSource.profileImage || existingMaster.profileImage || "",
            selfieUrl: resolvedSelfieUrl,
            selfieCaptured: resolvedSelfieCaptured,
            createdAt: baseRecord.createdAt || fallbackSource.createdAt || existingMaster.createdAt,
            createdDate: baseRecord.createdDate || fallbackSource.createdDate || existingMaster.createdDate,
            registeredAt: baseRecord.registeredAt || fallbackSource.registeredAt || existingMaster.registeredAt,
            visaType: baseRecord.visaType || fallbackSource.visaType || existingMaster.visaType || "Standard",
            visaValidUntil: baseRecord.visaValidUntil || fallbackSource.visaValidUntil || existingMaster.visaValidUntil || null,
            passportValidUntil: baseRecord.passportValidUntil || fallbackSource.passportValidUntil || existingMaster.passportValidUntil || null,
            isBritishOrIrish: Boolean(baseRecord.isBritishOrIrish ?? fallbackSource.isBritishOrIrish ?? existingMaster.isBritishOrIrish),
            isStudent: Boolean(baseRecord.isStudent ?? fallbackSource.isStudent ?? existingMaster.isStudent),
            eligibilityStatus: isTargetApproved
              ? "approved"
              : (baseRecord.eligibilityStatus || window.__computeEligibilityStatus({ ...baseRecord, approvalStage: nextStageId, documents: resolvedDocs })),
          };

          registry.set(pIdStr, updatedRecord);
          if (window.__kanbanProviderIdSet.has(pIdStr) || window.__hasDocumentGoingToExpire(updatedRecord)) {
            window.__kanbanProviderIdSet.add(pIdStr);
          }

          /* Keep the optimistic stage visible until the real-time listener confirms it */
          window.__pendingStageOverrides.set(pIdStr, { stage: nextStageId, ts: Date.now() });

          window.__logPipelineAudit({
            action: isTargetApproved ? "stage_approval" : "stage_transition",
            providerId: pIdStr,
            providerName: window.__getProviderDisplayName(updatedRecord),
            fromStage,
            toStage: nextStageId,
            reason: reasonText || (isTargetApproved ? "Provider Approved & Synced Across All Collections" : "Stage Transition Authorized"),
            approvedBy: isTargetApproved ? currentAdminAuth : null,
            approvedAt: isTargetApproved ? currentTimestamp : null,
          });

          const completeArray = Array.from(registry.values());
          const patchList = (prevList) => {
            const list = Array.isArray(prevList) && prevList.length > 0 ? [...prevList] : completeArray;
            let found = false;
            const res = list.map((item) => {
              if (window.__getProviderCanonId(item) === pIdStr) {
                found = true;
                return { ...item, ...updatedRecord };
              }
              return item;
            });
            if (!found) res.push(updatedRecord);
            return res;
          };

          if (typeof setPipelineBoardRecords === "function") {
            try { setPipelineBoardRecords(patchList); } catch (e) { setPipelineBoardRecords(completeArray); }
          }
          if (typeof setProviderPipelineCards === "function") {
            try { setProviderPipelineCards(patchList); } catch (e) { setProviderPipelineCards(completeArray); }
          }
          if (typeof setProviderInspectionRecord === "function") {
            setProviderInspectionRecord((prev) => {
              if (!prev || window.__getProviderCanonId(prev) !== pIdStr) return prev;
              return { ...prev, ...updatedRecord };
            });
          }
          if (typeof setProviderSnapshot === "function") {
            setProviderSnapshot((prev) => {
              if (!prev || window.__getProviderCanonId(prev) !== pIdStr) return prev;
              return { ...prev, ...updatedRecord };
            });
          }

          // ── MULTI-COLLECTION AUTOMATED FIRESTORE SYNC ──
          try {
            if (typeof db !== "undefined") {
              const ts = typeof serverTimestamp === "function" ? serverTimestamp() : new Date();
              const currentEligibility = isTargetApproved
                ? "approved"
                : (updatedRecord.eligibilityStatus || window.__computeEligibilityStatus(updatedRecord));
              const baseUpdatePayload = {
                approvalStage: nextStageId,
                status: isTargetApproved ? "approved" : nextStageId,
                verificationStatus: isTargetApproved ? "approved" : nextStageId,
                eligibilityStatus: currentEligibility,
                updatedAt: ts,
              };
              const providerPayload = {
                ...baseUpdatePayload,
                isVerified: isTargetApproved ? true : Boolean(updatedRecord.isVerified),
              };
              if (isTargetApproved) {
                providerPayload.approvedAt = ts;
                providerPayload.approvedBy = currentAdminAuth;
                providerPayload.approvedByEmail = currentAdminAuth;
                providerPayload.approvalTimestamp = Date.now();
                providerPayload.verified = true;
              }
              const userPayload = {
                ...baseUpdatePayload,
                isVerified: isTargetApproved ? true : Boolean(updatedRecord.isVerified),
              };
              if (isTargetApproved) {
                userPayload.approvedAt = ts;
                userPayload.approvedBy = currentAdminAuth;
                userPayload.approvedByEmail = currentAdminAuth;
                userPayload.approvalTimestamp = Date.now();
                userPayload.verified = true;
              }

              const vdocPayload = {
                status: "approved",
                verificationStatus: isTargetApproved ? "approved" : nextStageId,
                eligibilityStatus: currentEligibility,
                updatedAt: ts,
              };
              if (isTargetApproved) {
                vdocPayload.verified = true;
              }
              delete vdocPayload.approvalStage;
              delete vdocPayload.approvalTimestamp;
              delete vdocPayload.approvedAt;
              delete vdocPayload.approvedBy;
              delete vdocPayload.approvedByEmail;
              delete vdocPayload.approval;
              delete vdocPayload.approvalHistory;

              const safeUpdateExistingDocs = async (collectionName, candidateIds, payload) => {
                const updatedDocIds = new Set();
                const existingKnownSet = window.__firestoreExistingDocIds?.[collectionName]?.get(pIdStr) || new Set();
                const allCandidateIds = Array.from(new Set([...candidateIds, ...existingKnownSet].filter(Boolean)));
                const finalPayload = { ...payload };
                if (collectionName === "VerificationDocuments") {
                  finalPayload.status = "approved";
                  delete finalPayload.approvalStage;
                  delete finalPayload.approvalTimestamp;
                  delete finalPayload.approvedAt;
                  delete finalPayload.approvedBy;
                  delete finalPayload.approvedByEmail;
                  delete finalPayload.approval;
                  delete finalPayload.approvalHistory;
                }
                for (const targetId of allCandidateIds) {
                  try {
                    if (typeof doc === "function") {
                      const docRef = doc(db, collectionName, String(targetId));
                      if (typeof getDoc === "function") {
                        const snap = await getDoc(docRef);
                        if (snap.exists()) {
                          if (typeof updateDoc === "function") {
                            await updateDoc(docRef, finalPayload);
                            updatedDocIds.add(String(targetId));
                          }
                        }
                      } else if (typeof updateDoc === "function") {
                        await updateDoc(docRef, finalPayload);
                        updatedDocIds.add(String(targetId));
                      }
                    }
                  } catch (e) {}
                }
                if (updatedDocIds.size === 0 && typeof collection === "function" && typeof query === "function" && typeof where === "function" && typeof getDocs === "function") {
                  try {
                    const searchFields = ["userId", "uid", "providerId"];
                    for (const field of searchFields) {
                      if (updatedDocIds.size > 0) break;
                      const q = query(collection(db, collectionName), where(field, "==", pIdStr));
                      const querySnap = await getDocs(q);
                      if (querySnap && !querySnap.empty) {
                        for (const docSnap of querySnap.docs) {
                          if (docSnap.exists() && !updatedDocIds.has(docSnap.id)) {
                            if (typeof updateDoc === "function") {
                              await updateDoc(docSnap.ref, finalPayload);
                              updatedDocIds.add(docSnap.id);
                            }
                          }
                        }
                      }
                    }
                  } catch (queryErr) {}
                }
              };

              const candidateIds = [
                pIdStr,
                updatedRecord.id,
                updatedRecord.uid,
                updatedRecord.userId,
                updatedRecord.providerId,
              ].filter(Boolean);

              await safeUpdateExistingDocs("providers", candidateIds, providerPayload);
              await safeUpdateExistingDocs("users", candidateIds, userPayload);
              await safeUpdateExistingDocs("VerificationDocuments", candidateIds, vdocPayload);
            }
          } catch (e) {
            console.warn("Firestore multi-collection update error:", e);
          }
          window.__triggerPipelineReRender();
        };

        /* ══════════════════════════════════════════════════════════════
           REAL-TIME ENGINE: onSnapshot LISTENERS ON ALL THREE COLLECTIONS
           users · providers · VerificationDocuments
           - Every snapshot REPLACES the raw data for that collection (so deleted / old data
             disappears and nothing stale is kept).
           - No localStorage record cache is read or written.
           - Cache-served snapshots are ignored (see __IGNORE_CACHED_SNAPSHOTS).
        ══════════════════════════════════════════════════════════════ */
        window.__rebuildPipelineFromRealtime = () => {
          const raw = window.__rtRaw;
          if (!raw || !raw.ready || !raw.ready.users || !raw.ready.providers || !raw.ready.vdocs) return;
          try {
            const registry = window.__pipelineMasterRegistry;
            const idIdx = window.__firestoreExistingDocIds;
            idIdx.providers = new Map();
            idIdx.users = new Map();
            idIdx.VerificationDocuments = new Map();

            const toMillis = (v) => {
              const d = window.__toDocDate(v);
              return d ? d.getTime() : 0;
            };

            /* 1) Group VerificationDocuments docs per provider UID (handles duplicate docs) */
            const vGroups = new Map();
            raw.vdocs.forEach((data, id) => {
              const d = data || {};
              const canon = String(d.userId || d.uid || d.providerId || id).trim();
              if (!vGroups.has(canon)) vGroups.set(canon, []);
              vGroups.get(canon).push({ id, data: d });
              if (!idIdx.VerificationDocuments.has(canon)) idIdx.VerificationDocuments.set(canon, new Set());
              idIdx.VerificationDocuments.get(canon).add(id);
            });
            const mergeVGroup = (arr) => {
              if (!arr || arr.length === 0) return null;
              const sorted = [...arr].sort(
                (a, b) => toMillis(a.data.updatedAt || a.data.submittedAt) - toMillis(b.data.updatedAt || b.data.submittedAt)
              );
              const merged = {};
              const docsMap = {};
              const metaMap = {};
              sorted.forEach(({ data }) => {
                Object.assign(merged, data);
                if (data.documents && typeof data.documents === "object") Object.assign(docsMap, data.documents);
                if (data.documentMeta && typeof data.documentMeta === "object") Object.assign(metaMap, data.documentMeta);
              });
              merged.documents = docsMap;
              merged.documentMeta = metaMap;
              return merged;
            };

            /* 2) users & providers */
            const usersMap = {};
            raw.users.forEach((data, id) => {
              usersMap[id] = { id, uid: id, ...(data || {}) };
              idIdx.users.set(id, new Set([id]));
            });
            raw.providers.forEach((_, id) => {
              idIdx.providers.set(id, new Set([id]));
            });

            const candidates = new Map();
            const upsert = (kind, rec) => {
              if (!rec) return;
              const roleStr = String(rec.role || "").toLowerCase().trim();
              if (roleStr !== "provider") return;
              const canon = window.__getProviderCanonId(rec);
              if (!canon) return;
              const cur = candidates.get(canon) || {};
              cur[kind] = rec;
              candidates.set(canon, cur);
            };
            raw.providers.forEach((data, id) => upsert("prov", { id, ...(data || {}) }));
            Object.keys(usersMap).forEach((id) => upsert("user", usersMap[id]));

            /* 3) Build fresh provider records */
            const newMap = new Map();
            const toBlock = [];
            const toUnblock = [];
            const seenNotBlocked = new Set();

            candidates.forEach(({ prov, user }, canonKey) => {
              const item = { ...(user || {}), ...(prov || {}) };
              if (window.__isRecordInvalidOrCustomer(item)) return;

              const grp = vGroups.get(canonKey) || vGroups.get(String(item.id)) || vGroups.get(String(item.uid));
              const vData = mergeVGroup(grp);
              const uData = usersMap[canonKey] || usersMap[item.id] || usersMap[item.uid] || {};

              /* Documents: provider-doc array + VerificationDocuments map (+ metadata) */
              const structuredDocs = window.__extractBestDocuments(item);
              if (vData && vData.documents) {
                Object.keys(vData.documents).forEach((docKey) => {
                  const rawVal = vData.documents[docKey];
                  const url =
                    typeof rawVal === "string"
                      ? rawVal
                      : (rawVal && (rawVal.url || rawVal.fileUrl || rawVal.downloadURL)) || "";
                  if (!url || typeof url !== "string" || url.trim().length === 0) return;
                  const meta = (vData.documentMeta && vData.documentMeta[docKey]) || null;
                  const docKeyStr = String(docKey || "DOCUMENT");
                  const formattedName = docKeyStr.replace(/_/g, " ").toUpperCase();
                  const vId = `vdoc_${docKey}_${canonKey}`;
                  const exists = structuredDocs.some(
                    (d) => d.id === vId || window.__getDocumentFileUrl(d) === url.trim()
                  );
                  if (exists) return;
                  structuredDocs.push({
                    id: vId,
                    name: (meta && meta.name) || formattedName,
                    docType: (meta && meta.docType) || docKey,
                    fileUrl: url,
                    downloadURL: url,
                    verificationStatus: vData.status || "verified",
                    uploadedAt: meta && meta.uploadedAt
                      ? window.__formatCleanDate(meta.uploadedAt)
                      : (vData.submittedAt ? window.__formatCleanDate(vData.submittedAt) : "Verified On File"),
                    expiryDate: meta
                      ? (meta.expiryDate || null)
                      : (vData.visaValidUntil || vData.passportValidUntil || null),
                    isLocalUpload: false,
                    uploadedBy: (meta && meta.uploadedBy) || undefined,
                  });
                });
              }

              /* Stage (apply optimistic override only until Firestore confirms it) */
              let currentStage = item.approvalStage || item.status || "new_provider";
              const ov = window.__pendingStageOverrides.get(canonKey);
              if (ov) {
                const confirmed = window.__getStageCategory(currentStage) === window.__getStageCategory(ov.stage);
                if (confirmed || Date.now() - ov.ts > 20000) {
                  window.__pendingStageOverrides.delete(canonKey);
                } else {
                  currentStage = ov.stage;
                }
              }

              const resolvedUsername = uData.username || item.username || "";
              const resolvedFullName = uData.fullName || item.fullName || uData.name || item.name || "";
              const resolvedEmail = uData.email || item.providerEmailAddress || item.email || "";
              const resolvedPhoneNumber = uData.phoneNumber || uData.phone || item.providerContactNumber || item.phoneNumber || item.phone || "";
              const resolvedProfileImage = uData.profileImage || uData.photoURL || uData.profileImageUrl || item.profileImage || "";
              const resolvedSelfieUrl = (vData && vData.selfieUrl) || item.selfieUrl || "";
              const resolvedSelfieCaptured = Boolean(
                (vData && typeof vData.selfieCaptured === "boolean" ? vData.selfieCaptured : undefined) ??
                item.selfieCaptured ??
                Boolean(resolvedSelfieUrl)
              );
              const rawName = String(item.providerDisplayName || item.name || item.displayName || "").trim();
              const isUnnamed = !rawName || /^unnamed(\s*provider)?$/i.test(rawName);
              const computedDisplayName = isUnnamed
                ? (resolvedUsername || resolvedFullName || "Provider")
                : rawName;

              const mergedItem = {
                ...item,
                id: item.id || canonKey,
                uid: canonKey,
                userId: canonKey,
                role: "provider",
                providerDisplayName: computedDisplayName,
                username: resolvedUsername,
                fullName: resolvedFullName,
                email: resolvedEmail,
                providerEmailAddress: resolvedEmail,
                phoneNumber: resolvedPhoneNumber,
                providerContactNumber: resolvedPhoneNumber,
                profileImage: resolvedProfileImage,
                selfieUrl: resolvedSelfieUrl,
                selfieCaptured: resolvedSelfieCaptured,
                serviceCategory: item.serviceCategory || "General Services",
                serviceLocation: item.serviceLocation || "—",
                documents: structuredDocs,
                verificationMeta: vData || item.verificationMeta || {},
                visaType: (vData && vData.visaType) || item.visaType || "Standard",
                visaValidFrom: (vData && vData.visaValidFrom) || item.visaValidFrom || null,
                visaValidUntil: (vData && vData.visaValidUntil) || item.visaValidUntil || null,
                passportValidFrom: (vData && vData.passportValidFrom) || item.passportValidFrom || null,
                passportValidUntil: (vData && vData.passportValidUntil) || item.passportValidUntil || null,
                isStudent: Boolean((vData && vData.isStudent) ?? item.isStudent),
                isBritishOrIrish: Boolean((vData && vData.isBritishOrIrish) ?? item.isBritishOrIrish),
                approvalStage: currentStage,
                status: currentStage,
                approvedBy: item.approvedBy || null,
                approvedAt: item.approvedAt || null,
              };

              /* Automated Expiry Checking & Enforcement */
              const stageCatNow = window.__getStageCategory(currentStage);
              if (window.__isProviderBlocked(mergedItem)) {
                mergedItem.approvalStage = "blocked";
                mergedItem.status = "blocked";
                mergedItem.eligibilityStatus = "Ineligible (Expired Docs)";
                window.__kanbanProviderIdSet.add(canonKey);
                if (stageCatNow !== "blocked" && !window.__autoBlockPersisted.has(canonKey)) {
                  window.__autoBlockPersisted.add(canonKey);
                  toBlock.push(canonKey);
                }
              } else {
                if (stageCatNow === "blocked") {
                  /* Expired documents were removed / renewed → release the provider from Blocked */
                  mergedItem.approvalStage = "verification_pending";
                  mergedItem.status = "verification_pending";
                  if (!window.__autoUnblockPersisted.has(canonKey)) {
                    window.__autoUnblockPersisted.add(canonKey);
                    toUnblock.push(canonKey);
                  }
                } else {
                  seenNotBlocked.add(canonKey);
                }
                const isStageApproved = window.__getStageCategory(mergedItem.approvalStage) === "approved";
                let storedEligibility = item.eligibilityStatus;
                if (storedEligibility && /^ineligible/i.test(String(storedEligibility))) storedEligibility = null;
                mergedItem.eligibilityStatus = isStageApproved
                  ? "approved"
                  : (storedEligibility || window.__computeEligibilityStatus(mergedItem));
              }

              if (window.__hasDocumentGoingToExpire(mergedItem)) {
                window.__kanbanProviderIdSet.add(canonKey);
              }

              newMap.set(canonKey, mergedItem);
            });

            /* Reset loop-guards for providers that are healthy again */
            seenNotBlocked.forEach((id) => {
              window.__autoBlockPersisted.delete(id);
              window.__autoUnblockPersisted.delete(id);
            });

            /* 4) Replace registry contents with ONLY fresh Firestore-derived data */
            registry.clear();
            newMap.forEach((v, k) => registry.set(k, v));
            Array.from(window.__kanbanProviderIdSet).forEach((id) => {
              if (!registry.has(id)) window.__kanbanProviderIdSet.delete(id);
            });

            const completeArray = Array.from(newMap.values());
            if (typeof setPipelineBoardRecords === "function") setPipelineBoardRecords(completeArray);
            if (typeof setProviderPipelineCards === "function") setProviderPipelineCards(completeArray);
            if (typeof setProviderInspectionRecord === "function") {
              setProviderInspectionRecord((prev) => {
                if (!prev) return prev;
                const fresh = registry.get(window.__getProviderCanonId(prev));
                return fresh ? { ...fresh } : prev;
              });
            }
            if (typeof setProviderSnapshot === "function") {
              setProviderSnapshot((prev) => {
                if (!prev) return prev;
                const fresh = registry.get(window.__getProviderCanonId(prev));
                return fresh ? { ...fresh } : prev;
              });
            }
            if (window.__activeSectionModal && window.__activeSectionModal.open && window.__activeSectionModal.record) {
              const fresh = registry.get(window.__getProviderCanonId(window.__activeSectionModal.record));
              if (fresh) {
                window.__activeSectionModal = { ...window.__activeSectionModal, record: fresh };
              }
            }

            /* 5) Persist automatic block / unblock decisions (once per provider) */
            toBlock.forEach((id, i) => {
              setTimeout(() => {
                if (typeof window.__executePipelineStageTransition === "function") {
                  window.__executePipelineStageTransition(id, "blocked", "Automatic Stage Enforcement: Document Expired");
                }
              }, 80 + i * 150);
            });
            toUnblock.forEach((id, i) => {
              setTimeout(() => {
                if (typeof window.__executePipelineStageTransition === "function") {
                  window.__executePipelineStageTransition(id, "verification_pending", "Automatic Release: Expired Documents Resolved");
                }
              }, 80 + i * 150);
            });
          } catch (err) {
            console.error("Critical error in window.__rebuildPipelineFromRealtime:", err);
          } finally {
            window.__isPipelineSyncing = false;
            window.__triggerPipelineReRender();
          }
        };

        window.__schedulePipelineRebuild = () => {
          clearTimeout(window.__rtRebuildTimer);
          window.__rtRebuildTimer = setTimeout(() => window.__rebuildPipelineFromRealtime(), 60);
        };

        window.__stopPipelineRealtimeListeners = () => {
          try {
            (window.__pipelineUnsubs || []).forEach((u) => {
              try { if (typeof u === "function") u(); } catch (e) {}
            });
          } catch (e) {}
          window.__pipelineUnsubs = [];
          window.__pipelineListenersActive = false;
          clearTimeout(window.__rtRebuildTimer);
          clearTimeout(window.__rtSyncSafetyTimer);
        };

        window.__startPipelineRealtimeListeners = () => {
          if (window.__pipelineListenersActive) return;
          if (typeof db === "undefined" || typeof collection !== "function" || typeof onSnapshot !== "function") {
            console.warn("Pipeline real-time listeners need db, collection and onSnapshot to be imported in this scope.");
            window.__isPipelineSyncing = false;
            window.__triggerPipelineReRender();
            return;
          }
          window.__pipelineListenersActive = true;
          window.__isPipelineSyncing = true;
          window.__rtRaw = {
            users: new Map(),
            providers: new Map(),
            vdocs: new Map(),
            ready: { users: false, providers: false, vdocs: false },
          };
          window.__pipelineUnsubs = [];
          window.__triggerPipelineReRender();

          const bind = (collName, rawKey) => {
            try {
              const unsub = onSnapshot(
                collection(db, collName),
                { includeMetadataChanges: true },
                (snap) => {
                  if (window.__IGNORE_CACHED_SNAPSHOTS && snap.metadata && snap.metadata.fromCache) return;
                  const m = new Map();
                  snap.forEach((d) => m.set(d.id, d.data()));
                  if (!window.__rtRaw) return;
                  window.__rtRaw[rawKey] = m;
                  window.__rtRaw.ready[rawKey] = true;
                  window.__schedulePipelineRebuild();
                },
                (err) => {
                  console.warn(`Real-time listener error on "${collName}":`, err);
                  if (!window.__rtRaw) return;
                  window.__rtRaw.ready[rawKey] = true;
                  window.__schedulePipelineRebuild();
                }
              );
              window.__pipelineUnsubs.push(unsub);
            } catch (e) {
              console.warn(`Could not attach listener to "${collName}":`, e);
              window.__rtRaw.ready[rawKey] = true;
              window.__schedulePipelineRebuild();
            }
          };

          bind("VerificationDocuments", "vdocs");
          bind("users", "users");
          bind("providers", "providers");

          clearTimeout(window.__rtSyncSafetyTimer);
          window.__rtSyncSafetyTimer = setTimeout(() => {
            if (window.__isPipelineSyncing) {
              window.__isPipelineSyncing = false;
              window.__triggerPipelineReRender();
            }
          }, 15000);
        };

        /* ── SYNC BUTTON: re-attaches the real-time listeners for a fresh server pull + spinner ── */
        window.__refreshProviders = async () => {
          window.__isPipelineSyncing = true;
          window.__triggerPipelineReRender();
          window.__stopPipelineRealtimeListeners();
          window.__startPipelineRealtimeListeners();
        };

        /* ── FIRST LOAD: purge legacy caches, clear old in-memory data, start listeners ── */
        if (!window.__pipelineAutoLoaded) {
          window.__pipelineAutoLoaded = true;
          try {
            localStorage.removeItem(window.__LS_BOARD_KEY);
            localStorage.removeItem(window.__LS_KANBAN_KEY);
          } catch (e) {}
          window.__pipelineMasterRegistry.clear();
          window.__kanbanProviderIdSet.clear();
          window.__pendingStageOverrides.clear();
          window.__autoBlockPersisted.clear();
          window.__autoUnblockPersisted.clear();
          setTimeout(() => {
            if (typeof setPipelineBoardRecords === "function") setPipelineBoardRecords([]);
            if (typeof setProviderPipelineCards === "function") setProviderPipelineCards([]);
            window.__startPipelineRealtimeListeners();
          }, 0);
        }
      }
      return null;
    })()}

    {/* ── UNIFIED PIPELINE STAGE SCHEMA ── */}
    {(() => {
      window.__ALL_PIPELINE_STAGES = [
        { id: "new_provider", label: "New Provider", color: "#4f46e5", bg: "#e0e7ff" },
        { id: "verification_pending", label: "Verification Pending", color: "#2563eb", bg: "#dbeafe" },
        { id: "verification_started", label: "Verification Started", color: "#d97706", bg: "#fef3c7" },
        { id: "internal_review", label: "Under Review", color: "#7c3aed", bg: "#ede9fe" },
        { id: "verification_completed", label: "Verification Completed", color: "#059669", bg: "#d1fae5" },
        { id: "approved", label: "Approved", color: "#16a34a", bg: "#dcfce7" },
        { id: "rejected", label: "Rejected", color: "#dc2626", bg: "#fee2e2" },
        { id: "blocked", label: "Blocked — Documents Expired", color: "#b91c1c", bg: "#fee2e2" },
      ];
      return null;
    })()}

    {/* ── TOP PIPELINE TOOLBAR WITH ACTIVE SYNC SPINNER ──────────────── */}
    <header
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "14px 20px",
        background: "#0f172a",
        borderBottom: "1px solid #334155",
        flexWrap: "wrap",
        gap: 12,
        color: "#ffffff",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{ fontSize: 24, background: "#1e293b", padding: "6px 10px", borderRadius: 10, border: "1px solid #334155" }}>
          🛡️
        </div>
        <div>
          <h2 style={{ margin: 0, fontSize: "18px", fontWeight: 800, color: "#ffffff", letterSpacing: "-0.02em" }}>
            Provider Verification Pipeline
          </h2>
          <span style={{ fontSize: "12px", color: "#94a3b8" }}>
            Active Filter: Role === "provider" only · Live Firestore Listeners · Auto-Expiry Blocking Active · Expiring Documents Isolation · Anti-Capture Shielded
          </span>
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        {/* UID & Name Search Input */}
        <div style={{ display: "flex", alignItems: "center", background: "#1e293b", border: "1px solid #475569", borderRadius: 8, padding: "3px 10px", gap: 6 }}>
          <span style={{ fontSize: 13, color: "#94a3b8" }}>🔍</span>
          <input
            type="text"
            className="pipeline-filter-input"
            placeholder="Search UID / Name / Username..."
            value={window.__pipelineUidSearchQuery || ""}
            onChange={(e) => {
              window.__pipelineUidSearchQuery = e.target.value;
              window.__triggerPipelineReRender();
            }}
            style={{
              background: "transparent",
              border: "none",
              color: "#ffffff",
              fontSize: 12,
              outline: "none",
              width: 180,
            }}
          />
          {window.__pipelineUidSearchQuery && (
            <button
              onClick={() => {
                window.__pipelineUidSearchQuery = "";
                window.__triggerPipelineReRender();
              }}
              style={{ background: "none", border: "none", color: "#94a3b8", cursor: "pointer", fontSize: 11, padding: 0 }}
            >
              ✕
            </button>
          )}
        </div>
        {/* Signup Sorting Filter */}
        <div style={{ display: "flex", alignItems: "center", gap: 6, background: "#1e293b", padding: "4px 8px", borderRadius: 8, border: "1px solid #475569" }}>
          <span style={{ fontSize: 11, fontWeight: 700, color: "#cbd5e1" }}>📅 Sign Up:</span>
          <select
            value={window.__pipelineSortOrder || "default"}
            onChange={(e) => {
              window.__pipelineSortOrder = e.target.value;
              window.__triggerPipelineReRender();
            }}
            style={{
              background: "#0f172a",
              color: "#f8fafc",
              border: "1px solid #334155",
              borderRadius: 6,
              padding: "4px 8px",
              fontSize: 11,
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            <option value="default">Default Order</option>
            <option value="newest">Newest Sign Up First</option>
            <option value="oldest">Oldest Sign Up First</option>
          </select>
        </div>
        {/* View Mode Switcher with Passcode Protection */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            background: "#1e293b",
            padding: "3px",
            borderRadius: "10px",
            border: "1px solid #334155",
          }}
        >
          <button
            onClick={() => {
              if (providerViewMode === "board") return;
              window.__promptBoardAccessPassword("board", () => setProviderViewMode("board"));
            }}
            style={{
              padding: "6px 14px",
              borderRadius: "8px",
              border: "none",
              background: providerViewMode === "board" ? "#2563eb" : "transparent",
              color: "#ffffff",
              fontWeight: 700,
              fontSize: "12px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            <span>🆕</span>
            New Providers
          </button>
          <button
            onClick={() => {
              if (providerViewMode === "kanban") return;
              window.__promptBoardAccessPassword("kanban", () => setProviderViewMode("kanban"));
            }}
            style={{
              padding: "6px 14px",
              borderRadius: "8px",
              border: "none",
              background: providerViewMode === "kanban" ? "#7c3aed" : "transparent",
              color: "#ffffff",
              fontWeight: 700,
              fontSize: "12px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            <span>📋</span>
            Existing Providers
          </button>
        </div>
        {/* Sync Pipeline Button with Spin Animation */}
        <button
          onClick={async () => {
            if (typeof window.__refreshProviders === "function" && !window.__isPipelineSyncing) {
              await window.__refreshProviders();
            }
          }}
          disabled={window.__isPipelineSyncing}
          style={{
            padding: "6px 14px",
            borderRadius: 8,
            border: "1px solid #475569",
            background: window.__isPipelineSyncing ? "#334155" : "#1e293b",
            color: "#f8fafc",
            fontWeight: 700,
            fontSize: 12,
            cursor: window.__isPipelineSyncing ? "not-allowed" : "pointer",
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          <span className={window.__isPipelineSyncing ? "pipeline-spin-icon" : ""}>⟳</span>
          <span>{window.__isPipelineSyncing ? "Syncing..." : "Sync Pipeline"}</span>
        </button>
      </div>
    </header>

{/* ═══════════ PART 2 — PASTE DIRECTLY AFTER THE </header> OF PART 1 ═══════════ */}

    {/* ── MAIN WORKSPACE ───────────────────────────────────────────── */}
    <div style={{ display: "flex", flex: 1, overflow: "hidden", position: "relative", background: "#f8fafc" }}>
      <main style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", position: "relative" }}>
        {/* ============================================================
            VIEW 1: NEW PROVIDER VERIFICATION BOARD
        ============================================================ */}
        {providerViewMode === "board" && (
          <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%", overflow: "hidden" }}>
            {/* Zoom Sub-Toolbar */}
            <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 20px", background: "#ffffff", borderBottom: "1px solid #e2e8f0" }}>
              <span style={{ fontSize: 12, fontWeight: 700, color: "#475569" }}>Scale:</span>
              {[25, 50, 75, 100].map((lvl) => (
                <button
                  key={lvl}
                  onClick={() => {
                    if (typeof cycleBoardZoom === "function") cycleBoardZoom(lvl);
                    else if (typeof setBoardZoomLevel === "function") setBoardZoomLevel(lvl);
                  }}
                  style={{
                    padding: "3px 10px",
                    borderRadius: 6,
                    border: boardZoomLevel === lvl ? "1px solid #2563eb" : "1px solid #cbd5e1",
                    background: boardZoomLevel === lvl ? "#2563eb" : "#f1f5f9",
                    color: boardZoomLevel === lvl ? "#ffffff" : "#334155",
                    fontSize: 11,
                    fontWeight: 700,
                    cursor: "pointer",
                  }}
                >
                  {lvl}%
                </button>
              ))}
              {boardZoomLevel <= 50 && (
                <span style={{ fontSize: 11, color: "#64748b", marginLeft: 8, fontStyle: "italic" }}>
                  (Compact mode enabled at 25% scale; UIDs visible in profile inspection drawer)
                </span>
              )}
            </div>
            {/* Board Column Canvas */}
            <div style={{ display: "flex", flex: 1, overflow: "hidden", minHeight: 0 }}>
              <div style={{ flex: providerDrawerVisible ? "0 0 calc(100% - 500px)" : 1, overflow: "hidden", position: "relative" }}>
                {(() => {
                  const is25Scale = boardZoomLevel === 25;
                  const colWidth = is25Scale ? 188 : boardZoomLevel === 50 ? 230 : boardZoomLevel === 75 ? 280 : 330;
                  const boardRecordsMap = new Map();
                  if (window.__pipelineMasterRegistry) {
                    window.__pipelineMasterRegistry.forEach((masterRec, cid) => {
                      if (masterRec && !window.__isRecordInvalidOrCustomer(masterRec)) {
                        boardRecordsMap.set(cid, { ...masterRec });
                      }
                    });
                  }
                  (pipelineBoardRecords || []).forEach((item) => {
                    if (item && !window.__isRecordInvalidOrCustomer(item)) {
                      const canonId = window.__getProviderCanonId(item);
                      if (!canonId) return;
                      const master = boardRecordsMap.get(canonId) || {};
                      const structuredDocs = window.__extractBestDocuments(master, item);
                      const merged = {
                        ...item,
                        ...master,
                        documents: structuredDocs,
                        verificationMeta: { ...(item.verificationMeta || {}), ...(master.verificationMeta || {}) },
                      };
                      if (window.__isProviderBlocked(merged)) {
                        merged.approvalStage = "blocked";
                        merged.status = "blocked";
                        merged.eligibilityStatus = "Ineligible (Expired Docs)";
                      } else {
                        const curCat = window.__getStageCategory(merged.approvalStage || merged.status);
                        merged.eligibilityStatus = curCat === "approved" ? "approved" : (master.eligibilityStatus || item.eligibilityStatus || window.__computeEligibilityStatus(merged));
                      }
                      boardRecordsMap.set(canonId, merged);
                      window.__pipelineMasterRegistry.set(canonId, merged);
                    }
                  });
                  (providerPipelineCards || []).forEach((item) => {
                    if (item && !window.__isRecordInvalidOrCustomer(item)) {
                      const canonId = window.__getProviderCanonId(item);
                      if (!canonId) return;
                      const master = boardRecordsMap.get(canonId) || {};
                      const structuredDocs = window.__extractBestDocuments(master, item);
                      const merged = {
                        ...item,
                        ...master,
                        documents: structuredDocs,
                        verificationMeta: { ...(item.verificationMeta || {}), ...(master.verificationMeta || {}) },
                      };
                      if (window.__isProviderBlocked(merged)) {
                        merged.approvalStage = "blocked";
                        merged.status = "blocked";
                        merged.eligibilityStatus = "Ineligible (Expired Docs)";
                      } else {
                        const curCat = window.__getStageCategory(merged.approvalStage || merged.status);
                        merged.eligibilityStatus = curCat === "approved" ? "approved" : (master.eligibilityStatus || item.eligibilityStatus || window.__computeEligibilityStatus(merged));
                      }
                      boardRecordsMap.set(canonId, merged);
                      window.__pipelineMasterRegistry.set(canonId, merged);
                    }
                  });
                  let boardData = Array.from(boardRecordsMap.values());
                  if (window.__pipelineUidSearchQuery && window.__pipelineUidSearchQuery.trim()) {
                    const q = window.__pipelineUidSearchQuery.trim().toLowerCase();
                    boardData = boardData.filter((b) => {
                      const canon = window.__getProviderCanonId(b).toLowerCase();
                      const name = String(window.__getProviderDisplayName(b)).toLowerCase();
                      const uName = String(b.username || "").toLowerCase();
                      const fName = String(b.fullName || "").toLowerCase();
                      const email = String(b.providerEmailAddress || b.email || "").toLowerCase();
                      return canon.includes(q) || name.includes(q) || uName.includes(q) || fName.includes(q) || email.includes(q);
                    });
                  }
                  if (window.__pipelineSortOrder === "newest") {
                    boardData.sort((a, b) => window.__getSignupDateTimestamp(b) - window.__getSignupDateTimestamp(a));
                  } else if (window.__pipelineSortOrder === "oldest") {
                    boardData.sort((a, b) => window.__getSignupDateTimestamp(a) - window.__getSignupDateTimestamp(b));
                  }
                  const displayStages = window.__ALL_PIPELINE_STAGES || [];
                  return (
                    <div style={{ overflowX: "auto", overflowY: "hidden", padding: "16px", height: "100%", boxSizing: "border-box" }}>
                      <div style={{ display: "flex", gap: 14, minWidth: "fit-content", height: "100%" }}>
                        {displayStages.map((stage) => {
                          const stageCards = boardData.filter((rec) => {
                            const act = window.__getEffectiveProviderStage(rec);
                            return window.__isStageMatch(act, stage.id);
                          });
                          return (
                            <div
                              key={stage.id}
                              onDragOver={(e) => {
                                e.preventDefault();
                                e.dataTransfer.dropEffect = "move";
                              }}
                              onDragEnter={() => {
                                if (typeof setPipelineHoveredStage === "function") setPipelineHoveredStage(stage.id);
                              }}
                              onDragLeave={() => {
                                if (typeof setPipelineHoveredStage === "function") setPipelineHoveredStage(null);
                              }}
                              onDrop={(e) => {
                                e.preventDefault();
                                const draggedId = e.dataTransfer?.getData("text/plain") || window.__getProviderCanonId(pipelineDraggingCard);
                                if (typeof setPipelineDraggingCard === "function") setPipelineDraggingCard(null);
                                if (typeof setPipelineHoveredStage === "function") setPipelineHoveredStage(null);
                                if (!draggedId) return;
                                const rec = boardData.find((b) => window.__getProviderCanonId(b) === String(draggedId)) || window.__pipelineMasterRegistry.get(String(draggedId));
                                const curCat = window.__getStageCategory(rec?.approvalStage || rec?.status);
                                const targetCat = window.__getStageCategory(stage.id);
                                const isStartedToApproved = (curCat === "started" && targetCat === "approved");
                                const isPendingToApproved = (curCat === "pending" && targetCat === "approved");
                                const isApprovedToPending = (curCat === "approved" && targetCat === "pending");
                                const isApprovedToStarted = (curCat === "approved" && targetCat === "started");
                                if (isStartedToApproved || isPendingToApproved || isApprovedToPending || isApprovedToStarted) {
                                  window.__openCriticalTransitionModal({
                                    provider: rec,
                                    fromStage: curCat,
                                    toStage: targetCat,
                                    targetStageId: stage.id,
                                    onConfirm: (reason) => window.__executePipelineStageTransition(draggedId, stage.id, reason),
                                  });
                                  return;
                                }
                                const isApprovedRejected = (curCat === "approved" && targetCat === "rejected") || (curCat === "rejected" && targetCat === "approved");
                                const isStartedRejected = (curCat === "started" && targetCat === "rejected");
                                if (isApprovedRejected || isStartedRejected) {
                                  window.__openEncryptedStageGateModal({
                                    provider: rec,
                                    fromStage: curCat,
                                    toStage: targetCat,
                                    title: "🔐 Protected Stage Transition Gate",
                                    description: `Moving ${window.__getProviderDisplayName(rec)} from ${curCat} to ${targetCat}. Security authorization key and justification required.`,
                                    onConfirm: (reason) => window.__executePipelineStageTransition(draggedId, stage.id, reason),
                                  });
                                } else {
                                  window.__executePipelineStageTransition(draggedId, stage.id);
                                }
                              }}
                              style={{
                                width: colWidth,
                                flexShrink: 0,
                                background: pipelineHoveredStage === stage.id ? "#eff6ff" : stage.id === "blocked" ? "#fff5f5" : "#ffffff",
                                border: pipelineHoveredStage === stage.id ? "2px dashed #2563eb" : stage.id === "blocked" ? "1.5px solid #fecaca" : "1px solid #e2e8f0",
                                borderRadius: 12,
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.03)",
                              }}
                            >
                              {/* Stage Column Header */}
                              <div
                                style={{
                                  padding: is25Scale ? "8px 10px" : "12px 14px",
                                  borderBottom: "1px solid #e2e8f0",
                                  background: stage.id === "blocked" ? "#fee2e2" : "#f8fafc",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <strong style={{ fontSize: is25Scale ? 11 : 13, color: stage.id === "blocked" ? "#991b1b" : "#0f172a", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                  {stage.label}
                                </strong>
                                <span style={{ background: stage.bg, color: stage.color, padding: is25Scale ? "1px 6px" : "2px 8px", borderRadius: 12, fontSize: is25Scale ? 10 : 11, fontWeight: 700 }}>
                                  {stageCards.length}
                                </span>
                              </div>
                              {/* Stage Cards Container */}
                              <div style={{ padding: is25Scale ? 6 : 10, display: "flex", flexDirection: "column", gap: is25Scale ? 6 : 10, overflowY: "auto", flex: 1 }}>
                                {stageCards.length === 0 && (
                                  <div style={{ textAlign: "center", color: "#94a3b8", fontSize: is25Scale ? 11 : 12, padding: is25Scale ? 14 : 24 }}>
                                    No providers in stage
                                  </div>
                                )}
                                {stageCards.map((record) => {
                                  const providerId = window.__getProviderCanonId(record);
                                  const isUnnamed = window.__isUnnamedProvider(record);
                                  const displayName = window.__getProviderDisplayName(record);
                                  const docCount = (record.documents || []).length;
                                  const isBlocked = window.__isProviderBlocked(record);
                                  const isAppr = window.__getStageCategory(record.approvalStage || record.status) === "approved";
                                  const eligibility = isBlocked ? "Ineligible (Expired Docs)" : isAppr ? "approved" : (record.eligibilityStatus || window.__computeEligibilityStatus(record));
                                  const daysSigned = window.__getDaysSinceSignup(record);
                                  const stageMeta = window.__getStageMeta(isBlocked ? "blocked" : (record.approvalStage || record.status));
                                  const selfieUrl = window.__getProviderSelfieUrl(record);
                                  const selfieCaptured = window.__isProviderSelfieCaptured(record);
                                  return (
                                    <div
                                      key={`board_card_${providerId}`}
                                      draggable={!isBlocked}
                                      onDragStart={(e) => {
                                        if (typeof setPipelineDraggingCard === "function") setPipelineDraggingCard(record);
                                        e.dataTransfer.setData("text/plain", providerId);
                                        e.dataTransfer.effectAllowed = "move";
                                      }}
                                      onDragEnd={() => {
                                        if (typeof setPipelineDraggingCard === "function") setPipelineDraggingCard(null);
                                      }}
                                      onClick={() => {
                                        setProviderInspectionRecord(record);
                                        setProviderDrawerVisible(true);
                                      }}
                                      style={{
                                        background: "#ffffff",
                                        border: isBlocked ? "1.5px solid #ef4444" : "1px solid #cbd5e1",
                                        borderRadius: is25Scale ? 8 : 10,
                                        padding: is25Scale ? "7px 8px" : 12,
                                        cursor: isBlocked ? "not-allowed" : "grab",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: is25Scale ? 4 : 6,
                                      }}
                                    >
                                      {/* Selfie Verification Strip */}
                                      <div
                                        style={{
                                          position: "relative",
                                          width: "100%",
                                          height: is25Scale ? 42 : 64,
                                          borderRadius: is25Scale ? 6 : 8,
                                          overflow: "hidden",
                                          background: "#f1f5f9",
                                          border: "1px solid #e2e8f0",
                                          flexShrink: 0,
                                        }}
                                      >
                                        {selfieUrl ? (
                                          <img
                                            src={selfieUrl}
                                            alt="Selfie verification"
                                            draggable={false}
                                            onContextMenu={(e) => e.preventDefault()}
                                            style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                                          />
                                        ) : (
                                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", fontSize: is25Scale ? 9 : 11, color: "#94a3b8", fontWeight: 700 }}>
                                            🤳 No Selfie On File
                                          </div>
                                        )}
                                        <span
                                          style={{
                                            position: "absolute",
                                            top: 3,
                                            right: 3,
                                            fontSize: is25Scale ? 8 : 9.5,
                                            fontWeight: 800,
                                            padding: "1px 5px",
                                            borderRadius: 4,
                                            background: selfieCaptured ? "#dcfce7" : "#fee2e2",
                                            color: selfieCaptured ? "#166534" : "#991b1b",
                                            border: `1px solid ${selfieCaptured ? "#bbf7d0" : "#fecaca"}`,
                                          }}
                                        >
                                          {selfieCaptured ? "✓ Selfie" : "✕ No Selfie"}
                                        </span>
                                      </div>
                                      {/* Top Row */}
                                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 4 }}>
                                        {isUnnamed ? (
                                          <span
                                            style={{
                                              fontSize: is25Scale ? 9 : 10.5,
                                              fontWeight: 800,
                                              background: "#e0e7ff",
                                              color: "#3730a3",
                                              padding: is25Scale ? "1px 5px" : "2px 7px",
                                              borderRadius: 4,
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              maxWidth: is25Scale ? 95 : 140,
                                              border: "1px solid #c7d2fe",
                                            }}
                                            title={`Username: @${record.username || "provider"}`}
                                          >
                                            👤 @{record.username || "provider"}
                                          </span>
                                        ) : boardZoomLevel > 50 ? (
                                          <div style={{ display: "flex", alignItems: "center", gap: 4, overflow: "hidden" }}>
                                            <span style={{ fontSize: 9.5, fontWeight: 700, background: "#e0e7ff", color: "#3730a3", padding: "1px 5px", borderRadius: 4 }}>
                                              UID: {record.uid || providerId}
                                            </span>
                                            {record.username && (
                                              <span style={{ fontSize: 9, fontWeight: 800, background: "#f1f5f9", color: "#475569", padding: "1px 5px", borderRadius: 4 }}>
                                                @{record.username}
                                              </span>
                                            )}
                                          </div>
                                        ) : record.username ? (
                                          <span style={{ fontSize: 8.5, fontWeight: 800, background: "#ede9fe", color: "#6d28d9", padding: "1px 4px", borderRadius: 4 }}>
                                            @{record.username}
                                          </span>
                                        ) : <div />}
                                        <span
                                          style={{
                                            fontSize: is25Scale ? 8.5 : 10,
                                            fontWeight: 800,
                                            background: stageMeta.bg,
                                            color: stageMeta.color,
                                            padding: is25Scale ? "1px 5px" : "2px 6px",
                                            borderRadius: 4,
                                            border: `1px solid ${stageMeta.color}33`,
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          ● {is25Scale ? stageMeta.shortLabel : stageMeta.label}
                                        </span>
                                      </div>
                                      {/* Middle Row */}
                                      <div style={{ display: "flex", gap: is25Scale ? 6 : 10, alignItems: "center" }}>
                                        <img
                                          src={window.__getProviderProfileImage(record)}
                                          alt=""
                                          style={{
                                            width: is25Scale ? 26 : 38,
                                            height: is25Scale ? 26 : 38,
                                            borderRadius: "50%",
                                            objectFit: "cover",
                                            border: "1.5px solid #cbd5e1",
                                            flexShrink: 0,
                                          }}
                                        />
                                        <div style={{ minWidth: 0, flex: 1, overflow: "hidden" }}>
                                          <div
                                            style={{
                                              fontWeight: 700,
                                              fontSize: is25Scale ? 11 : 13,
                                              color: "#0f172a",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              lineHeight: "1.2",
                                            }}
                                            title={displayName}
                                          >
                                            {displayName}
                                          </div>
                                          <div style={{ fontSize: is25Scale ? 9 : 11, color: "#64748b", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                            {record.serviceCategory || "Services"}
                                          </div>
                                        </div>
                                      </div>
                                      {/* Bottom Badges Container */}
                                      <div style={{ display: "flex", gap: is25Scale ? 3 : 6, flexWrap: "wrap", alignItems: "center", marginTop: is25Scale ? 2 : 4 }}>
                                        <span
                                          style={{
                                            fontSize: is25Scale ? 8.5 : 10,
                                            fontWeight: 700,
                                            color: isBlocked ? "#991b1b" : isAppr ? "#166534" : "#059669",
                                            background: isBlocked ? "#fee2e2" : isAppr ? "#bbf7d0" : "#d1fae5",
                                            padding: is25Scale ? "1px 4px" : "2px 6px",
                                            borderRadius: 4,
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          ⚖️ {is25Scale && eligibility.length > 10 ? eligibility.slice(0, 8) + ".." : eligibility}
                                        </span>
                                        <span
                                          style={{
                                            fontSize: is25Scale ? 8.5 : 10,
                                            fontWeight: 700,
                                            background: daysSigned <= 3 ? "#ecfdf5" : daysSigned <= 14 ? "#eff6ff" : "#fff7ed",
                                            color: daysSigned <= 3 ? "#065f46" : daysSigned <= 14 ? "#1e40af" : "#9a3412",
                                            border: daysSigned <= 3 ? "1px solid #a7f3d0" : daysSigned <= 14 ? "1px solid #bfdbfe" : "1px solid #fed7aa",
                                            padding: is25Scale ? "1px 4px" : "2px 6px",
                                            borderRadius: 4,
                                            whiteSpace: "nowrap",
                                          }}
                                          title={`Signed up ${daysSigned} day(s) ago`}
                                        >
                                          ⏳ {daysSigned === 0 ? "0d" : `${daysSigned}d`}
                                        </span>
                                        <span
                                          style={{
                                            fontSize: is25Scale ? 8.5 : 10,
                                            background: "#f1f5f9",
                                            color: "#334155",
                                            padding: is25Scale ? "1px 4px" : "2px 6px",
                                            borderRadius: 4,
                                            fontWeight: 600,
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          📄 {docCount}
                                        </span>
                                        {record.visaType && (
                                          <span
                                            style={{
                                              fontSize: is25Scale ? 8.5 : 10,
                                              background: "#fef3c7",
                                              color: "#92400e",
                                              padding: is25Scale ? "1px 4px" : "2px 6px",
                                              borderRadius: 4,
                                              fontWeight: 600,
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            ✈️ {is25Scale && record.visaType.length > 8 ? record.visaType.slice(0, 7) + ".." : record.visaType}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })()}
              </div>
              {/* ============================================================
                  RIGHT DETAILS DRAWER (NEW PROVIDER BOARD)
              ============================================================ */}
              {providerDrawerVisible && providerInspectionRecord && (() => {
                const record = providerInspectionRecord;
                const pId = window.__getProviderCanonId(record);
                const displayName = window.__getProviderDisplayName(record);
                const isBlocked = window.__isProviderBlocked(record);
                const curCat = isBlocked ? "blocked" : window.__getStageCategory(record.approvalStage || record.status);
                const isAppr = curCat === "approved";
                const eligibility = isBlocked ? "Ineligible (Expired Docs)" : isAppr ? "approved" : (record.eligibilityStatus || window.__computeEligibilityStatus(record));
                const daysSigned = window.__getDaysSinceSignup(record);
                const stageMeta = window.__getStageMeta(curCat);
                const selfieUrlDrawer = window.__getProviderSelfieUrl(record);
                const selfieCapturedDrawer = window.__isProviderSelfieCaptured(record);
                return (
                  <aside
                    style={{
                      width: 500,
                      flexShrink: 0,
                      background: "#ffffff",
                      borderLeft: "1px solid #cbd5e1",
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      boxShadow: "-8px 0 25px rgba(0,0,0,0.06)",
                    }}
                  >
                    {/* Drawer Header */}
                    <div style={{ padding: 18, borderBottom: "1px solid #e2e8f0", background: "#0f172a", color: "#ffffff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                        <img
                          src={window.__getProviderProfileImage(record)}
                          alt=""
                          style={{ width: 48, height: 48, borderRadius: "50%", border: "2px solid #ffffff", objectFit: "cover" }}
                        />
                        <div>
                          <div style={{ fontWeight: 800, fontSize: 15 }}>{displayName}</div>
                          <div style={{ fontSize: 11, color: "#38bdf8", fontWeight: 700 }}>UID: {record.uid || pId}</div>
                        </div>
                      </div>
                      <button
                        onClick={() => setProviderDrawerVisible(false)}
                        style={{ border: "1px solid #475569", background: "#1e293b", color: "#fff", padding: "6px 12px", borderRadius: 6, cursor: "pointer", fontWeight: 700 }}
                      >
                        ✕ Close
                      </button>
                    </div>
                    {/* Stage Action Controls */}
                    <div style={{ padding: "12px 18px", borderBottom: "1px solid #e2e8f0", display: "flex", gap: 8, flexWrap: "wrap", background: "#f8fafc" }}>
                      {curCat !== "approved" && curCat !== "blocked" ? (
                        <button
                          onClick={() => {
                            let nextStage = "verification_started";
                            if (curCat === "new") nextStage = "verification_pending";
                            else if (curCat === "pending") nextStage = "verification_started";
                            else if (curCat === "started") nextStage = "internal_review";
                            else if (curCat === "review") nextStage = "verification_completed";
                            else if (curCat === "completed") nextStage = "approved";
                            window.__executePipelineStageTransition(pId, nextStage);
                          }}
                          style={{ flex: 1.2, padding: "8px 12px", borderRadius: 8, background: "#2563eb", color: "#fff", border: "none", fontWeight: 700, fontSize: 11, cursor: "pointer" }}
                        >
                          ⚡ Advance Stage
                        </button>
                      ) : curCat === "approved" ? (
                        <>
                          <button
                            onClick={() => {
                              window.__executePipelineStageTransition(pId, "verification_completed", "Moved back from Approved to Verification Completed");
                            }}
                            style={{ flex: 1, padding: "8px 10px", borderRadius: 8, background: "#0d9488", color: "#fff", border: "none", fontWeight: 700, fontSize: 11, cursor: "pointer" }}
                          >
                            ↩ To Completed
                          </button>
                          <button
                            onClick={() => {
                              window.__openCriticalTransitionModal({
                                provider: record,
                                fromStage: "approved",
                                toStage: "started",
                                targetStageId: "verification_started",
                                onConfirm: (reason) => window.__executePipelineStageTransition(pId, "verification_started", reason),
                              });
                            }}
                            style={{ flex: 1, padding: "8px 10px", borderRadius: 8, background: "#d97706", color: "#fff", border: "none", fontWeight: 700, fontSize: 11, cursor: "pointer" }}
                          >
                            ↩ To Started
                          </button>
                          <button
                            onClick={() => {
                              window.__openCriticalTransitionModal({
                                provider: record,
                                fromStage: "approved",
                                toStage: "pending",
                                targetStageId: "verification_pending",
                                onConfirm: (reason) => window.__executePipelineStageTransition(pId, "verification_pending", reason),
                              });
                            }}
                            style={{ flex: 1, padding: "8px 10px", borderRadius: 8, background: "#dc2626", color: "#fff", border: "none", fontWeight: 700, fontSize: 11, cursor: "pointer" }}
                          >
                            ↩ To Pending
                          </button>
                        </>
                      ) : (
                        <div style={{ flex: "1 1 100%", padding: "8px 12px", background: "#fee2e2", border: "1px solid #fecaca", borderRadius: 8, color: "#991b1b", fontSize: 11, fontWeight: 700 }}>
                          🚫 Provider Blocked: Identity or Right-to-Work document has expired. Re-upload valid documents to unlock.
                        </div>
                      )}
                      {curCat !== "approved" && curCat !== "blocked" && (
                        <button
                          onClick={() => {
                            if (curCat === "started" || curCat === "pending") {
                              window.__openCriticalTransitionModal({
                                provider: record,
                                fromStage: curCat,
                                toStage: "approved",
                                targetStageId: "approved",
                                onConfirm: (reason) => {
                                  window.__executePipelineStageTransition(pId, "approved", reason);
                                },
                              });
                            } else {
                              window.__openApprovalReasonModal({
                                provider: record,
                                fromStage: record.approvalStage || "verification_completed",
                                toStage: "approved",
                                onConfirm: (reason) => {
                                  window.__executePipelineStageTransition(pId, "approved", reason);
                                },
                              });
                            }
                          }}
                          style={{ flex: 1, padding: "8px 12px", borderRadius: 8, background: "#16a34a", color: "#fff", border: "none", fontWeight: 700, fontSize: 11, cursor: "pointer" }}
                        >
                          ✓ Approve
                        </button>
                      )}
                      <button
                        onClick={() => {
                          window.__openEncryptedStageGateModal({
                            provider: record,
                            fromStage: record.approvalStage || "pending",
                            toStage: "rejected",
                            title: "🔐 Stage Transition Gate: Move to Rejected",
                            description: `Rejecting ${displayName} requires authorization key and justification.`,
                            onConfirm: (reason) => {
                              window.__executePipelineStageTransition(pId, "rejected", reason);
                            },
                          });
                        }}
                        style={{ flex: 1, padding: "8px 12px", borderRadius: 8, background: "#dc2626", color: "#fff", border: "none", fontWeight: 700, fontSize: 11, cursor: "pointer" }}
                      >
                        ✕ Reject
                      </button>
                    </div>
                    {/* HIGH CONTRAST SECTION TABS */}
                    <div
                      style={{
                        padding: "10px 14px",
                        background: "#0b1329",
                        borderBottom: "1px solid #1e293b",
                        display: "grid",
                        gridTemplateColumns: "repeat(3, 1fr)",
                        gap: 6,
                      }}
                    >
                      {[
                        { key: "overview", label: "Overview", icon: "📋", count: null, accent: "#38bdf8", border: "#0284c7" },
                        { key: "documents", label: "All Docs", icon: "📄", count: (record?.documents || []).length, accent: "#60a5fa", border: "#2563eb" },
                        { key: "docTypes", label: "Doc Types", icon: "📑", count: null, accent: "#a78bfa", border: "#7c3aed" },
                        { key: "activity", label: "Audit Trail", icon: "🕒", count: null, accent: "#34d399", border: "#059669" },
                        { key: "notes", label: "Add Note", icon: "✏️", count: null, accent: "#fbbf24", border: "#d97706" },
                        { key: "notesLogs", label: "Notes Logs", icon: "📝", count: null, accent: "#fb7185", border: "#e11d48" },
                      ].map((t) => (
                        <button
                          key={t.key}
                          type="button"
                          onClick={() => window.__openPipelineSectionModal(t.key, record)}
                          style={{
                            padding: "8px 10px",
                            borderRadius: 8,
                            border: "1px solid #334155",
                            background: "#0f172a",
                            color: "#ffffff",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", gap: 6, minWidth: 0 }}>
                            <span style={{ fontSize: 13, flexShrink: 0 }}>{t.icon}</span>
                            <span
                              style={{
                                fontSize: 11,
                                fontWeight: 700,
                                color: "#f8fafc",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {t.label}
                            </span>
                          </div>
                          <div style={{ display: "flex", alignItems: "center", gap: 4, flexShrink: 0 }}>
                            {t.count !== null && (
                              <span
                                style={{
                                  fontSize: 9,
                                  fontWeight: 800,
                                  padding: "1px 5px",
                                  borderRadius: 10,
                                  background: "rgba(96, 165, 250, 0.2)",
                                  color: "#93c5fd",
                                  border: "1px solid rgba(96, 165, 250, 0.4)",
                                }}
                              >
                                {t.count}
                              </span>
                            )}
                            <span style={{ fontSize: 10, color: t.accent, opacity: 0.9, fontWeight: 800 }}>↗</span>
                          </div>
                        </button>
                      ))}
                    </div>
                    {/* Drawer Content */}
                    <div style={{ padding: 18, overflowY: "auto", flex: 1 }}>
                      {/* Selfie Verification Panel (click image to open zoom preview) */}
                      <div style={{ background: "#f8fafc", padding: 14, borderRadius: 10, border: "1px solid #e2e8f0", marginBottom: 14, display: "flex", gap: 14, alignItems: "center" }}>
                        <div
                          className={selfieUrlDrawer ? "selfie-zoom-trigger" : undefined}
                          title={selfieUrlDrawer ? "Click to zoom" : undefined}
                          onClick={() => {
                            if (selfieUrlDrawer) window.__openSelfiePreview(selfieUrlDrawer, `${displayName} — Selfie Verification`);
                          }}
                          style={{ width: 76, height: 76, borderRadius: 12, overflow: "hidden", background: "#e2e8f0", flexShrink: 0, border: "1px solid #cbd5e1" }}
                        >
                          {selfieUrlDrawer ? (
                            <img
                              src={selfieUrlDrawer}
                              alt="Selfie verification"
                              onContextMenu={(e) => e.preventDefault()}
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            />
                          ) : (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", fontSize: 22 }}>🤳</div>
                          )}
                        </div>
                        <div>
                          <div style={{ fontSize: 12, fontWeight: 700, color: "#0f172a", marginBottom: 4 }}>Selfie Verification (VerificationDocuments)</div>
                          <span
                            style={{
                              fontSize: 11,
                              fontWeight: 800,
                              padding: "2px 8px",
                              borderRadius: 6,
                              background: selfieCapturedDrawer ? "#dcfce7" : "#fee2e2",
                              color: selfieCapturedDrawer ? "#15803d" : "#991b1b",
                            }}
                          >
                            {selfieCapturedDrawer ? "✓ Selfie Captured" : "✕ Not Captured"}
                          </span>
                          {selfieUrlDrawer && (
                            <div style={{ fontSize: 10.5, color: "#2563eb", fontWeight: 700, marginTop: 6 }}>
                              🔍 Click the photo to zoom & inspect
                            </div>
                          )}
                        </div>
                      </div>
                      <div style={{ background: "#f8fafc", padding: 14, borderRadius: 10, border: "1px solid #e2e8f0", marginBottom: 14 }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: "#0f172a", marginBottom: 8 }}>Profile & Eligibility Summary</div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          UID: <strong style={{ color: "#1e40af" }}>{record.uid || pId}</strong>
                        </div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          Username: <strong style={{ color: "#6d28d9" }}>{record.username ? `@${record.username}` : "—"}</strong>
                        </div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          Full Name: <strong>{record.fullName || record.name || displayName || "—"}</strong>
                        </div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          Email: <strong>{record.email || record.providerEmailAddress || "—"}</strong>
                        </div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          Phone: <strong>{record.phoneNumber || record.providerContactNumber || record.phone || "—"}</strong>
                        </div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          Role: <strong style={{ color: "#4f46e5" }}>provider</strong>
                        </div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          Days Since Signup: <strong style={{ color: "#047857" }}>{daysSigned} day(s)</strong>
                        </div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          Current Stage: <strong style={{ color: stageMeta.color }}>{stageMeta.label}</strong>
                        </div>
                        {record.approvedBy && (
                          <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                            Approved By: <strong style={{ color: "#16a34a" }}>{record.approvedBy}</strong>
                          </div>
                        )}
                        {record.approvedAt && (
                          <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                            Approved Date: <strong>{window.__formatCleanDate(record.approvedAt)}</strong>
                          </div>
                        )}
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>Eligibility Status: <strong style={{ color: isBlocked ? "#dc2626" : isAppr ? "#16a34a" : "#1e293b" }}>{eligibility}</strong></div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>Location: <strong>{window.__formatServiceLocation(record.serviceLocation)}</strong></div>
                        <div style={{ fontSize: 12, color: "#334155" }}>Verified Docs on File: <strong>{(record.documents || []).length}</strong></div>
                      </div>
                    </div>
                  </aside>
                );
              })()}
            </div>
          </div>
        )}

        {/* ============================================================
            VIEW 2: EXISTING PROVIDER VERIFICATION (KANBAN VIEW)
        ============================================================ */}
        {providerViewMode === "kanban" && (() => {
          const is25Scale = kanbanZoom === 25;
          const displayStages = window.__ALL_PIPELINE_STAGES || [];
          const columnWidth = is25Scale ? 188 : kanbanZoom === 50 ? 230 : kanbanZoom === 75 ? 280 : 340;
          const kanbanMap = new Map();
          if (window.__pipelineMasterRegistry) {
            window.__pipelineMasterRegistry.forEach((masterRec, cid) => {
              if (masterRec && !window.__isRecordInvalidOrCustomer(masterRec)) {
                kanbanMap.set(cid, { ...masterRec });
              }
            });
          }
          const registerKanbanRecord = (item) => {
            if (!item || window.__isRecordInvalidOrCustomer(item)) return;
            const canonId = window.__getProviderCanonId(item);
            if (!canonId) return;
            const master = kanbanMap.get(canonId) || {};
            const structuredDocs = window.__extractBestDocuments(master, item);
            const merged = {
              ...item,
              ...master,
              documents: structuredDocs,
              verificationMeta: { ...(item.verificationMeta || {}), ...(master.verificationMeta || {}) },
            };
            if (window.__isProviderBlocked(merged)) {
              merged.approvalStage = "blocked";
              merged.status = "blocked";
              merged.eligibilityStatus = "Ineligible (Expired Docs)";
            } else {
              const curCat = window.__getStageCategory(merged.approvalStage || merged.status);
              merged.eligibilityStatus = curCat === "approved" ? "approved" : (master.eligibilityStatus || item.eligibilityStatus || window.__computeEligibilityStatus(merged));
            }
            kanbanMap.set(canonId, merged);
            window.__pipelineMasterRegistry.set(canonId, merged);
          };
          (providerPipelineCards || []).forEach(registerKanbanRecord);
          (pipelineBoardRecords || []).forEach(registerKanbanRecord);
          let kanbanData = Array.from(kanbanMap.values());
          if (window.__pipelineUidSearchQuery && window.__pipelineUidSearchQuery.trim()) {
            const q = window.__pipelineUidSearchQuery.trim().toLowerCase();
            kanbanData = kanbanData.filter((b) => {
              const canon = window.__getProviderCanonId(b).toLowerCase();
              const name = String(window.__getProviderDisplayName(b)).toLowerCase();
              const uName = String(b.username || "").toLowerCase();
              const fName = String(b.fullName || "").toLowerCase();
              const email = String(b.providerEmailAddress || b.email || "").toLowerCase();
              return canon.includes(q) || name.includes(q) || uName.includes(q) || fName.includes(q) || email.includes(q);
            });
          }
          kanbanData = kanbanData.filter((b) => window.__hasDocumentGoingToExpire(b));
          if (window.__pipelineSortOrder === "newest") {
            kanbanData.sort((a, b) => window.__getSignupDateTimestamp(b) - window.__getSignupDateTimestamp(a));
          } else if (window.__pipelineSortOrder === "oldest") {
            kanbanData.sort((a, b) => window.__getSignupDateTimestamp(a) - window.__getSignupDateTimestamp(b));
          }
          return (
            <div style={{ display: "flex", flexDirection: "row", height: "100%", overflow: "hidden" }}>
              <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                {/* Kanban Sub-Toolbar */}
                <div style={{ background: "#ffffff", padding: "10px 20px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ fontWeight: 700, fontSize: 13, color: "#0f172a", display: "flex", alignItems: "center", gap: 8 }}>
                    <span>Existing Providers Verification Dashboard ({kanbanData.length} records active)</span>
                    <span style={{ fontSize: 11, background: "#fee2e2", color: "#b91c1c", padding: "2px 8px", borderRadius: 6, fontWeight: 800 }}>
                      ⚠️ Filtered to records whose documents are going to expire or have expired
                    </span>
                  </div>
                  <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                    {[25, 50, 75, 100].map((sz) => (
                      <button
                        key={sz}
                        onClick={() => setKanbanZoom(sz)}
                        style={{
                          padding: "4px 10px",
                          borderRadius: 6,
                          border: kanbanZoom === sz ? "1px solid #7c3aed" : "1px solid #cbd5e1",
                          background: kanbanZoom === sz ? "#7c3aed" : "#f1f5f9",
                          color: kanbanZoom === sz ? "#ffffff" : "#334155",
                          fontSize: 11,
                          fontWeight: 700,
                          cursor: "pointer",
                        }}
                      >
                        {sz}%
                      </button>
                    ))}
                    {kanbanZoom <= 50 && (
                      <span style={{ fontSize: 11, color: "#64748b", marginLeft: 8, fontStyle: "italic" }}>
                        (Compact mode enabled at 25% scale; UIDs visible in profile inspection drawer)
                      </span>
                    )}
                  </div>
                </div>
                {/* Columns */}
                <div style={{ flex: 1, overflowX: "auto", overflowY: "hidden", padding: 16 }}>
                  <div style={{ display: "flex", gap: 14, minWidth: "max-content", height: "100%" }}>
                    {displayStages.map((stage) => {
                      const cards = kanbanData.filter((item) => {
                        const act = window.__getEffectiveProviderStage(item);
                        return window.__isStageMatch(act, stage.id);
                      });
                      return (
                        <div
                          key={stage.id}
                          onDragOver={(e) => {
                            e.preventDefault();
                            e.dataTransfer.dropEffect = "move";
                          }}
                          onDrop={(e) => {
                            e.preventDefault();
                            const pId = e.dataTransfer.getData("text/plain") || window.__getProviderCanonId(draggedProvider);
                            if (typeof setDraggedProvider === "function") setDraggedProvider(null);
                            if (!pId) return;
                            const prov = kanbanData.find((k) => window.__getProviderCanonId(k) === String(pId)) || window.__pipelineMasterRegistry.get(String(pId));
                            const curCat = window.__getStageCategory(prov?.approvalStage || prov?.status);
                            const targetCat = window.__getStageCategory(stage.id);
                            const isStartedToApproved = (curCat === "started" && targetCat === "approved");
                            const isPendingToApproved = (curCat === "pending" && targetCat === "approved");
                            const isApprovedToPending = (curCat === "approved" && targetCat === "pending");
                            const isApprovedToStarted = (curCat === "approved" && targetCat === "started");
                            if (isStartedToApproved || isPendingToApproved || isApprovedToPending || isApprovedToStarted) {
                              window.__openCriticalTransitionModal({
                                provider: prov,
                                fromStage: curCat,
                                toStage: targetCat,
                                targetStageId: stage.id,
                                onConfirm: (reason) => window.__executePipelineStageTransition(pId, stage.id, reason),
                              });
                              return;
                            }
                            const isApprovedRejected = (curCat === "approved" && targetCat === "rejected") || (curCat === "rejected" && targetCat === "approved");
                            const isStartedRejected = (curCat === "started" && targetCat === "rejected");
                            if (isApprovedRejected || isStartedRejected) {
                              window.__openEncryptedStageGateModal({
                                provider: prov,
                                fromStage: curCat,
                                toStage: targetCat,
                                title: "🔐 Protected Stage Transition Gate",
                                description: `Moving ${window.__getProviderDisplayName(prov)} from ${curCat} to ${targetCat}. Security authorization key and justification required.`,
                                onConfirm: (reason) => window.__executePipelineStageTransition(pId, stage.id, reason),
                              });
                            } else {
                              window.__executePipelineStageTransition(pId, stage.id);
                            }
                          }}
                          style={{
                            width: columnWidth,
                            flexShrink: 0,
                            background: stage.id === "blocked" ? "#fef2f2" : "#ffffff",
                            border: stage.id === "blocked" ? "1.5px solid #fca5a5" : "1px solid #e2e8f0",
                            borderRadius: 12,
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                          }}
                        >
                          <div style={{ padding: is25Scale ? "8px 10px" : "12px 14px", borderBottom: "1px solid #e2e8f0", background: "#f8fafc", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <strong style={{ fontSize: is25Scale ? 11 : 13, color: "#0f172a", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              {stage.label}
                            </strong>
                            <span style={{ background: stage.bg, color: stage.color, padding: is25Scale ? "1px 6px" : "2px 8px", borderRadius: 12, fontSize: is25Scale ? 10 : 11, fontWeight: 700 }}>
                              {cards.length}
                            </span>
                          </div>
                          <div style={{ padding: is25Scale ? 6 : 10, display: "flex", flexDirection: "column", gap: is25Scale ? 6 : 10, overflowY: "auto", flex: 1 }}>
                            {cards.length === 0 && (
                              <div style={{ textAlign: "center", color: "#94a3b8", fontSize: is25Scale ? 11 : 12, padding: is25Scale ? 14 : 24 }}>
                                No providers in stage
                              </div>
                            )}
                            {cards.map((prov) => {
                              const pId = window.__getProviderCanonId(prov);
                              const isUnnamed = window.__isUnnamedProvider(prov);
                              const displayName = window.__getProviderDisplayName(prov);
                              const isBlocked = window.__isProviderBlocked(prov);
                              const daysSigned = window.__getDaysSinceSignup(prov);
                              const stageMeta = window.__getStageMeta(isBlocked ? "blocked" : (prov.approvalStage || prov.status));
                              const isShieldedUser = window.__isTargetShieldedProvider(prov);
                              const selfieUrl = window.__getProviderSelfieUrl(prov);
                              const selfieCaptured = window.__isProviderSelfieCaptured(prov);
                              return (
                                <div
                                  key={`kanban_card_${pId}`}
                                  draggable={!isBlocked}
                                  onDragStart={(e) => {
                                    if (typeof setDraggedProvider === "function") setDraggedProvider(prov);
                                    e.dataTransfer.setData("text/plain", pId);
                                    e.dataTransfer.effectAllowed = "move";
                                  }}
                                  onDragEnd={() => {
                                    if (typeof setDraggedProvider === "function") setDraggedProvider(null);
                                  }}
                                  onClick={() => {
                                    setProviderSnapshot(prov);
                                    setProfileDrawerOpen(true);
                                  }}
                                  style={{
                                    background: "#ffffff",
                                    border: isBlocked ? "1.5px solid #ef4444" : "1px solid #cbd5e1",
                                    borderRadius: is25Scale ? 8 : 10,
                                    padding: is25Scale ? "7px 8px" : 12,
                                    cursor: isBlocked ? "not-allowed" : "grab",
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: is25Scale ? 4 : 6,
                                  }}
                                >
                                  {/* Selfie Verification Strip */}
                                  <div
                                    style={{
                                      position: "relative",
                                      width: "100%",
                                      height: is25Scale ? 42 : 64,
                                      borderRadius: is25Scale ? 6 : 8,
                                      overflow: "hidden",
                                      background: "#f1f5f9",
                                      border: "1px solid #e2e8f0",
                                      flexShrink: 0,
                                    }}
                                  >
                                    {selfieUrl ? (
                                      <img
                                        src={selfieUrl}
                                        alt="Selfie verification"
                                        draggable={false}
                                        onContextMenu={(e) => e.preventDefault()}
                                        style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                                      />
                                    ) : (
                                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", fontSize: is25Scale ? 9 : 11, color: "#94a3b8", fontWeight: 700 }}>
                                        🤳 No Selfie On File
                                      </div>
                                    )}
                                    <span
                                      style={{
                                        position: "absolute",
                                        top: 3,
                                        right: 3,
                                        fontSize: is25Scale ? 8 : 9.5,
                                        fontWeight: 800,
                                        padding: "1px 5px",
                                        borderRadius: 4,
                                        background: selfieCaptured ? "#dcfce7" : "#fee2e2",
                                        color: selfieCaptured ? "#166534" : "#991b1b",
                                        border: `1px solid ${selfieCaptured ? "#bbf7d0" : "#fecaca"}`,
                                      }}
                                    >
                                      {selfieCaptured ? "✓ Selfie" : "✕ No Selfie"}
                                    </span>
                                  </div>
                                  {/* Top Row */}
                                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 4 }}>
                                    {isUnnamed ? (
                                      <span
                                        style={{
                                          fontSize: is25Scale ? 9 : 10.5,
                                          fontWeight: 800,
                                          background: "#ede9fe",
                                          color: "#6d28d9",
                                          padding: is25Scale ? "1px 5px" : "2px 7px",
                                          borderRadius: 4,
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          maxWidth: is25Scale ? 95 : 140,
                                          border: "1px solid #ddd6fe",
                                        }}
                                        title={`Username: @${prov.username || "provider"}`}
                                      >
                                        👤 @{prov.username || "provider"}
                                      </span>
                                    ) : kanbanZoom > 50 ? (
                                      <div style={{ display: "flex", alignItems: "center", gap: 4, overflow: "hidden" }}>
                                        <span style={{ fontSize: 9.5, fontWeight: 700, background: "#ede9fe", color: "#6d28d9", padding: "1px 5px", borderRadius: 4 }}>
                                          UID: {prov.uid || pId}
                                        </span>
                                        {prov.username && (
                                          <span style={{ fontSize: 9, fontWeight: 800, background: "#f1f5f9", color: "#475569", padding: "1px 5px", borderRadius: 4 }}>
                                            @{prov.username}
                                          </span>
                                        )}
                                      </div>
                                    ) : prov.username ? (
                                      <span style={{ fontSize: 8.5, fontWeight: 800, background: "#e0e7ff", color: "#3730a3", padding: "1px 4px", borderRadius: 4 }}>
                                        @{prov.username}
                                      </span>
                                    ) : <div />}
                                    <span
                                      style={{
                                        fontSize: is25Scale ? 8.5 : 10,
                                        fontWeight: 800,
                                        background: stageMeta.bg,
                                        color: stageMeta.color,
                                        padding: is25Scale ? "1px 5px" : "2px 6px",
                                        borderRadius: 4,
                                        border: `1px solid ${stageMeta.color}33`,
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      ● {is25Scale ? stageMeta.shortLabel : stageMeta.label}
                                    </span>
                                  </div>
                                  <div style={{ display: "flex", gap: is25Scale ? 6 : 10, alignItems: "center" }}>
                                    <img
                                      src={window.__getProviderProfileImage(prov)}
                                      alt=""
                                      style={{
                                        width: is25Scale ? 26 : 38,
                                        height: is25Scale ? 26 : 38,
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                        border: "1.5px solid #cbd5e1",
                                        flexShrink: 0,
                                      }}
                                    />
                                    <div style={{ minWidth: 0, flex: 1, overflow: "hidden" }}>
                                      <div
                                        style={{
                                          fontWeight: 700,
                                          fontSize: is25Scale ? 11 : 13,
                                          color: "#0f172a",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          lineHeight: "1.2",
                                        }}
                                        title={displayName}
                                      >
                                        {displayName}
                                      </div>
                                      <div style={{ fontSize: is25Scale ? 9 : 11, color: "#64748b", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                        {prov.serviceCategory || "Services"}
                                      </div>
                                      {!isShieldedUser && prov.providerEmailAddress && !is25Scale && (
                                        <div style={{ fontSize: 10, color: "#94a3b8", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                          {prov.providerEmailAddress}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  {/* Bottom Trackers */}
                                  <div style={{ display: "flex", gap: is25Scale ? 3 : 6, flexWrap: "wrap", alignItems: "center", marginTop: is25Scale ? 2 : 4 }}>
                                    <span
                                      style={{
                                        fontSize: is25Scale ? 8.5 : 10,
                                        fontWeight: 700,
                                        background: daysSigned <= 3 ? "#ecfdf5" : daysSigned <= 14 ? "#eff6ff" : "#fff7ed",
                                        color: daysSigned <= 3 ? "#065f46" : daysSigned <= 14 ? "#1e40af" : "#9a3412",
                                        border: daysSigned <= 3 ? "1px solid #a7f3d0" : daysSigned <= 14 ? "1px solid #bfdbfe" : "1px solid #fed7aa",
                                        padding: is25Scale ? "1px 4px" : "2px 6px",
                                        borderRadius: 4,
                                        whiteSpace: "nowrap",
                                      }}
                                      title={`Signed up ${daysSigned} day(s) ago`}
                                    >
                                      ⏳ {daysSigned === 0 ? "0d" : `${daysSigned}d`}
                                    </span>
                                    <span
                                      style={{
                                        fontSize: is25Scale ? 8.5 : 10,
                                        background: "#f1f5f9",
                                        color: "#334155",
                                        padding: is25Scale ? "1px 4px" : "2px 6px",
                                        borderRadius: 4,
                                        fontWeight: 600,
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      📄 {(prov.documents || []).length}
                                    </span>
                                    <span
                                      style={{
                                        fontSize: is25Scale ? 8.5 : 9,
                                        fontWeight: 800,
                                        background: isBlocked ? "#fee2e2" : "#fef3c7",
                                        color: isBlocked ? "#991b1b" : "#b45309",
                                        border: isBlocked ? "1.5px solid #fca5a5" : "1px solid #fde68a",
                                        padding: is25Scale ? "1px 4px" : "2px 6px",
                                        borderRadius: 4,
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {isBlocked ? "🚫 Expired" : "⚠️ Expiring Soon"}
                                    </span>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              {/* ============================================================
                  RIGHT DETAILS DRAWER (EXISTING PROVIDER KANBAN)
              ============================================================ */}
              {profileDrawerOpen && providerSnapshot && (() => {
                const provider = providerSnapshot;
                const pId = window.__getProviderCanonId(provider);
                const displayName = window.__getProviderDisplayName(provider);
                const isBlocked = window.__isProviderBlocked(provider);
                const daysSigned = window.__getDaysSinceSignup(provider);
                const stageMeta = window.__getStageMeta(isBlocked ? "blocked" : (provider.approvalStage || provider.status));
                const curCat = isBlocked ? "blocked" : window.__getStageCategory(provider.approvalStage || provider.status);
                const isAppr = curCat === "approved";
                const eligibility = isBlocked ? "Ineligible (Expired Docs)" : isAppr ? "approved" : (provider.eligibilityStatus || window.__computeEligibilityStatus(provider));
                const isShieldedUser = window.__isTargetShieldedProvider(provider);
                const resolvedEmail = isShieldedUser ? "Dpyekbi703@gmail.com" : (provider.email || provider.providerEmailAddress || "—");
                const selfieUrlDrawer = window.__getProviderSelfieUrl(provider);
                const selfieCapturedDrawer = window.__isProviderSelfieCaptured(provider);
                return (
                  <aside
                    style={{
                      width: 500,
                      background: "#ffffff",
                      borderLeft: "1px solid #cbd5e1",
                      display: "flex",
                      flexDirection: "column",
                      flexShrink: 0,
                      boxShadow: "-8px 0 25px rgba(0,0,0,0.06)",
                    }}
                  >
                    {/* Header */}
                    <div style={{ padding: 18, borderBottom: "1px solid #e2e8f0", background: "#0f172a", color: "#ffffff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                        <img
                          src={window.__getProviderProfileImage(provider)}
                          alt=""
                          style={{ width: 48, height: 48, borderRadius: "50%", border: "2px solid #ffffff", objectFit: "cover" }}
                        />
                        <div>
                          <div style={{ fontWeight: 800, fontSize: 15 }}>{displayName}</div>
                          <div style={{ fontSize: 11, color: "#a78bfa", fontWeight: 700 }}>UID: {provider.uid || pId}</div>
                        </div>
                      </div>
                      <button
                        onClick={() => setProfileDrawerOpen(false)}
                        style={{ border: "1px solid #475569", background: "#1e293b", color: "#fff", padding: "6px 12px", borderRadius: 6, cursor: "pointer", fontWeight: 700 }}
                      >
                        ✕ Close
                      </button>
                    </div>
                    {/* Actions */}
                    <div style={{ padding: "12px 18px", borderBottom: "1px solid #e2e8f0", display: "flex", gap: 8, flexWrap: "wrap", background: "#f8fafc" }}>
                      {curCat === "approved" ? (
                        <>
                          <button
                            onClick={() => {
                              window.__executePipelineStageTransition(pId, "verification_completed", "Kanban: Moved from Approved back to Verification Completed");
                            }}
                            style={{ flex: 1, padding: "8px 10px", borderRadius: 8, background: "#0d9488", color: "#fff", border: "none", fontWeight: 700, fontSize: 11, cursor: "pointer" }}
                          >
                            ↩ To Completed
                          </button>
                          <button
                            onClick={() => {
                              window.__openCriticalTransitionModal({
                                provider,
                                fromStage: "approved",
                                toStage: "started",
                                targetStageId: "verification_started",
                                onConfirm: (reason) => window.__executePipelineStageTransition(pId, "verification_started", reason),
                              });
                            }}
                            style={{ flex: 1, padding: "8px 10px", borderRadius: 8, background: "#d97706", color: "#fff", border: "none", fontWeight: 700, fontSize: 11, cursor: "pointer" }}
                          >
                            ↩ To Started
                          </button>
                          <button
                            onClick={() => {
                              window.__openCriticalTransitionModal({
                                provider,
                                fromStage: "approved",
                                toStage: "pending",
                                targetStageId: "verification_pending",
                                onConfirm: (reason) => window.__executePipelineStageTransition(pId, "verification_pending", reason),
                              });
                            }}
                            style={{ flex: 1, padding: "8px 10px", borderRadius: 8, background: "#dc2626", color: "#fff", border: "none", fontWeight: 700, fontSize: 11, cursor: "pointer" }}
                          >
                            ↩ To Pending
                          </button>
                        </>
                      ) : curCat === "blocked" ? (
                        <div style={{ flex: "1 1 100%", padding: "8px 12px", background: "#fee2e2", border: "1px solid #fecaca", borderRadius: 8, color: "#991b1b", fontSize: 11, fontWeight: 700 }}>
                          🚫 Provider Blocked: Active documents have expired. Re-upload documents via All Docs tab to re-verify.
                        </div>
                      ) : (
                        <button
                          onClick={() => {
                            if (curCat === "started" || curCat === "pending") {
                              window.__openCriticalTransitionModal({
                                provider,
                                fromStage: curCat,
                                toStage: "approved",
                                targetStageId: "approved",
                                onConfirm: (reason) => {
                                  window.__executePipelineStageTransition(pId, "approved", reason);
                                },
                              });
                            } else {
                              window.__openApprovalReasonModal({
                                provider,
                                fromStage: provider.approvalStage || "verification_completed",
                                toStage: "approved",
                                onConfirm: (reason) => {
                                  window.__executePipelineStageTransition(pId, "approved", reason);
                                },
                              });
                            }
                          }}
                          style={{ flex: 1, padding: "8px 12px", borderRadius: 8, background: "#16a34a", color: "#fff", border: "none", fontWeight: 700, fontSize: 11, cursor: "pointer" }}
                        >
                          ✓ Approve
                        </button>
                      )}
                      <button
                        onClick={() => {
                          window.__openEncryptedStageGateModal({
                            provider,
                            fromStage: provider.approvalStage || "pending",
                            toStage: "rejected",
                            title: "🔐 Stage Transition Gate: Move to Rejected",
                            description: `Rejecting ${displayName} requires authorization key and documentation.`,
                            onConfirm: (reason) => {
                              window.__executePipelineStageTransition(pId, "rejected", reason);
                            },
                          });
                        }}
                        style={{ flex: 1, padding: "8px 12px", borderRadius: 8, background: "#dc2626", color: "#fff", border: "none", fontWeight: 700, fontSize: 11, cursor: "pointer" }}
                      >
                        ✕ Reject
                      </button>
                    </div>
                    {/* HIGH CONTRAST SECTION TABS */}
                    <div style={{ padding: "10px 16px", background: "#0f172a", borderBottom: "1px solid #1e293b", display: "flex", gap: 6, flexWrap: "wrap" }}>
                      {[
                        ["overview", "📋 Overview"],
                        ["documents", "📄 All Docs"],
                        ["docTypes", "📑 Doc Types"],
                        ["activity", "🕒 Activity / Audit"],
                        ["notes", "✏️ Add Note"],
                        ["notesLogs", "📝 Notes Logs"],
                      ].map(([key, lbl]) => (
                        <button
                          key={key}
                          type="button"
                          onClick={() => window.__openPipelineSectionModal(key, provider)}
                          style={{
                            padding: "6px 12px",
                            borderRadius: 6,
                            border: "1px solid #334155",
                            background: key === "notesLogs" ? "#be185d" : "#1e293b",
                            color: "#ffffff",
                            fontWeight: 700,
                            fontSize: 11,
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: 4,
                          }}
                        >
                          <span>{lbl}</span>
                          <span style={{ fontSize: 9, opacity: 0.8 }}>↗</span>
                        </button>
                      ))}
                    </div>
                    {/* Drawer Content */}
                    <div style={{ padding: 18, overflowY: "auto", flex: 1 }}>
                      {/* Selfie Verification Panel (click image to open zoom preview) */}
                      <div style={{ background: "#f8fafc", padding: 14, borderRadius: 10, border: "1px solid #e2e8f0", marginBottom: 14, display: "flex", gap: 14, alignItems: "center" }}>
                        <div
                          className={selfieUrlDrawer ? "selfie-zoom-trigger" : undefined}
                          title={selfieUrlDrawer ? "Click to zoom" : undefined}
                          onClick={() => {
                            if (selfieUrlDrawer) window.__openSelfiePreview(selfieUrlDrawer, `${displayName} — Selfie Verification`);
                          }}
                          style={{ width: 76, height: 76, borderRadius: 12, overflow: "hidden", background: "#e2e8f0", flexShrink: 0, border: "1px solid #cbd5e1" }}
                        >
                          {selfieUrlDrawer ? (
                            <img
                              src={selfieUrlDrawer}
                              alt="Selfie verification"
                              onContextMenu={(e) => e.preventDefault()}
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            />
                          ) : (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", fontSize: 22 }}>🤳</div>
                          )}
                        </div>
                        <div>
                          <div style={{ fontSize: 12, fontWeight: 700, color: "#0f172a", marginBottom: 4 }}>Selfie Verification (VerificationDocuments)</div>
                          <span
                            style={{
                              fontSize: 11,
                              fontWeight: 800,
                              padding: "2px 8px",
                              borderRadius: 6,
                              background: selfieCapturedDrawer ? "#dcfce7" : "#fee2e2",
                              color: selfieCapturedDrawer ? "#15803d" : "#991b1b",
                            }}
                          >
                            {selfieCapturedDrawer ? "✓ Selfie Captured" : "✕ Not Captured"}
                          </span>
                          {selfieUrlDrawer && (
                            <div style={{ fontSize: 10.5, color: "#2563eb", fontWeight: 700, marginTop: 6 }}>
                              🔍 Click the photo to zoom & inspect
                            </div>
                          )}
                        </div>
                      </div>
                      <div style={{ background: "#f8fafc", padding: 14, borderRadius: 10, border: "1px solid #e2e8f0" }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: "#0f172a", marginBottom: 8 }}>Existing Compliance Overview</div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          UID from system: <strong style={{ color: "#7c3aed" }}>{provider.uid || pId}</strong>
                        </div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          Username: <strong style={{ color: "#6d28d9" }}>{provider.username ? `@${provider.username}` : "—"}</strong>
                        </div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          Full Name: <strong>{provider.fullName || provider.name || displayName || "—"}</strong>
                        </div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          Email: <strong style={{ color: "#0284c7" }}>{resolvedEmail}</strong>
                        </div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          Phone: <strong>{provider.phoneNumber || provider.providerContactNumber || provider.phone || "—"}</strong>
                        </div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          Role: <strong style={{ color: "#4f46e5" }}>provider</strong>
                        </div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          Days Since Signup: <strong style={{ color: "#047857" }}>{daysSigned} day(s)</strong>
                        </div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          Current Stage: <strong style={{ color: stageMeta.color }}>{stageMeta.label}</strong>
                        </div>
                        {provider.approvedBy && (
                          <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                            Approved By: <strong style={{ color: "#16a34a" }}>{provider.approvedBy}</strong>
                          </div>
                        )}
                        {provider.approvedAt && (
                          <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                            Approved Date: <strong>{window.__formatCleanDate(provider.approvedAt)}</strong>
                          </div>
                        )}
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          Eligibility Status: <strong style={{ color: isBlocked ? "#dc2626" : isAppr ? "#16a34a" : "#1e293b" }}>{eligibility}</strong>
                        </div>
                        <div style={{ fontSize: 12, color: "#334155", marginBottom: 4 }}>
                          Location: <strong>{window.__formatServiceLocation(provider.serviceLocation)}</strong>
                        </div>
                        <div style={{ fontSize: 12, color: "#334155" }}>
                          Documents Count: <strong>{(provider.documents || []).length}</strong>
                        </div>
                      </div>
                    </div>
                  </aside>
                );
              })()}
            </div>
          );
        })()}
      </main>
    </div>

    {/* ============================================================
        SECURITY MODAL 1: BOARD ACCESS PASSCODE MODAL
    ============================================================ */}
    {window.__boardPasscodeModalState?.open && (() => {
      const state = window.__boardPasscodeModalState;
      const close = () => { window.__boardPasscodeModalState = null; window.__triggerPipelineReRender(); };
      return (
        <div
          onClick={close}
          style={{ position: "fixed", inset: 0, background: "rgba(15, 23, 42, 0.85)", zIndex: 14000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, backdropFilter: "blur(5px)" }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ background: "#ffffff", borderRadius: 14, width: "min(420px, 100%)", padding: 24, boxShadow: "0 25px 50px rgba(0,0,0,0.3)" }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
              <span style={{ fontSize: 24 }}>🔒</span>
              <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: "#0f172a" }}>
                Restricted Pipeline Access Gate
              </h3>
            </div>
            <p style={{ fontSize: 13, color: "#475569", margin: "0 0 16px 0", lineHeight: 1.45 }}>
              To access the <strong>{state.targetMode === "board" ? "New Provider Verification" : "Existing Provider Verification"}</strong> board, enter compliance authorization passcode.
            </p>
            <label style={{ fontSize: 12, fontWeight: 700, color: "#334155", display: "block", marginBottom: 6 }}>
              Security Passcode <span style={{ color: "#dc2626" }}>*</span>
            </label>
            <input
              type="password"
              id="board-passcode-input"
              placeholder="Enter authorization key..."
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  const val = document.getElementById("board-passcode-input")?.value;
                  state.onConfirm(val);
                }
              }}
              style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1.5px solid #cbd5e1", fontSize: 14, boxSizing: "border-box", marginBottom: 10 }}
            />
            {state.error && (
              <div style={{ fontSize: 12, color: "#dc2626", fontWeight: 700, marginBottom: 12 }}>
                ⚠️ {state.error}
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 10 }}>
              <button
                onClick={close}
                style={{ padding: "8px 16px", borderRadius: 8, border: "1px solid #cbd5e1", background: "#ffffff", color: "#334155", fontWeight: 700, cursor: "pointer" }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  const val = document.getElementById("board-passcode-input")?.value;
                  state.onConfirm(val);
                }}
                style={{ padding: "8px 18px", borderRadius: 8, border: "none", background: "#2563eb", color: "#ffffff", fontWeight: 800, cursor: "pointer" }}
              >
                Unlock Board
              </button>
            </div>
          </div>
        </div>
      );
    })()}

    {/* ============================================================
        SECURITY MODAL 1B: ALL DOCS TAB AUTHENTICATION GATE
    ============================================================ */}
    {window.__allDocsAuthModalState?.open && (() => {
      const state = window.__allDocsAuthModalState;
      const close = () => { window.__allDocsAuthModalState = null; window.__triggerPipelineReRender(); };
      return (
        <div
          onClick={close}
          style={{ position: "fixed", inset: 0, background: "rgba(15, 23, 42, 0.85)", zIndex: 14200, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, backdropFilter: "blur(6px)" }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ background: "#ffffff", borderRadius: 16, width: "min(430px, 100%)", padding: 24, boxShadow: "0 25px 60px rgba(0,0,0,0.35)" }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
              <span style={{ fontSize: 24 }}>📄</span>
              <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: "#1e40af" }}>
                All Documents Security Gate
              </h3>
            </div>
            <p style={{ fontSize: 13, color: "#475569", margin: "0 0 16px 0", lineHeight: 1.45 }}>
              Access to the comprehensive identity and right-to-work verification depository is strictly restricted. Enter compliance authorization passcode to proceed.
            </p>
            <label style={{ fontSize: 12, fontWeight: 700, color: "#334155", display: "block", marginBottom: 6 }}>
              Compliance Passcode <span style={{ color: "#dc2626" }}>*</span>
            </label>
            <input
              type="password"
              id="alldocs-passcode-input"
              placeholder="Enter authorization key..."
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  const val = document.getElementById("alldocs-passcode-input")?.value?.trim();
                  if (val === window.__PIPELINE_PASSCODE) {
                    const cb = state.onSuccess;
                    window.__allDocsAuthModalState = null;
                    if (cb) cb();
                  } else {
                    state.error = "Incorrect Security Passcode. Access denied.";
                    window.__triggerPipelineReRender();
                  }
                }
              }}
              style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1.5px solid #cbd5e1", fontSize: 14, boxSizing: "border-box", marginBottom: 10 }}
            />
            {state.error && (
              <div style={{ fontSize: 12, color: "#dc2626", fontWeight: 700, marginBottom: 12 }}>
                ⚠️ {state.error}
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 10 }}>
              <button
                onClick={close}
                style={{ padding: "8px 16px", borderRadius: 8, border: "1px solid #cbd5e1", background: "#ffffff", color: "#334155", fontWeight: 700, cursor: "pointer" }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  const val = document.getElementById("alldocs-passcode-input")?.value?.trim();
                  if (val === window.__PIPELINE_PASSCODE) {
                    const cb = state.onSuccess;
                    window.__allDocsAuthModalState = null;
                    if (cb) cb();
                  } else {
                    state.error = "Incorrect Security Passcode. Access denied.";
                    window.__triggerPipelineReRender();
                  }
                }}
                style={{ padding: "8px 18px", borderRadius: 8, border: "none", background: "#1e40af", color: "#ffffff", fontWeight: 800, cursor: "pointer" }}
              >
                Authorize Access
              </button>
            </div>
          </div>
        </div>
      );
    })()}

    {/* ============================================================
        SECURITY MODAL 1C: DOC TYPES TAB AUTHENTICATION GATE
    ============================================================ */}
    {window.__docTypesAuthModalState?.open && (() => {
      const state = window.__docTypesAuthModalState;
      const close = () => { window.__docTypesAuthModalState = null; window.__triggerPipelineReRender(); };
      return (
        <div
          onClick={close}
          style={{ position: "fixed", inset: 0, background: "rgba(15, 23, 42, 0.85)", zIndex: 14200, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, backdropFilter: "blur(6px)" }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ background: "#ffffff", borderRadius: 16, width: "min(430px, 100%)", padding: 24, boxShadow: "0 25px 60px rgba(0,0,0,0.35)" }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
              <span style={{ fontSize: 24 }}>📑</span>
              <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: "#7c3aed" }}>
                Doc Types Categorization Security Gate
              </h3>
            </div>
            <p style={{ fontSize: 13, color: "#475569", margin: "0 0 16px 0", lineHeight: 1.45 }}>
              Access to categorized identity verification document types (Passport, Visas, BRP, Licenses) is restricted by statutory compliance policy.
            </p>
            <label style={{ fontSize: 12, fontWeight: 700, color: "#334155", display: "block", marginBottom: 6 }}>
              Compliance Passcode <span style={{ color: "#dc2626" }}>*</span>
            </label>
            <input
              type="password"
              id="doctypes-passcode-input"
              placeholder="Enter authorization key..."
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  const val = document.getElementById("doctypes-passcode-input")?.value?.trim();
                  if (val === window.__PIPELINE_PASSCODE) {
                    const cb = state.onSuccess;
                    window.__docTypesAuthModalState = null;
                    if (cb) cb();
                  } else {
                    state.error = "Incorrect Security Passcode. Access denied.";
                    window.__triggerPipelineReRender();
                  }
                }
              }}
              style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1.5px solid #cbd5e1", fontSize: 14, boxSizing: "border-box", marginBottom: 10 }}
            />
            {state.error && (
              <div style={{ fontSize: 12, color: "#dc2626", fontWeight: 700, marginBottom: 12 }}>
                ⚠️ {state.error}
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 10 }}>
              <button
                onClick={close}
                style={{ padding: "8px 16px", borderRadius: 8, border: "1px solid #cbd5e1", background: "#ffffff", color: "#334155", fontWeight: 700, cursor: "pointer" }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  const val = document.getElementById("doctypes-passcode-input")?.value?.trim();
                  if (val === window.__PIPELINE_PASSCODE) {
                    const cb = state.onSuccess;
                    window.__docTypesAuthModalState = null;
                    if (cb) cb();
                  } else {
                    state.error = "Incorrect Security Passcode. Access denied.";
                    window.__triggerPipelineReRender();
                  }
                }}
                style={{ padding: "8px 18px", borderRadius: 8, border: "none", background: "#7c3aed", color: "#ffffff", fontWeight: 800, cursor: "pointer" }}
              >
                Authorize Access
              </button>
            </div>
          </div>
        </div>
      );
    })()}

    {/* ============================================================
        SECURITY MODAL 1D: INDIVIDUAL DOCUMENT ACCESS GATE
    ============================================================ */}
    {window.__docItemAuthModalState?.open && (() => {
      const state = window.__docItemAuthModalState;
      const close = () => { window.__docItemAuthModalState = null; window.__triggerPipelineReRender(); };
      return (
        <div
          onClick={close}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.85)",
            zIndex: 14300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
            backdropFilter: "blur(6px)",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#ffffff",
              borderRadius: 16,
              width: "min(430px, 100%)",
              padding: 24,
              boxShadow: "0 25px 60px rgba(0,0,0,0.35)",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
              <span style={{ fontSize: 24 }}>🔒</span>
              <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: "#1e40af" }}>
                Document Verification Security Gate
              </h3>
            </div>
            <p style={{ fontSize: 13, color: "#475569", margin: "0 0 16px 0", lineHeight: 1.45 }}>
              Enter compliance authorization passcode to decrypt and view <strong>{state.docItem?.name || "this document"}</strong>.
            </p>
            <label style={{ fontSize: 12, fontWeight: 700, color: "#334155", display: "block", marginBottom: 6 }}>
              Compliance Passcode <span style={{ color: "#dc2626" }}>*</span>
            </label>
            <input
              type="password"
              id="docitem-passcode-input"
              placeholder="Enter authorization key..."
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  const val = document.getElementById("docitem-passcode-input")?.value;
                  state.onConfirm(val);
                }
              }}
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: 8,
                border: "1.5px solid #cbd5e1",
                fontSize: 14,
                boxSizing: "border-box",
                marginBottom: 10,
              }}
            />
            {state.error && (
              <div style={{ fontSize: 12, color: "#dc2626", fontWeight: 700, marginBottom: 12 }}>
                ⚠️ {state.error}
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 10 }}>
              <button
                type="button"
                onClick={close}
                style={{
                  padding: "8px 16px",
                  borderRadius: 8,
                  border: "1px solid #cbd5e1",
                  background: "#ffffff",
                  color: "#334155",
                  fontWeight: 700,
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={() => {
                  const val = document.getElementById("docitem-passcode-input")?.value;
                  state.onConfirm(val);
                }}
                style={{
                  padding: "8px 18px",
                  borderRadius: 8,
                  border: "none",
                  background: "#2563eb",
                  color: "#ffffff",
                  fontWeight: 800,
                  cursor: "pointer",
                }}
              >
                Unlock Document
              </button>
            </div>
          </div>
        </div>
      );
    })()}

    {/* ============================================================
        SECURITY MODAL 1E: STRICT ACTIONS PROHIBITED WARNING POPUP
    ============================================================ */}
    {window.__securityViolationModalState?.open && (() => {
      const state = window.__securityViolationModalState;
      const close = () => { window.__securityViolationModalState = null; window.__triggerPipelineReRender(); };
      return (
        <div
          onClick={close}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.94)",
            zIndex: 999999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
            touchAction: "none",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="security-alert-box"
            style={{
              background: "#ffffff",
              borderRadius: 22,
              width: "min(500px, 94vw)",
              maxHeight: "90vh",
              overflowY: "auto",
              padding: "24px 22px",
              boxShadow: "0 25px 60px rgba(220, 38, 38, 0.45)",
              border: "2.5px solid #ef4444",
              textAlign: "center",
              boxSizing: "border-box",
            }}
          >
            <div style={{ fontSize: 44, marginBottom: 8 }}>🚫</div>
            <h3 style={{ margin: "0 0 10px 0", fontSize: 19, fontWeight: 900, color: "#b91c1c", letterSpacing: "-0.02em" }}>
              The actions are strictly prohibited
            </h3>
            <p style={{ fontSize: 13, color: "#334155", margin: "0 0 12px 0", lineHeight: 1.5 }}>
              Downloading documents, capturing screenshots, printing, and executing screen recordings of sensitive verification records through mobile (iOS / iPhone / Android) or laptop/desktop devices are strictly prohibited by statutory compliance and security audit policies.
            </p>
            <div style={{ background: "#fee2e2", border: "1px solid #fecaca", padding: "10px 12px", borderRadius: 8, fontSize: 12, color: "#991b1b", marginBottom: 16, fontWeight: 700, wordBreak: "break-word" }}>
              ⚠️ Incident logged: <strong>{state.action || "Unauthorized Capture Attempt"}</strong> at {state.timestamp}
            </div>
            {!state.showOverrideGate ? (
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                <button
                  type="button"
                  onClick={close}
                  style={{
                    width: "100%",
                    padding: "12px 20px",
                    borderRadius: 12,
                    border: "none",
                    background: "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)",
                    color: "#ffffff",
                    fontWeight: 800,
                    fontSize: 13.5,
                    cursor: "pointer",
                    boxShadow: "0 4px 14px rgba(220, 38, 38, 0.35)",
                  }}
                >
                  I Acknowledge & Understand
                </button>
                <button
                  type="button"
                  onClick={() => {
                    state.showOverrideGate = true;
                    window.__triggerPipelineReRender();
                  }}
                  style={{
                    background: "transparent",
                    border: "1px dashed #cbd5e1",
                    color: "#475569",
                    padding: "8px 12px",
                    borderRadius: 8,
                    fontSize: 11.5,
                    fontWeight: 700,
                    cursor: "pointer",
                  }}
                >
                  🔐 Compliance Officer Override (Authenticate with Passcode)
                </button>
              </div>
            ) : (
              <div style={{ background: "#f8fafc", padding: 14, borderRadius: 12, border: "1px solid #cbd5e1", textAlign: "left", marginTop: 10 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 8 }}>
                  <span style={{ fontSize: 16 }}>🛡️</span>
                  <strong style={{ fontSize: 12.5, color: "#0f172a" }}>Screen Recording & Screenshot Authorization Gate</strong>
                </div>
                <p style={{ fontSize: 11.5, color: "#64748b", margin: "0 0 8px 0" }}>
                  Enter administrative compliance passcode to authorize and permit capture or screen recording for compliance audit records.
                </p>
                <input
                  type="password"
                  id="security-override-passcode-input"
                  placeholder="Enter compliance authorization passcode..."
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      const entered = document.getElementById("security-override-passcode-input")?.value?.trim();
                      if (entered === window.__PIPELINE_PASSCODE) {
                        window.__securityOverrideActiveUntil = Date.now() + 60000;
                        window.__logSensitiveDocAccess({
                          providerId: "AUTHORIZED_AUDITOR",
                          providerName: "Security Gate",
                          docName: state.action,
                          action: "AUTHORIZED_SCREEN_CAPTURE_OVERRIDE",
                        });
                        const cb = state.onAuthorizeCallback;
                        window.__securityViolationModalState = null;
                        if (typeof cb === "function") cb();
                        window.__triggerPipelineReRender();
                      } else {
                        state.overrideError = "Invalid Authorization Passcode. Access denied.";
                        window.__triggerPipelineReRender();
                      }
                    }
                  }}
                  style={{
                    width: "100%",
                    padding: "9px 12px",
                    borderRadius: 8,
                    border: "1.5px solid #cbd5e1",
                    fontSize: 13,
                    boxSizing: "border-box",
                    marginBottom: 8,
                  }}
                />
                {state.overrideError && (
                  <div style={{ fontSize: 11.5, color: "#dc2626", fontWeight: 700, marginBottom: 8 }}>
                    ⚠️ {state.overrideError}
                  </div>
                )}
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 4 }}>
                  <button
                    type="button"
                    onClick={() => {
                      state.showOverrideGate = false;
                      state.overrideError = null;
                      window.__triggerPipelineReRender();
                    }}
                    style={{ padding: "6px 12px", borderRadius: 6, border: "1px solid #cbd5e1", background: "#ffffff", color: "#334155", fontSize: 11, fontWeight: 700, cursor: "pointer" }}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      const entered = document.getElementById("security-override-passcode-input")?.value?.trim();
                      if (entered === window.__PIPELINE_PASSCODE) {
                        window.__securityOverrideActiveUntil = Date.now() + 60000;
                        window.__logSensitiveDocAccess({
                          providerId: "AUTHORIZED_AUDITOR",
                          providerName: "Security Gate",
                          docName: state.action,
                          action: "AUTHORIZED_SCREEN_CAPTURE_OVERRIDE",
                        });
                        const cb = state.onAuthorizeCallback;
                        window.__securityViolationModalState = null;
                        if (typeof cb === "function") cb();
                        window.__triggerPipelineReRender();
                      } else {
                        state.overrideError = "Invalid Authorization Passcode. Access denied.";
                        window.__triggerPipelineReRender();
                      }
                    }}
                    style={{ padding: "6px 16px", borderRadius: 6, border: "none", background: "#1e40af", color: "#ffffff", fontSize: 11.5, fontWeight: 800, cursor: "pointer" }}
                  >
                    Authorize Action
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    })()}

    {/* ============================================================
        SECURITY MODAL 2: ENCRYPTED STAGE GATE MODAL
    ============================================================ */}
    {window.__encryptedStageGateState?.open && (() => {
      const state = window.__encryptedStageGateState;
      const prov = state.provider;
      const close = () => { window.__encryptedStageGateState = null; window.__triggerPipelineReRender(); };
      return (
        <div
          onClick={close}
          style={{ position: "fixed", inset: 0, background: "rgba(15, 23, 42, 0.8)", zIndex: 14000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ background: "#ffffff", borderRadius: 14, width: "min(500px, 100%)", padding: 24, boxShadow: "0 25px 50px rgba(0,0,0,0.3)" }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
              <span style={{ fontSize: 24 }}>🛡️</span>
              <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: "#991b1b" }}>
                {state.title || "🔐 Encrypted Stage Transition Gate"}
              </h3>
            </div>
            <p style={{ fontSize: 13, color: "#475569", margin: "0 0 14px 0" }}>
              {state.description || `Moving ${window.__getProviderDisplayName(prov)} from ${state.fromStage} to ${state.toStage}.`}
            </p>
            <label style={{ fontSize: 12, fontWeight: 700, color: "#334155", display: "block", marginBottom: 4 }}>
              Mandatory Justification / Reason <span style={{ color: "#dc2626" }}>*</span>
            </label>
            <select
              id="gate-reason-select"
              style={{ width: "100%", padding: "8px 10px", borderRadius: 8, border: "1px solid #cbd5e1", fontSize: 13, marginBottom: 10 }}
            >
              <option value="All Documents Verified & Full Compliance Met">All Documents Verified & Full Compliance Met</option>
              <option value="Manual Identity & Right-to-Work Validation Approved">Manual Identity & Right-to-Work Validation Approved</option>
              <option value="VerificationDocuments Collection Validated">VerificationDocuments Collection Validated</option>
              <option value="Stage Reversal to Verification Completed">Stage Reversal to Verification Completed</option>
              <option value="Document Discrepancy Found / Re-verification">Document Discrepancy Found / Re-verification</option>
              <option value="Regulatory Re-investigation Required">Regulatory Re-investigation Required</option>
              <option value="Executive Compliance Override">Executive Compliance Override</option>
            </select>
            <textarea
              id="gate-reason-notes"
              placeholder="Enter detailed audit reasoning for moving between these stages..."
              rows={3}
              style={{ width: "100%", padding: "8px 10px", borderRadius: 8, border: "1px solid #cbd5e1", fontSize: 13, boxSizing: "border-box", marginBottom: 14 }}
            />
            <label style={{ fontSize: 12, fontWeight: 700, color: "#334155", display: "block", marginBottom: 4 }}>
              Authorization Passcode <span style={{ color: "#dc2626" }}>*</span>
            </label>
            <input
              type="password"
              id="gate-passcode-input"
              placeholder="Enter authorization passcode..."
              style={{ width: "100%", padding: "9px 12px", borderRadius: 8, border: "1.5px solid #cbd5e1", fontSize: 13, boxSizing: "border-box", marginBottom: 8 }}
            />
            {state.error && (
              <div style={{ fontSize: 12, color: "#dc2626", fontWeight: 700, marginBottom: 12 }}>
                ⚠️ {state.error}
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 12 }}>
              <button
                onClick={close}
                style={{ padding: "8px 16px", borderRadius: 8, border: "1px solid #cbd5e1", background: "#ffffff", color: "#334155", fontWeight: 700, cursor: "pointer" }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  const pass = document.getElementById("gate-passcode-input")?.value?.trim();
                  const sel = document.getElementById("gate-reason-select")?.value || "Transition Authorized";
                  const notes = document.getElementById("gate-reason-notes")?.value?.trim() || "";
                  if (pass !== window.__PIPELINE_PASSCODE) {
                    state.error = "Invalid Security Passcode. Access denied.";
                    window.__triggerPipelineReRender();
                    return;
                  }
                  const fullReason = `${sel}${notes ? ` — ${notes}` : ""}`;
                  if (typeof state.onConfirm === "function") {
                    state.onConfirm(fullReason);
                  }
                  close();
                }}
                style={{ padding: "8px 18px", borderRadius: 8, border: "none", background: "#16a34a", color: "#ffffff", fontWeight: 800, cursor: "pointer" }}
              >
                Authorize & Move
              </button>
            </div>
          </div>
        </div>
      );
    })()}

    {/* ============================================================
        SECURITY MODAL 3: CRITICAL TRANSITION CONFIRMATION MODAL
    ============================================================ */}
    {window.__criticalTransitionModalState?.open && (() => {
      const state = window.__criticalTransitionModalState;
      const prov = state.provider;
      const pId = state.providerId || window.__getProviderCanonId(prov);
      const displayName = window.__getProviderDisplayName(prov);
      const daysSigned = window.__getDaysSinceSignup(prov);
      const docCount = (prov?.documents || []).length;
      const fromStage = state.fromStage;
      const toStage = state.toStage;
      let headerBg = "linear-gradient(135deg, #d97706 0%, #b45309 100%)";
      let subtitle = `Moving directly from ${fromStage} to ${toStage}`;
      let alertMessage = "Direct approval bypasses standard intermediate checks. Mandatory justification required.";
      let confirmCheckboxLabel = `I confirm that I have reviewed all right-to-work and identity documents for ${displayName}.`;
      let presets = [
        "Fast-Track Regulatory Clearance",
        "Direct Executive Board Approval",
        "External Accredited Agency Pre-Verified",
        "Urgent Service Deployment Authorized",
      ];
      if (fromStage === "approved" && toStage === "pending") {
        headerBg = "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)";
        subtitle = "Reverting Approved provider back to Verification Pending";
        alertMessage = "You are demoting this provider card from Approved back to Verification Pending. This revokes their active verified status and resets their pipeline progress.";
        confirmCheckboxLabel = `I confirm that this provider's approval should be revoked and moved back to Verification Pending.`;
        presets = [
          "Document Revocation / Regulatory Flag",
          "Suspected Identity Discrepancy",
          "Provider Account Reset Request",
          "Routine System Compliance Re-audit",
        ];
      } else if (fromStage === "approved" && toStage === "started") {
        headerBg = "linear-gradient(135deg, #ea580c 0%, #c2410c 100%)";
        subtitle = "Reverting Approved provider back to Verification Started";
        alertMessage = "You are demoting this provider card from Approved back to Verification Started. This triggers a full re-verification cycle for their documents.";
        confirmCheckboxLabel = `I confirm that this provider's approval is being demoted to Verification Started for active re-verification.`;
        presets = [
          "Expired Document Re-submission Required",
          "Partial Compliance Discrepancy Found",
          "Right to Work Re-check Triggered",
          "Updated Visa / Passport Under Review",
        ];
      } else if (fromStage === "pending" && toStage === "approved") {
        headerBg = "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)";
        subtitle = "Moving directly from Verification Pending to Approved";
        alertMessage = "You are moving this provider directly from Verification Pending to Approved, skipping Verification Started, Under Review, and Verification Completed.";
        confirmCheckboxLabel = `I confirm that this provider meets all statutory verification requirements for immediate full approval.`;
        presets = [
          "Direct Executive Board Full Approval",
          "Prior Regulatory License Validated",
          "Emergency Provider Deployment Authorized",
          "Pre-cleared Corporate Compliance Partner",
        ];
      } else if (fromStage === "started" && toStage === "approved") {
        headerBg = "linear-gradient(135deg, #d97706 0%, #b45309 100%)";
        subtitle = "Bypassing Under Review & Verification Completed directly to Approved";
        alertMessage = "You are moving this provider directly from Verification Started to Approved, bypassing Under Review and Verification Completed stages.";
        confirmCheckboxLabel = `I confirm that all uploaded documents have been examined and meet verified standards.`;
        presets = [
          "Fast-Track Regulatory Clearance",
          "Urgent Service Deployment Authorized",
          "Full External Compliance Cert Validated",
          "Executive Board Direct Approval",
        ];
      }
      const close = () => {
        window.__criticalTransitionModalState = null;
        window.__triggerPipelineReRender();
      };
      return (
        <div
          onClick={close}
          className="no-screen-capture"
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.82)",
            zIndex: 14500,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
            backdropFilter: "blur(6px)",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#ffffff",
              borderRadius: 16,
              width: "min(560px, 100%)",
              overflow: "hidden",
              boxShadow: "0 25px 60px rgba(0,0,0,0.35)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Warning Banner Header */}
            <div
              style={{
                background: headerBg,
                padding: "16px 22px",
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 24 }}>⚠️</span>
                <div>
                  <h3 style={{ margin: 0, fontSize: 16, fontWeight: 800, color: "#ffffff" }}>
                    Do you really want to move provider card?
                  </h3>
                  <span style={{ fontSize: 11, color: "rgba(255,255,255,0.9)" }}>
                    {subtitle}
                  </span>
                </div>
              </div>
              <button
                onClick={close}
                style={{
                  background: "rgba(0,0,0,0.2)",
                  border: "none",
                  color: "#ffffff",
                  borderRadius: "50%",
                  width: 28,
                  height: 28,
                  cursor: "pointer",
                  fontWeight: 800,
                  fontSize: 14,
                }}
              >
                ✕
              </button>
            </div>
            {/* Provider Snapshot Header */}
            <div style={{ padding: "16px 22px", background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <img
                  src={window.__getProviderProfileImage(prov)}
                  alt=""
                  style={{ width: 44, height: 44, borderRadius: "50%", border: "2px solid #cbd5e1", objectFit: "cover" }}
                />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <strong style={{ fontSize: 14, color: "#0f172a" }}>{displayName}</strong>
                    <span style={{ fontSize: 10, background: "#ede9fe", color: "#6d28d9", padding: "1px 6px", borderRadius: 4, fontWeight: 700 }}>
                      UID: {prov?.uid || pId}
                    </span>
                  </div>
                  <div style={{ fontSize: 11, color: "#64748b", marginTop: 2, display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <span>Registered: <strong>{daysSigned}d ago</strong></span>
                    <span>•</span>
                    <span>Docs on File: <strong>{docCount}</strong></span>
                    <span>•</span>
                    <span>Stage: <strong style={{ color: "#2563eb" }}>{fromStage} ➔ {toStage}</strong></span>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 12, padding: "8px 12px", background: "#fef3c7", borderRadius: 8, border: "1px solid #fde68a" }}>
                <span style={{ fontSize: 13 }}>⚠️</span>
                <span style={{ fontSize: 11.5, color: "#92400e", lineHeight: 1.4 }}>
                  <strong>Stage Progression Alert:</strong> {alertMessage}
                </span>
              </div>
            </div>
            {/* Modal Body */}
            <div style={{ padding: "18px 22px", display: "flex", flexDirection: "column", gap: 14 }}>
              <div>
                <label style={{ fontSize: 12, fontWeight: 700, color: "#1e293b", display: "block", marginBottom: 6 }}>
                  Mandatory Justification / Reason <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 8 }}>
                  {presets.map((preset) => (
                    <button
                      key={preset}
                      type="button"
                      onClick={() => {
                        const el = document.getElementById("critical-transition-justification-input");
                        if (el) el.value = preset;
                      }}
                      style={{
                        padding: "3px 8px",
                        fontSize: 10.5,
                        borderRadius: 6,
                        border: "1px solid #cbd5e1",
                        background: "#f1f5f9",
                        color: "#334155",
                        cursor: "pointer",
                        fontWeight: 600,
                      }}
                    >
                      + {preset}
                    </button>
                  ))}
                </div>
                <textarea
                  id="critical-transition-justification-input"
                  rows={3}
                  placeholder={`Type detailed audit reason for moving this provider from ${fromStage} to ${toStage}...`}
                  style={{
                    width: "100%",
                    padding: 10,
                    borderRadius: 8,
                    border: "1.5px solid #cbd5e1",
                    fontSize: 12.5,
                    boxSizing: "border-box",
                    outline: "none",
                    fontFamily: "inherit",
                  }}
                />
              </div>
              <label style={{ display: "flex", alignItems: "flex-start", gap: 8, cursor: "pointer", fontSize: 12, color: "#334155" }}>
                <input
                  type="checkbox"
                  id="critical-transition-confirm-check"
                  defaultChecked={false}
                  style={{ marginTop: 2, cursor: "pointer" }}
                />
                <span>{confirmCheckboxLabel}</span>
              </label>
              <div>
                <label style={{ fontSize: 12, fontWeight: 700, color: "#1e293b", display: "block", marginBottom: 4 }}>
                  Authorization Passcode <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <input
                  type="password"
                  id="critical-transition-passcode-input"
                  placeholder="Enter authorization key..."
                  style={{
                    width: "100%",
                    padding: "9px 12px",
                    borderRadius: 8,
                    border: "1.5px solid #cbd5e1",
                    fontSize: 13,
                    boxSizing: "border-box",
                  }}
                />
              </div>
              {state.error && (
                <div style={{ fontSize: 12, color: "#dc2626", fontWeight: 700, background: "#fee2e2", padding: "8px 12px", borderRadius: 8, border: "1px solid #fecaca" }}>
                  ⚠️ {state.error}
                </div>
              )}
            </div>
            {/* Footer */}
            <div style={{ padding: "14px 22px", background: "#f8fafc", borderTop: "1px solid #e2e8f0", display: "flex", justifyContent: "flex-end", gap: 10 }}>
              <button
                type="button"
                onClick={close}
                style={{
                  padding: "8px 18px",
                  borderRadius: 8,
                  border: "1px solid #cbd5e1",
                  background: "#ffffff",
                  color: "#334155",
                  fontWeight: 700,
                  fontSize: 12,
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={() => {
                  const reason = document.getElementById("critical-transition-justification-input")?.value?.trim();
                  const isChecked = document.getElementById("critical-transition-confirm-check")?.checked;
                  const pass = document.getElementById("critical-transition-passcode-input")?.value?.trim();
                  if (!reason || reason.length < 5) {
                    state.error = "Please enter a valid justification reason (at least 5 characters).";
                    window.__triggerPipelineReRender();
                    return;
                  }
                  if (!isChecked) {
                    state.error = "You must confirm the compliance acknowledgment before proceeding.";
                    window.__triggerPipelineReRender();
                    return;
                  }
                  if (pass !== window.__PIPELINE_PASSCODE) {
                    state.error = "Incorrect Security Passcode. Access denied.";
                    window.__triggerPipelineReRender();
                    return;
                  }
                  const fullReasonText = `Critical Transition (${fromStage} ➔ ${toStage}): ${reason}`;
                  if (typeof state.onConfirm === "function") {
                    state.onConfirm(fullReasonText);
                  }
                  close();
                }}
                style={{
                  padding: "8px 20px",
                  borderRadius: 8,
                  border: "none",
                  background: toStage === "approved" ? "linear-gradient(135deg, #16a34a 0%, #15803d 100%)" : "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
                  color: "#ffffff",
                  fontWeight: 800,
                  fontSize: 12,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <span>✓</span>
                <span>Yes, Confirm & Move Card</span>
              </button>
            </div>
          </div>
        </div>
      );
    })()}

    {/* ============================================================
        SECTION POPUP MODAL WINDOW (OVERVIEW, ALL DOCS, DOC TYPES,
        ACTIVITY/AUDIT, NOTES, NOTES LOGS)
    ============================================================ */}
    {window.__activeSectionModal?.open && (() => {
      const modal = window.__activeSectionModal;
      const tab = modal.tab;
      /* REAL-TIME: always resolve the freshest provider record from the live registry */
      const baseModalRecord = modal.record;
      if (!baseModalRecord) return null;
      const liveModalRecord = window.__pipelineMasterRegistry?.get(window.__getProviderCanonId(baseModalRecord));
      const record = liveModalRecord || baseModalRecord;
      const pId = window.__getProviderCanonId(record);
      const displayName = window.__getProviderDisplayName(record);
      const docs = record.documents || [];
      const vMeta = record.verificationMeta || {};
      const notesList = window.__getMergedNotesLogs(record);
      const daysSigned = window.__getDaysSinceSignup(record);
      const isBlocked = window.__isProviderBlocked(record);
      const isApprovedProvider = window.__getStageCategory(record.approvalStage || record.status) === "approved";
      const eligibility = isBlocked ? "Ineligible (Expired Docs)" : isApprovedProvider ? "approved" : (record.eligibilityStatus || window.__computeEligibilityStatus(record));
      const selfieUrlModal = window.__getProviderSelfieUrl(record);
      const selfieCapturedModal = window.__isProviderSelfieCaptured(record);
      const uploadState = window.__docUploadState && window.__docUploadState.providerId === pId ? window.__docUploadState : null;
      const isUploadingNow = Boolean(uploadState && uploadState.uploading);
      const close = () => window.__closePipelineSectionModal();
      const tabItems = [
        { key: "overview", label: "Overview", icon: "📋" },
        { key: "documents", label: "All Docs", icon: "📄", count: docs.length },
        { key: "docTypes", label: "Doc Types", icon: "📑" },
        { key: "activity", label: "Activity / Audit", icon: "🕒" },
        { key: "notes", label: "Add Note", icon: "✏️" },
        { key: "notesLogs", label: "Notes Logs", icon: "📝", count: notesList.length },
      ];
      return (
        <div
          onClick={close}
          className="no-screen-capture"
          onContextMenu={(e) => {
            e.preventDefault();
            window.__showSecurityViolationAlert("Right-Click Action Prevented");
          }}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.78)",
            zIndex: 11000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px 16px",
            backdropFilter: "blur(8px)",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#ffffff",
              borderRadius: 20,
              width: "min(980px, 100%)",
              maxHeight: "88vh",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 25px 50px -12px rgba(15, 23, 42, 0.35), 0 0 0 1px rgba(255, 255, 255, 0.1)",
              overflow: "hidden",
              position: "relative",
            }}
          >
            {/* Security Banner */}
            <div
              style={{
                background: "linear-gradient(90deg, #991b1b 0%, #b91c1c 50%, #991b1b 100%)",
                color: "#fee2e2",
                padding: "6px 20px",
                fontSize: 10.5,
                fontWeight: 800,
                textAlign: "center",
                letterSpacing: "0.06em",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 6,
                textTransform: "uppercase",
              }}
            >
              <span>🔒</span>
              <span>Confidential Compliance Audit Data — Downloading, Screenshots & Screen Recording Prohibited</span>
            </div>

            {/* Modal Header */}
            <div
              style={{
                padding: "16px 24px",
                background: "#0f172a",
                color: "#ffffff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #1e293b",
                gap: 16,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                <div style={{ position: "relative" }}>
                  <img
                    src={window.__getProviderProfileImage(record)}
                    alt=""
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: "50%",
                      border: "2px solid #38bdf8",
                      objectFit: "cover",
                      boxShadow: "0 0 12px rgba(56, 189, 248, 0.25)",
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      bottom: 0,
                      right: 0,
                      width: 13,
                      height: 13,
                      borderRadius: "50%",
                      background: isBlocked ? "#ef4444" : "#10b981",
                      border: "2px solid #0f172a",
                    }}
                  />
                </div>
                <div>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                    <h3 style={{ margin: 0, fontWeight: 800, fontSize: 17, color: "#ffffff", letterSpacing: "-0.01em" }}>
                      {displayName}
                    </h3>
                    <span
                      style={{
                        background: "#1e293b",
                        color: "#38bdf8",
                        fontSize: 10,
                        fontWeight: 800,
                        padding: "2px 8px",
                        borderRadius: 6,
                        border: "1px solid rgba(56, 189, 248, 0.3)",
                      }}
                    >
                      ROLE: PROVIDER
                    </span>
                    {record.username && (
                      <span
                        style={{
                          background: "rgba(167, 139, 250, 0.2)",
                          color: "#c4b5fd",
                          fontSize: 10.5,
                          fontWeight: 800,
                          padding: "2px 8px",
                          borderRadius: 6,
                          border: "1px solid rgba(167, 139, 250, 0.4)",
                        }}
                      >
                        @{record.username}
                      </span>
                    )}
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 4, flexWrap: "wrap", fontSize: 11, color: "#94a3b8" }}>
                    <span style={{ color: "#7dd3fc", fontWeight: 700 }}>UID: {record.uid || pId}</span>
                    <span>•</span>
                    <span>Share Code: <strong style={{ color: "#cbd5e1" }}>{window.__getProviderShareCode(record)}</strong></span>
                    <span>•</span>
                    <span style={{ background: "rgba(255,255,255,0.06)", padding: "1px 6px", borderRadius: 4 }}>
                      Registered {daysSigned} day(s) ago
                    </span>
                  </div>
                </div>
              </div>
              <button
                onClick={close}
                style={{
                  border: "1px solid #334155",
                  background: "#1e293b",
                  color: "#e2e8f0",
                  borderRadius: 10,
                  padding: "7px 14px",
                  fontWeight: 700,
                  fontSize: 12,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <span>✕</span>
                <span>Close</span>
              </button>
            </div>

            {/* High-Contrast Tab Bar */}
            <div
              style={{
                display: "flex",
                padding: "10px 18px",
                gap: 8,
                background: "#0b1329",
                borderBottom: "1px solid #1e293b",
                overflowX: "auto",
                scrollbarWidth: "none",
              }}
            >
              {tabItems.map((item) => {
                const isActive = tab === item.key;
                return (
                  <button
                    key={item.key}
                    type="button"
                    onClick={() => window.__openPipelineSectionModal(item.key, record)}
                    style={{
                      padding: "8px 15px",
                      borderRadius: 9,
                      border: isActive ? "1px solid #38bdf8" : "1px solid transparent",
                      background: isActive ? "linear-gradient(135deg, #1e40af 0%, #2563eb 100%)" : "rgba(30, 41, 59, 0.7)",
                      color: isActive ? "#ffffff" : "#94a3b8",
                      fontWeight: 800,
                      fontSize: 12,
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                      display: "flex",
                      alignItems: "center",
                      gap: 7,
                    }}
                  >
                    <span>{item.icon}</span>
                    <span>{item.label}</span>
                    {typeof item.count === "number" && (
                      <span
                        style={{
                          fontSize: 9.5,
                          fontWeight: 800,
                          padding: "1px 6px",
                          borderRadius: 8,
                          background: isActive ? "rgba(255, 255, 255, 0.22)" : "#334155",
                          color: isActive ? "#ffffff" : "#cbd5e1",
                        }}
                      >
                        {item.count}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>

            {/* Modal Body */}
            <div style={{ flex: 1, overflowY: "auto", padding: 22, background: "#f8fafc" }}>
              {/* TAB 1: OVERVIEW */}
              {tab === "overview" && (
                <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                  {/* Selfie Banner (click image to open zoom preview) */}
                  <div
                    style={{
                      background: "#ffffff",
                      borderRadius: 14,
                      border: "1px solid #e2e8f0",
                      padding: 18,
                      display: "flex",
                      alignItems: "center",
                      gap: 18,
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      className={selfieUrlModal ? "selfie-zoom-trigger" : undefined}
                      title={selfieUrlModal ? "Click to zoom" : undefined}
                      onClick={() => {
                        if (selfieUrlModal) window.__openSelfiePreview(selfieUrlModal, `${displayName} — Selfie Verification`);
                      }}
                      style={{ width: 110, height: 110, borderRadius: 14, overflow: "hidden", background: "#f1f5f9", flexShrink: 0, border: "1.5px solid #e2e8f0", position: "relative" }}
                    >
                      {selfieUrlModal ? (
                        <img
                          src={selfieUrlModal}
                          alt="Selfie verification"
                          onContextMenu={(e) => e.preventDefault()}
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                      ) : (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", fontSize: 30, color: "#94a3b8" }}>🤳</div>
                      )}
                      {selfieUrlModal && (
                        <span
                          style={{
                            position: "absolute",
                            bottom: 4,
                            right: 4,
                            fontSize: 10,
                            fontWeight: 800,
                            padding: "2px 6px",
                            borderRadius: 6,
                            background: "rgba(15, 23, 42, 0.78)",
                            color: "#ffffff",
                            pointerEvents: "none",
                          }}
                        >
                          🔍 Zoom
                        </span>
                      )}
                    </div>
                    <div style={{ flex: 1, minWidth: 200 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                        <span style={{ fontSize: 18 }}>🤳</span>
                        <strong style={{ fontSize: 14, color: "#0f172a" }}>Selfie Verification</strong>
                      </div>
                      <div style={{ fontSize: 12, color: "#64748b", marginBottom: 10, lineHeight: 1.5 }}>
                        Sourced live from the <strong>VerificationDocuments</strong> collection (<code>selfieCaptured</code>, <code>selfieUrl</code>).
                      </div>
                      <span
                        style={{
                          fontSize: 12,
                          fontWeight: 800,
                          padding: "3px 10px",
                          borderRadius: 6,
                          background: selfieCapturedModal ? "#dcfce7" : "#fee2e2",
                          color: selfieCapturedModal ? "#15803d" : "#991b1b",
                          border: `1px solid ${selfieCapturedModal ? "#bbf7d0" : "#fecaca"}`,
                        }}
                      >
                        {selfieCapturedModal ? "✓ Selfie Captured" : "✕ Not Captured"}
                      </span>
                      {selfieUrlModal && (
                        <div style={{ fontSize: 11, color: "#2563eb", fontWeight: 700, marginTop: 8 }}>
                          🔍 Click the photo to open a large zoomable preview
                        </div>
                      )}
                    </div>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(380px, 1fr))", gap: 16 }}>
                    <div style={{ background: "#ffffff", padding: 20, borderRadius: 14, border: "1px solid #e2e8f0" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14, borderBottom: "1px solid #f1f5f9", paddingBottom: 10 }}>
                        <span style={{ fontSize: 18 }}>👤</span>
                        <h4 style={{ margin: 0, color: "#0f172a", fontSize: 14, fontWeight: 800 }}>Provider Identity Profile</h4>
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 12.5, paddingBottom: 6, borderBottom: "1px dashed #e2e8f0" }}>
                          <span style={{ color: "#64748b", fontWeight: 600 }}>Profile Image:</span>
                          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <img
                              src={window.__getProviderProfileImage(record)}
                              alt="Profile"
                              style={{ width: 36, height: 36, borderRadius: "50%", objectFit: "cover", border: "1.5px solid #cbd5e1" }}
                            />
                            <span style={{ fontSize: 11, color: (record.profileImage || record.photoURL) ? "#059669" : "#64748b", fontWeight: 700 }}>
                              {(record.profileImage || record.photoURL) ? "Image on file" : "Default Avatar"}
                            </span>
                          </div>
                        </div>
                        {[
                          { label: "UID", value: record.uid || pId, highlight: true },
                          { label: "Username", value: record.username ? `@${record.username}` : "—", badge: Boolean(record.username), badgeBg: "#ede9fe", badgeClr: "#6d28d9" },
                          { label: "Full Name", value: record.fullName || record.name || displayName || "—", highlight: true },
                          { label: "Email Address", value: record.email || record.providerEmailAddress || "—" },
                          { label: "Phone Number", value: record.phoneNumber || record.providerContactNumber || record.phone || "—" },
                          { label: "Role", value: "provider", badge: true, badgeBg: "#ede9fe", badgeClr: "#6d28d9" },
                          { label: "Days Signed Up", value: `${daysSigned} day(s)`, badge: true, badgeBg: "#ecfdf5", badgeClr: "#047857" },
                          { label: "Service Category", value: record.serviceCategory || "General Services" },
                          { label: "Location", value: window.__formatServiceLocation(record.serviceLocation) },
                        ].map((field, fIdx) => (
                          <div key={fIdx} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 12.5 }}>
                            <span style={{ color: "#64748b", fontWeight: 600 }}>{field.label}:</span>
                            {field.badge ? (
                              <span style={{ fontWeight: 800, fontSize: 11, background: field.badgeBg, color: field.badgeClr, padding: "2px 8px", borderRadius: 6 }}>
                                {field.value}
                              </span>
                            ) : field.highlight ? (
                              <strong style={{ color: "#1e40af", fontFamily: field.label === "UID" ? "monospace" : "inherit", fontSize: 12 }}>{field.value}</strong>
                            ) : (
                              <strong style={{ color: "#1e293b", textAlign: "right" }}>{field.value}</strong>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div style={{ background: "#ffffff", padding: 20, borderRadius: 14, border: "1px solid #e2e8f0" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14, borderBottom: "1px solid #f1f5f9", paddingBottom: 10 }}>
                        <span style={{ fontSize: 18 }}>🛡️</span>
                        <h4 style={{ margin: 0, color: "#0f172a", fontSize: 14, fontWeight: 800 }}>Verification & Eligibility Status</h4>
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                        {[
                          { label: "Eligibility Status", value: eligibility, badge: true, badgeBg: isBlocked ? "#fee2e2" : isApprovedProvider ? "#bbf7d0" : "#dcfce7", badgeClr: isBlocked ? "#991b1b" : isApprovedProvider ? "#166534" : "#15803d" },
                          { label: "Selfie Captured", value: selfieCapturedModal ? "Yes" : "No", badge: true, badgeBg: selfieCapturedModal ? "#dcfce7" : "#fee2e2", badgeClr: selfieCapturedModal ? "#15803d" : "#991b1b" },
                          { label: "Approved By", value: record.approvedBy || "Not Yet Approved", badge: Boolean(record.approvedBy), badgeBg: "#dcfce7", badgeClr: "#15803d" },
                          { label: "Approval Timestamp", value: window.__formatCleanDate(record.approvedAt, "—") },
                          { label: "Approved Date", value: window.__formatCleanDate(record.approvedAt, "—") },
                          { label: "Visa Type", value: record.visaType || vMeta.visaType || "Standard" },
                          { label: "British / Irish Citizen", value: vMeta.isBritishOrIrish ? "Yes" : "No" },
                          { label: "Student Status", value: vMeta.isStudent ? "Yes" : "No" },
                          { label: "Passport Valid Until", value: window.__formatCleanDate(vMeta.passportValidUntil, "—") },
                          { label: "Visa Valid Until", value: window.__formatCleanDate(vMeta.visaValidUntil, "—") },
                          { label: "Documents On File", value: `${docs.length} uploaded`, badge: true, badgeBg: "#eff6ff", badgeClr: "#1d4ed8" },
                        ].map((field, fIdx) => (
                          <div key={fIdx} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 12.5 }}>
                            <span style={{ color: "#64748b", fontWeight: 600 }}>{field.label}:</span>
                            {field.badge ? (
                              <span style={{ fontWeight: 800, fontSize: 11, background: field.badgeBg, color: field.badgeClr, padding: "2px 8px", borderRadius: 6 }}>
                                {field.value}
                              </span>
                            ) : (
                              <strong style={{ color: "#1e293b", textAlign: "right" }}>{field.value}</strong>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* TAB 2: ALL DOCUMENTS (UPLOAD → FIRESTORE VerificationDocuments, LIVE LIST) */}
              {tab === "documents" && (
                <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                  {/* Document Uploader Card */}
                  <div
                    style={{
                      background: "#ffffff",
                      borderRadius: 14,
                      border: "1.5px dashed #3b82f6",
                      padding: 16,
                      display: "flex",
                      flexDirection: "column",
                      gap: 12,
                      boxShadow: "0 2px 6px rgba(59, 130, 246, 0.06)",
                    }}
                  >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{ fontSize: 20 }}>📤</span>
                        <div>
                          <strong style={{ fontSize: 13.5, color: "#0f172a" }}>Upload Verification Document</strong>
                          <div style={{ fontSize: 11, color: "#64748b" }}>
                            Upload PDF, JPG, PNG, or Scans — saved to this provider's record in the VerificationDocuments collection and synced live to the provider card.
                          </div>
                        </div>
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <select
                          id="document-upload-category-select"
                          disabled={isUploadingNow}
                          style={{
                            padding: "6px 10px",
                            borderRadius: 8,
                            border: "1px solid #cbd5e1",
                            fontSize: 12,
                            background: "#f8fafc",
                            fontWeight: 600,
                            color: "#334155",
                          }}
                        >
                          <option value="Passport Record">Passport Record</option>
                          <option value="Visa / BRP Document">Visa / BRP Document</option>
                          <option value="Student Share Code">Student Share Code</option>
                          <option value="Right to Work Verification">Right to Work Verification</option>
                          <option value="Accreditation Certificate">Accreditation Certificate</option>
                          <option value="General Identification">General Identification</option>
                        </select>
                        <label
                          htmlFor="direct-doc-upload-input"
                          style={{
                            padding: "7px 16px",
                            borderRadius: 8,
                            background: isUploadingNow ? "#94a3b8" : "#2563eb",
                            color: "#ffffff",
                            fontWeight: 800,
                            fontSize: 12,
                            cursor: isUploadingNow ? "not-allowed" : "pointer",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 6,
                            opacity: isUploadingNow ? 0.8 : 1,
                          }}
                        >
                          {isUploadingNow ? (
                            <>
                              <span className="pipeline-spin-icon">⟳</span>
                              <span>Uploading...</span>
                            </>
                          ) : (
                            <span>📁 Select & Upload</span>
                          )}
                        </label>
                        <input
                          type="file"
                          id="direct-doc-upload-input"
                          accept="image/*,application/pdf"
                          disabled={isUploadingNow}
                          style={{ display: "none" }}
                          onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (file) {
                              const selCat = document.getElementById("document-upload-category-select")?.value || "General Identification";
                              window.__handleDocumentFileUpload(file, record, selCat);
                              e.target.value = "";
                            }
                          }}
                        />
                      </div>
                    </div>
                    {uploadState && uploadState.uploading && (
                      <div style={{ fontSize: 12, color: "#1d4ed8", background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: "8px 12px", fontWeight: 700 }}>
                        ⏳ Uploading <strong>{uploadState.fileName}</strong> and saving to Firebase...
                      </div>
                    )}
                    {uploadState && uploadState.success && (
                      <div style={{ fontSize: 12, color: "#166534", background: "#dcfce7", border: "1px solid #bbf7d0", borderRadius: 8, padding: "8px 12px", fontWeight: 700 }}>
                        ✓ <strong>{uploadState.fileName}</strong> saved to VerificationDocuments and synced to the provider card.
                      </div>
                    )}
                    {uploadState && uploadState.error && (
                      <div style={{ fontSize: 12, color: "#991b1b", background: "#fee2e2", border: "1px solid #fecaca", borderRadius: 8, padding: "8px 12px", fontWeight: 700 }}>
                        ⚠️ Upload failed: {uploadState.error}
                      </div>
                    )}
                  </div>

                  {/* Anti-Capture Banner */}
                  <div
                    style={{
                      background: "#fef2f2",
                      border: "1.5px solid #fecaca",
                      borderRadius: 12,
                      padding: "12px 18px",
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                    }}
                  >
                    <span style={{ fontSize: 24 }}>🛡️</span>
                    <div style={{ fontSize: 12, color: "#991b1b", lineHeight: 1.45 }}>
                      <strong>Active Protection Protocol:</strong> Downloading, printing, screenshots, and screen recordings across mobile and laptop devices are strictly prohibited. Passcode verification required to open full protected preview.
                    </div>
                  </div>

                  {/* Documents List */}
                  {docs.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "50px 20px", background: "#ffffff", borderRadius: 14, border: "1.5px dashed #cbd5e1", color: "#64748b" }}>
                      <div style={{ fontSize: 36, marginBottom: 8 }}>📁</div>
                      <strong style={{ fontSize: 14, color: "#334155", display: "block" }}>No documents found</strong>
                      <span style={{ fontSize: 12, color: "#94a3b8" }}>Use the upload card above — documents appear here live from Firestore.</span>
                    </div>
                  ) : (
                    docs.map((docItem, idx) => {
                      const isExp = window.__isDocumentExpired(docItem);
                      const docUrl = window.__getDocumentFileUrl(docItem);
                      const thumbKey = `${pId}__${docItem.id || idx}`;
                      const thumbFailed = Boolean(window.__docThumbFailedMap[thumbKey]);
                      const showThumbImg = docUrl && window.__looksLikeImageDocUrl(docUrl) && !thumbFailed;
                      return (
                        <div
                          key={docItem.id || idx}
                          style={{
                            background: "#ffffff",
                            border: isExp ? "1.5px solid #fecaca" : "1px solid #e2e8f0",
                            borderRadius: 12,
                            padding: "14px 18px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
                            gap: 12,
                            flexWrap: "wrap",
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
                            <div
                              style={{
                                width: 52,
                                height: 52,
                                borderRadius: 10,
                                background: isExp ? "#fee2e2" : "#eff6ff",
                                color: isExp ? "#dc2626" : "#2563eb",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: 20,
                                flexShrink: 0,
                                overflow: "hidden",
                                border: "1px solid #e2e8f0",
                                position: "relative",
                              }}
                            >
                              {showThumbImg ? (
                                <img
                                  src={docUrl}
                                  alt={docItem.name || "Document thumbnail"}
                                  draggable={false}
                                  onContextMenu={(e) => e.preventDefault()}
                                  onError={() => {
                                    window.__docThumbFailedMap[thumbKey] = true;
                                    window.__triggerPipelineReRender();
                                  }}
                                  style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                                />
                              ) : (
                                <span>📄</span>
                              )}
                            </div>
                            <div style={{ minWidth: 0 }}>
                              <div style={{ fontWeight: 800, fontSize: 13.5, color: "#0f172a", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                {docItem.name || "Document File"}
                              </div>
                              <div style={{ fontSize: 11, color: "#64748b", marginTop: 2, display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                                <span>Type: <strong style={{ color: "#334155" }}>{docItem.docType || "General"}</strong></span>
                                <span>•</span>
                                <span>Uploaded: {docItem.uploadedAt || "Recently"}</span>
                                {docItem.isLocalUpload && (
                                  <span style={{ background: "#ede9fe", color: "#6d28d9", fontWeight: 800, fontSize: 9.5, padding: "1px 6px", borderRadius: 4 }}>
                                    LOCAL UPLOAD
                                  </span>
                                )}
                                {isExp && (
                                  <span style={{ background: "#fee2e2", color: "#b91c1c", fontWeight: 800, fontSize: 9.5, padding: "1px 6px", borderRadius: 4 }}>
                                    EXPIRED
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          {/* Authentication Gate to access preview */}
                          <button
                            type="button"
                            onClick={() => {
                              window.__promptDocAccessPasscode({
                                docItem,
                                url: docUrl,
                                providerRecord: record,
                                categoryTitle: docItem.docType || "All Documents",
                              });
                            }}
                            style={{
                              padding: "7px 16px",
                              borderRadius: 8,
                              border: "1px solid #2563eb",
                              background: "#eff6ff",
                              color: "#2563eb",
                              fontSize: 12,
                              fontWeight: 700,
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              flexShrink: 0,
                            }}
                          >
                            <span>🔒</span>
                            <span>Preview (Protected)</span>
                          </button>
                        </div>
                      );
                    })
                  )}
                </div>
              )}

              {/* TAB 3: CATEGORIZED DOC TYPES */}
              {tab === "docTypes" && (
                <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                  {[
                    { key: "passport", title: "Passport Records", icon: "🛂", docs: docs.filter((d) => /passport/i.test(d.docType || d.name)) },
                    { key: "visa", title: "Visa, BRP & Residence Permits", icon: "✈️", docs: docs.filter((d) => /visa|brp|permit|residence/i.test(d.docType || d.name)) },
                    { key: "student", title: "Student & Share Code Records", icon: "🎓", docs: docs.filter((d) => /student|share_code/i.test(d.docType || d.name)) },
                    { key: "other", title: "Other Certifications & Licenses", icon: "📁", docs: docs.filter((d) => !/passport|visa|brp|permit|residence|student|share_code/i.test(d.docType || d.name)) },
                  ].map((cat) => (
                    <div
                      key={cat.key}
                      style={{
                        background: "#ffffff",
                        borderRadius: 12,
                        border: "1px solid #e2e8f0",
                        padding: 16,
                      }}
                    >
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, borderBottom: "1px solid #f1f5f9", paddingBottom: 8 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <span style={{ fontSize: 16 }}>{cat.icon}</span>
                          <strong style={{ fontSize: 13, color: "#0f172a" }}>{cat.title}</strong>
                        </div>
                        <span style={{ fontSize: 10.5, background: "#0f172a", color: "#ffffff", padding: "2px 8px", borderRadius: 10, fontWeight: 700 }}>
                          {cat.docs.length} on file
                        </span>
                      </div>
                      {cat.docs.length === 0 ? (
                        <div style={{ fontSize: 12, color: "#94a3b8", fontStyle: "italic", padding: "6px 0" }}>
                          No documents submitted under this category.
                        </div>
                      ) : (
                        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                          {cat.docs.map((d, dIdx) => {
                            const dUrl = window.__getDocumentFileUrl(d);
                            const dThumbKey = `${pId}__${cat.key}__${d.id || dIdx}`;
                            const dThumbFailed = Boolean(window.__docThumbFailedMap[dThumbKey]);
                            const showDThumbImg = dUrl && window.__looksLikeImageDocUrl(dUrl) && !dThumbFailed;
                            return (
                              <div
                                key={d.id || dIdx}
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "8px 10px",
                                  background: "#f8fafc",
                                  borderRadius: 8,
                                  border: "1px solid #f1f5f9",
                                  gap: 10,
                                }}
                              >
                                <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
                                  <div
                                    style={{
                                      width: 34,
                                      height: 34,
                                      borderRadius: 7,
                                      overflow: "hidden",
                                      background: "#eff6ff",
                                      border: "1px solid #e2e8f0",
                                      flexShrink: 0,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {showDThumbImg ? (
                                      <img
                                        src={dUrl}
                                        alt={d.name || "Document thumbnail"}
                                        draggable={false}
                                        onContextMenu={(e) => e.preventDefault()}
                                        onError={() => {
                                          window.__docThumbFailedMap[dThumbKey] = true;
                                          window.__triggerPipelineReRender();
                                        }}
                                        style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                                      />
                                    ) : (
                                      <span style={{ fontSize: 14 }}>📄</span>
                                    )}
                                  </div>
                                  <span style={{ fontSize: 12, fontWeight: 600, color: "#334155", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{d.name}</span>
                                </div>
                                <button
                                  type="button"
                                  onClick={() => {
                                    window.__promptDocAccessPasscode({
                                      docItem: d,
                                      url: dUrl,
                                      providerRecord: record,
                                      categoryTitle: cat.title,
                                    });
                                  }}
                                  style={{
                                    padding: "4px 12px",
                                    borderRadius: 6,
                                    border: "1px solid #2563eb",
                                    background: "#ffffff",
                                    color: "#2563eb",
                                    fontSize: 11,
                                    fontWeight: 700,
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 4,
                                    flexShrink: 0,
                                  }}
                                >
                                  <span>🔒</span>
                                  <span>View 👁</span>
                                </button>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {/* TAB 4: ACTIVITY / AUDIT */}
              {tab === "activity" && (
                <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                  {/* Sensitive Access Register */}
                  <div
                    style={{
                      background: "#ffffff",
                      borderRadius: 12,
                      border: "1px solid #cbd5e1",
                      padding: 16,
                      boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                    }}
                  >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12, borderBottom: "1px solid #f1f5f9", paddingBottom: 8 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{ fontSize: 16 }}>👁️</span>
                        <strong style={{ fontSize: 13, color: "#0f172a" }}>Sensitive Data Access & Audit Logs</strong>
                      </div>
                      <span style={{ fontSize: 10, background: "#fee2e2", color: "#b91c1c", padding: "2px 8px", borderRadius: 6, fontWeight: 800 }}>
                        Audit Monitored
                      </span>
                    </div>
                    {(() => {
                      const docAccessLogs = window.__getSensitiveDocAccessLogs(pId);
                      if (docAccessLogs.length === 0) {
                        return (
                          <div style={{ fontSize: 12, color: "#94a3b8", fontStyle: "italic", padding: "8px 0" }}>
                            No sensitive document access records logged for this provider yet.
                          </div>
                        );
                      }
                      return (
                        <div style={{ display: "flex", flexDirection: "column", gap: 8, maxHeight: 200, overflowY: "auto" }}>
                          {docAccessLogs.map((item, idx) => (
                            <div
                              key={item.id || idx}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                background: "#f8fafc",
                                border: "1px solid #e2e8f0",
                                padding: "8px 12px",
                                borderRadius: 8,
                                fontSize: 11.5,
                              }}
                            >
                              <div>
                                <strong style={{ color: "#0f172a" }}>{item.accessedBy}</strong>
                                <span style={{ color: "#64748b", margin: "0 6px" }}>accessed</span>
                                <span style={{ color: "#2563eb", fontWeight: 700 }}>{item.targetResource}</span>
                              </div>
                              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                <span style={{ background: "#e0e7ff", color: "#3730a3", padding: "1px 6px", borderRadius: 4, fontWeight: 800, fontSize: 10 }}>
                                  Count: {item.accessCount}x
                                </span>
                                <span style={{ color: "#64748b" }}>{item.formattedTime}</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      );
                    })()}
                  </div>
                  {/* Stage History & Approval Logs */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "12px 16px",
                      background: "#0f172a",
                      borderRadius: 12,
                      color: "#f8fafc",
                      border: "1px solid #1e293b",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <span style={{ fontSize: 16 }}>📜</span>
                      <strong style={{ fontSize: 12.5, letterSpacing: "-0.01em" }}>
                        Stage History, Transition Logs & Approver Record
                      </strong>
                    </div>
                    <span
                      style={{
                        fontSize: 10,
                        fontWeight: 800,
                        background: "#1e293b",
                        color: "#38bdf8",
                        padding: "2px 8px",
                        borderRadius: 6,
                        border: "1px solid #334155",
                      }}
                    >
                      🔒 Verified Logs
                    </span>
                  </div>
                  {(() => {
                    const logs = window.__getProviderAuditLogs(pId);
                    if (!logs || logs.length === 0) {
                      return (
                        <div
                          style={{
                            textAlign: "center",
                            padding: "48px 20px",
                            background: "#ffffff",
                            borderRadius: 12,
                            border: "1.5px dashed #cbd5e1",
                            color: "#64748b",
                          }}
                        >
                          <div style={{ fontSize: 32, marginBottom: 8 }}>📋</div>
                          <strong style={{ fontSize: 13, color: "#334155", display: "block" }}>
                            No activity or audit logs recorded yet
                          </strong>
                          <span style={{ fontSize: 11, color: "#94a3b8" }}>
                            All protected stage transitions, approvals, rejections, and notes will be tracked here in real-time.
                          </span>
                        </div>
                      );
                    }
                    return (
                      <div
                        style={{
                          position: "relative",
                          paddingLeft: 18,
                          marginLeft: 8,
                          borderLeft: "2px solid #e2e8f0",
                          display: "flex",
                          flexDirection: "column",
                          gap: 14,
                        }}
                      >
                        {logs.map((l, lIdx) => {
                          const action = String(l?.action || "audit_record").toLowerCase();
                          const reason = l?.reason || l?.note || "";
                          const movedBy = l?.movedBy || l?.author || "Admin Authority";
                          const timeText = l?.formattedTime || window.__formatCleanDate(l?.timestamp, "Recorded");
                          let theme = {
                            label: "STAGE CHANGE",
                            color: "#2563eb",
                            bg: "#dbeafe",
                            border: "#bfdbfe",
                            icon: "⚡",
                            dotBg: "#2563eb",
                          };
                          if (action.includes("approve")) {
                            theme = {
                              label: "STAGE APPROVED",
                              color: "#16a34a",
                              bg: "#dcfce7",
                              border: "#bbf7d0",
                              icon: "✓",
                              dotBg: "#16a34a",
                            };
                          } else if (action.includes("reject")) {
                            theme = {
                              label: "STAGE REJECTED",
                              color: "#dc2626",
                              bg: "#fee2e2",
                              border: "#fecaca",
                              icon: "✕",
                              dotBg: "#dc2626",
                            };
                          } else if (action.includes("note")) {
                            theme = {
                              label: "AUDIT NOTE ADDED",
                              color: "#7c3aed",
                              bg: "#ede9fe",
                              border: "#ddd6fe",
                              icon: "📝",
                              dotBg: "#7c3aed",
                            };
                          }
                          return (
                            <div
                              key={l?.id || `audit_${lIdx}`}
                              style={{
                                position: "relative",
                                background: "#ffffff",
                                borderRadius: 10,
                                border: "1px solid #e2e8f0",
                                padding: "12px 16px",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  left: -26,
                                  top: 14,
                                  width: 14,
                                  height: 14,
                                  borderRadius: "50%",
                                  background: "#ffffff",
                                  border: `3px solid ${theme.dotBg}`,
                                  boxShadow: "0 0 0 2px #ffffff",
                                }}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginBottom: 8,
                                  flexWrap: "wrap",
                                  gap: 6,
                                }}
                              >
                                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                  <span
                                    style={{
                                      fontSize: 10,
                                      fontWeight: 800,
                                      background: theme.bg,
                                      color: theme.color,
                                      border: `1px solid ${theme.border}`,
                                      padding: "2px 8px",
                                      borderRadius: 6,
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: 4,
                                    }}
                                  >
                                    <span>{theme.icon}</span>
                                    <span>{theme.label}</span>
                                  </span>
                                  {l?.fromStage && l?.toStage && l.fromStage !== "—" && (
                                    <div style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 11, fontWeight: 700, color: "#475569" }}>
                                      <span style={{ background: "#f1f5f9", padding: "1px 6px", borderRadius: 4, color: "#334155" }}>
                                        {String(l.fromStage).replace(/_/g, " ")}
                                      </span>
                                      <span style={{ color: "#94a3b8" }}>➔</span>
                                      <span style={{ background: "#f1f5f9", padding: "1px 6px", borderRadius: 4, color: "#0f172a" }}>
                                        {String(l.toStage).replace(/_/g, " ")}
                                      </span>
                                    </div>
                                  )}
                                </div>
                                <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600, display: "flex", alignItems: "center", gap: 4 }}>
                                  <span>🕒</span>
                                  <span>{timeText}</span>
                                </div>
                              </div>
                              {reason && (
                                <div
                                  style={{
                                    background: "#f8fafc",
                                    borderLeft: `3px solid ${theme.color}`,
                                    borderRadius: "0 6px 6px 0",
                                    padding: "8px 12px",
                                    fontSize: 12,
                                    color: "#1e293b",
                                    lineHeight: 1.45,
                                    marginBottom: 8,
                                    fontStyle: action.includes("note") ? "italic" : "normal",
                                  }}
                                >
                                  <strong>Reason / Justification: </strong>
                                  <span>{reason}</span>
                                </div>
                              )}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  fontSize: 11,
                                  color: "#64748b",
                                  borderTop: "1px solid #f1f5f9",
                                  paddingTop: 6,
                                  marginTop: 4,
                                  flexWrap: "wrap",
                                  gap: 6,
                                }}
                              >
                                <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                  <span>👤 Action by:</span>
                                  <strong style={{ color: "#334155" }}>{movedBy}</strong>
                                </div>
                                {l?.approvedBy && (
                                  <div style={{ display: "flex", alignItems: "center", gap: 4, color: "#16a34a" }}>
                                    <span>✓ Approved by: <strong>{l.approvedBy}</strong> ({window.__formatCleanDate(l.approvedAt, timeText)})</span>
                                  </div>
                                )}
                                <span style={{ fontSize: 10, color: "#94a3b8", fontFamily: "monospace" }}>
                                  ID: {String(l?.id || "").slice(-8)}
                                </span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })()}
                </div>
              )}

              {/* TAB 5: ADD NOTE */}
              {tab === "notes" && (
                <div style={{ background: "#ffffff", borderRadius: 14, border: "1px solid #e2e8f0", padding: 20 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
                    <span style={{ fontSize: 18 }}>✏️</span>
                    <div>
                      <strong style={{ fontSize: 13.5, color: "#0f172a" }}>Log Provider Verification Note</strong>
                      <div style={{ fontSize: 11, color: "#64748b" }}>
                        Enter compliance observations, verification calls, or status explanations to save permanently.
                      </div>
                    </div>
                  </div>
                  <textarea
                    id="new-note-textarea"
                    placeholder="Type audit reasoning, document review comments, or verification notes..."
                    rows={6}
                    style={{
                      width: "100%",
                      padding: 12,
                      borderRadius: 10,
                      border: "1.5px solid #cbd5e1",
                      fontSize: 13,
                      boxSizing: "border-box",
                      outline: "none",
                      color: "#1e293b",
                      fontFamily: "inherit",
                    }}
                  />
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 14 }}>
                    <span style={{ fontSize: 11, color: "#94a3b8" }}>
                      * Notes are tamper-logged to provider history with current admin identity
                    </span>
                    <button
                      type="button"
                      onClick={() => {
                        const noteEl = document.getElementById("new-note-textarea");
                        const val = noteEl?.value?.trim();
                        if (!val) return;
                        window.__logPipelineAudit({ action: "note", providerId: pId, providerName: displayName, note: val });
                        window.__openPipelineSectionModal("notesLogs", record);
                      }}
                      style={{
                        padding: "9px 20px",
                        borderRadius: 8,
                        background: "#2563eb",
                        color: "#ffffff",
                        border: "none",
                        fontWeight: 700,
                        fontSize: 12,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                      }}
                    >
                      <span>💾</span>
                      <span>Save & View Notes Logs</span>
                    </button>
                  </div>
                </div>
              )}

              {/* TAB 6: NOTES LOGS */}
              {tab === "notesLogs" && (
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  {notesList.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "48px 20px", background: "#ffffff", borderRadius: 14, border: "1.5px dashed #cbd5e1", color: "#64748b" }}>
                      <div style={{ fontSize: 32, marginBottom: 8 }}>📝</div>
                      <strong style={{ fontSize: 14, color: "#334155", display: "block" }}>No notes logged yet</strong>
                      <span style={{ fontSize: 12, color: "#94a3b8" }}>Click on the "Add Note" tab above to create the first note entry.</span>
                    </div>
                  ) : (
                    notesList.map((n, nIdx) => (
                      <div
                        key={n.id || nIdx}
                        style={{
                          background: "#ffffff",
                          padding: "14px 18px",
                          borderRadius: 12,
                          borderLeft: "4px solid #be185d",
                          borderTop: "1px solid #e2e8f0",
                          borderRight: "1px solid #e2e8f0",
                          borderBottom: "1px solid #e2e8f0",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.03)",
                        }}
                      >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                            <span style={{ fontSize: 13 }}>👤</span>
                            <strong style={{ fontSize: 12, color: "#be185d" }}>{n.author}</strong>
                          </div>
                          <span style={{ fontSize: 11, color: "#64748b", textAlign: "right" }}>🕒 {n.formattedTime}</span>
                        </div>
                        <div style={{ fontSize: 13, color: "#1e293b", lineHeight: 1.5, whiteSpace: "pre-wrap" }}>
                          {n.text}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      );
    })()}

    {/* ============================================================
        DOCUMENT PREVIEW MODAL: ZERO DOWNLOAD & SCREENSHOT SHIELD
    ============================================================ */}
    {documentPreviewModal?.open && (() => {
      window.__isDocPreviewActive = true;
      const docItem = documentPreviewModal.doc;
      const url = documentPreviewModal.url;
      const previewKey = `${docItem?.id || docItem?.name || "doc"}__${url || "nourl"}`;
      const forceIframe = Boolean(window.__docPreviewForceIframeMap[previewKey]);
      const shouldRenderAsImage = Boolean(url) && !forceIframe && window.__looksLikeImageDocUrl(url);
      const close = () => {
        window.__isDocPreviewActive = false;
        setDocumentPreviewModal({ open: false, doc: null, url: null });
      };
      return (
        <div
          onClick={close}
          className="no-screen-capture"
          onContextMenu={(e) => {
            e.preventDefault();
            window.__showSecurityViolationAlert("Protected Canvas Context Menu Attempt");
          }}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15,23,42,0.85)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 13000,
            padding: 24,
            backdropFilter: "blur(4px)",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#ffffff",
              borderRadius: 16,
              width: "min(880px, 100%)",
              maxHeight: "88vh",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              position: "relative",
            }}
          >
            {/* Header */}
            <div style={{ padding: "12px 20px", background: "#0f172a", color: "#ffffff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 18 }}>🔒</span>
                <strong style={{ fontSize: 14 }}>{docItem?.name || "Document Preview"} (Protected View)</strong>
              </div>
              <button onClick={close} style={{ background: "none", border: "none", color: "#ffffff", fontSize: 18, cursor: "pointer" }}>
                ✕
              </button>
            </div>
            {/* Protected Canvas */}
            <div style={{ flex: 1, minHeight: 420, background: "#f1f5f9", position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <div className="doc-preview-shield" />
              {!url ? (
                <div style={{ color: "#64748b", position: "relative", zIndex: 5 }}>No document URL available for this record.</div>
              ) : shouldRenderAsImage ? (
                <img
                  src={url}
                  alt=""
                  onContextMenu={(e) => e.preventDefault()}
                  onError={() => {
                    window.__docPreviewForceIframeMap[previewKey] = true;
                    window.__triggerPipelineReRender();
                  }}
                  style={{ maxWidth: "100%", maxHeight: "75vh", width: "auto", height: "auto", objectFit: "contain", userSelect: "none", imageRendering: "auto", position: "relative", zIndex: 10 }}
                />
              ) : (
                <iframe
                  src={`${url}#toolbar=0&navpanes=0&scrollbar=0`}
                  title="Document Preview"
                  style={{ width: "100%", height: "75vh", border: "none", position: "relative", zIndex: 10 }}
                />
              )}
            </div>
            <div style={{ padding: "10px 20px", background: "#f8fafc", borderTop: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: 11, color: "#dc2626", fontWeight: 700 }}>
                ⚠️ Right-click, screenshots, and screen recordings are strictly monitored and prohibited
              </span>
              <button
                onClick={close}
                style={{ padding: "6px 16px", borderRadius: 6, background: "#0f172a", color: "#ffffff", border: "none", fontWeight: 700, cursor: "pointer" }}
              >
                Close Preview
              </button>
            </div>
          </div>
        </div>
      );
    })()}

    {/* ============================================================
        NEW — SELFIE CLICK-TO-ZOOM PREVIEW MODAL
        - Opens from the Selfie Verification image (drawers + Overview tab)
        - Uses the existing selfieUrl only (no upload / no Firebase writes)
        - +/- buttons, mouse-wheel zoom, drag-to-pan, X / outside-click / Esc close,
          animated open & close, responsive (desktop / tablet / mobile)
    ============================================================ */}
    {window.__selfiePreviewState?.open && (() => {
      const s = window.__selfiePreviewState;
      const isClosing = Boolean(s.closing);
      const close = () => window.__closeSelfiePreview();
      const atMin = s.scale <= window.__SELFIE_MIN_SCALE + 0.001;
      const atMax = s.scale >= window.__SELFIE_MAX_SCALE - 0.001;
      const toolbarBtnStyle = {
        minWidth: 38,
        height: 38,
        padding: "0 12px",
        borderRadius: 10,
        border: "1px solid #334155",
        background: "#1e293b",
        color: "#ffffff",
        fontSize: 18,
        fontWeight: 800,
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        lineHeight: 1,
      };
      return (
        <div
          onClick={close}
          className={`no-screen-capture ${isClosing ? "selfie-backdrop-close" : "selfie-backdrop-open"}`}
          onContextMenu={(e) => e.preventDefault()}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(2, 6, 23, 0.9)",
            zIndex: 15000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(6px)",
            WebkitBackdropFilter: "blur(6px)",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className={`selfie-preview-panel ${isClosing ? "selfie-panel-close" : "selfie-panel-open"}`}
            style={{
              background: "#0b1120",
              borderRadius: 18,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              boxShadow: "0 30px 80px rgba(0,0,0,0.6), 0 0 0 1px rgba(148, 163, 184, 0.15)",
              position: "relative",
            }}
          >
            {/* Toolbar */}
            <div
              className="selfie-preview-toolbar"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 10,
                padding: "12px 16px",
                background: "#0f172a",
                borderBottom: "1px solid #1e293b",
                flexWrap: "wrap",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0, flex: "1 1 160px" }}>
                <span style={{ fontSize: 18 }}>🤳</span>
                <strong
                  className="selfie-preview-title"
                  style={{ color: "#f8fafc", fontSize: 14, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                  title={s.name}
                >
                  {s.name}
                </strong>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <button
                  type="button"
                  id="selfie-zoom-out-btn"
                  className="selfie-zoom-btn"
                  aria-label="Zoom out"
                  title="Zoom out (-)"
                  disabled={atMin}
                  onClick={window.__selfieZoomOut}
                  style={toolbarBtnStyle}
                >
                  −
                </button>
                <span
                  id="selfie-zoom-level-label"
                  style={{ minWidth: 54, textAlign: "center", color: "#cbd5e1", fontSize: 13, fontWeight: 800 }}
                >
                  {Math.round(s.scale * 100)}%
                </span>
                <button
                  type="button"
                  id="selfie-zoom-in-btn"
                  className="selfie-zoom-btn"
                  aria-label="Zoom in"
                  title="Zoom in (+)"
                  disabled={atMax}
                  onClick={window.__selfieZoomIn}
                  style={toolbarBtnStyle}
                >
                  +
                </button>
                <button
                  type="button"
                  className="selfie-zoom-btn"
                  aria-label="Reset zoom"
                  title="Reset (0)"
                  onClick={window.__selfieZoomReset}
                  style={{ ...toolbarBtnStyle, fontSize: 12 }}
                >
                  <span>⟲</span>
                  <span className="selfie-preview-label">Reset</span>
                </button>
                <button
                  type="button"
                  className="selfie-zoom-btn"
                  aria-label="Close preview"
                  title="Close (Esc)"
                  onClick={close}
                  style={{ ...toolbarBtnStyle, background: "#b91c1c", borderColor: "#dc2626", fontSize: 16 }}
                >
                  ✕
                </button>
              </div>
            </div>

            {/* Zoom Stage */}
            <div
              id="selfie-preview-stage"
              ref={(el) => {
                if (el && !el.__selfieWheelBound) {
                  el.__selfieWheelBound = true;
                  el.addEventListener("wheel", window.__selfieWheelHandler, { passive: false });
                }
              }}
              style={{
                flex: 1,
                position: "relative",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "radial-gradient(circle at center, #111827 0%, #020617 100%)",
                touchAction: "none",
                minHeight: 0,
              }}
            >
              {!s.loaded && !s.error && (
                <div style={{ position: "absolute", display: "flex", flexDirection: "column", alignItems: "center", gap: 10, color: "#94a3b8", fontSize: 12, fontWeight: 700, zIndex: 2 }}>
                  <span className="pipeline-spin-icon" style={{ fontSize: 28 }}>⟳</span>
                  <span>Loading full-resolution selfie...</span>
                </div>
              )}
              {s.error && (
                <div style={{ position: "absolute", textAlign: "center", color: "#fca5a5", fontSize: 13, fontWeight: 700, padding: 20, zIndex: 2 }}>
                  ⚠️ Could not load the selfie image.
                </div>
              )}
              <img
                id="selfie-preview-img"
                src={s.url}
                alt="Selfie verification — full size"
                draggable={false}
                onContextMenu={(e) => e.preventDefault()}
                onDoubleClick={window.__selfieDoubleClick}
                onPointerDown={window.__selfiePointerDown}
                onPointerMove={window.__selfiePointerMove}
                onPointerUp={window.__selfiePointerUp}
                onPointerCancel={window.__selfiePointerUp}
                onLoad={() => {
                  if (window.__selfiePreviewState === s && !s.loaded) {
                    s.loaded = true;
                    window.__triggerPipelineReRender();
                  }
                }}
                onError={() => {
                  if (window.__selfiePreviewState === s) {
                    s.error = true;
                    window.__triggerPipelineReRender();
                  }
                }}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  width: "auto",
                  height: "auto",
                  objectFit: "contain",
                  imageRendering: "auto",
                  userSelect: "none",
                  WebkitUserDrag: "none",
                  touchAction: "none",
                  willChange: "transform",
                  opacity: s.loaded ? 1 : 0,
                  transform: `translate(${s.x}px, ${s.y}px) scale(${s.scale})`,
                  transition: s.dragging ? "none" : "transform 0.18s ease-out, opacity 0.25s ease",
                  cursor: s.scale > 1 ? (s.dragging ? "grabbing" : "grab") : "zoom-in",
                }}
              />
            </div>

            {/* Footer hint */}
            <div
              style={{
                padding: "8px 16px",
                background: "#0f172a",
                borderTop: "1px solid #1e293b",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 10,
                flexWrap: "wrap",
              }}
            >
              <span className="selfie-preview-label" style={{ fontSize: 11, color: "#94a3b8", fontWeight: 600 }}>
                Scroll or +/− to zoom · Drag to move · Double-click to toggle zoom · Esc to close
              </span>
              <span style={{ fontSize: 10.5, color: "#fca5a5", fontWeight: 700 }}>
                🔒 Confidential — screenshots & recording prohibited
              </span>
            </div>
          </div>
        </div>
      );
    })()}
  </>
)}

    {/* ✅ ADD USER */}
    {user?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
      currentView === "addUser" && (
      <div className="admin-container">
        {/* HEADER */}
        <div style={headerStyle}>
          <h3 style={titleStyle}>Add New Admin</h3>
        </div>
        {/* CARD */}
        <div style={cardStyle}>
          {/* ---------------- HEADER ---------------- */}
<div
  style={{
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    marginBottom: "20px",
    textAlign: "center",
  }}
>
  <h3
    style={{
      margin: 0,
      fontFamily: "'Poppins', sans-serif",
      fontSize: "24px",
      fontWeight: "700",
      color: "#111827",
    }}
  >
    Add New Admin
  </h3>
</div>
{/* ---------------- SINGLE WHITE CARD ---------------- */}
<div
  style={{
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    maxWidth: "1600px",
    margin: "0 auto",
  }}
>
  {/* ---------------- TITLE ---------------- */}
  <h3 style={{ marginBottom: "20px" }}>Add New Admin</h3>
  {/* ---------------- FORM ---------------- */}
  <div className="form-group">
    <label>Name</label>
    <input
      type="text"
      name="name"
      value={newUserData.name || ""}
      onChange={handleUserFieldChange}
      placeholder="Enter name"
    />
  </div>
  <div className="form-group">
    <label>Email</label>
    <input
      type="email"
      name="email"
      value={newUserData.email || ""}
      onChange={handleUserFieldChange}
      placeholder="Enter email"
    />
  </div>
  <div className="form-group">
    <label>Mobile</label>
    <input
      type="text"
      name="mobile"
      value={newUserData.mobile || ""}
      onChange={handleUserFieldChange}
      placeholder="Enter mobile"
    />
  </div>
  <div className="form-group">
    <label>Password</label>
    <input
      type="password"
      name="password"
      value={newUserData.password || ""}
      onChange={handleUserFieldChange}
      placeholder="Enter Password"
    />
  </div>
  <div className="checkbox-row">
    <input
      type="checkbox"
      name="isAdmin"
      checked={!!newUserData.isAdmin}
      onChange={handleUserFieldChange}
    />
    <span>Admin</span>
  </div>
  <button className="btn-primary" onClick={handleAddNewUser}>
    Add Admin
  </button>
  {/* ---------------- PERMISSIONS ---------------- */}
  <div style={{ marginTop: "30px" }}>
    <h3>Page Permissions</h3>
    {Object.entries(PAGE_HIERARCHY).map(([category, pages]) => (
      <div key={category} className="permission-block">
        <h4>{category}</h4>
        {pages.map((page) => {
          const isPermitted =
            newUserData?.permissions?.[category]?.[page] || false;
          const isEditable = page === "Completed Orders";
          return (
            <div key={page} className="checkbox-row">
              <input
                type="checkbox"
                checked={isPermitted}
                disabled={!isEditable}
                onChange={() =>
                  isEditable && handlePermissionToggle(category, page)
                }
              />
              <span style={{ color: isEditable ? "#000" : "#aaa" }}>
                {page}
              </span>
            </div>
          );
        })}
      </div>
    ))}
  </div>
  {/* ---------------- ADMIN LIST ---------------- */}
  <div style={{ marginTop: "30px" }}>
    <h3>Admin List</h3>
    <table className="admin-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Mobile</th>
          <th>Admin</th>
          <th>Last Login</th>
          <th>Status</th>
          <th>Permissions</th>
        </tr>
      </thead>
      <tbody>
        {userList.length > 0 ? (
          userList.map((user, idx) => {
            const allowedPages = Object.entries(user.permissions || {})
              .flatMap(([_, pages]) =>
                Object.entries(pages || {})
                  .filter(([, val]) => val)
                  .map(([page]) => page)
              );
            return (
              <tr key={user.id || idx}>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>{user.mobile}</td>
                <td>{user.isAdmin ? "✔️" : "—"}</td>
                <td>
                  {user.lastLogin
                    ? new Date(
                        user.lastLogin.seconds * 1000
                      ).toLocaleString()
                    : "—"}
                </td>
                <td>{user.status || "Active"}</td>
                <td>
                  <div className="permission-tags">
                    {allowedPages.length > 0 ? (
                      allowedPages.map((page, i) => (
                        <span key={i} className="tag">
                          {page}
                        </span>
                      ))
                    ) : (
                      "—"
                    )}
                  </div>
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan="7" className="empty">
              No admins added yet
            </td>
          </tr>
        )}
      </tbody>
    </table>
        </div>
      </div>
    </div>
    </div>
    )}
    {/* ✅ ADD CATEGORY */}
    {user?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
      currentView === "addCategory" && (
      <div className="admin-container">
        {/* HEADER */}
        <div style={headerStyle}>
          <h3 style={titleStyle}>Add Category</h3>
        </div>
        {/* CARD */}
        <div style={cardStyle}>
        {/* ---------------- HEADER ---------------- */}
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            marginBottom: "20px",
            textAlign: "center",
          }}
        >
          <h3
            style={{
              margin: 0,
              fontFamily: "'Poppins', sans-serif",
              fontSize: "24px",
              fontWeight: "700",
              color: "#111827",
            }}
          >
            Add Category
          </h3>
        </div>
        {/* ---------------- SINGLE WHITE CARD ---------------- */}
        <div
          style={{
            backgroundColor: "#fff",
            padding: "30px",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            maxWidth: "1600px",
            margin: "0 auto",
          }}
        >
          {/* ---------------- CATEGORY ID ---------------- */}
          <div className="form-group" style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "6px", color: "#374151", fontWeight: "500" }}>
              Category ID:
            </label>
            <input
              type="text"
              name="id"
              value={addData.id}
              onChange={(e) => setAddData({ ...addData, id: e.target.value })}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                outline: "none",
              }}
            />
          </div>
          {/* ---------------- CATEGORY NAME ---------------- */}
          <div className="form-group" style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "6px", color: "#374151", fontWeight: "500" }}>
              Category Name:
            </label>
            <input
              type="text"
              name="Name"
              value={addData.Name}
              onChange={(e) => setAddData({ ...addData, Name: e.target.value })}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                outline: "none",
              }}
            />
          </div>
          {/* ---------------- CATEGORY SUBTITLE ---------------- */}
          <div className="form-group" style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "6px", color: "#374151", fontWeight: "500" }}>
              Category Subtitle:
            </label>
            <input
              type="text"
              name="Storageimg_name"
              value={addData.Storageimg_name}
              onChange={(e) =>
                setAddData({ ...addData, Storageimg_name: e.target.value })
              }
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                outline: "none",
              }}
            />
          </div>
          {/* ---------------- CATEGORY IMAGE ---------------- */}
          <div className="form-group" style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "6px", color: "#374151", fontWeight: "500" }}>
              Category Image:
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) setAddData({ ...addData, Storageimg_name: file.name });
              }}
              style={{
                width: "100%",
                padding: "8px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
              }}
            />
          </div>
          {/* ---------------- CATEGORY VIDEO ---------------- */}
          <div className="form-group" style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "6px", color: "#374151", fontWeight: "500" }}>
              Category Video:
            </label>
            <input
              type="file"
              accept="video/*"
              required
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) setAddData({ ...addData, cat_video: file.name });
              }}
              style={{
                width: "100%",
                padding: "8px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
              }}
            />
            {addData.cat_video && (
              <p style={{ marginTop: "6px", color: "#4F46E5" }}>
                Selected Video: {addData.cat_video}
              </p>
            )}
          </div>
          {/* ---------------- STATUS ---------------- */}
          <div className="form-group" style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "6px", color: "#374151", fontWeight: "500" }}>
              Category Status:
            </label>
            <select
              value={addData.Active ? "Publish" : "Draft"}
              onChange={(e) =>
                setAddData({ ...addData, Active: e.target.value === "Publish" })
              }
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                outline: "none",
              }}
            >
              <option value="Publish">Publish</option>
              <option value="Draft">Draft</option>
            </select>
          </div>
          {/* ---------------- BUTTONS ---------------- */}
          <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
            <button
              onClick={handleAddDocument}
              style={{
                flex: 1,
                padding: "12px",
                backgroundColor: "#4F46E5",
                color: "white",
                fontWeight: "600",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Add Category
            </button>
            <button
              onClick={() => setShowAddCategoryForm(false)}
              style={{
                flex: 1,
                padding: "12px",
                backgroundColor: "#EF4444",
                color: "white",
                fontWeight: "600",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
        </div>
    )}
    {/* ✅ LIST CATEGORY */}
{user?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "listCategory" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Fetched Data</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
  {/* Title */}
      <div
        className="category-title-container"
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          Fetched Data
        </h3>
      </div>
      {/* Table Container */}
      <div
        className="category-form-container"
        style={{
          backgroundColor: "#fff",
          padding: "30px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          overflowX: "auto",
        }}
      >
        {loading ? (
          <p
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: "14px",
              color: "#6B7280",
            }}
          >
            Loading data...
          </p>
        ) : (
          <table
            className="borderless-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "'Inter', sans-serif",
              fontSize: "14px",
              color: "#374151",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#F9FAFB" }}>
                <th style={{ padding: "12px", textAlign: "left" }}>#</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Category Name</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Category Subtitle</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Status</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={item.id} style={{ borderBottom: "1px solid #E5E7EB" }}>
                  <td style={{ padding: "12px" }}>{index + 1}</td>
                  <td style={{ padding: "12px" }}>
                    {editingId === item.id ? (
                      <input
                        type="text"
                        name="Name"
                        value={
                          editedData[item.id]?.Name !== undefined
                            ? editedData[item.id].Name
                            : item.Name
                        }
                        onChange={(e) => handleUpdateField(e, item.id)}
                        style={{
                          padding: "6px 10px",
                          border: "1px solid #D1D5DB",
                          borderRadius: "6px",
                          fontFamily: "'Inter', sans-serif",
                        }}
                      />
                    ) : (
                      item.Name
                    )}
                  </td>
                  <td style={{ padding: "12px" }}>
                    {editingId === item.id ? (
                      <input
                        type="text"
                        name="Storageimg_name"
                        value={
                          editedData[item.id]?.Storageimg_name !== undefined
                            ? editedData[item.id].Storageimg_name
                            : item.Storageimg_name
                        }
                        onChange={(e) => handleUpdateField(e, item.id)}
                        style={{
                          padding: "6px 10px",
                          border: "1px solid #D1D5DB",
                          borderRadius: "6px",
                          fontFamily: "'Inter', sans-serif",
                        }}
                      />
                    ) : (
                      item.Storageimg_name
                    )}
                  </td>
                  <td style={{ padding: "12px" }}>
                    {editingId === item.id ? (
                      <select
                        name="Active"
                        value={
                          editedData[item.id]?.Active !== undefined
                            ? editedData[item.id].Active
                            : item.Active
                        }
                        onChange={(e) => handleUpdateField(e, item.id)}
                        style={{
                          padding: "6px 10px",
                          border: "1px solid #D1D5DB",
                          borderRadius: "6px",
                          fontFamily: "'Inter', sans-serif",
                        }}
                      >
                        <option value={true}>Published</option>
                        <option value={false}>UnPublished</option>
                      </select>
                    ) : (
                      <span
                        style={{
                          display: "inline-block",
                          padding: "4px 10px",
                          borderRadius: "6px",
                          fontSize: "12px",
                          fontWeight: "600",
                          backgroundColor: item.Active ? "#2563EB" : "#DC2626",
                          color: "#fff",
                          fontFamily: "'Inter', sans-serif",
                        }}
                      >
                        {item.Active ? "Published" : "UnPublished"}
                      </span>
                    )}
                  </td>
                  <td style={{ padding: "12px" }}>
                    {editingId === item.id ? (
                      <>
                        <button
                          onClick={() => handleSaveDocument(item.id)}
                          style={{
                            backgroundColor: "#2563EB",
                            color: "white",
                            marginRight: "6px",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            fontFamily: "'Inter', sans-serif",
                            fontWeight: "600",
                            cursor: "pointer",
                            border: "none",
                          }}
                        >
                          Save
                        </button>
                        <button
                          onClick={() => setEditingId(null)}
                          style={{
                            backgroundColor: "#111827",
                            color: "white",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            fontFamily: "'Inter', sans-serif",
                            fontWeight: "600",
                            cursor: "pointer",
                            border: "none",
                          }}
                        >
                          Cancel
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          onClick={() => handleEditDocument(item.id)}
                          style={{
                            backgroundColor: "#F59E0B",
                            color: "white",
                            fontSize: "16px",
                            marginRight: "6px",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            fontFamily: "'Inter', sans-serif",
                            fontWeight: "600",
                            cursor: "pointer",
                            border: "none",
                          }}
                        >
                          <FaEdit />
                        </button>
                        <button
                          onClick={() => handleDeleteDocument(item.id)}
                          style={{
                            backgroundColor: "#8B5CF6",
                            color: "white",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            fontFamily: "'Inter', sans-serif",
                            fontWeight: "600",
                            cursor: "pointer",
                            border: "none",
                          }}
                        >
                          <FaTrash />
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
    </div>
)}
{/* ✅ ADD DISCOUNT */}
{userUID === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "addDiscount" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Add Discount Coupon</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
      {/* Title */}
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          Add Discount Coupon
        </h3>
      </div>
      {/* Form */}
      <div
        style={{
          backgroundColor: "#fff",
          padding: "30px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <form onSubmit={handleDiscountSubmit}>
          {/* Auto-generated Discount Code */}
          <div className="form-group" style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "6px",
                color: "#374151",
                fontWeight: "500",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              Discount Coupon Code
            </label>
            <input
              type="text"
              value={discountCode}
              readOnly
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                backgroundColor: "#F9FAFB",
                fontFamily: "'Inter', sans-serif",
              }}
            />
          </div>
          {/* Discount Status */}
          <div className="form-group" style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "6px",
                color: "#374151",
                fontWeight: "500",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              Discount Status
            </label>
            <select
              value={discountStatus}
              onChange={(e) => setDiscountStatus(e.target.value === "true")}
              required
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
          </div>
          {/* Discount Amount */}
          <div className="form-group" style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "6px",
                color: "#374151",
                fontWeight: "500",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              Discount Amount (£)
            </label>
            <input
              type="number"
              value={discountAmount}
              onChange={(e) => setDiscountAmount(e.target.value)}
              placeholder="Enter Discount Amount"
              required
              min="0"
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                fontFamily: "'Inter', sans-serif",
              }}
            />
          </div>
          {/* Apply To (Provider/Customer) */}
          <div className="form-group" style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "6px",
                color: "#374151",
                fontWeight: "500",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              Apply Discount For
            </label>
            <select
              value={applyTo}
              onChange={(e) => setApplyTo(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              <option value="">Select</option>
              <option value="provider">Provider</option>
              <option value="customer">Customer</option>
            </select>
          </div>
          {/* Details Section */}
          <div className="form-group" style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "6px",
                color: "#374151",
                fontWeight: "500",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              {applyTo === "provider"
                ? "Provider Details (ID, Name, Email)"
                : "Customer Details (ID, Name, Email)"}
            </label>
            <input
              type="text"
              value={selectedId}
              onChange={(e) => setSelectedId(e.target.value)}
              placeholder="Enter ID"
              required
              style={{
                width: "100%",
                padding: "12px",
                marginBottom: "10px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                fontFamily: "'Inter', sans-serif",
              }}
            />
            <input
              type="text"
              value={selectedName}
              onChange={(e) => setSelectedName(e.target.value)}
              placeholder="Enter Name"
              required
              style={{
                width: "100%",
                padding: "12px",
                marginBottom: "10px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                fontFamily: "'Inter', sans-serif",
              }}
            />
            <input
              type="email"
              value={selectedEmail}
              onChange={(e) => setSelectedEmail(e.target.value)}
              placeholder="Enter Email"
              required
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                fontFamily: "'Inter', sans-serif",
              }}
            />
          </div>
          {/* Submit Button */}
          <div style={{ marginTop: "20px" }}>
            <button
              type="submit"
              style={{
                width: "100%",
                padding: "12px",
                backgroundColor: "#4F46E5",
                color: "white",
                fontWeight: "600",
                borderRadius: "8px",
                cursor: "pointer",
                fontFamily: "'Inter', sans-serif",
                transition: "all 0.2s",
              }}
            >
              Save Discount Coupon
            </button>
          </div>
        </form>
      </div>
    </div>
    </div>
)}
{/* ✅ LIST DISCOUNT COUPONS */}
{user?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "listDiscountCoupons" && (
    <div className="admin-container">
      {/* HEADER */}
      <div style={headerStyle}>
        <h3 style={titleStyle}>Discount Coupons</h3>
      </div>
      {/* CARD */}
      <div style={cardStyle}>
         {/* Header */}
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          Discount Coupons
        </h3>
      </div>
      {/* Table Container */}
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          overflowX: "auto",
        }}
      >
        {/* Table Controls */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
            fontFamily: "'Inter', sans-serif",
            gap: "12px",
            flexWrap: "wrap",
          }}
        >
          {/* Rows per page */}
          <label style={{ fontSize: "14px", color: "#374151", display: "flex", alignItems: "center", gap: 8 }}>
            Show
            <select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
              style={{
                margin: "0 5px",
                padding: "6px 10px",
                border: "1px solid #D1D5DB",
                borderRadius: "6px",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              {[10, 25, 50].map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
            entries
          </label>
          {/* Responsive equal-width search boxes */}
          <div
            style={{
              display: "flex",
              flex: 1,
              gap: "8px",
              flexWrap: "wrap",
            }}
          >
            {["Code", "ID", "Name", "Email"].map((field) => (
              <input
                key={field}
                type="text"
                placeholder={`Search ${field}...`}
                value={
                  field === "Code"
                    ? searchCode
                    : field === "ID"
                    ? searchId
                    : field === "Name"
                    ? searchName
                    : searchEmail
                }
                onChange={(e) => {
                  if (field === "Code") setSearchCode(e.target.value);
                  else if (field === "ID") setSearchId(e.target.value);
                  else if (field === "Name") setSearchName(e.target.value);
                  else setSearchEmail(e.target.value);
                  setCurrentPage(1);
                }}
                className="form-control rounded-lg border-[#D1D5DB]"
                style={{
                  flex: 1, // expand equally
                  minWidth: "120px", // prevent too small on mobile
                  height: "38px",
                  padding: "6px 10px",
                  fontFamily: "'Inter', sans-serif",
                  fontSize: "13px",
                }}
              />
            ))}
          </div>
        </div>
        {/* Filter + paginate data */}
        {(() => {
          const filteredDiscounts = (discountList || [])
            .filter((item) => !item.isTemporarilyDeleted)
            .filter((item) => {
              const matchCode = !searchCode || (item.discountCode ?? "").toLowerCase().includes(searchCode.toLowerCase());
              const matchId = !searchId || (item.targetId ?? "").toLowerCase().includes(searchId.toLowerCase());
              const matchName = !searchName || (item.targetName ?? "").toLowerCase().includes(searchName.toLowerCase());
              const matchEmail = !searchEmail || (item.targetEmail ?? "").toLowerCase().includes(searchEmail.toLowerCase());
              return matchCode && matchId && matchName && matchEmail;
            });
          const total = filteredDiscounts.length;
          const totalPages = Math.max(1, Math.ceil(total / rowsPerPage));
          const safePage = Math.min(Math.max(1, currentPage), totalPages);
          const start = (safePage - 1) * rowsPerPage;
          const paginated = filteredDiscounts.slice(start, start + rowsPerPage);
          return (
            <>
              {/* Table */}
              {paginated.length > 0 ? (
                <>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontFamily: "'Inter', sans-serif",
                      fontSize: "14px",
                      color: "#374151",
                    }}
                  >
                    <thead style={{ backgroundColor: "#F9FAFB" }}>
                      <tr>
                        <th style={{ padding: "12px", textAlign: "left" }}>#</th>
                        <th style={{ padding: "12px", textAlign: "left" }}>Coupon Code</th>
                        <th style={{ padding: "12px", textAlign: "left" }}>Amount (£)</th>
                        <th style={{ padding: "12px", textAlign: "left" }}>Status</th>
                        <th style={{ padding: "12px", textAlign: "left" }}>Applied To</th>
                        <th style={{ padding: "12px", textAlign: "left" }}>Target ID</th>
                        <th style={{ padding: "12px", textAlign: "left" }}>Target Name</th>
                        <th style={{ padding: "12px", textAlign: "left" }}>Target Email</th>
                        <th style={{ padding: "12px", textAlign: "left" }}>Created At</th>
                        <th style={{ padding: "12px", textAlign: "left" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginated.map((item, idx) => {
                        const rowIndex = start + idx + 1;
                        return (
                          <tr
                            key={item.id ?? `${item.discountCode}_${rowIndex}`}
                            style={{
                              borderBottom: "1px solid #E5E7EB",
                              backgroundColor: rowIndex % 2 === 0 ? "#fff" : "#F9FAFB",
                            }}
                          >
                            <td style={{ padding: "12px" }}>{rowIndex}</td>
                            {/* Coupon Code */}
                            <td style={{ padding: "12px" }}>
                              {item.isEditing ? (
                                <input
                                  value={item.discountCode ?? ""}
                                  onChange={(e) => updateDiscountField(item.id, "discountCode", e.target.value)}
                                  style={{
                                    padding: "4px 6px",
                                    borderRadius: "4px",
                                    border: "1px solid #D1D5DB",
                                  }}
                                />
                              ) : (
                                item.discountCode
                              )}
                            </td>
                            {/* Amount */}
                            <td style={{ padding: "12px" }}>
                              {item.isEditing ? (
                                <input
                                  type="number"
                                  value={item.amount ?? 0}
                                  onChange={(e) =>
                                    updateDiscountField(item.id, "amount", parseFloat(e.target.value || 0))
                                  }
                                  style={{
                                    padding: "4px 6px",
                                    borderRadius: "4px",
                                    border: "1px solid #D1D5DB",
                                  }}
                                />
                              ) : (
                                `£${item.amount ?? 0}`
                              )}
                            </td>
                            {/* Status */}
                            <td style={{ padding: "12px" }}>
                              {item.isEditing ? (
                                <select
                                  value={String(item.status ?? true)}
                                  onChange={(e) => updateDiscountField(item.id, "status", e.target.value === "true")}
                                  style={{
                                    padding: "4px 6px",
                                    borderRadius: "4px",
                                    border: "1px solid #D1D5DB",
                                  }}
                                >
                                  <option value="true">Active</option>
                                  <option value="false">Inactive</option>
                                </select>
                              ) : (
                                <span
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    padding: "4px 10px",
                                    borderRadius: "6px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    backgroundColor: item.status ? "#10B981" : "#DC2626",
                                    color: "#fff",
                                  }}
                                >
                                  {item.status ? "Active" : "Inactive"}
                                </span>
                              )}
                            </td>
                            {/* Applied To */}
                            <td style={{ padding: "12px" }}>
                              {item.isEditing ? (
                                <select
                                  value={item.appliedTo ?? "provider"}
                                  onChange={(e) => updateDiscountField(item.id, "appliedTo", e.target.value)}
                                  style={{
                                    padding: "4px 6px",
                                    borderRadius: "4px",
                                    border: "1px solid #D1D5DB",
                                  }}
                                >
                                  <option value="provider">Provider</option>
                                  <option value="customer">Customer</option>
                                  <option value="all">All</option>
                                </select>
                              ) : (
                                item.appliedTo
                              )}
                            </td>
                            {/* Target ID */}
                            <td style={{ padding: "12px" }}>
                              {item.isEditing ? (
                                <input
                                  value={item.targetId ?? ""}
                                  onChange={(e) => updateDiscountField(item.id, "targetId", e.target.value)}
                                  style={{
                                    padding: "4px 6px",
                                    borderRadius: "4px",
                                    border: "1px solid #D1D5DB",
                                  }}
                                />
                              ) : (
                                item.targetId
                              )}
                            </td>
                            {/* Target Name */}
                            <td style={{ padding: "12px" }}>
                              {item.isEditing ? (
                                <input
                                  value={item.targetName ?? ""}
                                  onChange={(e) => updateDiscountField(item.id, "targetName", e.target.value)}
                                  style={{
                                    padding: "4px 6px",
                                    borderRadius: "4px",
                                    border: "1px solid #D1D5DB",
                                  }}
                                />
                              ) : (
                                item.targetName
                              )}
                            </td>
                            {/* Target Email */}
                            <td style={{ padding: "12px" }}>
                              {item.isEditing ? (
                                <input
                                  value={item.targetEmail ?? ""}
                                  onChange={(e) => updateDiscountField(item.id, "targetEmail", e.target.value)}
                                  style={{
                                    padding: "4px 6px",
                                    borderRadius: "4px",
                                    border: "1px solid #D1D5DB",
                                  }}
                                />
                              ) : (
                                item.targetEmail
                              )}
                            </td>
                            {/* Created At */}
                            <td style={{ padding: "12px" }}>
                              {item.isEditing ? (
                                <input
                                  type="datetime-local"
                                  value={formatDateForInput(item.createdAt)}
                                  onChange={(e) =>
                                    updateDiscountField(item.id, "createdAt", new Date(e.target.value))
                                  }
                                  style={{
                                    padding: "4px 6px",
                                    borderRadius: "4px",
                                    border: "1px solid #D1D5DB",
                                  }}
                                />
                              ) : (
                                formatDateForDisplay(item.createdAt)
                              )}
                            </td>
                            {/* Actions */}
                            <td style={{ padding: "12px", display: "flex", gap: "8px" }}>
                              {item.isEditing ? (
                                <button
                                  onClick={() => commitDiscountEdit(item.id)}
                                  style={{
                                    backgroundColor: "#10B981",
                                    padding: "6px 12px",
                                    borderRadius: "6px",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                  title="Save"
                                >
                                  <MdSave size={18} color="white" />
                                </button>
                              ) : (
                                <button
                                  onClick={() => beginDiscountEdit(item.id)}
                                  style={{
                                    backgroundColor: "#2563EB",
                                    padding: "6px 12px",
                                    borderRadius: "6px",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                  title="Edit"
                                >
                                  <MdEdit size={18} color="white" />
                                </button>
                              )}
                              <button
                                onClick={() => hideDiscountTemporarily(item.id)}
                                style={{
                                  backgroundColor: "#DC2626",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                                title="Hide (temporary)"
                              >
                                <MdDelete size={18} color="white" />
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  {/* Pagination */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: 12,
                      fontFamily: "'Inter', sans-serif",
                      gap: 12,
                      flexWrap: "wrap",
                    }}
                  >
                    <div style={{ color: "#374151", fontSize: 13 }}>
                      Showing {start + 1} to {Math.min(start + rowsPerPage, total)} of {total} entries
                    </div>
                    <div style={{ display: "flex", gap: 8 }}>
                      <button
                        onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                        disabled={currentPage <= 1}
                        style={{
                          padding: "6px 10px",
                          borderRadius: 6,
                          border: "1px solid #D1D5DB",
                          backgroundColor: currentPage <= 1 ? "#F3F4F6" : "#fff",
                          cursor: currentPage <= 1 ? "not-allowed" : "pointer",
                        }}
                      >
                        Prev
                      </button>
                      <button
                        onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                        disabled={currentPage >= totalPages}
                        style={{
                          padding: "6px 10px",
                          borderRadius: 6,
                          border: "1px solid #D1D5DB",
                          backgroundColor: currentPage >= totalPages ? "#F3F4F6" : "#fff",
                          cursor: currentPage >= totalPages ? "not-allowed" : "pointer",
                        }}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <p
                  style={{
                    fontFamily: "'Inter', sans-serif",
                    fontSize: "14px",
                    color: "#6B7280",
                    textAlign: "center",
                  }}
                >
                  No discount coupons available.
                </p>
              )}
            </>
          );
        })()}
      </div>
    </div>
      </div>
)}
{/* ✅ PENDING ORDERS */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "Pending Orders" &&
  showPendingOrders && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Pending Order List</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
      {/* Header */}
      <div
        className="category-title-container"
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
    {/* Header Section */}
    <div className="pending-order-header mb-4">
      <h2 className="pending-order-title font-poppins text-2xl font-semibold" style={{ color: "#000000" }}>
        Pending Order List
      </h2>
    </div>
    {/* Table Section */}
    <div className="pending-order-card bg-white p-6 rounded-xl shadow-md">
      <div className="table-responsive">
        <table className="table table-striped" id="table-1">
          <thead style={{ backgroundColor: "#F5F5F7" }}>
            <tr>
              <th>#</th>
              <th>Order Id</th>
              <th>Order Date</th>
              <th>Service Partner Name</th>
              <th>Current Status</th>
              <th>Hire Type</th>
              <th>Credit Required?</th>
              <th>Preview Data</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order, index) => (
              <tr key={order.id} className="font-inter">
                <td className="order-index">{index + 1}</td>
                <td>{order.id}</td>
                <td>{order.date}</td>
                <td>{order.partner || "-"}</td>
                <td>{order.status}</td>
                <td>{order.type}</td>
                <td>{order.credit ? order.credit : "-"}</td>
                <td className="text-center">
                  {[6034, 6033, 6032, 6031, 6030, 6029].includes(order.id) ? (
                    <>
                      {order.image && (
                        <img
                          src={order.image}
                          alt="Order Preview"
                          className="preview-image rounded-lg shadow cursor-pointer"
                          onClick={() => setSelectedOrder(order)}
                        />
                      )}
                    <button
  className="preview-btn btn btn-dark btn-sm mt-2 rounded-lg shadow flex items-center justify-center gap-2"
  onClick={() => setSelectedOrder(order)}
  style={{ width: "110px" }} // slightly wider for icon + text
>
  <FiEye size={14} />
</button>
                    </>
                  ) : (
                    <span>-</span>
                  )}
                </td>
                <td>
                <button
  className="btn btn-sm font-medium rounded-lg shadow flex items-center justify-center gap-2"
  style={{
    backgroundColor: "#000",
    color: "#fff",
    padding: "8px 12px",
    border: "none",
    cursor: "pointer",
    fontSize: "14px",
    width: "140px",
  }}
  onClick={() => {
    setSelectedOrderId(order.id);
    setCurrentView("makeDecision");   // navigate to decision section
  }}
>
  <FiCheckCircle size={16} />
</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</div>
)}
{/* Order Preview Modal */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" && selectedOrder && (
  <div className="modal-overlay flex items-center justify-center bg-black bg-opacity-50">
    <div className="modal-dialog bg-white rounded-2xl shadow-xl max-w-2xl w-full">
      <div className="modal-content">
        {/* Modal Header */}
        <div className="modal-header flex justify-between items-center border-b border-gray-200 p-4">
          <h5 className="modal-title font-poppins text-xl font-semibold">Order Preview</h5>
          <button
            type="button"
            className="close text-gray-500 hover:text-gray-700"
            onClick={() => setSelectedOrder(null)}
          >
            &times;
          </button>
        </div>
        {/* Modal Body */}
        <div className="modal-body p-6 space-y-6 font-inter" id="orderPreviewContent">
          {/* Order Details */}
          <div className="order-section">
            <h4 className="section-title font-poppins text-lg font-medium mb-2">Order Details</h4>
            <div className="order-details text-gray-700 space-y-1">
              <p><strong>Order No:</strong> {selectedOrder.id}</p>
              <p><strong>Shipped Date:</strong> 
                {selectedOrder.id === 6034 ? "16-03-2025" : selectedOrder.id === 6029 ? "28-02-2025" : selectedOrder.date}
              </p>
              <p><strong><i className="fa fa-phone"></i> Mobile Number:</strong> Test</p>
              <p><strong><i className="fa fa-user"></i> Customer Name:</strong> Test</p>
            </div>
          </div>
          {/* Order Item */}
          <div className="order-section">
            <h4 className="section-title font-poppins text-lg font-medium mb-2">Order Item</h4>
            <div className="order-item text-gray-700 space-y-1">
              <p>
                <strong>
                  {selectedOrder.id === 6034 
                    ? "Full Chocolate Roll-On Waxing" 
                    : selectedOrder.id === 6029 
                    ? "Wax & Groom: Honey Waxing" 
                    : selectedOrder.id === 6033 
                    ? "Full Chocolate Roll-On Waxing" 
                    : selectedOrder.id === 6031 
                    ? "Haircut + Face Cleanup" 
                    : selectedOrder.id === 6030 
                    ? "Full Chocolate Roll-On Waxing" 
                    : "Wax & Groom: Honey Waxing"}
                </strong> 
                <span className="discount-badge ml-2 px-2 py-1 text-white text-sm rounded-lg shadow"
                  style={{ backgroundColor: "#4F46E5" }}
                >
                  {selectedOrder.id === 6034 || selectedOrder.id === 6033 || selectedOrder.id === 6030 ? "20%" : "40%"}
                </span>
              </p>
              <p><strong>Qty:</strong> 1 x {selectedOrder.id === 6031 ? "$300" : "$500"}</p>
              <p><strong>Price:</strong> 
                {selectedOrder.id === 6034 ? "$400" 
                : selectedOrder.id === 6029 ? "$300" 
                : selectedOrder.id === 6033 || selectedOrder.id === 6030 ? "$400" 
                : selectedOrder.id === 6031 ? "$240" 
                : "$300"}
              </p>
            </div>
          </div>
          {/* Slot Details */}
          <div className="order-section">
            <h4 className="section-title font-poppins text-lg font-medium mb-2">Date And Time Slot Details</h4>
            <div className="order-slot text-gray-700 space-y-1">
              <p><strong><i className="fa fa-calendar"></i> Date:</strong> 
                {selectedOrder.id === 6034 ? "Sun 16" 
                : selectedOrder.id === 6029 ? "Fri 28" 
                : selectedOrder.id === 6033 || selectedOrder.id === 6030 ? "Sun 2" 
                : selectedOrder.id === 6031 ? "Sun 09" 
                : "Tue 11"}
              </p>
              <p><strong><i className="fa fa-clock"></i> Time:</strong> 
                {selectedOrder.id === 6034 ? "08:00 AM" 
                : selectedOrder.id === 6029 ? "08:00 AM" 
                : selectedOrder.id === 6033 || selectedOrder.id === 6030 ? "08:00 AM" 
                : selectedOrder.id === 6031 ? "12:00 PM" 
                : "12:30PM"}
              </p>
              <p><strong><i className="fa fa-shopping-cart"></i> Payment Method:</strong> 
                {selectedOrder.id === 6034 ? "Razorpay" 
                : selectedOrder.id === 6029 ? "Cash On Delivery" 
                : selectedOrder.id === 6033 || selectedOrder.id === 6030 ? "Cash On Delivery" 
                : selectedOrder.id === 6031 ? "Wallet" 
                : "Razorpay"}
              </p>
              <p><strong><i className="fa fa-list"></i> Category:</strong> Salon for {selectedOrder.id === 6031 ? "Men" : "Women"}</p>
            </div>
          </div>
          {/* Total Order Report */}
          <h4 className="section-title font-poppins text-lg font-medium mb-2">Total Order Report</h4>
          <div className="order-summary text-gray-700 space-y-1">
            <p><strong>Subtotal:</strong> {selectedOrder.id === 6034 ? "$500" : selectedOrder.id === 6029 ? "$500" : selectedOrder.id === 6031 ? "$300" : "$500"}</p>
            <p><strong>+ Add On:</strong> I don’t require any Add-ons ($0)</p>
            <p><strong>- Discount:</strong> {selectedOrder.id === 6034 ? "$100" : selectedOrder.id === 6029 ? "$200" : selectedOrder.id === 6033 || selectedOrder.id === 6030 ? "$100" : selectedOrder.id === 6031 ? "$60" : "$200"}</p>
            {selectedOrder.id === 6031 && <p><strong>- Wallet:</strong> $240</p>}
            <p><strong>Net Amount:</strong> {selectedOrder.id === 6034 ? "$400" : selectedOrder.id === 6029 ? "$300" : selectedOrder.id === 6033 || selectedOrder.id === 6030 ? "$400" : selectedOrder.id === 6031 ? "$0" : "$300"}</p>
          </div>
          {/* Shipping */}
          <h4 className="section-title font-poppins text-lg font-medium mb-2">Shipping & Billing Details</h4>
          <div className="shipping-details text-gray-700 space-y-1">
            <p><strong>Shipping Address:</strong> Test</p>
            <p><strong>Transaction ID:</strong> {selectedOrder.id === 6034 ? "pay_Q7JW2tPQxjSf3" : selectedOrder.id === 6033 ? "pay_Q7JWatPQxjSf3" : "N/A"}</p>
            <p><strong>Order Status:</strong> Pending</p>
          </div>
        </div>
        {/* Modal Footer */}
        <div className="modal-footer flex justify-end gap-3 border-t border-gray-200 p-4">
          <button
            className="px-4 py-2 rounded-lg text-white shadow"
            style={{ backgroundColor: "#4F46E5" }}
            onClick={handlePrintOrder}
          >
            Print Order As Image
          </button>
          <button
            className="px-4 py-2 rounded-lg text-gray-700 bg-gray-200 hover:bg-gray-300 shadow"
            onClick={() => setSelectedOrder(null)}
          >
            Close
          </button>
        </div>
      </div>
    </div>
    </div>
)}
{/* ✅ COMPLETED ORDERS */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "Completed Orders" &&
  showCompletedOrders &&
  completedOrders && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Completed Wallet Transactions</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
{/* Header */}
            <div
              style={{
                backgroundColor: "#fff",
                padding: "20px",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                marginBottom: "20px",
                textAlign: "center",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontFamily: "'Poppins', sans-serif",
                  fontSize: "24px",
                  fontWeight: "700",
                  color: "#111827",
                }}
              >
                Completed Wallet Transactions
              </h3>
            </div>
            {/* Table Container */}
            <div
              style={{
                backgroundColor: "#fff",
                padding: "20px",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                overflowX: "auto",
              }}
            >
              {/* Controls */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "16px",
                  fontFamily: "'Inter', sans-serif",
                  flexWrap: "wrap",
                  gap: "12px",
                }}
              >
                <label style={{ fontSize: "14px", color: "#374151", display: "flex", alignItems: "center", gap: "8px" }}>
                  Show
                  <select
                    value={rowsPerPageOrders}
                    onChange={(e) => {
                      setRowsPerPageOrders(Number(e.target.value));
                      setCurrentOrdersPage(1);
                    }}
                    style={{
                      padding: "6px 10px",
                      border: "1px solid #D1D5DB",
                      borderRadius: "6px",
                      fontFamily: "'Inter', sans-serif",
                    }}
                  >
                    {[10, 25, 50].map((num) => (
                      <option key={num} value={num}>
                        {num}
                      </option>
                    ))}
                  </select>
                  entries
                </label>
                {/* Column-specific search filters */}
                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", flex: 1 }}>
                  {["transactionId", "participantType", "name", "email", "message", "status"].map((field) => (
                    <input
                      key={field}
                      type="text"
                      placeholder={`Search by ${field.replace(/([A-Z])/g, " $1")}`}
                      value={completedOrdersSearch[field] || ""}
                      onChange={(e) =>
                        setCompletedOrdersSearch((prev) => ({
                          ...prev,
                          [field]: e.target.value,
                        }))
                      }
                      style={{
                        flex: 1,
                        minWidth: "150px",
                        padding: "6px 10px",
                        border: "1px solid #D1D5DB",
                        borderRadius: "6px",
                        fontFamily: "'Inter', sans-serif",
                        fontSize: "14px",
                        height: "40px",
                      }}
                    />
                  ))}
                </div>
              </div>
              {/* Table */}
              {completedOrders.length > 0 ? (
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontFamily: "'Inter', sans-serif",
                    fontSize: "14px",
                    color: "#374151",
                  }}
                >
                  <thead style={{ backgroundColor: "#F9FAFB" }}>
                    <tr>
                      <th style={{ padding: "12px", textAlign: "left" }}>#</th>
                      <th style={{ padding: "12px", textAlign: "left" }}>Wallet ID</th>
                      <th style={{ padding: "12px", textAlign: "left" }}>Type</th>
                      <th style={{ padding: "12px", textAlign: "left" }}>Name</th>
                      <th style={{ padding: "12px", textAlign: "left" }}>Email</th>
                      <th style={{ padding: "12px", textAlign: "left" }}>Message</th>
                      <th style={{ padding: "12px", textAlign: "left" }}>Status</th>
                      <th style={{ padding: "12px", textAlign: "left" }}>Amount</th>
                      <th style={{ padding: "12px", textAlign: "left" }}>Currency</th>
                      <th style={{ padding: "12px", textAlign: "left" }}>Balance After</th>
                      <th style={{ padding: "12px", textAlign: "left" }}>Timestamp</th>
                      <th style={{ padding: "12px", textAlign: "left" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(completedOrders || [])
                      .filter((order) => !deletedOrders.includes(order.transactionId)) // filter deleted
                      .filter((order) => {
                        // Column-specific search
                        return Object.keys(completedOrdersSearch).every((field) => {
                          const value = completedOrdersSearch[field]?.toLowerCase() || "";
                          if (!value) return true;
                          const orderValue = order[field]?.toString().toLowerCase() || "";
                          return orderValue.includes(value);
                        });
                      })
                      .slice(
                        (currentOrdersPage - 1) * rowsPerPageOrders,
                        currentOrdersPage * rowsPerPageOrders
                      )
                      .map((order, index) => (
                        <tr
                          key={order.transactionId || index}
                          style={{
                            borderBottom: "1px solid #E5E7EB",
                            backgroundColor: index % 2 === 0 ? "#fff" : "#F9FAFB",
                          }}
                        >
                          <td style={{ padding: "12px" }}>
                            {index + 1 + (currentOrdersPage - 1) * rowsPerPageOrders}
                          </td>
                          <td style={{ padding: "12px" }}>{order.transactionId}</td>
                          <td style={{ padding: "12px", textTransform: "capitalize" }}>
                            {order.participantType}
                          </td>
                          <td style={{ padding: "12px" }}>{order.name}</td>
                          <td style={{ padding: "12px" }}>{order.email}</td>
                          <td style={{ padding: "12px" }}>{order.message}</td>
                          <td style={{ padding: "12px" }}>
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                padding: "4px 10px",
                                borderRadius: "6px",
                                fontSize: "12px",
                                fontWeight: "600",
                                backgroundColor:
                                  order.message?.toLowerCase().includes("add") || order.status === "Credited"
                                    ? "#10B981"
                                    : "#F59E0B",
                                color: "#fff",
                              }}
                            >
                              {order.status || "Completed"}
                            </span>
                          </td>
                          <td style={{ padding: "12px" }}>{(order.amount ?? 0).toFixed(2)}</td>
                          <td style={{ padding: "12px" }}>{order.currency}</td>
                          <td style={{ padding: "12px" }}>{(order.walletBalance ?? 0).toFixed(2)}</td>
                          <td style={{ padding: "12px" }}>
                            {order.timestamp ? new Date(order.timestamp).toLocaleString() : "—"}
                          </td>
                          <td style={{ padding: "12px" }}>
                            <button
                              onClick={() => handleDeleteOrder(order.transactionId)}
                              style={{
                                backgroundColor: "#DC2626",
                                color: "#fff",
                                padding: "6px 12px",
                                borderRadius: "6px",
                                border: "none",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <FiTrash2 size={16} /> Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              ) : (
                <p
                  style={{
                    fontFamily: "'Inter', sans-serif",
                    fontSize: "14px",
                    color: "#6B7280",
                    textAlign: "center",
                  }}
                >
                  No completed transactions found.
                </p>
              )}
            </div>
          </div>
    </div>
)}
{/* ✅ CANCELLED ORDERS */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "Cancelled Orders" &&
  showCancelledOrders && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Cancelled Order List</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
       {/* Header */}
      <div
        className="category-title-container"
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          Cancelled Order List
        </h3>
      </div>
      {/* Table Container */}
      <div
        className="category-form-container"
        style={{
          backgroundColor: "#fff",
          padding: "30px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          overflowX: "auto",
        }}
      >
        {cancelledOrders.length === 0 ? (
          <p
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: "14px",
              color: "#6B7280",
            }}
          >
            No cancelled orders found.
          </p>
        ) : (
          <table
            className="borderless-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "'Inter', sans-serif",
              fontSize: "14px",
              color: "#374151",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#F9FAFB" }}>
                <th style={{ padding: "12px", textAlign: "left" }}>#</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Order ID</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Order Date</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Status</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Hire Type</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Preview</th>
              </tr>
            </thead>
            <tbody>
              {cancelledOrders.map((order, index) => (
                <tr key={order.id} style={{ borderBottom: "1px solid #E5E7EB", backgroundColor: index % 2 === 0 ? "#fff" : "#fcfcfc" }}>
                  <td style={{ padding: "12px" }}>{index + 1}</td>
                  <td style={{ padding: "12px", fontWeight: "600", color: "#2563EB" }}>{order.id}</td>
                  <td style={{ padding: "12px" }}>{order.date}</td>
                  <td style={{ padding: "12px" }}>
                    <span
                      style={{
                        display: "inline-block",
                        padding: "4px 10px",
                        borderRadius: "6px",
                        fontSize: "12px",
                        fontWeight: "600",
                        backgroundColor: "#DC2626",
                        color: "#fff",
                      }}
                    >
                      Cancelled
                    </span>
                  </td>
                  <td style={{ padding: "12px" }}>{order.hireType || "Random"}</td>
                  <td style={{ padding: "12px" }}>
                    <button
                      onClick={() => setSelectedCancelledOrder(order)}
                      style={{
                        backgroundColor: "#111827",
                        color: "white",
                        padding: "6px 12px",
                        borderRadius: "6px",
                        fontFamily: "'Inter', sans-serif",
                        fontWeight: "600",
                        cursor: "pointer",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <FiEye /> Preview
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  </div>
)}
{/* Cancelled Order Preview Modal */}
{selectedCancelledOrder && (
  <div
    className="modal show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0, 0, 0, 0.5)" }}
    onClick={() => setSelectedCancelledOrder(null)}
  >
    <div
      className="modal-dialog modal-lg"
      role="document"
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="modal-content rounded-2xl shadow-lg"
        style={{ maxHeight: "90vh", overflowY: "auto" }}
      >
        <div className="modal-header border-b px-4 py-3">
          <h5 className="modal-title fw-bold">Order Preview</h5>
          <button
            type="button"
            className="close"
            onClick={() => setSelectedCancelledOrder(null)}
          >
            <span>&times;</span>
          </button>
        </div>
        <div className="modal-body p-4" ref={printRef}>
          <p className="text-xl font-semibold mb-2">Order Details</p>
          <p><strong>Order No:</strong> {selectedCancelledOrder?.id || "N/A"}</p>
          <p><strong>Shipped Date:</strong> {selectedCancelledOrder?.date || "N/A"}</p>
          <p><strong>Mobile Number:</strong> {selectedCancelledOrder?.mobile || "N/A"}</p>
          <p><strong>Customer Name:</strong> {selectedCancelledOrder?.customer || "N/A"}</p>
          <h6 className="fw-bold mt-4">Order Items</h6>
          {selectedCancelledOrder?.items?.length > 0 ? (
            selectedCancelledOrder.items.map((item, idx) => (
              <div
                key={idx}
                style={{
                  padding: "12px",
                  marginBottom: "8px",
                  borderRadius: "8px",
                  backgroundColor: "#F9FAFB",
                  border: "1px solid #E5E7EB",
                }}
              >
                <p><strong>{idx + 1}) {item.name}</strong></p>
                <p><strong>Qty:</strong> {item.qty} x {item.price} $</p>
                <p><strong>Price:</strong> {item.totalPrice} $</p>
              </div>
            ))
          ) : (
            <p>No items found.</p>
          )}
          {selectedCancelledOrder?.error && (
            <p style={{ color: "#DC2626", fontWeight: "600", marginTop: "8px" }}>
              Warning: {selectedCancelledOrder.error}
            </p>
          )}
          <h6 className="fw-bold mt-4">Date & Time Slot Details</h6>
          <p><strong>Date:</strong> {selectedCancelledOrder?.dateSlot || "N/A"}</p>
          <p><strong>Time:</strong> {selectedCancelledOrder?.timeSlot || "N/A"}</p>
          <p><strong>Payment Method:</strong> {selectedCancelledOrder?.paymentMethod || "Cash On Delivery"}</p>
          <p><strong>Category:</strong> {selectedCancelledOrder?.category || "N/A"}</p>
          <h6 className="fw-bold mt-4">Total Order Report</h6>
          <p><strong>Subtotal:</strong> {selectedCancelledOrder?.subtotal || "0 $"}</p>
          <p><strong>+ Add On:</strong> {selectedCancelledOrder?.addOn || "I don't require any Add-ons"}</p>
          <p><strong>- Discount:</strong> {selectedCancelledOrder?.discount || "0 $"}</p>
          <p><strong>Net Amount:</strong> {selectedCancelledOrder?.netAmount || "0 $"}</p>
          <h6 className="fw-bold mt-4">Shipping & Billing Details</h6>
          <p><strong>Shipping Address:</strong> {selectedCancelledOrder?.shippingAddress || "N/A"}</p>
          <p><strong>Order Status:</strong> <span style={{ color: "#DC2626", fontWeight: "600" }}>Cancelled</span></p>
        </div>
        <div className="modal-footer border-t p-3 d-flex justify-content-end gap-2">
          <button
            className="btn btn-dark btn-sm"
            onClick={printOrder}
          >
            Print Order
          </button>
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => setSelectedCancelledOrder(null)}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}
{/* ✅ PARTNER REPORT */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "Manage Partner Report" &&
  showPartnerReport && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Partner Report</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
     <div className="credit-dashboard-section">
      {/* ---------------- PARTNER REPORT SECTION ---------------- */}
      <section className="card mb-4 p-4 rounded-2xl shadow-md bg-white">
        <h2
          className="fw-bold mb-3"
          style={{ fontSize: "24px", fontFamily: "'Poppins', sans-serif" }}
        >
          XXXX Card Report
        </h2>
        <div className="row g-4">
          <div className="col-md-6">
            <div className="card report-card p-3 h-100 rounded-xl shadow-sm bg-white border border-[#E5E7EB]">
              <div className="d-flex align-items-center">
                <div className="icon-container p-2 bg-[#E5E7EB] rounded-lg">
                  <img src="total_order_icon.png" alt="Total Order" className="report-icon" />
                </div>
                <div className="ms-3">
                  <p className="text-muted mb-1 text-sm">Total Orders</p>
                  <h4 className="fw-semibold">{totalOrders}</h4>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card report-card p-3 h-100 rounded-xl shadow-sm bg-white border border-[#E5E7EB]">
              <div className="d-flex align-items-center">
                <div className="icon-container p-2 bg-[#E5E7EB] rounded-lg">
                  <img src="credit_balance_icon.png" alt="Credit Balance" className="report-icon" />
                </div>
                <div className="ms-3">
                  <p className="text-muted mb-1 text-sm">Credit Balance</p>
                  <h4 className="fw-semibold">{creditTransactions.reduce(
                    (total, t) =>
                      t.type === "add" ? total + Math.abs(t.amount) : total - Math.abs(t.amount),
                    0
                  )}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ---------------- PROVIDER DETAILS SECTION ---------------- */}
      <section className="card mb-4 p-4 rounded-2xl shadow-md bg-white">
        <h2 className="fw-bold mb-3" style={{ fontSize: "22px", fontFamily: "'Poppins', sans-serif" }}>
          Provider Details
        </h2>
        <div className="row g-3">
          <div className="col-md-4">
            <label className="form-label text-sm">Provider ID</label>
            <input
              type="text"
              className="form-control rounded-lg border-[#E5E7EB]"
              placeholder="Enter Provider ID"
              value={creditProviderId}
              onChange={(e) => setCreditProviderId(e.target.value)}
              disabled={creditCustomerId !== ""}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label text-sm">Provider Name</label>
            <input
              type="text"
              className="form-control rounded-lg border-[#E5E7EB]"
              placeholder="Enter Provider Name"
              value={creditProviderName}
              onChange={(e) => setCreditProviderName(e.target.value)}
              disabled={creditCustomerId !== ""}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label text-sm">Provider Email</label>
            <input
              type="email"
              className="form-control rounded-lg border-[#E5E7EB]"
              placeholder="Enter Provider Email"
              value={creditProviderEmail}
              onChange={(e) => setCreditProviderEmail(e.target.value)}
              disabled={creditCustomerId !== ""}
            />
          </div>
        </div>
      </section>
      {/* ---------------- CUSTOMER DETAILS SECTION ---------------- */}
      <section className="card mb-4 p-4 rounded-2xl shadow-md bg-white">
        <h2 className="fw-bold mb-3" style={{ fontSize: "22px", fontFamily: "'Poppins', sans-serif" }}>
          Customer Details
        </h2>
        <div className="row g-3">
          <div className="col-md-4">
            <label className="form-label text-sm">Customer ID</label>
            <input
              type="text"
              className="form-control rounded-lg border-[#E5E7EB]"
              placeholder="Enter Customer ID"
              value={creditCustomerId}
              onChange={(e) => setCreditCustomerId(e.target.value)}
              disabled={creditProviderId !== ""}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label text-sm">Customer Name</label>
            <input
              type="text"
              className="form-control rounded-lg border-[#E5E7EB]"
              placeholder="Enter Customer Name"
              value={creditCustomerName}
              onChange={(e) => setCreditCustomerName(e.target.value)}
              disabled={creditProviderId !== ""}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label text-sm">Customer Email</label>
            <input
              type="email"
              className="form-control rounded-lg border-[#E5E7EB]"
              placeholder="Enter Customer Email"
              value={creditCustomerEmail}
              onChange={(e) => setCreditCustomerEmail(e.target.value)}
              disabled={creditProviderId !== ""}
            />
          </div>
        </div>
      </section>
      {/* ---------------- MODIFY CREDIT ---------------- */}
      <section className="card mb-4 p-4 rounded-2xl shadow-md bg-white">
        <h2 className="fw-bold mb-3" style={{ fontSize: "20px", fontFamily: "'Poppins', sans-serif" }}>
          Add or Subtract Credit
        </h2>
        <form>
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label text-sm">Credit Amount</label>
              <input
                type="number"
                className="form-control rounded-lg border-[#E5E7EB]"
                placeholder="Enter Credit"
                value={creditAmount}
                onChange={(e) => setCreditAmount(Number(e.target.value) || 0)}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label text-sm">Select Currency</label>
              <select
                className="form-control rounded-lg border-[#E5E7EB]"
                value={selectedCurrency}
                onChange={(e) => setSelectedCurrency(e.target.value)}
              >
                <option value="USD">USD ($)</option>
                <option value="EUR">EUR (€)</option>
                <option value="GBP">GBP (£)</option>
                <option value="INR">INR (₹)</option>
              </select>
            </div>
            <div className="col-12 d-flex flex-column gap-2 mt-4">
              <button
                type="button"
                className="btn btn-primary rounded-lg shadow-sm d-flex align-items-center justify-content-center gap-1"
                onClick={() => handleModifyCredit("add")}
              >
                <PlusCircle size={16} /> Add Credit
              </button>
              <button
                type="button"
                className="btn btn-danger rounded-lg shadow-sm d-flex align-items-center justify-content-center gap-1"
                onClick={() => handleModifyCredit("subtract")}
              >
                <MinusCircle size={16} /> Subtract Credit
              </button>
            </div>
          </div>
        </form>
      </section>
 {/* ---------------- TRANSACTION TABLE ---------------- */}
<section className="card p-4 rounded-2xl shadow-md bg-white">
  <h2
    className="fw-bold mb-3"
    style={{ fontSize: "20px", fontFamily: "'Poppins', sans-serif" }}
  >
    Credit Transaction Report
  </h2>
  {/* 🔍 COLUMN-SPECIFIC SEARCH FILTERS */}
  <div className="mb-3 d-flex flex-wrap gap-2">
    <input
      type="text"
      placeholder="Search Wallet ID"
      className="form-control rounded-lg border-[#E5E7EB]"
      style={{ minWidth: "150px", flex: "1" }}
      value={walletIdFilter}
      onChange={(e) => setWalletIdFilter(e.target.value)}
    />
    <input
      type="text"
      placeholder="Search Entity ID"
      className="form-control rounded-lg border-[#E5E7EB]"
      style={{ minWidth: "150px", flex: "1" }}
      value={entityIdFilter}
      onChange={(e) => setEntityIdFilter(e.target.value)}
    />
    <input
      type="text"
      placeholder="Search Name"
      className="form-control rounded-lg border-[#E5E7EB]"
      style={{ minWidth: "150px", flex: "1" }}
      value={nameFilter}
      onChange={(e) => setNameFilter(e.target.value)}
    />
    <input
      type="text"
      placeholder="Search Message"
      className="form-control rounded-lg border-[#E5E7EB]"
      style={{ minWidth: "150px", flex: "1" }}
      value={messageFilter}
      onChange={(e) => setMessageFilter(e.target.value)}
    />
    <input
      type="text"
      placeholder="Search Status"
      className="form-control rounded-lg border-[#E5E7EB]"
      style={{ minWidth: "150px", flex: "1" }}
      value={statusFilter}
      onChange={(e) => setStatusFilter(e.target.value)}
    />
    <input
      type="text"
      placeholder="Search Amount"
      className="form-control rounded-lg border-[#E5E7EB]"
      style={{ minWidth: "150px", flex: "1" }}
      value={amountFilter}
      onChange={(e) => setAmountFilter(e.target.value)}
    />
    <input
      type="text"
      placeholder="Search Currency"
      className="form-control rounded-lg border-[#E5E7EB]"
      style={{ minWidth: "150px", flex: "1" }}
      value={currencyFilter}
      onChange={(e) => setCurrencyFilter(e.target.value)}
    />
  </div>
  {/* ---------------- TRANSACTION TABLE ---------------- */}
  <div className="table-responsive">
    <table className="table table-bordered table-hover align-middle">
      <thead className="bg-[#F5F5F7]">
        <tr>
          <th>Sr. No.</th>
          <th>Wallet ID</th>
          <th>Entity ID</th>
          <th>Name</th>
          <th>Message</th>
          <th>Status</th>
          <th>Amount</th>
          <th>Currency</th>
          <th>Entity</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {creditTransactions
          .filter((tx) => {
            return (
              tx.id.toLowerCase().includes(walletIdFilter.toLowerCase()) &&
              tx.entityId.toLowerCase().includes(entityIdFilter.toLowerCase()) &&
              tx.name.toLowerCase().includes(nameFilter.toLowerCase()) &&
              (tx.message || "").toLowerCase().includes(messageFilter.toLowerCase()) &&
              (tx.status || "").toLowerCase().includes(statusFilter.toLowerCase()) &&
              String(tx.amount).includes(amountFilter) &&
              (tx.currency || "").toLowerCase().includes(currencyFilter.toLowerCase())
            );
          })
          .map((transaction, index) => (
            <tr
              key={transaction.firestoreId} // Use Firestore document ID
              className={
                transaction.entityType === "providers"
                  ? "bg-[#E5F3FF]"
                  : "bg-[#FFF5E5]"
              }
            >
              <td>{index + 1}</td>
              <td>{transaction.id}</td>
              <td>{transaction.entityId}</td>
              <td>{transaction.name}</td>
              <td>{transaction.message}</td>
              <td>{transaction.status}</td>
              <td>{transaction.amount}</td>
              <td>{transaction.currency}</td>
              <td>{transaction.entityType === "providers" ? "Provider" : "Customer"}</td>
              <td>
                <button
                  className="btn btn-danger btn-sm rounded-md shadow-sm d-flex align-items-center gap-1"
                  onClick={async () => {
                    if (!transaction.firestoreId) return;
                    try {
                      // 🔹 Delete from Firestore
                      const txnDocRef = doc(
                        db,
                        "creditTransactions",
                        transaction.entityType,
                        "entries",
                        transaction.firestoreId
                      );
                      await deleteDoc(txnDocRef);
                      // 🔹 Remove from UI
                      setCreditTransactions((prev) =>
                        prev.filter((txn) => txn.firestoreId !== transaction.firestoreId)
                      );
                      // 🔹 Toast success
                      toast.success("Transaction deleted successfully!");
                    } catch (error) {
                      console.error("Delete failed:", error);
                      toast.error("Failed to delete transaction.");
                    }
                  }}
                >
                  <Trash2 size={16} /> Delete
                </button>
              </td>
            </tr>
          ))}
        {creditTransactions.length === 0 && (
          <tr>
            <td colSpan="10" className="text-center text-muted">
              No data available in table
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</section>
    </div>
    </div>
  </div>
)}
{/* ✅ SET COMMISSION */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "setCommission" &&
  showSetCommission && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Set Commission</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
        {/* Title */}
      <div
        className="category-title-container"
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          Set Commission
        </h3>
      </div>
      {/* Form Container */}
      <div
        className="category-form-container"
        style={{
          backgroundColor: "#fff",
          padding: "30px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <form onSubmit={handleCommissionSave}>
          {/* Commission Input */}
          <div className="form-group" style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "6px",
                color: "#374151",
                fontWeight: "500",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              Commission
            </label>
            <input
              type="number"
              value={commission}
              onChange={(e) => setCommission(e.target.value)}
              placeholder="Enter Commission"
              required
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                fontFamily: "'Inter', sans-serif",
                outline: "none",
                transition: "all 0.2s",
              }}
            />
          </div>
          {/* Submit Button */}
          <div style={{ marginTop: "20px" }}>
            <button
              type="submit"
              style={{
                width: "100%",
                padding: "12px",
                backgroundColor: "#4F46E5",
                color: "white",
                fontWeight: "600",
                borderRadius: "8px",
                cursor: "pointer",
                fontFamily: "'Inter', sans-serif",
                transition: "all 0.2s",
              }}
            >
              Set Commission
            </button>
          </div>
        </form>
      </div>
    </div>
    </div>
)}
{/* ✅ USER REPORT */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "userReport" &&
  showUserReport && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>User Report</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
      {/* 👉 KEEP YOUR FULL USER REPORT CONTENT HERE (NO CHANGE) */}
      <div className="credit-dashboard-container p-4 space-y-6">
         {/* ------------------- CARD REPORT SECTION ------------------- */}
        <section
          className="card-report-section bg-white p-6 rounded-2xl shadow-sm border border-[#E5E7EB]"
          style={{ marginBottom: "20px" }}
        >
          <div className="report-title mb-4">
            <h2
              style={{
                fontFamily: "'Poppins', sans-serif",
                fontSize: "24px",
                fontWeight: "700",
                margin: 0,
              }}
            >
              Wallet Summary Report
            </h2>
          </div>
          <div
            className="report-card-grid"
            style={{
              display: "flex",
              gap: "16px",
              flexWrap: "wrap",
              alignItems: "stretch",
            }}
          >
            <div
              className="report-card"
              style={{
                flex: "1 1 0",
                padding: "20px",
                borderRadius: "12px",
                backgroundColor: "#F9FAFB",
                boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                border: "1px solid #E5E7EB",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <h6 className="text-muted">Total Orders</h6>
              <h4 style={{ fontWeight: 600 }}>{totalOrders ?? 0}</h4>
            </div>
            <div
              className="report-card"
              style={{
                flex: "1 1 0",
                padding: "20px",
                borderRadius: "12px",
                backgroundColor: "#F9FAFB",
                boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                border: "1px solid #E5E7EB",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <h6 className="text-muted">
                Wallet Balance {currency ? `(${currency})` : ""}
              </h6>
              <h4 style={{ fontWeight: 600 }}>
                {typeof walletBalance === "number" && !isNaN(walletBalance)
                  ? walletBalance.toFixed(2)
                  : "0.00"}
              </h4>
            </div>
          </div>
        </section>
        {/* ------------------- WALLET BALANCE MANAGEMENT ------------------- */}
        <section
          className="balance-management bg-white p-6 rounded-2xl shadow-sm border border-[#E5E7EB]"
          style={{ marginBottom: "20px" }}
        >
          <h3
            style={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: "20px",
              fontWeight: "700",
              marginBottom: "16px",
            }}
          >
            Add / Subtract Balance (Providers & Customers)
          </h3>
          <form
            className="balance-form w-100"
            onSubmit={(e) => e.preventDefault()}
            style={{ display: "flex", flexDirection: "column", gap: "16px" }}
          >
            {/* Input Fields */}
            <div
              className="row g-3"
              style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}
            >
              <div className="col-md-4" style={{ flex: "1 1 30%" }}>
                <label className="form-label text-sm">Amount</label>
                <input
                  type="number"
                  className="form-control rounded-lg border-[#E5E7EB]"
                  placeholder="Enter Amount"
                  value={transactionAmount ?? ""}
                  onChange={(e) =>
                    setTransactionAmount(Math.max(0, Number(e.target.value) || 0))
                  }
                  required
                />
              </div>
              <div className="col-md-4" style={{ flex: "1 1 30%" }}>
                <label className="form-label text-sm">Currency</label>
                <select
                  className="form-control rounded-lg border-[#E5E7EB]"
                  value={currency}
                  onChange={(e) => setCurrency(e.target.value)}
                  required
                >
                  <option value="USD">USD ($)</option>
                  <option value="EUR">EUR (€)</option>
                  <option value="GBP">GBP (£)</option>
                </select>
              </div>
              <div className="col-md-4" style={{ flex: "1 1 30%" }}>
                <label className="form-label text-sm">Participant Type</label>
                <select
                  className="form-control rounded-lg border-[#E5E7EB]"
                  value={participantType}
                  onChange={(e) => setParticipantType(e.target.value)}
                  required
                >
                  <option value="provider">Provider</option>
                  <option value="customer">Customer</option>
                </select>
              </div>
            </div>
            {/* ID, Email, Name */}
            <div
              className="row g-3"
              style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}
            >
              <div className="col-md-4" style={{ flex: "1 1 30%" }}>
                <label className="form-label text-sm">ID</label>
                <input
                  type="text"
                  className="form-control rounded-lg border-[#E5E7EB]"
                  placeholder="Enter ID"
                  value={participantId ?? ""}
                  onChange={(e) => setParticipantId(e.target.value)}
                  required
                />
              </div>
              <div className="col-md-4" style={{ flex: "1 1 30%" }}>
                <label className="form-label text-sm">Email</label>
                <input
                  type="email"
                  className="form-control rounded-lg border-[#E5E7EB]"
                  placeholder="Enter Email"
                  value={participantEmail ?? ""}
                  onChange={(e) => setParticipantEmail(e.target.value)}
                  required
                />
              </div>
              <div className="col-md-4" style={{ flex: "1 1 30%" }}>
                <label className="form-label text-sm">Name</label>
                <input
                  type="text"
                  className="form-control rounded-lg border-[#E5E7EB]"
                  placeholder="Enter Name"
                  value={participantName ?? ""}
                  onChange={(e) => setParticipantName(e.target.value)}
                  required
                />
              </div>
            </div>
            {/* Action Buttons */}
            <div
              className="mt-4"
              style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}
            >
              <button
                type="button"
                className="btn btn-primary flex-grow-1 d-flex align-items-center justify-content-center gap-2 rounded-lg shadow-sm"
                style={{ minHeight: "50px" }}
                onClick={async () => {
                  await handleModifyWallet("add"); // save to Provider_Wallet / Customer_Wallet
                  setParticipantId("");
                  setParticipantName("");
                  setParticipantEmail("");
                  setTransactionAmount("");
                }}
              >
                <PlusCircle size={16} /> Add Amount
              </button>
              <button
                type="button"
                className="btn btn-danger flex-grow-1 d-flex align-items-center justify-content-center gap-2 rounded-lg shadow-sm"
                style={{ minHeight: "50px" }}
                onClick={async () => {
                  await handleModifyWallet("subtract"); // save to Provider_Wallet / Customer_Wallet
                  setParticipantId("");
                  setParticipantName("");
                  setParticipantEmail("");
                  setTransactionAmount("");
                }}
              >
                <MinusCircle size={16} /> Subtract Amount
              </button>
            </div>
          </form>
        </section>
{/* ------------------- WALLET TRANSACTION REPORT ------------------- */}
<section
  className="transaction-table-container bg-white p-6 rounded-2xl shadow-sm border border-[#E5E7EB]"
  style={{ marginBottom: "20px" }}
>
  {/* Header Section */}
  <div
    className="category-title-container"
    style={{
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      marginBottom: "20px",
      textAlign: "center",
    }}
  >
    <h2
      style={{
        margin: 0,
        fontFamily: "'Poppins', sans-serif",
        fontSize: "24px",
        fontWeight: "700",
        color: "#111827",
      }}
    >
      Wallet Transactions (Providers & Customers)
    </h2>
  {/* Responsive equal-width search boxes */}
<div
  style={{
    display: "flex",
    flex: 1,
    gap: "8px",
    flexWrap: "wrap",
    marginBottom: "12px",
  }}
>
  {[
    { placeholder: "Wallet ID", value: searchWalletId, setter: setSearchWalletId },
    { placeholder: "Type", value: searchWalletType, setter: setSearchWalletType },
    { placeholder: "Name", value: searchWalletName, setter: setSearchWalletName },
    { placeholder: "Email", value: searchWalletEmail, setter: setSearchWalletEmail },
    { placeholder: "Message", value: searchWalletMessage, setter: setSearchWalletMessage },
    { placeholder: "Transaction Status", value: searchWalletTxnStatus, setter: setSearchWalletTxnStatus },
    { placeholder: "Amount", value: searchWalletAmount, setter: setSearchWalletAmount },
    { placeholder: "Currency", value: searchWalletCurrency, setter: setSearchWalletCurrency },
    { placeholder: "Balance After", value: searchWalletBalance, setter: setSearchWalletBalance },
  ].map(({ placeholder, value, setter }, idx) => (
    <input
      key={idx}
      type="text"
      placeholder={`Search ${placeholder}...`}
      value={value}
      onChange={(e) => setter(e.target.value)}
      className="form-control rounded-lg border-[#D1D5DB]"
      style={{
        flex: "1 1 150px", // equal-width, wraps responsively
        minWidth: "150px",
        maxWidth: "200px",
        height: "38px",
        padding: "6px 10px",
        fontFamily: "'Inter', sans-serif",
        fontSize: "13px",
      }}
    />
  ))}
</div>
  </div>
  <div className="table-responsive mt-3">
    <table className="table table-bordered table-hover w-100 align-middle">
      <thead className="bg-[#F5F5F7]">
        <tr>
          <th>#</th>
          <th>Wallet ID</th>
          <th>Type</th>
          <th>Name</th>
          <th>Email</th>
          <th>Message</th>
          <th>Status</th>
          <th>Amount</th>
          <th>Currency</th>
          <th>Balance After</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {(walletTransactions || [])
          .filter((txn = {}) => {
            return (
              (txn.id ?? "").toLowerCase().includes(searchWalletId.toLowerCase()) &&
              (txn.participantType ?? "").toLowerCase().includes(searchWalletType.toLowerCase()) &&
              (txn.name ?? "").toLowerCase().includes(searchWalletName.toLowerCase()) &&
              (txn.email ?? "").toLowerCase().includes(searchWalletEmail.toLowerCase()) &&
              (txn.message ?? "").toLowerCase().includes(searchWalletMessage.toLowerCase()) &&
              (txn.status ?? "").toLowerCase().includes(searchWalletTxnStatus.toLowerCase()) &&
              String(txn.amount ?? "").includes(searchWalletAmount) &&
              (txn.currency ?? "").toLowerCase().includes(searchWalletCurrency.toLowerCase()) &&
              String(txn.walletBalanceAfter ?? "").includes(searchWalletBalance)
            );
          })
          .map((txn, index) => {
            const amountDisplay =
              txn.amount != null && !isNaN(Number(txn.amount)) ? Number(txn.amount).toFixed(2) : "0.00";
            const balanceDisplay =
              txn.walletBalanceAfter != null && !isNaN(Number(txn.walletBalanceAfter))
                ? Number(txn.walletBalanceAfter).toFixed(2)
                : "0.00";
            return (
              <tr key={txn.transactionId ?? `${txn.id}-${index}`}>
                <td>{index + 1}</td>
                <td>{txn.id}</td>
                <td>{txn.participantType}</td>
                <td>{txn.name}</td>
                <td>{txn.email}</td>
                <td>{txn.message}</td>
                <td>{txn.status}</td>
                <td>{amountDisplay}</td>
                <td>{txn.currency ?? ""}</td>
                <td>{balanceDisplay}</td>
                <td>
                  <button
                    className="btn btn-danger btn-sm d-flex align-items-center gap-1 rounded-md shadow-sm"
                    onClick={async () => {
                      if (!txn.transactionId || !txn.participantType) return;
                      try {
                        const collectionName =
                          txn.participantType.toLowerCase() === "provider"
                            ? "Provider_Wallet"
                            : "Customer_Wallet";
                        // Delete from Firestore
                        await deleteDoc(doc(db, collectionName, txn.transactionId));
                        // Remove from UI
                        setWalletTransactions((prev) =>
                          prev.filter((t) => t.transactionId !== txn.transactionId)
                        );
                        toast.success("Transaction deleted successfully!");
                      } catch (error) {
                        console.error("Delete failed:", error);
                        toast.error("Failed to delete transaction.");
                      }
                    }}
                  >
                    <Trash2 size={16} /> Remove
                  </button>
                </td>
              </tr>
            );
          })}
        {(walletTransactions || []).length === 0 && (
          <tr>
            <td colSpan="11" className="text-center text-muted">
              No transactions found
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</section>
   </div>
      </div>
    </div>
)}
{/* ✅ MAKE DECISION */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "makeDecision" &&
  showMakeDecision && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Make a Decision</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
       {/* Title */}
      <div
        className="category-title-container"
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          ACCEPT OR REJECT ORDER
        </h3>
      </div>
      {/* Form Container */}
      <div
        className="category-form-container"
        style={{
          backgroundColor: "#fff",
          padding: "30px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <form onSubmit={handleDecisionSubmit} style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {/* Order ID */}
          <div className="form-group">
            <label
              style={{
                display: "block",
                marginBottom: "6px",
                color: "#374151",
                fontWeight: "500",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              Order ID
            </label>
            <input
              type="text"
              name="orderId"
              required
              value={orderId}
              onChange={(e) => setOrderId(e.target.value)}
              placeholder="Enter Order ID"
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                fontFamily: "'Inter', sans-serif",
                outline: "none",
                transition: "all 0.2s",
                boxSizing: "border-box",
              }}
            />
          </div>
          {/* Status */}
          <div className="form-group">
            <label
              style={{
                display: "block",
                marginBottom: "6px",
                color: "#374151",
                fontWeight: "500",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              Select Status
            </label>
            <select
              name="status"
              required
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                fontFamily: "'Inter', sans-serif",
                outline: "none",
                transition: "all 0.2s",
                boxSizing: "border-box",
              }}
            >
              <option value="">Select a Status</option>
              <option value="accepted">Accept</option>
              <option value="rejected">Reject</option>
            </select>
          </div>
          {/* Provider Category */}
          <div className="form-group">
            <label
              style={{
                display: "block",
                marginBottom: "6px",
                color: "#374151",
                fontWeight: "500",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              Provider Category
            </label>
            <select
              name="providerId"
              required
              value={providerId}
              onChange={(e) => setProviderId(e.target.value)}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                fontFamily: "'Inter', sans-serif",
                outline: "none",
                transition: "all 0.2s",
                boxSizing: "border-box",
              }}
            >
              <option value="">Select Provider Category</option>
              <option value="Ac_Repair">Ac_Repair</option>
              <option value="Clerk">Clerk</option>
              <option value="Doctor">Doctor</option>
              <option value="Patient">Patient</option>
              <option value="Pest Control">Pest Control</option>
              <option value="Plumber">Plumber</option>
              <option value="SalesMan">SalesMan</option>
              <option value="Salon">Salon</option>
              <option value="Smart Home">Smart Home</option>
            </select>
          </div>
          {/* Comment */}
          <div className="form-group">
            <label
              style={{
                display: "block",
                marginBottom: "6px",
                color: "#374151",
                fontWeight: "500",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              Comment
            </label>
            <textarea
              name="comment"
              required
              rows="4"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Enter your comments..."
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                fontFamily: "'Inter', sans-serif",
                outline: "none",
                transition: "all 0.2s",
                boxSizing: "border-box",
              }}
            />
          </div>
          {/* Credit (Admin Only) */}
          {auth.currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" && (
            <div className="form-group">
              <label
                style={{
                  display: "block",
                  marginBottom: "6px",
                  color: "#374151",
                  fontWeight: "500",
                  fontFamily: "'Inter', sans-serif",
                }}
              >
                Credit Required For This Order?
              </label>
              <input
                type="number"
                name="credit"
                required
                value={credit}
                onChange={(e) => setCredit(e.target.value)}
                placeholder="Enter credit amount"
                style={{
                  width: "100%",
                  padding: "12px",
                  borderRadius: "8px",
                  border: "1px solid #D1D5DB",
                  fontFamily: "'Inter', sans-serif",
                  outline: "none",
                  transition: "all 0.2s",
                  boxSizing: "border-box",
                }}
              />
            </div>
          )}
         {/* Action Buttons */}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "10px" }}>
          <button
            type="submit"
            style={{
              backgroundColor: "#4F46E5",
              color: "#fff",
              padding: "12px 24px",
              borderRadius: "8px",
              fontFamily: "'Inter', sans-serif",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
          >
            Submit Decision
          </button>
          <button
            type="button"
            onClick={() => setShowDecisionForm(false)}
            style={{
              backgroundColor: "#6b7280",
              color: "#fff",
              padding: "12px 24px",
              borderRadius: "8px",
              fontFamily: "'Inter', sans-serif",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
          >
            Cancel
          </button>
          </div>
        </form>
      </div>
    </div>
    </div>
)}
{/* ✅ ADD BANNER */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "addBanner" &&
  showAddBannerForm && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Add Banner</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
      {/* Header */}
      <div
        className="category-title-container"
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          Add Banner
        </h3>
      </div>
      {/* Form Container */}
      <div
        className="category-form-container"
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <form
          id="banner-form"
          onSubmit={async (e) => {
            e.preventDefault();
            try {
              await addDoc(collection(db, "banners"), {
                imageName: bannerImage || null,
                videoName: bannerVideo || null,
                serviceCategory: serviceCategory,
                bannerStatus: bannerStatus,
                createdAt: serverTimestamp(),
              });
              toast.success("Banner added successfully!");
              setBannerImage("");
              setBannerVideo("");
              setServiceCategory("");
              setBannerStatus("Publish");
              document.getElementById("banner-form").reset();
            } catch (error) {
              console.error("Error adding banner:", error);
              toast.error("Failed to add banner");
            }
          }}
          style={{ display: "flex", flexDirection: "column", gap: "16px" }}
        >
          {/* Banner Image Upload */}
          <div className="form-group">
            <label
              style={{
                fontFamily: "'Inter', sans-serif",
                fontWeight: "500",
                color: "#374151",
              }}
            >
              Banner Image
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) setBannerImage(file.name);
              }}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                fontFamily: "'Inter', sans-serif",
                outline: "none",
              }}
            />
          </div>
          {/* Banner Video Upload */}
          <div className="form-group">
            <label
              style={{
                fontFamily: "'Inter', sans-serif",
                fontWeight: "500",
                color: "#374151",
              }}
            >
              Banner Video
            </label>
            <input
              type="file"
              accept="video/*"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) setBannerVideo(file.name);
              }}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                fontFamily: "'Inter', sans-serif",
                outline: "none",
              }}
            />
          </div>
          {/* Service Category Dropdown */}
          <div className="form-group">
            <label
              style={{
                fontFamily: "'Inter', sans-serif",
                fontWeight: "500",
                color: "#374151",
              }}
            >
              Select Service Category
            </label>
            <select
              value={serviceCategory}
              onChange={(e) => setServiceCategory(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                fontFamily: "'Inter', sans-serif",
                outline: "none",
              }}
            >
              <option value="">Select Service Category</option>
              <option value="Ac_Repair">Ac Repair</option>
              <option value="Clerk">Clerk</option>
              <option value="Patient">Patient</option>
              <option value="PestControl">Pest Control</option>
              <option value="Plumber">Plumber</option>
              <option value="Salon">Salon</option>
              <option value="Smart Home">Smart Home</option>
              <option value="SwimmingPool">Swimming Pool</option>
              <option value="Typing">Typing</option>
              <option value="Doctor">Doctor</option>
            </select>
          </div>
          {/* Banner Status Dropdown */}
          <div className="form-group">
            <label
              style={{
                fontFamily: "'Inter', sans-serif",
                fontWeight: "500",
                color: "#374151",
              }}
            >
              Banner Status
            </label>
            <select
              value={bannerStatus}
              onChange={(e) => setBannerStatus(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                fontFamily: "'Inter', sans-serif",
                outline: "none",
              }}
            >
              <option value="Publish">Publish</option>
              <option value="Unpublish">Unpublish</option>
            </select>
          </div>
          {/* Action Buttons */}
          <div
            className="button-group"
            style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          >
            <button
              type="submit"
              style={{
                backgroundColor: "#4F46E5",
                color: "#fff",
                padding: "12px 24px",
                borderRadius: "8px",
                fontFamily: "'Inter', sans-serif",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.2s",
              }}
            >
              Add Banner
            </button>
          <button
  type="button"
  onClick={() => setShowAddBannerForm(false)}
  style={{
    backgroundColor: "#DC2626", // red background
    color: "#fff",               // white text
    border: "1px solid #DC2626", // red border to match background
    padding: "12px 24px",
    borderRadius: "8px",
    fontFamily: "'Inter', sans-serif",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s",
  }}
>
  Cancel
</button>
          </div>
        </form>
      </div>
    </div>
    </div>
)}
{/* ✅ LIST BANNER */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "listBanner" &&
  showListBanner && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>List Banner</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
       {/* Header Section */}
    <div
      className="category-title-container"
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        marginBottom: "20px",
        textAlign: "center",
      }}
    >
      <h3
        style={{
          fontFamily: "'Poppins', sans-serif",
          fontWeight: "700",
          fontSize: "24px",
          color: "#111827",
          margin: 0,
        }}
      >
        Banner List
      </h3>
    </div>
    {/* Table Container */}
    <div
      className="category-form-container"
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        overflowX: "auto",
      }}
    >
      {banners.length > 0 ? (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontFamily: "'Inter', sans-serif",
            fontSize: "14px",
            color: "#374151",
          }}
        >
          <thead style={{ backgroundColor: "#F9FAFB" }}>
            <tr>
              <th style={{ padding: "12px", textAlign: "left" }}>#</th>
              <th style={{ padding: "12px", textAlign: "left" }}>Banner Image</th>
              <th style={{ padding: "12px", textAlign: "left" }}>Main Category</th>
              <th style={{ padding: "12px", textAlign: "left" }}>Sub Category</th>
              <th style={{ padding: "12px", textAlign: "left" }}>Child Category</th>
              <th style={{ padding: "12px", textAlign: "center" }}>Status</th>
              <th style={{ padding: "12px", textAlign: "center" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {banners.map((banner, index) => (
              <tr
                key={banner.id || index}
                style={{
                  borderBottom: "1px solid #E5E7EB",
                  backgroundColor: index % 2 === 0 ? "#fff" : "#F9FAFB",
                }}
              >
                <td style={{ padding: "12px" }}>{index + 1}</td>
                <td style={{ padding: "12px" }}>
                  {editingBannerId === banner.id ? (
                    <input
                      type="text"
                      value={editedBanner.image}
                      onChange={handleInputChange}
                      style={{
                        width: "100%",
                        padding: "6px 10px",
                        border: "1px solid #D1D5DB",
                        borderRadius: "6px",
                        fontFamily: "'Inter', sans-serif",
                      }}
                    />
                  ) : (
                    <BannerImage src={banner.image} />
                  )}
                </td>
                <td style={{ padding: "12px" }}>
                  {editingBannerId === banner.id ? (
                    <input
                      type="text"
                      value={editedBanner.mainCategory}
                      onChange={handleInputChange}
                      style={{
                        width: "100%",
                        padding: "6px 10px",
                        border: "1px solid #D1D5DB",
                        borderRadius: "6px",
                        fontFamily: "'Inter', sans-serif",
                      }}
                    />
                  ) : (
                    banner.mainCategory
                  )}
                </td>
                <td style={{ padding: "12px" }}>
                  {editingBannerId === banner.id ? (
                    <input
                      type="text"
                      value={editedBanner.subCategory}
                      onChange={handleInputChange}
                      style={{
                        width: "100%",
                        padding: "6px 10px",
                        border: "1px solid #D1D5DB",
                        borderRadius: "6px",
                        fontFamily: "'Inter', sans-serif",
                      }}
                    />
                  ) : (
                    banner.subCategory
                  )}
                </td>
                <td style={{ padding: "12px" }}>
                  {editingBannerId === banner.id ? (
                    <input
                      type="text"
                      value={editedBanner.childCategory}
                      onChange={handleInputChange}
                      style={{
                        width: "100%",
                        padding: "6px 10px",
                        border: "1px solid #D1D5DB",
                        borderRadius: "6px",
                        fontFamily: "'Inter', sans-serif",
                      }}
                    />
                  ) : (
                    banner.childCategory
                  )}
                </td>
                <td style={{ padding: "12px", textAlign: "center" }}>
                  {editingBannerId === banner.id ? (
                    <select
                      value={editedBanner.status}
                      onChange={(e) => handleStatusChange(e, banner.id)}
                      style={{
                        padding: "6px 10px",
                        border: "1px solid #D1D5DB",
                        borderRadius: "6px",
                        fontFamily: "'Inter', sans-serif",
                        outline: "none",
                      }}
                    >
                      <option value="Published">Published</option>
                      <option value="Unpublished">Unpublished</option>
                    </select>
                  ) : (
                    <span
                      style={{
                        display: "inline-block",
                        padding: "4px 10px",
                        borderRadius: "6px",
                        fontSize: "12px",
                        fontWeight: "600",
                        backgroundColor:
                          banner.status === "Published" ? "#10B981" : "#DC2626",
                        color: "#fff",
                      }}
                    >
                      {banner.status}
                    </span>
                  )}
                </td>
                <td
                  style={{
                    padding: "12px",
                    textAlign: "center",
                    display: "flex",
                    gap: "6px",
                    justifyContent: "center",
                  }}
                >
                  {editingBannerId === banner.id ? (
                    <button
                      onClick={handleSaveEdit}
                      style={{
                        backgroundColor: "#10B981",
                        color: "#fff",
                        padding: "8px 14px",
                        borderRadius: "6px",
                        border: "none",
                        cursor: "pointer",
                        fontFamily: "'Inter', sans-serif",
                        fontWeight: "600",
                        transition: "all 0.2s",
                      }}
                    >
                      <FontAwesomeIcon icon={faEdit} /> Save
                    </button>
                  ) : (
                    <>
                      <button
                        onClick={() => handleEdit(banner.id)}
                        style={{
                          backgroundColor: "#2563EB",
                          color: "#fff",
                          padding: "8px 14px",
                          borderRadius: "6px",
                          border: "none",
                          cursor: "pointer",
                          fontFamily: "'Inter', sans-serif",
                          fontWeight: "600",
                          transition: "all 0.2s",
                        }}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                      <button
                        onClick={() => handleDeleteBanner(banner.id)}
                        style={{
                          backgroundColor: "#DC2626",
                          color: "#fff",
                          padding: "8px 14px",
                          borderRadius: "6px",
                          border: "none",
                          cursor: "pointer",
                          fontFamily: "'Inter', sans-serif",
                          fontWeight: "600",
                          transition: "all 0.2s",
                        }}
                      >
                        <FontAwesomeIcon icon={faTrashAlt} />
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div
          style={{
            textAlign: "center",
            padding: "20px",
            fontFamily: "'Inter', sans-serif",
            color: "#6B7280",
          }}
        >
          No banners available
        </div>
      )}
    </div>
    </div>
  </div>
)}
{/* ✅ PARTNER LIST */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "partnerList" &&
  showPartnerList && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Partner List</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
     {/* Header + File Upload Section */}
      <div
        className="category-title-container mb-6 flex flex-col md:flex-row items-center justify-between gap-4"
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <div className="card-section flex justify-between items-center mb-4">
          <h3
            className="fw-bold mb-0"
            style={{ fontFamily: "'Poppins', sans-serif", fontSize: "22px" }}
          >
            Partner List
          </h3>
          {/* Restore All Partners */}
          <button
            onClick={handleRestoreAllPartners}
            className="btn btn-primary bg-[#4F46E5] hover:bg-[#4338CA] text-white rounded-xl shadow-sm px-1 py-[5px] cursor-pointer transition flex items-center gap-1"
            title="Restore All Partners"
          >
            🔄 Restore All
          </button>
        </div>
        {/* File Upload & View */}
        <div className="flex items-center gap-2">
          <label
            htmlFor="fileUpload"
            className="btn btn-primary bg-[#4F46E5] hover:bg-[#4338CA] text-white rounded-xl shadow-sm px-4 py-2 cursor-pointer transition"
          >
            Upload File
          </label>
          <input type="file" id="fileUpload" hidden onChange={handleFileUpload} />
          {uploadedFileURL && (
            <a
              href={uploadedFileURL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline-success border border-[#10B981] text-[#10B981] hover:bg-[#10B981] hover:text-white rounded-xl shadow-sm px-4 py-2 transition"
            >
              View File
            </a>
          )}
        </div>
      </div>
      {/* Partner Table */}
      <div className="table-responsive bg-white rounded-2xl shadow-md border border-[#E5E7EB] p-4 overflow-auto">
        <table className="table table-striped table-borderless align-middle mb-0 text-sm text-gray-700 w-full">
          <thead className="bg-[#F9FAFB] text-gray-600 uppercase text-xs border-b border-gray-200">
            <tr>
              <th className="px-3 py-2 text-left">#</th>
              <th className="px-3 py-2 text-left">Full Name</th>
              <th className="px-3 py-2 text-left">Email</th>
              <th className="px-3 py-2 text-left">Wallet Balance</th>
              <th className="px-3 py-2 text-left">Mobile</th>
              <th className="px-3 py-2 text-left">User Type</th>
              <th className="px-3 py-2 text-left">Username</th>
              <th className="px-3 py-2 text-left">User Storage Image</th>
              <th className="px-3 py-2 text-left">Status</th>
              <th className="px-3 py-2 text-left">Referred By</th>
              <th className="px-3 py-2 text-left">Referred By ID</th>
              <th className="px-3 py-2 text-left">Approval</th>
              <th className="px-3 py-2 text-left">Action</th>
            </tr>
          </thead>
          <tbody>
            {partners
              .filter((p) => !removedPartnerIds.includes(p.id))
              .map((partner, index) => {
                let imageSrc = "/images/default-user.png";
                if (partner.fullName === "John Doe") imageSrc = "/images/john.png";
                else if (partner.fullName === "Rushita") imageSrc = "/images/rushita.png";
                else if (partner?.storageImage && partner.storageImage !== "Default Storage")
                  imageSrc = partner.storageImage;

                return (
                  <tr
                    key={partner.id || index}
                    className={index % 2 === 0 ? "bg-white" : "bg-[#F9FAFB]"}
                  >
                    <td className="px-3 py-2">{index + 1}</td>
                    <td className="px-3 py-2">{partner.fullName}</td>
                    <td className="px-3 py-2">{partner.email || "N/A"}</td>
                    <td className="px-3 py-2">
                      <span className="bg-green-100 text-green-800 px-2 py-1 rounded-lg font-semibold inline-block">
                        💷 £{partner.walletBalance ?? 0}
                      </span>
                    </td>
                    <td className="px-3 py-2">{partner.mobile || "N/A"}</td>
                    <td className="px-3 py-2">{partner.user_type || "N/A"}</td>
                    <td className="px-3 py-2">{partner.username || "N/A"}</td>
                    <td className="px-3 py-2">
                      <img
                        src={partner.userStorageImage || imageSrc}
                        alt={partner.fullName}
                        className="w-12 h-12 rounded-full border border-gray-200"
                      />
                    </td>
                    <td className="px-3 py-2">
                      <span
                        className={`px-2 py-1 rounded-lg text-xs font-medium ${
                          partner.status === "active"
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        {partner.status}
                      </span>
                    </td>
                    <td className="px-3 py-2">{partner.referredByCode || "—"}</td>
                    <td className="px-3 py-2">{partner.referredById || "—"}</td>
                    <td className="px-3 py-2">
                      <span
                        style={{
                          backgroundColor: "#000000",
                          color: "#FFFFFF",
                          padding: "4px 8px",
                          borderRadius: "6px",
                          fontSize: "12px",
                          fontWeight: 500,
                          display: "inline-block",
                        }}
                      >
                        {partner.approval_status}
                      </span>
                    </td>
                    {/* ACTION BUTTONS */}
                    <td className="px-3 py-2 flex flex-wrap gap-2">
                      <div className="flex flex-wrap gap-2 mb-1">
                        <button
                          className="btn btn-danger btn-sm bg-red-500 hover:bg-red-600 text-white rounded-lg shadow-sm px-2 py-1"
                          onClick={(e) => {
                            e.stopPropagation();
                            const confirmRemove = window.confirm(
                              `Are you sure you want to remove partner "${partner.fullName}"?`
                            );
                            if (confirmRemove) {
                              setRemovedPartnerIds((prev) => {
                                const updated = [...prev, partner.id];
                                localStorage.setItem(
                                  "removedPartnerIds",
                                  JSON.stringify(updated)
                                );
                                return updated;
                              });
                              setShowAvailability(false);
                            }
                          }}
                          title="Remove"
                        >
                          🗑
                        </button>
                       {/* 📊 Manage Report */}
<button
  onClick={(e) => {
    e.stopPropagation();
    handleManagePartnerReport(partner);
    // Navigate to Manage Partner Report section
    setCurrentView("Manage Partner Report");
    setActiveButton("Manage Partner Report");
    // Control visibility
    setShowManagePartnerReport(true);
    setShowCustomerList(false);
    setShowAvailability(false);
  }}
  style={{ backgroundColor: "#4F46E5", color: "white" }}
  className="px-2 py-1 rounded shadow-sm"
  title="Manage Report"
>
  📊
</button>
                   {/* 👁 View Verification */}
<button
  onClick={(e) => {
    e.stopPropagation();
    setSelectedPartnerForVerification(partner); // store partner
    setShowVerificationModal(true); // open modal
  }}
  style={{ backgroundColor: "#7C3AED", color: "white" }}
  className="px-3 py-2 rounded hover:bg-[#6D28D9] transition duration-200 shadow-sm"
  title="View Verification & Compliance"
>
  👁
</button>
                       <button
  className="btn btn-sm text-white rounded-lg shadow-sm px-2 py-1 transition duration-200"
  onClick={(e) => e.stopPropagation()}
  style={{ backgroundColor: "#6B7280" }} // gray-500
  onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#4B5563")} // gray-600 hover
  onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#6B7280")}
  title="Payments"
>
  $
</button>
                        <button
                          className="btn btn-danger btn-sm bg-red-400 hover:bg-red-500 text-white rounded-lg shadow-sm px-2 py-1"
                          onClick={(e) => e.stopPropagation()}
                          title="Reset"
                        >
                          🔄
                        </button>
                        <button
  onClick={(e) => {
    e.stopPropagation();
    handleSetCommission(partner);
    // Navigate to Set Commission section
    setCurrentView("setCommission");
    setActiveButton("setCommission");
    // Control visibility
    setShowSetCommission(true);
    setShowPartnerList(false);
    setShowAvailability(false);
  }}
  style={{ backgroundColor: "#000000", color: "white" }}
  className="px-2 py-1 rounded shadow-sm"
  title="Set Commission"
>
  💰
</button>
                      </div>
                      <div className="flex flex-wrap gap-2">
                        <button
  className="btn btn-info btn-sm bg-sky-500 hover:bg-sky-600 text-white rounded-lg shadow-sm px-2 py-1"
  onClick={(e) => {
    e.stopPropagation();
    setSelectedPartner(partner);
    // navigate to send notification section
    setCurrentView("sendNotification");
    // hide other sections
    setShowPartnerList(false);
    setShowAvailability(false);
    // show send notification
    setShowSendNotification(true);
  }}
  title="Send Notification"
>
  🔔
</button>
                       <button
  className="btn btn-primary btn-sm bg-blue-500 hover:bg-blue-600 text-white rounded-lg shadow-sm px-2 py-1"
  onClick={(e) => {
    e.stopPropagation();
    setSelectedPartner(partner);
    // navigate to Activate Chat section
    setCurrentView("activateChat");
    // hide other sections
    setShowPartnerList(false);
    setShowAvailability(false);

    // show Activate Chat
    setShowChatActivation("activate-chat");
  }}
  title="Activate Chat"
>
  💬
</button>
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
    </div>
)}
{/* ✅ ADD CREDIT PACKAGE */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "addCreditPackage" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Add Credit Package</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
      {/* Title Section */}
      <div className="category-title-container mb-6">
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(48, 29, 29, 0.1)",
            textAlign: "center",
          }}
        >
          <h3
            style={{
              margin: 0,
              fontFamily: "'Poppins', sans-serif",
              fontSize: "22px",
              fontWeight: "700",
              color: "#111827",
            }}
          >
            Add Credit Package
          </h3>
        </div>
      </div>
      {/* Form Container */}
      <div
        className="category-form-container"
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            if (!creditPackage.camt || !creditPackage.amt || !creditPackage.status) {
              alert("Please fill in all fields.");
              return;
            }
            if (user.uid !== "eBdMwBiLYvZkUQsoQhjIYrpmlSk2") {
              alert("You do not have permission to add credit packages.");
              return;
            }
            const newPackage = {
              camt: Number(creditPackage.camt),
              amt: Number(creditPackage.amt),
              status: creditPackage.status,
              createdAt: new Date(),
            };
            try {
              const docRef = await addDoc(collection(db, "Credit_Packages"), newPackage);
              const newPackageWithId = { id: docRef.id, ...newPackage };
              setCreditPackages((prevPackages) => [...prevPackages, newPackageWithId]);
              setCreditPackage({ camt: "", amt: "", status: "" });
              setShowCreditPackageForm(false);
              setShowCreditPackageList(true);
              alert("Credit Package added successfully!");
            } catch (error) {
              console.error("Error adding credit package:", error);
              alert("Failed to add package. Please try again.");
            }
          }}
          style={{ display: "flex", flexDirection: "column", gap: "16px" }}
        >
          {/* Credit Amount */}
          <div className="form-group">
            <label style={{ fontSize: "14px", color: "#374151", fontWeight: "500", marginBottom: "6px", display: "block" }}>
              Credit Amount
            </label>
            <input
              type="number"
              value={creditPackage.camt}
              onChange={(e) => setCreditPackage({ ...creditPackage, camt: e.target.value })}
              placeholder="Enter credit amount"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #D1D5DB",
                fontFamily: "'Inter', sans-serif",
                outline: "none",
              }}
            />
          </div>
          {/* Amount */}
          <div className="form-group">
            <label style={{ fontSize: "14px", color: "#374151", fontWeight: "500", marginBottom: "6px", display: "block" }}>
              Amount (£)
            </label>
            <input
              type="number"
              value={creditPackage.amt}
              onChange={(e) => setCreditPackage({ ...creditPackage, amt: e.target.value })}
              placeholder="Enter amount"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #D1D5DB",
                fontFamily: "'Inter', sans-serif",
                outline: "none",
              }}
            />
          </div>
          {/* Status */}
          <div className="form-group">
            <label style={{ fontSize: "14px", color: "#374151", fontWeight: "500", marginBottom: "6px", display: "block" }}>
              Status
            </label>
            <select
              value={creditPackage.status}
              onChange={(e) => setCreditPackage({ ...creditPackage, status: e.target.value })}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #D1D5DB",
                fontFamily: "'Inter', sans-serif",
                outline: "none",
              }}
            >
              <option value="">Select Status</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
          {/* Submit Button */}
          <div style={{ textAlign: "right" }}>
            <button
              type="submit"
              style={{
                backgroundColor: "#4F46E5",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "6px",
                fontFamily: "'Inter', sans-serif",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.2s",
              }}
            >
              Add Credit Package
            </button>
          </div>
        </form>
      </div>
    </div>
    </div>
)}
{/* ✅ LIST CREDIT PACKAGE */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "listCreditPackage" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>List Credit Packages</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
      {/* Title Section */}
      <div className="text-center bg-white rounded-2xl shadow-md p-6 mb-6">
        <h3 className="text-2xl font-bold font-poppins text-gray-900">
          Credit Package List
        </h3>
      </div>
      {/* Action Button */}
      <div className="flex justify-end mb-4">
     <button
  onClick={() => {
    setShowCreditPackageForm(true);
    setShowCreditPackageList(false);
    // navigate to Add Credit Package section
    setActiveButton("addCreditPackage");
    setCurrentView("addCreditPackage");
    setCreditPackage({ camt: "", amt: "", status: "" });
    setEditingPackageId(null);
    setEditedPackage({ camt: "", amt: "", status: "" });
  }}
  style={{ backgroundColor: "#000000", color: "white" }}
  className="px-3 py-2 rounded shadow"
>
  Add New Credit Package
</button>
      </div>
      {/* Filters Section */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-4">
        <div className="flex items-center gap-2">
          <label>Show</label>
          <select className="form-select rounded-md border-gray-300">
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
          </select>
          <span>entries</span>
        </div>
        <div className="flex items-center gap-2">
          <label>Search:</label>
          <input
            type="text"
            className="form-input rounded-md border-gray-300 min-w-[180px]"
          />
        </div>
      </div>
      {/* Table Section */}
      <div className="table-responsive bg-white rounded-2xl shadow-md border border-[#E5E7EB] p-4 overflow-auto">
        <table className="table table-striped table-borderless align-middle mb-0 text-sm text-gray-700 w-full">
          {creditPackages.length === 0 ? (
            <tbody>
              <tr>
                <td colSpan={5} className="text-center text-gray-500 py-4">
                  No credit packages available.
                </td>
              </tr>
            </tbody>
          ) : (
            <>
              <thead className="bg-gray-100 sticky top-0 z-10">
                <tr>
                  <th className="px-4 py-2 text-left">#</th>
                  <th className="px-4 py-2 text-left">Credit Amount</th>
                  <th className="px-4 py-2 text-left">Amount Required</th>
                  <th className="px-4 py-2 text-left">Credit Status</th>
                  <th className="px-4 py-2 text-left">Action</th>
                </tr>
              </thead>
              <tbody>
                {creditPackages.map((pkg, index) => (
                  <tr
                    key={pkg.id}
                    className={`${index % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
                  >
                    <td className="px-4 py-2">{index + 1}</td>
                    {/* Credit Amount */}
                    <td className="px-4 py-2">
                      {editingPackageId === pkg.id ? (
                        <input
                          type="number"
                          name="camt"
                          value={editedPackage.camt}
                          onChange={handlePackageInputChange}
                          className="form-input rounded-md border-gray-300 w-full"
                        />
                      ) : (
                        pkg.camt
                      )}
                    </td>
                    {/* Amount Required */}
                    <td className="px-4 py-2">
                      {editingPackageId === pkg.id ? (
                        <input
                          type="number"
                          name="amt"
                          value={editedPackage.amt}
                          onChange={handlePackageInputChange}
                          className="form-input rounded-md border-gray-300 w-full"
                        />
                      ) : (
                        pkg.amt
                      )}
                    </td>
                    {/* Status */}
                    <td className="px-4 py-2">
                      {editingPackageId === pkg.id ? (
                        <select
                          name="status"
                          value={editedPackage.status}
                          onChange={handlePackageInputChange}
                          className="form-select rounded-md border-gray-300 w-full"
                        >
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </select>
                      ) : (
                        <span
                          className={`px-3 py-1 rounded-full text-white font-semibold ${
                            pkg.status === "active" ? "bg-green-500" : "bg-red-500"
                          }`}
                        >
                          {pkg.status.charAt(0).toUpperCase() + pkg.status.slice(1)}
                        </span>
                      )}
                    </td>
                    {/* Actions */}
                    <td className="px-4 py-2">
                      {editingPackageId === pkg.id ? (
                        <div className="flex gap-2">
                          <button
                            onClick={() => handleSavePackageEdit(pkg.id)}
                            style={{ backgroundColor: "#2563EB", color: "white" }}
                            className="px-3 py-2 rounded flex items-center gap-1"
                            title="Save"
                          >
                            <FaSave />
                            <span className="hidden md:inline">Save</span>
                          </button>
                          <button
                            onClick={() => setEditingPackageId(null)}
                            style={{ backgroundColor: "#DC2626", color: "white" }}
                            className="px-3 py-2 rounded flex items-center gap-1"
                            title="Cancel"
                          >
                            <FaTimes />
                            <span className="hidden md:inline">Cancel</span>
                          </button>
                        </div>
                      ) : (
                        <div className="flex gap-2">
                          <button
                            onClick={() => handleEditPackage(pkg)}
                            style={{ backgroundColor: "#2563EB", color: "white" }}
                            className="px-3 py-2 rounded flex items-center gap-1"
                            title="Edit"
                          >
                            <FaEdit />
                            <span className="hidden md:inline">Edit</span>
                          </button>
                          <button
                            onClick={() => handleDeletePackage(pkg.id)}
                            style={{ backgroundColor: "#DC2626", color: "white" }}
                            className="px-3 py-2 rounded flex items-center gap-1"
                            title="Delete"
                          >
                            <FaTrash />
                            <span className="hidden md:inline">Delete</span>
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </>
          )}
        </table>
      </div>
    </div>
  </div>
)}
{/* ✅ USER PROFILE */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "userProfile" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>User Profile</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
     {/* Header */}
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          👥 User Management Panel
        </h3>
      </div>
      {/* Table Container */}
      <div className="table-responsive bg-white rounded-2xl shadow-md border border-[#E5E7EB] p-4 overflow-auto">
        <table className="table table-striped table-borderless align-middle mb-0 text-sm text-gray-700 w-full">
          <thead className="bg-[#F9FAFB] text-gray-600 uppercase text-xs sticky top-0 z-10">
            <tr>
              {["Name", "Email", "Mobile", "Address", "Postcode", "Admin", "Last Login", "Status", "Actions"].map(
                (header) => (
                  <th
                    key={header}
                    className={`px-4 py-3 font-semibold text-gray-700 text-xs ${
                      header === "Actions" ? "text-center" : "text-left"
                    }`}
                  >
                    {header}
                  </th>
                )
              )}
            </tr>
          </thead>
          <tbody>
            {tempUserList.map((usr, index) => (
              <tr
                key={usr.id}
                className={`${index % 2 === 0 ? "bg-white" : "bg-gray-50"} border-b border-[#E5E7EB]`}
              >
                {/* Name */}
                <td className="px-4 py-2">
                  {activeEditRow === usr.id ? (
                    <input
                      type="text"
                      value={editableRowData.fullName || ""}
                      onChange={(e) => updateRowField("fullName", e.target.value)}
                      className="w-full border border-gray-300 rounded-lg p-2 text-sm"
                    />
                  ) : (
                    usr.fullName || `User ${usr.id}`
                  )}
                </td>
                {/* Email */}
                <td className="px-4 py-2">
                  {activeEditRow === usr.id ? (
                    <input
                      type="text"
                      value={editableRowData.email || ""}
                      onChange={(e) => updateRowField("email", e.target.value)}
                      className="w-full border border-gray-300 rounded-lg p-2 text-sm"
                    />
                  ) : (
                    usr.email
                  )}
                </td>
                {/* Mobile */}
                <td className="px-4 py-2">
                  {activeEditRow === usr.id ? (
                    <input
                      type="text"
                      value={editableRowData.mobile || ""}
                      onChange={(e) => updateRowField("mobile", e.target.value)}
                      className="w-full border border-gray-300 rounded-lg p-2 text-sm"
                    />
                  ) : (
                    usr.mobile
                  )}
                </td>
                {/* Address */}
                <td className="px-4 py-2">{usr.address || "-"}</td>
                {/* Postcode */}
                <td className="px-4 py-2">{usr.postcode || "-"}</td>
                {/* Admin */}
                <td className="px-4 py-2">
                  {activeEditRow === usr.id ? (
                    <select
                      value={editableRowData.isAdmin ? "true" : "false"}
                      onChange={(e) => updateRowField("isAdmin", e.target.value === "true")}
                      className="w-full border border-gray-300 rounded-lg p-2 text-sm"
                    >
                      <option value="true">✔️ Yes</option>
                      <option value="false">❌ No</option>
                    </select>
                  ) : usr.isAdmin ? (
                    "✔️"
                  ) : (
                    "❌"
                  )}
                </td>
                {/* Last Login */}
                <td className="px-4 py-2">{usr.lastLogin || "N/A"}</td>
                {/* Status */}
                <td className="px-4 py-2">
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "6px",
                      padding: "4px 10px",
                      borderRadius: "6px",
                      fontSize: "12px",
                      fontWeight: "600",
                      backgroundColor: usr.status === "Active" ? "#10B981" : usr.status === "Suspended" ? "#111827" : "#6B7280",
                      color: "#fff",
                    }}
                  >
                    {usr.status}
                  </span>
                </td>
                {/* Actions */}
                <td className="px-4 py-2 text-center">
                  <div className="flex flex-wrap gap-2 justify-center">
                    {activeEditRow === usr.id ? (
                      <>
                        <button
                          onClick={() => saveRowEditUI(usr.id)}
                          style={{ backgroundColor: "#2563EB", color: "white" }}
                          className="px-2 py-1 rounded text-xs flex items-center gap-1"
                        >
                          💾 Save
                        </button>
                        <button
                          onClick={cancelRowEditUI}
                          style={{ backgroundColor: "#111827", color: "white" }}
                          className="px-2 py-1 rounded text-xs flex items-center gap-1"
                        >
                          ❌ Cancel
                        </button>
                      </>
                    ) : (
                      <>
                        {/* Edit */}
                        <button
                          onClick={() => beginRowEditUI(usr)}
                          style={{ backgroundColor: "#2563EB", color: "white" }}
                          className="px-2 py-1 rounded text-xs flex items-center gap-1"
                        >
                          ✏️ Edit
                        </button>
                        {/* Delete */}
                        <button
                          onClick={() =>
                            setShowDeleteModal({ visible: true, userId: usr.id, userName: usr.fullName })
                          }
                          style={{ backgroundColor: "#dc2626", color: "white" }}
                          className="px-2 py-1 rounded text-xs flex items-center gap-1"
                        >
                          🗑️ Delete
                        </button>
                        {/* Activate */}
                        <button
                          onClick={() => {
                            setTempUserList((prev) =>
                              prev.map((u) => (u.id === usr.id ? { ...u, status: "Active" } : u))
                            );
                            toast.success(`User ${usr.fullName || usr.id} activated successfully!`, {
                              position: "top-right",
                              autoClose: 3000,
                            });
                          }}
                          style={{ backgroundColor: "#ec4899", color: "white" }}
                          className="px-2 py-1 rounded text-xs flex items-center gap-1"
                        >
                          ✅ Activate
                        </button>
                        {/* Suspend */}
                        <button
                          onClick={() => {
                            setTempUserList((prev) =>
                              prev.map((u) => (u.id === usr.id ? { ...u, status: "Suspended" } : u))
                            );
                            toast.info(`User ${usr.fullName || usr.id} has been suspended.`, {
                              position: "top-right",
                              autoClose: 3000,
                            });
                          }}
                          style={{ backgroundColor: "#111827", color: "white" }}
                          className="px-2 py-1 rounded text-xs flex items-center gap-1"
                        >
                          ⏸️ Suspend
                        </button>
                        {/* Address */}
                        <button
                          onClick={() => {
                            setEditableAddressData({ address: usr.address || "", postcode: usr.postcode || "" });
                            setShowAddressModal({ visible: true, userId: usr.id });
                          }}
                          style={{ backgroundColor: "#2563EB", color: "white" }}
                          className="px-2 py-1 rounded text-xs flex items-center gap-1"
                        >
                          🏠 Address
                        </button>
                        {/* Logins */}
                        <button
                          onClick={() => showLoginInfo(usr.id)}
                          style={{ backgroundColor: "#8b5cf6", color: "white" }}
                          className="px-2 py-1 rounded text-xs flex items-center gap-1"
                        >
                          🔐 Logins
                        </button>
                        {/* Ghost */}
                        <button
                          onClick={() => runGhostMode(usr.id)}
                          style={{ backgroundColor: "#1f2937", color: "white" }}
                          className="px-2 py-1 rounded text-xs flex items-center gap-1"
                        >
                          👻 Ghost
                        </button>
                        {/* Check */}
                        <button
                          onClick={() => runCheckStatus(usr.id)}
                          style={{ backgroundColor: "#6b7280", color: "white" }}
                          className="px-2 py-1 rounded text-xs flex items-center gap-1"
                        >
                          ✅ Check
                        </button>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
    {/* Delete Confirmation Modal */}
    {showDeleteModal.visible && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
          backdropFilter: "blur(4px)",
        }}
      >
        <div
          style={{
            background: "#fff",
            padding: "28px",
            borderRadius: "14px",
            width: "420px",
            boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
            textAlign: "center",
          }}
        >
          <h3 style={{ margin: 0, fontSize: "20px", fontWeight: "700", color: "#111827" }}>
            ⚠️ Confirm Deletion
          </h3>
          <p style={{ fontSize: "14px", color: "#4B5563", margin: 0, lineHeight: "1.5" }}>
            Are you sure you want to permanently delete <strong>{showDeleteModal.userName}</strong>? This action <strong>cannot</strong> be undone.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "14px", marginTop: "10px" }}>
            <button
              onClick={() => {
                deleteFromUIOnly(showDeleteModal.userId);
                setShowDeleteModal({ visible: false, userId: null, userName: "" });
              }}
              style={{
                padding: "10px 18px",
                borderRadius: "10px",
                border: "none",
                background: "#dc2626",
                color: "#fff",
                fontWeight: "500",
                cursor: "pointer",
              }}
            >
              🗑️ Delete
            </button>
            <button
              onClick={() => setShowDeleteModal({ visible: false, userId: null, userName: "" })}
              style={{
                padding: "10px 18px",
                borderRadius: "10px",
                border: "1px solid #D1D5DB",
                background: "#facc15",
                color: "#000",
                fontWeight: "500",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    )}
    {/* Address/Postal Modal */}
    {showAddressModal.visible && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
          backdropFilter: "blur(4px)",
        }}
      >
        <div
          style={{
            background: "#fff",
            padding: "28px",
            borderRadius: "14px",
            width: "400px",
            display: "flex",
            flexDirection: "column",
            gap: "14px",
          }}
        >
          <h3 style={{ margin: 0, fontSize: "20px", fontWeight: "700", color: "#111827" }}>
            🏠 Add Address & Postcode
          </h3>
          <input
            type="text"
            placeholder="Address"
            value={editableAddressData.address || ""}
            onChange={(e) => setEditableAddressData((prev) => ({ ...prev, address: e.target.value }))}
            style={{ padding: "10px", borderRadius: "10px", border: "1px solid #D1D5DB" }}
          />
          <input
            type="text"
            placeholder="Postcode"
            value={editableAddressData.postcode || ""}
            onChange={(e) => setEditableAddressData((prev) => ({ ...prev, postcode: e.target.value }))}
            style={{ padding: "10px", borderRadius: "10px", border: "1px solid #D1D5DB" }}
          />
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
            <button
              onClick={() => setShowAddressModal({ visible: false, userId: null })}
              style={{
                padding: "10px 16px",
                borderRadius: "10px",
                border: "1px solid #D1D5DB",
                background: "#facc15",
                color: "#000",
                fontWeight: "500",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                saveAddressEditUI(showAddressModal.userId, editableAddressData);
                setShowAddressModal({ visible: false, userId: null });
              }}
              style={{
                padding: "10px 16px",
                borderRadius: "10px",
                border: "none",
                background: "#2563EB",
                color: "#fff",
                fontWeight: "500",
                cursor: "pointer",
              }}
            >
              💾 Save
            </button>
          </div>
        </div>
      </div>
    )}
    </div>
)}
{/* ✅ CUSTOMERS */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "customers" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Customers</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
       {/* Header */}
      <div
        className="category-title-container"
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          👥 Customer List
        </h3>
      </div>
      {/* Filters & Campaign */}
      <div
        className="category-form-container"
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
        }}
      >
        <div className="flex flex-wrap justify-between items-center gap-3">
          <div className="flex items-center gap-2">
            <label className="text-sm font-medium">Filter by Tag:</label>
            <select
              value={tagFilter}
              onChange={(e) => setTagFilter(e.target.value)}
              className="rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm bg-white focus:ring-2 focus:ring-[#4F46E5] focus:border-[#4F46E5]"
            >
              <option value="">-- All --</option>
              {availableTags.map((tag) => (
                <option key={tag} value={tag}>
                  {tag}
                </option>
              ))}
            </select>
          </div>
          <div className="flex flex-wrap items-center gap-3">
            <select
              value={selectedCampaignTag}
              onChange={(e) => setSelectedCampaignTag(e.target.value)}
              className="rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm bg-white focus:ring-2 focus:ring-[#4F46E5] focus:border-[#4F46E5]"
            >
              <option value="">-- Select Tag --</option>
              {availableTags.map((tag) => (
                <option key={tag} value={tag}>
                  {tag}
                </option>
              ))}
            </select>
            <input
              type="text"
              value={campaignMessage}
              onChange={(e) => setCampaignMessage(e.target.value)}
              placeholder="Write your message..."
              className="rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm bg-white focus:ring-2 focus:ring-[#4F46E5] focus:border-[#4F46E5]"
            />
            <button
              onClick={handleSendCampaign}
              style={{ backgroundColor: "#22c55e", color: "white" }}
              className="px-4 py-2 rounded-lg shadow-sm font-semibold"
            >
              Send Campaign
            </button>
          </div>
        </div>
      </div>
      {/* Customer Table */}
      <div className="table-responsive bg-white rounded-2xl shadow-md border border-[#E5E7EB] p-4 overflow-auto">
        <table className="table table-striped table-borderless align-middle mb-0 text-sm text-gray-700 w-full">
          <thead className="bg-[#F9FAFB] text-gray-600 uppercase text-xs sticky top-0 z-10">
            <tr>
              {[
                "#",
                "Full Name",
                "Email",
                "Mobile",
                "Wallet",
                "Referral Balance",
                "Referred By",
                "Referred By ID",
                "Status",
                "Tags",
                "Notes",
                "Action",
              ].map((header) => (
                <th
                  key={header}
                  className="px-4 py-3 text-left font-semibold text-gray-700 text-xs"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {localCustomers
              .filter((c) => !tagFilter || (c.tags || []).includes(tagFilter))
              .map((customer, index) => (
                <tr
                  key={customer.id || customer.docId}
                  className={`${index % 2 === 0 ? "bg-white" : "bg-gray-50"} border-b border-[#E5E7EB]`}
                >
                  <td className="px-4 py-2">{index + 1}</td>
                  <td className="px-4 py-2 font-semibold text-blue-600">{customer.fullName || "—"}</td>
                  <td className="px-4 py-2">{customer.email || "—"}</td>
                  <td className="px-4 py-2">{customer.mobile || "—"}</td>
                  <td className="px-4 py-2">
                    <span className="bg-cyan-50 text-teal-700 px-2 py-1 rounded-lg font-semibold text-xs">
                      💰 £{(customer.walletBalance ?? 0).toFixed(2)}
                    </span>
                  </td>
                  <td className="px-4 py-2">
                    <span className="bg-lime-50 text-lime-800 px-2 py-1 rounded-lg font-semibold text-xs">
                      🎁 £{(customer.referralBalance ?? 0).toFixed(2)}
                    </span>
                  </td>
                  <td className="px-4 py-2">{customer.referredBy || "—"}</td>
                  <td className="px-4 py-2">{customer.referredById || "—"}</td>
                  <td className="px-4 py-2">
                    <span className="bg-red-100 text-red-700 px-3 py-1 rounded-lg text-xs font-medium">
                      Make Active
                    </span>
                  </td>
                  <td className="px-4 py-2 min-w-[220px]">
                    {(customer.tags || []).map((tag, i) => (
                      <span
                        key={i}
                        onClick={() => removeTagFromUI(customer.id, tag)}
                        className="bg-blue-100 text-blue-800 px-2 py-1 rounded-lg text-xs mr-1 cursor-pointer"
                      >
                        {tag} ✕
                      </span>
                    ))}
                    <div className="mt-2">
                      <select
                        onChange={(e) => {
                          const tag = e.target.value;
                          if (tag) addTagAndSaveCustomerInfo(customer, tag);
                        }}
                        value=""
                        className="rounded-md border border-gray-300 px-2 py-1 text-xs shadow-sm bg-white focus:ring-2 focus:ring-[#4F46E5] focus:border-[#4F46E5]"
                      >
                        <option value="">+ Add Tag</option>
                        {availableTags.map((tag) => (
                          <option key={tag} value={tag}>
                            {tag}
                          </option>
                        ))}
                      </select>
                    </div>
                  </td>
                  {/* Notes */}
                  <td className="px-4 py-3 min-w-[220px]">
                    <textarea
                      rows={3}
                      value={notesMap[customer.id]?.text || ""}
                      onChange={(e) => handleNoteChange(customer.id, e.target.value)}
                      placeholder="Add a note..."
                      className="w-full rounded-lg border border-gray-300 p-2 text-sm shadow-sm resize-y bg-white focus:ring-2 focus:ring-[#4F46E5] focus:border-[#4F46E5]"
                    />
                    <div className="mt-2 flex flex-col gap-2">
                      <button
                        className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded-lg text-xs shadow-sm transition"
                        onClick={async () => {
                          const noteText = notesMap[customer.id]?.text?.trim();
                          const fullName =
                            customer.fullName?.trim() || customer.Fullname?.trim() || "";
                          if (!noteText || !fullName) {
                            toast.error("❌ Customer name and note text are required.");
                            return;
                          }
                          await handleSendNote(customer.id, fullName, noteText);
                        }}
                        disabled={!notesMap[customer.id]?.text?.trim()}
                      >
                        Save Note
                      </button>
                      {notesMap[customer.id]?.id && (
                        <button
                          onClick={() =>
                            handleDeleteNote(customer.id, customer.fullName, notesMap[customer.id].id)
                          }
                          className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded-lg text-xs shadow-sm transition"
                        >
                          <FaTimes /> Delete
                        </button>
                      )}
                    </div>
                  </td>
                  {/* Action Buttons */}
                  <td className="px-4 py-2 text-center">
                    <div className="flex flex-wrap gap-2 justify-center">
                      <button
                        onClick={() => handleDelete(customer.id)}
                        title="Delete"
                        style={{ backgroundColor: "#e74c3c", color: "white" }}
                        className="px-2 py-1 rounded flex items-center gap-1 text-xs"
                      >
                        <FaTrash /> Delete
                      </button>
                     <button
  onClick={() => {
    handleManageUserReport(customer);
    // navigate to User Report section
    setCurrentView("userReport");
    // hide remaining sections
    setShowCustomers(false);
    setShowCustomerBonus(false);
    setShowCustomerProfile(false);
  }}
  title="Manage User Report"
  style={{ backgroundColor: "#34495e", color: "white" }}
  className="px-2 py-1 rounded flex items-center gap-1 text-xs"
>
  <FaChartBar /> Report
</button>
                      <button
  onClick={() => {
    setSelectedCustomer(customer);
    // Navigate to Financial Section
    setCurrentView("financialSection");
    // Hide Customers List
    setShowCustomers(false);
  }}
  title="Financial Info"
  style={{ backgroundColor: "#27ae60", color: "white" }}
  className="px-2 py-1 rounded flex items-center gap-1 text-xs"
>
  <FaMoneyBillAlt /> Finance
</button>
                     <button
  onClick={() => {
    setSelectedUserProfile(customer);
    // Navigate to User Profile section
    setCurrentView("userProfile");
    // Hide Customers section
    setShowCustomers(false);
  }}
  title="User Profile"
  style={{ backgroundColor: "#3498db", color: "white" }}
  className="px-2 py-1 rounded flex items-center gap-1 text-xs"
>
  <FaUser /> Profile
</button>
                     <button
  onClick={() => {
    setSelectedCustomer(customer);
    // Navigate to Send Notification section
    setCurrentView("sendNotification");
    // Hide Customers list
    setShowCustomers(false);
  }}
  title="Push Notification"
  style={{ backgroundColor: "#f39c12", color: "white" }}
  className="px-2 py-1 rounded flex items-center gap-1 text-xs"
>
  <FaBell /> Notify
</button>
                     <button
  onClick={() => {
    setSelectedCustomer(customer);
    // Navigate to Ticket Dashboard
    setCurrentView("ticketDashboard");
    // Hide Customers section
    setShowCustomers(false);
  }}
  title="Tickets"
  style={{ backgroundColor: "#9b59b6", color: "white" }}
  className="px-2 py-1 rounded flex items-center gap-1 text-xs"
>
  🎧 Tickets
</button>
                      <button
  onClick={() => {
    setSelectedCustomer(customer);
    // Navigate to Service History section
    setCurrentView("serviceHistory");
    // Hide Customers section
    setShowCustomers(false);
  }}
  title="Service History"
  style={{ backgroundColor: "#8e44ad", color: "white" }}
  className="px-2 py-1 rounded flex items-center gap-1 text-xs"
>
  📜 History
</button>
                     <button
  onClick={() => {
    setSelectedCustomer(customer);
    // Navigate to Activate Chat section
    setCurrentView("activateChat");
    // Hide Customers section
    setShowCustomers(false);
  }}
  title="Activate Chat"
  style={{ backgroundColor: "#2980b9", color: "white" }}
  className="px-2 py-1 rounded flex items-center gap-1 text-xs"
>
  💬 Chat
</button>
                          <button
  onClick={() => {
    setSelectedCustomer(customer);
    // Navigate to Payment Logs section
    setCurrentView("paymentLogs");
    // Hide Customers section
    setShowCustomers(false);
  }}
  title="Payment Logs"
  style={{ backgroundColor: "#6c5ce7", color: "white" }}
  className="px-2 py-1 rounded flex items-center gap-1 text-xs"
>
  <FaReceipt /> Payment Logs
</button>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
    </div>
)}
{/* ✅ ALL TICKETS */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "allTickets" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>All Tickets</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
      {/* Title */}
    <div
      className="category-title-container"
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        marginBottom: "20px",
        textAlign: "center",
      }}
    >
      <h3
        style={{
          margin: 0,
          fontFamily: "'Poppins', sans-serif",
          fontSize: "24px",
          fontWeight: "700",
          color: "#111827",
        }}
      >
        🎫 Ticket Activity Log
      </h3>
    </div>
    {/* Table Container */}
    <div
      className="category-form-container"
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        overflowX: "auto",
      }}
    >
      {/* Table Controls */}
      <div
        className="table-controls"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "16px",
          fontFamily: "'Inter', sans-serif",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <label style={{ fontSize: "14px", color: "#374151" }}>
          Show{" "}
          <select
            style={{
              margin: "0 5px",
              padding: "6px 10px",
              border: "1px solid #D1D5DB",
              borderRadius: "6px",
              fontFamily: "'Inter', sans-serif",
            }}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
            value={rowsPerPage}
          >
            {[10, 25, 50].map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </select>{" "}
          entries
        </label>
        {/* Column-specific search boxes */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(6, 1fr)",
            gap: "8px",
            flexGrow: 1,
          }}
        >
          {["Date", "Time", "User", "Action", "Details", "Ticket Details"].map(
            (column) => (
              <input
                key={column}
                type="text"
                placeholder={`Search ${column}`}
                value={columnFilters[column] || ""}
                onChange={(e) =>
                  handleColumnFilterChange(column, e.target.value)
                }
                style={{
                  padding: "6px 10px",
                  border: "1px solid #D1D5DB",
                  borderRadius: "6px",
                  fontFamily: "'Inter', sans-serif",
                  fontSize: "13px",
                  color: "#374151",
                  width: "100%",
                  boxSizing: "border-box",
                }}
              />
            )
          )}
        </div>
      </div>
      {/* Table */}
      {filteredTicketEntries.length > 0 ? (
        <table
          className="data-table borderless"
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontFamily: "'Inter', sans-serif",
            fontSize: "14px",
            color: "#374151",
          }}
        >
          <thead style={{ backgroundColor: "#F9FAFB" }}>
            <tr>
              {[
                "#",
                "Date",
                "Time",
                "User",
                "Action",
                "Details",
                "Ticket Details",
                "Operations",
              ].map((header) => (
                <th
                  key={header}
                  style={{
                    padding: "12px",
                    textAlign: "left",
                    fontWeight: "600",
                    fontSize: "12px",
                    color: "#374151",
                  }}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredTicketEntries
              .map((entry, originalIndex) => ({ entry, originalIndex })) // attach original index
              .filter(({ originalIndex }) => !deletedEntries.includes(originalIndex)) // hide deleted
              .slice(0, rowsPerPage)
              .map(({ entry, originalIndex }, displayIndex) => (
                <tr
                  key={originalIndex}
                  style={{
                    backgroundColor: displayIndex % 2 === 0 ? "#fff" : "#F9FAFB",
                    borderBottom: "1px solid #E5E7EB",
                  }}
                >
                  {/* Serial Number */}
                  <td style={{ padding: "12px" }}>{displayIndex + 1}</td>
                  {/* Editable fields */}
                  <td style={{ padding: "12px" }}>
                    {editableEntryIndex === originalIndex ? (
                      <input
                        type="text"
                        value={mutableEntryData.date}
                        onChange={(e) =>
                          handleFieldValueAdjust("date", e.target.value)
                        }
                        style={{
                          padding: "6px 10px",
                          border: "1px solid #D1D5DB",
                          borderRadius: "6px",
                          fontFamily: "'Inter', sans-serif",
                          width: "100%",
                        }}
                      />
                    ) : (
                      entry.date || "—"
                    )}
                  </td>
                  <td style={{ padding: "12px" }}>
                    {editableEntryIndex === originalIndex ? (
                      <input
                        type="text"
                        value={mutableEntryData.time}
                        onChange={(e) =>
                          handleFieldValueAdjust("time", e.target.value)
                        }
                        style={{
                          padding: "6px 10px",
                          border: "1px solid #D1D5DB",
                          borderRadius: "6px",
                          fontFamily: "'Inter', sans-serif",
                          width: "100%",
                        }}
                      />
                    ) : (
                      entry.time || "—"
                    )}
                  </td>
                  <td style={{ padding: "12px" }}>
                    {editableEntryIndex === originalIndex ? (
                      <input
                        type="text"
                        value={mutableEntryData.user}
                        onChange={(e) =>
                          handleFieldValueAdjust("user", e.target.value)
                        }
                        style={{
                          padding: "6px 10px",
                          border: "1px solid #D1D5DB",
                          borderRadius: "6px",
                          fontFamily: "'Inter', sans-serif",
                          width: "100%",
                        }}
                      />
                    ) : (
                      entry.user || "—"
                    )}
                  </td>
                  <td style={{ padding: "12px" }}>
                    {editableEntryIndex === originalIndex ? (
                      <input
                        type="text"
                        value={mutableEntryData.action}
                        onChange={(e) =>
                          handleFieldValueAdjust("action", e.target.value)
                        }
                        style={{
                          padding: "6px 10px",
                          border: "1px solid #D1D5DB",
                          borderRadius: "6px",
                          fontFamily: "'Inter', sans-serif",
                          width: "100%",
                        }}
                      />
                    ) : (
                      entry.action || "—"
                    )}
                  </td>
                  <td style={{ padding: "12px" }}>
                    {editableEntryIndex === originalIndex ? (
                      <textarea
                        value={mutableEntryData.details?.join("\n") || ""}
                        onChange={(e) =>
                          handleFieldValueAdjust(
                            "details",
                            e.target.value.split("\n")
                          )
                        }
                        style={{
                          padding: "6px 10px",
                          border: "1px solid #D1D5DB",
                          borderRadius: "6px",
                          fontFamily: "'Inter', sans-serif",
                          width: "100%",
                          resize: "vertical",
                        }}
                      />
                    ) : entry.details ? (
                      <ul className="list-disc list-inside">
                        {entry.details.map((d, i) => (
                          <li key={i}>{d}</li>
                        ))}
                      </ul>
                    ) : (
                      "—"
                    )}
                  </td>
                  <td style={{ padding: "12px" }}>
                    {editableEntryIndex === originalIndex ? (
                      <textarea
                        value={
                          mutableEntryData.ticketDetails
                            ? Object.entries(mutableEntryData.ticketDetails)
                                .map(([k, v]) => `${k}:${v}`)
                                .join("\n")
                            : ""
                        }
                        onChange={(e) => {
                          const updated = {};
                          e.target.value.split("\n").forEach((line) => {
                            const [key, val] = line.split(":");
                            if (key && val !== undefined)
                              updated[key.trim()] = val.trim();
                          });
                          handleFieldValueAdjust("ticketDetails", updated);
                        }}
                        style={{
                          padding: "6px 10px",
                          border: "1px solid #D1D5DB",
                          borderRadius: "6px",
                          fontFamily: "'Inter', sans-serif",
                          width: "100%",
                          resize: "vertical",
                        }}
                      />
                    ) : entry.ticketDetails ? (
                      <ul className="list-disc list-inside">
                        {Object.entries(entry.ticketDetails).map(([k, v]) => (
                          <li key={k}>
                            <strong>{k.replace(/([A-Z])/g, " $1")}:</strong>{" "}
                            {v}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      "—"
                    )}
                  </td>
                  {/* Operations */}
                  <td style={{ padding: "12px", display: "flex", gap: "8px" }}>
                    {editableEntryIndex === originalIndex ? (
                      <button
                        onClick={() => confirmEntryChanges(originalIndex)}
                        style={{
                          backgroundColor: "#10B981",
                          padding: "6px 12px",
                          borderRadius: "6px",
                          border: "none",
                          cursor: "pointer",
                          color: "#fff",
                        }}
                      >
                        <FaSave size={16} />
                      </button>
                    ) : (
                      <>
                        <button
                          onClick={() =>
                            initiateFieldModification(originalIndex, entry)
                          }
                          style={{
                            backgroundColor: "#2563EB",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            border: "none",
                            cursor: "pointer",
                            color: "#fff",
                          }}
                        >
                          <FaEdit size={16} />
                        </button>
                        <button
                          onClick={() => {
                            setDeletedEntries((prev) => [
                              ...prev,
                              originalIndex,
                            ]);
                            toast.success(
                              "Ticket entry deleted (UI only)",
                              {
                                position: "top-right",
                                autoClose: 2000,
                              }
                            );
                          }}
                          style={{
                            backgroundColor: "#DC2626",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            border: "none",
                            cursor: "pointer",
                            color: "#fff",
                          }}
                        >
                          <FaTrashAlt size={16} />
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      ) : (
        <p
          style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: "14px",
            color: "#6B7280",
            textAlign: "center",
          }}
        >
          No activity logs available.
        </p>
      )}
    </div>
    </div>
  </div>
)}
{/* ✅ TICKET DASHBOARD */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "ticketDashboard" &&
  (() => {
    // ✅ SORT TICKETS
    const sortedTicketRecords = [...ticketRecords].sort((a, b) => {
      const aTime = a?.createdAt?.seconds || 0;
      const bTime = b?.createdAt?.seconds || 0;
      return bTime - aTime;
    });
    // ✅ FILTER LOGIC
    const refinedTicketRecords = sortedTicketRecords.filter((entry) => {
      const completeName =
        `${entry?.firstName || ""} ${entry?.lastName || ""}`.toLowerCase();
      return (
        completeName.includes(
          dashboardFilters.fullName.toLowerCase()
        ) &&
        (entry?.business || "")
          .toLowerCase()
          .includes(dashboardFilters.business.toLowerCase()) &&
        (entry?.category || "")
          .toLowerCase()
          .includes(dashboardFilters.category.toLowerCase()) &&
        (entry?.city || "")
          .toLowerCase()
          .includes(dashboardFilters.city.toLowerCase()) &&
        (entry?.experience || "")
          .toLowerCase()
          .includes(dashboardFilters.experience.toLowerCase()) &&
        (entry?.email || "")
          .toLowerCase()
          .includes(dashboardFilters.email.toLowerCase()) &&
        (entry?.phone || "")
          .toLowerCase()
          .includes(dashboardFilters.phone.toLowerCase()) &&
        (entry?.status || "Pending")
          .toLowerCase()
          .includes(dashboardFilters.status.toLowerCase()) &&
        (entry?.ticketId || "")
          .toLowerCase()
          .includes(dashboardFilters.ticketId.toLowerCase())
      );
    });
    // ✅ STATUS COUNTS
    const pendingCount = ticketRecords.filter(
      (x) => (x?.status || "Pending") === "Pending"
    ).length;
    const approvedCount = ticketRecords.filter(
      (x) => x?.status === "Approved"
    ).length;
    const inProgressCount = ticketRecords.filter(
      (x) => x?.status === "In Progress"
    ).length;
    const resolvedCount = ticketRecords.filter(
      (x) => x?.status === "Resolved"
    ).length;
    const rejectedCount = ticketRecords.filter(
      (x) => x?.status === "Rejected"
    ).length;
    const holdCount = ticketRecords.filter(
      (x) => x?.status === "On Hold"
    ).length;
    // ✅ PAGINATION
    const TICKETS_PER_PAGE = 10;
    const totalPages = Math.ceil(
      refinedTicketRecords.length / TICKETS_PER_PAGE
    );
    const paginatedTickets = refinedTicketRecords.slice(
      (currentTicketPage - 1) * TICKETS_PER_PAGE,
      currentTicketPage * TICKETS_PER_PAGE
    );
    return (
      <div
        className="admin-container"
        style={{
          maxWidth: "1630px",
          margin: "0 auto",
          width: "100%",
        }}
      >
        {/* HEADER */}
        <div
          style={{
            ...headerStyle,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "15px",
          }}
        >
          <h3 style={titleStyle}>Provider Waitinglist</h3>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              flexWrap: "wrap",
            }}
          >
            {/* PAGE INFO */}
            {ticketRecords.length > 0 && (
              <span
                style={{
                  fontSize: "14px",
                  color: "#6B7280",
                  fontWeight: "500",
                }}
              >
                Page {currentTicketPage} of {totalPages}
              </span>
            )}
            {/* RELOAD */}
            <button
              onClick={initiateTicketLoad}
              disabled={isFetchingTickets}
              style={{
                padding: "8px 16px",
                background: "#3B82F6",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
                opacity: isFetchingTickets ? 0.7 : 1,
              }}
            >
              {isFetchingTickets && (
                <div
                  style={{
                    width: "14px",
                    height: "14px",
                    border: "2px solid #fff",
                    borderTop: "2px solid transparent",
                    borderRadius: "50%",
                    animation: "spin 0.8s linear infinite",
                  }}
                />
              )}
              {isFetchingTickets ? "Loading..." : "Reload"}
            </button>
          </div>
        </div>
        {/* STATUS BULBS */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit, minmax(180px, 1fr))",
            gap: "14px",
            marginBottom: "20px",
          }}
        >
          {[
            {
              label: "Pending",
              value: pendingCount,
              color: "#F59E0B",
            },
            {
              label: "Approved",
              value: approvedCount,
              color: "#10B981",
            },
            {
              label: "In Progress",
              value: inProgressCount,
              color: "#3B82F6",
            },
            {
              label: "Resolved",
              value: resolvedCount,
              color: "#6366F1",
            },
            {
              label: "Rejected",
              value: rejectedCount,
              color: "#EF4444",
            },
            {
              label: "On Hold",
              value: holdCount,
              color: "#6B7280",
            },
          ].map((item) => (
            <div
              key={item.label}
              style={{
                background: "#fff",
                borderRadius: "14px",
                padding: "18px",
                display: "flex",
                alignItems: "center",
                gap: "14px",
                boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
              }}
            >
              <div
                style={{
                  width: "16px",
                  height: "16px",
                  borderRadius: "50%",
                  background: item.color,
                  boxShadow: `0 0 15px ${item.color}`,
                }}
              />

              <div>
                <div
                  style={{
                    fontSize: "13px",
                    color: "#6B7280",
                    fontWeight: "600",
                  }}
                >
                  {item.label}
                </div>

                <div
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                    color: "#111827",
                  }}
                >
                  {item.value}
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* CARD */}
        <div style={cardStyle}>
          <div style={{ padding: "20px" }}>
            <h2 style={{ marginBottom: "15px" }}>
              Provider Tickets
            </h2>

            <div
              style={{
                overflowX: "auto",
                background: "#fff",
                borderRadius: "10px",
              }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                }}
              >
                <thead style={{ background: "#f3f4f6" }}>
                  <tr>
                    <th style={headerCell}>Ticket ID</th>
                    <th style={headerCell}>Name</th>
                    <th style={headerCell}>Business</th>
                    <th style={headerCell}>Category</th>
                    <th style={headerCell}>City</th>
                    <th style={headerCell}>Experience</th>
                    <th style={headerCell}>Email</th>
                    <th style={headerCell}>Phone</th>
                    <th style={headerCell}>Status</th>
                    <th style={headerCell}>Notes</th>
                    <th style={headerCell}>Logs</th>
                    <th style={headerCell}>Created At</th>
                  </tr>
                  {/* FILTERS */}
                  <tr>
                    {[
                      {
                        key: "ticketId",
                        placeholder: "Filter",
                      },
                      {
                        key: "fullName",
                        placeholder: "Filter",
                      },
                      {
                        key: "business",
                        placeholder: "Filter",
                      },
                      {
                        key: "category",
                        placeholder: "Filter",
                      },
                      {
                        key: "city",
                        placeholder: "Filter",
                      },
                      {
                        key: "experience",
                        placeholder: "Filter",
                      },
                      {
                        key: "email",
                        placeholder: "Filter",
                      },
                      {
                        key: "phone",
                        placeholder: "Filter",
                      },
                      {
                        key: "status",
                        placeholder: "Filter",
                      },
                    ].map((filterItem) => (
                      <th
                        key={filterItem.key}
                        style={{
                          padding: "10px",
                          background: "#fff",
                        }}
                      >
                        <input
                          type="text"
                          value={
                            dashboardFilters[
                              filterItem.key
                            ]
                          }
                          onChange={(e) =>
                            alterDashboardFilter(
                              filterItem.key,
                              e.target.value
                            )
                          }
                          placeholder={
                            filterItem.placeholder
                          }
                          style={{
                            width: "100%",
                            padding: "8px",
                            borderRadius: "8px",
                            border:
                              "1px solid #d1d5db",
                            fontSize: "12px",
                          }}
                        />
                      </th>
                    ))}
                    <th />
                    <th />
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {paginatedTickets.length === 0 ? (
                    <tr>
                      <td
                        colSpan="12"
                        style={{
                          textAlign: "center",
                          padding: "20px",
                          color: "#9CA3AF",
                        }}
                      >
                        No Data Found
                      </td>
                    </tr>
                  ) : (
                    paginatedTickets.map((entry) => {
                      const currentStatus =
                        entry?.status || "Pending";
                      return (
                        <tr
                          key={entry.id}
                          style={{
                            borderTop:
                              "1px solid #eee",
                          }}
                        >
                          <td style={bodyCell}>
                            {entry?.ticketId || "-"}
                          </td>
                          <td style={bodyCell}>
                            {entry?.firstName ||
                              "-"}{" "}
                            {entry?.lastName || ""}
                          </td>
                          <td style={bodyCell}>
                            {entry?.business || "-"}
                          </td>
                          <td style={bodyCell}>
                            {entry?.category || "-"}
                          </td>
                          <td style={bodyCell}>
                            {entry?.city || "-"}
                          </td>
                          <td style={bodyCell}>
                            {entry?.experience || "-"}
                          </td>
                          <td style={bodyCell}>
                            {entry?.email || "-"}
                          </td>
                          <td style={bodyCell}>
                            {entry?.phone || "-"}
                          </td>
                          {/* STATUS */}
                          <td style={bodyCell}>
                            <div
                              style={{
                                display: "flex",
                                flexDirection:
                                  "column",
                                gap: "8px",
                              }}
                            >
                              <span
                                style={{
                                  padding:
                                    "6px 12px",
                                  borderRadius:
                                    "20px",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                  width:
                                    "fit-content",
                                  background:
                                    currentStatus ===
                                    "Approved"
                                      ? "#DCFCE7"
                                      : currentStatus ===
                                        "Rejected"
                                      ? "#FEE2E2"
                                      : currentStatus ===
                                        "Resolved"
                                      ? "#DBEAFE"
                                      : currentStatus ===
                                        "In Progress"
                                      ? "#FEF3C7"
                                      : currentStatus ===
                                        "On Hold"
                                      ? "#E5E7EB"
                                      : "#FEF3C7",
                                  color:
                                    currentStatus ===
                                    "Approved"
                                      ? "#166534"
                                      : currentStatus ===
                                        "Rejected"
                                      ? "#991B1B"
                                      : currentStatus ===
                                        "Resolved"
                                      ? "#1D4ED8"
                                      : currentStatus ===
                                        "In Progress"
                                      ? "#92400E"
                                      : currentStatus ===
                                        "On Hold"
                                      ? "#374151"
                                      : "#92400E",
                                }}
                              >
                                {currentStatus}
                              </span>
                              <select
                                value={currentStatus}
                                onChange={(e) =>
                                  modifyTicketStage(
                                    entry.id,
                                    e.target.value
                                  )
                                }
                                style={{
                                  padding:
                                    "6px 10px",
                                  borderRadius:
                                    "8px",
                                  border:
                                    "1px solid #d1d5db",
                                  outline: "none",
                                  background:
                                    "#fff",
                                  cursor: "pointer",
                                  fontSize: "13px",
                                }}
                              >
                                <option value="Pending">
                                  Pending
                                </option>
                                <option value="Approved">
                                  Approved
                                </option>
                                <option value="In Progress">
                                  In Progress
                                </option>
                                <option value="Resolved">
                                  Resolved
                                </option>
                                <option value="Rejected">
                                  Rejected
                                </option>
                                <option value="On Hold">
                                  On Hold
                                </option>
                              </select>
                            </div>
                          </td>
                          {/* NOTES */}
                          <td style={bodyCell}>
                            <button
                              onClick={() => {
                                setFocusedTicket(
                                  entry
                                );
                                setNotesViewerOpen(
                                  true
                                );
                              }}
                              style={{
                                padding: "8px 14px",
                                border: "none",
                                borderRadius: "8px",
                                background:
                                  "#6366F1",
                                color: "#fff",
                                cursor: "pointer",
                                fontSize: "13px",
                                fontWeight: "600",
                              }}
                            >
                              View Notes
                            </button>
                          </td>
                          {/* LOGS */}
                          <td style={bodyCell}>
                            <button
                              onClick={() => {
                                setSelectedLogs(
                                  entry?.notesLogs ||
                                    []
                                );
                                setLogsViewerOpen(
                                  true
                                );
                              }}
                              style={{
                                padding: "8px 14px",
                                border: "none",
                                borderRadius: "8px",
                                background:
                                  "#0F172A",
                                color: "#fff",
                                cursor: "pointer",
                                fontSize: "13px",
                                fontWeight: "600",
                              }}
                            >
                              Logs (
                              {entry?.notesLogs
                                ?.length || 0}
                              )
                            </button>
                          </td>
                          <td style={bodyCell}>
                            {entry?.createdAt
                              ?.seconds
                              ? new Date(
                                  entry.createdAt
                                    .seconds *
                                    1000
                                ).toLocaleString()
                              : "-"}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
            {/* PAGINATION */}
            {refinedTicketRecords.length > 0 &&
              totalPages > 1 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8px",
                    marginTop: "20px",
                    flexWrap: "wrap",
                  }}
                >
                  <button
                    onClick={() =>
                      setCurrentTicketPage(
                        (prev) =>
                          Math.max(prev - 1, 1)
                      )
                    }
                    disabled={
                      currentTicketPage === 1
                    }
                    style={{
                      padding: "8px 14px",
                      border:
                        "1px solid #d1d5db",
                      borderRadius: "8px",
                    }}
                  >
                    Previous
                  </button>
                  {Array.from(
                    { length: totalPages },
                    (_, index) => index + 1
                  ).map((page) => (
                    <button
                      key={page}
                      onClick={() =>
                        setCurrentTicketPage(page)
                      }
                      style={{
                        padding: "8px 12px",
                        minWidth: "40px",
                        border:
                          "1px solid #d1d5db",
                        borderRadius: "8px",
                        background:
                          currentTicketPage ===
                          page
                            ? "#3B82F6"
                            : "#fff",
                        color:
                          currentTicketPage ===
                          page
                            ? "#fff"
                            : "#111827",
                      }}
                    >
                      {page}
                    </button>
                  ))}
                  <button
                    onClick={() =>
                      setCurrentTicketPage(
                        (prev) =>
                          Math.min(
                            prev + 1,
                            totalPages
                          )
                      )
                    }
                    disabled={
                      currentTicketPage ===
                      totalPages
                    }
                    style={{
                      padding: "8px 14px",
                      border:
                        "1px solid #d1d5db",
                      borderRadius: "8px",
                    }}
                  >
                    Next
                  </button>
                </div>
              )}
          </div>
        </div>
        {/* NOTES MODAL */}
        {notesViewerOpen && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.45)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                width: "500px",
                background: "#fff",
                borderRadius: "14px",
                padding: "24px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent:
                    "space-between",
                  marginBottom: "20px",
                }}
              >
                <h2>Ticket Notes</h2>
                <button
                  onClick={() =>
                    setNotesViewerOpen(false)
                  }
                  style={{
                    border: "none",
                    background: "transparent",
                    fontSize: "24px",
                    cursor: "pointer",
                  }}
                >
                  ×
                </button>
              </div>
              <textarea
                defaultValue={
                  focusedTicket?.notes || ""
                }
                onBlur={(e) =>
                  persistTicketNotes(
                    focusedTicket.id,
                    e.target.value
                  )
                }
                placeholder="Enter ticket notes..."
                style={{
                  width: "100%",
                  minHeight: "180px",
                  padding: "14px",
                  borderRadius: "10px",
                  border: "1px solid #d1d5db",
                  resize: "vertical",
                  fontSize: "14px",
                  boxSizing: "border-box",
                }}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "20px",
                }}
              >
                <button
                  onClick={() =>
                    setNotesViewerOpen(false)
                  }
                  style={{
                    padding: "10px 18px",
                    border: "none",
                    borderRadius: "8px",
                    background: "#111827",
                    color: "#fff",
                    cursor: "pointer",
                    fontWeight: "600",
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
       {/* LOGS MODAL */}
{logsViewerOpen && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
      padding: "20px",
    }}
  >
    <div
      style={{
        width: "700px",
        maxWidth: "100%",
        background: "#fff",
        borderRadius: "18px",
        overflow: "hidden",
        boxShadow: "0 10px 35px rgba(0,0,0,0.18)",
      }}
    >
      {/* HEADER */}
      <div
        style={{
          padding: "20px 24px",
          borderBottom: "1px solid #E5E7EB",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background:
            "linear-gradient(135deg, #0F172A, #1E293B)",
        }}
      >
        <div>
          <h2
            style={{
              margin: 0,
              color: "#fff",
              fontSize: "22px",
              fontWeight: "700",
            }}
          >
            Notes Activity Logs
          </h2>
          <p
            style={{
              margin: "6px 0 0",
              color: "#CBD5E1",
              fontSize: "13px",
            }}
          >
            View all notes history and updates
          </p>
        </div>
        {/* CLOSE ICON */}
        <button
          onClick={() => setLogsViewerOpen(false)}
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "10px",
            border: "none",
            background: "rgba(255,255,255,0.12)",
            color: "#fff",
            fontSize: "22px",
            cursor: "pointer",
            transition: "0.2s",
          }}
        >
          ×
        </button>
      </div>
      {/* BODY */}
      <div
        style={{
          padding: "24px",
          maxHeight: "65vh",
          overflowY: "auto",
          background: "#F9FAFB",
        }}
      >
        {selectedLogs.length === 0 ? (
          <div
            style={{
              padding: "50px 20px",
              textAlign: "center",
              color: "#6B7280",
              fontSize: "15px",
              fontWeight: "500",
            }}
          >
            No logs found
          </div>
        ) : (
          selectedLogs.map((log, index) => (
            <div
              key={index}
              style={{
                position: "relative",
                background: "#fff",
                border: "1px solid #E5E7EB",
                borderRadius: "14px",
                padding: "18px",
                marginBottom: "16px",
                boxShadow:
                  "0 2px 10px rgba(0,0,0,0.04)",
              }}
            >
              {/* LOG HEADER */}
              <div
                style={{
                  display: "flex",
                  justifyContent:
                    "space-between",
                  alignItems: "center",
                  marginBottom: "12px",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  {/* BULB */}
                  <div
                    style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      background: "#3B82F6",
                      boxShadow:
                        "0 0 12px #3B82F6",
                    }}
                  />
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: "700",
                      color: "#111827",
                    }}
                  >
                    Activity #{index + 1}
                  </span>
                </div>
                {/* OPEN / CLOSE BUTTONS */}
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  <button
                    onClick={() =>
                      expandSingleLog(index)
                    }
                    style={{
                      padding: "7px 14px",
                      border: "none",
                      borderRadius: "8px",
                      background: "#10B981",
                      color: "#fff",
                      fontSize: "12px",
                      fontWeight: "600",
                      cursor: "pointer",
                    }}
                  >
                    Open
                  </button>
                  <button
                    onClick={() =>
                      collapseSingleLog(index)
                    }
                    style={{
                      padding: "7px 14px",
                      border: "none",
                      borderRadius: "8px",
                      background: "#EF4444",
                      color: "#fff",
                      fontSize: "12px",
                      fontWeight: "600",
                      cursor: "pointer",
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
              {/* DATE */}
              <div
                style={{
                  fontSize: "12px",
                  color: "#6B7280",
                  marginBottom: "12px",
                  fontWeight: "500",
                }}
              >
                {log?.createdAt
                  ? new Date(
                      log.createdAt
                    ).toLocaleString()
                  : "-"}
              </div>
              {/* MESSAGE */}
              {openedLogIndexes?.includes(index) && (
                <div
                  style={{
                    background: "#F8FAFC",
                    borderRadius: "10px",
                    padding: "14px",
                    border:
                      "1px solid #E2E8F0",
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      color: "#111827",
                      lineHeight: "1.8",
                      whiteSpace:
                        "pre-wrap",
                    }}
                  >
                    {log?.message || "-"}
                  </div>
                </div>
              )}
            </div>
          ))
        )}
      </div>
      {/* FOOTER */}
      <div
        style={{
          padding: "18px 24px",
          borderTop: "1px solid #E5E7EB",
          display: "flex",
          justifyContent: "flex-end",
          background: "#fff",
        }}
      >
        <button
          onClick={() => setLogsViewerOpen(false)}
          style={{
            padding: "11px 20px",
            border: "none",
            borderRadius: "10px",
            background: "#111827",
            color: "#fff",
            cursor: "pointer",
            fontWeight: "600",
            fontSize: "14px",
          }}
        >
          Close Logs
        </button>
      </div>
    </div>
  </div>
)}
      </div>
    );
  })()}

{/* ✅ SERVICE HISTORY */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "serviceHistory" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Service History</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
      {/* Header */}
    <div
      className="category-title-container"
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        marginBottom: "20px",
        textAlign: "center",
      }}
    >
      <h3
        style={{
          margin: 0,
          fontFamily: "'Poppins', sans-serif",
          fontSize: "24px",
          fontWeight: "700",
          color: "#111827",
        }}
      >
        📜 Service History
      </h3>
    </div>
    {/* Column-specific Search Inputs */}
    <div
      style={{
        backgroundColor: "#fff",
        padding: "10px 20px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        marginBottom: "10px",
        display: "grid",
        gridTemplateColumns: "repeat(9, 1fr)",
        gap: "8px",
      }}
    >
      {[
        "Booking ID",
        "Customer ID",
        "Service",
        "Tasks",
        "Rating",
        "Feedback",
        "Before",
        "After",
        "Time",
      ].map((col) => (
        <input
          key={col}
          type="text"
          placeholder={`Search ${col}`}
          value={columnFilters[col] || ""}
          onChange={(e) =>
            handleServiceHistoryColumnFilterChange(col, e.target.value)
          }
          style={{
            padding: "6px 10px",
            border: "1px solid #D1D5DB",
            borderRadius: "6px",
            fontFamily: "'Inter', sans-serif",
            fontSize: "13px",
            color: "#374151",
            width: "100%",
            boxSizing: "border-box",
          }}
        />
      ))}
    </div>
    {/* Table Container */}
    <div
      className="category-form-container"
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        overflowX: "auto",
      }}
    >
      {serviceHistory.length === 0 ? (
        <p
          style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: "14px",
            color: "#6B7280",
            textAlign: "center",
          }}
        >
          No service history available yet.
        </p>
      ) : (
        <table
          className="data-table borderless"
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontFamily: "'Inter', sans-serif",
            fontSize: "14px",
            color: "#374151",
          }}
        >
          <thead style={{ backgroundColor: "#F9FAFB" }}>
            <tr>
              <th style={{ padding: "12px", textAlign: "left" }}>📦 Booking ID</th>
              <th style={{ padding: "12px", textAlign: "left" }}>👤 Customer ID</th>
              <th style={{ padding: "12px", textAlign: "left" }}>🔧 Service</th>
              <th style={{ padding: "12px", textAlign: "left" }}>📋 Tasks</th>
              <th style={{ padding: "12px", textAlign: "left" }}>⭐ Rating</th>
              <th style={{ padding: "12px", textAlign: "left" }}>🗣 Feedback</th>
              <th style={{ padding: "12px", textAlign: "left" }}>📸 Before</th>
              <th style={{ padding: "12px", textAlign: "left" }}>📸 After</th>
              <th style={{ padding: "12px", textAlign: "left" }}>🕒 Time</th>
            </tr>
          </thead>
          <tbody>
            {serviceHistory
              .filter((entry) => {
                const term = searchServiceHistoryTerm.toLowerCase();
                const columnMatch = Object.entries(columnFilters).every(([col, val]) => {
                  if (!val) return true;
                  const filterVal = val.toLowerCase();
                  switch (col) {
                    case "Booking ID":
                      return (entry.bookingId || "").toLowerCase().includes(filterVal);
                    case "Customer ID":
                      return (entry.customerUID || "").toLowerCase().includes(filterVal);
                    case "Service":
                      return (entry.serviceType || "").toLowerCase().includes(filterVal);
                    case "Tasks":
                      return (entry.completedTasks?.join(" ") || "").toLowerCase().includes(filterVal);
                    case "Rating":
                      return ((entry.rating ?? "").toString().toLowerCase()).includes(filterVal);
                    case "Feedback":
                      return ((entry.feedback ?? "").toString().toLowerCase()).includes(filterVal);
                    case "Before":
                      return (entry.images?.before || "").toLowerCase().includes(filterVal);
                    case "After":
                      return (entry.images?.after || "").toLowerCase().includes(filterVal);
                    case "Time":
                      if (!entry.timestamp) return false;
                      let timeString = "";
                      if (typeof entry.timestamp === "object" && entry.timestamp.seconds) {
                        timeString = new Date(entry.timestamp.seconds * 1000).toLocaleString();
                      } else {
                        timeString = new Date(entry.timestamp).toLocaleString();
                      }
                      return timeString.toLowerCase().includes(filterVal);
                    default:
                      return true;
                  }
                });
                const globalMatch =
                  (entry.bookingId?.toLowerCase() || "").includes(term) ||
                  (entry.customerUID?.toLowerCase() || "").includes(term) ||
                  (entry.serviceType?.toLowerCase() || "").includes(term) ||
                  (entry.completedTasks?.join(" ").toLowerCase() || "").includes(term) ||
                  ((entry.rating ?? "").toString().toLowerCase()).includes(term) ||
                  ((entry.feedback ?? "").toString().toLowerCase()).includes(term) ||
                  (entry.images?.before?.toLowerCase() || "").includes(term) ||
                  (entry.images?.after?.toLowerCase() || "").includes(term) ||
                  (entry.timestamp
                    ? new Date(entry.timestamp).toLocaleString().toLowerCase()
                    : ""
                  ).includes(term);

                return columnMatch && globalMatch;
              })
              .map((entry, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#fff" : "#F9FAFB",
                    borderBottom: "1px solid #E5E7EB",
                  }}
                >
                  <td style={{ padding: "12px" }}>
                    {entry.bookingId || <em style={{ color: "#9CA3AF" }}>N/A</em>}
                  </td>
                  <td style={{ padding: "12px" }}>
                    {entry.customerUID || <em style={{ color: "#9CA3AF" }}>N/A</em>}
                  </td>
                  <td style={{ padding: "12px" }}>{entry.serviceType}</td>
                  <td style={{ padding: "12px" }}>
                    <ul className="list-disc list-inside mb-0">
                      {entry.completedTasks?.length > 0
                        ? entry.completedTasks.map((task, i) => <li key={i}>{task}</li>)
                        : <li><em style={{ color: "#9CA3AF" }}>None</em></li>}
                    </ul>
                  </td>
                  <td style={{ padding: "12px" }}>
                    {entry.rating ? `${entry.rating} / 5` : <em style={{ color: "#9CA3AF" }}>N/A</em>}
                  </td>
                  <td style={{ padding: "12px" }}>{entry.feedback || <em style={{ color: "#9CA3AF" }}>N/A</em>}</td>
                  <td style={{ padding: "12px" }}>
                    {entry.images?.before ? <img src={entry.images.before} alt="Before" width="70" className="rounded border" /> : <em style={{ color: "#9CA3AF" }}>N/A</em>}
                  </td>
                  <td style={{ padding: "12px" }}>
                    {entry.images?.after ? <img src={entry.images.after} alt="After" width="70" className="rounded border" /> : <em style={{ color: "#9CA3AF" }}>N/A</em>}
                  </td>
                  <td style={{ padding: "12px" }}>
                    {entry.timestamp
                      ? new Date(
                          typeof entry.timestamp === "object" && entry.timestamp.seconds
                            ? entry.timestamp.seconds * 1000
                            : entry.timestamp
                        ).toLocaleString()
                      : "N/A"}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      )}
    </div>
    </div>
  </div>
)}
{/* ✅ LIST PAYMENT GATEWAY */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "listPaymentGateway" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>List Payment Gateway</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
      {/* Header */}
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          Payment Gateway List
        </h3>
      </div>
      {/* Table Container */}
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          overflowX: "auto",
        }}
      >
        {/* Controls */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
            flexWrap: "wrap",
            gap: "12px",
          }}
        >
          {/* Rows per page */}
          <label style={{ fontSize: "14px", color: "#374151", display: "flex", alignItems: "center", gap: "8px" }}>
            Show
            <select
              value={rowsPerPage}
              onChange={(e) => setRowsPerPage(Number(e.target.value))}
              style={{
                padding: "6px 10px",
                border: "1px solid #D1D5DB",
                borderRadius: "6px",
              }}
            >
              {[10, 25, 50].map((num) => (
                <option key={num} value={num}>{num}</option>
              ))}
            </select>
            entries
          </label>
          {/* Filters */}
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", flex: 1 }}>
            <input
              type="text"
              placeholder="Search Name"
              value={pgSearchName}
              onChange={(e) => setPgSearchName(e.target.value)}
              style={formInputStyle}
            />
            <input
              type="text"
              placeholder="Search Subtitle"
              value={pgSearchSubtitle}
              onChange={(e) => setPgSearchSubtitle(e.target.value)}
              style={formInputStyle}
            />
            <input
              type="text"
              placeholder="Search Status"
              value={pgSearchStatus}
              onChange={(e) => setPgSearchStatus(e.target.value)}
              style={formInputStyle}
            />
          </div>
        </div>
        {/* Table */}
        {availablePaymentGateways.length > 0 ? (
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "14px",
              color: "#374151",
            }}
          >
            <thead style={{ backgroundColor: "#F9FAFB" }}>
              <tr>
                <th style={tableHeaderStyle}>#</th>
                <th style={tableHeaderStyle}>Gateway Name</th>
                <th style={tableHeaderStyle}>Subtitle</th>
                <th style={tableHeaderStyle}>Status</th>
                <th style={tableHeaderStyle}>Action</th>
              </tr>
            </thead>
            <tbody>
              {availablePaymentGateways
                .filter((gateway) => {
                  return (
                    gateway.name.toLowerCase().includes(pgSearchName.toLowerCase()) &&
                    gateway.subtitle.toLowerCase().includes(pgSearchSubtitle.toLowerCase()) &&
                    (pgSearchStatus === "" ||
                      gateway.status.toLowerCase().includes(pgSearchStatus.toLowerCase()))
                  );
                })
                .slice(0, rowsPerPage)
                .map((gateway, index) => (
                  <tr
                    key={gateway.id}
                    style={{
                      borderBottom: "1px solid #E5E7EB",
                      backgroundColor: index % 2 === 0 ? "#fff" : "#F9FAFB",
                    }}
                  >
                    <td style={tableCellStyle}>{index + 1}</td>
                    {/* Name */}
                    <td style={tableCellStyle}>
                      {editableRow === gateway.id ? (
                        <input
                          value={editableData.name}
                          onChange={(e) => handleEditChange("name", e.target.value)}
                          style={formInputStyle}
                        />
                      ) : (
                        gateway.name
                      )}
                    </td>
                    {/* Subtitle */}
                    <td style={tableCellStyle}>
                      {editableRow === gateway.id ? (
                        <input
                          value={editableData.subtitle}
                          onChange={(e) => handleEditChange("subtitle", e.target.value)}
                          style={formInputStyle}
                        />
                      ) : (
                        gateway.subtitle
                      )}
                    </td>
                    {/* Status */}
                    <td style={tableCellStyle}>
                      {editableRow === gateway.id ? (
                        <select
                          value={editableData.status}
                          onChange={(e) => handleEditChange("status", e.target.value)}
                          style={formInputStyle}
                        >
                          <option value="Publish">Publish</option>
                          <option value="Unpublish">Unpublish</option>
                        </select>
                      ) : (
                        <span
                          style={{
                            padding: "4px 10px",
                            borderRadius: "6px",
                            fontSize: "12px",
                            fontWeight: "600",
                            backgroundColor:
                              gateway.status === "Publish" ? "#10B981" : "#DC2626",
                            color: "#fff",
                          }}
                        >
                          {gateway.status}
                        </span>
                      )}
                    </td>
                    {/* Action */}
                    <td style={tableCellStyle}>
                      {editableRow === gateway.id ? (
                        <button
                          onClick={() => saveEdit(gateway.id)}
                          style={successActionButton}
                        >
                          Save
                        </button>
                      ) : (
                        <button
                          onClick={() => enableEdit(gateway)}
                          style={primaryActionButton}
                        >
                          Edit
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        ) : (
          <p style={{ textAlign: "center", color: "#6B7280" }}>
            No payment gateways found.
          </p>
        )}
      </div>
    </div>
    </div>
)}
{/* ✅ PROVIDER NOTIFIER */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "providerNotifier" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Provider Notifier</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
     {/* Header */}
      <div className="mb-6 text-center">
        <h2 className="text-2xl font-semibold font-poppins text-black">
          Provider Notifier
        </h2>
      </div>
      {/* Table Container */}
      <div className="table-responsive bg-white rounded-2xl shadow-md border border-[#E5E7EB] p-4 overflow-auto">
        <table className="table table-striped table-borderless align-middle mb-0 text-sm text-gray-700 w-full">
          <thead className="bg-[#F9FAFB] text-gray-600 uppercase text-xs border-b border-[#E5E7EB] sticky top-0 z-10">
            <tr>
              <th className="px-4 py-3 text-left">Title</th>
              <th className="px-4 py-3 text-left">Provider</th>
              <th className="px-4 py-3 text-left">Date</th>
              <th className="px-4 py-3 text-left">Status</th>
              <th className="px-4 py-3 text-left">Action</th>
            </tr>
          </thead>
          <tbody>
            {notifications.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center text-gray-500 py-4">
                  No notifications yet.
                </td>
              </tr>
            ) : (
              notifications.map((notif) => (
                <tr
                  key={notif.id}
                  className={`${notif.read ? "opacity-70" : "bg-yellow-50"} hover:bg-gray-50`}
                >
                  <td
                    onClick={() => handleNotificationClick(notif)}
                    className="cursor-pointer px-4 py-2"
                  >
                    {notif.title}
                  </td>
                  <td className="px-4 py-2">
                    {notif.provider ? `${notif.provider.name} (${notif.provider.providerId})` : "-"}
                  </td>
                  <td className="px-4 py-2">
                    {notif.timestamp
                      ? new Date(
                          notif.timestamp.seconds
                            ? notif.timestamp.seconds * 1000
                            : notif.timestamp
                        ).toLocaleString()
                      : "Unknown date"}
                  </td>
                  <td className="px-4 py-2">
                    {!notif.read ? (
                      <span className="text-xs text-red-500 font-semibold">Unread</span>
                    ) : (
                      <span className="text-xs text-gray-500 font-semibold">Read</span>
                    )}
                  </td>
                  <td className="px-4 py-2 flex gap-2">
                    {!notif.read ? (
                      <button
                        onClick={() =>
                          toggleReadStatus(notif.id, notif.provider?.providerId, true, notif.email)
                        }
                        className="px-3 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700 shadow-sm"
                      >
                        Mark as Read
                      </button>
                    ) : (
                      <button
                        onClick={() =>
                          toggleReadStatus(notif.id, notif.provider?.providerId, false, notif.email)
                        }
                        className="px-3 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 shadow-sm"
                      >
                        Mark as Unread
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {/* Mark All as Read */}
      {notifications.length > 0 && (
        <div className="mt-4 flex justify-end">
         <button
  onClick={markAllAsRead}
  className="flex items-center px-4 py-2 rounded bg-red-600 hover:bg-red-700 text-white text-sm font-inter shadow-sm"
>
  <i className="fa fa-check-double mr-1" /> Mark All as Read
</button>
        </div>
      )}
    </div>
    </div>
)}

{/* ✅ CUSTOMER NOTIFIER */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "customerNotifier" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Customer Notifier</h3>
    </div>
    {/* SINGLE WHITE DASHBOARD CARD */}
    <div style={cardStyle}>
      {/* PAGE HEADER */}
      <div className="mb-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <h2 className="text-2xl font-semibold font-poppins text-black">
          Customer Notifier
        </h2>
        <button
          onClick={markAllCustomerNotificationsRead}
          className="flex items-center px-4 py-2 rounded bg-red-600 hover:bg-red-700 text-white text-sm font-inter shadow-sm"
        >
          <i className="fa fa-check-double mr-1" /> Mark All as Read
        </button>
      </div>
      {/* TABLE CONTAINER */}
      <div className="table-responsive border border-[#E5E7EB] rounded-xl p-4 overflow-auto">
        {/* TABLE CONTROLS */}
        <div className="table-controls flex justify-between items-center mb-4">
          <label className="text-gray-700 text-sm">
            Show{" "}
            <select
              className="mx-2 px-2 py-1 border border-gray-300 rounded"
              value={rowsPerPage}
              onChange={(e) => setRowsPerPage(Number(e.target.value))}
            >
              {[10, 25, 50].map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
            entries
          </label>
        </div>
        {/* SEARCH FILTERS */}
        <div
          style={{
            display: "flex",
            flex: 1,
            gap: "8px",
            flexWrap: "wrap",
            marginBottom: "14px",
          }}
        >
          {[
            { label: "Title", state: notifierSearchTitle, setState: setNotifierSearchTitle },
            { label: "Customer ID", state: notifierSearchCustomerId, setState: setNotifierSearchCustomerId },
            { label: "Name", state: notifierSearchName, setState: setNotifierSearchName },
            { label: "Email", state: notifierSearchEmail, setState: setNotifierSearchEmail },
            { label: "Phone", state: notifierSearchPhone, setState: setNotifierSearchPhone },
            { label: "Status", state: notifierSearchStatus, setState: setNotifierSearchStatus },
            { label: "Time", state: notifierSearchTime, setState: setNotifierSearchTime },
          ].map(({ label, state, setState }) => (
            <input
              key={label}
              type="text"
              placeholder={`Search ${label}`}
              value={state}
              onChange={(e) => setState(e.target.value)}
              className="form-control rounded-lg border border-gray-300 text-sm"
              style={{
                flex: 1,
                minWidth: "120px",
                height: "36px",
                padding: "6px 10px",
                fontFamily: "'Inter', sans-serif",
                fontSize: "13px",
              }}
            />
          ))}
        </div>
        {/* TABLE */}
        {Array.isArray(customerNotifications) && customerNotifications.length > 0 ? (
          <table className="table table-striped table-borderless align-middle mb-0 text-sm text-gray-700 w-full">
            {/* TABLE HEADER */}
            <thead className="bg-[#F9FAFB] text-gray-600 uppercase text-xs sticky top-0 z-10">
              <tr>
                <th className="px-4 py-3 text-left">Title</th>
                <th className="px-4 py-3 text-left">Customer ID</th>
                <th className="px-4 py-3 text-left">Name</th>
                <th className="px-4 py-3 text-left">Email</th>
                <th className="px-4 py-3 text-left">Phone</th>
                <th className="px-4 py-3 text-left">Status</th>
                <th className="px-4 py-3 text-left">Date</th>
                <th className="px-4 py-3 text-left">Action</th>
              </tr>
            </thead>
            {/* TABLE BODY */}
            <tbody>
              {customerNotifications
                .filter((notif) => {
                  const notifTime = notif.timestamp?.toDate
                    ? notif.timestamp.toDate().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
                    : notif.timestamp
                    ? new Date(notif.timestamp).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
                    : "";
                  return (
                    notif.title?.toLowerCase().includes(notifierSearchTitle.toLowerCase()) &&
                    notif.customerId?.toLowerCase().includes(notifierSearchCustomerId.toLowerCase()) &&
                    notif.name?.toLowerCase().includes(notifierSearchName.toLowerCase()) &&
                    notif.email?.toLowerCase().includes(notifierSearchEmail.toLowerCase()) &&
                    notif.phone?.toLowerCase().includes(notifierSearchPhone.toLowerCase()) &&
                    notif.status?.toLowerCase().includes(notifierSearchStatus.toLowerCase()) &&
                    notifTime.includes(notifierSearchTime)
                  );
                })
                .slice(0, rowsPerPage)
                .map((notif, index) => {
                  const notifDate =
                    notif.timestamp && notif.timestamp.toDate
                      ? notif.timestamp.toDate().toLocaleString()
                      : notif.timestamp
                      ? new Date(notif.timestamp).toLocaleString()
                      : "No date available";
                  return (
                    <tr
                      key={notif.id || index}
                      className={`${notif.read ? "opacity-70" : ""} hover:bg-gray-50 odd:bg-white even:bg-gray-50`}
                    >
                      <td
                        onClick={() => handleNotificationClick(notif)}
                        className="cursor-pointer px-4 py-2"
                      >
                        {notif.title || "📄 New Notification"}
                      </td>
                      <td className="px-4 py-2">{notif.customerId || "N/A"}</td>
                      <td className="px-4 py-2">{notif.name || "N/A"}</td>
                      <td className="px-4 py-2">{notif.email || "N/A"}</td>
                      <td className="px-4 py-2">{notif.phone || "N/A"}</td>
                      <td className="px-4 py-2">{notif.status || "N/A"}</td>
                      <td className="px-4 py-2">{notifDate}</td>
                      <td className="px-4 py-2">
                        <button
                          onClick={() => toggleReadStatusByName(notif.name, notif.read)}
                          className={`px-3 py-1 rounded text-xs font-inter shadow-sm text-white ${
                            notif.read
                              ? "bg-red-600 hover:bg-red-700"
                              : "bg-blue-600 hover:bg-blue-700"
                          }`}
                        >
                          Mark as {notif.read ? "Unread" : "Read"}
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        ) : (
          <p className="text-center text-gray-500 text-sm py-4">
            No notifications yet.
          </p>
        )}
      </div>
    </div>
  </div>
)}
{/* ✅ ESCALATION PANEL */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "escalationPanel" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Escalation Panel</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
       {/* ---------------- Service Issue Escalation Panel ---------------- */}
    <div className="category-title-container">
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          🚨 Service Issue Escalation Panel
        </h3>
      </div>
      <div
        className="category-form-container"
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          overflowX: "auto",
        }}
      >
        {jobList.length > 0 ? (
          <table
            className="data-table borderless"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "'Inter', sans-serif",
              fontSize: "14px",
              color: "#374151",
            }}
          >
            <thead style={{ backgroundColor: "#F9FAFB" }}>
              <tr>
                <th style={{ padding: "12px", textAlign: "left" }}>Job ID</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Customer</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Provider</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Rating</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Status</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {jobList.map((job, index) => (
                <tr
                  key={job.jobId}
                  style={{
                    borderBottom: "1px solid #E5E7EB",
                    backgroundColor: index % 2 === 0 ? "#fff" : "#F9FAFB",
                  }}
                >
                  <td style={{ padding: "12px" }}>{job.jobId}</td>
                  <td style={{ padding: "12px" }}>{job.customerName}</td>
                  <td style={{ padding: "12px" }}>{job.providerId}</td>
                  <td style={{ padding: "12px" }}>{job.rating}</td>
                  <td style={{ padding: "12px" }}>
                    {job.flagged ? (
                      <span
                        style={{
                          color: "#DC2626",
                          fontWeight: "600",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        🔴 Flagged
                      </span>
                    ) : (
                      <span style={{ color: "#10B981" }}>✅ OK</span>
                    )}
                  </td>
                  <td style={{ padding: "12px", display: "flex", flexWrap: "wrap", gap: "8px" }}>
                    {job.flagged ? (
                      <>
                       {/* Refund Actions */}
<button
  className="btn btn-warning btn-sm"
  style={{ marginRight: "8px" }}
  onClick={() =>
    setShowRefundDropdown((prev) => ({
      ...prev,
      [job.jobId]: !prev[job.jobId],
    }))
  }
>
  Refund
</button>
{showRefundDropdown[job.jobId] && (
  <>
    <button
      className="btn btn-success btn-sm"
      style={{ marginRight: "8px" }}
      onClick={() => {
        handleApproveRefund(job.jobId, job.partnerId);
        toast.success("✅ Refund Approved");
      }}
    >
      Approve
    </button>
    <button
      className="btn btn-danger btn-sm"
      style={{ marginRight: "8px" }}
      onClick={() =>
        handleDeclineRefund(job.jobId, job.partnerId)
      }
    >
      Decline
    </button>
  </>
)}
                        {/* Review */}
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => {
                            handleReviewMark(job.jobId, job.partnerId);
                            toast.info("📋 Sent for Review");
                          }}
                        >
                          Review
                        </button>
                        {/* AutoBlock / Unblock */}
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() =>
                            handleAutoBlockOrUnblock(job.partnerId, "block")
                          }
                        >
                          AutoBlock
                        </button>
                        <button
                          className="btn btn-sm text-white"
                          style={{ backgroundColor: "#003366", borderColor: "#003366" }}
                          onClick={() =>
                            handleAutoBlockOrUnblock(job.partnerId, "unblock")
                          }
                        >
                          Unblock
                        </button>
                        {/* Seed Jobs */}
                        <button
                          className="btn btn-outline-secondary btn-sm"
                          onClick={seedSampleJobs}
                        >
                          🔁 Seed Jobs
                        </button>
                      </>
                    ) : (
                      <span style={{ color: "#6B7280" }}>No action needed</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p style={{ textAlign: "center", color: "#6B7280", fontFamily: "'Inter', sans-serif" }}>
            No flagged jobs available.
          </p>
        )}
      </div>
    </div>
    {/* ---------------- Partner-Blocked Providers ---------------- */}
    <div className="category-title-container" style={{ marginTop: "40px" }}>
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          🏢 Partner-Blocked Providers
        </h3>
      </div>
      <div
        className="category-form-container"
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          overflowX: "auto",
        }}
      >
        {editablePartnerBlocks.filter((r) => !isPartnerRowHidden(r.id)).length > 0 ? (
          <table
            className="data-table borderless"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "'Inter', sans-serif",
              fontSize: "14px",
              color: "#374151",
            }}
          >
            <thead style={{ backgroundColor: "#F9FAFB" }}>
              <tr>
                <th style={{ padding: "12px", textAlign: "left" }}>Partner ID</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Blocked Reason</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Status</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Blocked At</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {editablePartnerBlocks
                .filter((r) => !isPartnerRowHidden(r.id))
                .map((row, index) => {
                  const isEditing = editingPartnerRowId === row.id;
                  return (
                    <tr
                      key={row.id}
                      style={{
                        borderBottom: "1px solid #E5E7EB",
                        backgroundColor: index % 2 === 0 ? "#fff" : "#F9FAFB",
                      }}
                    >
                      <td style={{ padding: "12px" }}>
                        {isEditing ? (
                          <input
                            type="text"
                            value={tempPartnerEditState?.id || ""}
                            onChange={(e) => updatePartnerField("id", e.target.value)}
                            style={{
                              padding: "6px 10px",
                              border: "1px solid #D1D5DB",
                              borderRadius: "6px",
                              fontFamily: "'Inter', sans-serif",
                            }}
                          />
                        ) : (
                          row.id
                        )}
                      </td>
                      <td style={{ padding: "12px" }}>
                        {isEditing ? (
                          <input
                            type="text"
                            value={tempPartnerEditState?.blockReason || ""}
                            onChange={(e) =>
                              updatePartnerField("blockReason", e.target.value)
                            }
                            style={{
                              padding: "6px 10px",
                              border: "1px solid #D1D5DB",
                              borderRadius: "6px",
                              fontFamily: "'Inter', sans-serif",
                            }}
                          />
                        ) : (
                          row.blockReason || "—"
                        )}
                      </td>
                      <td style={{ padding: "12px" }}>
                        {isEditing ? (
                          <input
                            type="text"
                            value={tempPartnerEditState?.status || "Blocked"}
                            onChange={(e) => updatePartnerField("status", e.target.value)}
                            style={{
                              padding: "6px 10px",
                              border: "1px solid #D1D5DB",
                              borderRadius: "6px",
                              fontFamily: "'Inter', sans-serif",
                            }}
                          />
                        ) : (
                          row.status || "Blocked"
                        )}
                      </td>
                      <td style={{ padding: "12px" }}>
                        {isEditing ? (
                          <input
                            type="text"
                            value={
                              typeof tempPartnerEditState?.blockedAt === "string"
                                ? tempPartnerEditState.blockedAt
                                : tempPartnerEditState?.blockedAt?.toDate
                                ? tempPartnerEditState.blockedAt.toDate().toLocaleString()
                                : ""
                            }
                            onChange={(e) => updatePartnerField("blockedAt", e.target.value)}
                            style={{
                              padding: "6px 10px",
                              border: "1px solid #D1D5DB",
                              borderRadius: "6px",
                              fontFamily: "'Inter', sans-serif",
                            }}
                          />
                        ) : row.blockedAt?.toDate ? (
                          row.blockedAt.toDate().toLocaleString()
                        ) : (
                          "—"
                        )}
                      </td>
                      <td style={{ padding: "12px", display: "flex", gap: "8px" }}>
                        {isEditing ? (
                          <button
                            style={{
                              backgroundColor: "#10B981",
                              color: "#fff",
                              padding: "6px 12px",
                              borderRadius: "6px",
                              border: "none",
                              cursor: "pointer",
                            }}
                            onClick={commitPartnerRowChanges}
                          >
                            💾 Save
                          </button>
                        ) : (
                          <button
                            style={{
                              backgroundColor: "#2563EB",
                              color: "#fff",
                              padding: "6px 12px",
                              borderRadius: "6px",
                              border: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => startEditPartnerRow(row)}
                          >
                            ✏️ Edit
                          </button>
                        )}
                        <button
                          style={{
                            backgroundColor: "#DC2626",
                            color: "#fff",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            border: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => hidePartnerRowUI(row.id)}
                        >
                          🗑️ Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        ) : (
          <p
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: "14px",
              color: "#6B7280",
              textAlign: "center",
            }}
          >
            No partner-blocked providers.
          </p>
        )}
      </div>
    </div>
    </div>
  </div>
)}

{/* ✅ CUSTOMER PANEL */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "customerPanel" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Customer Panel</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
       {/* ---------------- Service Issue Escalation Panel ---------------- */}
    <div className="category-title-container">
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          🚨 Service Issue Escalation Panel
        </h3>
      </div>
      <div
        className="category-form-container"
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          overflowX: "auto",
        }}
      >
        {jobData.length > 0 ? (
          <table
            className="data-table borderless"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "'Inter', sans-serif",
              fontSize: "14px",
              color: "#374151",
            }}
          >
            <thead style={{ backgroundColor: "#F9FAFB" }}>
              <tr>
                <th style={{ padding: "12px", textAlign: "left" }}>Job ID</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Customer</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Provider</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Rating</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Status</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {jobData.map((job, index) => (
                <tr
                  key={job.jobId}
                  style={{
                    borderBottom: "1px solid #E5E7EB",
                    backgroundColor: index % 2 === 0 ? "#fff" : "#F9FAFB",
                  }}
                >
                  <td style={{ padding: "12px" }}>{job.jobId}</td>
                  <td style={{ padding: "12px" }}>{job.customerName}</td>
                  <td style={{ padding: "12px" }}>{job.providerId}</td>
                  <td style={{ padding: "12px" }}>{job.rating}</td>
                  <td style={{ padding: "12px" }}>
                    {job.flagged ? (
                      <span
                        style={{
                          color: "#DC2626",
                          fontWeight: "600",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        🔴 Flagged
                      </span>
                    ) : (
                      <span style={{ color: "#10B981" }}>✅ OK</span>
                    )}
                  </td>
                  <td
                    style={{
                      padding: "12px",
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "8px",
                    }}
                  >
                    {job.flagged ? (
                      <>
                        {/* Refund Actions */}
                        <button
                          className="btn btn-warning btn-sm"
                          style={{ marginRight: "8px" }}
                          onClick={() =>
                            handleRefundAction(
                              job.customerId,
                              job.jobId,
                              "approved"
                            )
                          }
                        >
                          Approve Refund
                        </button>
                        <button
                          className="btn btn-secondary btn-sm"
                          style={{ marginRight: "8px" }}
                          onClick={() =>
                            handleRefundAction(
                              job.customerId,
                              job.jobId,
                              "pending"
                            )
                          }
                        >
                          Pending Refund
                        </button>
                        <button
                          className="btn btn-dark btn-sm"
                          style={{ marginRight: "8px" }}
                          onClick={() =>
                            handleRefundAction(
                              job.customerId,
                              job.jobId,
                              "declined"
                            )
                          }
                        >
                          Decline Refund
                        </button>
                        {/* Review */}
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() =>
                            markUnderReview(job.customerId, job.jobId)
                          }
                        >
                          Review
                        </button>
                        {/* Auto Block */}
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => autoBlockViolators(job)}
                        >
                          Auto Block
                        </button>
                        {/* Seed Jobs */}
                        <button
                          className="btn btn-outline-secondary btn-sm"
                          onClick={seedJobsToFirestore}
                        >
                          🔁 Upload Job Data
                        </button>
                      </>
                    ) : (
                      <span style={{ color: "#6B7280" }}>No action needed</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p
            style={{
              textAlign: "center",
              color: "#6B7280",
              fontFamily: "'Inter', sans-serif",
            }}
          >
            No flagged jobs available.
          </p>
        )}
      </div>
    </div>
    {/* ---------------- Customer-Blocked Providers ---------------- */}
    <div className="category-title-container" style={{ marginTop: "40px" }}>
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          👤 Customer-Blocked Providers
        </h3>
      </div>
      <div
        className="category-form-container"
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          overflowX: "auto",
        }}
      >
        {editableCustomerBlocks.filter((r) => !isHidden(r.id)).length > 0 ? (
          <table
            className="data-table borderless"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "'Inter', sans-serif",
              fontSize: "14px",
              color: "#374151",
            }}
          >
            <thead style={{ backgroundColor: "#F9FAFB" }}>
              <tr>
                <th style={{ padding: "12px", textAlign: "left" }}>Provider ID</th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Customer Name
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>Blocked Reason</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Status</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Blocked At</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {editableCustomerBlocks
                .filter((r) => !isHidden(r.id))
                .map((row, index) => {
                  const isEditing = editingRowId === row.id;
                  return (
                    <tr
                      key={row.id}
                      style={{
                        borderBottom: "1px solid #E5E7EB",
                        backgroundColor: index % 2 === 0 ? "#fff" : "#F9FAFB",
                      }}
                    >
                      <td style={{ padding: "12px" }}>
                        {isEditing ? (
                          <input
                            type="text"
                            value={tempEditState?.id || ""}
                            onChange={(e) =>
                              updateTempField("id", e.target.value)
                            }
                            style={{
                              padding: "6px 10px",
                              border: "1px solid #D1D5DB",
                              borderRadius: "6px",
                              fontFamily: "'Inter', sans-serif",
                            }}
                          />
                        ) : (
                          row.id
                        )}
                      </td>
                      <td style={{ padding: "12px" }}>
                        {isEditing ? (
                          <input
                            type="text"
                            value={tempEditState?.customerName || ""}
                            onChange={(e) =>
                              updateTempField("customerName", e.target.value)
                            }
                            style={{
                              padding: "6px 10px",
                              border: "1px solid #D1D5DB",
                              borderRadius: "6px",
                              fontFamily: "'Inter', sans-serif",
                            }}
                          />
                        ) : (
                          row.customerName
                        )}
                      </td>
                      <td style={{ padding: "12px" }}>
                        {isEditing ? (
                          <input
                            type="text"
                            value={tempEditState?.reason || ""}
                            onChange={(e) =>
                              updateTempField("reason", e.target.value)
                            }
                            style={{
                              padding: "6px 10px",
                              border: "1px solid #D1D5DB",
                              borderRadius: "6px",
                              fontFamily: "'Inter', sans-serif",
                            }}
                          />
                        ) : (
                          row.reason
                        )}
                      </td>
                      <td style={{ padding: "12px" }}>
                        {isEditing ? (
                          <input
                            type="text"
                            value={tempEditState?.status || "Blocked"}
                            onChange={(e) =>
                              updateTempField("status", e.target.value)
                            }
                            style={{
                              padding: "6px 10px",
                              border: "1px solid #D1D5DB",
                              borderRadius: "6px",
                              fontFamily: "'Inter', sans-serif",
                            }}
                          />
                        ) : (
                          row.status || "Blocked"
                        )}
                      </td>
                      <td style={{ padding: "12px" }}>
                        {isEditing ? (
                          <input
                            type="text"
                            value={
                              typeof tempEditState?.blockedAt === "string"
                                ? tempEditState.blockedAt
                                : tempEditState?.blockedAt?.toDate
                                ? tempEditState.blockedAt.toDate().toLocaleString()
                                : ""
                            }
                            onChange={(e) =>
                              updateTempField("blockedAt", e.target.value)
                            }
                            style={{
                              padding: "6px 10px",
                              border: "1px solid #D1D5DB",
                              borderRadius: "6px",
                              fontFamily: "'Inter', sans-serif",
                            }}
                          />
                        ) : row.blockedAt?.toDate ? (
                          row.blockedAt.toDate().toLocaleString()
                        ) : (
                          "—"
                        )}
                      </td>
                      <td style={{ padding: "12px", display: "flex", gap: "8px" }}>
                        {isEditing ? (
                          <button
                            style={{
                              backgroundColor: "#10B981",
                              color: "#fff",
                              padding: "6px 12px",
                              borderRadius: "6px",
                              border: "none",
                              cursor: "pointer",
                            }}
                            onClick={commitCustomerEdit}
                          >
                            💾 Save
                          </button>
                        ) : (
                          <button
                            style={{
                              backgroundColor: "#2563EB",
                              color: "#fff",
                              padding: "6px 12px",
                              borderRadius: "6px",
                              border: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => beginEditCustomerRow(row)}
                          >
                            ✏️ Edit
                          </button>
                        )}
                        <button
                          style={{
                            backgroundColor: "#DC2626",
                            color: "#fff",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            border: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => hideCustomerUIRow(row.id)}
                        >
                          🗑️ Delete
                        </button>
                        <button
                          style={{
                            backgroundColor: "#003366",
                            color: "#fff",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            border: "none",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            handleUnblock(row.customerId, row.id || row.providerId)
                          }
                        >
                          🔓 Unblock
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        ) : (
          <p
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: "14px",
              color: "#6B7280",
              textAlign: "center",
            }}
          >
            No customer-blocked providers.
          </p>
        )}
      </div>
    </div>
    </div>
  </div>
)}


{/* ✅ PROVIDER PROFILE */}
{currentUser &&
  currentView === "providerProfile" &&
  (() => {
    // Target Provider ID and User UID references
    const targetProviderId =
      activeProviderRecord?.providerId ||
      activeProviderRecord?.id ||
      activeProviderRecord?.uid;
    const targetUserId =
      activeProviderRecord?.uid ||
      activeProviderRecord?.id ||
      activeProviderRecord?.providerId;
    // Fast-reactive multi-criteria filter store (Crash-proof singleton: survives HMR and prevents undefined .has() errors)
    const getFilterStore = () => {
      if (typeof window === "undefined") {
        return {
          serviceName: "",
          category: "",
          maxPrice: "",
          recycleBinTargetService: null,
          inFlightActionIds: new Set(),
        };
      }
      if (!window.__crmProfileFilterStore || typeof window.__crmProfileFilterStore !== "object") {
        window.__crmProfileFilterStore = {};
      }
      const store = window.__crmProfileFilterStore;
      if (typeof store.serviceName !== "string") store.serviceName = "";
      if (typeof store.category !== "string") store.category = "";
      if (typeof store.maxPrice !== "string") store.maxPrice = "";
      if (!store.inFlightActionIds || !(store.inFlightActionIds instanceof Set)) {
        store.inFlightActionIds = new Set();
      }
      return store;
    };
    const filterStore = getFilterStore();
    // Safe helper to check if an action is currently in flight for a service
    const isActionInFlight = (id) => {
      if (!id || !filterStore || !filterStore.inFlightActionIds || !(filterStore.inFlightActionIds instanceof Set)) {
        return false;
      }
      return filterStore.inFlightActionIds.has(String(id));
    };
    // Instant lag-free re-render trigger for filter updates and backspace clearing
    const triggerFastReRender = () => {
      if (typeof setFilteredSubmissions === "function") {
        setFilteredSubmissions((prev) => (prev ? [...prev] : []));
      } else if (typeof setConfirmationModal === "function") {
        setConfirmationModal((prev) => ({ ...prev }));
      }
    };
    // Generic prompt helper to collect an admin-entered note/reason for an action.
    // Used by upload, edit, delete (recycle) and recovery flows so every media
    // action can carry a human-readable reason into the audit trail.
    const promptForActionReason = (message, defaultValue = "") => {
      try {
        const val = window.prompt(message, defaultValue);
        return val === null ? null : val.trim();
      } catch (e) {
        return "";
      }
    };
    // Helper to resolve Firestore reference across Modular and Compat SDKs
    const getFirestoreInstance = () => {
      if (typeof db !== "undefined" && db) return db;
      if (typeof firestore !== "undefined" && firestore) return firestore;
      if (typeof window !== "undefined") {
        return window.db || window.firestore || null;
      }
      return null;
    };
    // Universal DocRef Resolver supporting both Modular and Compat versions
    const getUniversalDocRef = (pathString) => {
      const dbRef = getFirestoreInstance();
      if (!dbRef || !pathString) return null;
      const cleanPath = pathString.replace(/^\/+|\/+$/g, "");
      const segments = cleanPath.split("/").filter(Boolean);
      if (segments.length % 2 !== 0) return null;
      if (typeof doc === "function") {
        try { return doc(dbRef, ...segments); } catch (e) {}
      }
      if (typeof window !== "undefined" && typeof window.doc === "function") {
        try { return window.doc(dbRef, ...segments); } catch (e) {}
      }
      if (typeof dbRef.doc === "function") {
        try { return dbRef.doc(cleanPath); } catch (e) {}
      }
      if (typeof dbRef.collection === "function") {
        try {
          let curr = dbRef;
          for (let i = 0; i < segments.length; i += 2) {
            curr = curr.collection(segments[i]).doc(segments[i + 1]);
          }
          return curr;
        } catch (e) {}
      }
      return null;
    };
    // =========================================================================
    // 🛡️ UNIVERSAL MEDIA EXTRACTOR (Shared between Table and Inspect Modal)
    // Ensures all images display properly in both the main grid and inspect dossier!
    // =========================================================================
    const extractAllMedia = (rec) => {
      if (!rec || typeof rec !== "object") return [];
      const list = [];
      const seenUrls = new Set();
      const binUrls = new Set(
        (Array.isArray(rec.recycle_bin) ? rec.recycle_bin : []).map(
          (b) => (typeof b === "string" ? b.trim() : (b?.url || b?.file || "").trim())
        ).filter(Boolean)
      );
      const add = (item) => {
        if (!item) return;
        let url = "";
        let type = "image";
        let status = rec.approval_status || rec.status || "pending";
        let approval_status = rec.approval_status || rec.status || "pending";
        let is_approved = rec.is_approved || status === "approved" || approval_status === "approved";
        let caption = "";
        if (typeof item === "string") {
          url = item.trim();
          type = (url.includes(".mp4") || url.includes(".webm") || url.includes(".mov") || url.includes(".mkv") || url.startsWith("data:video")) ? "video" : "image";
        } else if (typeof item === "object") {
          url = (item.url || item.file || item.image || item.fileUrl || item.downloadURL || item.src || "").trim();
          type = item.type || ((url.includes(".mp4") || url.includes(".webm") || url.includes(".mov") || url.includes(".mkv") || url.startsWith("data:video")) ? "video" : "image");
          status = item.status || status;
          approval_status = item.approval_status || item.status || approval_status;
          is_approved = item.is_approved ?? is_approved;
          caption = item.caption || item.title || "";
        }

        if (url && !seenUrls.has(url) && !binUrls.has(url)) {
          seenUrls.add(url);
          list.push(
            typeof item === "object"
              ? { ...item, url, file: url, type, status, approval_status, is_approved, caption }
              : { url, file: url, type, status, approval_status, is_approved, caption }
          );
        }
      };
      if (Array.isArray(rec.gallery_media)) rec.gallery_media.forEach(add);
      else if (rec.gallery_media?.items && Array.isArray(rec.gallery_media.items)) rec.gallery_media.items.forEach(add);
      if (Array.isArray(rec.media)) rec.media.forEach(add);
      else if (rec.media?.items && Array.isArray(rec.media.items)) rec.media.items.forEach(add);
      if (Array.isArray(rec.gallery_images)) rec.gallery_images.forEach(add);
      if (Array.isArray(rec.images)) rec.images.forEach(add);
      if (Array.isArray(rec.photos)) rec.photos.forEach(add);
      if (rec.coverImage) add(rec.coverImage);
      if (rec.serviceImage) add(rec.serviceImage);
      if (rec.thumbnail) add(rec.thumbnail);
      if (rec.image) add(rec.image);
      return list;
    };
    // =========================================================================
    // 🔍 SCAN & READ ALL SERVICES FROM 3 FIREBASE COLLECTIONS STRICTLY BY PROVIDER ID
    // 1) admin_pending_approvals/services/pending/{serviceId}
    // 2) users/{providerId}/Notification/{serviceId}
    // 3) All_categories/{category}/subCategories/{subCategory}/Notification/{serviceId}
    //
    // CRITICAL: Checks description_status & media_status across all 3 collections.
    // If either is "new_request" or "pending", it flags the service as pending so
    // buttons reappear!
    // =========================================================================
    const fetchProviderServicesFromThreeCollections = async () => {
      const dbRef = getFirestoreInstance();
      if (!dbRef) return;
      try {
        const aggregatedServicesMap = new Map();
        const pendingFlagsMap = new Map();
        const candidateProviderIds = new Set(
          [
            targetProviderId,
            targetUserId,
            activeProviderRecord?.id,
            activeProviderRecord?.uid,
            activeProviderRecord?.providerId,
          ]
            .filter(Boolean)
            .map((val) => String(val).trim())
        );
        const isMatchProvider = (data) => {
          if (candidateProviderIds.size === 0) return true;
          const recProvId = String(data?.providerId || data?.provider_id || "").trim();
          const recUid = String(data?.uid || data?.userId || data?.user_id || "").trim();
          const nestedProvId = String(data?.provider?.id || data?.provider?.uid || data?.provider?.providerId || "").trim();
          return (
            (recProvId && candidateProviderIds.has(recProvId)) ||
            (recUid && candidateProviderIds.has(recUid)) ||
            (nestedProvId && candidateProviderIds.has(nestedProvId))
          );
        };
        const detectIsPending = (data) => {
          if (!data) return false;
          const stStatus = String(data.status || "").toLowerCase().trim();
          const appStatus = String(data.approval_status || "").toLowerCase().trim();
          const descStatus = String(data.description_status || "").toLowerCase().trim();
          const medStatus = String(data.media_status || data.media?.status || data.gallery_media?.status || "").toLowerCase().trim();
          return (
            stStatus === "pending" ||
            stStatus === "new_request" ||
            stStatus === "under_review" ||
            appStatus === "pending" ||
            appStatus === "new_request" ||
            appStatus === "under_review" ||
            descStatus === "pending" ||
            descStatus === "new_request" ||
            descStatus === "under_review" ||
            medStatus === "pending" ||
            medStatus === "new_request" ||
            medStatus === "under_review" ||
            Boolean(data.edited_by_provider) ||
            Boolean(data.has_pending_edits)
          );
        };
        // 1. Scan admin_pending_approvals/services/pending
        try {
          if (typeof getDocs === "function" && typeof collection === "function") {
            const pendingSnap = await getDocs(
              collection(dbRef, "admin_pending_approvals", "services", "pending")
            );
            pendingSnap.forEach((docSnap) => {
              const data = docSnap.data() || {};
              const existingServiceId = docSnap.id;
              if (isMatchProvider(data)) {
                aggregatedServicesMap.set(existingServiceId, {
                  ...data,
                  id: existingServiceId,
                  service_id: existingServiceId,
                  sourcePath: "admin_pending_approvals/services/pending",
                });
                pendingFlagsMap.set(existingServiceId, true);
              }
            });
            try {
              const rootPendingSnap = await getDocs(collection(dbRef, "admin_pending_approvals"));
              rootPendingSnap.forEach((docSnap) => {
                if (docSnap.id === "services") return;
                const data = docSnap.data() || {};
                const existingServiceId = docSnap.id;
                if (isMatchProvider(data)) {
                  const existing = aggregatedServicesMap.get(existingServiceId) || {};
                  aggregatedServicesMap.set(existingServiceId, {
                    ...existing,
                    ...data,
                    id: existingServiceId,
                    service_id: existingServiceId,
                    sourcePath: existing.sourcePath || "admin_pending_approvals",
                  });
                  pendingFlagsMap.set(existingServiceId, true);
                }
              });
            } catch (rootErr) {
              console.warn("admin_pending_approvals root fallback check:", rootErr);
            }
          } else if (typeof dbRef.collection === "function") {
            const pendingSnap = await dbRef
              .collection("admin_pending_approvals")
              .doc("services")
              .collection("pending")
              .get();
            pendingSnap.forEach((docSnap) => {
              const data = docSnap.data() || {};
              const existingServiceId = docSnap.id;
              if (isMatchProvider(data)) {
                aggregatedServicesMap.set(existingServiceId, {
                  ...data,
                  id: existingServiceId,
                  service_id: existingServiceId,
                  sourcePath: "admin_pending_approvals/services/pending",
                });
                pendingFlagsMap.set(existingServiceId, true);
              }
            });
            try {
              const rootPendingSnap = await dbRef.collection("admin_pending_approvals").get();
              rootPendingSnap.forEach((docSnap) => {
                if (docSnap.id === "services") return;
                const data = docSnap.data() || {};
                const existingServiceId = docSnap.id;
                if (isMatchProvider(data)) {
                  const existing = aggregatedServicesMap.get(existingServiceId) || {};
                  aggregatedServicesMap.set(existingServiceId, {
                    ...existing,
                    ...data,
                    id: existingServiceId,
                    service_id: existingServiceId,
                    sourcePath: existing.sourcePath || "admin_pending_approvals",
                  });
                  pendingFlagsMap.set(existingServiceId, true);
                }
              });
            } catch (rootErr) {
              console.warn("Compat admin_pending_approvals root check:", rootErr);
            }
          }
        } catch (e) {
          console.warn("Error reading admin_pending_approvals/services/pending:", e);
        }
        // 2. Scan users/{providerId}/Notification/{serviceId}
        const scannedUserIds = new Set(candidateProviderIds);
        for (const provUid of scannedUserIds) {
          if (!provUid) continue;
          try {
            if (typeof getDocs === "function" && typeof collection === "function") {
              const userNotifSnap = await getDocs(
                collection(dbRef, "users", provUid, "Notification")
              );
              userNotifSnap.forEach((docSnap) => {
                const data = docSnap.data() || {};
                const existingServiceId = docSnap.id;
                const existing = aggregatedServicesMap.get(existingServiceId) || {};
                if (detectIsPending(data)) {
                  pendingFlagsMap.set(existingServiceId, true);
                }
                aggregatedServicesMap.set(existingServiceId, {
                  ...existing,
                  ...data,
                  id: existingServiceId,
                  service_id: existingServiceId,
                  providerId: data.providerId || data.provider_id || provUid,
                  uid: data.uid || provUid,
                  _userNotifPath: docSnap.ref?.path || `users/${provUid}/Notification/${existingServiceId}`,
                });
              });
            } else if (typeof dbRef.collection === "function") {
              const userNotifSnap = await dbRef
                .collection("users")
                .doc(provUid)
                .collection("Notification")
                .get();
              userNotifSnap.forEach((docSnap) => {
                const data = docSnap.data() || {};
                const existingServiceId = docSnap.id;
                const existing = aggregatedServicesMap.get(existingServiceId) || {};
                if (detectIsPending(data)) {
                  pendingFlagsMap.set(existingServiceId, true);
                }
                aggregatedServicesMap.set(existingServiceId, {
                  ...existing,
                  ...data,
                  id: existingServiceId,
                  service_id: existingServiceId,
                  providerId: data.providerId || data.provider_id || provUid,
                  uid: data.uid || provUid,
                  _userNotifPath: docSnap.ref?.path || `users/${provUid}/Notification/${existingServiceId}`,
                });
              });
            }
          } catch (e) {
            console.warn(`Error reading users/${provUid}/Notification:`, e);
          }
        }
        // 3. Scan All_categories/{category}/subCategories/{subCategory}/Notification/{serviceId}
        try {
          if (typeof collectionGroup === "function" && typeof getDocs === "function") {
            const notifGroupSnap = await getDocs(collectionGroup(dbRef, "Notification"));
            notifGroupSnap.forEach((docSnap) => {
              const data = docSnap.data() || {};
              const path = docSnap.ref?.path || "";
              if (path.includes("All_categories") || path.includes("subCategories")) {
                const existingServiceId = docSnap.id;
                if (isMatchProvider(data)) {
                  if (detectIsPending(data)) {
                    pendingFlagsMap.set(existingServiceId, true);
                  }
                  const pathSegments = path.split("/");
                  const pathCategory = pathSegments[0] === "All_categories" ? pathSegments[1] : undefined;
                  const pathSubCategory = pathSegments[2] === "subCategories" ? pathSegments[3] : undefined;
                  const existing = aggregatedServicesMap.get(existingServiceId) || {};
                  aggregatedServicesMap.set(existingServiceId, {
                    ...existing,
                    ...data,
                    id: existingServiceId,
                    service_id: existingServiceId,
                    category: data.category || data.category_name || pathCategory || existing.category,
                    sub_category: data.sub_category || data.subCategory || pathSubCategory || existing.sub_category,
                    _categoryNotifPath: path,
                  });
                }
              }
            });
          } else if (typeof dbRef.collectionGroup === "function") {
            const notifGroupSnap = await dbRef.collectionGroup("Notification").get();
            notifGroupSnap.forEach((docSnap) => {
              const data = docSnap.data() || {};
              const path = docSnap.ref?.path || "";
              if (path.includes("All_categories") || path.includes("subCategories")) {
                const existingServiceId = docSnap.id;
                if (isMatchProvider(data)) {
                  if (detectIsPending(data)) {
                    pendingFlagsMap.set(existingServiceId, true);
                  }
                  const pathSegments = path.split("/");
                  const pathCategory = pathSegments[0] === "All_categories" ? pathSegments[1] : undefined;
                  const pathSubCategory = pathSegments[2] === "subCategories" ? pathSegments[3] : undefined;
                  const existing = aggregatedServicesMap.get(existingServiceId) || {};
                  aggregatedServicesMap.set(existingServiceId, {
                    ...existing,
                    ...data,
                    id: existingServiceId,
                    service_id: existingServiceId,
                    category: data.category || data.category_name || pathCategory || existing.category,
                    sub_category: data.sub_category || data.subCategory || pathSubCategory || existing.sub_category,
                    _categoryNotifPath: path,
                  });
                }
              }
            });
          }
        } catch (e) {
          console.warn("Error reading All_categories Notification subcollections:", e);
        }
        // Cross-match verified provider services & prioritize pending status if description_status or media_status is pending/new_request
        const verifiedServices = [];
        for (const [existingServiceId, serviceRecord] of aggregatedServicesMap.entries()) {
          const recUid = serviceRecord.uid || serviceRecord.userId || serviceRecord.user_id;
          const recProviderId = serviceRecord.providerId || serviceRecord.provider_id;
          const isCustomer =
            serviceRecord.role === "customer" ||
            serviceRecord.user_role === "customer" ||
            serviceRecord.account_type === "customer" ||
            serviceRecord.type === "customer";
          if (isCustomer) continue;
          let isVerifiedProvider = false;
          if (
            (targetProviderId && (recProviderId === targetProviderId || existingServiceId === targetProviderId)) ||
            (targetUserId && (recUid === targetUserId || existingServiceId === targetUserId)) ||
            candidateProviderIds.has(String(recProviderId)) ||
            candidateProviderIds.has(String(recUid))
          ) {
            isVerifiedProvider = true;
          }
          if (!isVerifiedProvider && (recUid || recProviderId)) {
            try {
              if (typeof doc === "function" && typeof getDoc === "function") {
                if (recUid) {
                  const userSnap = await getDoc(doc(dbRef, "users", recUid));
                  if (userSnap.exists()) {
                    const uData = userSnap.data();
                    if (
                      uData.role !== "customer" &&
                      uData.account_type !== "customer" &&
                      (uData.role === "provider" || uData.user_type === "provider" || uData.isProvider === true || !uData.role)
                    ) {
                      isVerifiedProvider = true;
                    }
                  }
                }
                if (!isVerifiedProvider && recProviderId) {
                  const provSnap = await getDoc(doc(dbRef, "providers", recProviderId));
                  if (provSnap.exists()) {
                    isVerifiedProvider = true;
                  }
                }
              } else if (typeof dbRef.collection === "function") {
                if (recUid) {
                  const userSnap = await dbRef.collection("users").doc(recUid).get();
                  if (userSnap.exists) {
                    const uData = userSnap.data();
                    if (
                      uData.role !== "customer" &&
                      uData.account_type !== "customer" &&
                      (uData.role === "provider" || uData.user_type === "provider" || uData.isProvider === true || !uData.role)
                    ) {
                      isVerifiedProvider = true;
                    }
                  }
                }
                if (!isVerifiedProvider && recProviderId) {
                  const provSnap = await dbRef.collection("providers").doc(recProviderId).get();
                  if (provSnap.exists) {
                    isVerifiedProvider = true;
                  }
                }
              }
            } catch (err) {
              console.warn("Exception during provider verification cross-match:", err);
            }
          }
          if (isVerifiedProvider) {
            let galleryMediaList = Array.isArray(serviceRecord.gallery_media)
              ? serviceRecord.gallery_media
              : Array.isArray(serviceRecord.gallery_images)
              ? serviceRecord.gallery_images
              : serviceRecord.gallery_media?.items || [];
            // REAPPEAR CHECK: Any signal that description_status, media_status, or status is pending/new_request
            const hasPendingSignal =
              pendingFlagsMap.get(existingServiceId) === true ||
              detectIsPending(serviceRecord) ||
              serviceRecord.sourcePath === "admin_pending_approvals/services/pending" ||
              galleryMediaList.some(
                (m) => typeof m === "object" && m !== null && (m.status === "pending" || m.approval_status === "pending" || m.status === "new_request" || m.status === "under_review" || !m.status)
              );
            let finalStatus = "pending";
            let finalApprovalStatus = "pending";
            let finalDescriptionStatus = "pending";
            let finalMediaStatus = "pending";
            let isAlreadyApproved = false;
            let isAlreadyRejected = false;
            if (hasPendingSignal) {
              finalStatus = "pending";
              finalApprovalStatus = "pending";
              finalDescriptionStatus = "pending";
              finalMediaStatus = "pending";
              isAlreadyApproved = false;
              isAlreadyRejected = false;
            } else {
              const wasPreviouslyApproved =
                serviceRecord.status === "approved" ||
                serviceRecord.approval_status === "approved" ||
                serviceRecord.is_approved === true;
              const wasPreviouslyRejected =
                serviceRecord.status === "rejected" ||
                serviceRecord.status === "declined" ||
                serviceRecord.approval_status === "rejected" ||
                serviceRecord.approval_status === "declined" ||
                serviceRecord.is_rejected === true ||
                Boolean(serviceRecord.rejection_reason && serviceRecord.rejection_reason.trim());
              if (wasPreviouslyApproved) {
                finalStatus = "approved";
                finalApprovalStatus = "approved";
                finalDescriptionStatus = "approved";
                finalMediaStatus = "approved";
                isAlreadyApproved = true;
              } else if (wasPreviouslyRejected) {
                finalStatus = "rejected";
                finalApprovalStatus = "rejected";
                finalDescriptionStatus = "rejected";
                finalMediaStatus = "rejected";
                isAlreadyRejected = true;
              } else {
                finalStatus = serviceRecord.status || "pending";
                finalApprovalStatus = serviceRecord.approval_status || finalStatus;
                finalDescriptionStatus = serviceRecord.description_status || finalStatus;
                finalMediaStatus = serviceRecord.media_status || serviceRecord.media?.status || finalStatus;
              }
            }
            const normalizedGalleryList = galleryMediaList.map((m) => {
              if (typeof m === "object" && m !== null) {
                if (isAlreadyApproved) return { ...m, status: "approved", approval_status: "approved", is_approved: true, is_rejected: false };
                if (isAlreadyRejected) return { ...m, status: "rejected", approval_status: "rejected", is_approved: false, is_rejected: true };
                return { ...m, status: m.status || "pending", approval_status: m.approval_status || m.status || "pending" };
              }
              return m;
            });
            const recycleBinList = Array.isArray(serviceRecord.recycle_bin) ? serviceRecord.recycle_bin : [];
            verifiedServices.push({
              ...serviceRecord,
              id: existingServiceId,
              service_id: existingServiceId,
              status: finalStatus,
              approval_status: finalApprovalStatus,
              description_status: finalDescriptionStatus,
              media_status: finalMediaStatus,
              is_active: isAlreadyApproved ? true : false,
              is_approved: isAlreadyApproved,
              is_rejected: isAlreadyRejected,
              rejection_reason: isAlreadyApproved ? "" : serviceRecord.rejection_reason || "",
              approval_reason: isAlreadyApproved ? (serviceRecord.approval_reason || "Approved") : "",
              reviewed_at: serviceRecord.reviewed_at || "",
              reviewed_by: serviceRecord.reviewed_by || "",
              gallery_media: normalizedGalleryList,
              gallery_images: Array.isArray(serviceRecord.gallery_images) ? serviceRecord.gallery_images : [],
              images: Array.isArray(serviceRecord.images) ? serviceRecord.images : normalizedGalleryList,
              recycle_bin: recycleBinList,
              recycle_bin_count: recycleBinList.length,
              media: {
                ...(typeof serviceRecord.media === "object" && serviceRecord.media !== null ? serviceRecord.media : {}),
                status: finalMediaStatus,
                approval_status: finalMediaStatus,
              },
            });
          }
        }
        if (verifiedServices.length > 0) {
          if (typeof setFilteredSubmissions === "function") {
            setFilteredSubmissions((prev) => {
              const existingMap = new Map((prev || []).map((item) => [item.id || item.service_id, item]));
              verifiedServices.forEach((item) => {
                const sId = item.id || item.service_id;
                existingMap.set(sId, item);
              });
              return Array.from(existingMap.values());
            });
          }
          if (typeof setSubmissions === "function") {
            setSubmissions((prev) => {
              const existingMap = new Map((prev || []).map((item) => [item.id || item.service_id, item]));
              verifiedServices.forEach((item) => {
                const sId = item.id || item.service_id;
                existingMap.set(sId, item);
              });
              return Array.from(existingMap.values());
            });
          }
        }
      } catch (error) {
        console.error("Error scanning and reading services across collections:", error);
      }
    };
    // Filter services strictly matching verified provider credentials
    const providerScopedSubmissions = (filteredSubmissions || []).filter((record) => {
      const isCustomer =
        record?.role === "customer" ||
        record?.user_role === "customer" ||
        record?.account_type === "customer";
      if (isCustomer) return false;
      if (!targetProviderId && !targetUserId) return true;
      const recProviderId = record?.providerId || record?.provider_id;
      const recUid = record?.uid || record?.userId || record?.user_id;
      return (
        (recProviderId && (recProviderId === targetProviderId || recProviderId === targetUserId)) ||
        (recUid && (recUid === targetUserId || recUid === targetProviderId)) ||
        (record?.id && (record.id === targetProviderId || record.id === targetUserId))
      );
    });
    // Multi-criteria filter: Service Name, Category, Price (Instant 0ms lag)
    const filteredByCriteriaSubmissions = providerScopedSubmissions.filter((record) => {
      if (filterQueryToken && filterQueryToken.trim()) {
        const token = filterQueryToken.trim().toLowerCase();
        const matchGeneral =
          (record.service_name && record.service_name.toLowerCase().includes(token)) ||
          (record.id && String(record.id).toLowerCase().includes(token)) ||
          (record.service_id && String(record.service_id).toLowerCase().includes(token)) ||
          (record.category && record.category.toLowerCase().includes(token)) ||
          (record.sub_category && record.sub_category.toLowerCase().includes(token)) ||
          (record.provider_name && record.provider_name.toLowerCase().includes(token));
        if (!matchGeneral) return false;
      }
      if (filterStore.serviceName && filterStore.serviceName.trim()) {
        const queryName = filterStore.serviceName.trim().toLowerCase();
        const serviceNameStr = (record.service_name || record.name || "").toLowerCase();
        if (!serviceNameStr.includes(queryName)) return false;
      }
      if (filterStore.category && filterStore.category.trim()) {
        const queryCategory = filterStore.category.trim().toLowerCase();
        const catStr = (record.category || record.category_name || "").toLowerCase();
        const subCatStr = (record.sub_category || record.subCategory || "").toLowerCase();
        if (!catStr.includes(queryCategory) && !subCatStr.includes(queryCategory)) return false;
      }
      if (filterStore.maxPrice && filterStore.maxPrice.trim()) {
        const maxVal = parseFloat(filterStore.maxPrice.trim());
        if (!isNaN(maxVal)) {
          const itemPrice = parseFloat(record.price) || 0;
          if (itemPrice > maxVal) return false;
        }
      }
      return true;
    });
    // Provider aggregate metrics with description_status and media_status validation
    const providerAggregateMetrics = {
      totalSubmissions: providerScopedSubmissions.length,
      pendingReview: providerScopedSubmissions.filter((s) => {
        const st = String(s?.status || "").toLowerCase().trim();
        const app = String(s?.approval_status || "").toLowerCase().trim();
        const desc = String(s?.description_status || "").toLowerCase().trim();
        const med = String(s?.media_status || s?.media?.status || s?.gallery_media?.status || "").toLowerCase().trim();
        return (
          st === "pending" || st === "new_request" || st === "under_review" ||
          app === "pending" || app === "new_request" || app === "under_review" ||
          desc === "pending" || desc === "new_request" || desc === "under_review" ||
          med === "pending" || med === "new_request" || med === "under_review"
        );
      }).length,
      approvedSubmissions: providerScopedSubmissions.filter((s) => {
        const st = String(s?.status || "").toLowerCase().trim();
        const app = String(s?.approval_status || "").toLowerCase().trim();
        const desc = String(s?.description_status || "").toLowerCase().trim();
        const med = String(s?.media_status || "").toLowerCase().trim();
        const isApp = st === "approved" || app === "approved" || s?.is_approved === true;
        const isNotPending = desc !== "pending" && desc !== "new_request" && med !== "pending" && med !== "new_request";
        return isApp && isNotPending;
      }).length,
      rejectedSubmissions: providerScopedSubmissions.filter((s) => {
        const st = String(s?.status || "").toLowerCase().trim();
        const app = String(s?.approval_status || "").toLowerCase().trim();
        const desc = String(s?.description_status || "").toLowerCase().trim();
        const med = String(s?.media_status || "").toLowerCase().trim();
        const isRej =
          st === "rejected" || st === "declined" ||
          app === "rejected" || app === "declined" ||
          s?.is_rejected === true ||
          Boolean(s?.rejection_reason && s?.rejection_reason.trim());
        const isNotPending = desc !== "pending" && desc !== "new_request" && med !== "pending" && med !== "new_request";
        return isRej && isNotPending;
      }).length,
    };
    // ==============================================================
    // 🔒 PERSISTENT AUDIT & ACCESS LOGGING SYSTEM (LOCALSTORAGE)
    // ==============================================================
    const LOCAL_STORAGE_LOGS_KEY = "service_approval_access_logs";
    const getStoredApprovalLogs = () => {
      try {
        const stored = localStorage.getItem(LOCAL_STORAGE_LOGS_KEY);
        return stored ? JSON.parse(stored) : [];
      } catch (err) {
        console.error("Error reading approval audit logs:", err);
        return [];
      }
    };
    const recordServiceApprovalAccessLog = (entry = {}) => {
      try {
        const currentLogs = getStoredApprovalLogs();
        const newLogEntry = {
          id: "log_" + Date.now() + "_" + Math.random().toString(36).substring(2, 7),
          timestamp: new Date().toLocaleString(),
          isoTimestamp: new Date().toISOString(),
          accessedBy: {
            uid: currentUser?.uid || "N/A",
            email: currentUser?.email || "Unknown Email",
            name:
              currentUser?.displayName ||
              currentUser?.name ||
              currentUser?.username ||
              currentUser?.email?.split("@")[0] ||
              "Admin User",
            role: currentUser?.role || "Administrator",
          },
          actionType: entry.actionType || "VIEW_APPROVAL_REGISTRY",
          actionLabel: entry.actionLabel || "Accessed Service Approval Registry",
          providerId: targetProviderId || "N/A",
          providerName:
            activeProviderRecord?.name ||
            activeProviderRecord?.username ||
            "N/A",
          serviceId: entry.serviceId || "N/A",
          serviceName: entry.serviceName || "N/A",
          details: entry.details || "",
          reason: entry.reason || "",
        };
        const updatedLogs = [newLogEntry, ...currentLogs];
        localStorage.setItem(LOCAL_STORAGE_LOGS_KEY, JSON.stringify(updatedLogs));
        return updatedLogs;
      } catch (err) {
        console.error("Error saving approval audit log:", err);
        return [];
      }
    };

    const handleClearApprovalLogs = () => {
      if (window.confirm("Are you sure you want to clear all Service Approval audit logs?")) {
        try {
          localStorage.removeItem(LOCAL_STORAGE_LOGS_KEY);
          setActiveTab((prev) => (prev === "Approval Logs" ? "Approval Logs" : prev));
        } catch (e) {
          console.error(e);
        }
      }
    };
    const handleExportApprovalLogs = () => {
      try {
        const logs = getStoredApprovalLogs();
        const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(logs, null, 2));
        const downloadAnchor = document.createElement("a");
        downloadAnchor.setAttribute("href", dataStr);
        downloadAnchor.setAttribute("download", `service_approval_logs_${new Date().toISOString().slice(0, 10)}.json`);
        document.body.appendChild(downloadAnchor);
        downloadAnchor.click();
        downloadAnchor.remove();
      } catch (e) {
        console.error("Export logs error:", e);
      }
    };
    if (activeTab === "Service Approval") {
      const lastLoggedStamp = window.__lastServiceApprovalAccessStamp || 0;
      const now = Date.now();
      if (now - lastLoggedStamp > 10000) {
        window.__lastServiceApprovalAccessStamp = now;
        setTimeout(() => {
          recordServiceApprovalAccessLog({
            actionType: "REGISTRY_OPENED",
            actionLabel: "Accessed Service Approval Registry Window",
            details: `Registry viewed for Provider: ${activeProviderRecord?.name || targetProviderId || "All"}`,
          });
          fetchProviderServicesFromThreeCollections();
        }, 0);
      }
    }
    // =========================================================================
    // 🛡️ ZERO-LOSS MEDIA & IMAGES ARRAY NORMALIZER
    // Ensures all images are preserved AND approval_status/media_status are updated!
    // =========================================================================
    const harvestAndSyncMediaStructures = (sourceRecord, targetStatus) => {
      const isApproved = targetStatus === "approved";
      const isRejected = targetStatus === "rejected";
      const seen = new Set();
      const harvestedItems = [];
      const pushUrl = (u, title = "", extraMeta = {}) => {
        if (!u || typeof u !== "string") return;
        const clean = u.trim();
        if (!clean.startsWith("http") && !clean.startsWith("data:image") && !clean.startsWith("data:video") && !clean.startsWith("blob:")) return;
        if (seen.has(clean)) return;
        seen.add(clean);
        const isVid = (extraMeta && extraMeta.type === "video") || clean.includes(".mp4") || clean.includes(".mov") || clean.includes(".webm") || clean.includes(".mkv") || clean.startsWith("data:video");
        // Overwrite pending statuses with the new target decision
        harvestedItems.push({
          ...(extraMeta && typeof extraMeta === "object" ? extraMeta : {}),
          url: clean,
          file: clean,
          type: isVid ? "video" : "image",
          status: targetStatus,
          approval_status: targetStatus,
          media_status: targetStatus,
          is_approved: isApproved,
          is_rejected: isRejected,
          caption: (extraMeta && extraMeta.caption) || title || (isVid ? "Service Video" : "Service Media"),
        });
      };
      const inspectContainer = (container, label) => {
        if (!container) return;
        if (typeof container === "string") {
          pushUrl(container, label);
          return;
        }
        if (Array.isArray(container)) {
          container.forEach((item, idx) => {
            if (typeof item === "string") {
              pushUrl(item, `${label} #${idx + 1}`);
            } else if (item && typeof item === "object") {
              const urlCandidate = item.url || item.file || item.image || item.fileUrl || item.downloadURL || item.src;
              pushUrl(urlCandidate, item.caption || item.title || `${label} #${idx + 1}`, item);
            }
          });
          return;
        }
        if (typeof container === "object") {
          if (Array.isArray(container.items)) inspectContainer(container.items, `${label}_items`);
          if (Array.isArray(container.urls)) inspectContainer(container.urls, `${label}_urls`);
          if (Array.isArray(container.images)) inspectContainer(container.images, `${label}_images`);
          if (Array.isArray(container.media)) inspectContainer(container.media, `${label}_media`);
          const singleUrl = container.url || container.file || container.image || container.fileUrl || container.downloadURL;
          if (singleUrl) pushUrl(singleUrl, container.caption || container.title || label, container);
          Object.keys(container).forEach((k) => {
            if (["status", "approval_status", "media_status", "description_status", "items", "urls", "images", "media", "updatedAt", "createdAt", "recycle_bin"].includes(k)) return;
            const val = container[k];
            if (typeof val === "string") pushUrl(val, k);
            else if (val && typeof val === "object") inspectContainer(val, k);
          });
        }
      };
      inspectContainer(sourceRecord.gallery_media, "gallery_media");
      inspectContainer(sourceRecord.media, "media");
      inspectContainer(sourceRecord.gallery_images, "gallery_images");
      inspectContainer(sourceRecord.images, "images");
      inspectContainer(sourceRecord.photos, "photos");
      if (sourceRecord.coverImage) pushUrl(sourceRecord.coverImage, "Cover Photo");
      if (sourceRecord.serviceImage) pushUrl(sourceRecord.serviceImage, "Service Photo");
      if (sourceRecord.thumbnail) pushUrl(sourceRecord.thumbnail, "Thumbnail");
      if (sourceRecord.image) pushUrl(sourceRecord.image, "Main Image");
      const binUrls = new Set(
        (Array.isArray(sourceRecord.recycle_bin) ? sourceRecord.recycle_bin : []).map(
          (b) => (typeof b === "string" ? b.trim() : (b?.url || b?.file || "").trim())
        ).filter(Boolean)
      );
      const activeHarvested = harvestedItems.filter((item) => !binUrls.has(item.url));
      const itemsArray = activeHarvested.map((item, idx) => ({
        ...item,
        order: typeof item.order === "number" ? item.order : idx,
        status: targetStatus,
        approval_status: targetStatus,
        media_status: targetStatus,
        is_approved: isApproved,
        is_rejected: isRejected,
      }));
      let resolvedImagesArray = [];
      if (Array.isArray(sourceRecord.images) && sourceRecord.images.length > 0) {
        resolvedImagesArray = sourceRecord.images
          .filter((imgObj) => {
            const u = typeof imgObj === "string" ? imgObj : imgObj?.url || imgObj?.file;
            return !binUrls.has(u);
          })
          .map((imgObj, idx) => {
            if (typeof imgObj === "object" && imgObj !== null) {
              return {
                ...imgObj,
                status: targetStatus,
                approval_status: targetStatus,
                media_status: targetStatus,
                is_approved: isApproved,
                is_rejected: isRejected,
              };
            } else if (typeof imgObj === "string") {
              return {
                url: imgObj,
                file: imgObj,
                status: targetStatus,
                approval_status: targetStatus,
                media_status: targetStatus,
                is_approved: isApproved,
                is_rejected: isRejected,
                caption: `Image #${idx + 1}`,
              };
            }
            return { status: targetStatus, approval_status: targetStatus, media_status: targetStatus, is_approved: isApproved, is_rejected: isRejected };
          });
      } else {
        resolvedImagesArray = [...itemsArray];
      }
      const resolvedGalleryMedia = Array.isArray(sourceRecord.gallery_media)
        ? itemsArray
        : {
            status: targetStatus,
            approval_status: targetStatus,
            media_status: targetStatus,
            is_approved: isApproved,
            is_rejected: isRejected,
            items: itemsArray,
          };
      const resolvedMedia = {
        status: targetStatus,
        approval_status: targetStatus,
        media_status: targetStatus,
        is_approved: isApproved,
        is_rejected: isRejected,
        items: itemsArray,
      };
      return {
        gallery_media: resolvedGalleryMedia,
        media: resolvedMedia,
        gallery_images: itemsArray.map((item) => item.url),
        images: resolvedImagesArray,
      };
    };
    // =========================================================================
    // ⚡ GUARANTEED FIRESTORE UPDATER ACROSS ALL 3 COLLECTIONS
    // Writes approval_status, status, description_status, media_status to:
    // 1) admin_pending_approvals/services/pending/{serviceId}
    // 2) users/{providerId}/Notification/{serviceId}
    // 3) All_categories/{category}/subCategories/{subCategory}/Notification/{serviceId}
    // =========================================================================
    const syncStatusUpdateToFirestore = async (existingServiceId, updatePayload, targetRecord = {}) => {
      try {
        if (!existingServiceId) return;
        const dbRef = getFirestoreInstance();
        if (!dbRef) return;
        const targetDocMap = new Map();
        const registerTarget = (pathStr) => {
          if (!pathStr || targetDocMap.has(pathStr)) return;
          const ref = getUniversalDocRef(pathStr);
          if (ref) targetDocMap.set(pathStr, ref);
        };
        // 1. admin_pending_approvals/services/pending/{serviceId}
        registerTarget(`admin_pending_approvals/services/pending/${existingServiceId}`);
        // 2. users/{providerId}/Notification/{serviceId}
        const candidateProviderIds = new Set();
        if (targetRecord.providerId) candidateProviderIds.add(String(targetRecord.providerId).trim());
        if (targetRecord.provider_id) candidateProviderIds.add(String(targetRecord.provider_id).trim());
        if (targetRecord.uid) candidateProviderIds.add(String(targetRecord.uid).trim());
        if (targetRecord.userId) candidateProviderIds.add(String(targetRecord.userId).trim());
        if (targetProviderId) candidateProviderIds.add(String(targetProviderId).trim());
        if (targetUserId) candidateProviderIds.add(String(targetUserId).trim());
        if (activeProviderRecord?.id) candidateProviderIds.add(String(activeProviderRecord.id).trim());
        if (activeProviderRecord?.uid) candidateProviderIds.add(String(activeProviderRecord.uid).trim());
        candidateProviderIds.forEach((pId) => {
          if (pId && pId !== "N/A") {
            registerTarget(`users/${pId}/Notification/${existingServiceId}`);
          }
        });
        // 3. All_categories/{category}/subCategories/{subCategory}/Notification/{serviceId}
        const candidateCategories = new Set();
        if (targetRecord.category) candidateCategories.add(String(targetRecord.category).trim());
        if (targetRecord.category_name) candidateCategories.add(String(targetRecord.category_name).trim());
        if (targetRecord.serviceCategory) candidateCategories.add(String(targetRecord.serviceCategory).trim());
        const candidateSubCategories = new Set();
        if (targetRecord.sub_category) candidateSubCategories.add(String(targetRecord.sub_category).trim());
        if (targetRecord.subCategory) candidateSubCategories.add(String(targetRecord.subCategory).trim());
        if (targetRecord.subcategory) candidateSubCategories.add(String(targetRecord.subcategory).trim());
        if (candidateSubCategories.size === 0) candidateSubCategories.add("general");
        candidateCategories.forEach((cat) => {
          candidateSubCategories.forEach((subCat) => {
            if (cat) {
              registerTarget(`All_categories/${cat}/subCategories/${subCat}/Notification/${existingServiceId}`);
            }
          });
        });
        if (targetRecord._categoryNotifPath) registerTarget(targetRecord._categoryNotifPath);
        if (targetRecord._userNotifPath) registerTarget(targetRecord._userNotifPath);
        // Fallback: collectionGroup scan to dynamically discover any matching Notification doc
        try {
          if (typeof collectionGroup === "function" && typeof getDocs === "function") {
            const notifSnap = await getDocs(collectionGroup(dbRef, "Notification"));
            notifSnap.forEach((d) => {
              if (d.id === existingServiceId || d.data()?.serviceId === existingServiceId || d.data()?.id === existingServiceId) {
                if (d.ref?.path) registerTarget(d.ref.path);
              }
            });
          } else if (typeof dbRef.collectionGroup === "function") {
            const notifSnap = await dbRef.collectionGroup("Notification").get();
            notifSnap.forEach((d) => {
              if (d.id === existingServiceId || d.data()?.serviceId === existingServiceId || d.data()?.id === existingServiceId) {
                if (d.ref?.path) registerTarget(d.ref.path);
              }
            });
          }
        } catch (cgErr) {
          console.warn("CollectionGroup Notification scan notice:", cgErr);
        }
        const executeWrite = async (docReference) => {
          if (!docReference) return;
          try {
            if (typeof updateDoc === "function") {
              try {
                await updateDoc(docReference, updatePayload);
                return;
              } catch (uErr) {
                if (typeof setDoc === "function") {
                  await setDoc(docReference, updatePayload, { merge: true });
                  return;
                }
              }
            }
            if (typeof window !== "undefined" && typeof window.updateDoc === "function") {
              try {
                await window.updateDoc(docReference, updatePayload);
                return;
              } catch (wErr) {
                if (typeof window.setDoc === "function") {
                  await window.setDoc(docReference, updatePayload, { merge: true });
                  return;
                }
              }
            }
            if (typeof docReference.update === "function") {
              try {
                await docReference.update(updatePayload);
                return;
              } catch (cErr) {
                if (typeof docReference.set === "function") {
                  await docReference.set(updatePayload, { merge: true });
                  return;
                }
              }
            }
            if (typeof docReference.set === "function") {
              await docReference.set(updatePayload, { merge: true });
              return;
            }
            if (typeof setDoc === "function") {
              await setDoc(docReference, updatePayload, { merge: true });
              return;
            }
          } catch (writeErr) {
            console.warn(`Write skip for ref:`, writeErr);
          }
        };
        const writeOps = Array.from(targetDocMap.values()).map((r) => executeWrite(r));
        await Promise.allSettled(writeOps);
      } catch (err) {
        console.error("Critical error in syncStatusUpdateToFirestore:", err);
      }
    };
    // Direct CRM upload (Auto-Approved)
    const handleUploadMediaToService = async (serviceRecord, file) => {
      if (!file || !serviceRecord) return;
      const existingServiceId = serviceRecord.id || serviceRecord.service_id;
      if (!existingServiceId) return;
      let currentGalleryMedia = [];
      if (Array.isArray(serviceRecord.gallery_media)) {
        currentGalleryMedia = [...serviceRecord.gallery_media];
      } else if (serviceRecord.gallery_media?.items && Array.isArray(serviceRecord.gallery_media.items)) {
        currentGalleryMedia = [...serviceRecord.gallery_media.items];
      }
      let currentGalleryImages = [];
      if (Array.isArray(serviceRecord.gallery_images)) {
        currentGalleryImages = [...serviceRecord.gallery_images];
      }
      let currentImages = [];
      if (Array.isArray(serviceRecord.images)) {
        currentImages = [...serviceRecord.images];
      }
      const currentTotalImagesCount = Math.max(
        currentGalleryMedia.length,
        currentGalleryImages.length,
        currentImages.length
      );
      if (currentTotalImagesCount >= 5) {
        alert("Maximum limit of 5 images per service reached. Please remove an image before uploading a new one.");
        return;
      }
      // Optional note captured for the audit trail (who uploaded, why, when — timestamp/email are auto-recorded)
      const uploadNote =
        promptForActionReason(
          "Optional: add a note for this upload (visible in the audit log):",
          ""
        ) || "";
      if (typeof setToastNotification === "function") {
        setToastNotification({
          type: "success",
          message: `Uploading media for "${serviceRecord.service_name || existingServiceId}"...`,
        });
      }
      try {
        const isVideo = file.type.startsWith("video/") || /\.(mp4|mov|avi|webm|mkv)$/i.test(file.name);
        let mediaUrl = "";

        const getStorageInstance = () => {
          if (typeof storage !== "undefined" && storage) return storage;
          if (typeof window !== "undefined") {
            return window.storage || window.firebaseStorage || null;
          }
          return null;
        };
        const storageInst = getStorageInstance();
        let uploadedSuccessfully = false;
        if (storageInst) {
          try {
            const storagePath = `services/${existingServiceId}/media_${Date.now()}_${file.name.replace(/[^a-zA-Z0-9.-]/g, "_")}`;
            if (typeof uploadBytes === "function" && typeof ref === "function" && typeof getDownloadURL === "function") {
              const sRef = ref(storageInst, storagePath);
              const snap = await uploadBytes(sRef, file);
              mediaUrl = await getDownloadURL(snap.ref);
              uploadedSuccessfully = true;
            } else if (typeof storageInst.ref === "function") {
              const sRef = storageInst.ref(storagePath);
              const snap = await sRef.put(file);
              mediaUrl = await snap.ref.getDownloadURL();
              uploadedSuccessfully = true;
            }
          } catch (uploadErr) {
            console.warn("Storage upload fallback to DataURL:", uploadErr);
          }
        }
        if (!uploadedSuccessfully || !mediaUrl) {
          mediaUrl = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(file);
          });
        }
        const newMediaItem = {
          url: mediaUrl,
          file: mediaUrl,
          type: isVideo ? "video" : "image",
          name: file.name,
          status: "approved",
          approval_status: "approved",
          media_status: "approved",
          is_approved: true,
          caption: file.name || (isVideo ? "Service Video" : "Service Image"),
          uploadedAt: new Date().toISOString(),
          uploadedBy: currentUser?.email || "Admin (Direct CRM Upload)",
          uploadNote: uploadNote || "",
        };
        const updatedGalleryMediaList = [...currentGalleryMedia, newMediaItem];
        const updatedGalleryImagesList = isVideo ? currentGalleryImages : [...currentGalleryImages, mediaUrl];
        const updatedImagesList = [...currentImages, newMediaItem];
        const currentMediaCount = updatedGalleryMediaList.length;
        const mediaUpdatePayload = {
          gallery_media: Array.isArray(serviceRecord.gallery_media)
            ? updatedGalleryMediaList
            : {
                status: "approved",
                approval_status: "approved",
                media_status: "approved",
                items: updatedGalleryMediaList,
              },
          media: {
            status: "approved",
            approval_status: "approved",
            media_status: "approved",
            items: updatedGalleryMediaList,
          },
          gallery_images: updatedGalleryImagesList,
          images: updatedImagesList,
          total_media_count: currentMediaCount,
          has_videos: isVideo || Boolean(serviceRecord.has_videos),
          updatedAt: new Date().toISOString(),
        };
        await syncStatusUpdateToFirestore(existingServiceId, mediaUpdatePayload, serviceRecord);
        const patchRecord = (sub) =>
          sub.id === existingServiceId || sub.service_id === existingServiceId
            ? {
                ...sub,
                ...mediaUpdatePayload,
                gallery_media: updatedGalleryMediaList,
                gallery_images: updatedGalleryImagesList,
                images: updatedImagesList,
              }
            : sub;
        if (typeof setFilteredSubmissions === "function") setFilteredSubmissions((prevList) => (prevList || []).map(patchRecord));
        if (typeof setSubmissions === "function") setSubmissions((prevList) => (prevList || []).map(patchRecord));
        if (inspectedServiceDossier && (inspectedServiceDossier.id === existingServiceId || inspectedServiceDossier.service_id === existingServiceId)) {
          if (typeof setInspectedServiceDossier === "function") {
            setInspectedServiceDossier((prev) => ({
              ...prev,
              ...mediaUpdatePayload,
              gallery_media: updatedGalleryMediaList,
              gallery_images: updatedGalleryImagesList,
              images: updatedImagesList,
            }));
          }
        }
        recordServiceApprovalAccessLog({
          actionType: "UPLOADED_MEDIA",
          actionLabel: `Direct CRM Upload (${isVideo ? "Video" : "Image"} - Auto-Approved)`,
          serviceId: existingServiceId,
          serviceName: serviceRecord.service_name || "Unnamed",
          details: `Admin uploaded and auto-approved ${isVideo ? "video" : "image"} (${file.name}) to service ID: ${existingServiceId}. Total active images: ${currentMediaCount}/5.${uploadNote ? ` Note: "${uploadNote}"` : ""}`,
          reason: uploadNote || "",
        });
        if (typeof setToastNotification === "function") {
          setToastNotification({
            type: "success",
            message: `${isVideo ? "Video" : "Image"} "${file.name}" uploaded and auto-approved (${currentMediaCount}/5 images)!`,
          });
          setTimeout(() => setToastNotification(null), 4000);
        }
      } catch (err) {
        console.error("Failed to upload media:", err);
      }
    };
    // Recycle bin: Remove image safely (soft delete — image is NEVER destroyed,
    // only moved into recycle_bin so it can always be viewed and recovered)
    const handleRemoveImageFromService = async (serviceRecord, mediaItemToRemove) => {
      if (!serviceRecord || !mediaItemToRemove) return;
      const sId = serviceRecord.id || serviceRecord.service_id;
      if (!sId) return;
      const targetUrl =
        typeof mediaItemToRemove === "string"
          ? mediaItemToRemove.trim()
          : (mediaItemToRemove.url || mediaItemToRemove.file || "").trim();
      if (!targetUrl) return;
      const confirmDelete = window.confirm(
        "Move this image to the Recycle Bin? It will no longer be visible on provider or customer apps, but you can view and recover it at any time."
      );
      if (!confirmDelete) return;
      // A reason is required so every removal is traceable (who / when / why) in the audit trail
      const deleteReasonInput = promptForActionReason(
        "Please provide a reason for removing this image (required, visible in audit logs):",
        ""
      );
      if (deleteReasonInput === null) return;
      if (!deleteReasonInput) {
        alert("A reason is required to remove this image.");
        return;
      }

      try {
        const currentGalleryMedia = Array.isArray(serviceRecord.gallery_media)
          ? [...serviceRecord.gallery_media]
          : Array.isArray(serviceRecord.gallery_media?.items)
          ? [...serviceRecord.gallery_media.items]
          : [];
        const currentGalleryImages = Array.isArray(serviceRecord.gallery_images)
          ? [...serviceRecord.gallery_images]
          : [];
        const currentImages = Array.isArray(serviceRecord.images)
          ? [...serviceRecord.images]
          : [];
        const currentRecycleBin = Array.isArray(serviceRecord.recycle_bin)
          ? [...serviceRecord.recycle_bin]
          : [];
        const binPayload = {
          ...(typeof mediaItemToRemove === "object" ? mediaItemToRemove : {}),
          url: targetUrl,
          file: targetUrl,
          deletedAt: new Date().toISOString(),
          deletedBy: currentUser?.email || "Admin",
          deleteReason: deleteReasonInput,
          originalServiceId: sId,
          originalServiceName: serviceRecord.service_name || "Service",
        };
        const updatedGalleryMedia = currentGalleryMedia.filter((m) => {
          const u = typeof m === "string" ? m.trim() : (m?.url || m?.file || "").trim();
          return u !== targetUrl;
        });
        const updatedGalleryImages = currentGalleryImages.filter((u) => u.trim() !== targetUrl);
        const updatedImages = currentImages.filter((m) => {
          const u = typeof m === "string" ? m.trim() : (m?.url || m?.file || "").trim();
          return u !== targetUrl;
        });
        const updatedRecycleBin = [binPayload, ...currentRecycleBin];
        const targetStatus = serviceRecord.status || "approved";
        const targetApprovalStatus = serviceRecord.approval_status || targetStatus;
        const removalPayload = {
          gallery_media: Array.isArray(serviceRecord.gallery_media)
            ? updatedGalleryMedia
            : {
                status: targetStatus,
                approval_status: targetApprovalStatus,
                media_status: targetApprovalStatus,
                items: updatedGalleryMedia,
              },
          media: {
            status: targetStatus,
            approval_status: targetApprovalStatus,
            media_status: targetApprovalStatus,
            items: updatedGalleryMedia,
          },
          gallery_images: updatedGalleryImages,
          images: updatedImages,
          recycle_bin: updatedRecycleBin,
          recycle_bin_count: updatedRecycleBin.length,
          total_media_count: updatedGalleryMedia.length,
          updatedAt: new Date().toISOString(),
        };
        await syncStatusUpdateToFirestore(sId, removalPayload, serviceRecord);
        const patchService = (item) =>
          item.id === sId || item.service_id === sId ? { ...item, ...removalPayload } : item;
        if (typeof setFilteredSubmissions === "function") setFilteredSubmissions((prev) => (prev || []).map(patchService));
        if (typeof setSubmissions === "function") setSubmissions((prev) => (prev || []).map(patchService));
        if (inspectedServiceDossier && (inspectedServiceDossier.id === sId || inspectedServiceDossier.service_id === sId)) {
          if (typeof setInspectedServiceDossier === "function") {
            setInspectedServiceDossier((prev) => ({ ...prev, ...removalPayload }));
          }
        }
        recordServiceApprovalAccessLog({
          actionType: "IMAGE_MOVED_TO_RECYCLE_BIN",
          actionLabel: "Moved Image to Recycle Bin",
          serviceId: sId,
          serviceName: serviceRecord.service_name || "Unnamed",
          details: `Admin moved image (${targetUrl}) to Recycle Bin. Recycle bin now holds ${updatedRecycleBin.length} items. Image was preserved — not deleted.`,
          reason: deleteReasonInput,
        });

        if (typeof setToastNotification === "function") {
          setToastNotification({
            type: "success",
            message: `Image moved to Recycle Bin (${updatedRecycleBin.length} in bin). You can recover it anytime.`,
          });
          setTimeout(() => setToastNotification(null), 4000);
        }
      } catch (err) {
        console.error("Error removing image to recycle bin:", err);
      }
    };
    // Recycle bin: Recover image
    const handleRecoverImageFromRecycleBin = async (serviceRecord, binItemToRecover) => {
      if (!serviceRecord || !binItemToRecover) return;
      const sId = serviceRecord.id || serviceRecord.service_id;
      if (!sId) return;
      const restoreUrl =
        typeof binItemToRecover === "string"
          ? binItemToRecover.trim()
          : (binItemToRecover.url || binItemToRecover.file || "").trim();
      if (!restoreUrl) return;
      const currentGalleryMedia = Array.isArray(serviceRecord.gallery_media)
        ? [...serviceRecord.gallery_media]
        : Array.isArray(serviceRecord.gallery_media?.items)
        ? [...serviceRecord.gallery_media.items]
        : [];
      const currentGalleryImages = Array.isArray(serviceRecord.gallery_images)
        ? [...serviceRecord.gallery_images]
        : [];
      const currentImages = Array.isArray(serviceRecord.images)
        ? [...serviceRecord.images]
        : [];
      const currentRecycleBin = Array.isArray(serviceRecord.recycle_bin)
        ? [...serviceRecord.recycle_bin]
        : [];
      const activeCount = Math.max(currentGalleryMedia.length, currentGalleryImages.length, currentImages.length);
      if (activeCount >= 5) {
        alert("Cannot recover image: This service already contains the maximum limit of 5 images. Please delete an image first.");
        return;
      }
      // Optional note captured for the audit trail
      const recoveryNote =
        promptForActionReason(
          "Optional: add a note for this recovery (visible in audit logs):",
          ""
        ) || "";
      try {
        const restoredItem = {
          ...(typeof binItemToRecover === "object" ? binItemToRecover : {}),
          url: restoreUrl,
          file: restoreUrl,
          status: "approved",
          approval_status: "approved",
          media_status: "approved",
          is_approved: true,
          recoveredAt: new Date().toISOString(),
          recoveredBy: currentUser?.email || "Admin",
          recoveryNote,
        };
        delete restoredItem.deletedAt;
        delete restoredItem.deletedBy;
        const updatedGalleryMedia = [...currentGalleryMedia, restoredItem];
        const updatedGalleryImages = [...currentGalleryImages, restoreUrl];
        const updatedImages = [...currentImages, restoredItem];
        const updatedRecycleBin = currentRecycleBin.filter((item) => {
          const u = typeof item === "string" ? item.trim() : (item?.url || item?.file || "").trim();
          return u !== restoreUrl;
        });
        const targetStatus = serviceRecord.status || "approved";
        const targetApprovalStatus = serviceRecord.approval_status || targetStatus;
        const recoveryPayload = {
          gallery_media: Array.isArray(serviceRecord.gallery_media)
            ? updatedGalleryMedia
            : {
                status: targetStatus,
                approval_status: targetApprovalStatus,
                media_status: targetApprovalStatus,
                items: updatedGalleryMedia,
              },
          media: {
            status: targetStatus,
            approval_status: targetApprovalStatus,
            media_status: targetApprovalStatus,
            items: updatedGalleryMedia,
          },
          gallery_images: updatedGalleryImages,
          images: updatedImages,
          recycle_bin: updatedRecycleBin,
          recycle_bin_count: updatedRecycleBin.length,
          total_media_count: updatedGalleryMedia.length,
          updatedAt: new Date().toISOString(),
        };
        await syncStatusUpdateToFirestore(sId, recoveryPayload, serviceRecord);
        const patchService = (item) =>
          item.id === sId || item.service_id === sId ? { ...item, ...recoveryPayload } : item;
        if (typeof setFilteredSubmissions === "function") setFilteredSubmissions((prev) => (prev || []).map(patchService));
        if (typeof setSubmissions === "function") setSubmissions((prev) => (prev || []).map(patchService));
        if (inspectedServiceDossier && (inspectedServiceDossier.id === sId || inspectedServiceDossier.service_id === sId)) {
          if (typeof setInspectedServiceDossier === "function") {
            setInspectedServiceDossier((prev) => ({ ...prev, ...recoveryPayload }));
          }
        }
        if (filterStore.recycleBinTargetService && (filterStore.recycleBinTargetService.id === sId || filterStore.recycleBinTargetService.service_id === sId)) {
          filterStore.recycleBinTargetService = { ...filterStore.recycleBinTargetService, ...recoveryPayload };
        }
        recordServiceApprovalAccessLog({
          actionType: "IMAGE_RECOVERED",
          actionLabel: "Recovered Image from Recycle Bin",
          serviceId: sId,
          serviceName: serviceRecord.service_name || "Unnamed",
          details: `Admin recovered image (${restoreUrl}) back to service gallery (${updatedGalleryMedia.length}/5 images).${recoveryNote ? ` Note: "${recoveryNote}"` : ""}`,
          reason: recoveryNote,
        });

        if (typeof setToastNotification === "function") {
          setToastNotification({
            type: "success",
            message: `Image restored to service gallery! (${updatedGalleryMedia.length}/5 images active)`,
          });
          setTimeout(() => setToastNotification(null), 4000);
        }
      } catch (err) {
        console.error("Error recovering image from recycle bin:", err);
      }
    };
    // =========================================================================
    // ✎ EDIT MEDIA ITEM (caption/label) — zero-loss: never removes, replaces the
    // count of, or otherwise disappears any existing image/video. Every edit is
    // logged with who performed it, when, and the reason given.
    // =========================================================================
    const handleEditMediaItem = async (serviceRecord, mediaItemToEdit) => {
      if (!serviceRecord || !mediaItemToEdit) return;
      const sId = serviceRecord.id || serviceRecord.service_id;
      if (!sId) return;
      const targetUrl =
        typeof mediaItemToEdit === "string"
          ? mediaItemToEdit.trim()
          : (mediaItemToEdit.url || mediaItemToEdit.file || "").trim();
      if (!targetUrl) return;
      const currentCaption =
        (typeof mediaItemToEdit === "object" && (mediaItemToEdit.caption || mediaItemToEdit.title)) || "";
      const newCaption = promptForActionReason("Edit caption/label for this media item:", currentCaption);
      if (newCaption === null) return;
      const editReason = promptForActionReason(
        "Reason for this edit (required, visible in audit logs):",
        ""
      );
      if (!editReason) {
        alert("A reason is required to edit this image.");
        return;
      }
      try {
        const patchMediaArray = (arr) =>
          (Array.isArray(arr) ? arr : []).map((m) => {
            const u = typeof m === "string" ? m.trim() : (m?.url || m?.file || "").trim();
            if (u !== targetUrl) return m;
            if (typeof m === "string") {
              return {
                url: m,
                file: m,
                caption: newCaption,
                editedAt: new Date().toISOString(),
                editedBy: currentUser?.email || "Admin",
                editReason,
              };
            }
            return {
              ...m,
              caption: newCaption,
              editedAt: new Date().toISOString(),
              editedBy: currentUser?.email || "Admin",
              editReason,
            };
          });
        const currentGalleryMedia = Array.isArray(serviceRecord.gallery_media)
          ? serviceRecord.gallery_media
          : Array.isArray(serviceRecord.gallery_media?.items)
          ? serviceRecord.gallery_media.items
          : [];
        const currentImages = Array.isArray(serviceRecord.images) ? serviceRecord.images : [];
        // Zero-loss guarantee: patched arrays keep the exact same length/items —
        // only the caption/edit metadata of the matched item changes.
        const updatedGalleryMedia = patchMediaArray(currentGalleryMedia);
        const updatedImages = currentImages.length > 0 ? patchMediaArray(currentImages) : currentImages;
        const editPayload = {
          gallery_media: Array.isArray(serviceRecord.gallery_media)
            ? updatedGalleryMedia
            : {
                ...(typeof serviceRecord.gallery_media === "object" && serviceRecord.gallery_media !== null
                  ? serviceRecord.gallery_media
                  : {}),
                items: updatedGalleryMedia,
              },
          media: {
            ...(typeof serviceRecord.media === "object" && serviceRecord.media !== null ? serviceRecord.media : {}),
            items: updatedGalleryMedia,
          },
          images: updatedImages,
          updatedAt: new Date().toISOString(),
        };
        await syncStatusUpdateToFirestore(sId, editPayload, serviceRecord);
        const patchService = (item) =>
          item.id === sId || item.service_id === sId ? { ...item, ...editPayload } : item;
        if (typeof setFilteredSubmissions === "function") setFilteredSubmissions((prev) => (prev || []).map(patchService));
        if (typeof setSubmissions === "function") setSubmissions((prev) => (prev || []).map(patchService));
        if (inspectedServiceDossier && (inspectedServiceDossier.id === sId || inspectedServiceDossier.service_id === sId)) {
          if (typeof setInspectedServiceDossier === "function") {
            setInspectedServiceDossier((prev) => ({ ...prev, ...editPayload }));
          }
        }
        recordServiceApprovalAccessLog({
          actionType: "IMAGE_EDITED",
          actionLabel: "Edited Image Caption/Label",
          serviceId: sId,
          serviceName: serviceRecord.service_name || "Unnamed",
          details: `Admin edited media (${targetUrl}) caption from "${currentCaption || "—"}" to "${newCaption || "—"}". No images were removed or lost.`,
          reason: editReason,
        });
        if (typeof setToastNotification === "function") {
          setToastNotification({
            type: "success",
            message: `Image details updated. All images preserved.`,
          });
          setTimeout(() => setToastNotification(null), 4000);
        }
      } catch (err) {
        console.error("Error editing media item:", err);
      }
    };

    // =========================================================================
    // ⚡ EXECUTE DECISION: APPROVE OR REJECT ACROSS ALL 3 COLLECTIONS
    // - Explicitly writes approval_status, status, description_status, media_status
    //   across all 3 Firebase collections:
    //   1) admin_pending_approvals/services/pending/{serviceId}
    //   2) users/{providerId}/Notification/{serviceId}
    //   3) All_categories/{category}/subCategories/{subCategory}/Notification/{serviceId}
    // - Once performed, none of the status fields is "pending" or "new_request",
    //   so buttons immediately disappear!
    // =========================================================================
    const handleExecuteModalDecisionWithLogging = async () => {
      const targetService = confirmationModal.target;
      const existingServiceId = targetService?.id || targetService?.service_id;
      const currentReason = confirmationModal.reason || "";
      const isApproveService = confirmationModal.type === "approve_service";
      const isRejectService = confirmationModal.type === "reject_service";
      if (!existingServiceId) {
        setConfirmationModal({ isOpen: false, type: "", target: null, reason: "", step: "reason" });
        return;
      }
      // Safe single-action execution lock
      if (isActionInFlight(existingServiceId)) {
        return;
      }
      filterStore.inFlightActionIds.add(String(existingServiceId));
      triggerFastReRender();

      let liveDocData = null;
      try {
        const probeRef = getUniversalDocRef(`admin_pending_approvals/services/pending/${existingServiceId}`);
        if (probeRef) {
          let snap = null;
          if (typeof getDoc === "function") {
            snap = await getDoc(probeRef);
          } else if (typeof probeRef.get === "function") {
            snap = await probeRef.get();
          }
          if (snap && (typeof snap.exists === "function" ? snap.exists() : snap.exists)) {
            liveDocData = typeof snap.data === "function" ? snap.data() : snap.data;
          }
        }
      } catch (err) {
        console.warn("Live doc snapshot notice:", err);
      }
      const combinedSource = {
        ...targetService,
        ...(liveDocData || {}),
        gallery_media: (liveDocData && liveDocData.gallery_media) || targetService.gallery_media || null,
        media: (liveDocData && liveDocData.media) || targetService.media || null,
        gallery_images: (liveDocData && liveDocData.gallery_images) || targetService.gallery_images || null,
        images: (liveDocData && liveDocData.images) || targetService.images || null,
        photos: (liveDocData && liveDocData.photos) || targetService.photos || null,
        coverImage: (liveDocData && liveDocData.coverImage) || targetService.coverImage || null,
        serviceImage: (liveDocData && liveDocData.serviceImage) || targetService.serviceImage || null,
        thumbnail: (liveDocData && liveDocData.thumbnail) || targetService.thumbnail || null,
        image: (liveDocData && liveDocData.image) || targetService.image || null,
        recycle_bin: (liveDocData && liveDocData.recycle_bin) || targetService.recycle_bin || [],
      };
      try {
        // ---------------------------------------------------------------------
        // ACTION: APPROVE SERVICE & IMAGES ACROSS ALL 3 COLLECTIONS
        // ---------------------------------------------------------------------
        if (isApproveService) {
          recordServiceApprovalAccessLog({
            actionType: "SERVICE_APPROVED",
            actionLabel: "Approved Service",
            serviceId: existingServiceId,
            serviceName: targetService?.service_name || "Unnamed",
            reason: currentReason || "Approved by Administrator",
            details: `Service "${targetService?.service_name || existingServiceId}" and images approved across all 3 collections.`,
          });
          // Harmonize all media to "approved" (images preserved with zero loss, approval_status & media_status set to approved)
          const synchronizedMediaBundle = harvestAndSyncMediaStructures(combinedSource, "approved");
          const firestoreApprovalData = {
            serviceId: existingServiceId,
            id: existingServiceId,
            approval_status: "approved",
            status: "approved",
            description_status: "approved",
            description_is_approved: true,
            media_status: "approved",
            is_active: true,
            is_approved: true,
            is_rejected: false,
            gallery_media: synchronizedMediaBundle.gallery_media,
            media: synchronizedMediaBundle.media,
            gallery_images: synchronizedMediaBundle.gallery_images,
            images: synchronizedMediaBundle.images,
            rejection_reason: "",
            approval_reason: currentReason || "Approved by Administrator",
            reviewed_at: new Date().toISOString(),
            reviewed_by: currentUser?.email || currentUser?.uid || "Admin",
            updatedAt: new Date().toISOString(),
          };
          // Synchronize update to all 3 collections in Firebase
          await syncStatusUpdateToFirestore(existingServiceId, firestoreApprovalData, targetService);
          if (typeof setFilteredSubmissions === "function") {
            setFilteredSubmissions((prevList) =>
              (prevList || []).map((sub) => {
                if (sub.id === existingServiceId || sub.service_id === existingServiceId) {
                  return { ...sub, ...firestoreApprovalData };
                }
                return sub;
              })
            );
          }
          if (typeof setSubmissions === "function") {
            setSubmissions((prevList) =>
              (prevList || []).map((sub) =>
                sub.id === existingServiceId || sub.service_id === existingServiceId
                  ? { ...sub, ...firestoreApprovalData }
                  : sub
              )
            );
          }
          if (inspectedServiceDossier && (inspectedServiceDossier.id === existingServiceId || inspectedServiceDossier.service_id === existingServiceId)) {
            if (typeof setInspectedServiceDossier === "function") {
              setInspectedServiceDossier((prev) => ({ ...prev, ...firestoreApprovalData }));
            }
          }
          if (typeof setToastNotification === "function") {
            setToastNotification({
              type: "success",
              message: `Service "${targetService?.service_name || existingServiceId}" approved across all 3 collections!`,
            });
            setTimeout(() => setToastNotification(null), 4000);
          }
          setConfirmationModal({ isOpen: false, type: "", target: null, reason: "", step: "reason" });
          return;
        }
        // ---------------------------------------------------------------------
        // ACTION: REJECT SERVICE & IMAGES ACROSS ALL 3 COLLECTIONS
        // ---------------------------------------------------------------------
        if (isRejectService) {
          if (!currentReason?.trim()) {
            alert("Please provide a valid rejection reason.");
            filterStore.inFlightActionIds.delete(String(existingServiceId));
            return;
          }
          recordServiceApprovalAccessLog({
            actionType: "SERVICE_REJECTED",
            actionLabel: "Rejected Service & Images",
            serviceId: existingServiceId,
            serviceName: targetService?.service_name || "Unnamed",
            reason: currentReason,
            details: `Service "${targetService?.service_name || existingServiceId}" and images rejected across all 3 collections. Reason: ${currentReason}`,
          });
          // Harmonize all media to "rejected" without dropping any asset
          const synchronizedMediaBundle = harvestAndSyncMediaStructures(combinedSource, "rejected");
          const firestoreRejectionData = {
            serviceId: existingServiceId,
            id: existingServiceId,
            approval_status: "rejected",
            status: "rejected",
            description_status: "rejected",
            description_is_approved: false,
            media_status: "rejected",
            is_active: false,
            is_approved: false,
            is_rejected: true,
            gallery_media: synchronizedMediaBundle.gallery_media,
            media: synchronizedMediaBundle.media,
            gallery_images: synchronizedMediaBundle.gallery_images,
            images: synchronizedMediaBundle.images,
            rejection_reason: currentReason,
            reviewed_at: new Date().toISOString(),
            reviewed_by: currentUser?.email || currentUser?.uid || "Admin",
            updatedAt: new Date().toISOString(),
          };
          // Synchronize update to all 3 collections in Firebase
          await syncStatusUpdateToFirestore(existingServiceId, firestoreRejectionData, targetService);
          if (typeof setFilteredSubmissions === "function") {
            setFilteredSubmissions((prevList) =>
              (prevList || []).map((sub) => {
                if (sub.id === existingServiceId || sub.service_id === existingServiceId) {
                  return { ...sub, ...firestoreRejectionData };
                }
                return sub;
              })
            );
          }
          if (typeof setSubmissions === "function") {
            setSubmissions((prevList) =>
              (prevList || []).map((sub) =>
                sub.id === existingServiceId || sub.service_id === existingServiceId
                  ? { ...sub, ...firestoreRejectionData }
                  : sub
              )
            );
          }
          if (inspectedServiceDossier && (inspectedServiceDossier.id === existingServiceId || inspectedServiceDossier.service_id === existingServiceId)) {
            if (typeof setInspectedServiceDossier === "function") {
              setInspectedServiceDossier((prev) => ({ ...prev, ...firestoreRejectionData }));
            }
          }
          if (typeof setToastNotification === "function") {
            setToastNotification({
              type: "error",
              message: `Service "${targetService?.service_name || existingServiceId}" rejected across all 3 collections.`,
            });
            setTimeout(() => setToastNotification(null), 4000);
          }
          setConfirmationModal({ isOpen: false, type: "", target: null, reason: "", step: "reason" });
          return;
        }
        if (typeof handleExecuteModalDecision === "function") {
          handleExecuteModalDecision();
        }
        setConfirmationModal({ isOpen: false, type: "", target: null, reason: "", step: "reason" });
      } finally {
        filterStore.inFlightActionIds.delete(String(existingServiceId));
        triggerFastReRender();
      }
    };
    const approvalAuditLogs = getStoredApprovalLogs();
    return (
      <div className="admin-container" style={{ position: "relative", minHeight: "100vh" }}>
        {/* TOAST NOTIFICATION BANNER */}
        {toastNotification && (
          <div
            style={{
              position: "fixed",
              top: 24,
              right: 24,
              zIndex: 13000,
              padding: "14px 22px",
              borderRadius: "10px",
              background: toastNotification.type === "error" ? "#EF4444" : "#10B981",
              color: "#FFFFFF",
              boxShadow: "0 10px 25px -5px rgba(0,0,0,0.25)",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              fontWeight: 600,
              fontSize: "14px",
              animation: "fadeIn 0.3s ease-in-out",
            }}
          >
            <span>{toastNotification.type === "error" ? "⚠️" : "✅"}</span>
            <span>{toastNotification.message}</span>
          </div>
        )}
        {/* RECYCLE BIN MODAL (VIEW & RECOVER) */}
        {filterStore.recycleBinTargetService && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(15, 23, 42, 0.75)",
              backdropFilter: "blur(6px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 12600,
              padding: "20px",
              boxSizing: "border-box",
            }}
            onClick={() => {
              filterStore.recycleBinTargetService = null;
              triggerFastReRender();
            }}
          >
            <div
              style={{
                backgroundColor: "#FFFFFF",
                width: "100%",
                maxWidth: "760px",
                maxHeight: "85vh",
                borderRadius: "16px",
                boxShadow: "0 25px 50px -12px rgba(0,0,0,0.3)",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                border: "1px solid #CBD5E1",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                style={{
                  padding: "18px 24px",
                  borderBottom: "1px solid #E2E8F0",
                  backgroundColor: "#F8FAFC",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <h3 style={{ margin: 0, fontSize: "17px", fontWeight: "700", color: "#0F172A", display: "flex", alignItems: "center", gap: "8px" }}>
                    <span>🗑️</span> Service Recycle Bin — {filterStore.recycleBinTargetService.service_name || filterStore.recycleBinTargetService.id}
                  </h3>
                  <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#64748B" }}>
                    Images in this bin are hidden from providers & customers. Recovering an image restores it to this service (Max limit: 5 images).
                  </p>
                </div>
                <button
                  type="button"
                  style={{
                    border: "none",
                    background: "#E2E8F0",
                    borderRadius: "50%",
                    width: "32px",
                    height: "32px",
                    fontWeight: "bold",
                    fontSize: "16px",
                    color: "#475569",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    filterStore.recycleBinTargetService = null;
                    triggerFastReRender();
                  }}
                >
                  ✕
                </button>
              </div>
              <div style={{ flex: 1, overflowY: "auto", padding: "20px" }}>
                {(() => {
                  const binItems = Array.isArray(filterStore.recycleBinTargetService.recycle_bin)
                    ? filterStore.recycleBinTargetService.recycle_bin
                    : [];
                  if (binItems.length === 0) {
                    return (
                      <div style={{ textAlign: "center", padding: "40px 20px", color: "#64748B" }}>
                        <div style={{ fontSize: "42px", marginBottom: "10px" }}>📭</div>
                        <h4 style={{ margin: "0 0 6px 0", color: "#334155" }}>Recycle Bin is Empty</h4>
                        <p style={{ fontSize: "13px", margin: 0 }}>
                          No deleted images currently in the bin for this service.
                        </p>
                      </div>
                    );
                  }
                  return (
                    <div>
                      <div style={{ marginBottom: "14px", fontSize: "13px", color: "#334155", fontWeight: "600" }}>
                        Deleted Images in Bin: <span style={{ color: "#DC2626" }}>{binItems.length}</span>
                      </div>
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "16px" }}>
                        {binItems.map((binItem, bIdx) => {
                          const itemUrl = typeof binItem === "string" ? binItem : binItem.url || binItem.file;
                          const isVid =
                            typeof itemUrl === "string" &&
                            (itemUrl.includes(".mp4") || itemUrl.includes(".mov") || itemUrl.includes(".webm") || itemUrl.startsWith("data:video"));
                          return (
                            <div
                              key={bIdx}
                              style={{
                                border: "1px solid #E2E8F0",
                                borderRadius: "10px",
                                overflow: "hidden",
                                backgroundColor: "#FFFFFF",
                                display: "flex",
                                flexDirection: "column",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                              }}
                            >
                              <div
                                style={{
                                  position: "relative",
                                  height: "120px",
                                  backgroundColor: "#0F172A",
                                  cursor: "pointer",
                                }}
                                onClick={() => itemUrl && onActivateMediaPreview(itemUrl)}
                                title="Click to view full preview"
                              >
                                {isVid ? (
                                  <video src={itemUrl} muted style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                ) : (
                                  <img src={itemUrl} alt="Bin Media" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                )}
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "6px",
                                    left: "6px",
                                    backgroundColor: "rgba(0,0,0,0.6)",
                                    color: "#fff",
                                    fontSize: "10px",
                                    padding: "2px 6px",
                                    borderRadius: "4px",
                                    fontWeight: "600",
                                  }}
                                >
                                  {isVid ? "🎬 Video" : "🖼️ Image"}
                                </div>
                              </div>
                              <div style={{ padding: "10px", flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                                <div style={{ fontSize: "11px", color: "#64748B", marginBottom: "8px" }}>
                                  <div><strong>Deleted:</strong> {binItem.deletedAt ? new Date(binItem.deletedAt).toLocaleDateString() : "Recently"}</div>
                                  <div><strong>By:</strong> {binItem.deletedBy || "Admin"}</div>
                                  {binItem.deleteReason && (
                                    <div><strong>Reason:</strong> {binItem.deleteReason}</div>
                                  )}
                                </div>
                                <div style={{ display: "flex", gap: "6px" }}>
                                  <button
                                    type="button"
                                    onClick={() => itemUrl && onActivateMediaPreview(itemUrl)}
                                    style={{
                                      flex: 1,
                                      padding: "6px",
                                      borderRadius: "6px",
                                      backgroundColor: "#EFF6FF",
                                      color: "#1D4ED8",
                                      border: "1px solid #BFDBFE",
                                      fontSize: "11px",
                                      fontWeight: "600",
                                      cursor: "pointer",
                                    }}
                                  >
                                    🔍 View
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => handleRecoverImageFromRecycleBin(filterStore.recycleBinTargetService, binItem)}
                                    style={{
                                      flex: 1,
                                      padding: "6px",
                                      borderRadius: "6px",
                                      backgroundColor: "#16A34A",
                                      color: "#FFFFFF",
                                      border: "none",
                                      fontSize: "11px",
                                      fontWeight: "600",
                                      cursor: "pointer",
                                    }}
                                  >
                                    ♻️ Recover
                                  </button>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })()}
              </div>
            </div>
          </div>
        )}
        {/* CONFIRMATION / REJECTION / APPROVAL MODAL */}
        {confirmationModal.isOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(15, 23, 42, 0.7)",
              backdropFilter: "blur(4px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 12500,
            }}
            onClick={() => setConfirmationModal({ isOpen: false, type: "", target: null, reason: "", step: "reason" })}
          >
            <div
              style={{
                backgroundColor: "#FFFFFF",
                borderRadius: "16px",
                padding: "28px",
                width: "100%",
                maxWidth: "480px",
                boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ textAlign: "center", marginBottom: "18px" }}>
                <div
                  style={{
                    width: "56px",
                    height: "56px",
                    borderRadius: "50%",
                    backgroundColor: confirmationModal.type.includes("reject") ? "#FEE2E2" : "#DCFCE7",
                    color: confirmationModal.type.includes("reject") ? "#DC2626" : "#16A34A",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "26px",
                    marginBottom: "12px",
                  }}
                >
                  {confirmationModal.type.includes("reject") ? "✕" : "✓"}
                </div>
                <h3 style={{ fontSize: "20px", fontWeight: "700", color: "#1E293B", margin: 0 }}>
                  {confirmationModal.type === "approve_service" &&
                    (confirmationModal.step === "confirm" ? "Are you sure you want to approve?" : "Approve Service & Images")}
                  {confirmationModal.type === "reject_service" && "Reject Service & Images?"}
                  {confirmationModal.type === "approve_provider" && "Approve Provider Application?"}
                  {confirmationModal.type === "reject_provider" && "Reject Provider Application?"}
                </h3>
                <p style={{ fontSize: "14px", color: "#64748B", marginTop: "8px" }}>
                  {confirmationModal.type === "approve_service" && confirmationModal.step === "confirm"
                    ? "Approving this service will set status: 'approved' across all 3 Firebase collections without deleting images. The action executes once and buttons will disappear."
                    : confirmationModal.type === "approve_service"
                    ? "Specify the verification justification or reason for approving this service submission across all 3 collections."
                    : confirmationModal.type === "reject_service"
                    ? "Rejecting will set status: 'rejected' across all 3 Firebase collections. Images are fully preserved and will not be deleted."
                    : confirmationModal.type.includes("approve")
                    ? "This will make the item live, active, and accessible to customers."
                    : "Please specify a clear reason for rejecting this submission."}
                </p>
              </div>
              {/* APPROVAL REASON INPUT */}
              {confirmationModal.type === "approve_service" && confirmationModal.step !== "confirm" && (
                <div style={{ marginBottom: "20px" }}>
                  <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#334155", marginBottom: "6px" }}>
                    Reason for Approval <span style={{ color: "#EF4444" }}>*</span>
                  </label>
                  <textarea
                    value={confirmationModal.reason || ""}
                    onChange={(e) =>
                      setConfirmationModal((prev) => ({ ...prev, reason: e.target.value }))
                    }
                    placeholder="Enter justification for approving this service..."
                    rows={3}
                    style={{
                      width: "100%",
                      boxSizing: "border-box",
                      padding: "10px 14px",
                      borderRadius: "8px",
                      border: "1px solid #CBD5E1",
                      fontSize: "14px",
                      outline: "none",
                      resize: "vertical",
                    }}
                  />
                </div>
              )}
              {/* APPROVAL SUMMARY */}
              {confirmationModal.type === "approve_service" && confirmationModal.step === "confirm" && (
                <div
                  style={{
                    backgroundColor: "#F8FAFC",
                    border: "1px solid #E2E8F0",
                    borderRadius: "10px",
                    padding: "14px",
                    marginBottom: "20px",
                    fontSize: "13px",
                  }}
                >
                  <div style={{ marginBottom: "6px" }}>
                    <strong style={{ color: "#0F172A" }}>Service ID: </strong>
                    <span style={{ color: "#334155" }}>
                      {confirmationModal.target?.service_id || confirmationModal.target?.id || "N/A"}
                    </span>
                  </div>
                  <div style={{ marginBottom: "6px" }}>
                    <strong style={{ color: "#0F172A" }}>Service: </strong>
                    <span style={{ color: "#334155" }}>
                      {confirmationModal.target?.service_name || "N/A"}
                    </span>
                  </div>
                  <div>
                    <strong style={{ color: "#0F172A" }}>Approval Reason: </strong>
                    <span style={{ color: "#16A34A", fontStyle: "italic" }}>
                      "{confirmationModal.reason || "Approved by administrator"}"
                    </span>
                  </div>
                </div>
              )}
              {/* REJECTION REASON INPUT */}
              {confirmationModal.type.includes("reject") && (
                <div style={{ marginBottom: "20px" }}>
                  <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#334155", marginBottom: "6px" }}>
                    Rejection Reason <span style={{ color: "#EF4444" }}>*</span>
                  </label>
                  <textarea
                    value={confirmationModal.reason}
                    onChange={(e) =>
                      setConfirmationModal((prev) => ({ ...prev, reason: e.target.value }))
                    }
                    placeholder="Enter details about why this request and its images are being declined..."
                    rows={3}
                    style={{
                      width: "100%",
                      boxSizing: "border-box",
                      padding: "10px 14px",
                      borderRadius: "8px",
                      border: "1px solid #CBD5E1",
                      fontSize: "14px",
                      outline: "none",
                      resize: "vertical",
                    }}
                  />
                </div>
              )}
              {/* MODAL ACTION BUTTONS */}
              <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
                {confirmationModal.type === "approve_service" && confirmationModal.step !== "confirm" ? (
                  <>
                    <button
                      type="button"
                      onClick={() =>
                        setConfirmationModal({ isOpen: false, type: "", target: null, reason: "", step: "reason" })
                      }
                      style={{
                        padding: "10px 18px",
                        borderRadius: "8px",
                        border: "1px solid #E2E8F0",
                        backgroundColor: "#F8FAFC",
                        color: "#475569",
                        fontWeight: "600",
                        fontSize: "14px",
                        cursor: "pointer",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        if (!confirmationModal.reason?.trim()) {
                          alert("Please provide a reason why this service needs to be approved.");
                          return;
                        }
                        setConfirmationModal((prev) => ({ ...prev, step: "confirm" }));
                      }}
                      style={{
                        padding: "10px 20px",
                        borderRadius: "8px",
                        border: "none",
                        backgroundColor: "#16A34A",
                        color: "#FFFFFF",
                        fontWeight: "600",
                        fontSize: "14px",
                        cursor: "pointer",
                      }}
                    >
                      Proceed to Confirm →
                    </button>
                  </>
                ) : confirmationModal.type === "approve_service" && confirmationModal.step === "confirm" ? (
                  <>
                    <button
                      type="button"
                      onClick={() =>
                        setConfirmationModal({ isOpen: false, type: "", target: null, reason: "", step: "reason" })
                      }
                      style={{
                        padding: "10px 18px",
                        borderRadius: "8px",
                        border: "1px solid #E2E8F0",
                        backgroundColor: "#F8FAFC",
                        color: "#475569",
                        fontWeight: "600",
                        fontSize: "14px",
                        cursor: "pointer",
                      }}
                    >
                      No
                    </button>
                    <button
                      type="button"
                      disabled={isActionInFlight(confirmationModal.target?.id || confirmationModal.target?.service_id)}
                      onClick={handleExecuteModalDecisionWithLogging}
                      style={{
                        padding: "10px 22px",
                        borderRadius: "8px",
                        border: "none",
                        backgroundColor: "#16A34A",
                        color: "#FFFFFF",
                        fontWeight: "700",
                        fontSize: "14px",
                        cursor: "pointer",
                        opacity: isActionInFlight(confirmationModal.target?.id || confirmationModal.target?.service_id) ? 0.6 : 1,
                      }}
                    >
                      Yes, Approve
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      type="button"
                      onClick={() =>
                        setConfirmationModal({ isOpen: false, type: "", target: null, reason: "", step: "reason" })
                      }
                      style={{
                        padding: "10px 18px",
                        borderRadius: "8px",
                        border: "1px solid #E2E8F0",
                        backgroundColor: "#F8FAFC",
                        color: "#475569",
                        fontWeight: "600",
                        fontSize: "14px",
                        cursor: "pointer",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      disabled={isActionInFlight(confirmationModal.target?.id || confirmationModal.target?.service_id)}
                      onClick={handleExecuteModalDecisionWithLogging}
                      style={{
                        padding: "10px 20px",
                        borderRadius: "8px",
                        border: "none",
                        backgroundColor: confirmationModal.type.includes("reject") ? "#DC2626" : "#16A34A",
                        color: "#FFFFFF",
                        fontWeight: "600",
                        fontSize: "14px",
                        cursor: "pointer",
                        opacity: isActionInFlight(confirmationModal.target?.id || confirmationModal.target?.service_id) ? 0.6 : 1,
                      }}
                    >
                      {confirmationModal.type.includes("reject") ? "Confirm Rejection" : "Confirm Approval"}
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
        {/* 🌟 SERVICE APPROVAL REGISTRY MODAL WINDOW */}
        {activeTab === "Service Approval" && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(15, 23, 42, 0.7)",
              backdropFilter: "blur(6px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10000,
              padding: "24px",
              boxSizing: "border-box",
            }}
            onClick={() => setActiveTab("Overview")}
          >
            <div
              style={{
                backgroundColor: "#FFFFFF",
                width: "100%",
                maxWidth: "1420px",
                height: "94vh",
                borderRadius: "20px",
                boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                border: "1px solid #E2E8F0",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* MODAL HEADER */}
              <div
                style={{
                  padding: "18px 26px",
                  borderBottom: "1px solid #E2E8F0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "#F8FAFC",
                }}
              >
                <div>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <span style={{ fontSize: "20px" }}>📑</span>
                    <h2 style={{ fontSize: "19px", fontWeight: "700", color: "#0F172A", margin: 0 }}>
                      Service Approval Registry
                    </h2>
                    <span style={{ fontSize: "12px", backgroundColor: "#EFF6FF", color: "#1D4ED8", fontWeight: "600", padding: "3px 10px", borderRadius: "12px" }}>
                      Synchronized 3-Collection Multi-Scan
                    </span>
                  </div>
                  <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#64748B" }}>
                    Scanned collections: <code>admin_pending_approvals</code> &bull; <code>users/{targetProviderId || targetUserId}/Notification</code> &bull; <code>All_categories/.../Notification</code> &bull; Admin: <code>{currentUser?.email}</code>
                  </p>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <button
                    type="button"
                    style={{
                      padding: "8px 16px",
                      borderRadius: "8px",
                      backgroundColor: "#2563EB",
                      color: "#FFFFFF",
                      border: "none",
                      fontWeight: "600",
                      fontSize: "13px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                    onClick={() => {
                      recordServiceApprovalAccessLog({
                        actionType: "REFRESHED_DATA",
                        actionLabel: "Refreshed Approvals Queue",
                        details: "User re-scanned existing service IDs across 3 collections",
                      });
                      fetchProviderServicesFromThreeCollections();
                      if (typeof onRetryQueueSync === "function") {
                        onRetryQueueSync();
                      }
                    }}
                  >
                    🔄 Scan & Refresh
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab("Overview")}
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "50%",
                      backgroundColor: "#E2E8F0",
                      border: "none",
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "#475569",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    ✕
                  </button>
                </div>
              </div>
              {/* SCROLLABLE MODAL BODY */}
              <div style={{ flex: 1, overflowY: "auto", padding: "24px" }}>
                {isSynchronizing && (
                  <div style={styles.activityIndicatorOverlay}>
                    <div style={styles.loadingActivitySpinner}></div>
                    <p>Scanning and synchronizing provider services across collections...</p>
                  </div>
                )}
                {!isSynchronizing && syncFaultMessage && (
                  <div style={styles.faultNotificationBanner}>
                    <h3>Synchronization Error</h3>
                    <p>{syncFaultMessage}</p>
                    <button
                      type="button"
                      style={styles.actionTriggerPrimary}
                      onClick={() => {
                        fetchProviderServicesFromThreeCollections();
                        if (typeof onRetryQueueSync === "function") onRetryQueueSync();
                      }}
                    >
                      Retry Synchronization
                    </button>
                  </div>
                )}
                {!isSynchronizing && !syncFaultMessage && (
                  <>
                    {/* KPI METRIC CARDS */}
                    <section style={styles.metricDashboardGrid}>
                      <div style={styles.metricIndicatorTile}>
                        <span style={styles.metricCaptionLabel}>Total Submissions</span>
                        <strong style={styles.metricDataMagnitude}>
                          {providerAggregateMetrics.totalSubmissions}
                        </strong>
                      </div>
                      <div style={styles.metricIndicatorTile}>
                        <span style={styles.metricCaptionLabel}>Pending Validation</span>
                        <strong style={styles.metricDataMagnitude}>
                          {providerAggregateMetrics.pendingReview}
                        </strong>
                      </div>
                      <div style={styles.metricIndicatorTile}>
                        <span style={styles.metricCaptionLabel}>Approved Services</span>
                        <strong style={styles.metricDataMagnitude}>
                          {providerAggregateMetrics.approvedSubmissions}
                        </strong>
                      </div>
                      <div style={styles.metricIndicatorTile}>
                        <span style={styles.metricCaptionLabel}>Rejected Submissions</span>
                        <strong style={styles.metricDataMagnitude}>
                          {providerAggregateMetrics.rejectedSubmissions}
                        </strong>
                      </div>
                      <div style={styles.metricIndicatorTile}>
                        <span style={styles.metricCaptionLabel}>Audit Access Logs</span>
                        <strong style={styles.metricDataMagnitude}>
                          {approvalAuditLogs.length}
                        </strong>
                      </div>
                    </section>
                    {/* MULTI-FIELD SEARCH BAR */}
                    <div
                      style={{
                        backgroundColor: "#F8FAFC",
                        border: "1px solid #E2E8F0",
                        borderRadius: "12px",
                        padding: "16px 20px",
                        marginBottom: "20px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                      }}
                    >
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span style={{ fontSize: "13px", fontWeight: "700", color: "#334155", display: "flex", alignItems: "center", gap: "6px" }}>
                          <span>🔍</span> Filter Services (Instant Reaction &bull; 0ms Lag)
                        </span>
                        {(filterStore.serviceName || filterStore.category || filterStore.maxPrice || filterQueryToken) && (
                          <button
                            type="button"
                            onClick={() => {
                              filterStore.serviceName = "";
                              filterStore.category = "";
                              filterStore.maxPrice = "";
                              if (typeof onFilterQueryChange === "function") {
                                onFilterQueryChange({ target: { value: "" } });
                              }
                              triggerFastReRender();
                            }}
                            style={{
                              border: "none",
                              backgroundColor: "#FEE2E2",
                              color: "#DC2626",
                              padding: "4px 10px",
                              borderRadius: "6px",
                              fontSize: "11px",
                              fontWeight: "700",
                              cursor: "pointer",
                            }}
                          >
                            ✕ Clear Filters
                          </button>
                        )}
                      </div>
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "12px" }}>
                        <div>
                          <label style={{ display: "block", fontSize: "11px", fontWeight: "600", color: "#64748B", marginBottom: "4px" }}>
                            Service Name
                          </label>
                          <input
                            type="text"
                            value={filterStore.serviceName}
                            onChange={(e) => {
                              filterStore.serviceName = e.target.value;
                              triggerFastReRender();
                            }}
                            placeholder="Search service name..."
                            style={{
                              width: "100%",
                              padding: "8px 12px",
                              borderRadius: "6px",
                              border: "1px solid #CBD5E1",
                              fontSize: "13px",
                              outline: "none",
                              boxSizing: "border-box",
                            }}
                          />
                        </div>
                        <div>
                          <label style={{ display: "block", fontSize: "11px", fontWeight: "600", color: "#64748B", marginBottom: "4px" }}>
                            Category / Subcategory
                          </label>
                          <input
                            type="text"
                            value={filterStore.category}
                            onChange={(e) => {
                              filterStore.category = e.target.value;
                              triggerFastReRender();
                            }}
                            placeholder="e.g. Plumbing, Cleaning..."
                            style={{
                              width: "100%",
                              padding: "8px 12px",
                              borderRadius: "6px",
                              border: "1px solid #CBD5E1",
                              fontSize: "13px",
                              outline: "none",
                              boxSizing: "border-box",
                            }}
                          />
                        </div>
                        <div>
                          <label style={{ display: "block", fontSize: "11px", fontWeight: "600", color: "#64748B", marginBottom: "4px" }}>
                            Max Price (£)
                          </label>
                          <input
                            type="number"
                            min="0"
                            step="any"
                            value={filterStore.maxPrice}
                            onChange={(e) => {
                              filterStore.maxPrice = e.target.value;
                              triggerFastReRender();
                            }}
                            placeholder="Filter by maximum price..."
                            style={{
                              width: "100%",
                              padding: "8px 12px",
                              borderRadius: "6px",
                              border: "1px solid #CBD5E1",
                              fontSize: "13px",
                              outline: "none",
                              boxSizing: "border-box",
                            }}
                          />
                        </div>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "4px" }}>
                        <input
                          type="text"
                          value={filterQueryToken}
                          onChange={onFilterQueryChange}
                          placeholder="Quick search: Service ID, keyword, email..."
                          style={{
                            ...styles.searchQueryTextField,
                            maxWidth: "360px",
                            padding: "6px 12px",
                            fontSize: "12px",
                          }}
                        />
                        <span style={styles.aggregateCountIndicator}>
                          Showing <strong>{filteredByCriteriaSubmissions.length}</strong> of {providerScopedSubmissions.length} services
                        </span>
                      </div>
                    </div>
                    {filteredByCriteriaSubmissions.length === 0 && (
                      <div style={styles.zeroStatePresenter}>
                        <h3>No matching service records found</h3>
                        <p>No services matched the specified criteria. Clear the search or filter fields to view all submissions.</p>
                      </div>
                    )}
                    {filteredByCriteriaSubmissions.length > 0 && (
                      <div style={styles.tabularDataCanvas}>
                        <table style={styles.tabularGridElement}>
                          <thead>
                            <tr>
                              <th style={styles.tabularHeaderCell}>Service Details (ID)</th>
                              <th style={styles.tabularHeaderCell}>Category</th>
                              <th style={styles.tabularHeaderCell}>Provider</th>
                              <th style={styles.tabularHeaderCell}>Price</th>
                              <th style={styles.tabularHeaderCell}>Gallery Media (Max 5) & Badges</th>
                              <th style={styles.tabularHeaderCell}>Status (Active/Approved)</th>
                              <th style={styles.tabularHeaderCell}>Approval & Reason</th>
                              <th style={styles.tabularHeaderCell}>Review Audit</th>
                              <th style={styles.tabularHeaderCell}>Submitted At</th>
                              <th style={{ ...styles.tabularHeaderCell, textAlign: "center" }}>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredByCriteriaSubmissions.map((record) => {
                              const existingId = record.id || record.service_id;
                              const descSt = String(record.description_status || "").toLowerCase().trim();
                              const medSt = String(record.media_status || record.media?.status || record.gallery_media?.status || "").toLowerCase().trim();
                              const stStatus = String(record.status || "").toLowerCase().trim();
                              const appStatus = String(record.approval_status || "").toLowerCase().trim();
                              // CRITICAL REQUIREMENT: If description_status, media_status, or status is "pending" or "new_request",
                              // the buttons MUST reappear for admin to approve or reject!
                              const isPendingOrNew =
                                descSt === "pending" ||
                                descSt === "new_request" ||
                                descSt === "under_review" ||
                                medSt === "pending" ||
                                medSt === "new_request" ||
                                medSt === "under_review" ||
                                stStatus === "pending" ||
                                stStatus === "new_request" ||
                                stStatus === "under_review" ||
                                appStatus === "pending" ||
                                appStatus === "new_request" ||
                                appStatus === "under_review";
                              const isActionable = isPendingOrNew;
                              const isApproved =
                                !isActionable &&
                                (stStatus === "approved" ||
                                 appStatus === "approved" ||
                                 record.is_approved === true);
                              const isRejected =
                                !isActionable &&
                                (stStatus === "rejected" ||
                                 stStatus === "declined" ||
                                 appStatus === "rejected" ||
                                 appStatus === "declined" ||
                                 record.is_rejected === true ||
                                 Boolean(record.rejection_reason && record.rejection_reason.trim()));
                              const displayStatus = isActionable ? "pending" : isApproved ? "approved" : "rejected";
                              const galleryList = extractAllMedia(record);
                              const recycleBinCount = Array.isArray(record.recycle_bin) ? record.recycle_bin.length : 0;
                              const mediaStatusVal =
                                record.media?.status ||
                                record.gallery_media?.status ||
                                record.media_status ||
                                (isApproved ? "approved" : isRejected ? "rejected" : "pending");
                              return (
                                <tr key={existingId} style={styles.tabularDataRow}>
                                  {/* Service & ID */}
                                  <td style={styles.tabularDataCell}>
                                    <div style={styles.primaryTextToken}>
                                      {record.service_name || "Unnamed"}
                                    </div>
                                    <div style={styles.subduedTextToken}>
                                      ID: <code>{existingId}</code>
                                    </div>
                                    <div style={{ marginTop: "4px" }}>
                                      <span
                                        style={{
                                          fontSize: "10px",
                                          fontWeight: "700",
                                          padding: "2px 6px",
                                          borderRadius: "4px",
                                          backgroundColor: record.is_active ? "#DCFCE7" : "#F1F5F9",
                                          color: record.is_active ? "#15803D" : "#64748B",
                                        }}
                                      >
                                        {record.is_active ? "● ACTIVE" : "○ INACTIVE"}
                                      </span>
                                    </div>
                                  </td>
                                  {/* Category */}
                                  <td style={styles.tabularDataCell}>
                                    <div style={{ fontWeight: "600" }}>{record.category || "—"}</div>
                                    {record.sub_category && (
                                      <small style={styles.subduedTextToken}>
                                        {record.sub_category}
                                      </small>
                                    )}
                                  </td>
                                  {/* Provider Details */}
                                  <td style={styles.tabularDataCell}>
                                    <div>{record.provider_name || activeProviderRecord?.name || activeProviderRecord?.username || "—"}</div>
                                    <small style={styles.subduedTextToken}>
                                      {record.provider_email || activeProviderRecord?.email || "—"}
                                    </small>
                                  </td>
                                  {/* Pricing */}
                                  <td style={styles.tabularDataCell}>
                                    <strong>£{record.price ?? 0}</strong>
                                    {record.discount > 0 && (
                                      <div style={{ fontSize: "11px", color: "#16A34A" }}>
                                        {record.discount}% off
                                      </div>
                                    )}
                                  </td>
                                  {/* Gallery Images & Media with Badges */}
                                  <td style={styles.tabularDataCell}>
                                    <div style={{ marginBottom: "6px", display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                                      <span
                                        style={{
                                          fontSize: "11px",
                                          fontWeight: "700",
                                          padding: "3px 8px",
                                          borderRadius: "6px",
                                          backgroundColor:
                                            mediaStatusVal === "approved" ? "#DCFCE7" : mediaStatusVal === "rejected" ? "#FEE2E2" : "#FEF3C7",
                                          color:
                                            mediaStatusVal === "approved" ? "#15803D" : mediaStatusVal === "rejected" ? "#B91C1C" : "#B45309",
                                          border: `1px solid ${mediaStatusVal === "approved" ? "#86EFAC" : mediaStatusVal === "rejected" ? "#FCA5A5" : "#FDE68A"}`,
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: "4px",
                                        }}
                                      >
                                        <span>{mediaStatusVal === "approved" ? "✅" : mediaStatusVal === "rejected" ? "❌" : "⏳"}</span>
                                        <span>Media: {mediaStatusVal.toUpperCase()} ({galleryList.length}/5)</span>
                                      </span>
                                      <button
                                        type="button"
                                        onClick={() => {
                                          filterStore.recycleBinTargetService = record;
                                          triggerFastReRender();
                                        }}
                                        style={{
                                          fontSize: "10px",
                                          fontWeight: "700",
                                          padding: "3px 7px",
                                          borderRadius: "4px",
                                          backgroundColor: recycleBinCount > 0 ? "#FEE2E2" : "#F1F5F9",
                                          color: recycleBinCount > 0 ? "#DC2626" : "#64748B",
                                          border: "1px solid #CBD5E1",
                                          cursor: "pointer",
                                        }}
                                        title="Open Recycle Bin to view and recover deleted images"
                                      >
                                        🗑️ Bin ({recycleBinCount})
                                      </button>
                                    </div>
                                    {galleryList.length > 0 ? (
                                      <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                                        {galleryList.slice(0, 5).map((item, idx) => {
                                          const srcUrl = typeof item === "string" ? item : item?.url || item?.file;
                                          const isVid = typeof item === "object" && item?.type === "video"
                                            ? true
                                            : (typeof srcUrl === "string" && (srcUrl.includes(".mp4") || srcUrl.includes(".mov") || srcUrl.includes(".webm") || srcUrl.includes(".mkv") || srcUrl.startsWith("data:video")));
                                          if (!srcUrl) return null;
                                          return (
                                            <div
                                              key={idx}
                                              style={{
                                                position: "relative",
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "6px",
                                                overflow: "hidden",
                                                border: `2px solid ${mediaStatusVal === "approved" ? "#22C55E" : mediaStatusVal === "rejected" ? "#EF4444" : "#CBD5E1"}`,
                                                backgroundColor: isVid ? "#000" : "#F1F5F9",
                                              }}
                                            >
                                              {isVid ? (
                                                <video
                                                  src={srcUrl}
                                                  muted
                                                  onClick={() => onActivateMediaPreview(srcUrl)}
                                                  style={{ width: "100%", height: "100%", objectFit: "cover", cursor: "pointer" }}
                                                />
                                              ) : (
                                                <img
                                                  src={srcUrl}
                                                  alt={`Media ${idx + 1}`}
                                                  onClick={() => onActivateMediaPreview(srcUrl)}
                                                  style={{ width: "100%", height: "100%", objectFit: "cover", cursor: "pointer" }}
                                                />
                                              )}
                                              {/* Edit button for updating caption/label */}
                                              <button
                                                type="button"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleEditMediaItem(record, item);
                                                }}
                                                style={{
                                                  position: "absolute",
                                                  top: "1px",
                                                  left: "1px",
                                                  width: "14px",
                                                  height: "14px",
                                                  backgroundColor: "rgba(37, 99, 235, 0.85)",
                                                  color: "#FFFFFF",
                                                  border: "none",
                                                  borderRadius: "50%",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  fontSize: "9px",
                                                  cursor: "pointer",
                                                  padding: 0,
                                                  zIndex: 2,
                                                }}
                                                title="Edit this image's caption/label"
                                              >
                                                ✎
                                              </button>
                                              {/* Delete/Remove button moving image to Recycle Bin */}
                                              <button
                                                type="button"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleRemoveImageFromService(record, item);
                                                }}
                                                style={{
                                                  position: "absolute",
                                                  top: "1px",
                                                  right: "1px",
                                                  width: "14px",
                                                  height: "14px",
                                                  backgroundColor: "rgba(220, 38, 38, 0.85)",
                                                  color: "#FFFFFF",
                                                  border: "none",
                                                  borderRadius: "50%",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  fontSize: "9px",
                                                  cursor: "pointer",
                                                  padding: 0,
                                                  zIndex: 2,
                                                }}
                                                title="Move this image to Recycle Bin"
                                              >
                                                ✕
                                              </button>
                                              {isVid && (
                                                <span style={{ position: "absolute", bottom: "1px", right: "1px", fontSize: "9px", backgroundColor: "rgba(0,0,0,0.7)", color: "#fff", padding: "1px 3px", borderRadius: "2px" }}>
                                                  🎬
                                                </span>
                                              )}
                                            </div>
                                          );
                                        })}
                                        <div style={{ display: "flex", gap: "4px" }}>
                                          <button
                                            type="button"
                                            onClick={() => {
                                              const firstMedia = typeof galleryList[0] === "string" ? galleryList[0] : galleryList[0]?.url || galleryList[0]?.file;
                                              if (firstMedia) onActivateMediaPreview(firstMedia);
                                            }}
                                            style={{
                                              padding: "3px 7px",
                                              borderRadius: "4px",
                                              backgroundColor: "#2563EB",
                                              color: "#FFFFFF",
                                              border: "none",
                                              fontSize: "11px",
                                              fontWeight: "600",
                                              cursor: "pointer",
                                            }}
                                            title="Preview first media item"
                                          >
                                            🔍 Preview
                                          </button>
                                          <button
                                            type="button"
                                            onClick={() => {
                                              recordServiceApprovalAccessLog({
                                                actionType: "INSPECTED_SERVICE",
                                                actionLabel: "Inspected Service Details",
                                                serviceId: existingId,
                                                serviceName: record.service_name || "Unnamed",
                                                details: `Admin inspected details for "${record.service_name || existingId}"`,
                                              });
                                              onCommitServiceInspection(record);
                                            }}
                                            style={{
                                              padding: "3px 7px",
                                              borderRadius: "4px",
                                              backgroundColor: "#EFF6FF",
                                              color: "#1D4ED8",
                                              border: "1px solid #BFDBFE",
                                              fontSize: "11px",
                                              fontWeight: "600",
                                              cursor: "pointer",
                                            }}
                                            title="View all media in detailed dossier"
                                          >
                                            👁 View
                                          </button>
                                        </div>
                                      </div>
                                    ) : (
                                      <span style={styles.subduedTextToken}>No media</span>
                                    )}
                                  </td>
                                  {/* Lifecycle Status & is_approved */}
                                  <td style={styles.tabularDataCell}>
                                    <span style={resolveStatusBadgeVariant(displayStatus)}>
                                      {displayStatus}
                                    </span>
                                    <div style={{ fontSize: "10px", color: "#64748B", marginTop: "3px" }}>
                                      {record.is_approved ? "is_approved: true" : "is_approved: false"}
                                    </div>
                                    <div style={{ fontSize: "10px", color: "#64748B" }}>
                                      desc: {record.description_status || displayStatus}
                                    </div>
                                  </td>
                                  {/* Approval Status & Rejection Reason */}
                                  <td style={styles.tabularDataCell}>
                                    <span style={resolveStatusBadgeVariant(displayStatus)}>
                                      {displayStatus}
                                    </span>
                                    {isRejected && record.rejection_reason && (
                                      <div style={{ fontSize: "11px", color: "#DC2626", marginTop: "4px", maxWidth: "180px", wordBreak: "break-word" }}>
                                        <strong>Reason:</strong> {record.rejection_reason}
                                      </div>
                                    )}
                                    {isApproved && record.approval_reason && (
                                      <div style={{ fontSize: "11px", color: "#16A34A", marginTop: "4px", maxWidth: "180px", wordBreak: "break-word" }}>
                                        <strong>Reason:</strong> {record.approval_reason}
                                      </div>
                                    )}
                                  </td>
                                  {/* Review Audit */}
                                  <td style={styles.tabularDataCell}>
                                    <div style={{ fontSize: "11px", color: "#475569" }}>
                                      {record.reviewed_by ? `By: ${record.reviewed_by}` : "Pending Review"}
                                    </div>
                                    {record.reviewed_at && (
                                      <div style={{ fontSize: "10px", color: "#94A3B8" }}>
                                        {sanitizeDisplayToken(record.reviewed_at)}
                                      </div>
                                    )}
                                  </td>
                                  {/* Submitted At */}
                                  <td style={styles.tabularDataCell}>
                                    {sanitizeDisplayToken(record.submitted_at || record.created_at)}
                                  </td>
                                  {/* Action Buttons: Dynamically appear when status/desc/media is pending or new_request */}
                                  <td style={{ ...styles.tabularDataCell, textAlign: "center" }}>
                                    <div style={{ display: "flex", gap: "6px", justifyContent: "center", alignItems: "center", flexWrap: "wrap" }}>
                                      <button
                                        type="button"
                                        style={styles.secondaryTriggerButton}
                                        onClick={() => {
                                          recordServiceApprovalAccessLog({
                                            actionType: "INSPECTED_SERVICE",
                                            actionLabel: "Inspected Service Details",
                                            serviceId: existingId,
                                            serviceName: record.service_name || "Unnamed",
                                            details: `Admin inspected details for "${record.service_name || existingId}"`,
                                          });
                                          onCommitServiceInspection(record);
                                        }}
                                      >
                                        Inspect
                                      </button>

                                      {/* Direct CRM Upload Option */}
                                      <label
                                        style={{
                                          padding: "6px 10px",
                                          borderRadius: "6px",
                                          backgroundColor: galleryList.length >= 5 ? "#94A3B8" : "#2563EB",
                                          color: "#FFFFFF",
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          cursor: galleryList.length >= 5 ? "not-allowed" : "pointer",
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: "4px",
                                          whiteSpace: "nowrap",
                                          userSelect: "none",
                                          transition: "background-color 0.2s",
                                        }}
                                        title={galleryList.length >= 5 ? "Max 5 images reached. Delete an image first." : "Add image/video directly from CRM (Auto-Approved)"}
                                      >
                                        📤 Add Media {galleryList.length >= 5 ? "(5/5 Max)" : ""}
                                        <input
                                          type="file"
                                          accept="image/*,video/*"
                                          disabled={galleryList.length >= 5}
                                          style={{ display: "none" }}
                                          onChange={(e) => {
                                            const file = e.target.files?.[0];
                                            if (file) {
                                              handleUploadMediaToService(record, file);
                                              e.target.value = "";
                                            }
                                          }}
                                        />
                                      </label>
                                      {/* BUTTONS REAPPEAR IF PENDING OR NEW_REQUEST */}
                                      {isActionable ? (
                                        <>
                                          <button
                                            type="button"
                                            style={{
                                              padding: "6px 12px",
                                              borderRadius: "6px",
                                              backgroundColor: "#16A34A",
                                              color: "#FFF",
                                              border: "none",
                                              fontSize: "12px",
                                              fontWeight: "600",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              recordServiceApprovalAccessLog({
                                                actionType: "INITIATE_APPROVAL",
                                                actionLabel: "Initiated Approval Modal",
                                                serviceId: existingId,
                                                serviceName: record.service_name || "Unnamed",
                                                details: `Prompted approval modal for "${record.service_name || existingId}"`,
                                              });
                                              setConfirmationModal({
                                                isOpen: true,
                                                type: "approve_service",
                                                step: "reason",
                                                target: {
                                                  ...record,
                                                  id: existingId,
                                                  service_id: existingId,
                                                  providerId: record.providerId || record.provider_id || targetProviderId,
                                                  uid: record.uid || targetUserId,
                                                  _categoryNotifPath: record._categoryNotifPath,
                                                },
                                                reason: "",
                                              });
                                            }}
                                          >
                                            ✓ Approve
                                          </button>
                                          <button
                                            type="button"
                                            style={{
                                              padding: "6px 12px",
                                              borderRadius: "6px",
                                              backgroundColor: "#DC2626",
                                              color: "#FFF",
                                              border: "none",
                                              fontSize: "12px",
                                              fontWeight: "600",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              recordServiceApprovalAccessLog({
                                                actionType: "INITIATE_REJECTION",
                                                actionLabel: "Initiated Rejection Modal",
                                                serviceId: existingId,
                                                serviceName: record.service_name || "Unnamed",
                                                details: `Prompted rejection reason modal for "${record.service_name || existingId}"`,
                                              });
                                              setConfirmationModal({
                                                isOpen: true,
                                                type: "reject_service",
                                                step: "reason",
                                                target: {
                                                  ...record,
                                                  id: existingId,
                                                  service_id: existingId,
                                                  providerId: record.providerId || record.provider_id || targetProviderId,
                                                  uid: record.uid || targetUserId,
                                                  _categoryNotifPath: record._categoryNotifPath,
                                                },
                                                reason: "",
                                              });
                                            }}
                                          >
                                            ✕ Reject
                                          </button>
                                        </>
                                      ) : (
                                        <span
                                          style={{
                                            fontSize: "11px",
                                            fontWeight: "700",
                                            padding: "5px 10px",
                                            borderRadius: "6px",
                                            backgroundColor: isApproved ? "#DCFCE7" : "#FEE2E2",
                                            color: isApproved ? "#15803D" : "#B91C1C",
                                            border: `1px solid ${isApproved ? "#86EFAC" : "#FCA5A5"}`,
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "4px",
                                          }}
                                          title={isRejected && record.rejection_reason ? `Reason: ${record.rejection_reason}` : ""}
                                        >
                                          {isApproved ? "✅ Approved" : "❌ Rejected"}
                                        </span>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {/* AUDIT & ACCESS LOGS */}
                    <div style={{ marginTop: "36px", borderTop: "2px solid #E2E8F0", paddingTop: "24px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                        <div>
                          <h3 style={{ margin: 0, fontSize: "16px", fontWeight: "700", color: "#0F172A", display: "flex", alignItems: "center", gap: "8px" }}>
                            <span>📜</span> Service Approval Access & Audit Trail
                          </h3>
                          <p style={{ margin: "3px 0 0 0", fontSize: "12px", color: "#64748B" }}>
                            Persistent log stored locally in <code>localStorage</code> ({approvalAuditLogs.length} events logged) — includes every image upload, edit, delete and recovery, each recorded with who performed it, when, and any reason/note given. Survives page reloads and re-logins.
                          </p>
                        </div>
                        <div style={{ display: "flex", gap: "8px" }}>
                          <button
                            type="button"
                            onClick={handleExportApprovalLogs}
                            style={{
                              padding: "6px 12px",
                              backgroundColor: "#F1F5F9",
                              color: "#334155",
                              border: "1px solid #CBD5E1",
                              borderRadius: "6px",
                              fontSize: "12px",
                              fontWeight: "600",
                              cursor: "pointer",
                            }}
                          >
                            ⬇ Export JSON
                          </button>
                          <button
                            type="button"
                            onClick={handleClearApprovalLogs}
                            style={{
                              padding: "6px 12px",
                              backgroundColor: "#FEE2E2",
                              color: "#DC2626",
                              border: "1px solid #FCA5A5",
                              borderRadius: "6px",
                              fontSize: "12px",
                              fontWeight: "600",
                              cursor: "pointer",
                            }}
                          >
                            🗑 Clear Logs
                          </button>
                        </div>
                      </div>
                      {approvalAuditLogs.length === 0 ? (
                        <div style={{ padding: "20px", textAlign: "center", backgroundColor: "#F8FAFC", borderRadius: "8px", border: "1px dashed #CBD5E1", color: "#64748B", fontSize: "13px" }}>
                          No audit logs registered yet. Actions taken on this registry will be automatically recorded here.
                        </div>
                      ) : (
                        <div style={{ overflowX: "auto", border: "1px solid #E2E8F0", borderRadius: "10px", backgroundColor: "#FFFFFF" }}>
                          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px", textAlign: "left" }}>
                            <thead>
                              <tr style={{ backgroundColor: "#F1F5F9", color: "#475569", borderBottom: "1px solid #E2E8F0" }}>
                                <th style={{ padding: "10px 14px", fontWeight: "600" }}>Timestamp</th>
                                <th style={{ padding: "10px 14px", fontWeight: "600" }}>Accessed By (Admin)</th>
                                <th style={{ padding: "10px 14px", fontWeight: "600" }}>Action / Event</th>
                                <th style={{ padding: "10px 14px", fontWeight: "600" }}>Service ID / Name</th>
                                <th style={{ padding: "10px 14px", fontWeight: "600" }}>Details / Reason</th>
                              </tr>
                            </thead>
                            <tbody>
                              {approvalAuditLogs.slice(0, 50).map((log, idx) => (
                                <tr key={log.id || idx} style={{ borderBottom: "1px solid #F1F5F9" }}>
                                  <td style={{ padding: "10px 14px", whiteSpace: "nowrap", color: "#64748B", fontSize: "12px" }}>
                                    {log.timestamp}
                                  </td>
                                  <td style={{ padding: "10px 14px" }}>
                                    <div style={{ fontWeight: "600", color: "#0F172A" }}>{log.accessedBy?.email || "Unknown"}</div>
                                    <div style={{ fontSize: "11px", color: "#64748B" }}>UID: {log.accessedBy?.uid}</div>
                                  </td>
                                  <td style={{ padding: "10px 14px" }}>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        padding: "3px 8px",
                                        borderRadius: "6px",
                                        fontSize: "11px",
                                        fontWeight: "600",
                                        backgroundColor:
                                          log.actionType.includes("APPROVED")
                                            ? "#DCFCE7"
                                            : log.actionType.includes("REJECTED")
                                            ? "#FEE2E2"
                                            : log.actionType.includes("EDITED")
                                            ? "#EDE9FE"
                                            : log.actionType.includes("RECOVERED")
                                            ? "#DBEAFE"
                                            : log.actionType.includes("RECYCLE_BIN")
                                            ? "#FFE4E6"
                                            : log.actionType.includes("UPLOADED")
                                            ? "#E0F2FE"
                                            : log.actionType.includes("INSPECT")
                                            ? "#FEF3C7"
                                            : "#EFF6FF",
                                        color:
                                          log.actionType.includes("APPROVED")
                                            ? "#15803D"
                                            : log.actionType.includes("REJECTED")
                                            ? "#B91C1C"
                                            : log.actionType.includes("EDITED")
                                            ? "#6D28D9"
                                            : log.actionType.includes("RECOVERED")
                                            ? "#1D4ED8"
                                            : log.actionType.includes("RECYCLE_BIN")
                                            ? "#BE123C"
                                            : log.actionType.includes("UPLOADED")
                                            ? "#0369A1"
                                            : log.actionType.includes("INSPECT")
                                            ? "#B45309"
                                            : "#1D4ED8",
                                      }}
                                    >
                                      {log.actionLabel || log.actionType}
                                    </span>
                                  </td>
                                  <td style={{ padding: "10px 14px" }}>
                                    <div style={{ fontWeight: "500", color: "#1E293B" }}>{log.serviceName !== "N/A" ? log.serviceName : "—"}</div>
                                    {log.serviceId !== "N/A" && (
                                      <div style={{ fontSize: "11px", color: "#94A3B8" }}>ID: {log.serviceId}</div>
                                    )}
                                  </td>
                                  <td style={{ padding: "10px 14px", color: "#334155" }}>
                                    <div>{log.details || "—"}</div>
                                    {log.reason && (
                                      <div style={{ marginTop: "3px", fontSize: "12px", color: "#DC2626", fontStyle: "italic" }}>
                                        Reason/Note: {log.reason}
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
        {/* HEADER */}
        <div style={headerStyle}>
          <h3 style={titleStyle}>Provider Profile</h3>
        </div>
        {/* CARD */}
        <div style={cardStyle}>
          <div
            className="category-title-container"
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              marginBottom: "20px",
              textAlign: "center",
            }}
          >
            <h3
              style={{
                margin: 0,
                fontFamily: "'Poppins', sans-serif",
                fontSize: "24px",
                fontWeight: "700",
                color: "#111827",
              }}
            >
              👤 Provider Profile
            </h3>
          </div>

          <div className="card-section">
            <div className="bg-white p-6 rounded-2xl shadow border border-gray-200 card-section provider-card">
              {activeProviderRecord ? (
                <>
                  <div className="mb-6 text-center flex flex-col items-center">
                    <span
                      className={`font-bold text-2xl px-6 py-4 rounded-full flex items-center justify-center gap-2 ${
                        activeProviderRecord.status === "verified"
                          ? "bg-green-100 text-green-700"
                          : activeProviderRecord.status === "pending"
                          ? "bg-yellow-100 text-yellow-700"
                          : activeProviderRecord.status === "rejected"
                          ? "bg-red-100 text-red-700"
                          : "bg-gray-100 text-gray-700"
                      }`}
                    >
                      {activeProviderRecord.status === "verified" && "✅ Verified"}
                      {activeProviderRecord.status === "pending" && "⏳ Pending Verification"}
                      {activeProviderRecord.status === "rejected" &&
                        `❌ Rejected ${activeProviderRecord.rejectionReason || ""}`}
                    </span>
                  </div>
                  <div className="bg-white p-6 rounded-2xl shadow border border-gray-200 w-full max-w-sm text-center">
                    <div className="flex justify-center">
                      <img
                        src={
                          activeProviderRecord?.profileImage ||
                          activeProviderRecord?.photoURL ||
                          "/plumber1.jpeg"
                        }
                        alt="Provider"
                        style={{
                          width: "64px",
                          height: "64px",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                    <h2 className="text-lg font-semibold mt-4">
                      {activeProviderRecord?.username ||
                        activeProviderRecord?.name ||
                        "N/A"}
                    </h2>
                    <div className="mt-2 inline-flex items-center px-2 py-0.5 rounded-full bg-green-100 text-green-600 text-xs font-medium">
                      ✔ Verified
                    </div>
                    {activeProviderRecord?.status === "approved" && (
                      <div className="mt-2 inline-flex items-center px-2 py-0.5 rounded-full bg-green-100 text-green-600 text-xs font-medium">
                        ✔ Approved
                      </div>
                    )}
                    <hr className="my-4" />
                    <div className="text-left">
                      <h3 className="text-sm font-semibold text-gray-700 mb-1">Contact</h3>
                      {activeProviderRecord?.email && (
                        <p className="flex items-center gap-2 text-gray-600 text-sm">
                          📧 {activeProviderRecord.email}
                        </p>
                      )}
                      {(activeProviderRecord?.phoneNumber || activeProviderRecord?.phone) && (
                        <p className="flex items-center gap-2 text-gray-600 text-sm mt-1">
                          📞{" "}
                          {activeProviderRecord?.phoneNumber ||
                            activeProviderRecord?.phone ||
                            "Phone not available"}
                        </p>
                      )}
                    </div>
                    <hr className="my-4" />
                    <div className="text-left">
                      <h3 className="text-sm font-semibold text-gray-700 mb-1">Location</h3>
                      <p className="flex items-center gap-2 text-gray-600 text-sm">
                        📍{" "}
                        {typeof activeProviderRecord?.location === "object" &&
                        activeProviderRecord?.location !== null
                          ? activeProviderRecord.location.address || "UK"
                          : activeProviderRecord?.location || "UK"}
                      </p>
                    </div>
                    <div className="text-left">
                      <h3 className="text-sm font-semibold text-gray-700 mb-1 flex items-center gap-1">
                        📅 Availability
                      </h3>
                      {profileAvailability &&
                        Object.entries(profileAvailability)
                          .filter(([_, { open }]) => open)
                          .map(([day, { slots }]) => (
                            <div key={day} className="mb-2 text-gray-700 text-xs">
                              <strong>{day}:</strong>{" "}
                              {slots.map((slot, i) => {
                                const formatTime = (hour) => {
                                  const h = hour % 12 || 12;
                                  const ampm = hour < 12 ? "AM" : "PM";
                                  return `${h}:00 ${ampm}`;
                                };
                                return (
                                  <span key={i}>
                                    {formatTime(slot.from)} - {formatTime(slot.to)}
                                    {i < slots.length - 1 ? ", " : ""}
                                  </span>
                                );
                              })}
                            </div>
                          ))}
                    </div>
                  </div>
                  {/* Tabs */}
                  <div className="tab-nav flex gap-2 mb-4">
                    {[
                      "Overview",
                      "Verification & Compliance",
                      "Performance & Earnings",
                      "Trust Indicators",
                      "Automatic Flags",
                      "Availability",
                      "Service Approval",
                      "Approval Logs",
                    ].map((tab) => (
                      <button
                        key={tab}
                        onClick={() => {
                          if (tab === "Service Approval") {
                            recordServiceApprovalAccessLog({
                              actionType: "REGISTRY_TAB_CLICKED",
                              actionLabel: "Clicked Service Approval Tab",
                              details: `User navigated to Service Approval Registry for provider ${activeProviderRecord?.name || targetProviderId || "N/A"}`,
                            });
                            fetchProviderServicesFromThreeCollections();
                          }
                          setActiveTab(tab);
                        }}
                        className={`tab-button px-4 py-2 rounded ${
                          activeTab === tab ? "bg-blue-100 font-semibold text-blue-700" : "bg-gray-100"
                        }`}
                      >
                        {tab === "Service Approval"
                          ? "📑 Service Approval"
                          : tab === "Approval Logs"
                          ? `📜 Approval Logs (${approvalAuditLogs.length})`
                          : tab}
                      </button>
                    ))}
                  </div>
                  <div className="content-grid flex gap-6">
                    <div className="left-section flex-1 space-y-4">
                      {activeTab === "Service Approval" && (
                        <div className="bg-white p-8 rounded-2xl shadow border border-gray-200 text-center">
                          <div style={{ fontSize: "40px", marginBottom: "12px" }}>📂</div>
                          <h3 className="text-lg font-bold text-gray-800 mb-2">Service Approval Registry Window Open</h3>
                          <p className="text-sm text-gray-500 mb-5">
                            The Service Approval Registry is running in a full-sized modal overlay for comfortable review of services submitted by this provider.
                          </p>
                          <button
                            type="button"
                            onClick={() => {
                              recordServiceApprovalAccessLog({
                                actionType: "VIEW_MODAL_CLICKED",
                                actionLabel: "Opened Service Approval Modal",
                                details: "User re-opened modal window from prompt",
                              });
                              fetchProviderServicesFromThreeCollections();
                              setActiveTab("Service Approval");
                            }}
                            className="px-5 py-2.5 bg-blue-600 text-white rounded-lg text-sm font-semibold hover:bg-blue-700 transition"
                          >
                            View Modal Window
                          </button>
                        </div>
                      )}
                      {/* Approval Logs Tab View */}
                      {activeTab === "Approval Logs" && (
                        <div className="bg-white shadow-lg rounded-xl p-8 w-full max-w-5xl mx-auto my-4 border border-gray-200">
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                            <div>
                              <h2 className="text-2xl font-bold text-gray-800">📜 Service Approval Access & Audit Logs</h2>
                              <p className="text-sm text-gray-500 mt-1">
                                Complete log of who accessed, inspected, uploaded, edited, deleted, recovered, approved, or rejected services and media. All entries are preserved in <code>localStorage</code>.
                              </p>
                            </div>
                            <div style={{ display: "flex", gap: "10px" }}>
                              <button
                                type="button"
                                onClick={handleExportApprovalLogs}
                                className="px-4 py-2 bg-blue-50 text-blue-700 border border-blue-200 rounded-lg text-sm font-semibold hover:bg-blue-100"
                              >
                                📥 Export to JSON
                              </button>
                              <button
                                type="button"
                                onClick={handleClearApprovalLogs}
                                className="px-4 py-2 bg-red-50 text-red-700 border border-red-200 rounded-lg text-sm font-semibold hover:bg-red-100"
                              >
                                🗑 Clear All Logs
                              </button>
                            </div>
                          </div>
                          {approvalAuditLogs.length === 0 ? (
                            <div className="text-center py-12 text-gray-500 border border-dashed rounded-lg">
                              No logs recorded yet. Access the Service Approval tab to generate audit records.
                            </div>
                          ) : (
                            <div className="overflow-x-auto rounded-lg border border-gray-200">
                              <table className="w-full text-sm">
                                <thead>
                                  <tr className="bg-gray-50 text-left text-gray-600">
                                    <th className="p-3 border-b">Timestamp</th>
                                    <th className="p-3 border-b">Admin User</th>
                                    <th className="p-3 border-b">Action</th>
                                    <th className="p-3 border-b">Service Target</th>
                                    <th className="p-3 border-b">Details / Reason</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {approvalAuditLogs.map((log) => (
                                    <tr key={log.id} className="hover:bg-gray-50 border-b border-gray-100">
                                      <td className="p-3 text-xs text-gray-500 whitespace-nowrap">{log.timestamp}</td>
                                      <td className="p-3">
                                        <div className="font-semibold text-gray-800">{log.accessedBy?.email}</div>
                                        <div className="text-xs text-gray-400">UID: {log.accessedBy?.uid}</div>
                                      </td>
                                      <td className="p-3">
                                        <span
                                          className={`inline-block px-2.5 py-1 rounded text-xs font-semibold ${
                                            log.actionType.includes("APPROVED")
                                              ? "bg-green-100 text-green-800"
                                              : log.actionType.includes("REJECTED")
                                              ? "bg-red-100 text-red-800"
                                              : log.actionType.includes("EDITED")
                                              ? "bg-purple-100 text-purple-800"
                                              : log.actionType.includes("RECOVERED")
                                              ? "bg-blue-100 text-blue-800"
                                              : log.actionType.includes("RECYCLE_BIN")
                                              ? "bg-rose-100 text-rose-800"
                                              : log.actionType.includes("UPLOADED")
                                              ? "bg-sky-100 text-sky-800"
                                              : log.actionType.includes("INSPECT")
                                              ? "bg-amber-100 text-amber-800"
                                              : "bg-blue-100 text-blue-800"
                                          }`}
                                        >
                                          {log.actionLabel || log.actionType}
                                        </span>
                                      </td>
                                      <td className="p-3">
                                        <div className="font-medium text-gray-800">{log.serviceName !== "N/A" ? log.serviceName : "—"}</div>
                                        {log.serviceId !== "N/A" && (
                                          <div className="text-xs text-gray-400">ID: {log.serviceId}</div>
                                        )}
                                      </td>
                                      <td className="p-3 text-gray-700">
                                        <div>{log.details || "—"}</div>
                                        {log.reason && (
                                          <div className="text-xs text-red-600 italic mt-1 font-semibold">
                                            Reason/Note: {log.reason}
                                          </div>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>
                      )}
                      {/* Overview Tab */}
                      {activeTab === "Overview" && (
                        <div className="bg-white shadow-lg rounded-xl p-10 w-full max-w-5xl mx-auto my-10">
                          <h2 className="text-2xl font-bold mb-6 border-b pb-3">📋 Admin Notes</h2>
                          <div className="space-y-4">
                            <div>
                              <label className="block text-sm font-medium mb-1">New Note</label>
                              <textarea
                                value={newNote}
                                onChange={(e) => setNewNote(e.target.value)}
                                placeholder="Write a new note..."
                                className="w-full border rounded p-3 text-sm focus:ring focus:ring-blue-200"
                              />
                            </div>
                            <div>
                              <button
                                onClick={() => {
                                  if (!newNote.trim()) return;
                                  const updatedNotes = [
                                    ...allAdminNotes,
                                    {
                                      text: String(newNote.trim()),
                                      date: new Date().toLocaleString(),
                                    },
                                  ];
                                  setAllAdminNotes(updatedNotes);
                                  localStorage.setItem("allAdminNotes", JSON.stringify(updatedNotes));
                                  setNewNote("");
                                }}
                                style={{ backgroundColor: "#2563eb", color: "white" }}
                                className="px-3 py-2 rounded"
                              >
                                Add Note
                              </button>
                            </div>
                          </div>
                          <div className="mt-8">
                            {Array.isArray(allAdminNotes) && allAdminNotes.length > 0 ? (
                              <div className="overflow-x-auto rounded border border-gray-200">
                                <table className="w-full text-sm">
                                  <thead>
                                    <tr className="bg-gray-100 text-left">
                                      <th className="p-3 border">Note</th>
                                      <th className="p-3 border">Date</th>
                                      <th className="p-3 border text-center">Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {allAdminNotes.map((note, index) => (
                                      <tr key={index} className="hover:bg-gray-50">
                                        <td className="p-3 border">{note?.text || "No text"}</td>
                                        <td className="p-3 border text-gray-500">
                                          {note?.date || ""}
                                        </td>
                                        <td className="p-3 border text-center">
                                          <button
                                            onClick={() => {
                                              const updatedNotes = allAdminNotes.filter((_, i) => i !== index);
                                              setAllAdminNotes(updatedNotes);
                                              localStorage.setItem("allAdminNotes", JSON.stringify(updatedNotes));
                                            }}
                                            style={{ backgroundColor: "#dc2626", color: "white" }}
                                            className="px-3 py-2 rounded"
                                          >
                                            <X size={18} />
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            ) : (
                              <p className="text-sm text-gray-500">No notes yet.</p>
                            )}
                          </div>
                        </div>
                      )}
                      {/* Availability Tab */}
                      {activeTab === "Availability" && activeProviderRecord && (
                        <div className="bg-white p-6 rounded-2xl shadow border border-gray-200 mt-4">
                          <h3 className="text-sm font-semibold text-gray-700 mb-2">📅 Availability</h3>
                          <div className="mb-3">
                            <label className="text-gray-600 text-xs font-medium">🌍 Timezone</label>
                            <select
                              className="form-select w-full mt-1"
                              value={selectedTimezone}
                              onChange={(e) => setSelectedTimezone(e.target.value)}
                            >
                              <option value="Australia/Sydney">Australia/Sydney</option>
                              <option value="Asia/Kolkata">Asia/Kolkata</option>
                              <option value="UK/London">UK/London</option>
                              <option value="USA/America">USA/America</option>
                              <option value="Europe">Europe</option>
                              <option value="UTC">UTC</option>
                            </select>
                            <div className="text-primary text-xs mt-1">
                              🕒 Time is shown in selected timezone
                            </div>
                          </div>
                          <div className="table-responsive mb-2">
                            <table className="table table-bordered text-sm">
                              <thead className="table-light">
                                <tr>
                                  <th>Day</th>
                                  <th>Status</th>
                                  <th>Time Slots</th>
                                </tr>
                              </thead>
                              <tbody>
                                {Object.entries(profileAvailability).length === 0 ? (
                                  <tr>
                                    <td colSpan={3} className="text-center text-xs">
                                      No availability set yet
                                    </td>
                                  </tr>
                                ) : (
                                  Object.entries(profileAvailability).map(([dayName, { open, slots }]) => (
                                    <tr key={dayName}>
                                      <td>{dayName}</td>
                                      <td>
                                        <div className="form-check form-switch">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={open}
                                            onChange={() => toggleProfileDayStatus(dayName)}
                                          />
                                          <label className="form-check-label">
                                            {open ? "🟢 Open" : "🚫 Closed"}
                                          </label>
                                        </div>
                                      </td>
                                      <td>
                                        {open &&
                                          slots.map((slot, slotIndex) => {
                                            const isEditing =
                                              profileSlotEditingState?.[dayName]?.[slotIndex] ?? false;
                                            const handleEditToggle = () => {
                                              setProfileSlotEditingState((prev) => ({
                                                ...prev,
                                                [dayName]: {
                                                  ...(prev[dayName] || {}),
                                                  [slotIndex]: !isEditing,
                                                },
                                              }));
                                            };
                                            return (
                                              <div key={slotIndex} className="mb-4">
                                                <div className="flex justify-between items-center px-2 text-xs text-gray-600">
                                                  <small>
                                                    From:{" "}
                                                    {isEditing ? (
                                                      <input
                                                        type="number"
                                                        min={0}
                                                        max={slot.to - 1}
                                                        value={slot.from}
                                                        onChange={(e) =>
                                                          modifyDayTimeSlot(dayName, slotIndex, {
                                                            ...slot,
                                                            from: parseInt(e.target.value) || 0,
                                                          })
                                                        }
                                                        className="w-12 border rounded text-center"
                                                      />
                                                    ) : (
                                                      `${slot.from}:00`
                                                    )}
                                                  </small>
                                                  <small>
                                                    To:{" "}
                                                    {isEditing ? (
                                                      <input
                                                        type="number"
                                                        min={slot.from + 1}
                                                        max={24}
                                                        value={slot.to}
                                                        onChange={(e) =>
                                                          modifyDayTimeSlot(dayName, slotIndex, {
                                                            ...slot,
                                                            to: parseInt(e.target.value) || 24,
                                                          })
                                                        }
                                                        className="w-12 border rounded text-center"
                                                      />
                                                    ) : (
                                                      `${slot.to}:00`
                                                    )}
                                                  </small>
                                                </div>
                                                <div className="px-2 mt-2">
                                                  <Slider
                                                    value={[slot.from, slot.to]}
                                                    onChange={(e, newValue) =>
                                                      modifyDayTimeSlot(dayName, slotIndex, {
                                                        ...slot,
                                                        from: newValue[0],
                                                        to: newValue[1],
                                                      })
                                                    }
                                                    valueLabelDisplay="auto"
                                                    min={0}
                                                    max={24}
                                                    step={1}
                                                    marks
                                                  />
                                                </div>
                                                <div className="flex gap-2 px-2 mt-2">
                                                  <button
                                                    className={`btn btn-sm ${
                                                      isEditing ? "btn-success" : "btn-secondary"
                                                    }`}
                                                    onClick={handleEditToggle}
                                                  >
                                                    {isEditing ? "💾 Save" : "✏️"}
                                                  </button>
                                                  <button
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => deleteProfileSlot(dayName, slotIndex)}
                                                  >
                                                    🗑
                                                  </button>
                                                </div>
                                              </div>
                                            );
                                          })}
                                        {open && (
                                          <button
                                            className="btn btn-success btn-sm mt-1"
                                            onClick={() => appendProfileSlot(dayName)}
                                          >
                                            ➕ Add Slot
                                          </button>
                                        )}
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>
                          <div className="flex gap-2 mt-2">
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() => {
                                if (activeProviderRecord?.id) {
                                  saveAvailabilityToFirestore(activeProviderRecord.id, "weekly");
                                } else {
                                  console.error("Cannot save: activeProviderRecord ID is missing!");
                                }
                              }}
                            >
                              📀 Save Weekly
                            </button>
                            <button
                              className="btn btn-success btn-sm"
                              onClick={() => {
                                if (activeProviderRecord?.id) {
                                  saveAvailabilityToFirestore(activeProviderRecord.id, "monthly");
                                } else {
                                  console.error("Cannot save: activeProviderRecord ID is missing!");
                                }
                              }}
                            >
                              📀 Save Monthly
                            </button>
                            <button
                              className="btn btn-warning btn-sm text-white"
                              onClick={() => {
                                if (activeProviderRecord?.id) {
                                  saveAvailabilityToFirestore(activeProviderRecord.id, "yearly");
                                } else {
                                  console.error("Cannot save: activeProviderRecord ID is missing!");
                                }
                              }}
                            >
                              📀 Save Yearly
                            </button>
                          </div>
                        </div>
                      )}
                      {/* Verification & Compliance Tab */}
                      {activeTab === "Verification & Compliance" && (
                        <div
                          style={{
                            border: "1px solid #eee",
                            borderRadius: 10,
                            padding: 20,
                            width: 700,
                            fontFamily: "Arial, sans-serif",
                            position: "relative",
                          }}
                        >
                          <div className="mb-4">
                            <div
                              style={{
                                height: 10,
                                background: "#eee",
                                borderRadius: 5,
                                overflow: "hidden",
                              }}
                            >
                              <div
                                style={{
                                  width: `${completionPercent || 0}%`,
                                  height: "100%",
                                  background: "#007BFF",
                                  transition: "width 0.3s",
                                }}
                              ></div>
                            </div>
                            <p style={{ fontSize: 12, marginTop: 4 }}>
                              {(completionPercent || 0).toFixed(0)}% completed
                            </p>
                          </div>
                          <div style={{ position: "relative" }}>
                            <div
                              style={{
                                position: "absolute",
                                top: 10,
                                left: 10,
                                width: 2,
                                height: "calc(100% - 10px)",
                                backgroundColor: "#ddd",
                                zIndex: 0,
                              }}
                            ></div>
                            {steps.map((step, index) => {
                              const doc = verification?.[step.key] || {};
                              const expiryDate = doc.expiryDate ? new Date(doc.expiryDate) : null;
                              const daysLeft = expiryDate
                                ? Math.ceil((expiryDate - new Date()) / (1000 * 60 * 60 * 24))
                                : null;
                              return (
                                <div
                                  key={index}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    position: "relative",
                                    marginBottom: 20,
                                  }}
                                >
                                  <div style={{ marginRight: 12 }}>
                                    {getStatusIcon(doc.status)}
                                  </div>
                                  <div style={{ flex: 1 }}>
                                    <div
                                      style={{
                                        fontWeight: "bold",
                                        color:
                                          doc.status === "pending"
                                            ? "#d32f2f"
                                            : doc.status === "in-progress"
                                            ? "#333"
                                            : "#1a1a1a",
                                      }}
                                    >
                                      {step.title}
                                    </div>
                                    <div style={{ fontSize: 14, color: "#555" }}>
                                      {step.description}
                                    </div>
                                    {expiryDate && (
                                      <div
                                        style={{
                                          marginTop: 6,
                                          fontSize: 13,
                                          fontWeight: "bold",
                                          color: daysLeft <= 30 ? "#d32f2f" : "#2e7d32",
                                        }}
                                      >
                                        Expires on {expiryDate.toDateString()} ({daysLeft} days left)
                                      </div>
                                    )}
                                    <div style={{ marginTop: 8 }}>
                                      <input
                                        type="file"
                                        onChange={(e) => handleUpload(step.key, e)}
                                        style={{
                                          fontSize: 12,
                                          width: "100%",
                                          padding: "8px",
                                          border: "1px solid #ccc",
                                          borderRadius: "5px",
                                        }}
                                      />
                                    </div>
                                    <div style={{ marginTop: 8 }}>
                                      <input
                                        type="date"
                                        value={doc.expiryDate || ""}
                                        onChange={(e) =>
                                          handleExpiryChange(step.key, e.target.value)
                                        }
                                        style={{
                                          fontSize: 12,
                                          width: "100%",
                                          padding: "8px",
                                          border: "1px solid #ccc",
                                          borderRadius: "5px",
                                        }}
                                      />
                                    </div>
                                    {expiryDate && daysLeft <= 30 && (
                                      <button
                                        onClick={() =>
                                          sendReminder(step.key, expiryDate.toISOString().split("T")[0])
                                        }
                                        style={{
                                          marginTop: 8,
                                          background: "#ff9800",
                                          color: "white",
                                          padding: "6px 12px",
                                          borderRadius: 5,
                                          fontSize: 12,
                                          border: "none",
                                          cursor: "pointer",
                                        }}
                                      >
                                        Send Reminder to Provider
                                      </button>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                      {/* Performance & Earnings Tab */}
                      {activeTab === "Performance & Earnings" && (
                        <div className="rounded-xl bg-white shadow-sm border border-gray-100 p-6">
                          <div className="kpi-card">
                            <div className="chart-section">
                              <h3 className="tab-title">Performance</h3>
                              <div style={{ width: "100%", height: 200 }}>
                                <ResponsiveContainer width="100%" height="100%">
                                  <AreaChart
                                    data={performanceChartData}
                                    margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
                                  >
                                    <defs>
                                      <linearGradient
                                        id="areaGradient"
                                        x1="0"
                                        y1="0"
                                        x2="0"
                                        y2="1"
                                      >
                                        <stop
                                          offset="0%"
                                          stopColor="#007BFF"
                                          stopOpacity={0.18}
                                        />
                                        <stop
                                          offset="100%"
                                          stopColor="#007BFF"
                                          stopOpacity={0.04}
                                        />
                                      </linearGradient>
                                    </defs>
                                    <XAxis
                                      dataKey="month"
                                      axisLine={false}
                                      tickLine={false}
                                      tick={{ fill: "#334155", fontSize: 13 }}
                                      padding={{ left: 8, right: 8 }}
                                    />
                                    <YAxis
                                      axisLine={false}
                                      tickLine={false}
                                      tick={{ fill: "#334155", fontSize: 12 }}
                                      domain={[
                                        0,
                                        (dataMax) =>
                                          dataMax ? dataMax + dataMax * 0.15 : 100,
                                      ]}
                                    />
                                    <Tooltip
                                      contentStyle={{ borderRadius: 8 }}
                                      formatter={(value) => value}
                                      cursor={{ stroke: "#e6eefc", strokeWidth: 1 }}
                                    />
                                    <CartesianGrid
                                      vertical={false}
                                      horizontal={true}
                                      stroke="#f0f3f8"
                                      strokeDasharray="3 3"
                                    />
                                    <Area
                                      type="monotone"
                                      dataKey="value"
                                      stroke="#007BFF"
                                      strokeWidth={2}
                                      fill="url(#areaGradient)"
                                      dot={false}
                                      activeDot={{ r: 4 }}
                                    />
                                  </AreaChart>
                                </ResponsiveContainer>
                              </div>
                            </div>
                            <hr className="border-line" />
                            <h3 className="tab-title">📊 Job History</h3>
                            <div className="kpi-wrapper">
                              <div className="stat-item">
                                <p className="kpi-value">56</p>
                                <p className="kpi-subtext">Completed Jobs</p>
                              </div>
                              <div className="stat-item">
                                <p className="kpi-value">40%</p>
                                <p className="kpi-subtext">Repeat Customers</p>
                              </div>
                              <div className="stat-item">
                                <p className="kpi-value">2%</p>
                                <p className="kpi-subtext">Cancellation Rate</p>
                              </div>
                            </div>
                            <h3 className="tab-title">⭐ Customer Reviews</h3>
                            <ul className="reviews-list">
                              <li>⭐⭐⭐⭐ psychological- Very professional and quick response.</li>
                            </ul>
                            <hr className="border-line" />
                            <h3 className="tab-title">💷 Earnings</h3>
                            <div className="earnings-block">
                              <p className="kpi-subtext">Wallet Balance</p>
                              <p className="kpi-value">£320</p>
                              <p className="kpi-subtext">Pending Payout</p>
                              <p className="kpi-value">
                                £80{" "}
                                <span className="kpi-subtext">(Release: 24 Aug)</span>
                              </p>
                              <p className="kpi-subtext">Lifetime Earnings</p>
                              <p className="kpi-value">£12,450</p>
                              <p className="kpi-subtext">Avg. Response Time</p>
                              <p className="kpi-value">15 mins</p>
                            </div>
                          </div>
                        </div>
                      )}
                      {/* Trust Indicators Tab */}
                      {activeTab === "Trust Indicators" && (
                        <div
                          style={{
                            border: "1px solid #eee",
                            borderRadius: 25,
                            padding: 20,
                            maxwidth: 800,
                            fontFamily: "Arial, sans-serif",
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "bold",
                              marginBottom: 78,
                              fontSize: 16,
                              color: "#333",
                            }}
                          >
                            Trust Indicators
                          </h3>
                          <ul
                            style={{
                              listStyle: "none",
                              padding: 0,
                              margin: 0,
                              position: "relative",
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                left: 12,
                                top: 0,
                                bottom: 0,
                                width: 2,
                                backgroundColor: "#ccc",
                                zIndex: 1,
                              }}
                            />
                            {Array.isArray(verificationSteps) &&
                              verificationSteps.map((step, index) => {
                                if (!step) return null;
                                const stepStatus =
                                  verificationStatus?.[step.key] || {};
                                const isVerified =
                                  stepStatus.status === "verified";
                                const isPending =
                                  stepStatus?.fileName && !isVerified;
                                const notProvided = !stepStatus?.fileName;
                                let dotColor = "#ccc";
                                let IconComponent = null;
                                if (isVerified) {
                                  dotColor = "#28a745";
                                  IconComponent = Check;
                                } else if (isPending) {
                                  dotColor = "#ff9800";
                                  IconComponent = Clock;
                                } else if (notProvided) {
                                  dotColor = "#d32f2f";
                                  IconComponent = X;
                                }
                                return (
                                  <li
                                    key={index}
                                    style={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                      position: "relative",
                                      marginBottom: 20,
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: 20,
                                        height: 20,
                                        borderRadius: "50%",
                                        backgroundColor: dotColor,
                                        marginRight: 10,
                                        position: "relative",
                                        zIndex: 2,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "#fff",
                                        fontSize: 12,
                                      }}
                                    >
                                      {IconComponent && <IconComponent size={14} />}
                                    </div>
                                    <div style={{ flex: 1 }}>
                                      <div
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: 14,
                                          color: dotColor,
                                        }}
                                      >
                                        {step?.label || "N/A"}
                                      </div>
                                      <div style={{ fontSize: 12, color: "#555" }}>
                                        {isVerified
                                          ? "Verified"
                                          : isPending
                                          ? "Pending Verification"
                                          : "Not provided"}
                                      </div>
                                      <div style={{ marginTop: 5 }}>
                                        <input
                                          type="file"
                                          onChange={(e) =>
                                            handleDocumentUpload(step.key, e)
                                          }
                                          style={{ fontSize: 12 }}
                                        />
                                      </div>
                                    </div>
                                  </li>
                                );
                              })}
                          </ul>
                        </div>
                      )}
                      {/* Automatic Flags Tab */}
                      {activeTab === "Automatic Flags" && activeProviderRecord && (
                        <div
                          style={{
                            border: "1px solid #eee",
                            borderRadius: 10,
                            padding: 100,
                            width: 400,
                            fontFamily: "Arial, sans-serif",
                            position: "relative",
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "bold",
                              marginBottom: 16,
                              fontSize: 16,
                              color: "#333",
                            }}
                          >
                            Automatic Flags
                          </h3>
                          {Array.isArray(verificationSteps) &&
                            verificationSteps.map((step, index) => {
                              if (!step) return null;
                              const stepStatus = verificationStatus?.[step.key] || {};
                              const expiryDate = stepStatus?.expiryDate;
                              const today = new Date();
                              const isExpiringSoon =
                                expiryDate &&
                                (new Date(expiryDate) - today) / (1000 * 3600 * 24) <= 7;
                              const isExpired = expiryDate && new Date(expiryDate) < today;
                              let displayStatus = stepStatus.status;
                              if (isExpired) displayStatus = "Expired";
                              else if (isExpiringSoon) displayStatus = "Expiring Soon";
                              else if (stepStatus.status === "verified") displayStatus = "Verified";
                              const flagColor = isExpired
                                ? "#d32f2f"
                                : isExpiringSoon
                                ? "#FFA500"
                                : "#007BFF";
                              return (
                                <div
                                  key={index}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: 12,
                                  }}
                                >
                                  <div
                                    style={{
                                      width: 12,
                                      height: 12,
                                      borderRadius: "50%",
                                      backgroundColor: flagColor,
                                      marginRight: 8,
                                    }}
                                    title={displayStatus}
                                  ></div>
                                  <div>
                                    <strong>{step.label}</strong>{" "}
                                    {expiryDate && `- Expires on ${new Date(expiryDate).toLocaleDateString()}`}{" "}
                                    - <em>{displayStatus}</em>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      )}
                      {/* DETAILED INSPECTION DOSSIER */}
                      {isDossierActive && inspectedServiceDossier && (() => {
                        const dossierDescSt = String(inspectedServiceDossier.description_status || "").toLowerCase().trim();
                        const dossierMedSt = String(inspectedServiceDossier.media_status || inspectedServiceDossier.media?.status || inspectedServiceDossier.gallery_media?.status || "").toLowerCase().trim();
                        const dossierSt = String(inspectedServiceDossier.status || "").toLowerCase().trim();
                        const dossierApp = String(inspectedServiceDossier.approval_status || "").toLowerCase().trim();
                        const isDossierPendingOrNew =
                          dossierDescSt === "pending" ||
                          dossierDescSt === "new_request" ||
                          dossierDescSt === "under_review" ||
                          dossierMedSt === "pending" ||
                          dossierMedSt === "new_request" ||
                          dossierMedSt === "under_review" ||
                          dossierSt === "pending" ||
                          dossierSt === "new_request" ||
                          dossierSt === "under_review" ||
                          dossierApp === "pending" ||
                          dossierApp === "new_request" ||
                          dossierApp === "under_review";
                        const isDossierActionable = isDossierPendingOrNew;
                        const isDossierApproved =
                          !isDossierActionable &&
                          (dossierSt === "approved" ||
                           dossierApp === "approved" ||
                           inspectedServiceDossier.is_approved === true);
                        const isDossierRejected =
                          !isDossierActionable &&
                          (dossierSt === "rejected" ||
                           dossierSt === "declined" ||
                           dossierApp === "rejected" ||
                           dossierApp === "declined" ||
                           inspectedServiceDossier.is_rejected === true ||
                           Boolean(inspectedServiceDossier.rejection_reason && inspectedServiceDossier.rejection_reason.trim()));
                        const dossierExistingId = inspectedServiceDossier.service_id || inspectedServiceDossier.id;
                        return (
                          <div style={{ ...styles.dossierBackdropSurface, zIndex: 11000 }} onClick={onDismissServiceInspection}>
                            <div
                              style={styles.dossierModalShell}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <div style={styles.dossierSectionHeader}>
                                <div>
                                  <h2 style={styles.dossierPrimaryTitle}>
                                    {inspectedServiceDossier.service_name || "Service Dossier"}
                                  </h2>
                                  <p style={styles.dossierContextSubtitle}>
                                    Existing Document ID: <code>{dossierExistingId}</code>
                                  </p>
                                </div>
                                <button
                                  type="button"
                                  style={styles.circularDismissAction}
                                  onClick={onDismissServiceInspection}
                                >
                                  ×
                                </button>
                              </div>
                              <div style={styles.dossierScrollableContent}>
                                <div style={styles.sectionHeaderSeparator}>Core Metadata</div>
                                <div style={styles.attributeMatrixGrid}>
                                  <AttributeFieldBlock label="Service ID" value={dossierExistingId} />
                                  <AttributeFieldBlock label="Service Name" value={inspectedServiceDossier.service_name} />
                                  <AttributeFieldBlock label="Category" value={inspectedServiceDossier.category} />
                                  <AttributeFieldBlock label="Sub Category" value={inspectedServiceDossier.sub_category} />
                                  <AttributeFieldBlock label="Category Type" value={inspectedServiceDossier.category_type} />
                                  <AttributeFieldBlock label="Suggested Category" value={inspectedServiceDossier.suggest_category} />
                                  <AttributeFieldBlock label="Description" value={inspectedServiceDossier.description} spansFullWidth />
                                </div>
                                <div style={styles.sectionHeaderSeparator}>Provider & Geospatial</div>
                                <div style={styles.attributeMatrixGrid}>
                                  <AttributeFieldBlock label="Provider ID" value={inspectedServiceDossier.provider_id || inspectedServiceDossier.providerId || targetProviderId} />
                                  <AttributeFieldBlock label="Provider Name" value={inspectedServiceDossier.provider_name || activeProviderRecord?.name || activeProviderRecord?.username} />
                                  <AttributeFieldBlock label="Provider Email" value={inspectedServiceDossier.provider_email || activeProviderRecord?.email} />
                                  <AttributeFieldBlock label="Physical Address" value={inspectedServiceDossier.address} spansFullWidth />
                                  <AttributeFieldBlock label="Latitude" value={inspectedServiceDossier.latitude} />
                                  <AttributeFieldBlock label="Longitude" value={inspectedServiceDossier.longitude} />
                                </div>

                                <div style={styles.sectionHeaderSeparator}>Commercials & Schedule</div>
                                <div style={styles.attributeMatrixGrid}>
                                  <AttributeFieldBlock label="Base Price" value={`£${inspectedServiceDossier.price ?? 0}`} />
                                  <AttributeFieldBlock label="Discount" value={`${inspectedServiceDossier.discount ?? 0}%`} />
                                  <AttributeFieldBlock label="Duration (Hours)" value={inspectedServiceDossier.duration_hour} />
                                  <AttributeFieldBlock label="Duration (Minutes)" value={inspectedServiceDossier.duration_mins} />
                                </div>
                                <div style={styles.sectionHeaderSeparator}>Approval Audit State</div>
                                <div style={styles.attributeMatrixGrid}>
                                  <AttributeFieldBlock label="Approval Status" value={isDossierActionable ? "pending" : isDossierApproved ? "approved" : "rejected"} />
                                  <AttributeFieldBlock label="Lifecycle Status" value={isDossierActionable ? "pending" : isDossierApproved ? "approved" : "rejected"} />
                                  <AttributeFieldBlock label="Description Status" value={inspectedServiceDossier.description_status || (isDossierActionable ? "pending" : isDossierApproved ? "approved" : "rejected")} />
                                  <AttributeFieldBlock label="Media Status" value={inspectedServiceDossier.media_status || inspectedServiceDossier.media?.status || (isDossierActionable ? "pending" : isDossierApproved ? "approved" : "rejected")} />
                                  <AttributeFieldBlock label="Is Approved" value={isDossierApproved ? "true" : "false"} />
                                  <AttributeFieldBlock label="Is Active" value={inspectedServiceDossier.is_active ? "true" : "false"} />
                                  <AttributeFieldBlock label="Approval Reason" value={inspectedServiceDossier.approval_reason} />
                                  <AttributeFieldBlock label="Rejection Reason" value={inspectedServiceDossier.rejection_reason} />
                                  <AttributeFieldBlock label="Reviewed By" value={inspectedServiceDossier.reviewed_by} />
                                  <AttributeFieldBlock label="Reviewed At" value={inspectedServiceDossier.reviewed_at} />
                                </div>
                                <div style={styles.sectionHeaderSeparator}>
                                  Media Assets (Max 5 images active &bull; Direct CRM upload auto-approved)
                                </div>
                                <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "14px", flexWrap: "wrap" }}>
                                  <label
                                    style={{
                                      padding: "6px 12px",
                                      borderRadius: "6px",
                                      backgroundColor: "#2563EB",
                                      color: "#FFFFFF",
                                      fontSize: "12px",
                                      fontWeight: "600",
                                      cursor: "pointer",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: "4px",
                                    }}
                                    title="Add image or video directly to service gallery (Auto-Approved)"
                                  >
                                    📤 Upload New Image/Video
                                    <input
                                      type="file"
                                      accept="image/*,video/*"
                                      style={{ display: "none" }}
                                      onChange={(e) => {
                                        const file = e.target.files?.[0];
                                        if (file) {
                                          handleUploadMediaToService(inspectedServiceDossier, file);
                                          e.target.value = "";
                                        }
                                      }}
                                    />
                                  </label>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      filterStore.recycleBinTargetService = inspectedServiceDossier;
                                      triggerFastReRender();
                                    }}
                                    style={{
                                      padding: "6px 12px",
                                      borderRadius: "6px",
                                      backgroundColor: "#F8FAFC",
                                      color: "#334155",
                                      border: "1px solid #CBD5E1",
                                      fontSize: "12px",
                                      fontWeight: "600",
                                      cursor: "pointer",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: "4px",
                                    }}
                                  >
                                    🗑️ Open Recycle Bin ({Array.isArray(inspectedServiceDossier.recycle_bin) ? inspectedServiceDossier.recycle_bin.length : 0})
                                  </button>
                                </div>
                                <div style={{ marginTop: "10px" }}>
                                  <span style={styles.attributeDescriptorTag}>
                                    Gallery Images & Media (Limit: 5 images max)
                                  </span>
                                  <div style={styles.mediaAssetGrid}>
                                    {(() => {
                                      const dossierMediaList = extractAllMedia(inspectedServiceDossier);
                                      if (dossierMediaList.length === 0) {
                                        return <p style={styles.subduedTextToken}>No gallery images provided.</p>;
                                      }
                                      return dossierMediaList.map((mediaItem, index) => {
                                        const validSrc = typeof mediaItem === "string" ? mediaItem : mediaItem?.url || mediaItem?.file;
                                        const isVid = typeof mediaItem === "object" && mediaItem?.type === "video"
                                          ? true
                                          : (typeof validSrc === "string" && (validSrc.includes(".mp4") || validSrc.includes(".mov") || validSrc.includes(".webm") || validSrc.includes(".mkv") || validSrc.startsWith("data:video")));
                                        if (!validSrc) return null;
                                        return (
                                          <div
                                            key={index}
                                            style={{ display: "flex", flexDirection: "column", gap: "4px", position: "relative" }}
                                          >
                                            <div
                                              style={styles.mediaThumbnailFrame}
                                              onClick={() => onActivateMediaPreview(validSrc)}
                                            >
                                              {isVid ? (
                                                <video
                                                  src={validSrc}
                                                  muted
                                                  style={styles.mediaElementBitmap}
                                                />
                                              ) : (
                                                <img
                                                  src={validSrc}
                                                  alt={`Gallery asset ${index + 1}`}
                                                  style={styles.mediaElementBitmap}
                                                />
                                              )}
                                              <div style={styles.mediaHoverInteractionLayer}>
                                                🔍 Preview
                                              </div>
                                              {isVid && (
                                                <span style={{ position: "absolute", bottom: "3px", right: "3px", fontSize: "10px", backgroundColor: "rgba(0,0,0,0.7)", color: "#fff", padding: "1px 4px", borderRadius: "3px" }}>
                                                  🎬 Video
                                                </span>
                                              )}
                                            </div>
                                            <div style={{ display: "flex", gap: "4px" }}>
                                              <button
                                                type="button"
                                                onClick={() => onActivateMediaPreview(validSrc)}
                                                style={{
                                                  flex: 1,
                                                  padding: "4px 6px",
                                                  backgroundColor: "#2563EB",
                                                  color: "#FFF",
                                                  border: "none",
                                                  borderRadius: "4px",
                                                  fontSize: "11px",
                                                  fontWeight: "600",
                                                  cursor: "pointer",
                                                }}
                                              >
                                                👁 View
                                              </button>
                                              <button
                                                type="button"
                                                onClick={() => handleEditMediaItem(inspectedServiceDossier, mediaItem)}
                                                style={{
                                                  padding: "4px 8px",
                                                  backgroundColor: "#EFF6FF",
                                                  color: "#1D4ED8",
                                                  border: "1px solid #BFDBFE",
                                                  borderRadius: "4px",
                                                  fontSize: "11px",
                                                  fontWeight: "600",
                                                  cursor: "pointer",
                                                }}
                                                title="Edit this image's caption/label"
                                              >
                                                ✎ Edit
                                              </button>
                                              <button
                                                type="button"
                                                onClick={() => handleRemoveImageFromService(inspectedServiceDossier, mediaItem)}
                                                style={{
                                                  padding: "4px 8px",
                                                  backgroundColor: "#FEE2E2",
                                                  color: "#DC2626",
                                                  border: "1px solid #FCA5A5",
                                                  borderRadius: "4px",
                                                  fontSize: "11px",
                                                  fontWeight: "600",
                                                  cursor: "pointer",
                                                }}
                                                title="Move image to Recycle Bin"
                                              >
                                                🗑
                                              </button>
                                            </div>
                                          </div>
                                        );
                                      });
                                    })()}
                                  </div>
                                </div>
                              </div>
                              <div style={styles.dossierActionDock}>
                                {isDossierActionable ? (
                                  <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    <button
                                      type="button"
                                      style={{
                                        padding: "8px 18px",
                                        borderRadius: "8px",
                                        backgroundColor: "#16A34A",
                                        color: "#FFF",
                                        border: "none",
                                        fontSize: "13px",
                                        fontWeight: "600",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        recordServiceApprovalAccessLog({
                                          actionType: "INITIATE_DOSSIER_APPROVAL",
                                          actionLabel: "Initiated Approval via Dossier",
                                          serviceId: dossierExistingId,
                                          serviceName: inspectedServiceDossier.service_name,
                                          details: `Triggered approval action from detailed inspection modal for ID ${dossierExistingId}`,
                                        });
                                        setConfirmationModal({
                                          isOpen: true,
                                          type: "approve_service",
                                          step: "reason",
                                          target: {
                                            ...inspectedServiceDossier,
                                            id: dossierExistingId,
                                            service_id: dossierExistingId,
                                            providerId: inspectedServiceDossier.providerId || inspectedServiceDossier.provider_id || targetProviderId,
                                            uid: inspectedServiceDossier.uid || targetUserId,
                                            _categoryNotifPath: inspectedServiceDossier._categoryNotifPath,
                                          },
                                          reason: "",
                                        });
                                      }}
                                    >
                                      ✓ Approve Service & Images
                                    </button>
                                    <button
                                      type="button"
                                      style={{
                                        padding: "8px 18px",
                                        borderRadius: "8px",
                                        backgroundColor: "#DC2626",
                                        color: "#FFF",
                                        border: "none",
                                        fontSize: "13px",
                                        fontWeight: "600",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        recordServiceApprovalAccessLog({
                                          actionType: "INITIATE_DOSSIER_REJECTION",
                                          actionLabel: "Initiated Rejection via Dossier",
                                          serviceId: dossierExistingId,
                                          serviceName: inspectedServiceDossier.service_name,
                                          details: `Triggered rejection action from detailed inspection modal for ID ${dossierExistingId}`,
                                        });
                                        setConfirmationModal({
                                          isOpen: true,
                                          type: "reject_service",
                                          step: "reason",
                                          target: {
                                            ...inspectedServiceDossier,
                                            id: dossierExistingId,
                                            service_id: dossierExistingId,
                                            providerId: inspectedServiceDossier.providerId || inspectedServiceDossier.provider_id || targetProviderId,
                                            uid: inspectedServiceDossier.uid || targetUserId,
                                            _categoryNotifPath: inspectedServiceDossier._categoryNotifPath,
                                          },
                                          reason: "",
                                        });
                                      }}
                                    >
                                      ✕ Reject Service & Images
                                    </button>
                                  </div>
                                ) : (
                                  <div style={{ display: "flex", alignItems: "center" }}>
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: "700",
                                        padding: "6px 14px",
                                        borderRadius: "8px",
                                        backgroundColor: isDossierApproved ? "#DCFCE7" : "#FEE2E2",
                                        color: isDossierApproved ? "#15803D" : "#B91C1C",
                                        border: `1px solid ${isDossierApproved ? "#86EFAC" : "#FCA5A5"}`,
                                      }}
                                    >
                                      {isDossierApproved ? "✅ Service & Images Approved" : "❌ Service & Images Rejected"}
                                    </span>
                                  </div>
                                )}
                                <button
                                  type="button"
                                  style={styles.neutralDismissTrigger}
                                  onClick={onDismissServiceInspection}
                                >
                                  Close Dossier
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      })()}
                      {/* LIGHTBOX PREVIEW */}
                      {previewMediaTargetUrl && (
                        <div style={{ ...styles.lightboxPortalBackdrop, zIndex: 12800 }} onClick={onDismissMediaPreview}>
                          <div
                            style={styles.lightboxViewportFrame}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <button
                              type="button"
                              style={styles.lightboxExitTrigger}
                              onClick={onDismissMediaPreview}
                            >
                              &times;
                            </button>
                            {(() => {
                              const isVideo =
                                typeof previewMediaTargetUrl === "string" &&
                                (previewMediaTargetUrl.startsWith("data:video") ||
                                 previewMediaTargetUrl.includes(".mp4") ||
                                 previewMediaTargetUrl.includes(".mov") ||
                                 previewMediaTargetUrl.includes(".webm") ||
                                 previewMediaTargetUrl.includes(".mkv") ||
                                 previewMediaTargetUrl.includes("video"));
                              return isVideo ? (
                                <video
                                  src={previewMediaTargetUrl}
                                  controls
                                  autoPlay
                                  style={{ maxWidth: "85vw", maxHeight: "85vh", borderRadius: "10px", outline: "none", backgroundColor: "#000" }}
                                />
                              ) : (
                                <img
                                  src={previewMediaTargetUrl}
                                  alt="High-resolution preview"
                                  style={styles.lightboxMediaRenderer}
                                />
                              );
                            })()}
                          </div>
                        </div>
                      )}
                    </div>
                    {/* RIGHT SECTION */}
                    <div className="right-section" style={{ width: "320px", display: "flex", flexDirection: "column", gap: "16px" }}>
                      {/* Verification Timeline Card */}
                      <div
                        style={{
                          backgroundColor: "#FFFFFF",
                          borderRadius: "16px",
                          padding: "20px",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.03)",
                          border: "1px solid #E2E8F0",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "16px" }}>
                          <h3 style={{ margin: 0, fontSize: "15px", fontWeight: "700", color: "#1E293B" }}>
                            Verification Timeline
                          </h3>
                          <span style={{ fontSize: "11px", fontWeight: "600", color: "#0284C7", backgroundColor: "#E0F2FE", padding: "2px 8px", borderRadius: "12px" }}>
                            Audit Trail
                          </span>
                        </div>
                        <div style={{ position: "relative", paddingLeft: "18px" }}>
                          {Array.isArray(steps) && steps.length > 0 ? (
                            steps.map((step, i) => {
                              const status = verification?.[step.key]?.status || "pending";
                              const isCompleted = status === "completed" || status === "verified";
                              const isInProgress = status === "in-progress";
                              let dotBg = "#E2E8F0";
                              let dotBorder = "#CBD5E1";
                              let textColor = "#64748B";
                              if (isCompleted) {
                                dotBg = "#10B981";
                                dotBorder = "#059669";
                                textColor = "#0F172A";
                              } else if (isInProgress) {
                                dotBg = "#2563EB";
                                dotBorder = "#1D4ED8";
                                textColor = "#1E293B";
                              }
                              return (
                                <div
                                  key={step.key || i}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    position: "relative",
                                    marginBottom: i === steps.length - 1 ? 0 : 20,
                                  }}
                                >
                                  {i !== steps.length - 1 && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        left: "6px",
                                        top: "14px",
                                        width: "2px",
                                        height: "22px",
                                        backgroundColor: isCompleted ? "#A7F3D0" : "#E2E8F0",
                                        zIndex: 1,
                                      }}
                                    />
                                  )}
                                  <div
                                    style={{
                                      width: "14px",
                                      height: "14px",
                                      borderRadius: "50%",
                                      backgroundColor: dotBg,
                                      border: `2px solid ${dotBorder}`,
                                      zIndex: 2,
                                      boxShadow: isCompleted ? "0 0 0 3px #D1FAE5" : "none",
                                      transition: "all 0.2s",
                                    }}
                                  />
                                  <div style={{ marginLeft: "12px", display: "flex", justifyContent: "space-between", width: "100%" }}>
                                    <span style={{ fontSize: "13px", fontWeight: isCompleted ? "600" : "500", color: textColor }}>
                                      {step.title}
                                    </span>
                                    <span style={{ fontSize: "11px", color: isCompleted ? "#059669" : "#94A3B8" }}>
                                      {isCompleted ? "✓ Verified" : isInProgress ? "In Progress" : "Pending"}
                                    </span>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <p style={{ color: "#94A3B8", fontSize: "13px" }}>No timeline steps recorded</p>
                          )}
                        </div>
                      </div>
                      {/* Application Review Card */}
                      <div
                        style={{
                          backgroundColor: "#FFFFFF",
                          borderRadius: "16px",
                          padding: "20px",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                          border: "1px solid #E2E8F0",
                        }}
                      >
                        <h4 style={{ margin: "0 0 12px 0", fontSize: "14px", fontWeight: "700", color: "#1E293B" }}>
                          Application Review
                        </h4>
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
                            <button
                              type="button"
                              onClick={() =>
                                setConfirmationModal({
                                  isOpen: true,
                                  type: "approve_provider",
                                  target: activeProviderRecord,
                                  reason: "",
                                  step: "reason",
                                })
                              }
                              style={{
                                padding: "10px",
                                borderRadius: "8px",
                                backgroundColor: "#16A34A",
                                color: "#FFFFFF",
                                border: "none",
                                fontSize: "13px",
                                fontWeight: "600",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "6px",
                                boxShadow: "0 2px 4px rgba(22,163,74,0.2)",
                              }}
                            >
                              ✓ Approve
                            </button>
                            <button
                              type="button"
                              onClick={() =>
                                setConfirmationModal({
                                  isOpen: true,
                                  type: "reject_provider",
                                  target: activeProviderRecord,
                                  reason: "",
                                  step: "reason",
                                })
                              }
                              style={{
                                padding: "10px",
                                borderRadius: "8px",
                                backgroundColor: "#DC2626",
                                color: "#FFFFFF",
                                border: "none",
                                fontSize: "13px",
                                fontWeight: "600",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "6px",
                                boxShadow: "0 2px 4px rgba(220,38,38,0.2)",
                              }}
                            >
                              ✕ Reject
                            </button>
                          </div>
                          <button
                            type="button"
                            onClick={handleContactProvider}
                            style={{
                              width: "100%",
                              padding: "9px 12px",
                              borderRadius: "8px",
                              backgroundColor: "#EFF6FF",
                              color: "#1D4ED8",
                              border: "1px solid #BFDBFE",
                              fontSize: "13px",
                              fontWeight: "600",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "6px",
                            }}
                          >
                            📞 Contact Provider
                          </button>
                          <button
                            type="button"
                            onClick={handleExportProfile}
                            style={{
                              width: "100%",
                              padding: "9px 12px",
                              borderRadius: "8px",
                              backgroundColor: "#F8FAFC",
                              color: "#475569",
                              border: "1px solid #E2E8F0",
                              fontSize: "13px",
                              fontWeight: "600",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "6px",
                            }}
                          >
                            ⬇ Export Profile
                          </button>
                        </div>
                      </div>
                      {/* Lifecycle Operations Card */}
                      <div
                        style={{
                          backgroundColor: "#FFFFFF",
                          borderRadius: "16px",
                          padding: "20px",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                          border: "1px solid #E2E8F0",
                        }}
                      >
                        <h4 style={{ margin: "0 0 12px 0", fontSize: "14px", fontWeight: "700", color: "#1E293B" }}>
                          Lifecycle Operations
                        </h4>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
                          <button
                            type="button"
                            onClick={() => updateProviderVerificationStatus("authorized", activeProviderRecord?.name, notes)}
                            style={{
                              padding: "8px 10px",
                              borderRadius: "8px",
                              border: "1px solid #CBD5E1",
                              backgroundColor: "#F1F5F9",
                              color: "#334155",
                              fontSize: "12px",
                              fontWeight: "600",
                              cursor: "pointer",
                            }}
                          >
                            Authorize
                          </button>
                          <button
                            type="button"
                            onClick={() => updateProviderVerificationStatus("activated", activeProviderRecord?.name, notes)}
                            style={{
                              padding: "8px 10px",
                              borderRadius: "8px",
                              border: "1px solid #BBF7D0",
                              backgroundColor: "#DCFCE7",
                              color: "#15803D",
                              fontSize: "12px",
                              fontWeight: "600",
                              cursor: "pointer",
                            }}
                          >
                            Activate
                          </button>
                          <button
                            type="button"
                            onClick={() => updateProviderVerificationStatus("rejected", activeProviderRecord?.name, notes)}
                            style={{
                              padding: "8px 10px",
                              borderRadius: "8px",
                              border: "1px solid #FECACA",
                              backgroundColor: "#FEE2E2",
                              color: "#B91C1C",
                              fontSize: "12px",
                              fontWeight: "600",
                              cursor: "pointer",
                            }}
                          >
                            Reject
                          </button>
                          <button
                            type="button"
                            onClick={() => updateProviderVerificationStatus("authorization_complete", activeProviderRecord?.name, notes)}
                            style={{
                              padding: "8px 10px",
                              borderRadius: "8px",
                              border: "1px solid #BFDBFE",
                              backgroundColor: "#DBEAFE",
                              color: "#1E40AF",
                              fontSize: "12px",
                              fontWeight: "600",
                              cursor: "pointer",
                            }}
                          >
                            Complete
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <p className="card-details">Click a notification to view profile</p>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  })()}


{/* ✅ PROVIDER BONUS */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "providerBonus" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Provider Bonus</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
      {/* Title Section */}
    <div
      className="category-title-container"
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        marginBottom: "20px",
        textAlign: "center",
      }}
    >
      <h3
        style={{
          margin: 0,
          fontFamily: "'Poppins', sans-serif",
          fontSize: "24px",
          fontWeight: "700",
          color: "#111827",
        }}
      >
        🎉 Partner Referral Bonus
      </h3>
    </div>
    {/* Referral Form Section */}
    <div
      className="category-form-container"
      style={{
        backgroundColor: "#fff",
        padding: "30px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        marginBottom: "20px",
      }}
    >
      {/* Referral Code Input */}
      <div className="form-group mb-3">
        <label
          htmlFor="referralInput"
          style={{
            fontFamily: "'Inter', sans-serif",
            fontWeight: "500",
            color: "#374151",
            marginBottom: "6px",
            display: "block",
          }}
        >
          Referral Code (from another partner):
        </label>
        <input
          type="text"
          id="referralInput"
          className="form-control"
          value={enteredReferralCode}
          onChange={(e) => setEnteredReferralCode(e.target.value)}
          placeholder="Enter referral code"
          style={{
            width: "100%",
            padding: "12px",
            borderRadius: "8px",
            border: "1px solid #D1D5DB",
            fontFamily: "'Inter', sans-serif",
            outline: "none",
            transition: "all 0.2s",
          }}
        />
      </div>
      {/* Action Buttons */}
      <div className="d-flex flex-wrap gap-2 mb-3">
        <button
          onClick={() => applyReferralBonusForPartner(enteredReferralCode)}
          style={{
            backgroundColor: "#2563eb",
            color: "#fff",
            padding: "12px 24px",
            borderRadius: "8px",
            fontFamily: "'Inter', sans-serif",
            fontWeight: "600",
            cursor: "pointer",
            transition: "all 0.2s",
          }}
        >
          🎁 Apply Referral Bonus
        </button>
        <button
          onClick={resetWalletAndReferralForPartners}
          style={{
            backgroundColor: "#dc2626",
            color: "#fff",
            padding: "12px 24px",
            borderRadius: "8px",
            fontFamily: "'Inter', sans-serif",
            fontWeight: "600",
            cursor: "pointer",
            transition: "all 0.2s",
          }}
        >
          🔄 Reset Wallets for All Partners
        </button>
       <button
  onClick={() => {
    // hide provider bonus form
    setShowProviderBonus(false);
    // show partner list
    setShowPartnerList(true);
    // navigate to partner list section
    setActiveButton("partnerList");
    setCurrentView("partnerList");
  }}
  style={{
    backgroundColor: "#2563eb",
    color: "#fff",
    padding: "12px 16px",
    borderRadius: "8px",
    fontFamily: "'Inter', sans-serif",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s",
  }}
>
  👥
</button>
      </div>
      <div
        className="small text-muted"
        style={{ fontFamily: "'Inter', sans-serif", color: "#6B7280" }}
      >
        * New partners earn ₹100, referrers get ₹100 after successful onboarding.
      </div>
    </div>
    </div>
  </div>
)}
{/* ✅ CUSTOMER BONUS */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "customerBonus" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Customer Bonus</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
       {/* Title Section */}
    <div
      className="category-title-container"
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        marginBottom: "20px",
        textAlign: "center",
      }}
    >
      <h3
        style={{
          margin: 0,
          fontFamily: "'Poppins', sans-serif",
          fontSize: "24px",
          fontWeight: "700",
          color: "#111827",
        }}
      >
        🎁 Customer Referral Bonus Panel
      </h3>
    </div>
    {/* Referral Form Section */}
    <div
      className="category-form-container"
      style={{
        backgroundColor: "#fff",
        padding: "30px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        marginBottom: "20px",
      }}
    >
      {/* Apply Bonus by Referral Code */}
      <div className="form-group mb-3">
        <label
          htmlFor="customerReferralInput"
          style={{
            fontFamily: "'Inter', sans-serif",
            fontWeight: "500",
            color: "#374151",
            marginBottom: "6px",
            display: "block",
          }}
        >
          Referral Code (from another customer):
        </label>
        <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
          <input
            type="text"
            id="customerReferralInput"
            className="form-control"
            placeholder="Enter Referral Code"
            value={referralCode}
            onChange={(e) => setReferralCode(e.target.value.toUpperCase())}
            style={{
              flex: 1,
              padding: "12px",
              borderRadius: "8px",
              border: "1px solid #D1D5DB",
              fontFamily: "'Inter', sans-serif",
              outline: "none",
            }}
          />
          <button
            onClick={async () => {
              try {
                if (!referralCode.trim()) {
                  toast.error("❌ Please enter a referral code.");
                  return;
                }
                const q = query(
                  collection(db, "customers"),
                  where("myReferralCode", "==", referralCode.trim()),
                  limit(1)
                );
                const snapshot = await getDocs(q);
                if (snapshot.empty) {
                  toast.error("❌ No customer found with this referral code.");
                  return;
                }
                const customerDoc = snapshot.docs[0];
                const customerId = customerDoc.id;
                await applyReferralBonusFor(customerId);
                toast.success("✅ Bonus applied successfully!");
              } catch (error) {
                console.error("❌ Error applying bonus:", error);
                toast.error("❌ Something went wrong.");
              }
            }}
            style={{
              backgroundColor: "#2563eb",
              color: "#fff",
              padding: "12px 24px",
              borderRadius: "8px",
              fontFamily: "'Inter', sans-serif",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
          >
            🎁 Apply Bonus by Code
          </button>
        </div>
      </div>
      {/* Action Buttons */}
      <div className="d-flex flex-wrap gap-2 mb-3">
        <button
          onClick={() => resetAllCustomerWalletsAndReferrals(setLocalCustomers)}
          style={{
            backgroundColor: "#e63946",
            color: "#fff",
            padding: "12px 24px",
            borderRadius: "8px",
            fontFamily: "'Inter', sans-serif",
            fontWeight: "600",
            cursor: "pointer",
            transition: "all 0.2s",
          }}
        >
          🔁 Reset Wallet & Referral (Only Eligible Customers)
        </button>
        <button
          onClick={uploadCustomerReferralList}
          style={{
            backgroundColor: "#2563eb",
            color: "#fff",
            padding: "12px 24px",
            borderRadius: "8px",
            fontFamily: "'Inter', sans-serif",
            fontWeight: "600",
            cursor: "pointer",
            transition: "all 0.2s",
          }}
        >
          📤 Upload Full Referral List
        </button>
        <button
  onClick={() => {
    // hide customer bonus form
    setShowCustomerBonus(false);
    // toggle / hide customers section
    toggleCustomers();
    // navigate to customers section
    setActiveButton("customers");
    setCurrentView("customers");
  }}
  style={{
    backgroundColor: "#6b7280",
    color: "#fff",
    padding: "12px 24px",
    borderRadius: "8px",
    fontFamily: "'Inter', sans-serif",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s",
  }}
>
  👥 Customers
</button>
      </div>
      {/* Info Note */}
      <div
        className="small text-muted"
        style={{ fontFamily: "'Inter', sans-serif", color: "#6B7280" }}
      >
        Referred users get ₹100 bonus. Referrers receive ₹50 after successful job.
      </div>
    </div>
    </div>
  </div>
)}
{/* ✅ SEND NOTIFICATION */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "sendNotification" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Send Notification</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
       {/* Title Section */}
    <div
      className="category-title-container"
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        marginBottom: "20px",
        textAlign: "center",
      }}
    >
      <h3
        style={{
          margin: 0,
          fontFamily: "'Poppins', sans-serif",
          fontSize: "24px",
          fontWeight: "700",
          color: "#111827",
        }}
      >
        📣 Push Notification
      </h3>
    </div>
    {/* Form Section */}
    <div
      className="category-form-container"
      style={{
        backgroundColor: "#fff",
        padding: "30px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        marginBottom: "20px",
      }}
    >
      <form onSubmit={onNotificationSubmit} style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        {/* Notification Title */}
        <div className="form-group">
          <label
            style={{
              fontFamily: "'Inter', sans-serif",
              fontWeight: "500",
              color: "#374151",
              marginBottom: "6px",
              display: "block",
            }}
          >
            Notification Title
          </label>
          <input
            type="text"
            name="notifTitle"
            value={notificationForm.notifTitle}
            onChange={onFieldUpdate}
            placeholder="Enter Notification Title"
            required
            style={{
              width: "100%",
              padding: "12px",
              borderRadius: "8px",
              border: "1px solid #D1D5DB",
              fontFamily: "'Inter', sans-serif",
              outline: "none",
              transition: "all 0.2s",
            }}
          />
        </div>
        {/* Notification Message */}
        <div className="form-group">
          <label
            style={{
              fontFamily: "'Inter', sans-serif",
              fontWeight: "500",
              color: "#374151",
              marginBottom: "6px",
              display: "block",
            }}
          >
            Notification Message
          </label>
          <input
            type="text"
            name="notifMessage"
            value={notificationForm.notifMessage}
            onChange={onFieldUpdate}
            placeholder="Enter Notification Message"
            required
            style={{
              width: "100%",
              padding: "12px",
              borderRadius: "8px",
              border: "1px solid #D1D5DB",
              fontFamily: "'Inter', sans-serif",
              outline: "none",
              transition: "all 0.2s",
            }}
          />
        </div>
        {/* Notification Image URL */}
        <div className="form-group">
          <label
            style={{
              fontFamily: "'Inter', sans-serif",
              fontWeight: "500",
              color: "#374151",
              marginBottom: "6px",
              display: "block",
            }}
          >
            Notification Image URL (Optional)
          </label>
          <input
            type="url"
            name="notifImageUrl"
            value={notificationForm.notifImageUrl}
            onChange={onFieldUpdate}
            placeholder="Enter Image URL"
            style={{
              width: "100%",
              padding: "12px",
              borderRadius: "8px",
              border: "1px solid #D1D5DB",
              fontFamily: "'Inter', sans-serif",
              outline: "none",
              transition: "all 0.2s",
            }}
          />
        </div>
        {/* User Type Dropdown */}
        <div className="form-group">
          <label
            style={{
              fontFamily: "'Inter', sans-serif",
              fontWeight: "500",
              color: "#374151",
              marginBottom: "6px",
              display: "block",
            }}
          >
            Send User Type
          </label>
          <select
            name="userCategory"
            value={notificationForm.userCategory}
            onChange={onFieldUpdate}
            required
            style={{
              width: "100%",
              padding: "12px",
              borderRadius: "8px",
              border: "1px solid #D1D5DB",
              fontFamily: "'Inter', sans-serif",
              outline: "none",
              transition: "all 0.2s",
            }}
          >
            <option value="">-- Select User Type --</option>
            <option value="Customer">Customer</option>
            <option value="Partner">Partner</option>
          </select>
        </div>
   {/* Submit & Cancel Buttons */}
<div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    gap: "20px", // space between buttons
    marginTop: "10px",
  }}
>
  <button
    type="submit"
    style={{
      backgroundColor: "#4F46E5",
      color: "#fff",
      padding: "12px 24px",
      borderRadius: "8px",
      fontFamily: "'Inter', sans-serif",
      fontWeight: "600",
      cursor: "pointer",
      transition: "all 0.2s",
    }}
  >
    Send Notification
  </button>
  <button
    type="button"
    onClick={() => setShowSendNotification(false)}
    style={{
      backgroundColor: "#6b7280",
      color: "#fff",
      padding: "12px 24px",
      borderRadius: "8px",
      fontFamily: "'Inter', sans-serif",
      fontWeight: "600",
      cursor: "pointer",
      transition: "all 0.2s",
    }}
  >
    Cancel
  </button>
</div>
  </form>
    </div>
    </div>
  </div>
)}
 {/* ✅ AUTO-ASSIGN PROVIDERS */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "autoAssignProviders" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Auto-Assign Providers</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
       {/* Title Section */}
    <div
      className="category-title-container"
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        marginBottom: "20px",
        textAlign: "center",
      }}
    >
      <h3
        style={{
          margin: 0,
          fontFamily: "'Poppins', sans-serif",
          fontSize: "24px",
          fontWeight: "700",
          color: "#111827",
        }}
      >
        Automatch Providers
      </h3>
    </div>
    {/* Tabs & Content Section */}
    <div
      className="category-form-container"
      style={{
        backgroundColor: "#fff",
        padding: "30px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        marginBottom: "20px",
      }}
    >
      {/* Tab Buttons */}
      <div
        style={{
          display: "flex",
          gap: "12px",
          marginBottom: "20px",
          flexWrap: "wrap",
        }}
      >
        {["technician", "task", "matched", "requests", "jobs", "jobPortal"].map(
          (tab) => (
            <button
              key={tab}
              onClick={() => setCurrentTab(tab)}
              style={getButtonStyle(currentTab === tab, {
                technician: "#2563EB",
                task: "#EF4444",
                matched: "#4F46E5",
                requests: "#8B5CF6",
                jobs: "#FBBF24",
                jobPortal: "#10B981",
              }[tab])}
            >
              {tab === "technician"
                ? "Add Technician"
                : tab === "task"
                ? "Add Task"
                : tab === "matched"
                ? "Matched Providers"
                : tab === "requests"
                ? "Requests"
                : tab === "jobs"
                ? "Jobs"
                : "Job Portal"}
            </button>
          )
        )}
      </div>
      {/* ================== Technician Form ================== */}
      {currentTab === "technician" && (
        <form onSubmit={addTechnician} style={formStyle}>
          <input
            placeholder="Full Name"
            value={techForm.fullname}
            onChange={(e) =>
              setTechForm({ ...techForm, fullname: e.target.value })
            }
            style={inputStyle}
            required
          />
          <select
            value={techForm.specialty}
            onChange={(e) =>
              setTechForm({ ...techForm, specialty: e.target.value })
            }
            style={inputStyle}
            required
          >
            <option value="">Select Specialty</option>
            {SERVICE_CATEGORIES.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "14px", marginBottom: "8px" }}>
              Notification Radius: {techForm.radius} mi
            </div>
            <input
              type="range"
              min={1}
              max={50}
              value={techForm.radius}
              onChange={(e) =>
                setTechForm({ ...techForm, radius: parseInt(e.target.value) })
              }
              style={{ width: "100%" }}
            />
          </div>
          <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type="checkbox"
              checked={techForm.active}
              onChange={(e) =>
                setTechForm({ ...techForm, active: e.target.checked })
              }
            />{" "}
            Active Technician
          </label>
          <button type="submit" style={submitBtn("#4F46E5")}>
            Save Technician
          </button>
        </form>
      )}
      {/* ================== Task Form ================== */}
      {currentTab === "task" && (
        <form onSubmit={addTask} style={formStyle}>
          <select
            value={taskForm.service}
            onChange={(e) =>
              setTaskForm({ ...taskForm, service: e.target.value })
            }
            style={inputStyle}
            required
          >
            <option value="">Select Service</option>
            {SERVICE_CATEGORIES.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
          <input
            placeholder="Location"
            value={taskForm.site}
            onChange={(e) => setTaskForm({ ...taskForm, site: e.target.value })}
            style={inputStyle}
            required
          />
          <input
            type="number"
            placeholder="Cost (£)"
            value={taskForm.cost}
            onChange={(e) => setTaskForm({ ...taskForm, cost: e.target.value })}
            style={inputStyle}
            required
          />
          <input
            type="number"
            placeholder="Coverage (mi)"
            min={0}
            max={50}
            value={taskForm.coverage}
            onChange={(e) =>
              setTaskForm({ ...taskForm, coverage: e.target.value })
            }
            style={inputStyle}
            required
          />
          <button type="submit" style={submitBtn("#10B981")}>
            Post Task
          </button>
        </form>
      )}
      {/* ================== Matched Providers ================== */}
      {currentTab === "matched" && (
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {tasks.length === 0 ? (
            <div style={emptyBox}>No tasks posted yet.</div>
          ) : (
            tasks.map((task) => {
              const matchedTechs = technicians.filter(
                (t) =>
                  t.active &&
                  t.specialty.toLowerCase() === task.service.toLowerCase() &&
                  t.radius >= task.coverage
              );
              return (
                <div key={task.id} style={cardStyle}>
                  <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                    {task.service} at {task.site} • £{task.cost}
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      marginBottom: "12px",
                      color: "#6B7280",
                    }}
                  >
                    Coverage Required: {task.coverage} mi
                  </div>
                  {matchedTechs.length === 0 ? (
                    <div style={{ fontStyle: "italic", color: "#9CA3AF" }}>
                      No matched providers found.
                    </div>
                  ) : (
                    matchedTechs.map((tech) => (
                      <div key={tech.id} style={matchItem}>
                        <div>
                          <div style={{ fontWeight: "600" }}>
                            {tech.fullname}
                          </div>
                          <div style={{ fontSize: "14px", color: "#6B7280" }}>
                            Specialty: {tech.specialty} • Radius: {tech.radius}{" "}
                            mi
                          </div>
                        </div>
                        <button
                          style={submitBtn("#4F46E5")}
                          onClick={() => handleBookNow(tech, task)}
                        >
                          Book
                        </button>
                      </div>
                    ))
                  )}
                </div>
              );
            })
          )}
        </div>
      )}
      {/* ================== Jobs ================== */}
      {currentTab === "jobs" && (
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {/* Add Job Form */}
          <form onSubmit={addJob} style={{ ...formStyle, marginBottom: "20px" }}>
            <h4>Add New Job</h4>
            <select
              value={jobForm.service}
              onChange={(e) => setJobForm({ ...jobForm, service: e.target.value })}
              style={inputStyle}
              required
            >
              <option value="">Select Service</option>
              {[
                "Plumbing",
                "Cleaning",
                "Electrician",
                "Carpentry",
                "Painting",
                "Lawn Mowing",
                "Pest Control",
                "Moving / Hauling",
                "Handyman",
                "Appliance Repair",
              ].map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
            <input
              placeholder="Location"
              value={jobForm.location}
              onChange={(e) =>
                setJobForm({ ...jobForm, location: e.target.value })
              }
              style={inputStyle}
              required
            />
            <input
              type="number"
              placeholder="Distance (miles)"
              value={jobForm.distance}
              onChange={(e) =>
                setJobForm({ ...jobForm, distance: e.target.value })
              }
              style={inputStyle}
              required
            />
            <input
              type="number"
              placeholder="Cost (£)"
              value={jobForm.cost}
              onChange={(e) => setJobForm({ ...jobForm, cost: e.target.value })}
              style={inputStyle}
              required
            />
            <textarea
              placeholder="Job Description"
              value={jobForm.description}
              onChange={(e) =>
                setJobForm({ ...jobForm, description: e.target.value })
              }
              style={{ ...inputStyle, height: "60px" }}
            />
            <button type="submit" style={submitBtn("#10B981")}>
              Add Job
            </button>
          </form>
          {/* Jobs List */}
          {jobs.length === 0 ? (
            <div style={emptyBox}>No jobs available. Add one above!</div>
          ) : (
            jobs.map((job) => {
              const matchedTechs = technicians.filter(
                (t) =>
                  t.active &&
                  t.specialty.toLowerCase() === job.service.toLowerCase()
              );
              return (
                <div key={job.id} style={cardStyle}>
                  <h4>{job.service}</h4>
                  <div>
                    {job.location} • {job.distance} miles • £{job.cost}
                  </div>
                  {job.description && <p>{job.description}</p>}
                  {matchedTechs.length === 0 ? (
                    <div style={{ fontStyle: "italic", color: "#9CA3AF" }}>
                      No matched providers found for this job.
                    </div>
                  ) : (
                    matchedTechs.map((tech) => (
                      <div key={tech.id} style={matchItem}>
                        <div>
                          <div style={{ fontWeight: "600" }}>
                            {tech.fullname}
                          </div>
                          <div style={{ fontSize: "14px", color: "#6B7280" }}>
                            Specialty: {tech.specialty} • Radius: {tech.radius}{" "}
                            mi
                          </div>
                        </div>
                        <button
                          style={submitBtn("#4F46E5")}
                          onClick={() => handleBookNow(tech, job)}
                        >
                          Book
                        </button>
                      </div>
                    ))
                  )}
                  <button
                    style={{ ...submitBtn("#2563EB"), marginTop: "10px" }}
                    onClick={() => alert(`Accepted job: ${job.service}`)}
                  >
                    Accept Job
                  </button>
                </div>
              );
            })
          )}
          {/* Profile Visibility & Notification Range */}
          <div style={cardStyle}>
            <h4>Make my profile visible</h4>
            <label
              style={{ display: "flex", gap: "10px", alignItems: "center" }}
            >
              <input
                type="checkbox"
                checked={profileVisible}
                onChange={() => setProfileVisible(!profileVisible)}
              />{" "}
              Visible
            </label>
            {profileVisible && (
              <p>✅ Your profile is now visible. Customers can find you.</p>
            )}
          </div>
          <div style={cardStyle}>
            <h4>Job Notification Range</h4>
            <input
              type="range"
              min={1}
              max={50}
              value={jobRange}
              onChange={(e) => setJobRange(e.target.value)}
              style={{ width: "100%" }}
            />
            <p>{jobRange} miles</p>
            <button
              style={submitBtn("#2563EB")}
              onClick={() => {
                localStorage.setItem("jobRange", jobRange);
                toast.success("✅ Job notification range saved!");
              }}
            >
              Save
            </button>
          </div>
        </div>
      )}
      {/* ================== Requests ================== */}
      {currentTab === "requests" && (
        <div>
          {!requestSaved ? (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                const request = {
                  name: e.target[0].value,
                  contact: e.target[1].value,
                  service: e.target[2].value,
                  notes: e.target[3].value,
                };
                saveRequest(request);
              }}
              style={formStyle}
            >
              <input placeholder="Name" style={inputStyle} required />
              <input placeholder="Phone / Email" style={inputStyle} required />
              <select style={inputStyle} required>
                <option value="">Select Service</option>
                {SERVICE_CATEGORIES.map((s) => (
                  <option key={s}>{s}</option>
                ))}
              </select>
              <textarea
                placeholder="Notes"
                style={{ ...inputStyle, height: "80px" }}
              />
              <button type="submit" style={submitBtn("#10B981")}>
                Submit Request
              </button>
            </form>
          ) : (
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: "18px", marginBottom: "20px" }}>
                ✅ Request Saved! We'll notify you when providers are available.
              </div>
              <button
                onClick={() => setShowMatches(true)}
                style={submitBtn("#2563EB")}
              >
                See Matches
              </button>
            </div>
          )}
          {showMatches && (
            <div style={{ marginTop: "20px" }}>
              <h4 style={{ marginBottom: "10px" }}>Best Matches for You</h4>
              {jobs.length === 0 ? (
                <div style={emptyBox}>No jobs posted yet.</div>
              ) : (
                jobs.map((job) => {
                  const matchedTechs = technicians.filter(
                    (t) =>
                      t.active &&
                      t.specialty.toLowerCase() === job.service.toLowerCase()
                  );
                  return (
                    <div key={job.id} style={cardStyle}>
                      <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                        {job.service} at {job.location} • £{job.cost}
                      </div>
                      <div
                        style={{
                          fontSize: "14px",
                          marginBottom: "12px",
                          color: "#6B7280",
                        }}
                      >
                        Coverage Required: {job.distance} mi
                      </div>
                      {matchedTechs.length === 0 ? (
                        <div style={{ fontStyle: "italic", color: "#9CA3AF" }}>
                          No matched providers found for this job.
                        </div>
                      ) : (
                        matchedTechs.map((tech) => (
                          <div key={tech.id} style={matchItem}>
                            <div>
                              <div style={{ fontWeight: "600" }}>
                                {tech.fullname}
                              </div>
                              <div
                                style={{ fontSize: "14px", color: "#6B7280" }}
                              >
                                Specialty: {tech.specialty} • Radius:{" "}
                                {tech.radius} mi
                              </div>
                            </div>
                            <button
                              style={submitBtn("#4F46E5")}
                              onClick={() => handleBookNow(tech, job)}
                            >
                              Book
                            </button>
                          </div>
                        ))
                      )}
                    </div>
                  );
                })
              )}
            </div>
          )}
        </div>
      )}
      {/* ================== Job Portal ================== */}
      {currentTab === "jobPortal" && (
        <>
          {!user ? (
            <div style={{ textAlign: "center", padding: 20 }}>Loading user data...</div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              <div
                style={{
                  backgroundColor: "#fff",
                  padding: "20px",
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <h3>Jobs Portal</h3>
                  <p style={{ color: "#6B7280" }}>
                    Use tokens to apply to jobs. Watch ads to earn tokens.
                  </p>
                </div>
                <div style={{ textAlign: "right", display: "flex", gap: "10px", alignItems: "center" }}>
                  <div>
                    <p style={{ fontSize: 12, color: "#6B7280", margin: 0 }}>Wallet</p>
                    <h4 style={{ margin: "4px 0" }}>{tokenWallet} Tokens</h4>
                  </div>
                  {/* Watch Ad Button */}
                  <button
                    style={{
                      backgroundColor: "#10B981",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "8px 16px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                    onClick={() => {
                      const randomAd = YT_ADS[Math.floor(Math.random() * YT_ADS.length)];
                      setCurrentAdVideo(randomAd);
                      setIsAdPlaying(true);
                    }}
                    disabled={isAdPlaying}
                  >
                    <FaPlay /> {isAdPlaying ? "Playing Ad..." : "Watch Ad (+10)"}
                  </button>
                  {/* Deduct Button */}
                  <button
                    style={{
                      backgroundColor: "#EF4444",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "8px 16px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                    onClick={() => {
                      setTokenWallet(prev => {
                        const updated = Math.max(prev - 5, 0);
                        localStorage.setItem("walletTokens", updated);
                        return updated;
                      });
                    }}
                  >
                    <FaMinusCircle /> Deduct (-5)
                  </button>
                </div>
              </div>
              {/* ---------------- Ad Modal ---------------- */}
              {isAdPlaying && currentAdVideo && (
                <div style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0,0,0,0.6)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 9999,
                }}>
                  <YouTube
                    videoId={currentAdVideo}
                    opts={{ width: "800", height: "450", playerVars: { autoplay: 1, controls: 1 } }}
                    onEnd={async () => {
                      setIsAdPlaying(false);
                      setCurrentAdVideo(null);
                      await addTokensToUser(null, null, user.uid, 10, setTokenWallet);
                    }}
                  />
                  <button
                    style={{
                      position: "absolute",
                      top: 20,
                      right: 20,
                      backgroundColor: "#EF4444",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "8px 12px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setIsAdPlaying(false);
                      setCurrentAdVideo(null);
                    }}
                  >
                    Close
                  </button>
                </div>
              )}
              {/* ---------------- Post Job Form ---------------- */}
              <form
                onSubmit={async (e) => {
                  e.preventDefault();
                  try {
                    const { jobId } = await addJobPost(newJob, user.uid);
                    setJobPosts(prev => [...prev, { id: jobId, ...newJob, appliedUsers: [], quickBookedBy: null }]);
                    setNewJob({ category: "", location: "", distance: "", cost: "", description: "" });
                    toast.success("Job posted successfully!");
                  } catch (err) {
                    toast.error("Failed to post job.");
                    console.error(err);
                  }
                }}
                style={{
                  backgroundColor: "#fff",
                  padding: "20px",
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                <h4>Post New Job</h4>
                <select
                  value={newJob.category}
                  onChange={e => setNewJob({ ...newJob, category: e.target.value })}
                  style={{ padding: "8px", borderRadius: "6px", border: "1px solid #D1D5DB" }}
                  required
                >
                  <option value="">Select Category</option>
                  {WORK_CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
                <input
                  placeholder="Location"
                  value={newJob.location}
                  onChange={e => setNewJob({ ...newJob, location: e.target.value })}
                  style={{ padding: "8px", borderRadius: "6px", border: "1px solid #D1D5DB" }}
                  required
                />
                <input
                  type="number"
                  placeholder="Distance (miles)"
                  value={newJob.distance}
                  onChange={e => setNewJob({ ...newJob, distance: e.target.value })}
                  style={{ padding: "8px", borderRadius: "6px", border: "1px solid #D1D5DB" }}
                  required
                />
                <input
                  type="number"
                  placeholder="Cost (Tokens)"
                  value={newJob.cost}
                  onChange={e => setNewJob({ ...newJob, cost: e.target.value })}
                  style={{ padding: "8px", borderRadius: "6px", border: "1px solid #D1D5DB" }}
                  required
                />
                <textarea
                  placeholder="Description"
                  value={newJob.description}
                  onChange={e => setNewJob({ ...newJob, description: e.target.value })}
                  style={{ padding: "8px", borderRadius: "6px", border: "1px solid #D1D5DB", height: "60px" }}
                />
                <button
                  type="submit"
                  style={{ backgroundColor: "#4F46E5", color: "#fff", border: "none", borderRadius: "8px", padding: "10px 16px", cursor: "pointer" }}
                >
                  Post Job
                </button>
              </form>
              {/* ---------------- Job List ---------------- */}
              {jobPosts.length === 0 ? (
                <div style={{ backgroundColor: "#F3F4F6", padding: "20px", borderRadius: "12px", textAlign: "center", color: "#6B7280" }}>
                  No jobs available.
                </div>
              ) : (
                jobPosts.map(job => {
                  const matchingWorkers = findMatchingTechs(job);
                  const canAfford = tokenWallet >= Number(job.cost);
                  const alreadyApplied = job.appliedUsers?.includes(user.uid) || appliedJobIds.includes(job.id);
                  return (
                    <div key={job.id} style={{
                      backgroundColor: "#fff",
                      padding: "20px",
                      borderRadius: "12px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      gap: "12px",
                      flexWrap: "wrap"
                    }}>
                      <div>
                        <h4>{job.category}</h4>
                        <p style={{ color: "#6B7280" }}>{job.location} • {job.distance} miles • {job.cost} Tokens</p>
                        {job.description && <p>{job.description}</p>}
                        <p style={{ fontStyle: "italic", color: "#6B7280" }}>
                          Quick Booked By: {job.quickBookedBy || "Job Booking completed"}
                        </p>
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        {/* Apply Button */}
                        <button
                          style={{
                            backgroundColor: alreadyApplied ? "#9CA3AF" : "#4F46E5",
                            color: "#fff",
                            border: "none",
                            borderRadius: "8px",
                            padding: "8px 12px",
                            cursor: alreadyApplied ? "default" : "pointer"
                          }}
                          onClick={async () => {
                            if (!alreadyApplied && canAfford) {
                              await applyToJob("JobPortalRoot", job.id, user.uid, job.cost, setTokenWallet);
                              setAppliedJobIds(prev => [...prev, job.id]);
                              toast.success("Applied successfully!");
                            } else if (!canAfford) {
                              toast.info("Not enough tokens.");
                            }
                          }}
                          disabled={alreadyApplied}
                        >
                          {alreadyApplied ? "Applied" : "Apply (Pay Tokens)"}
                        </button>
                        {/* Watch Ad to Earn Tokens */}
                        {!canAfford && (
                          <button
                            style={{
                              backgroundColor: "#F59E0B",
                              color: "#fff",
                              border: "none",
                              borderRadius: "8px",
                              padding: "8px 12px",
                              cursor: "pointer"
                            }}
                            onClick={() => {
                              const randomAd = YT_ADS[Math.floor(Math.random() * YT_ADS.length)];
                              setCurrentAdVideo(randomAd);
                              setIsAdPlaying(true);
                            }}
                          >
                            Watch Ad to Earn Tokens
                          </button>
                        )}
                        {/* Quick Book Button */}
                        <button
                          style={{
                            backgroundColor: "#0EA5E9",
                            color: "#fff",
                            border: "none",
                            borderRadius: "8px",
                            padding: "8px 12px",
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            const workerToBook = matchingWorkers[0];
                            const bookedBy = workerToBook?.name || "Job Booking completed";
                            quickBookJob("JobPortalRoot", job.id, bookedBy);
                            setJobPosts(prev => prev.map(jobItem =>
                              jobItem.id === job.id ? { ...jobItem, quickBookedBy: bookedBy } : jobItem
                            ));
                            toast.success(`Job booked${workerToBook ? ` by ${workerToBook.name}` : ""}`);
                          }}
                        >
                          Book (Quick)
                        </button>
                        {/* Remove Job */}
                        <button
                          style={{
                            backgroundColor: "#EF4444",
                            color: "#fff",
                            border: "none",
                            borderRadius: "8px",
                            padding: "8px 12px",
                            cursor: "pointer"
                          }}
                          onClick={() => setJobPosts(prev => prev.filter(j => j.id !== job.id))}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          )}
        </>
      )}
    </div>
    </div>
  </div>
)}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "financialSection" && (
  <div className="admin-container">
    <div style={headerStyle}>
      <h3 style={titleStyle}>Bookings Revenue</h3>
    </div>
    <div style={cardStyle}>
      {/* 💼 Dashboard Header */}
      <div style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "12px", textAlign: "center", marginBottom: "30px" }}>
        <h3 style={{ margin: 0, fontFamily: "'Poppins', sans-serif", fontSize: "24px", fontWeight: "700", color: "#111827" }}>
          💼 Financial Section Dashboard
        </h3>
      </div>
      {/* 📊 Main Section: Bar Chart & Filters */}
      <div style={{ backgroundColor: "#fff", padding: "24px", borderRadius: "16px", boxShadow: "0 4px 12px rgba(0,0,0,0.05)", marginBottom: "40px" }}>
        <div className="flex justify-between items-center mb-4 flex-wrap gap-6">
          <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#111827", fontFamily: "'Poppins', sans-serif" }}>
            📊 {selectedFilter === "revenue" ? "Booking Revenue by Date" : selectedFilter === "totalAmount" ? "Total Amount by Date" : "Service Platform Revenue"}
          </h4>
          {/* 🌟 Filters */}
          <div className="flex flex-col sm:flex-row gap-4 items-end justify-end w-full sm:w-auto">
            {/* 📅 Date Picker */}
            <div className="relative flex flex-col bg-white border border-gray-200 rounded-2xl p-5 shadow-lg hover:shadow-xl transition-all duration-200 w-full max-w-[650px]">
              <div className="flex items-center justify-between mb-4">
                <div className="flex flex-col w-1/2 mr-3">
                  <label className="text-gray-700 text-sm font-semibold mb-1">From - To</label>
                  <input
                    type="text"
                    value={fromDate && toDate ? `${fromDate} – ${toDate}` : "Select date interval"}
                    readOnly
                    onClick={() => setShowCalendar(true)}
                    className="border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 cursor-pointer bg-white"
                  />
                </div>
                {/* First Action Dropdown */}
                <div className="flex flex-col w-1/2">
                  <label className="text-gray-700 text-sm font-semibold mb-1">First Action</label>
                  <select className="border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white cursor-pointer">
                    <option>Go to Out of Hour</option>
                    <option>Go to Working Hour</option>
                  </select>
                </div>
              </div>
              {/* 🌸 Calendar Modal */}
              {showCalendar && (
                <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ background: "rgba(0,0,0,0.5)", backdropFilter: "blur(4px)" }} onClick={() => setShowCalendar(false)}>
                  <div className="modal-dialog modal-lg" role="document" style={{ maxWidth: "750px" }} onClick={(e) => e.stopPropagation()}>
                    <div className="modal-content rounded-2xl shadow-lg" style={{ border: "1px solid #fbcfe8" }}>
                      {/* Header */}
                      <div className="modal-header border-b px-4 py-3" style={{ borderColor: "#f9a8d4" }}>
                        <h5 className="modal-title font-semibold" style={{ color: "#ec4899" }}>Select Date Interval</h5>
                        <button
                          type="button"
                          className="close"
                          onClick={() => setShowCalendar(false)}
                          style={{ border: "1px solid #ec4899", color: "#ec4899", padding: "4px 12px", borderRadius: "8px", fontWeight: "500" }}
                          onMouseEnter={(e) => { e.target.style.color = "white"; e.target.style.backgroundColor = "#ec4899"; }}
                          onMouseLeave={(e) => { e.target.style.color = "#ec4899"; e.target.style.backgroundColor = "transparent"; }}
                        >
                          ✕ Close
                        </button>
                      </div>
                      {/* Dual Calendar */}
                      <div className="modal-body p-4 flex justify-between gap-8">
                        <div className="flex-1 flex flex-col items-center">
                          <DatePicker
                            inline
                            selected={fromDate ? new Date(fromDate) : null}
                            onChange={(date) => setFromDate(date ? date.toISOString().split("T")[0] : "")}
                            monthsShown={1}
                            minDate={new Date("2000-01-01")}
                            maxDate={new Date("2060-12-31")}
                          />
                          <p className="text-xs mt-2 text-gray-500 font-medium">From Date</p>
                        </div>
                        <div className="flex-1 flex flex-col items-center">
                          <DatePicker
                            inline
                            selected={toDate ? new Date(toDate) : null}
                            onChange={(date) => setToDate(date ? date.toISOString().split("T")[0] : "")}
                            monthsShown={1}
                            minDate={new Date("2000-01-01")}
                            maxDate={new Date("2060-12-31")}
                          />
                          <p className="text-xs mt-2 text-gray-500 font-medium">To Date</p>
                        </div>
                      </div>
                      {/* Footer */}
                      <div className="modal-footer border-t px-4 py-3 d-flex justify-content-end gap-2">
                        <button className="btn btn-danger btn-sm" onClick={() => setShowCalendar(false)} style={{ backgroundColor: "#dc2626", border: "none", padding: "8px 14px", borderRadius: "8px", fontWeight: "500" }}>Cancel</button>
                        <button className="btn btn-primary btn-sm" onClick={handleApplyDateRange} style={{ backgroundColor: "#2563eb", border: "none", padding: "8px 14px", borderRadius: "8px", fontWeight: "500" }}>Apply</button>
                      </div>
                      {appliedDateRange.from && appliedDateRange.to && (
                        <div className="text-center text-sm text-gray-600 font-medium border-t border-gray-100 py-3" style={{ background: "#f9fafb" }}>
                          {appliedDateRange.from} 00:00 – {appliedDateRange.to} 23:59
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* 🔽 Filter Dropdown */}
            <div className="flex flex-col bg-gray-50 border border-gray-200 rounded-xl p-3 shadow-sm hover:shadow-md transition-all duration-200">
              <label className="flex items-center gap-2 text-gray-700 text-sm font-medium mb-1" htmlFor="filter-select">
                <i className="bi bi-funnel text-indigo-500"></i>
                Filter Type
              </label>
              <div className="relative">
                <select
                  id="filter-select"
                  value={selectedFilter}
                  onChange={(e) => setSelectedFilter(e.target.value)}
                  className="appearance-none w-full border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 cursor-pointer"
                >
                  <option value="revenue">📈 Booking Revenue</option>
                  <option value="totalAmount">💰 Total Amount</option>
                  <option value="servicePlatform">🧩 Service Platform</option>
                </select>
                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none">▼</span>
              </div>
            </div>
          </div>
        </div>
        {/* 📈 Bar Chart */}
        <ResponsiveContainer width="100%" height={380}>
          <BarChart data={getFilteredData()}>
            <XAxis dataKey={selectedFilter === "servicePlatform" ? "platform" : "month"} tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 12 }} />
            <Tooltip formatter={(value) => `£${value.toLocaleString()}`} contentStyle={{ backgroundColor: "#fff", borderRadius: "8px", border: "1px solid #E5E7EB", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }} />
            <Legend verticalAlign="bottom" height={36} iconType="circle" formatter={(value) => <span style={{ color: "#374151", fontWeight: 500 }}>{value}</span>} />
            {selectedFilter === "revenue" && <>
              <Bar dataKey="confirmed" name="Confirmed" fill="#9CA3AF" radius={[4,4,0,0]} />
              <Bar dataKey="pending" name="Pending" fill="#FACC15" radius={[4,4,0,0]} />
              <Bar dataKey="new" name="New" fill="#3B82F6" radius={[4,4,0,0]} />
              <Bar dataKey="cancelled" name="Cancelled" fill="#EF4444" radius={[4,4,0,0]} />
            </>}
            {selectedFilter === "totalAmount" && <Bar dataKey="total" name="Total Amount" fill="#10B981" radius={[4,4,0,0]} />}
            {selectedFilter === "servicePlatform" && <Bar dataKey="amount" name="Service Platform Revenue" fill="#8B5CF6" radius={[4,4,0,0]} />}
          </BarChart>
        </ResponsiveContainer>
      </div>
      {/* 📊 Pie Chart */}
      <div style={{ backgroundColor: "#fff", padding: "24px", borderRadius: "16px", boxShadow: "0 4px 12px rgba(0,0,0,0.05)" }}>
        <div className="flex justify-between items-center mb-6 flex-wrap gap-4">
          <h3 style={{ fontFamily: "'Poppins', sans-serif", fontSize: "20px", fontWeight: "600", color: "#111827" }}>
            📊 {selectedFilter === "revenue" ? "Booking Revenue Distribution" : selectedFilter === "totalAmount" ? "Total Amount Distribution" : "Service Platform Distribution"}
          </h3>
          <div className="relative">
            <select value={selectedFilter} onChange={(e) => setSelectedFilter(e.target.value)} className="appearance-none bg-white border border-gray-300 rounded-xl px-4 py-2.5 pr-10 text-sm text-gray-700 font-medium focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm transition-all duration-200 hover:border-indigo-400 cursor-pointer">
              <option value="revenue">📈 Booking Revenue</option>
              <option value="totalAmount">💰 Total Amount</option>
              <option value="servicePlatform">🧩 Service Platform</option>
            </select>
            <span className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500">▼</span>
          </div>
        </div>
        <AnimatePresence mode="wait">
          <motion.div key={selectedFilter + appliedDateRange.from + appliedDateRange.to} initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -15 }} transition={{ duration: 0.4 }}>
            <ResponsiveContainer width="100%" height={350}>
              <PieChart>
                <Pie
                  data={getFilteredData()}
                  dataKey={selectedFilter === "totalAmount" ? "total" : selectedFilter === "revenue" ? "confirmed" : "amount"}
                  nameKey={selectedFilter === "servicePlatform" ? "platform" : "month"}
                  cx="50%" cy="50%"
                  outerRadius={120}
                  label={({ name, percent }) => `${name}: ${(percent*100).toFixed(1)}%`}
                >
                  {getFilteredData().map((_, index) => (
                    <Cell key={`slice-${index}`} fill={colorScheme[index % colorScheme.length]} stroke="#fff" strokeWidth={2} />
                  ))}
                </Pie>
                <Tooltip formatter={(value) => `£${value.toLocaleString()}`} contentStyle={{ backgroundColor: "#fff", borderRadius: "8px", border: "1px solid #E5E7EB", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }} />
                <Legend verticalAlign="bottom" height={36} iconType="circle" formatter={(value) => <span style={{ color: "#374151", fontWeight: 500 }}>{value}</span>} />
              </PieChart>
            </ResponsiveContainer>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
    </div>
)}

{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "financialOverview" && (
  <div className="admin-container">
    <div style={headerStyle}>
      <h3 style={titleStyle}>Bookings Overview</h3>
    </div>
    <div style={cardStyle}>
      {/* Header */}
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          💼 Financial Overview Dashboard
        </h3>
        <p
          style={{
            marginTop: "8px",
            color: "#6B7280",
            fontFamily: "'Inter', sans-serif",
            fontSize: "14px",
          }}
        >
          Summary of all invoices and customer financial activities
        </p>
      </div>
      {/* 📊 Invoices per Customer Chart */}
      <div
        className="finance-graph-container"
        style={{
          backgroundColor: "#fff",
          padding: "24px",
          borderRadius: "16px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
          border: "1px solid #E5E7EB",
        }}
      >
        <h4
          style={{
            fontSize: "18px",
            fontWeight: "600",
            marginBottom: "16px",
            color: "#1F2937",
            fontFamily: "'Inter', sans-serif",
          }}
        >
          Number of Invoices per Customer
        </h4>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={Object.values(
              invoiceList.reduce((acc, inv) => {
                acc[inv.customer] =
                  acc[inv.customer] || { customer: inv.customer, count: 0 };
                acc[inv.customer].count += 1;
                return acc;
              }, {})
            )}
          >
            <XAxis dataKey="customer" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="count" fill="#F59E0B" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
    </div>
)}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "paymentLogs" && (
  <div className="admin-container">
    <div style={headerStyle}>
      <h3 style={titleStyle}>Payment Logs</h3>
    </div>
    <div style={cardStyle}>
      <div
  className="admin-container"
  style={{
    maxWidth: "1500px",
    margin: "0 auto",
    width: "100%",
  }}
>
      {/* Header */}
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          textAlign: "center",
          marginBottom: "20px",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          🤖 Automated Payment Logs
        </h3>
      </div>
  {/* ================= REFUND NOTIFICATION BULB + BACK ================= */}
<div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "12px",
    marginBottom: "12px",
    flexWrap: "wrap",
  }}
>
  {/* 🔙 BACK BUTTON (shown only when filter active) */}
  {selectedRefundFilter && (
    <button
  onClick={() => setSelectedRefundFilter("")}
  style={{
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "6px 14px",
    borderRadius: "999px",
    border: "1px solid #8B5CF6",        // violet border
    backgroundColor: "#F5F3FF",         // light violet bg
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 600,
    color: "#6D28D9",                   // deep violet text
    boxShadow: "0 2px 6px rgba(139,92,246,0.25)",
    transition: "all 0.2s ease",
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = "#8B5CF6";
    e.currentTarget.style.color = "#fff";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = "#F5F3FF";
    e.currentTarget.style.color = "#6D28D9";
  }}
>
  <i className="bi bi-arrow-left" />
  Back
</button>
  )}
  {/* 🔔 REFUND BULBS */}
  {[
    { label: "Refund New", color: "#FBBF24" },
    { label: "Refund Pending", color: "#FB923C" },
    { label: "Refund Issued", color: "#3B82F6" },
    { label: "Refund Confirmed", color: "#8B5CF6" },
    { label: "Refund Completed", color: "#10B981" },
  ].map(({ label, color }) => {
    if (!refundCounts[label]) return null;
    const isActive = selectedRefundFilter === label;
    return (
      <div
        key={label}
        onClick={() =>
          setSelectedRefundFilter(isActive ? "" : label)
        }
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "6px 12px",
          borderRadius: "999px",
          cursor: "pointer",
          fontFamily: "'Inter', sans-serif",
          fontSize: "13px",
          fontWeight: 600,
          transition: "all 0.2s ease",
          backgroundColor: isActive ? color : "#fff",
          color: isActive ? "#fff" : "#111827",
          boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
        }}
      >
        <i
          className="bi bi-bell-fill"
          style={{ color: isActive ? "#fff" : color }}
        />
        <span>{label}</span>
        <span
          style={{
            padding: "2px 8px",
            borderRadius: "999px",
            fontSize: "12px",
            backgroundColor: isActive ? "#fff" : color,
            color: isActive ? color : "#fff",
          }}
        >
          {refundCounts[label]}
        </span>
      </div>
    );
  })}
</div>
      {/* Search + Date Filter */}
      <div style={{ display: "flex", gap: "12px", marginBottom: "16px" }}>
        <input
          type="text"
          placeholder="Search Consumer (Name / Email / ID)"
          value={consumerSearch}
          onChange={(e) => setConsumerSearch(e.target.value)}
          style={{
            flex: 1,
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #D1D5DB",
            fontFamily: "'Inter', sans-serif",
            fontSize: "14px",
          }}
        />
        <input
          type="date"
          value={consumerDateFilter}
          onChange={(e) => setConsumerDateFilter(e.target.value)}
          style={{
            width: "180px",
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #D1D5DB",
            fontFamily: "'Inter', sans-serif",
            fontSize: "14px",
          }}
        />
      </div>
      {/* Fetch Button */}
      <button
        onClick={fetchConsumersWithLogs}
        disabled={fetching}
        style={{
          backgroundColor: "#8B5CF6",
          color: "white",
          padding: "8px 16px",
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          marginBottom: "20px",
          fontFamily: "'Inter', sans-serif",
        }}
      >
        {fetching ? (
          <>
            <div
              className="spinner-border spinner-border-sm"
              role="status"
              style={{ width: "1rem", height: "1rem" }}
            ></div>{" "}
            Fetching...
          </>
        ) : (
          <>
            <i className="bi bi-receipt"></i> Fetch Payment Logs
          </>
        )}
      </button>
      {/* Error */}
      {fetchError && (
        <p
          style={{
            color: "red",
            marginBottom: "16px",
            fontFamily: "'Inter', sans-serif",
          }}
        >
          ❌ {fetchError}
        </p>
      )}
      {/* ---------- ADMIN LIST ---------- */}
      {null}
      {(() => {
        const adminList = ["Aashish", "Vaibhav", "Rohit", "Ananya"];
        return null;
      })()}
      {/* List Consumers */}
      {!fetching &&
        consumers
          .filter((c) => {
            const matchText =
              consumerSearch.trim() === ""
                ? true
                : `${c.name || ""} ${c.email || ""} ${c.id || ""}`
                    .toLowerCase()
                    .includes(consumerSearch.toLowerCase());
            const matchDate =
              consumerDateFilter.trim() === ""
                ? true
                : (c.events || []).some((ev) => {
                    const eventDate = new Date(ev.timestamp)
                      .toISOString()
                      .split("T")[0];
                    return eventDate === consumerDateFilter;
                  });
            return matchText && matchDate;
          })
          .map((consumer) => {
            const filters = rowFilters[consumer.id] || {
              event: "",
              customerId: "",
              eventId: "",
              amount: "",
              status: "",
              paymentIntent: "",
              stripeId: "",
              timestamp: "",
              requestReason: "",
              refundStatus: "",
            };
            const filteredEvents = (consumer.events || []).filter((log) => {
              const requestReasonValue =
                log.refundApproval?.requestReason || "";
              const refundStatusValue =
                log.refundApproval?.refundStatus || "";
              /* ================= BULB FILTER ================= */
              if (
                selectedRefundFilter &&
                refundStatusValue !== selectedRefundFilter
              ) {
                return false;
              }
              /* ================= EXISTING FILTERS ================= */
              return (
                (log.eventType || "")
                  .toLowerCase()
                  .includes(filters.event.toLowerCase()) &&
                (log.customerId || "")
                  .toLowerCase()
                  .includes(filters.customerId.toLowerCase()) &&
                (log.eventId || "")
                  .toLowerCase()
                  .includes(filters.eventId.toLowerCase()) &&
                (String(log.amount) || "")
                  .toLowerCase()
                  .includes(filters.amount.toLowerCase()) &&
                (log.status || "")
                  .toLowerCase()
                  .includes(filters.status.toLowerCase()) &&
                (log.paymentIntentId || "")
                  .toLowerCase()
                  .includes(filters.paymentIntent.toLowerCase()) &&
                (log.stripeId || "")
                  .toLowerCase()
                  .includes(filters.stripeId.toLowerCase()) &&
                (prettyTime(log.timestamp) || "")
                  .toLowerCase()
                  .includes(filters.timestamp.toLowerCase()) &&
                requestReasonValue
                  .toLowerCase()
                  .includes(filters.requestReason.toLowerCase()) &&
                (filters.refundStatus.trim() === ""
                  ? true
                  : refundStatusValue
                      .toLowerCase()
                      .includes(filters.refundStatus.toLowerCase()))
              );
            });
            // helper to render refund status badge
            const renderRefundBadge = (status) => {
              if (!status) return null;
              const badgeStyle = {
                display: "inline-block",
                padding: "4px 8px",
                borderRadius: "999px",
                fontSize: "12px",
                fontWeight: 600,
                minWidth: "90px",
                textAlign: "center",
              };
              switch (status) {
                case "Refund New":
                  return (
                    <span
                      style={{
                        ...badgeStyle,
                        backgroundColor: "#FBBF24",
                        color: "#000",
                      }}
                    >
                      {status}
                    </span>
                  );
                case "Refund Pending":
                  return (
                    <span
                      style={{
                        ...badgeStyle,
                        backgroundColor: "#FB923C",
                        color: "#fff",
                      }}
                    >
                      {status}
                    </span>
                  );
                case "Refund Issued":
                  return (
                    <span
                      style={{
                        ...badgeStyle,
                        backgroundColor: "#3B82F6",
                        color: "#fff",
                      }}
                    >
                      {status}
                    </span>
                  );
                case "Refund Confirmed":
                  return (
                    <span
                      style={{
                        ...badgeStyle,
                        backgroundColor: "#8B5CF6",
                        color: "#fff",
                      }}
                    >
                      {status}
                    </span>
                  );
                case "Refund Completed":
                  return (
                    <span
                      style={{
                        ...badgeStyle,
                        backgroundColor: "#10B981",
                        color: "#fff",
                      }}
                    >
                      {status}
                    </span>
                  );
                default:
                  return (
                    <span
                      style={{
                        ...badgeStyle,
                        backgroundColor: "#E5E7EB",
                        color: "#111827",
                      }}
                    >
                      {status}
                    </span>
                  );
              }
            };
            return (
              <div
                key={consumer.id}
                style={{
                  marginBottom: "20px",
                  backgroundColor: "#fff",
                  padding: "16px",
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                }}
              >
                <h4
                  style={{
                    marginBottom: "8px",
                    fontWeight: 600,
                    fontFamily: "'Inter', sans-serif",
                  }}
                >
                  {consumer.name} (
                  <a
                    href={`https://dashboard.stripe.com/customers/${consumer.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#3B82F6", textDecoration: "underline" }}
                  >
                    {consumer.email}
                  </a>
                  )
                </h4>
                <p
                  style={{
                    fontFamily: "'Inter', sans-serif",
                    fontSize: "14px",
                  }}
                >
                  <strong>Customer ID:</strong>{" "}
                  <a
                    href={`https://dashboard.stripe.com/customers/${consumer.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#3B82F6", textDecoration: "underline" }}
                  >
                    {consumer.id}
                  </a>
                </p>
                {(consumer.events || []).length === 0 ? (
                  <em
                    style={{
                      fontFamily: "'Inter', sans-serif",
                      fontSize: "14px",
                    }}
                  >
                    No payment events found.
                  </em>
                ) : (
                  <div style={{ overflowX: "auto", marginTop: "12px" }}>
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontFamily: "'Inter', sans-serif",
                        fontSize: "14px",
                        color: "#374151",
                      }}
                    >
                      <thead style={{ backgroundColor: "#F9FAFB" }}>
                        <tr>
                          <th style={{ padding: "12px" }}>Event</th>
                          <th style={{ padding: "12px" }}>Customer ID</th>
                          <th style={{ padding: "12px" }}>Event ID</th>
                          <th style={{ padding: "12px" }}>Amount</th>
                          <th style={{ padding: "12px" }}>Status</th>
                          <th style={{ padding: "12px" }}>requestReason</th>
                          <th style={{ padding: "12px" }}>refundStatus</th>
                          <th style={{ padding: "12px" }}>PaymentIntent</th>
                          <th style={{ padding: "12px" }}>Stripe ID</th>
                          <th style={{ padding: "12px" }}>Timestamp</th>
                          <th style={{ padding: "12px" }}>Actions</th>
                        </tr>
                        {/* FILTER ROW */}
                        <tr>
                          {[
                            "event",
                            "customerId",
                            "eventId",
                            "amount",
                            "status",
                            "requestReason",
                            "refundStatus",
                            "paymentIntent",
                            "stripeId",
                            "timestamp",
                          ].map((col) => (
                            <th key={col} style={{ padding: "6px" }}>
                              {col === "refundStatus" ? (
                                <select
                                  value={filters.refundStatus}
                                  onChange={(e) =>
                                    setRowFilters({
                                      ...rowFilters,
                                      [consumer.id]: {
                                        ...filters,
                                        refundStatus: e.target.value,
                                      },
                                    })
                                  }
                                  style={{
                                    width: "100%",
                                    padding: "6px 8px",
                                    border: "1px solid #D1D5DB",
                                    borderRadius: "6px",
                                    fontFamily: "'Inter', sans-serif",
                                    fontSize: "12px",
                                    height: "32px",
                                  }}
                                >
                                  <option value="">All</option>
                                  <option value="Refund New">Refund New</option>
                                  <option value="Refund Pending">Refund Pending</option>
                                  <option value="Refund Issued">Refund Issued</option>
                                  <option value="Refund Confirmed">Refund Confirmed</option>
                                  <option value="Refund Completed">Refund Completed</option>
                                </select>
                              ) : col === "requestReason" ? (
                                <input
                                  type="text"
                                  placeholder={`Search ${col}`}
                                  value={filters.requestReason}
                                  onChange={(e) =>
                                    setRowFilters({
                                      ...rowFilters,
                                      [consumer.id]: {
                                        ...filters,
                                        requestReason: e.target.value,
                                      },
                                    })
                                  }
                                  style={{
                                    width: "100%",
                                    padding: "6px 8px",
                                    border: "1px solid #D1D5DB",
                                    borderRadius: "6px",
                                    fontFamily: "'Inter', sans-serif",
                                    fontSize: "12px",
                                    height: "32px",
                                  }}
                                />
                              ) : (
                                <input
                                  type="text"
                                  placeholder={`Search ${col}`}
                                  value={filters[col] || ""}
                                  onChange={(e) =>
                                    setRowFilters({
                                      ...rowFilters,
                                      [consumer.id]: {
                                        ...filters,
                                        [col]: e.target.value,
                                      },
                                    })
                                  }
                                  style={{
                                    width: "100%",
                                    padding: "6px 8px",
                                    border: "1px solid #D1D5DB",
                                    borderRadius: "6px",
                                    fontFamily: "'Inter', sans-serif",
                                    fontSize: "12px",
                                    height: "32px",
                                  }}
                                />
                              )}
                            </th>
                          ))}
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredEvents.map((log, idx) => {
                          const adminList = ["Aashish", "Vaibhav", "Rohit", "Ananya"];
                          const hasRefundApproval =
                            log.refundApproval && log.refundApproval.requested;
                          const approvalPending =
                            hasRefundApproval && !log.refundApproval.approved;
                          const approvalDone =
                            hasRefundApproval && log.refundApproval.approved;
                          const requestReason =
                            (log.refundApproval && log.refundApproval.requestReason) ||
                            "";
                          const refundStatus =
                            (log.refundApproval && log.refundApproval.refundStatus) ||
                            "";
                          const isEditingAmount =
                            typeof editingAmountEventId !== "undefined" &&
                            editingAmountEventId === log.eventId;
                          return (
                            <tr
                              key={log.eventId}
                              style={{
                                backgroundColor:
                                  idx % 2 === 0 ? "#fff" : "#F9FAFB",
                                borderBottom: "1px solid #E5E7EB",
                              }}
                            >
                              <td style={{ padding: "12px" }}>
                                {log.eventType}
                              </td>
                              <td style={{ padding: "12px" }}>
                                <a
                                  href={`https://dashboard.stripe.com/customers/${log.customerId}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "#3B82F6",
                                    textDecoration: "underline",
                                  }}
                                >
                                  {log.customerId}
                                </a>
                              </td>
                              <td style={{ padding: "12px" }}>{log.eventId}</td>
                              {/* Editable Amount Column */}
                              <td style={{ padding: "12px" }}>
                                {isEditingAmount ? (
                                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <input
                                      type="number"
                                      step="0.01"
                                      value={newAmountValue}
                                      onChange={(e) => setNewAmountValue(e.target.value)}
                                      style={{
                                        width: "80px",
                                        padding: "4px 6px",
                                        borderRadius: "4px",
                                        border: "1px solid #8B5CF6",
                                        fontSize: "13px",
                                      }}
                                      autoFocus
                                    />
                                    <button
                                      title="Save Amount"
                                      style={{
                                        backgroundColor: "#10B981",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "4px",
                                        padding: "4px 8px",
                                        cursor: "pointer",
                                      }}
                                      onClick={async () => {
                                        try {
                                          const parsedAmount = Number(newAmountValue);
                                          if (isNaN(parsedAmount) || parsedAmount < 0) {
                                            alert("Please enter a valid amount");
                                            return;
                                          }
                                          setLoading(true);
                                          const customerRef = doc(db, "Payment_Logs", consumer.id);
                                          const customerSnap = await getDoc(customerRef);
                                          if (customerSnap.exists()) {
                                            const data = customerSnap.data();
                                            const updatedEvents = (data.events || []).map((ev) =>
                                              ev.eventId === log.eventId
                                                ? { ...ev, amount: parsedAmount }
                                                : ev
                                            );
                                            await updateDoc(customerRef, { events: updatedEvents });
                                          }
                                          // Update local consumers state
                                          setConsumers((prev) =>
                                            prev.map((c) =>
                                              c.id === consumer.id
                                                ? {
                                                    ...c,
                                                    events: c.events.map((ev) =>
                                                      ev.eventId === log.eventId
                                                        ? { ...ev, amount: parsedAmount }
                                                        : ev
                                                    ),
                                                  }
                                                : c
                                            )
                                          );
                                          // Update Logs Profile Preview if currently open
                                          if (logsModal?.show && logsModal?.consumer?.id === consumer.id) {
                                            setLogsModal((prev) => ({
                                              ...prev,
                                              consumer: {
                                                ...prev.consumer,
                                                events: prev.consumer.events.map((ev) =>
                                                  ev.eventId === log.eventId
                                                    ? { ...ev, amount: parsedAmount }
                                                    : ev
                                                ),
                                              },
                                            }));
                                          }
                                          if (typeof setEditingAmountEventId === "function") {
                                            setEditingAmountEventId(null);
                                          }
                                          if (typeof setNewAmountValue === "function") {
                                            setNewAmountValue("");
                                          }
                                        } catch (err) {
                                          alert("Failed to update amount: " + err.message);
                                        } finally {
                                          setLoading(false);
                                        }
                                      }}
                                    >
                                      <i className="bi bi-check-lg"></i>
                                    </button>
                                    <button
                                      title="Cancel"
                                      style={{
                                        backgroundColor: "#EF4444",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "4px",
                                        padding: "4px 8px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        if (typeof setEditingAmountEventId === "function") {
                                          setEditingAmountEventId(null);
                                        }
                                        if (typeof setNewAmountValue === "function") {
                                          setNewAmountValue("");
                                        }
                                      }}
                                    >
                                      <i className="bi bi-x-lg"></i>
                                    </button>
                                  </div>
                                ) : (
                                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    <span>{log.amount}</span>
                                    <button
                                      title="Edit Amount"
                                      style={{
                                        background: "transparent",
                                        border: "none",
                                        color: "#6B7280",
                                        cursor: "pointer",
                                        padding: "2px 4px",
                                        fontSize: "13px",
                                      }}
                                      onClick={() => {
                                        if (typeof setEditingAmountEventId === "function") {
                                          setEditingAmountEventId(log.eventId);
                                          setNewAmountValue(String(log.amount));
                                        } else {
                                          const entered = window.prompt("Enter new amount:", log.amount);
                                          if (entered !== null && entered !== "") {
                                            const parsedAmount = Number(entered);
                                            if (isNaN(parsedAmount) || parsedAmount < 0) {
                                              alert("Invalid amount.");
                                              return;
                                            }
                                            (async () => {
                                              try {
                                                setLoading(true);
                                                const customerRef = doc(db, "Payment_Logs", consumer.id);
                                                const customerSnap = await getDoc(customerRef);
                                                if (customerSnap.exists()) {
                                                  const data = customerSnap.data();
                                                  const updatedEvents = (data.events || []).map((ev) =>
                                                    ev.eventId === log.eventId
                                                      ? { ...ev, amount: parsedAmount }
                                                      : ev
                                                  );
                                                  await updateDoc(customerRef, { events: updatedEvents });
                                                }
                                                setConsumers((prev) =>
                                                  prev.map((c) =>
                                                    c.id === consumer.id
                                                      ? {
                                                          ...c,
                                                          events: c.events.map((ev) =>
                                                            ev.eventId === log.eventId
                                                              ? { ...ev, amount: parsedAmount }
                                                              : ev
                                                          ),
                                                        }
                                                      : c
                                                  )
                                                );
                                                if (logsModal?.show && logsModal?.consumer?.id === consumer.id) {
                                                  setLogsModal((prev) => ({
                                                    ...prev,
                                                    consumer: {
                                                      ...prev.consumer,
                                                      events: prev.consumer.events.map((ev) =>
                                                        ev.eventId === log.eventId
                                                          ? { ...ev, amount: parsedAmount }
                                                          : ev
                                                      ),
                                                    },
                                                  }));
                                                }
                                              } catch (err) {
                                                alert("Failed to update amount: " + err.message);
                                              } finally {
                                                setLoading(false);
                                              }
                                            })();
                                          }
                                        }
                                      }}
                                    >
                                      <i className="bi bi-pencil"></i>
                                    </button>
                                  </div>
                                )}
                              </td>
                              <td style={{ padding: "12px" }}>{log.status}</td>
                              {/* requestReason column */}
                              <td style={{ padding: "12px", maxWidth: "220px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                {requestReason || "—"}
                              </td>
                              {/* Refund Status column with colored badge */}
                              <td style={{ padding: "12px" }}>
                                {refundStatus ? (
                                  renderRefundBadge(refundStatus)
                                ) : hasRefundApproval ? (
                                  renderRefundBadge("Refund Pending")
                                ) : (
                                  <span
                                    style={{
                                      display: "inline-block",
                                      padding: "4px 8px",
                                      borderRadius: "999px",
                                      fontSize: "12px",
                                      color: "#6B7280",
                                      backgroundColor: "#F3F4F6",
                                      fontWeight: 600,
                                      minWidth: "56px",
                                      textAlign: "center",
                                    }}
                                  >
                                    —
                                  </span>
                                )}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {log.paymentIntentId}
                              </td>
                              <td style={{ padding: "12px" }}>{log.stripeId}</td>
                              <td style={{ padding: "12px" }}>
                                {prettyTime(log.timestamp)}
                                {approvalPending && (
                                  <div style={{ fontSize: 12, color: "#92400E" }}>
                                    Approval pending by:{" "}
                                    <strong>{log.refundApproval.adminToApprove}</strong>
                                  </div>
                                )}
                                {approvalDone && (
                                  <div style={{ fontSize: 12, color: "#065F46" }}>
                                    Approved by: <strong>{log.refundApproval.approvedBy}</strong>{" "}
                                    on{" "}
                                    {new Date(
                                      log.refundApproval.approvedAt
                                    ).toLocaleString()}
                                  </div>
                                )}
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "6px",
                                }}
                              >
                                {/* Request Refund */}
                                <button
                                  style={{
                                    backgroundColor: "#F59E0B",
                                    color: "#fff",
                                    padding: "6px 12px",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                  }}
                                  onClick={() =>
                                    setRefundModal({
                                      show: true,
                                      customerId: consumer.id,
                                      eventId: log.eventId,
                                      currentEvent: log,
                                    })
                                  }
                                >
                                  <i className="bi bi-arrow-counterclockwise"></i>{" "}
                                  Request Refund
                                </button>
                                {/* View Logs Profile (Preview) */}
                                <button
                                  style={{
                                    backgroundColor: "#3B82F6",
                                    color: "#fff",
                                    padding: "6px 12px",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                  }}
                                  onClick={() =>
                                    setLogsModal({ show: true, consumer })
                                  }
                                >
                                  <i className="bi bi-journal-text"></i> Logs Profile
                                </button>
                                {/* Approve Refund action */}
                                {approvalPending && (
                                  <button
                                    style={{
                                      backgroundColor: "#06B6D4",
                                      color: "#fff",
                                      padding: "6px 12px",
                                      borderRadius: "6px",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "6px",
                                    }}
                                    onClick={() =>
                                      setApproveModal({
                                        show: true,
                                        customerId: consumer.id,
                                        eventId: log.eventId,
                                        currentEvent: log,
                                      })
                                    }
                                  >
                                    <i className="bi bi-check-circle"></i> Approve Refund
                                  </button>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })} 
{refundModal.show && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    }}
  >
    <div
      style={{
        backgroundColor: "#fff",
        padding: "24px",
        borderRadius: "12px",
        width: "420px",
        textAlign: "center",
      }}
    >
      <h4 style={{ marginBottom: "16px" }}>Request Refund Approval</h4>
     <input
  type="number"
  value={refundAmount}
  onChange={(e) => setRefundAmount(e.target.value)}
  placeholder="Refund Amount (£)"
  min="0"
  step="0.01"
  style={{
    padding: "10px",
    width: "100%",
    marginBottom: "12px",
    borderRadius: "6px",
    border: "1px solid #ccc",
  }}
/>
      <input
        type="text"
        value={refundReason}
        onChange={(e) => setRefundReason(e.target.value)}
        placeholder="Reason / Note for refund"
        style={{
          padding: "10px",
          width: "100%",
          marginBottom: "12px",
          borderRadius: "6px",
          border: "1px solid #ccc",
        }}
      />
      {/* Refund Status selection */}
      <select
        value={refundStatus}
        onChange={(e) => setRefundStatus(e.target.value)}
        style={{
          width: "100%",
          padding: "10px",
          marginBottom: "16px",
          borderRadius: "6px",
          border: "1px solid #ccc",
        }}
      >
        <option value="">Select Refund Status</option>
        <option value="Refund New">Refund New</option>
        <option value="Refund Pending">Refund Pending</option>
        <option value="Refund Issued">Refund Issued</option>
        <option value="Refund Confirmed">Refund Confirmed</option>
        <option value="Refund Completed">Refund Completed</option>
      </select>
      <select
        value={selectedAdminForRequest}
        onChange={(e) => setSelectedAdminForRequest(e.target.value)}
        style={{
          width: "100%",
          padding: "10px",
          marginBottom: "16px",
          borderRadius: "6px",
          border: "1px solid #ccc",
        }}
      >
        <option value="">Select Admin to Approve</option>
        {["Aashish", "Vaibhav", "Rohit", "Ananya"].map((a) => (
          <option key={a} value={a}>
            {a}
          </option>
        ))}
      </select>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "12px",
        }}
      >
        <button
          style={{
            backgroundColor: "#6B7280",
            color: "#fff",
            padding: "8px 16px",
            borderRadius: "6px",
            cursor: "pointer",
          }}
          onClick={() =>
            setRefundModal({
              show: false,
              customerId: null,
              eventId: null,
              currentEvent: null,
            })
          }
        >
          Cancel
        </button>
        <button
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            backgroundColor: "#10B981",
            color: "#fff",
            padding: "8px 16px",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: 500,
          }}
          onClick={async () => {
            try {
              if (
                !refundAmount ||
                Number(refundAmount) <= 0 ||
                !refundReason ||
                !selectedAdminForRequest
              ) {
                alert("Please provide amount, reason and admin to approve.");
                return;
              }
              const { customerId, eventId } = refundModal;
              if (!customerId || !eventId) return;
              setLoading(true);
              const customerRef = doc(db, "Payment_Logs", customerId);
              const customerSnap = await getDoc(customerRef);
              if (!customerSnap.exists()) {
                throw new Error("Customer payment log not found.");
              }
              const data = customerSnap.data();
              const events = data.events || [];
              const updatedEvents = events.map((ev) =>
                ev.eventId === eventId
                  ? {
                      ...ev,
                      refundApproval: {
                        requested: true,
                        requestedBy:
                          currentUser?.displayName ||
                          currentUser?.email ||
                          "Unknown user",
                        approved: false,
                        approvedBy: "",
                        approvedAt: null,
                        adminToApprove: selectedAdminForRequest,
                        requestAmount: Number(refundAmount),
                        requestReason: refundReason,
                        refundStatus: refundStatus || "Refund New",
                      },
                    }
                  : ev
              );
              await updateDoc(customerRef, { events: updatedEvents });
              setConsumers((prev) =>
                prev.map((c) =>
                  c.id === customerId
                    ? {
                        ...c,
                        events: c.events.map((ev) =>
                          ev.eventId === eventId
                            ? {
                                ...ev,
                                refundApproval: {
                                  requested: true,
                                  requestedBy:
                                    currentUser?.displayName ||
                                    currentUser?.email ||
                                    "Unknown user",
                                  approved: false,
                                  approvedBy: "",
                                  approvedAt: null,
                                  adminToApprove: selectedAdminForRequest,
                                  requestAmount: Number(refundAmount),
                                  requestReason: refundReason,
                                  refundStatus: refundStatus || "Refund New",
                                },
                              }
                            : ev
                        ),
                      }
                    : c
                )
              );
              alert(
                `Refund request for £${refundAmount} sent for approval to ${selectedAdminForRequest}.`
              );
              setRefundModal({ show: false, customerId: null, eventId: null, currentEvent: null });
              setRefundAmount("");
              setRefundReason("");
              setSelectedAdminForRequest("");
              setRefundStatus("");
            } catch (err) {
              alert(`❌ Error: ${err.message}`);
            } finally {
              setLoading(false);
            }
          }}
          disabled={loading}
        >
          {loading ? "Requesting..." : "Request Approval"}
        </button>
      </div>
    </div>
  </div>
)}
{approveModal.show && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    }}
  >
    <div
      style={{
        backgroundColor: "#fff",
        padding: "24px",
        borderRadius: "12px",
        width: "420px",
        textAlign: "center",
      }}
    >
      <h4 style={{ marginBottom: "12px" }}>Approve Refund</h4>
      {approveModal.currentEvent && (
        <>
          <p style={{ marginTop: 0 }}>
            Refund requested:{" "}
            <strong>£{approveModal.currentEvent.refundApproval.requestAmount}</strong>
          </p>
          <p style={{ marginTop: 0 }}>
            Requested by: <strong>{approveModal.currentEvent.refundApproval.requestedBy}</strong>
          </p>
          <p style={{ marginTop: 0 }}>
            Admin to approve:{" "}
            <strong>{approveModal.currentEvent.refundApproval.adminToApprove}</strong>
          </p>
          <p style={{ marginTop: 0 }}>
            Refund Status:{" "}
            <strong>
              {approveModal.currentEvent.refundApproval.refundStatus || "Refund New"}
            </strong>
          </p>
          <p style={{ marginTop: 0 }}>
            Request Reason:{" "}
            <strong>{approveModal.currentEvent.refundApproval.requestReason || "—"}</strong>
          </p>
        </>
      )}
      {/* Approver selects their name */}
      <select
        value={approverName}
        onChange={(e) => setApproverName(e.target.value)}
        style={{
          width: "100%",
          padding: "10px",
          marginBottom: "16px",
          borderRadius: "6px",
          border: "1px solid #ccc",
        }}
      >
        <option value="">Select your name to approve</option>
        {["Aashish", "Vaibhav", "Rohit", "Ananya"].map((a) => (
          <option key={a} value={a}>
            {a}
          </option>
        ))}
      </select>
      {/* Admin password */}
      <input
        type="password"
        placeholder="Enter Admin Password"
        value={approvePassword}
        onChange={(e) => setApprovePassword(e.target.value)}
        style={{
          width: "100%",
          padding: "10px",
          marginBottom: "16px",
          borderRadius: "6px",
          border: "1px solid #ccc",
        }}
      />
      {/* Approver can update the refund status */}
      <select
        value={approveStatus}
        onChange={(e) => setApproveStatus(e.target.value)}
        style={{
          width: "100%",
          padding: "10px",
          marginBottom: "16px",
          borderRadius: "6px",
          border: "1px solid #ccc",
        }}
      >
        <option value="">Update Refund Status</option>
        <option value="Refund New">Refund New</option>
        <option value="Refund Pending">Refund Pending</option>
        <option value="Refund Issued">Refund Issued</option>
        <option value="Refund Confirmed">Refund Confirmed</option>
        <option value="Refund Completed">Refund Completed</option>
      </select>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <button
          style={{
            backgroundColor: "#6B7280",
            color: "#fff",
            padding: "8px 16px",
            borderRadius: "6px",
            cursor: "pointer",
          }}
          onClick={() =>
            setApproveModal({ show: false, customerId: null, eventId: null, currentEvent: null })
          }
        >
          Cancel
        </button>
        <button
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            backgroundColor: "#065F46",
            color: "#fff",
            padding: "8px 16px",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: 500,
          }}
          onClick={async () => {
            try {
              if (!approverName) return alert("Please select your name.");
              if (approvePassword !== "1234") return alert("❌ Invalid admin password.");
              const { customerId, eventId } = approveModal;
              if (!customerId || !eventId) return;
              setLoading(true);
              const customerRef = doc(db, "Payment_Logs", customerId);
              const customerSnap = await getDoc(customerRef);
              if (!customerSnap.exists()) throw new Error("Customer log not found");
              const data = customerSnap.data();
              const events = data.events || [];
              const targetEvent = events.find((ev) => ev.eventId === eventId);
              if (!targetEvent?.refundApproval?.requested)
                throw new Error("No pending refund request found.");
              const nowIso = new Date().toISOString();
              const requestedAmount = targetEvent.refundApproval.requestAmount ?? 0;
              const designatedAdmin = targetEvent.refundApproval.adminToApprove;
              if (designatedAdmin && designatedAdmin !== approverName) {
                const proceed = window.confirm(
                  `This refund was requested to be approved by ${designatedAdmin}. You are signing as ${approverName}. Continue?`
                );
                if (!proceed) {
                  setLoading(false);
                  return;
                }
              }
              const updatedEvents = events.map((ev) => {
                if (ev.eventId !== eventId) return ev;
                return {
                  ...ev,
                  amount: Number(requestedAmount),
                  refundApproval: {
                    ...ev.refundApproval,
                    approved: true,
                    approvedBy: approverName,
                    approvedAt: nowIso,
                    refundStatus: approveStatus || ev.refundApproval.refundStatus || "Refund Pending",
                  },
                };
              });
              await updateDoc(customerRef, { events: updatedEvents });
              setConsumers((prev) =>
                prev.map((c) =>
                  c.id === customerId
                    ? {
                        ...c,
                        events: c.events.map((ev) =>
                          ev.eventId === eventId
                            ? {
                                ...ev,
                                amount: Number(ev.refundApproval.requestAmount ?? ev.amount),
                                refundApproval: {
                                  ...ev.refundApproval,
                                  approved: true,
                                  approvedBy: approverName,
                                  approvedAt: nowIso,
                                  refundStatus: approveStatus || ev.refundApproval.refundStatus || "Refund Pending",
                                },
                              }
                            : ev
                        ),
                      }
                    : c
                )
              );
              try {
                await fetch(
                  "https://us-central1-urbanclapclone-8dc68.cloudfunctions.net/sendAllRefundsFromFirestore",
                  {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ customerId }),
                  }
                );
              } catch (cfErr) {
                console.warn("Notification failed:", cfErr);
              }
              setApproveModal({ show: false, customerId: null, eventId: null, currentEvent: null });
              setApproverName("");
              setApprovePassword("");
              setApproveStatus("");
              alert("✅ Refund approved and updated!");
            } catch (err) {
              alert(`❌ Error: ${err.message}`);
            } finally {
              setLoading(false);
            }
          }}
          disabled={loading}
        >
          {loading ? "Approving..." : "Approve & Apply Refund"}
        </button>
      </div>
    </div>
  </div>
)}
{/* ================= LOGS PROFILE PREVIEW MODAL ================= */}
{logsModal.show && (() => {
  const modalConsumer =
    consumers.find((c) => c.id === logsModal.consumer?.id) || logsModal.consumer;
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "24px",
          borderRadius: "12px",
          width: "750px",
          maxHeight: "80vh",
          overflowY: "auto",
        }}
      >
        <h4 style={{ marginBottom: "16px" }}>
          {modalConsumer?.name} - Logs History Preview
        </h4>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontFamily: "'Inter', sans-serif",
            fontSize: "14px",
          }}
        >
          <thead style={{ backgroundColor: "#F9FAFB" }}>
            <tr>
              <th style={{ padding: "12px" }}>Event</th>
              <th style={{ padding: "12px" }}>Event ID</th>
              <th style={{ padding: "12px" }}>Amount</th>
              <th style={{ padding: "12px" }}>Status</th>
              <th style={{ padding: "12px" }}>Timestamp</th>
              <th style={{ padding: "12px" }}>Request Reason</th>
              <th style={{ padding: "12px" }}>Refund Status</th>
              <th style={{ padding: "12px" }}>Admin To Approve</th>
              <th style={{ padding: "12px" }}>Requested By</th>
              <th style={{ padding: "12px" }}>Request Amount</th>
              <th style={{ padding: "12px" }}>Approved</th>
              <th style={{ padding: "12px" }}>Approved By</th>
              <th style={{ padding: "12px" }}>Approved At</th>
            </tr>
          </thead>
          <tbody>
            {(modalConsumer?.events || []).map((log, idx) => {
              const refundStatus = log.refundApproval?.refundStatus || "-";
              return (
                <tr
                  key={log.eventId}
                  style={{
                    backgroundColor: idx % 2 === 0 ? "#fff" : "#F9FAFB",
                    borderBottom: "1px solid #E5E7EB",
                  }}
                >
                  {/* Event */}
                  <td style={{ padding: "12px" }}>{log.eventType}</td>
                  {/* Event ID */}
                  <td style={{ padding: "12px" }}>{log.eventId}</td>
                  {/* Amount (Always live updated) */}
                  <td style={{ padding: "12px", fontWeight: "600", color: "#111827" }}>
                    {log.amount}
                  </td>
                  {/* Payment Status */}
                  <td style={{ padding: "12px" }}>
                    <span
                      style={{
                        display: "inline-block",
                        padding: "4px 10px",
                        borderRadius: "6px",
                        fontSize: "12px",
                        fontWeight: 600,
                        color:
                          log.status === "success"
                            ? "#166534"
                            : log.status === "failed"
                            ? "#B91C1C"
                            : log.status === "pending"
                            ? "#B45309"
                            : "#374151",
                        backgroundColor:
                          log.status === "success"
                            ? "#DCFCE7"
                            : log.status === "failed"
                            ? "#FEE2E2"
                            : log.status === "pending"
                            ? "#FEF3C7"
                            : "#E5E7EB",
                      }}
                    >
                      {log.status}
                    </span>
                  </td>
                  {/* Timestamp */}
                  <td style={{ padding: "12px" }}>{prettyTime(log.timestamp)}</td>
                  {/* Request Reason */}
                  <td style={{ padding: "12px" }}>
                    {log.requestReason || "—"}
                  </td>
                  {/* Refund Status Badge */}
                  <td style={{ padding: "12px" }}>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "4px 10px",
                        borderRadius: "6px",
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "#fff",
                        backgroundColor:
                          refundStatus === "Refund New"
                            ? "#F59E0B"
                            : refundStatus === "Refund Pending"
                            ? "#D97706"
                            : refundStatus === "Refund Issued"
                            ? "#3B82F6"
                            : refundStatus === "Refund Confirmed"
                            ? "#8B5CF6"
                            : refundStatus === "Refund Completed"
                            ? "#10B981"
                            : "#6B7280",
                      }}
                    >
                      {refundStatus}
                    </span>
                  </td>
                  {/* Admin To Approve */}
                  <td style={{ padding: "12px" }}>
                    {log.refundApproval?.adminToApprove || "—"}
                  </td>
                  {/* Requested By */}
                  <td style={{ padding: "12px" }}>
                    {log.refundApproval?.requestedBy || "—"}
                  </td>
                  {/* Request Amount */}
                  <td style={{ padding: "12px" }}>
                    £{log.refundApproval?.requestAmount || "—"}
                  </td>
                  {/* Approved */}
                  <td style={{ padding: "12px" }}>
                    {log.refundApproval?.approved ? "Yes" : "No"}
                  </td>
                  {/* Approved By */}
                  <td style={{ padding: "12px" }}>
                    {log.refundApproval?.approvedBy || "—"}
                  </td>
                  {/* Approved At */}
                  <td style={{ padding: "12px" }}>
                    {log.refundApproval?.approvedAt
                      ? prettyTime(log.refundApproval.approvedAt)
                      : "—"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div style={{ textAlign: "right", marginTop: "16px" }}>
          <button
            style={{
              backgroundColor: "#6B7280",
              color: "#fff",
              padding: "8px 16px",
              borderRadius: "6px",
              cursor: "pointer",
            }}
            onClick={() => setLogsModal({ show: false })}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
})()}
</div>
    </div>
</div>  
)}

{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "financialBookings" &&
  showFinancialBookings && (
  <div
    className="admin-container"
    style={{
      maxWidth: "1800px",
      margin: "0 auto",
      width: "100%",
      fontFamily: "'Poppins', sans-serif",
    }}
  >
    {/* ------------------- SINGLE WHITE TAB ------------------- */}
    <div
      style={{
        background: "#ffffff",
        borderRadius: "12px",
        padding: "24px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        border: "1px solid #e5e7eb",
      }}
    >
      {/* ------------------- Header ------------------- */}
      <h3
        style={{
          margin: 0,
          fontSize: "24px",
          fontWeight: "700",
          color: "#111827",
        }}
      >
        💼 Financial Overview Dashboard
      </h3>
      <p
        style={{
          color: "#6B7280",
          fontSize: "14px",
          fontFamily: "'Inter', sans-serif",
          marginTop: "8px",
          marginBottom: "24px",
        }}
      >
        Summary of all invoices and customer financial activities
      </p>
      {/* ------------------- Chart ------------------- */}
      <div style={{ marginBottom: "32px" }}>
        <h4
          style={{
            fontSize: "18px",
            fontWeight: "600",
            marginBottom: "16px",
            color: "#1F2937",
            fontFamily: "'Inter', sans-serif",
          }}
        >
          Number of Invoices per Customer
        </h4>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={Object.values(
              invoiceList.reduce((acc, inv) => {
                acc[inv.customer] =
                  acc[inv.customer] || { customer: inv.customer, count: 0 };
                acc[inv.customer].count += 1;
                return acc;
              }, {})
            )}
          >
            <XAxis dataKey="customer" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="count" fill="#F59E0B" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      {/* ------------------- Financial Bookings Header ------------------- */}
      <h3
        style={{
          margin: 0,
          fontSize: "22px",
          fontWeight: "700",
          color: "#111827",
        }}
      >
        📘 Financial Bookings
      </h3>
      <p
        style={{
          color: "#6B7280",
          fontSize: "14px",
          fontFamily: "'Inter', sans-serif",
          marginTop: "8px",
          marginBottom: "20px",
        }}
      >
        Manage and review all financial invoices and payment logs
      </p>
      {/* ------------------- Tab Buttons ------------------- */}
      <div
        style={{
          display: "flex",
          gap: "12px",
          flexWrap: "wrap",
          justifyContent: "center",
          marginBottom: "24px",
        }}
      >
        {["invoices", "payments"].map((tab) => (
          <button
            key={tab}
            onClick={() => {
              setCurrentFinancialTab(tab);
              if (tab !== "invoices") {
                setCurrentView("paymentLogs");
                setShowFinancialOverview(false);
              }
            }}
            style={{
              padding: "10px 18px",
              borderRadius: "12px",
              border: "none",
              cursor: "pointer",
              fontWeight: "600",
              fontSize: "14px",
              backgroundColor:
                currentFinancialTab === tab ? "#4F46E5" : "#E5E7EB",
              color: currentFinancialTab === tab ? "#fff" : "#374151",
              transition: "all 0.3s",
            }}
          >
            {tab === "invoices" ? "Invoice List" : "Payment Logs"}
          </button>
        ))}
      </div>
      {/* ------------------- Invoice List Tab ------------------- */}
      {currentFinancialTab === "invoices" && (
        <>
          <h4 className="text-lg font-semibold text-gray-800 mb-4">
            Invoice List
          </h4>
          {/* ---------- Invoice Table ---------- */}
          <table className="borderless-table w-full text-left font-inter">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="py-3 px-4 text-sm font-semibold text-gray-700">#</th>
                <th className="py-3 px-4 text-sm font-semibold text-gray-700">Invoice ID</th>
                <th className="py-3 px-4 text-sm font-semibold text-gray-700">Customer</th>
                <th className="py-3 px-4 text-sm font-semibold text-gray-700">Amount</th>
                <th className="py-3 px-4 text-sm font-semibold text-gray-700">Status</th>
                <th className="py-3 px-4 text-sm font-semibold text-gray-700">Action</th>
              </tr>
            </thead>
            <tbody>
              {invoiceList.map((invoice, index) => (
                <tr
                  key={invoice.id}
                  className="border-b border-gray-100 hover:bg-gray-50 transition"
                >
                  <td className="py-3 px-4">{index + 1}</td>
                  <td className="py-3 px-4">
                    {editingIndex === index ? (
                      <input
                        type="text"
                        className="input input-bordered w-full rounded-md border-gray-300"
                        value={editedId}
                        onChange={(e) => setEditedId(e.target.value)}
                      />
                    ) : (
                      invoice.id
                    )}
                  </td>
                  <td className="py-3 px-4">
                    {editingIndex === index ? (
                      <input
                        type="text"
                        className="input input-bordered w-full rounded-md border-gray-300"
                        value={editedCustomer}
                        onChange={(e) => setEditedCustomer(e.target.value)}
                      />
                    ) : (
                      invoice.customer
                    )}
                  </td>
                  <td className="py-3 px-4">
                    {editingIndex === index ? (
                      <input
                        type="text"
                        className="input input-bordered w-full rounded-md border-gray-300"
                        value={editedAmount}
                        onChange={(e) => setEditedAmount(e.target.value)}
                      />
                    ) : (
                      typeof invoice.amount === "string"
                        ? invoice.amount.replace(/^\$/, "£")
                        : `£${invoice.amount}`
                    )}
                  </td>
                  <td className="py-3 px-4 text-center">
                    {editingIndex === index ? (
                      <select
                        value={editedStatus}
                        onChange={(e) => {
                          const updatedStatus = e.target.value;
                          setEditedStatus(updatedStatus);
                          localStorage.setItem(
                            `invoiceStatus_${invoice.id}`,
                            updatedStatus
                          );
                        }}
                        className="select select-bordered rounded-lg border-gray-300 px-3 py-2 text-sm font-semibold"
                      >
                        <option value="paid">Published ✅</option>
                        <option value="unpaid">UnPublished ❌</option>
                      </select>
                    ) : (
                      <span
                        className={`px-4 py-1.5 rounded-full text-xs font-bold tracking-wide shadow-sm ${
                          invoice.status === "paid"
                            ? "bg-green-100 text-green-800 border border-green-300"
                            : "bg-red-100 text-red-800 border border-red-300"
                        }`}
                      >
                        {invoice.status === "paid" ? "✅ Published" : "❌ UnPublished"}
                      </span>
                    )}
                  </td>
                  <td className="py-3 px-4 flex flex-col items-center gap-2">
                    {editingIndex === index ? (
                      <button
                        onClick={() => {
                          if (typeof handleConfirmSave === "function") {
                            handleConfirmSave(invoice.id);
                          }
                          setInvoiceList((prev) =>
                            prev.map((inv, i) =>
                              i === index
                                ? {
                                    ...inv,
                                    id: editedId || inv.id,
                                    customer: editedCustomer || inv.customer,
                                    amount: editedAmount !== undefined ? editedAmount : inv.amount,
                                    status: editedStatus || inv.status,
                                  }
                                : inv
                            )
                          );
                          setPreviewInvoice((prev) =>
                            prev && prev.id === invoice.id
                              ? {
                                  ...prev,
                                  id: editedId || prev.id,
                                  customer: editedCustomer || prev.customer,
                                  amount: editedAmount !== undefined ? editedAmount : prev.amount,
                                  status: editedStatus || prev.status,
                                }
                              : prev
                          );
                          if (typeof setEditingIndex === "function") {
                            setEditingIndex(null);
                          }
                        }}
                        style={{ backgroundColor: "#2563eb", color: "white" }}
                        className="px-3 py-2 rounded"
                      >
                        Save
                      </button>
                    ) : (
                      <button
                        onClick={() =>
                          handleStartEdit(
                            index,
                            invoice.id,
                            invoice.customer,
                            invoice.amount,
                            invoice.status
                          )
                        }
                        style={{ backgroundColor: "#ff4500", color: "white" }}
                        className="px-3 py-2 rounded flex items-center justify-center w-full"
                      >
                        <FaEdit />
                      </button>
                    )}
                    <button
                      onClick={() => {
                        setInvoiceList((prev) => {
                          const updated = prev.filter((inv) => inv.id !== invoice.id);
                          toast.error(
                            `Invoice "${invoice.id}" deleted successfully`,
                            { position: "top-right", autoClose: 2000 }
                          );
                          return updated;
                        });
                      }}
                      style={{ backgroundColor: "black", color: "white" }}
                      className="px-3 py-2 rounded"
                    >
                      <FaTrash />
                    </button>
                    <button
                      onClick={() => {
                        if (invoice.id === "2E47B723-0001") {
                          window.open(
                            "/invoices/Invoice-2E47B723-0001.pdf",
                            "_blank"
                          );
                        } else {
                          const currentAmount =
                            editingIndex === index ? editedAmount : invoice.amount;
                          const currentCustomer =
                            editingIndex === index ? editedCustomer : invoice.customer;
                          const currentId =
                            editingIndex === index ? editedId : invoice.id;
                          const currentStatus =
                            editingIndex === index ? editedStatus : invoice.status;
                          setPreviewInvoice({
                            ...invoice,
                            id: currentId,
                            customer: currentCustomer,
                            amount: currentAmount,
                            status: currentStatus,
                          });
                        }
                      }}
                      style={{ backgroundColor: "#7c3aed", color: "white" }}
                      className="px-3 py-2 rounded w-full"
                    >
                      Preview
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {/* ---------- Invoice Preview Popup ---------- */}
          {previewInvoice && (() => {
            const currentInvoiceData =
              invoiceList.find((inv) => inv.id === previewInvoice.id) || previewInvoice;
            const rawAmount =
              currentInvoiceData.amount !== undefined && currentInvoiceData.amount !== ""
                ? currentInvoiceData.amount
                : previewInvoice.amount || "0.00";
            const numericCleanAmount = String(rawAmount).replace(/^[\$£\s]+/, "");
            const formattedAmount = `£${numericCleanAmount}`;
            return (
              <div
                className="invoice-preview-popup"
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  backgroundColor: "rgba(0,0,0,0.5)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1000,
                }}
              >
                <div
                  style={{
                    backgroundColor: "#fff",
                    padding: "60px",
                    borderRadius: "20px",
                    minWidth: "400px",
                    maxWidth: "90vw",
                    position: "relative",
                  }}
                >
                  <h4 style={{ marginBottom: "50px" }}>Invoice Preview</h4>
                  {/* ---------- Custom invoice details based on ID ---------- */}
                  {previewInvoice.id === "in_1REVqQQvoACPyOLkWaP9Fyic" && (
                    <>
                      <p><strong>Invoice number:</strong> 508813390001</p>
                      <p><strong>Date of issue:</strong> April 16, 2025</p>
                      <p><strong>Date due:</strong> April 23, 2025</p>
                      <p><strong>Business:</strong> New business sandbox</p>
                      <p><strong>Country:</strong> United Kingdom</p>
                      <p><strong>Bill to:</strong> {currentInvoiceData.customer || "customer@example.com"}</p>
                      <hr />
                      <p><strong>Description:</strong> New business sandbox</p>
                      <p><strong>Qty:</strong> 1</p>
                      <p><strong>Unit price:</strong> {formattedAmount}</p>
                      <p><strong>Amount:</strong> {formattedAmount}</p>
                      <p><strong>Subtotal:</strong> {formattedAmount}</p>
                      <p><strong>Total:</strong> {formattedAmount}</p>
                      <p><strong>Amount due:</strong> {formattedAmount} GBP</p>
                    </>
                  )}
                  {previewInvoice.id === "in_1RET8bQvoACPyOLkI5tEUMKK" && (
                    <>
                      <p><strong>Invoice number:</strong> 185D76040001</p>
                      <p><strong>Date of issue:</strong> April 16, 2025</p>
                      <p><strong>Date due:</strong> April 23, 2025</p>
                      <p><strong>Business:</strong> New business sandbox</p>
                      <p><strong>Country:</strong> United Kingdom</p>
                      <p><strong>Bill to:</strong> {currentInvoiceData.customer || "customer@example.com"}</p>
                      <hr />
                      <p><strong>Description:</strong> New business sandbox</p>
                      <p><strong>Qty:</strong> 1</p>
                      <p><strong>Unit price:</strong> {formattedAmount}</p>
                      <p><strong>Amount:</strong> {formattedAmount}</p>
                      <p><strong>Subtotal:</strong> {formattedAmount}</p>
                      <p><strong>Total:</strong> {formattedAmount}</p>
                      <p><strong>Amount due:</strong> {formattedAmount} GBP</p>
                    </>
                  )}
                  {previewInvoice.id === "in_1RERHbQvoACPyOLk5oyMRBtH" && (
                    <>
                      <p><strong>Invoice number:</strong> D211C2EE0001</p>
                      <p><strong>Date of issue:</strong> April 16, 2025</p>
                      <p><strong>Date due:</strong> April 23, 2025</p>
                      <p><strong>Business:</strong> New business sandbox</p>
                      <p><strong>Country:</strong> United Kingdom</p>
                      <p><strong>Bill to:</strong> {currentInvoiceData.customer || "customer@example.com"}</p>
                      <hr />
                      <p><strong>Description:</strong> New business sandbox</p>
                      <p><strong>Qty:</strong> 1</p>
                      <p><strong>Unit price:</strong> {formattedAmount}</p>
                      <p><strong>Amount:</strong> {formattedAmount}</p>
                      <p><strong>Subtotal:</strong> {formattedAmount}</p>
                      <p><strong>Total:</strong> {formattedAmount}</p>
                      <p><strong>Amount due:</strong> {formattedAmount} GBP</p>
                    </>
                  )}
                  {previewInvoice.id === "in_1RER8rQvoACPyOLk9YAVL7fd" && (
                    <>
                      <p><strong>Invoice number:</strong> 726C39740001</p>
                      <p><strong>Date of issue:</strong> April 16, 2025</p>
                      <p><strong>Date due:</strong> April 23, 2025</p>
                      <p><strong>Business:</strong> New business sandbox</p>
                      <p><strong>Country:</strong> United Kingdom</p>
                      <p><strong>Bill to:</strong> {currentInvoiceData.customer || "customer@example.com"}</p>
                      <hr />
                      <p><strong>Description:</strong> New business sandbox</p>
                      <p><strong>Qty:</strong> 1</p>
                      <p><strong>Unit price:</strong> {formattedAmount}</p>
                      <p><strong>Amount:</strong> {formattedAmount}</p>
                      <p><strong>Subtotal:</strong> {formattedAmount}</p>
                      <p><strong>Total:</strong> {formattedAmount}</p>
                      <p><strong>Amount due:</strong> {formattedAmount} GBP</p>
                    </>
                  )}
                  {previewInvoice.id === "in_1RER6cQvoACPyOLkZjcwXXre" && (
                    <>
                      <p><strong>Invoice number:</strong> 108386810001</p>
                      <p><strong>Date of issue:</strong> April 16, 2025</p>
                      <p><strong>Date due:</strong> April 16, 2025</p>
                      <p><strong>Business:</strong> New business sandbox</p>
                      <p><strong>Country:</strong> United Kingdom</p>
                      <p><strong>Bill to:</strong> {currentInvoiceData.customer || "Customer for userId: abc123"}</p>
                      <p><strong>Email:</strong> customer@example.com</p>
                      <hr />
                      <p><strong>Description:</strong> New business sandbox</p>
                      <p><strong>Qty:</strong> 1</p>
                      <p><strong>Unit price:</strong> {formattedAmount}</p>
                      <p><strong>Amount:</strong> {formattedAmount}</p>
                      <p><strong>Subtotal:</strong> {formattedAmount}</p>
                      <p><strong>Total:</strong> {formattedAmount}</p>
                      <p><strong>Amount due:</strong> {formattedAmount} GBP</p>
                    </>
                  )}
                  {/* Fallback for any other updated invoice */}
                  {![
                    "in_1REVqQQvoACPyOLkWaP9Fyic",
                    "in_1RET8bQvoACPyOLkI5tEUMKK",
                    "in_1RERHbQvoACPyOLk5oyMRBtH",
                    "in_1RER8rQvoACPyOLk9YAVL7fd",
                    "in_1RER6cQvoACPyOLkZjcwXXre",
                  ].includes(previewInvoice.id) && (
                    <>
                      <p><strong>Invoice ID:</strong> {currentInvoiceData.id}</p>
                      <p><strong>Customer:</strong> {currentInvoiceData.customer}</p>
                      <p><strong>Status:</strong> {currentInvoiceData.status}</p>
                      <hr />
                      <p><strong>Unit price:</strong> {formattedAmount}</p>
                      <p><strong>Amount:</strong> {formattedAmount}</p>
                      <p><strong>Subtotal:</strong> {formattedAmount}</p>
                      <p><strong>Total:</strong> {formattedAmount}</p>
                      <p><strong>Amount due:</strong> {formattedAmount} GBP</p>
                    </>
                  )}

                  <button
                    onClick={() => window.print()}
                    style={{
                      position: "absolute",
                      top: "30px",
                      right: "120px",
                      backgroundColor: "#28a745",
                      color: "#fff",
                      border: "none",
                      width: "100px",
                      padding: "10px",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    Print
                  </button>
                  <button
                    onClick={() => setPreviewInvoice(null)}
                    style={{
                      position: "absolute",
                      top: "100px",
                      right: "120px",
                      backgroundColor: "#dc3545",
                      color: "#fff",
                      border: "none",
                      width: "100px",
                      padding: "10px",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            );
          })()}
        </>
      )}
    </div>
  </div> 
)}
<div>
</div>


{/* ======================================================================
    BOOKING DASHBOARD — styled like your Provider Booking List
    - JSX block only: no imports, no hooks, no new useState.
    - Uses your existing headerStyle, titleStyle, cardStyle.
    - Uses your existing state/handlers: currentUser, currentView,
      bookingFilters, updateBookingFilter, resetBookingFilters,
      loadBookingRegistry, isRegistryLoading, registryError,
      analyticsBookings, dateRangeFilteredBookings, visibleBookingRegistry,
      presentCellValue
    - UI state (search, dropdowns, page, details popup, calendar, status modal)
      is stored in bookingFilters.bd_ui through updateBookingFilter.
   ====================================================================== */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "manageBookings" &&
  (() => {
    /* ---------- helpers ---------- */
    const DAY = 86400000;
    const PAGE_SIZE = 10;
    const str = (v) => (typeof v === "string" || typeof v === "number" ? String(v) : "");
    const first = (...v) => v.find((x) => x !== undefined && x !== null && x !== "");
    const toDate = (v) => {
      if (v === null || v === undefined || v === "") return null;
      if (v instanceof Date) return isNaN(v) ? null : v;
      if (typeof v.toDate === "function") return v.toDate();
      if (typeof v === "number") return new Date(v < 1e12 ? v * 1000 : v);
      if (typeof v === "object") {
        const s = v.seconds ?? v._seconds;
        return s != null ? new Date(s * 1000) : null;
      }
      if (typeof v === "string") {
        const m = v.trim().match(/^(\d{1,2})[-/.](\d{1,2})[-/.](\d{4})(?:[ T,]+(\d{1,2}):(\d{2}))?/);
        if (m) return new Date(+m[3], +m[2] - 1, +m[1], +(m[4] || 0), +(m[5] || 0));
        const d = new Date(v);
        return isNaN(d) ? null : d;
      }
      return null;
    };
    const sod = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const eod = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);
    const sameDay = (a, b) => sod(a).getTime() === sod(b).getTime();
    const fmtDate = (d) => d.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" });
    const fmtTime = (d) => d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
    const getId = (b) => str(first(b.id, b.bookingId, b.booking_id, b.docId)) || "-";
    const getDate = (b) => {
      const known = toDate(first(b.bookingDate, b.scheduledDate, b.serviceDate, b.date, b.scheduledAt, b.startTime, b.createdAt, b.timestamp));
      if (known) return known;
      for (const k of Object.keys(b)) {
        if (/date|time|created|booked|scheduled|at$/i.test(k)) {
          const d = toDate(b[k]);
          if (d && d.getFullYear() > 2000) return d;
        }
      }
      return null;
    };
    const getCustomer = (b) => str(first(b.customerName, b.customer_name, b.customer?.name, b.userName, b.name)) || "-";
    const getPhone = (b) => str(first(b.customerPhone, b.customer_phone, b.phone, b.customer?.phone)) || "-";
    const getService = (b) => str(first(b.serviceName, b.service_name, b.service?.name, b.service, b.category, b.serviceType)) || "Service";
    const getProvider = (b) => str(first(b.providerName, b.provider_name, b.provider?.name, b.assignedProvider)) || "Unassigned";
    const getRating = (b) => str(first(b.providerRating, b.provider?.rating));
    const getLocation = (b) => str(first(b.city, b.postcode, b.location, b.address)) || "Unknown";
    const normStatus = (s) => {
      const v = String(s || "").toLowerCase().replace(/[\s_-]/g, "");
      if (v.includes("cancel")) return "cancelled";
      if (v.includes("complete")) return "completed";
      if (v.includes("progress") || v.includes("started") || v.includes("ongoing")) return "inprogress";
      if (v.includes("confirm")) return "confirmed";
      if (v.includes("schedul")) return "scheduled";
      return v || "pending";
    };
    const stOf = (b) => normStatus(b.status || b.bookingStatus);
    const STATUS = {
      confirmed: { label: "Confirmed", color: "#10B981", bg: "#D1FAE5" },
      inprogress: { label: "In Progress", color: "#F59E0B", bg: "#FEF3C7" },
      completed: { label: "Completed", color: "#2563EB", bg: "#DBEAFE" },
      pending: { label: "Pending", color: "#FBBF24", bg: "#FEF3C7" },
      cancelled: { label: "Cancelled", color: "#EF4444", bg: "#FEE2E2" },
      scheduled: { label: "Scheduled", color: "#6B7280", bg: "#F3F4F6" },
      rated: { label: "Rated", color: "#8B5CF6", bg: "#EDE9FE" },
      paymentpending: { label: "Payment Pending", color: "#F97316", bg: "#FFEDD5" },
      ontheway: { label: "On The Way", color: "#06B6D4", bg: "#CFFAFE" },
      paid: { label: "Paid", color: "#14B8A6", bg: "#CCFBF1" },
      arrived: { label: "Arrived", color: "#3B82F6", bg: "#DBEAFE" },
    };
    const stInfo = (k) => {
      if (STATUS[k]) return STATUS[k];
      const prettyLabel = k
        .replace(/paymentpending/i, "Payment Pending")
        .replace(/ontheway/i, "On The Way")
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/\b\w/g, (c) => c.toUpperCase());
      return { label: prettyLabel, color: "#6B7280", bg: "#F3F4F6" };
    };
    /* ---------- shared styles ---------- */
    const FONT_BODY = "'Inter', sans-serif";
    const FONT_HEAD = "'Poppins', sans-serif";
    const boxStyle = {
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      marginTop: "20px",
      overflowX: "auto",
      position: "relative",
    };
    const h3Style = { margin: 0, fontFamily: FONT_HEAD, fontSize: "20px", fontWeight: "700", color: "#111827" };
    const mutedStyle = { fontSize: "13px", color: "#6B7280" };
    const inputStyle = { padding: "10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "14px", fontFamily: FONT_BODY, color: "#374151", backgroundColor: "#fff" };
    const btn = (bg, extra = {}) => ({ backgroundColor: bg, color: "#fff", padding: "6px 12px", borderRadius: "6px", border: "none", fontSize: "12px", fontWeight: "600", cursor: "pointer", ...extra });
    const thStyle = { padding: "12px 10px", fontSize: "13px", fontWeight: "600", color: "#374151", whiteSpace: "nowrap" };
    const tdStyle = { padding: "10px", whiteSpace: "nowrap" };
    const pill = (k) => {
      const s = stInfo(k);
      return <span style={{ display: "inline-block", padding: "3px 12px", borderRadius: "999px", fontSize: "12px", fontWeight: "600", color: s.color, backgroundColor: s.bg }}>{s.label}</span>;
    };

    /* ---------- UI state stored in bookingFilters.bd_ui ---------- */
    const ui = {
      search: "",
      status: "",
      service: "",
      date: "",
      page: 1,
      detail: null,
      showCalendar: false,
      calMonthOffset: 0,
      showStatusModal: false,
      ...(bookingFilters.bd_ui || {}),
    };
    const setUi = (patch) => updateBookingFilter("bd_ui", { ...ui, ...patch });
    const all = Array.isArray(analyticsBookings) ? analyticsBookings : [];
    const rowsSource = Array.isArray(dateRangeFilteredBookings) ? dateRangeFilteredBookings : visibleBookingRegistry || [];
    const now = new Date();
    /* ---------- KPI cards ---------- */
    const hasRange = bookingFilters.fromDate && bookingFilters.toDate;
    const pTo = hasRange ? eod(new Date(bookingFilters.toDate)) : eod(now);
    const pFrom = hasRange ? sod(new Date(bookingFilters.fromDate)) : sod(new Date(pTo.getTime() - 6 * DAY));
    const pLen = pTo.getTime() - pFrom.getTime() + 1;
    const pDays = Math.max(1, Math.round(pLen / DAY));
    const countIn = (key, a, b) =>
      all.filter((x) => {
        const d = getDate(x);
        return d && d >= a && d <= b && (key === "total" || stOf(x) === key);
      }).length;
    const kpis = [
      { key: "total", label: "📦 Total Bookings", color: "#2563EB" },
      { key: "confirmed", label: "✅ Confirmed", color: "#10B981" },
      { key: "inprogress", label: "⏳ In Progress", color: "#F59E0B" },
      { key: "completed", label: "🏁 Completed", color: "#2563EB" },
      { key: "cancelled", label: "❌ Cancelled", color: "#EF4444" },
    ].map((c) => {
      const value = c.key === "total" ? all.length : all.filter((x) => stOf(x) === c.key).length;
      const cur = countIn(c.key, pFrom, pTo);
      const prev = countIn(c.key, new Date(pFrom.getTime() - pLen), new Date(pFrom.getTime() - 1));
      return { ...c, value, pct: prev ? ((cur - prev) / prev) * 100 : null };
    });
    /* ---------- operational highlights & locations ---------- */
    const unassignedCount = all.filter((b) => getProvider(b).toLowerCase().includes("unassigned")).length;
    const assignedPct = all.length ? (((all.length - unassignedCount) / all.length) * 100).toFixed(0) : "0";
    const completedCount = all.filter((b) => stOf(b) === "completed").length;
    const completionRate = all.length ? ((completedCount / all.length) * 100).toFixed(0) : "0";
    const locMap = {};
    all.forEach((b) => {
      const loc = getLocation(b);
      locMap[loc] = (locMap[loc] || 0) + 1;
    });
    const topLocations = Object.entries(locMap).sort((a, b) => b[1] - a[1]).slice(0, 4);
    /* ---------- schedule & status breakdown data ---------- */
    const schedule = all.filter((b) => { const d = getDate(b); return d && sameDay(d, now); }).sort((a, b) => getDate(a) - getDate(b)).slice(0, 5);
    const splitMap = {};
    all.forEach((b) => { splitMap[stOf(b)] = (splitMap[stOf(b)] || 0) + 1; });
    const splitTotal = Object.values(splitMap).reduce((s, x) => s + x, 0);
    const statusBars = [
      { key: "confirmed", label: "Confirmed", color: "#10B981", bg: "#D1FAE5", count: splitMap.confirmed || 0 },
      { key: "inprogress", label: "In Progress", color: "#F59E0B", bg: "#FEF3C7", count: splitMap.inprogress || 0 },
      { key: "completed", label: "Completed", color: "#2563EB", bg: "#DBEAFE", count: splitMap.completed || 0 },
      { key: "pending", label: "Pending", color: "#FBBF24", bg: "#FEF3C7", count: splitMap.pending || 0 },
      { key: "cancelled", label: "Cancelled", color: "#EF4444", bg: "#FEE2E2", count: splitMap.cancelled || 0 },
    ];
    if (splitMap.scheduled) {
      statusBars.push({ key: "scheduled", label: "Scheduled", color: "#6B7280", bg: "#F3F4F6", count: splitMap.scheduled });
    }
    Object.keys(splitMap).forEach((k) => {
      if (!statusBars.some((sb) => sb.key === k)) {
        const inf = stInfo(k);
        statusBars.push({ key: k, label: inf.label, color: inf.color, bg: inf.bg, count: splitMap[k] });
      }
    });
    const svcMap = {};
    all.forEach((b) => { const s = getService(b); svcMap[s] = (svcMap[s] || 0) + 1; });
    const topSvc = Object.entries(svcMap).sort((a, b) => b[1] - a[1]).slice(0, 5);
    /* ---------- table filters & pagination ---------- */
    const serviceOptions = [...new Set(rowsSource.map(getService))].sort();
    const statusOptions = [...new Set(rowsSource.map(stOf))];
    const q = ui.search.trim().toLowerCase();
    const rows = rowsSource.filter((b) => {
      if (ui.status && stOf(b) !== ui.status) return false;
      if (ui.service && getService(b) !== ui.service) return false;
      if (ui.date) {
        const d = getDate(b);
        if (!d) return false;
        if (ui.date === "today" && !sameDay(d, now)) return false;
        if (ui.date === "7" && d < new Date(now.getTime() - 7 * DAY)) return false;
        if (ui.date === "30" && d < new Date(now.getTime() - 30 * DAY)) return false;
      }
      return !q || [getId(b), getCustomer(b), getPhone(b), getService(b), getProvider(b), getLocation(b)].join(" ").toLowerCase().includes(q);
    });
    const pages = Math.max(1, Math.ceil(rows.length / PAGE_SIZE));
    const page = Math.min(Math.max(1, Number(ui.page) || 1), pages);
    const pageRows = rows.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
    const pageNums = [...new Set(Array.from({ length: Math.min(5, pages) }, (_, i) => Math.min(Math.max(page - 2, 1) + i, pages)))];
    const detail = ui.detail ? rowsSource.concat(all).find((b) => getId(b) === ui.detail) : null;
    /* ---------- export report functionality ---------- */
    const exportCsv = () => {
      const source = rows.length ? rows : all;
      if (!source.length) {
        alert("No bookings available to export.");
        return;
      }
      const headers = ["Booking ID", "Customer Name", "Customer Phone", "Service", "Provider", "Date", "Time", "Location", "Status"];
      const escape = (val) => `"${String(val ?? "").replace(/"/g, '""')}"`;
      const lines = [
        headers.join(","),
        ...source.map((b) => {
          const d = getDate(b);
          return [
            escape(getId(b)),
            escape(getCustomer(b)),
            escape(getPhone(b)),
            escape(getService(b)),
            escape(getProvider(b)),
            escape(d ? fmtDate(d) : "-"),
            escape(d ? fmtTime(d) : "-"),
            escape(getLocation(b)),
            escape(stInfo(stOf(b)).label),
          ].join(",");
        }),
      ];
      const blob = new Blob(["\uFEFF" + lines.join("\n")], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `bookings-report-${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    };
    /* ---------- calendar calculation ---------- */
    const calTargetDate = new Date(now.getFullYear(), now.getMonth() + (ui.calMonthOffset || 0), 1);
    const calYear = calTargetDate.getFullYear();
    const calMonth = calTargetDate.getMonth();
    const calMonthName = calTargetDate.toLocaleDateString("en-US", { month: "long", year: "numeric" });
    const firstDayIndex = new Date(calYear, calMonth, 1).getDay();
    const totalDaysInMonth = new Date(calYear, calMonth + 1, 0).getDate();
    const calCells = [];
    for (let i = 0; i < firstDayIndex; i++) calCells.push(null);
    for (let d = 1; d <= totalDaysInMonth; d++) calCells.push(new Date(calYear, calMonth, d));

    /* ---------- modal SVG bar graph metrics (wide, spacious, zero collisions) ---------- */
    const mW = 760, mH = 250, mPL = 44, mPR = 24, mPT = 24, mPB = 62;
    const mMax = Math.max(1, ...statusBars.map((s) => s.count));
    const mNiceMax = Math.ceil(mMax / 4) * 4 || 4;
    const mSlotW = (mW - mPL - mPR) / Math.max(1, statusBars.length);
    const mBarW = Math.min(36, mSlotW * 0.48);
    const myAt = (v) => mPT + (1 - v / mNiceMax) * (mH - mPT - mPB);
    const mBaseline = myAt(0);

    return (
      <div className="admin-container">
        {/* ================= PAGE HEADER ================= */}
        <div style={headerStyle}>
          <h3 style={titleStyle}>Booking Dashboard</h3>
        </div>
        {/* ================= MAIN CONTAINER ================= */}
        <div style={{ ...cardStyle, maxWidth: "none", margin: 0, width: "100%", boxSizing: "border-box", textAlign: "center", fontFamily: FONT_BODY }}>
          <h3 style={{ ...h3Style, fontSize: "22px" }}>📊 Booking Dashboard</h3>
          <p style={{ ...mutedStyle, margin: "6px 0 0" }}>Monitor, manage and track all bookings</p>
          {/* ---------- toolbar ---------- */}
          <div style={{ ...boxStyle, display: "flex", gap: "12px", flexWrap: "wrap", alignItems: "center", justifyContent: "center" }}>
            <label style={{ ...mutedStyle, fontWeight: 600 }}>
              From{" "}
              <input type="date" style={inputStyle} value={bookingFilters.fromDate || ""} onChange={(e) => updateBookingFilter("fromDate", e.target.value)} />
            </label>
            <label style={{ ...mutedStyle, fontWeight: 600 }}>
              To{" "}
              <input type="date" style={inputStyle} value={bookingFilters.toDate || ""} onChange={(e) => updateBookingFilter("toDate", e.target.value)} />
            </label>
            <button onClick={resetBookingFilters} style={btn("#111827", { padding: "10px 16px", fontSize: "13px" })}>♻️ Reset</button>
            <button onClick={loadBookingRegistry} disabled={isRegistryLoading} style={btn("#2563EB", { padding: "10px 16px", fontSize: "13px", opacity: isRegistryLoading ? 0.7 : 1 })}>
              {isRegistryLoading ? "Refreshing…" : "🔄 Refresh"}
            </button>
            <span style={mutedStyle}>Dates apply once both From and To are selected.</span>
          </div>
          {registryError && (
            <div style={{ ...boxStyle, backgroundColor: "#FEE2E2", color: "#991B1B", fontSize: "14px" }} role="alert">
              ❌ Couldn't load bookings. {registryError}
            </div>
          )}
          {/* ---------- KPI row ---------- */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))", gap: "16px", marginTop: "20px" }}>
            {kpis.map((k) => (
              <div key={k.key} style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)", borderTop: `4px solid ${k.color}` }}>
                <div style={{ fontFamily: FONT_BODY, fontSize: "14px", fontWeight: 600, color: "#374151" }}>{k.label}</div>
                <div style={{ fontFamily: FONT_HEAD, fontSize: "32px", fontWeight: 700, color: "#111827", margin: "6px 0" }}>{k.value.toLocaleString("en-GB")}</div>
                <div style={{ fontSize: "13px", fontWeight: 600, color: k.pct === null ? "#9CA3AF" : k.pct >= 0 ? "#10B981" : "#EF4444" }}>
                  {k.pct === null ? "No previous data" : `${k.pct >= 0 ? "↑" : "↓"} ${Math.abs(k.pct).toFixed(1)}%`}
                </div>
                <div style={mutedStyle}>vs. previous {pDays} days</div>
              </div>
            ))}
          </div>
          {/* ---------- OPERATIONAL INSIGHTS + TODAY'S SCHEDULE ---------- */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(340px,1fr))", gap: "20px" }}>
            {/* Operational Insights */}
            <div style={boxStyle}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h3 style={h3Style}>📊 Operational Insights</h3>
                <span style={{ fontSize: "12px", fontWeight: "600", color: "#2563EB", backgroundColor: "#EFF6FF", padding: "3px 10px", borderRadius: "999px" }}>
                  Active Metrics
                </span>
              </div>
              {/* Summary Cards */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginTop: "16px" }}>
                <div style={{ backgroundColor: "#F9FAFB", padding: "12px", borderRadius: "8px", border: "1px solid #E5E7EB", textAlign: "left" }}>
                  <div style={{ fontSize: "11px", color: "#6B7280", fontWeight: "600", textTransform: "uppercase" }}>Provider Assigned</div>
                  <div style={{ fontSize: "20px", fontWeight: "700", color: "#111827", marginTop: "2px" }}>{assignedPct}%</div>
                  <div style={{ fontSize: "11px", color: unassignedCount > 0 ? "#EF4444" : "#10B981", marginTop: "2px" }}>
                    {unassignedCount} unassigned
                  </div>
                </div>
                <div style={{ backgroundColor: "#F9FAFB", padding: "12px", borderRadius: "8px", border: "1px solid #E5E7EB", textAlign: "left" }}>
                  <div style={{ fontSize: "11px", color: "#6B7280", fontWeight: "600", textTransform: "uppercase" }}>Completion Rate</div>
                  <div style={{ fontSize: "20px", fontWeight: "700", color: "#10B981", marginTop: "2px" }}>{completionRate}%</div>
                  <div style={{ fontSize: "11px", color: "#6B7280", marginTop: "2px" }}>{completedCount} total jobs done</div>
                </div>
              </div>
              {/* Top Locations Progress Bars */}
              <div style={{ marginTop: "16px", textAlign: "left" }}>
                <div style={{ fontSize: "13px", fontWeight: "600", color: "#374151", marginBottom: "8px" }}>📍 Top Booking Locations</div>
                {topLocations.length === 0 && <p style={mutedStyle}>No location data recorded yet.</p>}
                {topLocations.map(([loc, count]) => {
                  const pct = all.length ? ((count / all.length) * 100).toFixed(1) : 0;
                  return (
                    <div key={loc} style={{ marginBottom: "8px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", marginBottom: "2px" }}>
                        <span style={{ fontWeight: "600", color: "#374151" }}>{loc}</span>
                        <span style={mutedStyle}>{count} bookings ({pct}%)</span>
                      </div>
                      <div style={{ height: "6px", backgroundColor: "#F3F4F6", borderRadius: "999px", overflow: "hidden" }}>
                        <div style={{ width: `${pct}%`, height: "100%", backgroundColor: "#3B82F6", borderRadius: "999px" }} />
                      </div>
                    </div>
                  );
                })}
              </div>
              {/* Quick filter shortcut pills */}
              <div style={{ marginTop: "14px", paddingTop: "12px", borderTop: "1px solid #F3F4F6", display: "flex", gap: "8px", flexWrap: "wrap", justifyContent: "center" }}>
                <span style={{ fontSize: "11px", color: "#6B7280", alignSelf: "center" }}>Quick view:</span>
                <button onClick={() => setUi({ status: "confirmed", page: 1 })} style={btn("#D1FAE5", { color: "#065F46", padding: "4px 10px", fontSize: "11px" })}>✅ Confirmed</button>
                <button onClick={() => setUi({ status: "inprogress", page: 1 })} style={btn("#FEF3C7", { color: "#92400E", padding: "4px 10px", fontSize: "11px" })}>⏳ In Progress</button>
                <button onClick={() => setUi({ status: "pending", page: 1 })} style={btn("#FEF3C7", { color: "#B45309", padding: "4px 10px", fontSize: "11px" })}>⚠️ Pending</button>
                <button onClick={() => setUi({ status: "", search: "", page: 1 })} style={btn("#F3F4F6", { color: "#374151", padding: "4px 10px", fontSize: "11px" })}>Clear Filters</button>
              </div>
            </div>
            {/* Today's Schedule */}
            <div style={boxStyle}>
              <h3 style={h3Style}>🗓️ Today's Schedule</h3>
              {schedule.length === 0 ? (
                <p style={{ ...mutedStyle, marginTop: "24px" }}>No bookings scheduled for today.</p>
              ) : (
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px", color: "#374151", marginTop: "12px" }}>
                  <thead style={{ backgroundColor: "#F9FAFB" }}>
                    <tr><th style={thStyle}>Time</th><th style={thStyle}>Service</th><th style={thStyle}>Provider</th><th style={thStyle}>Status</th></tr>
                  </thead>
                  <tbody>
                    {schedule.map((b, i) => (
                      <tr key={getId(b) + i} onClick={() => setUi({ detail: getId(b) })} style={{ borderBottom: "1px solid #E5E7EB", backgroundColor: i % 2 === 0 ? "#fff" : "#F9FAFB", cursor: "pointer" }}>
                        <td style={tdStyle}>{fmtTime(getDate(b))}</td>
                        <td style={tdStyle}>{getService(b)}</td>
                        <td style={tdStyle}>{getProvider(b)}</td>
                        <td style={tdStyle}>{pill(stOf(b))}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
          {/* ---------- STATUS BAR GRAPH + TOP SERVICES + QUICK ACTIONS ---------- */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))", gap: "20px" }}>
            {/* 🧮 BOOKING STATUS CARD (CLICK TO OPEN MODAL) */}
            <div
              style={{ ...boxStyle, cursor: "pointer", transition: "transform 0.15s ease, box-shadow 0.15s ease" }}
              onClick={() => setUi({ showStatusModal: true })}
              title="Click to view full status analytics modal"
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h3 style={h3Style}>🧮 Booking Status</h3>
                <span style={{ fontSize: "12px", fontWeight: "600", color: "#2563EB", backgroundColor: "#EFF6FF", padding: "4px 10px", borderRadius: "999px", display: "inline-flex", alignItems: "center", gap: "4px" }}>
                  ⛶ Expand Modal
                </span>
              </div>

              {/* Clean Horizontal Status Bars (No Collisions) */}
              <div style={{ marginTop: "16px", display: "flex", flexDirection: "column", gap: "12px", textAlign: "left" }}>
                {statusBars.map((s) => {
                  const pct = splitTotal ? ((s.count / splitTotal) * 100).toFixed(1) : "0.0";
                  return (
                    <div key={s.key}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "13px", marginBottom: "4px" }}>
                        <span style={{ display: "inline-flex", alignItems: "center", gap: "8px", fontWeight: "600", color: "#374151" }}>
                          <span style={{ width: "10px", height: "10px", borderRadius: "50%", backgroundColor: s.color }} />
                          {s.label}
                        </span>
                        <span style={{ fontSize: "12px", color: "#6B7280" }}>
                          <b style={{ color: "#111827", fontSize: "13px" }}>{s.count}</b> ({pct}%)
                        </span>
                      </div>
                      <div style={{ height: "8px", backgroundColor: "#F3F4F6", borderRadius: "999px", overflow: "hidden" }}>
                        <div style={{ width: `${pct}%`, height: "100%", backgroundColor: s.color, borderRadius: "999px" }} />
                      </div>
                    </div>
                  );
                })}
              </div>
              <div style={{ marginTop: "16px", paddingTop: "10px", borderTop: "1px solid #F3F4F6", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ ...mutedStyle, fontSize: "12px" }}>Total Recorded: <b>{splitTotal}</b></span>
                <span style={{ fontSize: "12px", fontWeight: "600", color: "#2563EB" }}>View Detailed Graph & Filter ›</span>
              </div>
            </div>
            {/* Top Services */}
            <div style={boxStyle}>
              <h3 style={h3Style}>🏆 Top Services</h3>
              {topSvc.length === 0 && <p style={{ ...mutedStyle, marginTop: "16px" }}>No services yet.</p>}
              <div style={{ marginTop: "16px", textAlign: "left" }}>
                {topSvc.map(([name, n]) => {
                  const pct = all.length ? (n / all.length) * 100 : 0;
                  return (
                    <div key={name} style={{ padding: "8px 0" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", color: "#374151" }}>
                        <b>{name}</b><span style={mutedStyle}>{n} bookings · {pct.toFixed(1)}%</span>
                      </div>
                      <div style={{ height: "6px", backgroundColor: "#E5E7EB", borderRadius: "999px", marginTop: "6px", overflow: "hidden" }}>
                        <div style={{ width: `${pct}%`, height: "100%", backgroundColor: "#2563EB" }} />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            {/* ⚡ QUICK ACTIONS (ONLY VIEW CALENDAR & EXPORT REPORT) */}
            <div style={boxStyle}>
              <h3 style={h3Style}>⚡ Quick Actions</h3>
              <p style={{ ...mutedStyle, margin: "8px 0 20px" }}>Access schedules and download booking data</p>
              <div style={{ display: "flex", flexDirection: "column", gap: "12px", justifyContent: "center", alignItems: "stretch", maxWidth: "260px", margin: "0 auto" }}>
                <button
                  onClick={() => setUi({ showCalendar: true })}
                  style={btn("#2563EB", { padding: "12px 18px", fontSize: "14px", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" })}
                >
                  📅 View Calendar
                </button>
                <button
                  onClick={exportCsv}
                  style={btn("#10B981", { padding: "12px 18px", fontSize: "14px", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" })}
                >
                  ⬇️ Export Report
                </button>
              </div>
            </div>
          </div>
          {/* ---------- ALL BOOKINGS TABLE ---------- */}
          <div id="bd-table" style={boxStyle}>
            <h3 style={h3Style}>📝 All Bookings</h3>
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", justifyContent: "center", margin: "16px 0" }}>
              <input type="text" placeholder="🔍 Search bookings..." value={ui.search} onChange={(e) => setUi({ search: e.target.value, page: 1 })} style={{ ...inputStyle, minWidth: "240px" }} />
              <select value={ui.status} onChange={(e) => setUi({ status: e.target.value, page: 1 })} style={inputStyle} aria-label="Filter by status">
                <option value="">Status</option>
                {statusOptions.map((s) => <option key={s} value={s}>{stInfo(s).label}</option>)}
              </select>
              <select value={ui.service} onChange={(e) => setUi({ service: e.target.value, page: 1 })} style={inputStyle} aria-label="Filter by service">
                <option value="">Service</option>
                {serviceOptions.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
              <select value={ui.date} onChange={(e) => setUi({ date: e.target.value, page: 1 })} style={inputStyle} aria-label="Filter by date">
                <option value="">Date</option>
                <option value="today">Today</option>
                <option value="7">Last 7 days</option>
                <option value="30">Last 30 days</option>
              </select>
              <button onClick={exportCsv} style={btn("#10B981", { padding: "10px 16px", fontSize: "13px" })}>⬇️ Export</button>
            </div>
            <table style={{ width: "100%", borderCollapse: "collapse", fontFamily: FONT_BODY, fontSize: "14px", color: "#374151" }}>
              <thead style={{ backgroundColor: "#F9FAFB" }}>
                <tr>
                  {["Booking ID", "Customer", "Phone", "Service", "Provider", "Date & Time", "Location", "Status", "Action"].map((h) => <th key={h} style={thStyle}>{h}</th>)}
                </tr>
              </thead>
              <tbody>
                {!isRegistryLoading && pageRows.length === 0 && (
                  <tr><td colSpan="9" style={{ textAlign: "center", padding: "16px" }}>No bookings found.</td></tr>
                )}
                {!isRegistryLoading && pageRows.map((b, i) => {
                  const d = getDate(b);
                  return (
                    <tr key={getId(b) + i} style={{ borderBottom: "1px solid #E5E7EB", backgroundColor: i % 2 === 0 ? "#fff" : "#F9FAFB", textAlign: "center" }}>
                      <td style={tdStyle}>{getId(b)}</td>
                      <td style={tdStyle}>{getCustomer(b)}</td>
                      <td style={tdStyle}>{getPhone(b)}</td>
                      <td style={tdStyle}>{getService(b)}</td>
                      <td style={tdStyle}>{getProvider(b)}{getRating(b) ? ` ★ ${getRating(b)}` : ""}</td>
                      <td style={tdStyle}>{d ? `${fmtDate(d)}, ${fmtTime(d)}` : "-"}</td>
                      <td style={tdStyle}>{getLocation(b)}</td>
                      <td style={tdStyle}>{pill(stOf(b))}</td>
                      <td style={tdStyle}><button onClick={() => setUi({ detail: getId(b) })} style={btn("#2563EB")}>📝 Details</button></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "10px", marginTop: "16px", ...mutedStyle }}>
              <span>
                {rows.length === 0 ? "Showing 0 bookings" : `Showing ${(page - 1) * PAGE_SIZE + 1}–${Math.min(page * PAGE_SIZE, rows.length)} of ${rows.length.toLocaleString("en-GB")} bookings`}
              </span>
              <div style={{ display: "flex", gap: "6px" }}>
                <button disabled={page === 1} onClick={() => setUi({ page: page - 1 })} style={btn("#111827", { opacity: page === 1 ? 0.4 : 1 })} aria-label="Previous page">‹</button>
                {pageNums.map((n) => <button key={n} onClick={() => setUi({ page: n })} style={btn(n === page ? "#2563EB" : "#9CA3AF")}>{n}</button>)}
                <button disabled={page === pages} onClick={() => setUi({ page: page + 1 })} style={btn("#111827", { opacity: page === pages ? 0.4 : 1 })} aria-label="Next page">›</button>
              </div>
            </div>

            {/* loader overlay */}
            {isRegistryLoading && (
              <div style={{ position: "absolute", inset: 0, backgroundColor: "rgba(255,255,255,0.75)", zIndex: 50, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "12px" }}>
                <div style={{ textAlign: "center" }}>
                  <div style={{ width: "48px", height: "48px", border: "4px solid #E5E7EB", borderTop: "4px solid #2563EB", borderRadius: "50%", animation: "spin 1s linear infinite", margin: "0 auto" }} />
                  <p style={{ marginTop: "12px", fontSize: "14px", color: "#374151", fontWeight: "500" }}>Loading bookings…</p>
                </div>
                <style>{`@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}`}</style>
              </div>
            )}
          </div>
        </div>
        {/* ================= BOOKING STATUS MODAL (SPACIOUS & COLLISION-FREE) ================= */}
        {ui.showStatusModal && (
          <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.65)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1100 }}>
            <div style={{ width: "95%", maxWidth: "900px", maxHeight: "92vh", backgroundColor: "#fff", borderRadius: "14px", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)" }}>
              {/* Modal Header */}
              <div style={{ padding: "18px 24px", borderBottom: "1px solid #E5E7EB", display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "#fff" }}>
                <div>
                  <h3 style={{ ...h3Style, fontSize: "22px" }}>🧮 Booking Status Analytics</h3>
                  <p style={{ ...mutedStyle, margin: "4px 0 0" }}>Comprehensive breakdown of all status categories across {splitTotal} bookings</p>
                </div>
                <button onClick={() => setUi({ showStatusModal: false })} style={btn("#EF4444", { padding: "8px 16px", fontSize: "14px" })}>✕ Close</button>
              </div>
              {/* Modal Body */}
              <div style={{ padding: "24px", overflowY: "auto", flex: 1, backgroundColor: "#F9FAFB" }}>
                {/* Large SVG Bar Graph with Angled Labels (Zero Collisions) */}
                <div style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "12px", border: "1px solid #E5E7EB", boxShadow: "0 2px 8px rgba(0,0,0,0.04)" }}>
                  <h4 style={{ margin: "0 0 16px 0", fontSize: "16px", color: "#111827", textAlign: "left", fontWeight: "700" }}>
                    📊 Status Volume Comparison
                  </h4>
                  <svg viewBox={`0 0 ${mW} ${mH}`} width="100%" role="img" aria-label="Expanded booking status bar chart">
                    {[0, 1, 2, 3, 4].map((i) => {
                      const v = (mNiceMax / 4) * i;
                      return (
                        <g key={i}>
                          <line x1={mPL} x2={mW - mPR} y1={myAt(v)} y2={myAt(v)} stroke="#F3F4F6" strokeDasharray="3,3" />
                          <text x={mPL - 8} y={myAt(v) + 4} fontSize="11" textAnchor="end" fill="#9CA3AF">{Math.round(v)}</text>
                        </g>
                      );
                    })}
                    {/* Baseline axis */}
                    <line x1={mPL} x2={mW - mPR} y1={mBaseline} y2={mBaseline} stroke="#E5E7EB" strokeWidth="1" />
                    {statusBars.map((s, i) => {
                      const x = mPL + i * mSlotW + (mSlotW - mBarW) / 2;
                      const y = myAt(s.count);
                      const h = Math.max(mBaseline - y, 0);
                      const pct = splitTotal ? ((s.count / splitTotal) * 100).toFixed(1) : "0.0";
                      const labelX = x + mBarW / 2;
                      const labelY = mBaseline + 14;
                      return (
                        <g key={s.key}>
                          {/* Colored Status Bar */}
                          <rect x={x} y={y} width={mBarW} height={h} rx="4" fill={s.color}>
                            <title>{`${s.label}: ${s.count} bookings (${pct}%)`}</title>
                          </rect>
                          {/* Value on top of bar */}
                          <text x={labelX} y={y - 8} fontSize="12" fontWeight="700" textAnchor="middle" fill="#111827">
                            {s.count}
                          </text>
                          {/* Angled Non-Colliding Status Label */}
                          <text
                            x={labelX}
                            y={labelY}
                            fontSize="11"
                            fontWeight="600"
                            textAnchor="end"
                            fill="#4B5563"
                            transform={`rotate(-32, ${labelX}, ${labelY})`}
                          >
                            {s.label}
                          </text>
                        </g>
                      );
                    })}
                  </svg>
                </div>
                {/* Status Cards Grid with Actionable Filter Buttons */}
                <div style={{ marginTop: "20px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "14px" }}>
                  {statusBars.map((s) => {
                    const pct = splitTotal ? ((s.count / splitTotal) * 100).toFixed(1) : "0.0";
                    return (
                      <div
                        key={s.key}
                        style={{
                          backgroundColor: "#fff",
                          border: `1px solid #E5E7EB`,
                          borderLeft: `5px solid ${s.color}`,
                          padding: "16px",
                          borderRadius: "10px",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
                          textAlign: "left",
                        }}
                      >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <span style={{ fontSize: "14px", fontWeight: "700", color: "#111827" }}>{s.label}</span>
                          <span style={{ fontSize: "11px", fontWeight: "700", color: s.color, backgroundColor: s.bg, padding: "2px 8px", borderRadius: "999px" }}>
                            {pct}%
                          </span>
                        </div>
                        <div style={{ fontSize: "24px", fontWeight: "800", color: "#111827", margin: "6px 0 2px" }}>
                          {s.count.toLocaleString("en-GB")}
                        </div>
                        <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "12px" }}>
                          out of {splitTotal} total bookings
                        </div>
                        <button
                          onClick={() => {
                            setUi({ showStatusModal: false, status: s.key, page: 1 });
                            const tbl = document.getElementById("bd-table");
                            if (tbl) tbl.scrollIntoView({ behavior: "smooth" });
                          }}
                          style={btn(s.color, { width: "100%", padding: "7px 10px", fontSize: "12px", textAlign: "center" })}
                        >
                          🔍 Filter Table by {s.label}
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}
        {/* ================= CALENDAR MODAL ================= */}
        {ui.showCalendar && (
          <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.65)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1100 }}>
            <div style={{ width: "95%", maxWidth: "860px", maxHeight: "92vh", backgroundColor: "#fff", borderRadius: "14px", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 20px 25px -5px rgba(0,0,0,0.2)" }}>
              {/* Header */}
              <div style={{ padding: "16px 20px", borderBottom: "1px solid #E5E7EB", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                  <h3 style={{ ...h3Style, fontSize: "20px" }}>📅 Bookings Calendar</h3>
                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <button onClick={() => setUi({ calMonthOffset: (ui.calMonthOffset || 0) - 1 })} style={btn("#F3F4F6", { color: "#374151", padding: "4px 10px" })}>‹</button>
                    <span style={{ fontWeight: "700", fontSize: "14px", minWidth: "130px", textAlign: "center" }}>{calMonthName}</span>
                    <button onClick={() => setUi({ calMonthOffset: (ui.calMonthOffset || 0) + 1 })} style={btn("#F3F4F6", { color: "#374151", padding: "4px 10px" })}>›</button>
                    {ui.calMonthOffset !== 0 && (
                      <button onClick={() => setUi({ calMonthOffset: 0 })} style={btn("#EFF6FF", { color: "#2563EB", padding: "4px 8px", fontSize: "11px" })}>Today</button>
                    )}
                  </div>
                </div>
                <button onClick={() => setUi({ showCalendar: false })} style={btn("#EF4444", { padding: "6px 14px", fontSize: "13px" })}>✕ Close</button>
              </div>
              {/* Grid */}
              <div style={{ padding: "16px", overflowY: "auto", flex: 1, backgroundColor: "#F9FAFB" }}>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "6px", marginBottom: "6px", textAlign: "center", fontWeight: "600", fontSize: "12px", color: "#6B7280" }}>
                  {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                    <div key={day} style={{ padding: "6px 0" }}>{day}</div>
                  ))}
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "6px" }}>
                  {calCells.map((cellDate, idx) => {
                    if (!cellDate) return <div key={"empty-" + idx} style={{ minHeight: "85px", backgroundColor: "transparent" }} />;
                    const isToday = sameDay(cellDate, now);
                    const dayBookings = all.filter((b) => {
                      const d = getDate(b);
                      return d && sameDay(d, cellDate);
                    });
                    return (
                      <div
                        key={cellDate.toISOString()}
                        style={{
                          minHeight: "85px",
                          backgroundColor: "#fff",
                          border: isToday ? "2px solid #2563EB" : "1px solid #E5E7EB",
                          borderRadius: "8px",
                          padding: "6px",
                          display: "flex",
                          flexDirection: "column",
                          overflow: "hidden",
                        }}
                      >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "4px" }}>
                          <span style={{ fontSize: "12px", fontWeight: isToday ? "800" : "600", color: isToday ? "#2563EB" : "#374151" }}>
                            {cellDate.getDate()}
                          </span>
                          {dayBookings.length > 0 && (
                            <span style={{ fontSize: "10px", backgroundColor: "#EFF6FF", color: "#1D4ED8", fontWeight: "700", padding: "1px 5px", borderRadius: "999px" }}>
                              {dayBookings.length}
                            </span>
                          )}
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "2px", overflowY: "auto", flex: 1 }}>
                          {dayBookings.slice(0, 3).map((b) => {
                            const info = stInfo(stOf(b));
                            return (
                              <div
                                key={getId(b)}
                                onClick={() => setUi({ detail: getId(b) })}
                                style={{
                                  fontSize: "10px",
                                  backgroundColor: info.bg,
                                  color: info.color,
                                  padding: "2px 4px",
                                  borderRadius: "4px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  cursor: "pointer",
                                  fontWeight: "600",
                                }}
                                title={`${getCustomer(b)} - ${getService(b)} (${info.label})`}
                              >
                                {fmtTime(getDate(b))} {getService(b)}
                              </div>
                            );
                          })}
                          {dayBookings.length > 3 && (
                            <div style={{ fontSize: "9px", color: "#6B7280", textAlign: "center", fontWeight: "600" }}>
                              +{dayBookings.length - 3} more
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}
        {/* ================= DETAILS MODAL ================= */}
        {detail && (
          <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.55)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1150 }}>
            <div style={{ width: "90%", maxWidth: "800px", maxHeight: "90vh", backgroundColor: "#F3F4F6", borderRadius: "14px", overflow: "hidden", display: "flex", flexDirection: "column" }}>
              <div style={{ backgroundColor: "#fff", padding: "20px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h3 style={{ ...h3Style, fontSize: "22px" }}>📝 Booking {getId(detail)}</h3>
                <button onClick={() => setUi({ detail: null })} style={btn("#EF4444", { padding: "6px 14px", fontSize: "14px" })}>✕ Close</button>
              </div>
              <div style={{ padding: "20px", overflowY: "auto", backgroundColor: "#F9FAFB" }}>
                <div style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", fontFamily: FONT_BODY, fontSize: "14px", color: "#374151" }}>
                    <tbody>
                      {Object.keys(detail).map((k, i) => (
                        <tr key={k} style={{ borderBottom: "1px solid #E5E7EB", backgroundColor: i % 2 === 0 ? "#fff" : "#F9FAFB" }}>
                          <th style={{ ...thStyle, textAlign: "left", width: "200px", verticalAlign: "top" }}>{k}</th>
                          <td style={{ padding: "10px", wordBreak: "break-word" }}>{presentCellValue(detail[k])}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  })()}

{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "customerBookingList" && (
  <div className="admin-container">
    {/* ================= HEADER ================= */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Customer Booking List</h3>
    </div>
    {/* ================= CARD ================= */}
    <div
      style={{
        ...cardStyle,
        maxWidth: "1520px",
        margin: "0 auto",
        width: "100%",
      }}
    >
       {/* Header */}
    <div
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        marginBottom: "20px",
        textAlign: "center",
      }}
    >
      <h3
        style={{
          margin: 0,
          fontFamily: "'Poppins', sans-serif",
          fontSize: "24px",
          fontWeight: "700",
          color: "#111827",
        }}
      >
        📋 Customer Booking List
      </h3>
    </div>
    {/* Table Container */}
    <div
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        overflowX: "auto",
      }}
    >
      {bookingRecords.length === 0 ? (
        <p
          style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: "14px",
            color: "#6B7280",
            textAlign: "center",
          }}
        >
          No bookings found.
        </p>
      ) : (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontFamily: "'Inter', sans-serif",
            fontSize: "14px",
            color: "#374151",
          }}
        >
          <thead style={{ backgroundColor: "#F9FAFB" }}>
            <tr>
              <th style={{ padding: "12px" }}>Booking ID</th>
              <th style={{ padding: "12px" }}>Type</th>
              <th style={{ padding: "12px" }}>Title</th>
              <th style={{ padding: "12px" }}>Timestamp</th>
              <th style={{ padding: "12px" }}>Customer ID</th>
              <th style={{ padding: "12px" }}>Name</th>
              <th style={{ padding: "12px" }}>Email</th>
              <th style={{ padding: "12px" }}>Phone</th>
              <th style={{ padding: "12px" }}>Device</th>
              <th style={{ padding: "12px" }}>OS</th>
              <th style={{ padding: "12px" }}>Browser</th>
              <th style={{ padding: "12px", textAlign: "center" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {bookingRecords.map((record, index) => {
              const parser = new UAParser(record.userAgentData || navigator.userAgent);
              const result = parser.getResult();
              const deviceType = result.device.type || "Desktop";
              const os = `${result.os.name || "Unknown"} ${result.os.version || ""}`;
              const browser = `${result.browser.name || "Unknown"} ${result.browser.version || ""}`;
              return (
                <tr
                  key={record.recordId}
                  style={{
                    borderBottom: "1px solid #E5E7EB",
                    backgroundColor: index % 2 === 0 ? "#fff" : "#F9FAFB",
                  }}
                >
                  <td style={{ padding: "12px" }}>{record.bookingCode}</td>
                  <td style={{ padding: "12px" }}>{record.bookingType}</td>
                  <td style={{ padding: "12px" }}>{record.bookingTitle}</td>
                  <td style={{ padding: "12px" }}>
                    {record.bookingTime ? new Date(record.bookingTime).toLocaleString() : "N/A"}
                  </td>
                  <td style={{ padding: "12px" }}>{record.customerCode}</td>
                  <td style={{ padding: "12px" }}>{record.customerName}</td>
                  <td style={{ padding: "12px" }}>{record.customerEmail}</td>
                  <td style={{ padding: "12px" }}>{record.customerPhone}</td>
                  <td style={{ padding: "12px" }}>{deviceType}</td>
                  <td style={{ padding: "12px" }}>{os}</td>
                  <td style={{ padding: "12px" }}>{browser}</td>
                  <td style={{ padding: "12px", textAlign: "center" }}>
                    <button
                      onClick={() =>
                        setActiveBooking({ ...record, deviceType, osName: os, browserInfo: browser })
                      }
                      style={{
                        backgroundColor: "#2563EB",
                        color: "#fff",
                        padding: "6px 12px",
                        borderRadius: "6px",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      👁️ View
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
    {/* ===============================
        Booking Preview Modal
    ================================ */}
    {activeBooking && (
      <div className="modal-overlay">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Booking Preview</h5>
              <button type="button" className="close" onClick={() => setActiveBooking(null)}>
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div id="bookingPrintContent">
                {/* Booking Details */}
                <div className="order-section">
                  <h4 className="section-title">Booking Details</h4>
                  <div className="order-details">
                    <p><strong>Booking ID:</strong> {activeBooking.bookingCode}</p>
                    <p><strong>Type:</strong> {activeBooking.bookingType}</p>
                    <p><strong>Title:</strong> {activeBooking.bookingTitle}</p>
                    <p>
                      <strong>Timestamp:</strong>{" "}
                      {activeBooking.bookingTime ? new Date(activeBooking.bookingTime).toLocaleString() : "N/A"}
                    </p>
                  </div>
                </div>
                {/* Customer Info */}
                <div className="order-section">
                  <h4 className="section-title">Customer Info</h4>
                  <div className="order-details">
                    <p><strong>Customer ID:</strong> {activeBooking.customerCode}</p>
                    <p><strong>Name:</strong> {activeBooking.customerName}</p>
                    <p><strong>Email:</strong> {activeBooking.customerEmail}</p>
                    <p><strong>Phone:</strong> {activeBooking.customerPhone}</p>
                  </div>
                </div>
                {/* Device Info */}
                <div className="order-section">
                  <h4 className="section-title">Device Info</h4>
                  <div className="order-details">
                    <p><strong>Device:</strong> {activeBooking.deviceType}</p>
                    <p><strong>OS:</strong> {activeBooking.osName}</p>
                    <p><strong>Browser:</strong> {activeBooking.browserInfo}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-dark btn-sm"
                onClick={async () => {
                  const el = document.getElementById("bookingPrintContent");
                  if (!el) return;
                  const originalOverflow = el.style.overflow;
                  const originalHeight = el.style.height;
                  el.style.overflow = "visible";
                  el.style.height = "auto";
                  await new Promise((r) => setTimeout(r, 100));
                  html2canvas(el, { scale: 2, useCORS: true }).then((canvas) => {
                    const img = canvas.toDataURL("image/png");
                    el.style.overflow = originalOverflow;
                    el.style.height = originalHeight;
                    const win = window.open("", "_blank");
                    win.document.write(`
                      <html>
                        <head>
                          <title>Booking Print</title>
                          <style>
                            body { margin: 0; text-align: center; }
                            img { width: 100%; display: block; }
                          </style>
                        </head>
                        <body>
                          <img src="${img}" />
                          <script>
                            window.onload = () => window.print();
                          </script>
                        </body>
                      </html>
                    `);
                    win.document.close();
                  });
                }}
              >
                Print Booking As Image
              </button>
              <button
                className="btn btn-secondary btn-sm"
                onClick={() => setActiveBooking(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    )}
    </div>
  </div>
)}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "addProvider" && (
  <div className="admin-container">
    {/* ================= HEADER ================= */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Add Provider</h3>
    </div>
    {/* ================= CARD ================= */}
    <div
      style={{
        ...cardStyle,
        maxWidth: "1500px",
        margin: "0 auto",
        width: "100%",
      }}
    >
       {/* ---------------- Add Provider ---------------- */}
      <div className="card-section">
       <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
  <input
    type="text"
    placeholder="Name"
    value={formProvider?.name || ""}
    onChange={(e) =>
      setFormProvider((prev) => ({ ...prev, name: e.target.value }))
    }
    className="border border-gray-300 px-3 py-2 rounded-md w-full"
  />
  <input
    type="email"
    placeholder="Email"
    value={formProvider?.email || ""}
    onChange={(e) =>
      setFormProvider((prev) => ({ ...prev, email: e.target.value }))
    }
    className="border border-gray-300 px-3 py-2 rounded-md w-full"
  />
  <input
    type="text"
    placeholder="Phone"
    value={formProvider?.phone || ""}
    onChange={(e) =>
      setFormProvider((prev) => ({ ...prev, phone: e.target.value }))
    }
    className="border border-gray-300 px-3 py-2 rounded-md w-full"
  />
  <input
    type="text"
    placeholder="Provider ID (optional)"
    value={formProvider?.providerId || ""}
    onChange={(e) =>
      setFormProvider((prev) => ({
        ...prev,
        providerId: e.target.value,
      }))
    }
    className="border border-gray-300 px-3 py-2 rounded-md w-full"
  />
</div>
        {/* Add Provider Button */}
        <button
          className="mt-4 px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded font-medium"
          onClick={submitNewProvider}
        >
          ➕ Add Provider
        </button>
     {/* 🔽 NEW NAVIGATION BUTTONS (AFTER Add Provider) */}
<div className="mt-6 flex flex-wrap gap-3">
 <button
  onClick={() => {
    setCurrentView("providerBookingList"); // navigate to providerBookingList
    showOnlySection("providerBookingList"); // hide other sections
  }}
  style={{ backgroundColor: "#2563eb", color: "white" }}
  className="px-3 py-2 rounded"
>
  📋 Provider Booking List
</button>
  <button
  onClick={() => {
    setCurrentView("providersList"); // navigate to providersList
    showOnlySection("providersList"); // hide other sections
  }}
  style={{ backgroundColor: "#dc2626", color: "white" }}
  className="px-3 py-2 rounded"
>
  📑 Providers List
</button>
</div>
      </div>
    <div style={{ fontFamily: "Arial, sans-serif", padding: "24px" }}>
  <h1>Booking & Chat System</h1>
  {/* ---------------- Booking Events ---------------- */}
  <div className="card-section" style={{ marginBottom: "24px" }}>
    <h3 className="font-semibold mb-3">📦 Booking Events</h3>
    <div className="flex flex-wrap gap-3 mb-6">
      {["new", "confirmed", "cancelled", "amended"].map((type) => (
        <button
          key={`save-${type}`}
          style={{
            backgroundColor:
              type === "new"
                ? "blue"
                : type === "confirmed"
                ? "green"
                : type === "cancelled"
                ? "red"
                : "orange",
            color: "white",
            padding: "8px 16px",
            borderRadius: "6px",
            fontWeight: "bold",
            cursor:
              formProvider?.providerId && !savingType ? "pointer" : "not-allowed",
            opacity: savingType === type || !formProvider?.providerId ? 0.6 : 1,
          }}
          onClick={() => addBooking(type)}
          disabled={!formProvider?.providerId || !!savingType}
          title={
            !formProvider?.providerId
              ? "Please fill provider details first"
              : undefined
          }
        >
          {type === "new"
            ? "📦 New Booking"
            : type === "confirmed"
            ? "✅ Confirmed"
            : type === "cancelled"
            ? "❌ Cancelled"
            : "🔁 Amended"}
          {savingType === type ? " …" : ""}
        </button>
      ))}
    </div>
  </div>
  {/* ---------------- Push Notifications ---------------- */}
  <div className="card-section" style={{ marginBottom: "24px" }}>
    <h3 className="font-semibold mb-3">📩 Send Push Notifications (Only FCM)</h3>
    <div className="flex flex-wrap gap-3 mb-6">
      {["new", "confirmed", "cancelled", "amended"].map((type) => (
        <button
          key={`push-${type}`}
          style={{
            backgroundColor:
              type === "new"
                ? "#2563eb"
                : type === "confirmed"
                ? "#16a34a"
                : type === "cancelled"
                ? "#dc2626"
                : "#f59e0b",
            color: "white",
            padding: "8px 16px",
            borderRadius: "6px",
            fontWeight: "bold",
            cursor:
              formProvider?.providerId && !pushingType ? "pointer" : "not-allowed",
            opacity: pushingType === type || !formProvider?.providerId ? 0.6 : 1,
          }}
          onClick={() => pushBookingNotification(type)}
          disabled={!formProvider?.providerId || !!pushingType}
          title={
            !formProvider?.providerId
              ? "Please fill provider details first"
              : undefined
          }
        >
          {`📩 Push: ${
            type === "new"
              ? "New Booking"
              : type === "confirmed"
              ? "Confirmed"
              : type === "cancelled"
              ? "Cancelled"
              : "Amended"
          }`}
          {pushingType === type ? " …" : ""}
        </button>
      ))}
    </div>
  </div>
    </div>
    </div>
  </div>
)}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "addCustomer" && (
  <div className="admin-container">
    {/* ================= HEADER ================= */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Add Customer</h3>
    </div>
    {/* ================= CARD ================= */}
    <div
      style={{
        ...cardStyle,
        maxWidth: "1510px",
        margin: "0 auto",
        width: "100%",
      }}
    >
      {/* Title Section */}
      <div
        className="category-title-container"
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          👤 Add Customer
        </h3>
      </div>
      {/* Customer Form */}
     <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4 w-full">
  <input
    type="text"
    className="border px-3 py-2 rounded w-full"
    placeholder="Customer ID"
    value={formCustomer?.customerId || ""}
    onChange={(e) =>
      setFormCustomer({ ...formCustomer, customerId: e.target.value })
    }
  />
  <input
    type="text"
    className="border px-3 py-2 rounded w-full"
    placeholder="Name"
    value={formCustomer?.name || ""}
    onChange={(e) =>
      setFormCustomer({ ...formCustomer, name: e.target.value })
    }
  />
  <input
    type="email"
    className="border px-3 py-2 rounded w-full"
    placeholder="Email"
    value={formCustomer?.email || ""}
    onChange={(e) =>
      setFormCustomer({ ...formCustomer, email: e.target.value })
    }
  />
  <input
    type="text"
    className="border px-3 py-2 rounded w-full"
    placeholder="Phone"
    value={formCustomer?.phone || ""}
    onChange={(e) =>
      setFormCustomer({ ...formCustomer, phone: e.target.value })
    }
  />
</div>
      {/* Add Customer Button */}
      <button
        className="mt-4 px-4 py-2 bg-red-600 text-white rounded font-semibold"
        onClick={submitNewCustomer}
      >
        Add Customer
      </button>
      {/* 🔽 Navigation Buttons */}
      <div className="mt-6 flex flex-wrap gap-3">
        <button
  onClick={() => {
    setCurrentView("customerBookingList"); // navigate to customerBookingList
    showOnlySection("customerBookingList"); // hide other sections
  }}
  style={{ backgroundColor: "#7c3aed", color: "white" }}
  className="px-5 py-2 rounded-lg shadow text-sm font-medium flex items-center gap-2"
>
  📦 Customer Booking List
</button>
        <button
  onClick={() => {
    setCurrentView("customerList"); // navigate to customerList
    showOnlySection("customerList"); // hide other sections
  }}
  style={{ backgroundColor: "#f97316", color: "white" }}
  className="px-5 py-2 rounded-lg shadow text-sm font-medium flex items-center gap-2"
>
  👤 Customer List
</button>
      </div>
      {/* 📦 Booking Notification Buttons */}
      <div className="mt-6 p-4 bg-white rounded shadow-md">
        <div className="flex flex-wrap gap-3 mb-6">
          {[
            { type: "new", label: "📦 New Booking", color: "blue" },
            { type: "confirmed", label: "✅ Confirmed", color: "green" },
            { type: "cancelled", label: "❌ Cancelled", color: "red" },
            { type: "amended", label: "🔁 Amended", color: "orange" },
          ].map((btn) => (
            <div key={btn.type} className="flex gap-2 items-center">
              {/* Main Booking Button */}
              <button
                style={{
                  backgroundColor: btn.color,
                  color: "white",
                  padding: "8px 16px",
                  borderRadius: "6px",
                  fontWeight: "bold",
                }}
                onClick={() => handleCustomerBookingClick(btn.type)}
              >
                {btn.label}
              </button>
              {/* Push Notification Button */}
              <button
                style={{
                  backgroundColor: "#9333ea",
                  color: "white",
                  padding: "8px 16px",
                  borderRadius: "6px",
                  fontWeight: "bold",
                }}
                onClick={() => handleSendNotification(btn.type)}
              >
                🔔 Send {btn.label}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
)}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "bookingServices" && (
  <div className="admin-container">
    <div style={headerStyle}>
      <h3 style={titleStyle}>Booking Services</h3>
    </div>
    <div style={cardStyle}>
       {/* Header */}
      <div
        className="category-title-container"
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          📋 Customer Booking Form
        </h3>
      </div>
      {/* Booking Form */}
      <div
        className="category-form-container"
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
        }}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Left Column: Booking Info */}
          <div className="space-y-3">
            {/* Booking Code */}
            <div className="flex gap-2">
              <input
                type="text"
                name="bookingCode"
                placeholder="Booking Code"
                value={bookingData.bookingCode}
                onChange={handleChange}
                className="flex-1 border p-2 rounded"
              />
              <button
                onClick={handleGenerateBookingCode}
                style={{ backgroundColor: "#dc2626", color: "white" }}
                className="px-3 py-2 rounded"
              >
                Generate
              </button>
            </div>
            {/* Invoice */}
            <div className="flex gap-2">
              <input
                type="text"
                name="invoice"
                placeholder="Invoice"
                value={bookingData.invoice}
                onChange={handleChange}
                className="flex-1 border p-2 rounded"
              />
              <button
                onClick={handleGenerateInvoice}
                style={{ backgroundColor: "#2563eb", color: "white" }}
                className="px-3 py-2 rounded"
              >
                Generate Invoice
              </button>
            </div>
            {/* Customer Info */}
            <input
              type="text"
              name="customerName"
              placeholder="Customer Name"
              value={bookingData.customerName}
              onChange={handleChange}
              className="w-full border p-2 rounded"
            />
            <input
              type="email"
              name="customerEmail"
              placeholder="Customer Email"
              value={bookingData.customerEmail}
              onChange={handleChange}
              className="w-full border p-2 rounded"
            />
            {/* Service Selection */}
            <select
              name="service"
              value={bookingData.service}
              onChange={handleServiceChange}
              className="w-full border p-2 rounded"
            >
              {services.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name} (${s.rate}/hr)
                </option>
              ))}
            </select>
            {/* Onsite & Expenses */}
            <div className="flex gap-2">
              <select
                name="onsite"
                value={bookingData.onsite}
                onChange={handleChange}
                className="flex-1 border p-2 rounded"
              >
                <option value="Yes">Provider Onsite</option>
                <option value="No">Provider Not Onsite</option>
              </select>
              <input
                type="number"
                name="expenses"
                placeholder="Additional Expenses"
                value={bookingData.expenses}
                onChange={handleChange}
                className="w-36 border p-2 rounded"
                min="0"
              />
            </div>
            {/* Estimated Cost */}
            <div className="text-sm font-medium text-gray-700">
              💰 Estimated Cost:{" "}
              <span className="text-green-700">£{calculateCost()}</span>
            </div>
          </div>
          {/* Right Column: Timer & Quick Actions */}
          <div className="space-y-4">
            {/* Timer Card */}
            <div className="p-4 border rounded-lg bg-gray-50 text-center shadow-sm">
              <h4 className="text-lg font-semibold">⏱️ Booking Timer</h4>
              <p className="text-3xl font-mono my-3">{formatTime(timer)}</p>
              {/* Timer Controls */}
              <div className="flex flex-wrap gap-2 justify-center">
                <button
                  onClick={handleClockIn}
                  disabled={isRunning && !isPaused}
                  style={{
                    backgroundColor: isRunning && !isPaused ? "#d1d5db" : "#7c3aed",
                    color: isRunning && !isPaused ? "#374151" : "white",
                    cursor: isRunning && !isPaused ? "not-allowed" : "pointer",
                  }}
                  className="px-4 py-2 rounded font-medium"
                >
                  {isPaused ? "Resume" : "Clock-In"}
                </button>
                <button
                  onClick={handlePause}
                  disabled={!isRunning || isPaused || isOnBreak}
                  style={{
                    backgroundColor:
                      !isRunning || isPaused || isOnBreak ? "#d1d5db" : "#f97316",
                    color: !isRunning || isPaused || isOnBreak ? "#374151" : "white",
                    cursor:
                      !isRunning || isPaused || isOnBreak ? "not-allowed" : "pointer",
                  }}
                  className="px-4 py-2 rounded font-medium"
                >
                  Pause
                </button>
                <button
                  onClick={handleTakeBreakToggle}
                  style={{
                    backgroundColor: isOnBreak ? "#ca8a04" : "#facc15",
                    color: "white",
                    cursor: "pointer",
                  }}
                  className="px-4 py-2 rounded font-medium"
                >
                  {isOnBreak ? "Back from Break" : "Take a Break"}
                </button>
                <button
                  onClick={handleClockOut}
                  disabled={!isRunning && timer === 0}
                  style={{
                    backgroundColor: !isRunning && timer === 0 ? "#d1d5db" : "#4f46e5",
                    color: !isRunning && timer === 0 ? "#374151" : "white",
                    cursor: !isRunning && timer === 0 ? "not-allowed" : "pointer",
                  }}
                  className="px-4 py-2 rounded font-medium"
                >
                  Clock-Out
                </button>
              </div>
              {/* Timer Mode & History */}
              <div className="mt-3 text-sm text-gray-600">
                <div>
                  <strong>Mode:</strong>{" "}
                  {isOnBreak ? (
                    <span className="text-blue-700">On Break</span>
                  ) : isPaused ? (
                    <span className="text-yellow-700">Paused</span>
                  ) : isRunning ? (
                    <span className="text-green-700">Working</span>
                  ) : (
                    <span className="text-gray-700">Idle</span>
                  )}
                </div>
                <div>
                  <strong>History entries:</strong> {history.length}
                </div>
              </div>
            </div>
            {/* Quick Actions */}
            <div className="p-3 border rounded-lg bg-white space-y-2 shadow-sm">
              <h4 className="font-semibold">Quick Actions</h4>
              <div className="flex flex-wrap gap-2">
                <button
                  onClick={handleSavePDF}
                  style={{ backgroundColor: "#6b7280", color: "white" }}
                  className="flex-1 px-3 py-2 rounded"
                >
                  💾 Save Receipt as PDF
                </button>
                <button
                  onClick={handleClearHistory}
                  style={{ backgroundColor: "#f5deb3", color: "#374151" }}
                  className="px-3 py-2 rounded"
                >
                  🧹 Clear History
                </button>
                <button
                  onClick={handleSaveBookingServices}
                  style={{ backgroundColor: "#10b981", color: "white", width: "100%" }}
                  className="px-3 py-2 rounded font-medium"
                >
                  📦 Save Booking Services
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Booking History */}
      <div
        className="category-form-container"
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          overflowX: "auto",
        }}
      >
        <div className="flex justify-between items-center mb-2">
          <h4 className="text-lg font-semibold">📜 Booking History</h4>
          <span className="text-sm text-gray-600">Total events: {history.length}</span>
        </div>
        {history.length === 0 ? (
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "14px", color: "#6B7280" }}>
            No events yet. Clock-In to start recording events.
          </p>
        ) : (
          <ul className="space-y-2 max-h-64 overflow-y-auto">
            {history.map((h, idx) => (
              <li key={idx} className="flex justify-between items-start">
                <span className="font-medium">{h.action}</span>
                <span className="text-xs text-gray-500">{h.timestamp}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
    </div>
)}

{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "providersList" && (
    <div className="admin-container">
      {/* HEADER */}
      <div style={headerStyle}>
        <h3 style={titleStyle}>Providers List</h3>
      </div>
      {/* CARD */}
      <div style={cardStyle}>
        {/* Header with Title, Search, Multi-field Filters, Unlock Modal, Logs, & Refresh Button */}
        <div
          style={{
            backgroundColor: "#fff",
            padding: "16px 20px",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            marginBottom: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
            <h3
              style={{
                margin: 0,
                fontFamily: "'Poppins', sans-serif",
                fontSize: "20px",
                fontWeight: "700",
                color: "#111827",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              📋 Providers List
            </h3>
            <span
              style={{
                fontSize: "12px",
                color: "#6B7280",
                backgroundColor: "#F3F4F6",
                padding: "3px 8px",
                borderRadius: "6px",
                fontWeight: "500",
              }}
            >
              Deduplicated Unique Providers
            </span>
            <span
              style={{
                fontSize: "12px",
                color: isListRevealed ? "#065F46" : "#991B1B",
                backgroundColor: isListRevealed ? "#D1FAE5" : "#FEE2E2",
                padding: "3px 8px",
                borderRadius: "6px",
                fontWeight: "600",
              }}
            >
              {isListRevealed ? "🔓 Data Unlocked" : "🔒 Data Hidden by Default"}
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
            {/* Multi-Field Search Filter Selector */}
            <select
              value={providerSearchField || "all"}
              onChange={(e) => {
                if (typeof setProviderSearchField === "function") {
                  setProviderSearchField(e.target.value);
                }
              }}
              style={{
                backgroundColor: "#F3F4F6",
                border: "1px solid #E5E7EB",
                borderRadius: "8px",
                padding: "6px 8px",
                fontSize: "12px",
                color: "#374151",
                outline: "none",
                fontWeight: "500",
                cursor: "pointer",
              }}
            >
              <option value="all">🔍 Search: All Fields</option>
              <option value="id">ID</option>
              <option value="name">Name</option>
              <option value="status">Status</option>
              <option value="deletion">🚨 Deletion / Cancellation Requests</option>
              <option value="device">Device</option>
              <option value="os">OS</option>
              <option value="browser">Browser</option>
            </select>
            {/* SEARCH BOX: Search by specified fields */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                backgroundColor: "#F3F4F6",
                padding: "6px 10px",
                borderRadius: "8px",
                border: "1px solid #E5E7EB",
              }}
            >
              <span style={{ fontSize: "13px" }}>🔎</span>
              <input
                type="text"
                value={providerSearchQuery || ""}
                onChange={(e) => {
                  const sanitized = e.target.value.replace(/[<>$]/g, "");
                  if (typeof setProviderSearchQuery === "function") {
                    setProviderSearchQuery(sanitized);
                  }
                }}
                placeholder={
                  (providerSearchField || "all") === "all"
                    ? "Filter by ID, Name, Status, Deletion, Device, OS, Browser…"
                    : (providerSearchField || "") === "deletion"
                    ? "Type 'deletion' or 'cancellation' to filter…"
                    : `Filter by ${providerSearchField}…`
                }
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  outline: "none",
                  fontSize: "12px",
                  width: "230px",
                  color: "#111827",
                }}
                maxLength={120}
                autoComplete="off"
                spellCheck={false}
              />
              {providerSearchQuery && (
                <button
                  onClick={() => typeof setProviderSearchQuery === "function" && setProviderSearchQuery("")}
                  title="Clear search"
                  style={{
                    border: "none",
                    background: "none",
                    cursor: "pointer",
                    color: "#9CA3AF",
                    fontSize: "13px",
                    padding: 0,
                  }}
                >
                  ✖
                </button>
              )}
            </div>
            {/* PASSWORD UNLOCK BUTTON FOR HIDDEN DATA */}
            <button
              onClick={() => {
                if (isListRevealed) {
                  if (typeof setIsListRevealed === "function") {
                    setIsListRevealed(false);
                  }
                } else {
                  if (typeof setIsListPasswordModalOpen === "function") {
                    setIsListPasswordModalOpen(true);
                  }
                }
              }}
              style={{
                backgroundColor: isListRevealed ? "#F59E0B" : "#10B981",
                color: "#fff",
                border: "none",
                padding: "6px 12px",
                borderRadius: "8px",
                fontSize: "12px",
                fontWeight: "600",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "5px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              }}
              title="Unlock full provider list data with PIN"
            >
              {isListRevealed ? "🔒 Hide List" : "🔑 Unlock"}
            </button>
            {/* ACCESS LOGS VIEWER BUTTON */}
            <button
              onClick={() => {
                if (typeof setIsAuditLogsModalOpen === "function") {
                  setIsAuditLogsModalOpen(true);
                }
              }}
              style={{
                backgroundColor: "#1F2937",
                color: "#fff",
                border: "none",
                padding: "6px 12px",
                borderRadius: "8px",
                fontSize: "12px",
                fontWeight: "600",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "5px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              }}
              title="View Action & Gated Access Logs"
            >
              📜 Access Logs
            </button>
            {/* Zoom / Scale Controls */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                backgroundColor: "#F3F4F6",
                padding: "4px 8px",
                borderRadius: "8px",
              }}
            >
              <span style={{ fontSize: "12px", color: "#6B7280", fontWeight: "500", marginRight: "4px" }}>
                🔍 Size
              </span>
              {[25, 50, 75, 100].map((level) => (
                <button
                  key={level}
                  onClick={() => setListZoomLevel(level)}
                  style={{
                    backgroundColor: listZoomLevel === level ? "#2563EB" : "#fff",
                    color: listZoomLevel === level ? "#fff" : "#374151",
                    border: "1px solid #D1D5DB",
                    padding: "4px 9px",
                    borderRadius: "6px",
                    fontSize: "11px",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "all 0.15s ease",
                  }}
                >
                  {level}%
                </button>
              ))}
            </div>
            {/* Refresh Button */}
            <button
              onClick={async () => {
                setIsRefreshSpinning(true);
                try {
                  if (
                    typeof db !== "undefined" &&
                    typeof collection === "function" &&
                    typeof getDocs === "function"
                  ) {
                    const [usersSnap, providersSnap] = await Promise.all([
                      getDocs(collection(db, "users")),
                      getDocs(collection(db, "providers")),
                    ]);
                    const usersDocsMap = new Map();
                    usersSnap.docs.forEach((d) => usersDocsMap.set(d.id, { id: d.id, ...d.data() }));
                    const providersDocsMap = new Map();
                    providersSnap.docs.forEach((d) => providersDocsMap.set(d.id, { id: d.id, ...d.data() }));
                    const isExplicitUserRecord = (uData) =>
                      uData?.role === "user" || uData?.userType === "User";
                    const isExplicitProviderRecord = (uData, pData) =>
                      uData?.role === "provider" || pData?.role === "provider";
                    // De-duplicate across both collections by unique ID
                    const deduplicatedMap = new Map();
                    // 1. Process users collection
                    usersSnap.docs.forEach((d) => {
                      const uData = d.data();
                      const pData = providersDocsMap.get(d.id) || {};
                      if (isExplicitUserRecord(uData) || isExplicitUserRecord(pData)) {
                        return;
                      }
                      if (isExplicitProviderRecord(uData, pData)) {
                        deduplicatedMap.set(d.id, {
                          ...pData,
                          ...uData,
                          id: d.id,
                          _source: "users",
                          _sourceLabel: "users",
                        });
                      }
                    });
                    // 2. Process providers collection (merges or inserts without duplicate rows)
                    providersSnap.docs.forEach((d) => {
                      const pData = d.data();
                      const uData = usersDocsMap.get(d.id) || {};
                      if (isExplicitUserRecord(uData) || isExplicitUserRecord(pData)) {
                        return;
                      }
                      if (!isExplicitProviderRecord(uData, pData)) {
                        return;
                      }
                      if (!deduplicatedMap.has(d.id)) {
                        deduplicatedMap.set(d.id, {
                          ...uData,
                          ...pData,
                          id: d.id,
                          _source: "providers",
                          _sourceLabel: "providers",
                        });
                      } else {
                        const existing = deduplicatedMap.get(d.id);
                        deduplicatedMap.set(d.id, { ...existing, ...pData });
                      }
                    });
                    const orderedList = Array.from(deduplicatedMap.values());
                    if (typeof setProviderList === "function") {
                      setProviderList(orderedList);
                    }
                    try {
                      localStorage.setItem("cached_providers_list", JSON.stringify(orderedList));
                    } catch (e) {
                      console.warn("Local storage cache error:", e);
                    }
                  } else {
                    if (typeof fetchProvidersFromUsersCollection === "function") {
                      await fetchProvidersFromUsersCollection();
                    }
                    if (typeof fetchProvidersFromProvidersCollection === "function") {
                      await fetchProvidersFromProvidersCollection();
                    }
                  }
                } catch (err) {
                  console.error("Error refreshing providers:", err);
                  if (typeof fetchProvidersFromUsersCollection === "function") {
                    fetchProvidersFromUsersCollection();
                  }
                } finally {
                  setTimeout(() => {
                    setIsRefreshSpinning(false);
                  }, 1000);
                }
              }}
              disabled={providersLoading || isRefreshSpinning}
              title={providersLoading ? "Refreshing..." : "Refresh Providers"}
              style={{
                backgroundColor:
                  providersLoading || isRefreshSpinning ? "#93C5FD" : "#2563EB",
                color: "#fff",
                width: "34px",
                height: "34px",
                borderRadius: "50%",
                border: "none",
                cursor:
                  providersLoading || isRefreshSpinning ? "not-allowed" : "pointer",
                fontSize: "16px",
                fontWeight: "600",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 6px rgba(37, 99, 235, 0.25)",
                transition: "all 0.2s ease",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  animation: isRefreshSpinning ? "spin-refresh 1s linear infinite" : "none",
                }}
              >
                🔄
              </span>
            </button>
            <style>
              {`
                @keyframes spin-refresh {
                  from { transform: rotate(0deg); }
                  to { transform: rotate(360deg); }
                }
              `}
            </style>
          </div>
        </div>
        {/* Table Container */}
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            overflowX: "auto",
          }}
        >
          <div
            style={{
              transform: `scale(${(listZoomLevel || 100) / 100})`,
              transformOrigin: "top left",
              width: `${100 / ((listZoomLevel || 100) / 100)}%`,
              transition: "transform 0.2s ease",
            }}
          >
            {(() => {
              // Ensure Catalog, Notes and Audit Logs persist and restore across refreshes and logins
              if (typeof window !== "undefined") {
                try {
                  const cachedCatalogStr = localStorage.getItem("persistent_provider_catalog_registry");
                  if (cachedCatalogStr) {
                    const parsedCatalog = JSON.parse(cachedCatalogStr);
                    if (
                      (!providerCatalogRegistry || Object.keys(providerCatalogRegistry).length === 0) &&
                      typeof setProviderCatalogRegistry === "function" &&
                      parsedCatalog &&
                      Object.keys(parsedCatalog).length > 0
                    ) {
                      setProviderCatalogRegistry(parsedCatalog);
                    }
                  }
                } catch (e) {}
                try {
                  const cachedNotesStr = localStorage.getItem("persistent_provider_notes_registry");
                  if (cachedNotesStr) {
                    const parsedNotes = JSON.parse(cachedNotesStr);
                    if (
                      (!providerNotesRegistry || Object.keys(providerNotesRegistry).length === 0) &&
                      typeof setProviderNotesRegistry === "function" &&
                      parsedNotes &&
                      Object.keys(parsedNotes).length > 0
                    ) {
                      setProviderNotesRegistry(parsedNotes);
                    }
                  }
                } catch (e) {}
                try {
                  const cachedLogsStr = localStorage.getItem("persistent_admin_audit_logs");
                  if (cachedLogsStr) {
                    const parsedLogs = JSON.parse(cachedLogsStr);
                    if (
                      (!adminAuditLogs || adminAuditLogs.length === 0) &&
                      typeof setAdminAuditLogs === "function" &&
                      Array.isArray(parsedLogs) &&
                      parsedLogs.length > 0
                    ) {
                      setAdminAuditLogs(parsedLogs);
                    }
                  }
                } catch (e) {}
                // Global Lightbox Preview Modal Helper to view any service gallery media / image / video
                window.__openImageModal = (mediaUrl, srvTitle, srvId, mediaType = "image") => {
                  if (!mediaUrl) return;
                  const existingModal = document.getElementById("admin-gallery-image-modal");
                  if (existingModal) existingModal.remove();
                  const modal = document.createElement("div");
                  modal.id = "admin-gallery-image-modal";
                  modal.style.position = "fixed";
                  modal.style.inset = "0";
                  modal.style.backgroundColor = "rgba(0, 0, 0, 0.88)";
                  modal.style.backdropFilter = "blur(6px)";
                  modal.style.display = "flex";
                  modal.style.flexDirection = "column";
                  modal.style.alignItems = "center";
                  modal.style.justifyContent = "center";
                  modal.style.zIndex = "9999999";
                  modal.style.padding = "20px";
                  modal.onclick = () => modal.remove();
                  const box = document.createElement("div");
                  box.style.position = "relative";
                  box.style.maxWidth = "92vw";
                  box.style.maxHeight = "92vh";
                  box.style.display = "flex";
                  box.style.flexDirection = "column";
                  box.style.alignItems = "center";
                  box.onclick = (e) => e.stopPropagation();
                  const isVideo = mediaType === "video" || mediaUrl.includes(".mp4") || mediaUrl.includes(".webm") || mediaUrl.includes(".mov");
                  const mediaTag = isVideo
                    ? `<video src="${mediaUrl}" controls autoplay style="max-width: 88vw; max-height: 78vh; border-radius: 8px; box-shadow: 0 10px 30px rgba(0,0,0,0.6); background-color: #000;"></video>`
                    : `<img src="${mediaUrl}" alt="Full Resolution Gallery" style="max-width: 88vw; max-height: 78vh; object-fit: contain; border-radius: 8px; box-shadow: 0 10px 30px rgba(0,0,0,0.6); background-color: #111;" />`;
                  box.innerHTML = `
                    <div style="width: 100%; display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; color: #fff; font-family: 'Inter', sans-serif;">
                      <div>
                        <div style="font-size: 15px; font-weight: 700;">${srvTitle || "Service Media"} (${isVideo ? "Video" : "Image"})</div>
                        <div style="font-size: 12px; color: #9CA3AF;">Service ID: ${srvId || "—"}</div>
                      </div>
                      <div style="display: flex; gap: 12px; align-items: center;">
                        <a href="${mediaUrl}" target="_blank" rel="noopener noreferrer" style="color: #60A5FA; text-decoration: none; font-size: 13px; font-weight: 600; background: rgba(255,255,255,0.1); padding: 6px 12px; border-radius: 6px;">Open Original ↗</a>
                        <button id="close-admin-img-modal" style="background: rgba(255,255,255,0.2); border: none; color: #fff; width: 32px; height: 32px; border-radius: 50%; cursor: pointer; font-size: 16px; display: flex; align-items: center; justify-content: center;">✖</button>
                      </div>
                    </div>
                    ${mediaTag}
                  `;
                  modal.appendChild(box);
                  document.body.appendChild(modal);
                  const closeBtn = document.getElementById("close-admin-img-modal");
                  if (closeBtn) closeBtn.onclick = () => modal.remove();
                };
                // Global, highly-optimized rapid-fetch handler for services across the 3 requested collections
                window.__fetchFastCatalogServices = async (targetProvId) => {
                  if (!targetProvId) return;
                  const cleanProvId = String(targetProvId).trim();
                  try {
                    const cachedStr = localStorage.getItem("persistent_provider_catalog_registry");
                    if (cachedStr) {
                      const cachedMap = JSON.parse(cachedStr);
                      if (cachedMap[cleanProvId] && typeof setProviderCatalogRegistry === "function") {
                        setProviderCatalogRegistry((prev) => ({
                          ...prev,
                          [cleanProvId]: cachedMap[cleanProvId],
                        }));
                      }
                    }
                  } catch (e) {}
                  if (typeof setSubcollectionFetchStatus === "function") {
                    setSubcollectionFetchStatus((prev) => ({
                      ...prev,
                      [`${cleanProvId}_catalog`]: true,
                    }));
                  }
                  try {
                    if (
                      typeof db === "undefined" ||
                      typeof collection !== "function" ||
                      typeof getDocs !== "function"
                    ) {
                      return;
                    }
                    const servicesMap = new Map();
                    const registerServiceDoc = (docSnap, sourceLabel, extraData = {}) => {
                      const data = docSnap.data() || {};
                      const sId = docSnap.id;
                      const provIdField = String(
                        data.provider_id || data.providerId || data.userId || ""
                      ).trim();
                      if (provIdField && provIdField !== cleanProvId) {
                        return;
                      }
                      const existing = servicesMap.get(sId) || {};
                      const currentSubSources = Array.isArray(existing._discoveredSubcollections)
                        ? [...existing._discoveredSubcollections]
                        : existing._discoveredSubcollection
                        ? [existing._discoveredSubcollection]
                        : [];
                      if (!currentSubSources.includes(sourceLabel)) {
                        currentSubSources.push(sourceLabel);
                      }
                      const currentDocPaths = Array.isArray(existing._docPaths)
                        ? [...existing._docPaths]
                        : [];
                      if (docSnap.ref?.path && !currentDocPaths.includes(docSnap.ref.path)) {
                        currentDocPaths.push(docSnap.ref.path);
                      }
                      const resolvedApproval =
                        data.approval_status ||
                        data.status ||
                        (data.is_approved === true
                          ? "approved"
                          : data.is_approved === false && (data.rejection_reason || data.rejectionReason)
                          ? "rejected"
                          : "pending_verification");
                      const resolvedStatus =
                        data.status ||
                        data.approval_status ||
                        resolvedApproval;
                      const resolvedRejectionReason =
                        data.rejection_reason !== undefined
                          ? data.rejection_reason
                          : data.rejectionReason !== undefined
                          ? data.rejectionReason
                          : data.reject_reason !== undefined
                          ? data.reject_reason
                          : existing.rejection_reason ?? null;
                      const resolvedReviewedAt =
                        data.reviewed_at ||
                        data.reviewedAt ||
                        existing.reviewed_at ||
                        null;
                      const resolvedReviewedBy =
                        data.reviewed_by ||
                        data.reviewedBy ||
                        existing.reviewed_by ||
                        "";
                      const resolvedGalleryImages =
                        data.gallery_images ||
                        data.galleryImages ||
                        data.images ||
                        existing.gallery_images ||
                        [];
                      const resolvedGalleryMedia =
                        data.gallery_media !== undefined
                          ? data.gallery_media
                          : data.galleryMedia !== undefined
                          ? data.galleryMedia
                          : existing.gallery_media || { items: [] };
                      const resolvedMedia =
                        data.media !== undefined
                          ? data.media
                          : existing.media || { items: [] };
                      servicesMap.set(sId, {
                        ...existing,
                        ...data,
                        ...extraData,
                        id: sId,
                        service_id: data.service_id || sId,
                        provider_id: data.provider_id || data.providerId || cleanProvId,
                        category: data.category || extraData.category || existing.category || "",
                        sub_category: data.sub_category || extraData.sub_category || existing.sub_category || "",
                        approval_status: existing.approval_status || resolvedApproval,
                        status: existing.status || resolvedStatus,
                        is_approved:
                          existing.is_approved !== undefined
                            ? existing.is_approved
                            : data.is_approved !== undefined
                            ? data.is_approved
                            : resolvedApproval === "approved",
                        is_active:
                          existing.is_active !== undefined
                            ? existing.is_active
                            : data.is_active !== undefined
                            ? data.is_active
                            : resolvedApproval === "approved",
                        gallery_images: resolvedGalleryImages,
                        gallery_media: resolvedGalleryMedia,
                        media: resolvedMedia,
                        has_videos:
                          data.has_videos !== undefined
                            ? data.has_videos
                            : existing.has_videos || false,
                        rejection_reason: resolvedRejectionReason,
                        reviewed_at: resolvedReviewedAt,
                        reviewed_by: resolvedReviewedBy,
                        _docPaths: currentDocPaths,
                        _discoveredSubcollections: currentSubSources,
                        _discoveredSubcollection: currentSubSources.join(" | "),
                      });
                    };
                    // CONCURRENT PARALLEL FETCHES ACROSS ALL 3 PATHS SIMULTANEOUSLY
                    const fetchTasks = [
                      // 1) admin_pending_approvals/services/pending/{serviceId}
                      (async () => {
                        try {
                          const pendingSnap = await getDocs(
                            collection(db, "admin_pending_approvals", "services", "pending")
                          );
                          pendingSnap.docs.forEach((d) => {
                            const dData = d.data() || {};
                            const pId = String(
                              dData.provider_id || dData.providerId || dData.userId || ""
                            ).trim();
                            if (!pId || pId === cleanProvId) {
                              registerServiceDoc(
                                d,
                                "admin_pending_approvals/services/pending",
                                { _inAdminPending: true }
                              );
                            }
                          });
                        } catch (e) {
                          console.warn("Fast fetch admin_pending_approvals:", e);
                        }
                      })(),
                      // 2) users/{providerId}/Notification/{serviceId}
                      (async () => {
                        try {
                          const userNotifSnap = await getDocs(
                            collection(db, "users", cleanProvId, "Notification")
                          );
                          userNotifSnap.docs.forEach((d) => {
                            registerServiceDoc(
                              d,
                              `users/${cleanProvId}/Notification`,
                              { _inUsersNotification: true }
                            );
                          });
                        } catch (e) {
                          console.warn("Fast fetch users Notification:", e);
                        }
                      })(),
                      // 3) All_categories/{category}/subCategories/{subCategory}/Notification/{serviceId}
                      (async () => {
                        let collectionGroupSucceeded = false;
                        if (typeof collectionGroup === "function") {
                          try {
                            const cgSnap = await getDocs(collectionGroup(db, "Notification"));
                            cgSnap.docs.forEach((d) => {
                              const path = d.ref?.path || "";
                              const dData = d.data() || {};
                              const pId = String(
                                dData.provider_id || dData.providerId || dData.userId || ""
                              ).trim();
                              if (path.includes("All_categories") && (!pId || pId === cleanProvId)) {
                                const pathParts = path.split("/");
                                const catPart = pathParts[1] || dData.category;
                                const subPart = pathParts[3] || dData.sub_category;
                                registerServiceDoc(d, path, {
                                  category: catPart,
                                  sub_category: subPart,
                                  _inCategoriesNotification: true,
                                });
                                collectionGroupSucceeded = true;
                              }
                            });
                          } catch (cgErr) {
                            collectionGroupSucceeded = false;
                          }
                        }
                        if (!collectionGroupSucceeded) {
                          try {
                            const categoriesSnap = await getDocs(collection(db, "All_categories"));
                            await Promise.allSettled(
                              categoriesSnap.docs.map(async (catDoc) => {
                                const catId = catDoc.id;
                                try {
                                  const subCatSnap = await getDocs(
                                    collection(db, "All_categories", catId, "subCategories")
                                  );
                                  await Promise.allSettled(
                                    subCatSnap.docs.map(async (subDoc) => {
                                      const subId = subDoc.id;
                                      try {
                                        const notifSnap = await getDocs(
                                          collection(
                                            db,
                                            "All_categories",
                                            catId,
                                            "subCategories",
                                            subId,
                                            "Notification"
                                          )
                                        );
                                        notifSnap.docs.forEach((d) => {
                                          const dData = d.data() || {};
                                          const pId = String(
                                            dData.provider_id || dData.providerId || dData.userId || ""
                                          ).trim();
                                          if (!pId || pId === cleanProvId) {
                                            registerServiceDoc(
                                              d,
                                              `All_categories/${catId}/subCategories/${subId}/Notification`,
                                              {
                                                category: dData.category || catId,
                                                sub_category: dData.sub_category || subId,
                                                _inCategoriesNotification: true,
                                              }
                                            );
                                          }
                                        });
                                      } catch (e) {}
                                    })
                                  );
                                } catch (e) {}
                              })
                            );
                          } catch (e) {
                            console.warn("Fast parallel All_categories fetch:", e);
                          }
                        }
                      })(),
                    ];
                    await Promise.allSettled(fetchTasks);
                    const consolidatedServices = Array.from(servicesMap.values());
                    try {
                      const cachedStr = localStorage.getItem("persistent_provider_catalog_registry");
                      const existingCatalogMap = cachedStr ? JSON.parse(cachedStr) : {};
                      const updatedCatalogMap = {
                        ...existingCatalogMap,
                        [cleanProvId]: consolidatedServices,
                      };
                      localStorage.setItem(
                        "persistent_provider_catalog_registry",
                        JSON.stringify(updatedCatalogMap)
                      );
                    } catch (storageErr) {}
                    if (typeof setProviderCatalogRegistry === "function") {
                      setProviderCatalogRegistry((prev) => ({
                        ...(prev || {}),
                        [cleanProvId]: consolidatedServices,
                      }));
                    }
                  } catch (err) {
                    console.error("Fast fetch error for provider catalog:", err);
                  } finally {
                    if (typeof setSubcollectionFetchStatus === "function") {
                      setSubcollectionFetchStatus((prev) => ({
                        ...prev,
                        [`${cleanProvId}_catalog`]: false,
                      }));
                    }
                  }
                };
              }
              // 1. DE-DUPLICATE RAW LIST FOUND WITH SAME IDs
              const rawSourceList = providerList || [];
              const uniqueMap = new Map();
              rawSourceList.forEach((prov) => {
                const uniqueId = String(
                  prov?.id || prov?.uid || prov?.serviceReference || prov?._id || ""
                ).trim();
                if (uniqueId && !uniqueMap.has(uniqueId)) {
                  uniqueMap.set(uniqueId, prov);
                } else if (!uniqueId) {
                  uniqueMap.set(Math.random().toString(), prov);
                }
              });
              const sourceList = Array.from(uniqueMap.values());
              const query = (providerSearchQuery || "").trim().toLowerCase();
              const activeField = providerSearchField || "all";

              // Helper to identify whether an account has requested deletion or cancellation
              const checkIsDeletionRequested = (p) => {
                const rawStatus = String(
                  p?.status || p?.approvalStage || p?.verificationStatus || p?.user?.status || ""
                ).toLowerCase().trim();
                return Boolean(
                  p?.deletion_requested === true ||
                  p?.deletionRequested === true ||
                  p?.delete_requested === true ||
                  p?.deleteAccountRequested === true ||
                  p?.accountDeletionRequested === true ||
                  p?.isDeletionRequested === true ||
                  p?.deletionRequest?.requested === true ||
                  p?.deletionRequest?.status === "pending" ||
                  rawStatus === "deletion_requested" ||
                  rawStatus === "delete_requested" ||
                  rawStatus === "pending_deletion" ||
                  rawStatus === "deletion_pending" ||
                  rawStatus === "account_deletion_requested"
                );
              };
              const checkIsCancellationRequested = (p) => {
                const rawStatus = String(
                  p?.status || p?.approvalStage || p?.verificationStatus || p?.user?.status || ""
                ).toLowerCase().trim();
                return Boolean(
                  p?.cancellation_requested === true ||
                  p?.cancellationRequested === true ||
                  p?.request_cancellation === true ||
                  p?.cancel_requested === true ||
                  p?.cancellationRequest?.requested === true ||
                  p?.cancellationRequest?.status === "pending" ||
                  rawStatus === "cancellation_requested" ||
                  rawStatus === "cancel_requested" ||
                  rawStatus === "request_cancellation" ||
                  rawStatus === "pending_cancellation"
                );
              };
              // 2. MULTI-FIELD FILTERING WITH DELETION AND CANCELLATION SUPPORT
              const matchesSearch = (prov) => {
                const isDeletionReq = checkIsDeletionRequested(prov);
                const isCancellationReq = checkIsCancellationRequested(prov);

                if (activeField === "deletion") {
                  if (!query) return isDeletionReq || isCancellationReq;
                  return (
                    (isDeletionReq || isCancellationReq) &&
                    (String(prov?.id || prov?.uid || "").toLowerCase().includes(query) ||
                      String(prov?.name || prov?.displayName || "").toLowerCase().includes(query))
                  );
                }
                if (!query) return false;
                const pid = String(
                  prov?.id || prov?.uid || prov?.serviceReference || prov?._id || ""
                ).toLowerCase();
                const pname = String(
                  prov?.name ||
                    prov?.displayName ||
                    prov?.providerDisplayName ||
                    prov?.username ||
                    prov?.fullName ||
                    prov?.user?.name ||
                    prov?.user?.displayName ||
                    prov?.user?.username ||
                    prov?.provider?.name ||
                    prov?.provider?.username ||
                    prov?.provider?.displayName ||
                    ""
                ).toLowerCase();
                const pstatus = String(
                  prov?.status ||
                    prov?.approvalStage ||
                    prov?.verificationStatus ||
                    prov?.user?.status ||
                    "active"
                ).toLowerCase();
                const rawUserAgent =
                  prov?.userAgent ||
                  prov?.deviceInfo?.userAgent ||
                  prov?.user?.userAgent ||
                  (typeof navigator !== "undefined" ? navigator.userAgent : "");
                const parser = typeof UAParser === "function" ? new UAParser(rawUserAgent) : null;
                const result = parser ? parser.getResult() : {};
                const pdevice = String(
                  prov?.device || prov?.deviceType || result.device?.type || "Desktop"
                ).toLowerCase();
                const pos = String(
                  prov?.os || `${result.os?.name || "Unknown"} ${result.os?.version || ""}`
                ).toLowerCase();
                const pbrowser = String(
                  prov?.browser || `${result.browser?.name || "Unknown"} ${result.browser?.version || ""}`
                ).toLowerCase();
                
                if (activeField === "id") return pid.includes(query);
                if (activeField === "name") return pname.includes(query);
                if (activeField === "status") return pstatus.includes(query);
                if (activeField === "device") return pdevice.includes(query);
                if (activeField === "os") return pos.includes(query);
                if (activeField === "browser") return pbrowser.includes(query);
                return (
                  pid.includes(query) ||
                  pname.includes(query) ||
                  pstatus.includes(query) ||
                  pdevice.includes(query) ||
                  pos.includes(query) ||
                  pbrowser.includes(query) ||
                  (query.includes("delet") && isDeletionReq) ||
                  (query.includes("cancel") && isCancellationReq)
                );
              };
              // 3. SECURITY RULE
              const isFiltered = query.length > 0 || activeField === "deletion";
              const filteredList = isFiltered
                ? sourceList.filter(matchesSearch)
                : isListRevealed
                ? sourceList
                : [];
              if (providersLoading && (!providerList || providerList.length === 0)) {
                return (
                  <p
                    style={{
                      fontFamily: "'Inter', sans-serif",
                      fontSize: "14px",
                      color: "#6B7280",
                      textAlign: "center",
                      margin: "20px 0",
                    }}
                  >
                    Loading providers…
                  </p>
                );
              }
              if (!providerList || providerList.length === 0) {
                return (
                  <p
                    style={{
                      fontFamily: "'Inter', sans-serif",
                      fontSize: "14px",
                      color: "#6B7280",
                      textAlign: "center",
                      margin: "20px 0",
                    }}
                  >
                    No providers added.
                  </p>
                );
              }
              if (!isListRevealed && !isFiltered) {
                return (
                  <div
                    style={{
                      padding: "40px 20px",
                      textAlign: "center",
                      backgroundColor: "#F9FAFB",
                      borderRadius: "10px",
                      border: "1px dashed #D1D5DB",
                      margin: "10px 0",
                    }}
                  >
                    <div style={{ fontSize: "36px", marginBottom: "8px" }}>🔒</div>
                    <h4 style={{ margin: "0 0 6px 0", color: "#111827", fontSize: "16px", fontWeight: "700" }}>
                      Provider Data is Hidden by Default
                    </h4>
                    <p style={{ margin: "0 0 16px 0", color: "#6B7280", fontSize: "13px", maxWidth: "540px", display: "inline-block" }}>
                      Information in this list is protected. To display provider records, filter by <strong>ID, Name, Status, Deletion Requests, Device, OS, or Browser</strong> using the search bar above, or click below to unlock using your 4-digit PIN.
                    </p>
                    <div>
                      <button
                        onClick={() => {
                          if (typeof setIsListPasswordModalOpen === "function") {
                            setIsListPasswordModalOpen(true);
                          }
                        }}
                        style={{
                          backgroundColor: "#2563EB",
                          color: "#fff",
                          border: "none",
                          padding: "8px 18px",
                          borderRadius: "8px",
                          fontSize: "13px",
                          fontWeight: "600",
                          cursor: "pointer",
                        }}
                      >
                        🔑 Enter PIN to Reveal Full List
                      </button>
                    </div>
                  </div>
                );
              }
              if (filteredList.length === 0) {
                return (
                  <p
                    style={{
                      fontFamily: "'Inter', sans-serif",
                      fontSize: "14px",
                      color: "#6B7280",
                      textAlign: "center",
                      margin: "20px 0",
                    }}
                  >
                    No providers match "{providerSearchQuery}".
                  </p>
                );
              }
              return (
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontFamily: "'Inter', sans-serif",
                    fontSize: "13px",
                    color: "#374151",
                  }}
                >
                  <thead style={{ backgroundColor: "#F9FAFB" }}>
                    <tr style={{ borderBottom: "1px solid #E5E7EB" }}>
                      <th style={{ padding: "10px 12px", textAlign: "left" }}>ID</th>
                      <th style={{ padding: "10px 12px", textAlign: "left" }}>Name</th>
                      <th style={{ padding: "10px 12px", textAlign: "left" }}>Status</th>
                      <th style={{ padding: "10px 12px", textAlign: "left" }}>Device</th>
                      <th style={{ padding: "10px 12px", textAlign: "left" }}>OS</th>
                      <th style={{ padding: "10px 12px", textAlign: "left" }}>Browser</th>
                      <th style={{ padding: "10px 12px", textAlign: "center" }}>Gated Access Modals</th>
                      <th style={{ padding: "10px 12px", textAlign: "center" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredList.map((prov, index) => {
                      const providerId =
                        prov?.id ||
                        prov?.uid ||
                        prov?.serviceReference ||
                        prov?._id ||
                        "—";
                      const providerName =
                        prov?.name ||
                        prov?.displayName ||
                        prov?.providerDisplayName ||
                        prov?.username ||
                        prov?.fullName ||
                        prov?.user?.name ||
                        prov?.user?.displayName ||
                        prov?.user?.username ||
                        prov?.provider?.name ||
                        prov?.provider?.username ||
                        prov?.provider?.displayName ||
                        "—";
                      const providerStatus =
                        prov?.status ||
                        prov?.approvalStage ||
                        prov?.verificationStatus ||
                        prov?.user?.status ||
                        "active";
                      const rawUserAgent =
                        prov?.userAgent ||
                        prov?.deviceInfo?.userAgent ||
                        prov?.user?.userAgent ||
                        (typeof navigator !== "undefined" ? navigator.userAgent : "");
                      const parser = typeof UAParser === "function" ? new UAParser(rawUserAgent) : null;
                      const result = parser ? parser.getResult() : {};
                      const deviceType =
                        prov?.device ||
                        prov?.deviceType ||
                        result.device?.type ||
                        "Desktop";
                      const os =
                        prov?.os ||
                        `${result.os?.name || "Unknown"} ${result.os?.version || ""}`.trim();
                      const browser =
                        prov?.browser ||
                        `${result.browser?.name || "Unknown"} ${result.browser?.version || ""}`.trim();
                      // ── Identification of Deletion & Cancellation Requests ──
                      const isAccountDeletionRequested = checkIsDeletionRequested(prov);
                      const isRequestCancellationActive = checkIsCancellationRequested(prov);
                      const deletionReason =
                        prov?.deletion_reason ||
                        prov?.deletionReason ||
                        prov?.deleteReason ||
                        prov?.deletionRequest?.reason ||
                        "Account deletion requested by user/provider";
                      // ── Status Conditions ──
                      const statusNormalized = String(providerStatus).toLowerCase().trim();
                      const isStatusVerificationCompleted =
                        statusNormalized === "verification_completed" ||
                        statusNormalized === "verification_complete" ||
                        statusNormalized === "authorization_complete";
                      const isStatusActive =
                        statusNormalized === "active" ||
                        statusNormalized === "approved" ||
                        statusNormalized === "verified";
                      const isStatusRejected =
                        statusNormalized === "rejected" ||
                        statusNormalized === "blocked";
                      const isFromUsers = prov?._source === "users";
                      // Registry counts
                      const catalogCount = (providerCatalogRegistry?.[providerId] || []).length;
                      const ledgerCount = (providerLedgerRegistry?.[providerId] || []).length;
                      const notesCount = (providerNotesRegistry?.[providerId] || []).length;
                      // Helper function to log audit event with comprehensive metadata and localStorage persistence
                      const triggerAuditLog = (actionType, details = {}) => {
                        const logPayload = {
                          action: actionType,
                          whoAccessed: currentUser?.email || currentUser?.uid || "Admin",
                          accessedAt: new Date().toLocaleString(),
                          timestamp: Date.now(),
                          isoTimestamp: new Date().toISOString(),
                          providerId,
                          providerName,
                          ...details,
                        };
                        try {
                          const existingLogsStr = localStorage.getItem("persistent_admin_audit_logs");
                          const existingLogs = existingLogsStr ? JSON.parse(existingLogsStr) : [];
                          const updatedLogs = [logPayload, ...existingLogs];
                          localStorage.setItem("persistent_admin_audit_logs", JSON.stringify(updatedLogs));
                        } catch (storageErr) {
                          console.warn("Error saving audit log to localStorage:", storageErr);
                        }
                        if (typeof logAuditEvent === "function") {
                          logAuditEvent(logPayload);
                        } else if (typeof setAdminAuditLogs === "function") {
                          setAdminAuditLogs((prev) => [logPayload, ...(prev || [])]);
                        } else {
                          console.log("🔒 [AUDIT LOG RECORDED]:", logPayload);
                        }
                      };
                      // Request Cancellation & Deletion Reversion Handler
                      const handleCancelProviderOrDeletionRequest = async (requestType = "deletion") => {
                        const confirmMsg =
                          requestType === "deletion"
                            ? `Are you sure you want to cancel the deletion request for ${providerName} (${providerId}) and restore active status?`
                            : `Are you sure you want to process request cancellation for ${providerName} (${providerId})?`;
                        if (!window.confirm(confirmMsg)) return;
                        try {
                          const updatePayload = {
                            deletion_requested: false,
                            deletionRequested: false,
                            accountDeletionRequested: false,
                            delete_requested: false,
                            deleteAccountRequested: false,
                            isDeletionRequested: false,
                            deletionRequest: null,
                            cancellation_requested: false,
                            cancellationRequested: false,
                            request_cancellation: false,
                            cancel_requested: false,
                            cancellationRequest: null,
                            status: "active",
                            request_cancelled_at: new Date().toISOString(),
                            request_cancelled_by: currentUser?.email || currentUser?.uid || "Admin",
                          };
                          // 1. Sync to Firebase Firestore if db available
                          if (
                            typeof db !== "undefined" &&
                            typeof doc === "function" &&
                            typeof updateDoc === "function"
                          ) {
                            try {
                              await updateDoc(doc(db, "providers", providerId), updatePayload);
                            } catch (errP) {}
                            try {
                              await updateDoc(doc(db, "users", providerId), updatePayload);
                            } catch (errU) {}
                          }
                          // 2. Update in-memory state so UI immediately responds
                          if (typeof setProviderList === "function") {
                            setProviderList((prevList) =>
                              (prevList || []).map((item) => {
                                const iId = item?.id || item?.uid || item?.serviceReference || item?._id;
                                if (iId === providerId) {
                                  return {
                                    ...item,
                                    ...updatePayload,
                                  };
                                }
                                return item;
                              })
                            );
                          }
                          // 3. Update localStorage cache
                          try {
                            const cached = localStorage.getItem("cached_providers_list");
                            if (cached) {
                              const parsed = JSON.parse(cached);
                              const updated = parsed.map((item) => {
                                const iId = item?.id || item?.uid || item?.serviceReference || item?._id;
                                if (iId === providerId) {
                                  return { ...item, ...updatePayload };
                                }
                                return item;
                              });
                              localStorage.setItem("cached_providers_list", JSON.stringify(updated));
                            }
                          } catch (e) {}
                          // 4. Audit log
                          triggerAuditLog(
                            requestType === "deletion"
                              ? "deletion_request_cancelled"
                              : "catalog_cancellation_processed",
                            {
                              actionLabel:
                                requestType === "deletion"
                                  ? "Account Deletion Request Cancelled"
                                  : "Catalog/Service Request Cancellation Processed",
                              targetId: providerId,
                              targetName: providerName,
                              restoredStatus: "active",
                              reason:
                                requestType === "deletion"
                                  ? "Deletion Request Reversal"
                                  : "Cancellation Request Processed",
                            }
                          );
                          alert(
                            requestType === "deletion"
                              ? `✅ Deletion request cancelled successfully. Provider account restored to Active.`
                              : `✅ Request cancellation completed successfully.`
                          );
                        } catch (err) {
                          console.error("Error processing request cancellation:", err);
                          alert(`⚠️ Error processing cancellation: ${err.message || err}`);
                        }
                      };
                      return (
                        <tr
                          key={`${prov?._source || "prov"}_${providerId}_${index}`}
                          style={{
                            borderBottom: "1px solid #E5E7EB",
                            backgroundColor: isAccountDeletionRequested
                              ? "#FEF2F2"
                              : isRequestCancellationActive
                              ? "#FFFBEB"
                              : index % 2 === 0
                              ? "#ffffff"
                              : "#F9FAFB",
                            borderLeft: isAccountDeletionRequested
                              ? "4px solid #EF4444"
                              : isRequestCancellationActive
                              ? "4px solid #F59E0B"
                              : "none",
                          }}
                        >
                          <td style={{ padding: "10px 12px" }}>
                            <div>{providerId}</div>
                            <span
                              style={{
                                fontSize: "10px",
                                fontWeight: "700",
                                padding: "1px 6px",
                                borderRadius: "4px",
                                backgroundColor: isFromUsers ? "#DBEAFE" : "#EDE9FE",
                                color: isFromUsers ? "#1E40AF" : "#6D28D9",
                                display: "inline-block",
                                marginTop: "2px",
                              }}
                            >
                              {isFromUsers ? "📁 users" : "🏢 providers"}
                            </span>
                          </td>
                          <td style={{ padding: "10px 12px", fontWeight: "600", color: "#111827" }}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                              <span>{providerName}</span>
                              {/* Prominent indicators for accounts requesting deletion or cancellation */}
                              {isAccountDeletionRequested && (
                                <span
                                  style={{
                                    fontSize: "10px",
                                    color: "#991B1B",
                                    backgroundColor: "#FEE2E2",
                                    padding: "2px 6px",
                                    borderRadius: "4px",
                                    fontWeight: "700",
                                    width: "fit-content",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "3px",
                                    border: "1px solid #FECACA",
                                  }}
                                  title={deletionReason}
                                >
                                  🚨 DELETION REQUESTED
                                </span>
                              )}
                              {isRequestCancellationActive && !isAccountDeletionRequested && (
                                <span
                                  style={{
                                    fontSize: "10px",
                                    color: "#92400E",
                                    backgroundColor: "#FEF3C7",
                                    padding: "2px 6px",
                                    borderRadius: "4px",
                                    fontWeight: "700",
                                    width: "fit-content",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "3px",
                                    border: "1px solid #FDE68A",
                                  }}
                                >
                                  ⚠️ CANCELLATION REQUEST
                                </span>
                              )}
                            </div>
                          </td>
                          <td style={{ padding: "10px 12px" }}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "flex-start" }}>
                              {isAccountDeletionRequested ? (
                                <span
                                  style={{
                                    padding: "3px 8px",
                                    borderRadius: "6px",
                                    fontSize: "11px",
                                    fontWeight: "700",
                                    backgroundColor: "#DC2626",
                                    color: "#fff",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  🚨 Deletion Requested
                                </span>
                              ) : isRequestCancellationActive ? (
                                <span
                                  style={{
                                    padding: "3px 8px",
                                    borderRadius: "6px",
                                    fontSize: "11px",
                                    fontWeight: "700",
                                    backgroundColor: "#D97706",
                                    color: "#fff",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  ⚠️ Request Cancellation
                                </span>
                              ) : (
                                <span
                                  style={{
                                    padding: "3px 8px",
                                    borderRadius: "6px",
                                    fontSize: "11px",
                                    fontWeight: "600",
                                    backgroundColor: isStatusVerificationCompleted
                                      ? "#2563EB"
                                      : isStatusActive
                                      ? "#10B981"
                                      : isStatusRejected
                                      ? "#EF4444"
                                      : "#F59E0B",
                                    color: "#fff",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  {providerStatus}
                                </span>
                              )}
                              {/* Request Reason Subtext if present */}
                              {isAccountDeletionRequested && (
                                <span style={{ fontSize: "10px", color: "#B91C1C", maxWidth: "160px", wordBreak: "break-word" }}>
                                  {deletionReason}
                                </span>
                              )}
                            </div>
                          </td>
                          <td style={{ padding: "10px 12px" }}>{deviceType}</td>
                          <td style={{ padding: "10px 12px" }}>{os || "Unknown"}</td>
                          <td style={{ padding: "10px 12px" }}>{browser || "Unknown"}</td>
                          {/* GATED ACCESS BUTTONS: SERVICES APPROVAL & MYBOOKING */}
                          <td style={{ padding: "10px 12px", textAlign: "center" }}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "6px", alignItems: "center" }}>
                              {/* Services Approval Button (Gated & Logged) */}
                              <button
                                onClick={() => {
                                  triggerAuditLog("services_catalog_click", {
                                    scope: "catalog_approval",
                                    actionLabel: "Services Approval Button Clicked",
                                  });
                                  initiateShieldProtocol(prov, "catalog_approval");
                                  if (typeof window.__fetchFastCatalogServices === "function") {
                                    window.__fetchFastCatalogServices(providerId);
                                  }
                                }}
                                style={{
                                  backgroundColor: "#0D9488",
                                  color: "#fff",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  border: "none",
                                  cursor: "pointer",
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  gap: "8px",
                                  width: "170px",
                                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                }}
                              >
                                <span>🔒 ⚡ Services Approval</span>
                                <span
                                  style={{
                                    backgroundColor: "rgba(255,255,255,0.25)",
                                    padding: "2px 6px",
                                    borderRadius: "10px",
                                    fontSize: "10px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {subcollectionFetchStatus?.[`${providerId}_catalog`] ? "…" : catalogCount}
                                </span>
                              </button>
                              {/* MyBooking Button (Gated & Logged) */}
                              <button
                                onClick={() => {
                                  const pId = prov?.id || prov?.uid || prov?.serviceReference || prov?._id;
                                  triggerAuditLog("my_bookings_ledger_click", {
                                    scope: "ledger_bookings",
                                    actionLabel: "MyBooking Button Clicked",
                                  });
                                  initiateShieldProtocol(prov, "ledger_bookings");
                                  if (typeof setSubcollectionFetchStatus === "function" && pId) {
                                    setSubcollectionFetchStatus((prev) => ({
                                      ...prev,
                                      [`${pId}_ledger`]: true,
                                    }));
                                  }
                                  (async () => {
                                    if (
                                      pId &&
                                      typeof db !== "undefined" &&
                                      typeof collection === "function" &&
                                      typeof getDocs === "function"
                                    ) {
                                      try {
                                        const subcollNames = ["Bookings", "MyBooking", "bookings"];
                                        const fetchedBookings = [];
                                        const seenIds = new Set();
                                        // 1. Fetch from 'providers' subcollections
                                        for (const cName of subcollNames) {
                                          try {
                                            const snap = await getDocs(collection(db, "providers", pId, cName));
                                            snap.docs.forEach((docSnap) => {
                                              if (!seenIds.has(docSnap.id)) {
                                                seenIds.add(docSnap.id);
                                                const d = docSnap.data() || {};
                                                fetchedBookings.push({
                                                  id: docSnap.id,
                                                  bookingId: d.bookingId || docSnap.id,
                                                  address: d.address || "",
                                                  bookingDate: d.bookingDate || "",
                                                  bookingDateTimestamp: d.bookingDateTimestamp || null,
                                                  bookingStatus: d.bookingStatus || "",
                                                  bookingTime: d.bookingTime || "",
                                                  bookingTimeStamp: d.bookingTimeStamp || null,
                                                  createdAt: d.createdAt || null,
                                                  customerId: d.customerId || "",
                                                  customerName: d.customerName || "",
                                                  customerToken: d.customerToken || "",
                                                  duration: d.duration || "",
                                                  hasPets: d.hasPets ?? false,
                                                  idempotencyKey: d.idempotencyKey || "",
                                                  jobDescription: d.jobDescription || "",
                                                  latitude: d.latitude ?? null,
                                                  longitude: d.longitude ?? null,
                                                  paymentMethod: d.paymentMethod || "",
                                                  paymentMethodDisplay: d.paymentMethodDisplay || "",
                                                  paymentStatus: d.paymentStatus || "",
                                                  providerId: d.providerId || pId,
                                                  providerPayout: d.providerPayout !== undefined ? d.providerPayout : (d.provider_payout !== undefined ? d.provider_payout : (d.payoutAmount !== undefined ? d.payoutAmount : "")),
                                                  serviceId: d.serviceId || "",
                                                  serviceName: d.serviceName || "",
                                                  status: d.status || "",
                                                  totalCharge: d.totalCharge !== undefined && d.totalCharge !== null ? d.totalCharge : "",
                                                  customer_total_amount: d.customer_total_amount !== undefined ? d.customer_total_amount : (d.totalCharge || d.totalAmount || 0),
                                                  ugRevenue: d.ugRevenue !== undefined ? d.ugRevenue : (d.ug_revenue || 0),
                                                  stripeProcessingFee: d.stripeProcessingFee !== undefined ? d.stripeProcessingFee : (d.stripe_fee || d.stripeFee || 0),
                                                  ...d,
                                                  _discoveredSubcollection: `providers/${cName}`,
                                                });
                                              }
                                            });
                                          } catch (e) {}
                                        }
                                        // 2. Also check 'users' subcollections
                                        for (const cName of subcollNames) {
                                          try {
                                            const snapUser = await getDocs(collection(db, "users", pId, cName));
                                            snapUser.docs.forEach((docSnap) => {
                                              if (!seenIds.has(docSnap.id)) {
                                                seenIds.add(docSnap.id);
                                                const d = docSnap.data() || {};
                                                fetchedBookings.push({
                                                  id: docSnap.id,
                                                  bookingId: d.bookingId || docSnap.id,
                                                  address: d.address || "",
                                                  bookingDate: d.bookingDate || "",
                                                  bookingDateTimestamp: d.bookingDateTimestamp || null,
                                                  bookingStatus: d.bookingStatus || "",
                                                  bookingTime: d.bookingTime || "",
                                                  bookingTimeStamp: d.bookingTimeStamp || null,
                                                  createdAt: d.createdAt || null,
                                                  customerId: d.customerId || "",
                                                  customerName: d.customerName || "",
                                                  customerToken: d.customerToken || "",
                                                  duration: d.duration || "",
                                                  hasPets: d.hasPets ?? false,
                                                  idempotencyKey: d.idempotencyKey || "",
                                                  jobDescription: d.jobDescription || "",
                                                  latitude: d.latitude ?? null,
                                                  longitude: d.longitude ?? null,
                                                  paymentMethod: d.paymentMethod || "",
                                                  paymentMethodDisplay: d.paymentMethodDisplay || "",
                                                  paymentStatus: d.paymentStatus || "",
                                                  providerId: d.providerId || pId,
                                                  providerPayout: d.providerPayout !== undefined ? d.providerPayout : (d.provider_payout !== undefined ? d.provider_payout : (d.payoutAmount !== undefined ? d.payoutAmount : "")),
                                                  serviceId: d.serviceId || "",
                                                  serviceName: d.serviceName || "",
                                                  status: d.status || "",
                                                  totalCharge: d.totalCharge !== undefined && d.totalCharge !== null ? d.totalCharge : "",
                                                  customer_total_amount: d.customer_total_amount !== undefined ? d.customer_total_amount : (d.totalCharge || d.totalAmount || 0),
                                                  ugRevenue: d.ugRevenue !== undefined ? d.ugRevenue : (d.ug_revenue || 0),
                                                  stripeProcessingFee: d.stripeProcessingFee !== undefined ? d.stripeProcessingFee : (d.stripe_fee || d.stripeFee || 0),
                                                  ...d,
                                                  _discoveredSubcollection: `users/${cName}`,
                                                });
                                              }
                                            });
                                          } catch (e) {}
                                        }
                                        if (typeof setProviderLedgerRegistry === "function") {
                                          setProviderLedgerRegistry((prev) => ({
                                            ...prev,
                                            [pId]: fetchedBookings,
                                          }));
                                        } else if (typeof providerLedgerRegistry !== "undefined") {
                                          providerLedgerRegistry[pId] = fetchedBookings;
                                        }
                                      } catch (prefetchErr) {
                                        console.warn("Error reading Bookings subcollection:", prefetchErr);
                                      } finally {
                                        if (typeof setSubcollectionFetchStatus === "function") {
                                          setSubcollectionFetchStatus((prev) => ({
                                            ...prev,
                                            [`${pId}_ledger`]: false,
                                          }));
                                        }
                                      }
                                    }
                                  })();
                                }}
                                style={{
                                  backgroundColor: "#4F46E5",
                                  color: "#fff",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  border: "none",
                                  cursor: "pointer",
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  gap: "8px",
                                  width: "170px",
                                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                }}
                              >
                                <span>🔒 📅 MyBooking</span>
                                <span
                                  style={{
                                    backgroundColor: "rgba(255,255,255,0.25)",
                                    padding: "2px 6px",
                                    borderRadius: "10px",
                                    fontSize: "10px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {subcollectionFetchStatus?.[`${providerId}_ledger`] ? "…" : ledgerCount}
                                </span>
                              </button>
                            </div>
                          </td>
                          {/* ACTION BUTTONS: VIEW, STRIPE KYC, NOTES, & REQUEST CANCELLATION */}
                          <td style={{ padding: "10px 12px", textAlign: "center" }}>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "6px",
                                alignItems: "stretch",
                                minWidth: "135px",
                              }}
                            >
                              {/* View Profile Button (Gated & Logged) */}
                              <button
                                onClick={() => {
                                  triggerAuditLog("profile_view_click", {
                                    scope: "profile_view",
                                    actionLabel: "View Profile Clicked",
                                  });
                                  initiateShieldProtocol(prov, "profile_view");
                                }}
                                style={{
                                  backgroundColor: "#2563EB",
                                  color: "#fff",
                                  padding: "6px 10px",
                                  borderRadius: "6px",
                                  border: "none",
                                  cursor: "pointer",
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  width: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "4px",
                                }}
                              >
                                🔒 View
                              </button>
                              {/* Stripe KYC Button (Gated & Logged) */}
                              <button
                                onClick={() => {
                                  triggerAuditLog("stripe_kyc_click", {
                                    scope: "stripe_kyc",
                                    actionLabel: "Stripe KYC Button Clicked",
                                  });
                                  initiateShieldProtocol(prov, "stripe_kyc");
                                }}
                                style={{
                                  backgroundColor: "#8B5CF6",
                                  color: "#fff",
                                  padding: "6px 10px",
                                  borderRadius: "6px",
                                  border: "none",
                                  cursor: "pointer",
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  width: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "4px",
                                }}
                              >
                                🔒 💰 Stripe KYC
                              </button>
                              {/* Notes Button (Logged) */}
                              <button
                                onClick={() => {
                                  triggerAuditLog("notes_modal_opened", {
                                    scope: "provider_notes",
                                    actionLabel: "Provider Notes Modal Opened",
                                  });
                                  if (typeof setInspectedNotesProvider === "function") {
                                    setInspectedNotesProvider(prov);
                                  }
                                }}
                                style={{
                                  backgroundColor: "#059669",
                                  color: "#fff",
                                  padding: "6px 10px",
                                  borderRadius: "6px",
                                  border: "none",
                                  cursor: "pointer",
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  width: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "4px",
                                }}
                              >
                                📝 Notes {notesCount > 0 ? `(${notesCount})` : ""}
                              </button>
                              {/* Request Cancellation / Cancel Deletion Request Button */}
                              {isAccountDeletionRequested ? (
                                <button
                                  onClick={() => handleCancelProviderOrDeletionRequest("deletion")}
                                  style={{
                                    backgroundColor: "#DC2626",
                                    color: "#fff",
                                    padding: "6px 10px",
                                    borderRadius: "6px",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "11px",
                                    fontWeight: "700",
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "4px",
                                    boxShadow: "0 1px 3px rgba(220, 38, 38, 0.3)",
                                  }}
                                  title="Cancel provider's account deletion request and restore active status"
                                >
                                  ↩ Cancel Deletion Req
                                </button>
                              ) : isRequestCancellationActive ? (
                                <button
                                  onClick={() => handleCancelProviderOrDeletionRequest("cancellation")}
                                  style={{
                                    backgroundColor: "#D97706",
                                    color: "#fff",
                                    padding: "6px 10px",
                                    borderRadius: "6px",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "11px",
                                    fontWeight: "700",
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "4px",
                                    boxShadow: "0 1px 3px rgba(217, 119, 6, 0.3)",
                                  }}
                                  title="Cancel pending catalog/service request"
                                >
                                  ↩ Process Cancellation
                                </button>
                              ) : (
                                <button
                                  onClick={() => handleCancelProviderOrDeletionRequest("catalog_request")}
                                  style={{
                                    backgroundColor: "#F3F4F6",
                                    color: "#6B7280",
                                    padding: "5px 10px",
                                    borderRadius: "6px",
                                    border: "1px solid #E5E7EB",
                                    cursor: "pointer",
                                    fontSize: "11px",
                                    fontWeight: "600",
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "4px",
                                  }}
                                  title="Manually trigger request cancellation mechanism for this provider"
                                >
                                  ⚙ Request Cancellation
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              );
            })()}
          </div>
        </div>
      </div>
      {/* ========================================================= */}
      {/* ============ MODAL 1: SERVICES APPROVAL MODAL ============ */}
      {/* ========================================================= */}
      {inspectedCatalogProvider && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(17, 24, 39, 0.65)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
            padding: "20px",
          }}
          onClick={() => setInspectedCatalogProvider(null)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#fff",
              borderRadius: "16px",
              width: "1100px",
              maxWidth: "96vw",
              maxHeight: "88vh",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
              overflow: "hidden",
            }}
          >
            {/* Modal Header */}
            <div
              style={{
                padding: "16px 24px",
                borderBottom: "1px solid #E5E7EB",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#F0FDFA",
                flexWrap: "wrap",
                gap: "12px",
              }}
            >
              <div>
                <h3 style={{ margin: 0, fontSize: "17px", fontWeight: "700", color: "#0F766E", display: "flex", alignItems: "center", gap: "8px" }}>
                  ⚡ Services Approval Subcollection Data (All Categories, Admin Pending, & User Notifications)
                </h3>
                <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#4B5563" }}>
                  Provider: <strong>{inspectedCatalogProvider.name || inspectedCatalogProvider.displayName || inspectedCatalogProvider.id}</strong> ({inspectedCatalogProvider.id}) — Count: <strong>{(providerCatalogRegistry?.[inspectedCatalogProvider.id] || []).length} items</strong>
                </p>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                {/* HIGH-SPEED REFRESH BUTTON INSIDE SERVICES MODAL */}
                <button
                  onClick={async () => {
                    const pId = inspectedCatalogProvider.id || inspectedCatalogProvider.uid;
                    if (typeof window.__fetchFastCatalogServices === "function") {
                      await window.__fetchFastCatalogServices(pId);
                    }
                  }}
                  disabled={subcollectionFetchStatus?.[`${inspectedCatalogProvider.id}_catalog`]}
                  style={{
                    backgroundColor: subcollectionFetchStatus?.[`${inspectedCatalogProvider.id}_catalog`] ? "#0D9488" : "#0F766E",
                    color: "#fff",
                    border: "none",
                    padding: "8px 14px",
                    borderRadius: "8px",
                    cursor: subcollectionFetchStatus?.[`${inspectedCatalogProvider.id}_catalog`] ? "not-allowed" : "pointer",
                    fontSize: "12px",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
                    transition: "all 0.2s ease",
                  }}
                  title="Immediately re-fetch all services from Firebase across all 3 collections"
                >
                  <span
                    style={{
                      fontSize: "13px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      animation: subcollectionFetchStatus?.[`${inspectedCatalogProvider.id}_catalog`] ? "spin-refresh 1s linear infinite" : "none",
                    }}
                  >
                    🔄
                  </span>
                  <span>{subcollectionFetchStatus?.[`${inspectedCatalogProvider.id}_catalog`] ? "Fetching…" : "Refresh Services"}</span>
                </button>
                <button
                  onClick={() => setInspectedCatalogProvider(null)}
                  style={{
                    backgroundColor: "#374151",
                    color: "#fff",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  ✖ Close
                </button>
              </div>
            </div>
            {/* Modal Body */}
            <div style={{ padding: "20px", overflowY: "auto", flex: 1, backgroundColor: "#F9FAFB" }}>
              {subcollectionFetchStatus?.[`${inspectedCatalogProvider.id}_catalog`] && (!providerCatalogRegistry?.[inspectedCatalogProvider.id] || providerCatalogRegistry[inspectedCatalogProvider.id].length === 0) ? (
                <div style={{ textAlign: "center", padding: "40px 0" }}>
                  <p style={{ fontSize: "14px", color: "#0F766E", fontWeight: 600 }}>Scanning services across Admin Pending, User Notification, & All Categories…</p>
                </div>
              ) : (providerCatalogRegistry?.[inspectedCatalogProvider.id] || []).length === 0 ? (
                <div style={{ textAlign: "center", padding: "40px 0" }}>
                  <p style={{ fontSize: "14px", color: "#6B7280" }}>No service documents found in any of the approval collections for this provider.</p>
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                  {(providerCatalogRegistry?.[inspectedCatalogProvider.id] || []).map((srv, sIdx) => {
                    const isServiceApproved =
                      srv.is_approved === true ||
                      String(srv.approval_status).toLowerCase() === "approved" ||
                      String(srv.status).toLowerCase() === "approved";
                    const isServiceRejected =
                      String(srv.approval_status).toLowerCase() === "rejected" ||
                      String(srv.status).toLowerCase() === "rejected" ||
                      (srv.is_approved === false && Boolean(srv.rejection_reason));
                    // Helper to format dates & temporal timestamps
                    const formatServiceTemporal = (temporalVal) => {
                      if (!temporalVal) return "—";
                      if (typeof stringifyFirestoreTemporal === "function") return stringifyFirestoreTemporal(temporalVal);
                      if (temporalVal?.toDate && typeof temporalVal.toDate === "function") return temporalVal.toDate().toLocaleString();
                      if (temporalVal?.seconds) return new Date(temporalVal.seconds * 1000).toLocaleString();
                      if (typeof temporalVal === "string" || typeof temporalVal === "number") {
                        const d = new Date(temporalVal);
                        if (!isNaN(d.getTime())) return d.toLocaleString();
                      }
                      return String(temporalVal);
                    };
                    // Normalized list of media items supporting both media.items and gallery_media.items
                    const mediaItems = Array.isArray(srv.media?.items)
                      ? srv.media.items
                      : Array.isArray(srv.gallery_media?.items)
                      ? srv.gallery_media.items
                      : Array.isArray(srv.media)
                      ? srv.media
                      : Array.isArray(srv.gallery_media)
                      ? srv.gallery_media
                      : [];
                    // Also gather simple image URLs
                    const rawGallery = srv.gallery_images || srv.galleryImages || srv.images || [];
                    const simpleGalleryUrls = (Array.isArray(rawGallery) ? rawGallery : (rawGallery ? [rawGallery] : [])).map((item) => {
                      if (typeof item === "string") return item;
                      if (item && typeof item === "object") return item.url || item.file || item.downloadURL || item.src || item.path || "";
                      return "";
                    }).filter(Boolean);
                    const srvTitle = srv.service_name || srv.name || "Untitled Service";
                    const srvId = srv.service_id || srv.id || `srv_${sIdx}`;
                    return (
                      <div
                        key={srv.id || srv.service_id || sIdx}
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #CCFBF1",
                          borderRadius: "12px",
                          padding: "18px",
                          boxShadow: "0 2px 5px rgba(0,0,0,0.04)",
                        }}
                      >
                        {/* Service Top Line */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            borderBottom: "1px solid #F3F4F6",
                            paddingBottom: "10px",
                            marginBottom: "12px",
                            flexWrap: "wrap",
                            gap: "10px",
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                            <span style={{ fontSize: "15px", fontWeight: "700", color: "#111827" }}>
                              {srvTitle}
                            </span>
                            <span style={{ fontSize: "11px", color: "#6B7280", backgroundColor: "#F3F4F6", padding: "2px 8px", borderRadius: "4px" }}>
                              Service ID: {srvId}
                            </span>
                            <span style={{ fontSize: "11px", color: "#0F766E", backgroundColor: "#E0F2FE", padding: "2px 8px", borderRadius: "4px", fontWeight: 600 }}>
                              Source(s): {srv._discoveredSubcollection || "Subcollection"}
                            </span>
                            {srv.set_as_feature && (
                              <span style={{ backgroundColor: "#FEF3C7", color: "#D97706", fontSize: "10px", padding: "2px 6px", borderRadius: "4px", fontWeight: 700 }}>
                                FEATURED
                              </span>
                            )}
                          </div>
                          <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
                            <span
                              style={{
                                padding: "4px 10px",
                                borderRadius: "6px",
                                fontSize: "11px",
                                fontWeight: "600",
                                backgroundColor: isServiceApproved
                                  ? "#10B981"
                                  : isServiceRejected
                                  ? "#EF4444"
                                  : "#F59E0B",
                                color: "#fff",
                                textTransform: "capitalize",
                              }}
                            >
                              Status: {srv.approval_status || srv.status || (isServiceApproved ? "approved" : isServiceRejected ? "rejected" : "pending_verification")}
                            </span>
                            <span
                              style={{
                                padding: "4px 10px",
                                borderRadius: "6px",
                                fontSize: "11px",
                                fontWeight: "600",
                                backgroundColor: srv.is_active ? "#3B82F6" : "#9CA3AF",
                                color: "#fff",
                              }}
                            >
                              {srv.is_active ? "Active" : "Inactive"}
                            </span>
                          </div>
                        </div>
                        {/* REJECTION REASON BANNER */}
                        {srv.rejection_reason && (
                          <div
                            style={{
                              backgroundColor: "#FEF2F2",
                              border: "1px solid #FECACA",
                              borderRadius: "8px",
                              padding: "10px 14px",
                              marginBottom: "14px",
                              display: "flex",
                              alignItems: "flex-start",
                              gap: "8px",
                            }}
                          >
                            <span style={{ fontSize: "16px" }}>⚠️</span>
                            <div>
                              <div style={{ fontSize: "12px", fontWeight: "700", color: "#991B1B" }}>
                                Rejection Reason:
                              </div>
                              <div style={{ fontSize: "12px", color: "#B91C1C", marginTop: "2px", whiteSpace: "pre-wrap" }}>
                                {srv.rejection_reason}
                              </div>
                              {srv.reviewed_by && (
                                <div style={{ fontSize: "11px", color: "#6B7280", marginTop: "4px" }}>
                                  Reviewed by <strong>{srv.reviewed_by}</strong> on {formatServiceTemporal(srv.reviewed_at)}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                        {/* APPROVED REVIEW DETAILS BANNER */}
                        {isServiceApproved && srv.reviewed_by && (
                          <div
                            style={{
                              backgroundColor: "#ECFDF5",
                              border: "1px solid #A7F3D0",
                              borderRadius: "8px",
                              padding: "8px 12px",
                              marginBottom: "14px",
                              fontSize: "12px",
                              color: "#065F46",
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <span>✔</span>
                            <span>
                              Approved by <strong>{srv.reviewed_by}</strong> on {formatServiceTemporal(srv.reviewed_at)}
                            </span>
                          </div>
                        )}
                        {/* Requested Fields Grid */}
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
                            gap: "10px 16px",
                            fontSize: "12px",
                            color: "#374151",
                            marginBottom: "14px",
                          }}
                        >
                          <div><strong>Address:</strong> {srv.address || "—"}</div>
                          <div><strong>Category:</strong> {srv.category || "—"}</div>
                          <div><strong>Sub Category:</strong> {srv.sub_category || "—"}</div>
                          <div><strong>Category Type:</strong> {srv.category_type || "—"}</div>
                          <div><strong>Suggest Category:</strong> {srv.suggest_category || "—"}</div>
                          <div><strong>Price:</strong> £{srv.price ?? "—"}</div>
                          <div><strong>Original Price:</strong> £{srv.original_price ?? "—"}</div>
                          <div><strong>Discount:</strong> {srv.discount ?? 0}%</div>
                          <div><strong>Discount Amount:</strong> £{srv.discount_amount ?? 0}</div>
                          <div><strong>Discounted Price:</strong> £{srv.discounted_price ?? "—"}</div>
                          <div><strong>Final Price:</strong> £{srv.final_price ?? "—"}</div>
                          <div><strong>Duration:</strong> {srv.duration_hour || 0}h {srv.duration_mins || 0}m</div>
                          <div><strong>Provider ID:</strong> {srv.provider_id || srv.providerId}</div>
                          <div><strong>Latitude:</strong> {srv.latitude ?? "—"}</div>
                          <div><strong>Longitude:</strong> {srv.longitude ?? "—"}</div>
                          <div><strong>Storage Image Name:</strong> {srv.storage_img_name || "—"}</div>
                          <div><strong>Reviewed By:</strong> <span style={{ color: "#1E40AF", fontWeight: "600" }}>{srv.reviewed_by || "—"}</span></div>
                          <div><strong>Reviewed At:</strong> <span style={{ fontWeight: "600" }}>{formatServiceTemporal(srv.reviewed_at)}</span></div>
                          <div><strong>Rejection Reason:</strong> <span style={{ color: srv.rejection_reason ? "#DC2626" : "#374151", fontWeight: srv.rejection_reason ? "600" : "normal" }}>{srv.rejection_reason || "None"}</span></div>
                          <div><strong>Edited By Provider:</strong> {srv.edited_by_provider ? "Yes" : "No"}</div>
                          <div><strong>Has Videos:</strong> {srv.has_videos || mediaItems.some((m) => m?.type === "video") ? "Yes" : "No"}</div>
                          <div><strong>Gallery Images Count:</strong> {simpleGalleryUrls.length}</div>
                          <div><strong>Gallery Media / Media Items:</strong> {mediaItems.length}</div>
                          <div><strong>Total Media Count:</strong> {srv.total_media_count ?? (simpleGalleryUrls.length + mediaItems.length)}</div>
                          <div><strong>Version:</strong> v{srv.version ?? 1}</div>
                          <div><strong>Submitted For Review At:</strong> {formatServiceTemporal(srv.submitted_for_review_at)}</div>
                          <div><strong>Created At:</strong> {formatServiceTemporal(srv.created_at)}</div>
                          <div><strong>Updated At:</strong> {formatServiceTemporal(srv.updated_at)}</div>
                          <div><strong>Timestamp:</strong> {formatServiceTemporal(srv.timestamp)}</div>
                          <div style={{ gridColumn: "1 / -1" }}><strong>Description:</strong> {srv.description || "—"}</div>
                          <div style={{ gridColumn: "1 / -1" }}>
                            <strong>Tools:</strong> {srv.tools && srv.tools.length > 0 ? srv.tools.join(", ") : "None"}
                          </div>
                          <div style={{ gridColumn: "1 / -1" }}>
                            <strong>Search Keywords:</strong> {srv.search_keywords && srv.search_keywords.length > 0 ? srv.search_keywords.join(", ") : "None"}
                          </div>
                        </div>
                        {/* GALLERY & MEDIA ITEMS (IMAGES & VIDEOS) WITH STATUS BADGES */}
                        <div
                          style={{
                            borderTop: "1px solid #E5E7EB",
                            paddingTop: "12px",
                            marginTop: "10px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginBottom: "10px",
                            }}
                          >
                            <span style={{ fontSize: "13px", fontWeight: "700", color: "#111827", display: "flex", alignItems: "center", gap: "6px" }}>
                              🖼 Media Items & Gallery ({mediaItems.length + simpleGalleryUrls.length})
                            </span>
                            <span style={{ fontSize: "11px", color: "#6B7280" }}>
                              Click media thumbnail to enlarge image or play video
                            </span>
                          </div>
                          {mediaItems.length === 0 && simpleGalleryUrls.length === 0 ? (
                            <div
                              style={{
                                padding: "10px 14px",
                                backgroundColor: "#F9FAFB",
                                borderRadius: "8px",
                                border: "1px dashed #D1D5DB",
                                fontSize: "12px",
                                color: "#9CA3AF",
                                fontStyle: "italic",
                              }}
                            >
                              No media or gallery items found for this service.
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "12px",
                                alignItems: "flex-start",
                              }}
                            >
                              {/* 1. Render Rich media.items / gallery_media.items */}
                              {mediaItems.map((item, mIdx) => {
                                const mediaFileUrl = item?.url || item?.file || "";
                                const mediaThumb = item?.thumbnail || mediaFileUrl;
                                const isVideo = item?.type === "video" || mediaFileUrl.includes(".mp4");
                                const itemStatus = item?.status || "pending";
                                const isApproved = String(itemStatus).toLowerCase() === "approved";
                                const isRejected = String(itemStatus).toLowerCase() === "rejected";
                                return (
                                  <div
                                    key={`media_item_${srvId}_${mIdx}`}
                                    style={{
                                      border: "1px solid #E5E7EB",
                                      borderRadius: "8px",
                                      padding: "6px",
                                      backgroundColor: "#FFFFFF",
                                      boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      width: "120px",
                                      position: "relative",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "100%",
                                        height: "75px",
                                        overflow: "hidden",
                                        borderRadius: "6px",
                                        backgroundColor: "#000",
                                        cursor: "pointer",
                                        position: "relative",
                                      }}
                                      onClick={() => {
                                        if (typeof window !== "undefined" && typeof window.__openImageModal === "function") {
                                          window.__openImageModal(mediaFileUrl, srvTitle, srvId, isVideo ? "video" : "image");
                                        }
                                      }}
                                    >
                                      {isVideo ? (
                                        item.thumbnail ? (
                                          <img
                                            src={item.thumbnail}
                                            alt="Video thumbnail"
                                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                          />
                                        ) : (
                                          <video
                                            src={mediaFileUrl}
                                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                          />
                                        )
                                      ) : (
                                        <img
                                          src={mediaThumb}
                                          alt="Media item"
                                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                        />
                                      )}
                                      <span
                                        style={{
                                          position: "absolute",
                                          top: "3px",
                                          left: "3px",
                                          backgroundColor: isVideo ? "#7C3AED" : "rgba(0,0,0,0.6)",
                                          color: "#fff",
                                          fontSize: "9px",
                                          fontWeight: "700",
                                          padding: "1px 4px",
                                          borderRadius: "3px",
                                        }}
                                      >
                                        {isVideo ? "🎬 VIDEO" : `#${item.order ?? mIdx}`}
                                      </span>
                                      {item.duration_seconds && (
                                        <span
                                          style={{
                                            position: "absolute",
                                            bottom: "3px",
                                            right: "3px",
                                            backgroundColor: "rgba(0,0,0,0.75)",
                                            color: "#fff",
                                            fontSize: "9px",
                                            padding: "1px 4px",
                                            borderRadius: "3px",
                                          }}
                                        >
                                          {item.duration_seconds}s
                                        </span>
                                      )}
                                    </div>
                                    <span
                                      style={{
                                        marginTop: "4px",
                                        fontSize: "10px",
                                        fontWeight: "700",
                                        padding: "1px 6px",
                                        borderRadius: "4px",
                                        backgroundColor: isApproved ? "#D1FAE5" : isRejected ? "#FEE2E2" : "#FEF3C7",
                                        color: isApproved ? "#065F46" : isRejected ? "#991B1B" : "#92400E",
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {itemStatus}
                                    </span>
                                    <button
                                      onClick={() => {
                                        if (typeof window !== "undefined" && typeof window.__openImageModal === "function") {
                                          window.__openImageModal(mediaFileUrl, srvTitle, srvId, isVideo ? "video" : "image");
                                        }
                                      }}
                                      style={{
                                        marginTop: "4px",
                                        width: "100%",
                                        backgroundColor: "#F0FDFA",
                                        color: "#0F766E",
                                        border: "1px solid #CCFBF1",
                                        padding: "3px 5px",
                                        borderRadius: "4px",
                                        fontSize: "10px",
                                        fontWeight: "600",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {isVideo ? "▶ Play" : "👁 View"}
                                    </button>
                                  </div>
                                );
                              })}
                              {/* 2. Render Simple Images */}
                              {simpleGalleryUrls.map((imgUrl, imgIndex) => (
                                <div
                                  key={`srv_img_${srvId}_${imgIndex}`}
                                  style={{
                                    border: "1px solid #E5E7EB",
                                    borderRadius: "8px",
                                    padding: "6px",
                                    backgroundColor: "#FFFFFF",
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    width: "110px",
                                    position: "relative",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      height: "75px",
                                      overflow: "hidden",
                                      borderRadius: "6px",
                                      backgroundColor: "#F3F4F6",
                                      cursor: "pointer",
                                      position: "relative",
                                    }}
                                    onClick={() => {
                                      if (typeof window !== "undefined" && typeof window.__openImageModal === "function") {
                                        window.__openImageModal(imgUrl, srvTitle, srvId, "image");
                                      }
                                    }}
                                  >
                                    <img
                                      src={imgUrl}
                                      alt={`${srvTitle} gallery ${imgIndex + 1}`}
                                      style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = "https://via.placeholder.com/100?text=Error+Loading";
                                      }}
                                    />
                                    <span
                                      style={{
                                        position: "absolute",
                                        top: "3px",
                                        left: "3px",
                                        backgroundColor: "rgba(0,0,0,0.6)",
                                        color: "#fff",
                                        fontSize: "9px",
                                        fontWeight: "700",
                                        padding: "1px 4px",
                                        borderRadius: "3px",
                                      }}
                                    >
                                      Img #{imgIndex + 1}
                                    </span>
                                  </div>
                                  <button
                                    onClick={() => {
                                      if (typeof window !== "undefined" && typeof window.__openImageModal === "function") {
                                        window.__openImageModal(imgUrl, srvTitle, srvId, "image");
                                      }
                                    }}
                                    style={{
                                      marginTop: "6px",
                                      width: "100%",
                                      backgroundColor: "#F0FDFA",
                                      color: "#0F766E",
                                      border: "1px solid #CCFBF1",
                                      padding: "4px 6px",
                                      borderRadius: "4px",
                                      fontSize: "11px",
                                      fontWeight: "600",
                                      cursor: "pointer",
                                    }}
                                  >
                                    👁 View
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {/* ================================================== */}
      {/* ============ MODAL 2: MYBOOKINGS MODAL ============ */}
      {/* ================================================== */}
      {inspectedLedgerProvider && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(17, 24, 39, 0.65)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
            padding: "20px",
          }}
          onClick={() => setInspectedLedgerProvider(null)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#fff",
              borderRadius: "16px",
              width: "1160px",
              maxWidth: "96vw",
              maxHeight: "88vh",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
              overflow: "hidden",
            }}
          >
            {/* Modal Header */}
            <div
              style={{
                padding: "16px 24px",
                borderBottom: "1px solid #E5E7EB",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#EEF2FF",
              }}
            >
              <div>
                <h3 style={{ margin: 0, fontSize: "17px", fontWeight: "700", color: "#3730A3", display: "flex", alignItems: "center", gap: "8px" }}>
                  📅 Provider Bookings (Bookings & MyBooking Subcollections)
                </h3>
                <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#4B5563" }}>
                  Provider: <strong>{inspectedLedgerProvider.name || inspectedLedgerProvider.displayName || inspectedLedgerProvider.id}</strong> ({inspectedLedgerProvider.id}) — Total Bookings: <strong>{(providerLedgerRegistry?.[inspectedLedgerProvider.id] || []).length}</strong>
                </p>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                {/* On-Demand Subcollection Sync Button */}
                <button
                  onClick={async () => {
                    const targetId = inspectedLedgerProvider.id || inspectedLedgerProvider.uid;
                    if (
                      targetId &&
                      typeof db !== "undefined" &&
                      typeof collection === "function" &&
                      typeof getDocs === "function"
                    ) {
                      try {
                        const subcollNames = ["Bookings", "MyBooking", "bookings"];
                        const fetchedList = [];
                        const seenIds = new Set();
                        for (const cName of subcollNames) {
                          try {
                            const snap = await getDocs(collection(db, "providers", targetId, cName));
                            snap.docs.forEach((docSnap) => {
                              if (!seenIds.has(docSnap.id)) {
                                seenIds.add(docSnap.id);
                                const d = docSnap.data() || {};
                                fetchedList.push({
                                  id: docSnap.id,
                                  bookingId: d.bookingId || docSnap.id,
                                  address: d.address || "",
                                  bookingDate: d.bookingDate || "",
                                  bookingDateTimestamp: d.bookingDateTimestamp || null,
                                  bookingStatus: d.bookingStatus || "",
                                  bookingTime: d.bookingTime || "",
                                  bookingTimeStamp: d.bookingTimeStamp || null,
                                  createdAt: d.createdAt || null,
                                  customerId: d.customerId || "",
                                  customerName: d.customerName || "",
                                  customerToken: d.customerToken || "",
                                  duration: d.duration || "",
                                  hasPets: d.hasPets ?? false,
                                  idempotencyKey: d.idempotencyKey || "",
                                  jobDescription: d.jobDescription || "",
                                  latitude: d.latitude ?? null,
                                  longitude: d.longitude ?? null,
                                  paymentMethod: d.paymentMethod || "",
                                  paymentMethodDisplay: d.paymentMethodDisplay || "",
                                  paymentStatus: d.paymentStatus || "",
                                  providerId: d.providerId || targetId,
                                  providerPayout: d.providerPayout !== undefined ? d.providerPayout : (d.provider_payout !== undefined ? d.provider_payout : (d.payoutAmount !== undefined ? d.payoutAmount : "")),
                                  serviceId: d.serviceId || "",
                                  serviceName: d.serviceName || "",
                                  status: d.status || "",
                                  totalCharge: d.totalCharge !== undefined && d.totalCharge !== null ? d.totalCharge : "",
                                  customer_total_amount: d.customer_total_amount !== undefined ? d.customer_total_amount : (d.totalCharge || d.totalAmount || 0),
                                  ugRevenue: d.ugRevenue !== undefined ? d.ugRevenue : (d.ug_revenue || 0),
                                  stripeProcessingFee: d.stripeProcessingFee !== undefined ? d.stripeProcessingFee : (d.stripe_fee || d.stripeFee || 0),
                                  ...d,
                                  _discoveredSubcollection: `providers/${cName}`,
                                });
                              }
                            });
                          } catch (e) {}
                        }
                        for (const cName of subcollNames) {
                          try {
                            const snapUser = await getDocs(collection(db, "users", targetId, cName));
                            snapUser.docs.forEach((docSnap) => {
                              if (!seenIds.has(docSnap.id)) {
                                seenIds.add(docSnap.id);
                                const d = docSnap.data() || {};
                                fetchedList.push({
                                  id: docSnap.id,
                                  bookingId: d.bookingId || docSnap.id,
                                  address: d.address || "",
                                  bookingDate: d.bookingDate || "",
                                  bookingDateTimestamp: d.bookingDateTimestamp || null,
                                  bookingStatus: d.bookingStatus || "",
                                  bookingTime: d.bookingTime || "",
                                  bookingTimeStamp: d.bookingTimeStamp || null,
                                  createdAt: d.createdAt || null,
                                  customerId: d.customerId || "",
                                  customerName: d.customerName || "",
                                  customerToken: d.customerToken || "",
                                  duration: d.duration || "",
                                  hasPets: d.hasPets ?? false,
                                  idempotencyKey: d.idempotencyKey || "",
                                  jobDescription: d.jobDescription || "",
                                  latitude: d.latitude ?? null,
                                  longitude: d.longitude ?? null,
                                  paymentMethod: d.paymentMethod || "",
                                  paymentMethodDisplay: d.paymentMethodDisplay || "",
                                  paymentStatus: d.paymentStatus || "",
                                  providerId: d.providerId || targetId,
                                  providerPayout: d.providerPayout !== undefined ? d.providerPayout : (d.provider_payout !== undefined ? d.provider_payout : (d.payoutAmount !== undefined ? d.payoutAmount : "")),
                                  serviceId: d.serviceId || "",
                                  serviceName: d.serviceName || "",
                                  status: d.status || "",
                                  totalCharge: d.totalCharge !== undefined && d.totalCharge !== null ? d.totalCharge : "",
                                  customer_total_amount: d.customer_total_amount !== undefined ? d.customer_total_amount : (d.totalCharge || d.totalAmount || 0),
                                  ugRevenue: d.ugRevenue !== undefined ? d.ugRevenue : (d.ug_revenue || 0),
                                  stripeProcessingFee: d.stripeProcessingFee !== undefined ? d.stripeProcessingFee : (d.stripe_fee || d.stripeFee || 0),
                                  ...d,
                                  _discoveredSubcollection: `users/${cName}`,
                                });
                              }
                            });
                          } catch (e) {}
                        }
                        if (typeof setProviderLedgerRegistry === "function") {
                          setProviderLedgerRegistry((prev) => ({
                            ...prev,
                            [targetId]: fetchedList,
                          }));
                        } else if (typeof providerLedgerRegistry !== "undefined") {
                          providerLedgerRegistry[targetId] = fetchedList;
                        }
                        const syncLog = {
                          action: "booking_ledger_manual_sync",
                          whoAccessed: currentUser?.email || currentUser?.uid,
                          accessedAt: new Date().toLocaleString(),
                          timestamp: Date.now(),
                          providerId: targetId,
                          providerName: inspectedLedgerProvider.name || inspectedLedgerProvider.displayName || targetId,
                          reason: shieldAccessReason || "Manual Bookings Sync",
                          justificationNote: shieldJustificationNote || "",
                        };
                        try {
                          const existingLogsStr = localStorage.getItem("persistent_admin_audit_logs");
                          const existingLogs = existingLogsStr ? JSON.parse(existingLogsStr) : [];
                          localStorage.setItem("persistent_admin_audit_logs", JSON.stringify([syncLog, ...existingLogs]));
                        } catch (e) {}
                        if (typeof logAuditEvent === "function") {
                          logAuditEvent(syncLog);
                        }
                      } catch (err) {
                        console.error("Error refreshing provider subcollection bookings:", err);
                      }
                    }
                  }}
                  style={{
                    backgroundColor: "#3730A3",
                    color: "#fff",
                    border: "none",
                    padding: "8px 14px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "12px",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                  title="Scan & Sync bookings subcollection"
                >
                  🔄 Fetch Bookings
                </button>
                <button
                  onClick={() => setInspectedLedgerProvider(null)}
                  style={{
                    backgroundColor: "#4338CA",
                    color: "#fff",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  ✖ Close
                </button>
              </div>
            </div>
            {/* Modal Body */}
            <div style={{ padding: "20px", overflowY: "auto", flex: 1, backgroundColor: "#F9FAFB" }}>
              {(() => {
                const ledgerProviderId = inspectedLedgerProvider.id || inspectedLedgerProvider.uid;
                const bookingsArr = providerLedgerRegistry?.[ledgerProviderId] || [];
                const isLedgerLoading = Boolean(subcollectionFetchStatus?.[`${ledgerProviderId}_ledger`]);
                // Numeric coercion helper for earnings dashboard math
                const toNum = (v) => {
                  const n = parseFloat(v);
                  return isNaN(n) ? 0 : n;
                };
                // ── EARNINGS DASHBOARD TOTALS (computed from the full, unfiltered booking set) ──
                const totalBookingsCount = bookingsArr.length;
                const totalEarningsSum = bookingsArr.reduce((sum, b) => {
                  const amt =
                    b.totalCharge !== undefined && b.totalCharge !== null && b.totalCharge !== ""
                      ? b.totalCharge
                      : b.totalAmount !== undefined && b.totalAmount !== null
                      ? b.totalAmount
                      : b.customer_total_amount || 0;
                  return sum + toNum(amt);
                }, 0);
                const totalUgRevenueSum = bookingsArr.reduce(
                  (sum, b) => sum + toNum(b.ugRevenue !== undefined && b.ugRevenue !== null ? b.ugRevenue : b.ug_revenue || 0),
                  0
                );
                const totalProviderPayoutSum = bookingsArr.reduce((sum, b) => {
                  const payout =
                    b.providerPayout !== undefined && b.providerPayout !== null && b.providerPayout !== ""
                      ? b.providerPayout
                      : b.provider_payout !== undefined && b.provider_payout !== null && b.provider_payout !== ""
                      ? b.provider_payout
                      : 0;
                  return sum + toNum(payout);
                }, 0);
                // ── LIVE SEARCH / FILTER — pure DOM toggling, no extra state needed in this fragment ──
                const filterBookingsList = (e) => {
                  const val = (e.target.value || "").trim().toLowerCase();
                  const listEl = document.getElementById(`booking-list-${ledgerProviderId}`);
                  const countEl = document.getElementById(`booking-visible-count-${ledgerProviderId}`);
                  if (!listEl) return;
                  const rows = listEl.querySelectorAll("[data-booking-search]");
                  let visibleCount = 0;
                  rows.forEach((row) => {
                    const haystack = row.getAttribute("data-booking-search") || "";
                    const isMatch = !val || haystack.includes(val);
                    row.style.display = isMatch ? "" : "none";
                    if (isMatch) visibleCount += 1;
                  });
                  if (countEl) countEl.textContent = `${visibleCount} of ${rows.length} bookings shown`;
                };
                // Expand/collapse a single booking's earnings/detail panel — lets an admin inspect
                // one booking's numbers without scrolling through every other booking.
                const toggleBookingDetail = (detailId, chevronId) => {
                  const detailEl = document.getElementById(detailId);
                  const chevronEl = document.getElementById(chevronId);
                  if (detailEl) {
                    detailEl.style.display = detailEl.style.display === "none" ? "block" : "none";
                  }
                  if (chevronEl) {
                    chevronEl.textContent = chevronEl.textContent === "▼" ? "▲" : "▼";
                  }
                };
                if (isLedgerLoading) {
                  return (
                    <div style={{ textAlign: "center", padding: "40px 0" }}>
                      <p style={{ fontSize: "14px", color: "#4338CA", fontWeight: 600 }}>Scanning Bookings subcollections in Firestore…</p>
                    </div>
                  );
                }
                if (totalBookingsCount === 0) {
                  return (
                    <div style={{ textAlign: "center", padding: "40px 0" }}>
                      <p style={{ fontSize: "14px", color: "#6B7280" }}>
                        No bookings found in subcollection for this provider.
                      </p>
                    </div>
                  );
                }
                return (
                  <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
                    {/* ═══════════════ EARNINGS DASHBOARD ═══════════════ */}
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                        gap: "12px",
                      }}
                    >
                      <div style={{ backgroundColor: "#EEF2FF", border: "1px solid #C7D2FE", borderRadius: "12px", padding: "14px 16px" }}>
                        <div style={{ fontSize: "11px", fontWeight: 700, color: "#4338CA", textTransform: "uppercase" }}>📅 Total Bookings</div>
                        <div style={{ fontSize: "22px", fontWeight: 800, color: "#3730A3", marginTop: "4px" }}>{totalBookingsCount}</div>
                      </div>
                      <div style={{ backgroundColor: "#ECFDF5", border: "1px solid #A7F3D0", borderRadius: "12px", padding: "14px 16px" }}>
                        <div style={{ fontSize: "11px", fontWeight: 700, color: "#065F46", textTransform: "uppercase" }}>💷 Total Earnings</div>
                        <div style={{ fontSize: "22px", fontWeight: 800, color: "#047857", marginTop: "4px" }}>£{totalEarningsSum.toFixed(2)}</div>
                      </div>
                      <div style={{ backgroundColor: "#EFF6FF", border: "1px solid #BFDBFE", borderRadius: "12px", padding: "14px 16px" }}>
                        <div style={{ fontSize: "11px", fontWeight: 700, color: "#1E40AF", textTransform: "uppercase" }}>📈 Total UG Revenue</div>
                        <div style={{ fontSize: "22px", fontWeight: 800, color: "#1D4ED8", marginTop: "4px" }}>£{totalUgRevenueSum.toFixed(2)}</div>
                      </div>
                      <div style={{ backgroundColor: "#FFFBEB", border: "1px solid #FDE68A", borderRadius: "12px", padding: "14px 16px" }}>
                        <div style={{ fontSize: "11px", fontWeight: 700, color: "#92400E", textTransform: "uppercase" }}>💰 Total Provider Payout</div>
                        <div style={{ fontSize: "22px", fontWeight: 800, color: "#B45309", marginTop: "4px" }}>£{totalProviderPayoutSum.toFixed(2)}</div>
                      </div>
                    </div>
                    {/* ═══════════════ SEARCH / FILTER BAR ═══════════════ */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        backgroundColor: "#fff",
                        border: "1px solid #E5E7EB",
                        borderRadius: "10px",
                        padding: "10px 14px",
                        flexWrap: "wrap",
                      }}
                    >
                      <span style={{ fontSize: "14px" }}>🔎</span>
                      <input
                        type="text"
                        onInput={filterBookingsList}
                        placeholder="Search bookings by ID, customer, service, status, date…"
                        style={{
                          flex: 1,
                          minWidth: "220px",
                          border: "1px solid #E5E7EB",
                          backgroundColor: "#F9FAFB",
                          borderRadius: "8px",
                          padding: "8px 10px",
                          fontSize: "13px",
                          outline: "none",
                          color: "#111827",
                        }}
                        autoComplete="off"
                        spellCheck={false}
                      />
                      <span id={`booking-visible-count-${ledgerProviderId}`} style={{ fontSize: "11px", color: "#6B7280", fontWeight: 600, whiteSpace: "nowrap" }}>
                        {totalBookingsCount} of {totalBookingsCount} bookings shown
                      </span>
                    </div>
                    {/* ═══════════════ BOOKINGS LIST — collapsed rows; click a row to expand just that booking ═══════════════ */}
                    <div id={`booking-list-${ledgerProviderId}`} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                  {bookingsArr.map((bk, bIdx) => {
                    const currentBookingId = bk.bookingId || bk.id || `b_${bIdx}`;
                    const currentTotalCharge =
                      bk.totalCharge !== undefined && bk.totalCharge !== null && bk.totalCharge !== ""
                        ? bk.totalCharge
                        : bk.totalAmount !== undefined && bk.totalAmount !== null
                        ? bk.totalAmount
                        : bk.customer_total_amount || 0;
                    const customerTotalAmount =
                      bk.customer_total_amount !== undefined && bk.customer_total_amount !== null
                        ? bk.customer_total_amount
                        : currentTotalCharge;
                    const ugRevenueAmount =
                      bk.ugRevenue !== undefined && bk.ugRevenue !== null
                        ? bk.ugRevenue
                        : bk.ug_revenue || 0;
                    const stripeProcessingFeeAmount =
                      bk.stripeProcessingFee !== undefined && bk.stripeProcessingFee !== null
                        ? bk.stripeProcessingFee
                        : bk.stripeFee || bk.stripe_fee || 0;
                    const providerPayoutAmount =
                      bk.providerPayout !== undefined && bk.providerPayout !== null && bk.providerPayout !== ""
                        ? bk.providerPayout
                        : bk.provider_payout !== undefined && bk.provider_payout !== null && bk.provider_payout !== ""
                        ? bk.provider_payout
                        : "—";
                    const piiKey = `${inspectedLedgerProvider.id}_${currentBookingId}`;
                    const piiUnlocked = Boolean(unlockedTransactionPII?.[piiKey]);
                    const maskedValue = (val) => (piiUnlocked ? val ?? "—" : "•••• Protected");
                    const detailPanelId = `booking-detail-${ledgerProviderId}-${currentBookingId}-${bIdx}`;
                    const chevronId = `booking-chevron-${ledgerProviderId}-${currentBookingId}-${bIdx}`;
                    const searchBlob = [
                      currentBookingId,
                      bk.customerName,
                      bk.serviceName,
                      bk.status,
                      bk.bookingStatus,
                      bk.bookingDate,
                      bk.providerName || inspectedLedgerProvider.name || inspectedLedgerProvider.displayName,
                    ]
                      .filter(Boolean)
                      .join(" | ")
                      .toLowerCase();
                    return (
                      <div
                        key={`${currentBookingId}_${bIdx}`}
                        data-booking-search={searchBlob}
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #C7D2FE",
                          borderRadius: "12px",
                          padding: "18px",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
                        }}
                      >
                        {/* ═══ COMPACT SUMMARY ROW — always visible; view a booking's earnings without scrolling ═══ */}
                        <div
                          onClick={() => toggleBookingDetail(detailPanelId, chevronId)}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "10px",
                            flexWrap: "wrap",
                            cursor: "pointer",
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", gap: "14px", flexWrap: "wrap" }}>
                            <div>
                              <div style={{ fontSize: "10px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>Booking</div>
                              <div style={{ fontSize: "13px", fontWeight: 700, color: "#4338CA" }}>{currentBookingId}</div>
                            </div>
                            <div>
                              <div style={{ fontSize: "10px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>Customer</div>
                              <div style={{ fontSize: "13px", fontWeight: 600, color: "#111827" }}>{bk.customerName || "—"}</div>
                            </div>
                            <div>
                              <div style={{ fontSize: "10px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>Date</div>
                              <div style={{ fontSize: "13px", color: "#374151" }}>{bk.bookingDate || "—"}</div>
                            </div>
                            <div>
                              <div style={{ fontSize: "10px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>Status</div>
                              <div style={{ fontSize: "13px", color: "#374151" }}>{bk.bookingStatus || bk.status || "—"}</div>
                            </div>
                          </div>
                          <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
                            <div style={{ textAlign: "right" }}>
                              <div style={{ fontSize: "10px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>Booking Amount</div>
                              <div style={{ fontSize: "14px", fontWeight: 800, color: "#047857" }}>£{currentTotalCharge}</div>
                            </div>
                            <div style={{ textAlign: "right" }}>
                              <div style={{ fontSize: "10px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>UG Revenue</div>
                              <div style={{ fontSize: "14px", fontWeight: 800, color: "#1D4ED8" }}>£{ugRevenueAmount}</div>
                            </div>
                            <div style={{ textAlign: "right" }}>
                              <div style={{ fontSize: "10px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>Provider Payout</div>
                              <div style={{ fontSize: "14px", fontWeight: 800, color: "#B45309" }}>{providerPayoutAmount !== "—" ? `£${providerPayoutAmount}` : "—"}</div>
                            </div>
                            <span id={chevronId} style={{ fontSize: "14px", color: "#6B7280" }}>▼</span>
                          </div>
                        </div>
                        {/* ═══ EXPANDABLE DETAIL PANEL — full booking detail, collapsed by default ═══ */}
                        <div id={detailPanelId} style={{ display: "none", marginTop: "14px", borderTop: "1px dashed #E5E7EB", paddingTop: "14px" }}>
                        {/* 1. TOP PRIORITIZED FIELDS */}
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
                            gap: "12px",
                            backgroundColor: "#F5F3FF",
                            padding: "14px",
                            borderRadius: "10px",
                            border: "1px solid #DDD6FE",
                            marginBottom: "16px",
                          }}
                        >
                          <div>
                            <span style={{ fontSize: "11px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>
                              Booking ID
                            </span>
                            <div style={{ fontSize: "14px", fontWeight: "700", color: "#4338CA", wordBreak: "break-all" }}>
                              {currentBookingId}
                            </div>
                          </div>
                          <div>
                            <span style={{ fontSize: "11px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>
                              Booking Amount
                            </span>
                            <div style={{ fontSize: "16px", fontWeight: "800", color: "#047857" }}>
                              £{currentTotalCharge}
                            </div>
                          </div>
                          <div>
                            <span style={{ fontSize: "11px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>
                              Customer Details
                            </span>
                            <div style={{ fontSize: "13px", fontWeight: "700", color: "#111827" }}>
                              {bk.customerName || "—"}
                            </div>
                            <div style={{ fontSize: "11px", color: "#6B7280" }}>{bk.customerId || "—"}</div>
                          </div>
                          <div>
                            <span style={{ fontSize: "11px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>
                              Provider Details
                            </span>
                            <div style={{ fontSize: "13px", fontWeight: "700", color: "#111827" }}>
                              {bk.providerName || inspectedLedgerProvider.name || inspectedLedgerProvider.displayName || "—"}
                            </div>
                            <div style={{ fontSize: "11px", color: "#6B7280" }}>{bk.providerId || inspectedLedgerProvider.id}</div>
                          </div>
                          <div>
                            <span style={{ fontSize: "11px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>
                              Customer Total Amount
                            </span>
                            <div style={{ fontSize: "15px", fontWeight: "800", color: "#111827" }}>
                              £{customerTotalAmount}
                            </div>
                          </div>
                          <div>
                            <span style={{ fontSize: "11px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>
                              UG Revenue
                            </span>
                            <div style={{ fontSize: "15px", fontWeight: "800", color: "#1D4ED8" }}>
                              £{ugRevenueAmount}
                            </div>
                          </div>
                          <div>
                            <span style={{ fontSize: "11px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>
                              Stripe Processing Fee
                            </span>
                            <div style={{ fontSize: "15px", fontWeight: "800", color: "#7C3AED" }}>
                              £{stripeProcessingFeeAmount}
                            </div>
                          </div>
                          <div>
                            <span style={{ fontSize: "11px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>
                              Provider Payout
                            </span>
                            <div style={{ fontSize: "16px", fontWeight: "800", color: "#B45309" }}>
                              {providerPayoutAmount !== "—" ? `£${providerPayoutAmount}` : "—"}
                            </div>
                          </div>
                          {bk.platformFee !== undefined && (
                            <div>
                              <span style={{ fontSize: "11px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>
                                Platform Fee
                              </span>
                              <div style={{ fontSize: "14px", fontWeight: "600", color: "#374151" }}>
                                £{bk.platformFee}
                              </div>
                            </div>
                          )}
                          {bk.discount !== undefined && (
                            <div>
                              <span style={{ fontSize: "11px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>
                                Discount
                              </span>
                              <div style={{ fontSize: "14px", fontWeight: "600", color: "#DC2626" }}>
                                -£{bk.discount}
                              </div>
                            </div>
                          )}
                          {bk.tax !== undefined && (
                            <div>
                              <span style={{ fontSize: "11px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>
                                Tax
                              </span>
                              <div style={{ fontSize: "14px", fontWeight: "600", color: "#374151" }}>
                                £{bk.tax}
                              </div>
                            </div>
                          )}
                        </div>
                        {/* 2. CUSTOMER & PROVIDER DETAIL CARDS */}
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "12px", marginBottom: "14px" }}>
                          <div style={{ backgroundColor: "#F9FAFB", padding: "12px", borderRadius: "8px", border: "1px solid #E5E7EB" }}>
                            <span style={{ fontSize: "11px", fontWeight: 700, color: "#374151", textTransform: "uppercase" }}>
                              👤 Customer Details
                            </span>
                            <div style={{ fontSize: "12px", marginTop: "4px" }}><strong>Customer ID:</strong> {maskedValue(bk.customerId)}</div>
                            <div style={{ fontSize: "12px" }}><strong>Customer Name:</strong> {bk.customerName || "—"}</div>
                            <div style={{ fontSize: "12px", wordBreak: "break-all" }}><strong>Customer Token:</strong> {maskedValue(bk.customerToken)}</div>
                            <div style={{ fontSize: "12px" }}><strong>Total Payment:</strong> £{customerTotalAmount}</div>
                            {bk.customerEmail && <div style={{ fontSize: "12px" }}><strong>Email:</strong> {maskedValue(bk.customerEmail)}</div>}
                            {bk.customerPhone && <div style={{ fontSize: "12px" }}><strong>Phone:</strong> {maskedValue(bk.customerPhone)}</div>}
                          </div>
                          <div style={{ backgroundColor: "#F9FAFB", padding: "12px", borderRadius: "8px", border: "1px solid #E5E7EB" }}>
                            <span style={{ fontSize: "11px", fontWeight: 700, color: "#374151", textTransform: "uppercase" }}>
                              🏢 Provider Details
                            </span>
                            <div style={{ fontSize: "12px", marginTop: "4px" }}><strong>Provider ID:</strong> {bk.providerId || inspectedLedgerProvider.id}</div>
                            <div style={{ fontSize: "12px" }}><strong>Provider Name:</strong> {bk.providerName || inspectedLedgerProvider.name || inspectedLedgerProvider.displayName || "—"}</div>
                            <div style={{ fontSize: "12px" }}><strong>Provider Payout:</strong> {providerPayoutAmount !== "—" ? `£${providerPayoutAmount}` : "—"}</div>
                            {bk.providerEmail && <div style={{ fontSize: "12px" }}><strong>Email:</strong> {maskedValue(bk.providerEmail)}</div>}
                            {bk.providerPhone && <div style={{ fontSize: "12px" }}><strong>Phone:</strong> {maskedValue(bk.providerPhone)}</div>}
                            {bk._discoveredSubcollection && (
                              <div style={{ fontSize: "11px", marginTop: "4px", color: "#4F46E5", fontWeight: 600 }}>
                                📁 Subcollection Source: {bk._discoveredSubcollection}
                              </div>
                            )}
                          </div>
                        </div>
                        {/* 3. TRANSACTION PII PROTECTION GATE */}
                        <div
                          style={{
                            marginBottom: "14px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            backgroundColor: piiUnlocked ? "#ECFDF5" : "#FEF2F2",
                            border: `1px solid ${piiUnlocked ? "#A7F3D0" : "#FECACA"}`,
                            borderRadius: "8px",
                            padding: "10px 14px",
                          }}
                        >
                          <span style={{ fontSize: "12px", fontWeight: 600, color: piiUnlocked ? "#065F46" : "#991B1B" }}>
                            {piiUnlocked
                              ? "🔓 Transaction PII unlocked for this session"
                              : "🔒 This booking contains sensitive PII (address, IDs, tokens). Unlock requires justification + PIN."}
                          </span>
                          {!piiUnlocked && (
                            <button
                              onClick={() =>
                                initiateShieldProtocol(
                                  { ...inspectedLedgerProvider, _piiTargetBookingKey: piiKey },
                                  "transaction_pii"
                                )
                              }
                              style={{
                                backgroundColor: "#DC2626",
                                color: "#fff",
                                border: "none",
                                padding: "6px 12px",
                                borderRadius: "6px",
                                cursor: "pointer",
                                fontSize: "11px",
                                fontWeight: 700,
                              }}
                            >
                              🔑 Unlock PII
                            </button>
                          )}
                        </div>
                        {/* 4. ALL SUBCOLLECTION & BOOKING FIELDS */}
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
                            gap: "8px 14px",
                            fontSize: "12px",
                            color: "#374151",
                            backgroundColor: "#FAFAFA",
                            padding: "14px",
                            borderRadius: "8px",
                            border: "1px solid #E5E7EB",
                          }}
                        >
                          <div><strong>Address:</strong> {maskedValue(bk.address)}</div>
                          <div><strong>Booking Date:</strong> {bk.bookingDate || "—"}</div>
                          <div><strong>Booking Date Timestamp:</strong> {typeof stringifyFirestoreTemporal === "function" ? stringifyFirestoreTemporal(bk.bookingDateTimestamp) : String(bk.bookingDateTimestamp || "—")}</div>
                          <div><strong>Booking ID:</strong> {bk.bookingId || bk.id || "—"}</div>
                          <div><strong>Booking Status:</strong> {bk.bookingStatus || "—"}</div>
                          <div><strong>Booking Time:</strong> {bk.bookingTime || "—"}</div>
                          <div><strong>Booking TimeStamp:</strong> {typeof stringifyFirestoreTemporal === "function" ? stringifyFirestoreTemporal(bk.bookingTimeStamp) : String(bk.bookingTimeStamp || "—")}</div>
                          <div><strong>Created At:</strong> {typeof stringifyFirestoreTemporal === "function" ? stringifyFirestoreTemporal(bk.createdAt) : String(bk.createdAt || "—")}</div>
                          <div><strong>Customer ID:</strong> {maskedValue(bk.customerId)}</div>
                          <div><strong>Customer Name:</strong> {bk.customerName || "—"}</div>
                          <div><strong>Customer Token:</strong> {piiUnlocked ? (bk.customerToken ? `${bk.customerToken.slice(0, 16)}…` : "—") : "•••• Protected"}</div>
                          <div><strong>Duration:</strong> {bk.duration || "—"}</div>
                          <div><strong>Has Pets:</strong> {bk.hasPets ? `Yes ${bk.petType ? `(${bk.petType})` : ""}` : "No"}</div>
                          <div><strong>Document ID:</strong> {bk.id || "—"}</div>
                          <div><strong>Idempotency Key:</strong> {maskedValue(bk.idempotencyKey)}</div>
                          <div><strong>Latitude:</strong> {piiUnlocked ? (bk.latitude !== null && bk.latitude !== undefined ? bk.latitude : "—") : "•••• Protected"}</div>
                          <div><strong>Longitude:</strong> {piiUnlocked ? (bk.longitude !== null && bk.longitude !== undefined ? bk.longitude : "—") : "•••• Protected"}</div>
                          <div><strong>Payment Method:</strong> {bk.paymentMethod || "—"}</div>
                          <div><strong>Payment Method Display:</strong> {bk.paymentMethodDisplay || "—"}</div>
                          <div><strong>Payment Status:</strong> {bk.paymentStatus || "—"}</div>
                          <div><strong>Provider ID:</strong> {bk.providerId || "—"}</div>
                          <div><strong>Provider Payout:</strong> {providerPayoutAmount !== "—" ? `£${providerPayoutAmount}` : "—"}</div>
                          <div><strong>Service ID:</strong> {bk.serviceId || "—"}</div>
                          <div><strong>Service Name:</strong> {bk.serviceName || "—"}</div>
                          <div><strong>Status:</strong> {bk.status || "—"}</div>
                          <div><strong>Total Charge:</strong> £{currentTotalCharge}</div>
                          {bk.arrivalOtp && <div><strong>Arrival OTP:</strong> {maskedValue(bk.arrivalOtp)}</div>}
                          {bk.arrivalOtpExpiry && <div><strong>Arrival OTP Expiry:</strong> {typeof stringifyFirestoreTemporal === "function" ? stringifyFirestoreTemporal(bk.arrivalOtpExpiry) : String(bk.arrivalOtpExpiry)}</div>}
                          {bk.arrivalVerified !== undefined && <div><strong>Arrival Verified:</strong> {bk.arrivalVerified ? "Yes" : "No"}</div>}
                          {bk.invoiceReady !== undefined && <div><strong>Invoice Ready:</strong> {bk.invoiceReady ? "Yes" : "No"}</div>}
                          {bk.isInvoiceGenerated !== undefined && <div><strong>Invoice Generated:</strong> {bk.isInvoiceGenerated ? "Yes" : "No"}</div>}
                          {bk.invoiceGeneratedAt && <div><strong>Invoice Generated At:</strong> {typeof stringifyFirestoreTemporal === "function" ? stringifyFirestoreTemporal(bk.invoiceGeneratedAt) : String(bk.invoiceGeneratedAt)}</div>}
                          {bk.isPaid !== undefined && <div><strong>Is Paid:</strong> {bk.isPaid ? "Yes" : "No"}</div>}
                          {bk.serviceStartedAt && <div><strong>Service Started At:</strong> {typeof stringifyFirestoreTemporal === "function" ? stringifyFirestoreTemporal(bk.serviceStartedAt) : String(bk.serviceStartedAt)}</div>}
                          {bk.updatedAt && <div><strong>Updated At:</strong> {typeof stringifyFirestoreTemporal === "function" ? stringifyFirestoreTemporal(bk.updatedAt) : String(bk.updatedAt)}</div>}
                          <div style={{ gridColumn: "1 / -1" }}><strong>Job Description:</strong> {bk.jobDescription || "—"}</div>
                        </div>
                        </div>
                      </div>
                    );
                  })}
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>
        </div>
      )}
      {/* =================================================================== */}
      {/* ============ MODAL 3: STRIPE KYC MODAL ========================== */}
      {/* =================================================================== */}
      {inspectedKycProvider && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(17, 24, 39, 0.65)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
            padding: "20px",
          }}
          onClick={() => setInspectedKycProvider(null)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#fff",
              borderRadius: "16px",
              width: "980px",
              maxWidth: "96vw",
              maxHeight: "88vh",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                padding: "16px 24px",
                borderBottom: "1px solid #E5E7EB",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#F5F3FF",
              }}
            >
              <div>
                <h3 style={{ margin: 0, fontSize: "17px", fontWeight: "700", color: "#5B21B6", display: "flex", alignItems: "center", gap: "8px" }}>
                  💰 Stripe KYC — Provider Verification
                </h3>
                <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#4B5563" }}>
                  Provider: <strong>{inspectedKycProvider.name || inspectedKycProvider.displayName || inspectedKycProvider.id}</strong> ({inspectedKycProvider.id})
                </p>
                <span
                  style={{
                    display: "inline-block",
                    marginTop: "6px",
                    fontSize: "11px",
                    fontWeight: "700",
                    padding: "3px 8px",
                    borderRadius: "5px",
                    backgroundColor: "#EDE9FE",
                    color: "#6D28D9",
                  }}
                >
                  📁 Source: stripe market place ➔ providers ➔ list ➔ {inspectedKycProvider.id || inspectedKycProvider.uid}
                </span>
              </div>
              <button
                onClick={() => setInspectedKycProvider(null)}
                style={{
                  backgroundColor: "#5B21B6",
                  color: "#fff",
                  border: "none",
                  padding: "8px 16px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "12px",
                  fontWeight: "600",
                }}
              >
                ✖ Close
              </button>
            </div>
            <div style={{ padding: "20px", overflowY: "auto", flex: 1, backgroundColor: "#F9FAFB" }}>
              {(() => {
                const kId = inspectedKycProvider.id || inspectedKycProvider.uid;
                const kycLoading = Boolean(kycFetchStatus?.[kId]);
                const kycData = kycRegistry?.[kId] || null;
                const isRecordMismatched =
                  kycData && kycData._ownerProviderId && kycData._ownerProviderId !== kId;
                if (kycLoading) {
                  return (
                    <div style={{ textAlign: "center", padding: "40px 0" }}>
                      <p style={{ fontSize: "14px", color: "#5B21B6", fontWeight: 600 }}>
                        Retrieving Stripe KYC record…
                      </p>
                    </div>
                  );
                }
                if (!kycData || isRecordMismatched) {
                  return (
                    <div style={{ textAlign: "center", padding: "40px 0" }}>
                      <p style={{ fontSize: "14px", color: "#6B7280" }}>
                        No Stripe KYC record found for {kId}.
                      </p>
                    </div>
                  );
                }
                const chargesEnabled = kycData.chargesEnabled === true;
                const payoutsEnabled = kycData.payoutsEnabled === true;
                const created_at = kycData.created_at || null;
                const email = kycData.email || "";
                const kyc_status = kycData.kyc_status || "";
                const name = kycData.name || "";
                const onboardingCompletedAt = kycData.onboardingCompletedAt || null;
                const providerId = kycData.providerId || kId || "";
                const stripeStatus = kycData.stripeStatus || "";
                const stripe_account_id = kycData.stripe_account_id || "";
                const stripe_onboarding_status = kycData.stripe_onboarding_status || "";
                const updated_at = kycData.updated_at || null;
                const verification_source = kycData.verification_source || "";
                const isVerified =
                  String(kyc_status).toLowerCase() === "verified" ||
                  String(kyc_status).toLowerCase() === "approved" ||
                  String(stripeStatus).toLowerCase() === "active" ||
                  String(stripeStatus).toLowerCase() === "verified";
                const isPending =
                  String(kyc_status).toLowerCase() === "pending" ||
                  String(kyc_status).toLowerCase() === "in_review" ||
                  String(stripe_onboarding_status).toLowerCase() === "pending";
                const formatTemporal = (val) => {
                  if (!val) return "—";
                  if (typeof stringifyFirestoreTemporal === "function") return stringifyFirestoreTemporal(val);
                  if (val?.toDate && typeof val.toDate === "function") return val.toDate().toLocaleString();
                  if (val?.seconds) return new Date(val.seconds * 1000).toLocaleString();
                  return String(val);
                };
                return (
                  <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        backgroundColor: isVerified ? "#ECFDF5" : isPending ? "#FFFBEB" : "#FEF2F2",
                        border: `1px solid ${isVerified ? "#A7F3D0" : isPending ? "#FDE68A" : "#FECACA"}`,
                        borderRadius: "10px",
                        padding: "14px 18px",
                      }}
                    >
                      <div>
                        <span style={{ fontSize: "11px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>
                          KYC Status / Stripe Status
                        </span>
                        <div
                          style={{
                            fontSize: "16px",
                            fontWeight: "800",
                            color: isVerified ? "#065F46" : isPending ? "#92400E" : "#991B1B",
                            textTransform: "capitalize",
                          }}
                        >
                          {kyc_status || stripeStatus || "Unknown"}
                        </div>
                        {stripe_onboarding_status && (
                          <div style={{ fontSize: "12px", color: "#4B5563", marginTop: "2px" }}>
                            Onboarding: <strong>{stripe_onboarding_status}</strong>
                          </div>
                        )}
                      </div>
                      <span
                        style={{
                          padding: "6px 12px",
                          borderRadius: "8px",
                          fontSize: "12px",
                          fontWeight: "700",
                          backgroundColor: isVerified ? "#10B981" : isPending ? "#F59E0B" : "#EF4444",
                          color: "#fff",
                        }}
                      >
                        {isVerified ? "✅ Verified" : isPending ? "⏳ Pending Review" : "⚠ Attention Required"}
                      </span>
                    </div>
                    <div
                      style={{
                        backgroundColor: "#fff",
                        border: "1px solid #E5E7EB",
                        borderRadius: "12px",
                        padding: "18px",
                      }}
                    >
                      <h4 style={{ margin: "0 0 14px 0", fontSize: "13px", fontWeight: "700", color: "#374151", textTransform: "uppercase" }}>
                        Stripe Marketplace KYC Information
                      </h4>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
                          gap: "12px 18px",
                          fontSize: "13px",
                          color: "#374151",
                        }}
                      >
                        <div><strong>Provider ID:</strong> <div>{providerId || "—"}</div></div>
                        <div><strong>Name:</strong> <div>{name || "—"}</div></div>
                        <div><strong>Email:</strong> <div>{email || "—"}</div></div>
                        <div><strong>Stripe Account ID:</strong> <div style={{ color: "#4F46E5", fontWeight: 700 }}>{stripe_account_id || "—"}</div></div>
                        <div><strong>KYC Status:</strong> <div>{kyc_status || "—"}</div></div>
                        <div><strong>Stripe Status:</strong> <div>{stripeStatus || "—"}</div></div>
                        <div><strong>Stripe Onboarding Status:</strong> <div>{stripe_onboarding_status || "—"}</div></div>
                        <div><strong>Charges Enabled:</strong> <div>{chargesEnabled ? "Yes (Enabled)" : "No (Disabled)"}</div></div>
                        <div><strong>Payouts Enabled:</strong> <div>{payoutsEnabled ? "Yes (Enabled)" : "No (Disabled)"}</div></div>
                        <div><strong>Verification Source:</strong> <div>{verification_source || "—"}</div></div>
                        <div><strong>Onboarding Completed At:</strong> <div>{formatTemporal(onboardingCompletedAt)}</div></div>
                        <div><strong>Created At:</strong> <div>{formatTemporal(created_at)}</div></div>
                        <div><strong>Updated At:</strong> <div>{formatTemporal(updated_at)}</div></div>
                      </div>
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>
        </div>
      )}
      {/* =================================================================== */}
      {/* ============ MODAL 4: PROVIDER NOTES MODAL & NOTES LOGS ========== */}
      {/* =================================================================== */}
      {inspectedNotesProvider && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(17, 24, 39, 0.65)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
            padding: "20px",
          }}
          onClick={() => setInspectedNotesProvider(null)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#fff",
              borderRadius: "16px",
              width: "780px",
              maxWidth: "96vw",
              maxHeight: "88vh",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
              overflow: "hidden",
            }}
          >
            {/* Notes Header */}
            <div
              style={{
                padding: "16px 24px",
                borderBottom: "1px solid #E5E7EB",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#ECFDF5",
              }}
            >
              <div>
                <h3 style={{ margin: 0, fontSize: "17px", fontWeight: "700", color: "#065F46", display: "flex", alignItems: "center", gap: "8px" }}>
                  📝 Provider Notes & Audit Logs
                </h3>
                <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#4B5563" }}>
                  Provider: <strong>{inspectedNotesProvider.name || inspectedNotesProvider.displayName || inspectedNotesProvider.id}</strong> ({inspectedNotesProvider.id})
                </p>
              </div>
              <button
                onClick={() => setInspectedNotesProvider(null)}
                style={{
                  backgroundColor: "#065F46",
                  color: "#fff",
                  border: "none",
                  padding: "8px 16px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "12px",
                  fontWeight: "600",
                }}
              >
                ✖ Close
              </button>
            </div>
            {/* Notes Body */}
            <div style={{ padding: "20px", overflowY: "auto", flex: 1, backgroundColor: "#F9FAFB" }}>
              {/* Add New Note Section */}
              <div style={{ backgroundColor: "#fff", padding: "16px", borderRadius: "10px", border: "1px solid #D1FAE5", marginBottom: "18px" }}>
                <label style={{ display: "block", fontSize: "13px", fontWeight: "700", color: "#065F46", marginBottom: "6px" }}>
                  Add Note for this Provider
                </label>
                <textarea
                  id="new-provider-note-input"
                  rows={3}
                  placeholder="Enter internal notes, compliance updates, or account records…"
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    border: "1px solid #D1D5DB",
                    borderRadius: "8px",
                    padding: "10px",
                    fontSize: "13px",
                    fontFamily: "'Inter', sans-serif",
                    resize: "vertical",
                    outline: "none",
                    marginBottom: "10px",
                  }}
                />
                <button
                  onClick={() => {
                    const inputElem = document.getElementById("new-provider-note-input");
                    const noteText = (inputElem?.value || "").trim();
                    if (!noteText) return;
                    const pId = inspectedNotesProvider.id || inspectedNotesProvider.uid;
                    const noteEntry = {
                      id: `note_${Date.now()}`,
                      note: noteText,
                      author: currentUser?.email || currentUser?.uid || "Admin",
                      createdAt: new Date().toLocaleString(),
                      timestamp: Date.now(),
                    };
                    let updatedNotesMap = {};
                    try {
                      const cachedNotesStr = localStorage.getItem("persistent_provider_notes_registry");
                      const existingNotesMap = cachedNotesStr ? JSON.parse(cachedNotesStr) : (providerNotesRegistry || {});
                      updatedNotesMap = {
                        ...existingNotesMap,
                        [pId]: [noteEntry, ...(existingNotesMap[pId] || [])],
                      };
                      localStorage.setItem("persistent_provider_notes_registry", JSON.stringify(updatedNotesMap));
                    } catch (storageErr) {
                      console.warn("Error saving notes to localStorage:", storageErr);
                    }
                    if (typeof setProviderNotesRegistry === "function") {
                      setProviderNotesRegistry((prev) => ({
                        ...prev,
                        [pId]: [noteEntry, ...(prev?.[pId] || [])],
                      }));
                    }
                    const noteAuditPayload = {
                      action: "provider_note_added",
                      whoAccessed: currentUser?.email || currentUser?.uid || "Admin",
                      accessedAt: new Date().toLocaleString(),
                      timestamp: Date.now(),
                      providerId: pId,
                      providerName: inspectedNotesProvider.name || inspectedNotesProvider.id,
                      reason: "Internal Note Added",
                      justificationNote: noteText,
                      noteText,
                    };
                    try {
                      const existingLogsStr = localStorage.getItem("persistent_admin_audit_logs");
                      const existingLogs = existingLogsStr ? JSON.parse(existingLogsStr) : [];
                      localStorage.setItem("persistent_admin_audit_logs", JSON.stringify([noteAuditPayload, ...existingLogs]));
                    } catch (e) {}
                    if (typeof logAuditEvent === "function") {
                      logAuditEvent(noteAuditPayload);
                    }
                    if (inputElem) inputElem.value = "";
                  }}
                  style={{
                    backgroundColor: "#059669",
                    color: "#fff",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "6px",
                    fontSize: "12px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  💾 Save Note & Log
                </button>
              </div>
              {/* Notes List with Logs */}
              <h4 style={{ margin: "0 0 10px 0", fontSize: "14px", fontWeight: "700", color: "#374151" }}>
                Saved Notes & Logs History
              </h4>
              {(() => {
                const pId = inspectedNotesProvider.id || inspectedNotesProvider.uid;
                let notesList = providerNotesRegistry?.[pId] || [];
                if ((!notesList || notesList.length === 0) && typeof window !== "undefined") {
                  try {
                    const cachedNotes = JSON.parse(localStorage.getItem("persistent_provider_notes_registry") || "{}");
                    notesList = cachedNotes[pId] || [];
                  } catch (e) {}
                }
                if (notesList.length === 0) {
                  return (
                    <div style={{ textAlign: "center", padding: "20px", color: "#6B7280", fontSize: "13px" }}>
                      No notes created yet for this provider.
                    </div>
                  );
                }
                return (
                  <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    {notesList.map((nt) => (
                      <div
                        key={nt.id}
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #E5E7EB",
                          borderRadius: "8px",
                          padding: "12px 14px",
                          fontSize: "13px",
                        }}
                      >
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
                          <span style={{ fontWeight: "700", color: "#111827" }}>👤 {nt.author}</span>
                          <span style={{ fontSize: "11px", color: "#6B7280" }}>📅 {nt.createdAt}</span>
                        </div>
                        <div style={{ color: "#374151", whiteSpace: "pre-wrap" }}>{nt.note}</div>
                      </div>
                    ))}
                  </div>
                );
              })()}
            </div>
          </div>
        </div>
      )}
      {/* =================================================================== */}
      {/* ============ MODAL 5: ALL ACTION & GATED ACCESS LOGS MODAL ======= */}
      {/* =================================================================== */}
      {isAuditLogsModalOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(17, 24, 39, 0.7)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 13000,
            padding: "20px",
          }}
          onClick={() => typeof setIsAuditLogsModalOpen === "function" && setIsAuditLogsModalOpen(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#fff",
              borderRadius: "16px",
              width: "1000px",
              maxWidth: "96vw",
              maxHeight: "88vh",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 25px 50px rgba(0, 0, 0, 0.25)",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                padding: "16px 24px",
                borderBottom: "1px solid #E5E7EB",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#1F2937",
                color: "#fff",
              }}
            >
              <div>
                <h3 style={{ margin: 0, fontSize: "17px", fontWeight: "700", display: "flex", alignItems: "center", gap: "8px" }}>
                  📜 Action & Gated Buttons Access Logs
                </h3>
                <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#9CA3AF" }}>
                  Real-time audit log of who accessed what provider data and when.
                </p>
              </div>
              <button
                onClick={() => typeof setIsAuditLogsModalOpen === "function" && setIsAuditLogsModalOpen(false)}
                style={{
                  backgroundColor: "#374151",
                  color: "#fff",
                  border: "none",
                  padding: "8px 16px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "12px",
                  fontWeight: "600",
                }}
              >
                ✖ Close
              </button>
            </div>
            <div style={{ padding: "20px", overflowY: "auto", flex: 1, backgroundColor: "#F9FAFB" }}>
              {(() => {
                let logs = adminAuditLogs || [];
                if ((!logs || logs.length === 0) && typeof window !== "undefined") {
                  try {
                    const cachedLogs = JSON.parse(localStorage.getItem("persistent_admin_audit_logs") || "[]");
                    if (Array.isArray(cachedLogs)) {
                      logs = cachedLogs;
                    }
                  } catch (e) {}
                }
                if (logs.length === 0) {
                  return (
                    <div style={{ textAlign: "center", padding: "40px 0", color: "#6B7280" }}>
                      No access logs recorded in this session yet.
                    </div>
                  );
                }
                return (
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px", color: "#374151" }}>
                    <thead>
                      <tr style={{ borderBottom: "2px solid #E5E7EB", backgroundColor: "#F3F4F6" }}>
                        <th style={{ padding: "10px", textAlign: "left" }}>When Accessed</th>
                        <th style={{ padding: "10px", textAlign: "left" }}>Who Accessed</th>
                        <th style={{ padding: "10px", textAlign: "left" }}>Action / Scope</th>
                        <th style={{ padding: "10px", textAlign: "left" }}>Provider Target</th>
                        <th style={{ padding: "10px", textAlign: "left" }}>Reason for Access</th>
                        <th style={{ padding: "10px", textAlign: "left" }}>Justification / Notes</th>
                      </tr>
                    </thead>
                    <tbody>
                      {logs.map((log, lIdx) => (
                        <tr key={`log_${lIdx}`} style={{ borderBottom: "1px solid #E5E7EB", backgroundColor: lIdx % 2 === 0 ? "#fff" : "#FAFAFA" }}>
                          <td style={{ padding: "10px", fontWeight: "600" }}>{log.accessedAt}</td>
                          <td style={{ padding: "10px", color: "#1E40AF", fontWeight: "700" }}>{log.whoAccessed}</td>
                          <td style={{ padding: "10px" }}>
                            <span style={{ backgroundColor: "#EDE9FE", color: "#6D28D9", padding: "2px 6px", borderRadius: "4px", fontWeight: "600" }}>
                              {log.actionLabel || log.action}
                            </span>
                          </td>
                          <td style={{ padding: "10px" }}>{log.providerName || log.providerId || "—"}</td>
                          <td style={{ padding: "10px", color: "#065F46", fontWeight: "600" }}>{log.reason || "—"}</td>
                          <td style={{ padding: "10px", color: "#4B5563", whiteSpace: "pre-wrap", maxWidth: "260px" }}>{log.justificationNote || log.noteText || "—"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                );
              })()}
            </div>
          </div>
        </div>
      )}
      {/* =================================================================== */}
      {/* ============ LIST DATA UNLOCK PASSWORD MODAL ====================== */}
      {/* =================================================================== */}
      {isListPasswordModalOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(17, 24, 39, 0.7)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 12000,
          }}
          onClick={() => {
            if (typeof setIsListPasswordModalOpen === "function") setIsListPasswordModalOpen(false);
            if (typeof setListPasswordError === "function") setListPasswordError("");
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#fff",
              borderRadius: "14px",
              padding: "26px",
              width: "360px",
              maxWidth: "92vw",
              boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
              textAlign: "center",
              fontFamily: "'Inter', sans-serif",
            }}
          >
            <div style={{ fontSize: "32px", marginBottom: "8px" }}>🔑</div>
            <h4 style={{ margin: "0 0 6px 0", fontSize: "17px", fontWeight: "700", color: "#111827" }}>
              Unlock Providers List
            </h4>
            <p style={{ margin: "0 0 16px 0", fontSize: "13px", color: "#6B7280" }}>
              Enter the 4-digit PIN to unhide and view the complete database list.
            </p>
            <input
              type="password"
              inputMode="numeric"
              maxLength={4}
              placeholder="••••"
              value={listPasswordInput || ""}
              onChange={(e) => {
                const val = e.target.value.replace(/\D/g, "");
                if (typeof setListPasswordInput === "function") {
                  setListPasswordInput(val);
                }
              }}
              autoFocus
              style={{
                width: "140px",
                textAlign: "center",
                letterSpacing: "8px",
                fontSize: "24px",
                fontWeight: "700",
                border: "2px solid #D1D5DB",
                borderRadius: "8px",
                padding: "8px 10px",
                marginBottom: "10px",
                outline: "none",
              }}
            />
            {listPasswordError && (
              <p style={{ margin: "0 0 10px 0", fontSize: "12px", color: "#EF4444", fontWeight: "600" }}>
                {listPasswordError}
              </p>
            )}
            <div style={{ display: "flex", gap: "10px", justifyContent: "center", marginTop: "10px" }}>
              <button
                onClick={() => {
                  if (typeof setIsListPasswordModalOpen === "function") setIsListPasswordModalOpen(false);
                  if (typeof setListPasswordInput === "function") setListPasswordInput("");
                  if (typeof setListPasswordError === "function") setListPasswordError("");
                }}
                style={{
                  backgroundColor: "#F3F4F6",
                  color: "#374151",
                  padding: "8px 16px",
                  borderRadius: "8px",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: "600",
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  if (String(listPasswordInput).trim() === "8972") {
                    if (typeof setIsListRevealed === "function") {
                      setIsListRevealed(true);
                    }
                    if (typeof setIsListPasswordModalOpen === "function") {
                      setIsListPasswordModalOpen(false);
                    }
                    if (typeof setListPasswordInput === "function") {
                      setListPasswordInput("");
                    }
                    if (typeof setListPasswordError === "function") {
                      setListPasswordError("");
                    }
                    const unlockLog = {
                      action: "full_list_unlocked_with_pin",
                      whoAccessed: currentUser?.email || currentUser?.uid,
                      accessedAt: new Date().toLocaleString(),
                      timestamp: Date.now(),
                      isoTimestamp: new Date().toISOString(),
                    };
                    try {
                      const existingLogsStr = localStorage.getItem("persistent_admin_audit_logs");
                      const existingLogs = existingLogsStr ? JSON.parse(existingLogsStr) : [];
                      localStorage.setItem("persistent_admin_audit_logs", JSON.stringify([unlockLog, ...existingLogs]));
                    } catch (e) {}
                    if (typeof logAuditEvent === "function") {
                      logAuditEvent(unlockLog);
                    }
                  } else {
                    if (typeof setListPasswordError === "function") {
                      setListPasswordError("Invalid PIN. Access denied.");
                    }
                  }
                }}
                style={{
                  backgroundColor: "#10B981",
                  color: "#fff",
                  padding: "8px 18px",
                  borderRadius: "8px",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: "600",
                }}
              >
                Unlock List
              </button>
            </div>
          </div>
        </div>
      )}
      {/* ============================================================= */}
      {/* ============ SECURITY GATE STEP 1: REASON MODAL ============ */}
      {/* ============================================================= */}
      {shieldProtocolPhase === "prompt_reason" && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(17, 24, 39, 0.65)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 11000,
          }}
          onClick={terminateShieldProtocol}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#fff",
              borderRadius: "14px",
              padding: "24px",
              width: "420px",
              maxWidth: "90vw",
              boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
              fontFamily: "'Inter', sans-serif",
            }}
          >
            <h4 style={{ margin: "0 0 6px 0", fontSize: "16px", fontWeight: 700, color: "#111827" }}>
              🔒 Security Gate: Justification Required
            </h4>
            <p style={{ margin: "0 0 14px 0", fontSize: "13px", color: "#6B7280" }}>
              Please provide a business justification before accessing{" "}
              <strong>
                {shieldIntentScope === "profile_view"
                  ? "Provider Profile"
                  : shieldIntentScope === "catalog_approval"
                  ? "Services Approval Catalog"
                  : shieldIntentScope === "transaction_pii"
                  ? "Transaction PII"
                  : shieldIntentScope === "stripe_kyc"
                  ? "Stripe KYC Verification Data"
                  : "Booking Ledger Data"}
              </strong>.
            </p>
            <p style={{ margin: "0 0 6px 0", fontSize: "12px", color: "#9CA3AF" }}>
              Target Provider: <strong>{shieldTargetEntity?.name || shieldTargetEntity?.displayName || shieldTargetEntity?.id}</strong>
            </p>
            <label style={{ display: "block", fontSize: "12px", fontWeight: 600, color: "#374151", marginBottom: "4px" }}>
              Reason for Access <span style={{ color: "#DC2626" }}>*</span>
            </label>
            <select
              value={shieldAccessReason || ""}
              onChange={(e) => setShieldAccessReason(e.target.value)}
              style={{
                width: "100%",
                boxSizing: "border-box",
                border: "1px solid #D1D5DB",
                borderRadius: "8px",
                padding: "8px 10px",
                fontSize: "13px",
                fontFamily: "'Inter', sans-serif",
                marginBottom: "10px",
                backgroundColor: "#fff",
                color: "#111827",
              }}
            >
              <option value="" disabled>
                Select a reason…
              </option>
              <option value="Support Ticket">Support Ticket</option>
              <option value="Existing Booking">Existing Booking</option>
              <option value="Onboarding">Onboarding</option>
              <option value="Verification/Compliance">Verification/Compliance</option>
              <option value="Payment Related">Payment Related</option>
              <option value="Profile Update">Profile Update</option>
              <option value="Other">Other</option>
            </select>
            <label style={{ display: "block", fontSize: "12px", fontWeight: 600, color: "#374151", marginBottom: "4px" }}>
              Additional Justification Notes
            </label>
            <textarea
              value={shieldJustificationNote}
              onChange={(e) => setShieldJustificationNote(e.target.value)}
              placeholder="e.g. Verifying KYC documents and provider subcollection catalog"
              rows={3}
              style={{
                width: "100%",
                boxSizing: "border-box",
                border: "1px solid #D1D5DB",
                borderRadius: "8px",
                padding: "8px 10px",
                fontSize: "13px",
                fontFamily: "'Inter', sans-serif",
                resize: "vertical",
                marginBottom: "8px",
              }}
            />
            {shieldValidationAlert && (
              <p style={{ margin: "0 0 8px 0", fontSize: "12px", color: "#EF4444" }}>{shieldValidationAlert}</p>
            )}
            <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end", marginTop: "6px" }}>
              <button
                onClick={terminateShieldProtocol}
                style={{
                  backgroundColor: "#F3F4F6",
                  color: "#374151",
                  padding: "8px 14px",
                  borderRadius: "8px",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 600,
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  if (!shieldAccessReason) {
                    setShieldValidationAlert("Please select a reason for access before continuing.");
                    return;
                  }
                  advanceShieldToPinValidation();
                }}
                style={{
                  backgroundColor: "#2563EB",
                  color: "#fff",
                  padding: "8px 14px",
                  borderRadius: "8px",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 600,
                }}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}
      {/* =============================================================== */}
      {/* ============ SECURITY GATE STEP 2: PASSWORD MODAL ============ */}
      {/* =============================================================== */}
      {shieldProtocolPhase === "prompt_passcode" && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(17, 24, 39, 0.65)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 11000,
          }}
          onClick={terminateShieldProtocol}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#fff",
              borderRadius: "14px",
              padding: "24px",
              width: "350px",
              maxWidth: "90vw",
              boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
              fontFamily: "'Inter', sans-serif",
              textAlign: "center",
            }}
          >
            <h4 style={{ margin: "0 0 6px 0", fontSize: "16px", fontWeight: 700, color: "#111827" }}>
              🔑 Enter 4-Digit Security PIN
            </h4>
            <p style={{ margin: "0 0 14px 0", fontSize: "13px", color: "#6B7280" }}>
              Enter security code to unlock{" "}
              <strong>
                {shieldIntentScope === "profile_view"
                  ? "profile"
                  : shieldIntentScope === "catalog_approval"
                  ? "services"
                  : shieldIntentScope === "transaction_pii"
                  ? "transaction PII"
                  : shieldIntentScope === "stripe_kyc"
                  ? "Stripe KYC data"
                  : "bookings"}
              </strong>.
            </p>
            <input
              type="password"
              inputMode="numeric"
              maxLength={4}
              value={shieldPasscodeSecret}
              onChange={(e) => setShieldPasscodeSecret(e.target.value.replace(/\D/g, ""))}
              placeholder="••••"
              autoFocus
              style={{
                width: "130px",
                textAlign: "center",
                letterSpacing: "8px",
                fontSize: "22px",
                border: "1px solid #D1D5DB",
                borderRadius: "8px",
                padding: "8px 10px",
                marginBottom: "8px",
              }}
            />
            {shieldValidationAlert && (
              <p style={{ margin: "0 0 8px 0", fontSize: "12px", color: "#EF4444" }}>{shieldValidationAlert}</p>
            )}
            <div style={{ display: "flex", gap: "8px", justifyContent: "center", marginTop: "10px" }}>
              <button
                onClick={terminateShieldProtocol}
                style={{
                  backgroundColor: "#F3F4F6",
                  color: "#374151",
                  padding: "8px 14px",
                  borderRadius: "8px",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 600,
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  const targetId = shieldTargetEntity?.id || shieldTargetEntity?.uid;
                  authorizeShieldAccessRequest();
                  const auditEntry = {
                    action:
                      shieldIntentScope === "profile_view"
                        ? "provider_profile_view"
                        : shieldIntentScope === "catalog_approval"
                        ? "services_catalog_view"
                        : shieldIntentScope === "transaction_pii"
                        ? "transaction_pii_unlock"
                        : shieldIntentScope === "stripe_kyc"
                        ? "stripe_kyc_view"
                        : "booking_ledger_view",
                    whoAccessed: currentUser?.email || currentUser?.uid || "Admin",
                    accessedAt: new Date().toLocaleString(),
                    timestamp: Date.now(),
                    isoTimestamp: new Date().toISOString(),
                    providerId: targetId,
                    providerName: shieldTargetEntity?.name || shieldTargetEntity?.displayName || targetId,
                    reason: shieldAccessReason || "Not specified",
                    justificationNote: shieldJustificationNote || "",
                  };
                  try {
                    const existingLogsStr = localStorage.getItem("persistent_admin_audit_logs");
                    const existingLogs = existingLogsStr ? JSON.parse(existingLogsStr) : [];
                    localStorage.setItem("persistent_admin_audit_logs", JSON.stringify([auditEntry, ...existingLogs]));
                  } catch (e) {}
                  if (typeof logAuditEvent === "function") {
                    logAuditEvent(auditEntry);
                  } else if (typeof setAdminAuditLogs === "function") {
                    setAdminAuditLogs((prev) => [auditEntry, ...(prev || [])]);
                  } else {
                    console.log("🔒 [AUDIT LOG ACCESS RECORDED]:", auditEntry);
                  }
                  if (
                    shieldIntentScope === "transaction_pii" &&
                    shieldTargetEntity?._piiTargetBookingKey &&
                    typeof setUnlockedTransactionPII === "function"
                  ) {
                    setUnlockedTransactionPII((prev) => ({
                      ...prev,
                      [shieldTargetEntity._piiTargetBookingKey]: true,
                    }));
                  }
                  if (
                    shieldIntentScope === "catalog_approval" &&
                    targetId &&
                    typeof window.__fetchFastCatalogServices === "function"
                  ) {
                    window.__fetchFastCatalogServices(targetId);
                  }
                  if (
                    shieldIntentScope === "stripe_kyc" &&
                    targetId &&
                    typeof setInspectedKycProvider === "function"
                  ) {
                    setInspectedKycProvider(shieldTargetEntity);
                    if (typeof setKycFetchStatus === "function") {
                      setKycFetchStatus((prev) => ({ ...prev, [targetId]: true }));
                    }
                    (async () => {
                      try {
                        if (typeof fetchStripeKycForProvider === "function") {
                          await fetchStripeKycForProvider(shieldTargetEntity);
                        } else if (
                          typeof db !== "undefined" &&
                          typeof getDoc === "function" &&
                          typeof doc === "function"
                        ) {
                          let kycDocData = null;
                          try {
                            const kycDocSnap = await getDoc(doc(db, "stripe market place", "providers", "list", targetId));
                            if (kycDocSnap.exists()) {
                              kycDocData = kycDocSnap.data();
                            }
                          } catch (e) {}
                          if (!kycDocData) {
                            try {
                              const altSnap1 = await getDoc(doc(db, "stripe_market_place", "providers", "list", targetId));
                              if (altSnap1.exists()) kycDocData = altSnap1.data();
                            } catch (e) {}
                          }
                          if (!kycDocData) {
                            try {
                              const altSnap2 = await getDoc(doc(db, "providers", targetId, "stripeKyc", "profile"));
                              if (altSnap2.exists()) kycDocData = altSnap2.data();
                            } catch (e) {}
                          }
                          if (!kycDocData) {
                            try {
                              const altSnap3 = await getDoc(doc(db, "stripeAccounts", targetId));
                              if (altSnap3.exists()) kycDocData = altSnap3.data();
                            } catch (e) {}
                          }
                          const scopedRecord = kycDocData
                            ? { ...kycDocData, _ownerProviderId: targetId }
                            : null;
                          if (typeof setKycRegistry === "function") {
                            setKycRegistry((prev) => ({
                              ...prev,
                              [targetId]: scopedRecord,
                            }));
                          }
                        }
                      } catch (kycErr) {
                        console.error("Error fetching Stripe KYC record:", kycErr);
                      } finally {
                        if (typeof setKycFetchStatus === "function") {
                          setKycFetchStatus((prev) => ({ ...prev, [targetId]: false }));
                        }
                      }
                    })();
                  }
                }}
                style={{
                  backgroundColor: "#10B981",
                  color: "#fff",
                  padding: "8px 14px",
                  borderRadius: "8px",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 600,
                }}
              >
                Unlock
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )}

{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
currentView === "customerList" &&
showCustomerList && (() => {
  // ============================================================================
  // CONSTANTS
  // ============================================================================
  const NINETY_DAYS_MS = 90 * 24 * 60 * 60 * 1000; // 3-month credit expiry window
  const CREDIT_PRESETS = [5, 10, 15, 20];          // predefined credit amounts (£)
  const HIGH_CREDIT_PRESETS = [25, 30, 40, 50, 75, 100]; // credit amounts > £20
  const MAX_NORMAL_STAFF_CREDIT = 20;               // hard ceiling for non-senior staff
  const isSeniorStaff = currentStaffRole === "senior" || currentStaffRole === "manager";
  const SECURITY_PASSCODE = "8972";                // Internal security key (hidden from UI)
  // Designated Approvers List
  const APPROVER_STAFF_LIST = [
    "Vamsi",
    "Tauheed",
    "Ravi",
    "Vaibhav",
    "Abhishek",
    "Karthik",
    "Pooja",
    "Sneha",
    "Rahul",
    "Priya"
  ];
  // Customer records are hidden by default — the list only appears once the
  // staff member starts typing a name or ID into the search bar.
  const hasSearchQuery = Boolean((customerSearchQuery || "").trim());
  // Customer List Unlock State (One-Time Code) — gates the whole list, separate
  // from the per-record PII security gate further below.
  const isCustomerListUnlocked = Boolean(
    (typeof isCustListUnlocked !== "undefined" ? isCustListUnlocked : window.__isCustomerListUnlocked) || false
  );
  const showCustomerListUnlockModal = Boolean(
    (typeof isCustListUnlockModalOpen !== "undefined" ? isCustListUnlockModalOpen : window.__showCustListUnlockModal) || false
  );
  const custListOtpInputValue = window.__custListOtpInput || "";
  const custListOtpErrorValue = window.__custListOtpError || "";
  // Per-customer Logs modal state (opened from the "Logs" button on each customer row)
  const customerLogsTarget = window.__customerLogsTarget || null;
  // Modal State helpers for Credit Approval Workflow
  const showCreditRequestModal = Boolean(
    (typeof isCreditRequestModalOpen !== "undefined" ? isCreditRequestModalOpen : window.__showCreditRequestModal) || false
  );
  const showCreditApprovalModal = Boolean(
    (typeof isCreditApprovalModalOpen !== "undefined" ? isCreditApprovalModalOpen : window.__showCreditApprovalModal) || false
  );
  const creditReqPassword = window.__creditReqPassword || "";
  const creditReqPasswordError = window.__creditReqPasswordError || "";
  const creditApprPassword = window.__creditApprPassword || "";
  const creditApprPasswordError = window.__creditApprPasswordError || "";
  const triggerCustomerListRender = () => {
    if (typeof setCustomerColumnFilters === "function") {
      setCustomerColumnFilters(prev => ({ ...(prev || {}) }));
    } else if (typeof setCustomerSearchQuery === "function") {
      setCustomerSearchQuery(customerSearchQuery || "");
    }
  };
  // Credit Request Modal Helpers
  const openCreditRequestModal = () => {
    window.__showCreditRequestModal = true;
    window.__creditReqPassword = "";
    window.__creditReqPasswordError = "";
    if (typeof setIsCreditRequestModalOpen === "function") setIsCreditRequestModalOpen(true);
    triggerCustomerListRender();
  };
  const closeCreditRequestModal = () => {
    window.__showCreditRequestModal = false;
    window.__creditReqPassword = "";
    window.__creditReqPasswordError = "";
    if (typeof setIsCreditRequestModalOpen === "function") setIsCreditRequestModalOpen(false);
    triggerCustomerListRender();
  };
  // Credit Approval Modal Helpers
  const openCreditApprovalModal = () => {
    window.__showCreditApprovalModal = true;
    window.__creditApprPassword = "";
    window.__creditApprPasswordError = "";
    if (typeof setIsCreditApprovalModalOpen === "function") setIsCreditApprovalModalOpen(true);
    triggerCustomerListRender();
  };
  const closeCreditApprovalModal = () => {
    window.__showCreditApprovalModal = false;
    window.__creditApprPassword = "";
    window.__creditApprPasswordError = "";
    if (typeof setIsCreditApprovalModalOpen === "function") setIsCreditApprovalModalOpen(false);
    triggerCustomerListRender();
  };
  // Customer Logs Modal Helpers (per-customer "Logs" button)
  const openCustomerLogsModal = (customer) => {
    window.__customerLogsTarget = customer || null;
    triggerCustomerListRender();
  };
  const closeCustomerLogsModal = () => {
    window.__customerLogsTarget = null;
    triggerCustomerListRender();
  };
  // ============================================================================
  // CUSTOMER LIST ONE-TIME CODE UNLOCK HELPERS
  // ============================================================================
  // Generates a fresh single-use 6-digit code for unlocking the whole customer
  // list. Each call overwrites any previous code, so a code can never be
  // reused once a new unlock attempt is started.
  const generateCustomerListAccessCode = () => {
    const code = String(Math.floor(100000 + Math.random() * 900000));
    window.__custListOtp = { code, issuedAt: Date.now(), used: false };
    return code;
  };
  const openCustomerListUnlockModal = () => {
    generateCustomerListAccessCode();
    window.__showCustListUnlockModal = true;
    window.__custListOtpInput = "";
    window.__custListOtpError = "";
    if (typeof setIsCustListUnlockModalOpen === "function") setIsCustListUnlockModalOpen(true);
    triggerCustomerListRender();
  };
  const closeCustomerListUnlockModal = () => {
    window.__showCustListUnlockModal = false;
    window.__custListOtpInput = "";
    window.__custListOtpError = "";
    window.__custListOtp = null;
    if (typeof setIsCustListUnlockModalOpen === "function") setIsCustListUnlockModalOpen(false);
    triggerCustomerListRender();
  };
  const resendCustomerListAccessCode = () => {
    generateCustomerListAccessCode();
    window.__custListOtpInput = "";
    window.__custListOtpError = "";
    triggerCustomerListRender();
  };
  const verifyCustomerListAccessCode = () => {
    const entered = (window.__custListOtpInput || "").trim();
    if (!entered || entered.length !== 6) {
      window.__custListOtpError = "Please enter the 6-digit verification code.";
      triggerCustomerListRender();
      return;
    }
    const record = window.__custListOtp;
    const codeOk = Boolean(record && !record.used && record.code === entered);
    if (!codeOk) {
      window.__custListOtpError = "Incorrect or expired code. Please try again.";
      triggerCustomerListRender();
      return;
    }
    // Mark the code used immediately so it cannot be replayed for another unlock.
    window.__custListOtp = { ...record, used: true };
    window.__isCustomerListUnlocked = true;
    if (typeof setIsCustListUnlocked === "function") setIsCustListUnlocked(true);
    logCustomerAuditEntry({
      customerId: "-",
      customerName: "-",
      action: "Unlocked Customer List view (verified via one-time code)",
      reason: "Customer list access"
    });
    closeCustomerListUnlockModal();
  };
  const relockCustomerList = () => {
    window.__isCustomerListUnlocked = false;
    window.__custListOtp = null;
    window.__customerLogsTarget = null;
    if (typeof setIsCustListUnlocked === "function") setIsCustListUnlocked(false);
    logCustomerAuditEntry({
      customerId: "-",
      customerName: "-",
      action: "Locked Customer List view",
      reason: "Customer list access"
    });
    triggerCustomerListRender();
  };
  // Helper to identify and discard provider records
  const isProviderEntity = (entity) => {
    if (!entity) return false;
    const role = String(entity.role || entity.userRole || entity.accountType || entity.type || "").toLowerCase().trim();
    return role === "provider" || role === "technician" || role === "driver" || entity.isProvider === true;
  };
  // Suggests a credit amount as a % of the related booking value, snapped to the nearest available preset.
  const getRecommendedCreditPreset = (bookingAmount) => {
    const amt = Number(bookingAmount || 0);
    if (!amt) return null;
    const raw = amt * 0.1;
    let best = CREDIT_PRESETS[0];
    let bestDiff = Infinity;
    CREDIT_PRESETS.forEach((p) => {
      const diff = Math.abs(p - raw);
      if (diff < bestDiff) { bestDiff = diff; best = p; }
    });
    return best;
  };
  // ============================================================================
  // AUDIT LOGGING
  // ============================================================================
  const logCustomerAuditEntry = ({ customerId, customerName, action, reason, justificationNotes, staffHandleOverride }) => {
    const activeStaff = staffHandleOverride || (currentUser && (currentUser.displayName || currentUser.email || currentUser.uid)) || "Unknown Staff";
    const entry = {
      id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
      staffHandle: activeStaff,
      customerId: customerId || "-",
      customerName: customerName || "-",
      reason: reason || customerShieldAccessReason || "Not specified",
      justificationNotes: justificationNotes || customerShieldJustificationNote || "",
      action: action || "Accessed record",
      timestamp: new Date().toISOString()
    };
    if (typeof setCustomerAuditLog === "function") {
      setCustomerAuditLog(prev => [entry, ...(prev || [])]);
    }
    try {
      const stored = JSON.parse(localStorage.getItem("customerAuditLog") || "[]");
      stored.unshift(entry);
      localStorage.setItem("customerAuditLog", JSON.stringify(stored.slice(0, 500)));
    } catch (e) {}
    return entry;
  };
  // ============================================================================
  // SECURITY GATE (Reason + PIN)
  // ============================================================================
  const SCOPE_LABELS = {
    profile_view: "Customer Profile",
    transactions: "Booking History",
    promotions: "Promotions",
    wallet: "Wallet & Credits",
    transaction_pii: "Booking PII (address / IDs / Bank details)"
  };
  // Generates a fresh single-use one-time verification code. Each call
  // overwrites any previous code, so a code can never be reused once a
  // new access request is started (and is cleared immediately after a
  // successful verification below).
  const generateOneTimeAccessCode = () => {
    const code = String(Math.floor(100000 + Math.random() * 900000));
    window.__customerShieldOtp = { code, issuedAt: Date.now(), used: false };
    return code;
  };
  const requestCustomerAccess = (entity, scope, onGranted) => {
    if (typeof setCustomerShieldTargetEntity === "function") setCustomerShieldTargetEntity(entity);
    if (typeof setCustomerShieldIntentScope === "function") setCustomerShieldIntentScope(scope);
    if (typeof setCustomerShieldPendingAction === "function") setCustomerShieldPendingAction(() => onGranted);
    if (typeof setCustomerShieldAccessReason === "function") setCustomerShieldAccessReason("");
    if (typeof setCustomerShieldJustificationNote === "function") setCustomerShieldJustificationNote("");
    if (typeof setCustomerShieldPasscodeSecret === "function") setCustomerShieldPasscodeSecret("");
    if (typeof setCustomerShieldValidationAlert === "function") setCustomerShieldValidationAlert("");
    window.__customerShieldOtp = null;
    if (typeof setCustomerShieldPhase === "function") setCustomerShieldPhase("prompt_reason");
  };
  const terminateCustomerShield = () => {
    if (typeof setCustomerShieldPhase === "function") setCustomerShieldPhase(null);
    if (typeof setCustomerShieldTargetEntity === "function") setCustomerShieldTargetEntity(null);
    if (typeof setCustomerShieldPendingAction === "function") setCustomerShieldPendingAction(null);
    if (typeof setCustomerShieldValidationAlert === "function") setCustomerShieldValidationAlert("");
    window.__customerShieldOtp = null;
  };
  const advanceCustomerShieldToOtp = () => {
    if (!customerShieldAccessReason) {
      if (typeof setCustomerShieldValidationAlert === "function") {
        setCustomerShieldValidationAlert("Please select a reason for access before continuing.");
      }
      return;
    }
    // A brand-new one-time code is generated the moment we move past the
    // reason step, and any code from a prior request is discarded.
    generateOneTimeAccessCode();
    if (typeof setCustomerShieldPasscodeSecret === "function") setCustomerShieldPasscodeSecret("");
    if (typeof setCustomerShieldValidationAlert === "function") setCustomerShieldValidationAlert("");
    if (typeof setCustomerShieldPhase === "function") setCustomerShieldPhase("prompt_otp");
    triggerCustomerListRender();
  };
  const confirmCustomerShieldOtp = () => {
    if (!customerShieldPasscodeSecret || customerShieldPasscodeSecret.length !== 6) {
      if (typeof setCustomerShieldValidationAlert === "function") {
        setCustomerShieldValidationAlert("Please enter the 6-digit verification code.");
      }
      return;
    }
    const otpRecord = window.__customerShieldOtp;
    const otpOk = Boolean(otpRecord && !otpRecord.used && otpRecord.code === customerShieldPasscodeSecret);
    if (!otpOk) {
      if (typeof setCustomerShieldValidationAlert === "function") {
        setCustomerShieldValidationAlert("Incorrect or expired code. Please try again.");
      }
      return;
    }
    // Mark the code used immediately so it cannot be replayed for another access.
    window.__customerShieldOtp = { ...otpRecord, used: true };
    const target = customerShieldTargetEntity || {};
    const targetId = target.customerId || target.id || target.uid;
    const targetName = target.name || target.username || targetId;
    const scopeLabel = SCOPE_LABELS[customerShieldIntentScope] || "Record";
    logCustomerAuditEntry({
      customerId: targetId,
      customerName: targetName,
      action: `Accessed ${scopeLabel} (verified via one-time code)`,
      reason: customerShieldAccessReason,
      justificationNotes: customerShieldJustificationNote
    });
    if (customerShieldIntentScope === "transaction_pii" && target._piiTargetKey && typeof setUnlockedCustomerPII === "function") {
      setUnlockedCustomerPII(prev => ({ ...prev, [target._piiTargetKey]: true }));
    }
    if (typeof customerShieldPendingAction === "function") customerShieldPendingAction();
    terminateCustomerShield();
  };
  const getExistingUserDocId = (custOrId) => {
    if (!custOrId) return "";
    let searchKey = "";
    if (typeof custOrId === "object") {
      searchKey = String(custOrId.id || custOrId.uid || custOrId.docId || custOrId.clientId || custOrId.customerId || "").trim().toLowerCase();
    } else {
      searchKey = String(custOrId).trim().toLowerCase();
    }
    if (!searchKey) return "";
    const profileMatch = (customerProfiles || []).find(p =>
      !isProviderEntity(p) && (
        String(p.id || "").trim().toLowerCase() === searchKey ||
        String(p.uid || "").trim().toLowerCase() === searchKey ||
        String(p.clientId || "").trim().toLowerCase() === searchKey ||
        String(p.customerId || "").trim().toLowerCase() === searchKey ||
        (p.emailAddress && String(p.emailAddress).trim().toLowerCase() === searchKey) ||
        (p.email && String(p.email).trim().toLowerCase() === searchKey)
      )
    );
    if (profileMatch) {
      return String(profileMatch.id || profileMatch.uid || profileMatch.docId || profileMatch.clientId || profileMatch.customerId || "").trim();
    }
    const listMatch = (customerList || []).find(c =>
      !isProviderEntity(c) && (
        String(c.id || "").trim().toLowerCase() === searchKey ||
        String(c.uid || "").trim().toLowerCase() === searchKey ||
        String(c.customerId || "").trim().toLowerCase() === searchKey ||
        String(c.clientId || "").trim().toLowerCase() === searchKey ||
        (c.email && String(c.email).trim().toLowerCase() === searchKey)
      )
    );
    if (listMatch) {
      return String(listMatch.id || listMatch.uid || listMatch.docId || listMatch.customerId || listMatch.clientId || "").trim();
    }
    if (typeof custOrId === "object") {
      return String(custOrId.id || custOrId.uid || custOrId.docId || custOrId.customerId || custOrId.clientId || "").trim();
    }
    return String(custOrId).trim();
  };
  // ============================================================================
  // INLINE ROW EDITING ENGINE
  // ============================================================================
  const activeEditRowId = (typeof inlineEditRowId !== "undefined" ? inlineEditRowId : window.__inlineEditCustRowId) || null;
  const activeEditDraft = (typeof inlineEditDraft !== "undefined" ? inlineEditDraft : window.__inlineEditCustDraft) || {};
  const triggerRowEditRender = () => {
    triggerCustomerListRender();
  };
  const startEditingRow = (customer) => {
    const rowId = String(customer.id || customer.customerId || customer.uid || "").trim();
    window.__inlineEditCustRowId = rowId;
    window.__inlineEditCustDraft = {
      id: rowId,
      customerId: customer.customerId || customer.id || customer.uid || "",
      name: customer.customerName || customer.name || customer.username || "",
      status: customer.status || "Active",
      walletBalance: customer.walletBalance !== undefined ? Number(customer.walletBalance) : 0,
      phone: customer.phone || customer.phoneNumber || customer.customerPhone || "",
      email: customer.email || customer.emailAddress || customer.customerEmail || "",
      address: customer.address || customer.location || "",
      notes: customer.notes || ""
    };
    if (typeof setInlineEditRowId === "function") setInlineEditRowId(rowId);
    if (typeof setInlineEditDraft === "function") setInlineEditDraft(window.__inlineEditCustDraft);
    triggerRowEditRender();
  };
  const cancelEditingRow = () => {
    window.__inlineEditCustRowId = null;
    window.__inlineEditCustDraft = {};
    if (typeof setInlineEditRowId === "function") setInlineEditRowId(null);
    if (typeof setInlineEditDraft === "function") setInlineEditDraft({});
    triggerRowEditRender();
  };
  const updateEditDraftField = (field, value) => {
    window.__inlineEditCustDraft = { ...(window.__inlineEditCustDraft || {}), [field]: value };
    if (typeof setInlineEditDraft === "function") {
      setInlineEditDraft(window.__inlineEditCustDraft);
    }
    triggerRowEditRender();
  };
  const saveEditingRow = async (originalCustomer) => {
    const draft = window.__inlineEditCustDraft || {};
    const exactDocId = getExistingUserDocId(draft.id || draft.customerId || originalCustomer);
    if (!exactDocId) {
      alert("Unable to find customer document ID to save.");
      return;
    }
    const updatedName = String(draft.name || "").trim();
    const updatedStatus = String(draft.status || "Active").trim();
    const updatedBalance = Number(draft.walletBalance ?? 0);
    const updatedPhone = String(draft.phone || "").trim();
    const updatedEmail = String(draft.email || "").trim();
    const updatedAddress = String(draft.address || "").trim();
    const previousBalance = Number(originalCustomer.walletBalance ?? 0);
    const balanceDiff = updatedBalance - previousBalance;
    try {
      if (typeof db !== "undefined") {
        const userRef = doc(db, "users", exactDocId);
        const updatePayload = {
          name: updatedName,
          customerName: updatedName,
          username: updatedName,
          displayName: updatedName,
          status: updatedStatus,
          walletBalance: updatedBalance,
          phone: updatedPhone,
          phoneNumber: updatedPhone,
          customerPhone: updatedPhone,
          email: updatedEmail,
          emailAddress: updatedEmail,
          customerEmail: updatedEmail,
          address: updatedAddress,
          location: updatedAddress,
          updatedAt: new Date().toISOString()
        };
        await setDoc(userRef, updatePayload, { merge: true });
        if (balanceDiff !== 0 && typeof collection !== "undefined" && typeof addDoc !== "undefined") {
          try {
            await addDoc(collection(db, "users", exactDocId, "walletTransactions"), {
              amount: balanceDiff,
              type: balanceDiff > 0 ? "credit" : "debit",
              reason: `Staff balance adjustment (${balanceDiff > 0 ? "+" : ""}£${balanceDiff.toFixed(2)})`,
              staffHandle: (currentUser && (currentUser.displayName || currentUser.email || currentUser.uid)) || "Staff",
              createdAt: typeof serverTimestamp === "function" ? serverTimestamp() : new Date().toISOString()
            });
          } catch (txErr) {
            console.error("walletTransactions update error:", txErr);
          }
        }
      }
      if (typeof setCustomerList === "function") {
        setCustomerList(prev => (prev || []).map(c => {
          const cKey = String(c.customerId || c.id || c.uid || "").trim().toLowerCase();
          if (cKey === exactDocId.toLowerCase() || cKey === String(draft.id || "").trim().toLowerCase()) {
            return {
              ...c,
              name: updatedName,
              customerName: updatedName,
              username: updatedName,
              status: updatedStatus,
              walletBalance: updatedBalance,
              phone: updatedPhone,
              email: updatedEmail,
              address: updatedAddress
            };
          }
          return c;
        }));
      }
      if (typeof setCustomerProfiles === "function") {
        setCustomerProfiles(prev => (prev || []).map(c => {
          const cKey = String(c.clientId || c.customerId || c.uid || c.id || "").trim().toLowerCase();
          if (cKey === exactDocId.toLowerCase() || cKey === String(draft.id || "").trim().toLowerCase()) {
            return {
              ...c,
              name: updatedName,
              customerName: updatedName,
              displayName: updatedName,
              username: updatedName,
              status: updatedStatus,
              walletBalance: updatedBalance,
              phone: updatedPhone,
              phoneNumber: updatedPhone,
              email: updatedEmail,
              emailAddress: updatedEmail,
              location: updatedAddress
            };
          }
          return c;
        }));
      }
      logCustomerAuditEntry({
        customerId: exactDocId,
        customerName: updatedName,
        action: `Edited customer row: Name="${updatedName}", Status="${updatedStatus}", Wallet=£${updatedBalance.toFixed(2)}`,
        reason: "Customer row edit"
      });
      cancelEditingRow();
      alert("Customer details updated successfully!");
    } catch (err) {
      console.error("Save customer edit error:", err);
      alert("Failed to save changes: " + err.message);
    }
  };
  // ============================================================================
  // CREDIT LEDGER CLASSIFICATION HELPERS
  // ============================================================================
  const computeCreditEntryState = (entry, custWalletOverrideUsed) => {
    const appliedDate = entry.transactionDate || entry.appliedDate || entry.createdAt || new Date().toISOString();
    const defaultExpiry = new Date(new Date(appliedDate).getTime() + NINETY_DAYS_MS).toISOString();
    const expiryDate = entry.expiryDate || entry.walletExpiryDate || entry.expiryDate90Days || defaultExpiry;
    const now = new Date();
    const isExpiredByDate = now > new Date(expiryDate);
    let effectiveStatus;
    if (entry.status === "Used" || custWalletOverrideUsed) {
      effectiveStatus = "Used";
    } else if (isExpiredByDate) {
      effectiveStatus = "Expired";
    } else {
      effectiveStatus = entry.status || "Active";
    }
    const isUsable = effectiveStatus === "Active";
    const effectiveAmount = effectiveStatus === "Active" ? Number(entry.amount || 0) : 0;
    return { appliedDate, expiryDate, effectiveStatus, isUsable, effectiveAmount, isExpiredByDate };
  };

  const autoExpireLedgerEntries = (ledgerArr) => {
    let changed = false;
    const expiredCustomerIds = new Set(); // customers whose credits just flipped Active → Expired
    const next = (ledgerArr || []).map(e => {
      if (e.status === "Active") {
        const expiryDate = e.expiryDate || e.walletExpiryDate || e.expiryDate90Days;
        if (expiryDate && new Date() > new Date(expiryDate)) {
          changed = true;
          if (e.customerId) expiredCustomerIds.add(e.customerId);
          return { ...e, status: "Expired", effectiveStatus: "Expired" };
        }
      }
      return e;
    });
    return { next, changed, expiredCustomerIds: Array.from(expiredCustomerIds) };
  };
  const computeUsableWalletBalance = (ledgerArr, targetIdNormalized) => {
    return (ledgerArr || [])
      .filter(e => normalizeWalletId(e.customerId) === targetIdNormalized && (e.entryType === "issue" || !e.entryType))
      .reduce((sum, e) => {
        const state = computeCreditEntryState(e, false);
        return sum + (state.isUsable ? state.effectiveAmount : 0);
      }, 0);
  };
  // ============================================================================
  // MARKETING LEDGER SYNC
  // Persists "Credit Allocated (lifetime issued)", "Credit Redeemed (redeemed / spent)",
  // "Credit Expired" and "Available Credits" per customer to Firestore
  // (marketingLedger/{customerId} — ONE document per customer, always written with
  // merge:true so no duplicate documents or collections are ever created),
  // localStorage, and optional React state. Defined BEFORE redeemCreditForBooking
  // so it is initialised by the time the auto-redeem loop below runs.
  // ============================================================================
  const computeLifetimeIssued = (ledgerArr, targetIdNormalized) => {
    return (ledgerArr || [])
      .filter(e => normalizeWalletId(e.customerId) === targetIdNormalized && (e.entryType === "issue" || !e.entryType))
      .reduce((sum, e) => sum + Number(e.originalAmount != null ? e.originalAmount : (e.amount || 0)), 0);
  };

  // Total £ that has been redeemed / spent on bookings
  const computeTotalSpent = (ledgerArr, targetIdNormalized) => {
    return (ledgerArr || [])
      .filter(e => normalizeWalletId(e.customerId) === targetIdNormalized && (e.entryType === "issue" || !e.entryType))
      .reduce((sum, e) => {
        const st = computeCreditEntryState(e, false).effectiveStatus;
        if (st !== "Used") return sum;
        return sum + Number(e.originalAmount != null ? e.originalAmount : (e.usedAmount || 0));
      }, 0);
  };

  // Total £ of credit that expired unused (90-day window elapsed)
  const computeTotalExpired = (ledgerArr, targetIdNormalized) => {
    return (ledgerArr || [])
      .filter(e => normalizeWalletId(e.customerId) === targetIdNormalized && (e.entryType === "issue" || !e.entryType))
      .reduce((sum, e) => {
        const st = computeCreditEntryState(e, false).effectiveStatus;
        if (st !== "Expired") return sum;
        return sum + Number(e.originalAmount != null ? e.originalAmount : (e.amount || 0));
      }, 0);
  };

  // Number of credits redeemed / used (same rule as the "Credits Redeemed / Used" card)
  const computeRedeemedCount = (ledgerArr, targetIdNormalized) => {
    return (ledgerArr || [])
      .filter(e => normalizeWalletId(e.customerId) === targetIdNormalized)
      .filter(e => e.entryType === "redeem" || computeCreditEntryState(e, false).effectiveStatus === "Used")
      .length;
  };

  const syncMarketingLedger = async ({
    customerDocId,
    customerName,
    existingUsableCredits,
    newCreditsIssuedLifetime,
    totalSpent = 0,
    totalExpired = 0,
    creditsRedeemedCount = 0,
    lastCreditAmount = 0,
    lastBookingId = "",
    staffHandle = "",
    event = "credit_issued"
  }) => {
    if (!customerDocId) return null;
    const available = Number(existingUsableCredits || 0);
    const lifetime = Number(newCreditsIssuedLifetime || 0);
    const spent = Number(totalSpent || 0);
    const expired = Number(totalExpired || 0);
    const entry = {
      customerId: String(customerDocId),
      customerName: customerName || "",
      // Wallet overview labels
      existingUsableCredits: available,
      newCreditsIssuedLifetime: lifetime,
      creditsRedeemedCount: Number(creditsRedeemedCount || 0),
      // Marketing Ledger card fields
      totalCredits: lifetime,        // "Total Credits — lifetime issued"
      lifetimeIssued: lifetime,
      totalSpent: spent,             // "Total Spent — redeemed / spent"
      redeemedSpent: spent,
      availableCredits: available,   // "Available Credits"
      // Credit lifecycle fields
      creditAllocated: lifetime,     // "Credit Allocated"
      creditRedeemed: spent,         // "Credit Redeemed"
      creditExpired: expired,        // "Credit Expired"
      lastCreditAmount: Number(lastCreditAmount || 0),
      lastBookingId: lastBookingId || "",
      lastEvent: event,
      updatedBy: staffHandle || "",
      updatedAt: new Date().toISOString()
    };
    try {
      if (typeof db !== "undefined" && typeof doc !== "undefined" && typeof setDoc !== "undefined") {
        await setDoc(doc(db, "marketingLedger", String(customerDocId)), entry, { merge: true });
      }
    } catch (mlErr) {
      console.error("marketingLedger sync error:", mlErr);
    }
    try {
      const storedML = JSON.parse(localStorage.getItem("marketingLedger") || "[]");
      const idx = storedML.findIndex(e => normalizeWalletId(e.customerId) === normalizeWalletId(customerDocId));
      if (idx >= 0) storedML[idx] = { ...storedML[idx], ...entry };
      else storedML.unshift(entry);
      localStorage.setItem("marketingLedger", JSON.stringify(storedML));
    } catch (mlLocalErr) {}
    if (typeof setMarketingLedger === "function") {
      setMarketingLedger(prev => {
        const list = Array.isArray(prev) ? [...prev] : [];
        const i = list.findIndex(e => normalizeWalletId(e.customerId) === normalizeWalletId(customerDocId));
        if (i >= 0) list[i] = { ...list[i], ...entry };
        else list.unshift(entry);
        return list;
      });
    }
    return entry;
  };
  let effectiveWalletLedger = (walletLedger && walletLedger.length > 0) ? [...walletLedger] : [];
  try {
    const localLedger = JSON.parse(localStorage.getItem("walletLedger") || "[]");
    if (Array.isArray(localLedger) && localLedger.length > 0) {
      const map = new Map();
      effectiveWalletLedger.forEach(e => map.set(e.id || `${e.customerId}_${e.appliedDate || e.createdAt}`, e));
      localLedger.forEach(e => {
        const k = e.id || `${e.customerId}_${e.appliedDate || e.createdAt}`;
        if (!map.has(k)) map.set(k, e);
      });
      effectiveWalletLedger = Array.from(map.values());
    }
  } catch (e) {}
  {
    const { next, changed, expiredCustomerIds } = autoExpireLedgerEntries(effectiveWalletLedger);
    effectiveWalletLedger = next;
    if (changed) {
      try { localStorage.setItem("walletLedger", JSON.stringify(effectiveWalletLedger)); } catch (e) {}
      if (typeof setWalletLedger === "function") setWalletLedger(effectiveWalletLedger);
      // ✅ Sync "Credit Expired" into the SAME marketingLedger/{customerId} document (merge — no duplicates).
      // A per-customer signature guard ensures each distinct state is written only once.
      window.__mlExpiredSyncSig = window.__mlExpiredSyncSig || {};
      (expiredCustomerIds || []).forEach((expCid) => {
        const expNorm = normalizeWalletId(expCid);
        const expDocId = getExistingUserDocId(expCid);
        if (!expNorm || !expDocId) return;
        const expLifetime = computeLifetimeIssued(effectiveWalletLedger, expNorm);
        const expSpent = computeTotalSpent(effectiveWalletLedger, expNorm);
        const expExpired = computeTotalExpired(effectiveWalletLedger, expNorm);
        const expUsable = computeUsableWalletBalance(effectiveWalletLedger, expNorm);
        const expSig = [expLifetime, expSpent, expExpired, expUsable].join("|");
        if (window.__mlExpiredSyncSig[expNorm] === expSig) return;
        window.__mlExpiredSyncSig[expNorm] = expSig;
        const expSample = effectiveWalletLedger.find(e => normalizeWalletId(e.customerId) === expNorm) || {};
        syncMarketingLedger({
          customerDocId: expDocId,
          customerName: expSample.customerName || expSample.username || "",
          existingUsableCredits: expUsable,
          newCreditsIssuedLifetime: expLifetime,
          totalSpent: expSpent,
          totalExpired: expExpired,
          creditsRedeemedCount: computeRedeemedCount(effectiveWalletLedger, expNorm),
          staffHandle: "System Auto-Expire",
          event: "credit_expired"
        });
      });
    }
  }
  (customerProfiles || []).concat(customerList || []).forEach(p => {
    if (isProviderEntity(p)) return;
    const pId = String(p.id || p.uid || p.clientId || p.customerId || "").trim();
    const pName = p.customerName || p.name || p.username || p.displayName || pId;
    const pBal = Number(p.walletBalance || 0);
    const pStatus = (p.walletStatus === "Used" || pBal === 0) ? "Used" : (p.walletStatus || "Active");
    const pDate = p.lastCreditAppliedDate || p.createdAt || new Date().toISOString();
    if (!pId) return;
    const normalizedPId = normalizeWalletId(pId);
    const matchingIndex = effectiveWalletLedger.findIndex(e => normalizeWalletId(e.customerId) === normalizedPId);
    if (matchingIndex === -1) {
      if (pBal > 0 || p.lastCreditAppliedDate || p.walletExpiryDate || p.walletStatus === "Used") {
        effectiveWalletLedger.unshift({
          id: `doc-${pId}`,
          customerId: pId,
          customerName: pName,
          username: pName,
          amount: pStatus === "Used" ? 0 : pBal,
          reasonCode: "Wallet Credit",
          staffHandle: "System",
          appliedDate: pDate,
          expiryDate: p.walletExpiryDate || p.expiryDate || new Date(Date.now() + NINETY_DAYS_MS).toISOString(),
          walletExpiryDate: p.walletExpiryDate || p.expiryDate || new Date(Date.now() + NINETY_DAYS_MS).toISOString(),
          status: pStatus,
          effectiveStatus: pStatus,
          entryType: "issue",
          createdAt: pDate
        });
      }
    } else {
      const existingEntry = effectiveWalletLedger[matchingIndex];
      if (pStatus === "Used" && existingEntry.status !== "Used") {
        effectiveWalletLedger[matchingIndex] = {
          ...existingEntry, status: "Used", effectiveStatus: "Used", amount: 0,
          usedAt: existingEntry.usedAt || p.lastCreditUsedDate || new Date().toISOString()
        };
      } else if (pStatus === "Active" && existingEntry.status === "Used" && pBal > 0 && p.walletStatus === "Active") {
        effectiveWalletLedger[matchingIndex] = { ...existingEntry, status: "Active", effectiveStatus: "Active", amount: pBal };
      }
    }
  });
  let effectiveVoucherRegistry = (voucherRegistry && voucherRegistry.length > 0) ? [...voucherRegistry] : [];
  try {
    const localVouchers = JSON.parse(localStorage.getItem("voucherRegistry") || "[]");
    if (Array.isArray(localVouchers) && localVouchers.length > 0) {
      const map = new Map();
      effectiveVoucherRegistry.forEach(v => map.set(v.id || `${v.customerId}_${v.voucherCode}`, v));
      localVouchers.forEach(v => {
        const k = v.id || `${v.customerId}_${v.voucherCode}`;
        if (!map.has(k)) map.set(k, v);
      });
      effectiveVoucherRegistry = Array.from(map.values());
    }
  } catch (e) {}
  {
    let changedV = false;
    effectiveVoucherRegistry = effectiveVoucherRegistry.map(v => {
      if (v.voucherStatus === "Active") {
        const expiryDate = v.expiryDate;
        if (expiryDate && new Date() > new Date(expiryDate)) {
          changedV = true;
          return { ...v, voucherStatus: "Expired", effectiveVoucherStatus: "Expired" };
        }
      }
      return v;
    });
    if (changedV) {
      try { localStorage.setItem("voucherRegistry", JSON.stringify(effectiveVoucherRegistry)); } catch (e) {}
      if (typeof setVoucherRegistry === "function") setVoucherRegistry(effectiveVoucherRegistry);
    }
  }
  // ============================================================================
  // AUTOMATIC CREDIT REDEMPTION ON BOOKING
  // ============================================================================
  const redeemCreditForBooking = async (customerIdRaw, bookingId) => {
    const exactDocId = getExistingUserDocId(customerIdRaw);
    if (!exactDocId) return;
    const targetIdNorm = normalizeWalletId(exactDocId);
    const usedTimestamp = new Date().toISOString();
    const candidateEntries = (effectiveWalletLedger || [])
      .filter(e => normalizeWalletId(e.customerId) === targetIdNorm && (e.entryType === "issue" || !e.entryType))
      .map(e => ({ ...e, __state: computeCreditEntryState(e, false) }))
      .filter(e => e.__state.isUsable)
      .sort((a, b) => new Date(a.__state.appliedDate) - new Date(b.__state.appliedDate));
    if (candidateEntries.length === 0) return;
    const entryToRedeem = candidateEntries[0];
    try {
      if (typeof db !== "undefined") {
        const userRef = doc(db, "users", exactDocId);
        await setDoc(userRef, {
          walletBalance: 0, walletStatus: "Used",
          lastCreditUsedDate: usedTimestamp, lastCreditUsedBookingId: bookingId || ""
        }, { merge: true });
        if (entryToRedeem.id && !String(entryToRedeem.id).startsWith("doc-")) {
          try {
            await setDoc(doc(db, "users", exactDocId, "walletLedger", String(entryToRedeem.id)), {
              status: "Used", amount: 0, usedAt: usedTimestamp, redeemedBookingId: bookingId || ""
            }, { merge: true });
          } catch (subErr) {}
        }
        if (typeof collection !== "undefined" && typeof addDoc !== "undefined") {
          try {
            const debitAmt = Number(entryToRedeem.amount || entryToRedeem.__state?.effectiveAmount || 0);
            await addDoc(collection(db, "users", exactDocId, "walletTransactions"), {
              amount: -Math.abs(debitAmt),
              type: "debit",
              reason: bookingId ? `Booking payment (${bookingId})` : "Booking payment",
              staffHandle: "System Auto-Redeem",
              createdAt: typeof serverTimestamp === "function" ? serverTimestamp() : new Date().toISOString()
            });
          } catch (wtErr) {
            console.error("walletTransactions logging error:", wtErr);
          }
        }
      }
      // Keep the redeemed amount on the entry so "Total Spent" stays correct
      const redeemedAmount = Number(entryToRedeem.originalAmount != null ? entryToRedeem.originalAmount : (entryToRedeem.amount || entryToRedeem.__state?.effectiveAmount || 0));
      const updatedLedger = (effectiveWalletLedger || []).map(e => {
        if (e.id === entryToRedeem.id) {
          return { ...e, status: "Used", effectiveStatus: "Used", amount: 0, usedAmount: redeemedAmount, usedAt: usedTimestamp, redeemedBookingId: bookingId || "" };
        }
        return e;
      });
      if (typeof setWalletLedger === "function") setWalletLedger(updatedLedger);
      try { localStorage.setItem("walletLedger", JSON.stringify(updatedLedger)); } catch (e) {}
      if (typeof setCustomerList === "function") {
        setCustomerList(prev => (prev || []).map(c => {
          const cKey = normalizeWalletId(c.customerId || c.id || c.uid);
          if (cKey === targetIdNorm) return { ...c, walletBalance: 0, walletStatus: "Used" };
          return c;
        }));
      }
      if (typeof setCustomerProfiles === "function") {
        setCustomerProfiles(prev => (prev || []).map(c => {
          const cKey = normalizeWalletId(c.clientId || c.customerId || c.uid || c.id);
          if (cKey === targetIdNorm) return { ...c, walletBalance: 0, walletStatus: "Used" };
          return c;
        }));
      }
      await syncMarketingLedger({
        customerDocId: exactDocId,
        customerName: entryToRedeem.customerName || entryToRedeem.username || "",
        existingUsableCredits: 0,
        newCreditsIssuedLifetime: computeLifetimeIssued(updatedLedger, targetIdNorm),
        totalSpent: computeTotalSpent(updatedLedger, targetIdNorm),
        totalExpired: computeTotalExpired(updatedLedger, targetIdNorm),
        creditsRedeemedCount: computeRedeemedCount(updatedLedger, targetIdNorm),
        lastBookingId: bookingId || "",
        staffHandle: "System Auto-Redeem",
        event: "credit_redeemed"
      });
      logCustomerAuditEntry({
        customerId: exactDocId,
        customerName: entryToRedeem.customerName || entryToRedeem.username || "",
        action: `Credit of £${Number(entryToRedeem.amount || entryToRedeem.__state.effectiveAmount).toFixed(2)} auto-redeemed on booking ${bookingId || "-"}`,
        reason: "Automatic booking redemption"
      });
      if (typeof logActivityTrailEntry === "function") {
        logActivityTrailEntry({
          customerId: exactDocId,
          customerName: entryToRedeem.customerName || entryToRedeem.username || "",
          activityCategory: "TopUp",
          summary: `Credit of £${Number(entryToRedeem.amount || entryToRedeem.__state.effectiveAmount).toFixed(2)} auto-redeemed on booking ${bookingId || "-"}. Balance set to £0.00, status Used. Not reusable.`,
          staffHandle: "System (Auto-Redeem)"
        });
      }
    } catch (err) {
      console.error("Auto credit redemption error:", err);
    }
  };

  (workOrders || []).forEach(job => {
    if (isProviderEntity(job)) return;
    const creditConsumedFlag = job.walletCreditUsed === true || job.creditApplied === true || String(job.paymentMethod || "").toLowerCase().includes("wallet credit");
    if (!creditConsumedFlag) return;
    const custIdRaw = job.customerId;
    if (!custIdRaw) return;
    const targetIdNorm = normalizeWalletId(getExistingUserDocId(custIdRaw) || custIdRaw);
    const stillHasUsableCredit = (effectiveWalletLedger || []).some(e => {
      if (normalizeWalletId(e.customerId) !== targetIdNorm) return false;
      const state = computeCreditEntryState(e, false);
      return state.isUsable;
    });
    const alreadyRedeemedForThisBooking = (effectiveWalletLedger || []).some(e => normalizeWalletId(e.customerId) === targetIdNorm && e.redeemedBookingId === (job.docId || job.id));
    if (stillHasUsableCredit && !alreadyRedeemedForThisBooking) {
      redeemCreditForBooking(custIdRaw, job.docId || job.id);
    }
  });
  // ============================================================================
  // ISSUE CREDIT HELPER (WITH JUSTIFICATION, AUDITED STAFF LOGGING & MARKETING LEDGER SYNC)
  // ============================================================================
  const issueCreditToCustomer = async ({
    rawCustomerId,
    customerName,
    amount,
    reasonCode,
    justificationNotes = "",
    staffHandle,
    bookingId = ""
  }) => {
    const existingDocId = getExistingUserDocId(rawCustomerId);
    if (!existingDocId || !amount) return null;
    const issueDate = new Date();
    const calculatedExpiryDate = new Date(issueDate.getTime() + NINETY_DAYS_MS).toISOString();
    const creditAmountVal = Number(amount || 0);
    const issuingStaff = staffHandle || (currentUser && (currentUser.displayName || currentUser.email || currentUser.uid)) || "Staff";
    const targetIdNorm = normalizeWalletId(existingDocId);
    const ledgerEntry = {
      id: Date.now().toString(),
      customerId: existingDocId,
      customerName: customerName || "",
      amount: creditAmountVal,
      originalAmount: creditAmountVal,
      reasonCode: reasonCode || "Goodwill Compensation",
      justificationNotes: justificationNotes || "",
      staffHandle: issuingStaff,
      bookingId: bookingId || "",
      appliedDate: issueDate.toISOString(),
      expiryDate: calculatedExpiryDate,
      walletExpiryDate: calculatedExpiryDate,
      expiryDate90Days: calculatedExpiryDate,
      status: "Active",
      entryType: "issue",
      redeemedBookingId: "",
      createdAt: new Date().toISOString()
    };
    // Ledger snapshot INCLUDING the credit being issued right now
    const ledgerAfterIssue = [ledgerEntry, ...(effectiveWalletLedger || [])];
    const currentUsable = computeUsableWalletBalance(effectiveWalletLedger, targetIdNorm);
    const newWalletBalance = Number(currentUsable || 0) + creditAmountVal;                // Existing / Usable Credits
    const lifetimeIssuedTotal = computeLifetimeIssued(ledgerAfterIssue, targetIdNorm);    // Credit Allocated (Lifetime)
    const totalSpentValue = computeTotalSpent(ledgerAfterIssue, targetIdNorm);            // Credit Redeemed (Total Spent)
    const totalExpiredValue = computeTotalExpired(ledgerAfterIssue, targetIdNorm);        // Credit Expired
    const redeemedCountValue = computeRedeemedCount(ledgerAfterIssue, targetIdNorm);      // Credits Redeemed / Used
    if (typeof db !== "undefined" && existingDocId) {
      if (typeof collection !== "undefined" && typeof addDoc !== "undefined") {
        await addDoc(collection(db, "users", existingDocId, "walletLedger"), ledgerEntry);
        try {
          await addDoc(collection(db, "users", existingDocId, "walletTransactions"), {
            amount: Math.abs(creditAmountVal),
            type: "credit",
            reason: reasonCode || "Goodwill Compensation",
            justificationNotes: justificationNotes || "",
            staffHandle: issuingStaff,
            bookingId: bookingId || "",
            createdAt: typeof serverTimestamp === "function" ? serverTimestamp() : new Date().toISOString()
          });
        } catch (wtErr) {
          console.error("walletTransactions logging error:", wtErr);
        }
      }
      const userRef = doc(db, "users", existingDocId);
      await setDoc(userRef, {
        walletBalance: newWalletBalance,
        marketingExistingCredits: newWalletBalance,
        marketingLifetimeIssued: lifetimeIssuedTotal,
        marketingTotalCredits: lifetimeIssuedTotal,
        marketingTotalSpent: totalSpentValue,
        marketingAvailableCredits: newWalletBalance,
        marketingCreditsRedeemedCount: redeemedCountValue,
        marketingCreditAllocated: lifetimeIssuedTotal,
        marketingCreditRedeemed: totalSpentValue,
        marketingCreditExpired: totalExpiredValue,
        walletStatus: "Active",
        walletExpiryDate: calculatedExpiryDate,
        expiryDate: calculatedExpiryDate,
        expiryDate90Days: calculatedExpiryDate,
        lastCreditAppliedDate: issueDate.toISOString(),
        lastCreditIssuedBy: issuingStaff,
        lastCreditBookingId: bookingId || "",
        lastCreditJustification: justificationNotes || ""
      }, { merge: true });
    }
    const marketingFields = {
      walletBalance: newWalletBalance,
      marketingExistingCredits: newWalletBalance,
      marketingLifetimeIssued: lifetimeIssuedTotal,
      marketingTotalCredits: lifetimeIssuedTotal,
      marketingTotalSpent: totalSpentValue,
      marketingAvailableCredits: newWalletBalance,
      marketingCreditsRedeemedCount: redeemedCountValue,
      marketingCreditAllocated: lifetimeIssuedTotal,
      marketingCreditRedeemed: totalSpentValue,
      marketingCreditExpired: totalExpiredValue,
      walletStatus: "Active",
      walletExpiryDate: calculatedExpiryDate,
      expiryDate: calculatedExpiryDate,
      expiryDate90Days: calculatedExpiryDate
    };
    if (typeof setCustomerList === "function") {
      setCustomerList(prev => (prev || []).map(c => {
        const cKey = String(c.customerId || c.id || c.uid || "").toLowerCase();
        if (cKey === existingDocId.toLowerCase() || cKey === String(rawCustomerId || "").toLowerCase()) {
          return { ...c, ...marketingFields };
        }
        return c;
      }));
    }
    if (typeof setCustomerProfiles === "function") {
      setCustomerProfiles(prev => (prev || []).map(c => {
        const cKey = String(c.clientId || c.customerId || c.uid || "").toLowerCase();
        if (cKey === existingDocId.toLowerCase() || cKey === String(rawCustomerId || "").toLowerCase()) {
          return { ...c, ...marketingFields };
        }
        return c;
      }));
    }
    if (typeof setWalletLedger === "function") setWalletLedger(prev => [ledgerEntry, ...(prev || [])]);
    try {
      const localLedger = JSON.parse(localStorage.getItem("walletLedger") || "[]");
      localLedger.unshift(ledgerEntry);
      localStorage.setItem("walletLedger", JSON.stringify(localLedger));
    } catch (errLocal) {}
    const bookingSummary = bookingId ? ` [Linked Booking: ${bookingId}]` : "";
    const noteSummary = justificationNotes ? ` [Notes: "${justificationNotes}"]` : "";
    if (typeof logActivityTrailEntry === "function") {
      logActivityTrailEntry({
        customerId: existingDocId,
        customerName: ledgerEntry.customerName || "",
        activityCategory: "TopUp",
        summary: `Credit issued: £${creditAmountVal.toFixed(2)} by ${issuingStaff} for "${reasonCode}". Valid 90 days (expires ${new Date(calculatedExpiryDate).toLocaleDateString()}).${bookingSummary}${noteSummary}`,
        staffHandle: issuingStaff
      });
    }
    logCustomerAuditEntry({
      customerId: existingDocId,
      customerName: ledgerEntry.customerName || "",
      action: `Issued £${creditAmountVal.toFixed(2)} credit (By: ${issuingStaff})${bookingSummary}`,
      reason: reasonCode || "Not specified",
      justificationNotes: justificationNotes || "",
      staffHandleOverride: issuingStaff
    });
    // ✅ Persist to the Marketing Ledger (Credit Allocated / Credit Redeemed / Credit Expired / Available Credits)
    // Same marketingLedger/{customerId} document, merged — no duplicate collections or documents.
    await syncMarketingLedger({
      customerDocId: existingDocId,
      customerName: ledgerEntry.customerName || "",
      existingUsableCredits: newWalletBalance,
      newCreditsIssuedLifetime: lifetimeIssuedTotal,
      totalSpent: totalSpentValue,
      totalExpired: totalExpiredValue,
      creditsRedeemedCount: redeemedCountValue,
      lastCreditAmount: creditAmountVal,
      lastBookingId: bookingId || "",
      staffHandle: issuingStaff,
      event: "credit_issued"
    });
    return { newWalletBalance, calculatedExpiryDate, ledgerEntry, lifetimeIssuedTotal, totalSpentValue, totalExpiredValue, redeemedCountValue };
  };
  // Pure customer lists filtered of any provider roles
  const sanitizedCustomerList = (customerList || []).filter(c => !isProviderEntity(c));
  const sanitizedWorkOrders = (workOrders || []).filter(j => !isProviderEntity(j));
  const sanitizedCustomerProfiles = (customerProfiles || []).filter(p => !isProviderEntity(p));
  // Compute all bookings map for quick dropdown / inspection
  const customerBookingsMap = {};
  sanitizedWorkOrders.forEach(job => {
    const cId = normalizeWalletId(job.customerId);
    if (!cId) return;
    if (!customerBookingsMap[cId]) customerBookingsMap[cId] = [];
    customerBookingsMap[cId].push(job);
  });
  return (
    <div style={{ width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box", overflowX: "hidden", padding: 0 }}>
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .refresh-spinning {
          animation: spin 1s linear infinite;
        }
      `}</style>
      <div style={headerStyle}>
        <h3 style={titleStyle}>Customer List Overview</h3>
      </div>
      <div style={{ ...cardStyle, width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box", background: "#ffffff", borderRadius: "16px", padding: "16px", boxShadow: "0 4px 20px rgba(0,0,0,0.06)", border: "1px solid #E5E7EB", overflow: "hidden" }}>
        {isFetching ? (
          <div style={{ padding: "80px 20px", textAlign: "center", fontWeight: "600", color: "#6B7280" }}>Loading Customer Records...</div>
        ) : (
          <>
            {/* Summary Cards */}
            <div style={{ display: "flex", gap: "12px", marginBottom: "16px", flexWrap: "wrap" }}>
              <div style={{ background: "#EEF2FF", color: "#0747A6", padding: "16px 18px", borderRadius: "10px", fontWeight: "700", fontSize: "14px", flex: "1 1 200px", minWidth: 0 }}>
                Total Customers : {sanitizedCustomerList.length}
              </div>
              <div style={{ background: "#EEF2FF", color: "#0747A6", padding: "16px 18px", borderRadius: "10px", fontWeight: "700", fontSize: "14px", flex: "1 1 200px", minWidth: 0 }}>
                Booking Collection : {sanitizedCustomerProfiles.length}
              </div>
              <div
                style={{ background: "#FDF2F8", color: "#9D174D", padding: "16px 18px", borderRadius: "10px", fontWeight: "700", fontSize: "14px", flex: "1 1 200px", minWidth: 0, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                onClick={async () => {
                  openPromotionsForCustomer(null);
                  if (typeof db !== "undefined" && typeof collection !== "undefined" && typeof getDocs !== "undefined") {
                    try {
                      const idsToScan = Array.from(new Set(
                        [...sanitizedCustomerList, ...sanitizedWorkOrders].map((c) => getExistingUserDocId(c)).filter(Boolean)
                      ));
                      const allFetched = [];
                      for (const cid of idsToScan) {
                        try {
                          const subSnap = await getDocs(collection(db, "users", cid, "campaigns"));
                          subSnap.docs.forEach((d) => allFetched.push({ id: d.id, ...d.data() }));
                        } catch (innerErr) {
                          console.error("Error fetching campaigns for customer:", cid, innerErr);
                        }
                      }
                      if (typeof setCampaigns === "function") setCampaigns(allFetched);
                    } catch (err) {
                      console.error("Error fetching global campaigns:", err);
                    }
                  }
                }}
              >
                <span>🎂 Upcoming Birthdays : {getUpcomingBirthdays(sanitizedCustomerList, 30).length}</span>
                <span style={{ fontSize: "11px", background: "#FBCFE8", padding: "2px 8px", borderRadius: "10px" }}>View →</span>
              </div>
              <div
                style={{ background: "#ECFDF5", color: "#065F46", padding: "16px 18px", borderRadius: "10px", fontWeight: "700", fontSize: "14px", flex: "1 1 200px", minWidth: 0, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                onClick={async () => {
                  setShowWalletModule(true);
                  if (typeof db !== "undefined" && typeof collection !== "undefined" && typeof getDocs !== "undefined") {
                    try {
                      const idsToScan = Array.from(new Set(
                        [...sanitizedCustomerList, ...sanitizedWorkOrders, ...sanitizedCustomerProfiles].map((c) => getExistingUserDocId(c)).filter(Boolean)
                      ));
                      const allFetchedVouchers = [];
                      for (const cid of idsToScan) {
                        try {
                          const vSnap = await getDocs(collection(db, "users", cid, "vouchers"));
                          vSnap.docs.forEach((d) => allFetchedVouchers.push({ id: d.id, ...d.data() }));
                        } catch (innerErr) {}
                      }
                      if (allFetchedVouchers.length > 0 && typeof setVoucherRegistry === "function") {
                        setVoucherRegistry(prev => {
                          const map = new Map();
                          (prev || []).forEach(v => map.set(v.id || `${v.customerId}_${v.voucherCode}`, v));
                          allFetchedVouchers.forEach(v => {
                            const key = v.id || `${v.customerId}_${v.voucherCode}`;
                            const existing = map.get(key);
                            if (existing && existing.voucherStatus === "Used") {
                              map.set(key, { ...v, voucherStatus: "Used", discountAmount: 0, voucherDiscountAmount: 0 });
                            } else {
                              map.set(key, v);
                            }
                          });
                          const merged = Array.from(map.values());
                          try { localStorage.setItem("voucherRegistry", JSON.stringify(merged)); } catch(e) {}
                          return merged;
                        });
                      }
                    } catch(err) {
                      console.error("Error fetching vouchers:", err);
                    }
                  }
                }}
              >
                <span>💰 Wallet Credits Issued : {getTotalTopUpsIssued(effectiveWalletLedger)}</span>
                <span style={{ fontSize: "11px", background: "#A7F3D0", padding: "2px 8px", borderRadius: "10px" }}>Open →</span>
              </div>
            </div>
            <div style={{ backgroundColor: "#fff", padding: "14px 16px", borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.06)", marginBottom: "10px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "10px" }}>
              <div style={{ flex: "1 1 200px", minWidth: 0 }}>
                <h3 style={{ margin: 0, fontFamily: "'Poppins', sans-serif", fontSize: "18px", fontWeight: "700", color: "#111827" }}>📋 Customers</h3>
                <p style={{ marginTop: "4px", color: "#6B7280", fontSize: "12px", marginBottom: 0 }}>
                  {isCustomerListUnlocked
                    ? "🔓 Customer list unlocked for this session — records appear once you search. Sensitive details still unlock per-record with a reason and one-time code."
                    : "🔒 PII protected — verify a one-time code to unlock the customer list. Sensitive details unlock per-record with a reason and one-time code."}
                </p>
              </div>
              <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
                {isCustomerListUnlocked && (
                  <button
                    onClick={relockCustomerList}
                    style={{ backgroundColor: "#6B7280", color: "#fff", padding: "7px 14px", borderRadius: "8px", border: "none", cursor: "pointer", fontSize: "12px", fontWeight: "600" }}
                  >🔒 Lock List</button>
                )}
                {purgedVault.length > 0 && (
                  <button onClick={handleRestoreArchive} style={{ backgroundColor: "#10B981", color: "#fff", padding: "7px 14px", borderRadius: "8px", border: "none", cursor: "pointer", fontSize: "12px", fontWeight: "600" }}>♻ Restore All ({purgedVault.length})</button>
                )}
              </div>
            </div>
            {!isCustomerListUnlocked ? (
              <div style={{ padding: "56px 20px", textAlign: "center", background: "#FFFBEB", border: "1px dashed #FBBF24", borderRadius: "12px", marginBottom: "12px" }}>
                <div style={{ fontSize: "32px", marginBottom: "8px" }}>🔑</div>
                <p style={{ margin: "0 0 4px", fontSize: "14px", color: "#92400E", fontWeight: "700" }}>Customer List is Locked</p>
                <p style={{ margin: "0 0 16px", fontSize: "12px", color: "#6B7280" }}>Verify a one-time code to reveal customer records and enable search &amp; filters.</p>
                <button
                  onClick={openCustomerListUnlockModal}
                  style={{ backgroundColor: "#F59E0B", color: "#fff", padding: "10px 22px", borderRadius: "8px", border: "none", cursor: "pointer", fontSize: "13px", fontWeight: "700" }}
                >
                  🔑 Unlock with One-Time Code
                </button>
              </div>
            ) : (
              <>
            {/* Search bar — the only thing shown until the user starts typing */}
            <div style={{ background: "#fff", padding: "12px 14px", borderRadius: "12px", marginBottom: "10px", boxShadow: "0 4px 12px rgba(0,0,0,.05)", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "10px", border: "1px solid #F3F4F6" }}>
              <input
                value={customerSearchQuery || ""}
                onChange={(e) => typeof setCustomerSearchQuery === "function" && setCustomerSearchQuery(e.target.value)}
                placeholder="🔍 Start typing a Customer Name or Customer ID…"
                autoFocus
                style={{ flex: "1 1 200px", minWidth: "200px", maxWidth: "420px", padding: "9px 14px", borderRadius: "8px", border: "1px solid #D1D5DB", outline: "none", fontSize: "14px", background: "#fff" }}
              />
              {hasSearchQuery && (
                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                  <button
                    className="btn btn-primary"
                    onClick={() => { setCustomerColumnFilters({}); typeof setCustomerSearchQuery === "function" && setCustomerSearchQuery(""); }}
                  >
                    ✖ Clear
                  </button>
                  <button className="btn btn-success">📄 Export CSV</button>
                </div>
              )}
            </div>
            {!hasSearchQuery && (
              <div style={{ padding: "48px 20px", textAlign: "center", background: "#F9FAFB", border: "1px dashed #E5E7EB", borderRadius: "12px", marginBottom: "12px" }}>
                <div style={{ fontSize: "28px", marginBottom: "6px" }}>🔍</div>
                <p style={{ margin: 0, fontSize: "13px", color: "#6B7280", fontWeight: "600" }}>Start typing a customer name or ID above to search.</p>
              </div>
            )}
            {/* ========== LIST CONTROLS (only once results exist) ========== */}
            {hasSearchQuery && (
            <div style={{ background: "#fff", padding: "8px 14px", borderRadius: "12px", marginBottom: "8px", boxShadow: "0 4px 12px rgba(0,0,0,.05)", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "10px", border: "1px solid #F3F4F6" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                <span style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", marginRight: 4 }}>List Size:</span>
                {[25, 35, 55, 75, 100].map((level) => (
                  <button
                    key={level}
                    onClick={() => { setCustomerListPageSize(level); setCustomerListExpanded(true); }}
                    style={{
                      padding: "4px 12px", borderRadius: 20,
                      border: customerListPageSize === level && customerListExpanded ? "none" : "1px solid #e5e7eb",
                      background: customerListPageSize === level && customerListExpanded ? "linear-gradient(135deg,#4f46e5,#6366f1)" : "#f9fafb",
                      color: customerListPageSize === level && customerListExpanded ? "#fff" : "#374151",
                      fontWeight: 700, fontSize: 11, cursor: "pointer", transition: "all 0.18s ease", whiteSpace: "nowrap",
                    }}
                  >
                    {level}
                  </button>
                ))}
                <button
                  onClick={() => { setCustomerListPageSize("all"); setCustomerListExpanded(true); }}
                  style={{
                    padding: "4px 12px", borderRadius: 20,
                    border: customerListPageSize === "all" && customerListExpanded ? "none" : "1px solid #e5e7eb",
                    background: customerListPageSize === "all" ? "linear-gradient(135deg,#4f46e5,#6366f1)" : "#f9fafb",
                    color: customerListPageSize === "all" && customerListExpanded ? "#fff" : "#374151",
                    fontWeight: 700, fontSize: 11, cursor: "pointer", transition: "all 0.18s ease", whiteSpace: "nowrap",
                  }}
                >
                  All
                </button>
              </div>
              <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
                <button
                  onClick={() => {
                    if (!customerListExpanded) {
                      setCustomerListExpanded(true);
                      if (customerListPageSize !== "all" && !customerListPageSize) setCustomerListPageSize(25);
                    } else {
                      setCustomerListExpanded(false);
                    }
                  }}
                  style={{
                    background: customerListExpanded ? "#4B5563" : "linear-gradient(135deg,#0747A6,#2563EB)",
                    color: "#fff", border: "none", padding: "6px 14px", borderRadius: 20, fontSize: "11px", fontWeight: "700",
                    cursor: "pointer", display: "flex", alignItems: "center", gap: "4px", transition: "all 0.18s ease"
                  }}
                >
                  {customerListExpanded ? "⬆ Collapse Entire List" : "⬇ Expand Entire List"}
                </button>
                <button
                  onClick={handleRefreshCustomerList}
                  disabled={isLoadingCustomerList}
                  style={{
                    display: "flex", alignItems: "center", gap: "6px",
                    background: isLoadingCustomerList ? "#9CA3AF" : "#0747A6", color: "#fff", border: "none",
                    padding: "6px 14px", borderRadius: "8px", fontSize: "12px", fontWeight: "700",
                    cursor: isLoadingCustomerList ? "not-allowed" : "pointer"
                  }}
                >
                  <span className={isLoadingCustomerList ? "refresh-spinning" : ""}>🔄</span>
                  {isLoadingCustomerList ? "Refreshing..." : "Refresh"}
                </button>
                {customerColumnFilters && Object.values(customerColumnFilters).some(v => String(v || "").trim() !== "") && (
                  <button
                    onClick={() => setCustomerColumnFilters({})}
                    style={{ display: "flex", alignItems: "center", gap: "6px", background: "#EF4444", color: "#fff", border: "none", padding: "6px 14px", borderRadius: "8px", fontSize: "12px", fontWeight: "700", cursor: "pointer" }}
                  >
                    ✖ Clear Filters
                  </button>
                )}
              </div>
            </div>
            )}
            {/* ========== CUSTOMER LIST TABLE — ONLY RENDERED WHEN SEARCHING ========== */}
            {hasSearchQuery && (
              <div style={{ width: "100%", overflowX: "auto", background: "#fff", borderRadius: "12px", border: "1px solid #E5E7EB", marginBottom: "10px" }}>
                {(() => {
                  return (
                  <table style={{ width: "100%", minWidth: "1150px", borderCollapse: "collapse", tableLayout: "auto" }}>
                    <thead style={{ background: "#F9FAFB", position: "sticky", top: 0, zIndex: 1 }}>
                      <tr>
                        <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#6B7280", textAlign: "left", whiteSpace: "nowrap", textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>#</th>
                        <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#0747A6", background: "#EEF2FF", textAlign: "left", whiteSpace: "nowrap", textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>Customer User ID</th>
                        <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#6B7280", textAlign: "left", whiteSpace: "nowrap", textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>Customer Name</th>
                        <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#6B7280", textAlign: "left", whiteSpace: "nowrap", textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>Status</th>
                        <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#059669", background: "#ECFDF5", textAlign: "left", whiteSpace: "nowrap", textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>💰 Wallet Balance (£)</th>
                        <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#6B7280", textAlign: "left", whiteSpace: "nowrap", textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>Total Bookings</th>
                        <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#6B7280", textAlign: "left", whiteSpace: "nowrap", textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>Device / Browser</th>
                        <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#6B7280", textAlign: "center", whiteSpace: "nowrap", textTransform: "uppercase", borderBottom: "1px solid #E5E7EB" }}>Action (Gated)</th>
                      </tr>
                      {/* FILTER ROW */}
                      <tr style={{ background: "#FFFFFF" }}>
                        <th style={{ padding: "6px 8px", borderBottom: "2px solid #E5E7EB" }}></th>
                        <th style={{ padding: "6px 8px", background: "#EEF2FF", borderBottom: "2px solid #E5E7EB" }}>
                          <input
                            value={customerColumnFilters.customerId || ""}
                            onChange={(e) => setCustomerColumnFilters(prev => ({...prev, customerId: e.target.value}))}
                            placeholder="Filter User ID..."
                            style={{ width: "100%", minWidth: "90px", padding: "5px 7px", fontSize: "11px", borderRadius: "6px", border: "1px solid #D1D5DB", outline: "none" }}
                          />
                        </th>
                        <th style={{ padding: "6px 8px", borderBottom: "2px solid #E5E7EB" }}>
                          <input
                            value={customerColumnFilters.name || ""}
                            onChange={(e) => setCustomerColumnFilters(prev => ({...prev, name: e.target.value}))}
                            placeholder="Filter Customer Name..."
                            style={{ width: "100%", minWidth: "110px", padding: "5px 7px", fontSize: "11px", borderRadius: "6px", border: "1px solid #D1D5DB", outline: "none" }}
                          />
                        </th>
                        <th style={{ padding: "6px 8px", borderBottom: "2px solid #E5E7EB" }}>
                          <input
                            value={customerColumnFilters.status || ""}
                            onChange={(e) => setCustomerColumnFilters(prev => ({...prev, status: e.target.value}))}
                            placeholder="Filter Status..."
                            style={{ width: "100%", minWidth: "90px", padding: "5px 7px", fontSize: "11px", borderRadius: "6px", border: "1px solid #D1D5DB", outline: "none" }}
                          />
                        </th>
                        <th style={{ padding: "6px 8px", background: "#ECFDF5", borderBottom: "2px solid #E5E7EB" }}>
                          <input
                            value={customerColumnFilters.walletBalance || ""}
                            onChange={(e) => setCustomerColumnFilters(prev => ({...prev, walletBalance: e.target.value}))}
                            placeholder="Filter £..."
                            style={{ width: "100%", minWidth: "90px", padding: "5px 7px", fontSize: "11px", borderRadius: "6px", border: "1px solid #D1D5DB", outline: "none" }}
                          />
                        </th>
                        <th style={{ padding: "6px 8px", borderBottom: "2px solid #E5E7EB" }}>
                          <input
                            value={customerColumnFilters.bookingCount || ""}
                            onChange={(e) => setCustomerColumnFilters(prev => ({...prev, bookingCount: e.target.value}))}
                            placeholder="Filter #..."
                            style={{ width: "100%", minWidth: "80px", padding: "5px 7px", fontSize: "11px", borderRadius: "6px", border: "1px solid #D1D5DB", outline: "none" }}
                          />
                        </th>
                        <th style={{ padding: "6px 8px", borderBottom: "2px solid #E5E7EB" }}>
                          <input
                            value={customerColumnFilters.device || ""}
                            onChange={(e) => setCustomerColumnFilters(prev => ({...prev, device: e.target.value}))}
                            placeholder="Filter Device..."
                            style={{ width: "100%", minWidth: "90px", padding: "5px 7px", fontSize: "11px", borderRadius: "6px", border: "1px solid #D1D5DB", outline: "none" }}
                          />
                        </th>
                        <th style={{ padding: "6px 8px", borderBottom: "2px solid #E5E7EB" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {(() => {
                        const normalize = (v) => String(v ?? "").trim().toLowerCase();
                        const getMergedBookingsForCustomer = (targetIdNormalized, relatedWorkOrderBookings) => {
                          const subRecords = (subBookingRecords && subBookingRecords[targetIdNormalized]) || [];
                          if (!subRecords.length) return relatedWorkOrderBookings;
                          const mergedMap = new Map();
                          relatedWorkOrderBookings.forEach((b, idx) => {
                            const key = b.docId || b.id || `wo-${idx}`;
                            mergedMap.set(key, b);
                          });
                          subRecords.forEach((b, idx) => {
                            const key = b.docId || b.id || `sub-${idx}`;
                            if (!mergedMap.has(key)) mergedMap.set(key, b);
                          });
                          return Array.from(mergedMap.values());
                        };
                        const combinedMap = new Map();
                        (customerList || []).concat(customerProfiles || []).forEach(c => {
                          if (isProviderEntity(c)) return;
                          const key = normalize(c.customerId || c.id || c.uid || c.clientId);
                          if (!key) return;
                          if (!combinedMap.has(key)) {
                            const resolvedName = c.customerName || c.name || c.username || c.displayName || key;
                            combinedMap.set(key, {
                              ...c,
                              id: c.id || c.customerId || c.uid || c.clientId,
                              customerId: c.customerId || c.id || c.uid || c.clientId,
                              name: resolvedName,
                              customerName: resolvedName,
                              username: resolvedName
                            });
                          }
                        });
                        (workOrders || []).forEach(job => {
                          if (isProviderEntity(job)) return;
                          const rawId = String(job.customerId || "").trim();
                          const key = normalize(rawId);
                          if (!key) return;
                          const bookingCustName = job.customerName || job.clientName || job.name || job.username || "";
                          if (!combinedMap.has(key)) {
                            combinedMap.set(key, {
                              id: rawId,
                              customerId: rawId,
                              name: bookingCustName || rawId,
                              customerName: bookingCustName || rawId,
                              username: bookingCustName,
                              email: job.customerEmail || job.emailAddress || job.email || "",
                              phone: job.customerPhone || job.phoneNumber || job.phone || "",
                              address: job.location || job.address || "",
                              bankAccount: job.customerBankAccount || job.bankAccount || job.customerBank || "",
                              stripeFee: job.stripeFee || job.stripeProcessingFee || job.stripe_fee || job.processingFee || "",
                              customer_total_amount: job.customer_total_amount !== undefined ? job.customer_total_amount : (job.totalCharge || job.amount || 0),
                              ugRevenue: job.ugRevenue !== undefined ? job.ugRevenue : (job.platformFee || 0),
                              providerPayout: job.providerPayout !== undefined ? job.providerPayout : (job.provider_payout !== undefined ? job.provider_payout : (job.technicianPayout || 0)),
                              userAgent: job.userAgent || "",
                              deviceName: job.deviceName || job.deviceModel || "",
                              status: job.status || "Active",
                              notes: job.notes,
                              notesBy: job.notesBy || "",
                              dob: job.dob || "",
                              walletBalance: job.walletBalance ?? 0,
                              discountAmount: job.discountAmount ?? job.voucherDiscountAmount ?? 0,
                              voucherCode: job.voucherCode || job.lastVoucherCode || "",
                              _fromBooking: true
                            });
                          } else {
                            const existing = combinedMap.get(key);
                            if ((!existing.customerName || existing.customerName === existing.customerId) && bookingCustName) {
                              existing.customerName = bookingCustName;
                              existing.name = bookingCustName;
                            }
                            if (!existing.bankAccount && (job.customerBankAccount || job.bankAccount || job.customerBank)) {
                              existing.bankAccount = job.customerBankAccount || job.bankAccount || job.customerBank;
                            }
                          }
                        });
                        let finalCustomerList = Array.from(combinedMap.values());
                        const searchTerm = normalize(customerSearchQuery);
                        if (searchTerm) {
                          finalCustomerList = finalCustomerList.filter((customer) => {
                            const idVal = normalize(customer.customerId || customer.id || customer.uid);
                            const nameVal = normalize(customer.customerName || customer.name || customer.username);
                            return idVal.includes(searchTerm) || nameVal.includes(searchTerm);
                          });
                        }
                        const filters = customerColumnFilters || {};
                        const hasActiveFilters = Object.values(filters).some(v => String(v || "").trim() !== "");
                        if (hasActiveFilters) {
                          finalCustomerList = finalCustomerList.filter((customer) => {
                            const targetId = normalize(customer.customerId || customer.id || customer.uid);
                            const relatedBookings = (workOrders || []).filter((job) => !isProviderEntity(job) && normalize(job.customerId) === targetId);
                            const bookingCount = (subBookingCounts[targetId] !== undefined) ? subBookingCounts[targetId] : relatedBookings.length;
                            const idFromBookingRecords = relatedBookings[0]?.customerId ?? customer.customerId ?? customer.id ?? "-";
                            const customerWalletBalance = (customer.walletStatus === "Used" || customer.status === "Used") ? 0 : (customer.walletBalance ?? computeUsableWalletBalance(effectiveWalletLedger, targetId));
                            const parser = new UAParser(customer.userAgent || navigator.userAgent);
                            const result = parser.getResult();
                            const deviceType = result.device.type || "Desktop";
                            const browser = `${result.browser.name || "Unknown"} ${result.browser.version || ""}`;
                            const statusVal = customer.status || "Active";
                            const custName = customer.customerName || customer.name || customer.username || "";
                            if (filters.customerId && !normalize(idFromBookingRecords).includes(normalize(filters.customerId))) return false;
                            if (filters.name && !normalize(custName).includes(normalize(filters.name))) return false;
                            if (filters.status && !normalize(statusVal).includes(normalize(filters.status))) return false;
                            if (filters.walletBalance && !String(Number(customerWalletBalance || 0).toFixed(2)).includes(String(filters.walletBalance).trim())) return false;
                            if (filters.bookingCount && !String(bookingCount).includes(String(filters.bookingCount).trim())) return false;
                            if (filters.device && !normalize(`${deviceType} ${browser}`).includes(normalize(filters.device))) return false;
                            return true;
                          });
                        }
                        const visibleCustomerList = customerListPageSize === "all"
                          ? finalCustomerList
                          : finalCustomerList.slice(0, Number(customerListPageSize) || 25);
                        if (visibleCustomerList.length === 0) {
                          return (
                            <tr>
                              <td colSpan={8} style={{ padding: "60px 20px", textAlign: "center", fontWeight: "600", color: "#6B7280" }}>
                                No matching customer records found.
                              </td>
                            </tr>
                          );
                        }
                        return visibleCustomerList.map((customer, index) => {
                          const parser = new UAParser(customer.userAgent || navigator.userAgent);
                          const result = parser.getResult();
                          const deviceType = result.device.type || "Desktop";
                          const browser = `${result.browser.name || "Unknown"} ${result.browser.version || ""}`;
                          const targetId = normalize(customer.customerId || customer.id || customer.uid);
                          const relatedBookings = (workOrders || []).filter((job) => !isProviderEntity(job) && normalize(job.customerId) === targetId);
                          const bookingCount = (subBookingCounts[targetId] !== undefined) ? subBookingCounts[targetId] : relatedBookings.length;
                          const idFromBookingRecords = relatedBookings[0]?.customerId ?? customer.customerId ?? customer.id ?? "-";
                          const customerBooking = (customerProfiles || []).find((c) => !isProviderEntity(c) && (normalize(c.clientId) === targetId || normalize(c.customerId) === targetId || normalize(c.uid) === targetId));
                          const customerWalletBalance = (customer.walletStatus === "Used" || customer.status === "Used" || customerBooking?.walletStatus === "Used") ? 0 : (customer.walletBalance ?? customerBooking?.walletBalance ?? computeUsableWalletBalance(effectiveWalletLedger, targetId));
                          const rowKey = customer.id || customer.customerId || customer.uid || `cust-${index}`;
                          const isRowEditing = Boolean(
                            activeEditRowId &&
                            (String(activeEditRowId).toLowerCase() === String(customer.id || "").toLowerCase() ||
                             String(activeEditRowId).toLowerCase() === String(customer.customerId || "").toLowerCase() ||
                             String(activeEditRowId).toLowerCase() === String(customer.uid || "").toLowerCase() ||
                             String(activeEditRowId).toLowerCase() === String(rowKey).toLowerCase())
                          );
                          const statusVal = isRowEditing ? (activeEditDraft.status ?? customer.status ?? "Active") : (customer.status || "Active");
                          const statusColors = statusVal === "Active" ? { bg: "#DCFCE7", color: "#166534" } : statusVal === "Used" ? { bg: "#E5E7EB", color: "#374151" } : { bg: "#FEF3C7", color: "#92400E" };
                          const displayName = customer.customerName || customer.name || customer.username || "-";
                          return (
                            <tr key={rowKey} style={{ background: isRowEditing ? "#FFFBEB" : (index % 2 === 0 ? "#ffffff" : "#F9FAFB"), borderBottom: isRowEditing ? "2px solid #F59E0B" : "1px solid #E5E7EB", transition: "background 0.2s" }}>
                              <td style={tableDataStyle}><span>{index + 1}</span></td>
                              {/* Customer User ID */}
                              <td style={{ ...tableDataStyle, background: isRowEditing ? "#FEF3C7" : "#EEF2FF", fontWeight: "700", color: "#0747A6" }}>
                                {isRowEditing ? (
                                  <div>
                                    <input
                                      value={activeEditDraft.customerId || idFromBookingRecords}
                                      disabled
                                      title="User ID cannot be changed"
                                      style={{ width: "100%", padding: "5px 8px", fontSize: "12px", fontWeight: "700", color: "#0747A6", background: "#EEF2FF", border: "1px solid #CBD5E1", borderRadius: "6px" }}
                                    />
                                    {customer._fromBooking && <span style={{ display: "inline-block", marginTop: 4, fontSize: 10, background: "#DBEAFE", padding: "2px 6px", borderRadius: 10 }}>Booking</span>}
                                  </div>
                                ) : (
                                  <>
                                    {idFromBookingRecords}{customer._fromBooking && <span style={{ marginLeft: 6, fontSize: 10, background: "#DBEAFE", padding: "2px 6px", borderRadius: 10 }}>Booking</span>}
                                  </>
                                )}
                              </td>
                              {/* Customer Name */}
                              <td style={tableDataStyle}>
                                {isRowEditing ? (
                                  <input
                                    value={activeEditDraft.name !== undefined ? activeEditDraft.name : displayName}
                                    onChange={(e) => updateEditDraftField("name", e.target.value)}
                                    placeholder="Enter full name"
                                    style={{ width: "100%", minWidth: "120px", padding: "6px 8px", fontSize: "12px", border: "2px solid #F59E0B", borderRadius: "6px", outline: "none", background: "#fff" }}
                                  />
                                ) : (
                                  <strong>{displayName}</strong>
                                )}
                              </td>
                              {/* Status */}
                              <td style={tableDataStyle}>
                                {isRowEditing ? (
                                  <select
                                    value={activeEditDraft.status !== undefined ? activeEditDraft.status : (customer.status || "Active")}
                                    onChange={(e) => updateEditDraftField("status", e.target.value)}
                                    style={{ padding: "6px 8px", fontSize: "12px", fontWeight: "700", border: "2px solid #F59E0B", borderRadius: "6px", outline: "none", background: "#fff" }}
                                  >
                                    <option value="Active">Active</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Suspended">Suspended</option>
                                    <option value="Inactive">Inactive</option>
                                    <option value="Used">Used</option>
                                  </select>
                                ) : (
                                  <span style={{ background: statusColors.bg, color: statusColors.color, padding: "3px 10px", borderRadius: "10px", fontSize: "11px", fontWeight: "700" }}>{statusVal}</span>
                                )}
                              </td>
                              {/* Wallet Balance */}
                              <td style={{ ...tableDataStyle, background: isRowEditing ? "#FEF3C7" : "#ECFDF5", fontWeight: "700", color: "#065F46" }}>
                                {isRowEditing ? (
                                  <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                    <span>£</span>
                                    <input
                                      type="number"
                                      step="0.01"
                                      value={activeEditDraft.walletBalance !== undefined ? activeEditDraft.walletBalance : Number(customerWalletBalance || 0)}
                                      onChange={(e) => updateEditDraftField("walletBalance", e.target.value)}
                                      style={{ width: "95px", padding: "6px 8px", fontSize: "12px", fontWeight: "700", border: "2px solid #10B981", borderRadius: "6px", outline: "none", background: "#fff" }}
                                    />
                                  </div>
                                ) : (
                                  `£${Number(customerWalletBalance || 0).toFixed(2)}`
                                )}
                              </td>
                              {/* Total Bookings */}
                              <td style={tableDataStyle}>
                                <span style={{ background: "#E0F2FE", color: "#0747A6", padding: "4px 10px", borderRadius: 20, fontWeight: 600 }}>{bookingCount}</span>
                              </td>
                              {/* Device / Browser */}
                              <td style={tableDataStyle}>{deviceType} · {browser}</td>
                              {/* Actions */}
                              <td style={{ ...tableDataStyle, textAlign: "center" }}>
                                {isRowEditing ? (
                                  <div style={{ display: "flex", gap: "6px", justifyContent: "center", alignItems: "center" }}>
                                    <button
                                      onClick={() => saveEditingRow(customer)}
                                      style={{ backgroundColor: "#10B981", color: "#fff", padding: "6px 12px", borderRadius: "6px", border: "none", cursor: "pointer", fontSize: "12px", fontWeight: "700", display: "flex", alignItems: "center", gap: "4px" }}
                                    >
                                      💾 Save
                                    </button>
                                    <button
                                      onClick={cancelEditingRow}
                                      style={{ backgroundColor: "#6B7280", color: "#fff", padding: "6px 12px", borderRadius: "6px", border: "none", cursor: "pointer", fontSize: "12px", fontWeight: "600" }}
                                    >
                                      ✖ Cancel
                                    </button>
                                  </div>
                                ) : (
                                  <div style={{ display: "flex", gap: "4px", justifyContent: "center", flexWrap: "wrap" }}>
                                    <button
                                      onClick={() => requestCustomerAccess(customer, "profile_view", () => setSelectedCustomerProfile(customer))}
                                      style={{ backgroundColor: "#2563EB", color: "#fff", padding: "6px 10px", borderRadius: "6px", border: "none", cursor: "pointer", fontSize: "12px", fontWeight: "600" }}
                                    >🔒 👤 View</button>
                                    <button
                                      onClick={() => {
                                        if (typeof handleInitiateEdit === "function") {
                                          try { handleInitiateEdit(customer); } catch(e) {}
                                        }
                                        startEditingRow(customer);
                                      }}
                                      style={{ backgroundColor: "#F59E0B", color: "#fff", padding: "6px 10px", borderRadius: "6px", border: "none", cursor: "pointer", fontSize: "12px", fontWeight: "600" }}
                                    >✏ Edit</button>
                                    <button onClick={() => handlePurgeClient(customer)} style={{ backgroundColor: "#EF4444", color: "#fff", padding: "6px 10px", borderRadius: "6px", border: "none", cursor: "pointer", fontSize: "12px", fontWeight: "600" }}>🗑</button>
                                    <button
                                      onClick={() => requestCustomerAccess(customer, "transactions", () => {
                                        const merged = getMergedBookingsForCustomer(targetId, relatedBookings);
                                        setSelectedTransactionCustomer(customer);
                                        setSelectedTransactionBookings(merged);
                                        setExpandedTxnRow(null);
                                      })}
                                      style={{ backgroundColor: "#7C3AED", color: "#fff", padding: "6px 10px", borderRadius: "6px", border: "none", cursor: "pointer", fontSize: "12px", fontWeight: "600" }}
                                    >🔒 📅 Bookings ({bookingCount})</button>
                                    <button
                                      onClick={() => requestCustomerAccess(customer, "promotions", async () => {
                                        openPromotionsForCustomer(customer);
                                        const targetIdVal = getExistingUserDocId(customer);
                                        if (targetIdVal && typeof db !== "undefined" && typeof collection !== "undefined" && typeof getDocs !== "undefined") {
                                          try {
                                            const subSnap = await getDocs(collection(db, "users", targetIdVal, "campaigns"));
                                            const subCampaigns = subSnap.docs.map(d => ({ id: d.id, ...d.data() }));
                                            if (typeof setCampaigns === "function") setCampaigns(subCampaigns);
                                          } catch (err) { console.error("Error fetching customer campaigns:", err); }
                                        }
                                      })}
                                      style={{ backgroundColor: "#EC4899", color: "#fff", border: "none", padding: "6px 10px", borderRadius: "6px", cursor: "pointer", fontSize: "12px", fontWeight: "600" }}
                                    >🔒 🎁 Promotions</button>
                                    <button
                                      onClick={() => requestCustomerAccess(customer, "wallet", async () => {
                                        openWalletDrawerForCustomer(customer, targetId);
                                        const targetIdVal = getExistingUserDocId(customer);
                                        if (targetIdVal && typeof db !== "undefined" && typeof collection !== "undefined" && typeof getDocs !== "undefined") {
                                          try {
                                            const vSnap = await getDocs(collection(db, "users", String(targetIdVal), "vouchers"));
                                            const fetchedVouchers = vSnap.docs.map(d => ({ id: d.id, ...d.data() }));
                                            if (fetchedVouchers.length > 0 && typeof setVoucherRegistry === "function") {
                                              setVoucherRegistry(prev => {
                                                const map = new Map();
                                                (prev || []).forEach(x => map.set(x.id || `${x.customerId}_${x.voucherCode}`, x));
                                                fetchedVouchers.forEach(x => {
                                                  const k = x.id || `${x.customerId}_${x.voucherCode}`;
                                                  const existing = map.get(k);
                                                  if (existing && existing.voucherStatus === "Used") {
                                                    map.set(k, { ...x, voucherStatus: "Used", discountAmount: 0, voucherDiscountAmount: 0 });
                                                  } else { map.set(k, x); }
                                                });
                                                const merged = Array.from(map.values());
                                                try { localStorage.setItem("voucherRegistry", JSON.stringify(merged)); } catch(e) {}
                                                return merged;
                                              });
                                            }
                                          } catch (err) {}
                                        }
                                      })}
                                      style={{ backgroundColor: "#059669", color: "#fff", border: "none", padding: "6px 10px", borderRadius: "6px", cursor: "pointer", fontSize: "12px", fontWeight: "600" }}
                                    >🔒 💰 Wallet</button>
                                    <button
                                      onClick={() => openCustomerLogsModal(customer)}
                                      style={{ backgroundColor: "#111827", color: "#fff", border: "none", padding: "6px 10px", borderRadius: "6px", cursor: "pointer", fontSize: "12px", fontWeight: "600" }}
                                    >📜 Logs</button>
                                  </div>
                                )}
                              </td>
                            </tr>
                          );
                        });
                      })()}
                    </tbody>
                  </table>
                  );
                })()}
              </div>
            )}
              </>
            )}
            {/* ========== PAGINATION INFO ========== */}
            {customerListExpanded && isCustomerListUnlocked && (() => {
              const normalize = (v) => String(v ?? "").trim().toLowerCase();
              const combinedMap = new Map();
              (customerList || []).concat(customerProfiles || []).forEach(c => {
                if (isProviderEntity(c)) return;
                const key = normalize(c.customerId || c.id || c.uid || c.clientId);
                if (key) combinedMap.set(key, c);
              });
              (workOrders || []).forEach(job => {
                if (isProviderEntity(job)) return;
                const rawId = String(job.customerId || "").trim();
                const key = normalize(rawId);
                if (key && !combinedMap.has(key)) combinedMap.set(key, { id: rawId, customerId: rawId });
              });
              const totalCount = combinedMap.size;
              const currentLimit = customerListPageSize === "all" ? totalCount : Number(customerListPageSize) || 25;
              const shownCount = Math.min(currentLimit, totalCount);
              return totalCount > 0 ? (
                <div style={{ textAlign: "center", marginBottom: "24px", fontSize: "12px", color: "#6B7280", fontWeight: "600" }}>
                  📊 Showing {shownCount} of {totalCount} verified customers (Size: {customerListPageSize === "all" ? "All" : customerListPageSize})
                </div>
              ) : null;
            })()}
          </>
        )}
      </div>
      {/* ========================================================================= */}
      {/* 🔑 ONE-TIME CODE UNLOCK MODAL (CUSTOMER LIST)                             */}
      {/* ========================================================================= */}
      {showCustomerListUnlockModal && (
        <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(17, 24, 39, 0.7)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 12000 }}>
          <div style={{ backgroundColor: "#ffffff", borderRadius: "16px", padding: "28px", width: "380px", maxWidth: "92vw", boxShadow: "0 25px 50px rgba(0,0,0,0.25)", textAlign: "center", fontFamily: "'Inter', sans-serif" }}>
            <div style={{ width: "56px", height: "56px", borderRadius: "50%", background: "#EFF6FF", color: "#1D4ED8", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "26px", margin: "0 auto 12px" }}>
              🔑
            </div>
            <h4 style={{ margin: "0 0 6px", fontSize: "18px", fontWeight: "800", color: "#111827" }}>
              Unlock Customer List
            </h4>
            <p style={{ margin: "0 0 10px", fontSize: "13px", color: "#6B7280" }}>
              A single-use 6-digit verification code has been issued to reveal customer records and enable table filters. This code can only be used once.
            </p>
            {window.__custListOtp?.code && (
              <p style={{ margin: "0 0 12px", fontSize: "11px", color: "#9CA3AF", background: "#F9FAFB", border: "1px dashed #E5E7EB", borderRadius: "8px", padding: "6px 8px" }}>
                Demo mode — in production this would be delivered by SMS/email. Your code: <strong style={{ color: "#111827", letterSpacing: "2px" }}>{window.__custListOtp.code}</strong>
              </p>
            )}
            <input
              type="password"
              inputMode="numeric"
              maxLength={6}
              autoFocus
              value={custListOtpInputValue}
              onChange={(e) => {
                window.__custListOtpInput = e.target.value.replace(/\D/g, "");
                window.__custListOtpError = "";
                triggerCustomerListRender();
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") verifyCustomerListAccessCode();
              }}
              placeholder="••••••"
              style={{
                width: "160px",
                textAlign: "center",
                letterSpacing: "6px",
                fontSize: "24px",
                fontWeight: "700",
                border: "2px solid #CBD5E1",
                borderRadius: "10px",
                padding: "8px 12px",
                marginBottom: "8px",
                outline: "none"
              }}
            />
            {custListOtpErrorValue && (
              <p style={{ margin: "0 0 10px", fontSize: "12px", color: "#DC2626", fontWeight: "600" }}>
                {custListOtpErrorValue}
              </p>
            )}
            <div style={{ marginBottom: "4px" }}>
              <button
                type="button"
                onClick={resendCustomerListAccessCode}
                style={{ background: "transparent", border: "none", color: "#2563EB", fontSize: "12px", fontWeight: "600", cursor: "pointer", textDecoration: "underline" }}
              >
                🔄 Resend Code
              </button>
            </div>
            <div style={{ display: "flex", gap: "10px", justifyContent: "center", marginTop: "8px" }}>
              <button
                onClick={closeCustomerListUnlockModal}
                style={{ backgroundColor: "#F3F4F6", color: "#374151", padding: "9px 18px", borderRadius: "8px", border: "none", cursor: "pointer", fontSize: "13px", fontWeight: "600" }}
              >
                Cancel
              </button>
              <button
                onClick={verifyCustomerListAccessCode}
                style={{ backgroundColor: "#059669", color: "#fff", padding: "9px 20px", borderRadius: "8px", border: "none", cursor: "pointer", fontSize: "13px", fontWeight: "700" }}
              >
                Verify &amp; Unlock
              </button>
            </div>
          </div>
        </div>
      )}
      {/* ========================================================================= */}
      {/* 📜 CUSTOMER LOGS MODAL (per-customer — opened by the "Logs" button)       */}
      {/* Shows audit-log entries, activity-log entries, credit lifecycle events    */}
      {/* (allocated / redeemed / expired) and refunds for ONE customer.            */}
      {/* ========================================================================= */}
      {customerLogsTarget && (() => {
        const normalizeLog = (v) => String(v ?? "").trim().toLowerCase();
        const idSet = new Set(
          [
            customerLogsTarget.customerId,
            customerLogsTarget.id,
            customerLogsTarget.uid,
            customerLogsTarget.clientId,
            getExistingUserDocId(customerLogsTarget)
          ].map(normalizeLog).filter(Boolean)
        );
        const matchesCustomer = (cid) => idSet.has(normalizeLog(cid));
        const toTime = (d) => { const t = new Date(d).getTime(); return isNaN(t) ? 0 : t; };
        const logCustomerName = customerLogsTarget.customerName || customerLogsTarget.name || customerLogsTarget.username || customerLogsTarget.customerId || customerLogsTarget.id || "Customer";
        const logCustomerId = customerLogsTarget.customerId || customerLogsTarget.id || customerLogsTarget.uid || "-";
        const events = [];
        // 1) Audit log entries
        (customerAuditLog || []).filter(a => matchesCustomer(a.customerId)).forEach(a => {
          events.push({ kind: "audit", when: a.timestamp, title: a.action, staff: a.staffHandle, reason: a.reason, notes: a.justificationNotes });
        });
        // 2) Activity log entries (notes, top-ups, refunds, booking actions)
        (activityTrail || []).filter(a => matchesCustomer(a.customerId)).forEach(a => {
          events.push({ kind: "activity", when: a.occurredAt, title: a.summary, staff: a.staffHandle, reason: a.activityCategory });
        });
        // 3) Credit lifecycle events from the wallet ledger — Allocated / Redeemed / Expired
        (effectiveWalletLedger || [])
          .filter(e => matchesCustomer(e.customerId) && (e.entryType === "issue" || !e.entryType))
          .forEach(e => {
            const st = computeCreditEntryState(e, false);
            const amt = Number(e.originalAmount != null ? e.originalAmount : (e.usedAmount || e.amount || 0));
            events.push({
              kind: "allocated", when: st.appliedDate,
              title: `Credit Allocated: £${amt.toFixed(2)}${e.reasonCode ? ` — ${e.reasonCode}` : ""} (expires ${new Date(st.expiryDate).toLocaleDateString()})`,
              staff: e.staffHandle, reason: e.bookingId ? `Linked booking: ${e.bookingId}` : "", notes: e.justificationNotes
            });
            if (st.effectiveStatus === "Used") {
              events.push({
                kind: "redeemed", when: e.usedAt || st.appliedDate,
                title: `Credit Redeemed: £${amt.toFixed(2)}`,
                staff: "System Auto-Redeem", reason: e.redeemedBookingId ? `Booking: ${e.redeemedBookingId}` : ""
              });
            } else if (st.effectiveStatus === "Expired") {
              events.push({
                kind: "expired", when: st.expiryDate,
                title: `Credit Expired: £${amt.toFixed(2)} (90-day validity elapsed)`,
                staff: "System Auto-Expire", reason: e.bookingId ? `Linked booking: ${e.bookingId}` : ""
              });
            }
          });
        // 4) Refund / reversal entries
        (reversalLedger || []).filter(r => matchesCustomer(r.customerId)).forEach(r => {
          events.push({
            kind: "refund", when: r.reversalDate,
            title: `Refund recorded: £${Number(r.refundAmount || 0).toFixed(2)}${r.bookingId ? ` (Booking ${r.bookingId})` : ""}`,
            staff: r.approvedByAdmin, reason: r.refundReason
          });
        });
        events.sort((a, b) => toTime(b.when) - toTime(a.when));
        const kindStyles = {
          audit:     { bg: "#F9FAFB", border: "#E5E7EB", label: "🔐 Audit" },
          activity:  { bg: "#EFF6FF", border: "#BFDBFE", label: "🗂 Activity" },
          allocated: { bg: "#ECFDF5", border: "#A7F3D0", label: "➕ Credit Allocated" },
          redeemed:  { bg: "#F5F3FF", border: "#DDD6FE", label: "⬇ Credit Redeemed" },
          expired:   { bg: "#FEF2F2", border: "#FECACA", label: "⏳ Credit Expired" },
          refund:    { bg: "#FFFBEB", border: "#FDE68A", label: "↩ Refund" }
        };
        return (
          <div className="modal-overlay" style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 12200, padding: "20px" }}>
            <div className="modal-dialog" style={{ width: "100%", maxWidth: "820px", maxHeight: "90vh", overflowY: "auto" }}>
              <div className="modal-content" style={{ background: "#fff", borderRadius: "16px", overflow: "hidden", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
                <div className="modal-header" style={{ background: "#111827", color: "#fff", padding: "18px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <h5 className="modal-title" style={{ margin: 0, fontSize: "17px", fontWeight: "700" }}>
                    📜 Customer Logs — {logCustomerName} ({logCustomerId})
                  </h5>
                  <button type="button" onClick={closeCustomerLogsModal} style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", fontSize: "22px", width: "32px", height: "32px", borderRadius: "50%", cursor: "pointer" }}>&times;</button>
                </div>
                <div style={{ padding: "10px 24px", background: "#F3F4F6", borderBottom: "1px solid #E5E7EB", fontSize: "12px", color: "#374151", fontWeight: "600" }}>
                  Total log entries: {events.length}
                </div>
                <div className="modal-body" style={{ padding: "20px", maxHeight: "65vh", overflowY: "auto" }}>
                  {events.length === 0 ? (
                    <p style={{ color: "#9CA3AF", fontSize: "13px", textAlign: "center", padding: "30px 0" }}>No logs recorded for this customer yet.</p>
                  ) : (
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                      {events.map((ev, evIdx) => {
                        const ks = kindStyles[ev.kind] || kindStyles.audit;
                        return (
                          <div key={`${ev.kind}-${evIdx}`} style={{ background: ks.bg, border: `1px solid ${ks.border}`, borderRadius: "8px", padding: "10px 14px" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "6px" }}>
                              <span style={{ fontSize: "11px", fontWeight: 700, color: "#374151" }}>{ks.label}{ev.staff ? ` · 👤 ${ev.staff}` : ""}</span>
                              <span style={{ fontSize: "11px", color: "#6B7280" }}>{ev.when ? new Date(ev.when).toLocaleString() : "-"}</span>
                            </div>
                            <p style={{ margin: "4px 0 0", fontSize: "13px", color: "#111827", whiteSpace: "pre-wrap" }}>{ev.title}</p>
                            {ev.reason && <p style={{ margin: "2px 0 0", fontSize: "12px", color: "#6B7280" }}>Reason: {ev.reason}</p>}
                            {ev.notes && (
                              <div style={{ margin: "4px 0 0", fontSize: "12px", color: "#065F46", background: "#ECFDF5", padding: "4px 8px", borderRadius: "4px", border: "1px solid #A7F3D0" }}>
                                📝 <strong>Justification Notes:</strong> {ev.notes}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
                <div className="modal-footer" style={{ padding: "14px 24px", background: "#F9FAFB", borderTop: "1px solid #E5E7EB", textAlign: "right" }}>
                  <button onClick={closeCustomerLogsModal} style={{ background: "#fff", border: "1px solid #D1D5DB", padding: "8px 16px", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}>Close</button>
                </div>
              </div>
            </div>
          </div>
        );
      })()}
      {/* ✅ DETAILED CUSTOMER PROFILE MODAL */}
      {selectedCustomerProfile && (
        <div className="modal-overlay" style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: "20px" }}>
          <div className="modal-dialog" style={{ width: "100%", maxWidth: "650px", maxHeight: "90vh", overflowY: "auto" }}>
            <div className="modal-content" style={{ background: "#fff", borderRadius: "16px", overflow: "hidden", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
              <div className="modal-header" style={{ background: "#0747A6", color: "#fff", padding: "20px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h5 className="modal-title" style={{ margin: 0, fontSize: "18px", fontWeight: "700" }}>👤 Customer Detailed Profile</h5>
                <button type="button" className="close" onClick={() => setSelectedCustomerProfile(null)} style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", fontSize: "22px", width: "32px", height: "32px", borderRadius: "50%", cursor: "pointer" }}>&times;</button>
              </div>
              <div className="modal-body" style={{ padding: 0 }}>
                <div id="customerPrintContent">
                  {(() => {
                    const normalize = (v) => String(v ?? "").trim().toLowerCase();
                    const getNoteText = (notesValue) => {
                      if (notesValue == null) return "";
                      if (typeof notesValue === "string") return notesValue;
                      if (Array.isArray(notesValue)) {
                        if (notesValue.length === 0) return "";
                        return getNoteText(notesValue[notesValue.length - 1]);
                      }
                      if (typeof notesValue === "object") return notesValue.text ?? notesValue.note ?? "";
                      return String(notesValue);
                    };
                    const targetId = normalize(selectedCustomerProfile.customerId || selectedCustomerProfile.id || selectedCustomerProfile.uid);
                    const relatedBookings = (workOrders || []).filter((j) => !isProviderEntity(j) && normalize(j.customerId) === targetId);
                    const bookingData = relatedBookings[0] || {};
                    const directoryData = (customerProfiles || []).find((c) => !isProviderEntity(c) && (normalize(c.clientId) === targetId || normalize(c.customerId) === targetId || normalize(c.uid) === targetId)) || {};
                    const finalCustomerId = bookingData.customerId || selectedCustomerProfile.customerId || selectedCustomerProfile.id || selectedCustomerProfile.uid || "-";
                    const finalName = selectedCustomerProfile.customerName || selectedCustomerProfile.name || selectedCustomerProfile.username || bookingData.customerName || directoryData.displayName || directoryData.username || "-";
                    const finalPhone = selectedCustomerProfile.phone || bookingData.customerPhone || bookingData.phone || "-";
                    const finalEmail = selectedCustomerProfile.email || bookingData.customerEmail || directoryData.emailAddress || "-";
                    const finalAddress = selectedCustomerProfile.address || bookingData.location || directoryData.location || "-";
                    const finalDob = selectedCustomerProfile.dob || bookingData.dob || directoryData.dob || "";
                    const totalBookings = (subBookingCounts[targetId] !== undefined) ? subBookingCounts[targetId] : relatedBookings.length;
                    const noteText = getNoteText(selectedCustomerProfile.notes);
                    return (
                      <>
                        <div style={{ background: "linear-gradient(135deg, #EEF2FF 0%, #DBEAFE 100%)", padding: "24px", textAlign: "center", borderBottom: "1px solid #E5E7EB" }}>
                          <div style={{ width: "72px", height: "72px", borderRadius: "50%", background: "#0747A6", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "32px", fontWeight: "800", margin: "0 auto 12px" }}>{String(finalName).charAt(0).toUpperCase()}</div>
                          <h3 style={{ margin: "0 0 4px", fontSize: "20px", fontWeight: "800", color: "#111827" }}>{finalName}</h3>
                          <p style={{ margin: 0, color: "#6B7280", fontSize: "13px" }}>Customer User ID: <strong style={{ color: "#0747A6" }}>{finalCustomerId}</strong></p>
                        </div>
                        <div style={{ padding: "20px 24px" }}>
                          <div style={{ background: "#ECFDF5", border: "1px solid #A7F3D0", color: "#065F46", padding: "8px 12px", borderRadius: "8px", fontSize: "11px", marginBottom: "16px", fontWeight: "700" }}>
                            🔓 PII unlocked for this session — access has been recorded in the Audit Log (reason: {customerShieldAccessReason || "Not specified"}).
                          </div>
                          <div className="order-section" style={{ marginBottom: "20px" }}>
                            <h4 style={{ fontSize: "13px", fontWeight: "700", color: "#0747A6", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "12px", borderBottom: "2px solid #EEF2FF", paddingBottom: "6px" }}>📋 Customer Information</h4>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "14px" }}>
                              <div style={{ background: "#F9FAFB", padding: "12px 14px", borderRadius: "10px", border: "1px solid #F3F4F6" }}>
                                <label style={{ fontSize: "11px", color: "#6B7280", fontWeight: "600", textTransform: "uppercase" }}>Customer User ID</label>
                                <p style={{ margin: "4px 0 0", fontSize: "14px", fontWeight: "700", color: "#111827" }}>{finalCustomerId}</p>
                              </div>
                              <div style={{ background: "#F9FAFB", padding: "12px 14px", borderRadius: "10px", border: "1px solid #F3F4F6" }}>
                                <label style={{ fontSize: "11px", color: "#6B7280", fontWeight: "600", textTransform: "uppercase" }}>Total Bookings</label>
                                <p style={{ margin: "4px 0 0", fontSize: "18px", fontWeight: "800", color: "#0747A6" }}>{totalBookings}</p>
                              </div>
                              <div style={{ background: "#FDF2F8", padding: "12px 14px", borderRadius: "10px", border: "1px solid #FBCFE8" }}>
                                <label style={{ fontSize: "11px", color: "#9D174D", fontWeight: "600", textTransform: "uppercase" }}>🎂 Date of Birth</label>
                                <p style={{ margin: "4px 0 0", fontSize: "14px", fontWeight: "700", color: "#111827" }}>{formatDobDisplay(finalDob)}</p>
                              </div>
                              <div style={{ background: "#F9FAFB", padding: "12px 14px", borderRadius: "10px", border: "1px solid #F3F4F6" }}>
                                <label style={{ fontSize: "11px", color: "#6B7280", fontWeight: "600", textTransform: "uppercase" }}>Address</label>
                                <p style={{ margin: "4px 0 0", fontSize: "13px", fontWeight: "600", color: "#111827" }}>{finalAddress}</p>
                              </div>
                            </div>
                          </div>
                          <div className="order-section" style={{ marginBottom: "20px" }}>
                            <h4 style={{ fontSize: "13px", fontWeight: "700", color: "#0747A6", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "12px", borderBottom: "2px solid #EEF2FF", paddingBottom: "6px" }}>📞 Phone / Contact Details</h4>
                            <div style={{ display: "grid", gap: "10px" }}>
                              <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 14px", background: "#fff", border: "1px solid #E5E7EB", borderRadius: "8px" }}>
                                <span style={{ color: "#6B7280", fontSize: "13px" }}>📱 Phone Number</span>
                                <strong style={{ color: "#111827", fontSize: "13px" }}>{finalPhone}</strong>
                              </div>
                              <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 14px", background: "#fff", border: "1px solid #E5E7EB", borderRadius: "8px" }}>
                                <span style={{ color: "#6B7280", fontSize: "13px" }}>✉ Email</span>
                                <strong style={{ color: "#111827", fontSize: "13px" }}>{finalEmail}</strong>
                              </div>
                            </div>
                          </div>
                          <div className="order-section">
                            <h4 style={{ fontSize: "13px", fontWeight: "700", color: "#0747A6", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "12px", borderBottom: "2px solid #EEF2FF", paddingBottom: "6px" }}>📝 Notes</h4>
                            <div style={{ padding: "10px 14px", background: "#FFFBEB", border: "1px solid #FDE68A", borderRadius: "8px" }}>
                              {selectedCustomerProfile.notesBy && (<span style={{ color: "#6B7280", fontSize: "11px" }}>by {selectedCustomerProfile.notesBy}</span>)}
                              <p style={{ margin: "6px 0 0", fontSize: "13px", whiteSpace: "pre-wrap" }}>{noteText || "No notes yet"}</p>
                            </div>
                            <div style={{ display: "flex", gap: "6px", marginTop: "10px" }}>
                              <input
                                placeholder="Your name"
                                value={noteAuthors[targetId] ?? ""}
                                onChange={(e) => setNoteAuthors(prev => ({...prev, [targetId]: e.target.value}))}
                                style={{ flex: 1, padding: "6px 8px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "12px" }}
                              />
                              <input
                                placeholder="Add note..."
                                value={noteInputs[targetId] ?? ""}
                                onChange={(e) => setNoteInputs(prev => ({...prev, [targetId]: e.target.value}))}
                                style={{ flex: 2, padding: "6px 8px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "12px" }}
                              />
                              <button
                                onClick={() => {
                                  const nText = (noteInputs[targetId] || "").trim();
                                  const nAuthor = (noteAuthors[targetId] || "").trim();
                                  if (!nText) return alert("Please enter a note");
                                  if (!nAuthor) return alert("Please enter who is leaving this note");
                                  const updatedList = (customerList || []).map(c => {
                                    const key = normalize(c.customerId || c.id || c.uid);
                                    if (key === targetId) return {...c, notes: nText, notesBy: nAuthor};
                                    return c;
                                  });
                                  if (typeof setCustomerList === 'function') setCustomerList(updatedList);
                                  setNoteInputs(prev => ({...prev, [targetId]: ""}));
                                  setNoteAuthors(prev => ({...prev, [targetId]: ""}));
                                  logCustomerAuditEntry({ customerId: finalCustomerId, customerName: finalName, action: `Added internal note: "${nText}"`, reason: nAuthor });
                                }}
                                style={{ background: "#F59E0B", color: "#fff", border: "none", padding: "6px 10px", borderRadius: "6px", fontSize: "11px", fontWeight: "700", cursor: "pointer" }}
                              >💾 Save</button>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })()}
                </div>
              </div>
              <div className="modal-footer" style={{ padding: "16px 24px", background: "#F9FAFB", display: "flex", justifyContent: "flex-end", gap: "10px", borderTop: "1px solid #E5E7EB" }}>
                <button className="btn btn-secondary btn-sm" onClick={() => setSelectedCustomerProfile(null)} style={{ background: "#fff", border: "1px solid #D1D5DB", padding: "8px 14px", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* ✅ BOOKINGS HISTORY MODAL (WITH TOP STRIP FOR FEES, BANK, TOTAL, UG REVENUE & PROVIDER PAYOUT IN £) */}
      {selectedTransactionCustomer && (
        <div className="modal-overlay" style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: "20px" }}>
          <div className="modal-dialog" style={{ width: "100%", maxWidth: "1050px", maxHeight: "90vh", overflowY: "auto" }}>
            <div className="modal-content" style={{ background: "#fff", borderRadius: "16px", overflow: "hidden", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
              <div className="modal-header" style={{ background: "#7C3AED", color: "#fff", padding: "18px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h5 className="modal-title" style={{ margin: 0, fontSize: "17px", fontWeight: "700" }}>
                  📅 Booking History (All Amounts in £) - {selectedTransactionCustomer.customerName || selectedTransactionCustomer.name || selectedTransactionCustomer.username || selectedTransactionCustomer.customerId}
                </h5>
                <button
                  type="button"
                  onClick={() => { setSelectedTransactionCustomer(null); setSelectedTransactionBookings([]); setExpandedTxnRow(null); }}
                  style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", fontSize: "22px", width: "32px", height: "32px", borderRadius: "50%", cursor: "pointer" }}
                >&times;</button>
              </div>
              <div style={{ padding: "12px 24px", background: "#F5F3FF", borderBottom: "1px solid #E5E7EB", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
                <span style={{ fontSize: "13px", color: "#5B21B6", fontWeight: "600" }}>
                  Total Bookings: {(() => {
                    const normalize = (v) => String(v ?? "").trim().toLowerCase();
                    const targetId = normalize(selectedTransactionCustomer.customerId || selectedTransactionCustomer.id || selectedTransactionCustomer.uid);
                    return (subBookingCounts[targetId] !== undefined) ? subBookingCounts[targetId] : selectedTransactionBookings.length;
                  })()}
                </span>
                {selectedTransactionBookings.length > 0 && (
                  <div style={{ display: "flex", gap: "8px" }}>
                    <button onClick={() => setExpandedTxnRow("__ALL__")} style={{ background: "#7C3AED", color: "#fff", border: "none", padding: "5px 10px", borderRadius: "6px", fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>⬇ Expand All</button>
                    <button onClick={() => setExpandedTxnRow(null)} style={{ background: "#6B7280", color: "#fff", border: "none", padding: "5px 10px", borderRadius: "6px", fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>⬆ Collapse All</button>
                  </div>
                )}
              </div>
              <div className="modal-body" style={{ padding: "20px", maxHeight: "65vh", overflowY: "auto" }}>
                {selectedTransactionBookings.length === 0 ? (
                  <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "14px", color: "#6B7280", textAlign: "center", padding: "40px 0" }}>No booking transaction history found.</p>
                ) : (
                  <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                    {selectedTransactionBookings.map((job, index) => {
                      const rowKey = job.docId || job.id || index;
                      const isOpen = expandedTxnRow === "__ALL__" || expandedTxnRow === rowKey;
                      const custIdForKey = getExistingUserDocId(selectedTransactionCustomer);
                      const piiKey = `${custIdForKey}_${rowKey}`;
                      const piiUnlocked = Boolean(unlockedCustomerPII?.[piiKey]);
                      const maskedValue = (val) => (piiUnlocked ? (val ?? "—") : "•••• Protected");
                      const bookingId = job.bookingId || job.docId || job.id || "-";
                      const bookingAmount = Number(job.totalCharge ?? job.amount ?? job.total ?? job.price ?? job.cost ?? 0);
                      const customerTotalAmount = Number(job.customer_total_amount !== undefined ? job.customer_total_amount : bookingAmount);
                      const stripeProcessingFee = job.stripeProcessingFee !== undefined ? job.stripeProcessingFee : (job.stripeFee !== undefined ? job.stripeFee : (job.stripe_fee !== undefined ? job.stripe_fee : (job.processingFee !== undefined ? job.processingFee : null)));
                      const ugRevenue = Number(job.ugRevenue !== undefined ? job.ugRevenue : (job.platformFee !== undefined ? job.platformFee : (bookingAmount * 0.2)));
                      const providerPayoutVal = Number(job.providerPayout !== undefined ? job.providerPayout : (job.provider_payout !== undefined ? job.provider_payout : (job.technicianPayout !== undefined ? job.technicianPayout : (customerTotalAmount - ugRevenue))));
                      const registeredBankAccount = job.customerBankAccount || job.bankAccount || job.customerBank || job.bankDetails || selectedTransactionCustomer.bankAccount || selectedTransactionCustomer.customerBankAccount || "Not provided";
                      return (
                        <div key={rowKey} style={{ border: "1px solid #E5E7EB", borderRadius: "12px", overflow: "hidden", background: "#fff", boxShadow: "0 2px 8px rgba(0,0,0,0.04)" }}>
                          {/* TOP HIGHLIGHT BAR: STRIPE FEE, PROVIDER PAYOUT, BANK ACCOUNT, CUSTOMER TOTAL & UG REVENUE */}
                          <div style={{ background: "linear-gradient(135deg, #1E1B4B, #312E81)", color: "#fff", padding: "12px 16px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))", gap: "10px", alignItems: "center" }}>
                            <div>
                              <span style={{ fontSize: "10px", color: "#C7D2FE", textTransform: "uppercase", fontWeight: 700, display: "block" }}>💳 Stripe Processing Fee</span>
                              <span style={{ fontSize: "14px", fontWeight: 800, color: "#A7F3D0" }}>
                                {stripeProcessingFee != null && !isNaN(Number(stripeProcessingFee)) ? `£${Number(stripeProcessingFee).toFixed(2)}` : (stripeProcessingFee || "£0.00")}
                              </span>
                            </div>
                            <div>
                              <span style={{ fontSize: "10px", color: "#C7D2FE", textTransform: "uppercase", fontWeight: 700, display: "block" }}>👷 Provider Payout</span>
                              <span style={{ fontSize: "14px", fontWeight: 800, color: "#1E3A8A", background: "#DBEAFE", padding: "2px 8px", borderRadius: "6px", display: "inline-block" }}>
                                £{providerPayoutVal.toFixed(2)}
                              </span>
                            </div>
                            <div>
                              <span style={{ fontSize: "10px", color: "#C7D2FE", textTransform: "uppercase", fontWeight: 700, display: "block" }}>🏦 Customer Bank Account</span>
                              <span style={{ fontSize: "12px", fontWeight: 700, color: "#FDE68A" }}>
                                {piiUnlocked ? registeredBankAccount : (registeredBankAccount !== "Not provided" ? `•••• ${String(registeredBankAccount).slice(-4)} (Protected)` : "Not provided")}
                              </span>
                            </div>
                            <div>
                              <span style={{ fontSize: "10px", color: "#C7D2FE", textTransform: "uppercase", fontWeight: 700, display: "block" }}>💰 Customer Total Amount</span>
                              <span style={{ fontSize: "15px", fontWeight: 800, color: "#67E8F9" }}>
                                £{customerTotalAmount.toFixed(2)}
                              </span>
                            </div>
                            <div>
                              <span style={{ fontSize: "10px", color: "#C7D2FE", textTransform: "uppercase", fontWeight: 700, display: "block" }}>📈 UG Revenue</span>
                              <span style={{ fontSize: "15px", fontWeight: 800, color: "#065F46", background: "#D1FAE5", padding: "2px 8px", borderRadius: "6px", display: "inline-block" }}>
                                £{ugRevenue.toFixed(2)}
                              </span>
                            </div>
                          </div>
                          {/* STANDARD BOOKING GRID */}
                          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: "10px", background: "#F5F3FF", padding: "14px 16px", borderBottom: "1px solid #E5E7EB" }}>
                            <div>
                              <span style={{ fontSize: "10px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>Booking ID</span>
                              <div style={{ fontSize: "13px", fontWeight: 700, color: "#4338CA", wordBreak: "break-all" }}>{bookingId}</div>
                            </div>
                            <div>
                              <span style={{ fontSize: "10px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>Booking Amount</span>
                              <div style={{ fontSize: "15px", fontWeight: 800, color: "#047857" }}>£{bookingAmount.toFixed(2)}</div>
                            </div>
                            <div>
                              <span style={{ fontSize: "10px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>📈 UG Revenue</span>
                              <div style={{ fontSize: "13px", fontWeight: 800, color: "#065F46" }}>£{ugRevenue.toFixed(2)}</div>
                            </div>
                            <div>
                              <span style={{ fontSize: "10px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>Customer</span>
                              <div style={{ fontSize: "12px", fontWeight: 700, color: "#111827" }}>{selectedTransactionCustomer.customerName || selectedTransactionCustomer.name || selectedTransactionCustomer.username || "—"}</div>
                              <div style={{ fontSize: "11px", color: "#6B7280" }}>{maskedValue(job.customerId)}</div>
                            </div>
                            <div>
                              <span style={{ fontSize: "10px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>Provider</span>
                              <div style={{ fontSize: "12px", fontWeight: 700, color: "#111827" }}>{job.providerName || "—"}</div>
                              <div style={{ fontSize: "11px", color: "#6B7280" }}>{job.providerId || "—"}</div>
                            </div>
                            <div>
                              <span style={{ fontSize: "10px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>👷 Provider Payout</span>
                              <div style={{ fontSize: "13px", fontWeight: 700, color: "#1E3A8A" }}>£{providerPayoutVal.toFixed(2)}</div>
                            </div>
                            {job.discount !== undefined && (
                              <div>
                                <span style={{ fontSize: "10px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>Discount</span>
                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#DC2626" }}>-£{Number(job.discount || 0).toFixed(2)}</div>
                              </div>
                            )}
                            {job.tax !== undefined && (
                              <div>
                                <span style={{ fontSize: "10px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>Tax</span>
                                <div style={{ fontSize: "13px", fontWeight: 600 }}>£{Number(job.tax || 0).toFixed(2)}</div>
                              </div>
                            )}
                            <div>
                              <span style={{ fontSize: "10px", color: "#6B7280", textTransform: "uppercase", fontWeight: 700 }}>Status</span>
                              <span style={{ display: "inline-block", marginTop: 2, fontSize: "11px", background: "#DBEAFE", color: "#1E40AF", padding: "2px 8px", borderRadius: "10px", fontWeight: "600" }}>{formatCellValue(job.status || job.bookingStatus || "-")}</span>
                            </div>
                          </div>
                          {/* PII & SECURITY STATUS STRIP */}
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 16px", background: piiUnlocked ? "#ECFDF5" : "#FEF2F2", borderBottom: "1px solid #E5E7EB" }}>
                            <span style={{ fontSize: "11px", fontWeight: 600, color: piiUnlocked ? "#065F46" : "#991B1B" }}>
                              {piiUnlocked ? "🔓 Booking PII & Bank details unlocked" : "🔒 Address, IDs, tokens & Bank Account are protected. Unlock requires reason + one-time code."}
                            </span>
                            {!piiUnlocked && (
                              <button
                                onClick={() => requestCustomerAccess({ ...selectedTransactionCustomer, _piiTargetKey: piiKey }, "transaction_pii", () => {})}
                                style={{ background: "#DC2626", color: "#fff", border: "none", padding: "5px 10px", borderRadius: "6px", cursor: "pointer", fontSize: "10px", fontWeight: 700 }}
                              >🔑 Unlock PII</button>
                            )}
                          </div>
                          <button
                            onClick={() => setExpandedTxnRow(isOpen ? null : rowKey)}
                            style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 16px", background: isOpen ? "#EEF2FF" : "#F9FAFB", border: "none", cursor: "pointer", textAlign: "left" }}
                          >
                            <span style={{ fontSize: "12px", fontWeight: 600, color: "#374151" }}>#{index + 1} — {formatCellValue(job.date || job.bookingDate || job.createdAt || "-")}</span>
                            <span style={{ fontSize: "14px", color: "#6B7280", transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }}>▼</span>
                          </button>
                          {isOpen && (
                            <div style={{ padding: "16px", borderTop: "1px solid #E5E7EB", background: "#fff" }}>
                              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: "12px" }}>
                                {allFields.map((field) => {
                                  const piiFieldNames = ["address", "customerId", "idempotencyKey", "latitude", "longitude", "customerToken", "bank", "account"];
                                  const isPiiField = piiFieldNames.some(f => field.toLowerCase().includes(f.toLowerCase()));
                                  return (
                                    <div key={field} style={{ background: "#F9FAFB", padding: "10px 12px", borderRadius: "8px", border: "1px solid #F3F4F6" }}>
                                      <div style={{ fontSize: "10px", color: "#6B7280", fontWeight: "700", textTransform: "uppercase", marginBottom: "4px" }}>{field}</div>
                                      <div style={{ fontSize: "13px", color: "#111827", wordBreak: "break-word", whiteSpace: "pre-wrap" }}>
                                        {isPiiField ? maskedValue(formatCellValue(job[field])) : (formatCellValue(job[field]) || "-")}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
              <div className="modal-footer" style={{ padding: "14px 24px", background: "#F9FAFB", borderTop: "1px solid #E5E7EB", textAlign: "right" }}>
                <button
                  onClick={() => { setSelectedTransactionCustomer(null); setSelectedTransactionBookings([]); setExpandedTxnRow(null); }}
                  style={{ background: "#fff", border: "1px solid #D1D5DB", padding: "8px 16px", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}
                >Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* ✅ PROMOTIONS MODULE MODAL */}
      {showPromotionsModule && (
        <div className="modal-overlay" style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9998, padding: "20px" }}>
          <div className="modal-dialog" style={{ width: "100%", maxWidth: "1100px", maxHeight: "92vh", overflowY: "auto" }}>
            <div className="modal-content" style={{ background: "#fff", borderRadius: "16px", overflow: "hidden", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
              <div className="modal-header" style={{ background: "linear-gradient(135deg,#EC4899,#9D174D)", color: "#fff", padding: "18px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h5 className="modal-title" style={{ margin: 0, fontSize: "18px", fontWeight: "700" }}>
                  🎁 Promotions Module {promoTargetCustomer ? `— ${promoTargetCustomer.customerName || promoTargetCustomer.name || promoTargetCustomer.username || promoTargetCustomer.customerId || promoTargetCustomer.id}` : "— Birthday Campaigns"}
                </h5>
                <button type="button" onClick={handleClosePromotionsModule} style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", fontSize: "22px", width: "32px", height: "32px", borderRadius: "50%", cursor: "pointer" }}>&times;</button>
              </div>
              <div className="modal-body" style={{ padding: "20px", maxHeight: "78vh", overflowY: "auto" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                  <h4 style={{ fontSize: "14px", fontWeight: "700", color: "#0747A6", textTransform: "uppercase", margin: 0 }}>
                    📣 Promotional Campaigns{promoTargetCustomer ? " — This Customer" : ""}
                  </h4>
                  <button
                    onClick={() => setShowNewCampaignForm(prev => !prev)}
                    style={{ background: "#7C3AED", color: "#fff", border: "none", padding: "6px 12px", borderRadius: "6px", fontSize: "12px", fontWeight: "600", cursor: "pointer" }}
                  >
                    {showNewCampaignForm ? "✖ Cancel" : "➕ New Campaign"}
                  </button>
                </div>
                {showNewCampaignForm && (
                  <div style={{ background: "#F9FAFB", border: "1px solid #E5E7EB", borderRadius: "10px", padding: "16px", marginBottom: "16px" }}>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginBottom: "10px" }}>
                      <input
                        placeholder="Campaign title (e.g. Birthday Booking Discount)"
                        value={campaignDraft.title || ""}
                        onChange={(e) => setCampaignDraft(prev => ({...prev, title: e.target.value}))}
                        style={{ padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px" }}
                      />
                      <input
                        placeholder="Discount (e.g. 10% OFF)"
                        value={campaignDraft.discount || ""}
                        onChange={(e) => setCampaignDraft(prev => ({...prev, discount: e.target.value}))}
                        style={{ padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px" }}
                      />
                      <select
                        value={campaignDraft.type || "birthday"}
                        onChange={(e) => setCampaignDraft(prev => ({...prev, type: e.target.value}))}
                        style={{ padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px" }}
                      >
                        <option value="birthday">Birthday</option>
                        <option value="seasonal">Seasonal</option>
                        <option value="loyalty">Loyalty</option>
                        <option value="general">General</option>
                      </select>
                      <select
                        value={campaignDraft.status || "Draft"}
                        onChange={(e) => setCampaignDraft(prev => ({...prev, status: e.target.value}))}
                        style={{ padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px" }}
                      >
                        <option>Draft</option>
                        <option>Active</option>
                        <option>Paused</option>
                        <option>Ended</option>
                      </select>
                      <input
                        type="date"
                        placeholder="Start date"
                        value={campaignDraft.startDate || ""}
                        onChange={(e) => setCampaignDraft(prev => ({...prev, startDate: e.target.value}))}
                        style={{ padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px" }}
                      />
                      <input
                        type="date"
                        placeholder="End date"
                        value={campaignDraft.endDate || ""}
                        onChange={(e) => setCampaignDraft(prev => ({...prev, endDate: e.target.value}))}
                        style={{ padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px" }}
                      />
                    </div>
                    <textarea
                      placeholder="Promotion description / message"
                      value={campaignDraft.description || ""}
                      onChange={(e) => setCampaignDraft(prev => ({...prev, description: e.target.value}))}
                      style={{ width: "100%", minHeight: "60px", padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px", marginBottom: "10px", resize: "vertical" }}
                    />
                    <button
                      onClick={async () => {
                        if (!campaignDraft.title) return alert("Please enter a campaign title");
                        const rawTarget = promoTargetCustomer || campaignDraft.customerId;
                        const targetCustId = getExistingUserDocId(rawTarget);
                        if (!targetCustId) return alert("A Customer User ID is required to save this campaign under users/{customerId}/campaigns.");
                        try {
                          const newCampaign = {
                            title: campaignDraft.title,
                            discount: campaignDraft.discount || "",
                            type: campaignDraft.type || "birthday",
                            status: campaignDraft.status || "Active",
                            startDate: campaignDraft.startDate || "",
                            endDate: campaignDraft.endDate || "",
                            description: campaignDraft.description || "",
                            customerId: String(targetCustId).trim(),
                            customerName: promoTargetCustomer ? (promoTargetCustomer.customerName || promoTargetCustomer.name || promoTargetCustomer.username || "") : (campaignDraft.customerName || ""),
                            createdAt: new Date().toISOString()
                          };
                          if (typeof db !== "undefined" && typeof collection !== "undefined" && typeof addDoc !== "undefined") {
                            const docRef = await addDoc(collection(db, "users", newCampaign.customerId, "campaigns"), newCampaign);
                            newCampaign.id = docRef.id;
                          } else {
                            newCampaign.id = Date.now().toString();
                          }
                          if (typeof setCampaigns === "function") {
                            setCampaigns(prev => [newCampaign, ...prev]);
                          }
                          setCampaignDraft({});
                          setShowNewCampaignForm(false);
                          alert("Campaign saved successfully!");
                        } catch (err) {
                          console.error("Save campaign error:", err);
                          alert("Failed to save campaign: " + err.message);
                        }
                      }}
                      style={{ background: "#10B981", color: "#fff", border: "none", padding: "8px 16px", borderRadius: "6px", fontSize: "13px", fontWeight: "700", cursor: "pointer" }}
                    >
                      💾 Save Campaign
                    </button>
                  </div>
                )}
                {(() => {
                  const normalize = (v) => String(v ?? "").trim().toLowerCase();
                  const targetCustId = promoTargetCustomer ? normalize(promoTargetCustomer.customerId || promoTargetCustomer.id || promoTargetCustomer.uid) : null;
                  let visibleCampaigns = campaigns || [];
                  if (targetCustId) {
                    visibleCampaigns = visibleCampaigns.filter((camp) => {
                      const campCustKey = camp.customerId ? normalize(camp.customerId) : "";
                      return !campCustKey || campCustKey === targetCustId;
                    });
                  }
                  const dedupMap = new Map();
                  visibleCampaigns.forEach((camp) => {
                    const key = (camp.customerId && camp.title)
                      ? `${normalize(camp.customerId)}_${normalize(camp.title)}`
                      : camp.id;
                    if (key && !dedupMap.has(key)) {
                      dedupMap.set(key, camp);
                    }
                  });
                  visibleCampaigns = Array.from(dedupMap.values());
                  if (visibleCampaigns.length === 0) {
                    return (
                      <p style={{ color: "#6B7280", fontSize: "13px" }}>
                        {promoTargetCustomer
                          ? "No campaigns created for this customer yet. Click \"New Campaign\" to get started."
                          : "No campaigns created yet. Click \"New Campaign\" to get started."}
                      </p>
                    );
                  }
                  return (
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "12px" }}>
                      {visibleCampaigns.map((camp) => {
                        const statusColor =
                          camp.status === "Active" ? { bg: "#DCFCE7", color: "#166534" } :
                          camp.status === "Paused" ? { bg: "#FEF3C7", color: "#92400E" } :
                          camp.status === "Ended" ? { bg: "#FEE2E2", color: "#991B1B" } :
                          { bg: "#E5E7EB", color: "#374151" };
                        return (
                          <div key={camp.id} style={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: "10px", padding: "14px" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "6px" }}>
                              <h5 style={{ margin: 0, fontSize: "14px", fontWeight: "700", color: "#111827" }}>{camp.title}</h5>
                              <span style={{ background: statusColor.bg, color: statusColor.color, fontSize: "10px", fontWeight: "700", padding: "2px 8px", borderRadius: "10px" }}>{camp.status}</span>
                            </div>
                            {camp.discount && (
                              <div style={{ display: "inline-block", background: "#FDF2F8", color: "#9D174D", fontSize: "12px", fontWeight: "700", padding: "3px 10px", borderRadius: "10px", marginBottom: "8px" }}>
                                {camp.discount}
                              </div>
                            )}
                            <p style={{ fontSize: "12px", color: "#6B7280", margin: "4px 0 8px", whiteSpace: "pre-wrap" }}>{camp.description}</p>
                            <div style={{ fontSize: "11px", color: "#9CA3AF", marginBottom: "10px" }}>
                              {camp.startDate || "-"} → {camp.endDate || "-"} &nbsp;|&nbsp; Type: {camp.type}
                            </div>
                            <div style={{ display: "flex", gap: "6px" }}>
                              <button
                                onClick={async () => {
                                  const updatedStatus = camp.status === "Active" ? "Paused" : "Active";
                                  try {
                                    const campCustId = getExistingUserDocId(camp.customerId);
                                    if (typeof db !== "undefined" && typeof doc !== "undefined" && typeof updateDoc !== "undefined" && camp.id && campCustId) {
                                      await updateDoc(doc(db, "users", campCustId, "campaigns", String(camp.id)), { status: updatedStatus, updatedAt: new Date().toISOString() });
                                    }
                                    if (typeof setCampaigns === "function") {
                                      setCampaigns(prev => prev.map(c => c.id === camp.id ? { ...c, status: updatedStatus } : c));
                                    }
                                  } catch (err) {
                                    console.error("Failed to update status:", err);
                                    alert("Failed to update status: " + err.message);
                                  }
                                }}
                                style={{ flex: 1, background: "#2563EB", color: "#fff", border: "none", padding: "5px 8px", borderRadius: "6px", fontSize: "11px", fontWeight: "600", cursor: "pointer" }}
                              >
                                {camp.status === "Active" ? "⏸ Pause" : "▶ Activate"}
                              </button>
                              <button
                                onClick={async () => {
                                  if (!confirm("Are you sure you want to delete this campaign?")) return;
                                  try {
                                    const campCustId = getExistingUserDocId(camp.customerId);
                                    if (typeof db !== "undefined" && typeof doc !== "undefined" && typeof deleteDoc !== "undefined" && camp.id && campCustId) {
                                      await deleteDoc(doc(db, "users", campCustId, "campaigns", String(camp.id)));
                                    }
                                    if (typeof setCampaigns === "function") {
                                      setCampaigns(prev => prev.filter(c => c.id !== camp.id));
                                    }
                                  } catch (err) {
                                    console.error("Failed to delete campaign:", err);
                                    alert("Failed to delete campaign: " + err.message);
                                  }
                                }}
                                style={{ background: "#EF4444", color: "#fff", border: "none", padding: "5px 8px", borderRadius: "6px", fontSize: "11px", fontWeight: "600", cursor: "pointer" }}
                              >
                                🗑
                              </button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                })()}
              </div>
              <div className="modal-footer" style={{ padding: "14px 24px", background: "#F9FAFB", borderTop: "1px solid #E5E7EB", textAlign: "right" }}>
                <button onClick={handleClosePromotionsModule} style={{ background: "#fff", border: "1px solid #D1D5DB", padding: "8px 16px", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* ✅ WALLET MODULE WITH DROPDOWN (LATEST BOOKING ON TOP), UG REVENUE DISPLAY & CUST CREDITS */}
      {showWalletModule && (
        <div className="modal-overlay" style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9997, padding: "20px" }}>
          <div className="modal-dialog" style={{ width: "100%", maxWidth: "1180px", maxHeight: "92vh", overflowY: "auto" }}>
            <div className="modal-content" style={{ background: "#fff", borderRadius: "16px", overflow: "hidden", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
              <div className="modal-header" style={{ background: "linear-gradient(135deg,#059669,#065F46)", color: "#fff", padding: "18px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h5 className="modal-title" style={{ margin: 0, fontSize: "18px", fontWeight: "700" }}>
                  💰 Wallet Module {walletActiveCustomer ? `— ${walletActiveCustomer.customerName || walletActiveCustomer.name || walletActiveCustomer.username || walletActiveCustomer.customerId || walletActiveCustomer.id}` : ""}
                </h5>
                <button type="button" onClick={handleCloseWalletModule} style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", fontSize: "22px", width: "32px", height: "32px", borderRadius: "50%", cursor: "pointer" }}>&times;</button>
              </div>
              <div style={{ display: "flex", gap: "6px", padding: "12px 24px 0", background: "#F0FDF4", borderBottom: "1px solid #E5E7EB", flexWrap: "wrap" }}>
                {["overview", "topup", "approvals", "promocodes", "reversals", "activitytrail", "auditlog"].map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setWalletActiveTab(tab)}
                    style={{
                      padding: "8px 14px", border: "none", borderRadius: "8px 8px 0 0", cursor: "pointer", fontSize: "12px", fontWeight: "700",
                      background: walletActiveTab === tab ? "#fff" : "transparent",
                      color: walletActiveTab === tab ? "#065F46" : "#6B7280",
                      borderBottom: walletActiveTab === tab ? "2px solid #059669" : "2px solid transparent"
                    }}
                  >
                    {tab === "overview" && "📊 Overview & Credits"}
                    {tab === "topup" && "➕ Add Credit"}
                    {tab === "approvals" && `🛡 Approvals (${(creditRequestQueue || []).filter(r => r.status === "Pending").length})`}
                    {tab === "promocodes" && "🎟 Vouchers"}
                    {tab === "reversals" && "↩ Refunds"}
                    {tab === "activitytrail" && "🗂 Activity Log"}
                    {tab === "auditlog" && "🔐 Audit Log"}
                  </button>
                ))}
              </div>
              <div className="modal-body" style={{ padding: "20px", maxHeight: "72vh", overflowY: "auto" }}>
                {walletActiveTab === "overview" && (() => {
                  const targetId = walletActiveCustomer ? normalizeWalletId(walletActiveCustomer.customerId || walletActiveCustomer.id || walletActiveCustomer.uid) : null;
                  let ledgerEntries = targetId
                    ? (effectiveWalletLedger || []).filter(e => normalizeWalletId(e.customerId) === targetId)
                    : (effectiveWalletLedger || []);
                  const custWalletOverrideUsed = (walletActiveCustomer?.walletStatus === "Used" || walletActiveCustomer?.walletBalance === 0);
                  const processedLedger = ledgerEntries.map(entry => {
                    const state = computeCreditEntryState(entry, custWalletOverrideUsed);
                    return { ...entry, appliedDate: state.appliedDate, expiryDate: state.expiryDate, effectiveStatus: state.effectiveStatus, isUsable: state.isUsable };
                  });
                  const totalIssuedGross = processedLedger
                    .filter(e => e.entryType === "issue" || !e.entryType)
                    .reduce((sum, e) => sum + Number(e.originalAmount != null ? e.originalAmount : (e.effectiveStatus === "Active" ? e.amount : (e.amount || 0))), 0);
                  const totalRedeemed = processedLedger.filter(e => e.entryType === "redeem" || e.effectiveStatus === "Used").length;
                  const usableCreditsTotal = processedLedger.filter(e => e.isUsable).reduce((sum, e) => sum + Number(e.amount || 0), 0);
                  const hasUsedAllCredits = processedLedger.length > 0 && processedLedger.every(e => e.effectiveStatus === "Used" || e.effectiveStatus === "Expired");
                  const currentBalance = custWalletOverrideUsed || hasUsedAllCredits ? 0 : usableCreditsTotal;
                  return (
                    <>
                      <div style={{ background: "#EFF6FF", border: "1px solid #BFDBFE", color: "#1E40AF", padding: "10px 14px", borderRadius: "8px", fontSize: "12px", marginBottom: "16px", fontWeight: "600" }}>
                        ℹ️ <strong>Automatic Credit Policy:</strong> Credits are deducted only when consumed on a booking — balance snaps to £0.00, status becomes Used. New Credits are valid 90 days from issue and auto-expire after that. All issuer staff details, booking IDs and justification remarks are permanently tracked.
                      </div>
                      <div style={{ display: "flex", gap: "12px", marginBottom: "12px", flexWrap: "wrap" }}>
                        <div style={{ background: "#ECFDF5", color: "#065F46", padding: "16px 18px", borderRadius: "10px", fontWeight: "700", fontSize: "14px", flex: "1 1 260px", border: "2px solid #10B981" }}>
                          ✅ Existing / Usable Credits : £{Number(currentBalance || 0).toFixed(2)}
                        </div>
                        <div style={{ background: "#F5F3FF", color: "#5B21B6", padding: "16px 18px", borderRadius: "10px", fontWeight: "700", fontSize: "14px", flex: "1 1 260px" }}>
                          🆕 New Credits Issued (Lifetime) : £{totalIssuedGross.toFixed(2)}
                        </div>
                        <div style={{ background: "#FEF2F2", color: "#991B1B", padding: "16px 18px", borderRadius: "10px", fontWeight: "700", fontSize: "14px", flex: "1 1 200px" }}>
                          ⬇ Credits Redeemed / Used : {totalRedeemed}
                        </div>
                      </div>
                      <h4 style={{ fontSize: "14px", fontWeight: "700", color: "#065F46", textTransform: "uppercase", marginBottom: "12px" }}>📜 Credit Breakdown & History</h4>
                      {processedLedger.length === 0 ? (
                        <p style={{ color: "#6B7280", fontSize: "13px" }}>No credit transactions found.</p>
                      ) : (
                        <div style={{ overflowX: "auto" }}>
                          <table style={{ width: "100%", minWidth: "980px", borderCollapse: "collapse", fontSize: "13px" }}>
                            <thead>
                              <tr style={{ background: "#F9FAFB" }}>
                                <th style={tableHeaderStyleLight}>Applied Date</th>
                                <th style={tableHeaderStyleLight}>Customer User ID</th>
                                <th style={tableHeaderStyleLight}>Credit Amount</th>
                                <th style={tableHeaderStyleLight}>Expiry Date (90 Days)</th>
                                <th style={tableHeaderStyleLight}>Status</th>
                                <th style={tableHeaderStyleLight}>Reason & Justification</th>
                                <th style={tableHeaderStyleLight}>Linked Booking ID</th>
                                <th style={tableHeaderStyleLight}>Issued By (Staff)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {processedLedger.slice().sort((a, b) => new Date(b.appliedDate) - new Date(a.appliedDate)).map((entry) => {
                                const isGreyedOut = entry.effectiveStatus === "Used" || entry.effectiveStatus === "Expired";
                                const noteDisplay = entry.justificationNotes ? ` | Notes: "${entry.justificationNotes}"` : "";
                                return (
                                  <tr key={entry.id || entry.appliedDate} style={{ borderBottom: "1px solid #F3F4F6", background: isGreyedOut ? "#F9FAFB" : "#ffffff", opacity: isGreyedOut ? 0.6 : 1 }}>
                                    <td style={tableDataStyle}>{new Date(entry.appliedDate).toLocaleDateString()}</td>
                                    <td style={tableDataStyle}>{entry.customerName || entry.username || entry.customerId}</td>
                                    <td style={{ ...tableDataStyle, fontWeight: "700", color: isGreyedOut ? "#6B7280" : "#065F46" }}>£{Number(entry.amount || 0).toFixed(2)}</td>
                                    <td style={tableDataStyle}>{new Date(entry.expiryDate).toLocaleDateString()}</td>
                                    <td style={tableDataStyle}>
                                      <span style={{
                                        background: entry.effectiveStatus === "Active" ? "#DCFCE7" : entry.effectiveStatus === "Used" ? "#E5E7EB" : "#FEE2E2",
                                        color: entry.effectiveStatus === "Active" ? "#166534" : entry.effectiveStatus === "Used" ? "#374151" : "#991B1B",
                                        padding: "3px 10px", borderRadius: "10px", fontSize: "11px", fontWeight: "700", textTransform: "uppercase"
                                      }}>
                                        {entry.effectiveStatus === "Active" ? "Usable" : entry.effectiveStatus}
                                      </span>
                                    </td>
                                    <td style={tableDataStyle}>{entry.reasonCode || "-"}{noteDisplay}</td>
                                    <td style={tableDataStyle}>{entry.bookingId || entry.redeemedBookingId || "-"}</td>
                                    <td style={tableDataStyle}>
                                      <span style={{ background: "#EEF2FF", color: "#1E40AF", padding: "2px 8px", borderRadius: "6px", fontWeight: 700, fontSize: "11px" }}>
                                        👤 {entry.staffHandle || "-"}
                                      </span>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </>
                  );
                })()}
                {walletActiveTab === "topup" && (() => {
                  const targetId = walletActiveCustomer ? normalizeWalletId(walletActiveCustomer.customerId || walletActiveCustomer.id || walletActiveCustomer.uid) : null;
                  // Sort customer bookings chronologically descending so LATEST is strictly at the top
                  const customerBookings = (targetId ? (customerBookingsMap[targetId] || []) : sanitizedWorkOrders)
                    .slice()
                    .sort((a, b) => {
                      const timeA = new Date(a.date || a.bookingDate || a.createdAt || a.bookingDateTimestamp || a.timestamp || 0).getTime();
                      const timeB = new Date(b.date || b.bookingDate || b.createdAt || b.bookingDateTimestamp || b.timestamp || 0).getTime();
                      return timeB - timeA;
                    });
                  // Auto-fetch the customer's primary latest booking record
                  const autoFetchedBooking = customerBookings[0] || null;
                  const autoFetchedBookingId = autoFetchedBooking ? (autoFetchedBooking.docId || autoFetchedBooking.id || autoFetchedBooking.bookingId || "") : "";
                  const activeBookingId = (topUpDraft && topUpDraft.bookingId !== undefined && topUpDraft.bookingId !== "") 
                    ? topUpDraft.bookingId 
                    : autoFetchedBookingId;
                  const matchedBookingJob = customerBookings.find(j => (j.docId || j.id || j.bookingId) === activeBookingId) || autoFetchedBooking;
                  const autoCalculatedCharge = matchedBookingJob ? (matchedBookingJob.totalCharge ?? matchedBookingJob.amount ?? matchedBookingJob.total ?? matchedBookingJob.customer_total_amount ?? "") : "";
                  const inferredBookingAmount = (topUpRelatedBookingAmount !== undefined && topUpRelatedBookingAmount !== "") 
                    ? topUpRelatedBookingAmount 
                    : autoCalculatedCharge;
                  // Calculate UG Revenue for the selected booking
                  const bookingAmountNum = Number(inferredBookingAmount || 0);
                  const currentUgRevenue = matchedBookingJob
                    ? Number(matchedBookingJob.ugRevenue !== undefined ? matchedBookingJob.ugRevenue : (matchedBookingJob.platformFee !== undefined ? matchedBookingJob.platformFee : (bookingAmountNum * 0.2)))
                    : (bookingAmountNum > 0 ? (bookingAmountNum * 0.2) : null);
                  // Maximum amount that can be applied automatically (without going through admin approval) for THIS booking.
                  // Capped by the booking's eligible UG Revenue (when known) and by the standard staff ceiling.
                  const maxAutoApplicableCredit = (currentUgRevenue != null && currentUgRevenue > 0)
                    ? Math.min(currentUgRevenue, MAX_NORMAL_STAFF_CREDIT)
                    : MAX_NORMAL_STAFF_CREDIT;
                  const recommendedPreset = getRecommendedCreditPreset(inferredBookingAmount);
                  const isDraftApprovedHigherAmount = Number(topUpDraft?.amount || 0) > MAX_NORMAL_STAFF_CREDIT && topUpDraft?.isManagerApproved;
                  const resolvedCustomerFullName = walletActiveCustomer
                    ? (walletActiveCustomer.customerName || walletActiveCustomer.name || walletActiveCustomer.displayName || walletActiveCustomer.username || walletActiveCustomer.customerId || walletActiveCustomer.id || "Unknown Customer")
                    : "No Customer Selected";
                  return (
                    <div>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px", flexWrap: "wrap", gap: "10px" }}>
                        <h4 style={{ fontSize: "14px", fontWeight: "700", color: "#065F46", textTransform: "uppercase", margin: 0 }}>
                          ➕ Add Customer Credit (£)
                        </h4>
                        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                          <button
                            type="button"
                            onClick={openCreditRequestModal}
                            style={{
                              background: "linear-gradient(135deg, #DC2626, #B91C1C)",
                              color: "#fff",
                              border: "none",
                              padding: "8px 14px",
                              borderRadius: "8px",
                              fontSize: "12px",
                              fontWeight: "700",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              boxShadow: "0 2px 6px rgba(220,38,38,0.25)"
                            }}
                          >
                            🛡 Request Credit Approval (&gt; £20)
                          </button>
                          <button
                            type="button"
                            onClick={openCreditApprovalModal}
                            style={{
                              background: "linear-gradient(135deg, #7C3AED, #6D28D9)",
                              color: "#fff",
                              border: "none",
                              padding: "8px 14px",
                              borderRadius: "8px",
                              fontSize: "12px",
                              fontWeight: "700",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              boxShadow: "0 2px 6px rgba(124,58,237,0.25)"
                            }}
                          >
                            ⭐ Credit Approval Options (&gt; £20)
                          </button>
                        </div>
                      </div>
                      <div style={{ background: "#EFF6FF", border: "1px solid #BFDBFE", color: "#1E40AF", padding: "10px 14px", borderRadius: "8px", fontSize: "12px", marginBottom: "16px", fontWeight: 600 }}>
                        ℹ️ Predefined options: <strong>£5, £10, £15, £20</strong> or enter a <strong>Custom Credit Amount (£0 - £20)</strong>. Credits should not exceed applicable UG Revenue. The customer's <strong>Booking ID and UG Revenue are auto-fetched</strong> from the latest booking on top. Notes are recorded directly into the audit log.
                      </div>
                      {isDraftApprovedHigherAmount && (
                        <div style={{ background: "#ECFDF5", border: "2px solid #10B981", color: "#065F46", padding: "12px 14px", borderRadius: "8px", fontSize: "13px", marginBottom: "16px", fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <div>
                            🎉 <strong>Approved Credit Attached:</strong> £{Number(topUpDraft?.amount).toFixed(2)} authorized by <strong>{topUpDraft?.approvedBy || "Manager"}</strong>! Ready to apply.
                          </div>
                          <button
                            onClick={() => setTopUpDraft(prev => ({ ...prev, amount: 20, isManagerApproved: false, approvedBy: "" }))}
                            style={{ background: "#EF4444", color: "#fff", border: "none", padding: "4px 10px", borderRadius: "6px", fontSize: "11px", cursor: "pointer", fontWeight: 700 }}
                          >
                            ✖ Reset
                          </button>
                        </div>
                      )}
                      <div style={{ background: "#F9FAFB", border: "1px solid #E5E7EB", borderRadius: "10px", padding: "16px" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginBottom: "10px" }}>
                          {/* TARGET CUSTOMER FULL NAME */}
                          <div>
                            <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "#374151", marginBottom: "4px", textTransform: "uppercase" }}>
                              Target Customer Full Name
                            </label>
                            <input
                              placeholder="Customer Full Name"
                              value={resolvedCustomerFullName}
                              readOnly
                              style={{ width: "100%", boxSizing: "border-box", padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px", background: "#F3F4F6", fontWeight: "700", color: "#111827" }}
                            />
                            {walletActiveCustomer && (
                              <div style={{ marginTop: "4px", fontSize: "11px", color: "#6B7280" }}>
                                Customer ID: <strong>{walletActiveCustomer.customerId || walletActiveCustomer.id || walletActiveCustomer.uid || "—"}</strong>
                              </div>
                            )}
                          </div>
                          {/* BOOKING IDS DROPDOWN WITH UG REVENUE DISPLAYED ALONG WITH BOOKING IDS */}
                          <div>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "4px" }}>
                              <label style={{ fontSize: "11px", fontWeight: 700, color: "#065F46", textTransform: "uppercase" }}>
                                🔗 Customer Booking ID &amp; UG Revenue (Latest on Top)
                              </label>
                              {activeBookingId && (
                                <span style={{ fontSize: "10px", background: "#DCFCE7", color: "#166534", padding: "1px 6px", borderRadius: "8px", fontWeight: "700" }}>
                                  {activeBookingId === autoFetchedBookingId ? "★ Latest Selected" : "✓ Selected"}
                                </span>
                              )}
                            </div>
                            <select
                              value={activeBookingId}
                              onChange={(e) => {
                                const selectedBId = e.target.value;
                                const matched = customerBookings.find(j => (j.docId || j.id || j.bookingId) === selectedBId);
                                const charge = matched ? (matched.totalCharge ?? matched.amount ?? matched.total ?? matched.customer_total_amount ?? "") : "";
                                setTopUpDraft(prev => ({ ...prev, bookingId: selectedBId }));
                                if (typeof setTopUpRelatedBookingAmount === "function") {
                                  setTopUpRelatedBookingAmount(charge !== "" ? charge : "");
                                }
                              }}
                              style={{ width: "100%", boxSizing: "border-box", padding: "8px 10px", borderRadius: "6px", border: "2px solid #10B981", fontSize: "13px", background: "#ECFDF5", fontWeight: "700", color: "#065F46", cursor: "pointer", outline: "none" }}
                            >
                              {customerBookings.length === 0 ? (
                                <option value="">No bookings recorded for this customer</option>
                              ) : (
                                <>
                                  {customerBookings.map((b, idx) => {
                                    const bId = b.docId || b.id || b.bookingId || `booking-${idx}`;
                                    const bAmt = Number(b.totalCharge ?? b.amount ?? b.total ?? b.customer_total_amount ?? 0);
                                    const bUgRev = Number(b.ugRevenue !== undefined ? b.ugRevenue : (b.platformFee !== undefined ? b.platformFee : (bAmt * 0.2)));
                                    const bDate = b.date || b.bookingDate || b.createdAt || "";
                                    const dateStr = bDate ? ` (${new Date(bDate).toLocaleDateString()})` : "";
                                    const isLatest = idx === 0;
                                    return (
                                      <option key={bId} value={bId}>
                                        {isLatest ? `★ [LATEST] ${bId} — Total: £${bAmt.toFixed(2)} | UG Revenue: £${bUgRev.toFixed(2)}${dateStr}` : `${bId} — Total: £${bAmt.toFixed(2)} | UG Revenue: £${bUgRev.toFixed(2)}${dateStr}`}
                                      </option>
                                    );
                                  })}
                                  <option value="">-- Enter Custom / Blank --</option>
                                </>
                              )}
                            </select>
                            {/* Prominent display of UG Revenue for the selected booking */}
                            <div style={{ marginTop: "6px", padding: "6px 10px", background: "#EFF6FF", border: "1px solid #BFDBFE", borderRadius: "6px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                              <span style={{ fontSize: "11px", fontWeight: "700", color: "#1E40AF" }}>
                                📈 Applicable UG Revenue: <strong style={{ color: "#065F46", fontSize: "12px" }}>{currentUgRevenue != null ? `£${Number(currentUgRevenue).toFixed(2)}` : "£0.00"}</strong>
                              </span>
                              <span style={{ fontSize: "10px", color: "#6B7280" }}>
                                (Credit should not exceed UG Revenue)
                              </span>
                            </div>
                            {/* Manual Booking ID input fallback */}
                            <div style={{ marginTop: "4px" }}>
                              <input
                                type="text"
                                placeholder="Or type custom Booking ID manually..."
                                value={topUpDraft?.bookingId !== undefined ? topUpDraft.bookingId : activeBookingId}
                                onChange={(e) => setTopUpDraft(prev => ({ ...prev, bookingId: e.target.value }))}
                                style={{ width: "100%", boxSizing: "border-box", padding: "5px 8px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "11px", background: "#fff" }}
                              />
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginBottom: "10px" }}>
                          <div>
                            <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "#374151", marginBottom: "4px", textTransform: "uppercase" }}>
                              Related Booking Value (£) (Auto-Fetched)
                            </label>
                            <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                              <span style={{ position: "absolute", left: "10px", fontWeight: "700", color: "#374151", fontSize: "13px" }}>£</span>
                              <input
                                placeholder="0.00"
                                type="number"
                                step="0.01"
                                value={inferredBookingAmount || ""}
                                onChange={(e) => typeof setTopUpRelatedBookingAmount === "function" && setTopUpRelatedBookingAmount(e.target.value)}
                                style={{ width: "100%", boxSizing: "border-box", padding: "8px 10px 8px 24px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px", fontWeight: "700" }}
                              />
                            </div>
                          </div>
                          <div>
                            <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "#374151", marginBottom: "4px", textTransform: "uppercase" }}>
                              Staff Issuer Handle (Audited)
                            </label>
                            <input
                              placeholder="Staff name (who is issuing this credit)"
                              value={(topUpDraft && topUpDraft.staffHandle) || (currentUser && (currentUser.displayName || currentUser.email)) || ""}
                              onChange={(e) => setTopUpDraft(prev => ({...prev, staffHandle: e.target.value}))}
                              style={{ width: "100%", boxSizing: "border-box", padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px" }}
                            />
                          </div>
                        </div>
                        {recommendedPreset && (
                          <div style={{ background: "#FFFBEB", border: "1px solid #FDE68A", color: "#92400E", padding: "8px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: 600, marginBottom: "12px" }}>
                            💡 Suggested credit for a £{Number(inferredBookingAmount).toFixed(2)} booking: <strong>£{recommendedPreset}</strong> (suggestion only — click preset or enter custom amount below).
                          </div>
                        )}
                        {/* 8. CREDIT AMOUNT SECTION: PREDEFINED OPTIONS + CUSTOM CREDIT AMOUNT (0 - 20) */}
                        <label style={{ display: "block", fontSize: "12px", fontWeight: 700, color: "#374151", marginBottom: "6px" }}>
                          8. Credit Amount — Predefined Options &amp; Custom (£0 - £{maxAutoApplicableCredit.toFixed(2)})
                          {isDraftApprovedHigherAmount && <span style={{ color: "#059669", marginLeft: 6 }}>(Higher amount attached: £{Number(topUpDraft?.amount).toFixed(2)})</span>}
                        </label>
                        <p style={{ margin: "0 0 8px", fontSize: "11px", color: "#6B7280" }}>
                          Maximum applicable credit for this booking (auto-apply limit): <strong style={{ color: "#065F46" }}>£{maxAutoApplicableCredit.toFixed(2)}</strong>. Amounts above this require admin approval via the "Request Credit Approval" workflow.
                        </p>
                        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", alignItems: "center", marginBottom: "12px" }}>
                          {CREDIT_PRESETS.map((preset) => {
                            const isSelected = Number(topUpDraft?.amount) === preset && !topUpDraft?.isCustom;
                            const isDisabledPreset = preset > maxAutoApplicableCredit;
                            return (
                              <button
                                key={preset}
                                type="button"
                                disabled={isDisabledPreset}
                                onClick={() => { if (!isDisabledPreset) setTopUpDraft(prev => ({ ...prev, amount: preset, customAmount: "", isCustom: false, isManagerApproved: false })); }}
                                title={isDisabledPreset ? `Exceeds the maximum applicable credit of £${maxAutoApplicableCredit.toFixed(2)} for this booking. Use "Request Credit Approval" for higher amounts.` : undefined}
                                style={{
                                  padding: "9px 18px", borderRadius: "8px",
                                  border: isSelected ? "2px solid #059669" : (preset === recommendedPreset && !isDisabledPreset ? "2px solid #F59E0B" : "1px solid #D1D5DB"),
                                  background: isDisabledPreset ? "#F3F4F6" : (isSelected ? "#059669" : "#fff"),
                                  color: isDisabledPreset ? "#9CA3AF" : (isSelected ? "#fff" : "#111827"),
                                  fontWeight: 700, fontSize: "13px", cursor: isDisabledPreset ? "not-allowed" : "pointer", opacity: isDisabledPreset ? 0.6 : 1, position: "relative"
                                }}
                              >
                                £{preset}
                                {preset === recommendedPreset && !isDisabledPreset && (
                                  <span style={{ position: "absolute", top: -8, right: -8, background: "#F59E0B", color: "#fff", fontSize: "9px", padding: "1px 5px", borderRadius: "8px", fontWeight: 700 }}>Rec.</span>
                                )}
                                {isDisabledPreset && (
                                  <span style={{ position: "absolute", bottom: -7, right: 2, background: "#FEE2E2", color: "#991B1B", fontSize: "8px", padding: "0 3px", borderRadius: "4px", fontWeight: 700 }}>Exceeds Max</span>
                                )}
                              </button>
                            );
                          })}
                          {/* CUSTOM CREDIT AMOUNT OPTION (£0 to £20) */}
                          <div style={{ display: "flex", alignItems: "center", gap: "6px", background: topUpDraft?.isCustom ? "#ECFDF5" : "#F3F4F6", padding: "4px 8px", borderRadius: "8px", border: topUpDraft?.isCustom ? "2px solid #10B981" : "1px solid #D1D5DB" }}>
                            <span style={{ fontSize: "11px", fontWeight: 700, color: "#374151", textTransform: "uppercase" }}>Custom (£0 - £{maxAutoApplicableCredit.toFixed(2)}):</span>
                            <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                              <span style={{ position: "absolute", left: "6px", fontWeight: "700", color: "#374151", fontSize: "12px" }}>£</span>
                              <input
                                type="number"
                                step="0.01"
                                min="0"
                                max={maxAutoApplicableCredit}
                                placeholder={currentUgRevenue != null ? `e.g. ${Number(currentUgRevenue).toFixed(2)}` : "e.g. 2.50"}
                                value={(topUpDraft && topUpDraft.customAmount) || ""}
                                onChange={(e) => {
                                  let val = e.target.value;
                                  if (val !== "" && !isNaN(Number(val)) && Number(val) > maxAutoApplicableCredit) {
                                    val = String(maxAutoApplicableCredit);
                                  }
                                  setTopUpDraft(prev => ({
                                    ...prev,
                                    customAmount: val,
                                    amount: val,
                                    isCustom: true,
                                    isManagerApproved: false
                                  }));
                                }}
                                style={{ padding: "6px 8px 6px 18px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "12px", width: "110px", fontWeight: "700" }}
                              />
                            </div>
                            <span style={{ fontSize: "9px", color: "#6B7280" }}>Max £{maxAutoApplicableCredit.toFixed(2)}</span>
                            {currentUgRevenue != null && currentUgRevenue > 0 && (
                              <button
                                type="button"
                                onClick={() => {
                                  const capped = Math.min(20, Number(currentUgRevenue));
                                  setTopUpDraft(prev => ({
                                    ...prev,
                                    customAmount: capped.toFixed(2),
                                    amount: capped.toFixed(2),
                                    isCustom: true,
                                    isManagerApproved: false
                                  }));
                                }}
                                style={{ background: "#059669", color: "#fff", border: "none", padding: "4px 8px", borderRadius: "4px", fontSize: "10px", fontWeight: "700", cursor: "pointer" }}
                                title="Set exact UG Revenue amount"
                              >
                                Max UG (£{Number(currentUgRevenue).toFixed(2)})
                              </button>
                            )}
                          </div>
                          {isDraftApprovedHigherAmount && (
                            <button
                              style={{
                                padding: "9px 16px", borderRadius: "8px",
                                border: "2px solid #7C3AED",
                                background: "#7C3AED",
                                color: "#fff",
                                fontWeight: 800, fontSize: "13px", cursor: "default"
                              }}
                            >
                              £{Number(topUpDraft?.amount).toFixed(2)} (Approved &gt; £20)
                            </button>
                          )}
                        </div>
                        {/* REASON SELECTION */}
                        <div style={{ marginBottom: "10px" }}>
                          <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "#374151", marginBottom: "4px", textTransform: "uppercase" }}>Mandatory Reason</label>
                          <select
                            value={(topUpDraft && topUpDraft.reasonCode) || ""}
                            onChange={(e) => setTopUpDraft(prev => ({...prev, reasonCode: e.target.value}))}
                            style={{ width: "100%", boxSizing: "border-box", padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px" }}
                          >
                            <option value="" disabled>Select mandatory reason…</option>
                            <option value="Goodwill Compensation">Goodwill Compensation</option>
                            <option value="Service Recovery">Service Recovery</option>
                            <option value="Loyalty Bonus">Loyalty Bonus</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>
                        {/* JUSTIFICATION BOX (EXPLICITLY STORED AND DISPLAYED IN AUDIT LOG) */}
                        <div style={{ marginBottom: "12px" }}>
                          <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "#374151", marginBottom: "4px", textTransform: "uppercase" }}>
                            Justification Notes (Required — Displayed in Audit Log)
                          </label>
                          <textarea
                            placeholder="Enter detailed reason and justification note (e.g. 'Customer experienced delay on booking BK-102. Credit capped to UG Revenue of £2.50 as goodwill.')"
                            value={(topUpDraft && topUpDraft.remarks) || ""}
                            onChange={(e) => setTopUpDraft(prev => ({...prev, remarks: e.target.value}))}
                            style={{ width: "100%", boxSizing: "border-box", minHeight: "65px", padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px", resize: "vertical" }}
                          />
                        </div>
                        <button
                          onClick={async () => {
                            const amount = Number((topUpDraft && topUpDraft.amount) || 0);
                            const reason = (topUpDraft && topUpDraft.reasonCode) || "";
                            const remarks = (topUpDraft && topUpDraft.remarks) || "";
                            const staffHandle = (topUpDraft && topUpDraft.staffHandle) || (currentUser && (currentUser.displayName || currentUser.email)) || "Staff";
                            const rawCust = walletActiveCustomer && (walletActiveCustomer.customerId || walletActiveCustomer.id || walletActiveCustomer.uid);
                            const linkedBookingId = (topUpDraft && topUpDraft.bookingId !== undefined && topUpDraft.bookingId !== "") 
                              ? topUpDraft.bookingId 
                              : autoFetchedBookingId;
                            if (!rawCust) return alert("No customer selected.");
                            if (!amount || amount <= 0) return alert("Please enter or select a valid credit amount greater than £0.00.");
                            if (!reason) return alert("A reason is mandatory before applying credit.");
                            // Rule: Credit can never exceed the maximum applicable amount for THIS booking (auto-apply limit)
                            // unless the amount has gone through the admin approval workflow (isManagerApproved).
                            if (amount > maxAutoApplicableCredit && !topUpDraft?.isManagerApproved) {
                              return alert(`Credit amount of £${amount.toFixed(2)} exceeds the maximum applicable credit of £${maxAutoApplicableCredit.toFixed(2)} for this booking. Amounts above this limit require admin approval — please use the "Request Credit Approval" button.`);
                            }
                            // Rule: Max £20 for normal credit unless manager approved (kept for cases with no booking-linked eligible amount)
                            if (!isSeniorStaff && amount > MAX_NORMAL_STAFF_CREDIT && !topUpDraft?.isManagerApproved) {
                              return alert(`Amounts above £${MAX_NORMAL_STAFF_CREDIT} must go through the credit approval request workflow. Please use the "Request Credit Approval" button.`);
                            }
                            setIsIssuingCredit(true);
                            try {
                              const result = await issueCreditToCustomer({
                                rawCustomerId: rawCust,
                                customerName: walletActiveCustomer.customerName || walletActiveCustomer.name || walletActiveCustomer.username,
                                amount,
                                reasonCode: `${reason}${topUpDraft?.approvedBy ? ` (Approved by ${topUpDraft.approvedBy})` : ""}`,
                                justificationNotes: remarks,
                                staffHandle,
                                bookingId: linkedBookingId
                              });
                              if (result) {
                                if (typeof setWalletActiveCustomer === 'function') {
                                  setWalletActiveCustomer(prev => prev ? { ...prev, walletBalance: result.newWalletBalance, walletStatus: "Active" } : prev);
                                }
                                setTopUpDraft({});
                                alert(`Credit of £${amount.toFixed(2)} added by ${staffHandle}! Usable balance: £${result.newWalletBalance.toFixed(2)}. Expires ${new Date(result.calculatedExpiryDate).toLocaleDateString()}.${linkedBookingId ? ` Linked to Booking: ${linkedBookingId}.` : ""}`);
                              }
                            } catch (err) {
                              console.error("Issue credit error:", err);
                              alert("Failed to issue credit: " + err.message);
                            } finally {
                              setIsIssuingCredit(false);
                            }
                          }}
                          disabled={isIssuingCredit}
                          style={{ background: isIssuingCredit ? "#9CA3AF" : "#059669", color: "#fff", border: "none", padding: "10px 20px", borderRadius: "6px", fontSize: "13px", fontWeight: "700", cursor: isIssuingCredit ? "not-allowed" : "pointer" }}
                        >
                          {isIssuingCredit ? "💾 Issuing & Archiving Logs..." : "💾 Apply Credit (Log Staff & Details)"}
                        </button>
                      </div>
                    </div>
                  );
                })()}
                {walletActiveTab === "approvals" && (
                  <div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px", flexWrap: "wrap", gap: "10px" }}>
                      <h4 style={{ fontSize: "14px", fontWeight: "700", color: "#991B1B", textTransform: "uppercase", margin: 0 }}>🛡 Pending Credit Requests</h4>
                      <button
                        onClick={openCreditApprovalModal}
                        style={{ background: "#7C3AED", color: "#fff", border: "none", padding: "6px 14px", borderRadius: "6px", fontSize: "12px", fontWeight: "700", cursor: "pointer" }}
                      >
                        ⭐ Open Credit Approval Options Modal
                      </button>
                    </div>
                    {(creditRequestQueue || []).filter(r => r.status === "Pending").length === 0 ? (
                      <p style={{ color: "#6B7280", fontSize: "13px" }}>No pending requests.</p>
                    ) : (
                      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        {(creditRequestQueue || []).filter(r => r.status === "Pending").map((req) => (
                          <div key={req.id} style={{ border: "1px solid #FECACA", background: "#FEF2F2", borderRadius: "10px", padding: "14px" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "8px" }}>
                              <div>
                                <strong style={{ fontSize: "14px", color: "#111827" }}>{req.customerName || req.customerId}</strong>
                                <span style={{ marginLeft: 8, fontSize: "12px", color: "#6B7280" }}>({req.customerId})</span>
                                {req.designatedApprover && (
                                  <div style={{ marginTop: 4, fontSize: "11px", color: "#7C3AED", fontWeight: "700" }}>
                                    Assigned Approver: {req.designatedApprover}
                                  </div>
                                )}
                              </div>
                              <span style={{ fontSize: "16px", fontWeight: 800, color: "#991B1B" }}>£{Number(req.amount).toFixed(2)}</span>
                            </div>
                            <p style={{ fontSize: "12px", color: "#374151", margin: "6px 0" }}>Reason: {req.reason}</p>
                            <p style={{ fontSize: "11px", color: "#9CA3AF", margin: "0 0 10px" }}>Requested by {req.requestedBy || "-"} on {new Date(req.requestedAt).toLocaleString()}</p>
                            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", alignItems: "center" }}>
                              <input
                                type="number"
                                defaultValue={req.amount}
                                id={`modify-amount-${req.id}`}
                                style={{ width: "100px", padding: "6px 8px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "12px" }}
                              />
                              <button
                                onClick={async () => {
                                  const enteredCode = prompt("Enter security passcode to authorize and approve this credit:");
                                  if (enteredCode !== SECURITY_PASSCODE) {
                                    alert("Incorrect security passcode. Authorization denied.");
                                    return;
                                  }
                                  const modifiedInput = document.getElementById(`modify-amount-${req.id}`);
                                  const finalAmount = Number(modifiedInput?.value || req.amount);
                                  const approverName = req.designatedApprover || (currentUser && (currentUser.displayName || currentUser.email)) || "Manager";
                                  if (typeof setTopUpDraft === "function") {
                                    setTopUpDraft(prev => ({
                                      ...(prev || {}),
                                      amount: finalAmount,
                                      reasonCode: `Approved: ${req.reason}`,
                                      remarks: req.reason || "",
                                      isManagerApproved: true,
                                      approvedBy: approverName
                                    }));
                                  }
                                  if (typeof setCreditRequestQueue === "function") {
                                    setCreditRequestQueue(prev => (prev || []).map(r => r.id === req.id ? { ...r, status: "Approved", approvedAmount: finalAmount, approvedAt: new Date().toISOString(), approvedBy: approverName } : r));
                                  }
                                  logCustomerAuditEntry({
                                    customerId: req.customerId, customerName: req.customerName,
                                    action: `Approved £${finalAmount.toFixed(2)} credit (request originally £${req.amount}) by ${approverName}`,
                                    reason: req.reason,
                                    justificationNotes: `Approved credit request: ${req.reason}`
                                  });
                                  setWalletActiveTab("topup");
                                  alert(`Approved £${finalAmount.toFixed(2)}! Returned to the Add Credit form — you can now click Apply Credit.`);
                                }}
                                style={{ background: "#10B981", color: "#fff", border: "none", padding: "6px 12px", borderRadius: "6px", fontSize: "11px", fontWeight: 700, cursor: "pointer" }}
                              >✔ Approve & Return to Add Credit Form</button>
                              <button
                                onClick={() => {
                                  if (typeof setCreditRequestQueue === "function") {
                                    setCreditRequestQueue(prev => (prev || []).map(r => r.id === req.id ? { ...r, status: "Rejected", rejectedAt: new Date().toISOString(), rejectedBy: (currentUser && (currentUser.displayName || currentUser.email)) || "Manager" } : r));
                                  }
                                  logCustomerAuditEntry({ customerId: req.customerId, customerName: req.customerName, action: `Rejected credit request of £${Number(req.amount).toFixed(2)}`, reason: req.reason });
                                }}
                                style={{ background: "#EF4444", color: "#fff", border: "none", padding: "6px 12px", borderRadius: "6px", fontSize: "11px", fontWeight: 700, cursor: "pointer" }}
                              >✖ Reject</button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    <h4 style={{ fontSize: "13px", fontWeight: "700", color: "#374151", textTransform: "uppercase", margin: "20px 0 10px" }}>History</h4>
                    {(creditRequestQueue || []).filter(r => r.status !== "Pending").length === 0 ? (
                      <p style={{ color: "#9CA3AF", fontSize: "12px" }}>No processed requests yet.</p>
                    ) : (
                      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                        {(creditRequestQueue || []).filter(r => r.status !== "Pending").map((req) => (
                          <div key={req.id} style={{ fontSize: "12px", padding: "8px 10px", borderRadius: "6px", background: req.status === "Approved" ? "#ECFDF5" : "#FEF2F2", border: `1px solid ${req.status === "Approved" ? "#A7F3D0" : "#FECACA"}` }}>
                            <strong>{req.status}</strong> — {req.customerName || req.customerId} — £{Number(req.approvedAmount || req.amount).toFixed(2)} ({req.reason}) — Approver: {req.approvedBy || req.designatedApprover || "-"}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
                {walletActiveTab === "promocodes" && (() => {
                  const defaultUid = (walletActiveCustomer && (walletActiveCustomer.customerId || walletActiveCustomer.id || walletActiveCustomer.uid)) || (currentUser && currentUser.uid) || "";
                  const targetId = walletActiveCustomer ? normalizeWalletId(walletActiveCustomer.customerId || walletActiveCustomer.id || walletActiveCustomer.uid) : null;
                  const matchedUser = (customerProfiles || []).find(p => !isProviderEntity(p) && String(p.id || p.customerId || p.clientId || p.uid).toLowerCase() === String(defaultUid).toLowerCase())
                    || (customerList || []).find(c => !isProviderEntity(c) && String(c.customerId || c.id || c.uid).toLowerCase() === String(defaultUid).toLowerCase())
                    || {};
                  const resolvedUsername = matchedUser.customerName || matchedUser.username || matchedUser.name || matchedUser.displayName || (walletActiveCustomer && (walletActiveCustomer.customerName || walletActiveCustomer.username || walletActiveCustomer.name || walletActiveCustomer.displayName)) || "";
                  const rawVouchers = targetId ? effectiveVoucherRegistry.filter(v => normalizeWalletId(v.customerId) === targetId) : effectiveVoucherRegistry;
                  const vouchers = rawVouchers.map(v => {
                    const dateIssued = v.dateIssued || v.createdAt || new Date().toISOString();
                    const defaultExpiry = new Date(new Date(dateIssued).getTime() + NINETY_DAYS_MS).toISOString();
                    const expiryDate = v.expiryDate || defaultExpiry;
                    const isExpired = new Date() > new Date(expiryDate) && v.voucherStatus !== "Used";
                    const isCustUsed = (walletActiveCustomer?.voucherStatus === "Used" || Number(walletActiveCustomer?.discountAmount || walletActiveCustomer?.voucherDiscountAmount || 0) === 0);
                    const effectiveVoucherStatus = (v.voucherStatus === "Used" || (isCustUsed && v.voucherStatus !== "Active")) ? "Used" : (isExpired ? "Expired" : (v.voucherStatus || "Active"));
                    return { ...v, dateIssued, expiryDate, effectiveVoucherStatus };
                  });
                  return (
                    <div>
                      <div style={{ background: "#EFF6FF", border: "1px solid #BFDBFE", color: "#1E40AF", padding: "10px 14px", borderRadius: "8px", fontSize: "12px", marginBottom: "16px", fontWeight: "600", display: "flex", alignItems: "center", gap: "8px" }}>
                        <span>ℹ️</span>
                        <span><strong>Voucher Policy:</strong> A voucher is automatically marked <strong>Used</strong> (discount set to <strong>£0.00</strong>) only when consumed during a booking, synced directly on `users/{'{customerId}'}` and its `vouchers/{'{id}'}` sub-document. Vouchers also auto-expire 90 days after issue. No manual override is available.</span>
                      </div>
                      {walletActiveCustomer && (
                        <div style={{ background: "#ECFDF5", border: "1px solid #A7F3D0", color: "#065F46", padding: "8px 12px", borderRadius: "8px", fontSize: "11px", fontWeight: "600" }}>
                          🔄 Directly synced with document `users/{getExistingUserDocId(walletActiveCustomer)}` in Firestore.
                        </div>
                      )}
                      <h4 style={{ fontSize: "14px", fontWeight: "700", color: "#065F46", textTransform: "uppercase", marginBottom: "12px" }}>🎟 Issue New Voucher (90 Days Validity)</h4>
                      <div style={{ background: "#F9FAFB", border: "1px solid #E5E7EB", borderRadius: "10px", padding: "16px", marginBottom: "20px" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginBottom: "10px" }}>
                          <input
                            placeholder="Voucher Code (e.g. WELCOME10, BONUS50)"
                            value={(typeof voucherDraft !== "undefined" && voucherDraft.voucherCode) || ""}
                            disabled={typeof isIssuingVoucher !== "undefined" && isIssuingVoucher}
                            onChange={(e) => {
                              if (typeof setVoucherDraft === "function") {
                                setVoucherDraft(prev => ({...(prev || {}), voucherCode: e.target.value.toUpperCase()}));
                              }
                            }}
                            style={{ padding: "8px 10px", borderRadius: "6px", border: "1px solid #059669", fontSize: "13px", fontWeight: "700", background: "#ECFDF5" }}
                          />
                          <input
                            type="number"
                            placeholder="Discount Amount (£)"
                            value={(typeof voucherDraft !== "undefined" && voucherDraft.discountAmount) || ""}
                            disabled={typeof isIssuingVoucher !== "undefined" && isIssuingVoucher}
                            onChange={(e) => {
                              if (typeof setVoucherDraft === "function") {
                                setVoucherDraft(prev => ({...(prev || {}), discountAmount: e.target.value}));
                              }
                            }}
                            style={{ padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px" }}
                          />
                          <input
                            placeholder="Customer User ID (Auto from users/uid)"
                            value={(typeof voucherDraft !== "undefined" && voucherDraft.customerId !== undefined) ? voucherDraft.customerId : defaultUid}
                            readOnly={!!defaultUid}
                            disabled={typeof isIssuingVoucher !== "undefined" && isIssuingVoucher}
                            onChange={(e) => {
                              if (typeof setVoucherDraft === "function") {
                                setVoucherDraft(prev => ({...(prev || {}), customerId: e.target.value}));
                              }
                            }}
                            style={{ padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px", background: "#F3F4F6" }}
                          />
                          <input
                            placeholder="Username (Auto from users collection)"
                            value={(typeof voucherDraft !== "undefined" && voucherDraft.customerName !== undefined) ? voucherDraft.customerName : resolvedUsername}
                            disabled={typeof isIssuingVoucher !== "undefined" && isIssuingVoucher}
                            onChange={(e) => {
                              if (typeof setVoucherDraft === "function") {
                                setVoucherDraft(prev => ({...(prev || {}), customerName: e.target.value}));
                              }
                            }}
                            style={{ padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px", background: resolvedUsername ? "#F3F4F6" : "#fff" }}
                          />
                          <select
                            value={(typeof voucherDraft !== "undefined" && voucherDraft.voucherStatus) || "Active"}
                            disabled={typeof isIssuingVoucher !== "undefined" && isIssuingVoucher}
                            onChange={(e) => {
                              if (typeof setVoucherDraft === "function") {
                                setVoucherDraft(prev => ({...(prev || {}), voucherStatus: e.target.value}));
                              }
                            }}
                            style={{ padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px" }}
                          >
                            <option>Active</option>
                            <option>Used</option>
                          </select>
                          <div style={{ padding: "8px 10px", background: "#EFF6FF", borderRadius: "6px", border: "1px solid #BFDBFE", fontSize: "12px", color: "#1E40AF", display: "flex", alignItems: "center" }}>
                            📅 Expiry Date: <strong>90 Days (3 months) from issue date</strong>
                          </div>
                        </div>
                        <button
                          onClick={async () => {
                            const currentVoucherDraft = (typeof voucherDraft !== "undefined" ? voucherDraft : {});
                            const exactDocId = getExistingUserDocId(currentVoucherDraft.customerId || defaultUid);
                            if (!currentVoucherDraft.voucherCode) return alert("Please specify your Voucher Code.");
                            if (typeof setIsIssuingVoucher === "function") setIsIssuingVoucher(true);
                            try {
                              const issueDate = new Date();
                              const calculatedExpiryDate = new Date(issueDate.getTime() + NINETY_DAYS_MS).toISOString();
                              const discountVal = Number(currentVoucherDraft.discountAmount || 0);
                              const voucherEntry = {
                                id: Date.now().toString(),
                                customerId: exactDocId,
                                customerName: currentVoucherDraft.customerName || resolvedUsername || "",
                                username: currentVoucherDraft.customerName || resolvedUsername || "",
                                voucherCode: String(currentVoucherDraft.voucherCode || "").trim().toUpperCase(),
                                discountAmount: discountVal,
                                voucherDiscountAmount: discountVal,
                                originalDiscountAmount: discountVal,
                                voucherStatus: currentVoucherDraft.voucherStatus || "Active",
                                dateIssued: issueDate.toISOString(),
                                expiryDate: calculatedExpiryDate,
                                redeemedBookingId: "",
                                createdAt: new Date().toISOString()
                              };
                              if (typeof db !== "undefined" && exactDocId) {
                                if (typeof collection !== "undefined" && typeof addDoc !== "undefined") {
                                  await addDoc(collection(db, "users", exactDocId, "vouchers"), voucherEntry);
                                }
                                const userRef = doc(db, "users", exactDocId);
                                const userDocUpdate = {
                                  discountAmount: discountVal,
                                  voucherDiscountAmount: discountVal,
                                  voucherCode: voucherEntry.voucherCode,
                                  lastVoucherIssuedDate: issueDate.toISOString(),
                                  lastVoucherCode: voucherEntry.voucherCode,
                                  lastVoucherExpiryDate: calculatedExpiryDate,
                                  voucherExpiryDate: calculatedExpiryDate,
                                  voucherStatus: voucherEntry.voucherStatus || "Active",
                                  username: voucherEntry.customerName || resolvedUsername || ""
                                };
                                await setDoc(userRef, userDocUpdate, { merge: true });
                              }
                              if (typeof setCustomerList === 'function') {
                                setCustomerList(prev => (prev || []).map(c => String(c.customerId || c.id || c.uid || "").toLowerCase() === exactDocId.toLowerCase() ? { ...c, discountAmount: discountVal, voucherDiscountAmount: discountVal, voucherCode: voucherEntry.voucherCode, voucherStatus: voucherEntry.voucherStatus } : c));
                              }
                              if (typeof setCustomerProfiles === 'function') {
                                setCustomerProfiles(prev => (prev || []).map(c => String(c.clientId || c.customerId || c.uid || "").toLowerCase() === exactDocId.toLowerCase() ? { ...c, discountAmount: discountVal, voucherDiscountAmount: discountVal, voucherCode: voucherEntry.voucherCode, voucherStatus: voucherEntry.voucherStatus } : c));
                              }
                              if (typeof setVoucherRegistry === "function") {
                                setVoucherRegistry(prev => [voucherEntry, ...(prev || [])]);
                              }
                              try {
                                const localVouchers = JSON.parse(localStorage.getItem("voucherRegistry") || "[]");
                                localVouchers.unshift(voucherEntry);
                                localStorage.setItem("voucherRegistry", JSON.stringify(localVouchers));
                              } catch (errLocal) {}
                              if (typeof logActivityTrailEntry === "function") {
                                logActivityTrailEntry({
                                  customerId: exactDocId,
                                  customerName: voucherEntry.customerName || "",
                                  activityCategory: "TopUp",
                                  summary: `Voucher issued: ${voucherEntry.voucherCode} (£${discountVal.toFixed(2)}), expires ${new Date(calculatedExpiryDate).toLocaleDateString()}.`,
                                  staffHandle: currentVoucherDraft.staffHandle || (currentUser && (currentUser.displayName || currentUser.email)) || "Staff"
                                });
                              }
                              if (typeof setVoucherDraft === "function") setVoucherDraft({});
                              alert(`Voucher ${voucherEntry.voucherCode} with discount £${discountVal.toFixed(2)} issued successfully! Expires ${new Date(calculatedExpiryDate).toLocaleDateString()}.`);
                            } catch (err) {
                              console.error("Issue voucher error:", err);
                              alert("Failed to issue voucher: " + err.message);
                            } finally {
                              if (typeof setIsIssuingVoucher === "function") setIsIssuingVoucher(false);
                            }
                          }}
                          disabled={typeof isIssuingVoucher !== "undefined" && isIssuingVoucher}
                          style={{
                            background: (typeof isIssuingVoucher !== "undefined" && isIssuingVoucher) ? "#9CA3AF" : "#059669",
                            color: "#fff",
                            border: "none",
                            padding: "9px 18px",
                            borderRadius: "6px",
                            fontSize: "13px",
                            fontWeight: "700",
                            cursor: (typeof isIssuingVoucher !== "undefined" && isIssuingVoucher) ? "not-allowed" : "pointer"
                          }}
                        >
                          {(typeof isIssuingVoucher !== "undefined" && isIssuingVoucher) ? "💾 Issuing & Syncing..." : "💾 Apply & Issue Voucher — Sync & Persist"}
                        </button>
                      </div>
                      <h4 style={{ fontSize: "14px", fontWeight: "700", color: "#065F46", textTransform: "uppercase", marginBottom: "12px" }}>🎟 Voucher Management — PromoCode Registry (90 Days Validity)</h4>
                      {vouchers.length === 0 ? (
                        <p style={{ color: "#6B7280", fontSize: "13px" }}>No vouchers issued yet.</p>
                      ) : (
                        <div style={{ overflowX: "auto" }}>
                          <table style={{ width: "100%", minWidth: "850px", borderCollapse: "collapse", fontSize: "13px" }}>
                            <thead>
                              <tr style={{ background: "#F9FAFB" }}>
                                <th style={tableHeaderStyleLight}>Voucher Code</th>
                                <th style={tableHeaderStyleLight}>Customer User ID</th>
                                <th style={tableHeaderStyleLight}>Username / Name</th>
                                <th style={tableHeaderStyleLight}>Status</th>
                                <th style={tableHeaderStyleLight}>Date Issued</th>
                                <th style={tableHeaderStyleLight}>Expiry Date (90 Days)</th>
                                <th style={tableHeaderStyleLight}>Booking ID (Redeemed)</th>
                                <th style={tableHeaderStyleLight}>Discount Amount (£)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {vouchers.map((v) => {
                                const isGreyedOut = v.effectiveVoucherStatus === "Used" || v.effectiveVoucherStatus === "Expired";
                                const statusColor =
                                  v.effectiveVoucherStatus === "Used" ? { bg: "#E5E7EB", color: "#374151" } :
                                  v.effectiveVoucherStatus === "Expired" ? { bg: "#FEE2E2", color: "#991B1B" } :
                                  { bg: "#DCFCE7", color: "#166534" };
                                return (
                                  <tr key={v.id || `${v.customerId}_${v.voucherCode}`} style={{ borderBottom: "1px solid #F3F4F6", opacity: isGreyedOut ? 0.6 : 1, background: isGreyedOut ? "#F9FAFB" : "#ffffff" }}>
                                    <td style={tableDataStyle}><strong>{v.voucherCode}</strong></td>
                                    <td style={tableDataStyle}>{v.customerId}</td>
                                    <td style={tableDataStyle}>{v.customerName || v.username || "-"}</td>
                                    <td style={tableDataStyle}>
                                      <span style={{ background: statusColor.bg, color: statusColor.color, padding: "2px 8px", borderRadius: "10px", fontSize: "11px", fontWeight: "700", textTransform: "uppercase" }}>
                                        {v.effectiveVoucherStatus}
                                      </span>
                                    </td>
                                    <td style={tableDataStyle}>{v.dateIssued ? new Date(v.dateIssued).toLocaleDateString() : "-"}</td>
                                    <td style={tableDataStyle}>{v.expiryDate ? new Date(v.expiryDate).toLocaleDateString() : "-"}</td>
                                    <td style={tableDataStyle}>{v.redeemedBookingId || "-"}</td>
                                    <td style={tableDataStyle}>{v.discountAmount ? `£${Number(v.discountAmount).toFixed(2)}` : "£0.00"}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  );
                })()}
                {walletActiveTab === "reversals" && (() => {
                  const targetId = walletActiveCustomer ? normalizeWalletId(walletActiveCustomer.customerId || walletActiveCustomer.id || walletActiveCustomer.uid) : null;
                  const reversals = targetId ? (reversalLedger || []).filter(r => normalizeWalletId(r.customerId) === targetId) : (reversalLedger || []);
                  const reversalCountsByCustomer = getReversalCountsByCustomer(reversalLedger || []);
                  return (
                    <div>
                      <h4 style={{ fontSize: "14px", fontWeight: "700", color: "#065F46", textTransform: "uppercase", marginBottom: "12px" }}>↩ Record a Refund</h4>
                      <div style={{ background: "#F9FAFB", border: "1px solid #E5E7EB", borderRadius: "10px", padding: "16px", marginBottom: "20px" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginBottom: "10px" }}>
                          <input
                            placeholder="Customer User ID"
                            value={(reversalDraft && reversalDraft.customerId) || (walletActiveCustomer && (walletActiveCustomer.customerId || walletActiveCustomer.id || walletActiveCustomer.uid)) || (currentUser && currentUser.uid) || ""}
                            readOnly={!!walletActiveCustomer}
                            onChange={(e) => setReversalDraft(prev => ({...prev, customerId: e.target.value}))}
                            style={{ padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px", background: walletActiveCustomer ? "#F3F4F6" : "#fff" }}
                          />
                          <input
                            placeholder="Customer Name / Username"
                            value={(reversalDraft && reversalDraft.customerName) || (walletActiveCustomer && (walletActiveCustomer.customerName || walletActiveCustomer.name || walletActiveCustomer.username)) || ""}
                            readOnly={!!walletActiveCustomer}
                            onChange={(e) => setReversalDraft(prev => ({...prev, customerName: e.target.value}))}
                            style={{ padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px", background: walletActiveCustomer ? "#F3F4F6" : "#fff" }}
                          />
                          <input
                            type="number"
                            placeholder="Refund amount (£)"
                            value={(reversalDraft && reversalDraft.refundAmount) || ""}
                            disabled={isRecordingReversal}
                            onChange={(e) => setReversalDraft(prev => ({...prev, refundAmount: e.target.value}))}
                            style={{ padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px" }}
                          />
                          <input
                            placeholder="Booking ID"
                            value={(reversalDraft && reversalDraft.bookingId) || ""}
                            disabled={isRecordingReversal}
                            onChange={(e) => setReversalDraft(prev => ({...prev, bookingId: e.target.value}))}
                            style={{ padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px" }}
                          />
                          <input
                            placeholder="Approving administrator name"
                            value={(reversalDraft && reversalDraft.approvedByAdmin) || ""}
                            disabled={isRecordingReversal}
                            onChange={(e) => setReversalDraft(prev => ({...prev, approvedByAdmin: e.target.value}))}
                            style={{ padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px" }}
                          />
                        </div>
                        <textarea
                          placeholder="Refund reason"
                          value={(reversalDraft && reversalDraft.refundReason) || ""}
                          disabled={isRecordingReversal}
                          onChange={(e) => setReversalDraft(prev => ({...prev, refundReason: e.target.value}))}
                          style={{ width: "100%", minHeight: "50px", padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px", marginBottom: "10px", resize: "vertical" }}
                        />
                        <button
                          onClick={handleRecordReversal}
                          disabled={isRecordingReversal}
                          style={{
                            background: isRecordingReversal ? "#9CA3AF" : "#DC2626",
                            color: "#fff",
                            border: "none",
                            padding: "9px 18px",
                            borderRadius: "6px",
                            fontSize: "13px",
                            fontWeight: "700",
                            cursor: isRecordingReversal ? "not-allowed" : "pointer"
                          }}
                        >
                          {isRecordingReversal ? "💾 Recording..." : "💾 Record Refund (£)"}
                        </button>
                      </div>
                      <h4 style={{ fontSize: "14px", fontWeight: "700", color: "#065F46", textTransform: "uppercase", marginBottom: "12px" }}>↩ Refund Tracking — Reversal Ledger</h4>
                      {reversals.length === 0 ? (
                        <p style={{ color: "#6B7280", fontSize: "13px" }}>No refund history found.</p>
                      ) : (
                        <div style={{ overflowX: "auto" }}>
                          <table style={{ width: "100%", minWidth: "850px", borderCollapse: "collapse", fontSize: "13px" }}>
                            <thead>
                              <tr style={{ background: "#F9FAFB" }}>
                                <th style={tableHeaderStyleLight}>Date</th>
                                <th style={tableHeaderStyleLight}>Customer User ID</th>
                                <th style={tableHeaderStyleLight}>Refund Amount</th>
                                <th style={tableHeaderStyleLight}>Reason</th>
                                <th style={tableHeaderStyleLight}>Booking ID</th>
                                <th style={tableHeaderStyleLight}>Approved By</th>
                                <th style={tableHeaderStyleLight}>Repeat Requester</th>
                              </tr>
                            </thead>
                            <tbody>
                              {reversals.map((r) => {
                                const custKey = normalizeWalletId(r.customerId);
                                const repeatCount = reversalCountsByCustomer[custKey] || 0;
                                return (
                                  <tr key={r.id} style={{ borderBottom: "1px solid #F3F4F6" }}>
                                    <td style={tableDataStyle}>{new Date(r.reversalDate).toLocaleString()}</td>
                                    <td style={tableDataStyle}>{r.customerName || r.username || r.customerId}</td>
                                    <td style={tableDataStyle}>£{Number(r.refundAmount || 0).toFixed(2)}</td>
                                    <td style={tableDataStyle}>{r.refundReason || "-"}</td>
                                    <td style={tableDataStyle}>{r.bookingId || "-"}</td>
                                    <td style={tableDataStyle}>{r.approvedByAdmin || "-"}</td>
                                    <td style={tableDataStyle}>
                                      {repeatCount >= 3 ? (
                                        <span style={{ background: "#FEE2E2", color: "#991B1B", padding: "2px 8px", borderRadius: "10px", fontSize: "11px", fontWeight: "700" }}>
                                          ⚠ {repeatCount}x refunds
                                        </span>
                                      ) : (
                                        `${repeatCount}x`
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  );
                })()}
                {walletActiveTab === "activitytrail" && (() => {
                  const targetId = walletActiveCustomer ? normalizeWalletId(walletActiveCustomer.customerId || walletActiveCustomer.id || walletActiveCustomer.uid) : null;
                  const trailEntries = targetId ? (activityTrail || []).filter(a => normalizeWalletId(a.customerId) === targetId) : (activityTrail || []);
                  return (
                    <div>
                      <h4 style={{ fontSize: "14px", fontWeight: "700", color: "#065F46", textTransform: "uppercase", marginBottom: "12px" }}>🗂 Customer Notes & Activity Log</h4>
                      {trailEntries.length === 0 ? (
                        <p style={{ color: "#6B7280", fontSize: "13px" }}>No activity recorded yet.</p>
                      ) : (
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                          {trailEntries
                            .slice()
                            .sort((a, b) => new Date(b.occurredAt) - new Date(a.occurredAt))
                            .map((entry) => {
                              const categoryColor = {
                                InternalNote: { bg: "#FFFBEB", border: "#FDE68A", label: "📝 Internal Note" },
                                SupportConversation: { bg: "#EFF6FF", border: "#BFDBFE", label: "💬 Support Conversation" },
                                Reversal: { bg: "#FEF2F2", border: "#FECACA", label: "↩ Refund" },
                                TopUp: { bg: "#ECFDF5", border: "#A7F3D0", label: "💰 Credit Top-Up" },
                                BookingAction: { bg: "#F5F3FF", border: "#DDD6FE", label: "📅 Booking Action" }
                              }[entry.activityCategory] || { bg: "#F9FAFB", border: "#E5E7EB", label: entry.activityCategory };
                              return (
                                <div key={entry.id} style={{ background: categoryColor.bg, border: `1px solid ${categoryColor.border}`, borderRadius: "10px", padding: "12px 14px" }}>
                                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px", flexWrap: "wrap", gap: "6px" }}>
                                    <span style={{ fontSize: "11px", fontWeight: "700", color: "#374151" }}>{categoryColor.label}</span>
                                    <span style={{ fontSize: "11px", color: "#6B7280" }}>{new Date(entry.occurredAt).toLocaleString()}</span>
                                  </div>
                                  <p style={{ margin: 0, fontSize: "13px", color: "#111827", whiteSpace: "pre-wrap" }}>{entry.summary}</p>
                                  <div style={{ marginTop: "6px", fontSize: "11px", color: "#6B7280" }}>
                                    Customer: {entry.customerName || entry.username || entry.customerId} &nbsp;|&nbsp; Staff Issuer: <strong>{entry.staffHandle || "-"}</strong>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      )}
                    </div>
                  );
                })()}
                {walletActiveTab === "auditlog" && (() => {
                  const targetId = walletActiveCustomer ? normalizeWalletId(walletActiveCustomer.customerId || walletActiveCustomer.id || walletActiveCustomer.uid) : null;
                  const normalize = (v) => String(v ?? "").trim().toLowerCase();
                  const entries = targetId
                    ? (customerAuditLog || []).filter(a => normalize(a.customerId) === targetId)
                    : (customerAuditLog || []);
                  return (
                    <div>
                      <h4 style={{ fontSize: "14px", fontWeight: "700", color: "#111827", textTransform: "uppercase", marginBottom: "12px" }}>🔐 Access & Action Audit Log</h4>
                      <p style={{ fontSize: "12px", color: "#6B7280", marginBottom: "14px" }}>
                        Every sensitive access (View / Bookings / Promotions / Wallet / PII unlock) and credit action is recorded here: who, which customer, why, justification notes, when, what was done, and staff handle.
                      </p>
                      {entries.length === 0 ? (
                        <p style={{ color: "#9CA3AF", fontSize: "13px" }}>No audit entries yet.</p>
                      ) : (
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                          {entries.map((entry) => (
                            <div key={entry.id} style={{ background: "#F9FAFB", border: "1px solid #E5E7EB", borderRadius: "8px", padding: "10px 14px" }}>
                              <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "6px" }}>
                                <span style={{ fontSize: "12px", fontWeight: 700, color: "#111827" }}>👤 Staff Issuer: {entry.staffHandle}</span>
                                <span style={{ fontSize: "11px", color: "#6B7280" }}>{new Date(entry.timestamp).toLocaleString()}</span>
                              </div>
                              <p style={{ margin: "4px 0 0", fontSize: "13px", color: "#374151" }}>
                                <strong>{entry.action}</strong> — Customer: {entry.customerName} ({entry.customerId})
                              </p>
                              <p style={{ margin: "2px 0 0", fontSize: "12px", color: "#6B7280" }}>Reason: {entry.reason}</p>
                              {entry.justificationNotes && (
                                <div style={{ margin: "4px 0 0", fontSize: "12px", color: "#065F46", background: "#ECFDF5", padding: "4px 8px", borderRadius: "4px", border: "1px solid #A7F3D0" }}>
                                  📝 <strong>Justification Notes:</strong> {entry.justificationNotes}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })()}
              </div>
              <div className="modal-footer" style={{ padding: "14px 24px", background: "#F9FAFB", borderTop: "1px solid #E5E7EB", textAlign: "right" }}>
                <button onClick={handleCloseWalletModule} style={{ background: "#fff", border: "1px solid #D1D5DB", padding: "8px 16px", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* ========================================================================= */}
      {/* 🛡 MODAL 1: REQUEST CREDIT APPROVAL (> £20) WITH PASSCODE AUTH            */}
      {/* ========================================================================= */}
      {showCreditRequestModal && (
        <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(17, 24, 39, 0.7)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 12500, padding: "20px" }}>
          <div style={{ backgroundColor: "#ffffff", borderRadius: "16px", padding: "26px", width: "480px", maxWidth: "94vw", boxShadow: "0 25px 50px rgba(0,0,0,0.25)", fontFamily: "'Inter', sans-serif" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "14px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <div style={{ width: "36px", height: "36px", borderRadius: "50%", background: "#FEE2E2", color: "#DC2626", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px" }}>🛡</div>
                <h4 style={{ margin: 0, fontSize: "16px", fontWeight: "800", color: "#111827" }}>Request Credit Approval (&gt; £20)</h4>
              </div>
              <button onClick={closeCreditRequestModal} style={{ background: "transparent", border: "none", fontSize: "20px", cursor: "pointer", color: "#6B7280" }}>&times;</button>
            </div>
            <p style={{ margin: "0 0 14px", fontSize: "12px", color: "#6B7280" }}>
              Specify the credit amount exceeding £20, the mandatory business reason, and designate the approving authority.
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginBottom: "14px" }}>
              <div>
                <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "#374151", marginBottom: "4px", textTransform: "uppercase" }}>Target Customer Full Name</label>
                <input
                  readOnly
                  value={walletActiveCustomer ? `${walletActiveCustomer.customerName || walletActiveCustomer.name || walletActiveCustomer.username || "Customer"} (${walletActiveCustomer.customerId || walletActiveCustomer.id || walletActiveCustomer.uid || "-"})` : "Select a customer"}
                  style={{ width: "100%", boxSizing: "border-box", padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px", background: "#F3F4F6", fontWeight: "600" }}
                />
              </div>
              <div>
                <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "#374151", marginBottom: "4px", textTransform: "uppercase" }}>
                  Requested Amount (£) <span style={{ color: "#DC2626" }}>*</span>
                </label>
                <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "6px" }}>
                  {HIGH_CREDIT_PRESETS.map((amt) => (
                    <button
                      key={amt}
                      type="button"
                      onClick={() => typeof setCreditRequestDraft === "function" && setCreditRequestDraft(prev => ({ ...prev, amount: amt }))}
                      style={{
                        padding: "5px 10px", borderRadius: "6px",
                        border: Number(creditRequestDraft?.amount) === amt ? "2px solid #DC2626" : "1px solid #D1D5DB",
                        background: Number(creditRequestDraft?.amount) === amt ? "#FEF2F2" : "#fff",
                        color: Number(creditRequestDraft?.amount) === amt ? "#DC2626" : "#374151",
                        fontSize: "12px", fontWeight: "700", cursor: "pointer"
                      }}
                    >
                      £{amt}
                    </button>
                  ))}
                </div>
                <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                  <span style={{ position: "absolute", left: "10px", fontWeight: "700", color: "#374151", fontSize: "13px" }}>£</span>
                  <input
                    type="number"
                    placeholder="Or enter custom amount > 20"
                    value={(creditRequestDraft && creditRequestDraft.amount) || ""}
                    onChange={(e) => typeof setCreditRequestDraft === "function" && setCreditRequestDraft(prev => ({ ...prev, amount: e.target.value }))}
                    style={{ width: "100%", boxSizing: "border-box", padding: "8px 10px 8px 24px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px" }}
                  />
                </div>
              </div>
              <div>
                <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "#374151", marginBottom: "4px", textTransform: "uppercase" }}>
                  Select Approver <span style={{ color: "#DC2626" }}>*</span>
                </label>
                <select
                  value={(creditRequestDraft && creditRequestDraft.designatedApprover) || ""}
                  onChange={(e) => typeof setCreditRequestDraft === "function" && setCreditRequestDraft(prev => ({ ...prev, designatedApprover: e.target.value }))}
                  style={{ width: "100%", boxSizing: "border-box", padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px", background: "#fff" }}
                >
                  <option value="" disabled>Choose approving staff member...</option>
                  {APPROVER_STAFF_LIST.map((name) => (
                    <option key={name} value={name}>{name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "#374151", marginBottom: "4px", textTransform: "uppercase" }}>
                  Reason &amp; Justification <span style={{ color: "#DC2626" }}>*</span>
                </label>
                <textarea
                  placeholder="State detailed business reason (e.g. Service failure compensation approved on phone)"
                  value={(creditRequestDraft && creditRequestDraft.reason) || ""}
                  onChange={(e) => typeof setCreditRequestDraft === "function" && setCreditRequestDraft(prev => ({ ...prev, reason: e.target.value }))}
                  style={{ width: "100%", boxSizing: "border-box", minHeight: "65px", padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px", resize: "vertical" }}
                />
              </div>
              <div>
                <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "#374151", marginBottom: "4px", textTransform: "uppercase" }}>Requested By</label>
                <input
                  placeholder="Your Staff Name"
                  value={(creditRequestDraft && creditRequestDraft.requestedBy) || (currentUser && (currentUser.displayName || currentUser.email)) || ""}
                  onChange={(e) => typeof setCreditRequestDraft === "function" && setCreditRequestDraft(prev => ({ ...prev, requestedBy: e.target.value }))}
                  style={{ width: "100%", boxSizing: "border-box", padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px" }}
                />
              </div>
              {/* Security Passcode Verification */}
              <div style={{ background: "#FEF2F2", border: "1px solid #FECACA", padding: "12px", borderRadius: "8px" }}>
                <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "#991B1B", marginBottom: "4px", textTransform: "uppercase" }}>
                  🔑 Security Passcode Authentication <span style={{ color: "#DC2626" }}>*</span>
                </label>
                <input
                  type="password"
                  maxLength={6}
                  placeholder="Enter security code"
                  value={creditReqPassword}
                  onChange={(e) => {
                    window.__creditReqPassword = e.target.value;
                    window.__creditReqPasswordError = "";
                    triggerCustomerListRender();
                  }}
                  style={{ width: "100%", boxSizing: "border-box", padding: "8px 10px", borderRadius: "6px", border: "1px solid #DC2626", fontSize: "13px", background: "#fff" }}
                />
                {creditReqPasswordError && (
                  <p style={{ margin: "6px 0 0", fontSize: "12px", color: "#DC2626", fontWeight: "700" }}>{creditReqPasswordError}</p>
                )}
              </div>
            </div>
            <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
              <button
                onClick={closeCreditRequestModal}
                style={{ backgroundColor: "#F3F4F6", color: "#374151", padding: "8px 16px", borderRadius: "6px", border: "none", cursor: "pointer", fontSize: "13px", fontWeight: 600 }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  const rawCust = walletActiveCustomer && (walletActiveCustomer.customerId || walletActiveCustomer.id || walletActiveCustomer.uid);
                  const amount = Number((creditRequestDraft && creditRequestDraft.amount) || 0);
                  const reason = (creditRequestDraft && creditRequestDraft.reason) || "";
                  const designatedApprover = (creditRequestDraft && creditRequestDraft.designatedApprover) || "";
                  const requestedBy = (creditRequestDraft && creditRequestDraft.requestedBy) || (currentUser && (currentUser.displayName || currentUser.email)) || "Staff";
                  if (!rawCust) return alert("Please select a customer first.");
                  if (!amount || amount <= MAX_NORMAL_STAFF_CREDIT) return alert(`Requested amount must be greater than £${MAX_NORMAL_STAFF_CREDIT}.`);
                  if (!designatedApprover) return alert("Please select an approver from the dropdown.");
                  if (!reason.trim()) return alert("A valid reason is required.");
                  if ((window.__creditReqPassword || "").trim() !== SECURITY_PASSCODE) {
                    window.__creditReqPasswordError = "Incorrect security passcode. Authorization denied.";
                    triggerCustomerListRender();
                    return;
                  }
                  const newRequest = {
                    id: `${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
                    customerId: getExistingUserDocId(rawCust),
                    customerName: walletActiveCustomer.customerName || walletActiveCustomer.name || walletActiveCustomer.username || "",
                    amount,
                    reason,
                    designatedApprover,
                    requestedBy,
                    status: "Pending",
                    requestedAt: new Date().toISOString()
                  };
                  if (typeof setCreditRequestQueue === "function") {
                    setCreditRequestQueue(prev => [newRequest, ...(prev || [])]);
                  }
                  logCustomerAuditEntry({
                    customerId: newRequest.customerId,
                    customerName: newRequest.customerName,
                    action: `Submitted request for £${amount.toFixed(2)} credit (Approver designated: ${designatedApprover})`,
                    reason,
                    justificationNotes: `Credit approval request: ${reason}`
                  });
                  if (typeof setCreditRequestDraft === "function") setCreditRequestDraft({});
                  closeCreditRequestModal();
                  alert(`Credit request for £${amount.toFixed(2)} submitted to ${designatedApprover}!`);
                }}
                style={{ backgroundColor: "#DC2626", color: "#fff", padding: "8px 18px", borderRadius: "6px", border: "none", cursor: "pointer", fontSize: "13px", fontWeight: 700 }}
              >
                📨 Submit Request
              </button>
            </div>
          </div>
        </div>
      )}
      {/* ========================================================================= */}
      {/* ⭐ MODAL 2: CREDIT APPROVAL MODAL (&gt; £20) WITH PASSCODE AUTH            */}
      {/* ========================================================================= */}
      {showCreditApprovalModal && (
        <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(17, 24, 39, 0.7)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 12600, padding: "20px" }}>
          <div style={{ backgroundColor: "#ffffff", borderRadius: "16px", padding: "26px", width: "520px", maxWidth: "94vw", boxShadow: "0 25px 50px rgba(0,0,0,0.25)", fontFamily: "'Inter', sans-serif" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <div style={{ width: "36px", height: "36px", borderRadius: "50%", background: "#EDE9FE", color: "#7C3AED", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px" }}>⭐</div>
                <h4 style={{ margin: 0, fontSize: "16px", fontWeight: "800", color: "#111827" }}>Credit Approval &amp; Tiers (&gt; £20)</h4>
              </div>
              <button onClick={closeCreditApprovalModal} style={{ background: "transparent", border: "none", fontSize: "20px", cursor: "pointer", color: "#6B7280" }}>&times;</button>
            </div>
            <p style={{ margin: "0 0 16px", fontSize: "12px", color: "#6B7280" }}>
              Select an authorized credit amount greater than £20 (or custom) to return it directly into the <strong>Add Credit Form</strong>.
            </p>
            <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "#374151", marginBottom: "6px", textTransform: "uppercase" }}>
              1. Choose Approving Authority
            </label>
            <select
              id="credit-approval-selected-authority"
              defaultValue={APPROVER_STAFF_LIST[0]}
              style={{ width: "100%", boxSizing: "border-box", padding: "8px 10px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px", background: "#fff", marginBottom: "14px" }}
            >
              {APPROVER_STAFF_LIST.map((name) => (
                <option key={name} value={name}>{name} (Authorized Approver)</option>
              ))}
            </select>
            {/* Passcode Authentication Block */}
            <div style={{ background: "#F5F3FF", border: "1px solid #DDD6FE", padding: "12px", borderRadius: "8px", marginBottom: "14px" }}>
              <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "#5B21B6", marginBottom: "4px", textTransform: "uppercase" }}>
                🔑 Enter Approver Passcode <span style={{ color: "#DC2626" }}>*</span>
              </label>
              <input
                type="password"
                maxLength={6}
                placeholder="Enter security code"
                value={creditApprPassword}
                onChange={(e) => {
                  window.__creditApprPassword = e.target.value;
                  window.__creditApprPasswordError = "";
                  triggerCustomerListRender();
                }}
                style={{ width: "100%", boxSizing: "border-box", padding: "8px 10px", borderRadius: "6px", border: "1px solid #7C3AED", fontSize: "13px", background: "#fff" }}
              />
              {creditApprPasswordError && (
                <p style={{ margin: "6px 0 0", fontSize: "12px", color: "#DC2626", fontWeight: "700" }}>{creditApprPasswordError}</p>
              )}
            </div>
            <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "#374151", marginBottom: "6px", textTransform: "uppercase" }}>
              2. Select Approved Amount (&gt; £20)
            </label>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "8px", marginBottom: "12px" }}>
              {HIGH_CREDIT_PRESETS.map((amountTier) => (
                <button
                  key={amountTier}
                  type="button"
                  onClick={() => {
                    if ((window.__creditApprPassword || "").trim() !== SECURITY_PASSCODE) {
                      window.__creditApprPasswordError = "Incorrect security passcode. Authorization denied.";
                      triggerCustomerListRender();
                      return;
                    }
                    const approverEl = document.getElementById("credit-approval-selected-authority");
                    const approver = approverEl ? approverEl.value : "Authorized Manager";
                    if (typeof setTopUpDraft === "function") {
                      setTopUpDraft(prev => ({
                        ...(prev || {}),
                        amount: amountTier,
                        customAmount: amountTier,
                        isManagerApproved: true,
                        approvedBy: approver,
                        reasonCode: prev?.reasonCode || "Manager Approved Goodwill"
                      }));
                    }
                    closeCreditApprovalModal();
                    setWalletActiveTab("topup");
                    alert(`£${amountTier.toFixed(2)} credit approved by ${approver}! Returned to Add Credit form. You can now finalize and apply.`);
                  }}
                  style={{
                    padding: "12px",
                    borderRadius: "8px",
                    border: "2px solid #7C3AED",
                    background: "#F5F3FF",
                    color: "#5B21B6",
                    fontWeight: "800",
                    fontSize: "15px",
                    cursor: "pointer",
                    transition: "all 0.15s ease",
                    textAlign: "center"
                  }}
                >
                  £{amountTier}
                </button>
              ))}
            </div>
            <div style={{ background: "#F9FAFB", padding: "12px", borderRadius: "8px", border: "1px solid #E5E7EB", marginBottom: "14px" }}>
              <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "#374151", marginBottom: "4px", textTransform: "uppercase" }}>
                Or Custom Approved Amount (£)
              </label>
              <div style={{ display: "flex", gap: "8px" }}>
                <div style={{ position: "relative", flex: 1, display: "flex", alignItems: "center" }}>
                  <span style={{ position: "absolute", left: "10px", fontWeight: "700", color: "#374151", fontSize: "13px" }}>£</span>
                  <input
                    type="number"
                    id="custom-credit-approval-amount"
                    placeholder="e.g. 150"
                    style={{ width: "100%", boxSizing: "border-box", padding: "8px 10px 8px 24px", borderRadius: "6px", border: "1px solid #D1D5DB", fontSize: "13px" }}
                  />
                </div>
                <button
                  type="button"
                  onClick={() => {
                    if ((window.__creditApprPassword || "").trim() !== SECURITY_PASSCODE) {
                      window.__creditApprPasswordError = "Incorrect security passcode. Authorization denied.";
                      triggerCustomerListRender();
                      return;
                    }
                    const inp = document.getElementById("custom-credit-approval-amount");
                    const val = Number(inp?.value || 0);
                    if (!val || val <= MAX_NORMAL_STAFF_CREDIT) return alert(`Please enter an amount greater than £${MAX_NORMAL_STAFF_CREDIT}.`);
                    const approverEl = document.getElementById("credit-approval-selected-authority");
                    const approver = approverEl ? approverEl.value : "Authorized Manager";
                    if (typeof setTopUpDraft === "function") {
                      setTopUpDraft(prev => ({
                        ...(prev || {}),
                        amount: val,
                        customAmount: val,
                        isManagerApproved: true,
                        approvedBy: approver,
                        reasonCode: prev?.reasonCode || "Manager Approved Goodwill"
                      }));
                    }
                    closeCreditApprovalModal();
                    setWalletActiveTab("topup");
                    alert(`Custom £${val.toFixed(2)} credit approved by ${approver}! Returned to Add Credit form.`);
                  }}
                  style={{ background: "#7C3AED", color: "#fff", border: "none", padding: "8px 14px", borderRadius: "6px", fontSize: "12px", fontWeight: "700", cursor: "pointer" }}
                >
                  Apply to Form
                </button>
              </div>
            </div>
            <div style={{ textAlign: "right" }}>
              <button
                onClick={closeCreditApprovalModal}
                style={{ backgroundColor: "#F3F4F6", color: "#374151", padding: "8px 16px", borderRadius: "6px", border: "none", cursor: "pointer", fontSize: "13px", fontWeight: 600 }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {/* ============================================================= */}
      {/* ============ SECURITY GATE STEP 1: REASON MODAL ============ */}
      {/* ============================================================= */}
      {customerShieldPhase === "prompt_reason" && (
        <div
          style={{ position: "fixed", inset: 0, backgroundColor: "rgba(17, 24, 39, 0.65)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 11000 }}
          onClick={terminateCustomerShield}
        >
          <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: "#fff", borderRadius: "14px", padding: "24px", width: "420px", maxWidth: "90vw", boxShadow: "0 20px 40px rgba(0,0,0,0.2)", fontFamily: "'Inter', sans-serif" }}>
            <h4 style={{ margin: "0 0 6px 0", fontSize: "16px", fontWeight: 700, color: "#111827" }}>🔒 Security Gate: Justification Required</h4>
            <p style={{ margin: "0 0 14px 0", fontSize: "13px", color: "#6B7280" }}>
              Please provide a business justification before accessing <strong>{SCOPE_LABELS[customerShieldIntentScope] || "this record"}</strong>.
            </p>
            <p style={{ margin: "0 0 6px 0", fontSize: "12px", color: "#9CA3AF" }}>
              Target Customer: <strong>{customerShieldTargetEntity?.customerName || customerShieldTargetEntity?.name || customerShieldTargetEntity?.username || customerShieldTargetEntity?.customerId || customerShieldTargetEntity?.id}</strong>
            </p>
            <label style={{ display: "block", fontSize: "12px", fontWeight: 600, color: "#374151", marginBottom: "4px" }}>
              Reason for Access <span style={{ color: "#DC2626" }}>*</span>
            </label>
            <select
              value={customerShieldAccessReason || ""}
              onChange={(e) => typeof setCustomerShieldAccessReason === "function" && setCustomerShieldAccessReason(e.target.value)}
              style={{ width: "100%", boxSizing: "border-box", border: "1px solid #D1D5DB", borderRadius: "8px", padding: "8px 10px", fontSize: "13px", marginBottom: "10px", backgroundColor: "#fff", color: "#111827" }}
            >
              <option value="" disabled>Select a reason…</option>
              <option value="Support Ticket">Support Ticket</option>
              <option value="Existing Booking">Existing Booking</option>
              <option value="Payment Related">Payment Related</option>
              <option value="Profile Update">Profile Update</option>
              <option value="Fraud/Compliance Review">Fraud/Compliance Review</option>
              <option value="Other">Other</option>
            </select>
            <label style={{ display: "block", fontSize: "12px", fontWeight: 600, color: "#374151", marginBottom: "4px" }}>Additional Justification Notes</label>
            <textarea
              value={customerShieldJustificationNote}
              onChange={(e) => typeof setCustomerShieldJustificationNote === "function" && setCustomerShieldJustificationNote(e.target.value)}
              placeholder="e.g. Customer contacted support regarding an existing booking."
              rows={3}
              style={{ width: "100%", boxSizing: "border-box", border: "1px solid #D1D5DB", borderRadius: "8px", padding: "8px 10px", fontSize: "13px", resize: "vertical", marginBottom: "8px" }}
            />
            {customerShieldValidationAlert && (<p style={{ margin: "0 0 8px 0", fontSize: "12px", color: "#EF4444" }}>{customerShieldValidationAlert}</p>)}
            <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end", marginTop: "6px" }}>
              <button onClick={terminateCustomerShield} style={{ backgroundColor: "#F3F4F6", color: "#374151", padding: "8px 14px", borderRadius: "8px", border: "none", cursor: "pointer", fontSize: "13px", fontWeight: 600 }}>Cancel</button>
              <button onClick={advanceCustomerShieldToOtp} style={{ backgroundColor: "#2563EB", color: "#fff", padding: "8px 14px", borderRadius: "8px", border: "none", cursor: "pointer", fontSize: "13px", fontWeight: 600 }}>Continue</button>
            </div>
          </div>
        </div>
      )}
      {/* =============================================================== */}
      {/* ==== SECURITY GATE STEP 2: ONE-TIME VERIFICATION CODE MODAL ==== */}
      {/* =============================================================== */}
      {customerShieldPhase === "prompt_otp" && (
        <div
          style={{ position: "fixed", inset: 0, backgroundColor: "rgba(17, 24, 39, 0.65)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 11000 }}
          onClick={terminateCustomerShield}
        >
          <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: "#fff", borderRadius: "14px", padding: "24px", width: "360px", maxWidth: "90vw", boxShadow: "0 20px 40px rgba(0,0,0,0.2)", fontFamily: "'Inter', sans-serif", textAlign: "center" }}>
            <h4 style={{ margin: "0 0 6px 0", fontSize: "16px", fontWeight: 700, color: "#111827" }}>🔑 Enter One-Time Verification Code</h4>
            <p style={{ margin: "0 0 10px 0", fontSize: "13px", color: "#6B7280" }}>
              A single-use 6-digit code has been issued to unlock <strong>{SCOPE_LABELS[customerShieldIntentScope] || "this record"}</strong>. This code can only be used once.
            </p>
            {window.__customerShieldOtp?.code && (
              <p style={{ margin: "0 0 12px 0", fontSize: "11px", color: "#9CA3AF", background: "#F9FAFB", border: "1px dashed #E5E7EB", borderRadius: "8px", padding: "6px 8px" }}>
                Demo mode — in production this would be delivered by SMS/email. Your code: <strong style={{ color: "#111827", letterSpacing: "2px" }}>{window.__customerShieldOtp.code}</strong>
              </p>
            )}
            <input
              type="password"
              inputMode="numeric"
              maxLength={6}
              value={customerShieldPasscodeSecret}
              onChange={(e) => typeof setCustomerShieldPasscodeSecret === "function" && setCustomerShieldPasscodeSecret(e.target.value.replace(/\D/g, ""))}
              placeholder="••••••"
              autoFocus
              style={{ width: "170px", textAlign: "center", letterSpacing: "8px", fontSize: "22px", border: "1px solid #D1D5DB", borderRadius: "8px", padding: "8px 10px", marginBottom: "8px" }}
            />
            {customerShieldValidationAlert && (<p style={{ margin: "0 0 8px 0", fontSize: "12px", color: "#EF4444" }}>{customerShieldValidationAlert}</p>)}
            <div style={{ display: "flex", gap: "8px", justifyContent: "center", marginTop: "10px" }}>
              <button onClick={terminateCustomerShield} style={{ backgroundColor: "#F3F4F6", color: "#374151", padding: "8px 14px", borderRadius: "8px", border: "none", cursor: "pointer", fontSize: "13px", fontWeight: 600 }}>Cancel</button>
              <button onClick={confirmCustomerShieldOtp} style={{ backgroundColor: "#10B981", color: "#fff", padding: "8px 14px", borderRadius: "8px", border: "none", cursor: "pointer", fontSize: "13px", fontWeight: 600 }}>Verify & Unlock</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
})()}


{/* ✅ VERIFICATION DOCUMENTS */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "verificationDocuments" &&
  showVerificationDocuments && (() => {
    /* ================= TOAST HELPER (defined inside the JSX, no external state needed) ================= */
    const showToast = (message, type = "success") => {
      try {
        const colors = {
          success: "#16A34A",
          error: "#DC2626",
          warning: "#D97706",
          info: "#2563EB",
        };
        const icons = {
          success: "✔",
          error: "✖",
          warning: "⚠",
          info: "ℹ",
        };
        let container = document.getElementById("vd-toast-container");
        if (!container) {
          container = document.createElement("div");
          container.id = "vd-toast-container";
          Object.assign(container.style, {
            position: "fixed",
            top: "20px",
            right: "20px",
            zIndex: "2000",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          });
          document.body.appendChild(container);
        }
        const toastEl = document.createElement("div");
        toastEl.textContent = `${icons[type] || icons.info} ${message}`;
        Object.assign(toastEl.style, {
          minWidth: "280px",
          maxWidth: "380px",
          padding: "12px 16px",
          borderRadius: "8px",
          color: "#fff",
          fontSize: "14px",
          fontWeight: "500",
          fontFamily: "'Inter', sans-serif",
          boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
          background: colors[type] || colors.info,
        });
        container.appendChild(toastEl);
        toastEl.animate(
          [
            { transform: "translateX(120%)", opacity: 0 },
            { transform: "translateX(0)", opacity: 1 },
          ],
          { duration: 300, easing: "ease-out" }
        );
        setTimeout(() => {
          const fade = toastEl.animate([{ opacity: 1 }, { opacity: 0 }], {
            duration: 300,
          });
          fade.onfinish = () => toastEl.remove();
        }, 4000);
      } catch (e) {
        console.warn("Toast failed to render:", e);
      }
    };

    return (
    <div className="admin-container">
      {/* HEADER */}
      <div style={headerStyle}>
        <h3 style={titleStyle}>Verification Documents</h3>
      </div>
      {/* CARD */}
      <div style={cardStyle}>
         <div
      style={{
        ...cardStyle,
        maxWidth: "1500px",
        margin: "0 auto",
        width: "100%",
      }}
    >
    {/* ================= KEYFRAMES ================= */}
    <style>{`
      @keyframes fullSpin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    `}</style>
    {/* ================= GLOBAL OVERLAY LOADER ================= */}
    {fetchingDocs && (
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(255,255,255,0.7)",
          backdropFilter: "blur(2px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 999,
          borderRadius: "12px",
        }}
      >
        <div
          style={{
            width: "60px",
            height: "60px",
            border: "5px solid #e5e7eb",
            borderTop: "5px solid #2563eb",
            borderRadius: "50%",
            animation: "fullSpin 0.8s linear infinite",
          }}
        />
      </div>
    )}
    {/* ================= HEADER ================= */}
    <div
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        marginBottom: "20px",
        textAlign: "center",
      }}
    >
      <h3
        style={{
          margin: 0,
          fontFamily: "'Poppins', sans-serif",
          fontSize: "24px",
          fontWeight: "700",
          color: "#111827",
        }}
      >
        📝 New Provider Verifications
      </h3>
      {/* 🔔 + 💡 STATS BAR */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          marginTop: "12px",
          flexWrap: "wrap",
          fontFamily: "'Inter', sans-serif",
        }}
      >
        {/* 🔔 Total Providers */}
        <div
          style={{
            background: "#EFF6FF",
            padding: "8px 14px",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: "600",
            color: "#1D4ED8",
          }}
        >
          🔔 Total Providers: {docs.length}
        </div>
        {/* 💡 Status Counts */}
        {(() => {
          let approved = 0;
          let rejected = 0;
          let pending = 0;
          docs.forEach((doc) => {
            const history = verificationApprovalRegistry[doc.id]?.history || [];
            const latest = history[history.length - 1];
            if (!latest) {
              pending++;
            } else if (latest.status === "approved") {
              approved++;
            } else if (latest.status === "rejected") {
              rejected++;
            }
          });
          return (
            <>
              <div
                style={{
                  background: "#ECFDF5",
                  padding: "8px 14px",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#065F46",
                }}
              >
                💡 Approved: {approved}
              </div>
              <div
                style={{
                  background: "#FEF2F2",
                  padding: "8px 14px",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#991B1B",
                }}
              >
                💡 Rejected: {rejected}
              </div>
              <div
                style={{
                  background: "#FFFBEB",
                  padding: "8px 14px",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#92400E",
                }}
              >
                💡 Pending: {pending}
              </div>
            </>
          );
        })()}
      </div>
      {/* FETCH BUTTON */}
      <button
        onClick={handleFetchVerificationDocs}
        disabled={fetchingDocs}
        style={{
          marginTop: "12px",
          padding: "10px 16px",
          backgroundColor: "#2563eb",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: fetchingDocs ? "not-allowed" : "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          marginInline: "auto",
          minWidth: "170px",
          opacity: fetchingDocs ? 0.85 : 1,
        }}
      >
        {fetchingDocs ? (
          <span
            style={{
              width: "16px",
              height: "16px",
              border: "2px solid rgba(255,255,255,0.5)",
              borderTop: "2px solid #ffffff",
              borderRadius: "50%",
              display: "inline-block",
              animation: "btnSpin 0.6s linear infinite",
            }}
          />
        ) : (
          <span>📄</span>
        )}
        <span>{fetchingDocs ? "Loading..." : "Fetch Documents"}</span>
      </button>
    </div>
   {/* ================= CONTENT ================= */}
{fetchingDocs && docs.length === 0 ? (
  <p style={{ textAlign: "center", fontSize: "15px" }}>
    Fetching verification documents...
  </p>
) : docs.length === 0 ? (
  <p style={{ textAlign: "center", fontSize: "15px" }}>
    No verification documents found.
  </p>
) : (
  <div
    style={{
      background: "#fff",
      padding: "20px",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
      overflowX: "auto",
    }}
  >
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        fontSize: "14px",
        minWidth: "2600px",
      }}
    >
      <thead style={{ background: "#F3F4F6" }}>
        <tr>
          <th style={tableHeadCell}>Provider ID</th>
          <th style={tableHeadCell}>DOB</th>
          <th style={tableHeadCell}>Status</th>
          <th style={tableHeadCell}>Verification Type</th>
          <th style={tableHeadCell}>Visa Type</th>
          <th style={tableHeadCell}>Share Code</th>
          <th style={tableHeadCell}>British / Irish</th>
          <th style={tableHeadCell}>Student</th>
          <th style={tableHeadCell}>Confirmed</th>
          <th style={tableHeadCell}>Passport From</th>
          <th style={tableHeadCell}>Passport Until</th>
          <th style={tableHeadCell}>Visa From</th>
          <th style={tableHeadCell}>Visa Until</th>
          <th style={tableHeadCell}>Submitted At</th>
          <th style={tableHeadCell}>Updated At</th>
          <th style={tableHeadCell}>Document Requirements</th>
          <th style={tableHeadCell}>Birth Certificate</th>
          <th style={tableHeadCell}>Driving Licence</th>
          <th style={tableHeadCell}>Passport</th>
          <th style={tableHeadCell}>Student Restriction</th>
          <th style={tableHeadCell}>All Students</th>
          <th style={tableHeadCell}>Full Time Allowed</th>
          <th style={tableHeadCell}>Max Hours / Week</th>
          <th style={tableHeadCell}>Requires Term Dates</th>
          <th style={tableHeadCell}>Restriction Type</th>
          <th style={tableHeadCell}>Approval</th>
          <th style={tableHeadCell}>Admin User</th>
          <th style={tableHeadCell}>Latest Note</th>
          <th style={tableHeadCell}>Timestamp</th>
          <th style={tableHeadCell}>History</th>
          <th style={tableHeadCell}>Actions</th>
        </tr>
        {/* ================= FILTER ROW ================= */}
        <tr>
          {[
            "userId","dateOfBirth","status","verificationType","visaType","shareCode",
            "isBritishOrIrish","isStudent","hasConfirmed","passportValidFrom",
            "passportValidUntil","visaValidFrom","visaValidUntil","submittedAt",
            "updatedAt","documentRequirements","birth_certificate",
            "driving_licence","passport","studentRestriction","allStudents",
            "fullTimeAllowed","maxHoursPerWeek","requiresTermDates",
            "restrictionType","approval","adminUser","note","time"
          ].map((key, i) => (
            <th key={i} style={tableHeadCell}>
              <input
                type="text"
                placeholder="Type..."
                onChange={(e) =>
                  handleTableFilterChange(key, e.target.value)
                }
                style={{
                  width: "100%",
                  padding: "4px",
                  fontSize: "12px",
                  borderRadius: "4px",
                  border: "1px solid #D1D5DB",
                }}
              />
            </th>
          ))}
          <th style={tableHeadCell}></th>
          <th style={tableHeadCell}></th>
        </tr>
      </thead>
      <tbody>
        {getFilteredDocs().map((doc, index) => {
          // ✅ FIXED APPROVAL STATE ACCESS
          const history = verificationApprovalRegistry?.[doc.id]?.history || [];
          const latest = history.length
            ? history[history.length - 1]
            : null;
          return (
            <tr key={doc.id || index} style={{ borderBottom: "1px solid #E5E7EB" }}>
              <td style={tableBodyCell}>{doc.userId || "—"}</td>
              <td style={tableBodyCell}>{doc.dateOfBirth || "—"}</td>
              <td style={tableBodyCell}>{doc.status || "—"}</td>
              <td style={tableBodyCell}>{doc.verificationType || "—"}</td>
              <td style={tableBodyCell}>{doc.visaType || "—"}</td>
              <td style={tableBodyCell}>{doc.shareCode || "—"}</td>
              <td style={tableBodyCell}>{String(doc.isBritishOrIrish ?? "—")}</td>
              <td style={tableBodyCell}>{String(doc.isStudent ?? "—")}</td>
              <td style={tableBodyCell}>{String(doc.hasConfirmed ?? "—")}</td>
              <td style={tableBodyCell}>{doc.passportValidFrom || "—"}</td>
              <td style={tableBodyCell}>{doc.passportValidUntil || "—"}</td>
              <td style={tableBodyCell}>{doc.visaValidFrom || "—"}</td>
              <td style={tableBodyCell}>{doc.visaValidUntil || "—"}</td>
              <td style={tableBodyCell}>{convertFirestoreTime(doc.submittedAt)}</td>
              <td style={tableBodyCell}>{convertFirestoreTime(doc.updatedAt)}</td>
              <td style={tableBodyCell}>
                {Array.isArray(doc.documentRequirements)
                  ? doc.documentRequirements.join(", ")
                  : "—"}
              </td>
              <td style={tableBodyCell}>
                {doc.documents?.birth_certificate ? (
                  <a href={doc.documents.birth_certificate} target="_blank" rel="noreferrer">View</a>
                ) : "—"}
              </td>
              <td style={tableBodyCell}>
                {doc.documents?.driving_licence ? (
                  <a href={doc.documents.driving_licence} target="_blank" rel="noreferrer">View</a>
                ) : "—"}
              </td>
              <td style={tableBodyCell}>
                {doc.documents?.passport ? (
                  <a href={doc.documents.passport} target="_blank" rel="noreferrer">View</a>
                ) : "—"}
              </td>
              <td style={tableBodyCell}>
                {String(doc.workingHoursRestrictions?.isStudent ?? "—")}
              </td>
              <td style={tableBodyCell}>
                {String(doc.workingHoursRestrictions?.restrictions?.appliesToAllStudents ?? "—")}
              </td>
              <td style={tableBodyCell}>
                {doc.workingHoursRestrictions?.restrictions?.fullTimeAllowed || "—"}
              </td>
              <td style={tableBodyCell}>
                {doc.workingHoursRestrictions?.restrictions?.maxHoursPerWeek || "—"}
              </td>
              <td style={tableBodyCell}>
                {String(doc.workingHoursRestrictions?.restrictions?.requiresTermDates ?? "—")}
              </td>
              <td style={tableBodyCell}>
                {doc.workingHoursRestrictions?.restrictions?.type || "—"}
              </td>
           <td style={tableBodyCell}>
  {latest
    ? latest.status === "approved"
      ? "Approved"
      : latest.status === "rejected"
      ? "Rejected"
      : latest.status
    : "Pending"}
</td>
              <td style={tableBodyCell}>{latest?.adminUser || "—"}</td>
              <td style={tableBodyCell}>{latest?.note || "—"}</td>
              <td style={tableBodyCell}>{latest?.time || "—"}</td>
              <td style={tableBodyCell}>
                {history.length > 0 ? (
                  <details>
                    <summary style={{ cursor: "pointer", color: "#2563EB" }}>
                      View
                    </summary>
                    <div style={{ marginTop: "6px" }}>
                      {history.map((h, i) => (
                        <div key={i}>
                          {h.status} • {h.adminUser} • {h.time}
                        </div>
                      ))}
                    </div>
                  </details>
                ) : (
                  "—"
                )}
              </td>
                  <td style={tableBodyCell}>
                   <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>

  {/* STEP 1 → REQUEST APPROVAL */}
  <button
    style={{
      background: "#111827",
      color: "#fff",
      border: "none",
      padding: "6px 12px",
      borderRadius: "6px",
      fontSize: "12px"
    }}
    onClick={() => initiateApprovalRequestFlow(doc)}
  >
    Request Approval
  </button>
 {/* STEP 2 → SHOW APPROVE / REJECT / ACTION BUTTON */}
{(approvalRequests || [])
  .filter((r) => r?.doc?.id === doc?.id)
  .map((req, i) => {
    const docId = req?.doc?.id;
    const status = verificationApprovalRegistry?.[docId]?.status;
    if (status === "approved") {
      return (
        <span
          key={i}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "5px",
            background: "#16A34A",
            color: "#fff",
            padding: "6px 10px",
            borderRadius: "6px",
            fontSize: "12px",
            fontWeight: "500",
          }}
        >
          ✔ Approved
        </span>
      );
    }
    if (status === "rejected") {
      return (
        <span
          key={i}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "5px",
            background: "#DC2626",
            color: "#fff",
            padding: "6px 10px",
            borderRadius: "6px",
            fontSize: "12px",
            fontWeight: "500",
          }}
        >
          ✖ Rejected
        </span>
      );
    }
    return (
      <button
        key={i}
        style={{
          background: "#2563EB",
          color: "#fff",
          border: "none",
          padding: "6px 12px",
          borderRadius: "6px",
          fontSize: "12px",
          cursor: "pointer",
        }}
        onClick={() => triggerFinalApprovalModal(req)}
      >
        Approve Request
      </button>
    );
  })}
</div>
     </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    )}
    {/* ================= REQUEST MODAL ================= */}
{isRequestModalOpen && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.4)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000
    }}
  >
    <div
      style={{
        background: "#fff",
        padding: "24px",
        borderRadius: "12px",
        width: "400px",
        textAlign: "center"
      }}
    >
      <h3>Approval Request</h3>
      <p style={{ marginBottom: "10px" }}>
        <b>Request ID:</b> {activeRequestPayload?.requestId}
      </p>
      {/* ✅ ADMIN DROPDOWN */}
      <select
        value={reqAdminPick}
        onChange={(e) => setReqAdminPick(e.target.value)}
        style={{
          width: "100%",
          marginBottom: "10px",
          padding: "8px"
        }}
      >
        <option value="">Select Admin</option>
        {ADMIN_LIST && ADMIN_LIST.length > 0 ? (
          ADMIN_LIST.map((a, i) => (
            <option key={i} value={a.name || a}>
              {a.name || a}
            </option>
          ))
        ) : (
          <option disabled>No Admins Available</option>
        )}
      </select>
      {/* ✅ STATUS DROPDOWN */}
      <select
        value={reqStatusPick}
        onChange={(e) => setReqStatusPick(e.target.value)}
        style={{
          width: "100%",
          marginBottom: "10px",
          padding: "8px"
        }}
      >
        <option value="">Select Status</option>
        {APPROVAL_STATUSES.map((s, i) => (
          <option key={i} value={s}>
            {s}
          </option>
        ))}
      </select>
      {/* ✅ REASON TEXTAREA */}
      <textarea
        placeholder="Reason for approval..."
        value={reqReasonText}
        onChange={(e) => setReqReasonText(e.target.value)}
        style={{
          width: "100%",
          padding: "8px",
          height: "80px"
        }}
      />
      {/* ✅ BUTTONS */}
      <div
        style={{
          marginTop: "12px",
          display: "flex",
          gap: "10px",
          justifyContent: "center"
        }}
      >
        {/* 🔴 CANCEL BUTTON */}
        <button
          onClick={() => setIsRequestModalOpen(false)}
          style={{
            background: "#DC2626",
            color: "#fff",
            border: "none",
            padding: "8px 12px",
            borderRadius: "6px",
            cursor: "pointer"
          }}
          onMouseOver={(e) => (e.target.style.background = "#B91C1C")}
          onMouseOut={(e) => (e.target.style.background = "#DC2626")}
        >
          Cancel
        </button>
        {/* 🔵 SEND BUTTON */}
        <button
          onClick={submitApprovalRequestPacket}
          style={{
            background: "#2563EB",
            color: "#fff",
            border: "none",
            padding: "8px 12px",
            borderRadius: "6px",
            cursor: "pointer"
          }}
        >
          Send Request
        </button>
      </div>
    </div>
  </div>
)}
{isFinalApprovalOpen && (
  <div style={modalOverlay}>
    <div style={modalBox}>
      <h3>Final Approval Panel</h3>
      <p><b>Request ID:</b> {activeApprovalPacket?.requestId}</p>
      <p><b>Reason:</b> {activeApprovalPacket?.reason}</p>
      <p><b>Assigned Admin:</b> {activeApprovalPacket?.assignedAdmin}</p>
      <p><b>Status:</b> {activeApprovalPacket?.status}</p>
      <input
        type="password"
        placeholder="Enter Admin Password"
        id="finalAuthPass"
        style={inputStyle}
      />
      {syncingApproval && (
        <p style={{ fontSize: "13px", color: "#2563EB", marginTop: "8px" }}>
          Syncing to Firebase...
        </p>
      )}
      <div style={btnRow}>
       <button
  onClick={() => setIsFinalApprovalOpen(false)}
  disabled={syncingApproval}
  style={{
    background: "#DC2626",
    color: "#fff",
    border: "none",
    padding: "8px 12px",
    borderRadius: "6px",
    cursor: syncingApproval ? "not-allowed" : "pointer",
    opacity: syncingApproval ? 0.7 : 1,
  }}
  onMouseOver={(e) => (e.target.style.background = "#B91C1C")}
  onMouseOut={(e) => (e.target.style.background = "#DC2626")}
>
  Cancel
</button>
   <button
  disabled={syncingApproval}
  onClick={async () => {
    const pass = document.getElementById("finalAuthPass")?.value;
    if (pass !== "8972") {
      alert("Invalid password");
      return;
    }
    const time = new Date().toLocaleString();
    const docId = activeApprovalPacket?.doc?.id;
    const providerUserId = activeApprovalPacket?.doc?.userId;
    // ✅ UPDATED HISTORY ENTRY (forced approved)
    const newHistoryEntry = {
      status: "approved", // FORCE approved
      adminUser: activeApprovalPacket?.assignedAdmin,
      note: activeApprovalPacket?.reason,
      time,
    };
    // Update local state first for responsive UI
    setVerificationApprovalRegistry((prev) => {
      const existingHistory = prev?.[docId]?.history || [];
      const updated = {
        ...prev,
        [docId]: {
          ...prev?.[docId],
          status: "approved", // main status update
          history: [...existingHistory, newHistoryEntry],
        },
      };
      // ✅ PERSIST TO LOCAL STORAGE so it survives refresh/login
      try {
        localStorage.setItem("verificationApprovalRegistry", JSON.stringify(updated));
      } catch (e) {
        console.error("Failed to save verificationApprovalRegistry to localStorage:", e);
      }
      return updated;
    });
    // ✅ SYNC TO FIREBASE — VerificationDocuments collection, keyed by userId
    if (!providerUserId) {
      console.error("Missing userId on doc; cannot sync approval to Firestore.");
      alert("Approval saved locally, but Firebase sync failed: missing provider userId.");
    } else {
      try {
        setSyncingApproval(true);
        const verificationDocRef = firestoreDoc(db, "VerificationDocuments", providerUserId);
        // Scan current document for fcmToken and existing status before or during update
        let fcmToken = activeApprovalPacket?.doc?.fcmToken;
        // 🔔 Track whether a notification was already sent for this status
        let alreadyNotified =
          activeApprovalPacket?.doc?.lastNotifiedStatus === "approved";
        try {
          if (typeof getDoc === "function") {
            const docSnap = await getDoc(verificationDocRef);
            if (docSnap.exists()) {
              const data = docSnap.data();
              if (data?.fcmToken) {
                fcmToken = data.fcmToken;
              }
              // ✅ Check previous notification state from Firestore
              alreadyNotified = data?.lastNotifiedStatus === "approved";
            }
          }
        } catch (scanErr) {
          console.warn("Could not fetch fresh doc for fcmToken, falling back to document packet:", scanErr);
        }
        await updateDoc(verificationDocRef, {
          status: "approved",
          approval: {
            status: "approved",
            adminUser: activeApprovalPacket?.assignedAdmin,
            note: activeApprovalPacket?.reason,
            time,
          },
          approvalHistory: arrayUnion(newHistoryEntry),
          updatedAt: serverTimestamp(),
        });
        console.log("FINAL APPROVAL SYNCED TO FIREBASE:", {
          requestId: activeApprovalPacket?.requestId,
          userId: providerUserId,
          ...newHistoryEntry,
        });
        // 🔔 SEND PUSH NOTIFICATION BASED ON fcmToken AND status
        if (alreadyNotified) {
          // ✅ TOAST: already notified previously
          showToast("User already notified about approval", "info");
          console.log("Skipping push: user already notified for approved status.", providerUserId);
        } else if (fcmToken) {
          try {
            const pushRes = await fetch("https://verifyproviderdocument-mc4pzotprq-uc.a.run.app", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                fcmToken,
                status: "approved",
                userId: providerUserId,
                title: "Document Verification Approved",
                body: activeApprovalPacket?.reason || "Your verification documents have been approved.",
                note: activeApprovalPacket?.reason || "",
                adminUser: activeApprovalPacket?.assignedAdmin || "",
                time,
              }),
            });
            if (!pushRes.ok) {
              throw new Error("Push endpoint responded with status " + pushRes.status);
            }
            console.log("Push notification dispatched for approval successfully.");
            // ✅ Remember that this status has been notified
            try {
              await updateDoc(verificationDocRef, {
                lastNotifiedStatus: "approved",
                notifiedAt: serverTimestamp(),
              });
            } catch (flagErr) {
              console.warn("Notification sent but failed to store notified flag:", flagErr);
            }
            // ✅ TOAST: notification sent successfully
            showToast("Approval notification sent successfully", "success");
          } catch (pushErr) {
            console.error("Failed to send push notification to cloud endpoint:", pushErr);
            // ✅ TOAST: notification failed
            showToast("Failed to send approval notification", "error");
          }
        } else {
          console.warn("No fcmToken found in VerificationDocuments for user:", providerUserId);
          // ✅ TOAST: no token, cannot notify
          showToast("Notification not sent: no device token found for user", "warning");
        }
      } catch (err) {
        console.error("Error syncing approval to Firestore:", err);
        alert("Approval saved locally, but syncing to Firebase failed: " + err.message);
      } finally {
        setSyncingApproval(false);
      }
    }
    setIsFinalApprovalOpen(false);
    setActiveApprovalPacket(null);
    alert("Approval Successfully Applied");
  }}
  style={{
    background: "#2563EB",
    color: "#fff",
    border: "none",
    padding: "8px 12px",
    borderRadius: "6px",
    cursor: syncingApproval ? "not-allowed" : "pointer",
    opacity: syncingApproval ? 0.7 : 1,
  }}
  onMouseOver={(e) => (e.target.style.background = "#1D4ED8")}
  onMouseOut={(e) => (e.target.style.background = "#2563EB")}
>
  Apply Approval
</button>
<button
  disabled={syncingApproval}
  onClick={async () => {
    const pass = document.getElementById("finalAuthPass")?.value;
    if (pass !== "8972") {
      alert("Invalid password");
      return;
    }
    const time = new Date().toLocaleString();
    const docId = activeApprovalPacket?.doc?.id;
    const providerUserId = activeApprovalPacket?.doc?.userId;
    const rejectHistoryEntry = {
      status: "rejected",
      adminUser: activeApprovalPacket?.assignedAdmin,
      note: activeApprovalPacket?.reason,
      time,
    };
    // Update local state first for responsive UI
    setVerificationApprovalRegistry((prev) => {
      const existingHistory = prev?.[docId]?.history || [];
      const updated = {
        ...prev,
        [docId]: {
          ...prev?.[docId],
          status: "rejected",
          history: [...existingHistory, rejectHistoryEntry],
        },
      };
      // ✅ PERSIST TO LOCAL STORAGE so it survives refresh/login
      try {
        localStorage.setItem("verificationApprovalRegistry", JSON.stringify(updated));
      } catch (e) {
        console.error("Failed to save verificationApprovalRegistry to localStorage:", e);
      }
      return updated;
    });
    // ✅ SYNC TO FIREBASE — VerificationDocuments collection, keyed by userId
    if (!providerUserId) {
      console.error("Missing userId on doc; cannot sync rejection to Firestore.");
      alert("Rejection saved locally, but Firebase sync failed: missing provider userId.");
    } else {
      try {
        setSyncingApproval(true);
        const verificationDocRef = firestoreDoc(db, "VerificationDocuments", providerUserId);
        // Scan current document for fcmToken and existing status before or during update
        let fcmToken = activeApprovalPacket?.doc?.fcmToken;
        // 🔔 Track whether a notification was already sent for this status
        let alreadyNotified =
          activeApprovalPacket?.doc?.lastNotifiedStatus === "rejected";
        try {
          if (typeof getDoc === "function") {
            const docSnap = await getDoc(verificationDocRef);
            if (docSnap.exists()) {
              const data = docSnap.data();
              if (data?.fcmToken) {
                fcmToken = data.fcmToken;
              }
              // ✅ Check previous notification state from Firestore
              alreadyNotified = data?.lastNotifiedStatus === "rejected";
            }
          }
        } catch (scanErr) {
          console.warn("Could not fetch fresh doc for fcmToken, falling back to document packet:", scanErr);
        }
        await updateDoc(verificationDocRef, {
          status: "rejected",
          approval: {
            status: "rejected",
            adminUser: activeApprovalPacket?.assignedAdmin,
            note: activeApprovalPacket?.reason,
            time,
          },
          approvalHistory: arrayUnion(rejectHistoryEntry),
          updatedAt: serverTimestamp(),
        });
        console.log("FINAL REJECTION SYNCED TO FIREBASE:", {
          requestId: activeApprovalPacket?.requestId,
          userId: providerUserId,
          ...rejectHistoryEntry,
        });
        // 🔔 SEND PUSH NOTIFICATION BASED ON fcmToken AND status
        if (alreadyNotified) {
          // ✅ TOAST: already notified previously
          showToast("User already notified about rejection", "info");
          console.log("Skipping push: user already notified for rejected status.", providerUserId);
        } else if (fcmToken) {
          try {
            const pushRes = await fetch("https://verifyproviderdocument-mc4pzotprq-uc.a.run.app", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                fcmToken,
                status: "rejected",
                userId: providerUserId,
                title: "Document Verification Rejected",
                body: activeApprovalPacket?.reason || "Your verification documents have been rejected.",
                note: activeApprovalPacket?.reason || "",
                adminUser: activeApprovalPacket?.assignedAdmin || "",
                time,
              }),
            });
            if (!pushRes.ok) {
              throw new Error("Push endpoint responded with status " + pushRes.status);
            }
            console.log("Push notification dispatched for rejection successfully.");
            // ✅ Remember that this status has been notified
            try {
              await updateDoc(verificationDocRef, {
                lastNotifiedStatus: "rejected",
                notifiedAt: serverTimestamp(),
              });
            } catch (flagErr) {
              console.warn("Notification sent but failed to store notified flag:", flagErr);
            }

            // ✅ TOAST: notification sent successfully
            showToast("Rejection notification sent successfully", "success");
          } catch (pushErr) {
            console.error("Failed to send push notification to cloud endpoint:", pushErr);
            // ✅ TOAST: notification failed
            showToast("Failed to send rejection notification", "error");
          }
        } else {
          console.warn("No fcmToken found in VerificationDocuments for user:", providerUserId);
          // ✅ TOAST: no token, cannot notify
          showToast("Notification not sent: no device token found for user", "warning");
        }
      } catch (err) {
        console.error("Error syncing rejection to Firestore:", err);
        alert("Rejection saved locally, but syncing to Firebase failed: " + err.message);
      } finally {
        setSyncingApproval(false);
      }
    }
    setIsFinalApprovalOpen(false);
    setActiveApprovalPacket(null);
    alert("Request Rejected Successfully");
  }}
  style={{
    background: "#DC2626",
    color: "#fff",
    border: "none",
    padding: "8px 12px",
    borderRadius: "6px",
    cursor: syncingApproval ? "not-allowed" : "pointer",
    opacity: syncingApproval ? 0.7 : 1,
  }}
  onMouseOver={(e) => (e.target.style.background = "#B91C1C")}
  onMouseOut={(e) => (e.target.style.background = "#DC2626")}
>
  Reject Request
</button>
      </div>
    </div>
    </div>
)}
</div>
      </div>  
      </div>
    );
  })()}

  {/* ✅ PROVIDER NOTIFICATIONS */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "providerNotifications" &&
  showProviderNotifications && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Provider Notifications</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
     <div
      style={{
        ...cardStyle,
        maxWidth: "1500px",
        margin: "0 auto",
        width: "100%",
      }}
    >
    {/* 🔄 GLOBAL LOADER */}
    {isNotificationLoading && (
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(255,255,255,0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 10,
          borderRadius: "12px",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "5px solid #e5e7eb",
            borderTop: "5px solid #2563eb",
            borderRadius: "50%",
            animation: "fullSpin 0.8s linear infinite",
          }}
        />
      </div>
    )}
    {/* ================= HEADER ================= */}
    <div
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        marginBottom: "20px",
        textAlign: "center",
      }}
    >
      <h3
        style={{
          margin: 0,
          fontSize: "24px",
          fontWeight: "700",
          color: "#111827",
        }}
      >
        🔔 Provider Notifications (CRM)
      </h3>
      <div style={{ marginTop: "12px" }}>
        <button
  onClick={handleFetchNotifications}
  disabled={isNotificationLoading}
  style={{
    marginTop: "12px",
    padding: "10px 16px",
    backgroundColor: "#2563EB",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: isNotificationLoading ? "not-allowed" : "pointer",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    justifyContent: "center",
    marginLeft: "auto",
    marginRight: "auto",
    opacity: isNotificationLoading ? 0.7 : 1,
  }}
>
  {isNotificationLoading ? (
    <span
      style={{
        width: "16px",
        height: "16px",
        border: "2px solid #fff",
        borderTop: "2px solid transparent",
        borderRadius: "50%",
        display: "inline-block",
        animation: "btnSpin 0.6s linear infinite",
      }}
    />
  ) : (
    <span>📡</span>
  )}
  {isNotificationLoading ? "Fetching Notifications..." : "Fetch Notifications"}
</button>
      </div>
    </div>
    {/* ================= TABLE ================= */}
    <div
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        overflowX: "auto",
      }}
    >
      {notificationRegistry.length === 0 ? (
        <p style={{ fontSize: "14px", color: "#6B7280", textAlign: "center" }}>
          Click "Fetch Notifications" to load data.
        </p>
      ) : (
        <>
          {/* 🔥 FORMAT FUNCTION */}
          {(() => {
            const formatToLocale = (value) => {
              if (!value) return "";
              try {
                if (value?.toDate) return value.toDate().toLocaleString().toLowerCase();
                if (value?.seconds) return new Date(value.seconds * 1000).toLocaleString().toLowerCase();
                if (typeof value === "number") return new Date(value).toLocaleString().toLowerCase();
                return String(value).toLowerCase();
              } catch {
                return "";
              }
            };
            /* 🔥 FILTER LOGIC */
            const refinedNotifications = notificationRegistry.filter((notification) => {
              const data = notification?.data || {};
              return (
                (!queryMap.time || formatToLocale(notification?.time).includes(queryMap.time.toLowerCase())) &&
                (!queryMap.createdAt || formatToLocale(notification?.createdAt).includes(queryMap.createdAt.toLowerCase())) &&
                (!queryMap.timestamp || formatToLocale(data?.timestamp).includes(queryMap.timestamp.toLowerCase()))
              );
            });
            return (
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "14px",
                  color: "#374151",
                }}
              >
                <thead style={{ backgroundColor: "#F9FAFB" }}>
                  <tr>
                    {[
                      "ID","User ID","Title","Description","Type","Is Read",
                      "Time","Image","Created At","Timestamp","Badge",
                      "Service","Booking Date","Booking Time","Duration",
                      "Total Amount","Customer Name","Customer Address",
                      "Pet Type","Has Pets"
                    ].map((head) => (
                      <th key={head} style={{ padding: "12px" }}>{head}</th>
                    ))}
                  </tr>
                  {/* 🔍 FILTER ROW */}
                  <tr>
                    {[
                      "id","userId","title","description","type","isRead",
                      "time","image","createdAt","timestamp","badge",
                      "service","bookingDate","bookingTime","duration",
                      "totalAmount","customerName","customerAddress",
                      "petType","hasPets"
                    ].map((key) => (
                      <th key={key} style={{ padding: "6px" }}>
                        <input
                          placeholder="Filter..."
                          onChange={(e) => updateQueryValue(key, e.target.value)}
                          style={{
                            width: "100%",
                            padding: "5px",
                            fontSize: "12px",
                            border: "1px solid #ddd",
                            borderRadius: "4px"
                          }}
                        />
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {refinedNotifications.map((notification, index) => {
                    const data = notification?.data || {};
                    const safeFormat = (value) => {
                      if (!value) return "-";
                      try {
                        if (value?.toDate) return value.toDate().toLocaleString();
                        if (value?.seconds) return new Date(value.seconds * 1000).toLocaleString();
                        if (typeof value === "number") return new Date(value).toLocaleString();
                        return value;
                      } catch {
                        return "-";
                      }
                    };
                    return (
                      <tr key={notification?.id || index}>
                        <td style={{ padding: "12px" }}>{notification?.id || "-"}</td>
                        <td style={{ padding: "12px" }}>{notification?.userId || "-"}</td>
                        <td style={{ padding: "12px" }}>{notification?.title || "-"}</td>
                        <td style={{ padding: "12px" }}>{notification?.description || "-"}</td>
                        <td style={{ padding: "12px" }}>{notification?.type || "-"}</td>
                        <td style={{ padding: "12px" }}>{notification?.isRead ? "True" : "False"}</td>
                        <td style={{ padding: "12px" }}>{safeFormat(notification?.time)}</td>
                        <td style={{ padding: "12px" }}>{notification?.image || "-"}</td>
                        <td style={{ padding: "12px" }}>{safeFormat(notification?.createdAt)}</td>
                        <td style={{ padding: "12px" }}>{safeFormat(data?.timestamp)}</td>
                        <td style={{ padding: "12px" }}>{data?.badgeName || "-"}</td>
                        <td style={{ padding: "12px" }}>{data?.serviceName || "-"}</td>
                        <td style={{ padding: "12px" }}>{data?.bookingDate || "-"}</td>
                        <td style={{ padding: "12px" }}>{data?.bookingTime || "-"}</td>
                        <td style={{ padding: "12px" }}>{data?.duration || "-"}</td>
                        <td style={{ padding: "12px" }}>{data?.totalAmount || "-"}</td>
                        <td style={{ padding: "12px" }}>{data?.customerName || "-"}</td>
                        <td style={{ padding: "12px" }}>{data?.customerAddress || "-"}</td>
                        <td style={{ padding: "12px" }}>{data?.petType || "-"}</td>
                        <td style={{ padding: "12px" }}>
                          {data?.hasPets !== undefined ? data.hasPets.toString() : "-"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            );
          })()}
        </>
      )}
    </div>
    {/* 🔁 SPIN */}
    <style>
      {`
        @keyframes fullSpin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes btnSpin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}
    </style>
  </div>
    </div>
  </div>
)}
{/* ✅ PROVIDER ONBOARDING */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "providerOnboarding" &&
  showProviderOnboarding && (
    <div className="admin-container">
      {/* HEADER */}
      <div style={headerStyle}>
        <h3 style={titleStyle}>Provider Onboarding</h3>
      </div>
      {/* CARD */}
      <div
        style={{
          ...cardStyle,
          maxWidth: "1520px",
          margin: "0 auto",
          width: "100%",
          position: "relative",
        }}
      >
        {/* ================= SPINNER CSS ================= */}
        <style>{`
          @keyframes fullSpin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
        {/* ================= GLOBAL LOADER ================= */}
        {isGlobalLoading && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(255,255,255,0.75)",
              backdropFilter: "blur(3px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 999,
              borderRadius: "12px",
            }}
          >
            <div
              style={{
                width: "70px",
                height: "70px",
                border: "6px solid #e5e7eb",
                borderTop: "6px solid #2563eb",
                borderRadius: "50%",
                animation: "fullSpin 0.8s linear infinite",
              }}
            />
          </div>
        )}
        <div className="category-title-container">
          {/* ================= HEADER ================= */}
          <div
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              marginBottom: "20px",
              textAlign: "center",
            }}
          >
            <h3 style={{ margin: 0 }}>🧾 Provider Onboarding</h3>
            <p
              style={{
                marginTop: "6px",
                fontSize: "14px",
                color: "#6B7280",
              }}
            >
              Stripe Marketplace Provider Status Overview
            </p>
            <button
              onClick={handleFetchProviders}
              disabled={isGlobalLoading}
              style={{
                marginTop: "12px",
                padding: "10px 16px",
                backgroundColor: "#2563EB",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: isGlobalLoading ? "not-allowed" : "pointer",
                opacity: isGlobalLoading ? 0.7 : 1,
              }}
            >
              🔄 {isGlobalLoading ? "Fetching Providers..." : "Fetch Providers"}
            </button>
          </div>
          {/* ================= TABLE ================= */}
          <div
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "12px",
              overflowX: "auto",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "14px",
              }}
            >
              {/* ================= HEAD ================= */}
              <thead style={{ backgroundColor: "#F9FAFB" }}>
                <tr>
                  {[
                    "Doc ID",
                    "Name",
                    "Email",
                    "KYC Status",
                    "Stripe Status",
                    "Charges Enabled",
                    "Payouts Enabled",
                    "Stripe Account",
                    "Onboarding Status",
                    "Provider ID",
                    "Verification Source",
                    "Created At",
                    "Updated At",
                    "Onboarding Completed",
                  ].map((header) => (
                    <th key={header} style={{ padding: "12px", textAlign: "left" }}>
                      {header}
                    </th>
                  ))}
                </tr>
                {/* ================= FILTER ROW ================= */}
                <tr>
                  {[
                    "uid",
                    "name",
                    "email",
                    "kyc",
                    "stripe",
                    "charges",
                    "payouts",
                    "account",
                    "onboarding",
                    "providerId",
                    "verification",
                    "created",
                    "updated",
                    "completed",
                  ].map((key) => (
                    <th key={key} style={{ padding: "6px" }}>
                      <input
                        type="text"
                        placeholder="Filter..."
                        value={filterHandles[key] || ""}
                        onChange={(e) => onFilterUpdate(key, e.target.value)}
                        style={{
                          width: "100%",
                          padding: "6px",
                          fontSize: "12px",
                          border: "1px solid #E5E7EB",
                          borderRadius: "4px",
                        }}
                      />
                    </th>
                  ))}
                </tr>
              </thead>
              {/* ================= BODY ================= */}
              <tbody>
                {filteredProviders.length > 0 ? (
                  filteredProviders.map((item, index) => (
                    <tr
                      key={item.uid}
                      style={{
                        borderBottom: "1px solid #E5E7EB",
                        backgroundColor: index % 2 === 0 ? "#fff" : "#F9FAFB",
                      }}
                    >
                      <td style={{ padding: "12px" }}>{item.uid}</td>
                      <td style={{ padding: "12px" }}>{item.displayName || "-"}</td>
                      <td style={{ padding: "12px" }}>{item.emailAddress || "-"}</td>
                      <td style={{ padding: "12px" }}>{item.kycState || "-"}</td>
                      <td style={{ padding: "12px" }}>{item.stripePhase || "-"}</td>
                      <td style={{ padding: "12px" }}>
                        {item.paymentStatus === null
                          ? "-"
                          : item.paymentStatus
                          ? "Enabled"
                          : "Disabled"}
                      </td>
                      <td style={{ padding: "12px" }}>
                        {item.payoutStatus === null
                          ? "-"
                          : item.payoutStatus
                          ? "Enabled"
                          : "Disabled"}
                      </td>
                      <td style={{ padding: "12px" }}>
                        {item.stripeAccountCode || "-"}
                      </td>
                      <td style={{ padding: "12px" }}>
                        {item.onboardingStage || "-"}
                      </td>
                      <td style={{ padding: "12px" }}>
                        {item.externalProviderId || "-"}
                      </td>
                      <td style={{ padding: "12px" }}>
                        {item.verificationMode || "-"}
                      </td>
                      <td style={{ padding: "12px" }}>
                        {formatTimestampDisplay(item.initiatedOn)}
                      </td>
                      <td style={{ padding: "12px" }}>
                        {formatTimestampDisplay(item.modifiedOn)}
                      </td>
                      <td style={{ padding: "12px" }}>
                        {formatTimestampDisplay(item.onboardingClosedAt)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="14"
                      style={{
                        textAlign: "center",
                        padding: "16px",
                        color: "#6B7280",
                      }}
                    >
                      No providers fetched yet
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
)}
{/* ✅ ACTIVATE CHAT */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "activateChat" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Activate Chat</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
      <p>Chat Activation Section</p>
       <div className="category-title-container">
      <h3>Chat Activation</h3>
      {/* =========================
         Search + Filters
      ========================= */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
          flexWrap: "wrap",
          gap: "12px",
        }}
      >
        {/* 🔍 Search */}
        <input
          placeholder="🔍 Search Booking / Customer / Provider"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            flex: 1,
            minWidth: "200px",
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #D1D5DB",
          }}
        />
        {/* ✅ Colored Filter Buttons */}
        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
          {[
            { key: "all", label: "All", color: "#3B82F6" },
            { key: "warnings", label: "Warnings", color: "#F59E0B" },
            { key: "escalated", label: "Escalated", color: "#6366F1" },
            { key: "blocked", label: "Blocked", color: "#EF4444" },
            { key: "active", label: "Active", color: "#10B981" },
            { key: "completed", label: "Completed", color: "#8B5CF6" },
            { key: "confirmed", label: "Confirmed", color: "#22C55E" },
          ].map(({ key, label, color }) => (
            <button
              key={key}
              onClick={() => setFilter(key)}
              style={{
                padding: "8px 14px",
                borderRadius: "8px",
                border: "none",
                background: filter === key ? color : "#E5E7EB",
                color: filter === key ? "#fff" : "#111827",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "600",
                transition: "background 0.2s, color 0.2s",
              }}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      {/* Main Layout */}
      <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
        {/* =========================
           Booking List Table
        ========================= */}
        <div
          style={{
            flex: 2,
            minWidth: "300px",
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
            maxHeight: "80vh",
            overflowY: "auto",
            marginTop: "30px",
          }}
        >
          <h3
            style={{
              fontWeight: "700",
              fontSize: "20px",
              marginBottom: "12px",
            }}
          >
            Bookings
          </h3>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#F3F4F6" }}>
                {["Booking ID", "Customer", "Provider", "Status", "Trigger", "Metadata Logs"].map((col) => (
                  <th
                    key={col}
                    style={{ padding: "12px", textAlign: col === "Metadata Logs" ? "center" : "left", fontWeight: "600" }}
                  >
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredBookings.length === 0 ? (
                <tr>
                  <td
                    colSpan="6"
                    style={{ textAlign: "center", padding: "20px", color: "#6B7280" }}
                  >
                    No bookings found.
                  </td>
                </tr>
              ) : (
                filteredBookings.map((b) => (
                  <tr
                    key={b.id}
                    onClick={() => setSelectedBookingId(b.id)}
                    style={{
                      cursor: "pointer",
                      background: selectedBookingId === b.id ? "#F9FAFB" : "#fff",
                      transition: "background 0.2s",
                    }}
                  >
                    <td style={{ padding: "12px", borderBottom: "1px solid #E5E7EB" }}>{b.id}</td>
                    <td style={{ padding: "12px", borderBottom: "1px solid #E5E7EB" }}>{b.customer}</td>
                    <td style={{ padding: "12px", borderBottom: "1px solid #E5E7EB" }}>{b.provider}</td>
                    <td style={{ padding: "12px", borderBottom: "1px solid #E5E7EB" }}>
                      <span
                        style={{
                          padding: "4px 8px",
                          borderRadius: "6px",
                          fontWeight: "600",
                          backgroundColor:
                            b.status === "confirmed"
                              ? "#22C55E"
                              : b.status === "active"
                              ? "#10B981"
                              : b.status === "completed"
                              ? "#8B5CF6"
                              : "#E5E7EB",
                          color: "#fff",
                        }}
                      >
                        {b.status.charAt(0).toUpperCase() + b.status.slice(1)}
                      </span>
                    </td>
                    <td style={{ padding: "12px", borderBottom: "1px solid #E5E7EB" }}>
                      <span
                        style={{
                          padding: "2px 6px",
                          borderRadius: "6px",
                          background: badgeColor(b.triggerStatus),
                          fontWeight: "600",
                        }}
                      >
                        {b.triggerStatus}
                      </span>
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        borderBottom: "1px solid #E5E7EB",
                        textAlign: "center",
                      }}
                    >
                      {b.metadataLogs?.length || 0}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {/* =========================
             Add Booking Form
          ========================= */}
          <div style={{ borderTop: "1px solid #E5E7EB", paddingTop: "12px", marginTop: "20px" }}>
            <h4 style={{ fontWeight: "600", marginBottom: "12px" }}>Add Booking</h4>
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              <input
                placeholder="Customer"
                value={newBooking.customer}
                onChange={(e) => setNewBooking((s) => ({ ...s, customer: e.target.value }))}
                style={{ padding: "10px", borderRadius: "8px", border: "1px solid #D1D5DB" }}
              />
              <input
                placeholder="Provider"
                value={newBooking.provider}
                onChange={(e) => setNewBooking((s) => ({ ...s, provider: e.target.value }))}
                style={{ padding: "10px", borderRadius: "8px", border: "1px solid #D1D5DB" }}
              />
              <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
                <select
                  value={newBooking.status}
                  onChange={(e) => setNewBooking((s) => ({ ...s, status: e.target.value }))}
                  style={{ flex: 1, padding: "10px", borderRadius: "8px", border: "1px solid #D1D5DB" }}
                >
                  <option value="active">Active</option>
                  <option value="completed">Completed</option>
                  <option value="confirmed">Confirmed</option>
                </select>
                <select
                  value={newBooking.triggerStatus}
                  onChange={(e) => setNewBooking((s) => ({ ...s, triggerStatus: e.target.value }))}
                  style={{ width: "140px", padding: "10px", borderRadius: "8px", border: "1px solid #D1D5DB" }}
                >
                  <option value="Safe">Safe</option>
                  <option value="Warning">Warning</option>
                  <option value="Escalated">Escalated</option>
                  <option value="Blocked">Blocked</option>
                </select>
              </div>
              <button
                onClick={() => {
                  handleAddBooking({
                    ...newBooking,
                    id: "BKG-" + Math.floor(100000 + Math.random() * 900000),
                  });
                  setNewBooking({ customer: "", provider: "", status: "active", triggerStatus: "Safe" });
                }}
                style={{
                  padding: "12px",
                  borderRadius: "8px",
                  backgroundColor: "#4F46E5",
                  color: "#fff",
                  fontWeight: "600",
                  cursor: "pointer",
                  border: "none",
                }}
              >
                Add Booking
              </button>
            </div>
          </div>
        </div>
        {/* 💬 Chatbot Section */}
        {selectedBooking &&
          bookings.find((b) => b.id === selectedBookingId)?.status === "confirmed" && (
            <div
              className="chatbot-section"
              style={{
                flex: 2,
                minWidth: "300px",
                display: "flex",
                flexDirection: "column",
                background: "#fff",
                borderRadius: "12px",
                boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
                overflow: "hidden",
                height: "80vh",
              }}
            >
              {/* Header */}
              <div
                style={{
                  background: "#4f46e5",
                  color: "#fff",
                  padding: "16px 20px",
                  fontSize: "20px",
                  fontWeight: "bold",
                }}
              >
                Chat: {bookings.find((b) => b.id === selectedBookingId).customer} ↔{" "}
                {bookings.find((b) => b.id === selectedBookingId).provider}
              </div>
              {/* Chat Messages */}
              <div
                ref={chatContainerRef}
                style={{ flex: 1, padding: "16px", overflowY: "auto", background: "#f9fafb" }}
              >
                {messages.length === 0 && (
                  <p style={{ fontSize: "14px", color: "#6B7280" }}>
                    No messages yet. Start the conversation.
                  </p>
                )}
                {messages.map((msg, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      justifyContent: msg.sender === "user" ? "flex-end" : "flex-start",
                      marginBottom: "10px",
                    }}
                  >
                    <span
                      style={{
                        padding: "12px 16px",
                        borderRadius: "20px",
                        maxWidth: "75%",
                        wordWrap: "break-word",
                        background: msg.sender === "user" ? "#4f46e5" : "#E5E7EB",
                        color: msg.sender === "user" ? "#fff" : "#111827",
                        fontSize: "15px",
                      }}
                    >
                      {msg.text}
                    </span>
                  </div>
                ))}
              </div>
              {/* Input Trigger Button */}
              <div
                style={{
                  padding: "14px",
                  borderTop: "1px solid #E5E7EB",
                  background: "#fff",
                  textAlign: "center",
                }}
              >
                <button
                  onClick={() => setShowModal(true)}
                  style={{
                    padding: "12px 22px",
                    borderRadius: "25px",
                    border: "none",
                    background: "#4f46e5",
                    color: "#fff",
                    fontWeight: "500",
                    fontSize: "15px",
                    cursor: "pointer",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  }}
                >
                  ✍️ Type a Message
                </button>
              </div>
              {/* Modal for Typing & Sending */}
              {showModal && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0,0,0,0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1000,
                  }}
                >
                  <div
                    style={{
                      background: "#fff",
                      padding: "24px",
                      borderRadius: "12px",
                      width: "420px",
                      boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
                      display: "flex",
                      flexDirection: "column",
                      gap: "14px",
                    }}
                  >
                    <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "bold" }}>
                      Type Your Message
                    </h3>
                    <input
                      type="text"
                      value={input}
                      onChange={(e) => setInput(e.target.value)}
                      onKeyDown={handleKeyDown}
                      placeholder="Write a message..."
                      style={{
                        padding: "12px 16px",
                        borderRadius: "10px",
                        border: "1px solid #D1D5DB",
                        outline: "none",
                        fontSize: "15px",
                      }}
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
                      <button
                        onClick={() => setShowModal(false)}
                        style={{
                          padding: "10px 18px",
                          borderRadius: "10px",
                          border: "1px solid #D1D5DB",
                          background: "#facc15",
                          color: "#000",
                          fontWeight: "500",
                          cursor: "pointer",
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        onClick={() => {
                          handleSend();
                          setShowModal(false);
                        }}
                        style={{
                          padding: "10px 18px",
                          borderRadius: "10px",
                          border: "none",
                          background: "#4f46e5",
                          color: "#fff",
                          fontWeight: "500",
                          cursor: "pointer",
                        }}
                      >
                        Send
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        {/* 🔔 Notifications */}
        <aside
          style={{
            width: "360px",
            minWidth: "280px",
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
            maxHeight: "80vh",
            overflowY: "auto",
            marginTop: "20px",
          }}
        >
          <h4 style={{ fontWeight: 600, marginBottom: "12px" }}>Notifications</h4>
          {/* Filter Buttons */}
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "12px" }}>
            {[
              { key: "all", label: "All", color: "#3B82F6" },
              { key: "Safe", label: "Safe", color: "#10B981" },
              { key: "Warning", label: "Warning", color: "#F59E0B" },
              { key: "Escalated", label: "Escalated", color: "#6366F1" },
              { key: "Blocked", label: "Blocked", color: "#EF4444" },
            ].map(({ key, label, color }) => (
              <button
                key={key}
                onClick={() => setNotifFilter(key)}
                style={{
                  padding: "6px 12px",
                  borderRadius: "8px",
                  border: "none",
                  background: notifFilter === key ? color : "#E5E7EB",
                  color: notifFilter === key ? "#fff" : "#111827",
                  fontSize: "13px",
                  fontWeight: "500",
                  cursor: "pointer",
                }}
              >
                {label}
              </button>
            ))}
          </div>
          {/* Group notifications by triggerStatus */}
          {["Safe", "Warning", "Escalated", "Blocked"].map((sectionKey) => {
            const sectionBookings = bookings.filter(
              (b) => b.triggerStatus === sectionKey && (notifFilter === "all" || notifFilter === sectionKey)
            );
            if (sectionBookings.length === 0) return null;
            return (
              <div key={sectionKey} style={{ marginBottom: "16px" }}>
                <h5 style={{ fontWeight: 600, marginBottom: "8px", color: badgeColor(sectionKey) }}>
                  {sectionKey} Notifications
                </h5>
                {sectionBookings.map((b) => (
                  <div
                    key={b.id}
                    style={{
                      border: "1px solid #E5E7EB",
                      padding: "12px",
                      borderRadius: "8px",
                      marginBottom: "8px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <div style={{ fontSize: "14px", fontWeight: 500, color: "#111827" }}>
                      {b.customer} → {b.provider}
                    </div>
                    {/* Booking status + triggerStatus */}
                    <div style={{ marginTop: "6px", display: "flex", gap: "6px" }}>
                      <span
                        style={{
                          padding: "2px 6px",
                          borderRadius: "6px",
                          background: badgeColor(b.status),
                          color: "#fff",
                          fontSize: "12px",
                          fontWeight: 600,
                        }}
                      >
                        {b.status}
                      </span>
                      <span
                        style={{
                          padding: "2px 6px",
                          borderRadius: "6px",
                          background: badgeColor(b.triggerStatus),
                          color: "#fff",
                          fontSize: "12px",
                          fontWeight: 600,
                        }}
                      >
                        {b.triggerStatus}
                      </span>
                    </div>
                    {/* Action Buttons */}
                    <div style={{ display: "flex", gap: "8px", marginTop: "8px", flexWrap: "wrap" }}>
                      <button
                        onClick={() => handleViewLogs(b)}
                        style={{
                          flex: 1,
                          padding: "6px 10px",
                          borderRadius: "6px",
                          border: "none",
                          backgroundColor: "#3B82F6",
                          color: "#fff",
                          fontSize: "13px",
                          fontWeight: 500,
                          cursor: "pointer",
                        }}
                      >
                        View Logs
                      </button>
                      {b.triggerStatus !== "Escalated" && (
                        <button
                          onClick={() => handleEscalate(b.id)}
                          style={{
                            flex: 1,
                            padding: "6px 10px",
                            borderRadius: "6px",
                            border: "none",
                            backgroundColor: "#F59E0B",
                            color: "#fff",
                            fontSize: "13px",
                            fontWeight: 500,
                            cursor: "pointer",
                          }}
                        >
                          Escalate
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            );
          })}
          {/* Logs Modal */}
          {showLogsModal && selectedBooking && (
            <div
              style={{
                position: "fixed",
                inset: 0,
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  padding: "20px",
                  width: "400px",
                  maxHeight: "70vh",
                  overflowY: "auto",
                }}
              >
                <h4 style={{ fontWeight: 600, marginBottom: "12px" }}>
                  Logs for {selectedBooking.customer} → {selectedBooking.provider}
                </h4>
                {selectedBooking.metadataLogs?.length ? (
                  selectedBooking.metadataLogs.map((log, idx) => (
                    <div
                      key={idx}
                      style={{
                        padding: "8px",
                        borderBottom: "1px solid #E5E7EB",
                        fontSize: "13px",
                        color: "#374151",
                      }}
                    >
                      <strong>{log.action}</strong> ({log.status})
                      <br />
                      <small>{new Date(log.timestamp).toLocaleString()}</small>
                    </div>
                  ))
                ) : (
                  <div style={{ color: "#6B7280" }}>No logs available.</div>
                )}
                <button
                  onClick={() => setShowLogsModal(false)}
                  style={{
                    marginTop: "12px",
                    padding: "8px 16px",
                    borderRadius: "8px",
                    border: "none",
                    backgroundColor: "#E5E7EB",
                    fontWeight: 600,
                    cursor: "pointer",
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          )}
        </aside>
      </div>
    </div>
    </div>
  </div>
)}
{/* ✅ SETTINGS VIEW */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "settings" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Settings</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
      {/* Title Section */}
  <div
    className="category-title-container"
    style={{
      backgroundColor: "#fff",
      padding: "10px",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      marginBottom: "20px",
      textAlign: "center",
    }}
  >
    <h3
      style={{
        fontFamily: "'Poppins', sans-serif",
        color: "#111827",
        fontWeight: "700",
        fontSize: "24px",
        margin: 0,
      }}
    >
      Settings
    </h3>
  </div>
    {/* Form Section */}
    <div
      className="settings-form"
      style={{
        backgroundColor: "#fff",
        padding: "30px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}
    >
      <form
        onSubmit={handleSubmitConfig}
        encType="multipart/form-data"
        style={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        {/* Panel Configuration */}
        <div className="form-group">
          <label>Panel Title</label>
          <input
            type="text"
            className="form-control"
            value={panelTitle}
            onChange={(e) => setPanelTitle(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Panel Alias</label>
          <input
            type="text"
            className="form-control"
            value={panelAlias}
            onChange={(e) => setPanelAlias(e.target.value)}
            required
          />
        </div>
        {/* OneSignal Keys - User */}
        <div className="form-group">
          <label>User App OneSignal ID</label>
          <input
            type="text"
            className="form-control"
            value={userAppKey}
            onChange={(e) => setUserAppKey(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>User App OneSignal REST API Key</label>
          <input
            type="text"
            className="form-control"
            value={userAppSecret}
            onChange={(e) => setUserAppSecret(e.target.value)}
            required
          />
        </div>
        {/* OneSignal Keys - Partner */}
        <div className="form-group">
          <label>Partner App OneSignal ID</label>
          <input
            type="text"
            className="form-control"
            value={partnerAppKey}
            onChange={(e) => setPartnerAppKey(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Partner App OneSignal REST API Key</label>
          <input
            type="text"
            className="form-control"
            value={partnerAppSecret}
            onChange={(e) => setPartnerAppSecret(e.target.value)}
            required
          />
        </div>
        {/* Currency Symbol */}
        <div className="form-group">
          <label>Currency Symbol</label>
          <input
            type="text"
            className="form-control"
            value={currencySymbol}
            onChange={(e) => setCurrencySymbol(e.target.value)}
            required
          />
        </div>
        {/* Logo Upload */}
        <div className="form-group">
          <label>Upload Logo/Favicon</label>
          <input
            type="file"
            className="form-control"
            onChange={(e) => setLogoFile(e.target.files[0])}
          />
          <br />
          <img src="assets/img/logo.png" alt="Logo" width="60" height="60" />
        </div>
        {/* Timezone Selector */}
        <div className="form-group">
          <label>Timezone</label>
          <select
            className="form-control"
            value={selectedZone}
            onChange={(e) => setSelectedZone(e.target.value)}
            required
          >
            <option value="">Select Timezone</option>
            <option value="Africa/Abidjan">Africa/Abidjan</option>
            <option value="Africa/Accra">Africa/Accra</option>
            <option value="Africa/Addis_Ababa">Africa/Addis_Ababa</option>
            <option value="Africa/Algiers">Africa/Algiers</option>
            <option value="Africa/Asmara">Africa/Asmara</option>
            <option value="America/New_York">America/New_York</option>
            <option value="Asia/Kolkata">Asia/Kolkata</option>
            <option value="Asia/Dubai">Asia/Dubai</option>
            <option value="Europe/London">Europe/London</option>
            <option value="UTC">UTC</option>
          </select>
        </div>
        {/* Bonuses and Thresholds */}
        <div className="form-group">
          <label>Signup Bonus</label>
          <input
            type="number"
            className="form-control"
            value={signupBonus}
            onChange={(e) => setSignupBonus(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Referral Bonus</label>
          <input
            type="number"
            className="form-control"
            value={referralBonus}
            onChange={(e) => setReferralBonus(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Partner Withdrawal Threshold</label>
          <input
            type="number"
            className="form-control"
            value={partnerWithdrawalThreshold}
            onChange={(e) => setPartnerWithdrawalThreshold(e.target.value)}
            required
          />
        </div>
        {/* Twilio Credentials */}
        <div className="form-group">
          <label>Twilio SID</label>
          <input
            type="text"
            className="form-control"
            value={twilioSID}
            onChange={(e) => setTwilioSID(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Twilio Auth Token</label>
          <input
            type="text"
            className="form-control"
            value={twilioAuthToken}
            onChange={(e) => setTwilioAuthToken(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Twilio Phone Number</label>
          <input
            type="text"
            className="form-control"
            value={twilioPhone}
            onChange={(e) => setTwilioPhone(e.target.value)}
            required
          />
        </div>
        {/* SMS Provider Selector */}
        <div className="form-group">
          <label>SMS Provider</label>
          <select
            className="form-control"
            value={messageServiceType}
            onChange={(e) => setMessageServiceType(e.target.value)}
          >
            <option value="">Select Provider</option>
            <option value="Msg91">Msg91</option>
            <option value="Twilio">Twilio</option>
          </select>
        </div>
        {/* Msg91 Settings */}
        <div className="form-group mt-4">
          <h5 className="fw-semibold">
            <i className="fas fa-sms"></i> Msg91 Settings
          </h5>
        </div>
        <div className="form-group">
          <label>Msg91 Auth Key</label>
          <input
            type="text"
            className="form-control"
            value={msg91Auth}
            onChange={(e) => setMsg91Auth(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Msg91 OTP Template ID</label>
          <input
            type="text"
            className="form-control"
            value={msg91Template}
            onChange={(e) => setMsg91Template(e.target.value)}
            required
          />
        </div>
        {/* Twilio Settings */}
        <div className="form-group mt-4">
          <h5 className="fw-semibold">
            <i className="fas fa-sms"></i> Twilio Settings
          </h5>
        </div>
        <div className="form-group">
          <label>Twilio Account ID</label>
          <input
            type="text"
            className="form-control"
            value={twilioAccountId}
            onChange={(e) => setTwilioAccountId(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Twilio Auth Token</label>
          <input
            type="text"
            className="form-control"
            value={twilioToken}
            onChange={(e) => setTwilioToken(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Twilio Phone Number</label>
          <input
            type="text"
            className="form-control"
            value={twilioNumberConfig}
            onChange={(e) => setTwilioNumberConfig(e.target.value)}
            required
          />
        </div>
        {/* OTP Settings */}
        <div className="form-group mt-4">
          <h5 className="fw-semibold">
            <i className="fa fa-phone"></i> OTP Settings
          </h5>
        </div>
        <div className="form-group">
          <label>OTP Required on Signup?</label>
          <select
            className="form-control"
            value={otpVerification}
            onChange={(e) => setOtpVerification(e.target.value)}
          >
            <option value="">Select Option</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>
        {/* Action Buttons */}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "10px" }}>
          <button
            type="submit"
            style={{
              backgroundColor: "#4F46E5",
              color: "#fff",
              padding: "12px 24px",
              borderRadius: "8px",
              fontFamily: "'Inter', sans-serif",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
          >
            Save Configuration
          </button>
          <button
            type="button"
            onClick={() => setShowSettings(false)}
            style={{
              backgroundColor: "#6b7280",
              color: "#fff",
              padding: "12px 24px",
              borderRadius: "8px",
              fontFamily: "'Inter', sans-serif",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
    </div>
  </div>
)}
{/* ✅ NOTIFICATION LOGS VIEW */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "notificationLogs" && (
  <div className="admin-container">
    {/* HEADER */}
    <div style={headerStyle}>
      <h3 style={titleStyle}>Notification Logs</h3>
    </div>
    {/* CARD */}
    <div style={cardStyle}>
      {/* ================= HEADER ================= */}
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          Backend Push Notification Tester
        </h3>
      </div>
      {/* ================= SUMMARY COUNTS ================= */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
          gap: "16px",
          marginBottom: "20px",
        }}
      >
        {(() => {
          const allLogs = [...providerLogs, ...customerLogs];
          const sentCount = allLogs.filter((n) => n.sent).length;
          const failedCount = allLogs.filter((n) => !n.sent).length;
          return (
            <>
              <div style={summaryCardStyle("#EEF2FF", "#1D4ED8")}>
                <h4>Total</h4>
                <p>{allLogs.length}</p>
              </div>
              <div style={summaryCardStyle("#ECFDF5", "#047857")}>
                <h4>Sent</h4>
                <p>{sentCount}</p>
              </div>

              <div style={summaryCardStyle("#FEF2F2", "#B91C1C")}>
                <h4>Failed</h4>
                <p>{failedCount}</p>
              </div>
            </>
          );
        })()}
      </div>
      {/* ================= MAIN PANEL ================= */}
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        {/* ================= CONTROLS ================= */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            flexWrap: "wrap",
            gap: "12px",
          }}
        >
          <button
            onClick={executePushTrigger}
            disabled={isProcessing}
            style={{
              backgroundColor: isProcessing ? "#9CA3AF" : "#2563EB",
              color: "#fff",
              padding: "10px 20px",
              borderRadius: "8px",
              border: "none",
              fontWeight: "600",
              cursor: isProcessing ? "not-allowed" : "pointer",
            }}
          >
            {isProcessing ? "Processing..." : "Execute Backend Trigger"}
          </button>
          <label style={{ fontFamily: "'Poppins', sans-serif", color: "#111827" }}>
            Filter Source&nbsp;
            <select
              value={logSourceFilter}
              onChange={(e) => setLogSourceFilter(e.target.value)}
              style={{ padding: "6px 10px", borderRadius: "6px" }}
            >
              <option value="ALL">All</option>
              <option value="PROVIDER">Providers</option>
              <option value="USER">Users</option>
            </select>
          </label>
          <label style={{ fontFamily: "'Poppins', sans-serif", color: "#111827" }}>
            Search by ID or Email&nbsp;
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Type ID or Email..."
              style={{ padding: "6px 10px", borderRadius: "6px" }}
            />
          </label>
        </div>
        {/* ================= ACTIVITY LOGS ================= */}
        {activityLogs.length > 0 ? (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead style={{ background: "#F9FAFB" }}>
              <tr>
                <th style={{ padding: "12px", textAlign: "left" }}>Type</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Message</th>
              </tr>
            </thead>
            <tbody>
              {activityLogs
                .filter((log) => {
                  if (!searchTerm) return true;
                  const term = searchTerm.toLowerCase();
                  return (
                    (log.providerId && log.providerId.toLowerCase().includes(term)) ||
                    (log.userId && log.userId.toLowerCase().includes(term)) ||
                    (log.email && log.email.toLowerCase().includes(term))
                  );
                })
                .map((log, i) => (
                  <tr key={i}>
                    <td style={{ padding: "12px", fontWeight: 600 }}>
                      {log.system ? "System" : log.userId ? "User" : "Provider"}
                    </td>
                    <td style={{ padding: "12px" }}>{log.message}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        ) : (
          <p style={{ textAlign: "center", fontFamily: "'Poppins', sans-serif", color: "#6B7280" }}>
            No activity logs
          </p>
        )}
        {/* ================= PROVIDER TABLE ================= */}
        {logSourceFilter !== "USER" && (
          <SectionTable
            title="Provider Notifications"
            headers={["Provider ID", "Email", "Status", "Message"]}
            rows={providerLogs
              .filter((p) => {
                if (!searchTerm) return true;
                const term = searchTerm.toLowerCase();
                return (
                  p.id.toLowerCase().includes(term) ||
                  (p.email && p.email.toLowerCase().includes(term))
                );
              })
              .map((p) => ({
                id: p.id,
                email: p.email || "-",
                status: p.sent ? "Sent" : "Failed",
                message: p.message,
              }))}
          />
        )}
        {/* ================= CUSTOMER TABLE ================= */}
        {logSourceFilter !== "PROVIDER" && (
          <SectionTable
            title="Customer Notifications"
            headers={["Customer ID", "Email", "Status", "Message"]}
            rows={customerLogs
              .filter((c) => {
                if (!searchTerm) return true;
                const term = searchTerm.toLowerCase();
                return (
                  c.id.toLowerCase().includes(term) ||
                  (c.email && c.email.toLowerCase().includes(term))
                );
              })
              .map((c) => ({
                id: c.id,
                email: c.email || "-",
                status: c.sent ? "Sent" : "Failed",
                message: c.message,
              }))}
          />
        )}
      </div>
    </div>
    </div>
)}
{/* ===========================
   PROVIDER LOGS VIEW
=========================== */}
{currentUser?.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2" &&
  currentView === "providerLogs" && (
    <>
      <div className="admin-container">
        <div style={cardStyle}>
          {/* ================= HEADER ================= */}
          <div
            className="category-title-container"
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              marginBottom: "20px",
              textAlign: "center",
            }}
          >
            <h3
              style={{
                margin: 0,
                fontSize: "24px",
                fontWeight: "700",
                color: "#111827",
              }}
            >
              📊 Provider & User Deep Scan Dashboard
            </h3>
          </div>
          {/* ================= BUTTON ================= */}
          <div style={{ textAlign: "right", marginBottom: "12px" }}>
            <button
              onClick={() => setShowScanModal(true)}
              style={{
                backgroundColor: "#2563EB",
                color: "#fff",
                padding: "10px 18px",
                borderRadius: "8px",
                border: "none",
                cursor: "pointer",
                fontWeight: "600",
                boxShadow: "0 4px 10px rgba(37,99,235,0.2)",
              }}
            >
              🔍 Open Deep Scan
            </button>
          </div>
          {/* ================= MODAL ================= */}
          {showScanModal && (
            <div
              style={{
                position: "fixed",
                inset: 0,
                backgroundColor: "rgba(0,0,0,0.45)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 999,
                padding: "20px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  maxWidth: "1850px",
                  height: "94vh",
                  backgroundColor: "#F3F4F6",
                  borderRadius: "20px",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: "0 12px 35px rgba(0,0,0,0.18)",
                }}
              >
                {/* ================= MODAL HEADER ================= */}
                <div
                  style={{
                    padding: "18px 24px",
                    backgroundColor: "#fff",
                    borderBottom: "1px solid #E5E7EB",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <h2
                    style={{
                      margin: 0,
                      fontSize: "22px",
                      fontWeight: "700",
                      color: "#111827",
                    }}
                  >
                    🔎 Provider & User Deep Scan
                  </h2>
                  <button
                    onClick={() => setShowScanModal(false)}
                    style={{
                      backgroundColor: "#EF4444",
                      color: "#fff",
                      border: "none",
                      padding: "10px 16px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontWeight: "600",
                      boxShadow: "0 4px 10px rgba(239,68,68,0.25)",
                    }}
                  >
                    ✕ Close
                  </button>
                </div>
                {/* ================= BODY ================= */}
                <div
                  style={{
                    padding: "24px",
                    overflowY: "auto",
                    flex: 1,
                    position: "relative",
                  }}
                >
                  {/* ================= LOADER ================= */}
                  {isLoadingScan && (
                    <div
                      style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(255,255,255,0.82)",
                        zIndex: 100,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backdropFilter: "blur(2px)",
                      }}
                    >
                      <div style={{ textAlign: "center" }}>
                        <div
                          style={{
                            width: "60px",
                            height: "60px",
                            border: "5px solid #E5E7EB",
                            borderTop: "5px solid #2563EB",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                            margin: "0 auto",
                          }}
                        />
                        <p
                          style={{
                            marginTop: "16px",
                            fontWeight: "700",
                            color: "#111827",
                            fontSize: "15px",
                          }}
                        >
                          Scanning{" "}
                          {selectedDomain === "providers"
                            ? "providers"
                            : "users"}
                          ...
                        </p>
                      </div>
                    </div>
                  )}
                  {/* ================= ACTION BUTTONS ================= */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: "14px",
                      flexWrap: "wrap",
                      marginBottom: "22px",
                    }}
                  >
                    <button
                      onClick={() => {
                        setSelectedDomain("providers");
                        loadDeepScanData();
                      }}
                      style={{
                        backgroundColor: "#111827",
                        color: "#fff",
                        border: "none",
                        padding: "11px 20px",
                        borderRadius: "10px",
                        fontWeight: "600",
                        cursor: "pointer",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                      }}
                    >
                      🧑‍🔧 Start Provider Scan
                    </button>
                    <button
                      onClick={() => {
                        setSelectedDomain("users");
                        loadDeepScanData();
                      }}
                      style={{
                        backgroundColor: "#2563EB",
                        color: "#fff",
                        border: "none",
                        padding: "11px 20px",
                        borderRadius: "10px",
                        fontWeight: "600",
                        cursor: "pointer",
                        boxShadow: "0 4px 10px rgba(37,99,235,0.25)",
                      }}
                    >
                      👤 Start User Scan
                    </button>
                  </div>
                  {/* ================= FILTER ================= */}
                  {scanResult?.[selectedDomain]?.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: "24px",
                      }}
                    >
                      <input
                        type="text"
                        placeholder={`Filter ${selectedDomain}`}
                        value={filterText}
                        onChange={(e) =>
                          setFilterText(e.target.value)
                        }
                        style={{
                          width: "340px",
                          padding: "12px 16px",
                          borderRadius: "10px",
                          border: "1px solid #D1D5DB",
                          outline: "none",
                          fontSize: "14px",
                          backgroundColor: "#fff",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                        }}
                      />
                    </div>
                  )}
                  {/* ================= ERROR ================= */}
                  {scanError && (
                    <div
                      style={{
                        backgroundColor: "#FEE2E2",
                        color: "#B91C1C",
                        padding: "14px",
                        borderRadius: "10px",
                        marginBottom: "20px",
                        textAlign: "center",
                        fontWeight: "600",
                        border: "1px solid #FCA5A5",
                      }}
                    >
                      {scanError}
                    </div>
                  )}
                  {/* ================= TABLE VIEW ================= */}
                  {!isLoadingScan &&
                    (scanResult?.[selectedDomain]?.length > 0 ? (
                      <div
                        style={{
                          background: "#fff",
                          borderRadius: "18px",
                          overflow: "hidden",
                          border: "1px solid #E5E7EB",
                          boxShadow:
                            "0 4px 15px rgba(0,0,0,0.06)",
                        }}
                      >
                        <div
                          style={{
                            overflowX: "auto",
                            maxHeight: "72vh",
                            overflowY: "auto",
                          }}
                        >
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                              minWidth: "1850px",
                            }}
                          >
                            {/* ================= HEADER ================= */}
                            <thead
                              style={{
                                position: "sticky",
                                top: 0,
                                zIndex: 20,
                                background: "#111827",
                              }}
                            >
                              <tr>
                                <th style={headerStyle}>#</th>
                                <th style={headerStyle}>
                                  Document ID
                                </th>
                                {/* DYNAMIC FIELDS */}
                                {Array.from(
                                  new Set(
                                    scanResult[
                                      selectedDomain
                                    ].flatMap((doc) =>
                                      Object.keys(
                                        doc.data || {}
                                      )
                                    )
                                  )
                                ).map((field) => (
                                  <th
                                    key={field}
                                    style={headerStyle}
                                  >
                                    {field}
                                  </th>
                                ))}
                                <th style={headerStyle}>
                                  Subcollections
                                </th>
                                <th style={headerStyle}>
                                  Images
                                </th>
                              </tr>
                            </thead>
                            {/* ================= BODY ================= */}
                            <tbody>
                              {scanResult[selectedDomain]
                                .filter((doc) =>
                                  doc.id
                                    .toLowerCase()
                                    .includes(
                                      filterText.toLowerCase()
                                    )
                                )
                                .map((doc, index) => {
                                  const allFields =
                                    Array.from(
                                      new Set(
                                        scanResult[
                                          selectedDomain
                                        ].flatMap((d) =>
                                          Object.keys(
                                            d.data || {}
                                          )
                                        )
                                      )
                                    );
                                  return (
                                    <tr
                                      key={doc.id}
                                      style={{
                                        backgroundColor:
                                          index % 2 === 0
                                            ? "#fff"
                                            : "#F9FAFB",
                                        transition:
                                          "0.2s ease",
                                      }}
                                    >
                                      {/* INDEX */}
                                      <td style={cellStyle}>
                                        {index + 1}
                                      </td>
                                      {/* DOC ID */}
                                      <td
                                        style={{
                                          ...cellStyle,
                                          color: "#2563EB",
                                          fontWeight: "700",
                                          minWidth: "260px",
                                          wordBreak: "break-all",
                                        }}
                                      >
                                        {doc.id}
                                      </td>
                                      {/* DYNAMIC DATA */}
                                      {allFields.map(
                                        (field) => (
                                          <td
                                            key={field}
                                            style={{
                                              ...cellStyle,
                                              minWidth: "250px",
                                            }}
                                          >
                                            {typeof doc
                                              .data?.[
                                              field
                                            ] ===
                                            "object" ? (
                                              <pre
                                                style={{
                                                  margin: 0,
                                                  whiteSpace:
                                                    "pre-wrap",
                                                  fontSize: "12px",
                                                  fontFamily:
                                                    "monospace",
                                                  color: "#111827",
                                                }}
                                              >
                                                {JSON.stringify(
                                                  doc
                                                    .data?.[
                                                    field
                                                  ],
                                                  null,
                                                  2
                                                )}
                                              </pre>
                                            ) : (
                                              String(
                                                doc
                                                  .data?.[
                                                  field
                                                ] ?? "-"
                                              )
                                            )}
                                          </td>
                                        )
                                      )}
                                      {/* SUBCOLLECTIONS */}
                                      <td
                                        style={{
                                          ...cellStyle,
                                          minWidth: "420px",
                                        }}
                                      >
                                        {doc.subcollections ? (
                                          Object.entries(
                                            doc.subcollections
                                          ).map(
                                            ([
                                              subName,
                                              subDocs,
                                            ]) => (
                                              <div
                                                key={subName}
                                                style={{
                                                  marginBottom:
                                                    "14px",
                                                  padding: "12px",
                                                  border:
                                                    "1px solid #E5E7EB",
                                                  borderRadius:
                                                    "10px",
                                                  background:
                                                    "#fff",
                                                  boxShadow:
                                                    "0 2px 6px rgba(0,0,0,0.04)",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    fontWeight:
                                                      "700",
                                                    marginBottom:
                                                      "8px",
                                                    color:
                                                      "#111827",
                                                  }}
                                                >
                                                  📂 {subName}
                                                </div>
                                                {subDocs &&
                                                subDocs.length >
                                                  0 ? (
                                                  subDocs.map(
                                                    (
                                                      subDoc,
                                                      subIndex
                                                    ) => (
                                                      <div
                                                        key={
                                                          subIndex
                                                        }
                                                        style={{
                                                          marginBottom:
                                                            "10px",
                                                          padding:
                                                            "10px",
                                                          background:
                                                            "#F9FAFB",
                                                          borderRadius:
                                                            "8px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            color:
                                                              "#059669",
                                                            fontWeight:
                                                              "700",
                                                            marginBottom:
                                                              "6px",
                                                          }}
                                                        >
                                                          🆔{" "}
                                                          {
                                                            subDoc.id
                                                          }
                                                        </div>

                                                        <pre
                                                          style={{
                                                            margin: 0,
                                                            whiteSpace:
                                                              "pre-wrap",
                                                            fontSize:
                                                              "11px",
                                                            color:
                                                              "#111827",
                                                          }}
                                                        >
                                                          {JSON.stringify(
                                                            subDoc,
                                                            null,
                                                            2
                                                          )}
                                                        </pre>
                                                      </div>
                                                    )
                                                  )
                                                ) : (
                                                  <div
                                                    style={{
                                                      color:
                                                        "#6B7280",
                                                    }}
                                                  >
                                                    No Data
                                                  </div>
                                                )}
                                              </div>
                                            )
                                          )
                                        ) : (
                                          <span
                                            style={{
                                              color:
                                                "#6B7280",
                                            }}
                                          >
                                            No Subcollections
                                          </span>
                                        )}
                                      </td>
                                      {/* IMAGES */}
                                      <td
                                        style={{
                                          ...cellStyle,
                                          minWidth: "260px",
                                        }}
                                      >
                                        {doc.images &&
                                        doc.images.length >
                                          0 ? (
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "10px",
                                              flexWrap: "wrap",
                                            }}
                                          >
                                            {doc.images.map(
                                              (
                                                image,
                                                imgIndex
                                              ) => (
                                                <img
                                                  key={imgIndex}
                                                  src={image}
                                                  alt="scan"
                                                  style={{
                                                    width: "90px",
                                                    height: "90px",
                                                    objectFit:
                                                      "cover",
                                                    borderRadius:
                                                      "10px",
                                                    border:
                                                      "1px solid #E5E7EB",
                                                    boxShadow:
                                                      "0 2px 6px rgba(0,0,0,0.08)",
                                                  }}
                                                />
                                              )
                                            )}
                                          </div>
                                        ) : (
                                          <span
                                            style={{
                                              color:
                                                "#6B7280",
                                            }}
                                          >
                                            No Images
                                          </span>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ) : (
                      <div
                        style={{
                          textAlign: "center",
                          color: "#6B7280",
                          padding: "40px 0",
                          fontSize: "15px",
                          fontWeight: "500",
                        }}
                      >
                        No {selectedDomain} data found.
                      </div>
                    ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* ================= SPINNER STYLE ================= */}
      <style>
        {`
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </>
)}
  </div>
</div>

{/* VERIFICATION MODAL */}
{showVerificationModal && selectedPartnerForVerification && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
      overflowY: "auto",
      padding: "30px",
    }}
  >
    <div
      className="dashboard-container"
      style={{
        width: "100%",
        maxWidth: "1100px",
        background: "#f9fafb",
        borderRadius: "12px",
      }}
    >
      <div className="category-title-container">
        {/* Header Section */}
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            marginBottom: "20px",
            textAlign: "center",
            position: "relative",
          }}
        >
          <h3
            style={{
              margin: 0,
              fontFamily: "'Poppins', sans-serif",
              fontSize: "24px",
              fontWeight: "700",
              color: "#111827",
            }}
          >
            Verification & Compliance Overview
          </h3>
          {/* Close Button */}
          <div style={{ marginTop: "8px", textAlign: "right" }}>
            <button
              onClick={() => {
                setShowVerificationModal(false);
              }}
              style={{
                background: "#7C3AED",
                color: "#fff",
                padding: "2px 8px",
                borderRadius: "4px",
                fontSize: "11px",
                border: "none",
                cursor: "pointer",
                transition: "background 0.2s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.background = "#6D28D9")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.background = "#7C3AED")
              }
            >
              ✖ Close
            </button>
          </div>
          {/* Horizontal Progress Bar */}
          <div className="mb-4" style={{ marginTop: "20px" }}>
            <div
              style={{
                height: 10,
                background: "#eee",
                borderRadius: 5,
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div
                style={{
                  width: `${
                    (
                      (Object.keys(
                        partnerVerification[selectedPartnerForVerification.id] ||
                          {}
                      ).filter(
                        (k) =>
                          partnerVerification[
                            selectedPartnerForVerification.id
                          ][k]?.fileURL
                      ).length /
                        steps.length) *
                      100
                    ).toFixed(0) || 0
                  }%`,
                  height: "100%",
                  background: "#007BFF",
                  transition: "width 0.5s ease",
                }}
              ></div>
              {/* Step Titles */}
              {steps.map((step, index) => {
                const stepPercent = ((index + 1) / steps.length) * 100;
                return (
                  <div
                    key={step.key}
                    style={{
                      position: "absolute",
                      left: `calc(${stepPercent}% - 20px)`,
                      top: 15,
                      width: 40,
                      textAlign: "center",
                      fontSize: 12,
                      color: "#555",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {step.title}
                  </div>
                );
              })}
            </div>
            <p style={{ fontSize: 12, marginTop: 4 }}>
              {(
                (Object.keys(
                  partnerVerification[selectedPartnerForVerification.id] || {}
                ).filter(
                  (k) =>
                    partnerVerification[selectedPartnerForVerification.id][k]
                      ?.fileURL
                ).length /
                  steps.length) *
                100
              ).toFixed(0)}
              % completed
            </p>
          </div>
          {/* Steps Section with Vertical Line */}
          <div style={{ position: "relative", marginTop: "20px" }}>
            {/* Background Line */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: "18px",
                width: "4px",
                height: "100%",
                backgroundColor: "#e5e7eb",
                borderRadius: "2px",
                zIndex: 0,
              }}
            ></div>
            {/* Green Progress Line */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: "18px",
                width: "4px",
                height: `${
                  steps.length
                    ? (
                        Math.round(
                          (Object.keys(
                            partnerVerification[
                              selectedPartnerForVerification.id
                            ] || {}
                          ).filter(
                            (k) =>
                              partnerVerification[
                                selectedPartnerForVerification.id
                              ][k]?.fileURL
                          ).length /
                            steps.length) *
                            steps.length
                        ) *
                        (100 / steps.length)
                      ).toFixed(0)
                    : 0
                }%`,
                background: "linear-gradient(to bottom, #22c55e, #16a34a)",
                borderRadius: "2px",
                zIndex: 1,
                transition: "height 0.5s ease",
              }}
            ></div>
            {/* Steps */}
            {steps.map((step, index) => {
              const docData =
                partnerVerification[selectedPartnerForVerification.id]?.[
                  step.key
                ] || {};
              const expiryDate = docData.expiryDate
                ? new Date(docData.expiryDate)
                : null;
              const daysLeft = expiryDate
                ? Math.ceil(
                    (expiryDate - new Date()) / (1000 * 60 * 60 * 24)
                  )
                : null;
              const formatDate = (date) => {
                if (!date) return "";
                const d = new Date(date);
                const month = (d.getMonth() + 1)
                  .toString()
                  .padStart(2, "0");
                const day = d.getDate().toString().padStart(2, "0");
                return `${d.getFullYear()}-${month}-${day}`;
              };
              const isCompleted = !!docData.fileURL;
              return (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    position: "relative",
                    marginBottom: "30px",
                  }}
                >
                  {/* Circle */}
                  <div
                    style={{
                      position: "relative",
                      zIndex: 2,
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                      backgroundColor: isCompleted ? "#22c55e" : "#d32f2f",
                      border: "2px solid #fff",
                      boxShadow: "0 0 0 2px #e5e7eb",
                      marginRight: "12px",
                      flexShrink: 0,
                    }}
                  ></div>
                  {/* Step Details */}
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        fontWeight: "bold",
                        color: isCompleted ? "#16a34a" : "#1a1a1a",
                      }}
                    >
                      {step.title}
                    </div>
                    <div style={{ fontSize: 14, color: "#555" }}>
                      {step.description}
                    </div>
                    {expiryDate && (
                      <div
                        style={{
                          marginTop: 6,
                          fontSize: 13,
                          fontWeight: "bold",
                          color: daysLeft <= 30 ? "#d32f2f" : "#2e7d32",
                        }}
                      >
                        Expires on {expiryDate.toDateString()} ({daysLeft} days
                        left)
                      </div>
                    )}
                    <div style={{ marginTop: 8 }}>
                      <input
                        type="file"
                        onChange={(e) =>
                          handleUploadAndSave(step.key, e)
                        }
                        style={{
                          fontSize: 12,
                          width: "100%",
                          padding: "8px",
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                        }}
                      />
                    </div>
                    <div style={{ marginTop: 8 }}>
                      <input
                        type="date"
                        value={formatDate(docData.expiryDate)}
                        onChange={(e) =>
                          handleExpiryChangeAndSave(
                            step.key,
                            e.target.value
                          )
                        }
                        style={{
                          fontSize: 12,
                          width: "100%",
                          padding: "8px",
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                        }}
                      />
                    </div>
                    {expiryDate && daysLeft <= 30 && (
                      <button
                        onClick={() => sendReminderToProvider(step.key)}
                        style={{
                          marginTop: 8,
                          background: "#ff9800",
                          color: "white",
                          padding: "6px 12px",
                          borderRadius: 5,
                          fontSize: 12,
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        Send Reminder to Provider
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {/* TOASTS */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          pointerEvents: "none",
          zIndex: 9999,
        }}
      >
        {toasts.map((t) => (
          <div
            key={t.id}
            style={{
              minWidth: "300px",
              maxWidth: "600px",
              backgroundColor: "#fff",
              color: "#111",
              padding: "20px",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
              fontSize: "16px",
              fontWeight: 500,
              textAlign: "center",
              pointerEvents: "auto",
              marginBottom: "12px",
            }}
          >
            {t.message}
          </div>
        ))}
      </div>
    </div>
  </div>
)}

{/* ---------------- Customer Automatching Section ---------------- */}
{showAutomatchCustomers && (
  <div className="dashboard-container">
    {/* Title Section */}
    <div
      className="category-title-container"
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        marginBottom: "20px",
        textAlign: "center",
      }}
    >
      <h3
        style={{
          margin: 0,
          fontFamily: "'Poppins', sans-serif",
          fontSize: "24px",
          fontWeight: "700",
          color: "#111827",
        }}
      >
        👥 Customer Auto-Assign (Round Robin)
      </h3>
    </div>
    {/* Toast Container */}
    <ToastContainer position="top-right" autoClose={3000} />
    {/* Table Section */}
    <div
      className="card-section"
      style={{
        backgroundColor: "#fff",
        padding: "24px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
      }}
    >
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ backgroundColor: "#F9FAFB" }}>
            <tr>
              {[
                "Job ID",
                "Type",
                "Location",
                "Time",
                "Status",
                "Matched Customer",
                "Score",
                "Loyalty",
                "Action",
              ].map((heading) => (
                <th
                  key={heading}
                  style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    fontWeight: 600,
                    fontSize: "14px",
                    color: "#374151",
                  }}
                >
                  {heading}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {taskQueue.map((task) => (
              <tr
                key={task.id}
                style={{
                  borderBottom: "1px solid #E5E7EB",
                  transition: "background-color 0.2s",
                }}
                className="hover:bg-gray-50"
              >
                <td style={tdStyle}>{task.id}</td>
                <td style={tdStyle}>{task.type}</td>
                <td style={tdStyle}>{task.location}</td>
                <td style={tdStyle}>{task.time}</td>
                <td style={tdStyle}>{taskStates[task.id] || "pending"}</td>
                {/* Matched Customer */}
                {allocationMap[task.id] && taskStates[task.id] === "assigned" ? (
                  <>
                    <td style={tdStyle}>{allocationMap[task.id].name}</td>
                    <td style={tdStyle}>{allocationMap[task.id].score}</td>
                    <td style={tdStyle}>{allocationMap[task.id].loyalty}</td>
                    <td style={tdStyle}>
                      <button
                        onClick={() => triggerReassignment(task.id)}
                        style={{
                          backgroundColor: "#2563EB",
                          color: "#fff",
                          padding: "6px 12px",
                          borderRadius: "8px",
                          fontSize: "14px",
                          fontWeight: 500,
                          cursor: "pointer",
                        }}
                        className="hover:bg-blue-700"
                      >
                        ❌ Reject
                      </button>
                    </td>
                  </>
                ) : taskStates[task.id] === "unmatched" ? (
                  <>
                    <td
                      style={{
                        padding: "12px 16px",
                        color: "#B45309",
                        fontStyle: "italic",
                        fontWeight: 500,
                        textAlign: "center",
                      }}
                      colSpan={3}
                    >
                      ⚠️ No suitable customer found
                    </td>
                    <td style={tdStyle}></td>
                  </>
                ) : (
                  <>
                    <td
                      style={{
                        padding: "12px 16px",
                        color: "#9CA3AF",
                        fontStyle: "italic",
                        textAlign: "center",
                      }}
                      colSpan={3}
                    >
                      Matching in progress...
                    </td>
                    <td style={tdStyle}></td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
)}
</div>
)}
export default FirestoreData; // ✅ Now correct








